// src/locale/locale.interface.ts
var SUPPORTED_LOCALES = ["hu", "en", "de", "uk"];
var LOCALE_CONFIGS = {
  hu: {
    locale: "hu",
    displayName: "Hungarian",
    nativeName: "Magyar",
    dateFormat: "yyyy.MM.dd",
    currencyCode: "HUF",
    currencySymbol: "Ft",
    numberFormat: { minimumFractionDigits: 0, maximumFractionDigits: 0 }
  },
  en: {
    locale: "en",
    displayName: "English",
    nativeName: "English",
    dateFormat: "dd/MM/yyyy",
    currencyCode: "HUF",
    currencySymbol: "Ft",
    numberFormat: { minimumFractionDigits: 0, maximumFractionDigits: 0 }
  },
  de: {
    locale: "de",
    displayName: "German",
    nativeName: "Deutsch",
    dateFormat: "dd.MM.yyyy",
    currencyCode: "HUF",
    currencySymbol: "Ft",
    numberFormat: { minimumFractionDigits: 0, maximumFractionDigits: 0 }
  },
  uk: {
    locale: "uk",
    displayName: "Ukrainian",
    nativeName: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
    dateFormat: "dd.MM.yyyy",
    currencyCode: "UAH",
    currencySymbol: "\u20B4",
    numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  }
};

// src/locale/translations/de.json
var de_default = {
  equipmentUnit: {
    backToTypes: "Vissza a t\xEDpusokhoz",
    editorTitle: "Egyedi g\xE9p szerkeszt\u0151",
    editorSubtitle: "Egyedi g\xE9p-rekord adatai, st\xE1tusza \xE9s dokumentumai",
    tabsAria: "Egyedi g\xE9p n\xE9zetek",
    tabs: {
      basic: "Alapadatok",
      status: "St\xE1tusz & el\u0151zm\xE9ny",
      images: "K\xE9pek",
      documents: "Dokumentumok"
    },
    seamPending: "Hamarosan \u2014 adatk\xF6t\xE9s a BE-seam-re v\xE1r",
    field: {
      manufacturerSku: "Gy\xE1ri cikksz\xE1m",
      internalSku: "Bels\u0151 cikksz\xE1m",
      altSkus: "Alternat\xEDv SKU-k",
      serialNumber: "Sorozatsz\xE1m",
      purchasedAt: "V\xE1s\xE1rl\xE1s d\xE1tuma",
      hours: "\xDCzem\xF3ra",
      category: "Kateg\xF3ria",
      note: "Megjegyz\xE9s",
      status: "St\xE1tusz",
      statusSince: "St\xE1tusz \xF3ta"
    },
    status: {
      AVAILABLE: "Szabad",
      RESERVED: "Foglalt",
      IN_USE: "Haszn\xE1latban",
      DAMAGED: "S\xE9r\xFClt",
      UNDER_REPAIR: "Jav\xEDt\xE1s alatt",
      SOLD: "Eladva",
      WITHDRAWAL_REQUESTED: "Kivon\xE1sra jel\xF6lve",
      RETIRED: "Kivonva"
    },
    category: {
      SMALL_ENGINE: "Kismotoros g\xE9p",
      LAWN_EQUIPMENT: "Kerti g\xE9p",
      POWER_TOOL: "Elektromos szersz\xE1m",
      OTHER: "Egy\xE9b"
    },
    statusHistory: "St\xE1tusz el\u0151zm\xE9ny",
    altSkusPlaceholder: "SKU + Enter (Excel/CSV beilleszt\xE9s t\xE1mogatott)",
    altSkusCreate: '+ \xDAj: "{value}"',
    altSkusDuplicate: "M\xE1r szerepel",
    saved: "Mentve",
    saveError: "Ment\xE9s sikertelen",
    imagesEmpty: "Nincs felt\xF6lt\xF6tt k\xE9p",
    documentsEmpty: "Nincs dokumentum",
    expiresAt: "Lej\xE1r",
    download: "Let\xF6lt\xE9s",
    transition: {
      button: "St\xE1tusz v\xE1lt\xE1s",
      title: "St\xE1tusz v\xE1lt\xE1s",
      targetLabel: "V\xE1lassz c\xE9lst\xE1tuszt",
      reasonLabel: "Indokl\xE1s",
      required: "k\xF6telez\u0151",
      reasonHint: "Minimum 20 karakter ({count}/20)",
      photoLabel: "F\xE9nyk\xE9pek",
      auditNote: "Minden st\xE1tusz-v\xE1lt\xE1s audit-logolt: ki, mikor \xE9s mi\xE9rt.",
      confirm: "St\xE1tusz meger\u0151s\xEDt\xE9se",
      noTargets: "Ebb\u0151l a st\xE1tuszb\xF3l nincs lehets\xE9ges \xE1tmenet.",
      success: "St\xE1tusz friss\xEDtve",
      error: "A st\xE1tusz-v\xE1lt\xE1s sikertelen"
    }
  },
  bank: {
    title: "Banktransaktionen",
    subtitle: "Bankkontobewegungen und Zuordnung",
    newTransaction: "Neue Transaktion",
    loading: "Banktransaktionen werden geladen...",
    error: "Ein Fehler ist aufgetreten",
    noResults: "Keine Ergebnisse",
    noResultsFiltered: "Keine Banktransaktion entspricht dem Filter. \xC4ndere den Filter.",
    total: "Gesamt",
    column: {
      bookingDate: "Buchungsdatum",
      counterparty: "Gegenpartei",
      amount: "Betrag",
      matchStatus: "Zuordnung",
      source: "Quelle"
    },
    matchStatus: {
      UNMATCHED: "Nicht zugeordnet",
      PARTIALLY_MATCHED: "Teilweise zugeordnet",
      MATCHED: "Zugeordnet",
      RECONCILED: "Abgestimmt"
    },
    direction: {
      IN: "Eingang",
      OUT: "Ausgang"
    },
    source: {
      MANUAL: "Manuell",
      IMPORT: "Import"
    },
    filter: {
      allStatuses: "Alle Status",
      allDirections: "Alle Richtungen"
    },
    form: {
      bookingDate: "Buchungsdatum",
      direction: "Richtung",
      amount: "Betrag",
      counterpartyName: "Name der Gegenpartei",
      counterpartyAccount: "Konto der Gegenpartei",
      memo: "Verwendungszweck",
      submit: "Speichern",
      success: "Banktransaktion gespeichert",
      error: "Speichern fehlgeschlagen"
    },
    match: {
      action: "Zuordnen",
      title: "Banktransaktion zuordnen",
      invoiceLabel: "Rechnung",
      invoicePlaceholder: "Rechnung ausw\xE4hlen\u2026",
      amountLabel: "Zugeordneter Betrag",
      submit: "Zuordnen",
      noInvoices: "Keine zuordenbare offene Rechnung",
      loadError: "Die zuordenbaren Rechnungen konnten nicht geladen werden. Bitte erneut versuchen.",
      success: "Erfolgreich zugeordnet",
      error: {
        overpay: "Der zugeordnete Betrag \xFCbersteigt den offenen Rechnungsbetrag",
        outNotAllowed: "Ausgehende Transaktionen k\xF6nnen keiner Rechnung zugeordnet werden",
        amountPositive: "Der zugeordnete Betrag muss positiv sein",
        alreadyExists: "Diese Zuordnung existiert bereits",
        invoiceNotFound: "Rechnung nicht gefunden",
        transactionNotFound: "Banktransaktion nicht gefunden",
        generic: "Zuordnung fehlgeschlagen"
      }
    }
  },
  common: {
    status: "Status",
    uploading: "Wird hochgeladen\u2026",
    save: "Speichern",
    saving: "Speichern...",
    cancel: "Abbrechen",
    delete: "L\xF6schen",
    confirmDelete: "M\xF6chten Sie dieses Element wirklich l\xF6schen?",
    search: "Suchen",
    clearSearch: "Suche leeren",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolgreich",
    yes: "Ja",
    no: "Nein",
    close: "Schlie\xDFen",
    back: "Zur\xFCck",
    previous: "Zur\xFCck",
    next: "Weiter",
    submit: "Absenden",
    edit: "Bearbeiten",
    create: "Erstellen",
    details: "Details",
    new: "Neu",
    all: "Alle",
    none: "Keine",
    actions: "Aktionen",
    confirm: "Best\xE4tigen",
    remove: "Entfernen",
    add: "Hinzuf\xFCgen",
    update: "Aktualisieren",
    refresh: "Aktualisieren",
    retry: "Erneut versuchen",
    print: "Drucken",
    export: "Exportieren",
    import: "Importieren",
    filter: "Filtern",
    sort: "Sortieren",
    reset: "Zur\xFCcksetzen",
    apply: "Anwenden",
    download: "Herunterladen",
    upload: "Hochladen",
    quantity: "Menge",
    total: "Gesamt",
    subtotal: "Zwischensumme",
    amount: "Betrag",
    date: "Datum",
    description: "Beschreibung",
    notes: "Notizen",
    comment: "Kommentar",
    type: "Typ",
    category: "Kategorie",
    priority: "Priorit\xE4t",
    responsible: "Verantwortlicher",
    noResponsible: "Kein Verantwortlicher",
    id: "ID",
    name: "Name",
    notFound: "Nicht gefunden",
    noData: "Keine Daten",
    backToList: "Zur\xFCck zur Liste",
    optional: "Optional",
    required: "Pflichtfeld",
    piece: "Stk.",
    day: "Tag",
    days: "Tage",
    hour: "Stunde",
    hours: "Stunden",
    createdAt: "Erstellt am",
    updatedAt: "Aktualisiert am",
    completedAt: "Abgeschlossen am",
    createdBy: "Erstellt von",
    saved: "Gespeichert!",
    loadingText: "Laden...",
    errorLabel: "Fehler",
    retryButton: "Erneut versuchen",
    months: {
      january: "Januar",
      february: "Februar",
      march: "M\xE4rz",
      april: "April",
      may: "Mai",
      june: "Juni",
      july: "Juli",
      august: "August",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "Dezember"
    },
    monthsShort: {
      jan: "Jan",
      feb: "Feb",
      mar: "M\xE4r",
      apr: "Apr",
      may: "Mai",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Okt",
      nov: "Nov",
      dec: "Dez"
    },
    other: "Sonstige",
    unknownError: "Unbekannter Fehler",
    activeRentals: "Aktive Vermietungen",
    currency: "Ft",
    summary: "Zusammenfassung",
    wizardStep: "Schritt {current} / {total}",
    processing: "Verarbeitung...",
    row: "Zeile",
    clear: "L\xF6schen",
    dismiss: "Verwerfen",
    active: "Akt\xEDv",
    inactive: "Inakt\xEDv",
    loadError: "Ladefehler"
  },
  navStatus: {
    label: "NAV-Status",
    pending: "Ausstehend",
    submitted: "Eingereicht",
    accepted: "Akzeptiert",
    rejected: "Abgelehnt",
    error: "Fehler"
  },
  nav: {
    bankImport: "Bankimport",
    navigation: "Navigation",
    favorites: "Favoriten",
    removeFavorite: "Entfernen",
    expandAll: "Alle aufklappen",
    collapseAll: "Alle zuklappen",
    expand: "Aufklappen",
    collapse: "Zuklappen",
    adminCenter: "Admin-Center",
    summary: "\xDCbersicht",
    knowledgeBase: "Wissensdatenbank",
    rental: "Vermietung",
    activeRentals: "Aktive Vermietungen",
    newRental: "Neue Vermietung",
    returnRental: "R\xFCckgabe",
    outstandingRentals: "Ausstehende Vermietungen",
    fleetCalendar: "Ger\xE4tekalender",
    worksheet: "Arbeitsblatt",
    worksheets: "Arbeitsbl\xE4tter",
    newWorksheet: "Neues Arbeitsblatt",
    claims: "Reklamationen",
    sales: "Verkauf",
    salesList: "Verkaufsliste",
    pos: "POS (Kasse)",
    inventory: "Lager",
    stockList: "Bestandsliste",
    movements: "Bewegungen",
    goodsReceipt: "Wareneingang",
    scrapping: "Verschrottung",
    inventoryAnalytics: "Bestandsanalytik",
    masterData: "Stammdaten",
    products: "Produkte",
    quotes: "Angebote",
    contracts: "Vertr\xE4ge",
    invoices: "Rechnungen",
    deliveryNotes: "Lieferscheine",
    partners: "Partner",
    partnerList: "Partnerliste",
    newPartner: "Neuer Partner",
    vipProgram: "VIP-Programm",
    duplicates: "Duplikate",
    vehicles: "Fahrzeuge",
    rentalVehicles: "Mietfahrzeuge",
    companyVehicles: "Firmenfahrzeuge",
    expiringDocuments: "Ablaufende Dokumente",
    finance: "Finanzen",
    cashRegister: "Kasse",
    dailyClose: "Tagesabschluss",
    monthlyClose: "Monatsabschluss",
    journal: "Hauptbuch",
    szhFolder: "SZH-Mappe",
    vouchers: "Gutscheine",
    fixedAssets: "Anlageverm\xF6gen",
    tamTaxExempt: "TAM Steuerfrei",
    receivables: "Forderungen",
    chat: "Chat",
    messaging: "Nachrichten",
    smsDashboard: "SMS-\xDCbersicht",
    inboundSms: "Eingehende SMS",
    courierDeliveries: "Kurierlieferungen",
    reports: "Berichte",
    tasks: "Aufgaben",
    integrations: "Integrationen",
    crm: "CRM (Twenty)",
    hr: "HR (Horilla)",
    porter: "rPI Porter",
    porterInbox: "Posteingang",
    porterChannels: "Kan\xE4le",
    porterAutoReply: "Auto-Antwort-Regeln",
    chatwoot: "rPI Porter",
    flow: "rPI Flow",
    admin: "Admin",
    users: "Benutzer",
    permissions: "Berechtigungen",
    tenantAdmin: "Mandanten-Admin",
    featureFlags: "Feature-Flags",
    releaseHub: "rPI Delta",
    settings: "Einstellungen",
    general: "Allgemein",
    openingHours: "\xD6ffnungszeiten",
    smsSettings: "SMS-Einstellungen",
    documentScanner: "Dokumentenscanner",
    dashboard: "Dashboard",
    crmNewWindow: "Twenty CRM (neues Fenster)",
    hrNewWindow: "Horilla HR (neues Fenster)",
    group: {
      daily: "T\xE4gliche Arbeit",
      registry: "Verwaltung",
      communication: "Kommunikation",
      system: "System",
      hr: "HR"
    },
    manufacturing: "Fertigung",
    bomList: "St\xFCckliste (BOM)",
    productionOrders: "Fertigungsauftr\xE4ge",
    packages: "Pakete",
    more: "Mehr",
    administration: "Administration",
    recentItems: "Zuletzt",
    moreMenu: "Mehr Optionen",
    sidebarMenu: "Navigationsbereich",
    emailTemplates: "E-Mail-Vorlagen",
    emailSmtp: "E-Mail SMTP",
    emailLogs: "Sendeprotokoll",
    bulkEmail: "Massen-E-Mail",
    hrModule: "HR",
    hrAttendance: "Anwesenheit",
    hrLeaveCalendar: "Urlaubskalender",
    hrLeaveRequest: "Urlaubsantrag",
    hrEmployees: "Mitarbeiter",
    overdueRentals: "Au\xDFenst\xE4nde"
  },
  header: {
    search: "Suchen",
    searchShortcut: "Suchen (Ctrl+K)",
    lightMode: "Heller Modus",
    darkMode: "Dunkler Modus",
    language: "Sprache",
    user: "Benutzer",
    logout: "Abmelden",
    role: "Rolle",
    pendingSync: "Synchronisierung l\xE4uft"
  },
  command: {
    searchPlaceholder: "Seiten durchsuchen...",
    noResults: "Keine Ergebnisse gefunden.",
    navigate: "Navigation",
    open: "\xF6ffnen",
    close: "schlie\xDFen",
    addFavorite: "Zu Favoriten hinzuf\xFCgen",
    removeFavorite: "Aus Favoriten entfernen"
  },
  status: {
    active: "Aktiv",
    closed: "Geschlossen",
    draft: "Entwurf",
    expired: "Abgelaufen",
    cancelled: "Storniert",
    pending: "Ausstehend",
    inProgress: "In Bearbeitung",
    completed: "Abgeschlossen",
    waiting: "Wartend",
    billable: "Abrechenbar",
    deleted: "Gel\xF6scht",
    partialReturn: "Teilweise zur\xFCckgegeben",
    returned: "Zur\xFCckgegeben",
    free: "Verf\xFCgbar",
    rentedOut: "Vermietet",
    inService: "In Wartung",
    reserved: "Reserviert",
    excellent: "Ausgezeichnet",
    good: "Gut",
    adequate: "Ausreichend",
    open: "Offen",
    interrupted: "Unterbrochen",
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    trusted: "Vertrauensw\xFCrdig",
    notTrusted: "Nicht vertrauensw\xFCrdig",
    depositFree: "Kautionsfrei!",
    depositMissing: "Kaution fehlt",
    storno: "(Storno)"
  },
  toast: {
    saved: "Erfolgreich gespeichert",
    deleted: "Erfolgreich gel\xF6scht",
    created: "Erfolgreich erstellt",
    updated: "Erfolgreich aktualisiert",
    error: "Ein Fehler ist aufgetreten",
    loginError: "Anmeldefehler"
  },
  error: {
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Ung\xFCltige E-Mail-Adresse",
    loadFailed: "Laden fehlgeschlagen",
    saveFailed: "Speichern fehlgeschlagen",
    general: "Ein Fehler ist aufgetreten: {message}",
    notFound: "Nicht gefunden",
    minLength: "Mindestens {min} Zeichen erforderlich",
    worksheetNotFound: "Arbeitsblatt nicht gefunden",
    rentalNotFound: "Vermietung nicht gefunden",
    invoiceNotFound: "Rechnung nicht gefunden",
    noCashRegisterOpen: "Keine Kasse ge\xF6ffnet.",
    atLeastOneItem: "Bitte mindestens einen Artikel hinzuf\xFCgen!",
    enterPartnerName: "Bitte Partnernamen eingeben!",
    minCharsRequired: "Mindestens {min} Zeichen erforderlich",
    atLeastOneChange: "Mindestens eine inhaltliche \xC4nderung ist erforderlich!",
    calendar: {
      createHoliday: "Feiertag konnte nicht erstellt werden",
      createOverride: "\xDCberschreibung konnte nicht erstellt werden",
      deleteHoliday: "Feiertag konnte nicht gel\xF6scht werden",
      deleteOverride: "\xDCberschreibung konnte nicht gel\xF6scht werden",
      loadCalendar: "Kalender konnte nicht geladen werden",
      loadHolidays: "Feiertage konnten nicht geladen werden",
      loadHours: "\xD6ffnungszeiten konnten nicht geladen werden",
      loadOverrides: "\xDCberschreibungen konnten nicht geladen werden",
      resetDefaults: "Standardwerte konnten nicht zur\xFCckgesetzt werden",
      seedNational: "Nationale Feiertage konnten nicht geladen werden",
      updateHoliday: "Feiertag konnte nicht aktualisiert werden",
      updateHours: "\xD6ffnungszeiten konnten nicht aktualisiert werden",
      updateOverride: "\xDCberschreibung konnte nicht aktualisiert werden"
    },
    chat: {
      createConversation: "Konversation konnte nicht erstellt werden",
      loadConversations: "Konversationen konnten nicht geladen werden",
      loadMessages: "Nachrichten konnten nicht geladen werden",
      loadUsers: "Benutzer konnten nicht geladen werden",
      sendMessage: "Nachricht konnte nicht gesendet werden"
    },
    common: {
      operationFailed: "Vorgang fehlgeschlagen",
      unknownError: "Unbekannter Fehler"
    },
    rental: {
      depositPaidEquipmentTaken: "Die Kaution wurde abgebucht und die Vermietung wurde angelegt \u2014 das Ger\xE4t wurde jedoch zwischenzeitlich an eine andere Vermietung vergeben und konnte nicht zugeordnet werden. Zahlung NICHT erneut starten: jeder Versuch erzeugt eine weitere Kautionsabbuchung und eine weitere Vermietung. Erstatten Sie die Kaution im Kautionsbereich und w\xE4hlen Sie ein anderes Ger\xE4t. ({contractNumber})",
      depositPaidNotRecorded: "Die Kaution wurde abgebucht und die Vermietung wurde angelegt \u2014 das System konnte die \xDCbergabe jedoch nicht erfassen. Das Ger\xE4t ist keiner Vermietung zugeordnet und steht m\xF6glicherweise noch am Tresen. Zahlung NICHT erneut starten: jeder Versuch erzeugt eine weitere Kautionsabbuchung und eine weitere Vermietung. Erstatten Sie die Kaution im Kautionsbereich und melden Sie den Fehler. ({contractNumber})",
      pickupFailed: "Ger\xE4te\xFCbergabe fehlgeschlagen. Die Vermietung blieb im ENTWURF-Status \u2014 bitte versuchen Sie es erneut auf der Detailseite. Fehler: {error}",
      depositRefundFailed: "R\xFCckgabe erfolgreich, aber Kautionsr\xFCckerstattung fehlgeschlagen. Betrag: {amount}. Fehler: {error}. Bitte erstatten Sie die Kaution manuell.",
      depositRefundTitle: "Mietr\xFCckgabe - Kautionsr\xFCckerstattung"
    },
    tasks: {
      loadAll: "Aufgaben konnten nicht geladen werden",
      loadByStatus: "Aufgaben konnten nicht geladen werden",
      loadOne: "Aufgabe konnte nicht geladen werden",
      loadOverdue: "\xDCberf\xE4llige Aufgaben konnten nicht geladen werden",
      loadStats: "Statistiken konnten nicht geladen werden"
    },
    users: {
      create: "Benutzer konnte nicht erstellt werden",
      delete: "Benutzer konnte nicht gel\xF6scht werden",
      loadAll: "Benutzer konnten nicht geladen werden",
      loadOne: "Benutzer konnte nicht geladen werden",
      update: "Benutzer konnte nicht aktualisiert werden"
    },
    contracts: {
      loadAll: "Vertr\xE4ge konnten nicht geladen werden",
      loadOne: "Vertrag konnte nicht geladen werden"
    },
    quotations: {
      loadAll: "Angebote konnten nicht geladen werden",
      loadOne: "Angebot konnte nicht geladen werden"
    },
    NOT_FOUND: "Nicht gefunden",
    BAD_REQUEST: "Ung\xFCltige Anfrage",
    UNAUTHORIZED: "Nicht autorisiert",
    FORBIDDEN: "Zugriff verweigert",
    CONFLICT: "Konflikt \u2014 Element existiert bereits",
    INTERNAL_ERROR: "Interner Serverfehler",
    VALIDATION_FAILED: "Validierungsfehler",
    AUTH_MISSING: "Authentifizierung erforderlich",
    AUTH_INVALID_TOKEN: "Ung\xFCltiges Token",
    AUTH_TOKEN_EXPIRED: "Token abgelaufen",
    AUTH_ACCESS_TOKEN_REQUIRED: "Access-Token erforderlich",
    AUTH_INVALID_CREDENTIALS: "Ung\xFCltige Anmeldedaten",
    AUTH_SESSION_EXPIRED: "Sitzung abgelaufen, bitte erneut anmelden",
    AUTH_INVALID_PIN: "Ung\xFCltiger PIN-Code",
    RENTAL_NOT_FOUND: "Vermietung nicht gefunden",
    RENTAL_INVALID_STATUS: "Ung\xFCltiger Vermietungsstatus",
    RENTAL_INVALID_TRANSITION: "Ung\xFCltiger Status\xFCbergang",
    RENTAL_ALREADY_EXISTS: "Vermietung existiert bereits",
    RENTAL_EQUIPMENT_NOT_AVAILABLE: "Ger\xE4t nicht verf\xFCgbar",
    RENTAL_CONTRACT_NOT_FOUND: "Mietvertrag nicht gefunden",
    RENTAL_DEPOSIT_NOT_FOUND: "Kaution nicht gefunden",
    RENTAL_DEPOSIT_ALREADY_EXISTS: "Kaution f\xFCr diese Vermietung existiert bereits",
    RENTAL_DEPOSIT_INVALID_AMOUNT: "Kautionsbetrag muss positiv sein",
    RENTAL_DEPOSIT_INVALID_STATUS: "Ung\xFCltiger Kautionsstatus",
    RENTAL_DEPOSIT_INSUFFICIENT: "Vor der \xDCbergabe muss die vollst\xE4ndige Kaution hinterlegt werden",
    RENTAL_HISTORY_NOT_FOUND: "Miethistorie nicht gefunden",
    WORKSHEET_NOT_FOUND: "Arbeitsblatt nicht gefunden",
    WORKSHEET_INVALID_STATUS: "Ung\xFCltiger Arbeitsblattstatus",
    WORKSHEET_INVALID_TRANSITION: "Ung\xFCltiger Arbeitsblatt-Status\xFCbergang",
    WARRANTY_CLAIM_NOT_FOUND: "Garantieanspruch nicht gefunden",
    WARRANTY_INVALID_STATUS: "Ung\xFCltiger Garantiestatus",
    SERVICE_NORM_NOT_FOUND: "Servicenorm nicht gefunden",
    SERVICE_NORM_INVALID_CODE: "Ung\xFCltiger Normcode",
    DIAGNOSTIC_NOT_FOUND: "Diagnose nicht gefunden",
    INVOICE_NOT_FOUND: "Rechnung nicht gefunden",
    INVOICE_INVALID_STATUS: "Ung\xFCltiger Rechnungsstatus",
    INVOICE_INVALID_TRANSITION: "Ung\xFCltiger Rechnungs-Status\xFCbergang",
    INVOICE_ITEM_NOT_FOUND: "Rechnungsposition nicht gefunden",
    POS_SESSION_NOT_FOUND: "Kassensitzung nicht gefunden",
    POS_SESSION_ALREADY_OPEN: "Kassensitzung bereits ge\xF6ffnet",
    QUOTE_NOT_FOUND: "Angebot nicht gefunden",
    QUOTE_INVALID_STATUS: "Ung\xFCltiger Angebotsstatus",
    QUOTE_ITEM_NOT_FOUND: "Angebotsposition nicht gefunden",
    QUOTE_ONLY_DRAFT_MODIFIABLE: "Nur Entwurfsangebote k\xF6nnen ge\xE4ndert werden",
    QUOTE_ONLY_DRAFT_DELETABLE: "Nur Entwurfsangebote k\xF6nnen gel\xF6scht werden",
    QUOTE_ONLY_DRAFT_SENDABLE: "Nur Entwurfs- oder gesendete Angebote k\xF6nnen versendet werden",
    QUOTE_EMAIL_NOT_CONFIGURED: "E-Mail-Dienst nicht konfiguriert",
    QUOTE_RECIPIENT_REQUIRED: "Empf\xE4nger-E-Mail ist erforderlich",
    QUOTE_PARTNER_REQUIRED: "Partner ist erforderlich",
    QUOTE_ITEMS_REQUIRED: "Mindestens eine Position ist erforderlich",
    QUOTE_INVALID_QUANTITY: "Menge muss positiv sein",
    QUOTE_INVALID_UNIT_PRICE: "St\xFCckpreis darf nicht negativ sein",
    QUOTE_EXPLODED_VIEW_NOT_FOUND: "Explosionszeichnung nicht gefunden",
    QUOTE_MANUFACTURER_REQUIRED: "Hersteller ist erforderlich",
    QUOTE_MODEL_REQUIRED: "Maschinenmodell-ID ist erforderlich",
    QUOTE_PARTS_REQUIRED: "Mindestens ein Teil muss ausgew\xE4hlt werden",
    PARTNER_NOT_FOUND: "Partner nicht gefunden",
    PARTNER_ALREADY_EXISTS: "Partner existiert bereits",
    PARTNER_INVALID_TAX_NUMBER: "Ung\xFCltige Steuernummer",
    PARTNER_DUPLICATE: "Doppelter Partner",
    PARTNER_CONTRACT_NOT_FOUND: "Partnervertrag nicht gefunden",
    PARTNER_REFERENCE_NOT_FOUND: "Partnerreferenz nicht gefunden",
    WAREHOUSE_NOT_FOUND: "Lager nicht gefunden",
    WAREHOUSE_LOCATION_NOT_FOUND: "Lagerplatz nicht gefunden",
    STOCK_INSUFFICIENT: "Unzureichender Bestand",
    STOCK_COUNT_NOT_FOUND: "Inventur nicht gefunden",
    MOVEMENT_NOT_FOUND: "Lagerbewegung nicht gefunden",
    MOVEMENT_INVALID_TYPE: "Ung\xFCltiger Bewegungstyp",
    PHANTOM_WAREHOUSE_NOT_FOUND: "Phantomlager nicht gefunden",
    PRODUCT_NOT_FOUND: "Produkt nicht gefunden",
    PRODUCT_SKU_EXISTS: "Artikelnummer existiert bereits",
    PRODUCT_CATEGORY_NOT_FOUND: "Produktkategorie nicht gefunden",
    PRODUCT_SUPPLIER_NOT_FOUND: "Lieferant nicht gefunden",
    VEHICLE_NOT_FOUND: "Fahrzeug nicht gefunden",
    VEHICLE_DOCUMENT_EXPIRED: "Fahrzeugdokument abgelaufen",
    CALENDAR_INVALID_DATE: "Ung\xFCltiges Datumsformat",
    CALENDAR_HOLIDAY_NOT_FOUND: "Feiertag nicht gefunden",
    CALENDAR_OVERRIDE_NOT_FOUND: "Kalender\xFCberschreibung nicht gefunden",
    PORTAL_INVALID_TOKEN: "Ung\xFCltiges Portal-Token",
    PORTAL_INVALID_OTP: "Ung\xFCltiges Einmalpasswort",
    PORTAL_BOOKING_NOT_FOUND: "Buchung nicht gefunden",
    PORTAL_EQUIPMENT_NOT_FOUND: "Ger\xE4t nicht gefunden",
    CASH_REGISTER_NOT_FOUND: "Kasse nicht gefunden",
    CASH_REGISTER_ALREADY_CLOSED: "Kasse bereits geschlossen",
    DAILY_CLOSE_ALREADY_EXISTS: "Tagesabschluss bereits durchgef\xFChrt",
    DELIVERY_NOTE_NOT_FOUND: "Lieferschein nicht gefunden",
    DELIVERY_NOTE_INVALID_STATUS: "Ung\xFCltiger Lieferscheinstatus",
    MENU_ITEM_ID_REQUIRED: "Men\xFCpunkt-ID ist erforderlich",
    FAVORITES_REQUIRED: "Favoritenliste ist erforderlich",
    EQUIPMENT_NOT_FOUND: "Ger\xE4t nicht gefunden",
    EQUIPMENT_NOT_AVAILABLE: "Ger\xE4t nicht verf\xFCgbar",
    KB_ARTICLE_NOT_FOUND: "Wissensdatenbank-Artikel nicht gefunden",
    WIDGET_ID_INVALID: "Ung\xFCltige Widget-ID",
    TENANT_CONTEXT_REQUIRED: "Mandantenkontext erforderlich",
    PRI_API_KEY_REQUIRED: "API-Schl\xFCssel erforderlich, wenn aktiviert",
    HOURLY_RATE_NEGATIVE: "Der Stundensatz darf nicht negativ sein",
    MACHINE_CATEGORY_NOT_FOUND: "Maschinenkategorie nicht gefunden",
    HOURLY_RATE_INVALID_DATE: "Ung\xFCltiges Datum",
    HOURLY_RATE_PERIOD_ORDER: "Das Enddatum darf nicht vor dem Startdatum liegen",
    HOURLY_RATE_NOT_FOUND: "Stundensatz-Konfiguration nicht gefunden",
    LEAVE_OVERLAP: "Sie haben bereits einen Urlaubsantrag f\xFCr diesen Zeitraum",
    LEAVE_INSUFFICIENT_BALANCE: "Unzureichendes Urlaubsguthaben f\xFCr diesen Antrag",
    LEAVE_REQUEST_NOT_FOUND: "Urlaubsantrag nicht gefunden",
    LEAVE_NOT_PENDING: "Der Antrag ist nicht mehr ausstehend",
    EMPLOYEE_PROFILE_NOT_FOUND: "Mitarbeiterprofil nicht gefunden",
    WARRANTY_ELIGIBLE_LIST_FAILED: "Anspruchsberechtigte Arbeitsbl\xE4tter konnten nicht geladen werden",
    WARRANTY_BATCH_FAILED: "Sammel-Garantieabrechnung fehlgeschlagen",
    WARRANTY_BATCH_INPUT_REQUIRED: "Fehlende Eingaben f\xFCr die Sammelabrechnung",
    WARRANTY_BATCH_INVALID_DATE: "Ung\xFCltiges Datum im Abrechnungszeitraum",
    WARRANTY_BATCH_PERIOD_ORDER: "Das Startdatum darf nicht nach dem Enddatum liegen",
    WARRANTY_ALREADY_INVOICED: "Diese Garantieposition wurde bereits abgerechnet",
    WORKSHEET_ID_REQUIRED: "Arbeitsblatt-ID ist erforderlich",
    PARTNER_DUPLICATE_TAX: "Ein Partner mit dieser Steuernummer existiert bereits \u2014 bitte aus der Liste ausw\xE4hlen.",
    PARTNER_DUPLICATE_CODE: "Partnercode-Konflikt. Bitte erneut versuchen \u2014 es wird ein neuer Code erzeugt.",
    CALCULATE_FAILED: "Die Lohnberechnung wurde nicht abgeschlossen. Bitte wenden Sie sich an Ihren Systemadministrator.",
    BOLT_APPROVE_FAILED: "Die Filialgenehmigung wurde nicht abgeschlossen. Bitte wenden Sie sich an Ihren Systemadministrator.",
    CENTRAL_REVIEW_FAILED: "Die zentrale Pr\xFCfung wurde nicht abgeschlossen. Bitte wenden Sie sich an Ihren Systemadministrator.",
    FINALIZE_FAILED: "Der Abschluss der Lohnabrechnung wurde nicht durchgef\xFChrt. Bitte wenden Sie sich an Ihren Systemadministrator."
  },
  login: {
    title: "Anmeldung",
    email: "E-Mail-Adresse",
    password: "Passwort",
    rememberMe: "Angemeldet bleiben",
    submit: "Anmelden",
    error: "Anmeldefehler",
    forgotPassword: "Passwort vergessen?",
    systemName: "rPI ERP-System",
    testCredentials: "Testdaten",
    placeholder: {
      email: "beispiel@email.de"
    },
    errorInvalidCredentials: "Falsche E-Mail-Adresse oder falsches Passwort.",
    errorSystemTemporary: "Vor\xFCbergehender Systemfehler. Bitte versuche es in einigen Minuten erneut.",
    errorTooManyAttempts: "Zu viele fehlgeschlagene Versuche. Bitte warte einige Minuten.",
    errorNetwork: "Verbindung zum Server fehlgeschlagen. \xDCberpr\xFCfe deine Internetverbindung."
  },
  rental: {
    loyalty: {
      title: "Treuepunkte einl\xF6sen",
      balance: "Guthaben: {points} Punkte",
      applied: "{points} Punkte eingel\xF6st",
      capReached: "Maximal einl\xF6sbar sind 50% der Rechnung \u2014 der Rest bleibt erhalten."
    },
    clone: {
      cta: "Wie beim letzten Mal ({code})",
      label: "Wie beim letzten Mal?",
      lastRental: "Letzte Miete: {code}",
      helper: "F\xFCllt Maschinen und Zubeh\xF6r aus, danach anpassbar",
      button: "Wiederholen \u2192",
      banner: {
        label: "Wie beim letzten Mal",
        summary: "{equipment} Maschinen \xB7 {package} Pakete",
        helper: "F\xFCllt Maschinen, Pakete und Zubeh\xF6r automatisch aus. Danach beliebig anpassbar.",
        apply: "Wiederholen",
        dismiss: "Leere Miete"
      }
    },
    inlineSign: {
      cta: "Vertrag jetzt unterschreiben",
      startFailed: "Vertrag konnte nicht vorbereitet werden."
    },
    pickup: {
      conflictTitle: "Ger\xE4t zwischenzeitlich vergeben",
      conflictDesc: "Eine andere Kasse hat dieses Ger\xE4t inzwischen ausgegeben. Verf\xFCgbarkeit aktualisiert \u2014 anderes Ger\xE4t w\xE4hlen oder erneut versuchen."
    },
    itemDiscount: {
      title: "Rabatt pro Ger\xE4t",
      helper: "Manueller Rabatt pro Position. \xDCber dem Rollenlimit (Role-Cap) kappt das System automatisch.",
      inputAria: "Rabatt % \u2014 {name}",
      applied: "Angewendet: {pct}%",
      cappedByRole: "auf Rollenlimit gekappt: {pct}%",
      totalDiscount: "Gesamtrabatt",
      finalAmount: "Endbetrag",
      apply: "Rabatt anwenden",
      noneEntered: "Mindestens einen Rabatt-% eingeben.",
      applyFailed: "Rabatt konnte nicht angewendet werden."
    },
    handover: {
      title: "Zustandsfotos",
      uploadHandover: "\xDCbergabefoto hochladen",
      uploadReturn: "R\xFCcknahmefoto hochladen",
      empty: "Noch keine Fotos hochgeladen",
      uploading: "Wird hochgeladen\u2026",
      errorType: "Nicht unterst\xFCtzter Dateityp. Erlaubt: JPEG, PNG, WebP.",
      errorSize: "Datei ist zu gro\xDF (max. {max} MB).",
      compareTitle: "Zustandsvergleich (\xDCbergabe \u2194 R\xFCckgabe)",
      compareHint: "Vergleich der \xDCbergabe- und R\xFCckgabefotos \u2014 bereits bei der \xDCbergabe vorhandene Sch\xE4den belasten den Mieter bei der Kautionsabrechnung nicht.",
      handoverColumn: "\xDCbergabezustand",
      returnColumn: "R\xFCckgabezustand"
    },
    title: "Vermietung",
    subtitle: "Vermietungsverwaltung und -verfolgung",
    fleetCalendar: {
      title: "Ger\xE4tekalender",
      available: "Verf\xFCgbar",
      rented: "Vermietet",
      reserved: "Reserviert",
      overdue: "\xDCberf\xE4llig",
      equipment: "Ger\xE4t",
      noEquipment: "Keine Ger\xE4te anzuzeigen"
    },
    newRental: "Neue Vermietung",
    equipment: "Ger\xE4t",
    startDate: "Startdatum",
    endDate: "Enddatum",
    deposit: "Kaution",
    dailyRate: "Tagessatz",
    returnDate: "R\xFCckgabedatum",
    returnRental: "Vermietung zur\xFCckgeben",
    status: {
      active: "Aktiv",
      expired: "Abgelaufen",
      returned: "Zur\xFCckgegeben",
      cancelled: "Storniert"
    },
    contract: "Vertrag",
    period: "Zeitraum",
    rentalFee: "Mietgeb\xFChr",
    depositPaid: "Kaution bezahlt",
    returnDeposit: "Kaution zur\xFCckgeben",
    selectReturnRental: "Vermietung zur R\xFCckgabe ausw\xE4hlen",
    equipmentConditionCheck: "Ger\xE4tezustandspr\xFCfung",
    paymentSettlement: "Zahlungsabrechnung",
    returnConfirmation: "R\xFCckgabebest\xE4tigung",
    activeRentalsCount: "Aktive Vermietungen ({count})",
    searchPlaceholder: "Suche nach Vertragsnr., Partner oder Ger\xE4t...",
    allStatuses: "Alle Status",
    selectEquipment: "Ger\xE4t zur R\xFCckgabe ausw\xE4hlen",
    rentalData: "Vermietungsdaten",
    financialSettlement: "Finanzielle Abrechnung",
    damageBreakdown: "Schadenersatz pro Ger\xE4t",
    deductions: "Abz\xFCge",
    lateFee: "Versp\xE4tungsgeb\xFChr ({days} Tage)",
    totalDamage: "Gesamtschaden",
    totalDeductions: "Gesamtabz\xFCge:",
    returnableDeposit: "R\xFCckzahlbare Kaution:",
    summary: "Zusammenfassung",
    returnedEquipment: "Zur\xFCckgegebene Ger\xE4te:",
    rentalContinues: "Vermietung l\xE4uft weiter:",
    returnable: "R\xFCckzahlbar:",
    partialReturnConfirm: "Teilr\xFCckgabe best\xE4tigen",
    returnConfirm: "R\xFCckgabe best\xE4tigen",
    returnedItems: "Zur\xFCckgegebene Artikel",
    continuingItems: "Vermietung l\xE4uft weiter",
    returnableDeposit2: "R\xFCckzahlbare Kaution",
    cashPayment: "Bargeld",
    cardPayment: "Karte",
    transferPayment: "\xDCberweisung",
    cashPaymentLabel: "In bar",
    cardPaymentLabel: "Auf Karte",
    transferPaymentLabel: "Per \xDCberweisung",
    deductionsLabel: "Abz\xFCge:",
    searchRentalPlaceholder: "Suche nach Mietnr., Partner oder Ger\xE4t...",
    overdueSubtitle: "\xDCberf\xE4llige und nicht zur\xFCckgegebene Ger\xE4te",
    searchPartnerPlaceholder: "Suche nach Partnername, Ger\xE4tename...",
    loadingActive: "Aktive Vermietungen werden geladen...",
    returnNotFound: "Vermietung nicht gefunden oder bereits zur\xFCckgegeben.",
    allRentals: "Alle Vermietungen",
    partnerNameCol: "Partnername",
    callPartner: "Partner anrufen",
    smsReminder: {
      triggerLabel: "SMS-Erinnerung",
      title: "SMS-Erinnerung senden",
      recipientLabel: "Empf\xE4nger",
      messageLabel: "Nachricht",
      defaultMessage: "Sehr geehrte(r) {customerName}! Die R\xFCckgabefrist f\xFCr das gemietete Ger\xE4t {equipmentName} ist vor {days} Tag(en) abgelaufen. Bitte bringen Sie es bald zur\xFCck oder kontaktieren Sie uns. Mit freundlichen Gr\xFC\xDFen: Kisg\xE9pcentrum",
      send: "Senden",
      sending: "Senden...",
      close: "Schlie\xDFen",
      status: {
        sent: "An den Anbieter gesendet",
        blocked: "Nicht gesendet \u2014 SMS-Versand ist derzeit deaktiviert (Gate geschlossen)",
        dryRun: "Testmodus: nicht gesendet (DRY-RUN), Nachricht protokolliert",
        failed: "Senden fehlgeschlagen"
      }
    },
    equipmentNameCol: "Ger\xE4tebezeichnung",
    expiryDate: "Ablaufdatum",
    daysOverdue: "Tage \xFCberf\xE4llig",
    rentalCodeCol: "Mietcode",
    amountCol: "Betrag",
    lateFeeLabel: "Versp\xE4tungsgeb\xFChr",
    estimatedLateFeeCol: "Voraussichtliche Geb\xFChr",
    estimatedLateFeeHint: "Bei jetziger R\xFCckgabe zu erwartende Versp\xE4tungsgeb\xFChr (Vorschau \u2014 der endg\xFCltige Betrag wird bei der R\xFCckgabe berechnet)",
    currentDebt: "Ausstehender Betrag",
    debtExceedsDeposit: "Kautionsdeckung \xFCberschritten!",
    daysLateLabel: "{days} Tage Versp\xE4tung",
    daysLabel: "{days} Tage",
    expired: "Abgelaufen:",
    noOverdue: "Keine \xDCberf\xE4lligkeiten",
    allReturned: "Alle Ger\xE4te wurden p\xFCnktlich zur\xFCckgegeben!",
    backToRentals: "Zur\xFCck zu Vermietungen",
    rentalReturn: "Mietr\xFCckgabe",
    unknownEquipment: "Unbekanntes Ger\xE4t",
    equipmentCount: "{count} Ger\xE4te",
    multiItemInfo: "Mehrteilige Vermietung \u2014 w\xE4hlen Sie aus, welche Ger\xE4te zur\xFCckgegeben werden. Nicht ausgew\xE4hlte Ger\xE4te werden weiter vermietet.",
    earlyReturnLabel: "Vorzeitige R\xFCckgabe",
    earlyReturnDays: "Vorzeitige R\xFCckgabe \u2014 {actual}/{original} Tage",
    originalDiscount: "Urspr\xFCnglicher Rabatt:",
    actualDiscount: "Tats\xE4chlicher Rabatt:",
    discountChanged: "Die Rabattstufe hat sich ge\xE4ndert \u2014 der Preis wird neu berechnet.",
    discountUnchanged: "Die Rabattstufe hat sich nicht ge\xE4ndert \u2014 der Originalpreis gilt.",
    selectEquipmentReturn: "Ger\xE4te zur R\xFCckgabe ausw\xE4hlen",
    selectEquipmentSingle: "Ger\xE4t zur R\xFCckgabe",
    issuedCondition: "Zustand bei Ausgabe:",
    returnConditionLabel: "R\xFCckgabezustand",
    damageDescription: "Schadensbeschreibung",
    damagePlaceholder: "Schadensbeschreibung (falls vorhanden)...",
    damageChargeLabel: "Schadensersatz (Ft)",
    damageDescriptionAria: "Schadensbeschreibung: {name}",
    contractLabel: "Vertrag:",
    partnerLabel: "Partner:",
    periodLabel: "Zeitraum:",
    rentalFeeLabel: "Mietgeb\xFChr:",
    depositPaidLabel: "Kaution bezahlt:",
    partialReturnInfo: "Teilr\xFCckgabe: {returning} Ger\xE4te zur\xFCckgegeben, {continuing} Ger\xE4te weiter vermietet",
    damageBreakdownLabel: "Schadensersatz pro Ger\xE4t",
    noDeductions: "Keine Abz\xFCge",
    depositPaidSummary: "Kaution bezahlt:",
    totalDeductionsSummary: "Gesamtabz\xFCge:",
    depositRefundMethod: "Kautionsr\xFCckzahlungsmethode",
    optionalNotePlaceholder: "Optionale Anmerkung...",
    returnNoteAria: "R\xFCckgabeanmerkung",
    returnedEquipmentLabel: "Zur\xFCckgegebene Ger\xE4te:",
    rentalContinuesLabel: "Vermietung l\xE4uft weiter:",
    returnableLabel: "R\xFCckzahlbar:",
    partialReturnConfirmTitle: "Teilr\xFCckgabe best\xE4tigen",
    returnConfirmTitle: "R\xFCckgabe best\xE4tigen",
    contractSummaryLabel: "Vertrag:",
    partnerSummaryLabel: "Partner:",
    finalizeReturn: "R\xFCckgabe abschlie\xDFen",
    returnTypePartial: "Teilr\xFCckgabe",
    returnTypeFull: "Vollst\xE4ndige R\xFCckgabe",
    returnSuccess: "{type} erfolgreich!\n\nVertrag: {contract}\nZur\xFCckgegebene Ger\xE4te: {equipment}\nKautionsr\xFCckzahlung: {deposit}",
    lateFeeWithDays: "Versp\xE4tungsgeb\xFChr ({days} Tage)",
    lateFeeConfirmLabel: "Versp\xE4tungsgeb\xFChr:",
    lateFeeBreakdown: "{days} angefangene Tag(e) \xD7 {rate}/Tag",
    lateFeeBreakdownCapped: "Obergrenze erreicht ({max})",
    lateFeeModelLegacy: "150%-Tagesmodell",
    lateFeeWaived: "Versp\xE4tungsgeb\xFChr erlassen",
    damageConfirmLabel: "Schadensersatz:",
    errorPrefix: "Fehler: {message}",
    daysDelayLabel: "{days} Tage Versp\xE4tung",
    depositLabel: "Kaution:",
    lateFeeAmount: "Versp\xE4tungsgeb\xFChr:",
    quantityLabel: "Menge: {count} Stk.",
    tierLabels: {
      hourly: "St\xFCndlich",
      daily: "T\xE4glich",
      weekly: "W\xF6chentlich",
      monthly: "Monatlich"
    },
    startTime: "Startzeit",
    returnTime: "R\xFCckgabezeit",
    rentalNotes: "Notizen zur Vermietung",
    rentalNotesPlaceholder: "Optionale Notizen zur Vermietung...",
    quantityPcs: "Menge: {count} Stk.",
    daysAgo: "Seit {days} Tagen \xFCberf\xE4llig",
    daysLeft: "Noch {days} Tage",
    daysUntilExpiry: "Noch {days} Tage bis zum Ablauf",
    expiresToday: "L\xE4uft heute ab!",
    extension: "Verl\xE4ngern",
    extensionDialog: {
      additionalDays: "Zus\xE4tzliche Tage",
      currentExpiry: "Aktuelles Ablaufdatum",
      dateError: "Das neue Datum muss nach dem aktuellen Ablaufdatum liegen",
      day: "Tag",
      days: "Tage",
      discountTierChange: "Rabattstufen\xE4nderung",
      newExpiryDate: "Neues Ablaufdatum",
      priceDisclaimer: "Der Endpreis wird auf Grundlage des Mietpreisplans berechnet",
      reasonLabel: "Grund der Verl\xE4ngerung (optional)",
      reasonPlaceholder: "Warum ist die Verl\xE4ngerung erforderlich...",
      surcharge: "Aufpreis",
      surchargeWithVat: "Aufpreis inkl. MwSt.",
      title: "Vermietung verl\xE4ngern"
    },
    extensionError: "Fehler bei der Verl\xE4ngerung",
    financialSummary: "Finanz\xFCbersicht",
    history: "Verlauf",
    notFound: "Vermietung nicht gefunden",
    notFoundDescription: "Die angeforderte Vermietung existiert nicht oder wurde gel\xF6scht",
    overdueAlert: "Seit {days} Tagen \xFCberf\xE4llig \u2014 Verzugsgeb\xFChr wird berechnet!",
    partnerDetails: "Partnerdaten",
    printContract: "Vertrag drucken",
    quickInfo: "Kurzinfo",
    remaining: "Verbleibende Zeit",
    rentedEquipment: "Gemietetes Ger\xE4t",
    sendEmail: "Per E-Mail senden",
    timeline: {
      contractCreated: "Vertrag erstellt",
      depositPaid: "Kaution bezahlt",
      rentalStarted: "Vermietung gestartet"
    },
    totalRentalFee: "Gesamtmietgeb\xFChr",
    stepWizard: {
      navLabel: "Mietschritte",
      step1: "Partner",
      step2: "Ger\xE4te",
      step3: "Zeitraum",
      step4: "Vertrag",
      stepAria: "Schritt {n}",
      stepDoneAria: "erledigt"
    },
    finalizeChecklist: {
      title: "Vor dem Abschluss",
      allReady: "Alles bereit zur \xDCbergabe",
      incomplete: "Noch {count} Punkt(e) fehlen",
      itemPartner: "Partner ausgew\xE4hlt",
      itemEquipment: "Ger\xE4t im Warenkorb",
      itemSchedule: "Mietzeitraum festgelegt",
      itemPayment: "Zahlungsart ausgew\xE4hlt",
      doneAria: "erledigt",
      missingAria: "fehlt",
      fix: "Beheben \u2192"
    },
    wizard: {
      draftRef: "Entwurf",
      ctx: {
        renter: "MIETER",
        machines: "GER\xC4TE",
        accCount: "{count} Zubeh\xF6r",
        payCard: "Karte",
        payCash: "Bargeld",
        payTransfer: "\xDCberweisung"
      },
      depositPaidLabel: "Kaution bezahlt",
      depositPaidYes: "Der Kunde zahlt jetzt",
      depositPaidNo: "Zahlt sp\xE4ter oder nicht erforderlich",
      title: "Vermietung starten",
      subtitle: "Neue Vermietung erstellen",
      stepPartnerDesc: "Mieter ausw\xE4hlen",
      stepCostBearerTitle: "Kostentr\xE4ger",
      stepCostBearerDesc: "Wer zahlt?",
      stepEquipmentTitle: "Ger\xE4t",
      stepEquipmentDesc: "Ger\xE4t ausw\xE4hlen",
      stepDetailsDesc: "Zeitraum und Preis",
      stepSummaryTitle: "Zusammenfassung",
      stepSummaryDesc: "Abschlie\xDFen",
      missingData: "Fehlende Daten",
      missingDataDesc: "Bitte f\xFCllen Sie alle Pflichtfelder aus",
      rentalCreated: "Vermietung erfolgreich erstellt!",
      contractNumber: "Vertragsnummer: {number}",
      rentalCreateFailed: "Vermietung konnte nicht erstellt werden",
      unknownError: "Unbekannter Fehler aufgetreten",
      cancelConfirm: "M\xF6chten Sie die Vermietung wirklich abbrechen?",
      myposTransaction: "MyPOS-Transaktion...",
      creatingRental: "Vermietung wird erstellt...",
      finalizeRental: "Vermietung abschlie\xDFen",
      selectPartner: "Mieter (Hauptpartner) w\xE4hlen",
      selectPartnerDesc: "Suchen oder w\xE4hlen Sie den Mietpartner",
      searchPartnerPlaceholder: "Suche nach Name, E-Mail, Telefon, Steuernummer, Stadt oder Ausweis...",
      partnersLoading: "Partner werden geladen...",
      partnersLoadError: "Fehler beim Laden der Partner: {message}",
      noPartnerResults: "Keine Ergebnisse gefunden",
      createNewPartner: "+ Neuen Partner erstellen",
      selectedPartner: "Ausgew\xE4hlter Partner: {name}",
      trustedStatus: "Stammkunde",
      warningStatus: "Warnung",
      blockedStatus: "Gesperrt",
      inactiveStatus: "Inaktiv",
      phoneLabel: "Tel:",
      emailLabel: "E-Mail:",
      taxNumberLabel: "StNr:",
      idCardLabel: "Ausweis:",
      costBearerLabel: "Kostentr\xE4ger:",
      balanceLabel: "Saldo:",
      loyaltyPointsUnit: "Pkt.",
      totalRentalsLabel: "Vermietungen gesamt:",
      lastRentalLabel: "Letzte Vermietung:",
      costBearerTitle: "Kostentr\xE4ger",
      costBearerDesc: "Wer zahlt die Mietgeb\xFChr?",
      partnerPaysSelf: "Partner zahlt selbst",
      partnerPaysDesc: "{name} zahlt die Mietgeb\xFChr",
      costBearerPays: "Kostentr\xE4ger zahlt:",
      costBearerPaysDesc: "Ein anderer Partner oder Unternehmen zahlt die Mietgeb\xFChr",
      selectCostBearer: "W\xE4hlen Sie den Kostentr\xE4ger:",
      knownCostBearers: "Bekannte Kostentr\xE4ger",
      searchPartner: "Partner suchen...",
      noCostBearerPartner: "Kein verf\xFCgbarer Kostentr\xE4ger-Partner",
      defaultCostBearer: "Standard-Kostentr\xE4ger:",
      partnerPaysSelfSummary: "Partner zahlt selbst: {name}",
      selectEquipmentTitle: "Ger\xE4te ausw\xE4hlen",
      selectEquipmentDesc: "W\xE4hlen Sie die zu vermietenden Ger\xE4te",
      searchEquipmentPlaceholder: "Suche nach Name, Artikelnummer, Seriennummer, Marke...",
      allFilter: "Alle ({count})",
      cart: "Warenkorb ({items} Artikel, {total} Stk.)",
      dailyTotal: "Tagessumme: {amount}",
      clearCart: "Warenkorb leeren",
      perDay: "/Tag",
      removeItem: "Entfernen",
      decrease: "Verringern",
      increase: "Erh\xF6hen",
      totalDeposit: "Gesamtkaution:",
      equipmentLoading: "Ger\xE4te werden geladen...",
      equipmentLoadError: "Fehler beim Laden der Ger\xE4te: {error}",
      noEquipmentResults: "Keine Ger\xE4te verf\xFCgbar, die den Filterkriterien entsprechen",
      itemCode: "Artikelnr.:",
      brand: "Marke:",
      condition: "Zustand:",
      categoryLabel: "Kategorie:",
      dailyPrice: "T\xE4glich",
      weeklyPrice: "W\xF6chentlich",
      monthlyPrice: "Monatlich",
      inCart: "Im Warenkorb: {count} Stk.",
      addOne: "+1 Stk.",
      accessoriesLoading: "Zubeh\xF6r wird geladen...",
      accessoriesLabel: "Zubeh\xF6r:",
      requiredAccessory: "(erforderlich)",
      accessoryValue: "Zubeh\xF6rwert:",
      detailsTitle: "Mietdetails",
      detailsDesc: "Geben Sie den Mietzeitraum ein und \xFCberpr\xFCfen Sie die Preise",
      selectedItems: "Ausgew\xE4hlte Artikel",
      rentalPeriod: "Mietzeitraum",
      datePicker: {
        chip: {
          tomorrow: "Morgen",
          twoDays: "2 Tage",
          weekend: "Wochenende",
          oneWeek: "1 Woche",
          custom: "Benutzerdefiniert"
        }
      },
      scannerActive: "Scanner aktiv",
      scannerActiveHint: "USB / Bluetooth-Barcodeleser im Tastatur-Wedge-Modus",
      accessoryDrawer: {
        title: "Zubeh\xF6r \u2014 {name}",
        description: "Zubeh\xF6r f\xFCr dieses Ger\xE4t ausw\xE4hlen. Durchsuchbar, filterbar.",
        searchPlaceholder: "Nach Name, Artikelnummer suchen...",
        requiredOnly: "Nur Pflicht",
        close: "Zur\xFCck",
        addAccessory: "Hinzuf\xFCgen",
        noAccessories: "Keine Ergebnisse",
        isRequired: "Pflicht-Zubeh\xF6r",
        valueLabel: "Wert: {value}",
        loadingAccessories: "Zubeh\xF6r wird geladen...",
        moreAccessoriesBtn: "Mehr Zubeh\xF6r",
        prevPage: "Vorherige Seite",
        nextPage: "N\xE4chste Seite"
      },
      collapseAll: "Alle einklappen",
      collapseAllHint: "Alle Panels schlie\xDFen \u2014 \xDCbersicht",
      expandInvalid: "Nur unvollst\xE4ndige",
      expandInvalidHint: "Nur die Panels \xF6ffnen, die Aufmerksamkeit brauchen",
      scanSuccess: "{name} in den Warenkorb",
      scanError: "Scan-Fehler",
      scanUnavailable: "Nicht verf\xFCgbar",
      scanMatchedField: {
        qrCode: "\xDCber QR-Code erkannt",
        factoryBarcode: "\xDCber Barcode erkannt",
        equipmentCode: "\xDCber Ger\xE4tecode erkannt",
        serialNumber: "\xDCber Seriennummer erkannt"
      },
      returnDateLabel: "R\xFCckgabedatum",
      startTimeLabel: "Startzeit",
      returnTimeLabel: "R\xFCckgabezeit",
      hourlyBilling: "Stundenabrechnung",
      hourlyBillingDesc: "Stundenbasierte Abrechnung f\xFCr die Tagesmiete",
      durationHours: "{hours} Stunden",
      durationDays: "{days} Tage",
      priceCalc: "Preiskalkulation",
      duration: "Dauer",
      pricingType: "Preistyp",
      netRentalFee: "Netto-Mietgeb\xFChr",
      discount: "Rabatt",
      discountPercent: "Rabatt ({percent}%)",
      vat27: "MwSt. (27%)",
      rentalFeeTotal: "Mietgeb\xFChr gesamt",
      payNow: "Jetzt zu zahlen",
      payNowBreakdown: "(Mietgeb\xFChr: {fee} + Kaution: {deposit})",
      selectDatesForCalc: "W\xE4hlen Sie Daten f\xFCr die Preiskalkulation",
      breakdownTitle: "Details der Preisberechnung",
      breakdownDate: "Datum",
      breakdownDay: "Tag",
      breakdownType: "Typ",
      breakdownValue: "Wert",
      breakdownWorkday: "Werktag",
      breakdownSunday: "Sonntag",
      breakdownHoliday: "Feiertag",
      breakdownFullDay: "1 Tag",
      breakdownHalfDay: "\xBD Tag",
      breakdownCalendarDays: "Kalendertage",
      breakdownBillableDays: "Abrechnungstage",
      breakdownWeeklyDiscount: "Wochenrabatt (-{days} Tag)",
      breakdownPayableDays: "Zahlbare Tage",
      breakdownDailyRate: "Tagessatz",
      breakdownMonthlyNote: "{days} Tage \u2192 {billable} zahlbare Tage (Monatsrabatt)",
      perHour: "/Stunde",
      rentalNotesAriaLabel: "Anmerkungen zur Vermietung",
      summaryTitle: "Zusammenfassung",
      summaryDesc: "\xDCberpr\xFCfen Sie die Mietdaten und best\xE4tigen Sie",
      partnerData: "Partnerdaten",
      equipmentCount: "Ger\xE4te ({count} Stk.)",
      returnLabel: "R\xFCckgabe",
      durationLabel: "Dauer",
      paymentSummary: "Zahlungs\xFCbersicht",
      grossRentalFee: "Brutto-Mietgeb\xFChr",
      totalToPay: "GESAMTBETRAG",
      selectPaymentMethod: "Zahlungsmethode w\xE4hlen:",
      bankCard: "Bankkarte (MyPOS)",
      companyOnly: "(nur f\xFCr Unternehmen)",
      selectPaymentRequired: "Bitte w\xE4hlen Sie eine Zahlungsmethode",
      disclaimer: "Mit der Finalisierung der Vermietung akzeptiert der Partner die Bedingungen des Mietvertrags. Die Kaution wird bei unbesch\xE4digter R\xFCckgabe des Ger\xE4ts erstattet.",
      tierHourly: "St\xFCndlich",
      tierDaily: "Tagesmiete",
      tierWeekly: "Wochenmiete",
      tierMonthly: "Monatsmiete",
      contractCreated: "Vertragsnummer: {contractNumber}. {transactionInfo}",
      suggestedAccessories: "Empfohlenes Zubeh\xF6r",
      noSuggestedPackages: "Kein empfohlenes Zubeh\xF6rpaket",
      selectAccessoryPackage: "Ausw\xE4hlen",
      removeAccessoryPackage: "Entfernen",
      included: "Inklusive",
      consignment: "Kommission",
      accessoryPackageSelected: "Zubeh\xF6rpaket ausgew\xE4hlt",
      packages: {
        stepTitle: "Pakete",
        stepDesc: "Pakete pro Ger\xE4t zuordnen",
        intro: "Mehrere Pakete pro Ger\xE4t m\xF6glich (z. B. Sicherheit + Wartung).",
        emptyCart: "Zuerst Ger\xE4t zum Warenkorb hinzuf\xFCgen.",
        qtyLabel: "{qty} Stk",
        addPackage: "Paket hinzuf\xFCgen",
        noneAvailable: "F\xFCr dieses Ger\xE4t sind keine Pakete verf\xFCgbar.",
        duplicateTitle: "Paket bereits hinzugef\xFCgt",
        duplicateDesc: "{name} ist bereits angeh\xE4ngt \u2014 mehrere S\xE4tze sind erlaubt.",
        removeAria: "Paket {name} entfernen"
      },
      v2: {
        addPackageButton: "Paket hinzuf\xFCgen",
        cartCount: "{count} Stk.",
        cartCountFiltered: "{shown} / {total} Stk.",
        cartFilteredEmpty: "Kein Warenkorbeintrag entspricht dem aktiven Filter. Entferne einen Filter, um Eintr\xE4ge anzuzeigen.",
        cartTitle: "Mietger\xE4t-Warenkorb",
        categoryHeader: "Kategorie",
        clearFilters: "L\xF6schen",
        closePickerAriaLabel: "Schlie\xDFen",
        combinedStepTitle: "Ger\xE4te + Paket",
        conditionHeader: "Zustand",
        headerSubtitle: "Multi-Machine-Vermietung, 3-Spalten-Layout",
        search: {
          label: "Ger\xE4te suchen",
          placeholder: "Nach Name, Seriennummer oder Kategorie suchen\u2026",
          hint: "Tippe los, um Ger\xE4te zum Warenkorb hinzuzuf\xFCgen.",
          loading: "Suche\u2026",
          noResults: 'Keine Ergebnisse f\xFCr "{query}"',
          addAction: "Hinzuf\xFCgen",
          addedToCart: "Hinzugef\xFCgt: {name}",
          alreadyInCart: "{name} ist bereits im Warenkorb",
          alreadyAdded: "\u2713 Hinzugef\xFCgt",
          clearAriaLabel: "Suche l\xF6schen",
          noFilterMatch: "Keine Treffer f\xFCr die aktiven Filter."
        },
        deferredFilters: "Demn\xE4chst:",
        duplicateDesc: 'Paket "{name}" ist diesem Ger\xE4t bereits zugewiesen. Erneut hinzugef\xFCgt.',
        duplicateTitle: "Bereits hinzugef\xFCgt",
        emptyCart: "F\xFCge dem Warenkorb Ger\xE4te hinzu.",
        equipmentCount: "Ger\xE4te",
        filtersTitle: "Filter",
        headerTitle: "Miet-Assistent \u2014 Ger\xE4te und Pakete",
        packageCount: "Paket",
        packageRemoveAriaLabel: "Paket {name} entfernen",
        packagesEmpty: "Keine Pakete zugewiesen",
        packagesLoading: "Pakete werden geladen\u2026",
        packagesNoneAvailable: "Keine Pakete verf\xFCgbar",
        pricingDeposit: "Kaution",
        pricingDiscount: "Rabatt",
        pricingEmpty: "F\xFCge Ger\xE4t und Zeitraum hinzu, um die Preise zu sehen.",
        pricingError: "Preisberechnung konnte nicht geladen werden.",
        pricingGrandTotal: "Brutto",
        pricingHeader: "Preisgestaltung",
        pricingLoading: "Preise werden berechnet\u2026",
        pricingSubtotal: "Netto",
        pricingVat: "MwSt.",
        removeAriaLabel: "{name} entfernen",
        removeButton: "Entfernen",
        summaryDeferred: "Demn\xE4chst: Tages-/Wochenaufteilung, Rabattcoupon, Zahlungsmethoden-Vorschau.",
        summaryTitle: "Zusammenfassung",
        legend: {
          title: "Legende",
          free: "Kostenlos",
          rentable: "Mietbar",
          consignment: "Kommission"
        },
        itemQty: "{qty} Stk",
        itemQtyInc: "Erh\xF6hen",
        itemQtyDec: "Verringern",
        breakdownHeader: "Tagesaufschl\xFCsselung",
        breakdownWorkdays: "Werktage",
        breakdownSundays: "Sonntage",
        breakdownHolidays: "Feiertage",
        breakdownBillable: "Berechnete Tage",
        breakdownWeeklyDiscount: "Wochenrabatt (Tage)",
        periodLabel: "Mietzeitraum",
        editPeriod: "\xC4ndern",
        perMachineHeader: "Pro Ger\xE4t",
        unnamedItem: "Zubeh\xF6r",
        detail: {
          railTitle: "Gemietete Ger\xE4te",
          railCount: "{n} Ger\xE4t",
          railEmpty: "Noch keine Ger\xE4te im Warenkorb.",
          addMachineButton: "+ Ger\xE4t hinzuf\xFCgen",
          activeEmpty: "F\xFCge ein Ger\xE4t zum Warenkorb hinzu, um Details anzuzeigen.",
          detailHeader: "Ger\xE4tedetails",
          detailSku: "Code",
          detailDailyRate: "Tagessatz",
          detailPackageSection: "Paket",
          accessoryPlaceholder: "\u2014 Zubeh\xF6r (slice-2) \u2014",
          legendTitle: "Legende",
          legendFreeHint: "im Paket enthalten",
          legendRentableHint: "Tagessatz, nur f\xFCr genutzte Tage",
          legendConsignHint: "nur f\xFCr Verbrauchtes zahlen",
          lineTotal: "Zeilensumme",
          freeInPkg: "kostenlos im Paket",
          rentableUnit: "HUF/Tag",
          consignUnit: "HUF/Stk (Kommission)",
          calcPeriodTitle: "Zeitraum",
          calcDays: "{n} Tage",
          calcPerMachineTitle: "Aufschl\xFCsselung pro Ger\xE4t",
          calcMachineRent: "{rate} HUF/Tag \xD7 {days} Tage",
          calcEstTotal: "Gesch\xE4tzter Gesamtbetrag",
          calcNote: "{m} Ger\xE4te \xB7 {d} Tage",
          calcNoPricing: "Zeitraum einstellen f\xFCr Preisanzeige.",
          accCatalogTitle: "Zubeh\xF6r",
          accCatalogLoading: "Zubeh\xF6r wird geladen\u2026",
          accCatalogEmpty: "Kein Zubeh\xF6r f\xFCr dieses Ger\xE4t.",
          accCatalogError: "Fehler beim Laden des Zubeh\xF6rs.",
          accTabAll: "Alle",
          accStockN: "{n} Stk. auf Lager",
          accFree: "kostenlos",
          addMachineDialogTitle: "Ger\xE4t hinzuf\xFCgen",
          addMachineSearchPlaceholder: "Name oder Code suchen\u2026",
          addMachineHint: "Tippen Sie, um nach einem Ger\xE4t zu suchen.",
          addMachineAddAction: "In den Warenkorb"
        }
      },
      summary: {
        rental: "Mietgeb\xFChr",
        deposit: "Kaution",
        total: "Gesamtbetrag",
        consignment: "Kommission"
      },
      reservationTimer: {
        label: "Reservierung abschlie\xDFen:",
        expired: "Reservierungszeit abgelaufen \u2014 Abschluss weiterhin m\xF6glich.",
        hint: "Visuelle Erinnerung (keine Bestandsreservierung)"
      },
      selectedBadge: "Ausgew\xE4hlt",
      calendar: {
        prevMonth: "Voriger Monat",
        nextMonth: "N\xE4chster Monat"
      }
    },
    checkout: {
      grant: {
        toggle: {
          label: "Der Mieter bevollm\xE4chtigt jemanden zur Abholung",
          adrHint: "(grantor = Mieter \u2014 ADR-124)",
          desc: "PERMANENT-Vollmacht gilt bis zum Widerruf. ONE_TIME erfordert Papier-Vollmacht-Upload."
        },
        section: {
          title: "Bevollm\xE4chtigte Person"
        },
        loading: "Vollmachten werden geladen...",
        materializeFailed: "Vollmachtserstellung fehlgeschlagen \u2014 die Vermietung wurde gespeichert, aber die Vollmacht muss manuell auf der Vermietungsseite hinzugef\xFCgt werden.",
        permanentDropdown: {
          intro: "Aktive Vollmachten \u2014 w\xE4hle im Namen von {name}:",
          validFrom: "g\xFCltig seit {date}"
        },
        empty: {
          title: "Keine aktive permanente Vollmacht",
          desc: "{name} hat derzeit keinen PERMANENT-Grant.",
          tip: 'Tipp: permanente Vollmachten k\xF6nnen auf der Partner-Seite im Tab \u201EVollmachten" angelegt werden.'
        },
        oneTime: {
          cta: "Neue Einmal-Vollmacht",
          pendingHint: "Die Vollmacht wird beim Abschluss der Vermietung erstellt."
        },
        oneTimeDialog: {
          title: "Neue Einmal-Vollmacht",
          grantor: "Mieter (grantor): {name}",
          nameLabel: "Name der Abholperson",
          namePlaceholder: "z.B. Hans Schmidt",
          idCardLabel: "Ausweisnummer",
          idCardPlaceholder: "z.B. AB123456",
          phoneLabel: "Telefonnummer",
          phonePlaceholder: "+49 ...",
          gracePeriodWarning: "Papier-Vollmacht-Upload ist Sprint-18+-Scope. Die Vollmacht wird jetzt mit 24h Gnadenfrist erstellt.",
          submit: "Vollmacht erstellen",
          submitting: "Speichern...",
          errors: {
            nameRequired: "Name der Abholperson ist erforderlich",
            noRental: "Kein Mietkontext \u2014 f\xFCge zuerst mindestens einen Mietartikel hinzu.",
            documentRequired: "Papier-Vollmacht ist erforderlich",
            validationFailed: "Ung\xFCltige Bevollm\xE4chtigtendaten",
            network: "Netzwerkfehler, bitte erneut versuchen"
          }
        }
      },
      subheader: {
        connectionLabel: "Verbindung",
        renter: {
          label: "mietet"
        },
        payer: {
          label: "zahlt"
        },
        grantee: {
          label: "holt ab"
        }
      }
    },
    category: {
      handTools: "Handwerkzeuge",
      electricMachines: "Elektromaschinen",
      outdoorMachines: "Au\xDFenmaschinen",
      other: "Sonstige",
      construction: "Bau",
      cleaning: "Reinigung",
      machinery: "Maschinen",
      handTool: "Handwerkzeug",
      measurement: "Messwerkzeug",
      safety: "Arbeitssicherheit"
    },
    equipmentStatus: {
      available: "Verf\xFCgbar",
      rented: "Vermietet",
      inService: "In Wartung",
      reserved: "Reserviert"
    },
    condition: {
      excellent: "Ausgezeichnet",
      good: "Gut",
      fair: "Ausreichend",
      poor: "Schlecht",
      damaged: "Besch\xE4digt",
      damagedUsable: "Besch\xE4digt \u2014 nutzbar",
      damagedService: "Besch\xE4digt \u2192 Service",
      incomplete: "Unvollst\xE4ndig",
      new: "Neu",
      used: "Gebraucht"
    },
    sendToService: "An Service senden",
    serviceWorksheetCreated: "Arbeitsblatt erstellt: {code}",
    serviceWorksheetError: "Fehler beim Erstellen des Arbeitsblatts",
    damagedServiceInfo: "Dieses Ger\xE4t kann nicht erneut ausgegeben werden \u2014 es muss sofort in den Service.",
    damagedServiceDefaultFault: "Schaden nach Miete \u2014 Service erforderlich",
    crossSell: {
      addProduct: "Produkt hinzufuegen",
      additionalItems: "Zusaetzliche Produkte",
      rentalFee: "Mietgebuehr",
      productTotal: "Produktsumme",
      productVat: "Produkt MwSt. (27%)",
      searchPlaceholder: "Suche nach Name oder Artikelnummer...",
      noResults: "Keine Ergebnisse",
      stock: "Bestand",
      depositNote: "nur Miete",
      net: "netto",
      gross: "brutto",
      subtotal: "Produkte gesamt",
      remove: "Entfernen",
      quantity: "Menge",
      emptyCart: "Noch keine Produkte hinzugefuegt",
      unitPrice: "Stueckpreis",
      lineTotal: "Gesamt",
      searching: "Suche...",
      add: "Hinzufuegen",
      pcs: "St."
    },
    confirmPickup: "Abholung + Kaution best\xE4tigen",
    packageSelect: {
      modeLabel: "Mietmodus",
      individual: "Einzelne Ger\xE4te",
      package: "Paket",
      individualDesc: "Ger\xE4te einzeln ausw\xE4hlen",
      packageDesc: "Ein vorgefertigtes Paket ausw\xE4hlen",
      searchPackage: "Pakete suchen...",
      loadingPackages: "Pakete werden geladen...",
      noPackages: "Keine Mietpakete verf\xFCgbar",
      packageContents: "Paketinhalt",
      included: "INKLUSIVE",
      rental: "MIETE",
      consignment: "KONSIGNATION",
      optional: "Optional",
      quantity: "Menge",
      unitPrice: "St\xFCckpreis",
      consignmentValue: "Konsignationswert",
      onDeliveryNote: "auf Lieferschein",
      rentalPrice: "Mietpreis",
      totalWithConsignment: "Gesamt (Miete + Konsignation)",
      savings: "Ersparnis gegen\xFCber Einzelmiete",
      savingsPercent: "{percent}% Ersparnis",
      selectPackage: "Paket ausw\xE4hlen",
      selectedPackage: "Ausgew\xE4hltes Paket: {name}",
      changePackage: "Paket wechseln",
      packageItems: "{count} Artikel"
    },
    consignment: {
      title: "Konsignation",
      deliveryNote: "Lieferschein",
      quantityOut: "Ausgegebene Menge",
      quantityReturned: "Zur\xFCckgegeben",
      quantityCharged: "Verbraucht",
      settlement: "Konsignationsabrechnung",
      settleAll: "Alle abrechnen",
      activeConsignments: "Aktive Konsignationen",
      totalValue: "Ausstehender Wert",
      noConsignments: "Keine Konsignationsartikel",
      returnedItems: "Zur\xFCckgegebene Artikel",
      chargedItems: "Berechnete Artikel",
      settlementSummary: "Abrechnungs\xFCbersicht",
      rentalFeeTotal: "Mietgeb\xFChr gesamt",
      consignmentCharges: "Konsignationsgeb\xFChren",
      grandTotal: "Gesamtsumme",
      depositRefund: "Kautionsr\xFCckerstattung",
      warningOverReturn: "Die zur\xFCckgegebene Menge darf die ausgegebene Menge nicht \xFCberschreiten!",
      itemName: "Produkt",
      dispatched: "Ausgegeben",
      returned: "Zur\xFCckgegeben",
      charged: "Berechnet",
      amount: "Betrag",
      freeAccessories: "Kostenloses Zubeh\xF6r",
      freeAccessoriesDesc: "Zur\xFCckzugebendes Zubeh\xF6r (Teil des Pakets)",
      accessoryReturned: "Zur\xFCckgegeben",
      accessoryMissing: "Fehlt",
      consignmentTotal: "Konsignationswert gesamt",
      consignmentNote: "Der Konsignationswert wird jetzt nicht berechnet \u2014 Abrechnung erfolgt bei R\xFCckgabe.",
      createFailed: "Konsignationserstellung fehlgeschlagen",
      status: {
        active: "Aktiv",
        settled: "Abgerechnet",
        partiallySettled: "Teilweise abgerechnet"
      }
    },
    stepNav: {
      navLabel: "Schritt-Navigation",
      prev: "Zur\xFCck",
      next: "Weiter",
      incompleteHint: "Dieser Schritt ist unvollst\xE4ndig \u2013 Sie k\xF6nnen trotzdem fortfahren",
      stepCounter: "Schritt {current}/{total}"
    },
    contractCard: {
      title: "Mietvertrag",
      lessor: "Vermieter",
      renter: "Mieter",
      pdfPreview: "PDF-Vorschau / Druck",
      pdfAfterFinalize: "Das Vertrags-PDF ist nach dem Abschluss verf\xFCgbar"
    },
    endTime: "Endzeitpunkt",
    hourlyBilling: "St\xFCndliche Abrechnung",
    hourlyRate: "Stundensatz",
    returnTable: {
      contract: "Vertrag / Beginn",
      renter: "Mieter",
      equipment: "Gemietete Ger\xE4te",
      expectedReturn: "Erwartete R\xFCckgabe",
      value: "Wert",
      status: "Status"
    },
    dueChips: {
      label: "F\xE4lligkeit:",
      all: "Alle",
      overdue: "\xDCberf\xE4llig",
      dueToday: "Heute f\xE4llig",
      dueSoon: "Bald f\xE4llig"
    },
    csvHeader: {
      contractNumber: "Vertragsnummer",
      partner: "Partner",
      equipment: "Ger\xE4te",
      endDate: "Frist",
      status: "Status"
    },
    exportCsv: "CSV exportieren",
    foundLabel: "Treffer",
    return: {
      signCta: "\xDCbernahmeprotokoll unterschreiben",
      error: {
        generic: "Fehler bei der Verarbeitung der R\xFCcknahme"
      },
      consignment: {
        settleFailedFallback: "Kommissionsabrechnung fehlgeschlagen",
        settleFailedDetail: "Die R\xFCcknahme der Vermietung wurde abgeschlossen, die Kommissionsabrechnung jedoch NICHT. Bitte versuchen Sie es erneut oder wenden Sie sich an den Administrator."
      },
      protocolTitle: "\xDCbernahmeprotokoll + Unterschrift",
      generateDoc: "Protokoll erstellen",
      signedOk: "Kunde hat das Protokoll unterschrieben"
    },
    partnerIdLabel: "Partner-ID",
    resolvedPackage: {
      none: "Kein Paket",
      noneDesc: "Dieser Maschine ist derzeit kein aktives Mietpaket zugewiesen."
    },
    payment: {
      title: "Zahlung erfassen",
      amount: "Betrag (HUF)",
      cash: "Bargeld",
      card: "Karte",
      transfer: "\xDCberweisung",
      reference: "Referenz (optional)",
      notes: "Hinweise (optional)",
      submit: "Zahlung erfassen",
      success: "Zahlung erfolgreich erfasst",
      overpaymentError: "Der Betrag \xFCbersteigt das offene Guthaben",
      recordFailed: "Zahlung konnte nicht erfasst werden",
      transferNotEligibleTitle: "\xDCberweisung nicht zul\xE4ssig",
      transferNotEligibleHint: "\xDCberweisung ist nur f\xFCr eine gelistete Person des abgerechneten Unternehmens m\xF6glich (aktiver Vertreter oder g\xFCltige Vollmacht).",
      transferBannedTitle: "\xDCberweisung gesperrt",
      transferBannedHint: "Der abgerechnete Partner ist von der \xDCberweisung gesperrt (Drei Verst\xF6\xDFe). Nur eine Freigabe durch die Leitung kann sie aufheben.",
      transferPersonBlockedTitle: "Gesperrte Person \u2014 \xDCberweisung nicht zul\xE4ssig",
      transferPersonBlockedHint: "Das abgerechnete Unternehmen hat diese Person von der Liste der verantwortlichen Personen gesperrt, daher kann keine \xDCberweisungszahlung gestartet werden. F\xFCgen Sie die Person der Liste hinzu, oder w\xE4hlen Sie Barzahlung.",
      transferCashHint: "Bitte w\xE4hlen Sie Bar- oder Kartenzahlung.",
      outstandingBalance: "Offener Betrag",
      paidAmount: "Bezahlter Betrag",
      fullyPaid: "Vollst\xE4ndig bezahlt",
      recordButton: "Zahlung erfassen",
      loyaltyDiscount: "Treuepunkte-Rabatt"
    },
    depositBreakdown: "Kaution pro Ger\xE4t",
    depositSettledAt: "Abgerechnet: {date}",
    depositUnnamed: "Unbenannter Artikel",
    depositAction: {
      refund: "R\xFCckerstattung",
      retain: "Einbehalten",
      refundTitle: "Vollst\xE4ndige Kautionsr\xFCckerstattung",
      retainTitle: "Kaution einbehalten",
      reason: "Grund",
      reasonPlaceholder: "Grund (optional)",
      retainReasonPlaceholder: "Grund (erforderlich)",
      confirm: "Best\xE4tigen",
      submit: "Senden",
      cancel: "Abbrechen",
      refundSuccess: "Kaution erfolgreich zur\xFCckerstattet.",
      retainSuccess: "Kaution erfolgreich einbehalten.",
      partialRefund: "Schadensabzug",
      partialRefundTitle: "Teilweise R\xFCckerstattung (Schadensabzug)",
      retainedAmount: "Einbehaltener (Schadens-)Betrag",
      retainedAmountPlaceholder: "z. B. 20000",
      damageDescription: "Schadensbeschreibung",
      damageDescriptionPlaceholder: "Kurze Beschreibung des Schadens (erscheint auf der Rechnung)",
      vatRate: "MwSt.-Satz",
      returnPreview: "R\xFCckzahlbar (gesch\xE4tzt)",
      partialRefundSuccess: "Schadensabzug erfolgreich erfasst.",
      viewDamageInvoice: "Schadensrechnung anzeigen",
      transfer: "Auf Arbeitsblatt \xFCbertragen",
      transferTitle: "Kaution auf ein Service-Arbeitsblatt \xFCbertragen",
      worksheet: "Ziel-Arbeitsblatt",
      worksheetPlaceholder: "Arbeitsblatt ausw\xE4hlen\u2026",
      transferAmount: "\xDCbertragungsbetrag (optional)",
      transferAmountPlaceholder: "Leer lassen f\xFCr die gesamte Kaution",
      transferSuccess: "Kaution erfolgreich auf das Arbeitsblatt \xFCbertragen.",
      noWorksheets: "Kein \xFCbertragbares Arbeitsblatt f\xFCr diesen Partner.",
      worksheetLoading: "Arbeitsbl\xE4tter werden geladen\u2026",
      cardPartialBlocked: "Kartenkaution \u2014 MyPOS-Weg",
      cardPartialTooltip: "Schadenseinbehalt aus einer Karten-(vorautorisierten) Kaution kann hier nicht gestartet werden \u2014 die R\xFCckzahlung erfolgt \xFCber MyPOS."
    },
    depositActionError: {
      notFound: "Kaution nicht gefunden.",
      invalidStatus: "Der aktuelle Kautionsstatus l\xE4sst diese Aktion nicht zu.",
      cardNotSupported: "Diese Aktion wird f\xFCr Karten-Kautionen (MyPOS) nicht unterst\xFCtzt.",
      serviceUnavailable: "Der Dienst ist vor\xFCbergehend nicht verf\xFCgbar. Bitte versuchen Sie es sp\xE4ter erneut.",
      failed: "Die Kautionsaktion ist fehlgeschlagen."
    },
    depositStatus: {
      PENDING: "Ausstehend",
      RECEIVED: "Eingegangen",
      HELD: "Einbehalten",
      RELEASED: "Freigegeben",
      RETAINED: "Zur\xFCckbehalten",
      PARTIAL: "Teilweise zur\xFCckerstattet"
    },
    settlement: {
      previewTitle: "Abrechnungsvorschau",
      linesTitle: "Endrechnungsposten (Vorschau)",
      vatPending: "MwSt. in Abstimmung",
      cashTitle: "Barabrechnung",
      deductionsTotal: "Abz\xFCge gesamt",
      depositApplied: "Kaution verrechnet",
      refundToCustomer: "R\xFCckzahlung an Kunden",
      payableByCustomer: "Vom Kunden zu zahlen",
      cardTitle: "Kartenkaution (separate Abrechnung)",
      cardNotNetted: "Kartenkautionen werden nie verrechnet \u2014 die R\xFCckzahlung erfolgt \xFCber MyPOS.",
      invoiceTotal: "Rechnungsbetrag",
      myposCapture: "MyPOS-Belastung",
      myposRefund: "MyPOS-R\xFCckerstattung",
      forceImmediate: "Sofortige Abrechnung erforderlich",
      paymentMethod: {
        CASH: "Bargeld",
        CARD: "Karte",
        BANK_TRANSFER: "\xDCberweisung",
        PRE_AUTH: "Vorautorisierung (MyPOS)"
      },
      extrasTitle: "Schaden / Zubeh\xF6r / Reinigung (f\xFCr Vorschau)",
      missingAccessoryLabel: "Fehlendes Zubeh\xF6r (Einkaufspreis, HUF)",
      cleaningOverrideLabel: "Reinigungsgeb\xFChr \xFCberschreiben (HUF)",
      cleaningDefaultHint: "leer: Standardgeb\xFChr",
      missingAccessoryPlaceholder: "0 Ft",
      sectionCharges: "Belastungen",
      sectionSettlement: "Abrechnung",
      sectionPayout: "Auszahlung",
      settleModeTitle: "Abrechnungsmodus",
      settleNow: "Jetzt abrechnen (Standard)",
      settleAtClose: "Bei Mietabschluss abrechnen",
      settleAtCloseHint: "Die Kautionsabrechnung wartet bis zum Mietabschluss; bei R\xFCckgabe des letzten Ger\xE4ts werden alle offenen Kautionen automatisch abgerechnet.",
      forceImmediateTooltip: "Wegen Ablauf der vorautorisierten Kartenkaution ist eine sofortige Abrechnung erforderlich."
    }
  },
  service: {
    warrantyClaim: "Garantieanspruch",
    warrantyClaimNumber: "Anspruchsnummer",
    warrantyManufacturer: "Hersteller",
    warrantyManufacturerPlaceholder: "Name des Herstellers",
    warrantyClaimValue: "Anspruchswert",
    warrantySettledAmount: "Erstatteter Betrag",
    warrantySubmittedAt: "Eingereicht am",
    warrantyNoClaimYet: "Noch kein Garantieanspruch",
    warrantyNotes: "Anmerkungen",
    warrantyNotesPlaceholder: "Anmerkung zum Anspruch",
    warrantySubmitClaim: "Anspruch einreichen",
    warrantyCreateClaim: "Garantieanspruch erstellen",
    photos: "Fotos",
    uploadPhoto: "Foto hochladen",
    photoFile: "Datei",
    photoFileRequired: "Eine Datei ist erforderlich",
    photoCaption: "Bildunterschrift",
    photoCaptionPlaceholder: "Foto-Bildunterschrift",
    photoTypeLabel: "Typ",
    photoTypeGeneral: "Allgemein",
    photoTypeBefore: "Vor der Reparatur",
    photoTypeAfter: "Nach der Reparatur",
    photoTypeDamage: "Schaden",
    noPhotos: "Keine Fotos hochgeladen",
    title: "Service",
    subtitle: "Service-Arbeitsblattverwaltung",
    worksheet: "Arbeitsblatt",
    worksheetLoading: "Arbeitsblatt wird geladen...",
    worksheetNotFound: "Arbeitsblatt nicht gefunden",
    technician: "Techniker",
    parts: "Ersatzteile",
    laborCost: "Arbeitskosten",
    diagnosis: "Diagnose",
    warranty: "Garantie",
    startWork: "Arbeit beginnen",
    billing: "Abrechnung",
    close: "Schlie\xDFen",
    reception: "Annahme",
    worksheetIntake: "Arbeitsblatt-Annahme",
    newServiceWorksheet: "Neues Service-Arbeitsblatt",
    worksheetIntakeAndPrint: "Arbeitsblatt aufnehmen und drucken",
    creating: "Wird erstellt...",
    cancelIntakeConfirm: "M\xF6chten Sie die Arbeitsblatt-Annahme wirklich abbrechen?",
    selectPartner: "Kunde ausw\xE4hlen",
    identifyDevice: "Ger\xE4t identifizieren",
    identifyDeviceDesc: "W\xE4hlen Sie das zu wartende Ger\xE4t aus dem System oder geben Sie es manuell ein.",
    reportFault: "Fehlermeldung",
    device: "Ger\xE4t",
    fault: "Fehler",
    diagnosticsNeeded: "Diagnose erforderlich",
    diagnosticsNeededDesc: "Das Arbeitsblatt wurde erfasst, der Kunde hat den Beleg erhalten. Die Diagnose erfolgt in einem separaten Schritt.",
    startDiagnostics: "Diagnose starten",
    diagnosticsAndItems: "Diagnose und Positionen",
    queuePositionLabel: "Position {position}",
    itemNotFound: "Position nicht gefunden",
    inspection: "Inspektion",
    inspectionDesc: "Geben Sie den empfangenen Zustand des Ger\xE4ts an und erfassen Sie den digitalen Unterschriftsort.",
    deviceReceivedState: "Empfangener Ger\xE4tezustand *",
    assembledState: "Zusammengebaut",
    disassembledState: "Zerlegt",
    assembledDesc: "Das Ger\xE4t kommt im originalen, zusammengebauten Zustand an. Kein Aufpreis.",
    disassembledDesc: "Das Ger\xE4t kommt im zerlegten Zustand an. Montageaufpreis wird berechnet.",
    disassembledSurcharge: "Aufpreis f\xFCr zerlegten Zustand",
    noSurcharge: "Kein Aufpreis f\xFCr zusammengebauten Zustand",
    free: "Kostenlos",
    quote: "Angebot",
    deadline: "Frist",
    limit: "Limit",
    searchPlaceholder: "Suche nach Arbeitsblattnr., Partner, Ger\xE4t oder Fehler...",
    equipmentProduct: "Ger\xE4t / Produkt",
    designation: "Bezeichnung",
    serialNumber: "Seriennummer",
    faultDescription: "Fehlerbeschreibung",
    diagnosisAndWork: "Diagnose und durchgef\xFChrte Arbeiten",
    completedWork: "Durchgef\xFChrte Arbeiten",
    internalNote: "Interne Notiz",
    internalOnly: "Nur intern",
    internalNoteHelper: "Diese Notiz ist f\xFCr den Kunden nicht sichtbar.",
    worksheetData: "Arbeitsblattdaten",
    costLimit: "Kostenlimit",
    directRepairBadge: "Direktreparatur \u2014 innerhalb des Kostenlimits",
    costLimitSkip: "Angebotsphase \xFCbersprungen \u2014 gesch\xE4tzte Kosten innerhalb des Limits",
    responsibleId: "Verantwortlicher ID",
    expectedCompletion: "Voraussichtliche Fertigstellung",
    queuePosition: "Warteschlangenposition",
    storageFee: "Lagergeb\xFChr",
    storageStart: "Lagerbeginn",
    storageDailyFee: "Tagesgeb\xFChr",
    storageTotalFee: "Gesamtgeb\xFChr",
    externalCost: "Subunternehmerkosten",
    addExternalCost: "Subunternehmerkosten hinzuf\xFCgen",
    externalCostDescription: "Beschreibung",
    externalCostDescriptionPlaceholder: "z.B. Motorwicklung, Galvanisierung...",
    externalCostAmount: "Betrag (netto HUF)",
    externalCostAmountPlaceholder: "z.B. 25000",
    externalCostBadge: "Subunternehmer",
    externalCostAdded: "Subunternehmerkosten hinzugef\xFCgt",
    externalCostDescriptionRequired: "Beschreibung ist erforderlich",
    externalCostAmountPositive: "Betrag muss positiv sein",
    worksheetItems: "Arbeitsblatt-Positionen",
    noItems: "Noch keine Positionen auf diesem Arbeitsblatt.",
    itemTypePart: "Ersatzteil",
    itemTypeLabor: "Arbeitskosten",
    itemTypeOther: "Sonstiges",
    itemTypeExternalCost: "Subunternehmerkosten",
    timestamps: "Zeitstempel",
    received: "Empfangen",
    created: "Erstellt",
    modified: "Ge\xE4ndert",
    completed: "Abgeschlossen",
    creatorId: "Ersteller-ID",
    relatedRental: "Zugeh\xF6rige Vermietung",
    viewRental: "Vermietung anzeigen",
    statusLabels: {
      received: "Empfangen",
      inProgress: "In Bearbeitung",
      waiting: "Wartend",
      completed: "Abgeschlossen",
      billable: "Abrechenbar",
      closed: "Geschlossen",
      cancelled: "Storniert"
    },
    typeLabels: {
      paid: "Kostenpflichtige Reparatur",
      warranty: "Garantie",
      rentalService: "Mietservice",
      maintenance: "Wartung"
    },
    priorityLabels: {
      urgent: "Dringend (+20%)",
      normal: "Normal",
      warranty: "Garantie"
    },
    categoryLabels: {
      powerTool: "Elektrowerkzeug",
      gardenEquipment: "Gartenger\xE4t",
      construction: "Baumaschine",
      cleaningMachine: "Reinigungsger\xE4t",
      other: "Sonstiges"
    },
    searchInSystem: "Im System suchen",
    manualEntry: "Manuelle Eingabe",
    searchProductPlaceholder: "Suche nach Name, Hersteller, Modell oder Seriennummer...",
    productsLoading: "Produkte werden geladen...",
    productsLoadError: "Fehler beim Laden der Produkte: {message}",
    serialNumberShort: "S/N: {serial}",
    manualDeviceEntry: "Manuelle Ger\xE4teeingabe",
    manualDeviceDataEntry: "Manuelle Eingabe der Ger\xE4tedaten",
    deviceNameRequired: "Ger\xE4tename *",
    deviceNamePlaceholder: "z.B. Makita HR2470 Bohrhammer",
    serialNumberPlaceholder: "z.B. MK-2024-001234",
    selectedDevice: "Ausgew\xE4hltes Ger\xE4t: {name}",
    selectPartnerHeading: "Partner ausw\xE4hlen",
    selectPartnerDesc: "W\xE4hlen Sie den Kunden, dessen Ger\xE4t gewartet werden soll.",
    searchPartnerPlaceholder: "Suche nach Name, E-Mail, Telefon, Steuernr., Stadt oder Ausweis...",
    partnersLoading: "Partner werden geladen...",
    partnersLoadError: "Fehler beim Laden der Partner: {message}",
    trustedPartner: "Stammkunde",
    warningStatus: "Warnung",
    blockedStatus: "Gesperrt",
    taxNumberLabel: "Steuernummer: {taxNumber}",
    costBearer: "Kostentr\xE4ger: {name}",
    selectedPartner: "Ausgew\xE4hlter Partner: {name}",
    reportFaultDesc: "Geben Sie die Fehlerbeschreibung ein und w\xE4hlen Sie den Arbeitsblatttyp.",
    deviceUnderWarranty: "Das Ger\xE4t ist in der Garantiezeit!",
    warrantyExpiry: "Garantie l\xE4uft ab: {date}",
    worksheetType: "Arbeitsblatttyp",
    recommended: "(Empfohlen)",
    faultDescriptionRequired: "Fehlerbeschreibung *",
    faultDescriptionPlaceholder: "Beschreiben Sie den Fehler detailliert, Symptome, wann er aufgetreten ist...",
    faultDescriptionHint: "Je detaillierter die Beschreibung, desto schneller die Diagnose.",
    costLimitOptional: "Kostenlimit (optional)",
    costLimitHint: "Wenn die Reparaturkosten diesen Betrag \xFCberschreiten, ist eine Vorabkonsultation erforderlich.",
    summaryType: "Typ: {type}",
    summaryPriority: "Priorit\xE4t: {priority}",
    summaryCostLimit: "Kostenlimit: {limit} Ft",
    inspectionFeeLabel: "Inspektions-/Montagegeb\xFChr",
    attentionWarning: "Achtung!",
    disassembledWarning: "Bei zerlegten Ger\xE4ten wird die Montagegeb\xFChr unabh\xE4ngig davon berechnet, ob die Reparatur durchgef\xFChrt wird oder nicht.",
    digitalSignature: "Digitale Unterschrift",
    digitalSignatureArea: "Bereich f\xFCr digitale Unterschrift",
    signatureTouchHint: "Ber\xFChren Sie den Bildschirm, um die Unterschrift aufzuzeichnen",
    signatureConfirmation: "Die Unterschrift des Kunden best\xE4tigt die \xDCbergabe des Ger\xE4ts und die Zustandsbewertung.",
    summaryTitle: "Zusammenfassung",
    summaryState: "Zustand: {state}",
    summaryFee: "Geb\xFChr: {fee}",
    summarySignature: "Unterschrift: {status}",
    signatureRecorded: "Aufgezeichnet",
    signatureNotRecorded: "Noch nicht aufgezeichnet",
    historyLabels: {
      created: "Erstellt",
      statusChange: "Status\xE4nderung",
      itemAdded: "Artikel hinzugef\xFCgt",
      itemRemoved: "Artikel entfernt",
      assigned: "Zugewiesen",
      comment: "Kommentar",
      invoiced: "Abgerechnet",
      completed: "Abgeschlossen"
    },
    editWorksheet: "Arbeitsblatt bearbeiten",
    saveError: "Beim Speichern ist ein Fehler aufgetreten",
    errorPrefix: "Fehler: {message}",
    worksheetNotEditable: "Dieses Arbeitsblatt hat den Status {status} und kann nicht bearbeitet werden.",
    deviceData: "Ger\xE4tedaten",
    deviceNamePlaceholderShort: "z.B. Makita DLX2220",
    serialNumberPlaceholderShort: "z.B. SN123456789",
    worksheetSettings: "Arbeitsblatt-Einstellungen",
    priorityField: "Priorit\xE4t",
    costLimitFt: "Kostenlimit (HUF)",
    costLimitPlaceholder: "z.B. 50000",
    faultDescriptionCustomerPlaceholder: "Was erlebt der Kunde?",
    diagnosisCausePlaceholder: "Was ist die Fehlerursache?",
    workPerformedPlaceholder: "Welche Arbeiten wurden durchgef\xFChrt?",
    internalNotePlaceholder: "Interne Notizen (f\xFCr Kunden nicht sichtbar)...",
    statusChangeTitle: "Status\xE4nderung",
    continueWork: "Fortfahren",
    toBilling: "Zur Abrechnung",
    saveChanges: "\xC4nderungen speichern",
    diagnosticsStepDesc: "Erfassen Sie die Diagnose und f\xFCgen Sie Ersatzteile und Arbeitskosten hinzu.",
    diagnosisLabel: "Diagnose / Befund *",
    diagnosisPlaceholder: "Ger\xE4tezustand, gefundene Fehler, erforderliche Reparaturen...",
    workPerformedDetailPlaceholder: "Detaillierte Beschreibung der durchgef\xFChrten Arbeiten...",
    laborNorms: "Arbeitsnormen",
    customItem: "Sonstiger Posten",
    searchPartPlaceholder: "Suche nach Teilename oder Artikelnummer...",
    stockCount: "Bestand: {count} Stk.",
    searchNormPlaceholder: "Suche nach Normcode oder Beschreibung...",
    normsLoading: "Normen werden geladen...",
    normsLoadError: "Fehler beim Laden der Normen: {message}",
    minuteUnit: "Min.",
    addCustomItem: "Sonstigen Posten hinzuf\xFCgen",
    customItemPlaceholder: "z.B. Anfahrtsgeb\xFChr",
    unitPriceFt: "St\xFCckpreis (HUF)",
    addedItems: "Hinzugef\xFCgte Posten ({count})",
    partLabel: "Ersatzteil",
    otherLabel: "Sonstiges",
    vatLabel: "MwSt. (27%):",
    summaryHeading: "Zusammenfassung",
    summaryStepDesc: "\xDCberpr\xFCfen Sie die Daten und schlie\xDFen Sie das Arbeitsblatt ab.",
    nameLabel: "Name:",
    emailLabel: "E-Mail:",
    phoneLabel: "Telefon:",
    designationSummaryLabel: "Bezeichnung:",
    serialNumberSummaryLabel: "Seriennummer:",
    categoryLabel: "Kategorie:",
    warrantyLabel: "Garantie:",
    warrantyExpiredNone: "Abgelaufen/Keine",
    faultReport: "Fehlermeldung",
    typeLabel: "Typ:",
    priorityLabel: "Priorit\xE4t:",
    costLimitSummaryLabel: "Kostenlimit:",
    faultDescriptionSummaryLabel: "Fehlerbeschreibung:",
    findingLabel: "Befund:",
    completedWorkSummaryLabel: "Durchgef\xFChrte Arbeiten:",
    itemsWithCount: "Posten ({count} Positionen)",
    netLabel: "Netto:",
    noItemsAdded: "Keine Posten hinzugef\xFCgt.",
    completionSection: "Abschluss",
    internalOnlyPlaceholder: "Nur f\xFCr Servicemitarbeiter sichtbar...",
    costLimitWarning: "Der Arbeitsblatt-Gesamtbetrag ({total} HUF) \xFCberschreitet das Kostenlimit ({limit} HUF). Kundenr\xFCcksprache erforderlich!",
    worksheetReadyToCreate: "Das Arbeitsblatt ist bereit zur Erstellung",
    accessories: "Zubeh\xF6r",
    accessoriesDesc: "Geben Sie an, welches Zubeh\xF6r mit dem Ger\xE4t \xFCbernommen wurde.",
    receivedAccessories: "\xDCbernommenes Zubeh\xF6r",
    addCustomAccessory: "Sonstiges Zubeh\xF6r hinzuf\xFCgen",
    customAccessoryPlaceholder: "z.B. Staubsaugeradapter, Lasernivellierger\xE4t...",
    customLabel: "Benutzerdefiniert",
    accessoryNote: "Anmerkungen zum Zubeh\xF6r",
    accessoryNotePlaceholder: "Weitere Anmerkungen zum Zustand des Zubeh\xF6rs, fehlende Teile...",
    selectedAccessoriesCount: "Ausgew\xE4hltes Zubeh\xF6r ({count} Stk.)",
    noAccessoriesSelected: "Kein Zubeh\xF6r ausgew\xE4hlt.",
    noAccessoriesHint: "Wenn das Ger\xE4t ohne Zubeh\xF6r angekommen ist, lassen Sie es leer und fahren Sie fort.",
    fieldService: "Au\xDFendienst",
    fieldServiceDesc: "Geben Sie an, ob es sich um eine Vor-Ort-Reparatur handelt.",
    fieldServiceAddress: "Standortadresse *",
    fieldServiceAddressPlaceholder: "z.B. 1052 Budapest, De\xE1k Ferenc utca 15.",
    fieldServiceAddressHint: "Geben Sie die genaue Adresse an, an der die Reparatur durchgef\xFChrt werden soll.",
    deviceMobility: "Ger\xE4temobilit\xE4t",
    mobilityLabels: {
      mobile: "Mobil",
      immobile: "Nicht mobil",
      partiallyMobile: "Teilweise mobil"
    },
    mobilityDescriptions: {
      mobile: "Das Ger\xE4t kann frei bewegt werden, ist nicht befestigt.",
      immobile: "Das Ger\xE4t ist befestigt und muss vor Ort repariert werden.",
      partiallyMobile: "Das Ger\xE4t ist eingeschr\xE4nkt beweglich, Hilfe erforderlich."
    },
    assistanceNeeded: "Hilfe erforderlich",
    assistanceNeededDesc: "Der Servicetechniker ben\xF6tigt Hilfe beim Bewegen oder Zugang zum Ger\xE4t.",
    assistanceNeededSuffix: " \u2014 Hilfe erforderlich",
    fieldObstacles: "Vor-Ort-Hindernisse, Anmerkungen",
    fieldObstaclesPlaceholder: "z.B. Stockwerk, Eingangsseite, Parkm\xF6glichkeiten, besondere Umst\xE4nde...",
    fieldServiceDetails: "Au\xDFendienst-Details",
    damageClaim: {
      title: "Schadenersatzanspr\xFCche",
      titleSingle: "Schadenersatzanspruch",
      statusLabels: {
        pending: "Ausstehend",
        approved: "Genehmigt",
        rejected: "Abgelehnt",
        settled: "Erledigt"
      },
      typeLabels: {
        warranty: "Garantie (ML-GAR)",
        damage: "Schadenersatz (ML-BH)"
      },
      noClaims: "Keine Schadenersatzanspr\xFCche.",
      repairCost: "Reparatur: {amount}",
      lostRevenue: "Entgangener Umsatz: {amount}",
      totalClaim: "Gesamt: {amount}",
      rejectedPrefix: "Abgelehnt: {note}",
      approve: "Genehmigen",
      reject: "Ablehnen",
      rejectionPrompt: "Ablehnungsbegr\xFCndung:",
      notFound: "Schadenersatzanspruch nicht gefunden",
      basicData: "Grunddaten",
      statusLabel: "Status",
      typeLabel: "Typ",
      rentalId: "Miet-ID",
      createdAt: "Erstellt",
      financialData: "Finanzdaten",
      repairCostLabel: "Reparaturkosten",
      lostRevenueLabel: "Entgangener Umsatz",
      totalClaimLabel: "Gesamtanspruch",
      rejectionReason: "Ablehnungsbegr\xFCndung",
      approval: "Genehmigung",
      approvedBy: "Genehmigt von: {name}",
      processing: "Verarbeitung..."
    },
    disassembly: {
      title: "Demontage",
      button: "Demontage",
      modalTitle: "Demontage-Protokoll",
      modalDescription: "Nach der Demontage werden die Teile dem Bestand hinzugef\xFCgt.",
      addPart: "Teil hinzuf\xFCgen",
      productSearch: "Produkt suchen...",
      quantity: "Menge",
      condition: "Zustand",
      conditionNew: "Neu",
      conditionUsed: "Gebraucht",
      conditionDamaged: "Besch\xE4digt",
      execute: "Ausf\xFChren",
      executing: "Wird ausgef\xFChrt...",
      success: "Demontage erfolgreich durchgef\xFChrt",
      error: "Demontage fehlgeschlagen",
      protocols: "Demontage-Protokolle",
      noProtocols: "Keine Demontage-Protokolle",
      performedBy: "Durchgef\xFChrt von",
      performedAt: "Durchgef\xFChrt am",
      partsCount: "{count} Teile"
    },
    express: {
      surcharge: "Express-Zuschlag",
      lineItem: "Express-Zuschlag (separate Rechnungsposition)",
      addSurcharge: "Express-Zuschlag hinzuf\xFCgen",
      amount: "Zuschlagsbetrag (netto HUF)",
      success: "Express-Zuschlag hinzugef\xFCgt",
      error: "Express-Zuschlag konnte nicht hinzugef\xFCgt werden"
    },
    external: {
      title: "Externer Service",
      forwardButton: "An externen Service weiterleiten",
      forwardModalTitle: "An externen Servicepartner weiterleiten",
      forwardModalDescription: "Das Arbeitsblatt wird an einen externen Servicepartner weitergeleitet.",
      partnerSelect: "Externer Servicepartner",
      reason: "Weiterleitungsgrund",
      reasonPlaceholder: "z.B. Spezialreparatur, keine passenden Teile...",
      estimatedReturn: "Voraussichtliches R\xFCckgabedatum",
      forward: "Weiterleiten",
      forwarding: "Wird weitergeleitet...",
      forwardSuccess: "Arbeitsblatt erfolgreich weitergeleitet",
      banner: "Bei externem Service",
      bannerInfo: "Partner: {partner} | Erwartete R\xFCckgabe: {date}",
      returnButton: "R\xFCcknahme",
      returnModalTitle: "R\xFCcknahme vom externen Service",
      actualCost: "Tats\xE4chliche Kosten (netto HUF)",
      returnNotes: "Anmerkungen",
      returnNotesPlaceholder: "z.B. Reparatur durchgef\xFChrt, Teil ersetzt...",
      returnSuccess: "R\xFCcknahme erfolgreich erfasst",
      error: "Vorgang fehlgeschlagen",
      partnerSearchPlaceholder: "Suche nach Name, Telefonnummer oder Steuernummer"
    },
    publicRequest: {
      title: "Serviceanfrage",
      subtitle: "Online-Service-Vorregistrierung",
      customerName: "Name",
      customerNamePlaceholder: "z.B. Max Mustermann",
      phone: "Telefonnummer",
      phonePlaceholder: "z.B. +36 30 123 4567",
      email: "E-Mail (optional)",
      emailPlaceholder: "z.B. max@example.com",
      equipmentDescription: "Ger\xE4tebeschreibung",
      equipmentDescriptionPlaceholder: "z.B. Makita HR2470 Bohrhammer",
      problemDescription: "Problembeschreibung",
      problemDescriptionPlaceholder: "Beschreiben Sie das Problem im Detail...",
      preferredDate: "Wunschtermin (optional)",
      submit: "Anfrage absenden",
      submitting: "Wird gesendet...",
      success: "Serviceanfrage erfolgreich eingereicht! Wir werden Sie in K\xFCrze kontaktieren.",
      error: "Beim Absenden ist ein Fehler aufgetreten"
    },
    pendingRequest: {
      title: "Serviceanfragen",
      noRequests: "Keine offenen Anfragen",
      accept: "Akzeptieren",
      reject: "Ablehnen",
      accepted: "Akzeptiert",
      rejected: "Abgelehnt",
      pending: "Ausstehend",
      customerName: "Kundenname",
      phone: "Telefon",
      equipment: "Ger\xE4t",
      problem: "Problem",
      date: "Datum",
      status: "Status"
    },
    externalCostLabel: "Subunternehmergeb\xFChr",
    abandoned: {
      tabTitle: "Aufgegebene Maschinen",
      noItems: "Keine aufgegebenen Maschinen",
      noItemsDesc: "Derzeit sind alle gemieteten Maschinen innerhalb der Frist.",
      totalCount: "{count} aufgegebene Maschinen",
      partner: "Partner",
      rental: "Vermietung",
      daysOverdue: "Tage seit Ablauf",
      perDay: "Tag",
      storageFee: "Gesch\xE4tzte Lagergeb\xFChr"
    },
    compensation: {
      tabTitle: "Kompensation",
      title: "Kompensationszahlung erfassen",
      description: "Wenn der Kunde die besch\xE4digte oder verlorene Maschine nicht zur\xFCckbringen kann, erfassen Sie die Kompensationszahlung.",
      rentalId: "Vermietungs-ID",
      rentalIdPlaceholder: "z. B. R-20260401-001",
      amount: "Betrag (Ft)",
      reason: "Begr\xFCndung",
      reasonPlaceholder: "z. B. Kunde kann die Maschine nicht zur\xFCckbringen, am Arbeitsplatz verloren...",
      action: "Aktion",
      writtenOff: "Abschreibung (WRITTEN_OFF)",
      transferredToInventory: "Einlagerung (TRANSFERRED_TO_INVENTORY)",
      submit: "Kompensation erfassen",
      validationError: "Bitte f\xFCllen Sie alle Felder korrekt aus."
    },
    afterlife: {
      tabTitle: "Nachnutzungs-Entscheidungen",
      pageTitle: "Maschinen-Lebenszyklusverwaltung",
      pageSubtitle: "Aufgegebene Maschinen, Kompensation, Nachnutzungs-Entscheidungen, Sammelerfassung",
      noItems: "Keine Eintr\xE4ge",
      scrapTitle: "Verschrottung",
      repairTitle: "Aufarbeitung",
      decisionTitle: "Entscheidung erforderlich",
      repairs: "Reparaturen",
      age: "Alter",
      months: "Monate",
      condition: "Zustand"
    },
    surrender: {
      tabTitle: "Freiwilliger Verzicht",
      title: "Freiwilligen Verzicht erfassen",
      description: "Wenn der Kunde freiwillig auf die gemietete Maschine verzichtet (kann nicht zahlen, ben\xF6tigt sie nicht), erfassen Sie die Erkl\xE4rung.",
      rentalId: "Vermietungs-ID",
      rentalIdPlaceholder: "z. B. R-20260401-001",
      statement: "Erkl\xE4rung",
      statementPlaceholder: "Erkl\xE4rung des Kunden \xFCber den freiwilligen Verzicht, Begr\xFCndung...",
      submit: "Verzicht erfassen",
      validationError: "Bitte f\xFCllen Sie alle Felder aus (Erkl\xE4rung mind. 5 Zeichen)."
    },
    issueInvoice: "Rechnung erstellen",
    invoiceSuccess: "Rechnung erfolgreich erstellt"
  },
  invoice: {
    title: "Rechnungen",
    subtitle: "Rechnungs- und Geb\xFChrennotenverwaltung",
    newInvoice: "Neue Rechnung",
    editInvoice: "Rechnung bearbeiten",
    invoiceType: "Rechnungstyp",
    allInvoices: "Alle Rechnungen",
    paidRevenue: "Bezahlter Umsatz",
    issuedPending: "Ausgestellt / Ausstehend",
    overdueDebt: "\xDCberf\xE4llige Schulden",
    searchPlaceholder: "Suche (Rechnungsnr., Partner, Steuernr.)...",
    allStatuses: "Alle Status",
    allTypes: "Alle Typen",
    dates: "Daten",
    items: "Positionen",
    itemName: "Positionsname...",
    noItems: 'Keine Positionen. Klicken Sie auf "Position hinzuf\xFCgen".',
    netTotal: "Netto gesamt:",
    grossTotal: "Brutto gesamt:",
    invoiceNotes: "Notizen",
    notesPlaceholder: "Z.B.: Zahlungsbedingungen, Lieferinformationen...",
    createInvoice: "Rechnung erstellen",
    saveChanges: "\xC4nderungen speichern",
    addressPlaceholder: "10115 Berlin, Hauptstra\xDFe 1.",
    invoiceCreated: "Rechnung {action}!\nNummer: {number}\nBetrag: {amount}",
    loading: "Rechnung wird geladen...",
    notFound: "Rechnung nicht gefunden",
    buyerData: "K\xE4uferdaten",
    nameLabel: "Name",
    addressLabel: "Adresse",
    taxNumber: "Steuernummer",
    description: "Bezeichnung",
    quantity: "Menge",
    quantityShort: "Menge",
    unitPrice: "St\xFCckpreis",
    unitPriceNet: "St\xFCckpreis (netto)",
    vat: "MwSt.",
    total: "Gesamt",
    productIdLabel: "Artikel: {id}",
    noItemsEmpty: "Keine Positionen",
    netTotalLabel: "Netto gesamt:",
    vatTotalLabel: "MwSt. gesamt:",
    payable: "Zahlbar:",
    invoiceData: "Rechnungsdaten",
    statusLabel: "Status:",
    typeLabel: "Typ:",
    issueDateLabel: "Ausstellungsdatum:",
    dueDateLabel: "F\xE4lligkeitsdatum:",
    paidAt: "Bezahlt:",
    paymentMethod: "Zahlungsmethode",
    paymentMethodType: {
      cash: "Bargeld",
      card: "Karte",
      transfer: "\xDCberweisung",
      cod: "Nachnahme"
    },
    correctionInvoice: "Korrekturrechnung",
    originalInvoice: "Originalrechnung:",
    modificationIndex: "\xC4nderungsnummer:",
    modificationReason: "Begr\xFCndung:",
    navOnline: "NAV Online",
    navTransactionId: "Transaktions-ID:",
    resendToNav: "Erneut an NAV senden",
    fullyPaid: "Vollst\xE4ndig bezahlt",
    balanceDue: "Restbetrag",
    paidSoFar: "Bisher bezahlt: {amount}",
    invoiceTotal: "Rechnungssumme",
    pdfDownload: "PDF herunterladen",
    sendEmail: "Per E-Mail senden",
    printInvoice: "Drucken",
    stornoInvoice: "Stornorechnung",
    storno: {
      title: "Rechnung stornieren",
      subtitle: "Zu stornierende Rechnung",
      reasonLabel: "Grund f\xFCr die Stornierung",
      isProductReturnLabel: "Die Ware wurde zur\xFCckgegeben",
      inspectionLabel: "Die Ware wurde gepr\xFCft",
      submit: "Stornieren",
      success: "Rechnung erfolgreich storniert",
      error: "Stornierung fehlgeschlagen"
    },
    markPaid: "Als bezahlt markieren",
    paid: "Bezahlt",
    overdueWarning: "\xDCberf\xE4llige Rechnung! {days} Tage \xFCberf\xE4llig.",
    overdueBalance: "Restbetrag: {amount}",
    paymentReminder: "Zahlungserinnerung",
    pdfAlert: "PDF-Erstellung: {number}\n\nDie Rechnung wird als PDF heruntergeladen...",
    emailAlert: "E-Mail-Versand: {number}\n\nDie Rechnung wird an die E-Mail-Adresse des Partners gesendet...",
    navResendAlert: "NAV-Neuversand: {number}\n\nDie Rechnung wird erneut an NAV Online gesendet...",
    markPaidAlert: "Als bezahlt markiert: {number}\n\nDie Rechnung wurde als bezahlt markiert.",
    errorOccurred: "Ein Fehler ist aufgetreten: {message}",
    unknownError: "Unbekannter Fehler",
    editInvoiceSubtitle: "Rechnungsdaten bearbeiten",
    newInvoiceSubtitle: "Neue Rechnung erstellen",
    partnerData: "Partnerdaten",
    partnerNameRequired: "Partnername *",
    partnerNamePlaceholder: "Partnername...",
    unit: "Einheit",
    vatPercent: "MwSt. %",
    totalGross: "Gesamt (brutto)",
    addItem: "+ Position hinzuf\xFCgen",
    itemDescriptionPlaceholder: "Positionsbezeichnung...",
    grossAmount: "Brutto gesamt",
    deleteItem: "L\xF6schen",
    noItemsClickAdd: "Keine Positionen. Klicken Sie auf {button}.",
    vatLabel: "MwSt.:",
    savingInProgress: "Speichern...",
    saveChangesButton: "\xC4nderungen speichern",
    createInvoiceButton: "Rechnung erstellen",
    createdAction: "erstellt",
    updatedAction: "aktualisiert",
    partnerNameValidation: "Bitte geben Sie den Partnernamen ein!",
    itemsValidation: "Bitte f\xFCgen Sie mindestens eine Position hinzu!",
    template: {
      standard: "Standard",
      detailed: "Detailliert",
      proforma: "Proforma",
      select: "Vorlage ausw\xE4hlen",
      download: "PDF herunterladen ({template})"
    },
    advance: {
      title: "Vorschussrechnung",
      createDirect: "Direkte Vorschussrechnung erstellen",
      createFromProforma: "Vorschuss aus Proforma erstellen",
      createFinal: "Schlussrechnung mit Vorschussabzug erstellen",
      cancelAdvance: "Vorschussrechnung stornieren",
      deductionLine: "Vorschussabzug",
      advanceAmount: "Vorschussbetrag",
      remainingAmount: "Restbetrag",
      refundMethod: "Erstattungsmethode",
      cancelReason: "Stornierungsgrund",
      cancelReasonPlaceholder: "z.B.: Bestellung storniert, Kundenwunsch...",
      proformaMustBePaid: "Die Proforma muss bezahlt sein",
      advanceMustBePaid: "Die Vorschussrechnung muss bezahlt sein",
      deductionExceedsTotal: "Der Vorschussabzug \xFCbersteigt die Schlussrechnungssumme",
      created: "Vorschussrechnung erstellt: {number}",
      finalCreated: "Schlussrechnung erstellt: {number}",
      cancelled: "Vorschussrechnung storniert",
      cancelledWithStorno: "Vorschussrechnung storniert, Storno: {number}",
      manualTitle: "Vorschussabzug",
      percentLabel: "Vorschuss %",
      amountLabel: "Vorschussbetrag (HUF)",
      percentPlaceholder: "z.B. 30",
      amountPlaceholder: "0 HUF",
      manualHint: "Geben Sie den Vorschussprozentsatz oder Festbetrag ein. Er wird auf der Endrechnung abgezogen."
    },
    correction: {
      title: "Korrektur erstellen",
      creating: "Wird erstellt...",
      originalInvoice: "Originalrechnung:",
      originalAmount: "Originalbetrag:",
      issuedAt: "Ausgestellt am:",
      reason: "Korrekturgrund *",
      reasonPlaceholder: "Z.B.: Mengenkorrektur, Preis\xE4nderung...",
      reasonMinLength: "Mindestens 5 Zeichen erforderlich",
      itemChanges: "Positions\xE4nderungen",
      netDifference: "Netto-Differenz:",
      vatDifference: "MwSt.-Differenz:",
      grossDifference: "Brutto-Differenz:",
      createCorrection: "Korrekturrechnung erstellen",
      correctionTitle: "Korrekturrechnung",
      originalLabel: "Original: {number}",
      partner: "Partner:",
      originalQty: "Orig. Menge",
      newQty: "Neue Menge",
      originalPrice: "Orig. Preis",
      newPrice: "Neuer St\xFCckpreis",
      difference: "Differenz",
      correctionCreated: "Korrekturrechnung erstellt: {number}",
      errorPrefix: "Fehler: {message}",
      reasonValidation: "Die Begr\xFCndung muss mindestens 5 Zeichen lang sein!",
      correctedItem: "Korrigierter Posten",
      differenceItem: "Differenzposten",
      modificationReference: "\xC4nderungsreferenz",
      originalItem: "Originalposten",
      performanceDateNote: "Leistungsdatum-Hinweis",
      previewTitle: "Korrekturrechnung Vorschau",
      vatSelfAudit: "USt-Selbstpr\xFCfung",
      vatSelfAuditDescription: "USt-Selbstpr\xFCfungserkl\xE4rung erforderlich"
    },
    deliveryNote: {
      title: "Lieferscheine",
      newDeliveryNote: "Neuer Lieferschein",
      types: {
        standard: "Standard (SZ-)",
        contract: "Vertrag (SZ-)",
        rentalAccessory: "Mietzubeh\xF6r (SZB-)",
        supplierCredit: "Lieferantenkredit (SZH-)"
      },
      typeLabels: {
        standard: "Standard",
        contract: "Vertrag",
        rentalAccessory: "Mietzubeh\xF6r",
        supplierCredit: "Lieferantenkredit"
      },
      statusLabels: {
        open: "Offen",
        invoiced: "Fakturiert",
        settled: "Beglichen",
        closed: "Geschlossen"
      },
      partnerName: "Partnername",
      partnerNameRequired: "Partnername *",
      partnerId: "Partner-ID",
      partnerIdOptional: "Partner-ID (optional)",
      partnerIdPlaceholder: "Partner-ID",
      partnerNamePlaceholder: "Partnername",
      itemId: "Artikel-ID",
      itemIdPlaceholder: "Artikel-ID",
      productName: "Produktname",
      productNamePlaceholder: "Produktname",
      notes: "Notizen...",
      notesOptional: "Notizen (optional)",
      notesPlaceholder: "Notizen...",
      typeFilterLabel: "Typ",
      items: "Positionen",
      addItem: "+ Position hinzuf\xFCgen",
      description: "Bezeichnung",
      quantity: "Menge",
      unitPrice: "St\xFCckpreis",
      unitPriceHuf: "St\xFCckpreis (HUF)",
      amount: "Betrag",
      totalWithAmount: "Gesamt: {amount}",
      totalLabel: "Gesamt:",
      deleteItem: "L\xF6schen",
      cancel: "Abbrechen",
      saving: "Speichern...",
      createButton: "Lieferschein erstellen",
      errorPrefix: "Fehler: {message}",
      unknownError: "Unbekannter Fehler",
      loading: "Laden...",
      notFound: "Lieferschein nicht gefunden",
      backToList: "Zur\xFCck zur Liste",
      statusLabel: "Status",
      amountLabel: "Betrag",
      createdAt: "Erstellt am",
      invoiceId: "Rechnungs-ID",
      contractPartner: "Vertragspartner",
      manualSettlement: "Manuelle Begleichung",
      settled: "Beglichen",
      notesLabel: "Notizen",
      itemsCount: "Positionen ({count})",
      product: "Produkt",
      invoicing: "Fakturierung",
      processing: "Verarbeitung...",
      financiallySettled: "Finanziell beglichen",
      assignToInvoice: "Rechnung zuweisen",
      invoiceIdLabel: "Rechnungs-ID",
      invoiceIdPlaceholder: "Rechnungs-ID",
      noDeliveryNotes: "Keine Lieferscheine",
      number: "Nummer",
      date: "Datum",
      allTypes: "Alle Typen",
      allStatuses: "Alle Status",
      batchConfirmGenerate: "Rechnung erstellen",
      batchConfirmMessage: "Sammelrechnung aus den ausgew\xE4hlten Lieferscheinen erstellen?",
      batchConfirmTitle: "Sammelrechnung",
      batchGenerating: "Wird erstellt\u2026",
      batchPartnerMismatch: "Die ausgew\xE4hlten Lieferscheine geh\xF6ren zu verschiedenen Partnern",
      generateBatchInvoice: "Sammelrechnung",
      selectForBatch: "F\xFCr Sammelrechnung ausw\xE4hlen",
      selectedNotes: "{count} Lieferscheine ausgew\xE4hlt"
    },
    status: {
      draft: "Entwurf",
      pending: "Genehmigung ausstehend",
      approved: "Genehmigt",
      sent: "Ausgestellt",
      paid: "Bezahlt",
      partiallyPaid: "Teilweise bezahlt",
      overdue: "\xDCberf\xE4llig",
      cancelled: "Storniert",
      voided: "Annulliert"
    },
    type: {
      standard: "Rechnung",
      advance: "Vorschussrechnung",
      final: "Endrechnung",
      proforma: "Proforma",
      creditNote: "Gutschrift",
      correction: "Korrektur",
      storno: "Storno",
      minuszos: "Negativrechnung"
    },
    eInvoice: {
      hash: "Hash",
      noEmail: "Keine E-Mail-Adresse",
      notSent: "Nicht gesendet",
      send: "E-Rechnung senden",
      sent: "Gesendet",
      sentAt: "Gesendet am: {date}",
      title: "E-Rechnung",
      partnerNotFound: "Kunde nicht gefunden \u2014 w\xE4hlen Sie einen g\xFCltigen Partner f\xFCr die NAV-Rechnung",
      partnerIncomplete: "Unvollst\xE4ndige Kundendaten (Name, PLZ, Stadt, Adresse; Steuernummer bei Firmen) \u2014 bitte f\xFCr die NAV-Rechnung erg\xE4nzen",
      fixPartner: "Kundendaten bearbeiten"
    },
    export: {
      monthLabel: "Exportmonat",
      xlsxButton: "Exportieren (XLSX)",
      csvButton: "CSV",
      error: "Export fehlgeschlagen"
    },
    voided: "Storniert",
    saveError: "Speicherfehler"
  },
  sales: {
    title: "Verkauf",
    subtitle: "Heutige und vergangene Verk\xE4ufe",
    totalSales: "Gesamtverk\xE4ufe",
    totalRevenue: "Gesamtumsatz",
    avgBasket: "\xD8 Warenkorb",
    searchPlaceholder: "Suche (Beleg, Kunde)...",
    allStatuses: "Alle Status",
    cashCustomer: "Barkunde",
    statusLabels: {
      inProgress: "In Bearbeitung",
      awaitingPayment: "Zahlung ausstehend",
      completed: "Abgeschlossen",
      reversed: "Storniert"
    },
    paymentStatusLabels: {
      pending: "Ausstehend",
      partial: "Teilweise",
      paid: "Bezahlt",
      refunded: "Erstattet"
    },
    newSale: "Neuer Verkauf",
    noSales: "Keine Verk\xE4ufe f\xFCr die gew\xE4hlten Filterkriterien.",
    pendingPayment: "Zahlung ausstehend",
    errorOccurred: "Ein Fehler ist aufgetreten: {message}",
    detail: {
      pendingPayment: "Zahlung ausstehend",
      voided: "Storniert",
      receipt: "Quittung",
      invoice: "Rechnung",
      processing: "Verarbeitung...",
      void: "Stornieren",
      voidConfirm: "M\xF6chten Sie diese Transaktion wirklich stornieren?",
      voidReason: "Auf Benutzerwunsch storniert",
      voidError: "Fehler beim Stornieren",
      printReceipt: "Quittung wird gedruckt...",
      printInvoice: "Rechnung wird gedruckt...",
      loadError: "Fehler beim Laden.",
      transactionNotFound: "Transaktion nicht gefunden.",
      items: "Positionen ({count})",
      noItems: "Keine Positionen",
      discount: "Rabatt",
      customerData: "Kundendaten",
      partnerId: "Partner-ID",
      voidData: "Stornierungsdaten",
      timestamp: "Zeitpunkt",
      reason: "Grund",
      summary: "Zusammenfassung",
      subtotal: "Zwischensumme",
      discountAmount: "Rabatt",
      paymentStatus: "Zahlungsstatus",
      paidAmount: "Bezahlt: {amount}",
      change: "R\xFCckgeld",
      transactionData: "Transaktionsdaten",
      transactionNumber: "Transaktionsnummer",
      sessionId: "Session-ID"
    },
    pos: {
      title: "Kasse (POS)",
      loadingSession: "Kassensitzung wird geladen...",
      noDefaultWarehouse: "Kein Standardlager f\xFCr dieses Konto. Richten Sie eines ein, um die Kasse zu \xF6ffnen.",
      warehouseLoadError: "Lager konnte nicht geladen werden. Bitte erneut versuchen.",
      retry: "Erneut",
      openRegister: "Kasse \xF6ffnen",
      suspend: "Unterbrechen",
      closeRegister: "Kasse schlie\xDFen",
      resume: "Fortsetzen",
      addCustomer: "+ Kunde",
      sessionWarning: "Die Kasse ist {status}. \xD6ffnen Sie die Kasse, um Transaktionen zu starten.",
      sessionSuspended: "unterbrochen",
      sessionClosed: "geschlossen",
      searchPlaceholder: "Suche nach Name, Artikelnummer oder Barcode...",
      allCategories: "Alle",
      openRegisterForProducts: "\xD6ffnen Sie die Kasse, um Produkte anzuzeigen",
      cart: "Warenkorb ({count} Artikel)",
      cartEmpty: "Warenkorb ist leer",
      subtotal: "Zwischensumme:",
      discount: "Rabatt:",
      total: "Gesamt:",
      clearCart: "Warenkorb leeren",
      pay: "Bezahlen",
      payment: "Zahlung",
      discountFt: "Rabatt (HUF)",
      receivedAmount: "Erhaltener Betrag (HUF)",
      toPay: "Zu zahlen:",
      change: "R\xFCckgeld:",
      completePayment: "Zahlung abschlie\xDFen",
      selectCustomer: "Kunde ausw\xE4hlen",
      noCustomer: "Kein Kunde (Barkauf)",
      saleSuccess: "Verkauf erfolgreich!\nBetrag: {total}\nR\xFCckgeld: {change}",
      noActiveSession: "Keine aktive Kassensitzung",
      outOfStock: "Produkt ist nicht auf Lager",
      procurement: {
        bannerTitle: "{name} \u2014 nicht auf Lager",
        bannerHint: "Lege es in den zentralen Beschaffungswagen, damit der Techniker beim n\xE4chsten Auftrag wei\xDF, dass dieser Artikel ben\xF6tigt wird.",
        addButton: "In den Beschaffungswagen",
        addSuccess: "Zum zentralen Beschaffungswagen hinzugef\xFCgt",
        addError: "Konnte nicht zum Wagen hinzugef\xFCgt werden"
      },
      unknownBarcode: "Unbekannter Barcode: {barcode}",
      barcodeError: "Fehler beim Barcode-Scan",
      paymentError: "Fehler bei der Zahlungsverarbeitung",
      voidError: "Fehler beim Stornieren der Transaktion",
      voidReason: "Vom Benutzer storniert",
      productCategories: {
        powerTool: "Elektrowerkzeug",
        handTool: "Handwerkzeug",
        accessory: "Zubeh\xF6r",
        workwear: "Arbeitskleidung"
      },
      loyalty: {
        balance: "Punktestand",
        points: "Punkte",
        redeem: "Punkte einl\xF6sen",
        maxRedemption: "max {percent}% des Gesamtbetrags",
        discount: "Treuepunkte-Rabatt",
        remaining: "Restbetrag",
        redeemFailed: "Punkteinl\xF6sung fehlgeschlagen",
        insufficientPoints: "Nicht gen\xFCgend Treuepunkte zum Einl\xF6sen",
        concurrentRetry: "Die Einl\xF6sung kollidierte mit einer anderen Transaktion \u2014 bitte erneut versuchen"
      },
      packages: {
        title: "Pakete",
        badge: "Paket",
        setBadge: "Set",
        savingsLabel: "Ersparnis gegen\xFCber Einzelkauf",
        tieredNotSellable: "Dieses Paket hat eine mietdauerabh\xE4ngige Preisgestaltung und kann nicht am POS verkauft werden",
        componentPriceMissing: "Ein Paketartikel hat keinen Preis \u2014 bitte im Admin-Bereich festlegen",
        discountMissing: "F\xFCr das Rabatt-Paket ist kein Rabatt konfiguriert",
        fixedPriceMissing: "F\xFCr das Festpreis-Paket ist kein Preis konfiguriert",
        addFailed: "Das Paket kann nicht zum Warenkorb hinzugef\xFCgt werden"
      },
      barcodePlaceholder: "Barcode scannen\u2026",
      creditPayment: "Auf Kredit",
      voucherPayment: "Gutschein",
      saleSuccessTitle: "Verkauf erfolgreich",
      saleSuccessTotal: "Bezahlter Betrag",
      saleSuccessChange: "R\xFCckgeld",
      saleTransactionLabel: "Transaktion",
      navProcessing: "NAV-\xDCbermittlung l\xE4uft\u2026",
      newSale: "Neuer Verkauf"
    },
    session: {
      close: {
        title: "Kasse schlie\xDFen",
        sessionLabel: "Sitzung:",
        openingBalance: "Er\xF6ffnungssaldo:",
        expectedBalance: "Erwarteter Saldo:",
        closingBalance: "Schlusssaldo (HUF)",
        variance: "Abweichung:",
        surplus: "\xDCberschuss in der Kasse",
        shortage: "Fehlbetrag in der Kasse",
        varianceReason: "Abweichungsbegr\xFCndung (erforderlich)",
        variancePlaceholder: "Geben Sie den Grund der Abweichung ein...",
        closeError: "Fehler beim Schlie\xDFen der Kasse",
        cancel: "Abbrechen",
        closing: "Schlie\xDFen...",
        closeButton: "Kasse schlie\xDFen"
      },
      suspend: {
        title: "Kasse unterbrechen",
        resumeTitle: "Kasse fortsetzen",
        statusLabel: "Status:",
        statusSuspended: "UNTERBROCHEN",
        statusActive: "AKTIV",
        reasonLabel: "Unterbrechungsgrund (optional)",
        reasonPlaceholder: "Z.B. Mittagspause, Schichtwechsel...",
        quickReasons: {
          lunch: "Mittagspause",
          break: "Pause",
          shiftChange: "Schichtwechsel",
          technical: "Technisches Problem"
        },
        resumeInfo: "Die Kasse ist derzeit unterbrochen.",
        resumeHint: 'Klicken Sie auf "Fortsetzen", um die Kasse wieder zu aktivieren.',
        resuming: "Fortsetzen...",
        resumeButton: "Kasse fortsetzen",
        suspending: "Unterbrechen...",
        suspendButton: "Unterbrechen"
      },
      open: {
        title: "Kasse \xF6ffnen",
        openingBalance: "Er\xF6ffnungssaldo (HUF)",
        openError: "Fehler beim \xD6ffnen der Kasse",
        cancel: "Abbrechen",
        opening: "\xD6ffnen...",
        openButton: "Kasse \xF6ffnen"
      },
      status: {
        open: "AKTIV",
        suspended: "UNTERBROCHEN",
        closed: "GESCHLOSSEN",
        noSession: "KEINE AKTIVE KASSE"
      }
    },
    zReport: {
      title: "Z-Bericht",
      sessionInfo: "KASSENINFORMATION",
      opened: "Ge\xF6ffnet:",
      closed: "Geschlossen:",
      cashBalance: "BARGELDSALDO",
      openingBalance: "Er\xF6ffnungssaldo:",
      expectedBalance: "Erwarteter Saldo:",
      closingBalance: "Schlusssaldo:",
      variance: "Abweichung:",
      note: "Anmerkung:",
      transactions: "TRANSAKTIONEN",
      totalTransactions: "Gesamttransaktionen:",
      completed: "Abgeschlossen:",
      voided: "Storniert:",
      paymentMethods: "ZAHLUNGSMETHODEN",
      cash: "Bargeld:",
      card: "Bankkarte:",
      transfer: "\xDCberweisung:",
      voucher: "Gutschein:",
      credit: "Kredit:",
      revenue: "UMSATZ",
      grossSales: "Bruttoumsatz:",
      discounts: "Rabatte:",
      netSales: "Nettoumsatz:",
      taxAmount: "MwSt.-Betrag:",
      changeGiven: "R\xFCckgeld:",
      print: "Drucken",
      downloadPdf: "PDF herunterladen",
      downloadPdfSoon: "PDF-Download demn\xE4chst verf\xFCgbar",
      close: "Schlie\xDFen",
      refunds: "R\xFCckerstattungen"
    }
  },
  inventory: {
    title: "Lager",
    stockList: "Bestandsliste",
    movements: "Bewegungen",
    goodsReceipt: "Wareneingang",
    scrapping: "Verschrottung",
    management: "Lagerverwaltung",
    warehouseAndMovements: "Lagerbestand und Bewegungen",
    allItems: "Alle Artikel",
    stockValue: "Bestandswert",
    available: "Verf\xFCgbar",
    lowStock: "Niedriger Bestand",
    lowStockCount: "{count} Artikel",
    searchPlaceholder: "Suche (Produkt, SKU, Referenz)...",
    allWarehouses: "Alle Lager",
    loadingStock: "Bestand wird geladen...",
    reserved: "Reserviert",
    purchasePrice: "Einkaufspreis",
    warehouse: "Lager",
    noResults: "Keine Ergebnisse",
    newReceipt: "+ Wareneingang",
    receiptFailed: "Wareneingang fehlgeschlagen. Bitte erneut versuchen.",
    availableCount: "Verf\xFCgbar ({count})",
    reservedCount: "Reserviert ({count})",
    lowStockCountBadge: "Niedriger Bestand ({count})",
    typeLabels: {
      product: "Produkt",
      rentalEquipment: "Mietger\xE4t",
      part: "Ersatzteil",
      consumable: "Verbrauchsmaterial"
    },
    statusLabels: {
      available: "Verf\xFCgbar",
      reserved: "Reserviert",
      inService: "In Wartung",
      inTransit: "Im Transport",
      rented: "Vermietet",
      sold: "Verkauft",
      damaged: "Besch\xE4digt",
      lost: "Verloren",
      scrapped: "Verschrottet"
    },
    scrapItems: "Ausschusspositionen",
    scrapProtocols: "Protokolle",
    newScrap: "Neuer Ausschuss",
    scrapMark: "Als Ausschuss markieren",
    scrapRecord: "Ausschuss erfassen",
    scrapRecording: "Erfassung...",
    scrapRecords: "Ausschusseintr\xE4ge ({count})",
    noScrapRecords: "Keine Ausschusseintr\xE4ge.",
    scrapReasonLabels: {
      damaged: "Besch\xE4digt",
      expired: "Abgelaufen",
      defective: "Defekt",
      other: "Sonstiges"
    },
    scrapProtocolStatuses: {
      draft: "Entwurf",
      approved: "Genehmigt",
      finalized: "Abgeschlossen"
    },
    scrapProtocolsTitle: "Verschrottungsprotokolle",
    newProtocol: "Neues Protokoll",
    year: "Jahr",
    inventoryItemId: "Lagerartikel-ID",
    productId: "Produkt-ID",
    warehouseId: "Lager-ID",
    itemNotFound: "Artikel nicht gefunden",
    stockCount: {
      title: "Inventuren",
      newButton: "Neue Inventur",
      newButtonHint: "Inventur starten \u2014 demn\xE4chst verf\xFCgbar",
      empty: "Noch keine Inventur",
      columns: {
        countNumber: "Inventurnummer",
        name: "Name",
        status: "Status",
        createdAt: "Erstellt",
        warehouse: "Lager"
      },
      statusLabels: {
        draft: "Entwurf",
        inProgress: "In Bearbeitung",
        suspended: "Ausgesetzt",
        pendingReview: "Pr\xFCfung ausstehend",
        pendingAdjustment: "Korrektur ausstehend",
        completed: "Abgeschlossen",
        cancelled: "Storniert"
      }
    },
    movementsTitle: "Lagerbewegungen",
    movementsSubtitle: "Eing\xE4nge, Ausg\xE4nge, Korrekturen",
    movementsSearch: "Suche (Produkt, Artikelnr., Referenz)...",
    category: {
      powerTool: "Elektrowerkzeug",
      handTool: "Handwerkzeug",
      accessory: "Zubeh\xF6r",
      consumable: "Verbrauchsmaterial",
      workwear: "Arbeitskleidung",
      sparePart: "Ersatzteil"
    },
    stockStatus: {
      inStock: "Auf Lager",
      lowStock: "Geringer Bestand",
      outOfStock: "Nicht auf Lager",
      discontinued: "Auslaufend"
    },
    movement: {
      in: "Eingang",
      out: "Ausgang",
      adjustment: "Korrektur",
      transfer: "Transfer",
      return: "R\xFCcknahme"
    },
    addProduct: "Produkt hinzuf\xFCgen",
    addProductsViaSearch: "Produkt suchen und hinzuf\xFCgen",
    allGroups: "Alle Gruppen",
    approve: "Genehmigen",
    backToList: "Zur\xFCck zur Liste",
    basicData: "Grunddaten",
    batchNumber: "Chargennummer",
    correction: "Korrektur",
    create: "Erstellen",
    createdAt: "Erstellt am",
    creating: "Wird erstellt...",
    documentData: "Dokumentdaten",
    finalize: "Abschlie\xDFen",
    issueStock: "Ausgabe",
    items: "Positionen",
    itemsToReceive: "Zu empfangende Positionen",
    location: "Standort",
    maximum: "Maximum",
    minimum: "Minimum",
    month: "Monat",
    noProtocols: "Keine Protokolle",
    optionalReceiptNote: "Optionale Empfangsnotiz",
    pcs: "Stk.",
    pricing: "Preisgestaltung",
    procurementAndRestock: "Beschaffung und Nachschub",
    productTypes: "Produkttypen",
    profitability: "Rentabilit\xE4t",
    protocolsList: "Protokollliste",
    purchaseCategories: {
      ARU: "Ware",
      BERENDEZES: "Einrichtung",
      BERUHAZAS: "Investition",
      EGYEB: "Sonstiges",
      REZSI: "Gemeinkosten"
    },
    purchaseCategoryLabel: "Einkaufskategorie",
    purchaseCategoryPlaceholder: "Kategorie w\xE4hlen...",
    purchaseValue: "Einkaufswert",
    quickActions: "Schnellaktionen",
    receive: {
      package: "Paket",
      packageQuantity: "Paketanzahl",
      totalUnits: "Gesamteinheiten",
      unitPrice: "St\xFCckpreis",
      unitsPerPackage: "Einheiten pro Paket"
    },
    receiveStock: "Wareneingang",
    recording: "Wird erfasst...",
    referenceOrderNumber: "Referenz-Bestellnummer",
    saveReceipt: "Eingang speichern",
    saving: "Wird gespeichert...",
    searchByNameSkuBarcode: "Suche nach Name, SKU, Barcode...",
    serialNumber: "Seriennummer",
    sku: "SKU",
    stock: "Bestand",
    stockLevels: "Bestandsniveaus",
    summary: "Zusammenfassung",
    targetWarehouse: "Ziellager",
    total: "Gesamt",
    totalPieces: "Gesamt (Stk.)",
    transferTitle: "Lager\xFCbergreifende Umlagerung",
    transferSubtitle: "Interne Bestandsbewegung (ohne Rechnung)",
    transferSource: "Quelllager",
    transferTarget: "Ziellager",
    transferSelectSource: "Quelllager ausw\xE4hlen",
    transferSelectTarget: "Ziellager ausw\xE4hlen",
    transferReason: "Grund (optional)",
    transferSameWarehouseError: "Quell- und Ziellager d\xFCrfen nicht identisch sein",
    transferAvailableItems: "Verf\xFCgbare Artikel",
    transferNoItems: "Keine verf\xFCgbaren Artikel im Quelllager",
    transferAdd: "Hinzuf\xFCgen",
    transferAddedItems: "Umzulagernde Artikel",
    transferQuantity: "Menge",
    transferAvailable: "Verf\xFCgbar: {qty}",
    transferRemove: "Entfernen",
    transferSubmit: "Umlagerung starten",
    transferSuccess: "Umlagerung gestartet (#{id})",
    transfer: {
      confirmNote: "Umbuchungsnotiz",
      confirmOwnAsset: "Registrierung als Eigenanlage best\xE4tigen",
      confirmRental: "Registrierung als Mietger\xE4t best\xE4tigen",
      ecsStarted: "AfA-Berechnung gestartet",
      error: "Umbuchungsfehler",
      rentalCardCreated: "Mietger\xE4tkarte erstellt",
      success: "Umbuchung erfolgreich",
      title: "Bestandsumbuchung",
      toOwnAsset: "Als Eigenanlage umklassifizieren",
      toRental: "Als Mietger\xE4t umklassifizieren"
    },
    updatedAt: "Aktualisiert am",
    views: "Ansichten",
    barcode: {
      scan: "Barcode-Scan",
      scanPlaceholder: "Barcode scannen oder Artikelnummer eingeben...",
      notFound: "Kein Produkt mit diesem Barcode gefunden",
      found: "Produkt gefunden",
      lookupError: "Barcode-Suchfehler"
    },
    withdrawal: {
      title: "Bestandsentnahme",
      scanToAdd: "Barcode scannen um Artikel hinzuzuf\xFCgen"
    },
    splitAvailability: {
      title: "Bestell-Bestand-Aufteilung",
      split: "Verf\xFCgbarkeit aufteilen",
      available: "Verf\xFCgbar",
      backordered: "R\xFCckst\xE4ndig",
      partial: "Teilweise verf\xFCgbar",
      fullyAvailable: "Vollst\xE4ndig verf\xFCgbar",
      fullyBackordered: "Vollst\xE4ndig r\xFCckst\xE4ndig",
      summary: "Zusammenfassung: {available} verf\xFCgbar, {backordered} r\xFCckst\xE4ndig, {partial} teilweise"
    },
    centralRequest: {
      title: "Anforderung an Zentrallager",
      submit: "Anforderung senden",
      submitting: "Wird gesendet...",
      pending: "Offene Anforderungen",
      note: "Anmerkung",
      notePlaceholder: "Optionale Anmerkung zur Anforderung...",
      success: "Anforderung erfolgreich gesendet ({count} Artikel)",
      noPending: "Keine offenen Anforderungen",
      requestedAt: "Angefordert am",
      selectLowStock: "Artikel mit niedrigem Bestand ausw\xE4hlen"
    },
    phantom: {
      title: "Phantom-Artikel",
      count: "{count} Phantom-Artikel",
      badge: "Phantom ({count})",
      resolve: "Aufl\xF6sen",
      scrap: "Verschrotten",
      recount: "Nachz\xE4hlen",
      actualQuantity: "Tats\xE4chliche Menge",
      reason: "Grund",
      reasonPlaceholder: "Aufl\xF6sungsgrund...",
      resolved: "Phantom-Artikel aufgel\xF6st",
      noPhantom: "Keine Phantom-Artikel"
    },
    deadStock: {
      title: "Tote Best\xE4nde",
      subtitle: "Artikel nach Bewegungsaktualit\xE4t klassifiziert",
      activeLabel: "Aktiv",
      warningLabel: "Warnung",
      deadLabel: "Tot",
      activeCount: "Aktive Artikel",
      warningCount: "Warnung",
      deadCount: "Tote Artikel",
      totalDeadValue: "Toter Bestandswert",
      productName: "Produkt",
      sku: "Artikelnummer",
      quantity: "Menge",
      lastMovement: "Letzte Bewegung",
      daysSinceMovement: "Tage inaktiv",
      classification: "Klassifizierung",
      value: "Wert",
      warehouse: "Lager",
      noMovement: "Keine Bewegung",
      noData: "Keine Daten f\xFCr die Analyse toter Best\xE4nde"
    },
    analytics: {
      title: "Bestandsanalytik",
      subtitle: "ITR- und ABC-Analyse"
    },
    turnover: {
      title: "Lagerumschlagsquote (ITR)",
      ratio: "Umschlagsquote",
      cogs: "COGS (gesch\xE4tzt)",
      avgInventoryValue: "Durchschn. Bestandswert",
      year: "Jahr",
      previousYear: "Vorjahr",
      trend: "Trend",
      trendUp: "Steigend",
      trendDown: "Fallend",
      trendStable: "Stabil",
      noData: "Keine Daten f\xFCr die Umschlagsanalyse"
    },
    abc: {
      title: "ABC-Analyse",
      subtitle: "Pareto-Klassifizierung nach Umsatz",
      product: "Produkt",
      sku: "Artikelnummer",
      revenue: "Umsatz",
      cumulativePercent: "Kumulativ %",
      class: "Klasse",
      aItems: "A-Artikel",
      bItems: "B-Artikel",
      cItems: "C-Artikel",
      totalRevenue: "Gesamtumsatz",
      noData: "Keine Daten f\xFCr ABC-Analyse"
    },
    seasonality: {
      title: "Saisonalit\xE4t",
      selectProduct: "Produkt ausw\xE4hlen",
      chooseProduct: "Produkt w\xE4hlen...",
      topSeasonal: "Top 10 saisonale Produkte",
      productName: "Produkt",
      index: "Saisonalit\xE4tsindex",
      peakMonths: "Spitzenmonate",
      lowMonths: "Schwache Monate",
      peak: "Spitze",
      normal: "Normal",
      low: "Niedrig",
      noData: "Keine Daten f\xFCr Saisonalit\xE4tsanalyse"
    },
    transferSuggestion: {
      title: "Transfervorschl\xE4ge",
      totalSuggestions: "Gesamtvorschl\xE4ge",
      product: "Produkt",
      from: "Quelllager",
      to: "Ziellager",
      currentFrom: "Aktuell (Quelle)",
      currentTo: "Aktuell (Ziel)",
      suggestedQty: "Vorgeschlagene Menge",
      reason: "Begr\xFCndung",
      noSuggestions: "Derzeit keine Transfervorschl\xE4ge"
    },
    supplierCatalog: {
      title: "Lieferantenkatalog",
      supplier: "Lieferant",
      search: "Suche",
      searchPlaceholder: "Suche Produkt, Artikelnummer...",
      results: "Ergebnisse",
      productName: "Produkt",
      category: "Kategorie",
      price: "Nettopreis",
      availability: "Verf\xFCgbarkeit",
      leadTime: "Lieferzeit",
      days: "Tage",
      inStock: "Auf Lager",
      outOfStock: "Nicht auf Lager",
      noResults: "Keine Ergebnisse",
      hint: "W\xE4hlen Sie einen Lieferanten und suchen Sie Produkte im Katalog"
    },
    allProductGroups: "Alle Produktgruppen",
    productGroups: {
      ALKATRESZ: "Ersatzteil",
      GEP: "Maschine",
      TARTOZEK: "Zubeh\xF6r",
      SZERSZAM: "Werkzeug",
      MUNKARUHA: "Arbeitskleidung / PSA",
      VEGYSZER: "Chemikalie / Schmierstoff",
      EGYEB: "Sonstiges Verbrauchsmaterial",
      BERGEP: "Mietmaschine",
      DIJAK: "Geb\xFChren / Servicegeb\xFChr",
      SZERZODESES: "Vertraglich",
      BERENDEZES: "Anlage"
    },
    reservedForWorksheet: "F\xFCr Arbeitsblatt reserviert",
    summaryTitle: "Bestands\xFCbersicht",
    summarySubtitle: "Aggregat je Produkt: Menge, reserviert vs. frei",
    occupiedOfTotal: "{occupied}/{total} belegt",
    stockLevel: {
      OK: "OK",
      LOW: "Niedrig",
      CRITICAL: "Kritisch",
      OUT_OF_STOCK: "Nicht auf Lager"
    },
    movementUnitCost: "St\xFCckkosten",
    movementValue: "Bewegungswert",
    breakdown: {
      expand: "Lageraufschl\xFCsselung anzeigen",
      collapse: "Lageraufschl\xFCsselung ausblenden",
      title: "Aufschl\xFCsselung nach Lager"
    }
  },
  partner: {
    title: "Partner",
    subtitle: "Kunden-, Lieferanten- und Subunternehmerverwaltung",
    name: "Name",
    email: "E-Mail",
    phone: "Telefon",
    address: "Adresse",
    taxNumber: "Steuernummer",
    newPartner: "Neuer Partner",
    partnerList: "Partnerliste",
    totalPartners: "Alle Partner",
    company: "Firma",
    individual: "Privatperson",
    withBalance: "Mit Saldo",
    totalBalance: "Gesamtsaldo",
    contact: "Kontakt",
    revenue: "Umsatz",
    balance: "Saldo",
    categories: "Kategorien",
    searchPlaceholder: "Suche nach Name, Code, E-Mail, Telefon, Steuernr...",
    duplicatesTitle: "Partnerduplikate & verlassene Ger\xE4te",
    matchFieldLabels: {
      phone: "Telefon",
      documentNumber: "Dokumentennummer",
      email: "E-Mail",
      name: "Name",
      taxNumber: "Steuernummer",
      DOCUMENT_NUMBER: "Dokumentnummer",
      EMAIL: "E-Mail-Adresse",
      NAME: "Name",
      TAX_NUMBER: "Steuernummer"
    },
    actionLabels: {
      scrapped: "Verschrottet",
      sold: "Verkauft",
      retained: "Behalten",
      DESTROY: "Vernichten",
      KEEP: "Behalten",
      SELL: "Verkaufen"
    },
    scrappingReason: "Verschrottungsgrund:",
    registerData: "Partnerdaten erfassen",
    typeAndCategory: "Typ und Kategorie",
    partnerType: "Partnertyp",
    categoriesRequired: "Kategorien * (mindestens eine)",
    basicData: "Grunddaten",
    companyName: "Firmenname",
    companyNameOptional: "Firma (optional)",
    validation: {
      taxFormat: "Ung\xFCltiges Steuernummernformat (8-1-2 Ziffern).",
      taxChecksum: "Die Pr\xFCfziffer der Steuernummer ist ung\xFCltig.",
      phoneFormat: "Ung\xFCltiges Telefonnummernformat.",
      postalFormat: "Ung\xFCltiges Postleitzahlformat (4 Ziffern)."
    },
    fullName: "Vollst\xE4ndiger Name",
    shortName: "Kurzname",
    registrationNumber: "Handelsregisternummer",
    contactInfo: "Kontaktdaten",
    website: "Webseite",
    billingAddress: "Rechnungsadresse",
    postalCode: "Postleitzahl",
    city: "Stadt",
    streetAddress: "Stra\xDFe, Hausnummer",
    floorDoor: "Stockwerk/T\xFCr",
    notificationEmail: "Benachrichtigungs-E-Mail",
    billingEmail: "Rechnungs-E-Mail",
    billingEmailSameAsNotification: "Gleich wie Benachrichtigungs-E-Mail",
    temporaryAddress: "Vor\xFCbergehende Adresse",
    tempAddressValidUntil: "G\xFCltig bis",
    temporaryAddressSection: "Vor\xFCbergehende Adresse (falls abweichend)",
    temporaryAddressExpired: "(abgelaufen)",
    lastDocumentScanDate: "Letzter Dokumentenscan",
    documentExpiredWarning: "Dokumentenaktualisierung erforderlich",
    documentExpiredRentalWarning: "Das Dokument des Partners wurde vor mehr als 180 Tagen gescannt. Bitte aktuelles Dokument anfordern!",
    cashB2bTaxNumberRequired: "F\xFCr Bartransaktionen mit Firmenkunden ist eine Steuernummer erforderlich!",
    paymentBypassEnabled: "\xDCberweisung ohne Genehmigung des Vorgesetzten zulassen",
    paymentBypassDescription: "Aktiviert: Der Partner kann per \xDCberweisung zahlen, ohne eine separate Genehmigung des Vorgesetzten.",
    paymentBypassReadonlyHint: "Kann nur \xFCber den Genehmigungsprozess des Vorgesetzten ge\xE4ndert werden.",
    fieldReadonlyHint: "Bei Erstellung festgelegt \u2014 hier nicht bearbeitbar.",
    categoriesReadonlyHint: "Die Kategorien ergeben sich aus dem Partnertyp \u2014 hier nicht bearbeitbar.",
    idVerified: "Ausweis gepr\xFCft",
    idVerifiedOn: "\u2705 Gepr\xFCft: {date}",
    costBearerTree: "Kostentr\xE4gerhierarchie",
    costBearerCompany: "Kostentr\xE4gerunternehmen",
    costBearerEmployees: "Mitarbeiter",
    compareTitle: "Partnervergleich",
    partnerA: "Partner A (Quelle)",
    partnerB: "Partner B (\xDCbereinstimmung)",
    compareDescription: "W\xE4hlen Sie, in welchen Partner zusammengef\xFChrt werden soll. Die Zusammenf\xFChrung \xFCbertr\xE4gt Vermietungen, Arbeitsbl\xE4tter und Rechnungen.",
    mergeIntoA: "In A zusammenf\xFChren \u2192",
    mergeIntoB: "\u2190 In B zusammenf\xFChren",
    openInNewTab: "In neuem Tab \xF6ffnen \u2192",
    tabRentals: "Vermietungen",
    tabService: "Service",
    tabInvoices: "Rechnungen",
    tabLoyalty: "Treuepunkte",
    transactionTabPlaceholder: "Transaktionen werden geladen...",
    loyaltyPoints: "Treuepunkte",
    depositExemption: "Kautionsbefreiung",
    depositRequired: "Erforderlich",
    depositExempt: "Befreit",
    depositAutomatic: "Automatisch (TRUSTED)",
    depositRequiredDesc: "Kaution ist f\xFCr alle Vermietungen erforderlich",
    depositExemptDesc: "Vom Filialleiter befreit \u2014 0 Kaution",
    depositAutomaticDesc: "Automatische Befreiung nach 10 problemlosen Vermietungen",
    depositExemptionUpdated: "Kautionsbefreiung aktualisiert",
    depositExemptionError: "Kautionsbefreiung konnte nicht aktualisiert werden",
    depositExemptionListRequired: "F\xFCr die Kautionsbefreiung ist mindestens ein bevollm\xE4chtigter Vertreter (aktiver Bevollm\xE4chtigter oder Vollmacht) erforderlich \u2014 f\xFCge zuerst einen hinzu.",
    depositExemptionRbacHint: "Nur ein Filialleiter kann dies \xE4ndern",
    loyaltyTier: "Stufe",
    phones: "Telefonnummern",
    phoneNumbers: "Telefonnummern",
    addPhone: "Telefonnummer hinzuf\xFCgen",
    phoneLabel: "Typ",
    phoneLabelPlaceholder: "z.B. Service, Ersatzteile...",
    phoneNumber: "Telefonnummer",
    phoneLabelPrivate: "Privat",
    phoneLabelCompany: "Firma",
    phoneLabelFax: "Fax",
    phoneLabelOther: "Sonstiges",
    phonePrimary: "Prim\xE4r",
    phoneMaxReached: "Maximal 5 Telefonnummern erlaubt",
    personalData: "Pers\xF6nliche Daten",
    birthDate: "Geburtsdatum",
    birthPlace: "Geburtsort",
    mothersName: "M\xE4dchenname der Mutter",
    idCardNumber: "Personalausweisnummer",
    financialSettings: "Finanzeinstellungen",
    paymentTermDays: "Zahlungsfrist (Tage)",
    creditLimitFt: "Kreditlimit (HUF)",
    discountPercent: "Rabatt %",
    rentalDepositPercent: "Mietkaution %",
    createPartner: "Partner erstellen",
    notesPlaceholder: "Optionale Notizen zum Partner...",
    nameRequired: "Name ist erforderlich!",
    categoryRequired: "Bitte mindestens eine Kategorie ausw\xE4hlen!",
    partnerCreated: "Partner erstellt!",
    partnerNotFound: "Partner nicht gefunden",
    backToList: "Zur\xFCck zur Liste",
    companyLabel: "Firma",
    individualLabel: "Privatperson",
    tabOverview: "\xDCbersicht",
    tabAddresses: "Adressen",
    tabContacts: "Kontakte",
    tabRepresentatives: "Bevollm\xE4chtigte",
    tabFinancial: "Finanzen",
    tabHistory: "Verlauf",
    statistics: "Statistiken",
    totalRevenue: "Gesamtumsatz:",
    ordersCount: "Bestellungen:",
    rentalsCount: "Vermietungen:",
    serviceOrdersCount: "Serviceauftr\xE4ge:",
    lastOrder: "Letzte Bestellung:",
    lastRental: "Letzte Vermietung:",
    debt: "Schulden:",
    rentalSettings: "Mieteinstellungen",
    depositPercent: "Kaution %:",
    rentalStatus: "Mietstatus:",
    blocked: "Gesperrt",
    allowed: "Erlaubt",
    newAddress: "Neue Adresse",
    noAddresses: "Keine Adressen registriert.",
    newContact: "Neuer Kontakt",
    noContacts: "Keine Kontakte registriert.",
    primary: "Prim\xE4r",
    defaultAddress: "Standard",
    addressBilling: "Rechnungs-",
    addressShipping: "Liefer-",
    addressOther: "Sonstige",
    suspend: "Sperren",
    unsuspend: "Sperre aufheben",
    suspended: "Partner gesperrt",
    unsuspended: "Sperre aufgehoben",
    suspendConfirm: "M\xF6chten Sie den Partner wirklich sperren: {name}?",
    unsuspendConfirm: "M\xF6chten Sie die Sperre des Partners wirklich aufheben?",
    suspendError: "Fehler beim Sperren",
    unsuspendError: "Fehler beim Aufheben der Sperre",
    suspendedBanner: "Partner gesperrt",
    suspendedBannerDesc: "Dieser Partner wurde aufgrund von Zahlungsproblemen gesperrt. Vermietung und neue Auftragsannahme sind nicht m\xF6glich.",
    rentalBlockedNote: "Vermietung gesperrt \u2014 Sperre muss aufgehoben werden.",
    blockedRentalTooltip: "Partner gesperrt \u2014 Vermietung nicht m\xF6glich",
    newRental: "Neue Vermietung",
    newSale: "Neuer Verkauf",
    newWorksheet: "Neues Arbeitsblatt",
    publicNote: "\xD6ffentliche Notiz",
    internalNote: "Interne Notiz",
    outstandingDebt: "Offene Schulden: {amount}",
    contactSupport: "Bitte kontaktieren Sie den Kundenservice.",
    noOutstandingDebt: "Keine offenen Schulden.",
    paymentTerm: "Zahlungsfrist",
    creditLimit: "Kreditlimit",
    baseDiscount: "Grundrabatt",
    priceList: "Preisliste",
    debtsTitle: "Schulden",
    partnerUpdated: "Partnerdaten aktualisiert",
    partnerCreatedBy: "Partner erstellt ({user})",
    nDays: "{count} Tage",
    defaultPriceList: "Standard",
    noneValue: "Keine",
    categoryLabels: {
      retail: "Einzelhandelskunde",
      wholesale: "Gro\xDFhandelskunde",
      renter: "Mieter",
      service: "Service",
      supplier: "Lieferant",
      subcontractor: "Subunternehmer"
    },
    typeLabels: {
      individual: "Privatperson",
      company: "Unternehmen"
    },
    idCard: "Personalausweis",
    drivingLicense: "F\xFChrerschein",
    passport: "Reisepass",
    duplicateSuspects: "Duplikatverdacht",
    abandonedEquipment: "60-Tage verlassene Ger\xE4te",
    editTitle: "Partner bearbeiten",
    saveChanges: "\xC4nderungen speichern",
    errorPrefix: "Fehler: {error}",
    saveFailed: "Beim Speichern ist ein Fehler aufgetreten",
    confidence: "Sicherheit",
    detected: "Erkannt",
    mergeButton: "Zusammenf\xFChren",
    dismissButton: "Verwerfen",
    noDuplicates: "Keine ungel\xF6sten Duplikate.",
    worksheetLabel: "Arbeitsblatt",
    noAbandonedEquipment: "Keine verlassene Ausr\xFCstung mit ausstehender Entscheidung.",
    scrapButton: "Verschrotten",
    sellButton: "Verkaufen",
    keepButton: "Behalten",
    namePlaceholderCompany: "Beispiel GmbH",
    namePlaceholderIndividual: "Max Mustermann",
    shortNamePlaceholder: "Beispiel",
    streetPlaceholder: "Hauptstr. 35",
    category: {
      retail: "Einzelhandelskunde",
      wholesale: "Gro\xDFhandelskunde",
      rental: "Mieter",
      service: "Service",
      supplier: "Lieferant",
      contractor: "Subunternehmer"
    },
    status: {
      active: "Aktiv",
      inactive: "Inaktiv",
      blocked: "Gesperrt",
      trusted: "Stammkunde",
      warning: "Warnung"
    },
    type: {
      individual: "Privatperson",
      company: "Firma"
    },
    createSuccess: "Partner erfolgreich erstellt!\nCode: {code}\nName: {name}",
    placeholder: {
      address: "Hauptstra\xDFe 35",
      city: "Berlin",
      companyName: "Beispiel GmbH",
      email: "info@beispiel.de",
      lastName: "Beispiel",
      personName: "Max Mustermann",
      website: "https://beispiel.de",
      birthPlace: "z.B. Berlin",
      mothersName: "z.B. Anna M\xFCller",
      temporaryAddress: "z.B. 10117 Berlin, Unter den Linden 1",
      idCardNumber: "z.B. 123456AB"
    },
    contractPrices: {
      title: "Vertragspreise"
    },
    discount: {
      categorized: "Kategorisierter Rabatt",
      max: "Maximaler Rabatt",
      noStacking: "Rabatte nicht kombinierbar",
      rental: "Mietrabatt",
      sales: "Verkaufsrabatt",
      service: "Servicerabatt"
    },
    displayedCount: "Angezeigt: {count}",
    quickCreate: {
      title: "Schnellerstellung Partner",
      typeLabel: "Typ",
      individual: "Privatperson",
      company: "Unternehmen",
      nameLabel: "Name *",
      namePlaceholder: "Partnername",
      taxNumberLabel: "Steuernummer",
      taxNumberPlaceholder: "12345678-1-42",
      emailLabel: "E-Mail",
      emailPlaceholder: "email@beispiel.de",
      phoneLabel: "Telefon",
      phonePlaceholder: "+36 30 123 4567",
      cityLabel: "Stadt",
      cityPlaceholder: "Budapest",
      submit: "Erstellen",
      cancel: "Abbrechen",
      success: "Partner erfolgreich erstellt: {name}",
      error: "Fehler beim Erstellen des Partners: {message}",
      taxNumberHint: "Ohne Steuernummer kann die Rechnungsstellung eingeschr\xE4nkt sein",
      duplicateWarning: "\xC4hnlicher Partner existiert bereits:",
      notFound: "Nicht gefunden? Neuen Partner erstellen",
      searchPlaceholder: "Suche nach Name, E-Mail, Telefon, Steuernr., Stadt..."
    },
    sanctions: {
      title: "Sanktionen",
      transferBan: "\xDCberweisung gesperrt",
      transferBanThreeMonth: "3-monatige Sperre",
      transferBanSixMonth: "6-monatige Sperre",
      transferBanPermanent: "Dauerhaft gesperrt",
      transferBanNone: "Keine Sperre",
      banUntil: "Sperre bis: {date}",
      strikeCount: "Zahlungsverz\xF6gerungen: {count}",
      walkInOnly: "Nur Walk-in",
      walkInOnlyUntil: "Walk-in-Beschr\xE4nkung bis: {date}",
      bookingWarning: "Buchungswarnung",
      cancelledCount: "Stornierte Buchungen: {count}",
      noShowCount: "Nichterscheinen: {count}",
      override: "\xDCberschreiben",
      overrideTitle: "Sanktion \xFCberschreiben",
      overrideReason: "Begr\xFCndung *",
      overrideReasonPlaceholder: "Warum wird die Sanktion \xFCberschrieben?",
      overrideConfirm: "\xDCberschreiben best\xE4tigen",
      overrideSuccess: "Sanktion erfolgreich \xFCberschrieben",
      overrideBy: "\xDCberschrieben von: {user}",
      overrideAt: "\xDCberschrieben am: {date}",
      discountsRevoked: "Rabatte entzogen",
      amnestyExpires: "Amnestie l\xE4uft ab: {date}"
    },
    segment: {
      title: "Kundensegment",
      vip: "VIP",
      active: "Aktiv",
      atRisk: "Gef\xE4hrdet",
      inactive: "Inaktiv",
      calculatedAt: "Letzte Berechnung: {date}",
      changedAt: "Segment\xE4nderung: {date}",
      distribution: "Segmentverteilung",
      partnerCount: "{count} Partner"
    },
    suggestions: {
      title: "Vorschl\xE4ge",
      crossSell: "{category} \u2014 {count} auf Lager",
      noSuggestions: "Keine Vorschl\xE4ge",
      calculating: "Segmentierung l\xE4uft..."
    },
    kpi: {
      lifetimeValue: "Gesamtumsatz",
      outstandingBalance: "Offener Saldo",
      totalRentals: "Mieten gesamt"
    },
    timeline: {
      title: "Kunden-Zeitstrahl",
      quickAddNote: "Notiz",
      loadMore: "Mehr laden",
      loadError: "Fehler beim Laden",
      empty: "Noch keine Ereignisse \u2014 erstelle die erste Notiz mit der Schaltfl\xE4che \u201ENotiz\u201C.",
      expand: "Details",
      collapse: "Einklappen",
      filterLabel: "Typ-Filter",
      types: {
        TASK: "Aufgabe",
        INVOICE: "Rechnung",
        QUOTE: "Angebot",
        DELIVERY_NOTE: "Lieferschein",
        RENTAL: "Vermietung",
        WORKSHEET: "Arbeitsblatt",
        LOYALTY: "Treue",
        TASK_NOTE: "Notiz",
        TASK_CALL: "Anruf"
      },
      quickAddDialog: {
        title: "Schnelle Notiz",
        description: "Notiz oder Anruf im Kunden-Zeitstrahl festhalten.",
        typeLabel: "Typ",
        titleLabel: "Titel",
        titlePlaceholder: "Kurze Zusammenfassung",
        descriptionLabel: "Details",
        descriptionPlaceholder: "Optionale ausf\xFChrliche Beschreibung",
        submit: "Speichern"
      },
      metaLabels: {
        dueDate: "F\xE4lligkeit",
        completedAt: "Abgeschlossen",
        priority: "Priorit\xE4t",
        issueDate: "Ausstellungsdatum",
        paidAmount: "Bezahlt",
        balanceDue: "Offen",
        currency: "W\xE4hrung",
        paymentMethod: "Zahlungsart",
        paidAt: "Bezahlt am",
        navStatus: "NAV-Status",
        validUntil: "G\xFCltig bis",
        sentAt: "Gesendet",
        acceptedAt: "Angenommen",
        rejectedAt: "Abgelehnt",
        invoiceId: "Rechnungs-ID",
        settledManually: "Manuell verrechnet",
        startDate: "Mietbeginn",
        expectedEnd: "Erwartete R\xFCckgabe",
        actualEnd: "Tats. Ende",
        returnedAt: "Zur\xFCckgegeben",
        depositRequired: "Kaution (erforderl.)",
        depositPaid: "Kaution (bezahlt)",
        depositReturned: "Kaution (zur\xFCck)",
        itemCount: "Positionen",
        equipment: "Ger\xE4t",
        serialNumber: "Seriennummer",
        receivedAt: "Eingenommen",
        deliveredAt: "Geliefert",
        isWarranty: "Garantie",
        transactionCount: "Transaktionen",
        totalSpend: "Gesamtumsatz"
      }
    },
    tabAuthorizationGrants: "Vollmacht",
    roleToggle: {
      customerLabel: "KUNDE",
      supplierLabel: "LIEFERANT",
      addCustomer: "+ KUNDE-Rolle hinzuf\xFCgen",
      addSupplier: "+ LIEFERANT-Rolle hinzuf\xFCgen",
      removeAria: "Rolle entfernen",
      confirmAddTitle: "Rolle hinzuf\xFCgen",
      confirmRemoveTitle: "Rolle entfernen",
      confirmAddText: "Rolle {role} diesem Partner hinzuf\xFCgen?",
      confirmRemoveText: "Rolle {role} von diesem Partner entfernen?",
      notYetWired: "Rollenumschaltung noch nicht verbunden \u2014 in K\xFCrze (STORY-1212 Folge)."
    },
    receiverData: "Daten des Empf\xE4ngers (Privatperson)",
    intent: {
      title: "Worum geht es beim Kunden?",
      hint: "Die Auswahl markiert, welche Daten ben\xF6tigt werden. Optional, und das Speichern wird nie blockiert.",
      purchase: "Kauf",
      rental: "Miete",
      service: "Service"
    },
    requiredMissing: {
      title: "F\xFCr diesen Vorgangstyp fehlende Daten",
      hint: "Das Speichern wird nicht blockiert \u2014 kann sp\xE4ter erg\xE4nzt werden."
    },
    field: {
      name: "Name",
      phone: "Telefonnummer",
      email: "E-Mail-Adresse",
      address: "Adresse / Firmensitz",
      idCard: "Personalausweis",
      addressCard: "Adresskarte",
      birthData: "Geburtsdaten",
      mothersName: "Name der Mutter",
      taxNumber: "Steuernummer",
      representative: "Vertreter / Empf\xE4nger"
    },
    receiverHint: "Die Daten der empfangenden Privatperson sind f\xFCr die Ger\xE4te\xFCbergabe erforderlich \u2014 nicht \xFCberspringen.",
    companyDataSecondary: "Firmendaten (Kostentr\xE4ger)",
    mothersNameRequired: "Der M\xE4dchenname der Mutter ist erforderlich (Empf\xE4nger)!",
    idCardRequired: "Die Ausweisnummer ist erforderlich (Empf\xE4nger)!",
    idCardExpiry: "Ablaufdatum des Ausweises",
    idCardCurrentMasked: "Aktuell (gespeichert): {masked} \u2014 leer lassen, wenn unver\xE4ndert",
    duplicate: {
      warning: "Ein \xE4hnlicher Kunde existiert m\xF6glicherweise bereits \u2014 bitte pr\xFCfen."
    },
    saveAndNew: "Speichern und neu",
    saveAndNewSuccess: "Partner gespeichert \u2014 das Formular ist f\xFCr eine neue Eingabe geleert.",
    saveHint: "Tipp: Strg+Enter zum schnellen Speichern",
    searchFilter: {
      typeAll: "Alle",
      typeIndividual: "Privatperson",
      typeCompany: "Firma",
      availableOnly: "Nur verf\xFCgbare",
      ariaLabel: "Partnerfilter",
      recentTitle: "Letzte Partner"
    },
    scan: {
      button: "\u{1F4F7} Ausweis scannen",
      buttonAriaLabel: "Dokument mit Kamera scannen",
      processing: "Verarbeitung...",
      success: "Scan erfolgreich \u2014 bitte die Daten pr\xFCfen",
      failure: "Scan fehlgeschlagen, bitte erneut versuchen",
      lowConfidence: "Geringe Zuverl\xE4ssigkeit \u2014 bitte die Daten manuell pr\xFCfen"
    },
    expired: {
      banner: "\u26A0\uFE0F Abgelaufenes Dokument \u2014 vor {days} Tagen",
      bannerNoDate: "\u26A0\uFE0F Das Dokument ist abgelaufen",
      overrideCheckbox: "Mit abgelaufenem Dokument fortfahren",
      overrideReasonLabel: "Begr\xFCndung der \xDCberschreibung (erforderlich)",
      overrideReasonPlaceholder: "z. B. Kunde hat das erneuerte Dokument am selben Tag erhalten",
      overrideReasonRequired: "Eine Begr\xFCndung ist erforderlich, um mit einem abgelaufenen Dokument fortzufahren"
    },
    representative: {
      title: "Bevollm\xE4chtigte",
      add: "Hinzuf\xFCgen",
      name: "Name",
      phone: "Telefon",
      email: "E-Mail",
      idNumber: "Ausweisnummer",
      validFrom: "G\xFCltig ab",
      validUntil: "G\xFCltig bis",
      unlimited: "unbegrenzt",
      permissions: "Berechtigungen",
      canRent: "Darf mieten",
      canReturn: "Darf zur\xFCckgeben",
      canSign: "Darf unterschreiben",
      canPayCash: "Darf bar zahlen",
      active: "Aktiv",
      inactive: "Inaktiv",
      expired: "Abgelaufen",
      expiringSoon: "L\xE4uft bald ab",
      activate: "Aktivieren",
      deactivate: "Deaktivieren",
      confirmDelete: "M\xF6chten Sie diesen Bevollm\xE4chtigten wirklich l\xF6schen?",
      noRepresentatives: "Keine Bevollm\xE4chtigten",
      notes: "Notiz"
    },
    selectSettlement: "Mehrere Orte teilen diese Postleitzahl \u2014 bitte w\xE4hlen:"
  },
  pos: {
    customerPanel: {
      title: "Kundeninfo",
      noCustomer: "Partner ausw\xE4hlen um Rabatte anzuzeigen",
      discounts: "Rabatte",
      discountRental: "Miete: {percent}%",
      discountSales: "Verkauf: {percent}%",
      discountService: "Service: {percent}%",
      balance: "Offener Betrag",
      balanceAmount: "{amount} Ft",
      creditLimit: "Kreditlimit: {amount} Ft",
      depositExempt: "Kautionsbefreiung",
      recentTransactions: "Letzte Transaktionen",
      noTransactions: "Kein Verlauf",
      viewDetails: "Partnerdetails"
    },
    suggestions: {
      winBack: "Seit {days} Tagen keine Miete \u2014 10% Rabattangebot",
      winBackApply: "Anwenden",
      inactiveNote: "Ehemaliger Kunde \u2014 6+ Monate inaktiv",
      crossSellTitle: "Empfohlene Produkte",
      crossSellItem: "{name} \u2014 {count} auf Lager",
      addToCart: "In den Warenkorb"
    }
  },
  loyalty: {
    title: "VIP-Treueprogramm",
    partnerId: "Partner-ID",
    pointBalance: "Punktestand",
    points: "{count} Punkte",
    trustedStatus: "Vertrauensstatus",
    consecutiveClean: "{count} aufeinanderfolgende saubere Vermietungen",
    deposit: "Kaution",
    creditPoints: "Punkte gutschreiben",
    amountFt: "Betrag (Ft)",
    rentalNumber: "Mietnummer",
    creditNote: "Notizen",
    creditButton: "Punkte gutschreiben",
    crediting: "Wird gutgeschrieben...",
    calculationNote: "Berechnung: floor(Betrag / 10.000). F\xFCr Vermietungen: erst ab der 11. Vermietung.",
    redeemableRewards: "Einl\xF6sbare Pr\xE4mien",
    redeem: "Einl\xF6sen",
    pointHistory: "Punktehistorie ({count} Eintr\xE4ge)",
    noPointRecords: "Keine Punkteeintr\xE4ge.",
    expiresAt: "L\xE4uft ab: {date}",
    sourceLabels: {
      rental: "Vermietung",
      purchase: "Kauf",
      bonus: "Bonus",
      redemption: "Einl\xF6sung",
      expiry: "Ablauf"
    },
    depositRequired: "Kaution erforderlich",
    depositFree: "Kautionsfrei",
    creditAmount: "Betrag (HUF)",
    rewardLabel: "Belohnung",
    trusted: "Vertrauensw\xFCrdig",
    notTrusted: "Nicht vertrauensw\xFCrdig",
    consecutiveCleanRentals: "{count} aufeinanderfolgende saubere Vermietungen",
    depositTitle: "Kaution",
    searchButton: "Suchen",
    loading: "Laden...",
    amountPlaceholder: "Betrag (HUF)",
    rentalCountPlaceholder: "Mietanzahl",
    notePlaceholder: "Bemerkung",
    calculationInfo: "Punktberechnung: floor(Betrag / 10.000). Bei Vermietungen: erst ab der 11. Vermietung.",
    redeemButton: "Einl\xF6sen",
    expiresLabel: "L\xE4uft ab",
    sourceLabelsObj: {
      RENTAL: "Vermietung",
      PURCHASE: "Kauf",
      BONUS: "Bonus",
      REDEMPTION: "Einl\xF6sung",
      EXPIRY: "Ablauf",
      SALES: "Verkauf",
      SERVICE: "Service"
    }
  },
  finance: {
    title: "Finanzen",
    journalTitle: "Hauptbuch (Journal)",
    journalSubtitle: "Buchungss\xE4tze (doppelte Buchf\xFChrung)",
    journalSourceFilter: "Quellenfilter",
    journalSourceAll: "Alle",
    journalSourceInvoice: "Rechnung",
    journalSourceSale: "Verkauf",
    journalSourceRentalDeposit: "Kaution",
    journalSourceRentalDepositRefund: "Kautionsr\xFCckzahlung",
    journalSourceRentalDepositForfeit: "Kautionseinbehalt",
    journalColEntryNumber: "Buchungsnummer",
    journalColDate: "Datum",
    journalColDescription: "Beschreibung",
    journalColSource: "Quelle",
    journalColDebit: "Soll",
    journalColCredit: "Haben",
    journalColAccount: "Sachkonto",
    journalUnbalanced: "Nicht ausgeglichen",
    journalEmpty: "Keine Buchungss\xE4tze im gew\xE4hlten Zeitraum",
    journalEntryCount: "{count} Buchungen",
    cashRegister: "Kasse",
    cash: {
      noTransactions: "Keine Transaktionen f\xFCr diesen Tag / Filter."
    },
    dailyClose: "Tagesabschluss",
    szhFolder: "SZH-Mappe",
    vouchers: "Gutscheine",
    fixedAssets: "Anlageverm\xF6gen",
    szh: {
      label: "SZH",
      activity: "Aktivit\xE4t",
      amountFt: "Betrag (Ft)",
      anonymous: "Anonym",
      cancel: "Storno",
      confirm: "Best\xE4tigen",
      confirmBody: "M\xF6chten Sie die SZH-Transaktion wirklich ausf\xFChren?",
      confirmTitle: "SZH-Transaktion best\xE4tigen",
      creditIssuance: "Kreditvergabe",
      expectedRevenue: "Erwarteter Umsatz",
      expectedSettlement: "Erwartete Abrechnung",
      generateReport: "Bericht erstellen",
      generating: "Wird erstellt...",
      internalNote: "Interne Notiz",
      internalNoteRequired: "Interne Notiz erforderlich",
      issue: "Ausgabe",
      items: "Positionen",
      loadError: "Laden fehlgeschlagen, bitte erneut versuchen.",
      lossReserve: "Verlustr\xFCcklage",
      noItems: "Keine Positionen",
      partnerName: "Partnername",
      repayment: "R\xFCckzahlung",
      reversal: "Stornierung"
    },
    receivables: "Forderungen",
    deposit: "Kaution",
    noRegisterOpen: "Heute ist noch keine Kasse ge\xF6ffnet.",
    openRegister: "Kasse \xF6ffnen",
    opening: "\xD6ffnen...",
    szhFolderButton: "SZH-Mappe",
    blindCloseButton: "Blindabschluss",
    totalBalance: "Gesamtsaldo",
    recordTransaction: "Transaktion erfassen",
    income: "Einnahme",
    expense: "Ausgabe",
    expenseSummaryTitle: "Ausgaben\xFCbersicht",
    expenseCategory: {
      label: "Ausgabenkategorie",
      none: "Keine Kategorie",
      salary: "Gehalt / Lohn",
      supplierPayment: "Lieferantenzahlung",
      office: "B\xFCro",
      transport: "Transport / Reise",
      marketing: "Marketing",
      other: "Sonstiges"
    },
    amountPlaceholder: "Betrag (HUF)",
    notePlaceholder: "Notiz",
    record: "Erfassen",
    recordError: {
      conflictTitle: "Die Kasse hat sich zwischenzeitlich ge\xE4ndert",
      conflictBody: "Jemand anderes hat an dieser Kasse eine Transaktion erfasst. Aktualisiere die Liste und pr\xFCfe, was passiert ist \u2014 deine Eingaben bleiben erhalten.",
      refresh: "Aktualisieren",
      amountInvalid: "Dieser Betrag kann so nicht erfasst werden. Bitte pr\xFCfen und erneut eingeben.",
      noteInvalid: "Bitte pr\xFCfe die Notiz und gib sie erneut ein.",
      validation: "Einer der Werte kann so nicht erfasst werden. Bitte pr\xFCfen und erneut versuchen.",
      failed: "Die Transaktion konnte gerade nicht erfasst werden. Deine Eingaben bleiben erhalten \u2014 bitte erneut versuchen."
    },
    transactions: "Transaktionen",
    loadingData: "Laden...",
    inLabel: "Ein:",
    outLabel: "Aus:",
    blindClose: "Blindabschluss",
    physicalCount: "Physischen Betrag eingeben",
    physicalCountDesc: "Z\xE4hlen Sie den Inhalt jeder Tasche und geben Sie dann die physischen Betr\xE4ge ein.",
    physicalAmountPlaceholder: "Physischer Betrag (HUF)",
    startBlindClose: "Blindabschluss starten",
    compare: "Vergleichen",
    result: "Ergebnis",
    match: "\xDCbereinstimmung",
    discrepancy: "Abweichung!",
    tolerance: "Toleranz: \xB12.000 HUF",
    recountRequired: "Nachz\xE4hlung erforderlich!",
    recountRequiredDesc: "Die Abweichung \xFCbersteigt die Toleranz. Bitte z\xE4hlen Sie die Taschen erneut.",
    recount: "Nachz\xE4hlen",
    finalizeClose: "Abschluss finalisieren",
    discrepancyReport: "Abweichungsbericht",
    blindCloseComplete: "Blindabschluss abgeschlossen",
    registerClosedSuccess: "Die Tageskasse wurde erfolgreich geschlossen.",
    backToRegister: "Zur\xFCck zur Kasse",
    noRegisterToClose: "Keine offene Kasse.",
    fixedAssetsTitle: "Anlageverm\xF6gen",
    runDepreciation: "Monatliche AfA ausf\xFChren",
    runningDepreciation: "AfA wird ausgef\xFChrt...",
    newAsset: "Neues Ger\xE4t",
    newAssetForm: "Neues Anlagegut erfassen",
    assetName: "Bezeichnung",
    purchasePricePlaceholder: "Anschaffungspreis (min 200.000 HUF)",
    commissionDate: "Inbetriebnahmedatum",
    inventoryNumber: "Inventarnummer",
    serialNumber: "Seriennummer",
    recordAsset: "Ger\xE4t erfassen",
    recording: "Erfassung...",
    depreciationComplete: "AfA-Lauf abgeschlossen: {processed} verarbeitet, {deprecated} vollst\xE4ndig abgeschrieben",
    assetsCount: "Ger\xE4te ({count})",
    noAssets: "Keine Ger\xE4te.",
    purchaseLabel: "Anschaffung:",
    allCategories: "Alle Kategorien",
    allStatuses: "Alle Status",
    categoryLabels: {
      machinery: "Maschine",
      itEquipment: "IT-Ger\xE4t",
      vehicle: "Fahrzeug"
    },
    assetStatusLabels: {
      active: "Aktiv",
      fullyDepreciated: "Vollst\xE4ndig abgeschrieben",
      scrapped: "Verschrottet",
      sold: "Verkauft"
    },
    errorOccurred: "Fehler: {message}",
    vatSummaryTitle: "MwSt.-Zusammenfassung",
    vatSummarySubtitle: "\xDCbersicht der ausgewiesenen und abzugsf\xE4higen MwSt.",
    csvExport: "CSV-Export",
    period: "Zeitraum",
    periodSelector: "Zeitraumauswahl",
    periodMonth: "Monat",
    periodQuarter: "Quartal",
    periodYear: "Jahr",
    staticData: "statische Daten",
    outputVat: "Ausgewiesene MwSt.",
    inputVat: "Vorsteuer",
    vatPayable: "Zu zahlende MwSt.",
    vatReclaimable: "Erstattungsf\xE4hig",
    salesNet: "Umsatz netto",
    vatBreakdownByRate: "MwSt.-Aufschl\xFCsselung nach Satz",
    rateColumn: "Satz",
    outputColumn: "Ausgewiesen",
    inputColumn: "Abzugsf\xE4hig",
    balanceColumn: "Saldo",
    payableColumn: "Zu zahlen",
    total: "Gesamt",
    monthlyTrend: "Monatlicher Trend",
    monthColumn: "Monat",
    currentLabel: "aktuell",
    vatDeadlineTitle: "MwSt.-Erkl\xE4rungsfrist",
    vatDeadlineDescription: "Die monatliche MwSt.-Erkl\xE4rung und Zahlungsfrist ist der 20. eines jeden Monats. Bei viertelj\xE4hrlicher Erkl\xE4rung der 20. des Folgemonats.",
    vatPayableLabel: "Zu zahlende MwSt.:",
    dueDateLabel: "F\xE4lligkeit:",
    vatExempt: "Befreit",
    receivablesAgingTitle: "Forderungen - Alterungsbericht",
    generatedAt: "Erstellt: {date}",
    refresh: "Aktualisieren",
    exportCsv: "CSV exportieren",
    totalReceivables: "Gesamtforderungen",
    overdueReceivables: "\xDCberf\xE4llige Forderungen",
    overdueRatio: "\xDCberf\xE4lligkeitsquote",
    agingBuckets: "Alterungsstufen (30/60/90+ Tage)",
    partnerCount: "{count} Partner, {invoices} Rechnungen",
    suspended: "Gesperrt",
    invoicesOldest: "{count} Rechnungen \u2022 \xC4lteste: {date}",
    sendReminderTitle: "{level} senden",
    sendReminderDefault: "Erinnerung senden",
    suspendPartnerTitle: "Partner sperren",
    unsuspendPartnerTitle: "Sperrung aufheben",
    morePartners: "+ {count} weitere Partner",
    noReceivablesInBucket: "Keine Forderungen in dieser Stufe.",
    loadingError: "Fehler beim Laden der Daten.",
    partnerSuspended: "Partner gesperrt ({id})",
    partnerUnsuspended: "Partnersperre aufgehoben ({id})",
    actionError: "Bei der Aktion ist ein Fehler aufgetreten",
    reminderSent: "Erinnerung gesendet{level}: {name}",
    confirmSuspend: "M\xF6chten Sie den Partner wirklich sperren: {name}?",
    confirmUnsuspend: "M\xF6chten Sie die Partnersperre wirklich aufheben?",
    csvHeaderAgingBucket: "Alterungsstufe",
    csvHeaderPartnerName: "Partnername",
    csvHeaderPartnerId: "Partner-ID",
    csvHeaderAmountHuf: "Betrag (HUF)",
    csvHeaderInvoiceCount: "Rechnungsanzahl",
    csvHeaderOldestInvoice: "\xC4lteste Rechnung",
    fixedAssetTitle: "Anlagegut",
    loading: "Laden...",
    assetNotFound: "Ger\xE4t nicht gefunden",
    back: "Zur\xFCck",
    basicData: "Grunddaten",
    category: "Kategorie",
    status: "Status",
    inventoryNumberLabel: "Inventarnummer",
    serialNumberLabel: "Seriennummer",
    commissionDateLabel: "Inbetriebnahme",
    depreciationRateLabel: "Abschreibungssatz",
    valueData: "Wertdaten",
    purchasePrice: "Anschaffungspreis",
    currentValue: "Aktueller Wert",
    depreciationPercent: "Wertminderung",
    noteLabel: "Anmerkung: ",
    tamDeclarationsTitle: "TAM-Erkl\xE4rungen",
    newTamDeclaration: "Neue TAM-Erkl\xE4rung",
    tamDescription: "TAM-Artikel (0% MwSt.) Rechnung erfordert eine obligatorische Erkl\xE4rung.",
    invoiceIdPlaceholder: "Rechnungs-ID",
    methodApp: "Anwendung",
    methodEmail: "E-Mail",
    methodPaper: "Papier",
    recordingDeclaration: "Erfassung...",
    recordDeclaration: "Erkl\xE4rung erfassen",
    retry: "Erneut versuchen",
    errorPrefix: "Fehler: {message}",
    unknownError: "Unbekannter Fehler",
    noTamDeclarations: "Noch keine TAM-Erkl\xE4rungen.",
    recordedDeclarations: "Erfasste Erkl\xE4rungen ({count})",
    invoiceLabel: "Rechnung: {id}",
    methodLabel: "Methode: {method}",
    expenseVouchersTitle: "Ausgabenbelege",
    expenseVoucherManagement: "Ausgabenbelegverwaltung",
    expenseVoucherDescription: "Ausgabenbeleg- und Abrechnungsfunktionen werden im n\xE4chsten Sprint implementiert (Story 62-8, 62-9 \u2014 ExpenseVoucher + AccountableExpense Prisma-Modelle erforderlich).",
    issueExpenseVoucher: "Ausgabenbeleg ausstellen",
    issueExpenseVoucherDesc: "Mitarbeitername, Betrag, Zweck \u2192 druckbar",
    accountableExpense: "Abrechenbare Ausgabe",
    accountableExpenseDesc: "Betrag, Mitarbeiter, Zweck, 3 Werktage Frist",
    comingSoon: "Demn\xE4chst",
    ev: {
      issueNew: "Neuer Beleg",
      issueTitle: "Ausgabenbeleg ausstellen",
      recipientName: "Empf\xE4ngername",
      recipientNamePlaceholder: "z.B. Max Mustermann",
      amount: "Betrag",
      purpose: "Zweck",
      purposePlaceholder: "z.B. B\xFCromaterial",
      issue: "Ausstellen",
      settleTitle: "Abrechnung",
      settledAmount: "Abgerechneter Betrag",
      returnedAmount: "R\xFCckgabebetrag",
      receiptAttached: "Quittung beigef\xFCgt",
      settle: "Abrechnen",
      cancel: "Stornieren",
      filterStatus: "Nach Status filtern",
      voucherNumber: "Belegnummer",
      recipient: "Empf\xE4nger",
      deadline: "Frist",
      noVouchers: "Keine Belege.",
      statusIssued: "Ausgestellt",
      statusOverdue: "\xDCberf\xE4llig",
      statusSettled: "Abgerechnet",
      statusCancelled: "Storniert",
      receiptOk: "Quittung OK"
    },
    csvHeaderVatRate: "MwSt.-Satz",
    csvHeaderSalesNet: "Umsatz netto (HUF)",
    csvHeaderOutputVat: "Ausgewiesene MwSt. (HUF)",
    csvHeaderPurchasesNet: "Einkauf netto (HUF)",
    csvHeaderInputVat: "Vorsteuer (HUF)",
    csvHeaderDifference: "Differenz (HUF)",
    autoAccepted: "Automatisch akzeptiert",
    dailyCloseButton: "Tagesabschluss starten",
    dailyCloseComplete: "Tagesabschluss abgeschlossen",
    expectedBalance: "Erwarteter Saldo",
    overToleranceWarning: "Abweichung au\xDFerhalb der Toleranz!",
    startDailyClose: "Tagesabschluss beginnen",
    szhLabel: "SZH-Beleg",
    toleranceInfo: "Toleranz: \xB12.000 Ft",
    monthlyClose: {
      title: "Monatsabschluss",
      subtitle: "Buchungsperiode schrittweise abschliessen",
      selectPeriod: "Periode auswahlen",
      selectPeriodDesc: "Jahr und Monat zum Abschliessen auswahlen",
      selected: "Ausgewahlt",
      periodHistory: "Periodenhistorie",
      noHistory: "Keine Periodenhistorie verfugbar.",
      periodColumn: "Periode",
      statusColumn: "Status",
      closedAtColumn: "Abgeschlossen am",
      closedByColumn: "Abgeschlossen von",
      statusOpen: "Offen",
      statusClosed: "Abgeschlossen",
      summaryTitle: "Zusammenfassung \u2014 {period}",
      revenue: "Einnahmen",
      expenses: "Ausgaben",
      vatTotal: "MwSt. gesamt",
      invoiceCount: "Rechnungsanzahl",
      transactionCount: "Transaktionsanzahl",
      closedInfo: "Abgeschlossen: {date}, von: {user}",
      noteLabel: "Anmerkung",
      reopenButton: "Wiederer\xF6ffnen",
      openItemsTitle: "Offene Posten",
      openItemsDesc: "Offene Posten in dieser Periode pr\xFCfen",
      openDeliveryNotes: "Offene Lieferscheine",
      unpaidInvoices: "Unbezahlte Rechnungen",
      pendingSzh: "Ausstehende SZH-Belege",
      openItemsWarning: "Achtung: Es gibt offene Posten in dieser Periode. Bitte vor dem Abschluss kl\xE4ren.",
      vatBreakdownTitle: "MwSt.-Zusammenfassung",
      vatBreakdownDesc: "MwSt.-Aufschl\xFCsselung nach Steuersatz f\xFCr die Periode",
      vatRateColumn: "MwSt.-Satz",
      netColumn: "Netto",
      vatColumn: "MwSt.",
      grossColumn: "Brutto",
      invoiceCountShort: "Rechnungen",
      noVatData: "Keine MwSt.-Daten f\xFCr diese Periode.",
      csvVatRate: "MwSt.-Satz",
      csvNet: "Netto (HUF)",
      csvVat: "MwSt. (HUF)",
      csvGross: "Brutto (HUF)",
      csvInvoiceCount: "Rechnungsanzahl",
      confirmTitle: "Monatsabschluss best\xE4tigen",
      confirmCheckbox: "Ich best\xE4tige den Monatsabschluss f\xFCr {period}. Die Periode wird danach schreibgesch\xFCtzt.",
      closeNoteLabel: "Anmerkung (optional)",
      closeNotePlaceholder: "Anmerkung zum Abschluss...",
      noPermission: "Sie haben keine Berechtigung zum Abschluss dieser Periode. Nur ADMIN und h\xF6her k\xF6nnen abschliessen.",
      closeButton: "Periode abschliessen",
      closeSuccess: "Monatsabschluss erfolgreich!",
      closeSuccessDesc: "Die Periode {period} wurde erfolgreich abgeschlossen. Sie ist jetzt schreibgesch\xFCtzt.",
      periodAlreadyClosed: "Periode bereits abgeschlossen",
      reopenTitle: "Periode wiederer\xF6ffnen",
      reopenDesc: "Periode {period} wiederer\xF6ffnen. Diese Aktion erfordert SUPER_ADMIN-Rechte.",
      reopenReasonPlaceholder: "Grund f\xFCr die Wiederer\xF6ffnung...",
      reopenConfirm: "Wiederer\xF6ffnung best\xE4tigen",
      loadError: "Fehler beim Laden der Daten.",
      vatFiled: "MwSt. gemeldet",
      vatNotFiled: "MwSt. nicht gemeldet",
      vatFiledAt: "MwSt. gemeldet: {date}",
      vatFiledBy: "Gemeldet von: {user}",
      markVatFiled: "MwSt.-Meldung erfassen",
      vatFilingNote: "Anmerkung (optional)",
      vatFilingNotePlaceholder: "MwSt.-Meldung Anmerkung...",
      vatFiledSuccess: "MwSt.-Meldung erfolgreich erfasst.",
      months: {
        januar: "Januar",
        februar: "Februar",
        marcius: "M\xE4rz",
        aprilis: "April",
        majus: "Mai",
        junius: "Juni",
        julius: "Juli",
        augusztus: "August",
        szeptember: "September",
        oktober: "Oktober",
        november: "November",
        december: "Dezember"
      },
      steps: {
        periodSelect: "Periode ausw\xE4hlen",
        summaryOverview: "Zusammenfassung",
        openItems: "Offene Posten",
        vatSummary: "MwSt.-Zusammenfassung",
        confirmation: "Best\xE4tigung"
      }
    }
  },
  task: {
    title: "Aufgaben",
    loading: "Aufgaben werden geladen...",
    searchPlaceholder: "Suchen...",
    allTypes: "Alle Typen",
    allPriorities: "Alle Priorit\xE4ten",
    titlePlaceholder: "Aufgabentitel...",
    descriptionPlaceholder: "Aufgabenbeschreibung...",
    statusLabels: {
      open: "Offen",
      inProgress: "In Bearbeitung",
      completed: "Abgeschlossen",
      interrupted: "Unterbrochen"
    },
    priorityLabels: {
      low: "Niedrig",
      medium: "Mittel",
      high: "Hoch"
    },
    kanbanTitle: "Kanban-Board und Aufgabenverwaltung",
    newTask: "Neue Aufgabe",
    taskCount: "Aufgaben",
    highPriority: "hohe Priorit\xE4t",
    noTasks: "Keine Aufgaben",
    assignee: "Verantwortlicher",
    daysOverdue: "{count} Tage \xFCberf\xE4llig",
    today: "Heute",
    tomorrow: "Morgen",
    deadline: "Frist",
    taskDescription: "Beschreibung",
    daysOverdueLabel: "Tage \xFCberf\xE4llig",
    quantityLabel: "Menge",
    unitDefault: "Stk",
    statusChange: "Status \xE4ndern",
    closeButton: "Schlie\xDFen",
    titleLabel: "Titel",
    descriptionLabel: "Beschreibung",
    priorityLabel: "Priorit\xE4t",
    priorityMedium: "Mittel",
    quantityFieldLabel: "Menge",
    unitLabel: "Einheit",
    createButton: "Erstellen",
    assignTo: "Verantwortlichen zuweisen",
    assignedUsers: "Verantwortliche",
    searchUsers: "Mitarbeiter suchen...",
    removeAssignee: "Entfernen",
    status: {
      open: "Offen",
      inProgress: "In Bearbeitung",
      completed: "Abgeschlossen",
      cancelled: "Abgebrochen"
    },
    type: {
      shopping: "Einkauf",
      todo: "Aufgabe",
      note: "Notiz",
      message: "Nachricht"
    },
    priority: {
      low: "Niedrig",
      medium: "Mittel",
      high: "Hoch"
    }
  },
  admin: {
    title: "Admin-Center",
    quickActions: "Schnellaktionen",
    dailyOpen: "Tages\xF6ffnung",
    dailyOpenDesc: "Laden\xF6ffnungsprozess starten",
    dailyClose: "Tagesabschluss",
    dailyCloseDesc: "Ladenschliessprozess starten",
    sendReminders: "Erinnerungen senden",
    sendRemindersDesc: "Abgelaufene Miet-Erinnerungen",
    knowledgeBase: "Wissensdatenbank",
    knowledgeBaseDesc: "Hilfe und Anleitungen",
    subtitle: "Tages\xFCbersicht, Schnellaktionen und Betrieb",
    expiredRentals: "Abgelaufene Vermietungen",
    oldestDays: "\xC4lteste: {days} Tage",
    noExpiredRentals: "Keine abgelaufenen Vermietungen",
    receivables: "Forderungen",
    overdue30Partners: "30+ Tage: {count} Partner",
    noReceivables: "Keine Forderungen",
    serviceWorksheets: "Service-Arbeitsbl\xE4tter",
    worksheetStats: "Wartend: {waiting} | In Bearbeitung: {inProgress} | Fertig: {completed}",
    todayBookings: "Heutige Buchungen",
    todayPlanned: "F\xFCr heute geplant",
    tasks: "Aufgaben",
    expiredTasks: "Abgelaufen: {count} Aufgaben",
    noExpiredTasks: "Keine abgelaufenen Aufgaben",
    dailyOpenWizard: "Tages\xF6ffnung",
    dailyCloseWizard: "Tagesabschluss",
    stepCashBalance: "Kassen-Er\xF6ffnungsbilanz",
    stepExpiredRentals: "Abgelaufene Vermietungen",
    stepTodayBookings: "Heutige Buchungen",
    stepServiceWaiting: "Service wartend",
    stepReceivables: "Forderungen",
    stepTasks: "Aufgaben",
    stepSummary: "Zusammenfassung",
    stepCashBalanceClose: "Kassenbestand",
    stepOpenRentals: "Offene Vermietungen",
    stepServiceStatuses: "Service-Status",
    stepDailyTurnover: "Tagesumsatz",
    stepTaskClose: "Aufgabenabschluss",
    enterOpeningBalance: "Geben Sie den Kassen-Er\xF6ffnungsbetrag ein (Kasse + Tresor).",
    openingBalanceHuf: "Er\xF6ffnungsbilanz (HUF)",
    storeOpened: "Gesch\xE4ft ge\xF6ffnet",
    openingTime: "\xD6ffnungszeit",
    expectedBalanceHuf: "Erwarteter Betrag (HUF)",
    actualBalanceHuf: "Tats\xE4chlicher Betrag (HUF)",
    difference: "Differenz",
    storeClosed: "Gesch\xE4ft geschlossen",
    closingTime: "Schlie\xDFzeit",
    openStore: "Gesch\xE4ft \xF6ffnen",
    closeStore: "Gesch\xE4ft schlie\xDFen",
    cashBalanceDesc: "Geben Sie den erwarteten und tats\xE4chlichen Kassenbestand ein.",
    cashMismatch: "Der Kassenbestand stimmt nicht mit dem erwarteten Wert \xFCberein!",
    openRentalsReview: "\xDCbersicht offene Vermietungen",
    expiredRentalsLabel: "Abgelaufene Vermietungen",
    pcs: "Stk",
    oldestRental: "\xC4lteste Vermietung",
    expiredDaysAgo: "Vor {days} Tagen abgelaufen",
    serviceCloseStatus: "Abschlussstatus der Servicebl\xE4tter",
    waitingLabel: "Wartend",
    inProgressLabel: "In Bearbeitung",
    todayCompleted: "Heute abgeschlossen",
    dailyTurnoverSummary: "Tagesumsatz\xFCbersicht",
    todayBookingsLabel: "Heutige Buchungen",
    receivablesLabel: "Forderungen",
    taskReviewClose: "Aufgaben\xFCberpr\xFCfung und Abschluss",
    assignedTasks: "Zugewiesene Aufgaben",
    expiredTasksLabel: "\xDCberf\xE4llige Aufgaben",
    noteOptional: "Bemerkung (optional)",
    notePlaceholder: "Bemerkung zum heutigen Tag...",
    verifyAndCloseStore: "\xDCberpr\xFCfen Sie die Daten und schlie\xDFen Sie das Gesch\xE4ft.",
    cashBalance: "Kassenbestand",
    expectedActual: "Erwartet: {expected} | Tats\xE4chlich: {actual}",
    deviation: "Abweichung: {amount}",
    openRentalsLabel: "Offene Vermietungen",
    serviceWorksheetsOpen: "Servicebl\xE4tter (offen)",
    tasksExpiredAssigned: "Aufgaben (\xFCberf\xE4llig / zugewiesen)",
    noteLabel: "Bemerkung:",
    back: "Zur\xFCck",
    permissionMatrix: {
      adminAlwaysActive: "Admin (immer aktiv)",
      loading: "Laden...",
      noWidgets: "Keine Widgets im System."
    },
    kb: {
      tagPlaceholder: "Neues Tag (Enter zum Hinzuf\xFCgen)"
    },
    warehouseLoading: "Lager wird geladen \u2014 bitte warten.",
    warehouseMissing: "F\xFCr dieses Unternehmen ist kein Standardlager konfiguriert, daher kann die Kasse nicht ge\xF6ffnet/geschlossen werden. Bitte den Administrator kontaktieren.",
    warehouseFetchFailed: "Das Lager konnte nicht geladen werden (Netzwerkfehler). Bitte erneut versuchen.",
    warehouseUnresolved: "Das Lager kann nicht ermittelt werden, daher ist der Kassenvorgang nicht m\xF6glich."
  },
  settings: {
    title: "Einstellungen",
    fullName: "Vollst\xE4ndiger Name",
    emailAddress: "E-Mail-Adresse",
    phoneNumber: "Telefonnummer",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmNewPassword: "Neues Passwort best\xE4tigen",
    profileTab: "Profil",
    appearanceTab: "Darstellung",
    notificationsTab: "Benachrichtigungen",
    systemTab: "System",
    personalData: "Pers\xF6nliche Daten",
    uploadImage: "Bild hochladen",
    role: "Rolle",
    changePassword: "Passwort \xE4ndern",
    theme: "Design",
    themeSystem: "System",
    themeLight: "Hell",
    themeDark: "Dunkel",
    language: "Sprache",
    langHu: "Magyar",
    langEn: "English",
    langDe: "Deutsch",
    fontSize: "Schriftgr\xF6\xDFe",
    fontSmall: "Klein",
    fontMedium: "Mittel",
    fontLarge: "Gro\xDF",
    compactMode: "Kompaktmodus",
    compactModeDesc: "Kleinere Abst\xE4nde und R\xE4nder",
    notifEmail: "E-Mail-Benachrichtigungen",
    notifEmailDesc: "Benachrichtigungen per E-Mail",
    notifPush: "Push-Benachrichtigungen",
    notifPushDesc: "Browser-Benachrichtigungen",
    notifSound: "Tonsignal",
    notifSoundDesc: "Benachrichtigungston",
    notifRentalExpiry: "Mietablauf",
    notifRentalExpiryDesc: "Warnung bei Mietablauf",
    notifServiceReady: "Service fertig",
    notifServiceReadyDesc: "Benachrichtigung wenn die Servicearbeit abgeschlossen ist",
    notifNewBooking: "Neue Buchung",
    notifNewBookingDesc: "Online-Buchungsbenachrichtigung",
    notifPaymentReceived: "Zahlung eingegangen",
    notifPaymentReceivedDesc: "Benachrichtigung bei Zahlungseingang",
    notifLowStock: "Niedriger Bestand",
    notifLowStockDesc: "Bestandswarnung",
    notifTaskAssigned: "Aufgabe zugewiesen",
    notifTaskAssignedDesc: "Benachrichtigung bei neuer Aufgabenzuweisung",
    notificationPrefs: {
      title: "Benachrichtigungseinstellungen",
      subtitle: "Legen Sie fest, \xFCber welche Kan\xE4le (E-Mail / SMS / In-App) jede Benachrichtigungsart zugestellt wird, und definieren Sie ein t\xE4gliches Ruhefenster.",
      loading: "Einstellungen werden geladen\u2026",
      loadError: "Einstellungen konnten nicht geladen werden. Bitte erneut versuchen.",
      channelsTitle: "Kan\xE4le je Benachrichtigungsart",
      channels: {
        email: "E-Mail",
        sms: "SMS",
        "in-app": "In-App"
      },
      domains: {
        vehicle: "Fahrzeug",
        rental: "Vermietung",
        service: "Service",
        sales: "Verkauf",
        finance: "Finanzen",
        workflow: "Workflow",
        documents: "Dokumente",
        partner: "Partner"
      },
      priorityCritical: "Kritisch",
      quietHoursTitle: "Ruhezeiten",
      quietHoursHint: "W\xE4hrend der Ruhezeiten werden nur kritische Benachrichtigungen zugestellt \u2014 der Rest wird auf den n\xE4chsten Tag verschoben.",
      quietHoursStart: "Beginn",
      quietHoursEnd: "Ende",
      timezone: "Zeitzone",
      timezonePlaceholder: "Zeitzone w\xE4hlen\u2026",
      saveAll: "Alle speichern",
      saving: "Speichern\u2026",
      unsavedChanges: "{count} nicht gespeicherte \xC4nderungen",
      allSaved: "Alle \xC4nderungen gespeichert",
      adminResetTitle: "Admin: Einstellungen zur\xFCcksetzen",
      adminResetHint: "Franchise-Admin \u2014 setzt die Benachrichtigungseinstellungen eines Nutzers auf die Katalogstandards zur\xFCck. Der Nutzer erh\xE4lt anschlie\xDFend wieder alle Standardbenachrichtigungen.",
      adminResetPlaceholder: "Nutzer-UUID",
      adminResetAction: "Zur\xFCcksetzen",
      adminResetting: "Wird zur\xFCckgesetzt\u2026",
      adminResetSuccess: "{count} Zeilen auf Standard zur\xFCckgesetzt.",
      adminResetError: "Zur\xFCcksetzen fehlgeschlagen. UUID und Berechtigungen pr\xFCfen."
    },
    systemSettings: "Systemeinstellungen",
    autoLogout: "Automatische Abmeldung",
    autoLogoutDesc: "Abmeldung nach Inaktivit\xE4t",
    minutes: "Minuten",
    dataExport: "Datenexport",
    dataExportDesc: "Pers\xF6nliche Daten gem\xE4\xDF DSGVO herunterladen",
    exportButton: "Daten exportieren",
    dangerZone: "Gefahrenzone",
    deleteAccount: "Konto l\xF6schen",
    deleteAccountDesc: "Konto und alle zugeh\xF6rigen Daten dauerhaft l\xF6schen",
    deleteButton: "Konto endg\xFCltig l\xF6schen",
    subtitleText: "System- und Benutzereinstellungen",
    roleLabel: "Rolle",
    changePasswordButton: "Passwort \xE4ndern",
    themeLabel: "Design",
    emailNotifications: "E-Mail-Benachrichtigungen",
    pushNotifications: "Push-Benachrichtigungen",
    summaryEmails: "Zusammenfassungs-E-Mails",
    rentalExpiryDesc: "Benachrichtigung 1 Tag vor Mietablauf",
    dailySummaryDesc: "Jeden Tag um 8:00 Uhr",
    weeklySummaryDesc: "Jeden Montag um 8:00 Uhr",
    languageLabel: "Sprache",
    dateFormatLabel: "Datumsformat",
    currencyLabel: "W\xE4hrung",
    timezoneLabel: "Zeitzone",
    securityTitle: "Sicherheit",
    rentalDefaultsTitle: "Mietstandards",
    defaultRentalDays: "Standard-Mietdauer (Tage)",
    defaultDeposit: "Standardkaution (%)",
    exportDesc: "Alle Daten im CSV-Format herunterladen",
    clearCache: "Cache leeren",
    clearCacheDesc: "Lokalen Cache und Einstellungen l\xF6schen",
    clearButton: "L\xF6schen",
    profileSaved: "Profil gespeichert!",
    notificationsSaved: "Benachrichtigungseinstellungen gespeichert!",
    systemSaved: "Systemeinstellungen gespeichert!",
    currencyHUF: "HUF - Ungarischer Forint",
    currencyEUR: "EUR - Euro",
    autoLogout15: "15 Minuten",
    autoLogout30: "30 Minuten",
    autoLogout60: "1 Stunde",
    autoLogout120: "2 Stunden",
    autoLogoutNever: "Nie",
    ocr: {
      zebraLabel: "Zebra ZD220 Etikett (43x26mm)"
    },
    avatarHelp: "JPG oder PNG, max 2MB",
    sms: {
      sendTab: "SMS senden",
      historyTab: "Verlauf",
      templatesTab: "Vorlagen"
    }
  },
  dashboard: {
    title: "Dashboard",
    monthlyRevenue: "Monatlicher Umsatz",
    activeRentals: "Aktive Vermietungen",
    openWorksheets: "Offene Arbeitsbl\xE4tter",
    dailyTransactions: "T\xE4gliche Transaktionen",
    revenueChart: "Umsatzdiagramm",
    topPartners: "Top-Partner",
    equipmentProfit: "Ger\xE4tegewinn",
    rentalStats: "Vermietungsstatistik",
    serviceProfit: "Servicegewinn",
    seasonality: "Saisonalit\xE4t",
    stockAlerts: "Bestandswarnungen",
    technicianWorkload: "Technikerbelegung",
    partnerActivity: "Partneraktivit\xE4t",
    warrantyRatio: "Garantiequote",
    revenueForecast: "Umsatzprognose",
    vatSummary: "MwSt.-Zusammenfassung",
    recurringIssues: "Wiederkehrende Probleme",
    popularEquipment: "Beliebte Ger\xE4te",
    section: {
      alreadyAtBottom: "Bereits an unterster Position",
      alreadyAtTop: "Bereits an oberster Position",
      collapse: "Einklappen",
      collapseSection: "Bereich einklappen",
      comingSoon: "Demn\xE4chst...",
      expand: "Aufklappen",
      expandSection: "Bereich aufklappen",
      moveDown: "Nach unten",
      moveSectionDown: "Bereich nach unten verschieben",
      moveSectionUp: "Bereich nach oben verschieben",
      moveUp: "Nach oben",
      settings: "Einstellungen",
      summary: "Zusammenfassung",
      finance: "Finanzen",
      inventory: "Bestand",
      service: "Service",
      partner: "Partner",
      analytics: "Vermietung",
      rental: "Vermietung",
      kassza: "Kasse"
    },
    collapse: "Zuklappen",
    expand: "Vergr\xF6\xDFern",
    showMore: "Mehr anzeigen",
    showLess: "Weniger anzeigen",
    welcome: "Willkommen, {name}!",
    todaySummary: "Hier ist die Zusammenfassung des heutigen Tages.",
    defaultUser: "Benutzer",
    executiveSummaryAriaLabel: "Zusammenfassung - Schl\xFCsselkennzahlen",
    executiveSummaryTitle: "Zusammenfassung",
    expandWidget: "Widget vergr\xF6\xDFern",
    minimize: "Minimieren",
    minimizeWidget: "Auf kleine Gr\xF6\xDFe zur\xFCcksetzen",
    pinIndicatorAriaLabel: "Fixierter Bereich",
    pinIndicatorTitle: "Immer sichtbar - nicht zusammenklappbar",
    collapseAll: "Alle einklappen",
    contactAdminForPermissions: "Bitten Sie den Administrator, Berechtigungen einzurichten.",
    executive: {
      activeWorksheets: "Aktive Arbeitsbl\xE4tter",
      businessHealth: "Gesch\xE4ftslage",
      dailyRevenue: "Tagesumsatz",
      healthGood: "Gut",
      inventory: "Bestand",
      openedToday: "Heute er\xF6ffnet",
      receivables: "Forderungen",
      utilization: "Auslastung",
      revenueTarget: "Ziel: {amount}",
      receivablesTarget: "Ziel: {amount}"
    },
    expandAll: "Alle aufklappen",
    hideExecutiveSummary: "Executive Summary ausblenden",
    loading: "Laden...",
    noSections: "Keine anzeigbaren Bereiche.",
    noWidgetsInSection: "Kein anzeigbares Widget in diesem Bereich.",
    notAuthenticated: "Nicht angemeldet",
    sectionCount: "{count} Bereich(e)",
    showExecutiveSummary: "Executive Summary anzeigen",
    franchiseRevenue: {
      title: "Franchise-Umsatzverteilung",
      total: "Ges."
    },
    dragToReorder: "Widget-Reihenfolge \xE4ndern",
    resetLayout: "Layout zur\xFCcksetzen",
    widgets: {
      reset: "Widget-Einstellungen zur\xFCcksetzen",
      sync_error: "Widget-Einstellungen konnten nicht gespeichert werden \u2014 bitte erneut versuchen",
      sync_success: "Widget-Einstellungen gespeichert",
      migration_done: "Vorheriges Layout geladen",
      migration_error: "\xDCbertragung des vorherigen Layouts fehlgeschlagen",
      loading: "Einstellungen werden geladen...",
      saved: "Gespeichert"
    },
    kassza: {
      bankAccount: "Bankkonto",
      dailyNet: "Tages-Netto",
      dailyStatusTitle: "Tagesstatus",
      expense: "Ausgabe",
      hoursAgo: "vor {hours} Stunden",
      income: "Einnahme",
      lastTransactions: "Letzte Transaktionen",
      mainRegister: "Hauptkasse",
      minutesAgo: "vor {minutes} Minuten",
      openedAt: "Ge\xF6ffnet um",
      statusClosed: "Geschlossen",
      statusOpen: "Offen",
      szhPocket: "SZH Tasche",
      szhReportTitle: "SZH Bericht",
      szhTotal: "SZH Gesamt",
      threePocketTitle: "Drei-Taschen-System",
      toleranceCritical: "Kritisch",
      toleranceOk: "OK",
      toleranceTitle: "Toleranz",
      toleranceWarning: "Warnung",
      total: "Gesamt",
      transfer: "\xDCbertrag",
      statusNotOpened: "Nicht ge\xF6ffnet",
      noData: "Keine Daten"
    },
    kpi: {
      grossRevenue: "Bruttoumsatz",
      grossRevenueAria: "Bruttoumsatz KPI Widget",
      netRevenue: "Nettoumsatz",
      netRevenueAria: "Nettoumsatz KPI Widget",
      receivables: "Forderungen",
      receivablesAria: "Forderungen KPI Widget",
      high: "Hoch",
      payments: "Zahlungen",
      paymentsAria: "Zahlungen KPI Widget"
    },
    detailedView: "Detailansicht"
  },
  network: {
    online: "Online",
    offline: "Offline",
    offlineMode: "Offline-Modus",
    syncing: "Synchronisierung...",
    lastSync: "Letzte Synchronisierung",
    pendingSync: "Synchronisierung ausstehend",
    syncComplete: "Synchronisierung abgeschlossen",
    syncFailed: "Synchronisierung fehlgeschlagen",
    minuteAgo: "vor einer Minute",
    minutesAgo: "vor Minuten",
    hourAgo: "vor einer Stunde",
    hoursAgo: "vor Stunden"
  },
  table: {
    partner: "Partner",
    period: "Zeitraum",
    amount: "Betrag",
    status: "Status",
    actions: "Aktionen",
    date: "Datum",
    type: "Typ",
    description: "Beschreibung",
    quantity: "Menge",
    unitPrice: "Einzelpreis",
    vat: "MwSt.",
    netAmount: "Netto",
    grossAmount: "Brutto",
    addItem: "Position hinzuf\xFCgen"
  },
  payment: {
    cash: "Bargeld",
    card: "Karte",
    transfer: "\xDCberweisung",
    method: "Zahlungsmethode"
  },
  page: {
    allStatuses: "Alle Status",
    allTypes: "Alle Typen",
    allCategories: "Alle Kategorien",
    noResults: "Keine Ergebnisse f\xFCr die Suchkriterien.",
    noFilterResults: "Keine Ergebnisse f\xFCr die Filterkriterien.",
    errorPrefix: "Fehler: {message}",
    displayed: "{count} angezeigt",
    partnersDisplayed: "{count} Partner angezeigt",
    ordersCount: "{count} Bestellungen",
    itemsCount: "{count} Positionen",
    daysLate: "{count} Tage Versp\xE4tung",
    machinesCount: "{count} Ger\xE4te",
    abandoned: {
      tabTitle: "Verlassene Ger\xE4te",
      noItems: "Keine verlassenen Ger\xE4te",
      noItemsDesc: "Alle gemieteten Ger\xE4te sind innerhalb der R\xFCckgabefrist.",
      totalCount: "{count} verlassene Ger\xE4te",
      partner: "Partner",
      rental: "Miete",
      daysOverdue: "Tage \xFCberf\xE4llig",
      perDay: "Tag",
      storageFee: "Gesch\xE4tzte Lagergeb\xFChr"
    },
    compensation: {
      tabTitle: "Kompensation",
      title: "Kompensationszahlung erfassen",
      description: "Wenn der Kunde besch\xE4digte oder verlorene Ger\xE4te nicht zur\xFCckbringen kann, erfassen Sie die Kompensationszahlung.",
      rentalId: "Miet-ID",
      rentalIdPlaceholder: "z.B. R-20260401-001",
      amount: "Betrag (HUF)",
      reason: "Begr\xFCndung",
      reasonPlaceholder: "z.B. Kunde kann das Ger\xE4t nicht zur\xFCckbringen, am Arbeitsplatz verloren...",
      action: "Aktion",
      writtenOff: "Abschreibung (WRITTEN_OFF)",
      transferredToInventory: "\xDCbernahme ins Inventar (TRANSFERRED_TO_INVENTORY)",
      submit: "Kompensation erfassen",
      validationError: "Bitte f\xFCllen Sie alle Felder korrekt aus."
    },
    afterlife: {
      tabTitle: "Lebenszyklus-Entscheidungen",
      pageTitle: "Ger\xE4te-Lebenszyklusverwaltung",
      pageSubtitle: "Verlassene Ger\xE4te, Kompensation, Lebenszyklus-Entscheidungen, Gruppenerfassung",
      noItems: "Keine Elemente",
      scrapTitle: "Verschrottung",
      repairTitle: "Aufarbeitung",
      decisionTitle: "Entscheidung erforderlich",
      repairs: "Reparaturen",
      age: "Alter",
      months: "Monate",
      condition: "Zustand"
    },
    surrender: {
      tabTitle: "Freiwillige R\xFCckgabe",
      title: "Freiwillige R\xFCckgabe erfassen",
      description: "Wenn der Kunde freiwillig auf gemietete Ger\xE4te verzichtet (kann nicht zahlen, braucht es nicht), erfassen Sie die Erkl\xE4rung.",
      rentalId: "Miet-ID",
      rentalIdPlaceholder: "z.B. R-20260401-001",
      statement: "Erkl\xE4rung",
      statementPlaceholder: "Kundenerkl\xE4rung zur freiwilligen R\xFCckgabe, Begr\xFCndung...",
      submit: "R\xFCckgabe erfassen",
      validationError: "Bitte f\xFCllen Sie alle Felder aus (Erkl\xE4rung min. 5 Zeichen)."
    }
  },
  quotation: {
    draft: "Entwurf",
    sent: "Gesendet",
    accepted: "Angenommen",
    pendingValue: "Ausstehender Wert",
    worksheet: "Arbeitsblatt",
    createdAt: "Erstellt",
    validUntil: "G\xFCltig bis",
    amount: "Betrag",
    expiringSoon: "L\xE4uft bald ab!",
    gross: "brutto",
    itemsCount: "{count} Positionen",
    quotationsDisplayed: "{count} Angebote angezeigt",
    newQuotationInfo: "Neues Angebot erstellen",
    newQuotationDesc: 'Um ein Angebot zu erstellen, \xF6ffnen Sie das Arbeitsblatt und klicken Sie auf die Schaltfl\xE4che "Angebot erstellen". Die Arbeitsblattpositionen werden automatisch in das Angebot \xFCbertragen.',
    notFound: "Angebot nicht gefunden",
    backToList: "Zur\xFCck zur Liste",
    partnerData: "Partnerdaten",
    partnerName: "Partnername",
    phone: "Telefon",
    relatedWorksheet: "Zugeh\xF6riges Arbeitsblatt",
    itemDescription: "Bezeichnung",
    unitPrice: "Einzelpreis",
    vat: "MwSt.",
    totalColumn: "Gesamt",
    netTotal: "Netto gesamt:",
    vatTotal: "MwSt. gesamt:",
    grossTotal: "Brutto gesamt:",
    netLabel: "netto:",
    customerNote: "Kundennotiz",
    internalNote: "Interne Notiz (nicht sichtbar f\xFCr Kunden)",
    statusLabel: "Status:",
    createdAtLabel: "Erstellt:",
    sentAtLabel: "Gesendet:",
    validUntilLabel: "G\xFCltig bis:",
    respondedAtLabel: "Antwortdatum:",
    createdByLabel: "Erstellt von:",
    quotationAmount: "Angebotssumme",
    pdfDownload: "PDF herunterladen",
    emailSend: "E-Mail senden",
    openWorksheet: "Arbeitsblatt \xF6ffnen",
    recordAcceptance: "Annahme erfassen",
    recordRejection: "Ablehnung erfassen",
    generateWorksheet: "Arbeitsblatt generieren",
    acceptTitle: "Angebot annehmen",
    acceptConfirm: "M\xF6chten Sie die Annahme des Angebots {number} wirklich erfassen?",
    acceptAfterInfo: "Nach der Annahme wird die Arbeitsblatterstellung verf\xFCgbar.",
    processing: "Verarbeitung...",
    accept: "Annehmen",
    rejectTitle: "Angebot ablehnen",
    rejectConfirm: "M\xF6chten Sie die Ablehnung des Angebots {number} wirklich erfassen?",
    rejectionReasonLabel: "Ablehnungsgrund (optional)",
    rejectionPlaceholder: "Z.B. Preis zu hoch, anderes Angebot gew\xE4hlt...",
    reject: "Ablehnen",
    generateWorksheetTitle: "Arbeitsblatt generieren",
    generateWorksheetConfirm: "Arbeitsblatt aus Angebot {number} erstellen?",
    generateWorksheetInfo: "Das System erstellt automatisch ein Arbeitsblatt aus den Angebotspositionen:",
    partnerLabel: "Partner:",
    itemCountLabel: "Anzahl Positionen:",
    amountLabel: "Betrag:",
    generating: "Generierung...",
    sendButton: "Senden",
    sentSuccess: "Angebot gesendet.",
    sendFailed: "Senden fehlgeschlagen",
    acceptedSuccess: "Angebot angenommen.",
    acceptFailed: "Annahme fehlgeschlagen",
    rejectedSuccess: "Angebot abgelehnt.",
    rejectFailed: "Ablehnung fehlgeschlagen",
    worksheetCreated: "Arbeitsblatt erstellt: {number}",
    conversionFailed: "Konvertierung fehlgeschlagen",
    newQuotation: "Neues Angebot",
    editQuotation: "Angebot bearbeiten",
    quotationData: "Angebotsdaten",
    validityEnd: "G\xFCltigkeitsende",
    totalGross: "Gesamt (brutto)",
    addItem: "+ Position hinzuf\xFCgen",
    itemDescriptionPlaceholder: "Positionsbezeichnung...",
    qty: "Menge",
    unit: "Einheit",
    netPrice: "Nettopreis",
    grossTotalItem: "Brutto gesamt",
    noItems: "Keine Positionen. Klicken Sie auf die Schaltfl\xE4che {button}.",
    customerVisibleNote: "F\xFCr Kunden sichtbare Notiz",
    customerNotePlaceholder: "Z.B.: Erwartete Fertigstellungszeit, Zahlungsbedingungen...",
    internalNotePlaceholder: "Z.B.: Rabattgrund, Kundenabsprache...",
    createQuotation: "Angebot erstellen",
    saveChanges: "\xC4nderungen speichern",
    saveFailed: "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.",
    atLeastOneItem: "Bitte mindestens eine Position hinzuf\xFCgen!",
    productId: "Artikelnr.:",
    emailLabel: "E-Mail",
    worksheetLabel: "Arbeitsblatt:",
    sendEmailSubject: "E-Mail senden: {email}\nBetreff: Angebot - {number}",
    pdfGeneration: "PDF-Generierung: {number}",
    version: "Version",
    versionHistory: "Versionsgeschichte",
    versionOf: "v{current}/{total}",
    currentVersion: "aktuell",
    createNewVersion: "Neue Version",
    newVersionCreated: "Neue Version erstellt.",
    newVersionFailed: "Neue Version konnte nicht erstellt werden",
    quotationNumber: "Angebotsnummer",
    diff: {
      compareVersions: "Versionen vergleichen",
      versionHistory: "Versionsgeschichte",
      versionN: "v{n}",
      changed: "Ge\xE4ndert",
      added: "Hinzugef\xFCgt",
      removed: "Entfernt",
      noChanges: "Keine \xC4nderungen zwischen den beiden Versionen",
      selectVersions: "W\xE4hlen Sie zwei Versionen zum Vergleich",
      basicInfo: "Grunddaten",
      field: "Feld",
      versions: "Versionen"
    },
    status: {
      draft: "Entwurf",
      sent: "Gesendet",
      accepted: "Akzeptiert",
      rejected: "Abgelehnt",
      expired: "Abgelaufen",
      converted: "Konvertiert"
    }
  },
  vehicle: {
    title: "Fahrzeuge",
    rentalVehicles: "Mietfahrzeuge",
    companyVehicles: "Firmenfahrzeuge",
    expiringDocuments: "Ablaufende Dokumente",
    technicalInspection: "Technische \xDCberpr\xFCfung",
    registrationCert: "Zulassungsbescheinigung",
    mtplInsurance: "Kfz-Haftpflicht",
    cascoInsurance: "Kaskoversicherung",
    highwaySticker: "Autobahnvignette",
    subtitle: "Anh\xE4nger, Aggregatoren, Plattformen verwalten",
    newVehicle: "Neues Fahrzeug",
    totalVehicles: "Alle Fahrzeuge",
    available: "Verf\xFCgbar",
    rentedOut: "Vermietet",
    expiringIn30Days: "L\xE4uft in 30 Tagen ab",
    searchPlaceholder: "Suche Kennzeichen, Name, Marke...",
    allTypes: "Alle Typen",
    allStatuses: "Alle Status",
    vehicleColumn: "Fahrzeug",
    technicalExpiry: "Technischer Ablauf",
    registrationExpiry: "Zulassungsablauf",
    insuranceExpiry: "Versicherungsablauf",
    operations: "Aktionen",
    loadingVehicles: "Fahrzeuge werden geladen...",
    noResults: "Keine Ergebnisse f\xFCr die Suchkriterien.",
    deleteConfirm: "M\xF6chten Sie das Fahrzeug wirklich l\xF6schen: {name}?",
    deleteFailed: "Fahrzeug konnte nicht gel\xF6scht werden.",
    typeLabels: {
      trailer: "Anh\xE4nger",
      aggregator: "Aggregator",
      platform: "Plattform",
      other: "Sonstiges"
    },
    statusLabels: {
      active: "Verf\xFCgbar",
      rented: "Vermietet",
      maintenance: "Wartung",
      inactive: "Inaktiv",
      available: "Verf\xFCgbar"
    },
    companyTypeLabels: {
      car: "Personenkraftwagen",
      van: "Transporter",
      truck: "Lastkraftwagen"
    },
    companyStatusLabels: {
      active: "Verf\xFCgbar",
      in_use: "In Gebrauch",
      maintenance: "In Wartung",
      inactive: "Inaktiv"
    },
    fuelLabels: {
      petrol: "Benzin",
      diesel: "Diesel",
      electric: "Elektrisch",
      hybrid: "Hybrid"
    },
    companySubtitle: "Zentrale Verwaltung von Pkw und Transportern",
    inUse: "In Gebrauch",
    vehicleNotFound: "Fahrzeug nicht gefunden.",
    basicInfo: "Grunddaten",
    licensePlate: "Kennzeichen",
    brandModel: "Marke / Modell",
    yearOfManufacture: "Baujahr",
    fuelType: "Kraftstoff",
    odometer: "Kilometerz\xE4hler",
    assignedTo: "Zugewiesen an",
    expiryAndInsurance: "Ablaufdaten & Versicherungen",
    insurance: "Versicherung",
    recordData: "Datensatz",
    lastModified: "Zuletzt ge\xE4ndert",
    editCompanyVehicle: "Firmenfahrzeug bearbeiten",
    newCompanyVehicle: "Neues Firmenfahrzeug",
    editVehicleData: "Fahrzeugdaten bearbeiten",
    registerNewCompanyVehicle: "Neues Firmenfahrzeug erfassen",
    licensePlateRequired: "Kennzeichen ist erforderlich",
    nameRequired: "Bezeichnung ist erforderlich",
    brandRequired: "Marke ist erforderlich",
    kgfbExpiryRequired: "Kfz-Haftpflicht-Ablauf ist erforderlich",
    technicalExpiryRequired: "T\xDCV-Ablauf ist erforderlich",
    registrationExpiryRequired: "Zulassungsablauf ist erforderlich",
    insuranceExpiryRequired: "Versicherungsablauf ist erforderlich",
    invalidLicensePlate: "Ung\xFCltiges Kennzeichenformat (z.B. ABC-123)",
    expiryDatesAndInsurance: "Ablaufdaten und Versicherungen",
    designation: "Bezeichnung",
    brandLabel: "Marke",
    modelLabel: "Modell",
    statusLabel: "Status",
    odometerReading: "Kilometerstand",
    assignedStore: "Zugewiesene Filiale",
    noAssignment: "-- Keine Zuweisung --",
    additionalInfo: "Weitere Informationen...",
    savingInProgress: "Speichern...",
    rentalHistory: "Mietverlauf",
    loadingHistory: "Verlauf wird geladen...",
    noRentalHistory: "Kein Mietverlauf vorhanden.",
    backToList: "Zur\xFCck zur Liste",
    expiryDates: "Ablaufdaten",
    editVehicle: "Fahrzeug bearbeiten",
    addNewVehicle: "Neues Fahrzeug hinzuf\xFCgen",
    registerNewRentalVehicle: "Neues Mietfahrzeug erfassen",
    expiringDocsSubtitle: "Ablaufende Dokumente f\xFCr Miet- und Firmenfahrzeuge",
    within30Days: "Innerhalb von 30 Tagen",
    within60Days: "Innerhalb von 60 Tagen",
    allMonitored: "Alle \xFCberwachten",
    allFilter: "Alle",
    allCategories: "Alle Kategorien",
    allDocuments: "Alle Dokumente",
    noExpiringDocs: "Keine ablaufenden Dokumente f\xFCr die gew\xE4hlten Filter.",
    companyLabel: "Firma",
    rentalLabel: "Mietger\xE4t",
    expiredDaysAgo: "Vor {days} Tagen abgelaufen",
    expiresInDays: "In {days} Tagen",
    typeLabel: "Typ",
    additionalVehicleInfo: "Weitere Informationen zum Fahrzeug...",
    placeholder: {
      brand: "z.B. Skoda",
      companyName: "z.B. Dienstwagen 1",
      model: "z.B. Octavia",
      rentalName: "z.B. Anh\xE4nger 1"
    }
  },
  user: {
    title: "Benutzer",
    subtitle: "Benutzer- und Berechtigungsverwaltung",
    loadingUsers: "Benutzer werden geladen...",
    loadingUser: "Benutzer wird geladen...",
    errorOccurred: "Ein Fehler ist aufgetreten",
    backToDashboard: "Zur\xFCck zum Dashboard",
    roles: "Rollen",
    newUser: "+ Neuer Benutzer",
    totalUsers: "Alle Benutzer",
    searchPlaceholder: "Suche Name, E-Mail...",
    allRoles: "Alle Rollen",
    allStores: "Alle Filialen",
    userColumn: "Benutzer",
    roleColumn: "Rolle",
    createdAtColumn: "Erstellt",
    usersDisplayed: "{count} Benutzer angezeigt",
    notFound: "Benutzer nicht gefunden",
    suspend: "Sperren",
    activate: "Aktivieren",
    tabOverview: "\xDCbersicht",
    tabActivity: "Aktivit\xE4t",
    basicData: "Grunddaten",
    email: "E-Mail",
    role: "Rolle",
    tenantId: "Mandanten-ID",
    locationId: "Standort-ID",
    systemInfo: "Systeminformation",
    identifier: "Kennung:",
    createdLabel: "Erstellt:",
    modifiedLabel: "Ge\xE4ndert:",
    activityLog: "Aktivit\xE4tsprotokoll",
    profileUpdated: "Profil aktualisiert",
    userCreated: "Benutzer erstellt",
    editUser: "Benutzer bearbeiten",
    newUserTitle: "Neuer Benutzer",
    savingLabel: "Speichern...",
    createLabel: "Erstellen",
    nameRequired: "Name *",
    emailRequired: "E-Mail-Adresse *",
    passwordChange: "Passwort \xE4ndern",
    newPassword: "Neues Passwort",
    passwordRequired: "Passwort *",
    minChars: "Mindestens 8 Zeichen",
    passwordLeaveEmpty: "Leer lassen, wenn keine \xC4nderung gew\xFCnscht",
    confirmPassword: "Passwort best\xE4tigen",
    confirmPasswordRequired: "Passwort best\xE4tigen *",
    passwordAgain: "Passwort erneut",
    roleAndLocation: "Rolle und Standort",
    roleRequired: "Rolle *",
    locationOptional: "Filiale / Standort (optional)",
    notSpecified: "Nicht angegeben",
    saveChanges: "\xC4nderungen speichern",
    createUser: "Benutzer erstellen",
    saveError: "Beim Speichern ist ein Fehler aufgetreten.",
    namePlaceholder: "Max Mustermann",
    emailPlaceholder: "benutzer@beispiel.de",
    validation: {
      emailRequired: "E-Mail-Adresse ist erforderlich",
      emailInvalid: "Ung\xFCltige E-Mail-Adresse",
      nameRequired: "Name ist erforderlich",
      roleRequired: "Rollenauswahl ist erforderlich",
      passwordRequired: "Passwort ist erforderlich",
      passwordMinLength: "Mindestens 8 Zeichen",
      passwordMismatch: "Passw\xF6rter stimmen nicht \xFCberein",
      taxFormat: "Ung\xFCltiges Steuernummernformat (8 oder 11 Ziffern)",
      taxChecksum: "Die Pr\xFCfziffer der Steuernummer ist ung\xFCltig",
      phoneFormat: "Ung\xFCltiges Telefonnummernformat",
      postalFormat: "Postleitzahl muss 4 Ziffern lang sein"
    },
    roleLabels: {
      OPERATOR: "Bediener",
      TECHNIKUS: "Techniker",
      BOLTVEZETO: "Filialleiter",
      ACCOUNTANT: "Buchhalter",
      PARTNER_OWNER: "Partner-Inhaber",
      CENTRAL_ADMIN: "Zentraladmin",
      DEVOPS_ADMIN: "DevOps-Admin",
      SUPER_ADMIN: "Systemadministrator"
    },
    roleDescriptions: {
      OPERATOR: "Kasse, Verkauf, Vermietung",
      TECHNIKUS: "Arbeitsbl\xE4tter, Servicevorg\xE4nge",
      BOLTVEZETO: "Filialbetrieb, Berichte, Benutzerverwaltung",
      ACCOUNTANT: "Finanzoperationen, Rechnungsstellung, Abrechnung",
      PARTNER_OWNER: "Partnerzugang, Vertr\xE4ge",
      CENTRAL_ADMIN: "Zentralverwaltung, alle Filialen",
      DEVOPS_ADMIN: "Systembetrieb, Infrastruktur",
      SUPER_ADMIN: "Vollzugriff auf alle Funktionen"
    },
    statusLabels: {
      ACTIVE: "Aktiv",
      INACTIVE: "Inaktiv",
      LOCKED: "Gesperrt",
      PENDING_VERIFICATION: "Ausstehende \xDCberpr\xFCfung"
    },
    rolesAndPermissions: "Rollen und Berechtigungen",
    rbacDescription: "RBAC-Verwaltung (8-stufige Rollenhierarchie)",
    rbacInfoBanner: "Rollen sind im Backend-RBAC-System definiert (ADR-032). Berechtigungen k\xF6nnen eingesehen, aber nur in der Systemkonfiguration ge\xE4ndert werden.",
    rolesCount: "Rollen ({count})",
    level: "Stufe {level}",
    code: "Code:",
    hierarchyLevel: "Hierarchiestufe:",
    permissionsLabel: "Berechtigungen:",
    typeLabel: "Typ:",
    systemRole: "Systemrolle",
    permissionsCount: "Berechtigungen ({count})",
    selectRolePrompt: "W\xE4hlen Sie eine Rolle aus, um Details anzuzeigen."
  },
  dunning: {
    title: "Mahnung",
    level: {
      none: "Keine",
      reminder: "Erinnerung",
      warning: "Warnung",
      finalNotice: "Letzte Mahnung"
    },
    currentLevel: "Aktuelle Stufe",
    escalate: "Eskalieren",
    escalateSuccess: "Mahnstufe erfolgreich erh\xF6ht",
    history: "Mahnverlauf",
    sentAt: "Gesendet am",
    nextEscalation: "N\xE4chste Eskalation",
    overdueDays: "\xDCberf\xE4llige Tage",
    days: "Tage",
    amount: "Ausstehend",
    escalationCount: "Mahnungen",
    noHistory: "Kein Mahnverlauf"
  },
  invoicePage: {
    invoiceNumber: "Rechnungsnummer",
    issueDate: "Ausstellungsdatum",
    dueDate: "F\xE4lligkeitsdatum",
    amount: "Betrag",
    arrears: "R\xFCckstand: {amount}",
    loadingInvoices: "Rechnungen werden geladen...",
    errorOccurred: "Ein Fehler ist aufgetreten: {message}",
    noResults: "Keine Ergebnisse f\xFCr die gew\xE4hlten Filter",
    invoiceCount: "{count} Rechnungen"
  },
  contract: {
    title: "Vertr\xE4ge",
    subtitle: "Miet- und Servicevertr\xE4ge",
    contract: "Vertrag",
    goToRentals: "Vermietungen",
    activeDeposit: "Aktive Kaution",
    activeValue: "Aktiver Wert",
    searchPlaceholder: "Suche Nummer, Partner, Vermietung...",
    deposit: "Kaution",
    depositPaid: "Bezahlt",
    depositMissing: "Fehlt",
    depositNotPaid: "Nicht bezahlt",
    depositAmount: "Kautionsbetrag",
    contractsDisplayed: "{count} Vertr\xE4ge angezeigt",
    autoGenerationTitle: "Automatische Vertragserstellung",
    autoGenerationDesc: "Vertr\xE4ge werden automatisch beim Start einer Vermietung erstellt. PDF-Download und Druck sind auf der Detailseite verf\xFCgbar.",
    notFound: "Vertrag nicht gefunden",
    rental: "Vermietung",
    pdfDownload: "PDF herunterladen",
    pdfGeneration: "PDF-Erstellung",
    pdfDownloading: "Das Vertrags-PDF wird heruntergeladen...",
    sign: "Unterschreiben",
    partnerData: "Partnerdaten",
    partnerName: "Partnername",
    idNumber: "Ausweisnummer",
    contractPeriod: "Vertragszeitraum",
    startDate: "Startdatum",
    expectedEndDate: "Voraussichtliches Enddatum",
    expectedEnd: "Voraussichtliches Ende",
    actualEndDate: "Tats\xE4chliches Enddatum",
    activeContractMessage: "Aktiver Vertrag - R\xFCckgabe l\xE4uft",
    dailyRate: "Tagessatz",
    productId: "Artikel",
    termsAndNotes: "Bedingungen und Anmerkungen",
    contractTerms: "Vertragsbedingungen",
    signedAt: "Unterschrieben am",
    signatures: "Unterschriften",
    partnerSignature: "Unterschrift des Partners",
    staffSignature: "Unterschrift des Mitarbeiters",
    contractAmount: "Vertragsbetrag",
    openRental: "Vermietung \xF6ffnen",
    recordSignature: "Unterschrift erfassen",
    editContract: "Vertrag bearbeiten",
    contractData: "Vertragsdaten",
    duration: "Dauer",
    financialData: "Finanzdaten",
    termsPlaceholder: "Allgemeine Vertragsbedingungen...",
    notesPlaceholder: "Weitere Anmerkungen...",
    saveChanges: "\xC4nderungen speichern",
    datesRequired: "Start- und Enddatum sind erforderlich!",
    saveFailed: "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.",
    status: {
      draft: "Entwurf",
      active: "Aktiv",
      completed: "Abgeschlossen",
      cancelled: "Storniert"
    },
    type: {
      rental: "Vermietung",
      service: "Service",
      sales: "Verkauf"
    }
  },
  product: {
    title: "Artikel",
    subtitle: "Produkte, Ersatzteile und Mietger\xE4te verwalten",
    newProduct: "Neuer Artikel",
    newProductTitle: "Neuer Artikel",
    newProductSubtitle: "Produktdaten erfassen",
    editProduct: "Artikel bearbeiten",
    productNotFound: "Artikel nicht gefunden",
    backToList: "Zur\xFCck zur Liste",
    identifiers: "Kennungen",
    sku: "Artikelnummer (intern)",
    skuRequired: "Artikelnummer (intern) *",
    skuOptional: "Artikelnummer (intern) \u2014 automatisch generiert, leer lassen",
    skuAutoPlaceholder: "KGC-{year}-####",
    internalCodeSource: {
      label: "Quelle der internen Artikelnummer",
      AUTO_GENERATED: "Automatisch generieren (KGC-{year}-####)",
      SUPPLIER_FGS: "FGS-Lieferanten-SKU \xFCbernommen",
      SUPPLIER_MAV: "MAV-Lieferanten-SKU \xFCbernommen"
    },
    barcode: "Barcode (EAN)",
    manufacturerCode: "Hersteller-Artikelnummer",
    manufacturerCodeShort: "Herstellercode",
    manufacturerPartNumber: "Hersteller-Teilenummer",
    manufacturerPartNumberShort: "Herst.-Nr.",
    locationCode: "Lagerplatz (L-R-F)",
    productDetails: "Produktdaten",
    productName: "Bezeichnung *",
    productNamePlaceholder: "Makita DHP481RTJ Akku-Schlagbohrschrauber",
    shortName: "Kurzname",
    brand: "Marke",
    typeModel: "Typ/Modell",
    supplier: "Lieferant",
    supplierName: "Lieferantenname",
    supplierCode: "Lieferantencode",
    selectPlaceholder: "-- Ausw\xE4hlen --",
    description: "Beschreibung",
    descriptionPlaceholder: "Ausf\xFChrliche Produktbeschreibung...",
    pricing: "Preisgestaltung",
    purchasePriceNet: "Einkaufspreis (netto)",
    sellingPriceNet: "Verkaufspreis (netto)",
    sellingPriceGross: "Verkaufspreis (brutto)",
    vatRate: "MwSt.-Satz",
    calculatedMargin: "Berechnete Marge: <strong>{percent}%</strong>",
    stockSettings: "Bestandseinstellungen",
    minStockLevel: "Mindestbestand",
    reorderQuantity: "Bestellmenge",
    rentalSettings: "Mieteinstellungen",
    dailyRateFt: "Tagessatz (HUF)",
    weeklyRateFt: "Wochensatz (HUF)",
    monthlyRateFt: "Monatssatz (HUF)",
    depositAmountFt: "Kautionsbetrag (HUF)",
    creating: "Erstellen...",
    createProduct: "Artikel erstellen",
    savingChanges: "Speichern...",
    saveChanges: "\xC4nderungen speichern",
    nameRequired: "Name ist erforderlich!",
    skuRequiredAlert: "Artikelnummer ist erforderlich!",
    errorPrefix: "Fehler: {message}",
    sale: "Verkauf",
    tabs: {
      overview: "\xDCbersicht",
      stock: "Bestand",
      pricing: "Preise",
      rental: "Vermietung",
      components: "Komponenten",
      history: "Verlauf"
    },
    explodedView: {
      title: "Komponenten (St\xFCckliste)",
      addComponent: "Hinzuf\xFCgen",
      noComponents: "Keine Komponenten f\xFCr dieses Produkt erfasst.",
      componentName: "Komponentenname",
      quantityPerUnit: "Menge/Stk",
      unitCost: "St\xFCckpreis",
      totalCost: "Gesamt",
      totalBomCost: "Gesamte BOM-Kosten",
      marginSummary: "Margen\xFCbersicht",
      searchProduct: "Produkt suchen"
    },
    basicData: "Stammdaten",
    noSupplier: "Kein Lieferant angegeben",
    lastOrder: "Letzte Bestellung",
    lastPurchasePrice: "Letzter Einkaufspreis",
    quickOverview: "Schnell\xFCbersicht",
    inStock: "Auf Lager:",
    reserved: "Reserviert:",
    margin: "Marge:",
    goodsReceipt: "Wareneingang",
    movements: "Bewegungen",
    startRental: "Vermietung starten",
    stockData: "Bestandsdaten",
    totalStock: "Gesamtbestand:",
    available: "Verf\xFCgbar:",
    minimumLevel: "Mindestbestand:",
    placement: "Lagerplatz",
    notSpecified: "Nicht angegeben",
    locationCodeFormat: "Lagerplatzformat: <strong>Lager - Regal - Fach</strong>",
    locationCodeExample: "Beispiel: A-02-03 = Lager A, Regal 2, Fach 3",
    lowStockWarning: "Niedriger Bestand!",
    lowStockDescription: "Der Bestand ({current} Stk.) liegt unter dem Mindestbestand ({min} Stk.). Empfohlene Bestellmenge: {reorder} Stk.",
    prices: "Preise",
    marginCalculation: "Margenberechnung",
    marginFt: "Marge (HUF):",
    marginPercent: "Marge (%):",
    marginFormula: "Margenberechnung: (Verkauf - Einkauf) / Einkauf x 100",
    rentalRates: "Mietpreise",
    dailyRate: "Tagessatz:",
    weeklyRate: "Wochensatz:",
    monthlyRate: "Monatssatz (30 Tage):",
    depositAmount: "Kautionsbetrag:",
    rentalStatus: "Mietstatus",
    totalMachines: "Gesamte Ger\xE4te:",
    rentedOut: "Vermietet:",
    availableForRental: "Zur Vermietung verf\xFCgbar:",
    startNewRental: "Neue Vermietung starten",
    history: "Verlauf",
    productUpdated: "Artikeldaten aktualisiert",
    lastPurchase: "Letzter Einkauf - {price}",
    productCreated: "Artikel erstellt ({user})",
    statusAndCategory: "Status und Kategorie",
    currentStock: "Aktueller Bestand: <strong>{total} Stk.</strong> (Verf\xFCgbar: {available} Stk., Reserviert: {reserved} Stk.)",
    stats: {
      total: "Artikel gesamt",
      active: "Aktiv",
      lowStock: "Niedriger Bestand",
      outOfStock: "Nicht auf Lager",
      stockValue: "Bestandswert"
    },
    searchPlaceholder: "Suche nach Name, Artikelnr., Barcode, Marke...",
    allCategories: "Alle Kategorien",
    allStatuses: "Alle Status",
    allSuppliers: "Alle Lieferanten",
    filter: {
      brand: "Markenfilter",
      allBrands: "Alle Marken"
    },
    lowStockOnly: "Nur niedriger Bestand",
    tableHeaders: {
      product: "Artikel",
      category: "Kategorie",
      barcode: "Barcode",
      supplier: "Lieferant",
      netPrice: "Nettopreis",
      grossPrice: "Bruttopreis",
      stock: "Bestand",
      status: "Status"
    },
    stockBadge: {
      none: "Keine",
      low: "Niedrig",
      ok: "OK"
    },
    detailsButton: "Details",
    noResults: "Keine Ergebnisse f\xFCr die Filterkriterien.",
    displayedCount: "{count} Artikel angezeigt",
    import: {
      imported: "Importiert",
      updated: "Aktualisiert",
      skipped: "\xDCbersprungen",
      totalRows: "Gesamtzeilen"
    },
    categoriesLoadError: "Kategorien konnten nicht geladen werden.",
    noCategories: "Keine Kategorien vorhanden."
  },
  report: {
    title: "Berichte",
    subtitle: "Gesch\xE4ftsberichte und Statistiken",
    overview: "\xDCbersicht",
    sales: "Verkauf",
    rentals: "Vermietungen",
    inventory: "Lager",
    financial: "Finanzen",
    period: "Zeitraum:",
    today: "Heute",
    week: "Woche",
    month: "Monat",
    quarter: "Quartal",
    year: "Jahr",
    customPeriod: "Benutzerdefinierter Zeitraum",
    totalRevenue: "Gesamtumsatz",
    comparedToPrevMonth: "im Vergleich zum Vormonat",
    salesCount: "Verk\xE4ufe",
    worksheets: "Arbeitsbl\xE4tter",
    revenueTrend: "Umsatztrend",
    revenueChart: "Liniendiagramm - Umsatz",
    categoryDistribution: "Kategorienverteilung",
    categoryChart: "Kreisdiagramm - Kategorien",
    salesByCategory: "Verkauf nach Kategorie",
    category: "Kategorie",
    amount: "Betrag",
    pieces: "St\xFCck",
    avgPerPiece: "Durchschn./Stk.",
    ratio: "Anteil",
    total: "Gesamt",
    dailySales: "T\xE4gliche Verk\xE4ufe",
    dailySalesChart: "S\xE4ulendiagramm - T\xE4gliche Verk\xE4ufe",
    topRentals: "Top-Vermietungen - Ger\xE4teauslastung",
    equipment: "Ger\xE4t",
    rentalsCount: "Vermietungen",
    revenue: "Umsatz",
    utilization: "Auslastung",
    avgRentalDuration: "Durchschnittliche Mietdauer",
    avgRentalDays: "{days} Tage",
    overdueReturns: "\xDCberf\xE4llige R\xFCckgaben",
    avgDeposit: "Durchschnittliche Kaution",
    inventoryByCategory: "Bestandsstatus nach Kategorie",
    inStock: "Auf Lager",
    reserved: "Reserviert",
    available: "Verf\xFCgbar",
    lowStock: "Niedriger Bestand",
    lowStockItems: "{count} Artikel",
    grossRevenue: "Bruttoumsatz",
    vatPayment: "MwSt.-Zahlung",
    vatRate: "27% MwSt.-Satz",
    netResult: "Nettoergebnis",
    expiredInvoices: "{count} \xFCberf\xE4llige Rechnungen",
    revenueBreakdown: "Umsatzaufschl\xFCsselung",
    productSales: "Produktverk\xE4ufe",
    rentalFees: "Mietgeb\xFChren",
    serviceLabor: "Serviceleistungen",
    other: "Sonstiges",
    smallMachines: "Kleinger\xE4te",
    tools: "Werkzeuge",
    safetyEquipment: "Schutzausr\xFCstung",
    rentalReport: "Vermietungsbericht",
    periodLabel: "Zeitraum: {start} - {end}",
    refresh: "Aktualisieren",
    filters: "Filter",
    lastWeek: "Letzte Woche",
    lastMonth: "Letzter Monat",
    lastQuarter: "Letztes Quartal",
    lastYear: "Letztes Jahr",
    startDate: "Startdatum",
    endDate: "Enddatum",
    equipmentType: "Ger\xE4tetyp",
    allTypes: "Alle Typen",
    clearFilters: "Filter l\xF6schen",
    totalRentals: "Gesamtvermietungen",
    activeRentals: "Aktive Vermietungen",
    closedRentals: "Abgeschlossene Vermietungen",
    avgRentalTime: "Durchschn. Mietdauer",
    avgRevenuePerRental: "Durchschn. Umsatz/Vermietung",
    overdue: "\xDCberf\xE4llig",
    rentalsByEquipmentType: "Vermietungen nach Ger\xE4tetyp",
    equipmentTypeCol: "Ger\xE4tetyp",
    count: "Anzahl",
    revenueCol: "Umsatz",
    ratioCol: "Anteil",
    noDataForFilters: "Keine Daten f\xFCr die angegebenen Filterkriterien.",
    errorLoading: "Fehler beim Laden der Daten.",
    retryButton: "Erneut versuchen",
    comparedToPrevMonthShort: "gg\xFC. Vormonat",
    margin: {
      title: "Marge",
      byProduct: "Nach Produkt",
      byCategory: "Nach Kategorie",
      revenue: "Umsatz",
      cogs: "Einkaufskosten",
      marginAmount: "Marge (HUF)",
      marginPercent: "Marge (%)",
      exportCsv: "CSV exportieren",
      detailTable: "Detaillierter Margenbericht",
      productName: "Produkt"
    }
  },
  kb: {
    title: "Wissensdatenbank-Verwaltung",
    subtitle: "Artikel erstellen, bearbeiten und l\xF6schen",
    newArticle: "Neuer Artikel",
    loadingArticles: "Artikel werden geladen...",
    noArticles: "Keine Artikel",
    createNewArticle: "Neuen Artikel erstellen",
    editArticle: "Artikel bearbeiten",
    articleTitle: "Titel *",
    content: "Inhalt (Markdown) *",
    status: "Status",
    tags: "Tags",
    addTag: "Hinzuf\xFCgen",
    searchTitle: "Wissensdatenbank",
    searchPlaceholder: "Artikel durchsuchen...",
    searchInKb: "In der Wissensdatenbank suchen...",
    noResults: "Keine Ergebnisse",
    tryOtherSearch: "Versuchen Sie andere Suchkriterien",
    feedbackThanks: "Vielen Dank f\xFCr Ihr Feedback!",
    wasHelpful: "War dieser Artikel hilfreich?",
    helpful: "Hilfreich",
    notHelpful: "Nicht hilfreich",
    helpfulCount: "hilfreich",
    notHelpfulCount: "nicht hilfreich",
    statusDraft: "Entwurf",
    statusPublished: "Ver\xF6ffentlicht",
    statusArchived: "Archiviert",
    deleteButton: "L\xF6schen",
    titlePlaceholder: "Artikeltitel...",
    contentPlaceholder: "Artikelinhalt im Markdown-Format...",
    category: {
      berles: "Vermietung",
      szerviz: "Service",
      penzugy: "Finanzen",
      rendszer: "System",
      altalanos: "Allgemein"
    }
  },
  sms: {
    title: "SMS-Einstellungen",
    sendTab: "SMS senden",
    historyTab: "Verlauf",
    templatesTab: "Vorlagen",
    phonePlaceholder: "Telefonnummer (+36...)",
    messagePlaceholder: "Nachrichtentext (max. 480 Zeichen)",
    charCount: "{count}/480 Zeichen",
    sending: "Senden...",
    send: "Senden",
    sentSuccess: "SMS erfolgreich gesendet!",
    historyTitle: "SMS-Verlauf ({count})",
    noRecords: "Keine SMS-Eintr\xE4ge.",
    directionOutbound: "Ausgehend",
    directionInbound: "Eingehend",
    newTemplate: "Neue Vorlage",
    templateName: "Vorlagenname",
    templateBody: "Vorlagentext (Variablen: {gep}, {datum}, {idopont}, {ml_szam})",
    templateVariables: "Variablen (kommagetrennt: gep,datum,idopont)",
    templateActive: "Aktiv",
    templateSaving: "Speichern...",
    templateSave: "Vorlage speichern",
    templatesTitle: "Vorlagen ({count})",
    noTemplates: "Keine Vorlagen.",
    activeLabel: "Aktiv",
    inactiveLabel: "Inaktiv",
    typeCustom: "Benutzerdefiniert",
    typeBookingConfirm: "Buchungsbest\xE4tigung",
    typeRentalExpiry: "Mietablauf",
    typeServiceReady: "Service fertig",
    typeRentalReminder: "Mieterinnerung",
    backToDashboard: "Zur\xFCck zum Dashboard",
    dashboardTitle: "SMS-Zentrale",
    filterPending: "Ausstehend",
    filterProcessed: "Verarbeitet",
    inboundTitle: "Eingehende Nachrichten",
    markProcessed: "Als verarbeitet markieren",
    noInboundMessages: "Keine eingehenden Nachrichten",
    pendingFailed: "Senden fehlgeschlagen",
    quickSend: "Schnellversand",
    recentHistory: "Letzte Eintr\xE4ge",
    recognizedCommand: "Erkannter Befehl",
    selectTemplate: "Vorlage ausw\xE4hlen",
    sentToday: "Heute gesendet",
    settingsLink: "SMS-Einstellungen",
    statusPending: "Ausstehend",
    statusProcessed: "Verarbeitet",
    successRate: "Erfolgsrate",
    viewAll: "Alle anzeigen",
    viewRelated: "Verwandte anzeigen"
  },
  ocr: {
    title: "Dokumentenscanner & Etikettendruck",
    subtitle: "IPEVO V4K Dokumentenkamera + Zebra/Brother Etikettendrucker",
    scanTab: "Dokumentenscan",
    labelTab: "Etikettendruck",
    scanTitle: "Dokumentenscan (IPEVO V4K)",
    scanInstruction: "Legen Sie das Dokument unter die Kamera und klicken Sie auf Scannen.",
    scanButton: "Scan starten",
    scanning: "Scannen...",
    scanResults: "Scanergebnisse",
    noResults: "Noch keine Scanergebnisse.",
    labelTitle: "Etikettenerstellung",
    zebraLabel: "Zebra ZD 220 (43\xD726mm)",
    brotherLabel: "Brother QL-700 (50mm)",
    generateZebra: "Zebra-Etikett erstellen",
    generateBrother: "Brother-Etikett erstellen",
    generating: "Erstellen...",
    sku: "Artikelnummer",
    productName: "Produktname",
    price: "Preis (brutto)",
    pageTitle: "Dokumentenleser & Etikettendruck",
    scanButtonLabel: "Dokument scannen",
    scanSuccess: "Scan erfolgreich!",
    nameLabel: "Name",
    documentNumberLabel: "Dokumentennummer",
    confidenceLabel: "Zuverl\xE4ssigkeit",
    productNamePlaceholder: "Produktname",
    barcodePlaceholder: "Barcode",
    pricePlaceholder: "Preis (HUF)",
    skuPlaceholder: "SKU (optional)",
    netPricePlaceholder: "Nettopreis (HUF)",
    vatRatePlaceholder: "MwSt.-Satz (%)",
    barcodeOptionalPlaceholder: "Barcode (optional)",
    categoryPlaceholder: "Kategorie (optional)",
    generatingLabel: "Generierung...",
    priceLabelGenerate: "Preisetikett generieren",
    errorUnknown: "Unbekannter Fehler"
  },
  businessHours: {
    title: "\xD6ffnungszeiten & Feiertage",
    subtitle: "\xD6ffnungszeiten, Feiertage und Ausnahmen verwalten",
    weeklyTab: "Wochenplan",
    holidaysTab: "Feiertage",
    overridesTab: "Ausnahmen",
    weeklySchedule: "W\xF6chentliche \xD6ffnungszeiten",
    dayNames: {
      monday: "Montag",
      tuesday: "Dienstag",
      wednesday: "Mittwoch",
      thursday: "Donnerstag",
      friday: "Freitag",
      saturday: "Samstag",
      sunday: "Sonntag"
    },
    dayShort: {
      monday: "Mo",
      tuesday: "Di",
      wednesday: "Mi",
      thursday: "Do",
      friday: "Fr",
      saturday: "Sa",
      sunday: "So"
    },
    open: "Ge\xF6ffnet",
    closed: "Geschlossen",
    openTime: "\xD6ffnung",
    closeTime: "Schlie\xDFung",
    holidayManagement: "Feiertagsverwaltung",
    newHoliday: "Neuer Feiertag",
    holidayName: "Feiertagsname",
    holidayDate: "Datum",
    recurring: "J\xE4hrlich wiederkehrend",
    noHolidays: "Keine Feiertage eingetragen.",
    overrideManagement: "Ausnahmenverwaltung",
    newOverride: "Neue Ausnahme",
    overrideDate: "Datum",
    overrideOpenTime: "\xD6ffnungszeit",
    overrideCloseTime: "Schlie\xDFzeit",
    overrideClosed: "Ganzt\xE4gig geschlossen",
    overrideReason: "Grund",
    noOverrides: "Keine Ausnahmen eingetragen.",
    saved: "Gespeichert!",
    everyYear: "Jedes Jahr",
    pageTitle: "\xD6ffnungszeiten verwalten",
    pageSubtitle: "W\xF6chentliche \xD6ffnungszeiten, Feiertage und Sondertage",
    weeklyScheduleTitle: "Wochenplan",
    defaultButton: "Standard",
    saveButton: "Speichern",
    savingButton: "Speichern...",
    savingSuccess: "\xD6ffnungszeiten erfolgreich gespeichert!",
    resetSuccess: "Auf Standard zur\xFCckgesetzt!",
    loadingWeekly: "\xD6ffnungszeiten laden...",
    dayColumn: "Tag",
    openColumn: "Ge\xF6ffnet",
    openingColumn: "\xD6ffnung",
    closingColumn: "Schlie\xDFung",
    hungHolidays: "Ungarische Feiertage",
    newHolidayButton: "Neuer Feiertag",
    editHolidayTitle: "Feiertag bearbeiten",
    newHolidayTitle: "Neuer Feiertag",
    nameLabel: "Name",
    dateLabel: "Datum",
    namePlaceholder: "z.B. Weihnachten",
    recurringLabel: "J\xE4hrlich wiederkehrend",
    cancelButton: "Abbrechen",
    updateButton: "Aktualisieren",
    createButton: "Erstellen",
    holidayUpdated: "Feiertag aktualisiert!",
    holidayCreated: "Feiertag erstellt!",
    holidayDeleted: "Feiertag gel\xF6scht!",
    nationalSeeded: "nationale Feiertage geladen!",
    loadingHolidays: "Feiertage laden...",
    holidaysTitle: "Feiertage",
    noHolidaysText: 'Keine Feiertage in diesem Jahr. Verwenden Sie die Schaltfl\xE4che "Ungarische Feiertage".',
    nameColumn: "Name",
    dateColumnHeader: "Datum",
    typeColumn: "Typ",
    actionsColumn: "Aktionen",
    nationalBadge: "National",
    recurringBadge: "Wiederkehrend",
    customBadge: "Benutzerdefiniert",
    editButton: "Bearbeiten",
    deleteButton: "L\xF6schen",
    overridesTitle: "Sondertage (\xDCberschreibungen)",
    newOverrideButton: "Neue \xDCberschreibung",
    editOverrideTitle: "\xDCberschreibung bearbeiten",
    newOverrideTitle: "Neue \xDCberschreibung",
    overrideUpdated: "\xDCberschreibung aktualisiert!",
    overrideCreated: "\xDCberschreibung erstellt!",
    overrideDeleted: "\xDCberschreibung gel\xF6scht!",
    loadingOverrides: "\xDCberschreibungen laden...",
    noOverridesText: "Keine Sondertag-\xDCberschreibungen.",
    statusColumn: "Status",
    timeColumn: "Zeit",
    reasonColumn: "Grund",
    reasonLabel: "Grund / Anmerkung",
    reasonPlaceholder: "z.B. Sonder\xF6ffnung am Samstag im Sommer",
    openBadge: "Ge\xF6ffnet",
    closedBadge: "Geschlossen",
    tabWeekly: "Wochenplan",
    tabHolidays: "Feiertage",
    tabOverrides: "Sondertage"
  },
  tenant: {
    title: "Mandanten-Admin",
    subtitle: "Unternehmensdaten und Franchise-Verwaltung",
    companyTab: "Unternehmenseinstellungen",
    franchiseTab: "Franchise-\xDCbersicht",
    basicData: "Grunddaten",
    storeName: "Filial-/Standortname",
    companyName: "Offizieller Firmenname",
    taxNumber: "Steuernummer",
    registrationNumber: "Handelsregisternummer",
    bankAccount: "Bankkontonummer",
    contactInfo: "Kontaktinformationen",
    phoneNumber: "Telefonnummer",
    emailAddress: "E-Mail-Adresse",
    website: "Webseite",
    address: "Adresse",
    franchiseStats: "Franchise-Statistiken",
    totalStores: "Alle Filialen",
    activeStores: "Aktive Filialen",
    totalRevenue: "Gesamtumsatz",
    tenantTable: "Mandantenliste",
    tenantName: "Name",
    tenantStatus: "Status",
    tenantPlan: "Tarif",
    tenantCreated: "Erstellt",
    bankName: "Bankname",
    addressLabel: "Adresse",
    cityLabel: "Stadt",
    postalCodeLabel: "Postleitzahl",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    websiteLabel: "Webseite",
    businessHoursTitle: "\xD6ffnungszeiten",
    openLabel: "Ge\xF6ffnet",
    closedLabel: "Geschlossen",
    brandingTitle: "Erscheinungsbild",
    uploadLogo: "Hochladen",
    primaryColor: "Hauptfarbe",
    accentColor: "Akzentfarbe",
    systemSettingsTitle: "Systemeinstellungen",
    currencyLabel: "W\xE4hrung",
    timezoneLabel: "Zeitzone",
    languageLabel: "Sprache",
    vatRateLabel: "MwSt.-Satz (%)",
    employees: "Mitarbeiter",
    activeWorksheets: "Aktive Arbeitsbl\xE4tter",
    searchPlaceholder: "Suche nach Standort, Stadt, Eigent\xFCmer...",
    locationsTitle: "Standorte",
    locationColumn: "Standort",
    ownerColumn: "Eigent\xFCmer",
    monthlyRevenueColumn: "Monatsumsatz",
    rentalsColumn: "Vermietungen",
    worksheetsColumn: "Arbeitsbl\xE4tter",
    lastActivityColumn: "Letzte Aktivit\xE4t",
    statusInactive: "Inaktiv",
    statusSuspended: "Gesperrt",
    currencyHUF: "HUF - Ungarischer Forint",
    currencyEUR: "EUR - Euro",
    employeesSuffix: "Mitarbeiter"
  },
  chat: {
    title: "Chat",
    newConversation: "Neues Gespr\xE4ch",
    you: "Du",
    noMessages: "Keine Nachrichten",
    participant: "Teilnehmer",
    participants: "Teilnehmer",
    online: "Online",
    offline: "Offline",
    call: "Anruf",
    info: "Information",
    attachment: "Anhang",
    messagePlaceholder: "Nachricht schreiben...",
    sendButton: "Senden",
    selectConversation: "Gespr\xE4ch ausw\xE4hlen",
    onlineColleagues: "Online-Kollegen",
    newChat: "Neues Gespr\xE4ch",
    groupName: "Gruppenname (optional)",
    selectParticipants: "Teilnehmer ausw\xE4hlen",
    startConversation: "Gespr\xE4ch starten",
    newButton: "+ Neu",
    selectOrStartNew: "W\xE4hlen Sie eine bestehende Konversation auf der linken Seite oder starten Sie eine neue.",
    selected: "ausgew\xE4hlt",
    groupChat: "Gruppenchat",
    writeMessage: "Nachricht schreiben...",
    sendLabel: "Senden",
    groupNamePlaceholder: "Gruppenname...",
    minimize: "Minimieren",
    openChat: "Chat \xF6ffnen"
  },
  modules: {
    title: "Moduleinstellungen",
    activeCount: "Aktives Modul",
    inactiveCount: "Inaktives Modul",
    totalCount: "Alle Module",
    mandatory: "Pflicht",
    saved: "Gespeichert!",
    categoryCore: "Basis",
    categorySales: "Verkauf",
    categoryService: "Service",
    categoryFinance: "Finanzen",
    categoryIntegration: "Integration",
    moduleRental: "Vermietung",
    moduleRentalDesc: "Ger\xE4tevermietung, R\xFCckgabe, Geb\xFChrenberechnung",
    moduleSales: "Verkauf",
    moduleSalesDesc: "Produktverkauf, POS-Kasse",
    moduleService: "Service",
    moduleServiceDesc: "Service-Arbeitsblatt, Reparatur, Garantie",
    moduleInventory: "Lagerverwaltung",
    moduleInventoryDesc: "Bestand, Inventur, Wareneingang",
    moduleInvoicing: "Rechnungsstellung",
    moduleInvoicingDesc: "Rechnungserstellung, NAV Online",
    modulePartners: "Partnerverwaltung",
    modulePartnersDesc: "Kunden, Lieferanten",
    moduleQuotes: "Angebote",
    moduleQuotesDesc: "Angebote, Konversionen",
    moduleCash: "Kasse",
    moduleCashDesc: "Kassenverwaltung, Tagesabschluss",
    moduleReporting: "Berichte",
    moduleReportingDesc: "KPIs, Auswertungen",
    moduleChat: "Interner Chat",
    moduleChatDesc: "Teamkommunikation",
    moduleBooking: "Online-Buchung",
    moduleBookingDesc: "Ger\xE4tebuchung \xFCber Website",
    moduleCrm: "CRM (Twenty)",
    moduleCrmDesc: "Kundenbeziehungsmanagement",
    moduleHr: "HR (Horilla)",
    moduleHrDesc: "Personalmanagement",
    moduleVehicles: "Fahrzeugregister",
    moduleVehiclesDesc: "Firmen- und Mietfahrzeuge",
    moduleLoyalty: "VIP Treue",
    moduleLoyaltyDesc: "Treueprogramm, Punktesammlung",
    moduleSms: "SMS Gateway",
    moduleSmsDesc: "SMS-Versand, Vorlagen",
    subtitle: "Systemmodule aktivieren oder deaktivieren. \xC4nderungen treten sofort in Kraft.",
    saveButton: "Speichern",
    activeLabel: "Aktiv",
    inactiveLabel: "Inaktiv",
    categoryLabels: {
      core: "Kernmodule",
      domain: "Gesch\xE4ftsmodule",
      integration: "Integrationen"
    },
    categoryDescriptions: {
      core: "Kernmodule f\xFCr den Systembetrieb. K\xF6nnen nicht deaktiviert werden.",
      domain: "Gesch\xE4ftsfunktionen, die einzeln aktiviert/deaktiviert werden k\xF6nnen.",
      integration: "Externe Systemintegrationen."
    },
    moduleNames: {
      auth: "Authentifizierung (Auth)",
      tenant: "Multi-Tenancy",
      audit: "Audit-Trail",
      rental: "Vermietungsmodul",
      sales: "Vertriebsmodul",
      service: "Servicemodul",
      inventory: "Bestandsverwaltung",
      quotation: "Angebotsverwaltung",
      partners: "Partnerverwaltung",
      vehicles: "Fahrzeugverwaltung",
      "nav-online": "NAV Online Rechnungsstellung",
      mypos: "MyPOS Zahlung",
      "szamlazz-hu": "Sz\xE1ml\xE1zz.hu",
      "twenty-crm": "Twenty CRM",
      chatwoot: "rPI Porter",
      "online-booking": "Online-Buchung"
    },
    moduleDescriptions: {
      auth: "Benutzerauthentifizierung, JWT, PIN-Login, RBAC-Zugriffskontrolle.",
      tenant: "Franchise-Netzwerk-Unterst\xFCtzung, Filial-Trennung, RLS-Policies.",
      audit: "Aktivit\xE4ts\xFCberwachung, DSGVO-Konformit\xE4t, Aufbewahrungsmanagement.",
      rental: "Ger\xE4tevermietung, Kautionsverwaltung, Langzeitvertr\xE4ge, Versp\xE4tungsgeb\xFChren.",
      sales: "Produktverkauf, POS-Terminal, NAV Online Rechnungsstellung.",
      service: "Arbeitsblatt-Verwaltung, Garantiereparaturen, Ersatzteilkatalog.",
      inventory: "Bestandsverfolgung, Inventur, Warenannahme, Lagerbewegungen.",
      quotation: "Preiskalkulation, Konversionsverfolgung, PDF-Generierung.",
      partners: "Kunden, Lieferanten, Rabatte, Treueprogramm.",
      vehicles: "Firmen- und Mietfahrzeuge, Dokumente.",
      "nav-online": "NAV Online Rechnungs-API-Integration (in Produktion obligatorisch).",
      mypos: "Zahlungsgateway, Kaution, Kartenzahlungsoptionen.",
      "szamlazz-hu": "API-Integration des Rechnungssystems.",
      "twenty-crm": "CRM-Systemintegration f\xFCr Kundenmanagement.",
      chatwoot: "Kundenservice-Chat und Support.",
      "online-booking": "Online-Service- und Vermietungsbuchungssystem."
    }
  },
  notifications: {
    title: "Benachrichtigungseinstellungen",
    matrix: "Benachrichtigungsmatrix",
    role: "Rolle",
    totalCol: "Gesamt",
    legend: "Legende",
    enabled: "Benachrichtigung aktiviert",
    disabled: "Benachrichtigung deaktiviert",
    roleLabels: {
      admin: "Admin",
      manager: "Manager",
      cashier: "Kassierer",
      technician: "Techniker",
      salesRep: "Vertriebsmitarbeiter",
      warehouseWorker: "Lagermitarbeiter",
      accountant: "Buchhalter",
      viewer: "Leser"
    },
    domainLabels: {
      rental: "Vermietung",
      service: "Service",
      sales: "Verkauf",
      inventory: "Lager",
      finance: "Finanzen",
      partner: "Partner",
      system: "System",
      invoice: "Rechnung"
    },
    subtitle: "Konfigurieren Sie, welche Rollen welche Domain-Benachrichtigungen erhalten.",
    matrixHint: "Klicken Sie auf eine Zelle, um Benachrichtigungen ein-/auszuschalten. Klicken Sie auf die Zeilen-/Spalten\xFCberschrift, um die gesamte Zeile/Spalte umzuschalten.",
    tipText: "Tipp: Klicken Sie auf die Zeilen- oder Spalten\xFCberschrift, um die gesamte Zeile/Spalte auf einmal umzuschalten.",
    vehicle: {
      documentExpiring: {
        subject: "Fahrzeugdokument l\xE4uft ab: {licensePlate} ({documentLabel})",
        title: "Fahrzeugdokument l\xE4uft bald ab",
        body: "Das Dokument {documentLabel} f\xFCr das Fahrzeug {licensePlate} l\xE4uft in {daysUntilExpiry} Tagen ab ({expiryDate}). Bitte rechtzeitig erneuern.",
        cta: "Fahrzeug \xF6ffnen"
      },
      documentExpired: {
        subject: "ABGELAUFENES Fahrzeugdokument: {licensePlate} ({documentLabel})",
        title: "Fahrzeugdokument ABGELAUFEN",
        body: "Das Dokument {documentLabel} f\xFCr das Fahrzeug {licensePlate} ist vor {daysOverdue} Tagen abgelaufen (Ablauf: {expiryDate}). Mit einem abgelaufenen Dokument darf das Fahrzeug nicht rechtm\xE4\xDFig betrieben werden \u2014 sofortiges Handeln erforderlich.",
        cta: "Fahrzeug \xF6ffnen"
      },
      documentTypes: {
        REGISTRATION: "Zulassungsbescheinigung",
        TECHNICAL_INSPECTION: "Hauptuntersuchung",
        KGFB_INSURANCE: "Haftpflichtversicherung (KGFB)",
        CASCO_INSURANCE: "Kasko-Versicherung",
        HIGHWAY_STICKER: "Autobahnvignette"
      }
    },
    partner: {
      loyaltyReward: {
        subject: "Neue Treuepr\xE4mie verf\xFCgbar \u2014 {partnerName}",
        title: "Treuepr\xE4mie freigeschaltet",
        body: "Hallo {partnerName}, Sie haben eine neue Pr\xE4mie im Treueprogramm: {rewardName}. Besuchen Sie unser Gesch\xE4ft zum Einl\xF6sen.",
        cta: "Pr\xE4mie ansehen"
      }
    },
    marketing: {
      seasonal: {
        subject: "{campaignName} \u2014 Sonderangebot",
        title: "{campaignName}",
        body: "{campaignBody} Antworten Sie mit STOP, um sich abzumelden.",
        cta: "Angebot ansehen"
      }
    },
    types: {
      vehicle: {
        document: {
          expiring: {
            label: "Fahrzeugdokument l\xE4uft ab",
            description: "Bevorstehender Ablauf eines Fahrzeugschein-/Pr\xFCf-/Versicherungsdokuments."
          },
          expired: {
            label: "Fahrzeugdokument ABGELAUFEN",
            description: "Abgelaufenes Fahrzeugdokument \u2014 rechtliche Haftung, sofortiges Handeln erforderlich."
          }
        },
        service: {
          due: {
            label: "Fahrzeugwartung f\xE4llig",
            description: "Geplante Wartung steht an (nach Kilometerstand oder Datum)."
          }
        }
      },
      rental: {
        overdue: {
          label: "\xDCberf\xE4llige Vermietung",
          description: "Der Mieter hat das Ger\xE4t nicht bis zur vertraglich vereinbarten Frist zur\xFCckgegeben."
        },
        return: {
          reminder: {
            label: "R\xFCckgabeerinnerung",
            description: "Das Mietende naht (24-72 Stunden) \u2014 Erinnerung senden."
          }
        },
        contract: {
          signed: {
            label: "Mietvertrag unterschrieben",
            description: "Der Mietvertrag wurde elektronisch unterschrieben."
          }
        }
      },
      service: {
        worksheet: {
          ready: {
            label: "Arbeitsblatt fertig",
            description: "Das Service-Arbeitsblatt ist fertig \u2014 Kunden benachrichtigen."
          }
        },
        warranty: {
          expiring: {
            label: "Garantie l\xE4uft bald ab",
            description: "Eine aktive Garantie n\xE4hert sich ihrem Ablauf."
          }
        }
      },
      sales: {
        invoice: {
          issued: {
            label: "Neue Rechnung ausgestellt",
            description: "Eine Rechnung wurde ausgestellt und an NAV gemeldet."
          }
        },
        deliveryNote: {
          signed: {
            label: "Lieferschein unterschrieben",
            description: "Der Lieferschein wurde mit elektronischer Unterschrift abgeschlossen."
          }
        }
      },
      finance: {
        payment: {
          overdue: {
            label: "Rechnung \xFCberf\xE4llig",
            description: "Eine Kundenrechnung ist \xFCberf\xE4llig \u2014 Inkassoprozess starten."
          }
        },
        "cash-close": {
          due: {
            label: "T\xE4glicher Kassenabschluss f\xE4llig",
            description: "Der t\xE4gliche Kassenabschluss ist mit operativer Frist verpflichtend."
          }
        }
      },
      workflow: {
        approval: {
          requested: {
            label: "Genehmigung erforderlich",
            description: "Ein Workflow-Lauf hat einen Genehmigungspunkt erreicht."
          }
        },
        execution: {
          failed: {
            label: "Workflow-Lauf fehlgeschlagen",
            description: "Ein @kgc/workflow-Lauf ist terminal fehlgeschlagen."
          }
        }
      },
      documents: {
        hash: {
          mismatch: {
            label: "Dokumentintegrit\xE4tsfehler",
            description: "Die Hash-Integrit\xE4tspr\xFCfung hat eine Abweichung festgestellt \u2014 m\xF6gliche Manipulation."
          }
        },
        retention: {
          expired: {
            label: "Dokumentaufbewahrung abgelaufen",
            description: "Die DSGVO-Aufbewahrungsfrist ist abgelaufen; das Dokument wurde gel\xF6scht."
          }
        }
      },
      partner: {
        blocklisted: {
          label: "Partner auf Sanktionsliste",
          description: "Der Partner wurde auf eine AML-/Sanktionsliste gesetzt \u2014 Sperrung aktiviert."
        },
        loyaltyReward: {
          label: "Treueprogramm-Belohnung",
          description: "Eine neue Treueprogramm-Belohnung ist verf\xFCgbar \u2014 einwilligungsbasierte Marketingbenachrichtigung (E-93)."
        }
      },
      marketing: {
        seasonal: {
          label: "Saisonales Angebot",
          description: "Periodische Marketingkampagne \u2014 ausdr\xFCckliche Einwilligung erforderlich (E-93 ADR-109 J-1)."
        }
      }
    }
  },
  featureFlags: {
    title: "Feature-Flags",
    subtitle: "Funktionen ein- und ausschalten",
    saveChanges: "\xC4nderungen speichern",
    totalFlags: "Alle Flags",
    enabledFlags: "Aktiviert",
    disabledFlags: "Deaktiviert",
    newBadge: "NEU",
    betaBadge: "BETA",
    updatedAt: "Aktualisiert: {date}",
    dependsOn: "Abh\xE4ngig: {flags}",
    allCategories: "Alle Kategorien",
    enabledOnly: "Nur aktivierte",
    disabledOnly: "Nur deaktivierte",
    searchPlaceholder: "Suchen...",
    infoText: "Feature-Flags erm\xF6glichen das Ein- und Ausschalten von Anwendungsfunktionen. Einige Funktionen k\xF6nnen von anderen abh\xE4ngen.",
    saved: "Gespeichert!",
    allLabel: "Alle",
    noResults: "Keine Ergebnisse mit den angegebenen Filtern",
    searchPlaceholderLong: "Suche (Name, Beschreibung, Schl\xFCssel)...",
    usageTitle: "Feature Flags Verwendung",
    usageDescription: "Feature-Flags erm\xF6glichen das Ein- und Ausschalten von Funktionen in der Anwendung. Einige Flags k\xF6nnen von anderen Flags abh\xE4ngen - diese k\xF6nnen nur aktiviert werden, wenn die Abh\xE4ngigkeit aktiv ist. BETA-gekennzeichnete Funktionen befinden sich noch in der Testphase.",
    dependencyDisabled: "Abh\xE4ngigkeit ist nicht aktiviert",
    totalLabel: "Gesamte Flags"
  },
  equipmentProfit: {
    profitable: "Profitabel",
    lossmaking: "Verlustbringend",
    breakeven: "Kostendeckend",
    missingData: "Fehlende Daten",
    rentalCancelled: "Storniert",
    roi: "Rentabilit\xE4t",
    purchasePrice: "Kaufpreis",
    rentalRevenue: "Mieteinnahmen",
    serviceCost: "Servicekosten",
    profit: "Gewinn",
    rentalHistory: "Miethistorie",
    noRentalHistory: "Keine Miethistorie.",
    ongoing: "laufend",
    loadError: "Fehler beim Laden der Rentabilit\xE4tsdaten."
  },
  ws: {
    connected: "WebSocket: Verbunden",
    connecting: "WebSocket: Verbinde...",
    reconnecting: "WebSocket: Erneut verbinden...",
    disconnected: "WebSocket: Offline",
    clickToReconnect: "Klicken zum Wiederverbinden"
  },
  serviceHistory: {
    close: "Schlie\xDFen",
    issue: "Problem",
    laborCost: "Arbeitskosten",
    loadError: "Fehler beim Laden der Daten",
    loading: "Laden...",
    noHistory: "Keine Servicehistorie",
    partsCost: "Teile",
    resolution: "L\xF6sung",
    title: "Servicehistorie",
    totalCost: "Gesamtkosten",
    totalServices: "Gesamt Services",
    unknownError: "Unbekannter Fehler",
    warranty: "Garantie",
    warrantyBadge: "Garantie",
    serialNumber: "Seriennummer: {serial}",
    statusDraft: "Entwurf",
    statusDiagnosed: "Diagnostiziert",
    statusInProgress: "In Bearbeitung",
    statusWaitingParts: "Warten auf Teile",
    statusCompleted: "Abgeschlossen",
    statusClosed: "Geschlossen"
  },
  stockDetail: {
    availableInPhase2: "Verf\xFCgbar in Phase 2",
    avgMonthlyUsage: "Durchschn. Monatsverbrauch",
    close: "Schlie\xDFen",
    critical: "Kritisch",
    currentStock: "Aktueller Bestand",
    description: "Bestandsdetails und Einkaufsempfehlung",
    lastPurchase: "Letzter Einkauf",
    minimumThreshold: "Minimalschwelle",
    model: "Modell",
    movementHistory30d: "Bewegungshistorie (30 Tage)",
    purchaseHistory: "Einkaufshistorie",
    purchaseRecommendation: "Einkaufsempfehlung",
    recommendedPurchase: "Empfohlener Einkauf: {quantity} Ger\xE4te (f\xFCr Minimum {threshold})",
    serialNumber: "Seriennummer",
    status: "Status",
    tabInfo: "Information",
    tabMovement: "Bewegungshistorie",
    type: "Typ",
    warning: "Warnung",
    quantity: "Menge: {count} Stk.",
    unitCount: "{count} Stk."
  },
  widget: {
    permissions: {
      title: "Dashboard Widget Berechtigungen",
      description: "Konfigurieren Sie, welche Rolle welches Dashboard-Widget sehen kann",
      loadError: "Fehler beim Laden",
      unknownError: "Unbekannter Fehler",
      retry: "Erneut versuchen",
      matrixTitle: "Widget-Matrix",
      matrixDescription: "Die Admin-Rolle sieht immer alle Widgets und kann nicht ge\xE4ndert werden.",
      resetToDefaults: "Auf Standard zur\xFCcksetzen",
      cancel: "Abbrechen",
      pendingChanges: "{count} \xC4nderung(en) ausstehend",
      saving: "Speichern...",
      save: "Speichern",
      saveError: "Fehler beim Speichern",
      resetError: "Fehler beim Zur\xFCcksetzen",
      resetConfirmTitle: "Zur\xFCcksetzen best\xE4tigen",
      resetConfirmDescription: "M\xF6chten Sie wirklich auf die Standardberechtigungen zur\xFCcksetzen? Alle benutzerdefinierten Einstellungen werden gel\xF6scht.",
      resetting: "Zur\xFCcksetzen...",
      reset: "Zur\xFCcksetzen"
    },
    cardExpiry: {
      title: "Kartenablauf",
      ariaLabel: "Kartenablauf-\xDCberwachung",
      loading: "Kartenablaufdaten laden...",
      errorTitle: "Fehler aufgetreten",
      errorMessage: "Kartenablaufdaten konnten nicht geladen werden.",
      alertCount: "Warnung(en)",
      noAlerts: "Keine ablaufenden Kartenwarnungen.",
      urgent: "Dringend",
      warning: "Warnung",
      info: "Information",
      expiredToday: "Heute abgelaufen",
      expiresToday: "L\xE4uft heute ab",
      expiredDaysAgo: "Vor {days} Tag(en) abgelaufen",
      expiresInDays: "L\xE4uft in {days} Tag(en) ab",
      deposit: "Kaution",
      newCard: "Neue Karte",
      newCardRequest: "Neue Kartenanfrage: {partner}",
      newCardStarted: "Neue Kartenanfrage gestartet",
      alertListAria: "{count} Kartenablauf-Warnung(en)"
    },
    equipmentProfit: {
      title: "Ger\xE4te-ROI",
      loadError: "Fehler beim Laden der Daten.",
      avgRoi: "Durchschn. ROI",
      totalRevenue: "Gesamterl\xF6s",
      totalCosts: "Gesamtkosten",
      totalProfit: "Gesamtgewinn",
      totalEquipment: "Gesamtger\xE4te",
      profitable: "Profitabel",
      losing: "Verlustbringend",
      topFive: "Top 5 Profitabelste"
    },
    forecast: {
      title: "Umsatzprognose",
      ariaLabel: "Umsatzprognose",
      loading: "Umsatzprognose laden...",
      error: "Fehler aufgetreten",
      errorDescription: "Umsatzprognose konnte nicht geladen werden.",
      comparedToPreviousMonth: "im Vergleich zum Vormonat",
      sourceBreakdown: "Aufschl\xFCsselung nach Quelle",
      previousMonthActual: "Vormonat tats\xE4chlich",
      sourcePercentage: "{source} ({percentage}%)",
      expectedRevenue: "Erwarteter Umsatz"
    },
    partnerActivity: {
      title: "Partneraktivit\xE4t",
      expandedTitle: "Partneraktivit\xE4t",
      refresh: "Aktualisieren",
      transactions: "Transaktion(en)",
      totalTransactions: "Gesamttransaktionen",
      vsPrevious: "vs Vorperiode",
      rental: "Vermietung",
      rentals: "Vermietungen",
      sales: "Verkauf",
      salesPlural: "Verk\xE4ufe",
      service: "Service",
      date: "Datum",
      totalColumn: "Gesamt"
    },
    partnerOverview: {
      title: "Partner\xFCbersicht",
      refresh: "Aktualisieren",
      last30Days: "(30 Tage)",
      activePartners: "aktive(r) Partner",
      categoryRetail: "Privat",
      categoryB2B: "Gesch\xE4ftlich",
      categoryVIP: "VIP"
    },
    receivables: {
      title: "Forderungsalterung",
      reportTitle: "Forderungsalterungs-Bericht",
      totalReceivables: "Gesamtforderungen",
      bucket0_30: "0-30 Tage",
      bucket31_60: "31-60 Tage",
      bucket61_90: "61-90 Tage",
      bucket90plus: "90+ Tage",
      invoices: "Rechnung(en)",
      topDebtors: "Top 3 Schuldner",
      moreDebtors: "weitere(r) Schuldner",
      noReceivables: "Keine Forderungen",
      loadError: "Fehler beim Laden der Daten.",
      updatedAt: "Aktualisiert",
      total: "Gesamt",
      partnersOwe: "Partner schulden",
      agingBreakdown: "Altersaufschl\xFCsselung",
      ofTotal: "vom Gesamt",
      allDebtors: "Alle Schuldner",
      partner: "Partner",
      debt: "Schulden",
      invoicesHeader: "Rechnungen",
      oldestDueDate: "\xC4ltestes F\xE4lligkeitsdatum",
      overdue: "\xDCberf\xE4llig",
      pcs: "Stk.",
      days: "Tag(e)"
    },
    recurringIssues: {
      title: "Wiederkehrende Probleme",
      refresh: "Aktualisieren",
      problematicEquipment: "problematische(s) Ger\xE4t(e)",
      critical: "kritisch",
      noIssues: "Keine wiederkehrenden Probleme",
      viewServiceHistory: "Servicehistorie f\xFCr {name} anzeigen",
      lastService: "Letzter Service",
      more: "mehr"
    },
    rentalStats: {
      title: "Vermietungsstatistik",
      ariaLabel: "Vermietungsstatistik",
      loading: "Vermietungsstatistik laden...",
      error: "Fehler aufgetreten",
      errorDescription: "Vermietungsstatistik konnte nicht geladen werden.",
      daysPerRental: "Tage / Vermietung",
      comparedToPreviousPeriod: "im Vergleich zur Vorperiode",
      totalRentals: "Gesamtvermietungen",
      active: "Aktiv",
      overdue: "\xDCberf\xE4llig"
    },
    seasonality: {
      title: "Saisonaler Trend",
      titleShort: "Vermietungstrend (12 Monate)",
      ariaLabel: "Saisonaler Trend",
      loading: "Saisonalen Trend laden...",
      error: "Fehler aufgetreten",
      errorDescription: "Saisonaler Trend konnte nicht geladen werden.",
      noData: "Noch nicht gen\xFCgend Daten zur Anzeige des Trends.",
      rentals: "Vermietungen",
      revenue: "Umsatz",
      revenueFt: "Umsatz (HUF)",
      totalRentals: "Gesamtvermietungen:",
      totalRevenue: "Gesamtumsatz:",
      pcs: "Stk."
    },
    serviceProfit: {
      title: "Service-Rentabilit\xE4t",
      loading: "Laden...",
      loadError: "Fehler beim Laden der Daten.",
      avgMargin: "Durchschn. Marge",
      totalRevenue: "Gesamterl\xF6s",
      partsCost: "Teilekosten",
      netProfit: "Nettogewinn",
      worksheets: "Arbeitsbl\xE4tter",
      laborRevenue: "Arbeitserl\xF6s",
      topFiveTechnicians: "Top 5 Techniker (Gewinn)",
      worksheet: "Arbeitsblatt",
      margin: "Marge",
      noData: "Keine Technikerprofitdaten in diesem Zeitraum."
    },
    serviceRevenue: {
      title: "Service-Umsatz",
      periodSelect: "Zeitraum w\xE4hlen",
      refresh: "Aktualisieren",
      periodDay: "Heute",
      periodWeek: "Woche",
      periodMonth: "Monat",
      laborFee: "Arbeitsgeb\xFChr",
      parts: "Teile"
    },
    stockAlert: {
      title: "Bestandswarnungen",
      noShortage: "Kein Bestandsmangel",
      allProductsAdequate: "Alle Produkte auf angemessenem Bestandsniveau",
      totalAlerts: "Gesamtwarnungen",
      critical: "Kritisch",
      warning: "Warnung",
      criticalShortages: "Kritische Engp\xE4sse",
      warnings: "Warnungen",
      model: "Modell",
      type: "Typ",
      current: "Aktuell",
      minimum: "Minimum",
      shortage: "Mangel",
      lastOrder: "Letzte Bestellung",
      status: "Status"
    },
    stockHeatmap: {
      title: "Bestands-Heatmap",
      description: "Bestandsverteilung nach Ger\xE4tetyp und Standort"
    },
    stockMovement: {
      title: "Bestandsbewegungen",
      subtitle: "Bestandsbewegungen - letzte 30 Tage",
      refresh: "Aktualisieren",
      incoming: "Eingehend",
      outgoing: "Ausgehend",
      returns: "R\xFCcknahmen",
      netChange: "Nettover\xE4nderung"
    },
    techWorkload: {
      title: "Techniker-Auslastung",
      refresh: "Aktualisieren",
      worksheetsOf: "Arbeitsbl\xE4tter von",
      more: "weitere",
      moreTechnicians: "weitere(r) Techniker",
      totalTechnicians: "Gesamttechniker",
      active: "aktiv",
      activeWorksheets: "Aktive Arbeitsbl\xE4tter",
      noActiveWorksheets: "Keine aktiven Arbeitsbl\xE4tter",
      priority: {
        low: "Niedrig",
        normal: "Normal",
        high: "Hoch",
        urgent: "Dringend"
      }
    },
    topPartners: {
      title: "Top-Partner",
      expandedTitle: "Top-Partner",
      periodMonth: "Monat",
      periodQuarter: "Quartal",
      periodYear: "Jahr",
      periodSelect: "Zeitraum w\xE4hlen",
      refresh: "Aktualisieren",
      giftEligible: "Geschenkberechtigt",
      morePartners: "weitere(r) Partner",
      period: "Zeitraum",
      partner: "Partner",
      totalRevenue: "Gesamterl\xF6s",
      rental: "Vermietung",
      sales: "Verkauf",
      service: "Service"
    },
    vat: {
      title: "MwSt.-Zusammenfassung",
      ariaLabel: "MwSt.-Zusammenfassung",
      loading: "MwSt.-Zusammenfassung laden...",
      errorTitle: "Fehler aufgetreten",
      errorMessage: "MwSt.-Zusammenfassung konnte nicht geladen werden.",
      payable: "MwSt. f\xE4llig",
      claimable: "Erstattungsf\xE4hige MwSt.",
      outputVat: "Ausgangs-MwSt.",
      inputVat: "Eingangs-MwSt.",
      rateBreakdown: "Satzaufschl\xFCsselung"
    },
    warranty: {
      title: "Garantiequote",
      refresh: "Aktualisieren",
      warranty: "Garantie",
      paid: "Bezahlt",
      repairs: "Reparatur(en)",
      paidRevenue: "Bezahlter Umsatz",
      sixMonthTrend: "6-Monats-Trend",
      trendUp: "steigend",
      trendDown: "sinkend",
      trendStable: "stabil"
    },
    worksheet: {
      title: "Arbeitsbl\xE4tter",
      refresh: "Aktualisieren",
      activeWorksheets: "aktive(s) Arbeitsblatt(-bl\xE4tter)",
      status: {
        draft: "Entwurf",
        diagnosed: "Diagnostiziert",
        inProgress: "In Bearbeitung",
        waitingParts: "Warten auf Teile",
        completed: "Abgeschlossen",
        closed: "Geschlossen"
      }
    },
    emptyState: {
      message: "Kein Widget anzuzeigen",
      hint: "Wenden Sie sich an den Administrator",
      defaultMessage: "Keine Daten verf\xFCgbar",
      defaultHint: "Versuchen Sie andere Filterkriterien."
    },
    partnerCredit: {
      comingSoon: "Demn\xE4chst...",
      featureInProgress: "Feature aktiviert - Implementierung l\xE4uft",
      managementLabel: "Partner-Kreditlimit-Verwaltung",
      title: "Partner-Kreditlimit",
      tooltipDescription: "Partner-Kreditlimit-Verwaltung - zuk\xFCnftiges Epic"
    },
    popularEquipment: {
      ariaLabel: "Beliebte Ger\xE4te",
      error: "Fehler aufgetreten",
      errorDescription: "Beliebte Ger\xE4te konnten nicht geladen werden.",
      loading: "Beliebte Ger\xE4te laden...",
      noData: "Noch nicht gen\xFCgend Mietdaten.",
      rentalCount: "{count} Vermietung(en)",
      title: "Beliebte Ger\xE4te",
      top5Title: "Top 5 Beliebte Ger\xE4te",
      top5Total: "Top 5 gesamt"
    },
    warrantyPlaceholder: {
      comingSoon: "Demn\xE4chst...",
      epicInfo: "In Epic 38 implementiert",
      ratioLabel: "Garantie vs. bezahltes Verh\xE4ltnis",
      title: "Garantiequote",
      tooltipDescription: "Garantie vs. bezahltes Verh\xE4ltnis - in Epic 38"
    },
    error: {
      loadError: "Fehler beim Laden der Daten",
      errorTitle: "Widget-Ladefehler",
      retry: "Erneut versuchen"
    },
    alert: {
      details: "Details"
    },
    stock: {
      critical: "Kritisch",
      warning: "Warnung"
    }
  },
  integration: {
    crm: {
      errorDescription: "Der Twenty CRM-Dienst ist nicht verf\xFCgbar oder der Browser blockiert den iFrame.",
      loading: "Twenty CRM laden...",
      subtitle: "Kundenbeziehungsmanagement"
    },
    hr: {
      errorDescription: "Der Horilla HR-Dienst ist nicht verf\xFCgbar oder der Browser blockiert den iFrame.",
      loading: "Horilla HR laden...",
      subtitle: "Personalverwaltung"
    },
    flow: {
      errorDescription: "rPI Flow ist nicht verf\xFCgbar.",
      loading: "rPI Flow laden...",
      subtitle: "Workflow-Starter & Tracker",
      unavailable: "rPI Flow ist auf diesem Server nicht konfiguriert.",
      publishedWorkflows: "Verf\xFCgbare Workflows",
      noWorkflows: "Keine registrierten Workflows",
      recentExecutions: "Letzte Ausf\xFChrungen",
      noExecutions: "Keine aktiven Ausf\xFChrungen",
      steps: "Schritte",
      tabs: {
        catalog: "Katalog",
        running: "Laufend",
        history: "Verlauf",
        approvals: "Genehmigungen",
        operations: "Operationen"
      },
      running: {
        noExecutions: "Keine laufenden Workflows",
        startOne: "Starten \u2192",
        step: "Schritt"
      },
      health: {
        ok: "OK",
        offline: "Offline",
        workflows: "Workflows",
        running: "laufend",
        approvals: "Genehmigungen",
        schedules: "Zeitpl\xE4ne"
      },
      operations: {
        engineHealth: "Engine-Status",
        online: "Online",
        offline: "Offline",
        registeredWorkflows: "registrierte Workflows",
        dailyStats: "Tagesstatistik",
        totalToday: "Heute gesamt",
        successRate: "Erfolgsrate",
        schedules: "Zeitpl\xE4ne",
        schedulesInfo: "Geplante Workflows werden hier angezeigt"
      },
      schedule: {
        title: "Zeitplan",
        save: "Speichern",
        saved: "\u23F0 Zeitplan gespeichert",
        error: "Zeitplan konnte nicht gespeichert werden",
        daily: "Jeden Tag",
        weekdays: "Werktags",
        weekly: "W\xF6chentlich",
        monthly: "Monatlich",
        custom: "Benutzerdefiniert",
        dayOfMonth: "Tag des Monats",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",
        sunday: "Sonntag"
      },
      approval: {
        approve: "Genehmigen",
        reject: "Ablehnen",
        approved: "Genehmigt",
        rejected: "Abgelehnt",
        error: "Ein Fehler ist aufgetreten",
        noPending: "Keine ausstehenden Genehmigungen \u2705",
        pastDecisions: "Fr\xFChere Entscheidungen",
        requestedBy: "Angefordert von",
        requiredRole: "Erforderliche Rolle",
        reason: "Grund",
        rejectTitle: "Ablehnungsgrund",
        reasonPlaceholder: "Beschreiben Sie den Ablehnungsgrund..."
      },
      history: {
        noExecutions: "Keine fr\xFCheren Ausf\xFChrungen",
        noResults: "Keine Ergebnisse f\xFCr diese Filter",
        startOne: "Starten \u2192",
        filterStatus: "Status",
        filterWorkflow: "Workflow",
        filterPeriod: "Zeitraum",
        periodAll: "Alle",
        periodToday: "Heute",
        periodWeek: "Diese Woche",
        periodMonth: "Dieser Monat",
        restart: "Neu starten"
      },
      toast: {
        completed: "\u2705 {name} abgeschlossen",
        failed: "\u274C {name} fehlgeschlagen"
      },
      execution: {
        details: "Details",
        hideDetails: "Ausblenden",
        parameters: "Parameter",
        cancel: "Abbrechen",
        cancelConfirm: "Sind Sie sicher?",
        cancelled: "{name} abgebrochen",
        keepRunning: "Weiterlaufen lassen"
      },
      status: {
        running: "L\xE4uft",
        pending: "Wartend",
        completed: "Fertig",
        failed: "Fehlgeschlagen",
        cancelled: "Abgebrochen"
      },
      emptyState: {
        running: "Keine laufenden Workflows",
        history: "Keine fr\xFCheren Ausf\xFChrungen",
        approvals: "Keine ausstehenden Genehmigungen",
        operations: "Operationen demn\xE4chst..."
      },
      categories: {
        finance: "Finanzen",
        rental: "Vermietung",
        service: "Service",
        inventory: "Inventar",
        sales: "Verkauf",
        reporting: "Berichte",
        compliance: "Compliance",
        hr: "HR",
        operations: "Operationen"
      },
      startWorkflow: "Starten",
      favorites: "Favoriten",
      pinWorkflow: "Anheften",
      unpinWorkflow: "Losl\xF6sen",
      execute: {
        title: "Workflow starten",
        submit: "Starten",
        success: "{name} gestartet",
        error: "{name} Start fehlgeschlagen",
        steps: "Schritte",
        required: "Pflichtfeld"
      }
    },
    loadFailed: "Laden fehlgeschlagen",
    openInNewTab: "In neuem Fenster \xF6ffnen",
    refresh: "Aktualisieren",
    retry: "Erneut versuchen",
    sso: {
      active: "SSO aktiv",
      connecting: "SSO...",
      fallback: "Manuelle Anmeldung",
      retryButton: "SSO erneut"
    }
  },
  myforge: {
    openInNewTab: "In neuem Fenster \xF6ffnen"
  },
  pwa: {
    close: "Schlie\xDFen",
    install: {
      button: "Installieren",
      description: "Installieren Sie die App auf Ihrem Startbildschirm f\xFCr schnelleren Zugriff!",
      title: "Anwendung installieren"
    },
    notification: {
      description: "Erhalten Sie Benachrichtigungen \xFCber wichtige Ereignisse, Vermietungen und Servicestatus.",
      dismiss: "Nicht jetzt",
      enable: "Aktivieren",
      title: "Benachrichtigungen aktivieren"
    },
    offline: {
      message: "Keine Internetverbindung"
    },
    update: {
      button: "Aktualisieren",
      dismiss: "Sp\xE4ter",
      message: "Neue Version verf\xFCgbar"
    }
  },
  worksheetPrint: {
    downloadPdf: "PDF herunterladen",
    emailPlaceholder: "E-Mail-Adresse",
    emailSendFailed: "E-Mail-Versand fehlgeschlagen",
    emailSent: "E-Mail gesendet",
    errorPrefix: "Fehler",
    generating: "PDF wird generiert...",
    pdfGenerationFailed: "PDF-Generierung fehlgeschlagen",
    pdfTitle: "Arbeitsblatt-PDF",
    print: "Drucken",
    sendEmail: "E-Mail senden",
    sending: "Senden...",
    title: "Arbeitsblatt drucken",
    unknownError: "Fehler: Unbekannter Fehler"
  },
  permission: {
    module: {
      auth: "Authentifizierung",
      users: "Benutzer",
      partners: "Partner",
      inventory: "Bestand",
      rental: "Vermietung",
      sales: "Verkauf",
      service: "Service",
      reports: "Berichte",
      settings: "Einstellungen"
    }
  },
  worksheet: {
    status: {
      felveve: "Aufgenommen",
      folyamatban: "In Bearbeitung",
      varhato: "Wartend",
      felfuggesztve: "Ausgesetzt",
      kesz: "Fertig",
      szamlazando: "Zu fakturieren",
      lezart: "Geschlossen",
      torolve: "Gel\xF6scht"
    },
    stepper: {
      ariaLabel: "Arbeitsablauf-Status",
      cancelled: "Storniert",
      completed: "abgeschlossen",
      current: "aktuell"
    },
    type: {
      fizetos: "Bezahlte Reparatur",
      garancialis: "Garantie",
      berlesi: "Miet-Service",
      karbantartas: "Wartung",
      szerzodeses: "Vertraglich"
    },
    priority: {
      surgos: "Dringend (+20%)",
      felaras: "Aufpreis",
      garancialis: "Garantie",
      franchise: "Franchise",
      normal: "Normal",
      surcharge: "Aufpreis"
    },
    category: {
      powerTool: "Elektrowerkzeug",
      garden: "Gartenger\xE4t",
      construction: "Bauwesen",
      cleaning: "Reinigungsmaschine",
      other: "Sonstige"
    },
    history: {
      created: "Erstellt",
      statusChanged: "Status ge\xE4ndert",
      itemAdded: "Artikel hinzugef\xFCgt",
      itemRemoved: "Artikel entfernt",
      assigned: "Zugewiesen",
      noteAdded: "Notiz hinzugef\xFCgt",
      invoiced: "Fakturiert",
      completed: "Abgeschlossen"
    },
    placeholder: {
      estimatedCost: "z.B. 50000"
    },
    inspectionFee: {
      change: "Pr\xFCfgeb\xFChr \xE4ndern",
      confirm: "Pr\xFCfgeb\xFChr best\xE4tigen",
      confirmed: "Pr\xFCfgeb\xFChr best\xE4tigt",
      overridden: "Pr\xFCfgeb\xFChr \xFCberschrieben",
      override: "Pr\xFCfgeb\xFChr \xFCberschreiben",
      suggested: "Vorgeschlagene Pr\xFCfgeb\xFChr",
      urgent: "Dringlichkeitszuschlag",
      notApplicable: "Nicht anwendbar ({reason})"
    },
    paymentGate: {
      title: "Zahlung der Pr\xFCfgeb\xFChr erforderlich",
      description: "Die Pr\xFCfgeb\xFChr ({amount}) muss bezahlt werden, bevor die Arbeit beginnen kann. Das Ger\xE4t kann erst nach Zahlung einem Techniker zugewiesen werden.",
      markPaid: "Als bezahlt markieren",
      blockInfo: "Arbeit kann ohne Zahlung nicht beginnen"
    },
    pendingPartsBlock: {
      title: "Abschluss gesperrt \u2014 ausstehende Teile",
      description: "{count} ausstehende Teilebeschaffung(en). Das Arbeitsblatt kann nicht abgeschlossen oder geschlossen werden, bis die Teile eintreffen.",
      blockInfo: "Gesperrt wegen ausstehender Teilebeschaffung",
      toast: "Das Arbeitsblatt kann nicht mit ausstehender Teilebeschaffung geschlossen werden."
    },
    inspectionFeeCredit: {
      label: "Gutschrift der Pr\xFCfgeb\xFChr",
      netAfterCredit: "Zahlbar (nach Gutschrift)"
    },
    costAllocation: {
      title: "Kostenaufschl\xFCsselung",
      customerFacing: "Kundenberechnung",
      customerTotal: "Kunden gesamt (netto)",
      internal: "Interne Kosten (Subunternehmer)",
      internalTotal: "Intern gesamt",
      grandTotal: "Gesamtsumme (brutto)",
      vatIncluded: "Inkl. MwSt."
    },
    basket: {
      title: "Arbeitsblatt-Warenkorb",
      addPlaceholder: "Arbeitsblatt-ID oder Nummer...",
      empty: "Warenkorb ist leer",
      clear: "Leeren",
      checkout: "Sammelrechnung",
      checkoutSuccess: "Rechnung generiert",
      warrantyError: "Garantie-Arbeitsbl\xE4tter k\xF6nnen nicht zum Warenkorb hinzugef\xFCgt werden \u2014 Garantiereparaturen werden vom Hersteller/Garantie \xFCber separate Sammelabrechnung abgedeckt."
    },
    supplierSettlement: {
      title: "Lieferanten-Garantieabrechnung",
      subtitle: "Sammelrechnungen f\xFCr Garantiereparaturen an Hersteller generieren",
      filters: "Filter",
      supplier: "Lieferant",
      from: "Zeitraum von",
      to: "Zeitraum bis",
      search: "Suchen",
      filterRequired: "Bitte Lieferant und Zeitraum angeben",
      eligible: "Abrechnungsf\xE4hige Arbeitsbl\xE4tter",
      generateInvoice: "Sammelrechnung generieren",
      generated: "Sammelrechnung erfolgreich generiert!",
      invoiceNumber: "Rechnungsnummer",
      worksheets: "Arbeitsbl\xE4tter",
      wsNumber: "Arbeitsblatt Nr.",
      brand: "Marke",
      completed: "Abgeschlossen"
    },
    procurement: {
      title: "Ersatzteil-Beschaffungsanfragen",
      addRequest: "Neue Anfrage",
      empty: "Keine Beschaffungsanfragen f\xFCr dieses Arbeitsblatt",
      descriptionPlaceholder: "Teilname oder Beschreibung...",
      markOrdered: "Als bestellt markieren",
      markReceived: "Als erhalten markieren",
      status: {
        pending: "Ausstehend",
        ordered: "Bestellt",
        received: "Erhalten",
        cancelled: "Storniert"
      }
    },
    hourlyRateConfig: {
      title: "Service-Stundensatz Konfiguration",
      subtitle: "Stundensatz-Einstellungen pro Maschinenkategorie",
      tableTitle: "Stundensatz pro Kategorie (netto HUF)",
      category: "Kategorie",
      fallbackRate: "Standard",
      configuredRate: "Konfigurierter Satz",
      invalidRate: "Stundensatz darf nicht negativ sein",
      priorityInfo: "Priorit\xE4t: Vertragspartnertarif > konfigurierter Kategorietarif > Standardtabelle > 8.000 HUF"
    },
    markReadyAction: "Arbeit fertig",
    isWarranty: "Garantie",
    suspendAction: "Aussetzen",
    resumeAction: "Fortsetzen",
    suspendedTitle: "Arbeitsblatt ausgesetzt \u2014 zus\xE4tzliche Kosten",
    suspendedDescription: "Bei der Reparatur wurde ein neues Problem entdeckt, das zus\xE4tzliche Kosten verursacht. Warten auf Kundenentscheidung.",
    newQuoteVersion: "Neues Angebot erstellen",
    resumeOriginalScope: "Mit urspr\xFCnglichem Umfang fortfahren",
    technician: {
      title: "Zugewiesene Techniker",
      primary: "Haupttechniker",
      coTech: "Co-Techniker",
      maxReached: "Maximal {max} Co-Techniker k\xF6nnen zugewiesen werden",
      maxCoTechInfo: "Max {max} Co-Techs",
      noAssigned: "Kein Techniker zugewiesen",
      addTechnician: "Techniker hinzuf\xFCgen",
      nameLabel: "Technikername",
      namePlaceholder: "z.B. Hans M\xFCller",
      roleLabel: "Rolle",
      nameRequired: "Technikername ist erforderlich (min. 2 Zeichen)"
    },
    batch: {
      tabTitle: "Gruppenerfassung",
      scanTitle: "Barcode-Scanner",
      scanPlaceholder: "Barcode scannen oder eingeben...",
      worksheetType: "Arbeitsblatt-Typ",
      scannedItems: "Gescannte Artikel",
      createAll: "Alle erstellen",
      results: "Ergebnisse",
      successCount: "{count} erfolgreich erstellt",
      failureCount: "{count} fehlgeschlagen"
    },
    repairType: {
      title: "Reparaturart",
      description: "W\xE4hlen Sie die Reparaturart",
      fizetos: "Kostenpflichtig",
      fizetosDesc: "Kostenpflichtige Reparatur, Pr\xFCfgeb\xFChr kann berechnet werden",
      garancialis: "Garantie",
      garancialisDesc: "Garantiereparatur, keine Pr\xFCfgeb\xFChr anwendbar",
      szerzodeses: "Vertragspartner",
      szerzodesesDesc: "Reparatur f\xFCr Vertragspartner, keine Pr\xFCfgeb\xFChr anwendbar",
      szerzodesesBadge: "Vertragspartner erkannt",
      selected: "Ausgew\xE4hlt: {type}"
    },
    machineCategory: {
      title: "Maschinenkategorie",
      subtitle: "W\xE4hlen Sie den Maschinentyp",
      electricSmall: "Elektrisches Kleinger\xE4t",
      electricLarge: "Elektrisches Gro\xDFger\xE4t",
      petrolHandheld: "Benzin-Handger\xE4t",
      petrolPush: "Benzin-Schubger\xE4t",
      tractor: "Traktor/Aufsitzger\xE4t",
      battery: "Akkubetrieben"
    },
    filter: {
      machineCategory: "Maschinenkategorie",
      allCategories: "Alle Kategorien"
    },
    directRepairBadge: "Sofortreparatur \u2014 unter Kostengrenze",
    costLimitSkip: "Angebotsphase \xFCbersprungen \u2014 gesch\xE4tzte Kosten unter dem Limit",
    tabs: {
      overview: "\xDCbersicht",
      diagnosis: "Diagnose",
      parts: "Teile",
      history: "Verlauf",
      photos: "Fotos",
      warranty: "Garantie",
      noWarranty: "Kein Garantieanspruch f\xFCr dieses Arbeitsblatt."
    },
    closeConfirm: {
      title: "Arbeitsblatt schlie\xDFen",
      warning: "{count} Beschaffungsposten noch offen. Arbeitsblatt trotzdem schlie\xDFen?",
      qty: "{qty} Stk",
      unnamedItem: "Beschaffungsposten",
      confirm: "Trotzdem schlie\xDFen",
      cancel: "Abbrechen",
      status: {
        DRAFT: "Entwurf",
        SUBMITTED: "Eingereicht",
        ORDERED: "Bestellt"
      }
    },
    historyEvents: {
      created: "Arbeitsblatt erstellt",
      received: "Annahme",
      diagnosed: "Diagnose gestartet",
      started: "Reparatur gestartet",
      completed: "Fertiggestellt",
      notified: "Kunde benachrichtigt",
      delivered: "\xDCbergeben",
      closed: "Abgeschlossen",
      empty: "Keine Ereignisse anzuzeigen"
    },
    intakeBatch: {
      count: "{count} Ger\xE4te in einer Annahme",
      current: "dieses Arbeitsblatt",
      error: "Sammelannahme-Daten sind nicht verf\xFCgbar",
      title: "Sammelannahme",
      formTitle: "Sammelannahme von Arbeitsbl\xE4ttern",
      formDesc: "Mehrere Ger\xE4te eines Partners auf einmal, unter einer gemeinsamen Annahme-ID.",
      partnerSection: "Partner ausw\xE4hlen",
      partnerHint: "W\xE4hlen Sie den Partner, zu dem diese Annahme geh\xF6rt.",
      selectedPartner: "Ausgew\xE4hlter Partner: {name}",
      changePartner: "Partner \xE4ndern",
      batchSettings: "Annahme-Einstellungen",
      deviceList: "Ger\xE4te",
      itemHeading: "Ger\xE4t {index}",
      addItem: "Ger\xE4t hinzuf\xFCgen",
      removeItem: "Ger\xE4t entfernen",
      itemCount: "{count} / 26 Ger\xE4te",
      submit: "Annahme erstellen ({count} Ger\xE4te)",
      submitting: "Annahme wird erstellt\u2026",
      successTitle: "Annahme erstellt",
      successDesc: "{count} Arbeitsbl\xE4tter erstellt \u2014 Annahme-ID: {batchId}",
      newBatch: "Neue Annahme",
      listBadge: "Sammel",
      listBadgeHint: "Sammelannahme \u2014 zum Anzeigen der ganzen Charge klicken",
      filterActive: "Sammelannahme-Filter aktiv",
      clearFilter: "Filter l\xF6schen",
      errors: {
        empty: "Mindestens ein Ger\xE4t ist f\xFCr die Annahme erforderlich.",
        tooMany: "H\xF6chstens 26 Ger\xE4te k\xF6nnen in einer Annahme angegeben werden.",
        duplicateSerial: "Doppelte Seriennummer in der Annahme \u2014 jedes Ger\xE4t muss eine eindeutige Seriennummer haben.",
        deviceActive: "Das Ger\xE4t hat bereits ein aktives Arbeitsblatt.",
        partnerRequired: "W\xE4hlen Sie vor dem Absenden einen Partner aus.",
        generic: "Annahme konnte nicht erstellt werden. Bitte versuchen Sie es erneut."
      }
    },
    resolvedPackage: {
      none: "Kein Paket",
      noneDesc: "Diesem Produkt ist derzeit kein aktives Servicepaket zugewiesen."
    },
    viewInvoice: "Rechnung anzeigen",
    billError: {
      alreadyInvoiced: "Der Arbeitsschein wurde bereits abgerechnet.",
      notBillable: "Der Arbeitsschein ist derzeit nicht abrechenbar.",
      warrantyNotBillable: "Garantie-Arbeitsblatt ist nicht fakturierbar (vom Hersteller gedeckt).",
      failed: "Die Rechnung konnte nicht erstellt werden."
    },
    partner: {
      loading: "Partner wird geladen\u2026",
      label: "Partner: {name}",
      unresolved: "Unbekannter Partner ({id})"
    }
  },
  dashboardApp: {
    changelog: {
      categoryFixed: "Korrektur",
      categoryImproved: "Verbesserung",
      categoryNew: "Neue Funktion",
      codeCoverage: "Code-Abdeckung:",
      collapseDetails: "Alle Details zuklappen",
      collapseVersions: "Alle Versionen zuklappen",
      details: "Details",
      expandDetails: "Alle Details aufklappen",
      expandVersions: "Alle Versionen aufklappen",
      failedTests: "fehlgeschlagen",
      filter: "Filter:",
      filterAll: "Alle",
      filterFixed: "Korrekturen",
      filterImproved: "Verbesserungen",
      filterNew: "Neue Funktionen",
      findings: "Ergebnisse",
      fixedIssues: "behoben",
      heading: "\xC4nderungen und Neuigkeiten",
      openIssues: "offen",
      passed: "bestanden",
      relatedTests: "Zugeh\xF6rige Tests",
      reviewFindings: "Code Review Ergebnisse",
      reviewSummary: "Code Review Zusammenfassung",
      severityCritical: "Kritisch",
      severityMajor: "Wichtig",
      severityMinor: "Gering",
      statusFixed: "\u2713 Behoben",
      statusOpen: "\u25CB Offen",
      statusRejected: "\u2014 Abgelehnt",
      subscribe: "Abonnieren",
      subscribeDescription: "Abonnieren Sie unseren Newsletter und erfahren Sie als Erster von neuen Funktionen und Verbesserungen.",
      subscribeTitle: "Bleiben Sie auf dem Laufenden!",
      subtitle: "Verfolgen Sie die Systementwicklungen und neuen Funktionen",
      test: "Test",
      testSummary: "Testzusammenfassung",
      typeMajor: "Hauptversion",
      typeMinor: "Funktionsupdate",
      typePatch: "Fehlerbehebung",
      versions: "Versionen"
    },
    developer: {
      active: "aktiv",
      completed: "Abgeschlossen",
      completionTrend: "Abschlusstrend (Kumulativ)",
      done: "Fertig",
      epicProgress: "Epic Fortschritt (%)",
      epicStorySummary: "Epic & Story Zusammenfassung",
      filterAll: "Alle",
      filterDone: "Fertig",
      filterInProgress: "In Bearbeitung",
      filterLabel: "Filter:",
      filterPlanned: "Geplant",
      inProgress: "In Bearbeitung",
      inProgressEpics: "Laufende Epics",
      noFilterResults: "Keine Ergebnisse f\xFCr diesen Filter",
      noInProgressEpics: "Keine laufenden Epics",
      progress: "Fortschritt",
      storyStatusDistribution: "Story Status Verteilung",
      tabEpics: "Epics",
      tabOverview: "\xDCbersicht",
      tabStories: "Stories",
      totalCompleted: "Gesamt abgeschlossen",
      totalEpics: "Gesamt Epics",
      totalStories: "Gesamt Stories"
    },
    downloads: {
      archive: "Archiv",
      archiveDesc: "Fr\xFChere Exporte",
      comingSoon: "Downloads werden bald verf\xFCgbar sein.",
      download: "Herunterladen \u2192",
      fullStatus: "Vollst\xE4ndiger Status",
      fullStatusDesc: "Alle Daten in einer Datei",
      heading: "Exporte und Berichte",
      progressExport: "Fortschritt Export",
      progressExportDesc: "Epic und Story Fortschrittsdaten",
      reviewSummary: "Review Zusammenfassung",
      reviewSummaryDesc: "Code Review Ergebnisse",
      sprintReport: "Sprint Bericht",
      sprintReportDesc: "Aktueller Sprint Status Export",
      testReport: "Test Bericht",
      testReportDesc: "Testergebnisse und Coverage"
    },
    executive: {
      activeWork: "Aktive Arbeit",
      allStoriesDone: "Alle Stories fertig!",
      done: "Fertig",
      doneEpic: "Fertige Epic",
      fixed: "Behoben",
      inProgress: "In Bearbeitung",
      issues: "Fehler",
      more: "weitere",
      overallProgress: "Gesamtfortschritt",
      projectProgress: "Projektfortschritt",
      recentlyCompletedEpics: "K\xFCrzlich abgeschlossene Epics",
      testSummary: "Testzusammenfassung",
      tests: "Tests",
      totalIssues: "Gesamtfehler"
    },
    workflow: {
      pendingApprovals: "Ausstehende Genehmigungen",
      runningWorkflows: "Laufende Workflows",
      openFlow: "rPI Flow \xF6ffnen",
      refresh: "Aktualisieren"
    },
    knowledge: {
      adrs: "ADRs",
      adrsDesc: "Architecture Decision Records",
      architecture: "Architektur",
      architectureDesc: "Systemarchitektur Dokumentation",
      comingSoon: "Die Wissensbasis wird bald verf\xFCgbar sein.",
      epicDefinitions: "Epic Definitionen",
      epicDefinitionsDesc: "Epic und Story Beschreibungen",
      heading: "Dokumentation",
      prd: "PRD",
      prdDesc: "Product Requirements Document"
    },
    layout: {
      header: {
        refreshButton: "Aktualisieren",
        settingsButton: "Einstellungen",
        statsDone: "fertig",
        statsEpics: "Epics",
        statsStories: "Stories",
        views: {
          changelog: {
            subtitle: "Versionen, \xC4nderungen und Funktionsupdates",
            title: "Neuigkeiten"
          },
          developer: {
            subtitle: "Epic und Story Fortschritt im Detail",
            title: "Entwickleransicht"
          },
          downloads: {
            subtitle: "Exporte und Berichte",
            title: "Downloads"
          },
          executive: {
            subtitle: "Projektstatus und KPIs auf einen Blick",
            title: "F\xFChrungs\xFCbersicht"
          },
          knowledge: {
            subtitle: "Dokumentation und ADRs",
            title: "Wissensbasis"
          },
          qa: {
            subtitle: "Testmetriken und Code Review Ergebnisse",
            title: "QA Ansicht"
          },
          statistics: {
            subtitle: "Detaillierte Projektmetriken und Analytik",
            title: "Statistiken"
          }
        }
      },
      sidebar: {
        collapse: "Zuklappen",
        darkMode: "Dunkelmodus",
        lightMode: "Hellmodus",
        logoSubtitle: "rPI ERP Dashboard",
        logoTitle: "rPI ERP",
        mobileLogoSubtitle: "KGC ERP Dashboard",
        mobileLogoTitle: "MyForgeOS",
        refresh: "Aktualisieren",
        refreshData: "Daten aktualisieren",
        refreshing: "Aktualisierung...",
        sectionUtilities: "Werkzeuge",
        sectionViews: "Ansichten",
        themeToggle: "Design wechseln",
        utilities: {
          changelog: {
            description: "Versionen und \xC4nderungen",
            name: "Neuigkeiten"
          },
          downloads: {
            description: "Exporte und Berichte",
            name: "Downloads"
          },
          knowledge: {
            description: "Dokumentation und ADRs",
            name: "Wissensbasis"
          }
        },
        views: {
          developer: {
            description: "Sprint und Story Details",
            name: "Developer"
          },
          executive: {
            description: "F\xFChrungs\xFCbersicht und KPIs",
            name: "Executive"
          },
          qa: {
            description: "Test und Qualit\xE4tsmetriken",
            name: "QA"
          },
          statistics: {
            description: "Detaillierte Analytik und Diagramme",
            name: "Statistiken"
          }
        }
      }
    },
    qa: {
      allEpics: "Alle Epics",
      allPackages: "Alle Pakete",
      avgCoverage: "Durchschn. Coverage",
      claudeVsGemini: "Claude vs Gemini Vergleich",
      collapseAll: "\u25B2 Zuklappen",
      consensus: "Konsens",
      coverageByPackage: "Coverage nach Paket",
      coveragePercent: "Coverage %",
      critical: "Kritisch",
      deferred: "Zur\xFCckgestellt",
      expandAll: "\u25BC Aufklappen",
      failed: "Fehlgeschlagen",
      failingTests: "Fehlgeschlagene Tests",
      filter: "Filter:",
      filterAll: "Alle",
      filterCritical: "\u{1F534} Kritisch",
      filterFailed: "\u2717 Fehlgeschlagen",
      filterFixed: "\u2713 Behoben",
      filterOpen: "\u25CB Offen",
      filterPassed: "\u2713 Bestanden",
      fixed: "Behoben",
      found: "Gefunden",
      heading: "QA Dashboard",
      high: "Hoch",
      inProgressRound: "In Bearbeitung",
      issueResolutionFlow: "Issue Resolution Ablauf",
      issues: "Fehler",
      low: "Niedrig",
      medium: "Mittel",
      noFilterResults: "Keine Ergebnisse f\xFCr diesen Filter",
      open: "Offen",
      passRate: "Erfolgsrate %",
      passed: "Bestanden",
      qualityScore: "Qualit\xE4tspunktzahl",
      reviewIssues: "Review Fehler",
      reviewSummary: "Review Zusammenfassung",
      runTime: "Laufzeit",
      severityDistribution: "Fehler Schweregrad Verteilung",
      skipped: "\xDCbersprungen",
      statusDeferred: "\u21B7 Zur\xFCckgestellt",
      statusFixed: "\u2713 Behoben",
      statusOpen: "\u25CB Offen",
      statusWontfix: "\u2014 Wird nicht behoben",
      subtitle: "Testmetriken, Code Review und Qualit\xE4tssicherung - aus echten BMAD Daten",
      tabOverview: "\xDCbersicht",
      tabReviews: "Reviews",
      tabTests: "Tests",
      test: "Tests",
      testResultsByPackage: "Testergebnisse nach Paket",
      trendTitle: "Erfolgsrate & Coverage Trend",
      verdictApproved: "\u2705 Genehmigt",
      verdictApprovedWithFixes: "\u2705 Genehmigt (mit Korrekturen)",
      verdictInProgress: "\u{1F504} In Bearbeitung",
      verdictRejected: "\u274C Abgelehnt"
    },
    statistics: {
      activeStories: "Aktive Stories",
      actual: "Tats\xE4chlich",
      average: "Durchschnitt",
      averageFixRate: "Durchschnittliche Fix-Rate",
      avgStoriesPerEpic: "Durchschn. Stories/Epic",
      claudeVsGemini: "Claude vs Gemini Vergleich",
      codeReviewAnalytics: "Code Review Analytik",
      completedStories: "Abgeschlossene Stories",
      completionRate: "Abschlussrate",
      consensusRate: "Konsensrate",
      done: "Fertig",
      epicCompletionTimeline: "Epic Abschluss Timeline",
      epicOverview: "Epic \xDCbersicht",
      epicStatusDistribution: "Epic Status Verteilung",
      fixRate: "Fix-Rate",
      fixed: "Behoben",
      found: "Gefunden",
      heading: "Statistiken",
      ideal: "Ideal",
      inProgress: "In Bearbeitung",
      openIssues: "Offene Fehler",
      passRate: "Bestehensrate",
      projectHealth: "Projektgesundheit",
      projectProgress: "Projektfortschritt",
      remaining: "Verbleibend",
      remainingStories: "Verbleibende",
      severityDistribution: "Fehler Schweregrad Verteilung",
      sprintProgress: "Sprint Fortschritt",
      storyDistributionByEpic: "Story Verteilung nach Epic",
      subtitle: "Detaillierte Projektmetriken und Analytik",
      teamPerformance: "Teamleistung",
      testCoverage: "Testabdeckung",
      testMetrics: "Testmetriken",
      testTypeDistribution: "Test Typ Verteilung",
      totalIssues: "Gesamtfehler",
      totalStories: "Gesamt Stories",
      uniqueFindings: "Einzigartige Ergebnisse"
    },
    drawer: {
      done: "fertig",
      epicDetails: "Epic Details",
      fixed: "Behoben",
      foundIssues: "Gefundene Fehler",
      issues: "Fehler",
      noSubtasks: "Keine Unteraufgaben",
      progress: "Fortschritt",
      remaining: "verbleibend",
      reviewDetails: "Review Details",
      severity: "Schweregrad",
      storyDetails: "Story Details",
      tasks: "Aufgaben"
    }
  },
  notification: {
    newRental: {
      message: "{partner} - {count} Positionen",
      title: "Neue Vermietung"
    },
    paymentError: {
      message: "Transaktion abgelehnt ({amount})",
      title: "Zahlungsfehler"
    },
    stockShortage: {
      message: "{productName} Bestand auf kritischem Niveau (< 50%)",
      title: "Lagerengpass"
    },
    urgentWorksheet: {
      message: "Neues dringendes Arbeitsblatt ({number}) erstellt",
      title: "Dringendes Arbeitsblatt"
    }
  },
  permissions: {
    auth: {
      login: "Anmeldung",
      loginDesc: "Systemanmeldung",
      pin: "PIN-Anmeldung",
      pinDesc: "Schnelle PIN-Anmeldung"
    },
    users: {
      read: "Benutzer anzeigen",
      readDesc: "Benutzerliste und Profile anzeigen",
      create: "Benutzer erstellen",
      createDesc: "Neuen Benutzer registrieren",
      update: "Benutzer bearbeiten",
      updateDesc: "Benutzerdaten \xE4ndern",
      delete: "Benutzer l\xF6schen",
      deleteDesc: "Benutzerkonto deaktivieren",
      roles: "Rollenverwaltung",
      rolesDesc: "Rollen und Berechtigungen konfigurieren"
    },
    partners: {
      read: "Partner anzeigen",
      readDesc: "Partnerliste und Details anzeigen",
      create: "Partner erstellen",
      createDesc: "Neuen Partner registrieren",
      update: "Partner bearbeiten",
      updateDesc: "Partnerdaten \xE4ndern",
      delete: "Partner l\xF6schen",
      deleteDesc: "Partner deaktivieren"
    },
    rental: {
      read: "Vermietungen anzeigen",
      readDesc: "Vermietungsliste und Details anzeigen",
      create: "Vermietung erstellen",
      createDesc: "Neue Vermietung erstellen",
      return: "Vermietung zur\xFCcknehmen",
      returnDesc: "Ger\xE4ter\xFCckgabe verarbeiten",
      extend: "Vermietung verl\xE4ngern",
      extendDesc: "Mietdauer verl\xE4ngern"
    },
    sales: {
      read: "Verk\xE4ufe anzeigen",
      readDesc: "Verkaufsliste und Details",
      create: "Verkauf erstellen",
      createDesc: "Neuen Verkauf erfassen",
      discount: "Rabatt gew\xE4hren",
      discountDesc: "Rabatt auf Verkauf anwenden",
      refund: "R\xFCckerstattung",
      refundDesc: "R\xFCckerstattung verarbeiten"
    },
    service: {
      read: "Arbeitsbl\xE4tter anzeigen",
      readDesc: "Service-Arbeitsblatt Liste und Details",
      create: "Arbeitsblatt erstellen",
      createDesc: "Neues Service-Arbeitsblatt \xF6ffnen",
      update: "Arbeitsblatt bearbeiten",
      updateDesc: "Arbeitsblattdaten \xE4ndern",
      close: "Arbeitsblatt schlie\xDFen",
      closeDesc: "Service-Arbeitsblatt abschlie\xDFen"
    },
    settings: {
      read: "Einstellungen anzeigen",
      readDesc: "Systemeinstellungen anzeigen",
      update: "Einstellungen \xE4ndern",
      updateDesc: "Systemeinstellungen bearbeiten"
    },
    inventory: {
      read: "Bestand anzeigen",
      readDesc: "Bestandsliste und Details",
      adjust: "Bestand korrigieren",
      adjustDesc: "Bestandsmenge \xE4ndern",
      receive: "Wareneingang",
      receiveDesc: "Wareneingang verarbeiten",
      transfer: "Lager\xFCbertragung",
      transferDesc: "Bestand zwischen Lagern \xFCbertragen"
    },
    reports: {
      rental: "Vermietungsberichte",
      rentalDesc: "Vermietungsstatistiken und Berichte",
      sales: "Verkaufsberichte",
      salesDesc: "Verkaufsstatistiken und Berichte",
      financial: "Finanzberichte",
      financialDesc: "Finanzzusammenfassungen und Abschl\xFCsse",
      inventory: "Bestandsberichte",
      inventoryDesc: "Bestandsstatistiken und Inventurberichte"
    }
  },
  courier: {
    title: "Kurierdienst Lieferungen",
    titleSingle: "Lieferungsdetails",
    newDelivery: "Neue Lieferung",
    noDeliveries: "Keine Lieferungen",
    notFound: "Lieferung nicht gefunden",
    noCourierYet: "Noch kein Kurier zugewiesen",
    deliveryInfo: "Lieferinformationen",
    courierInfo: "Kurierdetails",
    paymentSection: "Zahlung",
    paymentPendingInfo: "Zahlung ausstehend",
    paymentDescription: "Zahlungsbeschreibung",
    createPaymentLink: "Zahlungslink erstellen",
    handoff: "\xDCbergabe",
    markDelivered: "Als zugestellt markieren",
    cancel: "Abbrechen",
    statusLabel: "Status",
    statusProgress: "In Bearbeitung",
    providerLabel: "Anbieter",
    trackingLabel: "Sendungsnummer",
    addressLabel: "Adresse",
    costLabel: "Kosten",
    scheduledLabel: "Geplant",
    createdAtLabel: "Erstellt",
    deliveredAtLabel: "Zugestellt",
    handoffAtLabel: "\xDCbergeben",
    worksheetIdLabel: "Arbeitsblatt",
    enterProvider: "Anbieter eingeben",
    enterTracking: "Sendungsnummer eingeben",
    enterAmount: "Betrag eingeben",
    statusLabels: {
      requested: "Angefordert",
      paymentPending: "Zahlung ausstehend",
      paid: "Bezahlt",
      dispatched: "Versendet",
      delivered: "Zugestellt",
      cancelled: "Storniert"
    },
    cancelDelivery: "Lieferung stornieren"
  },
  releaseHub: {
    title: "rPI Delta",
    subtitle: "Neueste \xC4nderungen und Verbesserungen",
    tabs: {
      changelog: "\xC4nderungsprotokoll",
      testing: "Release-Tests"
    },
    changelog: {
      version: "Version",
      date: "Datum",
      changes: "\xC4nderungen",
      expandAll: "Alle erweitern",
      collapseAll: "Alle reduzieren",
      types: {
        feature: "Neue Funktion",
        fix: "Fehlerbehebung",
        improvement: "Verbesserung",
        breaking: "Wichtige \xC4nderung"
      },
      testStepsBadge: "Testschritte",
      noEntries: "Noch keine Eintr\xE4ge."
    },
    testing: {
      summary: "Gesamt",
      features: "Funktionen",
      steps: "Schritte",
      expected: "Erwartetes Ergebnis",
      status: {
        passed: "Bestanden",
        failed: "Fehlgeschlagen",
        not_tested: "Nicht getestet"
      },
      progress: "{done}/{total} getestet",
      exportCsv: "CSV Export",
      changelogBadge: "\xC4nderungsprotokoll",
      testedBy: "Getestet von",
      comment: "Kommentar (optional)...",
      save: "Speichern",
      noTests: "Keine Testschritte f\xFCr diese Version.",
      retest: "Erneut testen",
      retestNote: "Grund f\xFCr erneuten Test (optional)...",
      retestConfirm: "Erneuten Test starten",
      retestCancel: "Abbrechen",
      lastTest: "Letzter",
      testers: "Tester",
      retestCount: "{count}x getestet",
      history: "Testverlauf",
      historyEmpty: "Keine fr\xFCheren Testl\xE4ufe.",
      historyError: "Testverlauf konnte nicht geladen werden.",
      historyRetry: "Erneut versuchen",
      saveError: "Speichern fehlgeschlagen. Bitte erneut versuchen.",
      retestError: "Erneuter Test konnte nicht gestartet werden.",
      retestReason: "Grund",
      notTestedYet: "Noch nicht getestet",
      showSteps: "{count} Testschritte anzeigen",
      hideSteps: "{count} Testschritte",
      previousTests: "{count} vorherige",
      noPreviousTests: "0 vorherige",
      retestNeeded: "Erneuter Test erforderlich",
      passBtn: "Bestanden",
      failBtn: "Fehlgeschlagen",
      untested: "Nicht getestet",
      testedPct: "{done}/{total} getestet ({pct}%)",
      historyTestedAt: "Getestet",
      historyActiveFor: "{duration} aktiv",
      historyStepStats: "{checked}/{total} Schritte abgehakt",
      durationMinutes: "{n} Min.",
      durationHours: "{n} Std.",
      durationDays: "{n} Tage"
    },
    filters: {
      search: "Suchen...",
      showOlder: "\xC4ltere Versionen ({count})",
      clearFilters: "Filter l\xF6schen",
      results: "{filtered}/{total} Eintr\xE4ge",
      noResults: "Keine Ergebnisse f\xFCr diese Filter.",
      categories: "Kategorie",
      types: "Typ",
      statuses: "Status"
    }
  },
  quote: {
    advance: {
      amount: "Vorschussbetrag",
      confirm: "Vorschuss best\xE4tigen",
      deducted: "Abgezogen",
      exceedsTotal: "Vorschuss \xFCbersteigt Gesamtbetrag",
      invalidAmount: "Ung\xFCltiger Betrag",
      method: "Zahlungsmethode",
      methodCard: "Karte",
      methodCash: "Bargeld",
      methodTransfer: "\xDCberweisung",
      paid: "Vorschuss bezahlt",
      paidAt: "Bezahlt am",
      pay: "Vorschuss zahlen",
      payDescription: "Vorschusszahlung erfassen",
      recordFailed: "Vorschusserfassung fehlgeschlagen",
      recorded: "Vorschuss erfasst",
      refund: "Vorschuss erstatten",
      refundBtn: "Erstatten",
      refundConfirm: "Erstattung best\xE4tigen",
      refundFailed: "Erstattung fehlgeschlagen",
      refunded: "Erstattet",
      refundedLabel: "Erstattet"
    }
  },
  priLlm: {
    apiKeyPlaceholder: "Neuen API-Schl\xFCssel eingeben...",
    userPerMin: "Benutzer / Minute",
    tenantPerMin: "Tenant / Minute",
    userPerDay: "Benutzer / Tag",
    sonnetPerMin: "Sonnet / Minute",
    requests: "Anfragen",
    inputTokens: "Eingabe-Token",
    outputTokens: "Ausgabe-Token",
    costUsd: "Kosten (USD)",
    title: "pRI-Assistent Einstellungen",
    apiConfigTitle: "API-Konfiguration",
    apiConfigDesc: "LLM-Anbieter- und API-Schl\xFCssel-Einstellungen",
    providerLabel: "Anbieter",
    apiKeyLabel: "API-Schl\xFCssel",
    currentKeyLabel: "Aktuell:",
    enabledLabel: "pRI aktiviert",
    enabledDesc: "LLM-Antworten f\xFCr Benutzer aktivieren",
    testConnection: "Verbindung testen",
    testOk: "OK \u2014 {model} ({latencyMs}ms)",
    testFailed: "Fehlgeschlagen",
    rateLimitTitle: "Rate-Limiting & Kontingente",
    rateLimitDesc: "Beschr\xE4nkungen auf Benutzer- und Mandantenebene",
    monthlyQuotasTitle: "Monatliche Kontingente (Anfragen/Monat)",
    tierStrategyTitle: "Tarifstufen-Strategie",
    defaultTierLabel: "Standard-Tarifstufe",
    autoDowngradeLabel: "Automatische Herabstufung",
    autoDowngradeDesc: "Wechselt nach Erreichen des Kontingents zu einer g\xFCnstigeren Stufe",
    usageStatsTitle: "Nutzungsstatistiken",
    usageStatsDesc: "Aggregierte Daten f\xFCr den aktuellen Monat",
    noUsageData: "Keine Nutzungsdaten f\xFCr diesen Monat.",
    saveButton: "Einstellungen speichern",
    saveSuccessTitle: "Gespeichert",
    saveSuccessDesc: "pRI-Einstellungen erfolgreich aktualisiert.",
    saveErrorTitle: "Fehler",
    unknownError: "Unbekannter Fehler.",
    networkError: "Netzwerkfehler"
  },
  goodsReceipt: {
    detail: {
      backToList: "Zur\xFCck zur Liste",
      notFound: "Wareneingang nicht gefunden",
      completeConfirm: "Wareneingang abschlie\xDFen? Bestand wird aktualisiert.",
      completing: "Wird abgeschlossen...",
      complete: "Abschlie\xDFen",
      unresolvedCount: "{count} ungel\xF6ste Abweichung(en)",
      supplier: "Lieferant",
      createdAt: "Erstellt am",
      completedAt: "Abgeschlossen am",
      linkedAvizo: "Verkn\xFCpfter Lieferavis",
      notes: "Anmerkungen",
      items: "Positionen",
      productCode: "Artikelnummer",
      productName: "Produkt",
      expectedQty: "Erwartet",
      receivedQty: "Erhalten",
      difference: "Differenz",
      ok: "OK",
      discrepancies: "Abweichungen",
      expected: "Erwartet",
      actual: "Tats\xE4chlich",
      resolved: "Gel\xF6st",
      resolutionNotePlaceholder: "L\xF6sungshinweis...",
      resolveButton: "L\xF6sen"
    },
    statusLabels: {
      draft: "Entwurf",
      inProgress: "In Bearbeitung",
      discrepancy: "Abweichung",
      completed: "Abgeschlossen"
    },
    discrepancyTypes: {
      shortage: "Fehlmenge",
      surplus: "\xDCberschuss",
      damaged: "Besch\xE4digt",
      wrong_item: "Falscher Artikel"
    },
    shipping: {
      title: "Versandkosten-Verteilung",
      costLabel: "Versandkosten",
      costPlaceholder: "z.B. 15000",
      distribute: "Verteilen",
      allocationTitle: "Versandkosten-Zuweisung",
      originalPrice: "Urspr\xFCnglicher St\xFCckpreis",
      proportion: "Anteil",
      allocation: "Versandkosten",
      adjustedPrice: "Angepasster St\xFCckpreis"
    },
    form: {
      title: "Neuer Wareneingang",
      linkAvizo: "Mit Avis verkn\xFCpfen",
      noAvizo: "Kein Avis",
      itemsLabel: "Positionen",
      avizoHint: "W\xE4hlen Sie ein ausstehendes Avis, um die Positionen automatisch auszuf\xFCllen",
      supplier: "Lieferant",
      supplierPlaceholder: "Lieferant suchen\u2026",
      notes: "Notiz",
      notesPlaceholder: "Notiz zum Wareneingang\u2026",
      items: "Positionen",
      addItem: "Position hinzuf\xFCgen",
      productCode: "Artikelnummer",
      productCodePlaceholder: "z. B. 12345",
      productName: "Bezeichnung",
      productNamePlaceholder: "Produktname",
      expectedQty: "Erwartete Menge",
      receivedQty: "Erhaltene Menge",
      unitPrice: "Einzelpreis",
      purchaseCategory: "Einkaufskategorie",
      locationCode: "Lagerplatz-Code",
      locationPlaceholder: "z. B. A-01-02",
      packageSplitting: "Verpackungsaufteilung",
      packageQty: "Paketmenge",
      unitsPerPackage: "Einheiten pro Paket",
      totalUnits: "Gesamteinheiten",
      categories: {
        aru: "Ware",
        beruhazas: "Investition",
        berendezes: "Ausstattung",
        egyeb: "Sonstiges",
        rezsi: "Betriebskosten"
      }
    },
    allStatuses: "Alle Status",
    hasDiscrepancy: "Mit Abweichung",
    newReceipt: "Neuer Wareneingang",
    noAvizos: "Keine Avise",
    noReceipts: "Keine Wareneing\xE4nge",
    searchPlaceholder: "Suche nach Artikelnummer, Lieferant\u2026",
    subtitle: "Wareneing\xE4nge und Avise verwalten",
    title: "Wareneing\xE4nge",
    avizo: {
      expectedDate: "Erwartetes Datum",
      itemCount: "Anzahl Positionen",
      notes: "Notiz",
      startReceipt: "Wareneingang starten",
      supplier: "Lieferant"
    },
    stats: {
      completedThisMonth: "Abgeschlossen (diesen Monat)",
      inProgress: "In Bearbeitung",
      total: "Gesamt",
      withDiscrepancy: "Mit Abweichung"
    },
    table: {
      discrepancy: "Abweichung",
      itemCount: "Positionen",
      receiptNumber: "Belegnr.",
      receivedDate: "Eingangsdatum",
      supplier: "Lieferant"
    },
    tabs: {
      avizos: "Avise",
      receipts: "Wareneing\xE4nge"
    }
  },
  packages: {
    title: "Pakete",
    subtitle: "Produkt- und Servicepakete verwalten",
    createNew: "Neues Paket",
    editPackage: "Paket bearbeiten",
    editor: {
      sharedBanner: "Dieses Paket ist mit {count} Maschinen geteilt. \xC4nderungen betreffen alle.",
      conflictTitle: "Paket geteilt",
      conflictSubtext: "\xC4nderungen betreffen alle Maschinen. Wie m\xF6chtest du fortfahren?",
      conflictApplyAll: "Auf alle anwenden",
      conflictApplyAllDesc: "Das Master-Paket wird aktualisiert. Alle verkn\xFCpften Maschinen sehen die neue Version.",
      conflictCopyForThis: "Nur f\xFCr diese",
      conflictCopyForThisDesc: "F\xFCr die ausgew\xE4hlte Maschine wird ein neues Varianten-Paket erstellt. Andere Maschinen behalten das unver\xE4nderte Master. Hinweis: deine aktuellen \xC4nderungen werden NICHT in die Variante \xFCbernommen \u2014 dort erneut bearbeiten.",
      conflictForking: "Variante wird erstellt...",
      conflictCopyTargetPlaceholder: "Maschine w\xE4hlen...",
      conflictCopyTargetAriaLabel: "Zielmaschine f\xFCr den Fork"
    },
    editorSubtitle: "Paket zusammenstellen und Preise konfigurieren",
    packageCode: "Paketcode",
    packageCodePlaceholder: "z.B. PKG-001",
    packageName: "Paketname",
    packageNamePlaceholder: "z.B. Basis-Mietpaket",
    noPackages: "Keine Pakete",
    searchPlaceholder: "Suche nach Name oder Code...",
    displayedCount: "{count} Pakete angezeigt",
    copy: "Kopieren",
    basicInfo: "Grunddaten",
    scopeLabel: "Geltungsbereich",
    descriptionPlaceholder: "Paketbeschreibung...",
    packageItems: "Paketpositionen",
    noItems: "Noch keine Positionen. Suchen Sie Produkte im rechten Panel.",
    moveUp: "Nach oben",
    moveDown: "Nach unten",
    productSearch: "Produktsuche",
    searchProductPlaceholder: "Suche nach Produktname oder Artikelnr...",
    noSearchResults: "Keine Ergebnisse",
    alreadyAdded: "Hinzugef\xFCgt",
    pricing: "Preisgestaltung",
    pricingModelLabel: "Preismodell",
    fixedPriceLabel: "Festpreis",
    discountPercentLabel: "Rabatt (%)",
    validFrom: "G\xFCltig ab",
    validUntil: "G\xFCltig bis",
    calculator: "Kalkulator",
    itemsTotal: "Positionen gesamt",
    packagePriceLabel: "Paketpreis",
    savingsLabel: "Ersparnis",
    itemCount: "{count} Positionen",
    expired: "Abgelaufen",
    daysLeft: "{count} Tage verbleibend",
    type: {
      rental: "Vermietung",
      sales: "Verkauf",
      service: "Service",
      mixed: "Gemischt",
      promotional: "Aktion",
      franchise: "Franchise"
    },
    status: {
      active: "Aktiv",
      inactive: "Inaktiv",
      draft: "Entwurf"
    },
    pricingModel: {
      fixed: "Festpreis",
      discounted: "Rabattiert",
      tiered: "Gestaffelt"
    },
    scopeValue: {
      central: "Zentral",
      local: "Lokal"
    },
    itemType: {
      product: "Produkt",
      service: "Service",
      rental_equipment: "Mietger\xE4t"
    },
    upsell: {
      banner: "Wussten Sie?",
      cheaperBy: "ist im Paket {percent}% guenstiger!",
      contents: "Paketinhalt",
      individually: "Einzeln",
      inPackage: "Im Paket",
      perDay: "/Tag",
      choosePackage: "Paket waehlen",
      keepIndividual: "Einzelauswahl beibehalten",
      savings: "Ersparnis",
      savingsPercent: "{percent}% Ersparnis"
    },
    linkedCategories: "Verkn\xFCpfte Ger\xE4tekategorien",
    linkedCategoriesDesc: "F\xFCr welche Ger\xE4tetypen soll dieses Paket vorgeschlagen werden",
    scope: {
      sectionTitle: "Paketumfang",
      mode: {
        category: "Nach Kategorie",
        equipment: "Spezifische Mietger\xE4te"
      },
      switchConfirmTitle: "Modus wechseln?",
      switchConfirmBody: "Die aktuell ausgew\xE4hlten {count} Element(e) gehen beim Wechsel verloren.",
      switchConfirmOk: "Ja, wechseln",
      switchConfirmCancel: "Abbrechen",
      equipment: {
        selectedTitle: "Ausgew\xE4hlte Mietger\xE4te ({count})",
        selectedEmpty: "Noch keine Mietger\xE4te ausgew\xE4hlt",
        searchTitle: "Mietger\xE4tesuche",
        searchPlaceholder: "Name oder Artikelnummer...",
        searchEmpty: "Keine Ergebnisse",
        alreadyAdded: "Bereits hinzugef\xFCgt",
        add: "Hinzuf\xFCgen",
        remove: "Entfernen"
      },
      validationError: {
        categoryRequired: "Mindestens 1 Kategorie erforderlich",
        equipmentRequired: "Mindestens 1 Mietger\xE4t erforderlich"
      }
    },
    productDetail: {
      linkedPackagesTitle: "Dieses Mietger\xE4t erscheint in folgenden Paketen:"
    },
    item: {
      category: "Kategorie",
      categoryOption: {
        free: "Kostenlos",
        rentable: "Mietbar",
        consignment: "Kommission"
      },
      defaultQuantity: "Standardmenge",
      isQuantityEditable: "Menge \xE4nderbar",
      visibleOnWebshop: "Im Webshop sichtbar"
    }
  },
  manufacturing: {
    title: "Fertigung",
    bom: {
      title: "St\xFCckliste (BOM)",
      subtitle: "St\xFCcklisten verwalten und bearbeiten",
      bomCode: "BOM-Code",
      createNew: "Neue BOM",
      editBom: "BOM bearbeiten",
      editorSubtitle: "St\xFCckliste zusammenstellen und Komponenten verwalten",
      basicInfo: "Grunddaten",
      outputProduct: "Ausgangsprodukt",
      outputQuantity: "Ausgangsmenge",
      searchOutputProduct: "Ausgangsprodukt suchen...",
      descriptionPlaceholder: "BOM-Beschreibung...",
      validFrom: "G\xFCltig ab",
      validUntil: "G\xFCltig bis",
      components: "Komponenten",
      noLines: "Noch keine Komponenten. Suchen und \xFCber das rechte Panel hinzuf\xFCgen.",
      addComponent: "Komponente hinzuf\xFCgen",
      searchComponentPlaceholder: "Produkt suchen (Name, SKU)...",
      noSearchResults: "Keine Ergebnisse gefunden",
      alreadyAdded: "Bereits hinzugef\xFCgt",
      lineCount: "{count} Komponenten",
      displayedCount: "{count} BOMs angezeigt",
      noBoms: "Keine St\xFCcklisten gefunden",
      searchPlaceholder: "Nach Code oder Beschreibung suchen...",
      optional: "Optional",
      required: "Erforderlich",
      toggleOptional: "Optional/Erforderlich umschalten",
      moveUp: "Nach oben",
      moveDown: "Nach unten"
    },
    productionOrder: {
      title: "Fertigungsauftr\xE4ge",
      subtitle: "Fertigungsauftr\xE4ge verwalten und verfolgen",
      orderNumber: "Auftragsnummer",
      createNew: "Neuer Fertigungsauftrag",
      product: "Produkt",
      planned: "Geplant",
      actual: "Tats\xE4chlich",
      plannedQty: "Geplante Menge",
      actualQty: "Tats\xE4chliche Menge",
      plannedStart: "Geplanter Start",
      plannedEnd: "Geplantes Ende",
      progress: "Fortschritt",
      phases: "Phasen",
      phasesCompleted: "Phasen abgeschlossen",
      plan: "Planen",
      startProduction: "Produktion starten",
      complete: "Abschlie\xDFen",
      startPhase: "Phase starten",
      completePhase: "Phase abschlie\xDFen",
      recordScrap: "Ausschuss erfassen",
      confirmScrap: "Ausschuss best\xE4tigen",
      scrapReason: "Ausschussgrund",
      scrapReasonPlaceholder: "Was hat den Ausschuss verursacht?",
      scrap: "Ausschuss",
      started: "Gestartet",
      completed: "Abgeschlossen",
      duration: "Dauer",
      noOrders: "Keine Fertigungsauftr\xE4ge gefunden",
      searchPlaceholder: "Nach Auftragsnummer suchen...",
      displayedCount: "{count} Auftr\xE4ge angezeigt",
      notFound: "Fertigungsauftrag nicht gefunden"
    },
    phase: {
      preparation: "Vorbereitung",
      manufacturing: "Fertigung",
      qc: "Qualit\xE4tskontrolle",
      receipt: "Wareneingang"
    },
    phaseStatus: {
      pending: "Ausstehend",
      in_progress: "In Bearbeitung",
      completed: "Abgeschlossen",
      skipped: "\xDCbersprungen"
    },
    lotBatch: {
      title: "Los/Charge",
      lotNumber: "Losnummer",
      qualityStatus: "Qualit\xE4tsstatus",
      producedAt: "Hergestellt am",
      noLots: "Keine erfassten Lose"
    },
    status: {
      active: "Aktiv",
      inactive: "Inaktiv",
      draft: "Entwurf",
      planned: "Geplant",
      in_progress: "In Bearbeitung",
      completed: "Abgeschlossen",
      cancelled: "Storniert"
    },
    bomType: {
      assembly: "Montage",
      kit: "Kit/Paket",
      refurbishment: "Aufarbeitung",
      custom: "Individuell"
    },
    qualityStatus: {
      pending: "Ausstehend",
      passed: "Bestanden",
      failed: "Nicht bestanden",
      partial: "Teilweise bestanden"
    },
    refurbishment: {
      title: "Aufarbeitung",
      start: "Aufarbeitung starten",
      complete: "Aufarbeitung abschliessen",
      approve: "Genehmigen",
      reject: "Ablehnen",
      history: "Aufarbeitungshistorie",
      sourceWorksheet: "Quell-Arbeitsblatt",
      sourceEquipment: "Quell-Mietgeraet",
      outputProduct: "Ausgabeprodukt",
      outputSku: "Ausgabe-SKU",
      qualityCheck: "Qualitaetspruefung",
      approved: "Genehmigt \u2014 neues Produkt erstellt",
      rejected: "Abgelehnt \u2014 Ausschuss erfasst",
      noHistory: "Keine Aufarbeitungshistorie"
    }
  },
  consignment: {
    dashboard: {
      title: "Kommissions-Zusammenfassung",
      outstandingValue: "Ausstehender Wert",
      partnerCount: "Anzahl Partner",
      oldest: "Aelteste",
      daysAgo: "vor {days} Tagen",
      overdueWarning: "Ueber 30 Tage",
      overduePartners: "{count} Partner",
      overdueRentals: "{count} Vermietung(en)",
      noActive: "Keine aktiven Kommissionen"
    }
  },
  helpdesk: {
    screenLabel: "Bildschirm / Men\xFCpunkt",
    screenPlaceholder: "Z.B.: Vermietung > Aktive Vermietungen > R\xFCckgabe",
    bugDescLabel: "Fehlerbeschreibung",
    featureDescLabel: "Anforderungsbeschreibung",
    questionDescLabel: "Ihre Frage",
    guidedActionFieldLabel: "Was ich getan habe:",
    guidedActionPrefix: "Was ich getan habe: ",
    actionPlaceholder: "Z.B.: Ich habe auf Speichern geklickt",
    guidedResultFieldLabel: "Was passiert ist:",
    guidedResultPrefix: "Was passiert ist: ",
    resultPlaceholder: "Z.B.: Eine Fehlermeldung erschien",
    guidedExpectedFieldLabel: "Was h\xE4tte passieren sollen:",
    guidedExpectedPrefix: "Was h\xE4tte passieren sollen: ",
    expectedPlaceholder: "Z.B.: Die Daten h\xE4tten gespeichert werden sollen",
    freeTextModeBtn: "Freitextmodus \u2192",
    bugPlaceholder: "Was haben Sie getan? Was ist passiert? Was h\xE4tte passieren sollen?",
    featurePlaceholder: "Was brauchen Sie? Wie soll es funktionieren?",
    questionPlaceholder: "Beschreiben Sie Ihre Frage...",
    guidedModeBtn: "\u2190 Gef\xFChrter Modus (hilft bei der Beschreibung)",
    duplicateWarningTitle: "\u26A0 Eine \xE4hnliche Meldung existiert bereits:",
    reasonLabel: "Warum ist es wichtig?",
    reasonPlaceholder: "Z.B.: Wird f\xFCr den Monatsabschluss ben\xF6tigt, derzeit manuell",
    screenshotLabel: "Screenshot(s)",
    tabNewReport: "Neue Meldung",
    tabMyReports: "Meine Meldungen",
    reporterLabel: "Wer meldet?",
    moduleLabel: "Modul",
    selectPlaceholder: "\u2014 Ausw\xE4hlen \u2014",
    severityLabel: "Schweregrad",
    priorityLabel: "Priorit\xE4t",
    clearDescriptionBtn: "\u2715 L\xF6schen",
    clearDescriptionTitle: "Beschreibung l\xF6schen",
    screenshotMax: "\u2014 max. {max}",
    screenshotPasteHint: "Screenshot hier einf\xFCgen",
    screenshotClickHint: "oder klicken / Bild hierher ziehen",
    screenshotCount: "{count} / {max} Bilder",
    autoCaptureTitle: "\u26A0 Automatisch erfasste Daten",
    attachConsoleErrors: "{count} Konsolenfehler anh\xE4ngen",
    attachFailedApis: "{count} fehlgeschlagene API-Aufrufe anh\xE4ngen",
    submitting: "Senden...",
    submit: "Absenden",
    resetFormTitle: "Formular leeren",
    openSpreadsheet: "Helpdesk-Tabelle in Google Sheets \xF6ffnen \u2192",
    loading: "Wird geladen...",
    noTickets: "Du hast noch keine Meldungen.",
    selectReporterFirst: 'W\xE4hle zuerst deinen Namen im Tab "Neue Meldung"!',
    successTitle: "Danke!",
    successMessage: "Die Meldung wurde gespeichert.",
    openInSpreadsheet: "In der Tabelle \xF6ffnen \u2192",
    fabTooltip: "Helpdesk (Ctrl+Shift+H)",
    alertMissingFields: "Bitte f\xFClle die Pflichtfelder aus! (Melder, Modul, Beschreibung)",
    alertMissingSeverity: "Bitte w\xE4hle den Schweregrad aus!",
    alertSubmitError: "Ein Fehler ist aufgetreten: {error}",
    unknownError: "Unbekannter Fehler",
    type: {
      bug: "Fehler",
      feature: "Wunsch",
      question: "Frage"
    }
  },
  pri: {
    inputPlaceholder: "Fragen Sie alles...",
    sendLabel: "Senden",
    welcome: {
      greeting: "Hallo! Ich bin pRI, dein digitaler Kollege.",
      subtitle: "Wie kann ich helfen?",
      howToFallback: "Wie mache ich das?",
      whatIsFallback: "Was ist diese Seite?",
      expiringRentalsLabel: "Auslaufende Vermietungen",
      expiringRentalsMessage: "Zeige die auslaufenden Vermietungen!",
      openWorksheetsLabel: "Offene Arbeitsbl\xE4tter",
      openWorksheetsMessage: "Zeige die offenen Arbeitsbl\xE4tter!"
    }
  },
  priceInput: {
    netLabel: "Netto",
    grossLabel: "Brutto",
    vatRate: "MwSt"
  },
  email: {
    templates: "E-Mail-Vorlagen",
    templateList: "Vorlagenliste",
    editTemplate: "Vorlage bearbeiten",
    selectTemplate: "W\xE4hlen Sie eine Vorlage aus der Liste",
    subject: "Betreff",
    greeting: "Begr\xFC\xDFung",
    body: "Inhalt",
    cta: "CTA-Schaltfl\xE4che",
    ctaUrl: "CTA-URL",
    insertVariable: "Variable einf\xFCgen",
    save: "Speichern",
    saving: "Speichern...",
    default: "Standard",
    customized: "Angepasst",
    active: "Aktiv",
    inactive: "Inaktiv",
    locked: "Gesperrt",
    editable: "Bearbeitbar",
    missingVariables: "Fehlende Pflichtfelder",
    saveSuccess: "Vorlage gespeichert",
    version: "Version",
    lastUpdated: "Zuletzt ge\xE4ndert",
    source: "Quelle",
    preview: "Vorschau",
    desktopPreview: "Desktop-Ansicht",
    mobilePreview: "Mobile Ansicht",
    sendTestEmail: "Test-E-Mail senden",
    testEmailSent: "Test-E-Mail gesendet",
    testEmailAddress: "Ziel-E-Mail-Adresse",
    resetToDefault: "Auf Standard zur\xFCcksetzen",
    resetConfirm: "M\xF6chten Sie die Vorlage wirklich zur\xFCcksetzen?",
    resetSuccess: "Vorlage zur\xFCckgesetzt",
    smtpSettings: "SMTP-Einstellungen",
    smtpHost: "SMTP-Server",
    smtpPort: "Port",
    smtpUser: "Benutzername",
    smtpPass: "Passwort",
    senderEmail: "Absender-E-Mail",
    senderName: "Absendername",
    dailyLimit: "Tageslimit",
    testConnection: "Verbindung testen",
    connectionOk: "Verbindung OK",
    connectionFailed: "Verbindung fehlgeschlagen",
    emailLogs: "Sendeprotokoll",
    recipientEmail: "Empf\xE4nger",
    status: "Status",
    sentAt: "Gesendet am",
    resend: "Erneut senden",
    resendConfirm: "M\xF6chten Sie diese E-Mail erneut senden?",
    resendSuccess: "E-Mail erneut gesendet",
    filterByStatus: "Nach Status filtern",
    filterByTemplate: "Nach Vorlage filtern",
    todayStats: "Heutige Statistik",
    bulkSend: {
      title: "Massen-E-Mail senden",
      settings: "Sendeeinstellungen",
      template: "E-Mail-Vorlage",
      templatePlaceholder: "Vorlage ausw\xE4hlen...",
      language: "Sprache",
      partnerPlaceholder: "Partnerauswahl \u2014 demn\xE4chst verf\xFCgbar. Derzeit wird an alle aktiven Partner gesendet.",
      variables: "Variablen",
      addVariable: "Variable hinzuf\xFCgen",
      variableKey: "Variablenname",
      variableValue: "Wert",
      send: "Senden starten",
      sending: "Senden...",
      results: "Ergebnisse",
      queued: "Warteschlange",
      skipped: "\xDCbersprungen",
      failed: "Fehlgeschlagen",
      success: "Massenversand gestartet!",
      errorNoTemplate: "Bitte w\xE4hlen Sie eine Vorlage!",
      errorSend: "Fehler beim Senden.",
      filters: {
        title: "Partnerfilter",
        search: "Suche nach Name / E-Mail / Partnercode",
        segmentLabel: "Segment",
        segment: {
          vip: "VIP",
          active: "Regul\xE4r",
          atRisk: "Gef\xE4hrdet",
          inactive: "Inaktiv"
        },
        hasActiveRentalLabel: "Aktive Miete",
        hasActiveRental: {
          any: "Kein Filter",
          yes: "Aktiv",
          no: "Keine",
          expiring7d: "L\xE4uft in 7 Tagen aus"
        },
        lastPurchaseDaysLabel: "Letzter Einkauf",
        lastPurchase: {
          "30": "In den letzten 30 Tagen",
          "60": "In den letzten 60 Tagen",
          any: "Kein Filter",
          "90plus": "Vor \xFCber 90 Tagen"
        },
        hasOutstandingLabel: "Offene Forderung",
        hasOutstanding: {
          any: "Kein Filter",
          yes: "Ja",
          no: "Nein"
        },
        hasEmailOnly: "Nur mit E-Mail",
        marketingConsentOnly: "Nur mit Marketing-Einwilligung",
        resetFilters: "Filter zur\xFCcksetzen",
        filteredCount: "Gefilterte Partner ({count})",
        selectedCount: "{count} / {max} Partner ausgew\xE4hlt",
        selectAll: "Alle ausw\xE4hlen",
        clearSelection: "Auswahl aufheben",
        maxLimitWarning: "Mehr als {max} Partner gefunden \u2014 Filter verfeinern",
        maxSelectionReached: "Maximal 500 Partner pro Versand (NFR1)",
        unsubscribedTooltip: "Abgemeldeter Partner \u2014 kein Versand m\xF6glich",
        loadMore: "Mehr laden",
        loading: "L\xE4dt\u2026",
        emptyState: "Keine Partner entsprechen dem Filter",
        sendWithCount: "Senden ({count} Partner)",
        columns: {
          name: "Name",
          email: "E-Mail",
          segment: "Segment",
          flags: "Kennzeichen"
        },
        flagMarketingConsent: "Marketing-Einwilligung",
        flagUnsubscribed: "Abgemeldet",
        flagOutstanding: "Offene Forderung"
      },
      errorNoRecipients: "Keine Empf\xE4nger ausgew\xE4hlt",
      confirmModal: {
        title: "Best\xE4tigen: {count} Partner",
        description: "Gro\xDFe Kampagne \u2014 Empf\xE4ngerzahl exakt eingeben, um versehentliche Sendungen zu vermeiden.",
        hint: "Eingabe: {count}",
        inputLabel: "Empf\xE4ngerzahl",
        inputPlaceholder: "Zahlen",
        mismatchTooltip: "Gib die genaue Zahl ein",
        confirmButton: "Senden best\xE4tigen",
        cancelButton: "Abbrechen"
      },
      legalBasis: {
        TRANSACTIONAL: "Transaktional",
        MARKETING_CONSENT: "Marketing-Einwilligung",
        LEGITIMATE_INTEREST: "Berechtigtes Interesse",
        unknown: "Unbekannte Vorlage",
        marketingWarning: "Marketing-Vorlage \u2014 nur Partner mit ausdr\xFCcklicher Einwilligung (marketingConsent=true) erhalten diese."
      },
      skipReason: {
        no_email: "Keine E-Mail",
        not_found: "Nicht gefunden",
        unsubscribed: "Abgemeldet",
        no_consent: "Keine Einwilligung"
      },
      skipBreakdown: "\xDCbersprungen nach Grund",
      sendDynamic: "{template} an {count} Partner senden",
      preview: {
        openButton: "Vorschau",
        title: "Vorlagenvorschau",
        subtitle: "{slug} ({language})",
        noTemplate: "W\xE4hlen Sie eine Vorlage zur Vorschau.",
        loading: "Vorschau wird geladen\u2026",
        error: "Fehler",
        subjectLabel: "Betreff",
        iframeTitle: "E-Mail-Vorlagenvorschau",
        sampleDataLabel: "Beispielvariablen",
        closeButton: "Schlie\xDFen"
      },
      undo: {
        toastTitle: "Senden in {seconds} Sekunden\u2026",
        toastBody: "{count} Partner",
        undoButton: "R\xFCckg\xE4ngig",
        undoneToast: "Senden abgebrochen",
        sendingNow: "Wird gesendet\u2026"
      },
      draft: {
        restoreTitle: "Gespeicherter Entwurf gefunden",
        restoreSubtitle: "Gespeichert: {savedAt}",
        restoreButton: "Wiederherstellen",
        dismissButton: "Verwerfen"
      },
      stats: {
        totalBatches: "Kampagnen",
        activeCampaigns: "Aktiv",
        completedToday: "Heute abgeschlossen",
        successRate: "Zustellrate",
        windowHint: "Letzte {days} Tage",
        activeHint: "Laufend / geplant",
        completedHint: "Heute abgeschlossen",
        successHint: "von {recipients} Empf\xE4ngern"
      },
      allFailed: "Alle Sendungen fehlgeschlagen",
      asyncInfo: "Der Versand erfolgt im Hintergrund; der Status wird aktualisiert",
      description: "E-Mail an die ausgew\xE4hlten Partner senden",
      error: "Fehler beim Senden",
      moreRecipients: "weitere",
      noEmailWarning: "Einige ausgew\xE4hlte Partner haben keine E-Mail-Adresse",
      partialSuccess: "{queued} E-Mails gesendet, {skipped} \xFCbersprungen",
      partnersSelected: "Partner ausgew\xE4hlt",
      recipients: "Empf\xE4nger",
      selectLanguage: "Sprache ausw\xE4hlen",
      selectTemplate: "Vorlage ausw\xE4hlen",
      sendButton: "Senden",
      sendEmail: "E-Mail senden",
      successAll: "{count} E-Mails in die Warteschlange eingereiht"
    },
    template: {
      invoiceSent: "Rechnung gesendet",
      invoiceOverdue: "\xDCberf\xE4llige Rechnung",
      rentalConfirmation: "Mietbest\xE4tigung",
      rentalOverdue: "\xDCberf\xE4llige Miete",
      rentalDepositWarning: "Kautionswarnung",
      worksheetCreated: "Arbeitsblatt erstellt",
      worksheetReady: "Arbeitsblatt fertig",
      quoteSent: "Angebot gesendet",
      welcomePartner: "Willkommens-E-Mail",
      paymentReceived: "Zahlung eingegangen"
    },
    selectPartners: "Partner ausw\xE4hlen",
    bulkResult: "Sendeergebnis",
    queued: "Eingereiht",
    skipped: "\xDCbersprungen",
    failedCount: "Fehlgeschlagen",
    scheduled: {
      title: "Geplante Sendungen",
      sectionAriaLabel: "Liste der geplanten Bulk-Email-Batches",
      loading: "Wird geladen...",
      empty: "Derzeit keine geplanten Sendungen.",
      error: "Liste konnte nicht geladen werden: {message}",
      skippedSuffix: "{count} \xFCbersprungen",
      cancelButton: "Abbrechen",
      cancelling: "Wird abgebrochen...",
      col: {
        template: "Vorlage",
        scheduledAt: "Wann",
        recipients: "Empf\xE4nger",
        status: "Status",
        legalBasis: "DSGVO-Grundlage",
        actions: "Aktionen"
      },
      cancelModal: {
        title: "Geplante Sendung abbrechen",
        description: "Sendung der Vorlage {templateSlug} an {count} Empf\xE4nger abbrechen? Dies kann nicht r\xFCckg\xE4ngig gemacht werden, aber Sie k\xF6nnen manuell erneut senden.",
        confirmButton: "Abbrechen",
        dismissButton: "Geplant lassen"
      },
      cancelToast: {
        success: "Geplante Sendung abgebrochen.",
        alreadyCancelled: "Diese Sendung wurde bereits abgebrochen.",
        notCancellable: "Die Sendung ist im Status {status} \u2014 kann nicht abgebrochen werden.",
        race: "Die Sendung wird gerade verarbeitet \u2014 zu sp\xE4t zum Abbrechen.",
        notFound: "Sendung nicht gefunden.",
        error: "Fehler beim Abbrechen."
      }
    }
  },
  documents: {
    panel: {
      title: "Dokumente",
      uploadButton: "Hochladen",
      downloadButton: "Herunterladen",
      deleteButton: "L\xF6schen",
      deleteConfirm: "M\xF6chten Sie dieses Dokument wirklich l\xF6schen?",
      deleteConfirmButton: "L\xF6schen best\xE4tigen",
      deleteCancel: "Abbrechen",
      uploadSuccess: "Dokument erfolgreich hochgeladen.",
      deleteSuccess: "Dokument gel\xF6scht.",
      loading: "Dokumente werden geladen\u2026",
      empty: "Keine angeh\xE4ngten Dokumente.",
      retry: "Erneut versuchen"
    },
    errors: {
      loadFailed: "Dokumente konnten nicht geladen werden.",
      uploadFailed: "Upload fehlgeschlagen: {message}",
      downloadFailed: "Download fehlgeschlagen: {message}",
      deleteFailed: "L\xF6schen fehlgeschlagen: {message}"
    },
    audit: {
      backToAdmin: "Zur\xFCck zum Admin",
      title: "Dokument-Auditprotokoll",
      subtitle: "Operativer Audit-Trail f\xFCr DSGVO Art. 30 Compliance.",
      filters: "Filter",
      filterAction: "Aktion",
      filterDocumentId: "Dokument-ID",
      invalidUuid: "Ung\xFCltiges UUID-Format",
      allActions: "Alle Aktionen",
      pageSize: "Zeilen pro Seite",
      clearFilters: "Filter l\xF6schen",
      refresh: "Aktualisieren",
      exportCsv: "CSV exportieren",
      exportSuccess: "CSV-Export bereit.",
      loading: "Auditprotokoll wird geladen\u2026",
      loadError: "Auditprotokoll konnte nicht geladen werden.",
      retry: "Erneut versuchen",
      empty: "Keine Eintr\xE4ge f\xFCr die aktuellen Filter.",
      previousPage: "Zur\xFCck",
      nextPage: "Weiter",
      pageInfo: "Seite {page} von {totalPages} \xB7 {total} Eintr\xE4ge insgesamt",
      col: {
        performedAt: "Zeit",
        action: "Aktion",
        documentId: "Dokument",
        performedBy: "Benutzer",
        ipAddress: "IP-Adresse",
        metadata: "Metadaten"
      },
      action: {
        UPLOADED: "Hochgeladen",
        DOWNLOADED: "Heruntergeladen",
        VIEWED: "Angesehen",
        SHARED_VIA_LINK: "Link geteilt",
        UPDATED: "Aktualisiert",
        DELETED: "Gel\xF6scht",
        RESTORED: "Wiederhergestellt",
        HASH_VERIFIED: "Hash verifiziert",
        HASH_MISMATCH: "Hash-Unterschied",
        ORPHAN_DETECTED: "Waise erkannt"
      }
    }
  },
  esign: {
    error: {
      sessionNotFound: "Signatur-Sitzung nicht gefunden.",
      sessionExpired: "Signatur-Sitzung ist abgelaufen.",
      alreadySigned: "Signatur-Sitzung ist bereits unterschrieben.",
      invalidProvider: "Ung\xFCltiger Signaturanbieter.",
      consentNotGiven: "Einwilligung wurde nicht gegeben.",
      hashMismatch: "Signatur-Hash-Pr\xFCfung fehlgeschlagen \u2014 Inhalt wurde m\xF6glicherweise ver\xE4ndert.",
      tenantMismatch: "Signatur-Sitzung nicht gefunden.",
      internalError: "Interner Fehler bei der Signaturverarbeitung.",
      missingConsentBasic: "Grundlegende Einwilligung fehlt.",
      missingConsentDataProcessing: "Datenverarbeitungs-Einwilligung fehlt."
    },
    warning: {
      aesRequired: "F\xFCr Kautionen \xFCber 500.000 HUF wird eine qualifizierte (AES) Signatur empfohlen \u2014 einfache (SES) Signaturen bleiben w\xE4hrend Sprint 2 akzeptiert.",
      sessionExpiresSoon: "Die Signatur-Sitzung l\xE4uft bald ab."
    },
    verify: {
      passed: "Signatur erfolgreich verifiziert.",
      hashChainBroken: "Die Integrit\xE4t der Signaturkette ist beeintr\xE4chtigt.",
      evidenceHashMismatch: "Beweis-Hash stimmt nicht mit dem gespeicherten Wert \xFCberein.",
      sessionTerminal: "Sitzung befindet sich in einem terminalen Zustand (abgelaufen oder widerrufen)."
    },
    action: {
      createSession: "Signatur starten",
      sign: "Unterschreiben",
      verify: "Verifizieren",
      viewAudit: "Audit-Protokoll anzeigen"
    },
    consent: {
      basicLabel: "Ich habe die Vertragsbedingungen gelesen und akzeptiert.",
      dataProcessingLabel: "Ich stimme der Verarbeitung meiner pers\xF6nlichen Daten zum Zweck der Signatur zu."
    },
    dialog: {
      title: "Vertrag unterschreiben",
      success: "Der Vertrag wurde erfolgreich unterschrieben.",
      sessionLoading: "Signiersitzung wird vorbereitet\u2026",
      padHint: "Unterschreiben Sie mit dem Finger oder Stift im Feld",
      payloadTooLarge: "Die Unterschrift ist zu gro\xDF (max. 512 KiB). Bitte l\xF6schen und erneut unterschreiben.",
      consentRequired: "Beide Einwilligungen sind erforderlich."
    }
  },
  hr: {
    employee: {
      title: "Mitarbeiter",
      create: "Neuer Mitarbeiter",
      name: "Name",
      email: "E-Mail",
      tajNumber: "Sozialversicherungsnummer",
      taxId: "Steuer-ID",
      bankAccount: "Bankkonto",
      grossSalary: "Bruttogehalt",
      employmentType: "Besch\xE4ftigungsart",
      salaryType: "Gehaltsart",
      weeklyHours: "Wochenstunden",
      contractStart: "Vertragsbeginn",
      contractEnd: "Vertragsende",
      childrenCount: "Anzahl der Kinder",
      disabledChildrenCount: "Behinderte Kinder",
      familyTaxCredit: "Familiensteuerverg\xFCnstigung",
      familyCreditChildCount: "Anspruchsberechtigte Kinder",
      isFirstMarriage: "Erste Ehe",
      userId: "Benutzer-ID",
      basicInfo: "Grunddaten",
      taxAndBankInfo: "Steuer- und Bankdaten",
      familyData: "Familiendaten",
      noEmployees: "Keine Mitarbeiter vorhanden",
      created: "Mitarbeiter erstellt",
      updated: "Mitarbeiter aktualisiert",
      saveError: "Speichern fehlgeschlagen",
      employmentTypes: {
        fulltime: "Vollzeit",
        parttime: "Teilzeit",
        seasonal: "Saisonal"
      },
      salaryTypes: {
        monthly: "Monatlich",
        hourly: "St\xFCndlich"
      },
      panelBasic: "Grunddaten",
      panelEmployment: "Besch\xE4ftigung",
      panelPayroll: "Gehalt",
      panelFamily: "Familie",
      panelInvalid: "Fehlendes oder ung\xFCltiges Feld",
      validationError: "Bitte alle Pflichtfelder ausf\xFCllen",
      completionLabel: "{percent}% ausgef\xFCllt",
      missingLabel: "Fehlend",
      miniCardAttendance: "Anwesenheit {year}-{month}",
      miniCardLeaveBalance: "Urlaub {year}",
      miniCardRecentRecords: "Letzte Anwesenheit",
      noAttendanceData: "Keine Anwesenheitsdaten in diesem Monat",
      noLeaveBalance: "Urlaubsguthaben nicht initialisiert",
      noRecentRecords: "Keine aktuelle Anwesenheit",
      missingDays: "Fehlend",
      viewFullAttendance: "Vollansicht",
      viewLeaveHistory: "Urlaubshistorie"
    },
    attendance: {
      title: "Anwesenheit",
      clockIn: "Einstempeln",
      clockOut: "Ausstempeln",
      currentlyClockedIn: "Eingeloggt",
      currentlyClockedOut: "Ausgeloggt",
      monthlyView: "Monatsansicht",
      workedDays: "Arbeitstage",
      overtimeHours: "\xDCberstunden",
      clockedInSuccess: "Erfolgreich eingestempelt",
      clockedOutSuccess: "Erfolgreich ausgestempelt",
      clockInError: "Einstempeln fehlgeschlagen",
      clockOutError: "Ausstempeln fehlgeschlagen",
      overtimeActive: "\xDCberstunden aktiv",
      forgottenClockOut: "Vergessener Clock-Out",
      forgottenClockOutBanner: "Sie haben gestern vergessen auszuloggen.",
      forgottenClockOutHint: "Bitte loggen Sie sich aus oder bitten Sie Ihren Manager um Korrektur.",
      startedAt: "Ein",
      endedAt: "Aus",
      todayWorkedLabel: "Heute",
      weeklyProgress: "Wochenstunden",
      filterEmployee: "Nach Mitarbeiter",
      allEmployees: "Alle Mitarbeiter",
      hideWeekend: "Wochenende ausblenden",
      hideHoliday: "Feiertag ausblenden",
      exportCsv: "CSV-Export",
      summaryLabel: "Gesamt",
      summaryWorkedDays: "{count} Arbeitstage",
      summaryOvertime: "{duration} \xDCberstunden",
      summaryHolidays: "{count} Feiertage",
      summaryMissing: "{count} fehlend",
      noRecord: "Kein Anwesenheitseintrag",
      breakMinutesLabel: "Pause",
      overtimeLabel: "\xDCberstunden",
      holidayLabel: "Feiertag",
      weekendLabel: "Wochenende",
      sourceLabel: "Quelle",
      noteLabel: "Notiz"
    },
    leave: {
      title: "Urlaub",
      request: "Neuer Antrag",
      myRequests: "Meine Antr\xE4ge",
      type: "Typ",
      startDate: "Startdatum",
      endDate: "Enddatum",
      reason: "Begr\xFCndung",
      reasonPlaceholder: "Optionaler Kommentar...",
      balance: "Guthaben",
      remaining: "Verbleibend",
      used: "Verwendet",
      entitled: "Berechtigt",
      calendar: "Kalender",
      approve: "Genehmigen",
      reject: "Ablehnen",
      pending: "Ausstehend",
      approved: "Genehmigt",
      rejected: "Abgelehnt",
      cancelled: "Abgebrochen",
      noRequests: "Keine Urlaubsantr\xE4ge",
      workingDays: "Arbeitstage",
      requestSubmitted: "Urlaubsantrag eingereicht",
      requestError: "Antragstellung fehlgeschlagen",
      missingFields: "Bitte f\xFCllen Sie alle Pflichtfelder aus",
      invalidDateRange: "Das Enddatum darf nicht vor dem Startdatum liegen",
      selectType: "Typ ausw\xE4hlen",
      types: {
        annual: "Jahresurlaub",
        sickSelf: "Krankenurlaub (selbst)",
        sickChild: "Krankenurlaub (Kind)",
        unpaid: "Unbezahlter Urlaub",
        maternity: "Mutterschaftsurlaub",
        paternity: "Vaterschaftsurlaub",
        bereavement: "Trauerurlaub",
        bloodDonation: "Blutspendeurlaub"
      },
      datePreset: "Schnelldatum",
      workingDaysPreview: "{count} Arbeitstage (Wochenenden ausgeschlossen)",
      quotaLabel: "verbleibend {remaining} / {entitled} Tage",
      overlapError: "Sie haben bereits einen Urlaubsantrag f\xFCr diesen Zeitraum",
      insufficientBalance: "Unzureichendes Urlaubsguthaben f\xFCr diesen Antrag",
      chip: {
        tomorrow: "Morgen",
        nextMonday: "N\xE4chster Montag",
        oneWeek: "N\xE4chste Mo-Fr",
        custom: "Benutzerdef."
      },
      filterByType: "Nach Typ",
      filterByEmployee: "Nach Mitarbeiter",
      allTypes: "Alle Typen",
      allEmployees: "Alle Mitarbeiter",
      onlyPending: "Nur ausstehend",
      conflictWarning: "Zwei genehmigte Urlaube in Konflikt",
      approveError: "Genehmigung fehlgeschlagen",
      rejectError: "Ablehnung fehlgeschlagen"
    },
    shift: {
      title: "Schichten",
      name: "Name",
      startTime: "Startzeit",
      endTime: "Endzeit",
      breakMinutes: "Pause (Minuten)",
      isNightShift: "Nachtschicht"
    }
  },
  payroll: {
    config: {
      title: "Lohnabrechnung Konfiguration",
      taxRates: "Steuers\xE4tze",
      shifts: "Schichtmuster",
      rate: "Satz",
      description: "Beschreibung",
      validFrom: "G\xFCltig ab",
      validTo: "G\xFCltig bis",
      save: "Speichern",
      delete: "L\xF6schen",
      addNew: "Neu hinzuf\xFCgen",
      year: "Jahr",
      deleteConfirm: "M\xF6chten Sie diesen Steuersatz wirklich l\xF6schen?",
      loadError: "Fehler beim Laden.",
      noRatesForYear: "Keine Steuers\xE4tze f\xFCr dieses Jahr. F\xFChren Sie ein Seed am /api/v1/payroll/seed-Endpunkt aus.",
      taxType: "Steuerart",
      month: "Monat",
      subtitle: "Steuers\xE4tze und Schichtmuster verwalten",
      saveError: "Der Steuersatz konnte nicht gespeichert werden.",
      deleteError: "Der Steuersatz konnte nicht gel\xF6scht werden."
    },
    runs: {
      title: "Lohnabrechnungsl\xE4ufe",
      detail: "Lauf Details",
      newRun: "Neuer Lauf",
      period: "Zeitraum",
      status: "Status",
      employeeCount: "Mitarbeiter",
      totalGross: "Brutto gesamt",
      totalNet: "Netto gesamt",
      totalEmployerCost: "Arbeitgeberkosten"
    },
    status: {
      DRAFT: "Entwurf",
      CALCULATED: "Berechnet",
      BOLT_APPROVED: "Filiale genehmigt",
      CENTRAL_REVIEWED: "Zentrale gepr\xFCft",
      FINALIZED: "Abgeschlossen"
    },
    steps: {
      draft: "Entwurf",
      calculated: "Berechnet",
      boltApproved: "Filiale genehmigt",
      centralReviewed: "Zentrale Pr\xFCfung",
      finalized: "Abgeschlossen"
    },
    actions: {
      calculate: "Berechnen",
      boltApprove: "Filiale genehmigen",
      centralReview: "Zentrale Pr\xFCfung",
      finalize: "Abschlie\xDFen",
      exportCsv: "CSV exportieren",
      exportExcel: "Excel exportieren",
      calculateError: "Die Lohnberechnung ist fehlgeschlagen.",
      approveError: "Die Genehmigung ist fehlgeschlagen."
    },
    payslip: {
      myTitle: "Meine Lohnzettel",
      period: "Zeitraum",
      gross: "Brutto",
      net: "Netto",
      downloadPdf: "PDF herunterladen",
      empty: "Keine Lohnzettel f\xFCr das gew\xE4hlte Jahr gefunden.",
      taxId: "Steuer-ID",
      tajNumber: "Sozialversicherungsnummer",
      bankAccount: "Bankkonto",
      employmentType: "Besch\xE4ftigungsart",
      weeklyHours: "Wochenstunden",
      grossSalary: "Brutto-Grundgehalt"
    },
    employmentTypes: {
      FULL_TIME: "Vollzeit",
      PART_TIME: "Teilzeit",
      SEASONAL: "Saisonal"
    },
    items: {
      tableTitle: "Lohnabrechnungspositionen",
      employee: "Mitarbeiter",
      workingDays: "Arbeitstage",
      workedDays: "Geleistet",
      leaveDays: "Urlaub",
      sickDays: "Krankheitstage",
      overtimeHours: "\xDCberstunden (Std)",
      baseSalary: "Grundgehalt",
      totalGross: "Brutto",
      totalNet: "Netto",
      empty: "Keine Positionen in diesem Lauf."
    },
    dashboard: {
      title: "Lohnabrechnung \xDCbersicht",
      latestGross: "Letztes Brutto",
      latestNet: "Letztes Netto",
      employerCost: "Arbeitgeberkosten",
      employees: "Mitarbeiter",
      trend: "12-Monats-Trend",
      noData: "Keine Daten f\xFCr den Trend verf\xFCgbar"
    },
    shift: {
      editHint: "Schichtmuster werden in der HR-Verwaltung bearbeitet.",
      loadError: "Fehler beim Laden der Schichtmuster.",
      empty: "Keine Schichtmuster.",
      nameHeader: "Name",
      startHeader: "Beginn",
      endHeader: "Ende",
      breakHeader: "Pause (Min.)",
      night: "Nacht"
    }
  },
  porter: {
    inbox: {
      title: "Posteingang",
      searchPlaceholder: "Unterhaltungen durchsuchen...",
      filters: "Filter",
      statusLabel: "Status",
      channelLabel: "Kanal",
      assigneeLabel: "Zust\xE4ndigkeit",
      loading: "Aktualisieren...",
      noSubject: "(kein Betreff)",
      threadCount: "Posteingang ({count})",
      pollingHint: "Automatische Aktualisierung alle 5 Sekunden",
      filter: {
        status: {
          all: "Alle Status",
          OPEN: "Offen",
          PENDING: "Ausstehend",
          RESOLVED: "Erledigt",
          SNOOZED: "Zur\xFCckgestellt"
        },
        channel: {
          all: "Alle Kan\xE4le",
          EMAIL: "E-Mail",
          WEBCHAT: "Webchat",
          CONTACT_FORM: "Formular"
        },
        assignee: {
          all: "Alle",
          me: "Meine",
          unassigned: "Nicht zugewiesen"
        }
      },
      empty: {
        title: "Noch keine Nachrichten",
        description: "Verbinden Sie Ihr Gmail-Konto und das Webchat-Widget \u2014 die erste Nachricht trifft innerhalb von 2 Minuten ein.",
        ctaSetup: "Kanal einrichten",
        ctaDemo: "Demo-Tour starten"
      },
      filteredEmpty: {
        title: "Keine Treffer f\xFCr diese Filter",
        description: "Versuchen Sie, die Filter zu lockern."
      },
      error: {
        title: "Nachrichten konnten nicht geladen werden",
        description: "Netzwerkfehler oder Server nicht erreichbar. Bitte erneut versuchen.",
        retry: "Erneut versuchen"
      },
      previewHint: {
        title: "Unterhaltung ausw\xE4hlen",
        description: "Klicken Sie links auf einen Eintrag, um die Unterhaltung zu \xF6ffnen und zu antworten."
      },
      relativeTime: {
        now: "jetzt",
        minutes: "vor {count} Min.",
        hours: "vor {count} Std.",
        days: "vor {count} Tagen"
      },
      sla: {
        OK: "OK",
        DUE_SOON: "Bald f\xE4llig",
        BREACHED: "\xDCberf\xE4llig",
        ESCALATED: "Eskaliert"
      },
      unread: "Ungelesen"
    },
    thread: {
      subject: "Betreff",
      back: "Zur\xFCck",
      inboxLink: "Posteingang",
      loading: "Wird geladen...",
      channel: {
        EMAIL: "E-Mail",
        WEBCHAT: "Webchat",
        CONTACT_FORM: "Formular"
      },
      status: {
        label: "Status",
        OPEN: "Offen",
        PENDING: "Ausstehend",
        RESOLVED: "Gel\xF6st",
        SNOOZED: "Zur\xFCckgestellt"
      },
      assignee: {
        label: "Zugewiesen",
        unassigned: "Nicht zugewiesen"
      },
      partner: {
        label: "Kunde",
        unknown: "Unbekannter Kontakt",
        createCta: "+ Partner anlegen",
        timeline: "Alle Konversationen"
      },
      message: {
        pending: "wird gesendet...",
        failed: "Senden fehlgeschlagen",
        retry: "Erneut",
        expand: "Gesamte Nachricht anzeigen",
        collapse: "Einklappen",
        attachmentUnavailable: "Anhang abgelaufen, wird aktualisiert..."
      },
      composer: {
        placeholder: "Antwort schreiben...",
        send: "Senden",
        sending: "Senden..."
      },
      error: {
        loadFail: "Konversation konnte nicht geladen werden",
        retry: "Erneut versuchen"
      }
    },
    settings: {
      channels: {
        title: "Kan\xE4le",
        subtitle: "Konfigurieren Sie, wie rPI Porter Nachrichten von Kunden empf\xE4ngt.",
        copy: "Kopieren",
        copySuccess: "Kopiert!",
        notConfigured: {
          title: "Noch keine Kan\xE4le angebunden",
          description: "Zun\xE4chst ist eine Chatwoot-Kontokonfiguration erforderlich. Bitte kontaktieren Sie Ihren Administrator."
        },
        list: {
          title: "Aktive Kan\xE4le",
          EMAIL: {
            name: "E-Mail",
            description: "Gmail IMAP/SMTP-Anbindung"
          },
          WEBCHAT: {
            name: "Webchat-Widget",
            description: "Einbettbares Snippet f\xFCr Ihre Website"
          },
          CONTACT_FORM: {
            name: "Kontaktformular",
            description: "\xD6ffentliches Formular mit hCaptcha-Schutz"
          },
          configured: "Angebunden",
          notConfigured: "Nicht angebunden",
          setupCta: "Anbinden"
        },
        webchat: {
          title: "Webchat-Embed-Snippet",
          description: "F\xFCgen Sie dies am Ende des <body>-Tags Ihrer Website ein. Das Widget erscheint automatisch."
        },
        form: {
          title: "\xD6ffentliche Formular-URL",
          description: "Teilen Sie diese URL auf Ihrer Website oder in Kampagnen."
        },
        error: {
          loadFail: "Kanalkonfiguration konnte nicht geladen werden",
          retry: "Erneut versuchen"
        }
      },
      webchat: {
        form: {
          replyTimeOptions: {
            in_a_few_minutes: "In wenigen Minuten",
            in_a_few_hours: "In wenigen Stunden",
            in_a_day: "Innerhalb eines Tages"
          }
        }
      },
      autoReply: {
        title: "Auto-Antwort-Regeln",
        subtitle: "Automatische Nachrichten bei bestimmten Bedingungen senden.",
        addRule: "Regel hinzuf\xFCgen",
        editRule: "Regel bearbeiten",
        deleteRule: "L\xF6schen",
        confirmDelete: "M\xF6chten Sie diese Regel wirklich l\xF6schen?",
        noRules: "Keine Auto-Antwort-Regeln konfiguriert.",
        active: "Aktiv",
        inactive: "Inaktiv",
        trigger: {
          label: "Ausl\xF6ser",
          NEW_CONVERSATION: "Neues Gespr\xE4ch",
          OFF_HOURS: "Au\xDFerhalb der Gesch\xE4ftszeiten",
          KEYWORD: "Schl\xFCsselwort",
          NO_RESPONSE_TIMER: "Kein Antwort-Timer",
          CHANNEL_SPECIFIC: "Kanalspezifisch"
        },
        form: {
          name: "Regelname",
          namePlaceholder: "z.B. Nachricht au\xDFerhalb der Gesch\xE4ftszeiten",
          templateId: "Vorlagen-ID",
          templateIdPlaceholder: "E-93 E-Mail-Vorlagen-ID",
          conditionJson: "Bedingung (JSON)",
          save: "Speichern",
          cancel: "Abbrechen"
        },
        save: "Speichern",
        cancel: "Abbrechen"
      }
    },
    timeline: {
      title: "Alle Gespr\xE4che",
      subtitle: "Alle Support-Threads f\xFCr diesen Partner in chronologischer Reihenfolge.",
      empty: "Keine fr\xFCheren Gespr\xE4che mit diesem Partner.",
      lastMessage: "Letzte Nachricht",
      noMessages: "Keine Nachrichten",
      openThread: "\xD6ffnen",
      loading: "Wird geladen...",
      error: "Gespr\xE4che konnten nicht geladen werden."
    }
  },
  authGrant: {
    type: {
      permanent: "Dauerhaft",
      oneTime: "Einmalig"
    },
    badge: {
      permanentActive: "Aktiv",
      oneTimeUntilRental: "Bis Miete"
    },
    card: {
      revoke: "Widerrufen",
      validFrom: "Start",
      validUntil: "Ende",
      valueLimit: "Wertgrenze",
      rental: "Miete",
      revokedReason: "Widerrufen"
    },
    tab: {
      title: "Vollmachten",
      subtitle: "Dauerhafte und einmalige Partnervollmachten",
      createButton: "Neue Vollmacht",
      givenTitle: "Erteilte Vollmachten",
      givenEmpty: "Dieser Partner hat noch keine Vollmachten erteilt.",
      receivedTitle: "Erhaltene Vollmachten",
      receivedEmpty: "Dieser Partner hat noch keine Vollmachten erhalten.",
      archivedToggle: "{count} archivierte Vollmacht(en)"
    },
    chooser: {
      title: "Neuer Vollmachtstyp",
      subtitle: "W\xE4hlen Sie den Vollmachtstyp aus.",
      permanentLabel: "Dauerhafte Vollmacht",
      permanentDesc: "Langfristige Partner-zu-Partner-Vollmacht (z. B. Firmenvertreter).",
      oneTimeLabel: "Einmalige Vollmacht",
      oneTimeDesc: "Miete-gebunden, mit Ausweisfoto (z. B. Fahrer, Kurier)."
    },
    dialog: {
      permanent: {
        title: "Dauerhafte Vollmacht",
        granteeLabel: "Beg\xFCnstigter Partner (UUID)",
        granteeHint: "Partner UUID (in einer sp\xE4teren Story durch Autocomplete ersetzt)",
        validFromLabel: "Start",
        validUntilLabel: "Ende (optional)",
        valueLimitLabel: "Wertgrenze (HUF, optional)",
        submit: "Vollmacht erstellen",
        validationGranteeRequired: "Beg\xFCnstigter Partner ist erforderlich",
        validationGranteeUuid: "Beg\xFCnstigter Partner muss ein g\xFCltiges UUID sein",
        validationValidFromRequired: "Startdatum ist erforderlich",
        validationValidUntilAfter: "Enddatum muss nach Startdatum liegen",
        validationValueLimit: "Wertgrenze muss eine positive ganze Zahl sein (leer = unbegrenzt)",
        validationValidFromPast: "Startdatum darf nicht in der Vergangenheit liegen"
      }
    }
  },
  equipment: {
    types: {
      categories: {
        SMALL_ENGINE: "Kleinmotor",
        LAWN_EQUIPMENT: "Gartenger\xE4t",
        POWER_TOOL: "Elektrowerkzeug",
        OTHER: "Sonstiges"
      },
      list: {
        title: "Ger\xE4tetyp-Katalog",
        subtitle: "Equipment Type Editor \u2014 Typ + SKU + Bilder + Kategorie",
        newCta: "Neuer Typ",
        searchPlaceholder: "Suche nach Name / SKU / Hersteller-SKU\u2026",
        allCategories: "Alle Kategorien",
        activeOnly: "Nur aktiv",
        loading: "Typen werden geladen\u2026",
        empty: {
          title: "Noch keine Typen",
          desc: "Erstelle den ersten Ger\xE4tetyp f\xFCr Webshop + Vermietung/Service/Verkauf."
        },
        col: {
          name: "Name",
          sku: "SKU",
          category: "Kategorie",
          brand: "Marke / Modell",
          status: "Status",
          actions: "Aktionen"
        },
        active: "Aktiv",
        inactive: "Inaktiv",
        actionEdit: "Bearbeiten"
      },
      editor: {
        title: {
          new: "Neuer Ger\xE4tetyp",
          edit: "Ger\xE4tetyp bearbeiten"
        },
        subtitle: "F\xFClle die Identit\xE4tsfelder aus. Spezifikationen + Einheiten + Dokumente folgen in Phase 2 (Sprint 18+).",
        loading: "Typ wird geladen\u2026",
        backToList: "Zur\xFCck zur Liste",
        submitting: "Speichern\u2026",
        save: "Speichern",
        create: "Erstellen",
        field: {
          name: "Anzeigename",
          namePlaceholder: "z. B. Honda GX160 Benzinmotor",
          sku: "SKU (Katalognummer)",
          skuPlaceholder: "z. B. KGC-HONDA-GX160",
          manufacturerSku: "Hersteller-SKU",
          alternativeSkus: "Alternative SKUs",
          alternativeSkusPlaceholder: "kommagetrennt",
          alternativeSkusHint: "F\xFCr Bulk-Import + N6 Querverweise. Beispiel: HONDA-180-OLD, MS180-16",
          category: "Kategorie",
          brand: "Marke",
          model: "Modell",
          description: "Beschreibung",
          heroImageUrl: "Hero-Bild URL",
          galleryImages: "Galerie-URLs",
          galleryImagesPlaceholder: "https://...\nhttps://...",
          galleryImagesHint: "Eine URL pro Zeile. Phase 2 (ADR-123 Am.2) ersetzt durch EquipmentTypeImage-Kindtabelle.",
          isActive: "Aktiv",
          isActiveHint: "Inaktive Typen werden in Vermietung / Service / Verkauf ausgeblendet.",
          alternativeSkusCreate: '\u201E{value}" hinzuf\xFCgen',
          alternativeSkusDuplicate: "Diese SKU ist bereits vorhanden",
          alternativeSkusTooLong: "Die SKU darf h\xF6chstens 100 Zeichen lang sein"
        },
        images: {
          title: "Bilder (D5 Phase 1)",
          previewError: "Bildvorschau konnte nicht von dieser URL geladen werden. Adresse pr\xFCfen."
        },
        toast: {
          created: "Ger\xE4tetyp erstellt",
          updated: "Ger\xE4tetyp aktualisiert"
        },
        errors: {
          nameRequired: "Name ist erforderlich",
          skuRequired: "SKU ist erforderlich",
          duplicateSku: "Diese SKU existiert bereits",
          validationFailed: "Ung\xFCltige Formulardaten",
          notFound: "Ger\xE4tetyp nicht gefunden",
          network: "Netzwerkfehler, bitte erneut versuchen",
          businessRuleFail: "Gesch\xE4ftsregelverletzung. Bitte die Eingabe \xFCberpr\xFCfen.",
          fkViolation: "Referenzierter Datensatz existiert nicht.",
          specsInvalidJson: "Die technische Spezifikation ist ung\xFCltiges JSON \u2014 korrigieren Sie das Specs-Feld vor dem Speichern."
        },
        cancelConfirm: "Nicht gespeicherte \xC4nderungen gehen verloren. Wirklich verwerfen?",
        specs: {
          title: "Technische Spezifikationen",
          hint: "Schl\xFCssel\u2013Wert-Paare f\xFCr die technischen Daten des Typs (z. B. Leistung, Gewicht). Die Raw-Ansicht akzeptiert beliebiges JSON.",
          kvView: "Schl\xFCssel\u2013Wert",
          rawView: "Raw JSON",
          addRow: "Zeile hinzuf\xFCgen",
          removeRow: "Entfernen",
          keyPlaceholder: "z. B. Leistung",
          valuePlaceholder: "z. B. 4.0 kW",
          invalidJson: 'Ung\xFCltiges JSON \u2014 ein Objekt ist erforderlich (z. B. {"schl\xFCssel": "wert"})',
          nonPrimitiveHint: "Die Spezifikationen enthalten verschachtelte/typisierte Werte \u2014 die Schl\xFCssel\u2013Wert-Ansicht w\xFCrde Typen verlieren, daher ist die Raw-Ansicht aktiv."
        },
        tabsLabel: "Typ-Editor-Reiter",
        tabs: {
          data: "Stammdaten",
          units: "Einheiten",
          webshop: "Webshop",
          docs: "Dokumente"
        },
        units: {
          loading: "Einheiten werden geladen\u2026",
          error: "Einheiten konnten nicht geladen werden.",
          empty: "Dieser Typ hat noch keine Einheiten.",
          countSuffix: "Einheiten",
          serialNumber: "Seriennummer",
          assetTag: "Inventarnummer",
          status: "Status",
          createdAt: "Erstellt",
          open: "\xD6ffnen"
        },
        webshop: {
          loading: "Webshop-Daten werden geladen\u2026",
          error: "Webshop-Daten konnten nicht geladen werden.",
          localeTitle: "Sprachinhalte",
          localeHint: "HU erforderlich \xB7 EN/DE/UK optional (leer \u2192 HU-Fallback)",
          nameLabel: "Name",
          namePlaceholderHu: "z. B. Honda GX160 Benzinmotor",
          huNameRequired: "Der ungarische Name ist bei Webshop-Sichtbarkeit erforderlich.",
          descriptionLabel: "Beschreibung",
          slugLabel: "URL-Slug",
          slugGenerate: "Generieren",
          flagVisibleOnWebshop: "Im Webshop sichtbar",
          flagVisibleOnWebshopHint: "Wenn aktiviert, ist es im Webshop f\xFCr alle sichtbar.",
          flagAvailableForRent: "Buchbar (Vermietung)",
          flagAvailableForRentHint: "Kunden k\xF6nnen \xFCber den Webshop buchen.",
          flagAvailableForSale: "Kaufbar",
          flagAvailableForSaleHint: "Kunden k\xF6nnen \xFCber den Webshop kaufen.",
          save: "Webshop-Daten speichern",
          saving: "Speichern\u2026",
          saved: "Webshop-Daten gespeichert",
          saveFailed: "Speichern fehlgeschlagen.",
          seoSectionTitle: "Suchmaschinenoptimierung (SEO)",
          seoPlaceholderNote: "In Vorbereitung \u2014 das Speichern der SEO-Felder wird in einer k\xFCnftigen Version verf\xFCgbar sein (Inhalte werden noch nicht gespeichert).",
          seoTitleLabel: "SEO-Titel",
          seoTitlePlaceholder: "z. B. Honda GX160 Motor Vermietung und Verkauf \u2014 Kisg\xE9pcentrum",
          seoDescriptionLabel: "SEO-Beschreibung",
          seoDescriptionPlaceholder: "z. B. Honda GX160 professioneller Benzinmotor, 4-Takt, 163 cm\xB3. Vermietung und Verkauf bei Kisg\xE9pcentrum.",
          seoTooLong: "zu lang"
        },
        docs: {
          loading: "Dokumente werden geladen\u2026",
          error: "Dokumente konnten nicht geladen werden.",
          empty: "Dieser Typ hat noch keine Dokumente.",
          countSuffix: "Dokumente",
          name: "Name",
          kind: "Art",
          size: "Gr\xF6\xDFe",
          uploadedAt: "Hochgeladen",
          kinds: {
            MANUAL: "Anleitung",
            SAFETY: "Sicherheit",
            WARRANTY: "Garantie",
            CERTIFICATE: "Zertifikat",
            OTHER: "Sonstiges"
          }
        }
      }
    }
  },
  procurement: {
    worksheetPanelTitle: "Beschaffungsanfragen",
    addRequest: "Neue Beschaffungsanfrage",
    addRequestTitle: "Neue Beschaffungsanfrage",
    emptyForWorksheet: "Keine Beschaffungsanfragen f\xFCr diesen Arbeitsschein.",
    productSearchLabel: "Produkt",
    productSearchPlaceholder: "Suche nach SKU oder Name\u2026",
    noProductsFound: "Keine Ergebnisse",
    selectedProduct: "Ausgew\xE4hltes Produkt",
    productIdShort: "Produkt",
    quantity: "Menge",
    notes: "Notizen",
    notesPlaceholder: "z. B. dringend, Originalteil\u2026",
    create: "Zum Warenkorb hinzuf\xFCgen",
    errors: {
      productRequired: "Bitte ein Produkt aus der Liste w\xE4hlen.",
      quantityInvalid: "Die Menge muss eine positive Zahl sein.",
      transitionRejected: "Status\xFCbergang {from} \u2192 {to} ist nicht erlaubt."
    },
    status: {
      DRAFT: "Entwurf",
      SUBMITTED: "Eingereicht",
      ORDERED: "Bestellt",
      RECEIVED: "Erhalten",
      CANCELLED: "Storniert"
    },
    actions: {
      submit: "Einreichen",
      markOrdered: "Als bestellt markieren",
      markReceived: "Als erhalten markieren",
      cancel: "Stornieren",
      confirmCancel: "Diese Beschaffungsanfrage stornieren?"
    },
    closeGate: {
      title: "Arbeitsschein abschlie\xDFen?",
      warning: "Es gibt noch {count} offene Beschaffungsanfrage(n) f\xFCr diesen Arbeitsschein (weder eingegangen noch storniert). Trotzdem abschlie\xDFen?",
      proceed: "Ja, abschlie\xDFen"
    },
    cart: {
      title: "Zentraler Beschaffungswagen",
      subtitle: "Alle Beschaffungsanfragen nach Quelle gruppiert",
      empty: "Der Beschaffungswagen ist leer.",
      totalCount: "{count} Anfragen",
      productIdShort: "Produkt",
      quantity: "Menge",
      sourceLabel: {
        WORKSHEET: "Arbeitsschein-getrieben",
        SALES: "Nicht auf Lager an der Kasse",
        MANUAL: "Manuelle Eingabe",
        AUTO_MIN: "Automatische Nachbestellung"
      },
      submitButton: "Wagen einreichen ({count})",
      confirmSubmit: "{count} Anfrage(n) zur Beschaffung einreichen. Fortfahren?",
      markGroupOrderedButton: "Gruppe als bestellt markieren",
      supplierNotesPrompt: "Lieferant (optional, wird an Notizen angeh\xE4ngt):"
    },
    listTruncated: "Gek\xFCrzte Liste: {shown} von {total} werden angezeigt. Filter eingrenzen oder die vollst\xE4ndige Beschaffungsliste \xF6ffnen."
  },
  camera: {
    title: "Dokumentaufnahme mit Kamera",
    description: "USB-Webcam (Logitech C920) \u2014 nur Desktop Chrome / Firefox",
    stepFront: "Vorderseite aufnehmen",
    stepBack: "R\xFCckseite aufnehmen (MRZ)",
    stepCounter: "{current}/{total}",
    permissionPrompt: "Bitte erteilen Sie dem Browser die Berechtigung zur Nutzung der Kamera.",
    permissionRequest: "Berechtigung anfordern",
    permissionDenied: "Kameraberechtigung verweigert. Bitte aktivieren Sie sie in den Browsereinstellungen und versuchen Sie es erneut.",
    deviceNotFound: "Kamera nicht gefunden. Bitte schlie\xDFen Sie die Logitech C920 USB-Webcam an.",
    deviceGeneric: "Zugriff auf die Kamera nicht m\xF6glich. Bitte pr\xFCfen Sie, dass keine andere Anwendung sie verwendet.",
    captureFront: "Vorderseite aufnehmen",
    captureBack: "R\xFCckseite aufnehmen",
    retake: "Wiederholen",
    next: "Weiter",
    useCaptures: "Bilder verwenden",
    cancel: "Abbrechen",
    thumbnailFront: "Vorschau Vorderseite",
    thumbnailBack: "Vorschau R\xFCckseite",
    instructionFront: "Legen Sie die Vorderseite des Dokuments (Foto) vor die Kamera und nehmen Sie auf.",
    instructionBack: "Drehen Sie das Dokument um \u2014 die maschinenlesbare Zone (MRZ) auf der R\xFCckseite muss sichtbar sein.",
    zeroRetentionHint: "Keine Speicherung \u2014 Bilder existieren nur bis zur Verarbeitung und werden danach sofort vernichtet.",
    focusManual: "Manueller Fokus unterst\xFCtzt",
    focusAuto: "Automatischer Fokus",
    starting: "Kamera wird gestartet..."
  },
  contractPriceList: {
    title: "Vertragspreisliste",
    orderableOnly: "Nur in der Liste enthaltene Artikel bestellbar",
    importButton: "Import (.xlsx)",
    templateDownload: "Vorlage",
    export: "Exportieren",
    importPreview: "Import-Vorschau \u2014 pr\xFCfen Sie die \xC4nderungen",
    confirmImport: "Import durchf\xFChren",
    importSuccess: "Import erfolgreich: {successful}/{total} Positionen",
    importPartial: "Teilweiser Import: {successful} erfolgreich, {failed} fehlerhaft",
    importError: "Fehler beim Import",
    annualLimitWarning: "J\xE4hrliches \xC4nderungslimit!",
    annualLimitDescription: "Der letzte Preislistenimport war vor weniger als 12 Monaten. M\xF6chten Sie ihn wirklich \xFCberschreiben?",
    forceImport: "\xDCberschreiben und importieren",
    previewNew: "{count} neu",
    previewChanged: "{count} ge\xE4ndert",
    previewRemoved: "{count} entfernt",
    previewUnchanged: "{count} unver\xE4ndert",
    customerSku: "Kundenartikelnummer",
    product: "Bezeichnung",
    contractPrice: "Vertragspreis",
    validFrom: "G\xFCltig ab",
    validUntil: "G\xFCltig bis",
    status: "Status",
    oldPrice: "Alter Preis",
    newPrice: "Neuer Preis",
    change: "\xC4nderung",
    noItems: "Keine Preisliste hochgeladen",
    dragDrop: "Laden Sie eine .xlsx-Datei \xFCber die Import-Schaltfl\xE4che hoch",
    itemCount: "{count} Positionen in der Preisliste",
    active: "Aktiv",
    expired: "Abgelaufen",
    notYetValid: "Noch nicht g\xFCltig",
    notOrderable: "Nicht bestellbar",
    diff: {
      NEW: "Neu",
      CHANGED: "Ge\xE4ndert",
      REMOVED: "Entfernt",
      UNCHANGED: "Unver\xE4ndert"
    }
  },
  crossSell: {
    title: "Gemischte Rechnung",
    subtitle: "Vermietung + Kauf + Kaution auf einer Rechnung",
    addItem: "Position hinzuf\xFCgen",
    itemType: "Positionstyp",
    rentalFee: "Mietgeb\xFChr",
    product: "Produkt",
    serviceFee: "Service-Arbeitskosten",
    servicePart: "Service-Ersatzteil",
    deposit: "Kaution",
    handlingFee: "Bearbeitungsgeb\xFChr",
    lateFee: "Verzugsgeb\xFChr",
    discount: "Rabatt",
    depositCard: "Kartenkaution",
    depositCash: "Barkaution",
    revenueTotal: "Umsatz gesamt",
    depositTotal: "Kaution (kein Umsatz)",
    payableTotal: "Zu zahlen gesamt",
    handlingFeeDescription: "Bearbeitungsgeb\xFChr f\xFCr Kartenkaution (2%)",
    handlingFeeRefund: "R\xFCckzuzahlende Kaution",
    noDeposit: "Keine Kaution",
    vatBreakdown: "MwSt.-Aufschl\xFCsselung"
  },
  assetTransfer: {
    title: "Bestandsumbuchung",
    toRentalEquipment: "Umbuchung in Mietger\xE4t",
    toOwnedAsset: "Umbuchung in eigenes Anlagegut",
    confirmTitle: "Umbuchung best\xE4tigen",
    confirmMessage: "M\xF6chten Sie das Produkt wirklich umbuchen? Die Umbuchung kann nicht r\xFCckg\xE4ngig gemacht werden.",
    success: "Umbuchung erfolgreich",
    rentalCardCreated: "Mietger\xE4tekarte automatisch erstellt",
    depreciationCreated: "AfA-Datensatz automatisch erstellt (200k+ Ft)",
    noDepreciation: "Keine AfA erforderlich (Preis < 200.000 Ft)",
    note: "Anmerkung (optional)",
    errorNotProduct: "Nur Positionen vom Typ Ware k\xF6nnen umgebucht werden",
    errorNotAvailable: "Nur Positionen mit Status Verf\xFCgbar k\xF6nnen umgebucht werden"
  },
  package: {
    backToList: "Zur\xFCck zu den Paketen",
    adminTabs: "Paketansichten",
    tabs: {
      items: "Positionen",
      data: "Paketdaten"
    },
    item: {
      name: "Bezeichnung",
      settlement: "Abrechnung",
      settlementIncluded: "Inbegriffen",
      settlementRental: "Vermietung",
      settlementConsignment: "Kommission",
      unitPrice: "Einzelpreis"
    },
    scope: "Geltungsbereich",
    pricingModel: "Preismodell",
    fixedPrice: "Festpreis",
    depositAmount: "Kaution",
    validFrom: "G\xFCltig ab",
    validTo: "G\xFCltig bis",
    category: {
      free: "Kostenlos",
      rentable: "Mietbar",
      consignment: "Kommission"
    }
  },
  inquiry: {
    title: "Kontakt",
    subtitle: "Schreiben Sie uns, was Sie brauchen \u2014 wir antworten innerhalb von 1 Werktag.",
    success: {
      title: "Danke f\xFCr Ihre Anfrage!",
      body: "Wir antworten innerhalb von 1 Werktag an die angegebene E-Mail-Adresse."
    },
    field: {
      name: "Name",
      email: "E-Mail",
      phone: "Telefonnummer (optional)",
      message: "Nachricht"
    },
    submit: "Senden",
    submitting: "Senden...",
    validation: {
      nameMin: "Mindestens 2 Zeichen",
      email: "Ung\xFCltige E-Mail",
      messageMin: "Mindestens 10 Zeichen",
      messageMax: "Maximal 5000 Zeichen",
      captcha: "Bitte best\xE4tigen Sie, dass Sie kein Roboter sind"
    },
    error: {
      submit: "Konnte nicht gesendet werden. Bitte versuchen Sie es in ein paar Minuten erneut."
    }
  },
  priDrawer: {
    title: "pRI-Assistent",
    clearHistory: "Unterhaltung l\xF6schen",
    close: "Schlie\xDFen"
  },
  unifiedFab: {
    items: {
      pri: "pRI-Assistent",
      chat: "Chat",
      helpdesk: "Helpdesk"
    },
    title: {
      withShortcut: "rPI-Assistent (Ctrl+Shift+H)",
      default: "rPI-Assistent"
    }
  }
};

// src/locale/translations/en.json
var en_default = {
  equipmentUnit: {
    backToTypes: "Back to types",
    editorTitle: "Equipment unit editor",
    editorSubtitle: "Unit record data, status and documents",
    tabsAria: "Equipment unit views",
    tabs: {
      basic: "Basic data",
      status: "Status & history",
      images: "Images",
      documents: "Documents"
    },
    seamPending: "Coming soon \u2014 data binding awaits the BE seam",
    field: {
      manufacturerSku: "Manufacturer SKU",
      internalSku: "Internal SKU",
      altSkus: "Alternative SKUs",
      serialNumber: "Serial number",
      purchasedAt: "Purchase date",
      hours: "Operating hours",
      category: "Category",
      note: "Note",
      status: "Status",
      statusSince: "Status since"
    },
    status: {
      AVAILABLE: "Available",
      RESERVED: "Reserved",
      IN_USE: "In use",
      DAMAGED: "Damaged",
      UNDER_REPAIR: "Under repair",
      SOLD: "Sold",
      WITHDRAWAL_REQUESTED: "Withdrawal requested",
      RETIRED: "Retired"
    },
    category: {
      SMALL_ENGINE: "Small engine",
      LAWN_EQUIPMENT: "Lawn equipment",
      POWER_TOOL: "Power tool",
      OTHER: "Other"
    },
    statusHistory: "Status history",
    altSkusPlaceholder: "SKU + Enter (Excel/CSV paste supported)",
    altSkusCreate: '+ New: "{value}"',
    altSkusDuplicate: "Already added",
    saved: "Saved",
    saveError: "Save failed",
    imagesEmpty: "No images uploaded",
    documentsEmpty: "No documents",
    expiresAt: "Expires",
    download: "Download",
    transition: {
      button: "Change status",
      title: "Change status",
      targetLabel: "Select a target status",
      reasonLabel: "Reason",
      required: "required",
      reasonHint: "Minimum 20 characters ({count}/20)",
      photoLabel: "Photos",
      auditNote: "Every status change is audit-logged: who, when and why.",
      confirm: "Confirm status",
      noTargets: "No transitions available from this status.",
      success: "Status updated",
      error: "Status change failed"
    }
  },
  bank: {
    title: "Bank transactions",
    subtitle: "Bank account movements and matching",
    newTransaction: "New transaction",
    loading: "Loading bank transactions...",
    error: "An error occurred",
    noResults: "No results",
    noResultsFiltered: "No bank transactions match the filter. Try adjusting it.",
    total: "Total",
    column: {
      bookingDate: "Booking date",
      counterparty: "Counterparty",
      amount: "Amount",
      matchStatus: "Matching",
      source: "Source"
    },
    matchStatus: {
      UNMATCHED: "Unmatched",
      PARTIALLY_MATCHED: "Partially matched",
      MATCHED: "Matched",
      RECONCILED: "Reconciled"
    },
    direction: {
      IN: "Incoming",
      OUT: "Outgoing"
    },
    source: {
      MANUAL: "Manual",
      IMPORT: "Import"
    },
    filter: {
      allStatuses: "All statuses",
      allDirections: "All directions"
    },
    form: {
      bookingDate: "Booking date",
      direction: "Direction",
      amount: "Amount",
      counterpartyName: "Counterparty name",
      counterpartyAccount: "Counterparty account",
      memo: "Memo",
      submit: "Save",
      success: "Bank transaction saved",
      error: "Failed to save"
    },
    match: {
      action: "Match",
      title: "Match bank transaction",
      invoiceLabel: "Invoice",
      invoicePlaceholder: "Select an invoice\u2026",
      amountLabel: "Matched amount",
      submit: "Match",
      noInvoices: "No matchable open invoice",
      loadError: "Failed to load matchable invoices. Please try again.",
      success: "Matched successfully",
      error: {
        overpay: "The matched amount exceeds the invoice balance",
        outNotAllowed: "Outgoing transactions cannot be matched to an invoice",
        amountPositive: "The matched amount must be positive",
        alreadyExists: "This match already exists",
        invoiceNotFound: "Invoice not found",
        transactionNotFound: "Bank transaction not found",
        generic: "Matching failed"
      }
    }
  },
  common: {
    status: "Status",
    uploading: "Uploading\u2026",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this item?",
    search: "Search",
    clearSearch: "Clear search",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    yes: "Yes",
    no: "No",
    close: "Close",
    back: "Back",
    previous: "Previous",
    next: "Next",
    submit: "Submit",
    edit: "Edit",
    create: "Create",
    details: "Details",
    new: "New",
    all: "All",
    none: "None",
    actions: "Actions",
    confirm: "Confirm",
    remove: "Remove",
    add: "Add",
    update: "Update",
    refresh: "Refresh",
    retry: "Retry",
    print: "Print",
    export: "Export",
    import: "Import",
    filter: "Filter",
    sort: "Sort",
    reset: "Reset",
    apply: "Apply",
    download: "Download",
    upload: "Upload",
    quantity: "Quantity",
    total: "Total",
    subtotal: "Subtotal",
    amount: "Amount",
    date: "Date",
    description: "Description",
    notes: "Notes",
    comment: "Comment",
    type: "Type",
    category: "Category",
    priority: "Priority",
    responsible: "Responsible",
    noResponsible: "No responsible",
    id: "ID",
    name: "Name",
    notFound: "Not found",
    noData: "No data",
    backToList: "Back to list",
    optional: "Optional",
    required: "Required",
    piece: "pc",
    day: "day",
    days: "days",
    hour: "hour",
    hours: "hours",
    createdAt: "Created at",
    updatedAt: "Updated at",
    completedAt: "Completed at",
    createdBy: "Created by",
    saved: "Saved!",
    loadingText: "Loading...",
    errorLabel: "Error",
    retryButton: "Retry",
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December"
    },
    monthsShort: {
      jan: "Jan",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dec"
    },
    other: "Other",
    unknownError: "Unknown error",
    activeRentals: "Active rentals",
    currency: "HUF",
    summary: "Summary",
    wizardStep: "Step {current} / {total}",
    processing: "Processing...",
    row: "Row",
    clear: "Clear",
    dismiss: "Dismiss",
    active: "Active",
    inactive: "Inactive",
    loadError: "Load error"
  },
  navStatus: {
    label: "NAV status",
    pending: "Pending",
    submitted: "Submitted",
    accepted: "Accepted",
    rejected: "Rejected",
    error: "Error"
  },
  nav: {
    bankImport: "Bank import",
    navigation: "Navigation",
    favorites: "Favorites",
    removeFavorite: "Remove",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    expand: "Expand",
    collapse: "Collapse",
    adminCenter: "Admin Center",
    summary: "Summary",
    knowledgeBase: "Knowledge Base",
    rental: "Rental",
    activeRentals: "Active rentals",
    newRental: "New rental",
    returnRental: "Return",
    outstandingRentals: "Outstanding Rentals",
    fleetCalendar: "Equipment Calendar",
    worksheet: "Worksheet",
    worksheets: "Worksheets",
    newWorksheet: "New worksheet",
    claims: "Claims",
    sales: "Sales",
    salesList: "Sales list",
    pos: "POS (Cash Register)",
    inventory: "Inventory",
    stockList: "Stock list",
    movements: "Movements",
    goodsReceipt: "Goods receipt",
    scrapping: "Scrapping",
    inventoryAnalytics: "Inventory Analytics",
    masterData: "Master Data",
    products: "Products",
    quotes: "Quotes",
    contracts: "Contracts",
    invoices: "Invoices",
    deliveryNotes: "Delivery notes",
    partners: "Partners",
    partnerList: "Partner list",
    newPartner: "New partner",
    vipProgram: "VIP Program",
    duplicates: "Duplicates",
    vehicles: "Vehicles",
    rentalVehicles: "Rental vehicles",
    companyVehicles: "Company vehicles",
    expiringDocuments: "Expiring documents",
    finance: "Finance",
    cashRegister: "Cash register",
    dailyClose: "Daily close",
    monthlyClose: "Monthly close",
    journal: "General ledger",
    szhFolder: "SZH Folder",
    vouchers: "Vouchers",
    fixedAssets: "Fixed assets",
    tamTaxExempt: "TAM Tax Exempt",
    receivables: "Receivables",
    overdueRentals: "Overdue rentals",
    chat: "Chat",
    messaging: "Messaging",
    smsDashboard: "SMS Dashboard",
    inboundSms: "Inbound SMS",
    courierDeliveries: "Courier Deliveries",
    reports: "Reports",
    tasks: "Tasks",
    integrations: "Integrations",
    crm: "CRM (Twenty)",
    hr: "HR (Horilla)",
    porter: "rPI Porter",
    porterInbox: "Inbox",
    porterChannels: "Channels",
    porterAutoReply: "Auto-reply rules",
    chatwoot: "rPI Porter",
    flow: "rPI Flow",
    admin: "Admin",
    users: "Users",
    permissions: "Permissions",
    tenantAdmin: "Tenant Admin",
    featureFlags: "Feature Flags",
    releaseHub: "rPI Delta",
    settings: "Settings",
    general: "General",
    openingHours: "Opening Hours",
    smsSettings: "SMS Settings",
    documentScanner: "Document Scanner",
    dashboard: "Dashboard",
    crmNewWindow: "Twenty CRM (new window)",
    hrNewWindow: "Horilla HR (new window)",
    group: {
      daily: "Daily Work",
      registry: "Registry",
      communication: "Communication",
      system: "System",
      hr: "HR"
    },
    manufacturing: "Manufacturing",
    bomList: "Bill of Materials (BOM)",
    productionOrders: "Production Orders",
    packages: "Packages",
    more: "More",
    administration: "Administration",
    recentItems: "Recent",
    moreMenu: "More options",
    sidebarMenu: "Navigation panel",
    emailTemplates: "Email Templates",
    emailSmtp: "Email SMTP",
    emailLogs: "Send Log",
    bulkEmail: "Bulk Email",
    hrModule: "HR",
    hrAttendance: "Attendance",
    hrLeaveCalendar: "Leave Calendar",
    hrLeaveRequest: "Leave Request",
    hrEmployees: "Employees"
  },
  header: {
    search: "Search",
    searchShortcut: "Search (Ctrl+K)",
    lightMode: "Light mode",
    darkMode: "Dark mode",
    language: "Language",
    user: "User",
    logout: "Log out",
    role: "Role",
    pendingSync: "Sync in progress"
  },
  command: {
    searchPlaceholder: "Search pages...",
    noResults: "No results found.",
    navigate: "navigate",
    open: "open",
    close: "close",
    addFavorite: "Add to favorites",
    removeFavorite: "Remove from favorites"
  },
  status: {
    active: "Active",
    closed: "Closed",
    draft: "Draft",
    expired: "Expired",
    cancelled: "Cancelled",
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    waiting: "Waiting",
    billable: "Billable",
    deleted: "Deleted",
    partialReturn: "Partially Returned",
    returned: "Returned",
    free: "Available",
    rentedOut: "Rented Out",
    inService: "In Service",
    reserved: "Reserved",
    excellent: "Excellent",
    good: "Good",
    adequate: "Adequate",
    open: "Open",
    interrupted: "Interrupted",
    low: "Low",
    medium: "Medium",
    high: "High",
    trusted: "Trusted",
    notTrusted: "Not trusted",
    depositFree: "Deposit-free!",
    depositMissing: "Deposit missing",
    storno: "(storno)"
  },
  toast: {
    saved: "Successfully saved",
    deleted: "Successfully deleted",
    created: "Successfully created",
    updated: "Successfully updated",
    error: "An error occurred",
    loginError: "Login error"
  },
  error: {
    required: "This field is required",
    invalidEmail: "Invalid email address",
    loadFailed: "Loading failed",
    saveFailed: "Save failed",
    general: "An error occurred: {message}",
    notFound: "Not found",
    minLength: "Minimum {min} characters required",
    worksheetNotFound: "Worksheet not found",
    rentalNotFound: "Rental not found",
    invoiceNotFound: "Invoice not found",
    noCashRegisterOpen: "No cash register open.",
    atLeastOneItem: "Please add at least one item!",
    enterPartnerName: "Please enter the partner name!",
    minCharsRequired: "Minimum {min} characters required",
    atLeastOneChange: "At least one substantive change is required!",
    calendar: {
      createHoliday: "Failed to create holiday",
      createOverride: "Failed to create override",
      deleteHoliday: "Failed to delete holiday",
      deleteOverride: "Failed to delete override",
      loadCalendar: "Failed to load calendar",
      loadHolidays: "Failed to load holidays",
      loadHours: "Failed to load business hours",
      loadOverrides: "Failed to load overrides",
      resetDefaults: "Failed to reset defaults",
      seedNational: "Failed to seed national holidays",
      updateHoliday: "Failed to update holiday",
      updateHours: "Failed to update business hours",
      updateOverride: "Failed to update override"
    },
    chat: {
      createConversation: "Failed to create conversation",
      loadConversations: "Failed to load conversations",
      loadMessages: "Failed to load messages",
      loadUsers: "Failed to load users",
      sendMessage: "Failed to send message"
    },
    common: {
      operationFailed: "Operation failed",
      unknownError: "Unknown error"
    },
    rental: {
      depositPaidEquipmentTaken: "The deposit has been charged and the rental was created \u2014 but the machine was rented out to another rental in the meantime, so it could not be assigned. Do NOT retry the payment: every retry creates another deposit charge and another rental. Refund the deposit on the deposit screen and select a different machine. ({contractNumber})",
      depositPaidNotRecorded: "The deposit has been charged and the rental was created \u2014 but the system could not record the handover. The machine is not assigned to any rental and may still be at the counter. Do NOT retry the payment: every retry creates another deposit charge and another rental. Refund the deposit on the deposit screen and report the error. ({contractNumber})",
      pickupFailed: "Machine pickup failed. The rental remained in DRAFT status \u2014 please try again on the detail page. Error: {error}",
      depositRefundFailed: "Return successful, but deposit refund failed. Amount: {amount}. Error: {error}. Please process the refund manually.",
      depositRefundTitle: "Rental return - deposit refund"
    },
    tasks: {
      loadAll: "Failed to load tasks",
      loadByStatus: "Failed to load tasks",
      loadOne: "Failed to load task",
      loadOverdue: "Failed to load overdue tasks",
      loadStats: "Failed to load statistics"
    },
    users: {
      create: "Failed to create user",
      delete: "Failed to delete user",
      loadAll: "Failed to load users",
      loadOne: "Failed to load user",
      update: "Failed to update user"
    },
    contracts: {
      loadAll: "Failed to load contracts",
      loadOne: "Failed to load contract"
    },
    quotations: {
      loadAll: "Failed to load quotations",
      loadOne: "Failed to load quotation"
    },
    NOT_FOUND: "Not found",
    BAD_REQUEST: "Invalid request",
    UNAUTHORIZED: "Unauthorized",
    FORBIDDEN: "Access denied",
    CONFLICT: "Conflict \u2014 item already exists",
    INTERNAL_ERROR: "Internal server error",
    VALIDATION_FAILED: "Validation error",
    AUTH_MISSING: "Authentication required",
    AUTH_INVALID_TOKEN: "Invalid token",
    AUTH_TOKEN_EXPIRED: "Token expired",
    AUTH_ACCESS_TOKEN_REQUIRED: "Access token required",
    AUTH_INVALID_CREDENTIALS: "Invalid credentials",
    AUTH_SESSION_EXPIRED: "Session expired, please log in again",
    AUTH_INVALID_PIN: "Invalid PIN code",
    RENTAL_NOT_FOUND: "Rental not found",
    RENTAL_INVALID_STATUS: "Invalid rental status",
    RENTAL_INVALID_TRANSITION: "Invalid status transition",
    RENTAL_ALREADY_EXISTS: "Rental already exists",
    RENTAL_EQUIPMENT_NOT_AVAILABLE: "Equipment not available",
    RENTAL_CONTRACT_NOT_FOUND: "Rental contract not found",
    RENTAL_DEPOSIT_NOT_FOUND: "Deposit not found",
    RENTAL_DEPOSIT_ALREADY_EXISTS: "Deposit already exists for this rental",
    RENTAL_DEPOSIT_INVALID_AMOUNT: "Deposit amount must be positive",
    RENTAL_DEPOSIT_INVALID_STATUS: "Invalid deposit status",
    RENTAL_DEPOSIT_INSUFFICIENT: "Full deposit payment is required before handover",
    RENTAL_HISTORY_NOT_FOUND: "Rental history not found",
    WORKSHEET_NOT_FOUND: "Worksheet not found",
    WORKSHEET_INVALID_STATUS: "Invalid worksheet status",
    WORKSHEET_INVALID_TRANSITION: "Invalid worksheet status transition",
    WARRANTY_CLAIM_NOT_FOUND: "Warranty claim not found",
    WARRANTY_INVALID_STATUS: "Invalid warranty status",
    SERVICE_NORM_NOT_FOUND: "Service norm not found",
    SERVICE_NORM_INVALID_CODE: "Invalid norm code",
    DIAGNOSTIC_NOT_FOUND: "Diagnostic not found",
    INVOICE_NOT_FOUND: "Invoice not found",
    INVOICE_INVALID_STATUS: "Invalid invoice status",
    INVOICE_INVALID_TRANSITION: "Invalid invoice status transition",
    INVOICE_ITEM_NOT_FOUND: "Invoice item not found",
    POS_SESSION_NOT_FOUND: "POS session not found",
    POS_SESSION_ALREADY_OPEN: "POS session already open",
    QUOTE_NOT_FOUND: "Quotation not found",
    QUOTE_INVALID_STATUS: "Invalid quotation status",
    QUOTE_ITEM_NOT_FOUND: "Quotation item not found",
    QUOTE_ONLY_DRAFT_MODIFIABLE: "Only draft quotations can be modified",
    QUOTE_ONLY_DRAFT_DELETABLE: "Only draft quotations can be deleted",
    QUOTE_ONLY_DRAFT_SENDABLE: "Only draft or sent quotations can be sent",
    QUOTE_EMAIL_NOT_CONFIGURED: "Email service not configured",
    QUOTE_RECIPIENT_REQUIRED: "Recipient email is required",
    QUOTE_PARTNER_REQUIRED: "Partner is required",
    QUOTE_ITEMS_REQUIRED: "At least one item is required",
    QUOTE_INVALID_QUANTITY: "Quantity must be positive",
    QUOTE_INVALID_UNIT_PRICE: "Unit price cannot be negative",
    QUOTE_EXPLODED_VIEW_NOT_FOUND: "Exploded view not found",
    QUOTE_MANUFACTURER_REQUIRED: "Manufacturer is required",
    QUOTE_MODEL_REQUIRED: "Machine model ID is required",
    QUOTE_PARTS_REQUIRED: "At least one part must be selected",
    PARTNER_NOT_FOUND: "Partner not found",
    PARTNER_ALREADY_EXISTS: "Partner already exists",
    PARTNER_INVALID_TAX_NUMBER: "Invalid tax number",
    PARTNER_DUPLICATE: "Duplicate partner",
    PARTNER_CONTRACT_NOT_FOUND: "Partner contract not found",
    PARTNER_REFERENCE_NOT_FOUND: "Partner reference not found",
    WAREHOUSE_NOT_FOUND: "Warehouse not found",
    WAREHOUSE_LOCATION_NOT_FOUND: "Warehouse location not found",
    STOCK_INSUFFICIENT: "Insufficient stock",
    STOCK_COUNT_NOT_FOUND: "Stock count not found",
    MOVEMENT_NOT_FOUND: "Stock movement not found",
    MOVEMENT_INVALID_TYPE: "Invalid movement type",
    PHANTOM_WAREHOUSE_NOT_FOUND: "Phantom warehouse not found",
    PRODUCT_NOT_FOUND: "Product not found",
    PRODUCT_SKU_EXISTS: "SKU already exists",
    PRODUCT_CATEGORY_NOT_FOUND: "Product category not found",
    PRODUCT_SUPPLIER_NOT_FOUND: "Supplier not found",
    VEHICLE_NOT_FOUND: "Vehicle not found",
    VEHICLE_DOCUMENT_EXPIRED: "Vehicle document expired",
    CALENDAR_INVALID_DATE: "Invalid date format",
    CALENDAR_HOLIDAY_NOT_FOUND: "Holiday not found",
    CALENDAR_OVERRIDE_NOT_FOUND: "Calendar override not found",
    PORTAL_INVALID_TOKEN: "Invalid portal token",
    PORTAL_INVALID_OTP: "Invalid one-time password",
    PORTAL_BOOKING_NOT_FOUND: "Booking not found",
    PORTAL_EQUIPMENT_NOT_FOUND: "Equipment not found",
    CASH_REGISTER_NOT_FOUND: "Cash register not found",
    CASH_REGISTER_ALREADY_CLOSED: "Cash register already closed",
    DAILY_CLOSE_ALREADY_EXISTS: "Daily close already completed",
    DELIVERY_NOTE_NOT_FOUND: "Delivery note not found",
    DELIVERY_NOTE_INVALID_STATUS: "Invalid delivery note status",
    MENU_ITEM_ID_REQUIRED: "Menu item ID is required",
    FAVORITES_REQUIRED: "Favorites list is required",
    EQUIPMENT_NOT_FOUND: "Equipment not found",
    EQUIPMENT_NOT_AVAILABLE: "Equipment not available",
    KB_ARTICLE_NOT_FOUND: "Knowledge base article not found",
    WIDGET_ID_INVALID: "Invalid widget ID",
    TENANT_CONTEXT_REQUIRED: "Tenant context required",
    PRI_API_KEY_REQUIRED: "API key is required when enabled",
    HOURLY_RATE_NEGATIVE: "The hourly rate cannot be negative",
    MACHINE_CATEGORY_NOT_FOUND: "Machine category not found",
    HOURLY_RATE_INVALID_DATE: "Invalid date",
    HOURLY_RATE_PERIOD_ORDER: "The end date cannot be earlier than the start date",
    HOURLY_RATE_NOT_FOUND: "Hourly rate configuration not found",
    LEAVE_OVERLAP: "You already have a leave request for this period",
    LEAVE_INSUFFICIENT_BALANCE: "Insufficient leave balance for this request",
    LEAVE_REQUEST_NOT_FOUND: "Leave request not found",
    LEAVE_NOT_PENDING: "The request is no longer pending",
    EMPLOYEE_PROFILE_NOT_FOUND: "Employee profile not found",
    WARRANTY_ELIGIBLE_LIST_FAILED: "Failed to load eligible worksheets",
    WARRANTY_BATCH_FAILED: "Batch warranty invoicing failed",
    WARRANTY_BATCH_INPUT_REQUIRED: "Missing input for batch invoicing",
    WARRANTY_BATCH_INVALID_DATE: "Invalid date in the billing period",
    WARRANTY_BATCH_PERIOD_ORDER: "The start date cannot be later than the end date",
    WARRANTY_ALREADY_INVOICED: "This warranty item has already been invoiced",
    WORKSHEET_ID_REQUIRED: "Worksheet ID is required",
    PARTNER_DUPLICATE_TAX: "A partner with this tax number already exists \u2014 select it from the list.",
    PARTNER_DUPLICATE_CODE: "Partner code collision. Please try again \u2014 a new code will be generated.",
    CALCULATE_FAILED: "The payroll calculation did not complete. Please report this to your system administrator.",
    BOLT_APPROVE_FAILED: "The shop approval did not complete. Please report this to your system administrator.",
    CENTRAL_REVIEW_FAILED: "The central review did not complete. Please report this to your system administrator.",
    FINALIZE_FAILED: "The payroll finalization did not complete. Please report this to your system administrator."
  },
  login: {
    title: "Login",
    email: "Email address",
    password: "Password",
    rememberMe: "Remember me",
    submit: "Sign in",
    error: "Login error",
    forgotPassword: "Forgot password?",
    systemName: "rPI ERP System",
    testCredentials: "Test credentials",
    placeholder: {
      email: "example@email.com"
    },
    errorInvalidCredentials: "Incorrect email or password.",
    errorSystemTemporary: "Temporary system error. Please try again in a few minutes.",
    errorTooManyAttempts: "Too many failed attempts. Please wait a few minutes.",
    errorNetwork: "Could not connect to the server. Check your internet connection."
  },
  rental: {
    loyalty: {
      title: "Redeem loyalty points",
      balance: "Balance: {points} points",
      applied: "{points} points redeemed",
      capReached: "Max redeemable is 50% of the invoice \u2014 the rest is kept."
    },
    clone: {
      cta: "Same as last time ({code})",
      label: "Same as last time?",
      lastRental: "Last rental: {code}",
      helper: "Pre-fills the machines and accessories, adjust afterwards",
      button: "Repeat \u2192",
      banner: {
        label: "Same as last time",
        summary: "{equipment} machines \xB7 {package} packages",
        helper: "Automatically fills in machines, packages and accessories. You can change anything afterwards.",
        apply: "Repeat",
        dismiss: "Empty rental"
      }
    },
    inlineSign: {
      cta: "Sign contract now",
      startFailed: "Failed to prepare the contract."
    },
    pickup: {
      conflictTitle: "Equipment already taken",
      conflictDesc: "Another counter picked up this equipment in the meantime. Availability refreshed \u2014 pick another unit or try again."
    },
    itemDiscount: {
      title: "Per-item discount",
      helper: "Manual discount per item. Above the role limit (role-cap) the system clamps it automatically.",
      inputAria: "Discount % \u2014 {name}",
      applied: "Applied: {pct}%",
      cappedByRole: "capped to role limit: {pct}%",
      totalDiscount: "Total discount",
      finalAmount: "Final amount",
      apply: "Apply discount",
      noneEntered: "Enter at least one discount %.",
      applyFailed: "Failed to apply discount."
    },
    handover: {
      title: "Condition photos",
      uploadHandover: "Upload handover photo",
      uploadReturn: "Upload return photo",
      empty: "No photos uploaded yet",
      uploading: "Uploading\u2026",
      errorType: "Unsupported file type. Allowed: JPEG, PNG, WebP.",
      errorSize: "File is too large (max {max} MB).",
      compareTitle: "Condition comparison (handover \u2194 return)",
      compareHint: "Compare the handover and return photos \u2014 damage already present at handover does not burden the renter in the deposit settlement.",
      handoverColumn: "Handover condition",
      returnColumn: "Return condition"
    },
    title: "Rental",
    subtitle: "Rental management and tracking",
    fleetCalendar: {
      title: "Equipment Calendar",
      available: "Available",
      rented: "Rented",
      reserved: "Reserved",
      overdue: "Overdue",
      equipment: "Equipment",
      noEquipment: "No equipment to display"
    },
    newRental: "New rental",
    equipment: "Equipment",
    startDate: "Start date",
    endDate: "End date",
    deposit: "Deposit",
    dailyRate: "Daily rate",
    returnDate: "Return date",
    returnRental: "Return rental",
    status: {
      active: "Active",
      expired: "Expired",
      returned: "Returned",
      cancelled: "Cancelled"
    },
    contract: "Contract",
    period: "Period",
    rentalFee: "Rental fee",
    depositPaid: "Deposit paid",
    returnDeposit: "Return deposit",
    selectReturnRental: "Select rental to return",
    equipmentConditionCheck: "Equipment condition check",
    paymentSettlement: "Payment settlement",
    returnConfirmation: "Return confirmation",
    activeRentalsCount: "Active rentals ({count})",
    searchPlaceholder: "Search by contract number, partner or equipment...",
    allStatuses: "All statuses",
    selectEquipment: "Select equipment to return",
    rentalData: "Rental data",
    financialSettlement: "Financial settlement",
    damageBreakdown: "Damage compensation by equipment",
    deductions: "Deductions",
    lateFee: "Late fee ({days} days)",
    totalDamage: "Total damage",
    totalDeductions: "Total deductions:",
    returnableDeposit: "Returnable deposit:",
    summary: "Summary",
    returnedEquipment: "Returned equipment:",
    rentalContinues: "Rental continues:",
    returnable: "Returnable:",
    partialReturnConfirm: "Confirm partial return",
    returnConfirm: "Confirm return",
    returnedItems: "Returned items",
    continuingItems: "Rental continues",
    returnableDeposit2: "Returnable deposit",
    cashPayment: "Cash",
    cardPayment: "Card",
    transferPayment: "Transfer",
    cashPaymentLabel: "In cash",
    cardPaymentLabel: "To card",
    transferPaymentLabel: "By transfer",
    deductionsLabel: "Deductions:",
    searchRentalPlaceholder: "Search by rental number, partner or equipment...",
    overdueSubtitle: "Overdue and unreturned equipment",
    searchPartnerPlaceholder: "Search by partner name, equipment name...",
    loadingActive: "Loading active rentals...",
    returnNotFound: "Rental not found or already returned.",
    allRentals: "All rentals",
    partnerNameCol: "Partner name",
    callPartner: "Call partner",
    smsReminder: {
      triggerLabel: "SMS reminder",
      title: "Send SMS reminder",
      recipientLabel: "Recipient",
      messageLabel: "Message",
      defaultMessage: "Dear {customerName}! The return deadline for the rented {equipmentName} passed {days} day(s) ago. Please return it soon or contact us. Regards: Kisg\xE9pcentrum",
      send: "Send",
      sending: "Sending...",
      close: "Close",
      status: {
        sent: "Sent to provider",
        blocked: "Not sent \u2014 SMS sending is currently disabled (gate closed)",
        dryRun: "Test mode: not sent (DRY-RUN), message logged",
        failed: "Sending failed"
      }
    },
    equipmentNameCol: "Equipment name",
    expiryDate: "Expiry date",
    daysOverdue: "Days overdue",
    rentalCodeCol: "Rental code",
    amountCol: "Amount",
    lateFeeLabel: "late fee",
    estimatedLateFeeCol: "Expected fee",
    estimatedLateFeeHint: "Late fee expected if returned now (preview \u2014 the final amount is calculated at return)",
    currentDebt: "Outstanding debt",
    debtExceedsDeposit: "Deposit coverage exceeded!",
    daysLateLabel: "{days} days late",
    daysLabel: "{days} days",
    expired: "Expired:",
    noOverdue: "No overdue items",
    allReturned: "All equipment has been returned on time!",
    backToRentals: "Back to rentals",
    rentalReturn: "Rental return",
    unknownEquipment: "Unknown equipment",
    equipmentCount: "{count} equipment",
    multiItemInfo: "Multi-item rental \u2014 select which equipment to return. Unselected equipment will continue renting.",
    earlyReturnLabel: "Early return",
    earlyReturnDays: "Early return \u2014 {actual}/{original} days",
    originalDiscount: "Original discount:",
    actualDiscount: "Actual discount:",
    discountChanged: "The discount tier has changed \u2014 the price will be recalculated.",
    discountUnchanged: "The discount tier has not changed \u2014 the original price applies.",
    selectEquipmentReturn: "Select equipment to return",
    selectEquipmentSingle: "Equipment to return",
    issuedCondition: "Condition at issue:",
    returnConditionLabel: "Return condition",
    damageDescription: "Damage description",
    damagePlaceholder: "Damage description (if any)...",
    damageChargeLabel: "Damage charge (Ft)",
    damageDescriptionAria: "Damage description: {name}",
    contractLabel: "Contract:",
    partnerLabel: "Partner:",
    periodLabel: "Period:",
    rentalFeeLabel: "Rental fee:",
    depositPaidLabel: "Deposit paid:",
    partialReturnInfo: "Partial return: {returning} equipment returned, {continuing} equipment continues renting",
    damageBreakdownLabel: "Damage charges by equipment",
    noDeductions: "No deductions",
    depositPaidSummary: "Deposit paid:",
    totalDeductionsSummary: "Total deductions:",
    depositRefundMethod: "Deposit refund method",
    optionalNotePlaceholder: "Optional note...",
    returnNoteAria: "Return note",
    returnedEquipmentLabel: "Returned equipment:",
    rentalContinuesLabel: "Rental continues:",
    returnableLabel: "Returnable:",
    partialReturnConfirmTitle: "Confirm partial return",
    returnConfirmTitle: "Confirm return",
    contractSummaryLabel: "Contract:",
    partnerSummaryLabel: "Partner:",
    finalizeReturn: "Finalize return",
    returnTypePartial: "Partial return",
    returnTypeFull: "Full return",
    returnSuccess: "{type} successful!\n\nContract: {contract}\nReturned equipment: {equipment}\nDeposit refund: {deposit}",
    lateFeeWithDays: "Late fee ({days} days)",
    lateFeeConfirmLabel: "Late fee:",
    lateFeeBreakdown: "{days} started day(s) \xD7 {rate}/day",
    lateFeeBreakdownCapped: "cap reached ({max})",
    lateFeeModelLegacy: "150% daily model",
    lateFeeWaived: "late fee waived",
    damageConfirmLabel: "Damage:",
    errorPrefix: "Error: {message}",
    daysDelayLabel: "{days} days late",
    depositLabel: "Deposit:",
    lateFeeAmount: "Late fee:",
    quantityLabel: "Quantity: {count} pcs",
    tierLabels: {
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly"
    },
    startTime: "Start time",
    endTime: "End time",
    hourlyBilling: "Hourly billing",
    hourlyRate: "Hourly rate",
    returnTime: "Return time",
    rentalNotes: "Notes for rental",
    rentalNotesPlaceholder: "Optional notes for rental...",
    quantityPcs: "Quantity: {count} pcs",
    daysAgo: "Overdue by {days} days",
    daysLeft: "{days} days remaining",
    daysUntilExpiry: "{days} days until expiry",
    expiresToday: "Expires today!",
    extension: "Extend",
    extensionDialog: {
      additionalDays: "Additional days",
      currentExpiry: "Current expiry",
      dateError: "New date must be after the current expiry date",
      day: "day",
      days: "days",
      discountTierChange: "Discount tier change",
      newExpiryDate: "New expiry date",
      priceDisclaimer: "Final price will be calculated based on the rental fee schedule",
      reasonLabel: "Reason for extension (optional)",
      reasonPlaceholder: "Why is the extension needed...",
      surcharge: "Surcharge",
      surchargeWithVat: "Surcharge incl. VAT",
      title: "Extend rental"
    },
    extensionError: "Error during extension",
    financialSummary: "Financial summary",
    history: "History",
    notFound: "Rental not found",
    notFoundDescription: "The requested rental does not exist or has been deleted",
    overdueAlert: "Overdue by {days} days \u2014 late fee is being charged!",
    partnerDetails: "Partner details",
    printContract: "Print contract",
    quickInfo: "Quick info",
    remaining: "Time remaining",
    rentedEquipment: "Rented equipment",
    sendEmail: "Send by email",
    timeline: {
      contractCreated: "Contract created",
      depositPaid: "Deposit paid",
      rentalStarted: "Rental started"
    },
    totalRentalFee: "Total rental fee",
    stepWizard: {
      navLabel: "Rental steps",
      step1: "Partner",
      step2: "Equipment",
      step3: "Period",
      step4: "Contract",
      stepAria: "Step {n}",
      stepDoneAria: "done"
    },
    finalizeChecklist: {
      title: "Before finalizing",
      allReady: "Everything ready for handover",
      incomplete: "{count} item(s) still missing",
      itemPartner: "Partner selected",
      itemEquipment: "Equipment in cart",
      itemSchedule: "Rental period set",
      itemPayment: "Payment method selected",
      doneAria: "done",
      missingAria: "missing",
      fix: "Fix \u2192"
    },
    wizard: {
      draftRef: "Draft",
      ctx: {
        renter: "RENTER",
        machines: "MACHINES",
        accCount: "{count} accessories",
        payCard: "Card",
        payCash: "Cash",
        payTransfer: "Transfer"
      },
      depositPaidLabel: "Deposit paid",
      depositPaidYes: "The customer pays now",
      depositPaidNo: "Pays later or not required",
      title: "Start rental",
      subtitle: "Create a new rental",
      stepPartnerDesc: "Select renter",
      stepCostBearerTitle: "Cost bearer",
      stepCostBearerDesc: "Who pays?",
      stepEquipmentTitle: "Equipment",
      stepEquipmentDesc: "Select equipment",
      stepDetailsDesc: "Period and price",
      stepSummaryTitle: "Summary",
      stepSummaryDesc: "Finalize",
      missingData: "Missing data",
      missingDataDesc: "Please fill in all required fields",
      rentalCreated: "Rental created successfully!",
      contractNumber: "Contract number: {number}",
      rentalCreateFailed: "Rental creation failed",
      unknownError: "Unknown error occurred",
      cancelConfirm: "Are you sure you want to cancel the rental?",
      myposTransaction: "MyPOS transaction...",
      creatingRental: "Creating rental...",
      finalizeRental: "Finalize rental",
      selectPartner: "Select renter (main partner)",
      selectPartnerDesc: "Search or select the renting partner",
      searchPartnerPlaceholder: "Search by name, email, phone, tax number, city or ID card...",
      partnersLoading: "Loading partners...",
      partnersLoadError: "Error loading partners: {message}",
      noPartnerResults: "No results found",
      createNewPartner: "+ Create new partner",
      selectedPartner: "Selected partner: {name}",
      trustedStatus: "Trusted",
      warningStatus: "Warning",
      blockedStatus: "Blocked",
      inactiveStatus: "Inactive",
      phoneLabel: "Phone:",
      emailLabel: "Email:",
      taxNumberLabel: "Tax No:",
      idCardLabel: "ID:",
      costBearerLabel: "Cost bearer:",
      balanceLabel: "Balance:",
      loyaltyPointsUnit: "pts",
      totalRentalsLabel: "Total rentals:",
      lastRentalLabel: "Last rental:",
      costBearerTitle: "Cost bearer",
      costBearerDesc: "Who pays the rental fee?",
      partnerPaysSelf: "Partner pays themselves",
      partnerPaysDesc: "{name} pays the rental fee",
      costBearerPays: "Cost bearer pays:",
      costBearerPaysDesc: "Another partner or company pays the rental fee",
      selectCostBearer: "Select the cost bearer:",
      knownCostBearers: "Known cost bearers",
      searchPartner: "Search partner...",
      noCostBearerPartner: "No available cost bearer partner",
      defaultCostBearer: "Default cost bearer:",
      partnerPaysSelfSummary: "Partner pays themselves: {name}",
      selectEquipmentTitle: "Select equipment",
      selectEquipmentDesc: "Select the equipment to rent",
      searchEquipmentPlaceholder: "Search by name, item code, serial number, brand...",
      allFilter: "All ({count})",
      cart: "Cart ({items} items, {total} pcs)",
      dailyTotal: "Daily total: {amount}",
      clearCart: "Clear cart",
      perDay: "/day",
      removeItem: "Remove",
      decrease: "Decrease",
      increase: "Increase",
      totalDeposit: "Total deposit:",
      equipmentLoading: "Loading equipment...",
      equipmentLoadError: "Error loading equipment: {error}",
      noEquipmentResults: "No equipment available matching the filter criteria",
      itemCode: "Item code:",
      brand: "Brand:",
      condition: "Condition:",
      categoryLabel: "Category:",
      dailyPrice: "Daily",
      weeklyPrice: "Weekly",
      monthlyPrice: "Monthly",
      inCart: "In cart: {count} pcs",
      addOne: "+1 pc",
      accessoriesLoading: "Loading accessories...",
      accessoriesLabel: "Accessories:",
      requiredAccessory: "(required)",
      accessoryValue: "Accessory value:",
      detailsTitle: "Rental details",
      detailsDesc: "Enter the rental period and review the prices",
      selectedItems: "Selected items",
      rentalPeriod: "Rental period",
      datePicker: {
        chip: {
          tomorrow: "Tomorrow",
          twoDays: "2 days",
          weekend: "Weekend",
          oneWeek: "1 week",
          custom: "Custom"
        }
      },
      scannerActive: "Scanner active",
      scannerActiveHint: "USB / Bluetooth barcode reader in keyboard wedge mode",
      accessoryDrawer: {
        title: "Accessories \u2014 {name}",
        description: "Select an accessory for this equipment. Searchable, filterable list.",
        searchPlaceholder: "Search by name, part number...",
        requiredOnly: "Required only",
        close: "Back",
        addAccessory: "Add",
        noAccessories: "No results",
        isRequired: "Required accessory",
        valueLabel: "Value: {value}",
        loadingAccessories: "Loading accessories...",
        moreAccessoriesBtn: "More accessories",
        prevPage: "Previous page",
        nextPage: "Next page"
      },
      collapseAll: "Collapse all",
      collapseAllHint: "Close all panels \u2014 high-level overview",
      expandInvalid: "Show invalid only",
      expandInvalidHint: "Open only the panels that need attention",
      scanSuccess: "{name} added to cart",
      scanError: "Scan error",
      scanUnavailable: "Not available",
      scanMatchedField: {
        qrCode: "Matched by QR code",
        factoryBarcode: "Matched by barcode",
        equipmentCode: "Matched by equipment code",
        serialNumber: "Matched by serial number"
      },
      returnDateLabel: "Return date",
      startTimeLabel: "Start time",
      returnTimeLabel: "Return time",
      hourlyBilling: "Hourly billing",
      hourlyBillingDesc: "Hourly billing for the daily rental",
      durationHours: "{hours} hours",
      durationDays: "{days} days",
      priceCalc: "Price calculation",
      duration: "Duration",
      pricingType: "Pricing type",
      netRentalFee: "Net rental fee",
      discount: "Discount",
      discountPercent: "Discount ({percent}%)",
      vat27: "VAT (27%)",
      rentalFeeTotal: "Rental fee total",
      payNow: "Pay now",
      payNowBreakdown: "(Rental fee: {fee} + Deposit: {deposit})",
      selectDatesForCalc: "Select dates for price calculation",
      breakdownTitle: "Price calculation details",
      breakdownDate: "Date",
      breakdownDay: "Day",
      breakdownType: "Type",
      breakdownValue: "Value",
      breakdownWorkday: "Workday",
      breakdownSunday: "Sunday",
      breakdownHoliday: "Holiday",
      breakdownFullDay: "1 day",
      breakdownHalfDay: "\xBD day",
      breakdownCalendarDays: "Calendar days",
      breakdownBillableDays: "Billable days",
      breakdownWeeklyDiscount: "Weekly discount (-{days} day)",
      breakdownPayableDays: "Payable days",
      breakdownDailyRate: "Daily rate",
      breakdownMonthlyNote: "{days} days \u2192 {billable} payable days (monthly discount)",
      perHour: "/hour",
      rentalNotesAriaLabel: "Notes for rental",
      summaryTitle: "Summary",
      summaryDesc: "Review the rental data and confirm",
      partnerData: "Partner details",
      equipmentCount: "Equipment ({count} pcs)",
      returnLabel: "Return",
      durationLabel: "Duration",
      paymentSummary: "Payment summary",
      grossRentalFee: "Gross rental fee",
      totalToPay: "TOTAL TO PAY",
      selectPaymentMethod: "Select payment method:",
      bankCard: "Bank card (MyPOS)",
      companyOnly: "(companies only)",
      selectPaymentRequired: "Please select a payment method to continue",
      disclaimer: "By finalizing the rental, the partner accepts the terms of the rental agreement. The deposit will be returned upon undamaged return of the equipment.",
      tierHourly: "Hourly",
      tierDaily: "Daily rate",
      tierWeekly: "Weekly rate",
      tierMonthly: "Monthly rate",
      contractCreated: "Contract number: {contractNumber}. {transactionInfo}",
      suggestedAccessories: "Suggested accessories",
      noSuggestedPackages: "No suggested accessory packages",
      selectAccessoryPackage: "Select",
      removeAccessoryPackage: "Remove",
      included: "Included",
      consignment: "Consignment",
      accessoryPackageSelected: "Accessory package selected",
      packages: {
        stepTitle: "Packages",
        stepDesc: "Attach packages per equipment",
        intro: "Multiple packages may be attached per equipment (e.g. safety + maintenance).",
        emptyCart: "Add equipment to the cart first.",
        qtyLabel: "{qty} pcs",
        addPackage: "Add package",
        noneAvailable: "No packages available for this equipment.",
        duplicateTitle: "Package already added",
        duplicateDesc: "{name} is already attached \u2014 multiple sets are allowed.",
        removeAria: "Remove package {name}"
      },
      v2: {
        addPackageButton: "Add package",
        cartCount: "{count} pcs",
        cartCountFiltered: "{shown} / {total} pcs",
        cartFilteredEmpty: "No cart items match the active filter. Remove a filter to display items.",
        cartTitle: "Equipment cart",
        categoryHeader: "Category",
        clearFilters: "Clear",
        closePickerAriaLabel: "Close",
        combinedStepTitle: "Equipment + package",
        conditionHeader: "Condition",
        headerSubtitle: "Multi-machine rental, 3-column layout",
        search: {
          label: "Search equipment",
          placeholder: "Search by name, serial number or category\u2026",
          hint: "Start typing to add equipment to the cart.",
          loading: "Searching\u2026",
          noResults: 'No results for "{query}"',
          addAction: "Add to cart",
          addedToCart: "Added: {name}",
          alreadyInCart: "{name} is already in the cart",
          alreadyAdded: "\u2713 Added",
          clearAriaLabel: "Clear search",
          noFilterMatch: "No equipment matches the active filters."
        },
        deferredFilters: "Coming soon:",
        duplicateDesc: 'Package "{name}" is already assigned to this equipment. Added again.',
        duplicateTitle: "Already added",
        emptyCart: "Add equipment items to the cart.",
        equipmentCount: "Equipment",
        filtersTitle: "Filters",
        headerTitle: "Rental wizard \u2014 equipment and packages",
        packageCount: "Package",
        packageRemoveAriaLabel: "Remove package {name}",
        packagesEmpty: "No packages assigned",
        packagesLoading: "Loading packages\u2026",
        packagesNoneAvailable: "No packages available",
        pricingDeposit: "Deposit",
        pricingDiscount: "Discount",
        pricingEmpty: "Add equipment and a period to see pricing.",
        pricingError: "Pricing could not be loaded.",
        pricingGrandTotal: "Gross",
        pricingHeader: "Pricing",
        pricingLoading: "Calculating pricing\u2026",
        pricingSubtotal: "Net",
        pricingVat: "VAT",
        removeAriaLabel: "Remove {name}",
        removeButton: "Remove",
        summaryDeferred: "Coming soon: daily/weekly breakdown, discount coupon, payment method preview.",
        summaryTitle: "Summary",
        legend: {
          title: "Legend",
          free: "Free",
          rentable: "Rentable",
          consignment: "Consignment"
        },
        itemQty: "{qty} pcs",
        itemQtyInc: "Increase",
        itemQtyDec: "Decrease",
        breakdownHeader: "Daily breakdown",
        breakdownWorkdays: "Workdays",
        breakdownSundays: "Sundays",
        breakdownHolidays: "Holidays",
        breakdownBillable: "Billed days",
        breakdownWeeklyDiscount: "Weekly discount (days)",
        periodLabel: "Rental period",
        editPeriod: "Edit",
        perMachineHeader: "Per-machine",
        unnamedItem: "Accessory",
        detail: {
          railTitle: "Rented equipment",
          railCount: "{n} machine",
          railEmpty: "No machines in cart yet.",
          addMachineButton: "+ Add machine",
          activeEmpty: "Add a machine to the cart to see its details.",
          detailHeader: "Machine details",
          detailSku: "Code",
          detailDailyRate: "Daily rate",
          detailPackageSection: "Package",
          accessoryPlaceholder: "\u2014 Accessories (slice-2) \u2014",
          legendTitle: "Legend",
          legendFreeHint: "included in package",
          legendRentableHint: "daily rate, pay only for days used",
          legendConsignHint: "pay only what you use",
          lineTotal: "Line total",
          freeInPkg: "free in package",
          rentableUnit: "HUF/day",
          consignUnit: "HUF/pc (consignment)",
          calcPeriodTitle: "Period",
          calcDays: "{n} days",
          calcPerMachineTitle: "Per-machine breakdown",
          calcMachineRent: "{rate} HUF/day \xD7 {days} days",
          calcEstTotal: "Estimated total",
          calcNote: "{m} machines \xB7 {d} days",
          calcNoPricing: "Set a period to see pricing.",
          accCatalogTitle: "Accessories",
          accCatalogLoading: "Loading accessories\u2026",
          accCatalogEmpty: "No accessories for this machine.",
          accCatalogError: "Failed to load accessories.",
          accTabAll: "All",
          accStockN: "{n} pcs in stock",
          accFree: "free",
          addMachineDialogTitle: "Add machine",
          addMachineSearchPlaceholder: "Search by name or code\u2026",
          addMachineHint: "Start typing to search for a machine.",
          addMachineAddAction: "Add to cart"
        }
      },
      summary: {
        rental: "Rental fee",
        deposit: "Deposit",
        total: "Total",
        consignment: "Consignment"
      },
      reservationTimer: {
        label: "Finalize reservation:",
        expired: "Reservation time expired \u2014 finalizing is still possible.",
        hint: "Visual reminder (not a stock hold)"
      },
      selectedBadge: "Selected",
      calendar: {
        prevMonth: "Previous month",
        nextMonth: "Next month"
      }
    },
    checkout: {
      grant: {
        toggle: {
          label: "The renter authorizes someone to pick up",
          adrHint: "(grantor = renter \u2014 ADR-124)",
          desc: "PERMANENT authorization is valid until revoked. ONE_TIME requires a paper authorization upload."
        },
        section: {
          title: "Authorized person"
        },
        loading: "Loading authorizations...",
        materializeFailed: "Authorization creation failed \u2014 the rental was saved, but the authorization must be added manually on the rental page.",
        permanentDropdown: {
          intro: "Active authorizations \u2014 pick one on behalf of {name}:",
          validFrom: "valid since {date}"
        },
        empty: {
          title: "No active permanent authorizations",
          desc: "{name} currently has no PERMANENT grant on file.",
          tip: 'Tip: permanent authorizations can be created on the Partner page under the "Authorizations" tab.'
        },
        oneTime: {
          cta: "New one-time authorization",
          pendingHint: "The authorization will be created when the rental is finalized."
        },
        oneTimeDialog: {
          title: "New one-time authorization",
          grantor: "Renter (grantor): {name}",
          nameLabel: "Pickup person name",
          namePlaceholder: "e.g. John Smith",
          idCardLabel: "ID card number",
          idCardPlaceholder: "e.g. AB123456",
          phoneLabel: "Phone number",
          phonePlaceholder: "+1 ...",
          gracePeriodWarning: "Paper authorization upload is Sprint 18+ scope. The grant is now created with a 24-hour grace period \u2014 the document must be uploaded within 24 hours, otherwise the system automatically revokes the authorization.",
          submit: "Create authorization",
          submitting: "Saving...",
          errors: {
            nameRequired: "Pickup person name is required",
            noRental: "No rental context \u2014 add at least one rental item first.",
            documentRequired: "Paper authorization is required",
            validationFailed: "Invalid grantee data",
            network: "Network error, please try again"
          }
        }
      },
      subheader: {
        connectionLabel: "Connection",
        renter: {
          label: "renting"
        },
        payer: {
          label: "paying"
        },
        grantee: {
          label: "picking up"
        }
      }
    },
    category: {
      handTools: "Hand tools",
      electricMachines: "Electric machines",
      outdoorMachines: "Outdoor machines",
      other: "Other",
      construction: "Construction",
      cleaning: "Cleaning",
      machinery: "Machinery",
      handTool: "Hand tool",
      measurement: "Measurement",
      safety: "Safety"
    },
    equipmentStatus: {
      available: "Available",
      rented: "Rented",
      inService: "In service",
      reserved: "Reserved"
    },
    condition: {
      excellent: "Excellent",
      good: "Good",
      fair: "Fair",
      poor: "Poor",
      damaged: "Damaged",
      damagedUsable: "Damaged \u2014 usable",
      damagedService: "Damaged \u2192 Service",
      incomplete: "Incomplete",
      new: "New",
      used: "Used"
    },
    sendToService: "Send to Service",
    serviceWorksheetCreated: "Worksheet created: {code}",
    serviceWorksheetError: "Failed to create worksheet",
    damagedServiceInfo: "This equipment cannot be re-issued \u2014 it must be sent to service immediately.",
    damagedServiceDefaultFault: "Post-rental damage \u2014 service required",
    crossSell: {
      addProduct: "Add product",
      additionalItems: "Additional products",
      rentalFee: "Rental fee",
      productTotal: "Product total",
      productVat: "Product VAT (27%)",
      searchPlaceholder: "Search by name or SKU...",
      noResults: "No results",
      stock: "Stock",
      depositNote: "rental only",
      net: "net",
      gross: "gross",
      subtotal: "Products total",
      remove: "Remove",
      quantity: "Quantity",
      emptyCart: "No products added yet",
      unitPrice: "Unit price",
      lineTotal: "Total",
      searching: "Searching...",
      add: "Add",
      pcs: "pcs"
    },
    confirmPickup: "Confirm Pickup + Deposit",
    packageSelect: {
      modeLabel: "Rental mode",
      individual: "Individual equipment",
      package: "Package",
      individualDesc: "Select equipment one by one",
      packageDesc: "Select a pre-built package",
      searchPackage: "Search packages...",
      loadingPackages: "Loading packages...",
      noPackages: "No rental packages available",
      packageContents: "Package contents",
      included: "INCLUDED",
      rental: "RENTAL",
      consignment: "CONSIGNMENT",
      optional: "Optional",
      quantity: "Quantity",
      unitPrice: "Unit price",
      consignmentValue: "Consignment value",
      onDeliveryNote: "on delivery note",
      rentalPrice: "Rental price",
      totalWithConsignment: "Total (rental + consignment)",
      savings: "Savings vs individual rental",
      savingsPercent: "{percent}% savings",
      selectPackage: "Select package",
      selectedPackage: "Selected package: {name}",
      changePackage: "Change package",
      packageItems: "{count} items"
    },
    consignment: {
      title: "Consignment",
      deliveryNote: "Delivery note",
      quantityOut: "Quantity dispatched",
      quantityReturned: "Returned",
      quantityCharged: "Used",
      settlement: "Consignment settlement",
      settleAll: "Settle all",
      activeConsignments: "Active consignments",
      totalValue: "Outstanding value",
      noConsignments: "No consignment items",
      returnedItems: "Returned items",
      chargedItems: "Charged items",
      settlementSummary: "Settlement summary",
      rentalFeeTotal: "Rental fee total",
      consignmentCharges: "Consignment charges",
      grandTotal: "Grand total",
      depositRefund: "Deposit refund",
      warningOverReturn: "Returned quantity cannot exceed dispatched quantity!",
      itemName: "Product",
      dispatched: "Dispatched",
      returned: "Returned",
      charged: "Charged",
      amount: "Amount",
      freeAccessories: "Free accessories",
      freeAccessoriesDesc: "Accessories to return (part of package)",
      accessoryReturned: "Returned",
      accessoryMissing: "Missing",
      consignmentTotal: "Total consignment value",
      consignmentNote: "Consignment value is not invoiced now \u2014 settlement occurs upon return.",
      createFailed: "Consignment creation failed",
      status: {
        active: "Active",
        settled: "Settled",
        partiallySettled: "Partially settled"
      }
    },
    stepNav: {
      navLabel: "Step navigation",
      prev: "Back",
      next: "Next",
      incompleteHint: "This step is incomplete \u2013 you can still continue",
      stepCounter: "Step {current}/{total}"
    },
    contractCard: {
      title: "Rental contract",
      lessor: "Lessor",
      renter: "Renter",
      pdfPreview: "PDF preview / print",
      pdfAfterFinalize: "The contract PDF becomes available after finalization"
    },
    returnTable: {
      contract: "Contract / Start",
      renter: "Renter",
      equipment: "Rented equipment",
      expectedReturn: "Expected return",
      value: "Value",
      status: "Status"
    },
    dueChips: {
      label: "Due:",
      all: "All",
      overdue: "Overdue",
      dueToday: "Due today",
      dueSoon: "Due soon"
    },
    csvHeader: {
      contractNumber: "Contract number",
      partner: "Partner",
      equipment: "Equipment",
      endDate: "Due date",
      status: "Status"
    },
    exportCsv: "Export CSV",
    foundLabel: "results",
    return: {
      signCta: "Sign handover protocol",
      error: {
        generic: "Error processing the return"
      },
      consignment: {
        settleFailedFallback: "Consignment settlement failed",
        settleFailedDetail: "The rental return was completed, but the consignment settlement was NOT. Please try again or contact the administrator."
      },
      protocolTitle: "Handover protocol + signature",
      generateDoc: "Generate protocol",
      signedOk: "Customer signed the protocol"
    },
    partnerIdLabel: "Partner ID",
    resolvedPackage: {
      none: "No package",
      noneDesc: "No active rental package is currently assigned to this machine."
    },
    payment: {
      title: "Record Payment",
      amount: "Amount (HUF)",
      cash: "Cash",
      card: "Card",
      transfer: "Transfer",
      reference: "Reference (optional)",
      notes: "Notes (optional)",
      submit: "Record Payment",
      success: "Payment successfully recorded",
      overpaymentError: "The amount exceeds the outstanding balance",
      recordFailed: "Failed to record the payment",
      transferNotEligibleTitle: "Transfer not permitted",
      transferNotEligibleHint: "Bank transfer is only available to a listed person of the billed company (active representative or valid authorization).",
      transferBannedTitle: "Transfer disabled",
      transferBannedHint: "The billed partner is banned from bank transfer (Three Strikes). Only a manager override can lift it.",
      transferPersonBlockedTitle: "Blocked person \u2014 transfer not permitted",
      transferPersonBlockedHint: "The billed company has blocked this person from the list of accountable persons, so bank transfer payment cannot be started. Add the person to the list, or choose cash.",
      transferCashHint: "Please choose Cash or Card payment.",
      outstandingBalance: "Outstanding Balance",
      paidAmount: "Paid Amount",
      fullyPaid: "Fully Paid",
      recordButton: "Record Payment",
      loyaltyDiscount: "Loyalty Discount"
    },
    depositBreakdown: "Deposit per equipment",
    depositSettledAt: "Settled: {date}",
    depositUnnamed: "Unnamed item",
    depositAction: {
      refund: "Refund",
      retain: "Retain",
      refundTitle: "Full deposit refund",
      retainTitle: "Retain deposit",
      reason: "Reason",
      reasonPlaceholder: "Reason (optional)",
      retainReasonPlaceholder: "Reason (required)",
      confirm: "Confirm",
      submit: "Submit",
      cancel: "Cancel",
      refundSuccess: "Deposit refunded successfully.",
      retainSuccess: "Deposit retained successfully.",
      partialRefund: "Damage deduction",
      partialRefundTitle: "Partial refund (damage deduction)",
      retainedAmount: "Retained (damage) amount",
      retainedAmountPlaceholder: "e.g. 20000",
      damageDescription: "Damage description",
      damageDescriptionPlaceholder: "Short description of the damage (shown on the invoice)",
      vatRate: "VAT rate",
      returnPreview: "Refundable (estimated)",
      partialRefundSuccess: "Damage deduction recorded successfully.",
      viewDamageInvoice: "View damage invoice",
      transfer: "Transfer to worksheet",
      transferTitle: "Transfer deposit to a service worksheet",
      worksheet: "Target worksheet",
      worksheetPlaceholder: "Select a worksheet\u2026",
      transferAmount: "Transfer amount (optional)",
      transferAmountPlaceholder: "Leave empty for the full deposit",
      transferSuccess: "Deposit transferred to the worksheet successfully.",
      noWorksheets: "No transferable worksheet for this partner.",
      worksheetLoading: "Loading worksheets\u2026",
      cardPartialBlocked: "Card deposit \u2014 MyPOS flow",
      cardPartialTooltip: "Damage retention cannot be started from a card (pre-authorized) deposit here \u2014 the refund goes through the MyPOS flow."
    },
    depositActionError: {
      notFound: "Deposit not found.",
      invalidStatus: "The current deposit status does not allow this action.",
      cardNotSupported: "This action is not supported for card (MyPOS) deposits.",
      serviceUnavailable: "The service is temporarily unavailable. Please try again later.",
      failed: "The deposit action failed."
    },
    depositStatus: {
      PENDING: "Pending",
      RECEIVED: "Received",
      HELD: "Held",
      RELEASED: "Released",
      RETAINED: "Retained",
      PARTIAL: "Partially refunded"
    },
    settlement: {
      previewTitle: "Settlement preview",
      linesTitle: "Final invoice lines (preview)",
      vatPending: "VAT under review",
      cashTitle: "Cash settlement",
      deductionsTotal: "Total deductions",
      depositApplied: "Deposit applied",
      refundToCustomer: "Refund to customer",
      payableByCustomer: "Payable by customer",
      cardTitle: "Card deposit (separate settlement)",
      cardNotNetted: "Card deposits are never netted \u2014 the refund goes through the MyPOS flow.",
      invoiceTotal: "Invoice total",
      myposCapture: "MyPOS capture",
      myposRefund: "MyPOS refund",
      forceImmediate: "Immediate settlement required",
      paymentMethod: {
        CASH: "Cash",
        CARD: "Card",
        BANK_TRANSFER: "Bank transfer",
        PRE_AUTH: "Pre-authorization (MyPOS)"
      },
      extrasTitle: "Damage / accessory / cleaning (for preview)",
      missingAccessoryLabel: "Missing accessory (purchase price, HUF)",
      cleaningOverrideLabel: "Cleaning fee override (HUF)",
      cleaningDefaultHint: "empty: default fee",
      missingAccessoryPlaceholder: "0 Ft",
      sectionCharges: "Charges",
      sectionSettlement: "Settlement",
      sectionPayout: "Payout",
      settleModeTitle: "Settlement mode",
      settleNow: "Settle now (default)",
      settleAtClose: "Settle at rental close",
      settleAtCloseHint: "Deposit settlement waits until the rental is closed; returning the last item settles all outstanding deposits automatically.",
      forceImmediateTooltip: "Immediate settlement is required due to the pre-authorized card deposit expiry."
    }
  },
  invoice: {
    title: "Invoices",
    subtitle: "Invoice and fee note management",
    newInvoice: "New invoice",
    editInvoice: "Edit invoice",
    invoiceType: "Invoice type",
    allInvoices: "All invoices",
    paidRevenue: "Paid revenue",
    issuedPending: "Issued / Pending",
    overdueDebt: "Overdue debt",
    searchPlaceholder: "Search (invoice number, partner, tax number)...",
    allStatuses: "All statuses",
    allTypes: "All types",
    dates: "Dates",
    items: "Items",
    itemName: "Item name...",
    noItems: 'No items. Click "Add item" button.',
    netTotal: "Net total:",
    grossTotal: "Gross total:",
    invoiceNotes: "Notes",
    notesPlaceholder: "E.g.: Payment terms, delivery information...",
    createInvoice: "Create invoice",
    saveChanges: "Save changes",
    addressPlaceholder: "1011 Budapest, F\u0151 utca 1.",
    invoiceCreated: "Invoice {action}!\nNumber: {number}\nAmount: {amount}",
    loading: "Loading invoice...",
    notFound: "Invoice not found",
    buyerData: "Buyer data",
    nameLabel: "Name",
    addressLabel: "Address",
    taxNumber: "Tax number",
    description: "Description",
    quantity: "Quantity",
    quantityShort: "Qty",
    unitPrice: "Unit price",
    unitPriceNet: "Unit price (net)",
    vat: "VAT",
    total: "Total",
    productIdLabel: "Item: {id}",
    noItemsEmpty: "No items",
    netTotalLabel: "Net total:",
    vatTotalLabel: "VAT total:",
    payable: "Payable:",
    invoiceData: "Invoice data",
    statusLabel: "Status:",
    typeLabel: "Type:",
    issueDateLabel: "Issue date:",
    dueDateLabel: "Due date:",
    paidAt: "Paid:",
    paymentMethod: "Payment method",
    paymentMethodType: {
      cash: "Cash",
      card: "Card",
      transfer: "Bank transfer",
      cod: "Cash on delivery"
    },
    correctionInvoice: "Correction invoice",
    originalInvoice: "Original invoice:",
    modificationIndex: "Modification index:",
    modificationReason: "Reason:",
    navOnline: "NAV Online",
    navTransactionId: "Transaction ID:",
    resendToNav: "Resend to NAV",
    fullyPaid: "Fully paid",
    balanceDue: "Balance due",
    paidSoFar: "Paid so far: {amount}",
    invoiceTotal: "Invoice total",
    pdfDownload: "Download PDF",
    sendEmail: "Send by email",
    printInvoice: "Print",
    stornoInvoice: "Storno invoice",
    storno: {
      title: "Void invoice",
      subtitle: "Invoice to void",
      reasonLabel: "Reason for storno",
      isProductReturnLabel: "The product was returned",
      inspectionLabel: "The goods have been inspected",
      submit: "Void",
      success: "Invoice voided successfully",
      error: "Failed to void the invoice"
    },
    markPaid: "Mark as paid",
    paid: "Paid",
    overdueWarning: "Overdue invoice! {days} days past due.",
    overdueBalance: "Balance due: {amount}",
    paymentReminder: "Payment reminder",
    pdfAlert: "PDF generation: {number}\n\nThe invoice PDF will be downloaded...",
    emailAlert: "Email sending: {number}\n\nThe invoice will be sent to the partner's email address...",
    navResendAlert: "NAV resend: {number}\n\nThe invoice will be resent to NAV Online...",
    markPaidAlert: "Mark as paid: {number}\n\nThe invoice has been marked as paid.",
    errorOccurred: "An error occurred: {message}",
    unknownError: "Unknown error",
    editInvoiceSubtitle: "Edit invoice data",
    newInvoiceSubtitle: "Create a new invoice",
    partnerData: "Partner data",
    partnerNameRequired: "Partner name *",
    partnerNamePlaceholder: "Partner name...",
    unit: "Unit",
    vatPercent: "VAT %",
    totalGross: "Total (gross)",
    addItem: "+ Add item",
    itemDescriptionPlaceholder: "Item description...",
    grossAmount: "Gross total",
    deleteItem: "Delete",
    noItemsClickAdd: "No items. Click the {button} button.",
    vatLabel: "VAT:",
    savingInProgress: "Saving...",
    saveChangesButton: "Save changes",
    createInvoiceButton: "Create invoice",
    createdAction: "created",
    updatedAction: "updated",
    partnerNameValidation: "Please enter the partner name!",
    itemsValidation: "Please add at least one item!",
    template: {
      standard: "Standard",
      detailed: "Detailed",
      proforma: "Proforma",
      select: "Select template",
      download: "Download PDF ({template})"
    },
    advance: {
      title: "Advance Invoice",
      createDirect: "Create direct advance invoice",
      createFromProforma: "Create advance from proforma",
      createFinal: "Create final invoice with advance deduction",
      cancelAdvance: "Cancel advance invoice",
      deductionLine: "Advance deduction",
      advanceAmount: "Advance amount",
      remainingAmount: "Remaining amount",
      refundMethod: "Refund method",
      cancelReason: "Cancellation reason",
      cancelReasonPlaceholder: "e.g.: Order cancelled, customer request...",
      proformaMustBePaid: "The proforma must be paid",
      advanceMustBePaid: "The advance invoice must be paid",
      deductionExceedsTotal: "Advance deduction exceeds the final invoice total",
      created: "Advance invoice created: {number}",
      finalCreated: "Final invoice created: {number}",
      cancelled: "Advance invoice cancelled",
      cancelledWithStorno: "Advance invoice cancelled, storno: {number}",
      manualTitle: "Advance deduction",
      percentLabel: "Advance %",
      amountLabel: "Advance amount (HUF)",
      percentPlaceholder: "e.g. 30",
      amountPlaceholder: "0 HUF",
      manualHint: "Enter advance percentage or fixed amount. It will be deducted on the final invoice."
    },
    correction: {
      title: "Create correction",
      creating: "Creating...",
      originalInvoice: "Original invoice:",
      originalAmount: "Original amount:",
      issuedAt: "Issued at:",
      reason: "Correction reason *",
      reasonPlaceholder: "E.g.: Quantity error correction, unit price change...",
      reasonMinLength: "Minimum 5 characters required",
      itemChanges: "Item changes",
      netDifference: "Net difference:",
      vatDifference: "VAT difference:",
      grossDifference: "Gross difference:",
      createCorrection: "Create correction invoice",
      correctionTitle: "Correction invoice",
      originalLabel: "Original: {number}",
      partner: "Partner:",
      originalQty: "Original qty",
      newQty: "New quantity",
      originalPrice: "Original price",
      newPrice: "New unit price",
      difference: "Difference",
      correctionCreated: "Correction invoice created: {number}",
      errorPrefix: "Error: {message}",
      reasonValidation: "The reason must be at least 5 characters!",
      correctedItem: "Corrected item",
      differenceItem: "Difference item",
      modificationReference: "Modification reference",
      originalItem: "Original item",
      performanceDateNote: "Performance date note",
      previewTitle: "Correction invoice preview",
      vatSelfAudit: "VAT self-audit",
      vatSelfAuditDescription: "VAT self-audit declaration required"
    },
    deliveryNote: {
      title: "Delivery notes",
      newDeliveryNote: "New delivery note",
      types: {
        standard: "Standard (SZ-)",
        contract: "Contract (SZ-)",
        rentalAccessory: "Rental accessory (SZB-)",
        supplierCredit: "Supplier credit (SZH-)"
      },
      typeLabels: {
        standard: "Standard",
        contract: "Contract",
        rentalAccessory: "Rental accessory",
        supplierCredit: "Supplier credit"
      },
      statusLabels: {
        open: "Open",
        invoiced: "Invoiced",
        settled: "Settled",
        closed: "Closed"
      },
      partnerName: "Partner name",
      partnerNameRequired: "Partner name *",
      partnerId: "Partner ID",
      partnerIdOptional: "Partner ID (optional)",
      partnerIdPlaceholder: "Partner ID",
      partnerNamePlaceholder: "Partner name",
      itemId: "Item ID",
      itemIdPlaceholder: "Item ID",
      productName: "Product name",
      productNamePlaceholder: "Product name",
      notes: "Notes...",
      notesOptional: "Notes (optional)",
      notesPlaceholder: "Notes...",
      typeFilterLabel: "Type",
      items: "Items",
      addItem: "+ Add item",
      description: "Description",
      quantity: "Quantity",
      unitPrice: "Unit price",
      unitPriceHuf: "Unit price (HUF)",
      amount: "Amount",
      totalWithAmount: "Total: {amount}",
      totalLabel: "Total:",
      deleteItem: "Delete",
      cancel: "Cancel",
      saving: "Saving...",
      createButton: "Create delivery note",
      errorPrefix: "Error: {message}",
      unknownError: "Unknown error",
      loading: "Loading...",
      notFound: "Delivery note not found",
      backToList: "Back to list",
      statusLabel: "Status",
      amountLabel: "Amount",
      createdAt: "Created at",
      invoiceId: "Invoice ID",
      contractPartner: "Contract partner",
      manualSettlement: "Manual settlement",
      settled: "Settled",
      notesLabel: "Notes",
      itemsCount: "Items ({count})",
      product: "Product",
      invoicing: "Invoicing",
      processing: "Processing...",
      financiallySettled: "Financially settled",
      assignToInvoice: "Assign to invoice",
      invoiceIdLabel: "Invoice ID",
      invoiceIdPlaceholder: "Invoice ID",
      noDeliveryNotes: "No delivery notes",
      number: "Number",
      date: "Date",
      allTypes: "All types",
      allStatuses: "All statuses",
      batchConfirmGenerate: "Generate invoice",
      batchConfirmMessage: "Generate a batch invoice from the selected delivery notes?",
      batchConfirmTitle: "Batch invoicing",
      batchGenerating: "Generating\u2026",
      batchPartnerMismatch: "The selected delivery notes belong to different partners",
      generateBatchInvoice: "Batch invoice",
      selectForBatch: "Select for batch",
      selectedNotes: "{count} delivery notes selected"
    },
    status: {
      draft: "Draft",
      pending: "Pending approval",
      approved: "Approved",
      sent: "Issued",
      paid: "Paid",
      partiallyPaid: "Partially paid",
      overdue: "Overdue",
      cancelled: "Cancelled",
      voided: "Voided"
    },
    type: {
      standard: "Invoice",
      advance: "Advance invoice",
      final: "Final invoice",
      proforma: "Proforma",
      creditNote: "Credit note",
      correction: "Correction",
      storno: "Storno",
      minuszos: "Negative invoice"
    },
    eInvoice: {
      hash: "Hash",
      noEmail: "No email address",
      notSent: "Not sent",
      send: "Send e-invoice",
      sent: "Sent",
      sentAt: "Sent at: {date}",
      title: "E-invoice",
      partnerNotFound: "Customer not found \u2014 select a valid partner for the NAV invoice",
      partnerIncomplete: "Incomplete customer data (name, postal code, city, address; tax number for companies) \u2014 complete it for the NAV invoice",
      fixPartner: "Edit customer data"
    },
    export: {
      monthLabel: "Export month",
      xlsxButton: "Export (XLSX)",
      csvButton: "CSV",
      error: "Export failed"
    },
    voided: "Voided",
    saveError: "Save error"
  },
  sales: {
    title: "Sales",
    subtitle: "Today's and previous sales",
    totalSales: "Total sales",
    totalRevenue: "Total revenue",
    avgBasket: "Avg. basket",
    searchPlaceholder: "Search (receipt, customer)...",
    allStatuses: "All statuses",
    cashCustomer: "Cash customer",
    statusLabels: {
      inProgress: "In Progress",
      awaitingPayment: "Awaiting Payment",
      completed: "Completed",
      reversed: "Reversed"
    },
    paymentStatusLabels: {
      pending: "Pending",
      partial: "Partial",
      paid: "Paid",
      refunded: "Refunded"
    },
    newSale: "New sale",
    noSales: "No sales matching the filter criteria.",
    pendingPayment: "Awaiting payment",
    errorOccurred: "An error occurred: {message}",
    detail: {
      pendingPayment: "Awaiting payment",
      voided: "Voided",
      receipt: "Receipt",
      invoice: "Invoice",
      processing: "Processing...",
      void: "Void",
      voidConfirm: "Are you sure you want to void this transaction?",
      voidReason: "Voided by user request",
      voidError: "An error occurred while voiding",
      printReceipt: "Printing receipt...",
      printInvoice: "Printing invoice...",
      loadError: "An error occurred while loading.",
      transactionNotFound: "Transaction not found.",
      items: "Items ({count})",
      noItems: "No items",
      discount: "discount",
      customerData: "Customer data",
      partnerId: "Partner ID",
      voidData: "Void details",
      timestamp: "Timestamp",
      reason: "Reason",
      summary: "Summary",
      subtotal: "Subtotal",
      discountAmount: "Discount",
      paymentStatus: "Payment status",
      paidAmount: "Paid: {amount}",
      change: "Change",
      transactionData: "Transaction data",
      transactionNumber: "Transaction number",
      sessionId: "Session ID"
    },
    pos: {
      title: "Cash Register (POS)",
      loadingSession: "Loading register session...",
      noDefaultWarehouse: "No default warehouse for this account. Set one up to open the register.",
      warehouseLoadError: "Could not load the warehouse. Please try again.",
      retry: "Retry",
      openRegister: "Open register",
      suspend: "Suspend",
      closeRegister: "Close register",
      resume: "Resume",
      addCustomer: "+ Customer",
      sessionWarning: "The register is {status}. Open the register to start transactions.",
      sessionSuspended: "suspended",
      sessionClosed: "closed",
      searchPlaceholder: "Search by name, SKU or barcode...",
      allCategories: "All",
      openRegisterForProducts: "Open the register to display products",
      cart: "Cart ({count} items)",
      cartEmpty: "Cart is empty",
      subtotal: "Subtotal:",
      discount: "Discount:",
      total: "Total:",
      clearCart: "Clear cart",
      pay: "Pay",
      payment: "Payment",
      discountFt: "Discount (HUF)",
      receivedAmount: "Received amount (HUF)",
      toPay: "To pay:",
      change: "Change:",
      completePayment: "Complete payment",
      selectCustomer: "Select customer",
      noCustomer: "No customer (cash purchase)",
      saleSuccess: "Sale successful!\nAmount: {total}\nChange: {change}",
      noActiveSession: "No active register session",
      outOfStock: "Product is out of stock",
      procurement: {
        bannerTitle: "{name} \u2014 out of stock",
        bannerHint: "Add it to the central procurement cart so the technician knows this item is needed at the next order.",
        addButton: "Add to procurement cart",
        addSuccess: "Added to the central procurement cart",
        addError: "Failed to add to the cart"
      },
      unknownBarcode: "Unknown barcode: {barcode}",
      barcodeError: "Error scanning barcode",
      paymentError: "Error processing payment",
      voidError: "Error voiding transaction",
      voidReason: "Voided by user",
      productCategories: {
        powerTool: "Power tool",
        handTool: "Hand tool",
        accessory: "Accessory",
        workwear: "Workwear"
      },
      loyalty: {
        balance: "Points Balance",
        points: "points",
        redeem: "Redeem Points",
        maxRedemption: "max {percent}% of total",
        discount: "Loyalty Discount",
        remaining: "Remaining to Pay",
        redeemFailed: "Point redemption failed",
        insufficientPoints: "Not enough loyalty points to redeem",
        concurrentRetry: "The redemption conflicted with another transaction \u2014 please try again"
      },
      packages: {
        title: "Packages",
        badge: "Package",
        setBadge: "Set",
        savingsLabel: "Savings vs. buying separately",
        tieredNotSellable: "This package has rental-length-based pricing and cannot be sold at POS",
        componentPriceMissing: "One of the package items has no price \u2014 set it in the admin panel",
        discountMissing: "The discounted package has no discount configured",
        fixedPriceMissing: "The fixed-price package has no price configured",
        addFailed: "The package cannot be added to the cart"
      },
      barcodePlaceholder: "Scan barcode\u2026",
      creditPayment: "Credit",
      voucherPayment: "Voucher",
      saleSuccessTitle: "Sale successful",
      saleSuccessTotal: "Amount paid",
      saleSuccessChange: "Change",
      saleTransactionLabel: "Transaction",
      navProcessing: "NAV submission in progress\u2026",
      newSale: "New sale"
    },
    session: {
      close: {
        title: "Close register",
        sessionLabel: "Session:",
        openingBalance: "Opening balance:",
        expectedBalance: "Expected balance:",
        closingBalance: "Closing balance (HUF)",
        variance: "Variance:",
        surplus: "Surplus in register",
        shortage: "Shortage in register",
        varianceReason: "Variance reason (required)",
        variancePlaceholder: "Enter the reason for variance...",
        closeError: "Error closing register",
        cancel: "Cancel",
        closing: "Closing...",
        closeButton: "Close register"
      },
      suspend: {
        title: "Suspend register",
        resumeTitle: "Resume register",
        statusLabel: "Status:",
        statusSuspended: "SUSPENDED",
        statusActive: "ACTIVE",
        reasonLabel: "Suspension reason (optional)",
        reasonPlaceholder: "E.g. lunch break, shift change...",
        quickReasons: {
          lunch: "Lunch break",
          break: "Break",
          shiftChange: "Shift change",
          technical: "Technical issue"
        },
        resumeInfo: "The register is currently suspended.",
        resumeHint: 'Click "Resume" to reactivate the register.',
        resuming: "Resuming...",
        resumeButton: "Resume register",
        suspending: "Suspending...",
        suspendButton: "Suspend"
      },
      open: {
        title: "Open register",
        openingBalance: "Opening balance (HUF)",
        openError: "Error opening register",
        cancel: "Cancel",
        opening: "Opening...",
        openButton: "Open register"
      },
      status: {
        open: "ACTIVE",
        suspended: "SUSPENDED",
        closed: "CLOSED",
        noSession: "NO ACTIVE REGISTER"
      }
    },
    zReport: {
      title: "Z-Report",
      sessionInfo: "REGISTER INFORMATION",
      opened: "Opened:",
      closed: "Closed:",
      cashBalance: "CASH BALANCE",
      openingBalance: "Opening balance:",
      expectedBalance: "Expected balance:",
      closingBalance: "Closing balance:",
      variance: "Variance:",
      note: "Note:",
      transactions: "TRANSACTIONS",
      totalTransactions: "Total transactions:",
      completed: "Completed:",
      voided: "Voided:",
      paymentMethods: "PAYMENT METHODS",
      cash: "Cash:",
      card: "Bank card:",
      transfer: "Transfer:",
      voucher: "Voucher:",
      credit: "Credit:",
      revenue: "REVENUE",
      grossSales: "Gross sales:",
      discounts: "Discounts:",
      netSales: "Net sales:",
      taxAmount: "VAT amount:",
      changeGiven: "Change given:",
      print: "Print",
      downloadPdf: "Download PDF",
      downloadPdfSoon: "PDF download feature coming soon",
      close: "Close",
      refunds: "Refunds"
    }
  },
  inventory: {
    title: "Inventory",
    stockList: "Stock list",
    movements: "Movements",
    goodsReceipt: "Goods receipt",
    scrapping: "Scrapping",
    management: "Inventory management",
    warehouseAndMovements: "Warehouse stock and movements",
    allItems: "All items",
    stockValue: "Stock value",
    available: "Available",
    lowStock: "Low stock",
    lowStockCount: "{count} items",
    searchPlaceholder: "Search (product, SKU, reference)...",
    allWarehouses: "All warehouses",
    loadingStock: "Loading stock...",
    reserved: "Reserved",
    purchasePrice: "Purchase price",
    warehouse: "Warehouse",
    noResults: "No results",
    newReceipt: "+ Goods receipt",
    receiptFailed: "Receipt failed. Please try again.",
    availableCount: "Available ({count})",
    reservedCount: "Reserved ({count})",
    lowStockCountBadge: "Low stock ({count})",
    typeLabels: {
      product: "Product",
      rentalEquipment: "Rental equipment",
      part: "Part",
      consumable: "Consumable"
    },
    statusLabels: {
      available: "Available",
      reserved: "Reserved",
      inService: "In service",
      inTransit: "In transit",
      rented: "Rented out",
      sold: "Sold",
      damaged: "Damaged",
      lost: "Lost",
      scrapped: "Scrapped"
    },
    scrapItems: "Scrap items",
    scrapProtocols: "Protocols",
    newScrap: "New scrap record",
    scrapMark: "Mark as scrap",
    scrapRecord: "Record scrap",
    scrapRecording: "Recording...",
    scrapRecords: "Scrap records ({count})",
    noScrapRecords: "No scrap records.",
    scrapReasonLabels: {
      damaged: "Damaged",
      expired: "Expired",
      defective: "Defective",
      other: "Other"
    },
    scrapProtocolStatuses: {
      draft: "Draft",
      approved: "Approved",
      finalized: "Finalized"
    },
    scrapProtocolsTitle: "Scrap protocols",
    newProtocol: "New protocol",
    year: "Year",
    inventoryItemId: "Inventory item ID",
    productId: "Product ID",
    warehouseId: "Warehouse ID",
    itemNotFound: "Item not found",
    stockCount: {
      title: "Stock counts",
      newButton: "New stock count",
      newButtonHint: "Start a stock count \u2014 coming soon",
      empty: "No stock counts yet",
      columns: {
        countNumber: "Count number",
        name: "Name",
        status: "Status",
        createdAt: "Created",
        warehouse: "Warehouse"
      },
      statusLabels: {
        draft: "Draft",
        inProgress: "In progress",
        suspended: "Suspended",
        pendingReview: "Pending review",
        pendingAdjustment: "Pending adjustment",
        completed: "Completed",
        cancelled: "Cancelled"
      }
    },
    movementsTitle: "Inventory movements",
    movementsSubtitle: "Receipts, issues, corrections",
    movementsSearch: "Search (product, SKU, reference)...",
    category: {
      powerTool: "Power tool",
      handTool: "Hand tool",
      accessory: "Accessory",
      consumable: "Consumable",
      workwear: "Workwear",
      sparePart: "Spare part"
    },
    stockStatus: {
      inStock: "In stock",
      lowStock: "Low stock",
      outOfStock: "Out of stock",
      discontinued: "Discontinued"
    },
    movement: {
      in: "Incoming",
      out: "Outgoing",
      adjustment: "Adjustment",
      transfer: "Transfer",
      return: "Return"
    },
    addProduct: "Add product",
    addProductsViaSearch: "Search and add product",
    allGroups: "All groups",
    approve: "Approve",
    backToList: "Back to list",
    basicData: "Basic data",
    batchNumber: "Batch number",
    correction: "Correction",
    create: "Create",
    createdAt: "Created at",
    creating: "Creating...",
    documentData: "Document data",
    finalize: "Finalize",
    issueStock: "Issue stock",
    items: "Items",
    itemsToReceive: "Items to receive",
    location: "Location",
    maximum: "Maximum",
    minimum: "Minimum",
    month: "Month",
    noProtocols: "No protocols",
    optionalReceiptNote: "Optional receipt note",
    pcs: "pcs",
    pricing: "Pricing",
    procurementAndRestock: "Procurement and restock",
    productTypes: "Product types",
    profitability: "Profitability",
    protocolsList: "Protocols list",
    purchaseCategories: {
      ARU: "Goods",
      BERENDEZES: "Equipment",
      BERUHAZAS: "Investment",
      EGYEB: "Other",
      REZSI: "Overhead"
    },
    purchaseCategoryLabel: "Purchase category",
    purchaseCategoryPlaceholder: "Select category...",
    purchaseValue: "Purchase value",
    quickActions: "Quick actions",
    receive: {
      package: "Package",
      packageQuantity: "Package quantity",
      totalUnits: "Total units",
      unitPrice: "Unit price",
      unitsPerPackage: "Units per package"
    },
    receiveStock: "Receive stock",
    recording: "Recording...",
    referenceOrderNumber: "Reference order number",
    saveReceipt: "Save receipt",
    saving: "Saving...",
    searchByNameSkuBarcode: "Search by name, SKU, barcode...",
    serialNumber: "Serial number",
    sku: "SKU",
    stock: "Stock",
    stockLevels: "Stock levels",
    summary: "Summary",
    targetWarehouse: "Target warehouse",
    total: "Total",
    totalPieces: "Total (pcs)",
    transferTitle: "Inter-warehouse transfer",
    transferSubtitle: "In-house stock movement (no invoice)",
    transferSource: "Source warehouse",
    transferTarget: "Target warehouse",
    transferSelectSource: "Select source warehouse",
    transferSelectTarget: "Select target warehouse",
    transferReason: "Reason (optional)",
    transferSameWarehouseError: "Source and target warehouse cannot be the same",
    transferAvailableItems: "Available items",
    transferNoItems: "No available items in the source warehouse",
    transferAdd: "Add",
    transferAddedItems: "Items to transfer",
    transferQuantity: "Quantity",
    transferAvailable: "Available: {qty}",
    transferRemove: "Remove",
    transferSubmit: "Start transfer",
    transferSuccess: "Transfer started (#{id})",
    transfer: {
      confirmNote: "Transfer note",
      confirmOwnAsset: "Confirm registration as own asset",
      confirmRental: "Confirm registration as rental equipment",
      ecsStarted: "Depreciation calculation started",
      error: "Transfer error",
      rentalCardCreated: "Rental equipment card created",
      success: "Transfer successful",
      title: "Stock transfer",
      toOwnAsset: "Reclassify as own asset",
      toRental: "Reclassify as rental equipment"
    },
    updatedAt: "Updated at",
    views: "Views",
    barcode: {
      scan: "Barcode scan",
      scanPlaceholder: "Scan barcode or enter product code...",
      notFound: "No product found for this barcode",
      found: "Product found",
      lookupError: "Barcode lookup error"
    },
    withdrawal: {
      title: "Inventory withdrawal",
      scanToAdd: "Scan barcode to add item"
    },
    splitAvailability: {
      title: "Order-stock split",
      split: "Split availability",
      available: "Available",
      backordered: "Backordered",
      partial: "Partially available",
      fullyAvailable: "Fully available",
      fullyBackordered: "Fully backordered",
      summary: "Summary: {available} available, {backordered} backordered, {partial} partial"
    },
    centralRequest: {
      title: "Request from central warehouse",
      submit: "Submit request",
      submitting: "Submitting...",
      pending: "Pending requests",
      note: "Note",
      notePlaceholder: "Optional note for the request...",
      success: "Request submitted successfully ({count} items)",
      noPending: "No pending requests",
      requestedAt: "Requested at",
      selectLowStock: "Select low stock items"
    },
    phantom: {
      title: "Phantom items",
      count: "{count} phantom items",
      badge: "Phantom ({count})",
      resolve: "Resolve",
      scrap: "Scrap",
      recount: "Recount",
      actualQuantity: "Actual quantity",
      reason: "Reason",
      reasonPlaceholder: "Resolution reason...",
      resolved: "Phantom item resolved",
      noPhantom: "No phantom items"
    },
    deadStock: {
      title: "Dead Stock",
      subtitle: "Items classified by movement recency",
      activeLabel: "Active",
      warningLabel: "Warning",
      deadLabel: "Dead",
      activeCount: "Active items",
      warningCount: "Warning",
      deadCount: "Dead items",
      totalDeadValue: "Dead stock value",
      productName: "Product",
      sku: "SKU",
      quantity: "Quantity",
      lastMovement: "Last movement",
      daysSinceMovement: "Days idle",
      classification: "Classification",
      value: "Value",
      warehouse: "Warehouse",
      noMovement: "No movement",
      noData: "No data for dead stock analysis"
    },
    analytics: {
      title: "Inventory Analytics",
      subtitle: "ITR and ABC analysis"
    },
    turnover: {
      title: "Inventory Turnover Ratio (ITR)",
      ratio: "Turnover ratio",
      cogs: "COGS (estimated)",
      avgInventoryValue: "Avg. inventory value",
      year: "Year",
      previousYear: "Previous year",
      trend: "Trend",
      trendUp: "Increasing",
      trendDown: "Decreasing",
      trendStable: "Stable",
      noData: "No data for turnover analysis"
    },
    abc: {
      title: "ABC Analysis",
      subtitle: "Pareto classification by revenue",
      product: "Product",
      sku: "SKU",
      revenue: "Revenue",
      cumulativePercent: "Cumulative %",
      class: "Class",
      aItems: "A items",
      bItems: "B items",
      cItems: "C items",
      totalRevenue: "Total revenue",
      noData: "No data for ABC analysis"
    },
    seasonality: {
      title: "Seasonality",
      selectProduct: "Select product",
      chooseProduct: "Choose a product...",
      topSeasonal: "Top 10 most seasonal products",
      productName: "Product",
      index: "Seasonality index",
      peakMonths: "Peak months",
      lowMonths: "Low months",
      peak: "Peak",
      normal: "Normal",
      low: "Low",
      noData: "No data for seasonality analysis"
    },
    transferSuggestion: {
      title: "Transfer suggestions",
      totalSuggestions: "Total suggestions",
      product: "Product",
      from: "Source warehouse",
      to: "Target warehouse",
      currentFrom: "Current (source)",
      currentTo: "Current (target)",
      suggestedQty: "Suggested quantity",
      reason: "Reason",
      noSuggestions: "No transfer suggestions at the moment"
    },
    supplierCatalog: {
      title: "Supplier catalog",
      supplier: "Supplier",
      search: "Search",
      searchPlaceholder: "Search product, SKU...",
      results: "Results",
      productName: "Product",
      category: "Category",
      price: "Net price",
      availability: "Availability",
      leadTime: "Lead time",
      days: "days",
      inStock: "In stock",
      outOfStock: "Out of stock",
      noResults: "No results",
      hint: "Select a supplier and search for products in the catalog"
    },
    allProductGroups: "All product groups",
    productGroups: {
      ALKATRESZ: "Spare part",
      GEP: "Machine",
      TARTOZEK: "Accessory",
      SZERSZAM: "Tool",
      MUNKARUHA: "Workwear / PPE",
      VEGYSZER: "Chemical / Lubricant",
      EGYEB: "Other consumable",
      BERGEP: "Rental machine",
      DIJAK: "Fees / Service charge",
      SZERZODESES: "Contractual",
      BERENDEZES: "Equipment"
    },
    reservedForWorksheet: "Reserved for worksheet",
    summaryTitle: "Stock summary",
    summarySubtitle: "Per-product aggregate: how much, reserved vs. free",
    occupiedOfTotal: "{occupied}/{total} occupied",
    stockLevel: {
      OK: "OK",
      LOW: "Low",
      CRITICAL: "Critical",
      OUT_OF_STOCK: "Out of stock"
    },
    movementUnitCost: "Unit cost",
    movementValue: "Movement value",
    breakdown: {
      expand: "Show warehouse breakdown",
      collapse: "Hide warehouse breakdown",
      title: "Per-warehouse breakdown"
    }
  },
  loyalty: {
    title: "VIP Loyalty Program",
    partnerId: "Partner ID",
    pointBalance: "Point balance",
    points: "{count} points",
    trustedStatus: "Trusted status",
    consecutiveClean: "{count} consecutive clean rentals",
    deposit: "Deposit",
    creditPoints: "Credit points",
    amountFt: "Amount (Ft)",
    rentalNumber: "Rental number",
    creditNote: "Notes",
    creditButton: "Credit points",
    crediting: "Crediting...",
    calculationNote: "Calculation: floor(amount / 10,000). For rentals: only from the 11th rental.",
    redeemableRewards: "Redeemable rewards",
    redeem: "Redeem",
    pointHistory: "Point history ({count} records)",
    noPointRecords: "No point records.",
    expiresAt: "Expires: {date}",
    sourceLabels: {
      rental: "Rental",
      purchase: "Purchase",
      bonus: "Bonus",
      redemption: "Redemption",
      expiry: "Expiry"
    },
    depositRequired: "Deposit required",
    depositFree: "Deposit-free",
    creditAmount: "Amount (HUF)",
    rewardLabel: "Reward",
    trusted: "Trusted",
    notTrusted: "Not trusted",
    consecutiveCleanRentals: "{count} consecutive clean rentals",
    depositTitle: "Deposit",
    searchButton: "Search",
    loading: "Loading...",
    amountPlaceholder: "Amount (HUF)",
    rentalCountPlaceholder: "Rental count",
    notePlaceholder: "Note",
    calculationInfo: "Point calculation: floor(amount / 10,000). For rentals: from the 11th rental only.",
    redeemButton: "Redeem",
    expiresLabel: "Expires",
    sourceLabelsObj: {
      RENTAL: "Rental",
      PURCHASE: "Purchase",
      BONUS: "Bonus",
      REDEMPTION: "Redemption",
      EXPIRY: "Expiry",
      SALES: "Sales",
      SERVICE: "Service"
    }
  },
  finance: {
    title: "Finance",
    journalTitle: "General Ledger (Journal)",
    journalSubtitle: "Accounting entries (double-entry bookkeeping)",
    journalSourceFilter: "Source filter",
    journalSourceAll: "All",
    journalSourceInvoice: "Invoice",
    journalSourceSale: "Sale",
    journalSourceRentalDeposit: "Deposit",
    journalSourceRentalDepositRefund: "Deposit refund",
    journalSourceRentalDepositForfeit: "Deposit forfeit",
    journalColEntryNumber: "Entry no.",
    journalColDate: "Date",
    journalColDescription: "Description",
    journalColSource: "Source",
    journalColDebit: "Debit",
    journalColCredit: "Credit",
    journalColAccount: "Account",
    journalUnbalanced: "Not balanced",
    journalEmpty: "No accounting entries in the selected period",
    journalEntryCount: "{count} entries",
    cashRegister: "Cash register",
    cash: {
      noTransactions: "No transactions for this day / filter."
    },
    dailyClose: "Daily close",
    szhFolder: "SZH Folder",
    vouchers: "Vouchers",
    fixedAssets: "Fixed assets",
    szh: {
      label: "SZH",
      activity: "Activity",
      amountFt: "Amount (Ft)",
      anonymous: "Anonymous",
      cancel: "Cancel",
      confirm: "Confirm",
      confirmBody: "Are you sure you want to execute the SZH transaction?",
      confirmTitle: "Confirm SZH transaction",
      creditIssuance: "Credit issuance",
      expectedRevenue: "Expected revenue",
      expectedSettlement: "Expected settlement",
      generateReport: "Generate report",
      generating: "Generating...",
      internalNote: "Internal note",
      internalNoteRequired: "Internal note is required",
      issue: "Issue",
      items: "Items",
      loadError: "Failed to load, please try again.",
      lossReserve: "Loss reserve",
      noItems: "No items",
      partnerName: "Partner name",
      repayment: "Repayment",
      reversal: "Reversal"
    },
    receivables: "Receivables",
    deposit: "Deposit",
    noRegisterOpen: "No cash register open today.",
    openRegister: "Open cash register",
    opening: "Opening...",
    szhFolderButton: "SZH Folder",
    blindCloseButton: "Blind close",
    totalBalance: "Total balance",
    recordTransaction: "Record transaction",
    income: "Income",
    expense: "Expense",
    expenseSummaryTitle: "Expense summary",
    expenseCategory: {
      label: "Expense category",
      none: "No category",
      salary: "Salary / Wages",
      supplierPayment: "Supplier payment",
      office: "Office",
      transport: "Transport / Travel",
      marketing: "Marketing",
      other: "Other"
    },
    amountPlaceholder: "Amount (HUF)",
    notePlaceholder: "Note",
    record: "Record",
    recordError: {
      conflictTitle: "The register changed in the meantime",
      conflictBody: "Someone else recorded a transaction on this register. Refresh the list and check what happened \u2014 your entered data has been kept.",
      refresh: "Refresh",
      amountInvalid: "This amount cannot be recorded like this. Check it and enter it again.",
      noteInvalid: "Please check the note and enter it again.",
      validation: "One of the values cannot be recorded like this. Check it and try again.",
      failed: "The transaction could not be recorded right now. Your entered data has been kept \u2014 please try again."
    },
    transactions: "Transactions",
    loadingData: "Loading...",
    inLabel: "In:",
    outLabel: "Out:",
    blindClose: "Blind close",
    physicalCount: "Enter physical amounts",
    physicalCountDesc: "Count the contents of each pocket, then enter the physical amounts.",
    physicalAmountPlaceholder: "Physical amount (HUF)",
    startBlindClose: "Start blind close",
    compare: "Compare",
    result: "Result",
    match: "Match",
    discrepancy: "Discrepancy!",
    tolerance: "Tolerance: +/-2,000 HUF",
    recountRequired: "Recount required!",
    recountRequiredDesc: "The discrepancy exceeds tolerance. Please recount the pockets.",
    recount: "Recount",
    finalizeClose: "Finalize close",
    discrepancyReport: "Discrepancy report",
    blindCloseComplete: "Blind close completed",
    registerClosedSuccess: "The daily cash register has been successfully closed.",
    backToRegister: "Back to cash register",
    noRegisterToClose: "No open cash register.",
    fixedAssetsTitle: "Fixed assets",
    runDepreciation: "Monthly depreciation run",
    runningDepreciation: "Running depreciation...",
    newAsset: "New asset",
    newAssetForm: "Register new fixed asset",
    assetName: "Name",
    purchasePricePlaceholder: "Purchase price (min 200,000 HUF)",
    commissionDate: "Commission date",
    inventoryNumber: "Inventory number",
    serialNumber: "Serial number",
    recordAsset: "Record asset",
    recording: "Recording...",
    depreciationComplete: "Depreciation run complete: {processed} processed, {deprecated} fully depreciated",
    assetsCount: "Assets ({count})",
    noAssets: "No assets.",
    purchaseLabel: "Purchase:",
    allCategories: "All categories",
    allStatuses: "All statuses",
    categoryLabels: {
      machinery: "Machinery",
      itEquipment: "IT equipment",
      vehicle: "Vehicle"
    },
    assetStatusLabels: {
      active: "Active",
      fullyDepreciated: "Fully depreciated",
      scrapped: "Scrapped",
      sold: "Sold"
    },
    errorOccurred: "Error: {message}",
    vatSummaryTitle: "VAT Summary",
    vatSummarySubtitle: "Output and input VAT overview",
    csvExport: "CSV Export",
    period: "Period",
    periodSelector: "Period selector",
    periodMonth: "Month",
    periodQuarter: "Quarter",
    periodYear: "Year",
    staticData: "static data",
    outputVat: "Output VAT",
    inputVat: "Input VAT",
    vatPayable: "VAT payable",
    vatReclaimable: "Reclaimable",
    salesNet: "Sales net",
    vatBreakdownByRate: "VAT breakdown by rate",
    rateColumn: "Rate",
    outputColumn: "Output",
    inputColumn: "Input",
    balanceColumn: "Balance",
    payableColumn: "Payable",
    total: "Total",
    monthlyTrend: "Monthly trend",
    monthColumn: "Month",
    currentLabel: "current",
    vatDeadlineTitle: "VAT return deadline",
    vatDeadlineDescription: "The monthly VAT return and payment deadline is the 20th of each month. For quarterly returns, the 20th of the month following the quarter.",
    vatPayableLabel: "VAT payable:",
    dueDateLabel: "Due date:",
    vatExempt: "Exempt",
    receivablesAgingTitle: "Receivables - Aging Report",
    generatedAt: "Generated: {date}",
    refresh: "Refresh",
    exportCsv: "Export CSV",
    totalReceivables: "Total receivables",
    overdueReceivables: "Overdue receivables",
    overdueRatio: "Overdue ratio",
    agingBuckets: "Aging Buckets (30/60/90+ days)",
    partnerCount: "{count} partners, {invoices} invoices",
    suspended: "Suspended",
    invoicesOldest: "{count} invoices \u2022 Oldest: {date}",
    sendReminderTitle: "Send {level}",
    sendReminderDefault: "Send reminder",
    suspendPartnerTitle: "Suspend partner",
    unsuspendPartnerTitle: "Lift suspension",
    morePartners: "+ {count} more partners",
    noReceivablesInBucket: "No receivables in this bucket.",
    loadingError: "Error loading data.",
    partnerSuspended: "Partner suspended ({id})",
    partnerUnsuspended: "Partner suspension lifted ({id})",
    actionError: "An error occurred during the operation",
    reminderSent: "Reminder sent{level}: {name}",
    confirmSuspend: "Are you sure you want to suspend partner: {name}?",
    confirmUnsuspend: "Are you sure you want to lift the partner suspension?",
    csvHeaderAgingBucket: "Aging bucket",
    csvHeaderPartnerName: "Partner name",
    csvHeaderPartnerId: "Partner ID",
    csvHeaderAmountHuf: "Amount (HUF)",
    csvHeaderInvoiceCount: "Invoice count",
    csvHeaderOldestInvoice: "Oldest invoice",
    fixedAssetTitle: "Fixed asset",
    loading: "Loading...",
    assetNotFound: "Asset not found",
    back: "Back",
    basicData: "Basic data",
    category: "Category",
    status: "Status",
    inventoryNumberLabel: "Inventory number",
    serialNumberLabel: "Serial number",
    commissionDateLabel: "Commission date",
    depreciationRateLabel: "Depreciation rate",
    valueData: "Value data",
    purchasePrice: "Purchase price",
    currentValue: "Current value",
    depreciationPercent: "Depreciation",
    noteLabel: "Note: ",
    tamDeclarationsTitle: "TAM declarations",
    newTamDeclaration: "New TAM declaration",
    tamDescription: "TAM item (0% VAT) invoice requires a mandatory declaration.",
    invoiceIdPlaceholder: "Invoice ID",
    methodApp: "Application",
    methodEmail: "Email",
    methodPaper: "Paper",
    recordingDeclaration: "Recording...",
    recordDeclaration: "Record declaration",
    retry: "Retry",
    errorPrefix: "Error: {message}",
    unknownError: "Unknown error",
    noTamDeclarations: "No TAM declarations yet.",
    recordedDeclarations: "Recorded declarations ({count})",
    invoiceLabel: "Invoice: {id}",
    methodLabel: "Method: {method}",
    expenseVouchersTitle: "Expense Vouchers",
    expenseVoucherManagement: "Expense voucher management",
    expenseVoucherDescription: "Expense voucher and accountable expense features will be implemented in the next sprint (Story 62-8, 62-9 \u2014 ExpenseVoucher + AccountableExpense Prisma models required).",
    issueExpenseVoucher: "Issue expense voucher",
    issueExpenseVoucherDesc: "Colleague name, amount, purpose \u2192 printable",
    accountableExpense: "Accountable expense",
    accountableExpenseDesc: "Amount, colleague, purpose, 3 business day deadline",
    comingSoon: "Coming soon",
    ev: {
      issueNew: "New voucher",
      issueTitle: "Issue expense voucher",
      recipientName: "Recipient name",
      recipientNamePlaceholder: "e.g. John Smith",
      amount: "Amount",
      purpose: "Purpose",
      purposePlaceholder: "e.g. Office supplies",
      issue: "Issue",
      settleTitle: "Settlement",
      settledAmount: "Settled amount",
      returnedAmount: "Returned amount",
      receiptAttached: "Receipt attached",
      settle: "Settle",
      cancel: "Cancel",
      filterStatus: "Filter by status",
      voucherNumber: "Voucher number",
      recipient: "Recipient",
      deadline: "Deadline",
      noVouchers: "No vouchers.",
      statusIssued: "Issued",
      statusOverdue: "Overdue",
      statusSettled: "Settled",
      statusCancelled: "Cancelled",
      receiptOk: "Receipt OK"
    },
    csvHeaderVatRate: "VAT rate",
    csvHeaderSalesNet: "Sales net (HUF)",
    csvHeaderOutputVat: "Output VAT (HUF)",
    csvHeaderPurchasesNet: "Purchases net (HUF)",
    csvHeaderInputVat: "Input VAT (HUF)",
    csvHeaderDifference: "Difference (HUF)",
    autoAccepted: "Automatically accepted",
    dailyCloseButton: "Start daily close",
    dailyCloseComplete: "Daily close completed",
    expectedBalance: "Expected balance",
    overToleranceWarning: "Variance exceeds tolerance!",
    startDailyClose: "Begin daily close",
    szhLabel: "SZH voucher",
    toleranceInfo: "Tolerance: \xB12,000 Ft",
    monthlyClose: {
      title: "Monthly close",
      subtitle: "Close an accounting period step by step",
      selectPeriod: "Select period",
      selectPeriodDesc: "Choose the year and month to close",
      selected: "Selected",
      periodHistory: "Period history",
      noHistory: "No period history available.",
      periodColumn: "Period",
      statusColumn: "Status",
      closedAtColumn: "Closed at",
      closedByColumn: "Closed by",
      statusOpen: "Open",
      statusClosed: "Closed",
      summaryTitle: "Summary \u2014 {period}",
      revenue: "Revenue",
      expenses: "Expenses",
      vatTotal: "VAT total",
      invoiceCount: "Invoice count",
      transactionCount: "Transaction count",
      closedInfo: "Closed: {date}, by: {user}",
      noteLabel: "Note",
      reopenButton: "Reopen",
      openItemsTitle: "Open items",
      openItemsDesc: "Review unclosed items in this period",
      openDeliveryNotes: "Open delivery notes",
      unpaidInvoices: "Unpaid invoices",
      pendingSzh: "Pending SZH vouchers",
      openItemsWarning: "Warning: There are open items in this period. Consider resolving them before closing.",
      vatBreakdownTitle: "VAT summary",
      vatBreakdownDesc: "VAT breakdown by rate for the period",
      vatRateColumn: "VAT rate",
      netColumn: "Net",
      vatColumn: "VAT",
      grossColumn: "Gross",
      invoiceCountShort: "Invoices",
      noVatData: "No VAT data for this period.",
      csvVatRate: "VAT rate",
      csvNet: "Net (HUF)",
      csvVat: "VAT (HUF)",
      csvGross: "Gross (HUF)",
      csvInvoiceCount: "Invoice count",
      confirmTitle: "Confirm monthly close",
      confirmCheckbox: "I confirm the monthly close for {period}. The period will become read-only after closing.",
      closeNoteLabel: "Note (optional)",
      closeNotePlaceholder: "Note for the close...",
      noPermission: "You do not have permission to close this period. Only ADMIN and above can close periods.",
      closeButton: "Close period",
      closeSuccess: "Monthly close successful!",
      closeSuccessDesc: "The {period} period has been closed successfully. It is now read-only.",
      periodAlreadyClosed: "Period is already closed",
      reopenTitle: "Reopen period",
      reopenDesc: "Reopen the {period} period. This action requires SUPER_ADMIN privileges.",
      reopenReasonPlaceholder: "Reason for reopening...",
      reopenConfirm: "Confirm reopen",
      loadError: "Error loading data.",
      vatFiled: "VAT filed",
      vatNotFiled: "VAT not filed",
      vatFiledAt: "VAT filed: {date}",
      vatFiledBy: "Filed by: {user}",
      markVatFiled: "Mark VAT as filed",
      vatFilingNote: "Note (optional)",
      vatFilingNotePlaceholder: "VAT filing note...",
      vatFiledSuccess: "VAT filing recorded successfully.",
      months: {
        januar: "January",
        februar: "February",
        marcius: "March",
        aprilis: "April",
        majus: "May",
        junius: "June",
        julius: "July",
        augusztus: "August",
        szeptember: "September",
        oktober: "October",
        november: "November",
        december: "December"
      },
      steps: {
        periodSelect: "Select period",
        summaryOverview: "Summary overview",
        openItems: "Open items",
        vatSummary: "VAT summary",
        confirmation: "Confirmation"
      }
    }
  },
  task: {
    title: "Tasks",
    loading: "Loading tasks...",
    searchPlaceholder: "Search...",
    allTypes: "All types",
    allPriorities: "All priorities",
    titlePlaceholder: "Task title...",
    descriptionPlaceholder: "Task description...",
    statusLabels: {
      open: "Open",
      inProgress: "In Progress",
      completed: "Completed",
      interrupted: "Interrupted"
    },
    priorityLabels: {
      low: "Low",
      medium: "Medium",
      high: "High"
    },
    kanbanTitle: "Kanban board and task management",
    newTask: "New Task",
    taskCount: "tasks",
    highPriority: "high priority",
    noTasks: "No tasks",
    assignee: "assignee",
    daysOverdue: "{count} days overdue",
    today: "Today",
    tomorrow: "Tomorrow",
    deadline: "Deadline",
    taskDescription: "Description",
    daysOverdueLabel: "days overdue",
    quantityLabel: "Quantity",
    unitDefault: "pcs",
    statusChange: "Change Status",
    closeButton: "Close",
    titleLabel: "Title",
    descriptionLabel: "Description",
    priorityLabel: "Priority",
    priorityMedium: "Medium",
    quantityFieldLabel: "Quantity",
    unitLabel: "Unit",
    createButton: "Create",
    assignTo: "Assign responsible",
    assignedUsers: "Assignees",
    searchUsers: "Search staff...",
    removeAssignee: "Remove",
    status: {
      open: "Open",
      inProgress: "In progress",
      completed: "Completed",
      cancelled: "Cancelled"
    },
    type: {
      shopping: "Shopping",
      todo: "To-do",
      note: "Note",
      message: "Message"
    },
    priority: {
      low: "Low",
      medium: "Medium",
      high: "High"
    }
  },
  admin: {
    title: "Admin Center",
    quickActions: "Quick actions",
    dailyOpen: "Daily opening",
    dailyOpenDesc: "Start store opening process",
    dailyClose: "Daily close",
    dailyCloseDesc: "Start store closing process",
    sendReminders: "Send reminders",
    sendRemindersDesc: "Expired rental reminders",
    knowledgeBase: "Knowledge base",
    knowledgeBaseDesc: "Help and guides",
    subtitle: "Daily summary, quick actions and operations",
    expiredRentals: "Expired rentals",
    oldestDays: "Oldest: {days} days",
    noExpiredRentals: "No expired rentals",
    receivables: "Receivables",
    overdue30Partners: "30+ days: {count} partners",
    noReceivables: "No receivables",
    serviceWorksheets: "Service worksheets",
    worksheetStats: "Waiting: {waiting} | In progress: {inProgress} | Done: {completed}",
    todayBookings: "Today's bookings",
    todayPlanned: "Planned for today",
    tasks: "Tasks",
    expiredTasks: "Expired: {count} tasks",
    noExpiredTasks: "No expired tasks",
    dailyOpenWizard: "Daily opening",
    dailyCloseWizard: "Daily closing",
    stepCashBalance: "Cash opening balance",
    stepExpiredRentals: "Expired rentals",
    stepTodayBookings: "Today's bookings",
    stepServiceWaiting: "Service waiting",
    stepReceivables: "Receivables",
    stepTasks: "Tasks",
    stepSummary: "Summary",
    stepCashBalanceClose: "Cash balance",
    stepOpenRentals: "Open rentals",
    stepServiceStatuses: "Service statuses",
    stepDailyTurnover: "Daily turnover",
    stepTaskClose: "Task close",
    enterOpeningBalance: "Enter the cash opening balance (cash register + safe).",
    openingBalanceHuf: "Opening balance (HUF)",
    storeOpened: "Store opened",
    openingTime: "Opening time",
    expectedBalanceHuf: "Expected balance (HUF)",
    actualBalanceHuf: "Actual balance (HUF)",
    difference: "Difference",
    storeClosed: "Store closed",
    closingTime: "Closing time",
    openStore: "Open store",
    closeStore: "Close store",
    cashBalanceDesc: "Enter the expected and actual cash balance.",
    cashMismatch: "The cash balance does not match the expected value!",
    openRentalsReview: "Open rentals review",
    expiredRentalsLabel: "Expired rentals",
    pcs: "pcs",
    oldestRental: "Oldest rental",
    expiredDaysAgo: "Expired {days} days ago",
    serviceCloseStatus: "Service worksheets closing status",
    waitingLabel: "Waiting",
    inProgressLabel: "In progress",
    todayCompleted: "Completed today",
    dailyTurnoverSummary: "Daily turnover summary",
    todayBookingsLabel: "Today's bookings",
    receivablesLabel: "Receivables",
    taskReviewClose: "Task review and close",
    assignedTasks: "Assigned tasks",
    expiredTasksLabel: "Expired tasks",
    noteOptional: "Note (optional)",
    notePlaceholder: "Note about today...",
    verifyAndCloseStore: "Verify the data and close the store.",
    cashBalance: "Cash balance",
    expectedActual: "Expected: {expected} | Actual: {actual}",
    deviation: "Deviation: {amount}",
    openRentalsLabel: "Open rentals",
    serviceWorksheetsOpen: "Service worksheets (open)",
    tasksExpiredAssigned: "Tasks (expired / assigned)",
    noteLabel: "Note:",
    back: "Back",
    permissionMatrix: {
      adminAlwaysActive: "Admin (always active)",
      loading: "Loading...",
      noWidgets: "No widgets in the system."
    },
    kb: {
      tagPlaceholder: "New tag (press Enter to add)"
    },
    warehouseLoading: "Loading warehouse \u2014 please wait.",
    warehouseMissing: "No default warehouse is configured for this company, so the cash register cannot be opened/closed. Contact your admin.",
    warehouseFetchFailed: "Failed to fetch the warehouse (network error). Please try again.",
    warehouseUnresolved: "The warehouse cannot be identified, so the cash register operation cannot run."
  },
  settings: {
    title: "Settings",
    fullName: "Full name",
    emailAddress: "Email address",
    phoneNumber: "Phone number",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    profileTab: "Profile",
    appearanceTab: "Appearance",
    notificationsTab: "Notifications",
    systemTab: "System",
    personalData: "Personal data",
    uploadImage: "Upload image",
    role: "Role",
    changePassword: "Change password",
    theme: "Theme",
    themeSystem: "System",
    themeLight: "Light",
    themeDark: "Dark",
    language: "Language",
    langHu: "Magyar",
    langEn: "English",
    langDe: "Deutsch",
    fontSize: "Font size",
    fontSmall: "Small",
    fontMedium: "Medium",
    fontLarge: "Large",
    compactMode: "Compact mode",
    compactModeDesc: "Smaller margins and spacing",
    notifEmail: "Email notifications",
    notifEmailDesc: "Receive notifications by email",
    notifPush: "Push notifications",
    notifPushDesc: "Browser notifications",
    notifSound: "Sound alert",
    notifSoundDesc: "Notification sound",
    notifRentalExpiry: "Rental expiry",
    notifRentalExpiryDesc: "Alert on rental expiry",
    notifServiceReady: "Service ready",
    notifServiceReadyDesc: "Notification when service work is completed",
    notifNewBooking: "New booking",
    notifNewBookingDesc: "Online booking notification",
    notifPaymentReceived: "Payment received",
    notifPaymentReceivedDesc: "Notification on payment receipt",
    notifLowStock: "Low stock",
    notifLowStockDesc: "Stock level warning",
    notifTaskAssigned: "Task assigned",
    notifTaskAssignedDesc: "Notification on new task assignment",
    notificationPrefs: {
      title: "Notification settings",
      subtitle: "Choose which channels (email / SMS / in-app) each notification type goes to, and set a daily quiet window.",
      loading: "Loading settings\u2026",
      loadError: "Failed to load settings. Please try again.",
      channelsTitle: "Channels by notification type",
      channels: {
        email: "Email",
        sms: "SMS",
        "in-app": "In-app"
      },
      domains: {
        vehicle: "Vehicle",
        rental: "Rental",
        service: "Service",
        sales: "Sales",
        finance: "Finance",
        workflow: "Workflow",
        documents: "Documents",
        partner: "Partner"
      },
      priorityCritical: "Critical",
      quietHoursTitle: "Quiet hours",
      quietHoursHint: "During quiet hours only critical notifications are delivered \u2014 the rest are deferred to the next day.",
      quietHoursStart: "Start",
      quietHoursEnd: "End",
      timezone: "Time zone",
      timezonePlaceholder: "Pick a time zone\u2026",
      saveAll: "Save all",
      saving: "Saving\u2026",
      unsavedChanges: "{count} unsaved changes",
      allSaved: "All changes saved",
      adminResetTitle: "Admin: reset preferences",
      adminResetHint: "Franchise admin \u2014 resets one user's notification preferences to catalog defaults. That user will start receiving the default notifications again.",
      adminResetPlaceholder: "User UUID",
      adminResetAction: "Reset",
      adminResetting: "Resetting\u2026",
      adminResetSuccess: "{count} rows reset to defaults.",
      adminResetError: "Reset failed. Check the user UUID and your permissions."
    },
    systemSettings: "System settings",
    autoLogout: "Auto logout",
    autoLogoutDesc: "Logout after inactivity",
    minutes: "minutes",
    dataExport: "Data export",
    dataExportDesc: "Download personal data per GDPR",
    exportButton: "Export data",
    dangerZone: "Danger zone",
    deleteAccount: "Delete account",
    deleteAccountDesc: "Permanently delete account and all associated data",
    deleteButton: "Permanently delete account",
    subtitleText: "System and user settings",
    roleLabel: "Role",
    changePasswordButton: "Change password",
    themeLabel: "Theme",
    emailNotifications: "Email notifications",
    pushNotifications: "Push notifications",
    summaryEmails: "Summary emails",
    rentalExpiryDesc: "Notification 1 day before rental expiry",
    dailySummaryDesc: "Every day at 8:00 AM",
    weeklySummaryDesc: "Every Monday at 8:00 AM",
    languageLabel: "Language",
    dateFormatLabel: "Date format",
    currencyLabel: "Currency",
    timezoneLabel: "Timezone",
    securityTitle: "Security",
    rentalDefaultsTitle: "Rental defaults",
    defaultRentalDays: "Default rental period (days)",
    defaultDeposit: "Default deposit (%)",
    exportDesc: "Download all data in CSV format",
    clearCache: "Clear cache",
    clearCacheDesc: "Clear local cache and settings",
    clearButton: "Clear",
    profileSaved: "Profile saved!",
    notificationsSaved: "Notification settings saved!",
    systemSaved: "System settings saved!",
    currencyHUF: "HUF - Hungarian Forint",
    currencyEUR: "EUR - Euro",
    autoLogout15: "15 minutes",
    autoLogout30: "30 minutes",
    autoLogout60: "1 hour",
    autoLogout120: "2 hours",
    autoLogoutNever: "Never",
    ocr: {
      zebraLabel: "Zebra ZD220 label (43x26mm)"
    },
    avatarHelp: "JPG or PNG, max 2MB",
    sms: {
      sendTab: "Send SMS",
      historyTab: "History",
      templatesTab: "Templates"
    }
  },
  dashboard: {
    title: "Dashboard",
    monthlyRevenue: "Monthly revenue",
    activeRentals: "Active rentals",
    openWorksheets: "Open worksheets",
    dailyTransactions: "Daily transactions",
    revenueChart: "Revenue chart",
    topPartners: "Top partners",
    equipmentProfit: "Equipment profit",
    rentalStats: "Rental statistics",
    serviceProfit: "Service profit",
    seasonality: "Seasonality",
    stockAlerts: "Stock alerts",
    technicianWorkload: "Technician workload",
    partnerActivity: "Partner activity",
    warrantyRatio: "Warranty ratio",
    revenueForecast: "Revenue forecast",
    vatSummary: "VAT summary",
    recurringIssues: "Recurring issues",
    popularEquipment: "Popular equipment",
    section: {
      alreadyAtBottom: "Already at bottom position",
      alreadyAtTop: "Already at top position",
      collapse: "Collapse",
      collapseSection: "Collapse section",
      comingSoon: "Coming soon...",
      expand: "Expand",
      expandSection: "Expand section",
      moveDown: "Move down",
      moveSectionDown: "Move section down",
      moveSectionUp: "Move section up",
      moveUp: "Move up",
      settings: "Settings",
      summary: "Summary",
      finance: "Finance",
      inventory: "Inventory",
      service: "Service",
      partner: "Partners",
      analytics: "Rental",
      rental: "Rental",
      kassza: "Cash Register"
    },
    collapse: "Collapse",
    expand: "Expand",
    showMore: "Show more",
    showLess: "Show less",
    welcome: "Welcome, {name}!",
    todaySummary: "Here is today's summary.",
    defaultUser: "User",
    executiveSummaryAriaLabel: "Executive Summary - Key Metrics",
    executiveSummaryTitle: "Executive Summary",
    expandWidget: "Expand widget",
    minimize: "Minimize",
    minimizeWidget: "Restore to small size",
    pinIndicatorAriaLabel: "Pinned section",
    pinIndicatorTitle: "Always visible - not collapsible",
    collapseAll: "Collapse all",
    contactAdminForPermissions: "Ask the administrator to set up permissions.",
    executive: {
      activeWorksheets: "Active Worksheets",
      businessHealth: "Business Health",
      dailyRevenue: "Daily Revenue",
      healthGood: "Good",
      inventory: "Inventory",
      openedToday: "opened today",
      receivables: "Receivables",
      utilization: "utilization",
      revenueTarget: "target: {amount}",
      receivablesTarget: "target: {amount}"
    },
    expandAll: "Expand all",
    hideExecutiveSummary: "Hide Executive Summary",
    loading: "Loading...",
    noSections: "No displayable sections.",
    noWidgetsInSection: "No displayable widget in this section.",
    notAuthenticated: "Not authenticated",
    sectionCount: "{count} section(s)",
    showExecutiveSummary: "Show Executive Summary",
    resetLayout: "Reset to default layout",
    dragToReorder: "Drag here to reorder",
    widgets: {
      reset: "Reset widget settings",
      sync_error: "Failed to save widget settings \u2014 please try again",
      sync_success: "Widget settings saved",
      migration_done: "Previous layout loaded",
      migration_error: "Failed to migrate previous layout",
      loading: "Loading settings...",
      saved: "Saved"
    },
    kassza: {
      threePocketTitle: "3-Pocket Cash Register",
      total: "Total",
      mainRegister: "Main Register",
      szhPocket: "Supplier Credit Pocket",
      bankAccount: "Bank (K&H)",
      dailyNet: "daily net",
      toleranceTitle: "Cash Tolerance",
      toleranceOk: "Within tolerance",
      toleranceWarning: "Warning",
      toleranceCritical: "Out of tolerance!",
      lastTransactions: "Recent Transactions",
      income: "Income",
      expense: "Expense",
      transfer: "Transfer",
      minutesAgo: "min ago",
      hoursAgo: "hr ago",
      dailyStatusTitle: "Daily Status",
      statusOpen: "Open",
      statusClosed: "Closed",
      openedAt: "Opened at",
      szhReportTitle: "Supplier Credit Summary",
      szhTotal: "SC Total",
      statusNotOpened: "Not opened",
      noData: "No data"
    },
    franchiseRevenue: {
      title: "Franchise revenue distribution",
      total: "Total"
    },
    kpi: {
      grossRevenue: "Gross Revenue",
      grossRevenueAria: "Gross Revenue KPI widget",
      netRevenue: "Net Revenue",
      netRevenueAria: "Net Revenue KPI widget",
      receivables: "Receivables",
      receivablesAria: "Receivables KPI widget",
      high: "High",
      payments: "Payments",
      paymentsAria: "Payments KPI widget"
    },
    detailedView: "Detailed view"
  },
  network: {
    online: "Online",
    offline: "Offline",
    offlineMode: "Offline Mode",
    syncing: "Syncing...",
    lastSync: "Last Sync",
    pendingSync: "pending sync",
    syncComplete: "Sync Complete",
    syncFailed: "Sync Failed",
    minuteAgo: "minute ago",
    minutesAgo: "minutes ago",
    hourAgo: "hour ago",
    hoursAgo: "hours ago"
  },
  table: {
    partner: "Partner",
    period: "Period",
    amount: "Amount",
    status: "Status",
    actions: "Actions",
    date: "Date",
    type: "Type",
    description: "Description",
    quantity: "Qty",
    unitPrice: "Unit price",
    vat: "VAT",
    netAmount: "Net",
    grossAmount: "Gross",
    addItem: "Add item"
  },
  payment: {
    cash: "Cash",
    card: "Card",
    transfer: "Transfer",
    method: "Payment method"
  },
  page: {
    allStatuses: "All statuses",
    allTypes: "All types",
    allCategories: "All categories",
    noResults: "No results matching the search criteria.",
    noFilterResults: "No results matching the filter criteria.",
    errorPrefix: "Error: {message}",
    displayed: "{count} displayed",
    partnersDisplayed: "{count} partners displayed",
    ordersCount: "{count} orders",
    itemsCount: "{count} items",
    daysLate: "{count} days late",
    machinesCount: "{count} machines"
  },
  partner: {
    title: "Partners",
    subtitle: "Customer, supplier and subcontractor management",
    name: "Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    taxNumber: "Tax number",
    newPartner: "New partner",
    partnerList: "Partner list",
    totalPartners: "Total partners",
    company: "Company",
    individual: "Individual",
    withBalance: "With balance",
    totalBalance: "Total balance",
    contact: "Contact",
    revenue: "Revenue",
    balance: "Balance",
    categories: "Categories",
    duplicatesTitle: "Partner duplicates & abandoned equipment",
    searchPlaceholder: "Search by name, code, email, phone, tax number...",
    matchFieldLabels: {
      phone: "Phone",
      documentNumber: "Document number",
      email: "Email",
      name: "Name",
      taxNumber: "Tax number",
      DOCUMENT_NUMBER: "Document number",
      EMAIL: "Email address",
      NAME: "Name",
      TAX_NUMBER: "Tax number"
    },
    actionLabels: {
      scrapped: "Scrapped",
      sold: "Sold",
      retained: "Retained",
      DESTROY: "Destroy",
      KEEP: "Keep",
      SELL: "Sell"
    },
    scrappingReason: "Scrapping reason:",
    registerData: "Register partner data",
    typeAndCategory: "Type and category",
    partnerType: "Partner type",
    categoriesRequired: "Categories * (at least one)",
    basicData: "Basic data",
    companyName: "Company name",
    companyNameOptional: "Company (optional)",
    validation: {
      taxFormat: "Invalid tax number format (8-1-2 digits).",
      taxChecksum: "The tax number checksum is invalid.",
      phoneFormat: "Invalid phone number format.",
      postalFormat: "Invalid postal code format (4 digits)."
    },
    fullName: "Full name",
    shortName: "Short name",
    registrationNumber: "Registration number",
    contactInfo: "Contact information",
    website: "Website",
    billingAddress: "Billing address",
    postalCode: "Postal code",
    city: "City",
    streetAddress: "Street, house number",
    floorDoor: "Floor/door",
    notificationEmail: "Notification email",
    billingEmail: "Billing email",
    billingEmailSameAsNotification: "Same as notification email",
    temporaryAddress: "Temporary address",
    tempAddressValidUntil: "Valid until",
    temporaryAddressSection: "Temporary address (if different from permanent)",
    temporaryAddressExpired: "(expired)",
    lastDocumentScanDate: "Last document scan",
    documentExpiredWarning: "Document refresh required",
    documentExpiredRentalWarning: "Partner's document was scanned more than 180 days ago. Please request an updated document!",
    cashB2bTaxNumberRequired: "Tax number is required for cash transactions with company partners!",
    paymentBypassEnabled: "Allow bank transfer without manager approval",
    paymentBypassDescription: "When enabled, the partner can pay by bank transfer without separate manager authorization.",
    paymentBypassReadonlyHint: "Can only be changed via the manager approval flow.",
    fieldReadonlyHint: "Set at creation \u2014 not editable here.",
    categoriesReadonlyHint: "Categories are derived from the partner type \u2014 not editable here.",
    idVerified: "ID document verified",
    idVerifiedOn: "\u2705 Verified: {date}",
    costBearerTree: "Cost bearer hierarchy",
    costBearerCompany: "Cost bearer company",
    costBearerEmployees: "Employees",
    compareTitle: "Partner comparison",
    partnerA: "Partner A (source)",
    partnerB: "Partner B (match)",
    compareDescription: "Choose which partner to merge into. Merging transfers rentals, worksheets, and invoices.",
    mergeIntoA: "Merge into A \u2192",
    mergeIntoB: "\u2190 Merge into B",
    openInNewTab: "Open in new tab \u2192",
    tabRentals: "Rentals",
    tabService: "Service",
    tabInvoices: "Invoices",
    tabLoyalty: "Loyalty",
    transactionTabPlaceholder: "Loading transactions...",
    loyaltyPoints: "Loyalty points",
    depositExemption: "Deposit exemption",
    depositRequired: "Required",
    depositExempt: "Exempt",
    depositAutomatic: "Automatic (TRUSTED)",
    depositRequiredDesc: "Deposit is required for all rentals",
    depositExemptDesc: "Exempted by store manager \u2014 0 deposit",
    depositAutomaticDesc: "Automatic exemption after 10 clean rentals",
    depositExemptionUpdated: "Deposit exemption updated",
    depositExemptionError: "Failed to update deposit exemption",
    depositExemptionListRequired: "Deposit exemption requires at least one authorized representative (active delegate or power of attorney) \u2014 add one first.",
    depositExemptionRbacHint: "Only a store manager can change this",
    loyaltyTier: "Tier",
    phones: "Phone numbers",
    phoneNumbers: "Phone numbers",
    addPhone: "Add phone number",
    phoneLabel: "Type",
    phoneLabelPlaceholder: "e.g. Service, Parts...",
    phoneNumber: "Phone number",
    phoneLabelPrivate: "Private",
    phoneLabelCompany: "Company",
    phoneLabelFax: "Fax",
    phoneLabelOther: "Other",
    phonePrimary: "Primary",
    phoneMaxReached: "Maximum 5 phone numbers allowed",
    personalData: "Personal data",
    birthDate: "Date of birth",
    birthPlace: "Place of birth",
    mothersName: "Mother's maiden name",
    idCardNumber: "ID card number",
    financialSettings: "Financial settings",
    paymentTermDays: "Payment term (days)",
    creditLimitFt: "Credit limit (HUF)",
    discountPercent: "Discount %",
    rentalDepositPercent: "Rental deposit %",
    createPartner: "Create partner",
    notesPlaceholder: "Optional notes about the partner...",
    nameRequired: "Name is required!",
    categoryRequired: "Please select at least one category!",
    partnerCreated: "Partner created!",
    partnerNotFound: "Partner not found",
    backToList: "Back to list",
    companyLabel: "Company",
    individualLabel: "Individual",
    tabOverview: "Overview",
    tabAddresses: "Addresses",
    tabContacts: "Contacts",
    tabRepresentatives: "Representatives",
    tabFinancial: "Financial",
    tabHistory: "History",
    statistics: "Statistics",
    totalRevenue: "Total revenue:",
    ordersCount: "Orders:",
    rentalsCount: "Rentals:",
    serviceOrdersCount: "Service orders:",
    lastOrder: "Last order:",
    lastRental: "Last rental:",
    debt: "Debt:",
    rentalSettings: "Rental settings",
    depositPercent: "Deposit %:",
    rentalStatus: "Rental status:",
    blocked: "Blocked",
    allowed: "Allowed",
    newAddress: "New address",
    noAddresses: "No addresses registered.",
    newContact: "New contact",
    noContacts: "No contacts registered.",
    primary: "Primary",
    defaultAddress: "Default",
    addressBilling: "Billing",
    addressShipping: "Shipping",
    addressOther: "Other",
    suspend: "Suspend",
    unsuspend: "Unsuspend",
    suspended: "Partner suspended",
    unsuspended: "Suspension lifted",
    suspendConfirm: "Are you sure you want to suspend the partner: {name}?",
    unsuspendConfirm: "Are you sure you want to lift the partner suspension?",
    suspendError: "Error during suspension",
    unsuspendError: "Error lifting suspension",
    suspendedBanner: "Partner suspended",
    suspendedBannerDesc: "This partner has been suspended due to payment issues. Rental and new order creation is not possible.",
    rentalBlockedNote: "Rental blocked \u2014 suspension must be lifted.",
    blockedRentalTooltip: "Partner suspended \u2014 rental cannot be started",
    newRental: "New rental",
    newSale: "New sale",
    newWorksheet: "New worksheet",
    publicNote: "Public note",
    internalNote: "Internal note",
    outstandingDebt: "Outstanding debt: {amount}",
    contactSupport: "Please contact customer support.",
    noOutstandingDebt: "No outstanding debt.",
    paymentTerm: "Payment term",
    creditLimit: "Credit limit",
    baseDiscount: "Base discount",
    priceList: "Price list",
    debtsTitle: "Debts",
    partnerUpdated: "Partner data updated",
    partnerCreatedBy: "Partner created ({user})",
    nDays: "{count} days",
    defaultPriceList: "Default",
    noneValue: "None",
    categoryLabels: {
      retail: "Retail customer",
      wholesale: "Wholesale customer",
      renter: "Renter",
      service: "Service",
      supplier: "Supplier",
      subcontractor: "Subcontractor"
    },
    typeLabels: {
      individual: "Individual",
      company: "Company"
    },
    idCard: "ID card",
    drivingLicense: "Driving license",
    passport: "Passport",
    duplicateSuspects: "Duplicate suspects",
    abandonedEquipment: "60-day abandoned equipment",
    editTitle: "Edit partner",
    saveChanges: "Save changes",
    errorPrefix: "Error: {error}",
    saveFailed: "An error occurred while saving",
    confidence: "confidence",
    detected: "Detected",
    mergeButton: "Merge",
    dismissButton: "Dismiss",
    noDuplicates: "No unresolved duplicates.",
    worksheetLabel: "Worksheet",
    noAbandonedEquipment: "No abandoned equipment pending decision.",
    scrapButton: "Scrap",
    sellButton: "Sell",
    keepButton: "Keep",
    namePlaceholderCompany: "Acme Inc.",
    namePlaceholderIndividual: "John Smith",
    shortNamePlaceholder: "Acme",
    streetPlaceholder: "123 Main St.",
    category: {
      retail: "Retail customer",
      wholesale: "Wholesale customer",
      rental: "Renter",
      service: "Service",
      supplier: "Supplier",
      contractor: "Contractor"
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      blocked: "Blocked",
      trusted: "Trusted",
      warning: "Warning"
    },
    type: {
      individual: "Individual",
      company: "Company"
    },
    createSuccess: "Partner created successfully!\nCode: {code}\nName: {name}",
    placeholder: {
      address: "123 Main Street",
      city: "London",
      companyName: "Example Ltd.",
      email: "info@example.com",
      lastName: "Example",
      personName: "John Smith",
      website: "https://example.com",
      birthPlace: "e.g. Budapest",
      mothersName: "e.g. Jane Smith",
      temporaryAddress: "e.g. 1052 Budapest, Pet\u0151fi t\xE9r 3.",
      idCardNumber: "e.g. 123456AB"
    },
    contractPrices: {
      title: "Contract prices"
    },
    discount: {
      categorized: "Categorized discount",
      max: "Maximum discount",
      noStacking: "Discounts cannot be combined",
      rental: "Rental discount",
      sales: "Sales discount",
      service: "Service discount"
    },
    displayedCount: "Displayed: {count}",
    quickCreate: {
      title: "Quick Create Partner",
      typeLabel: "Type",
      individual: "Individual",
      company: "Company",
      nameLabel: "Name *",
      namePlaceholder: "Partner name",
      taxNumberLabel: "Tax Number",
      taxNumberPlaceholder: "12345678-1-42",
      emailLabel: "Email",
      emailPlaceholder: "email@example.com",
      phoneLabel: "Phone",
      phonePlaceholder: "+36 30 123 4567",
      cityLabel: "City",
      cityPlaceholder: "Budapest",
      submit: "Create",
      cancel: "Cancel",
      success: "Partner created successfully: {name}",
      error: "Error creating partner: {message}",
      taxNumberHint: "Invoicing may be limited without a tax number",
      duplicateWarning: "Similar partner already exists:",
      notFound: "Can't find it? Create new partner",
      searchPlaceholder: "Search by name, email, phone, tax number, city..."
    },
    sanctions: {
      title: "Sanctions",
      transferBan: "Transfer banned",
      transferBanThreeMonth: "3-month ban",
      transferBanSixMonth: "6-month ban",
      transferBanPermanent: "Permanent ban",
      transferBanNone: "No ban",
      banUntil: "Ban expires: {date}",
      strikeCount: "Late payment incidents: {count}",
      walkInOnly: "Walk-in only",
      walkInOnlyUntil: "Walk-in restriction expires: {date}",
      bookingWarning: "Booking warning",
      cancelledCount: "Cancelled bookings: {count}",
      noShowCount: "No-shows: {count}",
      override: "Override",
      overrideTitle: "Override Sanction",
      overrideReason: "Reason *",
      overrideReasonPlaceholder: "Why are you overriding this sanction?",
      overrideConfirm: "Confirm Override",
      overrideSuccess: "Sanction overridden successfully",
      overrideBy: "Overridden by: {user}",
      overrideAt: "Override date: {date}",
      discountsRevoked: "Discounts revoked",
      amnestyExpires: "Amnesty expires: {date}"
    },
    segment: {
      title: "Customer Segment",
      vip: "VIP",
      active: "Active",
      atRisk: "At Risk",
      inactive: "Inactive",
      calculatedAt: "Last calculated: {date}",
      changedAt: "Segment changed: {date}",
      distribution: "Segment Distribution",
      partnerCount: "{count} partners"
    },
    suggestions: {
      title: "Suggestions",
      crossSell: "{category} \u2014 {count} in stock",
      noSuggestions: "No suggestions",
      calculating: "Segmentation in progress..."
    },
    kpi: {
      lifetimeValue: "Lifetime value",
      outstandingBalance: "Outstanding balance",
      totalRentals: "Total rentals"
    },
    timeline: {
      title: "Customer timeline",
      quickAddNote: "Note",
      loadMore: "Load more",
      loadError: "Failed to load",
      empty: 'No events yet \u2014 create the first note with the "Note" button.',
      expand: "Details",
      collapse: "Collapse",
      filterLabel: "Type filter",
      types: {
        TASK: "Task",
        INVOICE: "Invoice",
        QUOTE: "Quote",
        DELIVERY_NOTE: "Delivery note",
        RENTAL: "Rental",
        WORKSHEET: "Worksheet",
        LOYALTY: "Loyalty",
        TASK_NOTE: "Note",
        TASK_CALL: "Call"
      },
      quickAddDialog: {
        title: "Quick note",
        description: "Record a note or call on the customer timeline.",
        typeLabel: "Type",
        titleLabel: "Title",
        titlePlaceholder: "Short summary",
        descriptionLabel: "Details",
        descriptionPlaceholder: "Optional detailed description",
        submit: "Save"
      },
      metaLabels: {
        dueDate: "Due date",
        completedAt: "Completed",
        priority: "Priority",
        issueDate: "Issue date",
        paidAmount: "Paid",
        balanceDue: "Balance due",
        currency: "Currency",
        paymentMethod: "Payment method",
        paidAt: "Paid at",
        navStatus: "NAV status",
        validUntil: "Valid until",
        sentAt: "Sent",
        acceptedAt: "Accepted",
        rejectedAt: "Rejected",
        invoiceId: "Invoice ID",
        settledManually: "Settled manually",
        startDate: "Rental start",
        expectedEnd: "Expected return",
        actualEnd: "Actual end",
        returnedAt: "Returned at",
        depositRequired: "Deposit (required)",
        depositPaid: "Deposit (paid)",
        depositReturned: "Deposit (returned)",
        itemCount: "Item count",
        equipment: "Equipment",
        serialNumber: "Serial number",
        receivedAt: "Received",
        deliveredAt: "Delivered",
        isWarranty: "Warranty",
        transactionCount: "Transactions",
        totalSpend: "Total spend"
      }
    },
    tabAuthorizationGrants: "Authorization",
    roleToggle: {
      customerLabel: "CUSTOMER",
      supplierLabel: "SUPPLIER",
      addCustomer: "+ Add CUSTOMER role",
      addSupplier: "+ Add SUPPLIER role",
      removeAria: "Remove role",
      confirmAddTitle: "Add role",
      confirmRemoveTitle: "Remove role",
      confirmAddText: "Add the {role} role to this partner?",
      confirmRemoveText: "Remove the {role} role from this partner?",
      notYetWired: "Role toggle not yet wired \u2014 coming soon (STORY-1212 follow-up)."
    },
    receiverData: "Receiver details (individual)",
    intent: {
      title: "What is the customer here for?",
      hint: "The selection marks which details are needed. Optional, and it never blocks saving.",
      purchase: "Purchase",
      rental: "Rental",
      service: "Service"
    },
    requiredMissing: {
      title: "Details missing for this transaction type",
      hint: "Saving is not blocked \u2014 these can be added later."
    },
    field: {
      name: "Name",
      phone: "Phone number",
      email: "Email address",
      address: "Address / registered seat",
      idCard: "ID card",
      addressCard: "Address card",
      birthData: "Birth details",
      mothersName: "Mother's name",
      taxNumber: "Tax number",
      representative: "Representative / receiver"
    },
    receiverHint: "The receiving individual's data is required for machine handover \u2014 do not skip.",
    companyDataSecondary: "Company data (cost bearer)",
    mothersNameRequired: "Mother's name is required (receiver)!",
    idCardRequired: "ID card number is required (receiver)!",
    idCardExpiry: "ID card expiry",
    idCardCurrentMasked: "Current (saved): {masked} \u2014 leave empty if unchanged",
    duplicate: {
      warning: "A similar customer may already exist \u2014 check the list."
    },
    saveAndNew: "Save and new",
    saveAndNewSuccess: "Partner saved \u2014 the form is cleared for a new entry.",
    saveHint: "Tip: Ctrl+Enter to save quickly",
    searchFilter: {
      typeAll: "All",
      typeIndividual: "Individual",
      typeCompany: "Company",
      availableOnly: "Available only",
      ariaLabel: "Partner filters",
      recentTitle: "Recent partners"
    },
    scan: {
      button: "\u{1F4F7} Scan ID document",
      buttonAriaLabel: "Scan document with camera",
      processing: "Processing...",
      success: "Scan successful \u2014 please verify the data",
      failure: "Scan failed, please try again",
      lowConfidence: "Low confidence \u2014 please verify the data manually"
    },
    expired: {
      banner: "\u26A0\uFE0F Expired document \u2014 {days} days ago",
      bannerNoDate: "\u26A0\uFE0F The document has expired",
      overrideCheckbox: "Continue with expired document",
      overrideReasonLabel: "Override reason (required)",
      overrideReasonPlaceholder: "e.g. Customer received the renewed document that day",
      overrideReasonRequired: "A reason is required to continue with an expired document"
    },
    representative: {
      title: "Representatives",
      add: "Add",
      name: "Name",
      phone: "Phone",
      email: "Email",
      idNumber: "ID number",
      validFrom: "Valid from",
      validUntil: "Valid until",
      unlimited: "unlimited",
      permissions: "Permissions",
      canRent: "Can rent",
      canReturn: "Can return",
      canSign: "Can sign",
      canPayCash: "Can pay cash",
      active: "Active",
      inactive: "Inactive",
      expired: "Expired",
      expiringSoon: "Expiring soon",
      activate: "Activate",
      deactivate: "Deactivate",
      confirmDelete: "Are you sure you want to delete this representative?",
      noRepresentatives: "No representatives",
      notes: "Notes"
    },
    selectSettlement: "Multiple settlements share this postal code \u2014 please choose:"
  },
  pos: {
    customerPanel: {
      title: "Customer Info",
      noCustomer: "Select a partner to view discounts",
      discounts: "Discounts",
      discountRental: "Rental: {percent}%",
      discountSales: "Sales: {percent}%",
      discountService: "Service: {percent}%",
      balance: "Balance Due",
      balanceAmount: "{amount} Ft",
      creditLimit: "Credit limit: {amount} Ft",
      depositExempt: "Deposit exempt",
      recentTransactions: "Recent Transactions",
      noTransactions: "No history",
      viewDetails: "Partner details"
    },
    suggestions: {
      winBack: "No rental for {days} days \u2014 10% discount offer",
      winBackApply: "Apply",
      inactiveNote: "Former customer \u2014 inactive for 6+ months",
      crossSellTitle: "Recommended Products",
      crossSellItem: "{name} \u2014 {count} in stock",
      addToCart: "Add to cart"
    }
  },
  service: {
    warrantyClaim: "Warranty claim",
    warrantyClaimNumber: "Claim number",
    warrantyManufacturer: "Manufacturer",
    warrantyManufacturerPlaceholder: "Manufacturer name",
    warrantyClaimValue: "Claim value",
    warrantySettledAmount: "Settled amount",
    warrantySubmittedAt: "Submitted at",
    warrantyNoClaimYet: "No warranty claim yet",
    warrantyNotes: "Notes",
    warrantyNotesPlaceholder: "Note for the claim",
    warrantySubmitClaim: "Submit claim",
    warrantyCreateClaim: "Create warranty claim",
    photos: "Photos",
    uploadPhoto: "Upload photo",
    photoFile: "File",
    photoFileRequired: "A file is required",
    photoCaption: "Caption",
    photoCaptionPlaceholder: "Photo caption",
    photoTypeLabel: "Type",
    photoTypeGeneral: "General",
    photoTypeBefore: "Before repair",
    photoTypeAfter: "After repair",
    photoTypeDamage: "Damage",
    noPhotos: "No photos uploaded",
    itemTypeOther: "Other",
    title: "Service",
    subtitle: "Service worksheet management",
    worksheet: "Worksheet",
    worksheetLoading: "Loading worksheet...",
    worksheetNotFound: "Worksheet not found",
    technician: "Technician",
    parts: "Parts",
    laborCost: "Labor cost",
    diagnosis: "Diagnosis",
    warranty: "Warranty",
    startWork: "Start work",
    billing: "Billing",
    quote: "Quote",
    close: "Close",
    reception: "Reception",
    worksheetIntake: "Worksheet intake",
    newServiceWorksheet: "New service worksheet",
    worksheetIntakeAndPrint: "Worksheet intake and print",
    creating: "Creating...",
    cancelIntakeConfirm: "Are you sure you want to cancel the worksheet intake?",
    selectPartner: "Select customer",
    identifyDevice: "Identify device",
    identifyDeviceDesc: "Select the device to service from the system, or enter manually.",
    reportFault: "Report fault",
    device: "Device",
    fault: "Fault",
    diagnosticsNeeded: "Diagnostics needed",
    diagnosticsNeededDesc: "The worksheet has been recorded, the customer received the receipt. Diagnostics will be done in a separate step.",
    startDiagnostics: "Start diagnostics",
    diagnosticsAndItems: "Diagnostics and items",
    queuePositionLabel: "Position {position}",
    itemNotFound: "Item not found",
    inspection: "Inspection",
    inspectionDesc: "Indicate the received condition of the device and record the digital signature location.",
    deviceReceivedState: "Device received condition *",
    assembledState: "Assembled condition",
    disassembledState: "Disassembled condition",
    assembledDesc: "The device arrives in original, assembled condition. No surcharge.",
    disassembledDesc: "The device arrives in disassembled condition. Assembly surcharge will be applied.",
    disassembledSurcharge: "Surcharge for disassembled condition",
    noSurcharge: "No surcharge for assembled condition",
    free: "Free",
    deadline: "Deadline",
    limit: "Limit",
    searchPlaceholder: "Search by worksheet number, partner, equipment or fault...",
    equipmentProduct: "Equipment / Product",
    designation: "Designation",
    serialNumber: "Serial number",
    faultDescription: "Fault description",
    diagnosisAndWork: "Diagnosis and completed work",
    completedWork: "Completed work",
    internalNote: "Internal note",
    internalOnly: "Internal use only",
    internalNoteHelper: "This note is not visible to the customer.",
    worksheetData: "Worksheet data",
    costLimit: "Cost limit",
    responsibleId: "Responsible ID",
    expectedCompletion: "Expected completion",
    queuePosition: "Queue position",
    storageFee: "Storage fee",
    storageStart: "Storage start",
    storageDailyFee: "Daily fee",
    storageTotalFee: "Total fee",
    timestamps: "Timestamps",
    received: "Received",
    created: "Created",
    modified: "Modified",
    completed: "Completed",
    creatorId: "Creator ID",
    relatedRental: "Related rental",
    viewRental: "View rental",
    statusLabels: {
      received: "Received",
      inProgress: "In Progress",
      waiting: "Waiting",
      completed: "Completed",
      billable: "Billable",
      closed: "Closed",
      cancelled: "Cancelled"
    },
    typeLabels: {
      paid: "Paid repair",
      warranty: "Warranty",
      rentalService: "Rental service",
      maintenance: "Maintenance"
    },
    priorityLabels: {
      urgent: "Urgent (+20%)",
      normal: "Normal",
      warranty: "Warranty"
    },
    categoryLabels: {
      powerTool: "Power tool",
      gardenEquipment: "Garden equipment",
      construction: "Construction",
      cleaningMachine: "Cleaning machine",
      other: "Other"
    },
    searchInSystem: "Search in system",
    manualEntry: "Manual entry",
    searchProductPlaceholder: "Search by name, manufacturer, model or serial number...",
    productsLoading: "Loading products...",
    productsLoadError: "Error loading products: {message}",
    serialNumberShort: "S/N: {serial}",
    manualDeviceEntry: "Manual device entry",
    manualDeviceDataEntry: "Manual device data entry",
    deviceNameRequired: "Device name *",
    deviceNamePlaceholder: "e.g. Makita HR2470 Rotary Hammer",
    serialNumberPlaceholder: "e.g. MK-2024-001234",
    selectedDevice: "Selected device: {name}",
    selectPartnerHeading: "Select partner",
    selectPartnerDesc: "Select the customer whose device you want to service.",
    searchPartnerPlaceholder: "Search by name, email, phone, tax number, city or ID card...",
    partnersLoading: "Loading partners...",
    partnersLoadError: "Error loading partners: {message}",
    trustedPartner: "Trusted",
    warningStatus: "Warning",
    blockedStatus: "Blocked",
    taxNumberLabel: "Tax number: {taxNumber}",
    costBearer: "Cost bearer: {name}",
    selectedPartner: "Selected partner: {name}",
    reportFaultDesc: "Enter the fault description and select the worksheet type.",
    deviceUnderWarranty: "The device is under warranty!",
    warrantyExpiry: "Warranty expires: {date}",
    worksheetType: "Worksheet type",
    recommended: "(Recommended)",
    faultDescriptionRequired: "Fault description *",
    faultDescriptionPlaceholder: "Describe the fault in detail, symptoms, when it occurred...",
    faultDescriptionHint: "The more detailed the description, the faster the diagnostics.",
    costLimitOptional: "Cost limit (optional)",
    costLimitHint: "If repair cost exceeds this amount, prior consultation is required.",
    summaryType: "Type: {type}",
    summaryPriority: "Priority: {priority}",
    summaryCostLimit: "Cost limit: {limit} Ft",
    inspectionFeeLabel: "Inspection / assembly fee",
    attentionWarning: "Attention!",
    disassembledWarning: "For devices received in disassembled condition, the assembly fee will be charged regardless of whether the repair is performed or not.",
    digitalSignature: "Digital signature",
    digitalSignatureArea: "Digital signature area",
    signatureTouchHint: "Touch the screen to record the signature",
    signatureConfirmation: "The customer's signature confirms the handover of the device and the condition assessment.",
    summaryTitle: "Summary",
    summaryState: "Condition: {state}",
    summaryFee: "Fee: {fee}",
    summarySignature: "Signature: {status}",
    signatureRecorded: "Recorded",
    signatureNotRecorded: "Not yet recorded",
    historyLabels: {
      created: "Created",
      statusChange: "Status change",
      itemAdded: "Item added",
      itemRemoved: "Item removed",
      assigned: "Assigned",
      comment: "Comment",
      invoiced: "Invoiced",
      completed: "Completed"
    },
    editWorksheet: "Edit worksheet",
    saveError: "An error occurred while saving",
    errorPrefix: "Error: {message}",
    worksheetNotEditable: "This worksheet is in {status} status and cannot be edited.",
    deviceData: "Device data",
    deviceNamePlaceholderShort: "e.g. Makita DLX2220",
    serialNumberPlaceholderShort: "e.g. SN123456789",
    worksheetSettings: "Worksheet settings",
    priorityField: "Priority",
    costLimitFt: "Cost limit (HUF)",
    costLimitPlaceholder: "e.g. 50000",
    faultDescriptionCustomerPlaceholder: "What does the customer experience?",
    diagnosisCausePlaceholder: "What is the cause of the fault?",
    workPerformedPlaceholder: "What work was performed?",
    internalNotePlaceholder: "Internal notes (not visible to customer)...",
    statusChangeTitle: "Status change",
    continueWork: "Continue",
    toBilling: "To billing",
    saveChanges: "Save changes",
    diagnosticsStepDesc: "Record the diagnostics, then add parts and labor costs.",
    diagnosisLabel: "Diagnostics / Findings *",
    diagnosisPlaceholder: "Device condition, found faults, required repairs...",
    workPerformedDetailPlaceholder: "Detailed description of work performed...",
    laborNorms: "Labor norms",
    customItem: "Custom item",
    searchPartPlaceholder: "Search by part name or SKU...",
    stockCount: "Stock: {count} pcs",
    searchNormPlaceholder: "Search by norm code or description...",
    normsLoading: "Loading norms...",
    normsLoadError: "Error loading norms: {message}",
    minuteUnit: "min",
    addCustomItem: "Add custom item",
    customItemPlaceholder: "e.g. On-site service fee",
    unitPriceFt: "Unit price (HUF)",
    addedItems: "Added items ({count})",
    partLabel: "Part",
    otherLabel: "Other",
    externalCostLabel: "Subcontractor cost",
    addExternalCost: "Add subcontractor cost",
    externalCostDescription: "Description",
    externalCostDescriptionPlaceholder: "e.g. Motor rewinding, Galvanisation...",
    externalCostAmount: "Amount (net HUF)",
    externalCostAmountPlaceholder: "e.g. 25000",
    externalCostBadge: "Subcontractor",
    externalCostAdded: "Subcontractor cost added",
    externalCostDescriptionRequired: "Subcontractor cost description is required (min. 2 characters)",
    externalCostAmountPositive: "Subcontractor cost amount must be positive",
    itemTypeExternalCost: "Subcontractor cost",
    vatLabel: "VAT (27%):",
    summaryHeading: "Summary",
    summaryStepDesc: "Review the data and finalize the worksheet.",
    nameLabel: "Name:",
    emailLabel: "Email:",
    phoneLabel: "Phone:",
    designationSummaryLabel: "Designation:",
    serialNumberSummaryLabel: "Serial number:",
    categoryLabel: "Category:",
    warrantyLabel: "Warranty:",
    warrantyExpiredNone: "Expired/None",
    faultReport: "Fault report",
    typeLabel: "Type:",
    priorityLabel: "Priority:",
    costLimitSummaryLabel: "Cost limit:",
    faultDescriptionSummaryLabel: "Fault description:",
    findingLabel: "Findings:",
    completedWorkSummaryLabel: "Completed work:",
    itemsWithCount: "Items ({count} items)",
    netLabel: "Net:",
    noItemsAdded: "No items added.",
    completionSection: "Completion",
    internalOnlyPlaceholder: "Visible only to service staff...",
    costLimitWarning: "The worksheet total ({total} HUF) exceeds the specified cost limit ({limit} HUF). Customer consultation required!",
    worksheetReadyToCreate: "The worksheet is ready to be created",
    accessories: "Accessories",
    accessoriesDesc: "Indicate which accessories were received with the device.",
    receivedAccessories: "Received accessories",
    addCustomAccessory: "Add custom accessory",
    customAccessoryPlaceholder: "e.g. Dust extractor adapter, Laser level...",
    customLabel: "Custom",
    accessoryNote: "Accessory notes",
    accessoryNotePlaceholder: "Additional notes about accessory condition, missing items...",
    selectedAccessoriesCount: "Selected accessories ({count} pcs)",
    noAccessoriesSelected: "No accessories selected.",
    noAccessoriesHint: "If the device arrived without accessories, leave empty and proceed.",
    fieldService: "Field service",
    fieldServiceDesc: "Indicate if this is an on-site repair.",
    fieldServiceAddress: "Site address *",
    fieldServiceAddressPlaceholder: "e.g. 1052 Budapest, De\xE1k Ferenc utca 15.",
    fieldServiceAddressHint: "Enter the exact address where the repair needs to be performed.",
    deviceMobility: "Device mobility",
    mobilityLabels: {
      mobile: "Mobile",
      immobile: "Immobile",
      partiallyMobile: "Partially mobile"
    },
    mobilityDescriptions: {
      mobile: "The device can be freely moved, not fixed in place.",
      immobile: "The device is fixed in place, must be repaired on-site.",
      partiallyMobile: "The device has limited mobility, assistance required."
    },
    assistanceNeeded: "Assistance needed",
    assistanceNeededDesc: "The service technician needs help moving or accessing the device.",
    assistanceNeededSuffix: " \u2014 Assistance needed",
    fieldObstacles: "On-site obstacles, notes",
    fieldObstaclesPlaceholder: "e.g. Floor number, entrance side, parking options, special circumstances...",
    fieldServiceDetails: "Field service details",
    damageClaim: {
      title: "Damage claims",
      titleSingle: "Damage claim",
      statusLabels: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        settled: "Settled"
      },
      typeLabels: {
        warranty: "Warranty (ML-GAR)",
        damage: "Damage claim (ML-BH)"
      },
      noClaims: "No damage claims.",
      repairCost: "Repair: {amount}",
      lostRevenue: "Lost revenue: {amount}",
      totalClaim: "Total: {amount}",
      rejectedPrefix: "Rejected: {note}",
      approve: "Approve",
      reject: "Reject",
      rejectionPrompt: "Rejection reason:",
      notFound: "Damage claim not found",
      basicData: "Basic data",
      statusLabel: "Status",
      typeLabel: "Type",
      rentalId: "Rental ID",
      createdAt: "Created",
      financialData: "Financial data",
      repairCostLabel: "Repair cost",
      lostRevenueLabel: "Lost revenue",
      totalClaimLabel: "Total claim",
      rejectionReason: "Rejection reason",
      approval: "Approval",
      approvedBy: "Approved by: {name}",
      processing: "Processing..."
    },
    noItems: "No items",
    worksheetItems: "Worksheet items",
    disassembly: {
      title: "Disassembly",
      button: "Disassembly",
      modalTitle: "Disassembly Protocol",
      modalDescription: "After disassembly, parts will be added to inventory.",
      addPart: "Add part",
      productSearch: "Search product...",
      quantity: "Quantity",
      condition: "Condition",
      conditionNew: "New",
      conditionUsed: "Used",
      conditionDamaged: "Damaged",
      execute: "Execute",
      executing: "Executing...",
      success: "Disassembly completed successfully",
      error: "Disassembly failed",
      protocols: "Disassembly Protocols",
      noProtocols: "No disassembly protocols",
      performedBy: "Performed by",
      performedAt: "Performed at",
      partsCount: "{count} parts"
    },
    express: {
      surcharge: "Express surcharge",
      lineItem: "Express surcharge (separate invoice line)",
      addSurcharge: "Add express surcharge",
      amount: "Surcharge amount (net HUF)",
      success: "Express surcharge added",
      error: "Failed to add express surcharge"
    },
    external: {
      title: "External service",
      forwardButton: "Forward to external service",
      forwardModalTitle: "Forward to external service partner",
      forwardModalDescription: "The worksheet will be forwarded to an external service partner.",
      partnerSelect: "External service partner",
      reason: "Reason for forwarding",
      reasonPlaceholder: "e.g. Specialized repair, no suitable parts...",
      estimatedReturn: "Estimated return date",
      forward: "Forward",
      forwarding: "Forwarding...",
      forwardSuccess: "Worksheet forwarded successfully",
      banner: "At external service",
      bannerInfo: "Partner: {partner} | Expected return: {date}",
      returnButton: "Record return",
      returnModalTitle: "Return from external service",
      actualCost: "Actual cost (net HUF)",
      returnNotes: "Notes",
      returnNotesPlaceholder: "e.g. Repair completed, part replaced...",
      returnSuccess: "Return recorded successfully",
      error: "Operation failed",
      partnerSearchPlaceholder: "Search by name, phone number or tax number"
    },
    publicRequest: {
      title: "Service Request",
      subtitle: "Online service pre-registration",
      customerName: "Name",
      customerNamePlaceholder: "e.g. John Smith",
      phone: "Phone number",
      phonePlaceholder: "e.g. +36 30 123 4567",
      email: "Email (optional)",
      emailPlaceholder: "e.g. john@example.com",
      equipmentDescription: "Equipment description",
      equipmentDescriptionPlaceholder: "e.g. Makita HR2470 rotary hammer",
      problemDescription: "Problem description",
      problemDescriptionPlaceholder: "Describe the problem in detail...",
      preferredDate: "Preferred date (optional)",
      submit: "Submit request",
      submitting: "Submitting...",
      success: "Service request submitted successfully! We will contact you shortly.",
      error: "An error occurred while submitting"
    },
    pendingRequest: {
      title: "Service Requests",
      noRequests: "No pending requests",
      accept: "Accept",
      reject: "Reject",
      accepted: "Accepted",
      rejected: "Rejected",
      pending: "Pending",
      customerName: "Customer name",
      phone: "Phone",
      equipment: "Equipment",
      problem: "Problem",
      date: "Date",
      status: "Status"
    },
    abandoned: {
      tabTitle: "Abandoned equipment",
      noItems: "No abandoned equipment",
      noItemsDesc: "All rented equipment is currently within the return deadline.",
      totalCount: "{count} abandoned equipment",
      partner: "Partner",
      rental: "Rental",
      daysOverdue: "days overdue",
      perDay: "day",
      storageFee: "Estimated storage fee"
    },
    compensation: {
      tabTitle: "Compensation",
      title: "Record compensation payment",
      description: "If the customer cannot return damaged or lost equipment, record the compensation payment.",
      rentalId: "Rental ID",
      rentalIdPlaceholder: "e.g. R-20260401-001",
      amount: "Amount (HUF)",
      reason: "Reason",
      reasonPlaceholder: "e.g. Customer cannot return the equipment, lost at workplace...",
      action: "Action",
      writtenOff: "Write off (WRITTEN_OFF)",
      transferredToInventory: "Transfer to inventory (TRANSFERRED_TO_INVENTORY)",
      submit: "Record compensation",
      validationError: "Please fill in all fields correctly."
    },
    afterlife: {
      tabTitle: "Afterlife decisions",
      pageTitle: "Equipment lifecycle management",
      pageSubtitle: "Abandoned equipment, compensation, afterlife decisions, batch intake",
      noItems: "No items",
      scrapTitle: "Scrap",
      repairTitle: "Refurbish",
      decisionTitle: "Decision needed",
      repairs: "Repairs",
      age: "Age",
      months: "months",
      condition: "Condition"
    },
    surrender: {
      tabTitle: "Voluntary surrender",
      title: "Record voluntary surrender",
      description: "If the customer voluntarily gives up rented equipment (cannot pay, does not need), record the statement.",
      rentalId: "Rental ID",
      rentalIdPlaceholder: "e.g. R-20260401-001",
      statement: "Statement",
      statementPlaceholder: "Customer statement about the voluntary surrender, reason...",
      submit: "Record surrender",
      validationError: "Please fill in all fields (statement min. 5 characters)."
    },
    issueInvoice: "Issue invoice",
    invoiceSuccess: "Invoice issued successfully"
  },
  quotation: {
    draft: "Draft",
    sent: "Sent",
    accepted: "Accepted",
    pendingValue: "Pending value",
    worksheet: "Worksheet",
    createdAt: "Created",
    validUntil: "Valid until",
    amount: "Amount",
    expiringSoon: "Expiring soon!",
    gross: "gross",
    itemsCount: "{count} items",
    quotationsDisplayed: "{count} quotations displayed",
    newQuotationInfo: "Create new quotation",
    newQuotationDesc: 'To create a quotation, open the worksheet and click the "Create quotation" button. The worksheet items will be automatically transferred to the quotation.',
    notFound: "Quotation not found",
    backToList: "Back to list",
    partnerData: "Partner data",
    partnerName: "Partner name",
    phone: "Phone",
    relatedWorksheet: "Related worksheet",
    itemDescription: "Description",
    unitPrice: "Unit price",
    vat: "VAT",
    totalColumn: "Total",
    netTotal: "Net total:",
    vatTotal: "VAT total:",
    grossTotal: "Gross total:",
    netLabel: "net:",
    customerNote: "Customer note",
    internalNote: "Internal note (not visible to customer)",
    statusLabel: "Status:",
    createdAtLabel: "Created:",
    sentAtLabel: "Sent:",
    validUntilLabel: "Valid until:",
    respondedAtLabel: "Response date:",
    createdByLabel: "Created by:",
    quotationAmount: "Quotation amount",
    pdfDownload: "PDF download",
    emailSend: "Send email",
    openWorksheet: "Open worksheet",
    recordAcceptance: "Record acceptance",
    recordRejection: "Record rejection",
    generateWorksheet: "Generate worksheet",
    acceptTitle: "Accept quotation",
    acceptConfirm: "Are you sure you want to record the acceptance of quotation {number}?",
    acceptAfterInfo: "After acceptance, worksheet generation will become available.",
    processing: "Processing...",
    accept: "Accept",
    rejectTitle: "Reject quotation",
    rejectConfirm: "Are you sure you want to record the rejection of quotation {number}?",
    rejectionReasonLabel: "Rejection reason (optional)",
    rejectionPlaceholder: "E.g. price too high, chose another offer...",
    reject: "Reject",
    generateWorksheetTitle: "Generate worksheet",
    generateWorksheetConfirm: "Create worksheet from quotation {number}?",
    generateWorksheetInfo: "The system will automatically create a worksheet from the quotation items:",
    partnerLabel: "Partner:",
    itemCountLabel: "Number of items:",
    amountLabel: "Amount:",
    generating: "Generating...",
    sendButton: "Send",
    sentSuccess: "Quotation sent.",
    sendFailed: "Sending failed",
    acceptedSuccess: "Quotation accepted.",
    acceptFailed: "Acceptance failed",
    rejectedSuccess: "Quotation rejected.",
    rejectFailed: "Rejection failed",
    worksheetCreated: "Worksheet created: {number}",
    conversionFailed: "Conversion failed",
    newQuotation: "New quotation",
    editQuotation: "Edit quotation",
    quotationData: "Quotation data",
    validityEnd: "Validity end",
    totalGross: "Total (gross)",
    addItem: "+ Add item",
    itemDescriptionPlaceholder: "Item description...",
    qty: "Qty",
    unit: "Unit",
    netPrice: "Net price",
    grossTotalItem: "Gross total",
    noItems: "No items. Click the {button} button.",
    customerVisibleNote: "Customer visible note",
    customerNotePlaceholder: "E.g.: Expected completion time, payment terms...",
    internalNotePlaceholder: "E.g.: Discount reason, customer discussion...",
    createQuotation: "Create quotation",
    saveChanges: "Save changes",
    saveFailed: "Save failed. Please try again.",
    atLeastOneItem: "Please add at least one item!",
    productId: "Product ID:",
    emailLabel: "Email",
    worksheetLabel: "Worksheet:",
    sendEmailSubject: "Send email: {email}\nSubject: Quotation - {number}",
    pdfGeneration: "PDF generation: {number}",
    version: "Version",
    versionHistory: "Version history",
    versionOf: "v{current}/{total}",
    currentVersion: "current",
    createNewVersion: "New version",
    newVersionCreated: "New version created.",
    newVersionFailed: "Failed to create new version",
    quotationNumber: "Quotation number",
    diff: {
      compareVersions: "Compare versions",
      versionHistory: "Version history",
      versionN: "v{n}",
      changed: "Changed",
      added: "Added",
      removed: "Removed",
      noChanges: "No changes between the two versions",
      selectVersions: "Select two versions to compare",
      basicInfo: "Basic information",
      field: "Field",
      versions: "Versions"
    },
    status: {
      draft: "Draft",
      sent: "Sent",
      accepted: "Accepted",
      rejected: "Rejected",
      expired: "Expired",
      converted: "Converted"
    }
  },
  vehicle: {
    title: "Vehicles",
    rentalVehicles: "Rental vehicles",
    companyVehicles: "Company vehicles",
    expiringDocuments: "Expiring documents",
    technicalInspection: "Technical inspection",
    registrationCert: "Registration certificate",
    mtplInsurance: "MTPL insurance",
    cascoInsurance: "CASCO insurance",
    highwaySticker: "Highway sticker",
    subtitle: "Trailer, aggregator, platform management",
    newVehicle: "New vehicle",
    totalVehicles: "Total vehicles",
    available: "Available",
    rentedOut: "Rented out",
    expiringIn30Days: "Expiring in 30 days",
    searchPlaceholder: "Search license plate, name, brand...",
    allTypes: "All types",
    allStatuses: "All statuses",
    vehicleColumn: "Vehicle",
    technicalExpiry: "Technical expiry",
    registrationExpiry: "Registration expiry",
    insuranceExpiry: "Insurance expiry",
    operations: "Operations",
    loadingVehicles: "Loading vehicles...",
    noResults: "No results matching the search criteria.",
    deleteConfirm: "Are you sure you want to delete the vehicle: {name}?",
    deleteFailed: "Failed to delete the vehicle.",
    typeLabels: {
      trailer: "Trailer",
      aggregator: "Aggregator",
      platform: "Platform",
      other: "Other"
    },
    statusLabels: {
      active: "Available",
      rented: "Rented out",
      maintenance: "Maintenance",
      inactive: "Inactive",
      available: "Available"
    },
    companyTypeLabels: {
      car: "Passenger car",
      van: "Van",
      truck: "Truck"
    },
    companyStatusLabels: {
      active: "Available",
      in_use: "In use",
      maintenance: "In service",
      inactive: "Inactive"
    },
    fuelLabels: {
      petrol: "Petrol",
      diesel: "Diesel",
      electric: "Electric",
      hybrid: "Hybrid"
    },
    companySubtitle: "Central management of cars and vans",
    inUse: "In use",
    vehicleNotFound: "Vehicle not found.",
    basicInfo: "Basic information",
    licensePlate: "License plate",
    brandModel: "Brand / Model",
    yearOfManufacture: "Year",
    fuelType: "Fuel type",
    odometer: "Odometer",
    assignedTo: "Assigned to",
    expiryAndInsurance: "Expiry dates & Insurance",
    insurance: "Insurance",
    recordData: "Record data",
    lastModified: "Last modified",
    editCompanyVehicle: "Edit company vehicle",
    newCompanyVehicle: "New company vehicle",
    editVehicleData: "Edit vehicle data",
    registerNewCompanyVehicle: "Register new company vehicle",
    licensePlateRequired: "License plate is required",
    nameRequired: "Name is required",
    brandRequired: "Brand is required",
    kgfbExpiryRequired: "MTPL expiry date is required",
    technicalExpiryRequired: "Technical inspection expiry is required",
    registrationExpiryRequired: "Registration expiry is required",
    insuranceExpiryRequired: "Insurance expiry is required",
    invalidLicensePlate: "Invalid license plate format (e.g. ABC-123)",
    expiryDatesAndInsurance: "Expiry dates and insurance",
    designation: "Designation",
    brandLabel: "Brand",
    modelLabel: "Model",
    statusLabel: "Status",
    odometerReading: "Odometer reading",
    assignedStore: "Assigned store",
    noAssignment: "-- No assignment --",
    additionalInfo: "Additional information...",
    savingInProgress: "Saving...",
    rentalHistory: "Rental history",
    loadingHistory: "Loading history...",
    noRentalHistory: "No rental history.",
    backToList: "Back to list",
    expiryDates: "Expiry dates",
    editVehicle: "Edit vehicle",
    addNewVehicle: "Add new vehicle",
    registerNewRentalVehicle: "Register new rental vehicle",
    expiringDocsSubtitle: "Expiring documents for rental and company vehicles",
    within30Days: "Within 30 days",
    within60Days: "Within 60 days",
    allMonitored: "All monitored",
    allFilter: "All",
    allCategories: "All categories",
    allDocuments: "All documents",
    noExpiringDocs: "No expiring documents matching the selected filters.",
    companyLabel: "Company",
    rentalLabel: "Rental",
    expiredDaysAgo: "Expired {days} days ago",
    expiresInDays: "In {days} days",
    typeLabel: "Type",
    additionalVehicleInfo: "Additional vehicle information...",
    placeholder: {
      brand: "e.g. Skoda",
      companyName: "e.g. Company car 1",
      model: "e.g. Octavia",
      rentalName: "e.g. Trailer 1"
    }
  },
  user: {
    title: "Users",
    subtitle: "User and permission management",
    loadingUsers: "Loading users...",
    loadingUser: "Loading user...",
    errorOccurred: "An error occurred",
    backToDashboard: "Back to dashboard",
    roles: "Roles",
    newUser: "+ New user",
    totalUsers: "Total users",
    searchPlaceholder: "Search name, email...",
    allRoles: "All roles",
    allStores: "All stores",
    userColumn: "User",
    roleColumn: "Role",
    createdAtColumn: "Created",
    usersDisplayed: "{count} users displayed",
    notFound: "User not found",
    suspend: "Suspend",
    activate: "Activate",
    tabOverview: "Overview",
    tabActivity: "Activity",
    basicData: "Basic data",
    email: "Email",
    role: "Role",
    tenantId: "Tenant ID",
    locationId: "Location ID",
    systemInfo: "System information",
    identifier: "Identifier:",
    createdLabel: "Created:",
    modifiedLabel: "Modified:",
    activityLog: "Activity log",
    profileUpdated: "Profile updated",
    userCreated: "User created",
    editUser: "Edit user",
    newUserTitle: "New user",
    savingLabel: "Saving...",
    createLabel: "Create",
    nameRequired: "Name *",
    emailRequired: "Email address *",
    passwordChange: "Change password",
    newPassword: "New password",
    passwordRequired: "Password *",
    minChars: "At least 8 characters",
    passwordLeaveEmpty: "Leave empty if you don't want to change it",
    confirmPassword: "Confirm password",
    confirmPasswordRequired: "Confirm password *",
    passwordAgain: "Password again",
    roleAndLocation: "Role and location",
    roleRequired: "Role *",
    locationOptional: "Store / Location (optional)",
    notSpecified: "Not specified",
    saveChanges: "Save changes",
    createUser: "Create user",
    saveError: "An error occurred while saving.",
    namePlaceholder: "John Smith",
    emailPlaceholder: "user@example.com",
    validation: {
      emailRequired: "Email address is required",
      emailInvalid: "Invalid email address",
      nameRequired: "Name is required",
      roleRequired: "Role selection is required",
      passwordRequired: "Password is required",
      passwordMinLength: "At least 8 characters",
      passwordMismatch: "Passwords do not match",
      taxFormat: "Invalid tax number format (8 or 11 digits)",
      taxChecksum: "Tax number check digit is invalid",
      phoneFormat: "Invalid phone number format",
      postalFormat: "Postal code must be 4 digits"
    },
    roleLabels: {
      OPERATOR: "Operator",
      TECHNIKUS: "Technician",
      BOLTVEZETO: "Store Manager",
      ACCOUNTANT: "Accountant",
      PARTNER_OWNER: "Partner Owner",
      CENTRAL_ADMIN: "Central Admin",
      DEVOPS_ADMIN: "DevOps Admin",
      SUPER_ADMIN: "Super Admin"
    },
    roleDescriptions: {
      OPERATOR: "Cash register, sales, rentals",
      TECHNIKUS: "Worksheet management, service operations",
      BOLTVEZETO: "Store operations, reports, user management",
      ACCOUNTANT: "Financial operations, invoicing, settlements",
      PARTNER_OWNER: "Partner-level access, contracts",
      CENTRAL_ADMIN: "Central administration, all stores",
      DEVOPS_ADMIN: "System operations, infrastructure",
      SUPER_ADMIN: "Full access to all features"
    },
    statusLabels: {
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      LOCKED: "Locked",
      PENDING_VERIFICATION: "Pending verification"
    },
    rolesAndPermissions: "Roles and permissions",
    rbacDescription: "RBAC management (8-level role hierarchy)",
    rbacInfoBanner: "Roles are defined in the backend RBAC system (ADR-032). Permissions can be viewed, but modifications are made in the system configuration.",
    rolesCount: "Roles ({count})",
    level: "Level {level}",
    code: "Code:",
    hierarchyLevel: "Hierarchy level:",
    permissionsLabel: "Permissions:",
    typeLabel: "Type:",
    systemRole: "System role",
    permissionsCount: "Permissions ({count})",
    selectRolePrompt: "Select a role to view details."
  },
  dunning: {
    title: "Dunning",
    level: {
      none: "None",
      reminder: "Reminder",
      warning: "Warning",
      finalNotice: "Final Notice"
    },
    currentLevel: "Current level",
    escalate: "Escalate",
    escalateSuccess: "Dunning level successfully escalated",
    history: "Dunning history",
    sentAt: "Sent at",
    nextEscalation: "Next escalation",
    overdueDays: "Overdue days",
    days: "days",
    amount: "Outstanding",
    escalationCount: "Escalation count",
    noHistory: "No dunning history"
  },
  invoicePage: {
    invoiceNumber: "Invoice number",
    issueDate: "Issue date",
    dueDate: "Due date",
    amount: "Amount",
    arrears: "Arrears: {amount}",
    loadingInvoices: "Loading invoices...",
    errorOccurred: "An error occurred: {message}",
    noResults: "No results matching the selected filters",
    invoiceCount: "{count} invoices"
  },
  contract: {
    title: "Contracts",
    subtitle: "Rental and service contracts",
    contract: "Contract",
    goToRentals: "Rentals",
    activeDeposit: "Active deposit",
    activeValue: "Active value",
    searchPlaceholder: "Search number, partner, rental...",
    deposit: "Deposit",
    depositPaid: "Paid",
    depositMissing: "Missing",
    depositNotPaid: "Not paid",
    depositAmount: "Deposit amount",
    contractsDisplayed: "{count} contracts displayed",
    autoGenerationTitle: "Automatic contract generation",
    autoGenerationDesc: "Contracts are automatically generated when starting a rental. PDF download and printing are available on the details page.",
    notFound: "Contract not found",
    rental: "Rental",
    pdfDownload: "PDF download",
    pdfGeneration: "PDF generation",
    pdfDownloading: "The contract PDF is being downloaded...",
    sign: "Sign",
    partnerData: "Partner details",
    partnerName: "Partner name",
    idNumber: "ID card number",
    contractPeriod: "Contract period",
    startDate: "Start date",
    expectedEndDate: "Expected end date",
    expectedEnd: "Expected end",
    actualEndDate: "Actual end date",
    activeContractMessage: "Active contract - return in progress",
    dailyRate: "Daily rate",
    productId: "Product",
    termsAndNotes: "Terms and notes",
    contractTerms: "Contract terms",
    signedAt: "Signed at",
    signatures: "Signatures",
    partnerSignature: "Partner signature",
    staffSignature: "Staff signature",
    contractAmount: "Contract amount",
    openRental: "Open rental",
    recordSignature: "Record signature",
    editContract: "Edit contract",
    contractData: "Contract details",
    duration: "Duration",
    financialData: "Financial data",
    termsPlaceholder: "General terms of the contract...",
    notesPlaceholder: "Additional notes...",
    saveChanges: "Save changes",
    datesRequired: "Start and end dates are required!",
    saveFailed: "Save failed. Please try again.",
    status: {
      draft: "Draft",
      active: "Active",
      completed: "Completed",
      cancelled: "Cancelled"
    },
    type: {
      rental: "Rental",
      service: "Service",
      sales: "Sales"
    }
  },
  product: {
    title: "Products",
    subtitle: "Product, parts and rental equipment management",
    newProduct: "New product",
    newProductTitle: "New product",
    newProductSubtitle: "Enter product details",
    editProduct: "Edit product",
    productNotFound: "Product not found",
    backToList: "Back to list",
    identifiers: "Identifiers",
    sku: "SKU (internal)",
    skuRequired: "SKU (internal) *",
    skuOptional: "SKU (internal) \u2014 auto-generated, leave empty",
    skuAutoPlaceholder: "KGC-{year}-####",
    internalCodeSource: {
      label: "Internal code source",
      AUTO_GENERATED: "Auto-generate (KGC-{year}-####)",
      SUPPLIER_FGS: "FGS supplier SKU adopted",
      SUPPLIER_MAV: "MAV supplier SKU adopted"
    },
    barcode: "Barcode (EAN)",
    manufacturerCode: "Manufacturer code",
    manufacturerCodeShort: "Manufacturer code",
    locationCode: "Location code (W-S-B)",
    productDetails: "Product details",
    productName: "Name *",
    productNamePlaceholder: "Makita DHP481RTJ cordless hammer drill",
    shortName: "Short name",
    brand: "Brand",
    typeModel: "Type/Model",
    supplier: "Supplier",
    supplierName: "Supplier name",
    supplierCode: "Supplier code",
    selectPlaceholder: "-- Select --",
    description: "Description",
    descriptionPlaceholder: "Detailed product description...",
    pricing: "Pricing",
    purchasePriceNet: "Purchase price (net)",
    sellingPriceNet: "Selling price (net)",
    sellingPriceGross: "Selling price (gross)",
    vatRate: "VAT rate",
    calculatedMargin: "Calculated margin: <strong>{percent}%</strong>",
    stockSettings: "Stock settings",
    minStockLevel: "Minimum stock level",
    reorderQuantity: "Reorder quantity",
    rentalSettings: "Rental settings",
    dailyRateFt: "Daily rate (HUF)",
    weeklyRateFt: "Weekly rate (HUF)",
    monthlyRateFt: "Monthly rate (HUF)",
    depositAmountFt: "Deposit amount (HUF)",
    creating: "Creating...",
    createProduct: "Create product",
    savingChanges: "Saving...",
    saveChanges: "Save changes",
    nameRequired: "Name is required!",
    skuRequiredAlert: "SKU is required!",
    errorPrefix: "Error: {message}",
    sale: "Sale",
    tabs: {
      overview: "Overview",
      stock: "Stock",
      pricing: "Pricing",
      rental: "Rental",
      components: "Components",
      history: "History"
    },
    explodedView: {
      title: "Components (BOM)",
      addComponent: "Add",
      noComponents: "No components recorded for this product.",
      componentName: "Component name",
      quantityPerUnit: "Qty/unit",
      unitCost: "Unit cost",
      totalCost: "Total",
      totalBomCost: "Total BOM cost",
      marginSummary: "Margin summary",
      searchProduct: "Search product"
    },
    basicData: "Basic data",
    noSupplier: "No supplier specified",
    lastOrder: "Last order",
    lastPurchasePrice: "Last purchase price",
    quickOverview: "Quick overview",
    inStock: "In stock:",
    reserved: "Reserved:",
    margin: "Margin:",
    goodsReceipt: "Goods receipt",
    movements: "Movements",
    startRental: "Start rental",
    stockData: "Stock data",
    totalStock: "Total stock:",
    available: "Available:",
    minimumLevel: "Minimum level:",
    placement: "Placement",
    notSpecified: "Not specified",
    locationCodeFormat: "Location code format: <strong>Warehouse - Shelf - Box</strong>",
    locationCodeExample: "Example: A-02-03 = Warehouse A, shelf 2, box 3",
    lowStockWarning: "Low stock level!",
    lowStockDescription: "Stock ({current} pcs) is below minimum level ({min} pcs). Suggested reorder quantity: {reorder} pcs",
    prices: "Prices",
    marginCalculation: "Margin calculation",
    marginFt: "Margin (HUF):",
    marginPercent: "Margin (%):",
    marginFormula: "Margin calculation: (Selling - Purchase) / Purchase x 100",
    rentalRates: "Rental rates",
    dailyRate: "Daily rate:",
    weeklyRate: "Weekly rate:",
    monthlyRate: "Monthly rate (30 days):",
    depositAmount: "Deposit amount:",
    rentalStatus: "Rental status",
    totalMachines: "Total machines:",
    rentedOut: "Rented out:",
    availableForRental: "Available for rental:",
    startNewRental: "Start new rental",
    history: "History",
    productUpdated: "Product data updated",
    lastPurchase: "Last purchase - {price}",
    productCreated: "Product created ({user})",
    statusAndCategory: "Status and category",
    currentStock: "Current stock: <strong>{total} pcs</strong> (Available: {available} pcs, Reserved: {reserved} pcs)",
    stats: {
      total: "Total products",
      active: "Active",
      lowStock: "Low stock",
      outOfStock: "Out of stock",
      stockValue: "Stock value"
    },
    searchPlaceholder: "Search by name, SKU, barcode, brand...",
    allCategories: "All categories",
    allStatuses: "All statuses",
    allSuppliers: "All suppliers",
    lowStockOnly: "Low stock only",
    tableHeaders: {
      product: "Product",
      category: "Category",
      barcode: "Barcode",
      supplier: "Supplier",
      netPrice: "Net price",
      grossPrice: "Gross price",
      stock: "Stock",
      status: "Status"
    },
    stockBadge: {
      none: "None",
      low: "Low",
      ok: "OK"
    },
    detailsButton: "Details",
    noResults: "No results matching the filter criteria.",
    displayedCount: "{count} products displayed",
    filter: {
      allBrands: "All brands"
    },
    manufacturerPartNumber: "Manufacturer part number",
    manufacturerPartNumberShort: "Mfr. part no.",
    import: {
      imported: "Imported",
      updated: "Updated",
      skipped: "Skipped",
      totalRows: "Total rows"
    },
    categoriesLoadError: "Failed to load categories.",
    noCategories: "No categories available."
  },
  report: {
    title: "Reports",
    subtitle: "Business reports and statistics",
    overview: "Overview",
    sales: "Sales",
    rentals: "Rentals",
    inventory: "Inventory",
    financial: "Financial",
    period: "Period:",
    today: "Today",
    week: "Week",
    month: "Month",
    quarter: "Quarter",
    year: "Year",
    customPeriod: "Custom period",
    totalRevenue: "Total revenue",
    comparedToPrevMonth: "compared to previous month",
    salesCount: "Sales",
    worksheets: "Worksheets",
    revenueTrend: "Revenue trend",
    revenueChart: "Line chart - Revenue",
    categoryDistribution: "Category distribution",
    categoryChart: "Pie chart - Categories",
    salesByCategory: "Sales by category",
    category: "Category",
    amount: "Amount",
    pieces: "Pieces",
    avgPerPiece: "Avg/pc",
    ratio: "Ratio",
    total: "Total",
    dailySales: "Daily sales",
    dailySalesChart: "Bar chart - Daily sales",
    topRentals: "Top rentals - equipment utilization",
    equipment: "Equipment",
    rentalsCount: "Rentals",
    revenue: "Revenue",
    utilization: "Utilization",
    avgRentalDuration: "Average rental duration",
    avgRentalDays: "{days} days",
    overdueReturns: "Overdue returns",
    avgDeposit: "Average deposit",
    inventoryByCategory: "Inventory status by category",
    inStock: "In stock",
    reserved: "Reserved",
    available: "Available",
    lowStock: "Low stock",
    lowStockItems: "{count} items",
    grossRevenue: "Gross revenue",
    vatPayment: "VAT payment",
    vatRate: "27% VAT rate",
    netResult: "Net result",
    expiredInvoices: "{count} expired invoices",
    revenueBreakdown: "Revenue breakdown",
    productSales: "Product sales",
    rentalFees: "Rental fees",
    serviceLabor: "Service labor",
    other: "Other",
    smallMachines: "Small machines",
    tools: "Tools",
    safetyEquipment: "Safety equipment",
    rentalReport: "Rental Report",
    periodLabel: "Period: {start} - {end}",
    refresh: "Refresh",
    filters: "Filters",
    lastWeek: "Last week",
    lastMonth: "Last month",
    lastQuarter: "Last quarter",
    lastYear: "Last year",
    startDate: "Start date",
    endDate: "End date",
    equipmentType: "Equipment type",
    allTypes: "All types",
    clearFilters: "Clear filters",
    totalRentals: "Total rentals",
    activeRentals: "Active rentals",
    closedRentals: "Closed rentals",
    avgRentalTime: "Avg. rental time",
    avgRevenuePerRental: "Avg. revenue/rental",
    overdue: "Overdue",
    rentalsByEquipmentType: "Rentals by equipment type",
    equipmentTypeCol: "Equipment type",
    count: "Count",
    revenueCol: "Revenue",
    ratioCol: "Ratio",
    noDataForFilters: "No data for the specified filter criteria.",
    errorLoading: "Error loading data.",
    retryButton: "Retry",
    comparedToPrevMonthShort: "vs. previous month",
    margin: {
      title: "Margin",
      byProduct: "By product",
      byCategory: "By category",
      revenue: "Revenue",
      cogs: "COGS",
      marginAmount: "Margin (HUF)",
      marginPercent: "Margin (%)",
      exportCsv: "Export CSV",
      detailTable: "Detailed margin report",
      productName: "Product"
    }
  },
  kb: {
    title: "Knowledge Base Management",
    subtitle: "Create, edit and delete articles",
    newArticle: "New article",
    loadingArticles: "Loading articles...",
    noArticles: "No articles",
    createNewArticle: "Create new article",
    editArticle: "Edit article",
    articleTitle: "Title *",
    content: "Content (Markdown) *",
    status: "Status",
    tags: "Tags",
    addTag: "Add",
    searchTitle: "Knowledge Base",
    searchPlaceholder: "Search articles...",
    searchInKb: "Search in knowledge base...",
    noResults: "No results",
    tryOtherSearch: "Try different search criteria",
    feedbackThanks: "Thank you for the feedback!",
    wasHelpful: "Was this article helpful?",
    helpful: "Helpful",
    notHelpful: "Not helpful",
    helpfulCount: "helpful",
    notHelpfulCount: "not helpful",
    statusDraft: "Draft",
    statusPublished: "Published",
    statusArchived: "Archived",
    deleteButton: "Delete",
    titlePlaceholder: "Article title...",
    contentPlaceholder: "Article content in Markdown format...",
    category: {
      berles: "Rental",
      szerviz: "Service",
      penzugy: "Finance",
      rendszer: "System",
      altalanos: "General"
    }
  },
  sms: {
    title: "SMS Settings",
    sendTab: "Send SMS",
    historyTab: "History",
    templatesTab: "Templates",
    phonePlaceholder: "Phone number (+36...)",
    messagePlaceholder: "Message text (max 480 characters)",
    charCount: "{count}/480 characters",
    sending: "Sending...",
    send: "Send",
    sentSuccess: "SMS sent successfully!",
    historyTitle: "SMS history ({count})",
    noRecords: "No SMS records.",
    directionOutbound: "Outbound",
    directionInbound: "Inbound",
    newTemplate: "New template",
    templateName: "Template name",
    templateBody: "Template body (variables: {gep}, {datum}, {idopont}, {ml_szam})",
    templateVariables: "Variables (comma-separated: gep,datum,idopont)",
    templateActive: "Active",
    templateSaving: "Saving...",
    templateSave: "Save template",
    templatesTitle: "Templates ({count})",
    noTemplates: "No templates.",
    activeLabel: "Active",
    inactiveLabel: "Inactive",
    typeCustom: "Custom",
    typeBookingConfirm: "Booking confirmation",
    typeRentalExpiry: "Rental expiry",
    typeServiceReady: "Service ready",
    typeRentalReminder: "Rental reminder",
    backToDashboard: "Back to dashboard",
    dashboardTitle: "SMS Center",
    filterPending: "Pending",
    filterProcessed: "Processed",
    inboundTitle: "Inbound messages",
    markProcessed: "Mark as processed",
    noInboundMessages: "No inbound messages",
    pendingFailed: "Failed to send",
    quickSend: "Quick send",
    recentHistory: "Recent history",
    recognizedCommand: "Recognized command",
    selectTemplate: "Select template",
    sentToday: "Sent today",
    settingsLink: "SMS settings",
    statusPending: "Pending",
    statusProcessed: "Processed",
    successRate: "Success rate",
    viewAll: "View all",
    viewRelated: "View related"
  },
  ocr: {
    title: "Document Scanner & Label Printing",
    subtitle: "IPEVO V4K document camera + Zebra/Brother label printer",
    scanTab: "Document scanning",
    labelTab: "Label printing",
    scanTitle: "Document scanning (IPEVO V4K)",
    scanInstruction: "Place the document under the camera and click the scan button.",
    scanButton: "Start scanning",
    scanning: "Scanning...",
    scanResults: "Scan results",
    noResults: "No scan results yet.",
    labelTitle: "Label generation",
    zebraLabel: "Zebra ZD 220 (43\xD726mm)",
    brotherLabel: "Brother QL-700 (50mm)",
    generateZebra: "Generate Zebra label",
    generateBrother: "Generate Brother label",
    generating: "Generating...",
    sku: "SKU",
    productName: "Product name",
    price: "Price (gross)",
    pageTitle: "Document reader & Label printing",
    scanButtonLabel: "Scan document",
    scanSuccess: "Scan successful!",
    nameLabel: "Name",
    documentNumberLabel: "Document number",
    confidenceLabel: "Confidence",
    productNamePlaceholder: "Product name",
    barcodePlaceholder: "Barcode",
    pricePlaceholder: "Price (HUF)",
    skuPlaceholder: "SKU (optional)",
    netPricePlaceholder: "Net price (HUF)",
    vatRatePlaceholder: "VAT rate (%)",
    barcodeOptionalPlaceholder: "Barcode (optional)",
    categoryPlaceholder: "Category (optional)",
    generatingLabel: "Generating...",
    priceLabelGenerate: "Generate price label",
    errorUnknown: "Unknown error"
  },
  businessHours: {
    title: "Business Hours & Holidays",
    subtitle: "Manage opening hours, holidays and overrides",
    weeklyTab: "Weekly schedule",
    holidaysTab: "Holidays",
    overridesTab: "Overrides",
    weeklySchedule: "Weekly opening hours",
    dayNames: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    },
    dayShort: {
      monday: "M",
      tuesday: "T",
      wednesday: "W",
      thursday: "T",
      friday: "F",
      saturday: "S",
      sunday: "S"
    },
    open: "Open",
    closed: "Closed",
    openTime: "Open",
    closeTime: "Close",
    holidayManagement: "Holiday management",
    newHoliday: "New holiday",
    holidayName: "Holiday name",
    holidayDate: "Date",
    recurring: "Recurring every year",
    noHolidays: "No holidays recorded.",
    overrideManagement: "Override management",
    newOverride: "New override",
    overrideDate: "Date",
    overrideOpenTime: "Opening time",
    overrideCloseTime: "Closing time",
    overrideClosed: "Closed all day",
    overrideReason: "Reason",
    noOverrides: "No overrides recorded.",
    saved: "Saved!",
    everyYear: "Every year",
    pageTitle: "Business Hours Management",
    pageSubtitle: "Set weekly hours, holidays and special days",
    weeklyScheduleTitle: "Weekly Schedule",
    defaultButton: "Reset to Default",
    saveButton: "Save",
    savingButton: "Saving...",
    savingSuccess: "Business hours saved successfully!",
    resetSuccess: "Reset to defaults!",
    loadingWeekly: "Loading business hours...",
    dayColumn: "Day",
    openColumn: "Open",
    openingColumn: "Opening",
    closingColumn: "Closing",
    hungHolidays: "Hungarian holidays",
    newHolidayButton: "New holiday",
    editHolidayTitle: "Edit holiday",
    newHolidayTitle: "New holiday",
    nameLabel: "Name",
    dateLabel: "Date",
    namePlaceholder: "e.g. Christmas",
    recurringLabel: "Recurring yearly",
    cancelButton: "Cancel",
    updateButton: "Update",
    createButton: "Create",
    holidayUpdated: "Holiday updated!",
    holidayCreated: "Holiday created!",
    holidayDeleted: "Holiday deleted!",
    nationalSeeded: "national holidays loaded!",
    loadingHolidays: "Loading holidays...",
    holidaysTitle: "Holidays",
    noHolidaysText: 'No holidays for this year. Use the "Hungarian holidays" button to load national holidays.',
    nameColumn: "Name",
    dateColumnHeader: "Date",
    typeColumn: "Type",
    actionsColumn: "Actions",
    nationalBadge: "National",
    recurringBadge: "Recurring",
    customBadge: "Custom",
    editButton: "Edit",
    deleteButton: "Delete",
    overridesTitle: "Custom Days (Overrides)",
    newOverrideButton: "New override",
    editOverrideTitle: "Edit override",
    newOverrideTitle: "New override",
    overrideUpdated: "Override updated!",
    overrideCreated: "Override created!",
    overrideDeleted: "Override deleted!",
    loadingOverrides: "Loading overrides...",
    noOverridesText: "No custom day overrides.",
    statusColumn: "Status",
    timeColumn: "Time",
    reasonColumn: "Reason",
    reasonLabel: "Reason / note",
    reasonPlaceholder: "e.g. Special summer Saturday opening",
    openBadge: "Open",
    closedBadge: "Closed",
    tabWeekly: "Weekly Schedule",
    tabHolidays: "Holidays",
    tabOverrides: "Custom Days"
  },
  tenant: {
    title: "Tenant Admin",
    subtitle: "Company data and franchise management",
    companyTab: "Company settings",
    franchiseTab: "Franchise overview",
    basicData: "Basic data",
    storeName: "Store/location name",
    companyName: "Official company name",
    taxNumber: "Tax number",
    registrationNumber: "Registration number",
    bankAccount: "Bank account number",
    contactInfo: "Contact information",
    phoneNumber: "Phone number",
    emailAddress: "Email address",
    website: "Website",
    address: "Address",
    franchiseStats: "Franchise statistics",
    totalStores: "Total stores",
    activeStores: "Active stores",
    totalRevenue: "Total revenue",
    tenantTable: "Tenant list",
    tenantName: "Name",
    tenantStatus: "Status",
    tenantPlan: "Plan",
    tenantCreated: "Created",
    bankName: "Bank name",
    addressLabel: "Address",
    cityLabel: "City",
    postalCodeLabel: "Postal code",
    phoneLabel: "Phone",
    emailLabel: "Email",
    websiteLabel: "Website",
    businessHoursTitle: "Business hours",
    openLabel: "Open",
    closedLabel: "Closed",
    brandingTitle: "Branding",
    uploadLogo: "Upload",
    primaryColor: "Primary color",
    accentColor: "Accent color",
    systemSettingsTitle: "System settings",
    currencyLabel: "Currency",
    timezoneLabel: "Timezone",
    languageLabel: "Language",
    vatRateLabel: "VAT rate (%)",
    employees: "Employees",
    activeWorksheets: "Active worksheets",
    searchPlaceholder: "Search by location, city, owner...",
    locationsTitle: "Locations",
    locationColumn: "Location",
    ownerColumn: "Owner",
    monthlyRevenueColumn: "Monthly revenue",
    rentalsColumn: "Rentals",
    worksheetsColumn: "Worksheets",
    lastActivityColumn: "Last activity",
    statusInactive: "Inactive",
    statusSuspended: "Suspended",
    currencyHUF: "HUF - Hungarian Forint",
    currencyEUR: "EUR - Euro",
    employeesSuffix: "staff"
  },
  chat: {
    title: "Chat",
    newConversation: "New conversation",
    you: "You",
    noMessages: "No messages",
    participant: "participant",
    participants: "participants",
    online: "Online",
    offline: "Offline",
    call: "Call",
    info: "Information",
    attachment: "Attachment",
    messagePlaceholder: "Write a message...",
    sendButton: "Send",
    selectConversation: "Select a conversation",
    onlineColleagues: "Online colleagues",
    newChat: "New conversation",
    groupName: "Group name (optional)",
    selectParticipants: "Select participants",
    startConversation: "Start conversation",
    newButton: "+ New",
    selectOrStartNew: "Select an existing conversation on the left, or start a new one.",
    selected: "selected",
    groupChat: "group chat",
    writeMessage: "Write a message...",
    sendLabel: "Send",
    groupNamePlaceholder: "Group name...",
    minimize: "Minimize",
    openChat: "Open chat"
  },
  modules: {
    title: "Module settings",
    activeCount: "Active module",
    inactiveCount: "Inactive module",
    totalCount: "Total modules",
    mandatory: "Mandatory",
    saved: "Saved!",
    categoryCore: "Core",
    categorySales: "Sales",
    categoryService: "Service",
    categoryFinance: "Finance",
    categoryIntegration: "Integration",
    moduleRental: "Rental",
    moduleRentalDesc: "Equipment rental, return, fee calculation",
    moduleSales: "Sales",
    moduleSalesDesc: "Product sales, POS cash register",
    moduleService: "Service",
    moduleServiceDesc: "Service worksheet, repair, warranty",
    moduleInventory: "Inventory management",
    moduleInventoryDesc: "Stock, inventory, goods receipt",
    moduleInvoicing: "Invoicing",
    moduleInvoicingDesc: "Invoice creation, NAV Online",
    modulePartners: "Partner management",
    modulePartnersDesc: "Customers, suppliers",
    moduleQuotes: "Quotes",
    moduleQuotesDesc: "Quotes, conversions",
    moduleCash: "Cash register",
    moduleCashDesc: "Cash management, daily close",
    moduleReporting: "Reporting",
    moduleReportingDesc: "KPIs, reports",
    moduleChat: "Internal chat",
    moduleChatDesc: "Team communication",
    moduleBooking: "Online booking",
    moduleBookingDesc: "Equipment booking via website",
    moduleCrm: "CRM (Twenty)",
    moduleCrmDesc: "Customer relationship management",
    moduleHr: "HR (Horilla)",
    moduleHrDesc: "Human resource management",
    moduleVehicles: "Vehicle registry",
    moduleVehiclesDesc: "Company and rental vehicles",
    moduleLoyalty: "VIP Loyalty",
    moduleLoyaltyDesc: "Loyalty program, point collection",
    moduleSms: "SMS Gateway",
    moduleSmsDesc: "SMS sending, templates",
    subtitle: "Enable or disable system modules. Changes take effect immediately.",
    saveButton: "Save",
    activeLabel: "Active",
    inactiveLabel: "Inactive",
    categoryLabels: {
      core: "Core modules",
      domain: "Business modules",
      integration: "Integrations"
    },
    categoryDescriptions: {
      core: "Core modules required for system operation. Cannot be disabled.",
      domain: "Business functions that can be individually enabled or disabled.",
      integration: "External system integrations."
    },
    moduleNames: {
      auth: "Authentication (Auth)",
      tenant: "Multi-tenancy",
      audit: "Audit trail",
      rental: "Rental module",
      sales: "Sales module",
      service: "Service module",
      inventory: "Inventory management",
      quotation: "Quotation management",
      partners: "Partner management",
      vehicles: "Vehicle registry",
      "nav-online": "NAV Online invoicing",
      mypos: "MyPOS payment",
      "szamlazz-hu": "Sz\xE1ml\xE1zz.hu",
      "twenty-crm": "Twenty CRM",
      chatwoot: "rPI Porter",
      "online-booking": "Online booking"
    },
    moduleDescriptions: {
      auth: "User authentication, JWT, PIN login, RBAC access control.",
      tenant: "Franchise network support, store separation, RLS policies.",
      audit: "Activity monitoring, GDPR compliance, retention management.",
      rental: "Equipment rental, deposit management, long-term contracts, late fees.",
      sales: "Product sales, POS terminal, NAV Online invoicing.",
      service: "Worksheet management, warranty repairs, parts catalog.",
      inventory: "Stock tracking, inventory, receiving, inter-warehouse movements.",
      quotation: "Price calculation, conversion tracking, PDF generation.",
      partners: "Customers, suppliers, discounts, loyalty program.",
      vehicles: "Company and rental vehicles, documents.",
      "nav-online": "NAV Online Invoice API integration (mandatory in production).",
      mypos: "Payment gateway, deposit, card payment options.",
      "szamlazz-hu": "Invoicing system API integration.",
      "twenty-crm": "CRM system integration for customer management.",
      chatwoot: "Customer service chat and support.",
      "online-booking": "Online service and rental booking system."
    }
  },
  notifications: {
    title: "Notification settings",
    matrix: "Notification matrix",
    role: "Role",
    totalCol: "Total",
    legend: "Legend",
    enabled: "Notification enabled",
    disabled: "Notification disabled",
    roleLabels: {
      admin: "Admin",
      manager: "Manager",
      cashier: "Cashier",
      technician: "Technician",
      salesRep: "Sales rep",
      warehouseWorker: "Warehouse worker",
      accountant: "Accountant",
      viewer: "Viewer"
    },
    domainLabels: {
      rental: "Rental",
      service: "Service",
      sales: "Sales",
      inventory: "Inventory",
      finance: "Finance",
      partner: "Partner",
      system: "System",
      invoice: "Invoice"
    },
    subtitle: "Configure which roles receive which domain notifications.",
    matrixHint: "Click a cell to toggle notification on/off. Click row/column header to toggle the entire row/column.",
    tipText: "Tip: Click the row or column header to toggle the entire row/column at once.",
    vehicle: {
      documentExpiring: {
        subject: "Vehicle document expiring: {licensePlate} ({documentLabel})",
        title: "Vehicle document expiring soon",
        body: "The {documentLabel} for vehicle {licensePlate} expires in {daysUntilExpiry} days ({expiryDate}). Please renew it in time.",
        cta: "Open vehicle"
      },
      documentExpired: {
        subject: "EXPIRED vehicle document: {licensePlate} ({documentLabel})",
        title: "Vehicle document EXPIRED",
        body: "The {documentLabel} for vehicle {licensePlate} expired {daysOverdue} days ago (expiry: {expiryDate}). The vehicle may not be operated legally with an expired document \u2014 immediate action required.",
        cta: "Open vehicle"
      },
      documentTypes: {
        REGISTRATION: "registration certificate",
        TECHNICAL_INSPECTION: "technical inspection",
        KGFB_INSURANCE: "mandatory insurance (KGFB)",
        CASCO_INSURANCE: "CASCO insurance",
        HIGHWAY_STICKER: "highway sticker"
      }
    },
    partner: {
      loyaltyReward: {
        subject: "New loyalty reward available \u2014 {partnerName}",
        title: "Loyalty reward unlocked",
        body: "Hi {partnerName}, you have a new reward in our loyalty programme: {rewardName}. Visit our store to redeem it.",
        cta: "View reward"
      }
    },
    marketing: {
      seasonal: {
        subject: "{campaignName} \u2014 special offer",
        title: "{campaignName}",
        body: "{campaignBody} Reply STOP to unsubscribe.",
        cta: "View offer"
      }
    },
    types: {
      vehicle: {
        document: {
          expiring: {
            label: "Vehicle document expiring",
            description: "Upcoming expiry of a vehicle registration/inspection/insurance document."
          },
          expired: {
            label: "Vehicle document EXPIRED",
            description: "Expired vehicle document \u2014 legal liability, immediate action required."
          }
        },
        service: {
          due: {
            label: "Vehicle service due",
            description: "Scheduled maintenance is approaching (based on mileage or date)."
          }
        }
      },
      rental: {
        overdue: {
          label: "Overdue rental",
          description: "The renter did not return the equipment by the contracted deadline."
        },
        return: {
          reminder: {
            label: "Return reminder",
            description: "Rental end is approaching (24-72 hours) \u2014 send a reminder."
          }
        },
        contract: {
          signed: {
            label: "Rental contract signed",
            description: "The rental contract has been electronically signed."
          }
        }
      },
      service: {
        worksheet: {
          ready: {
            label: "Worksheet ready",
            description: "The service worksheet is ready \u2014 notify the customer."
          }
        },
        warranty: {
          expiring: {
            label: "Warranty expiring soon",
            description: "An active warranty is approaching its expiry."
          }
        }
      },
      sales: {
        invoice: {
          issued: {
            label: "New invoice issued",
            description: "An invoice has been issued and reported to NAV."
          }
        },
        deliveryNote: {
          signed: {
            label: "Delivery note signed",
            description: "The delivery note has been finalized with an electronic signature."
          }
        }
      },
      finance: {
        payment: {
          overdue: {
            label: "Invoice overdue",
            description: "A customer invoice is overdue \u2014 start the collection process."
          }
        },
        "cash-close": {
          due: {
            label: "Daily cash close due",
            description: "The daily cash close is mandatory with an operational deadline."
          }
        }
      },
      workflow: {
        approval: {
          requested: {
            label: "Approval required",
            description: "A workflow run has reached an approval point."
          }
        },
        execution: {
          failed: {
            label: "Workflow run failed",
            description: "A @kgc/workflow run failed terminally."
          }
        }
      },
      documents: {
        hash: {
          mismatch: {
            label: "Document integrity error",
            description: "The hash integrity check found a mismatch \u2014 possible tampering."
          }
        },
        retention: {
          expired: {
            label: "Document retention expired",
            description: "The GDPR retention period has expired; the document has been deleted."
          }
        }
      },
      partner: {
        blocklisted: {
          label: "Partner on sanctions list",
          description: "The partner has been added to an AML / sanctions list \u2014 blocking activated."
        },
        loyaltyReward: {
          label: "Loyalty program reward",
          description: "A new loyalty program reward is available \u2014 consent-based marketing notification (E-93)."
        }
      },
      marketing: {
        seasonal: {
          label: "Seasonal offer",
          description: "Periodic marketing campaign \u2014 explicit consent required (E-93 ADR-109 J-1)."
        }
      }
    }
  },
  featureFlags: {
    title: "Feature Flags",
    subtitle: "Enable and disable features",
    saveChanges: "Save changes",
    totalFlags: "Total flags",
    enabledFlags: "Enabled",
    disabledFlags: "Disabled",
    newBadge: "NEW",
    betaBadge: "BETA",
    updatedAt: "Updated: {date}",
    dependsOn: "Depends: {flags}",
    allCategories: "All categories",
    enabledOnly: "Enabled only",
    disabledOnly: "Disabled only",
    searchPlaceholder: "Search...",
    infoText: "Feature flags allow you to enable and disable application features. Some features may depend on other features.",
    saved: "Saved!",
    allLabel: "All",
    noResults: "No results with the specified filters",
    searchPlaceholderLong: "Search (name, description, key)...",
    usageTitle: "Feature Flags usage",
    usageDescription: "Feature flags allow enabling and disabling features in the application. Some flags may depend on other flags - these can only be enabled when the dependency is active. BETA labeled features are still under testing.",
    dependencyDisabled: "Dependency is not enabled",
    totalLabel: "Total flags"
  },
  equipmentProfit: {
    profitable: "Profitable",
    lossmaking: "Loss-making",
    breakeven: "Break-even",
    missingData: "Missing data",
    rentalCancelled: "Cancelled",
    roi: "ROI",
    purchasePrice: "Purchase price",
    rentalRevenue: "Rental revenue",
    serviceCost: "Service cost",
    profit: "Profit",
    rentalHistory: "Rental history",
    noRentalHistory: "No rental history.",
    ongoing: "ongoing",
    loadError: "Error loading profitability data."
  },
  ws: {
    connected: "WebSocket: Connected",
    connecting: "WebSocket: Connecting...",
    reconnecting: "WebSocket: Reconnecting...",
    disconnected: "WebSocket: Offline",
    clickToReconnect: "Click to reconnect"
  },
  serviceHistory: {
    close: "Close",
    issue: "Issue",
    laborCost: "Labor cost",
    loadError: "Error loading data",
    loading: "Loading...",
    noHistory: "No service history",
    partsCost: "Parts",
    resolution: "Resolution",
    title: "Service history",
    totalCost: "Total cost",
    totalServices: "Total services",
    unknownError: "Unknown error",
    warranty: "Warranty",
    warrantyBadge: "Warranty",
    serialNumber: "Serial number: {serial}",
    statusDraft: "Draft",
    statusDiagnosed: "Diagnosed",
    statusInProgress: "In progress",
    statusWaitingParts: "Waiting for parts",
    statusCompleted: "Completed",
    statusClosed: "Closed"
  },
  stockDetail: {
    availableInPhase2: "Available in Phase 2",
    avgMonthlyUsage: "Avg. monthly usage",
    close: "Close",
    critical: "Critical",
    currentStock: "Current stock",
    description: "Stock details and purchase recommendation",
    lastPurchase: "Last purchase",
    minimumThreshold: "Minimum threshold",
    model: "Model",
    movementHistory30d: "Movement history (30 days)",
    purchaseHistory: "Purchase history",
    purchaseRecommendation: "Purchase recommendation",
    recommendedPurchase: "Recommended purchase: {quantity} units (to reach minimum {threshold})",
    serialNumber: "Serial number",
    status: "Status",
    tabInfo: "Information",
    tabMovement: "Movement history",
    type: "Type",
    warning: "Warning",
    quantity: "Quantity: {count} pcs",
    unitCount: "{count} pcs"
  },
  widget: {
    permissions: {
      title: "Dashboard Widget Permissions",
      description: "Configure which role can see which dashboard widget",
      loadError: "Error loading data",
      unknownError: "Unknown error",
      retry: "Retry",
      matrixTitle: "Widget Matrix",
      matrixDescription: "The Admin role always sees all widgets and cannot be modified.",
      resetToDefaults: "Reset to defaults",
      cancel: "Cancel",
      pendingChanges: "{count} change(s) pending",
      saving: "Saving...",
      save: "Save",
      saveError: "Error saving",
      resetError: "Error resetting",
      resetConfirmTitle: "Confirm reset",
      resetConfirmDescription: "Are you sure you want to reset to default permissions? This will remove all custom settings.",
      resetting: "Resetting...",
      reset: "Reset"
    },
    cardExpiry: {
      title: "Card Expiration",
      ariaLabel: "Card expiration monitoring",
      loading: "Loading card expiration data...",
      errorTitle: "Error occurred",
      errorMessage: "Failed to load card expiration data.",
      alertCount: "alert(s)",
      noAlerts: "No expiring card alerts.",
      urgent: "Urgent",
      warning: "Warning",
      info: "Information",
      expiredToday: "Expired today",
      expiresToday: "Expires today",
      expiredDaysAgo: "Expired {days} day(s) ago",
      expiresInDays: "Expires in {days} day(s)",
      deposit: "Deposit",
      newCard: "New card",
      newCardRequest: "New card request: {partner}",
      newCardStarted: "New card request started",
      alertListAria: "{count} card expiration alert(s)"
    },
    equipmentProfit: {
      title: "Equipment ROI",
      loadError: "Error loading data.",
      avgRoi: "Avg. ROI",
      totalRevenue: "Total revenue",
      totalCosts: "Total costs",
      totalProfit: "Total profit",
      totalEquipment: "Total equipment",
      profitable: "Profitable",
      losing: "Losing",
      topFive: "Top 5 Most Profitable"
    },
    forecast: {
      title: "Revenue Forecast",
      ariaLabel: "Revenue Forecast",
      loading: "Loading revenue forecast...",
      error: "Error occurred",
      errorDescription: "Failed to load revenue forecast.",
      comparedToPreviousMonth: "compared to previous month",
      sourceBreakdown: "Breakdown by source",
      previousMonthActual: "Previous month actual",
      sourcePercentage: "{source} ({percentage}%)",
      expectedRevenue: "Expected Revenue"
    },
    partnerActivity: {
      title: "Partner Activity",
      expandedTitle: "Partner Activity",
      refresh: "Refresh",
      transactions: "transaction(s)",
      totalTransactions: "Total transactions",
      vsPrevious: "vs previous period",
      rental: "Rental",
      rentals: "Rentals",
      sales: "Sales",
      salesPlural: "Sales",
      service: "Service",
      date: "Date",
      totalColumn: "Total"
    },
    partnerOverview: {
      title: "Partner Overview",
      refresh: "Refresh",
      last30Days: "(30 days)",
      activePartners: "active partner(s)",
      categoryRetail: "Retail",
      categoryB2B: "B2B",
      categoryVIP: "VIP"
    },
    receivables: {
      title: "Receivables Aging",
      reportTitle: "Receivables Aging Report",
      totalReceivables: "Total receivables",
      bucket0_30: "0-30 days",
      bucket31_60: "31-60 days",
      bucket61_90: "61-90 days",
      bucket90plus: "90+ days",
      invoices: "invoice(s)",
      topDebtors: "Top 3 Debtors",
      moreDebtors: "more debtor(s)",
      noReceivables: "No receivables",
      loadError: "Error loading data.",
      updatedAt: "Updated",
      total: "Total",
      partnersOwe: "partner(s) owe",
      agingBreakdown: "Aging breakdown",
      ofTotal: "of total",
      allDebtors: "All Debtors",
      partner: "Partner",
      debt: "Debt",
      invoicesHeader: "Invoices",
      oldestDueDate: "Oldest due date",
      overdue: "Overdue",
      pcs: "pcs",
      days: "day(s)"
    },
    recurringIssues: {
      title: "Recurring Issues",
      refresh: "Refresh",
      problematicEquipment: "problematic equipment",
      critical: "critical",
      noIssues: "No recurring issues",
      viewServiceHistory: "View service history for {name}",
      lastService: "Last service",
      more: "more"
    },
    rentalStats: {
      title: "Rental Statistics",
      ariaLabel: "Rental Statistics",
      loading: "Loading rental statistics...",
      error: "Error occurred",
      errorDescription: "Failed to load rental statistics.",
      daysPerRental: "days / rental",
      comparedToPreviousPeriod: "compared to previous period",
      totalRentals: "Total rentals",
      active: "Active",
      overdue: "Overdue"
    },
    seasonality: {
      title: "Seasonal Trend",
      titleShort: "Rental Trend (12 months)",
      ariaLabel: "Seasonal Trend",
      loading: "Loading seasonal trend...",
      error: "Error occurred",
      errorDescription: "Failed to load seasonal trend.",
      noData: "Not enough data to display trend.",
      rentals: "Rentals",
      revenue: "Revenue",
      revenueFt: "Revenue (HUF)",
      totalRentals: "Total rentals:",
      totalRevenue: "Total revenue:",
      pcs: "pcs"
    },
    serviceProfit: {
      title: "Service Profitability",
      loading: "Loading...",
      loadError: "Error loading data.",
      avgMargin: "Avg. margin",
      totalRevenue: "Total revenue",
      partsCost: "Parts cost",
      netProfit: "Net profit",
      worksheets: "Worksheets",
      laborRevenue: "Labor revenue",
      topFiveTechnicians: "Top 5 Technicians (Profit)",
      worksheet: "worksheet",
      margin: "margin",
      noData: "No technician profit data in this period."
    },
    serviceRevenue: {
      title: "Service Revenue",
      periodSelect: "Select period",
      refresh: "Refresh",
      periodDay: "Today",
      periodWeek: "Week",
      periodMonth: "Month",
      laborFee: "Labor fee",
      parts: "Parts"
    },
    stockAlert: {
      title: "Stock Alert List",
      noShortage: "No stock shortage",
      allProductsAdequate: "All products at adequate stock level",
      totalAlerts: "Total alerts",
      critical: "Critical",
      warning: "Warning",
      criticalShortages: "Critical Shortages",
      warnings: "Warnings",
      model: "Model",
      type: "Type",
      current: "Current",
      minimum: "Minimum",
      shortage: "Shortage",
      lastOrder: "Last order",
      status: "Status"
    },
    stockHeatmap: {
      title: "Stock Heatmap",
      description: "Stock distribution by equipment type and location"
    },
    stockMovement: {
      title: "Stock Movements",
      subtitle: "Stock movements - last 30 days",
      refresh: "Refresh",
      incoming: "Incoming",
      outgoing: "Outgoing",
      returns: "Returns",
      netChange: "Net change"
    },
    techWorkload: {
      title: "Technician Workload",
      refresh: "Refresh",
      worksheetsOf: "worksheets of",
      more: "more",
      moreTechnicians: "more technician(s)",
      totalTechnicians: "Total technicians",
      active: "active",
      activeWorksheets: "Active worksheets",
      noActiveWorksheets: "No active worksheets",
      priority: {
        low: "Low",
        normal: "Normal",
        high: "High",
        urgent: "Urgent"
      }
    },
    topPartners: {
      title: "Top Partners",
      expandedTitle: "Top Partners",
      periodMonth: "Month",
      periodQuarter: "Quarter",
      periodYear: "Year",
      periodSelect: "Select period",
      refresh: "Refresh",
      giftEligible: "Gift eligible",
      morePartners: "more partner(s)",
      period: "Period",
      partner: "Partner",
      totalRevenue: "Total revenue",
      rental: "Rental",
      sales: "Sales",
      service: "Service"
    },
    vat: {
      title: "VAT Summary",
      ariaLabel: "VAT summary",
      loading: "Loading VAT summary...",
      errorTitle: "Error occurred",
      errorMessage: "Failed to load VAT summary.",
      payable: "VAT payable",
      claimable: "Claimable VAT",
      outputVat: "Output",
      inputVat: "Input",
      rateBreakdown: "Rate breakdown"
    },
    warranty: {
      title: "Warranty Ratio",
      refresh: "Refresh",
      warranty: "Warranty",
      paid: "Paid",
      repairs: "repair(s)",
      paidRevenue: "Paid revenue",
      sixMonthTrend: "6 month trend",
      trendUp: "rising",
      trendDown: "declining",
      trendStable: "stable"
    },
    worksheet: {
      title: "Worksheets",
      refresh: "Refresh",
      activeWorksheets: "active worksheet(s)",
      status: {
        draft: "Draft",
        diagnosed: "Diagnosed",
        inProgress: "In progress",
        waitingParts: "Waiting for parts",
        completed: "Completed",
        closed: "Closed"
      }
    },
    emptyState: {
      message: "No widget to display",
      hint: "Contact your administrator",
      defaultMessage: "No data to display",
      defaultHint: "Try using different filter criteria."
    },
    partnerCredit: {
      comingSoon: "Coming soon...",
      featureInProgress: "Feature enabled - implementation in progress",
      managementLabel: "Partner credit limit management",
      title: "Partner Credit Limit",
      tooltipDescription: "Partner credit limit management - future epic"
    },
    popularEquipment: {
      ariaLabel: "Popular equipment",
      error: "Error occurred",
      errorDescription: "Failed to load popular equipment.",
      loading: "Loading popular equipment...",
      noData: "Not enough rental data yet.",
      rentalCount: "{count} rental(s)",
      title: "Popular Equipment",
      top5Title: "Top 5 Popular Equipment",
      top5Total: "Top 5 total"
    },
    warrantyPlaceholder: {
      comingSoon: "Coming soon...",
      epicInfo: "Implemented in Epic 38",
      ratioLabel: "Warranty vs paid ratio",
      title: "Warranty Ratio",
      tooltipDescription: "Warranty vs paid ratio - in Epic 38"
    },
    error: {
      loadError: "An error occurred while loading data",
      errorTitle: "Widget loading error",
      retry: "Retry"
    },
    alert: {
      details: "Details"
    },
    stock: {
      critical: "Critical",
      warning: "Warning"
    }
  },
  integration: {
    crm: {
      errorDescription: "The Twenty CRM service is unavailable, or the browser is blocking the iframe.",
      loading: "Loading Twenty CRM...",
      subtitle: "Customer relationship management"
    },
    hr: {
      errorDescription: "The Horilla HR service is unavailable, or the browser is blocking the iframe.",
      loading: "Loading Horilla HR...",
      subtitle: "Human resource management"
    },
    flow: {
      errorDescription: "rPI Flow is not available.",
      loading: "Loading rPI Flow...",
      subtitle: "Workflow launcher & tracker",
      unavailable: "rPI Flow is not configured on this server.",
      publishedWorkflows: "Available workflows",
      noWorkflows: "No registered workflows",
      recentExecutions: "Recent executions",
      noExecutions: "No active executions",
      steps: "steps",
      tabs: {
        catalog: "Catalog",
        running: "Running",
        history: "History",
        approvals: "Approvals",
        operations: "Operations"
      },
      running: {
        noExecutions: "No running workflows",
        startOne: "Start one \u2192",
        step: "step"
      },
      health: {
        ok: "OK",
        offline: "Offline",
        workflows: "workflows",
        running: "running",
        approvals: "approvals",
        schedules: "schedules"
      },
      operations: {
        engineHealth: "Engine Health",
        online: "Online",
        offline: "Offline",
        registeredWorkflows: "registered workflows",
        dailyStats: "Daily Statistics",
        totalToday: "Total today",
        successRate: "Success rate",
        schedules: "Schedules",
        schedulesInfo: "Scheduled workflows will appear here"
      },
      schedule: {
        title: "Schedule",
        save: "Save",
        saved: "\u23F0 Schedule saved",
        error: "Failed to save schedule",
        daily: "Every day",
        weekdays: "Weekdays",
        weekly: "Weekly",
        monthly: "Monthly",
        custom: "Custom cron",
        dayOfMonth: "Day of month",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
      },
      approval: {
        approve: "Approve",
        reject: "Reject",
        approved: "Approved",
        rejected: "Rejected",
        error: "An error occurred",
        noPending: "No pending approvals \u2705",
        pastDecisions: "Past decisions",
        requestedBy: "Requested by",
        requiredRole: "Required role",
        reason: "Reason",
        rejectTitle: "Rejection reason",
        reasonPlaceholder: "Describe the reason for rejection..."
      },
      history: {
        noExecutions: "No past executions",
        noResults: "No results match filters",
        startOne: "Start one \u2192",
        filterStatus: "Status",
        filterWorkflow: "Workflow",
        filterPeriod: "Period",
        periodAll: "All",
        periodToday: "Today",
        periodWeek: "This week",
        periodMonth: "This month",
        restart: "Restart"
      },
      toast: {
        completed: "\u2705 {name} completed",
        failed: "\u274C {name} failed"
      },
      execution: {
        details: "Details",
        hideDetails: "Hide",
        parameters: "Parameters",
        cancel: "Cancel",
        cancelConfirm: "Are you sure you want to cancel?",
        cancelled: "{name} cancelled",
        keepRunning: "Keep running"
      },
      status: {
        running: "Running",
        pending: "Pending",
        completed: "Completed",
        failed: "Failed",
        cancelled: "Cancelled"
      },
      emptyState: {
        running: "No running workflows",
        history: "No past executions",
        approvals: "No pending approvals",
        operations: "Operations coming soon..."
      },
      categories: {
        finance: "Finance",
        rental: "Rental",
        service: "Service",
        inventory: "Inventory",
        sales: "Sales",
        reporting: "Reporting",
        compliance: "Compliance",
        hr: "HR",
        operations: "Operations"
      },
      startWorkflow: "Start",
      favorites: "Favorites",
      pinWorkflow: "Pin",
      unpinWorkflow: "Unpin",
      execute: {
        title: "Start Workflow",
        submit: "Start",
        success: "{name} started",
        error: "Failed to start {name}",
        steps: "Steps",
        required: "Required field"
      }
    },
    loadFailed: "Failed to load",
    openInNewTab: "Open in new window",
    refresh: "Refresh",
    retry: "Retry",
    sso: {
      active: "SSO active",
      connecting: "SSO...",
      fallback: "Manual login",
      retryButton: "Retry SSO"
    }
  },
  myforge: {
    openInNewTab: "Open in new window"
  },
  pwa: {
    close: "Close",
    install: {
      button: "Install",
      description: "Install the app to your home screen for faster access!",
      title: "Install application"
    },
    notification: {
      description: "Receive notifications about important events, rentals and service statuses.",
      dismiss: "Not now",
      enable: "Enable",
      title: "Enable notifications"
    },
    offline: {
      message: "No internet connection"
    },
    update: {
      button: "Update",
      dismiss: "Later",
      message: "New version available"
    }
  },
  worksheetPrint: {
    downloadPdf: "Download PDF",
    emailPlaceholder: "Email address",
    emailSendFailed: "Email sending failed",
    emailSent: "Email sent",
    errorPrefix: "Error",
    generating: "Generating PDF...",
    pdfGenerationFailed: "PDF generation failed",
    pdfTitle: "Worksheet PDF",
    print: "Print",
    sendEmail: "Send email",
    sending: "Sending...",
    title: "Worksheet print",
    unknownError: "Error: Unknown error"
  },
  permission: {
    module: {
      auth: "Authentication",
      users: "Users",
      partners: "Partners",
      inventory: "Inventory",
      rental: "Rental",
      sales: "Sales",
      service: "Service",
      reports: "Reports",
      settings: "Settings"
    }
  },
  worksheet: {
    status: {
      felveve: "Received",
      folyamatban: "In progress",
      varhato: "Waiting",
      felfuggesztve: "Suspended",
      kesz: "Ready",
      szamlazando: "To be invoiced",
      lezart: "Closed",
      torolve: "Deleted"
    },
    stepper: {
      ariaLabel: "Worksheet status progress",
      cancelled: "Cancelled",
      completed: "completed",
      current: "current"
    },
    type: {
      fizetos: "Paid repair",
      garancialis: "Warranty",
      berlesi: "Rental service",
      karbantartas: "Maintenance",
      szerzodeses: "Contracted"
    },
    priority: {
      surgos: "Urgent (+20%)",
      felaras: "Premium",
      garancialis: "Warranty",
      franchise: "Franchise",
      normal: "Normal",
      surcharge: "Surcharge"
    },
    category: {
      powerTool: "Power tool",
      garden: "Garden tool",
      construction: "Construction",
      cleaning: "Cleaning machine",
      other: "Other"
    },
    history: {
      created: "Created",
      statusChanged: "Status changed",
      itemAdded: "Item added",
      itemRemoved: "Item removed",
      assigned: "Assigned",
      noteAdded: "Note added",
      invoiced: "Invoiced",
      completed: "Completed"
    },
    placeholder: {
      estimatedCost: "e.g. 50000"
    },
    repairType: {
      title: "Repair Type",
      description: "Select the type of repair",
      fizetos: "Paid Repair",
      fizetosDesc: "Paid repair, inspection fee may apply",
      garancialis: "Warranty",
      garancialisDesc: "Warranty repair, inspection fee not applicable",
      szerzodeses: "Contract Partner",
      szerzodesesDesc: "Contract partner repair, inspection fee not applicable",
      szerzodesesBadge: "Contract partner detected",
      selected: "Selected: {type}"
    },
    inspectionFee: {
      notApplicable: "Not applicable ({reason})",
      change: "Change inspection fee",
      confirm: "Confirm inspection fee",
      confirmed: "Inspection fee confirmed",
      overridden: "Inspection fee overridden",
      override: "Override inspection fee",
      suggested: "Suggested inspection fee",
      urgent: "Urgency surcharge"
    },
    paymentGate: {
      title: "Inspection fee payment required",
      description: "The inspection fee ({amount}) must be paid before work can begin. The equipment can only be assigned to a technician after payment.",
      markPaid: "Mark as paid",
      blockInfo: "Work cannot start without payment"
    },
    pendingPartsBlock: {
      title: "Closing blocked \u2014 pending parts",
      description: "{count} pending parts procurement(s). The worksheet cannot be completed or closed until the parts arrive.",
      blockInfo: "Blocked due to pending parts procurement",
      toast: "The worksheet cannot be closed with pending parts procurement."
    },
    inspectionFeeCredit: {
      label: "Inspection fee credit",
      netAfterCredit: "Payable (after credit)"
    },
    costAllocation: {
      title: "Cost breakdown",
      customerFacing: "Customer-facing",
      customerTotal: "Customer total (net)",
      internal: "Internal costs (subcontractor)",
      internalTotal: "Internal total",
      grandTotal: "Grand total (gross)",
      vatIncluded: "Includes VAT"
    },
    basket: {
      title: "Worksheet basket",
      addPlaceholder: "Worksheet ID or number...",
      empty: "Basket is empty",
      clear: "Clear",
      checkout: "Consolidated invoice",
      checkoutSuccess: "Invoice generated",
      warrantyError: "Warranty worksheets cannot be added to the basket \u2014 warranty repairs are covered by the manufacturer/warranty via separate batch billing."
    },
    supplierSettlement: {
      title: "Supplier Warranty Settlement",
      subtitle: "Generate batch invoices for warranty repairs to manufacturers",
      filters: "Filters",
      supplier: "Supplier",
      from: "Period start",
      to: "Period end",
      search: "Search",
      filterRequired: "Please specify supplier and period",
      eligible: "Eligible worksheets",
      generateInvoice: "Generate batch invoice",
      generated: "Batch invoice generated successfully!",
      invoiceNumber: "Invoice number",
      worksheets: "worksheets",
      wsNumber: "Worksheet #",
      brand: "Brand",
      completed: "Completed"
    },
    procurement: {
      title: "Parts procurement requests",
      addRequest: "New request",
      empty: "No procurement requests for this worksheet",
      descriptionPlaceholder: "Part name or description...",
      markOrdered: "Mark ordered",
      markReceived: "Mark received",
      status: {
        pending: "Pending",
        ordered: "Ordered",
        received: "Received",
        cancelled: "Cancelled"
      }
    },
    hourlyRateConfig: {
      title: "Service Hourly Rate Configuration",
      subtitle: "Hourly rate settings per machine category",
      tableTitle: "Hourly rate per category (net HUF)",
      category: "Category",
      fallbackRate: "Default",
      configuredRate: "Configured rate",
      invalidRate: "Hourly rate cannot be negative",
      priorityInfo: "Priority: contract partner rate > configured category rate > default table > 8,000 HUF"
    },
    markReadyAction: "Mark complete",
    isWarranty: "Warranty",
    suspendAction: "Suspend",
    resumeAction: "Resume",
    suspendedTitle: "Worksheet suspended \u2014 additional cost",
    suspendedDescription: "A new issue was discovered during repair that involves extra cost. Awaiting customer decision.",
    newQuoteVersion: "Create new quote",
    resumeOriginalScope: "Resume with original scope",
    machineCategory: {
      title: "Machine Category",
      subtitle: "Select the machine type",
      electricSmall: "Electric Small Tool",
      electricLarge: "Electric Large Tool",
      petrolHandheld: "Petrol Handheld",
      petrolPush: "Petrol Push Mower",
      tractor: "Tractor/Ride-on",
      battery: "Battery Powered"
    },
    filter: {
      machineCategory: "Machine Category",
      allCategories: "All categories"
    },
    directRepairBadge: "Direct repair \u2014 within cost limit",
    costLimitSkip: "Quote phase skipped \u2014 estimated cost within limit",
    technician: {
      title: "Assigned Technicians",
      primary: "Primary",
      coTech: "Co-Technician",
      maxReached: "Maximum {max} co-technicians can be assigned",
      maxCoTechInfo: "Max {max} co-techs",
      noAssigned: "No technician assigned",
      addTechnician: "Add Technician",
      nameLabel: "Technician name",
      namePlaceholder: "e.g. John Smith",
      roleLabel: "Role",
      nameRequired: "Technician name is required (min. 2 characters)"
    },
    batch: {
      tabTitle: "Batch intake",
      scanTitle: "Barcode scanner",
      scanPlaceholder: "Scan or type barcode...",
      worksheetType: "Worksheet type",
      scannedItems: "Scanned items",
      createAll: "Create all",
      results: "Results",
      successCount: "{count} successfully created",
      failureCount: "{count} failed"
    },
    tabs: {
      overview: "Overview",
      diagnosis: "Diagnosis",
      parts: "Parts",
      history: "History",
      photos: "Photos",
      warranty: "Warranty",
      noWarranty: "No warranty claim for this worksheet."
    },
    closeConfirm: {
      title: "Close worksheet",
      warning: "{count} procurement item(s) still pending. Close the worksheet anyway?",
      qty: "{qty} pcs",
      unnamedItem: "Procurement item",
      confirm: "Close anyway",
      cancel: "Cancel",
      status: {
        DRAFT: "Draft",
        SUBMITTED: "Submitted",
        ORDERED: "Ordered"
      }
    },
    historyEvents: {
      created: "Worksheet created",
      received: "Intake",
      diagnosed: "Diagnosis started",
      started: "Repair started",
      completed: "Completed",
      notified: "Customer notified",
      delivered: "Handed over",
      closed: "Closed",
      empty: "No events to display"
    },
    intakeBatch: {
      count: "{count} machines in one intake",
      current: "this worksheet",
      error: "Batch intake data is unavailable",
      title: "Batch intake",
      formTitle: "Batch worksheet intake",
      formDesc: "Multiple devices from one partner at once, under a shared intake ID.",
      partnerSection: "Select partner",
      partnerHint: "Choose the partner this intake belongs to.",
      selectedPartner: "Selected partner: {name}",
      changePartner: "Change partner",
      batchSettings: "Intake settings",
      deviceList: "Devices",
      itemHeading: "Device {index}",
      addItem: "Add device",
      removeItem: "Remove device",
      itemCount: "{count} / 26 devices",
      submit: "Create intake ({count} devices)",
      submitting: "Creating intake\u2026",
      successTitle: "Intake created",
      successDesc: "{count} worksheets created \u2014 intake ID: {batchId}",
      newBatch: "New intake",
      listBadge: "Batch",
      listBadgeHint: "Batch intake \u2014 click to view the whole batch",
      filterActive: "Batch intake filter active",
      clearFilter: "Clear filter",
      errors: {
        empty: "At least one device is required for the intake.",
        tooMany: "At most 26 devices can be added in one intake.",
        duplicateSerial: "Duplicate serial number in the intake \u2014 each device must have a unique serial number.",
        deviceActive: "The device already has an active worksheet.",
        partnerRequired: "Select a partner before submitting.",
        generic: "Failed to create the intake. Please try again."
      }
    },
    resolvedPackage: {
      none: "No package",
      noneDesc: "No active service package is currently assigned to this product."
    },
    viewInvoice: "View invoice",
    billError: {
      alreadyInvoiced: "The worksheet has already been invoiced.",
      notBillable: "The worksheet is not billable yet.",
      warrantyNotBillable: "Warranty worksheet cannot be invoiced (covered by manufacturer).",
      failed: "Failed to issue the invoice."
    },
    partner: {
      loading: "Loading partner\u2026",
      label: "Partner: {name}",
      unresolved: "Unknown partner ({id})"
    }
  },
  dashboardApp: {
    changelog: {
      categoryFixed: "Fix",
      categoryImproved: "Improvement",
      categoryNew: "New feature",
      codeCoverage: "Code coverage:",
      collapseDetails: "Collapse all details",
      collapseVersions: "Collapse all versions",
      details: "Details",
      expandDetails: "Expand all details",
      expandVersions: "Expand all versions",
      failedTests: "failed",
      filter: "Filter:",
      filterAll: "All",
      filterFixed: "Fixes",
      filterImproved: "Improvements",
      filterNew: "New features",
      findings: "findings",
      fixedIssues: "fixed",
      heading: "Changes and Updates",
      openIssues: "open",
      passed: "passed",
      relatedTests: "Related Tests",
      reviewFindings: "Code Review Findings",
      reviewSummary: "Code Review Summary",
      severityCritical: "Critical",
      severityMajor: "Major",
      severityMinor: "Minor",
      statusFixed: "\u2713 Fixed",
      statusOpen: "\u25CB Open",
      statusRejected: "\u2014 Rejected",
      subscribe: "Subscribe",
      subscribeDescription: "Subscribe to our newsletter and be the first to learn about new features and improvements.",
      subscribeTitle: "Stay up to date!",
      subtitle: "Follow the system developments and new features",
      test: "test",
      testSummary: "Test Summary",
      typeMajor: "Major version",
      typeMinor: "Feature update",
      typePatch: "Bug fix",
      versions: "Versions"
    },
    developer: {
      active: "active",
      completed: "Completed",
      completionTrend: "Completion Trend (Cumulative)",
      done: "Done",
      epicProgress: "Epic Progress (%)",
      epicStorySummary: "Epic & Story Summary",
      filterAll: "All",
      filterDone: "Done",
      filterInProgress: "In Progress",
      filterLabel: "Filter:",
      filterPlanned: "Planned",
      inProgress: "In Progress",
      inProgressEpics: "In Progress Epics",
      noFilterResults: "No results for this filter",
      noInProgressEpics: "No in-progress epics",
      progress: "Progress",
      storyStatusDistribution: "Story Status Distribution",
      tabEpics: "Epics",
      tabOverview: "Overview",
      tabStories: "Stories",
      totalCompleted: "Total completed",
      totalEpics: "Total Epics",
      totalStories: "Total Stories"
    },
    downloads: {
      archive: "Archive",
      archiveDesc: "Previous exports",
      comingSoon: "Downloads will be available soon.",
      download: "Download \u2192",
      fullStatus: "Full Status",
      fullStatusDesc: "All data in one file",
      heading: "Exports and Reports",
      progressExport: "Progress Export",
      progressExportDesc: "Epic and story progress data",
      reviewSummary: "Review Summary",
      reviewSummaryDesc: "Code review results",
      sprintReport: "Sprint Report",
      sprintReportDesc: "Current sprint status export",
      testReport: "Test Report",
      testReportDesc: "Test results and coverage"
    },
    executive: {
      activeWork: "Active Work",
      allStoriesDone: "All stories done!",
      done: "Done",
      doneEpic: "Done Epic",
      fixed: "Fixed",
      inProgress: "In Progress",
      issues: "issues",
      more: "more",
      overallProgress: "Overall progress",
      projectProgress: "Project Progress",
      recentlyCompletedEpics: "Recently Completed Epics",
      testSummary: "Test Summary",
      tests: "Tests",
      totalIssues: "Total issues"
    },
    workflow: {
      pendingApprovals: "Pending approvals",
      runningWorkflows: "Running workflows",
      openFlow: "Open rPI Flow",
      refresh: "Refresh"
    },
    knowledge: {
      adrs: "ADRs",
      adrsDesc: "Architecture Decision Records",
      architecture: "Architecture",
      architectureDesc: "System architecture documentation",
      comingSoon: "Knowledge base will be available soon.",
      epicDefinitions: "Epic Definitions",
      epicDefinitionsDesc: "Epic and story descriptions",
      heading: "Documentation",
      prd: "PRD",
      prdDesc: "Product Requirements Document"
    },
    layout: {
      header: {
        refreshButton: "Refresh",
        settingsButton: "Settings",
        statsDone: "done",
        statsEpics: "Epics",
        statsStories: "Stories",
        views: {
          changelog: {
            subtitle: "Versions, changes and feature updates",
            title: "What's New"
          },
          developer: {
            subtitle: "Epic and story progress in detail",
            title: "Developer View"
          },
          downloads: {
            subtitle: "Exports and reports",
            title: "Downloads"
          },
          executive: {
            subtitle: "Project status and KPIs at a glance",
            title: "Executive Overview"
          },
          knowledge: {
            subtitle: "Documentation and ADRs",
            title: "Knowledge Base"
          },
          qa: {
            subtitle: "Test metrics and code review results",
            title: "QA View"
          },
          statistics: {
            subtitle: "Detailed project metrics and analytics",
            title: "Statistics"
          }
        }
      },
      sidebar: {
        collapse: "Collapse",
        darkMode: "Dark mode",
        lightMode: "Light mode",
        logoSubtitle: "rPI ERP Dashboard",
        logoTitle: "rPI ERP",
        mobileLogoSubtitle: "KGC ERP Dashboard",
        mobileLogoTitle: "MyForgeOS",
        refresh: "Refresh",
        refreshData: "Refresh data",
        refreshing: "Refreshing...",
        sectionUtilities: "Utilities",
        sectionViews: "Views",
        themeToggle: "Toggle theme",
        utilities: {
          changelog: {
            description: "Versions and changes",
            name: "What's New"
          },
          downloads: {
            description: "Exports and reports",
            name: "Downloads"
          },
          knowledge: {
            description: "Documentation and ADRs",
            name: "Knowledge Base"
          }
        },
        views: {
          developer: {
            description: "Sprint and story details",
            name: "Developer"
          },
          executive: {
            description: "Executive overview and KPIs",
            name: "Executive"
          },
          qa: {
            description: "Test and quality metrics",
            name: "QA"
          },
          statistics: {
            description: "Detailed analytics and charts",
            name: "Statistics"
          }
        }
      }
    },
    qa: {
      allEpics: "All Epics",
      allPackages: "All packages",
      avgCoverage: "Avg Coverage",
      claudeVsGemini: "Claude vs Gemini Comparison",
      collapseAll: "\u25B2 Collapse",
      consensus: "Consensus",
      coverageByPackage: "Coverage by Package",
      coveragePercent: "Coverage %",
      critical: "Critical",
      deferred: "Deferred",
      expandAll: "\u25BC Expand",
      failed: "Failed",
      failingTests: "Failing Tests",
      filter: "Filter:",
      filterAll: "All",
      filterCritical: "\u{1F534} Critical",
      filterFailed: "\u2717 Failed",
      filterFixed: "\u2713 Fixed",
      filterOpen: "\u25CB Open",
      filterPassed: "\u2713 Passed",
      fixed: "Fixed",
      found: "Found",
      heading: "QA Dashboard",
      high: "High",
      inProgressRound: "In Progress",
      issueResolutionFlow: "Issue Resolution Flow",
      issues: "issues",
      low: "Low",
      medium: "Medium",
      noFilterResults: "No results for this filter",
      open: "Open",
      passRate: "Pass Rate %",
      passed: "Passed",
      qualityScore: "Quality Score",
      reviewIssues: "Review Issues",
      reviewSummary: "Review Summary",
      runTime: "Run time",
      severityDistribution: "Issue Severity Distribution",
      skipped: "Skipped",
      statusDeferred: "\u21B7 Deferred",
      statusFixed: "\u2713 Fixed",
      statusOpen: "\u25CB Open",
      statusWontfix: "\u2014 Won't fix",
      subtitle: "Test metrics, code review and quality assurance - from real BMAD data",
      tabOverview: "Overview",
      tabReviews: "Reviews",
      tabTests: "Tests",
      test: "Tests",
      testResultsByPackage: "Test Results by Package",
      trendTitle: "Pass Rate & Coverage Trend",
      verdictApproved: "\u2705 Approved",
      verdictApprovedWithFixes: "\u2705 Approved (with fixes)",
      verdictInProgress: "\u{1F504} In Progress",
      verdictRejected: "\u274C Rejected"
    },
    statistics: {
      activeStories: "Active Stories",
      actual: "Actual",
      average: "Average",
      averageFixRate: "Average fix rate",
      avgStoriesPerEpic: "Avg Stories/Epic",
      claudeVsGemini: "Claude vs Gemini Comparison",
      codeReviewAnalytics: "Code Review Analytics",
      completedStories: "Completed Stories",
      completionRate: "Completion Rate",
      consensusRate: "Consensus Rate",
      done: "Done",
      epicCompletionTimeline: "Epic Completion Timeline",
      epicOverview: "Epic Overview",
      epicStatusDistribution: "Epic Status Distribution",
      fixRate: "Fix Rate",
      fixed: "Fixed",
      found: "Found",
      heading: "Statistics",
      ideal: "Ideal",
      inProgress: "In Progress",
      openIssues: "Open Issues",
      passRate: "Pass Rate",
      projectHealth: "Project Health",
      projectProgress: "Project Progress",
      remaining: "Remaining",
      remainingStories: "Remaining",
      severityDistribution: "Issue Severity Distribution",
      sprintProgress: "Sprint Progress",
      storyDistributionByEpic: "Story Distribution by Epic",
      subtitle: "Detailed project metrics and analytics",
      teamPerformance: "Team Performance",
      testCoverage: "Test Coverage",
      testMetrics: "Test Metrics",
      testTypeDistribution: "Test Type Distribution",
      totalIssues: "Total issues",
      totalStories: "Total Stories",
      uniqueFindings: "Unique findings"
    },
    drawer: {
      done: "done",
      epicDetails: "Epic Details",
      fixed: "Fixed",
      foundIssues: "Found issues",
      issues: "Issues",
      noSubtasks: "No subtasks",
      progress: "Progress",
      remaining: "remaining",
      reviewDetails: "Review Details",
      severity: "Severity",
      storyDetails: "Story Details",
      tasks: "Tasks"
    }
  },
  notification: {
    newRental: {
      message: "{partner} - {count} items",
      title: "New rental"
    },
    paymentError: {
      message: "Transaction declined ({amount})",
      title: "Payment error"
    },
    stockShortage: {
      message: "{productName} stock at critical level (< 50%)",
      title: "Stock shortage"
    },
    urgentWorksheet: {
      message: "New urgent worksheet ({number}) created",
      title: "Urgent worksheet"
    }
  },
  permissions: {
    auth: {
      login: "Login",
      loginDesc: "System login",
      pin: "PIN login",
      pinDesc: "Quick PIN code login"
    },
    users: {
      read: "View users",
      readDesc: "View user list and profiles",
      create: "Create user",
      createDesc: "Register new user",
      update: "Edit user",
      updateDesc: "Modify user data",
      delete: "Delete user",
      deleteDesc: "Deactivate user account",
      roles: "Role management",
      rolesDesc: "Configure roles and permissions"
    },
    partners: {
      read: "View partners",
      readDesc: "View partner list and details",
      create: "Create partner",
      createDesc: "Register new partner",
      update: "Edit partner",
      updateDesc: "Modify partner data",
      delete: "Delete partner",
      deleteDesc: "Deactivate partner"
    },
    rental: {
      read: "View rentals",
      readDesc: "View rental list and details",
      create: "Create rental",
      createDesc: "Create new rental",
      return: "Return rental",
      returnDesc: "Process equipment return",
      extend: "Extend rental",
      extendDesc: "Extend rental period"
    },
    sales: {
      read: "View sales",
      readDesc: "View sales list and details",
      create: "Create sale",
      createDesc: "Record new sale",
      discount: "Apply discount",
      discountDesc: "Apply discount to sale",
      refund: "Refund",
      refundDesc: "Process refund"
    },
    service: {
      read: "View worksheets",
      readDesc: "Service worksheet list and details",
      create: "Create worksheet",
      createDesc: "Open new service worksheet",
      update: "Edit worksheet",
      updateDesc: "Modify worksheet data",
      close: "Close worksheet",
      closeDesc: "Finalize service worksheet"
    },
    settings: {
      read: "View settings",
      readDesc: "View system settings",
      update: "Modify settings",
      updateDesc: "Edit system settings"
    },
    inventory: {
      read: "View inventory",
      readDesc: "View inventory list and details",
      adjust: "Adjust inventory",
      adjustDesc: "Modify inventory quantity",
      receive: "Receive goods",
      receiveDesc: "Process goods receipt",
      transfer: "Warehouse transfer",
      transferDesc: "Transfer stock between warehouses"
    },
    reports: {
      rental: "Rental reports",
      rentalDesc: "Rental statistics and reports",
      sales: "Sales reports",
      salesDesc: "Sales statistics and reports",
      financial: "Financial reports",
      financialDesc: "Financial summaries and closings",
      inventory: "Inventory reports",
      inventoryDesc: "Inventory statistics and stocktake reports"
    }
  },
  courier: {
    title: "Courier Deliveries",
    titleSingle: "Delivery Details",
    newDelivery: "New Delivery",
    noDeliveries: "No deliveries",
    notFound: "Delivery not found",
    noCourierYet: "No courier assigned yet",
    deliveryInfo: "Delivery Information",
    courierInfo: "Courier Details",
    paymentSection: "Payment",
    paymentPendingInfo: "Payment pending",
    paymentDescription: "Payment description",
    createPaymentLink: "Create payment link",
    handoff: "Handoff",
    markDelivered: "Mark Delivered",
    cancel: "Cancel",
    statusLabel: "Status",
    statusProgress: "In Progress",
    providerLabel: "Provider",
    trackingLabel: "Tracking Number",
    addressLabel: "Address",
    costLabel: "Cost",
    scheduledLabel: "Scheduled",
    createdAtLabel: "Created",
    deliveredAtLabel: "Delivered",
    handoffAtLabel: "Handed off",
    worksheetIdLabel: "Worksheet",
    enterProvider: "Enter provider",
    enterTracking: "Enter tracking number",
    enterAmount: "Enter amount",
    statusLabels: {
      requested: "Requested",
      paymentPending: "Payment Pending",
      paid: "Paid",
      dispatched: "Dispatched",
      delivered: "Delivered",
      cancelled: "Cancelled"
    },
    cancelDelivery: "Cancel delivery"
  },
  contractPriceList: {
    title: "Contract Price List",
    orderableOnly: "Only items on the list can be ordered",
    importButton: "Import (.xlsx)",
    templateDownload: "Template",
    export: "Export",
    importPreview: "Import preview \u2014 review changes",
    confirmImport: "Confirm Import",
    importSuccess: "Successful import: {successful}/{total} items",
    importPartial: "Partial import: {successful} successful, {failed} failed",
    importError: "Error during import",
    annualLimitWarning: "Annual modification limit!",
    annualLimitDescription: "The last price list import was less than 12 months ago. Are you sure you want to override?",
    forceImport: "Override and import",
    previewNew: "{count} new",
    previewChanged: "{count} changed",
    previewRemoved: "{count} removed",
    previewUnchanged: "{count} unchanged",
    customerSku: "Customer SKU",
    product: "Description",
    contractPrice: "Contract Price",
    validFrom: "Valid From",
    validUntil: "Valid Until",
    status: "Status",
    oldPrice: "Old Price",
    newPrice: "New Price",
    change: "Change",
    noItems: "No price list uploaded",
    dragDrop: "Upload an .xlsx file using the Import button",
    itemCount: "{count} items in price list",
    active: "Active",
    expired: "Expired",
    notYetValid: "Not Yet Valid",
    notOrderable: "Not Orderable",
    diff: {
      NEW: "New",
      CHANGED: "Changed",
      REMOVED: "Removed",
      UNCHANGED: "Unchanged"
    }
  },
  crossSell: {
    title: "Mixed Invoice",
    subtitle: "Rental + purchase + deposit on one invoice",
    addItem: "Add Item",
    itemType: "Item Type",
    rentalFee: "Rental Fee",
    product: "Product",
    serviceFee: "Service Fee",
    servicePart: "Service Part",
    deposit: "Deposit",
    handlingFee: "Handling Fee",
    lateFee: "Late Fee",
    discount: "Discount",
    depositCard: "Card Deposit",
    depositCash: "Cash Deposit",
    revenueTotal: "Revenue Total",
    depositTotal: "Deposit (non-revenue)",
    payableTotal: "Total Payable",
    handlingFeeDescription: "Card deposit handling fee (2%)",
    handlingFeeRefund: "Deposit refund amount",
    noDeposit: "No deposit",
    vatBreakdown: "VAT Breakdown"
  },
  assetTransfer: {
    title: "Asset Transfer",
    toRentalEquipment: "Transfer to Rental Equipment",
    toOwnedAsset: "Transfer to Own Asset",
    confirmTitle: "Confirm Transfer",
    confirmMessage: "Are you sure you want to transfer this product? This action cannot be undone.",
    success: "Transfer successful",
    rentalCardCreated: "Rental equipment card created automatically",
    depreciationCreated: "Depreciation record created automatically (200k+ HUF)",
    noDepreciation: "No depreciation needed (price < 200,000 HUF)",
    note: "Note (optional)",
    errorNotProduct: "Only product-type items can be transferred",
    errorNotAvailable: "Only available items can be transferred"
  },
  releaseHub: {
    title: "rPI Delta",
    subtitle: "Latest changes and improvements",
    tabs: {
      changelog: "Changelog",
      testing: "Release Testing"
    },
    changelog: {
      version: "Version",
      date: "Date",
      changes: "changes",
      expandAll: "Expand All",
      collapseAll: "Collapse All",
      types: {
        feature: "New Feature",
        fix: "Bug Fix",
        improvement: "Improvement",
        breaking: "Breaking Change"
      },
      testStepsBadge: "Test Steps",
      noEntries: "No changelog entries yet."
    },
    testing: {
      summary: "Total",
      features: "features",
      steps: "steps",
      expected: "Expected Result",
      status: {
        passed: "Passed",
        failed: "Failed",
        not_tested: "Not Tested"
      },
      progress: "{done}/{total} tested",
      exportCsv: "Export CSV",
      changelogBadge: "Changelog",
      testedBy: "Tested by",
      comment: "Comment (optional)...",
      save: "Save",
      noTests: "No test steps for this version.",
      retest: "Retest",
      retestNote: "Reason for retest (optional)...",
      retestConfirm: "Start Retest",
      retestCancel: "Cancel",
      lastTest: "Last",
      testers: "tester(s)",
      retestCount: "{count}x tested",
      history: "Testing History",
      historyEmpty: "No previous test runs.",
      historyError: "Failed to load test history.",
      historyRetry: "Retry",
      saveError: "Save failed. Please try again.",
      retestError: "Could not start retest.",
      retestReason: "Reason",
      notTestedYet: "Not tested yet",
      showSteps: "Show {count} test steps",
      hideSteps: "{count} test steps",
      previousTests: "{count} previous",
      noPreviousTests: "0 previous",
      retestNeeded: "Retest needed",
      passBtn: "Pass",
      failBtn: "Fail",
      untested: "Not tested",
      testedPct: "{done}/{total} tested ({pct}%)",
      historyTestedAt: "Tested",
      historyActiveFor: "Active for {duration}",
      historyStepStats: "{checked}/{total} steps checked",
      durationMinutes: "{n} min",
      durationHours: "{n} hours",
      durationDays: "{n} days"
    },
    filters: {
      search: "Search...",
      showOlder: "Older versions ({count})",
      clearFilters: "Clear filters",
      results: "{filtered}/{total} entries",
      noResults: "No results match your filters.",
      categories: "Category",
      types: "Type",
      statuses: "Status"
    }
  },
  quote: {
    advance: {
      amount: "Advance amount",
      confirm: "Confirm advance",
      deducted: "Deducted",
      exceedsTotal: "Advance exceeds total",
      invalidAmount: "Invalid amount",
      method: "Payment method",
      methodCard: "Card",
      methodCash: "Cash",
      methodTransfer: "Bank transfer",
      paid: "Advance paid",
      paidAt: "Paid at",
      pay: "Pay advance",
      payDescription: "Record advance payment",
      recordFailed: "Failed to record advance",
      recorded: "Advance recorded",
      refund: "Refund advance",
      refundBtn: "Refund",
      refundConfirm: "Confirm refund",
      refundFailed: "Refund failed",
      refunded: "Refunded",
      refundedLabel: "Refunded"
    }
  },
  priLlm: {
    apiKeyPlaceholder: "Enter new API key...",
    userPerMin: "User / minute",
    tenantPerMin: "Tenant / minute",
    userPerDay: "User / day",
    sonnetPerMin: "Sonnet / minute",
    requests: "Requests",
    inputTokens: "Input tokens",
    outputTokens: "Output tokens",
    costUsd: "Cost (USD)",
    title: "pRI Assistant Settings",
    apiConfigTitle: "API Configuration",
    apiConfigDesc: "LLM provider and API key settings",
    providerLabel: "Provider",
    apiKeyLabel: "API Key",
    currentKeyLabel: "Current:",
    enabledLabel: "pRI Enabled",
    enabledDesc: "Enable LLM responses for users",
    testConnection: "Test connection",
    testOk: "OK \u2014 {model} ({latencyMs}ms)",
    testFailed: "Failed",
    rateLimitTitle: "Rate Limiting & Quotas",
    rateLimitDesc: "User- and tenant-level limits",
    monthlyQuotasTitle: "Monthly quotas (requests/month)",
    tierStrategyTitle: "Tier strategy",
    defaultTierLabel: "Default tier",
    autoDowngradeLabel: "Auto-downgrade",
    autoDowngradeDesc: "Switches to a cheaper tier once the quota is reached",
    usageStatsTitle: "Usage Statistics",
    usageStatsDesc: "Aggregated data for the current month",
    noUsageData: "No usage data for this month.",
    saveButton: "Save settings",
    saveSuccessTitle: "Saved",
    saveSuccessDesc: "pRI settings updated successfully.",
    saveErrorTitle: "Error",
    unknownError: "Unknown error.",
    networkError: "Network error"
  },
  goodsReceipt: {
    detail: {
      backToList: "Back to list",
      notFound: "Goods receipt not found",
      completeConfirm: "Complete receipt? Stock will be updated.",
      completing: "Completing...",
      complete: "Complete",
      unresolvedCount: "{count} unresolved discrepancy(ies)",
      supplier: "Supplier",
      createdAt: "Created at",
      completedAt: "Completed at",
      linkedAvizo: "Linked purchase advice",
      notes: "Notes",
      items: "Items",
      productCode: "Product code",
      productName: "Product",
      expectedQty: "Expected",
      receivedQty: "Received",
      difference: "Difference",
      ok: "OK",
      discrepancies: "Discrepancies",
      expected: "Expected",
      actual: "Actual",
      resolved: "Resolved",
      resolutionNotePlaceholder: "Resolution note...",
      resolveButton: "Resolve"
    },
    statusLabels: {
      draft: "Draft",
      inProgress: "In progress",
      discrepancy: "Discrepancy",
      completed: "Completed"
    },
    discrepancyTypes: {
      shortage: "Shortage",
      surplus: "Surplus",
      damaged: "Damaged",
      wrong_item: "Wrong item"
    },
    shipping: {
      title: "Shipping cost distribution",
      costLabel: "Shipping cost",
      costPlaceholder: "e.g. 15000",
      distribute: "Distribute",
      allocationTitle: "Shipping cost allocation",
      originalPrice: "Original unit price",
      proportion: "Proportion",
      allocation: "Shipping cost",
      adjustedPrice: "Adjusted unit price"
    },
    form: {
      title: "New goods receipt",
      linkAvizo: "Link to advice note",
      noAvizo: "No advice note",
      itemsLabel: "items",
      avizoHint: "Select a pending advice note to auto-fill the items",
      supplier: "Supplier",
      supplierPlaceholder: "Search supplier\u2026",
      notes: "Notes",
      notesPlaceholder: "Notes for the goods receipt\u2026",
      items: "Items",
      addItem: "Add item",
      productCode: "Product code",
      productCodePlaceholder: "e.g. 12345",
      productName: "Product name",
      productNamePlaceholder: "Product name",
      expectedQty: "Expected qty",
      receivedQty: "Received qty",
      unitPrice: "Unit price",
      purchaseCategory: "Purchase category",
      locationCode: "Location code",
      locationPlaceholder: "e.g. A-01-02",
      packageSplitting: "Package splitting",
      packageQty: "Package qty",
      unitsPerPackage: "Units per package",
      totalUnits: "Total units",
      categories: {
        aru: "Goods",
        beruhazas: "Investment",
        berendezes: "Equipment",
        egyeb: "Other",
        rezsi: "Overhead"
      }
    },
    allStatuses: "All statuses",
    hasDiscrepancy: "Has discrepancy",
    newReceipt: "New goods receipt",
    noAvizos: "No advice notes",
    noReceipts: "No goods receipts",
    searchPlaceholder: "Search by code, supplier\u2026",
    subtitle: "Manage incoming goods and advice notes",
    title: "Goods receipts",
    avizo: {
      expectedDate: "Expected date",
      itemCount: "Item count",
      notes: "Notes",
      startReceipt: "Start goods receipt",
      supplier: "Supplier"
    },
    stats: {
      completedThisMonth: "Completed (this month)",
      inProgress: "In progress",
      total: "Total",
      withDiscrepancy: "With discrepancy"
    },
    table: {
      discrepancy: "Discrepancy",
      itemCount: "Items",
      receiptNumber: "Receipt no.",
      receivedDate: "Received date",
      supplier: "Supplier"
    },
    tabs: {
      avizos: "Advice notes",
      receipts: "Goods receipts"
    }
  },
  packages: {
    title: "Packages",
    subtitle: "Manage product and service bundles",
    createNew: "New package",
    editPackage: "Edit package",
    editor: {
      sharedBanner: "This package is shared with {count} machines. Changes affect all of them.",
      conflictTitle: "Package shared",
      conflictSubtext: "Changes affect every machine. How would you like to proceed?",
      conflictApplyAll: "Apply to all",
      conflictApplyAllDesc: "The master package is updated. Every linked machine sees the new version.",
      conflictCopyForThis: "Only this one",
      conflictCopyForThisDesc: "A new variant package is created for the selected machine. Other machines keep the unchanged master. Note: your current edits are NOT carried over to the variant \u2014 re-edit it there.",
      conflictForking: "Creating variant...",
      conflictCopyTargetPlaceholder: "Select a machine...",
      conflictCopyTargetAriaLabel: "Target machine for the fork"
    },
    editorSubtitle: "Assemble package and configure pricing",
    packageCode: "Package code",
    packageCodePlaceholder: "e.g. PKG-001",
    packageName: "Package name",
    packageNamePlaceholder: "e.g. Basic rental package",
    noPackages: "No packages",
    searchPlaceholder: "Search by name or code...",
    displayedCount: "{count} packages displayed",
    copy: "Copy",
    basicInfo: "Basic info",
    scopeLabel: "Scope",
    descriptionPlaceholder: "Package description...",
    packageItems: "Package items",
    noItems: "No items yet. Search for products in the right panel.",
    moveUp: "Move up",
    moveDown: "Move down",
    productSearch: "Product search",
    searchProductPlaceholder: "Search by product name or SKU...",
    noSearchResults: "No results",
    alreadyAdded: "Added",
    pricing: "Pricing",
    pricingModelLabel: "Pricing model",
    fixedPriceLabel: "Fixed price",
    discountPercentLabel: "Discount (%)",
    validFrom: "Valid from",
    validUntil: "Valid until",
    calculator: "Calculator",
    itemsTotal: "Items total",
    packagePriceLabel: "Package price",
    savingsLabel: "Savings",
    itemCount: "{count} items",
    expired: "Expired",
    daysLeft: "{count} days left",
    type: {
      rental: "Rental",
      sales: "Sales",
      service: "Service",
      mixed: "Mixed",
      promotional: "Promotional",
      franchise: "Franchise"
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      draft: "Draft"
    },
    pricingModel: {
      fixed: "Fixed price",
      discounted: "Discounted",
      tiered: "Tiered"
    },
    scopeValue: {
      central: "Central",
      local: "Local"
    },
    itemType: {
      product: "Product",
      service: "Service",
      rental_equipment: "Rental equipment"
    },
    upsell: {
      banner: "Did you know?",
      cheaperBy: "is {percent}% cheaper in a package!",
      contents: "Package contents",
      individually: "Individually",
      inPackage: "In package",
      perDay: "/day",
      choosePackage: "Choose package",
      keepIndividual: "Keep individual selection",
      savings: "savings",
      savingsPercent: "{percent}% savings"
    },
    linkedCategories: "Linked equipment categories",
    linkedCategoriesDesc: "Which equipment types should suggest this package",
    scope: {
      sectionTitle: "Package scope",
      mode: {
        category: "By category",
        equipment: "Specific equipment"
      },
      switchConfirmTitle: "Switch mode?",
      switchConfirmBody: "The currently selected {count} item(s) will be lost if you switch.",
      switchConfirmOk: "Yes, switch",
      switchConfirmCancel: "Cancel",
      equipment: {
        selectedTitle: "Selected equipment ({count})",
        selectedEmpty: "No equipment selected yet",
        searchTitle: "Equipment search",
        searchPlaceholder: "Name or SKU...",
        searchEmpty: "No results",
        alreadyAdded: "Already added",
        add: "Add",
        remove: "Remove"
      },
      validationError: {
        categoryRequired: "At least 1 category required",
        equipmentRequired: "At least 1 equipment required"
      }
    },
    productDetail: {
      linkedPackagesTitle: "This equipment appears in the following packages:"
    },
    item: {
      category: "Category",
      categoryOption: {
        free: "Free",
        rentable: "Rentable",
        consignment: "Consignment"
      },
      defaultQuantity: "Default qty",
      isQuantityEditable: "Qty editable",
      visibleOnWebshop: "Visible on webshop"
    }
  },
  manufacturing: {
    title: "Manufacturing",
    bom: {
      title: "Bill of Materials (BOM)",
      subtitle: "Manage and edit bills of materials",
      bomCode: "BOM Code",
      createNew: "New BOM",
      editBom: "Edit BOM",
      editorSubtitle: "Compose bill of materials and manage components",
      basicInfo: "Basic Information",
      outputProduct: "Output Product",
      outputQuantity: "Output Quantity",
      searchOutputProduct: "Search output product...",
      descriptionPlaceholder: "BOM description...",
      validFrom: "Valid From",
      validUntil: "Valid Until",
      components: "Components",
      noLines: "No components yet. Search and add from the right panel.",
      addComponent: "Add Component",
      searchComponentPlaceholder: "Search product (name, SKU)...",
      noSearchResults: "No results found",
      alreadyAdded: "Already added",
      lineCount: "{count} components",
      displayedCount: "{count} BOMs displayed",
      noBoms: "No bills of materials found",
      searchPlaceholder: "Search by code or description...",
      optional: "Optional",
      required: "Required",
      toggleOptional: "Toggle optional/required",
      moveUp: "Move up",
      moveDown: "Move down"
    },
    productionOrder: {
      title: "Production Orders",
      subtitle: "Manage and track production orders",
      orderNumber: "Order Number",
      createNew: "New Production Order",
      product: "Product",
      planned: "Planned",
      actual: "Actual",
      plannedQty: "Planned Quantity",
      actualQty: "Actual Quantity",
      plannedStart: "Planned Start",
      plannedEnd: "Planned End",
      progress: "Progress",
      phases: "Phases",
      phasesCompleted: "phases completed",
      plan: "Plan",
      startProduction: "Start Production",
      complete: "Complete",
      startPhase: "Start Phase",
      completePhase: "Complete Phase",
      recordScrap: "Record Scrap",
      confirmScrap: "Confirm Scrap",
      scrapReason: "Scrap Reason",
      scrapReasonPlaceholder: "What caused the scrap?",
      scrap: "Scrap",
      started: "Started",
      completed: "Completed",
      duration: "Duration",
      noOrders: "No production orders found",
      searchPlaceholder: "Search by order number...",
      displayedCount: "{count} orders displayed",
      notFound: "Production order not found"
    },
    phase: {
      preparation: "Preparation",
      manufacturing: "Manufacturing",
      qc: "Quality Control",
      receipt: "Receipt"
    },
    phaseStatus: {
      pending: "Pending",
      in_progress: "In Progress",
      completed: "Completed",
      skipped: "Skipped"
    },
    lotBatch: {
      title: "Lot/Batch",
      lotNumber: "Lot Number",
      qualityStatus: "Quality Status",
      producedAt: "Produced At",
      noLots: "No recorded lots"
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      draft: "Draft",
      planned: "Planned",
      in_progress: "In Progress",
      completed: "Completed",
      cancelled: "Cancelled"
    },
    bomType: {
      assembly: "Assembly",
      kit: "Kit/Bundle",
      refurbishment: "Refurbishment",
      custom: "Custom"
    },
    qualityStatus: {
      pending: "Pending",
      passed: "Passed",
      failed: "Failed",
      partial: "Partially Passed"
    },
    refurbishment: {
      title: "Refurbishment",
      start: "Start Refurbishment",
      complete: "Complete Refurbishment",
      approve: "Approve",
      reject: "Reject",
      history: "Refurbishment History",
      sourceWorksheet: "Source Worksheet",
      sourceEquipment: "Source Equipment",
      outputProduct: "Output Product",
      outputSku: "Output SKU",
      qualityCheck: "Quality Check",
      approved: "Approved \u2014 new product created",
      rejected: "Rejected \u2014 scrap recorded",
      noHistory: "No refurbishment history"
    }
  },
  consignment: {
    dashboard: {
      title: "Consignment Summary",
      outstandingValue: "Outstanding value",
      partnerCount: "Number of partners",
      oldest: "Oldest",
      daysAgo: "{days} days ago",
      overdueWarning: "Over 30 days",
      overduePartners: "{count} partner(s)",
      overdueRentals: "{count} rental(s)",
      noActive: "No active consignments"
    }
  },
  helpdesk: {
    screenLabel: "Screen / Menu item",
    screenPlaceholder: "E.g.: Rental > Active rentals > Return",
    bugDescLabel: "Bug description",
    featureDescLabel: "Feature description",
    questionDescLabel: "Your question",
    guidedActionFieldLabel: "What I did:",
    guidedActionPrefix: "What I did: ",
    actionPlaceholder: "E.g.: I clicked the Save button",
    guidedResultFieldLabel: "What happened:",
    guidedResultPrefix: "What happened: ",
    resultPlaceholder: "E.g.: An error message appeared",
    guidedExpectedFieldLabel: "What should have happened:",
    guidedExpectedPrefix: "What should have happened: ",
    expectedPlaceholder: "E.g.: The data should have been saved",
    freeTextModeBtn: "Free text mode \u2192",
    bugPlaceholder: "What did you do? What happened? What should have happened?",
    featurePlaceholder: "What do you need? How should it work?",
    questionPlaceholder: "Describe your question...",
    guidedModeBtn: "\u2190 Guided mode (helps with description)",
    duplicateWarningTitle: "\u26A0 A similar report already exists:",
    reasonLabel: "Why is it important?",
    reasonPlaceholder: "E.g.: Needed for monthly closing, currently done manually",
    screenshotLabel: "Screenshot(s)",
    tabNewReport: "New report",
    tabMyReports: "My reports",
    reporterLabel: "Who is reporting?",
    moduleLabel: "Module",
    selectPlaceholder: "\u2014 Select \u2014",
    severityLabel: "Severity",
    priorityLabel: "Priority",
    clearDescriptionBtn: "\u2715 Clear",
    clearDescriptionTitle: "Clear description",
    screenshotMax: "\u2014 max {max}",
    screenshotPasteHint: "to paste a screenshot here",
    screenshotClickHint: "or click / drag the image here",
    screenshotCount: "{count} / {max} images",
    autoCaptureTitle: "\u26A0 Automatically collected data",
    attachConsoleErrors: "Attach {count} console errors",
    attachFailedApis: "Attach {count} failed API calls",
    submitting: "Sending...",
    submit: "Submit",
    resetFormTitle: "Clear form",
    openSpreadsheet: "Open the helpdesk spreadsheet in Google Sheets \u2192",
    loading: "Loading...",
    noTickets: "You have no reports yet.",
    selectReporterFirst: 'First select your name on the "New report" tab!',
    successTitle: "Thank you!",
    successMessage: "The report has been saved.",
    openInSpreadsheet: "Open in the spreadsheet \u2192",
    fabTooltip: "Helpdesk (Ctrl+Shift+H)",
    alertMissingFields: "Please fill in the required fields! (Reporter, Module, Description)",
    alertMissingSeverity: "Please select the severity!",
    alertSubmitError: "An error occurred: {error}",
    unknownError: "Unknown error",
    type: {
      bug: "Bug",
      feature: "Feature",
      question: "Question"
    }
  },
  pri: {
    inputPlaceholder: "Ask anything...",
    sendLabel: "Send",
    welcome: {
      greeting: "Hi! I'm pRI, your digital colleague.",
      subtitle: "How can I help?",
      howToFallback: "How do I do this?",
      whatIsFallback: "What is this page?",
      expiringRentalsLabel: "Expiring rentals",
      expiringRentalsMessage: "Show the expiring rentals!",
      openWorksheetsLabel: "Open worksheets",
      openWorksheetsMessage: "Show the open worksheets!"
    }
  },
  priceInput: {
    netLabel: "Net",
    grossLabel: "Gross",
    vatRate: "VAT"
  },
  email: {
    templates: "Email Templates",
    templateList: "Template list",
    editTemplate: "Edit template",
    selectTemplate: "Select a template from the list",
    subject: "Subject",
    greeting: "Greeting",
    body: "Body",
    cta: "CTA button",
    ctaUrl: "CTA URL",
    insertVariable: "Insert variable",
    save: "Save",
    saving: "Saving...",
    default: "Default",
    customized: "Customized",
    active: "Active",
    inactive: "Inactive",
    locked: "Locked",
    editable: "Editable",
    missingVariables: "Missing required variables",
    saveSuccess: "Template saved",
    version: "Version",
    lastUpdated: "Last updated",
    source: "Source",
    preview: "Preview",
    desktopPreview: "Desktop view",
    mobilePreview: "Mobile view",
    sendTestEmail: "Send test email",
    testEmailSent: "Test email sent",
    testEmailAddress: "Target email address",
    resetToDefault: "Reset to default",
    resetConfirm: "Are you sure you want to reset to the default template?",
    resetSuccess: "Template reset",
    smtpSettings: "SMTP Settings",
    smtpHost: "SMTP server",
    smtpPort: "Port",
    smtpUser: "Username",
    smtpPass: "Password",
    senderEmail: "Sender email",
    senderName: "Sender name",
    dailyLimit: "Daily limit",
    testConnection: "Test connection",
    connectionOk: "Connection OK",
    connectionFailed: "Connection failed",
    emailLogs: "Send log",
    recipientEmail: "Recipient",
    status: "Status",
    sentAt: "Sent at",
    resend: "Resend",
    resendConfirm: "Are you sure you want to resend this email?",
    resendSuccess: "Email resent",
    filterByStatus: "Filter by status",
    filterByTemplate: "Filter by template",
    todayStats: "Today's stats",
    bulkSend: {
      title: "Bulk Email Send",
      settings: "Send Settings",
      template: "Email Template",
      templatePlaceholder: "Select a template...",
      language: "Language",
      partnerPlaceholder: "Partner selection \u2014 coming soon. Currently sends to all active partners.",
      variables: "Variables",
      addVariable: "Add Variable",
      variableKey: "Variable name",
      variableValue: "Value",
      send: "Start Sending",
      sending: "Sending...",
      results: "Results",
      queued: "Queued",
      skipped: "Skipped",
      failed: "Failed",
      success: "Bulk send started!",
      errorNoTemplate: "Please select a template!",
      errorSend: "Error sending emails.",
      filters: {
        title: "Partner filter",
        search: "Search by name / email / partner code",
        segmentLabel: "Segment",
        segment: {
          vip: "VIP",
          active: "Regular",
          atRisk: "At risk",
          inactive: "Inactive"
        },
        hasActiveRentalLabel: "Active rental",
        hasActiveRental: {
          any: "No filter",
          yes: "Has rental",
          no: "None",
          expiring7d: "Expiring in 7 days"
        },
        lastPurchaseDaysLabel: "Last purchase",
        lastPurchase: {
          "30": "Within 30 days",
          "60": "Within 60 days",
          any: "No filter",
          "90plus": "90+ days ago"
        },
        hasOutstandingLabel: "Outstanding balance",
        hasOutstanding: {
          any: "No filter",
          yes: "Yes",
          no: "No"
        },
        hasEmailOnly: "With email only",
        marketingConsentOnly: "With marketing consent only",
        resetFilters: "Reset filters",
        filteredCount: "Filtered partners ({count})",
        selectedCount: "{count} / {max} partners selected",
        selectAll: "Select all",
        clearSelection: "Clear selection",
        maxLimitWarning: "More than {max} partners match \u2014 narrow the filter",
        maxSelectionReached: "Maximum 500 partners per send (NFR1)",
        unsubscribedTooltip: "Unsubscribed partner \u2014 cannot send",
        loadMore: "Load more",
        loading: "Loading\u2026",
        emptyState: "No partners match the filter",
        sendWithCount: "Send ({count} partners)",
        columns: {
          name: "Name",
          email: "Email",
          segment: "Segment",
          flags: "Flags"
        },
        flagMarketingConsent: "Marketing consent",
        flagUnsubscribed: "Unsubscribed",
        flagOutstanding: "Outstanding balance"
      },
      errorNoRecipients: "No recipients selected",
      confirmModal: {
        title: "Confirm: {count} partners",
        description: "Large campaign \u2014 type the exact recipient count to prevent accidental sends.",
        hint: "Enter: {count}",
        inputLabel: "Recipient count",
        inputPlaceholder: "Numeric",
        mismatchTooltip: "Type the exact number",
        confirmButton: "Confirm send",
        cancelButton: "Cancel"
      },
      legalBasis: {
        TRANSACTIONAL: "Transactional",
        MARKETING_CONSENT: "Marketing consent",
        LEGITIMATE_INTEREST: "Legitimate interest",
        unknown: "Unknown template",
        marketingWarning: "Marketing template \u2014 only partners with explicit opt-in (marketingConsent=true) will receive this."
      },
      skipReason: {
        no_email: "No email",
        not_found: "Not found",
        unsubscribed: "Unsubscribed",
        no_consent: "No consent"
      },
      skipBreakdown: "Skip reason breakdown",
      sendDynamic: "Send {template} to {count} partners",
      preview: {
        openButton: "Preview",
        title: "Template preview",
        subtitle: "{slug} ({language})",
        noTemplate: "Select a template to preview.",
        loading: "Loading preview\u2026",
        error: "Error",
        subjectLabel: "Subject",
        iframeTitle: "Email template preview",
        sampleDataLabel: "Sample variables",
        closeButton: "Close"
      },
      undo: {
        toastTitle: "Sending in {seconds} seconds\u2026",
        toastBody: "{count} partners",
        undoButton: "Undo",
        undoneToast: "Send cancelled",
        sendingNow: "Sending now\u2026"
      },
      draft: {
        restoreTitle: "Saved draft found",
        restoreSubtitle: "Saved at: {savedAt}",
        restoreButton: "Restore",
        dismissButton: "Dismiss"
      },
      stats: {
        totalBatches: "Campaigns",
        activeCampaigns: "Active",
        completedToday: "Completed today",
        successRate: "Delivery rate",
        windowHint: "Last {days} days",
        activeHint: "Running / scheduled",
        completedHint: "Closed today",
        successHint: "of {recipients} recipients"
      },
      allFailed: "All sends failed",
      asyncInfo: "Sending happens in the background; the status will update",
      description: "Send email to the selected partners",
      error: "Error while sending",
      moreRecipients: "more",
      noEmailWarning: "Some selected partners have no email address",
      partialSuccess: "{queued} emails sent, {skipped} skipped",
      partnersSelected: "partners selected",
      recipients: "Recipients",
      selectLanguage: "Select language",
      selectTemplate: "Select template",
      sendButton: "Send",
      sendEmail: "Send email",
      successAll: "{count} emails queued for sending"
    },
    template: {
      invoiceSent: "Invoice Sent",
      invoiceOverdue: "Invoice Overdue Reminder",
      rentalConfirmation: "Rental Confirmation",
      rentalOverdue: "Rental Overdue Notice",
      rentalDepositWarning: "Deposit Warning",
      worksheetCreated: "Worksheet Created",
      worksheetReady: "Worksheet Ready",
      quoteSent: "Quote Sent",
      welcomePartner: "Welcome Email",
      paymentReceived: "Payment Received"
    },
    selectPartners: "Select partners",
    bulkResult: "Send Result",
    queued: "Queued",
    skipped: "Skipped",
    failedCount: "Failed",
    scheduled: {
      title: "Scheduled sends",
      sectionAriaLabel: "Scheduled bulk email batches list",
      loading: "Loading...",
      empty: "No scheduled sends right now.",
      error: "Failed to load list: {message}",
      skippedSuffix: "{count} skipped",
      cancelButton: "Cancel",
      cancelling: "Cancelling...",
      col: {
        template: "Template",
        scheduledAt: "When",
        recipients: "Recipients",
        status: "Status",
        legalBasis: "GDPR basis",
        actions: "Actions"
      },
      cancelModal: {
        title: "Cancel scheduled send",
        description: "Cancel the {templateSlug} send to {count} recipients? This cannot be undone, but you can re-send manually.",
        confirmButton: "Cancel send",
        dismissButton: "Keep scheduled"
      },
      cancelToast: {
        success: "Scheduled send cancelled.",
        alreadyCancelled: "This send was already cancelled.",
        notCancellable: "The send is in {status} state \u2014 cannot be cancelled.",
        race: "The send just started dispatching \u2014 too late to cancel.",
        notFound: "Send not found.",
        error: "Error cancelling send."
      }
    }
  },
  documents: {
    panel: {
      title: "Documents",
      uploadButton: "Upload",
      downloadButton: "Download",
      deleteButton: "Delete",
      deleteConfirm: "Are you sure you want to delete this document?",
      deleteConfirmButton: "Confirm delete",
      deleteCancel: "Cancel",
      uploadSuccess: "Document uploaded successfully.",
      deleteSuccess: "Document deleted.",
      loading: "Loading documents\u2026",
      empty: "No documents attached.",
      retry: "Retry"
    },
    errors: {
      loadFailed: "Failed to load documents.",
      uploadFailed: "Upload failed: {message}",
      downloadFailed: "Download failed: {message}",
      deleteFailed: "Delete failed: {message}"
    },
    audit: {
      backToAdmin: "Back to admin",
      title: "Document Audit Log",
      subtitle: "Per-operation audit trail for GDPR Art. 30 compliance.",
      filters: "Filters",
      filterAction: "Action",
      filterDocumentId: "Document ID",
      invalidUuid: "Invalid UUID format",
      allActions: "All actions",
      pageSize: "Rows per page",
      clearFilters: "Clear filters",
      refresh: "Refresh",
      exportCsv: "Export CSV",
      exportSuccess: "CSV export ready.",
      loading: "Loading audit log\u2026",
      loadError: "Failed to load audit log.",
      retry: "Retry",
      empty: "No entries match the current filters.",
      previousPage: "Previous",
      nextPage: "Next",
      pageInfo: "Page {page} of {totalPages} \xB7 {total} total rows",
      col: {
        performedAt: "Time",
        action: "Action",
        documentId: "Document",
        performedBy: "User",
        ipAddress: "IP address",
        metadata: "Metadata"
      },
      action: {
        UPLOADED: "Uploaded",
        DOWNLOADED: "Downloaded",
        VIEWED: "Viewed",
        SHARED_VIA_LINK: "Link shared",
        UPDATED: "Updated",
        DELETED: "Deleted",
        RESTORED: "Restored",
        HASH_VERIFIED: "Hash verified",
        HASH_MISMATCH: "Hash mismatch",
        ORPHAN_DETECTED: "Orphan detected"
      }
    }
  },
  esign: {
    error: {
      sessionNotFound: "E-sign session not found.",
      sessionExpired: "E-sign session has expired.",
      alreadySigned: "E-sign session is already signed.",
      invalidProvider: "Invalid e-sign provider.",
      consentNotGiven: "Consent was not given.",
      hashMismatch: "Signature hash verification failed \u2014 content may have been tampered with.",
      tenantMismatch: "E-sign session not found.",
      internalError: "Internal error processing the signature.",
      missingConsentBasic: "Basic consent is missing.",
      missingConsentDataProcessing: "Data processing consent is missing."
    },
    warning: {
      aesRequired: "For deposits above 500,000 HUF, a qualified (AES) signature is recommended \u2014 simple (SES) signatures remain accepted during Sprint 2.",
      sessionExpiresSoon: "The signing session will expire soon."
    },
    verify: {
      passed: "Signature successfully verified.",
      hashChainBroken: "Signature chain integrity is compromised.",
      evidenceHashMismatch: "Evidence hash does not match the stored value.",
      sessionTerminal: "Session is in a terminal state (expired or revoked)."
    },
    action: {
      createSession: "Start signing",
      sign: "Sign",
      verify: "Verify",
      viewAudit: "View audit log"
    },
    consent: {
      basicLabel: "I have read and accept the contract terms.",
      dataProcessingLabel: "I consent to the processing of my personal data for signing purposes."
    },
    dialog: {
      title: "Sign contract",
      success: "The contract was signed successfully.",
      sessionLoading: "Preparing signing session\u2026",
      padHint: "Sign with your finger or a stylus in the field",
      payloadTooLarge: "The signature is too large (max 512 KiB). Please clear and sign again.",
      consentRequired: "Both consents are required."
    }
  },
  hr: {
    employee: {
      title: "Employees",
      create: "New Employee",
      name: "Name",
      email: "Email",
      tajNumber: "Social Security Number",
      taxId: "Tax ID",
      bankAccount: "Bank Account",
      grossSalary: "Gross Salary",
      employmentType: "Employment Type",
      salaryType: "Salary Type",
      weeklyHours: "Weekly Hours",
      contractStart: "Contract Start",
      contractEnd: "Contract End",
      childrenCount: "Number of Children",
      disabledChildrenCount: "Disabled Children",
      familyTaxCredit: "Family Tax Credit",
      familyCreditChildCount: "Credited Children Count",
      isFirstMarriage: "First Marriage",
      userId: "User ID",
      basicInfo: "Basic Information",
      taxAndBankInfo: "Tax & Bank Info",
      familyData: "Family Data",
      noEmployees: "No employees to display",
      created: "Employee created",
      updated: "Employee updated",
      saveError: "Save failed",
      employmentTypes: {
        fulltime: "Full Time",
        parttime: "Part Time",
        seasonal: "Seasonal"
      },
      salaryTypes: {
        monthly: "Monthly",
        hourly: "Hourly"
      },
      panelBasic: "Basic info",
      panelEmployment: "Employment",
      panelPayroll: "Payroll",
      panelFamily: "Family",
      panelInvalid: "Missing or invalid field",
      validationError: "Please fill all required fields",
      completionLabel: "{percent}% filled",
      missingLabel: "Missing",
      miniCardAttendance: "Attendance {year}-{month}",
      miniCardLeaveBalance: "Leave {year}",
      miniCardRecentRecords: "Recent attendance",
      noAttendanceData: "No attendance data this month",
      noLeaveBalance: "Leave balance not initialized",
      noRecentRecords: "No recent attendance",
      missingDays: "Missing",
      viewFullAttendance: "Full view",
      viewLeaveHistory: "Leave history"
    },
    attendance: {
      title: "Attendance",
      clockIn: "Clock In",
      clockOut: "Clock Out",
      currentlyClockedIn: "Currently clocked in",
      currentlyClockedOut: "Currently clocked out",
      monthlyView: "Monthly View",
      workedDays: "Days Worked",
      overtimeHours: "Overtime",
      clockedInSuccess: "Successfully clocked in",
      clockedOutSuccess: "Successfully clocked out",
      clockInError: "Clock in failed",
      clockOutError: "Clock out failed",
      overtimeActive: "Overtime active",
      forgottenClockOut: "Forgotten clock-out",
      forgottenClockOutBanner: "Looks like you forgot to clock out yesterday.",
      forgottenClockOutHint: "Please clock out or ask your manager for a correction.",
      startedAt: "In",
      endedAt: "Out",
      todayWorkedLabel: "Today",
      weeklyProgress: "Weekly hours",
      filterEmployee: "By employee",
      allEmployees: "All employees",
      hideWeekend: "Hide weekend",
      hideHoliday: "Hide holiday",
      exportCsv: "CSV export",
      summaryLabel: "Total",
      summaryWorkedDays: "{count} working days",
      summaryOvertime: "{duration} overtime",
      summaryHolidays: "{count} holidays",
      summaryMissing: "{count} missing",
      noRecord: "No attendance record",
      breakMinutesLabel: "Break",
      overtimeLabel: "Overtime",
      holidayLabel: "Holiday",
      weekendLabel: "Weekend",
      sourceLabel: "Source",
      noteLabel: "Note"
    },
    leave: {
      title: "Leave",
      request: "New Request",
      myRequests: "My Requests",
      type: "Type",
      startDate: "Start Date",
      endDate: "End Date",
      reason: "Reason",
      reasonPlaceholder: "Optional comment...",
      balance: "Balance",
      remaining: "Remaining",
      used: "Used",
      entitled: "Entitled",
      calendar: "Calendar",
      approve: "Approve",
      reject: "Reject",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      cancelled: "Cancelled",
      noRequests: "No leave requests",
      workingDays: "working days",
      requestSubmitted: "Leave request submitted",
      requestError: "Request submission failed",
      missingFields: "Please fill in all required fields",
      invalidDateRange: "End date cannot be before start date",
      selectType: "Select type",
      types: {
        annual: "Annual Leave",
        sickSelf: "Sick Leave (Self)",
        sickChild: "Sick Leave (Child)",
        unpaid: "Unpaid Leave",
        maternity: "Maternity Leave",
        paternity: "Paternity Leave",
        bereavement: "Bereavement Leave",
        bloodDonation: "Blood Donation Leave"
      },
      datePreset: "Quick date",
      workingDaysPreview: "{count} working days (weekends excluded)",
      quotaLabel: "remaining {remaining} / {entitled} days",
      overlapError: "You already have a leave request for this period",
      insufficientBalance: "Insufficient leave balance for this request",
      chip: {
        tomorrow: "Tomorrow",
        nextMonday: "Next Monday",
        oneWeek: "Next Mon-Fri",
        custom: "Custom"
      },
      filterByType: "By type",
      filterByEmployee: "By employee",
      allTypes: "All types",
      allEmployees: "All employees",
      onlyPending: "Only pending",
      conflictWarning: "Two approved leaves conflict",
      approveError: "Approval failed",
      rejectError: "Rejection failed"
    },
    shift: {
      title: "Shifts",
      name: "Name",
      startTime: "Start Time",
      endTime: "End Time",
      breakMinutes: "Break (minutes)",
      isNightShift: "Night Shift"
    }
  },
  payroll: {
    config: {
      title: "Payroll configuration",
      taxRates: "Tax rates",
      shifts: "Shift patterns",
      rate: "Rate",
      description: "Description",
      validFrom: "Valid from",
      validTo: "Valid until",
      save: "Save",
      delete: "Delete",
      addNew: "Add new",
      year: "Year",
      deleteConfirm: "Are you sure you want to delete this tax rate?",
      loadError: "Error while loading.",
      noRatesForYear: "No tax rates for this year. Run a seed on the /api/v1/payroll/seed endpoint.",
      taxType: "Tax type",
      month: "Month",
      subtitle: "Manage tax rates and shift patterns",
      saveError: "Failed to save the tax rate.",
      deleteError: "Failed to delete the tax rate."
    },
    runs: {
      title: "Payroll runs",
      detail: "Run details",
      newRun: "New run",
      period: "Period",
      status: "Status",
      employeeCount: "Employees",
      totalGross: "Total gross",
      totalNet: "Total net",
      totalEmployerCost: "Employer cost"
    },
    status: {
      DRAFT: "Draft",
      CALCULATED: "Calculated",
      BOLT_APPROVED: "Shop approved",
      CENTRAL_REVIEWED: "Central reviewed",
      FINALIZED: "Finalized"
    },
    steps: {
      draft: "Draft",
      calculated: "Calculated",
      boltApproved: "Shop approved",
      centralReviewed: "Central review",
      finalized: "Finalized"
    },
    actions: {
      calculate: "Calculate",
      boltApprove: "Shop approve",
      centralReview: "Central review",
      finalize: "Finalize",
      exportCsv: "Export CSV",
      exportExcel: "Export Excel",
      calculateError: "Payroll calculation failed.",
      approveError: "Approval failed."
    },
    payslip: {
      myTitle: "My payslips",
      period: "Period",
      gross: "Gross",
      net: "Net",
      downloadPdf: "Download PDF",
      empty: "No payslips found for the selected year.",
      taxId: "Tax ID",
      tajNumber: "Social security number",
      bankAccount: "Bank account",
      employmentType: "Employment type",
      weeklyHours: "Weekly hours",
      grossSalary: "Gross base salary"
    },
    employmentTypes: {
      FULL_TIME: "Full-time",
      PART_TIME: "Part-time",
      SEASONAL: "Seasonal"
    },
    items: {
      tableTitle: "Payroll items",
      employee: "Employee",
      workingDays: "Working days",
      workedDays: "Worked",
      leaveDays: "Leave",
      sickDays: "Sick days",
      overtimeHours: "Overtime (hrs)",
      baseSalary: "Base salary",
      totalGross: "Gross",
      totalNet: "Net",
      empty: "No items in this run."
    },
    dashboard: {
      title: "Payroll overview",
      latestGross: "Latest gross",
      latestNet: "Latest net",
      employerCost: "Employer cost",
      employees: "Employees",
      trend: "12-month trend",
      noData: "No data available for trend"
    },
    shift: {
      editHint: "Shift patterns are managed in the HR admin interface.",
      loadError: "Error loading shift patterns.",
      empty: "No shift patterns.",
      nameHeader: "Name",
      startHeader: "Start",
      endHeader: "End",
      breakHeader: "Break (min)",
      night: "Night"
    }
  },
  porter: {
    inbox: {
      title: "Inbox",
      searchPlaceholder: "Search conversations...",
      filters: "Filters",
      statusLabel: "Status",
      channelLabel: "Channel",
      assigneeLabel: "Assignee",
      loading: "Refreshing...",
      noSubject: "(no subject)",
      threadCount: "Inbox ({count})",
      pollingHint: "Auto-refresh every 5 seconds",
      filter: {
        status: {
          all: "All statuses",
          OPEN: "Open",
          PENDING: "Pending",
          RESOLVED: "Resolved",
          SNOOZED: "Snoozed"
        },
        channel: {
          all: "All channels",
          EMAIL: "Email",
          WEBCHAT: "Webchat",
          CONTACT_FORM: "Form"
        },
        assignee: {
          all: "All",
          me: "Mine",
          unassigned: "Unassigned"
        }
      },
      empty: {
        title: "No messages yet",
        description: "Connect your Gmail account and the webchat widget \u2014 the first message arrives within 2 minutes.",
        ctaSetup: "Set up a channel",
        ctaDemo: "Take the demo tour"
      },
      filteredEmpty: {
        title: "No threads match these filters",
        description: "Try loosening the filters."
      },
      error: {
        title: "Failed to load messages",
        description: "Network error or server unreachable. Please retry.",
        retry: "Retry"
      },
      previewHint: {
        title: "Select a conversation",
        description: "Click an item on the left to view the conversation and reply."
      },
      relativeTime: {
        now: "now",
        minutes: "{count}m ago",
        hours: "{count}h ago",
        days: "{count}d ago"
      },
      sla: {
        OK: "OK",
        DUE_SOON: "Due soon",
        BREACHED: "Breached",
        ESCALATED: "Escalated"
      },
      unread: "Unread"
    },
    thread: {
      subject: "Subject",
      back: "Back",
      inboxLink: "Inbox",
      loading: "Loading...",
      channel: {
        EMAIL: "Email",
        WEBCHAT: "Webchat",
        CONTACT_FORM: "Form"
      },
      status: {
        label: "Status",
        OPEN: "Open",
        PENDING: "Pending",
        RESOLVED: "Resolved",
        SNOOZED: "Snoozed"
      },
      assignee: {
        label: "Assignee",
        unassigned: "Unassigned"
      },
      partner: {
        label: "Customer",
        unknown: "Unknown contact",
        createCta: "+ Create partner",
        timeline: "All conversations"
      },
      message: {
        pending: "sending...",
        failed: "send failed",
        retry: "Retry",
        expand: "Show full message",
        collapse: "Collapse",
        attachmentUnavailable: "Attachment expired, refreshing..."
      },
      composer: {
        placeholder: "Write a reply...",
        send: "Send",
        sending: "Sending..."
      },
      error: {
        loadFail: "Failed to load the conversation",
        retry: "Try again"
      }
    },
    settings: {
      channels: {
        title: "Channels",
        subtitle: "Configure how rPI Porter receives messages from your customers.",
        copy: "Copy",
        copySuccess: "Copied!",
        notConfigured: {
          title: "No channels connected yet",
          description: "A Chatwoot account configuration is required as a first step. Please contact your admin."
        },
        list: {
          title: "Active channels",
          EMAIL: {
            name: "Email",
            description: "Gmail IMAP/SMTP connection"
          },
          WEBCHAT: {
            name: "Webchat widget",
            description: "Embeddable snippet for your website"
          },
          CONTACT_FORM: {
            name: "Contact form",
            description: "Public form with hCaptcha protection"
          },
          configured: "Connected",
          notConfigured: "Not connected",
          setupCta: "Connect"
        },
        webchat: {
          title: "Webchat embed snippet",
          description: "Paste this at the end of your website <body>. The widget appears automatically."
        },
        form: {
          title: "Public form URL",
          description: "Share this URL on your website or in campaigns."
        },
        error: {
          loadFail: "Failed to load the channel configuration",
          retry: "Try again"
        }
      },
      webchat: {
        form: {
          replyTimeOptions: {
            in_a_few_minutes: "In a few minutes",
            in_a_few_hours: "In a few hours",
            in_a_day: "In a day"
          }
        }
      },
      autoReply: {
        title: "Auto-reply rules",
        subtitle: "Send automated messages when specific conditions are met.",
        addRule: "Add rule",
        editRule: "Edit rule",
        deleteRule: "Delete",
        confirmDelete: "Are you sure you want to delete this rule?",
        noRules: "No auto-reply rules configured.",
        active: "Active",
        inactive: "Inactive",
        trigger: {
          label: "Trigger",
          NEW_CONVERSATION: "New conversation",
          OFF_HOURS: "Off-hours",
          KEYWORD: "Keyword",
          NO_RESPONSE_TIMER: "No response timer",
          CHANNEL_SPECIFIC: "Channel-specific"
        },
        form: {
          name: "Rule name",
          namePlaceholder: "e.g. After hours message",
          templateId: "Template ID",
          templateIdPlaceholder: "E-93 email template ID",
          conditionJson: "Condition (JSON)",
          save: "Save",
          cancel: "Cancel"
        },
        save: "Save",
        cancel: "Cancel"
      }
    },
    timeline: {
      title: "All conversations",
      subtitle: "All support threads for this partner in chronological order.",
      empty: "No previous conversations with this partner.",
      lastMessage: "Last message",
      noMessages: "No messages",
      openThread: "Open",
      loading: "Loading...",
      error: "Failed to load conversations."
    }
  },
  authGrant: {
    type: {
      permanent: "Permanent",
      oneTime: "One-time"
    },
    badge: {
      permanentActive: "Active",
      oneTimeUntilRental: "Until rental"
    },
    card: {
      revoke: "Revoke",
      validFrom: "Starts",
      validUntil: "Expires",
      valueLimit: "Value limit",
      rental: "Rental",
      revokedReason: "Revoked"
    },
    tab: {
      title: "Authorizations",
      subtitle: "Permanent and one-time partner authorizations",
      createButton: "New authorization",
      givenTitle: "Given authorizations",
      givenEmpty: "This partner has not given any authorizations yet.",
      receivedTitle: "Received authorizations",
      receivedEmpty: "This partner has not received any authorizations yet.",
      archivedToggle: "{count} archived authorization(s)"
    },
    chooser: {
      title: "New authorization type",
      subtitle: "Choose what type of authorization you want to create.",
      permanentLabel: "Permanent authorization",
      permanentDesc: "Long-term partner-to-partner authorization (e.g., company rep).",
      oneTimeLabel: "One-time authorization",
      oneTimeDesc: "Rental-bound, requires ID document upload (e.g., driver, courier)."
    },
    dialog: {
      permanent: {
        title: "Permanent authorization",
        granteeLabel: "Grantee partner UUID",
        granteeHint: "Partner UUID (replaced by autocomplete in a future story)",
        validFromLabel: "Start",
        validUntilLabel: "End (optional)",
        valueLimitLabel: "Value limit (HUF, optional)",
        submit: "Create authorization",
        validationGranteeRequired: "Grantee partner is required",
        validationGranteeUuid: "Grantee partner must be a valid UUID",
        validationValidFromRequired: "Start date is required",
        validationValidUntilAfter: "End date must be after start date",
        validationValueLimit: "Value limit must be a positive integer (empty = unlimited)",
        validationValidFromPast: "Start date cannot be in the past"
      }
    }
  },
  equipment: {
    types: {
      categories: {
        SMALL_ENGINE: "Small engine",
        LAWN_EQUIPMENT: "Lawn equipment",
        POWER_TOOL: "Power tool",
        OTHER: "Other"
      },
      list: {
        title: "Equipment Type catalog",
        subtitle: "Equipment Type editor \u2014 type identity + SKU + images + category",
        newCta: "New type",
        searchPlaceholder: "Search by name / SKU / manufacturer SKU\u2026",
        allCategories: "All categories",
        activeOnly: "Active only",
        loading: "Loading types\u2026",
        empty: {
          title: "No types yet",
          desc: "Create the first equipment type to power the webshop face + rental/service/sales flows."
        },
        col: {
          name: "Name",
          sku: "SKU",
          category: "Category",
          brand: "Brand / model",
          status: "Status",
          actions: "Actions"
        },
        active: "Active",
        inactive: "Inactive",
        actionEdit: "Edit"
      },
      editor: {
        title: {
          new: "New equipment type",
          edit: "Edit equipment type"
        },
        subtitle: "Fill in the type's identity fields. Specs + units + documents will land in Phase 2 (Sprint 18+).",
        loading: "Loading type\u2026",
        backToList: "Back to list",
        submitting: "Saving\u2026",
        save: "Save",
        create: "Create",
        field: {
          name: "Display name",
          namePlaceholder: "e.g. Honda GX160 petrol engine",
          sku: "SKU (catalog number)",
          skuPlaceholder: "e.g. KGC-HONDA-GX160",
          manufacturerSku: "Manufacturer SKU",
          alternativeSkus: "Alternative SKUs",
          alternativeSkusPlaceholder: "comma-separated",
          alternativeSkusHint: "Used for bulk imports + N6 cross-reference. Example: HONDA-180-OLD, MS180-16",
          category: "Category",
          brand: "Brand",
          model: "Model",
          description: "Description",
          heroImageUrl: "Hero image URL",
          galleryImages: "Gallery URLs",
          galleryImagesPlaceholder: "https://...\nhttps://...",
          galleryImagesHint: "One URL per line. Phase 2 (ADR-123 Am.2) replaces this with the EquipmentTypeImage child table.",
          isActive: "Active",
          isActiveHint: "Inactive types are hidden from rental / service / sales UI.",
          alternativeSkusCreate: 'Add "{value}"',
          alternativeSkusDuplicate: "This SKU is already added",
          alternativeSkusTooLong: "The SKU can be at most 100 characters"
        },
        images: {
          title: "Images (D5 Phase 1)",
          previewError: "Image preview could not load from this URL. Verify the address."
        },
        toast: {
          created: "Equipment type created",
          updated: "Equipment type updated"
        },
        errors: {
          nameRequired: "Name is required",
          skuRequired: "SKU is required",
          duplicateSku: "This SKU already exists (manufacturer or alternative cross-reference)",
          validationFailed: "Invalid form data \u2014 check the fields",
          notFound: "Equipment type not found",
          network: "Network error, please retry",
          businessRuleFail: "Business rule violation. Please review the input.",
          fkViolation: "Referenced record does not exist.",
          specsInvalidJson: "The technical specification is invalid JSON \u2014 fix the Specs field before saving."
        },
        cancelConfirm: "You have unsaved changes. Discard and leave?",
        specs: {
          title: "Technical specifications",
          hint: "Key\u2013value pairs for the type\u2019s technical data (e.g. power, weight). The Raw view accepts arbitrary JSON.",
          kvView: "Key\u2013value",
          rawView: "Raw JSON",
          addRow: "Add row",
          removeRow: "Remove",
          keyPlaceholder: "e.g. power",
          valuePlaceholder: "e.g. 4.0 kW",
          invalidJson: 'Invalid JSON \u2014 an object is required (e.g. {"key": "value"})',
          nonPrimitiveHint: "The specs contain nested/typed values \u2014 the key\u2013value view would lose types, so the Raw view is active."
        },
        tabsLabel: "Type editor tabs",
        tabs: {
          data: "Basic data",
          units: "Units",
          webshop: "Webshop",
          docs: "Documents"
        },
        units: {
          loading: "Loading units\u2026",
          error: "Failed to load units.",
          empty: "This type has no units yet.",
          countSuffix: "units",
          serialNumber: "Serial number",
          assetTag: "Asset tag",
          status: "Status",
          createdAt: "Created",
          open: "Open"
        },
        webshop: {
          loading: "Loading webshop data\u2026",
          error: "Failed to load webshop data.",
          localeTitle: "Language content",
          localeHint: "HU required \xB7 EN/DE/UK optional (empty \u2192 HU fallback)",
          nameLabel: "Name",
          namePlaceholderHu: "e.g. Honda GX160 petrol engine",
          huNameRequired: "The Hungarian name is required when visible on the webshop.",
          descriptionLabel: "Description",
          slugLabel: "URL slug",
          slugGenerate: "Generate",
          flagVisibleOnWebshop: "Visible on webshop",
          flagVisibleOnWebshopHint: "When enabled, anyone can see it on the webshop.",
          flagAvailableForRent: "Bookable (rental)",
          flagAvailableForRentHint: "Customers can book from the webshop.",
          flagAvailableForSale: "Purchasable",
          flagAvailableForSaleHint: "Customers can purchase from the webshop.",
          save: "Save webshop data",
          saving: "Saving\u2026",
          saved: "Webshop data saved",
          saveFailed: "Saving failed.",
          seoSectionTitle: "Search engine optimization (SEO)",
          seoPlaceholderNote: "In preparation \u2014 saving SEO fields will be available in a future release (content is not persisted yet).",
          seoTitleLabel: "SEO title",
          seoTitlePlaceholder: "e.g. Honda GX160 engine rental and purchase \u2014 Kisg\xE9pcentrum",
          seoDescriptionLabel: "SEO description",
          seoDescriptionPlaceholder: "e.g. Honda GX160 professional petrol engine, 4-stroke, 163 cm\xB3. Rental and purchase at Kisg\xE9pcentrum.",
          seoTooLong: "too long"
        },
        docs: {
          loading: "Loading documents\u2026",
          error: "Failed to load documents.",
          empty: "This type has no documents yet.",
          countSuffix: "documents",
          name: "Name",
          kind: "Kind",
          size: "Size",
          uploadedAt: "Uploaded",
          kinds: {
            MANUAL: "Manual",
            SAFETY: "Safety",
            WARRANTY: "Warranty",
            CERTIFICATE: "Certificate",
            OTHER: "Other"
          }
        }
      }
    }
  },
  procurement: {
    worksheetPanelTitle: "Procurement requests",
    addRequest: "New procurement request",
    addRequestTitle: "New procurement request",
    emptyForWorksheet: "No procurement requests for this worksheet yet.",
    productSearchLabel: "Product",
    productSearchPlaceholder: "Search by SKU or name\u2026",
    noProductsFound: "No results",
    selectedProduct: "Selected product",
    productIdShort: "Product",
    quantity: "Quantity",
    notes: "Notes",
    notesPlaceholder: "e.g. urgent, OEM part\u2026",
    create: "Add to cart",
    errors: {
      productRequired: "Please select a product from the list.",
      quantityInvalid: "Quantity must be a positive number.",
      transitionRejected: "Status transition {from} \u2192 {to} is not allowed."
    },
    status: {
      DRAFT: "Draft",
      SUBMITTED: "Submitted",
      ORDERED: "Ordered",
      RECEIVED: "Received",
      CANCELLED: "Cancelled"
    },
    actions: {
      submit: "Submit",
      markOrdered: "Mark ordered",
      markReceived: "Mark received",
      cancel: "Cancel",
      confirmCancel: "Cancel this procurement request?"
    },
    closeGate: {
      title: "Close worksheet?",
      warning: "There are still {count} open procurement request(s) for this worksheet (not yet received or cancelled). Close anyway?",
      proceed: "Yes, close"
    },
    cart: {
      title: "Central procurement cart",
      subtitle: "All procurement requests grouped by source",
      empty: "The procurement cart is empty.",
      totalCount: "{count} requests",
      productIdShort: "Product",
      quantity: "Quantity",
      sourceLabel: {
        WORKSHEET: "Worksheet-driven",
        SALES: "Out-of-stock at POS",
        MANUAL: "Manual entry",
        AUTO_MIN: "Auto reorder"
      },
      submitButton: "Submit cart ({count})",
      confirmSubmit: "Submit {count} request(s) for procurement. Continue?",
      markGroupOrderedButton: "Mark group ordered",
      supplierNotesPrompt: "Supplier name (optional, appended to notes):"
    },
    listTruncated: "Truncated list: showing {shown} of {total}. Narrow the filter or open the full procurement list."
  },
  camera: {
    title: "Document camera capture",
    description: "USB webcam (Logitech C920) \u2014 desktop Chrome / Firefox only",
    stepFront: "Capture front side",
    stepBack: "Capture back side (MRZ)",
    stepCounter: "{current}/{total}",
    permissionPrompt: "Please grant the browser permission to use the camera.",
    permissionRequest: "Request permission",
    permissionDenied: "Camera permission denied. Please enable it in your browser settings and try again.",
    deviceNotFound: "Camera not found. Please connect the Logitech C920 USB webcam.",
    deviceGeneric: "Could not access the camera. Please check that no other application is using it.",
    captureFront: "Capture front side",
    captureBack: "Capture back side",
    retake: "Retake",
    next: "Next",
    useCaptures: "Use images",
    cancel: "Cancel",
    thumbnailFront: "Front side preview",
    thumbnailBack: "Back side preview",
    instructionFront: "Place the front of the document (photo) in front of the camera and capture.",
    instructionBack: "Turn the document over \u2014 the machine-readable zone (MRZ) on the back should be visible.",
    zeroRetentionHint: "Zero retention \u2014 images exist only until processing, then are destroyed immediately.",
    focusManual: "Manual focus supported",
    focusAuto: "Automatic focus",
    starting: "Starting camera..."
  },
  package: {
    backToList: "Back to packages",
    adminTabs: "Package views",
    tabs: {
      items: "Items",
      data: "Package data"
    },
    item: {
      name: "Name",
      settlement: "Settlement",
      settlementIncluded: "Included",
      settlementRental: "Rental",
      settlementConsignment: "Consignment",
      unitPrice: "Unit price"
    },
    scope: "Scope",
    pricingModel: "Pricing model",
    fixedPrice: "Fixed price",
    depositAmount: "Deposit",
    validFrom: "Valid from",
    validTo: "Valid to",
    category: {
      free: "Free",
      rentable: "Rentable",
      consignment: "Consignment"
    }
  },
  inquiry: {
    title: "Contact us",
    subtitle: "Tell us what you need \u2014 we'll reply within 1 business day.",
    success: {
      title: "Thank you for reaching out!",
      body: "We'll reply to the email address you provided within 1 business day."
    },
    field: {
      name: "Name",
      email: "Email",
      phone: "Phone number (optional)",
      message: "Message"
    },
    submit: "Send",
    submitting: "Sending...",
    validation: {
      nameMin: "At least 2 characters",
      email: "Invalid email",
      messageMin: "At least 10 characters",
      messageMax: "Maximum 5000 characters",
      captcha: "Please confirm you're not a robot"
    },
    error: {
      submit: "Could not send. Please try again in a few minutes."
    }
  },
  priDrawer: {
    title: "pRI Assistant",
    clearHistory: "Clear conversation",
    close: "Close"
  },
  unifiedFab: {
    items: {
      pri: "pRI Assistant",
      chat: "Chat",
      helpdesk: "Helpdesk"
    },
    title: {
      withShortcut: "rPI Assistant (Ctrl+Shift+H)",
      default: "rPI Assistant"
    }
  }
};

// src/locale/translations/hu.json
var hu_default = {
  equipmentUnit: {
    backToTypes: "Vissza a t\xEDpusokhoz",
    editorTitle: "Egyedi g\xE9p szerkeszt\u0151",
    editorSubtitle: "Egyedi g\xE9p-rekord adatai, st\xE1tusza \xE9s dokumentumai",
    tabsAria: "Egyedi g\xE9p n\xE9zetek",
    tabs: {
      basic: "Alapadatok",
      status: "St\xE1tusz & el\u0151zm\xE9ny",
      images: "K\xE9pek",
      documents: "Dokumentumok"
    },
    seamPending: "Hamarosan \u2014 adatk\xF6t\xE9s a BE-seam-re v\xE1r",
    field: {
      manufacturerSku: "Gy\xE1ri cikksz\xE1m",
      internalSku: "Bels\u0151 cikksz\xE1m",
      altSkus: "Alternat\xEDv SKU-k",
      serialNumber: "Sorozatsz\xE1m",
      purchasedAt: "V\xE1s\xE1rl\xE1s d\xE1tuma",
      hours: "\xDCzem\xF3ra",
      category: "Kateg\xF3ria",
      note: "Megjegyz\xE9s",
      status: "St\xE1tusz",
      statusSince: "St\xE1tusz \xF3ta"
    },
    status: {
      AVAILABLE: "Szabad",
      RESERVED: "Foglalt",
      IN_USE: "Haszn\xE1latban",
      DAMAGED: "S\xE9r\xFClt",
      UNDER_REPAIR: "Jav\xEDt\xE1s alatt",
      SOLD: "Eladva",
      WITHDRAWAL_REQUESTED: "Kivon\xE1sra jel\xF6lve",
      RETIRED: "Kivonva"
    },
    category: {
      SMALL_ENGINE: "Kismotoros g\xE9p",
      LAWN_EQUIPMENT: "Kerti g\xE9p",
      POWER_TOOL: "Elektromos szersz\xE1m",
      OTHER: "Egy\xE9b"
    },
    statusHistory: "St\xE1tusz el\u0151zm\xE9ny",
    altSkusPlaceholder: "SKU + Enter (Excel/CSV beilleszt\xE9s t\xE1mogatott)",
    altSkusCreate: '+ \xDAj: "{value}"',
    altSkusDuplicate: "M\xE1r szerepel",
    saved: "Mentve",
    saveError: "Ment\xE9s sikertelen",
    imagesEmpty: "Nincs felt\xF6lt\xF6tt k\xE9p",
    documentsEmpty: "Nincs dokumentum",
    expiresAt: "Lej\xE1r",
    download: "Let\xF6lt\xE9s",
    transition: {
      button: "St\xE1tusz v\xE1lt\xE1s",
      title: "St\xE1tusz v\xE1lt\xE1s",
      targetLabel: "V\xE1lassz c\xE9lst\xE1tuszt",
      reasonLabel: "Indokl\xE1s",
      required: "k\xF6telez\u0151",
      reasonHint: "Minimum 20 karakter ({count}/20)",
      photoLabel: "F\xE9nyk\xE9pek",
      auditNote: "Minden st\xE1tusz-v\xE1lt\xE1s audit-logolt: ki, mikor \xE9s mi\xE9rt.",
      confirm: "St\xE1tusz meger\u0151s\xEDt\xE9se",
      noTargets: "Ebb\u0151l a st\xE1tuszb\xF3l nincs lehets\xE9ges \xE1tmenet.",
      success: "St\xE1tusz friss\xEDtve",
      error: "A st\xE1tusz-v\xE1lt\xE1s sikertelen"
    }
  },
  bank: {
    title: "Banki t\xE9telek",
    subtitle: "Banksz\xE1mla-mozg\xE1sok \xE9s p\xE1ros\xEDt\xE1s",
    newTransaction: "\xDAj t\xE9tel",
    loading: "Banki t\xE9telek bet\xF6lt\xE9se...",
    error: "Hiba t\xF6rt\xE9nt",
    noResults: "Nincs tal\xE1lat",
    noResultsFiltered: "A sz\u0171r\xE9snek megfelel\u0151 banki t\xE9tel nincs. M\xF3dos\xEDtsd a sz\u0171r\u0151t.",
    total: "\xD6sszesen",
    column: {
      bookingDate: "K\xF6nyvel\xE9s d\xE1tuma",
      counterparty: "Partner",
      amount: "\xD6sszeg",
      matchStatus: "P\xE1ros\xEDt\xE1s",
      source: "Forr\xE1s"
    },
    matchStatus: {
      UNMATCHED: "P\xE1ros\xEDtatlan",
      PARTIALLY_MATCHED: "R\xE9szben p\xE1ros\xEDtott",
      MATCHED: "P\xE1ros\xEDtott",
      RECONCILED: "Egyeztetett"
    },
    direction: {
      IN: "Bev\xE9t",
      OUT: "Kiad\xE1s"
    },
    source: {
      MANUAL: "K\xE9zi",
      IMPORT: "Import"
    },
    filter: {
      allStatuses: "Minden \xE1llapot",
      allDirections: "Minden ir\xE1ny"
    },
    form: {
      bookingDate: "K\xF6nyvel\xE9s d\xE1tuma",
      direction: "Ir\xE1ny",
      amount: "\xD6sszeg",
      counterpartyName: "Partner neve",
      counterpartyAccount: "Partner sz\xE1mlasz\xE1ma",
      memo: "K\xF6zlem\xE9ny",
      submit: "R\xF6gz\xEDt\xE9s",
      success: "Banki t\xE9tel r\xF6gz\xEDtve",
      error: "A r\xF6gz\xEDt\xE9s nem siker\xFClt"
    },
    match: {
      action: "P\xE1ros\xEDt\xE1s",
      title: "Banki t\xE9tel p\xE1ros\xEDt\xE1sa",
      invoiceLabel: "Sz\xE1mla",
      invoicePlaceholder: "V\xE1lassz sz\xE1ml\xE1t\u2026",
      amountLabel: "P\xE1ros\xEDtott \xF6sszeg",
      submit: "P\xE1ros\xEDt\xE1s",
      noInvoices: "Nincs p\xE1ros\xEDthat\xF3 nyitott sz\xE1mla",
      loadError: "Nem siker\xFClt bet\xF6lteni az egyeztethet\u0151 sz\xE1ml\xE1kat. Pr\xF3b\xE1ld \xFAjra.",
      success: "Sikeres p\xE1ros\xEDt\xE1s",
      error: {
        overpay: "A p\xE1ros\xEDtott \xF6sszeg meghaladja a sz\xE1mla kintl\xE9v\u0151s\xE9g\xE9t",
        outNotAllowed: "Kimen\u0151 t\xE9tel nem p\xE1ros\xEDthat\xF3 sz\xE1ml\xE1hoz",
        amountPositive: "A p\xE1ros\xEDtott \xF6sszegnek pozit\xEDvnak kell lennie",
        alreadyExists: "Ez a p\xE1ros\xEDt\xE1s m\xE1r l\xE9tezik",
        invoiceNotFound: "A sz\xE1mla nem tal\xE1lhat\xF3",
        transactionNotFound: "A banki t\xE9tel nem tal\xE1lhat\xF3",
        generic: "A p\xE1ros\xEDt\xE1s nem siker\xFClt"
      }
    }
  },
  common: {
    status: "St\xE1tusz",
    uploading: "Felt\xF6lt\xE9s\u2026",
    save: "Ment\xE9s",
    saving: "Ment\xE9s...",
    cancel: "M\xE9gse",
    delete: "T\xF6rl\xE9s",
    confirmDelete: "Biztosan t\xF6r\xF6lni szeretn\xE9d ezt az elemet?",
    search: "Keres\xE9s",
    clearSearch: "Keres\xE9s t\xF6rl\xE9se",
    loading: "Bet\xF6lt\xE9s...",
    error: "Hiba",
    success: "Sikeres",
    yes: "Igen",
    no: "Nem",
    close: "Bez\xE1r\xE1s",
    back: "Vissza",
    previous: "El\u0151z\u0151",
    next: "K\xF6vetkez\u0151",
    submit: "Bek\xFCld\xE9s",
    edit: "Szerkeszt\xE9s",
    create: "L\xE9trehoz\xE1s",
    details: "R\xE9szletek",
    new: "\xDAj",
    all: "Mind",
    none: "Nincs",
    actions: "M\u0171veletek",
    confirm: "Meger\u0151s\xEDt\xE9s",
    remove: "Elt\xE1vol\xEDt\xE1s",
    add: "Hozz\xE1ad\xE1s",
    update: "Friss\xEDt\xE9s",
    refresh: "Friss\xEDt\xE9s",
    retry: "\xDAjrapr\xF3b\xE1l\xE1s",
    print: "Nyomtat\xE1s",
    export: "Export\xE1l\xE1s",
    import: "Import\xE1l\xE1s",
    filter: "Sz\u0171r\xE9s",
    sort: "Rendez\xE9s",
    reset: "Vissza\xE1ll\xEDt\xE1s",
    apply: "Alkalmaz",
    download: "Let\xF6lt\xE9s",
    upload: "Felt\xF6lt\xE9s",
    quantity: "Mennyis\xE9g",
    total: "\xD6sszesen",
    subtotal: "R\xE9sz\xF6sszeg",
    amount: "\xD6sszeg",
    date: "D\xE1tum",
    description: "Le\xEDr\xE1s",
    notes: "Megjegyz\xE9s",
    comment: "Megjegyz\xE9s",
    type: "T\xEDpus",
    category: "Kateg\xF3ria",
    priority: "Priorit\xE1s",
    responsible: "Felel\u0151s",
    noResponsible: "Nincs felel\u0151s",
    id: "Azonos\xEDt\xF3",
    name: "Megnevez\xE9s",
    notFound: "Nem tal\xE1lhat\xF3",
    noData: "Nincs adat",
    backToList: "Vissza a list\xE1hoz",
    optional: "Opcion\xE1lis",
    required: "K\xF6telez\u0151",
    piece: "db",
    day: "nap",
    days: "nap",
    hour: "\xF3ra",
    hours: "\xF3ra",
    createdAt: "L\xE9trehozva",
    updatedAt: "M\xF3dos\xEDtva",
    completedAt: "Befejezve",
    createdBy: "L\xE9trehoz\xF3",
    saved: "Mentve!",
    loadingText: "Bet\xF6lt\xE9s...",
    errorLabel: "Hiba",
    retryButton: "\xDAjrapr\xF3ba",
    months: {
      january: "Janu\xE1r",
      february: "Febru\xE1r",
      march: "M\xE1rcius",
      april: "\xC1prilis",
      may: "M\xE1jus",
      june: "J\xFAnius",
      july: "J\xFAlius",
      august: "Augusztus",
      september: "Szeptember",
      october: "Okt\xF3ber",
      november: "November",
      december: "December"
    },
    monthsShort: {
      jan: "Jan",
      feb: "Feb",
      mar: "M\xE1r",
      apr: "\xC1pr",
      may: "M\xE1j",
      jun: "J\xFAn",
      jul: "J\xFAl",
      aug: "Aug",
      sep: "Szep",
      oct: "Okt",
      nov: "Nov",
      dec: "Dec"
    },
    other: "Egy\xE9b",
    unknownError: "Ismeretlen hiba",
    activeRentals: "Akt\xEDv b\xE9rl\xE9sek",
    currency: "Ft",
    summary: "\xD6sszefoglal\xF3",
    wizardStep: "L\xE9p\xE9s {current} / {total}",
    processing: "Feldolgoz\xE1s...",
    row: "Sor",
    clear: "T\xF6rl\xE9s",
    dismiss: "Elvet\xE9s",
    active: "Akt\xEDv",
    inactive: "Inakt\xEDv",
    loadError: "Bet\xF6lt\xE9si hiba"
  },
  navStatus: {
    label: "NAV st\xE1tusz",
    pending: "F\xFCgg\u0151ben",
    submitted: "Elk\xFCldve",
    accepted: "Elfogadva",
    rejected: "Elutas\xEDtva",
    error: "Hiba"
  },
  nav: {
    bankImport: "Banki t\xE9telek",
    navigation: "Navig\xE1ci\xF3",
    favorites: "Kedvencek",
    removeFavorite: "Elt\xE1vol\xEDt\xE1s",
    expandAll: "Mindent kinyit",
    collapseAll: "Mindent \xF6sszecsuk",
    expand: "Kinyit\xE1s",
    collapse: "\xD6sszecsuk\xE1s",
    adminCenter: "Admin K\xF6zpont",
    summary: "\xD6sszefoglal\xF3",
    knowledgeBase: "Tud\xE1sb\xE1zis",
    rental: "B\xE9rl\xE9s",
    activeRentals: "Akt\xEDv b\xE9rl\xE9sek",
    newRental: "\xDAj b\xE9rl\xE9s",
    returnRental: "Visszav\xE9tel",
    outstandingRentals: "Kintl\xE9v\u0151s\xE9gek",
    fleetCalendar: "G\xE9ppark napt\xE1r",
    worksheet: "Munkalap",
    worksheets: "Munkalapok",
    newWorksheet: "\xDAj munkalap",
    claims: "K\xE1rig\xE9nyek",
    sales: "\xC9rt\xE9kes\xEDt\xE9s",
    salesList: "Elad\xE1sok",
    pos: "P\xE9nzt\xE1r (POS)",
    inventory: "K\xE9szlet",
    stockList: "K\xE9szletlista",
    movements: "Mozg\xE1sok",
    goodsReceipt: "Bev\xE9telez\xE9s",
    scrapping: "Selejtez\xE9s",
    inventoryAnalytics: "K\xE9szlet analitika",
    masterData: "T\xF6rzsadatok",
    products: "Cikkek",
    quotes: "\xC1raj\xE1nlatok",
    contracts: "Szerz\u0151d\xE9sek",
    invoices: "Sz\xE1ml\xE1k",
    deliveryNotes: "Sz\xE1ll\xEDt\xF3levelek",
    partners: "Partnerek",
    partnerList: "Partnerlista",
    newPartner: "\xDAj partner",
    vipProgram: "VIP Program",
    duplicates: "Duplik\xE1ci\xF3k",
    vehicles: "J\xE1rm\u0171vek",
    rentalVehicles: "B\xE9rg\xE9p j\xE1rm\u0171vek",
    companyVehicles: "C\xE9ges j\xE1rm\u0171vek",
    expiringDocuments: "Lej\xE1r\xF3 dokumentumok",
    finance: "P\xE9nz\xFCgyek",
    cashRegister: "Kassza",
    dailyClose: "Vakz\xE1r\xE1s",
    monthlyClose: "Havi z\xE1r\xE1s",
    journal: "F\u0151k\xF6nyvi napl\xF3",
    szhFolder: "SZH Mappa",
    vouchers: "Bizonylatok",
    fixedAssets: "T\xE1rgyi eszk\xF6z\xF6k",
    tamTaxExempt: "TAM Ad\xF3mentess\xE9g",
    receivables: "Kintl\xE9v\u0151s\xE9gek",
    overdueRentals: "Kintl\xE9v\u0151s\xE9gek",
    chat: "Chat",
    messaging: "\xDCzenetkezel\xE9s",
    smsDashboard: "SMS Ir\xE1ny\xEDt\xF3pult",
    inboundSms: "Bej\xF6v\u0151 SMS",
    courierDeliveries: "Fut\xE1ros sz\xE1ll\xEDtm\xE1nyok",
    reports: "Riportok",
    tasks: "Feladatok",
    integrations: "Integr\xE1ci\xF3k",
    crm: "CRM (Twenty)",
    hr: "HR (Horilla)",
    porter: "rPI Porter",
    porterInbox: "Inbox",
    porterChannels: "Csatorn\xE1k",
    porterAutoReply: "Auto-reply szab\xE1lyok",
    chatwoot: "rPI Porter",
    flow: "rPI Flow",
    admin: "Admin",
    users: "Felhaszn\xE1l\xF3k",
    permissions: "Jogosults\xE1gok",
    tenantAdmin: "B\xE9rl\u0151i Admin",
    featureFlags: "Funkci\xF3 kapcsol\xF3k",
    releaseHub: "rPI Delta",
    settings: "Be\xE1ll\xEDt\xE1sok",
    general: "\xC1ltal\xE1nos",
    openingHours: "Nyitvatart\xE1s",
    smsSettings: "SMS be\xE1ll\xEDt\xE1sok",
    documentScanner: "Okm\xE1nyolvas\xF3",
    dashboard: "Dashboard",
    crmNewWindow: "Twenty CRM (\xFAj ablak)",
    hrNewWindow: "Horilla HR (\xFAj ablak)",
    group: {
      daily: "Napi munka",
      registry: "Nyilv\xE1ntart\xE1s",
      communication: "Kommunik\xE1ci\xF3",
      system: "Rendszer",
      hr: "HR"
    },
    manufacturing: "Gyart\xE1s",
    bomList: "Anyagjegyz\xE9k (BOM)",
    productionOrders: "Gy\xE1rt\xE1si rendel\xE9sek",
    packages: "Csomagok",
    more: "T\xF6bb",
    administration: "Adminisztr\xE1ci\xF3",
    recentItems: "Legut\xF3bbi",
    moreMenu: "T\xF6bb men\xFCpont",
    sidebarMenu: "Navig\xE1ci\xF3s panel",
    emailTemplates: "Email sablonok",
    emailSmtp: "Email SMTP",
    emailLogs: "K\xFCld\xE9si napl\xF3",
    bulkEmail: "T\xF6meges email",
    hrModule: "HR",
    hrAttendance: "Jelenl\xE9t",
    hrLeaveCalendar: "Szabads\xE1g napt\xE1r",
    hrLeaveRequest: "Szabads\xE1g k\xE9relem",
    hrEmployees: "Dolgoz\xF3k"
  },
  header: {
    search: "Keres\xE9s",
    searchShortcut: "Keres\xE9s (Ctrl+K)",
    lightMode: "Vil\xE1gos m\xF3d",
    darkMode: "S\xF6t\xE9t m\xF3d",
    language: "Nyelv / Language",
    user: "Felhaszn\xE1l\xF3",
    logout: "Kijelentkez\xE9s",
    role: "Szerepk\xF6r",
    pendingSync: "Szinkroniz\xE1l\xE1s folyamatban"
  },
  command: {
    searchPlaceholder: "Keres\xE9s oldalak k\xF6z\xF6tt...",
    noResults: "Nincs tal\xE1lat.",
    navigate: "navig\xE1ci\xF3",
    open: "megnyit\xE1s",
    close: "bez\xE1r\xE1s",
    addFavorite: "Hozz\xE1ad\xE1s a kedvencekhez",
    removeFavorite: "Elt\xE1vol\xEDt\xE1s a kedvencekb\u0151l"
  },
  status: {
    active: "Akt\xEDv",
    closed: "Lez\xE1rt",
    draft: "V\xE1zlat",
    expired: "Lej\xE1rt",
    cancelled: "Lemondva",
    pending: "F\xFCgg\u0151ben",
    inProgress: "Folyamatban",
    completed: "K\xE9sz",
    waiting: "V\xE1rakoz\xF3",
    billable: "Sz\xE1ml\xE1zand\xF3",
    deleted: "T\xF6r\xF6lve",
    partialReturn: "R\xE9szben visszav\xE9ve",
    returned: "Visszav\xE9ve",
    free: "Szabad",
    rentedOut: "Kiadva",
    inService: "Szervizben",
    reserved: "Foglalt",
    excellent: "Kiv\xE1l\xF3",
    good: "J\xF3",
    adequate: "Megfelel\u0151",
    open: "Nyitott",
    interrupted: "Megszak\xEDtva",
    low: "Alacsony",
    medium: "K\xF6zepes",
    high: "Magas",
    trusted: "Megb\xEDzhat\xF3",
    notTrusted: "Nem megb\xEDzhat\xF3",
    depositFree: "Kauci\xF3mentes!",
    depositMissing: "Kauci\xF3 hi\xE1nyzik",
    storno: "(sztorn\xF3)"
  },
  toast: {
    saved: "Sikeresen mentve",
    deleted: "Sikeresen t\xF6r\xF6lve",
    created: "Sikeresen l\xE9trehozva",
    updated: "Sikeresen friss\xEDtve",
    error: "Hiba t\xF6rt\xE9nt",
    loginError: "Bejelentkez\xE9si hiba"
  },
  error: {
    required: "A mez\u0151 k\xF6telez\u0151",
    invalidEmail: "\xC9rv\xE9nytelen email c\xEDm",
    loadFailed: "Bet\xF6lt\xE9s sikertelen",
    saveFailed: "Ment\xE9s sikertelen",
    general: "Hiba t\xF6rt\xE9nt: {message}",
    notFound: "Nem tal\xE1lhat\xF3",
    minLength: "Minimum {min} karakter sz\xFCks\xE9ges",
    worksheetNotFound: "Munkalap nem tal\xE1lhat\xF3",
    rentalNotFound: "B\xE9rl\xE9s nem tal\xE1lhat\xF3",
    invoiceNotFound: "Sz\xE1mla nem tal\xE1lhat\xF3",
    noCashRegisterOpen: "Nincs nyitott kassza.",
    atLeastOneItem: "Legal\xE1bb egy t\xE9telt adjon meg!",
    enterPartnerName: "K\xE9rj\xFCk adja meg a partner nev\xE9t!",
    minCharsRequired: "Minimum {min} karakter sz\xFCks\xE9ges",
    atLeastOneChange: "Legal\xE1bb egy \xE9rdemi m\xF3dos\xEDt\xE1s sz\xFCks\xE9ges!",
    calendar: {
      createHoliday: "\xDCnnepnap l\xE9trehoz\xE1sa sikertelen",
      createOverride: "Fel\xFCl\xEDr\xE1s l\xE9trehoz\xE1sa sikertelen",
      deleteHoliday: "\xDCnnepnap t\xF6rl\xE9se sikertelen",
      deleteOverride: "Fel\xFCl\xEDr\xE1s t\xF6rl\xE9se sikertelen",
      loadCalendar: "Napt\xE1r bet\xF6lt\xE9se sikertelen",
      loadHolidays: "\xDCnnepnapok bet\xF6lt\xE9se sikertelen",
      loadHours: "Nyitvatart\xE1s bet\xF6lt\xE9se sikertelen",
      loadOverrides: "Fel\xFCl\xEDr\xE1sok bet\xF6lt\xE9se sikertelen",
      resetDefaults: "Alap\xE9rtelmez\xE9s vissza\xE1ll\xEDt\xE1sa sikertelen",
      seedNational: "Nemzeti \xFCnnepnapok bet\xF6lt\xE9se sikertelen",
      updateHoliday: "\xDCnnepnap friss\xEDt\xE9se sikertelen",
      updateHours: "Nyitvatart\xE1s friss\xEDt\xE9se sikertelen",
      updateOverride: "Fel\xFCl\xEDr\xE1s friss\xEDt\xE9se sikertelen"
    },
    chat: {
      createConversation: "Nem siker\xFClt l\xE9trehozni a cseveg\xE9st",
      loadConversations: "Nem siker\xFClt bet\xF6lteni a cseveg\xE9seket",
      loadMessages: "Nem siker\xFClt bet\xF6lteni az \xFCzeneteket",
      loadUsers: "Nem siker\xFClt bet\xF6lteni a felhaszn\xE1l\xF3kat",
      sendMessage: "Nem siker\xFClt elk\xFCldeni az \xFCzenetet"
    },
    common: {
      operationFailed: "M\u0171velet sikertelen",
      unknownError: "Ismeretlen hiba"
    },
    rental: {
      depositPaidEquipmentTaken: "A kauci\xF3 levonva, a b\xE9rl\xE9s l\xE9trej\xF6tt \u2014 de a g\xE9pet id\u0151k\xF6zben m\xE1sik b\xE9rl\xE9shez adt\xE1k ki, ez\xE9rt nem lett hozz\xE1rendelve. NE ind\xEDtsd \xFAjra a fizet\xE9st: minden \xFAjrapr\xF3ba \xFAjabb kauci\xF3-levon\xE1st \xE9s \xFAjabb b\xE9rl\xE9st hoz l\xE9tre. T\xE9r\xEDtsd vissza a kauci\xF3t a kauci\xF3-fel\xFCleten, \xE9s v\xE1lassz m\xE1sik g\xE9pet. ({contractNumber})",
      depositPaidNotRecorded: "A kauci\xF3 levonva, a b\xE9rl\xE9s l\xE9trej\xF6tt \u2014 de a rendszer nem tudta r\xF6gz\xEDteni a g\xE9p kiad\xE1s\xE1t. A g\xE9p egyik b\xE9rl\xE9shez sincs hozz\xE1rendelve, ak\xE1r a pultn\xE1l is lehet. NE ind\xEDtsd \xFAjra a fizet\xE9st: minden \xFAjrapr\xF3ba \xFAjabb kauci\xF3-levon\xE1st \xE9s \xFAjabb b\xE9rl\xE9st hoz l\xE9tre. T\xE9r\xEDtsd vissza a kauci\xF3t a kauci\xF3-fel\xFCleten, \xE9s jelezd a hib\xE1t. ({contractNumber})",
      pickupFailed: "G\xE9pkiad\xE1s sikertelen. A b\xE9rl\xE9s DRAFT st\xE1tuszban maradt \u2014 k\xE9rj\xFCk pr\xF3b\xE1lja \xFAjra az adatlapon. Hiba: {error}",
      depositRefundFailed: "Visszav\xE9tel sikeres, de a kauci\xF3 visszautal\xE1s sikertelen. \xD6sszeg: {amount}. Hiba: {error}. K\xE9rj\xFCk manu\xE1lisan int\xE9zze a visszautal\xE1st.",
      depositRefundTitle: "B\xE9rl\xE9s visszav\xE9tel - kauci\xF3 visszat\xE9r\xEDt\xE9s"
    },
    tasks: {
      loadAll: "Nem siker\xFClt bet\xF6lteni a feladatokat",
      loadByStatus: "Nem siker\xFClt bet\xF6lteni a feladatokat",
      loadOne: "Nem siker\xFClt bet\xF6lteni a feladatot",
      loadOverdue: "Nem siker\xFClt bet\xF6lteni a lej\xE1rt feladatokat",
      loadStats: "Nem siker\xFClt bet\xF6lteni a statisztik\xE1kat"
    },
    users: {
      create: "Nem siker\xFClt l\xE9trehozni a felhaszn\xE1l\xF3t",
      delete: "Nem siker\xFClt t\xF6r\xF6lni a felhaszn\xE1l\xF3t",
      loadAll: "Nem siker\xFClt bet\xF6lteni a felhaszn\xE1l\xF3kat",
      loadOne: "Nem siker\xFClt bet\xF6lteni a felhaszn\xE1l\xF3t",
      update: "Nem siker\xFClt friss\xEDteni a felhaszn\xE1l\xF3t"
    },
    contracts: {
      loadAll: "Nem siker\xFClt bet\xF6lteni a szerz\u0151d\xE9seket",
      loadOne: "Nem siker\xFClt bet\xF6lteni a szerz\u0151d\xE9st"
    },
    quotations: {
      loadAll: "Nem siker\xFClt bet\xF6lteni az \xE1raj\xE1nlatokat",
      loadOne: "Nem siker\xFClt bet\xF6lteni az \xE1raj\xE1nlatot"
    },
    NOT_FOUND: "Nem tal\xE1lhat\xF3",
    BAD_REQUEST: "\xC9rv\xE9nytelen k\xE9r\xE9s",
    UNAUTHORIZED: "Nincs jogosults\xE1ga",
    FORBIDDEN: "Hozz\xE1f\xE9r\xE9s megtagadva",
    CONFLICT: "\xDCtk\xF6z\xE9s \u2014 az elem m\xE1r l\xE9tezik",
    INTERNAL_ERROR: "Bels\u0151 szerverhiba",
    VALIDATION_FAILED: "\xC9rv\xE9nyes\xEDt\xE9si hiba",
    AUTH_MISSING: "Hi\xE1nyz\xF3 autentik\xE1ci\xF3",
    AUTH_INVALID_TOKEN: "\xC9rv\xE9nytelen token",
    AUTH_TOKEN_EXPIRED: "Lej\xE1rt token",
    AUTH_ACCESS_TOKEN_REQUIRED: "Access token sz\xFCks\xE9ges",
    AUTH_INVALID_CREDENTIALS: "\xC9rv\xE9nytelen bejelentkez\xE9si adatok",
    AUTH_SESSION_EXPIRED: "A munkamenet lej\xE1rt, k\xE9rj\xFCk jelentkezzen be \xFAjra",
    AUTH_INVALID_PIN: "\xC9rv\xE9nytelen PIN k\xF3d",
    RENTAL_NOT_FOUND: "B\xE9rl\xE9s nem tal\xE1lhat\xF3",
    RENTAL_INVALID_STATUS: "\xC9rv\xE9nytelen b\xE9rl\xE9si st\xE1tusz",
    RENTAL_INVALID_TRANSITION: "\xC9rv\xE9nytelen st\xE1tusz \xE1tmenet",
    RENTAL_ALREADY_EXISTS: "A b\xE9rl\xE9s m\xE1r l\xE9tezik",
    RENTAL_EQUIPMENT_NOT_AVAILABLE: "Az eszk\xF6z nem el\xE9rhet\u0151",
    RENTAL_CONTRACT_NOT_FOUND: "B\xE9rl\xE9si szerz\u0151d\xE9s nem tal\xE1lhat\xF3",
    RENTAL_DEPOSIT_NOT_FOUND: "Kauci\xF3 nem tal\xE1lhat\xF3",
    RENTAL_DEPOSIT_ALREADY_EXISTS: "A kauci\xF3 m\xE1r l\xE9tezik ehhez a b\xE9rl\xE9shez",
    RENTAL_DEPOSIT_INVALID_AMOUNT: "A kauci\xF3 \xF6sszegnek pozit\xEDvnak kell lennie",
    RENTAL_DEPOSIT_INVALID_STATUS: "\xC9rv\xE9nytelen kauci\xF3 st\xE1tusz",
    RENTAL_DEPOSIT_INSUFFICIENT: "A teljes kauci\xF3 befizet\xE9se sz\xFCks\xE9ges a kiad\xE1shoz",
    RENTAL_HISTORY_NOT_FOUND: "B\xE9rl\xE9si el\u0151zm\xE9ny nem tal\xE1lhat\xF3",
    WORKSHEET_NOT_FOUND: "Munkalap nem tal\xE1lhat\xF3",
    WORKSHEET_INVALID_STATUS: "\xC9rv\xE9nytelen munkalap st\xE1tusz",
    WORKSHEET_INVALID_TRANSITION: "\xC9rv\xE9nytelen munkalap st\xE1tusz \xE1tmenet",
    WARRANTY_CLAIM_NOT_FOUND: "Garanci\xE1lis ig\xE9ny nem tal\xE1lhat\xF3",
    WARRANTY_INVALID_STATUS: "\xC9rv\xE9nytelen garancia st\xE1tusz",
    SERVICE_NORM_NOT_FOUND: "Szerviz norma nem tal\xE1lhat\xF3",
    SERVICE_NORM_INVALID_CODE: "\xC9rv\xE9nytelen norma k\xF3d",
    DIAGNOSTIC_NOT_FOUND: "Diagnosztika nem tal\xE1lhat\xF3",
    INVOICE_NOT_FOUND: "Sz\xE1mla nem tal\xE1lhat\xF3",
    INVOICE_INVALID_STATUS: "\xC9rv\xE9nytelen sz\xE1mla st\xE1tusz",
    INVOICE_INVALID_TRANSITION: "\xC9rv\xE9nytelen sz\xE1mla st\xE1tusz \xE1tmenet",
    INVOICE_ITEM_NOT_FOUND: "Sz\xE1mlat\xE9tel nem tal\xE1lhat\xF3",
    POS_SESSION_NOT_FOUND: "P\xE9nzt\xE1r munkamenet nem tal\xE1lhat\xF3",
    POS_SESSION_ALREADY_OPEN: "P\xE9nzt\xE1r munkamenet m\xE1r nyitva van",
    QUOTE_NOT_FOUND: "\xC1raj\xE1nlat nem tal\xE1lhat\xF3",
    QUOTE_INVALID_STATUS: "\xC9rv\xE9nytelen \xE1raj\xE1nlat st\xE1tusz",
    QUOTE_ITEM_NOT_FOUND: "\xC1raj\xE1nlat t\xE9tel nem tal\xE1lhat\xF3",
    QUOTE_ONLY_DRAFT_MODIFIABLE: "Csak piszkozat st\xE1tusz\xFA \xE1raj\xE1nlat m\xF3dos\xEDthat\xF3",
    QUOTE_ONLY_DRAFT_DELETABLE: "Csak piszkozat st\xE1tusz\xFA \xE1raj\xE1nlat t\xF6r\xF6lhet\u0151",
    QUOTE_ONLY_DRAFT_SENDABLE: "Csak piszkozat vagy elk\xFCld\xF6tt st\xE1tusz\xFA \xE1raj\xE1nlat k\xFCldhet\u0151",
    QUOTE_EMAIL_NOT_CONFIGURED: "Email szolg\xE1ltat\xE1s nem konfigur\xE1lt",
    QUOTE_RECIPIENT_REQUIRED: "C\xEDmzett email c\xEDm megad\xE1sa k\xF6telez\u0151",
    QUOTE_PARTNER_REQUIRED: "Partner megad\xE1sa k\xF6telez\u0151",
    QUOTE_ITEMS_REQUIRED: "Legal\xE1bb egy t\xE9tel megad\xE1sa k\xF6telez\u0151",
    QUOTE_INVALID_QUANTITY: "Mennyis\xE9g nem lehet nulla vagy negat\xEDv",
    QUOTE_INVALID_UNIT_PRICE: "Egys\xE9g\xE1r nem lehet negat\xEDv",
    QUOTE_EXPLODED_VIEW_NOT_FOUND: "Robbantott \xE1bra nem tal\xE1lhat\xF3",
    QUOTE_MANUFACTURER_REQUIRED: "Gy\xE1rt\xF3 megad\xE1sa k\xF6telez\u0151",
    QUOTE_MODEL_REQUIRED: "G\xE9pmodell azonos\xEDt\xF3 megad\xE1sa k\xF6telez\u0151",
    QUOTE_PARTS_REQUIRED: "Legal\xE1bb egy alkatr\xE9sz kiv\xE1laszt\xE1sa k\xF6telez\u0151",
    PARTNER_NOT_FOUND: "Partner nem tal\xE1lhat\xF3",
    PARTNER_ALREADY_EXISTS: "A partner m\xE1r l\xE9tezik",
    PARTNER_INVALID_TAX_NUMBER: "\xC9rv\xE9nytelen ad\xF3sz\xE1m",
    PARTNER_DUPLICATE: "Duplik\xE1lt partner",
    PARTNER_CONTRACT_NOT_FOUND: "Partner szerz\u0151d\xE9s nem tal\xE1lhat\xF3",
    PARTNER_REFERENCE_NOT_FOUND: "Partner referencia nem tal\xE1lhat\xF3",
    WAREHOUSE_NOT_FOUND: "Rakt\xE1r nem tal\xE1lhat\xF3",
    WAREHOUSE_LOCATION_NOT_FOUND: "Rakt\xE1rhely nem tal\xE1lhat\xF3",
    STOCK_INSUFFICIENT: "Nincs elegend\u0151 k\xE9szlet",
    STOCK_COUNT_NOT_FOUND: "Lelt\xE1r nem tal\xE1lhat\xF3",
    MOVEMENT_NOT_FOUND: "K\xE9szletmozg\xE1s nem tal\xE1lhat\xF3",
    MOVEMENT_INVALID_TYPE: "\xC9rv\xE9nytelen mozg\xE1s t\xEDpus",
    PHANTOM_WAREHOUSE_NOT_FOUND: "Fantom rakt\xE1r nem tal\xE1lhat\xF3",
    PRODUCT_NOT_FOUND: "Term\xE9k nem tal\xE1lhat\xF3",
    PRODUCT_SKU_EXISTS: "A cikksz\xE1m (SKU) m\xE1r l\xE9tezik",
    PRODUCT_CATEGORY_NOT_FOUND: "Term\xE9kkateg\xF3ria nem tal\xE1lhat\xF3",
    PRODUCT_SUPPLIER_NOT_FOUND: "Besz\xE1ll\xEDt\xF3 nem tal\xE1lhat\xF3",
    VEHICLE_NOT_FOUND: "J\xE1rm\u0171 nem tal\xE1lhat\xF3",
    VEHICLE_DOCUMENT_EXPIRED: "A j\xE1rm\u0171 dokumentum lej\xE1rt",
    CALENDAR_INVALID_DATE: "\xC9rv\xE9nytelen d\xE1tum form\xE1tum",
    CALENDAR_HOLIDAY_NOT_FOUND: "\xDCnnepnap nem tal\xE1lhat\xF3",
    CALENDAR_OVERRIDE_NOT_FOUND: "Napt\xE1r fel\xFCl\xEDr\xE1s nem tal\xE1lhat\xF3",
    PORTAL_INVALID_TOKEN: "\xC9rv\xE9nytelen port\xE1l token",
    PORTAL_INVALID_OTP: "\xC9rv\xE9nytelen egyszer haszn\xE1latos k\xF3d",
    PORTAL_BOOKING_NOT_FOUND: "Foglal\xE1s nem tal\xE1lhat\xF3",
    PORTAL_EQUIPMENT_NOT_FOUND: "Eszk\xF6z nem tal\xE1lhat\xF3",
    CASH_REGISTER_NOT_FOUND: "Kassza nem tal\xE1lhat\xF3",
    CASH_REGISTER_ALREADY_CLOSED: "A kassza m\xE1r le van z\xE1rva",
    DAILY_CLOSE_ALREADY_EXISTS: "A napi z\xE1r\xE1s m\xE1r megt\xF6rt\xE9nt",
    DELIVERY_NOTE_NOT_FOUND: "Sz\xE1ll\xEDt\xF3lev\xE9l nem tal\xE1lhat\xF3",
    DELIVERY_NOTE_INVALID_STATUS: "\xC9rv\xE9nytelen sz\xE1ll\xEDt\xF3lev\xE9l st\xE1tusz",
    MENU_ITEM_ID_REQUIRED: "Men\xFCpont azonos\xEDt\xF3 sz\xFCks\xE9ges",
    FAVORITES_REQUIRED: "Kedvencek lista sz\xFCks\xE9ges",
    EQUIPMENT_NOT_FOUND: "B\xE9rg\xE9p nem tal\xE1lhat\xF3",
    EQUIPMENT_NOT_AVAILABLE: "A b\xE9rg\xE9p nem el\xE9rhet\u0151",
    KB_ARTICLE_NOT_FOUND: "A tud\xE1sb\xE1zis-cikk nem tal\xE1lhat\xF3",
    WIDGET_ID_INVALID: "\xC9rv\xE9nytelen widget azonos\xEDt\xF3",
    TENANT_CONTEXT_REQUIRED: "Hi\xE1nyz\xF3 b\xE9rl\u0151i kontextus",
    PRI_API_KEY_REQUIRED: "API kulcs k\xF6telez\u0151, ha enged\xE9lyezve van",
    HOURLY_RATE_NEGATIVE: "Az \xF3rad\xEDj nem lehet negat\xEDv",
    MACHINE_CATEGORY_NOT_FOUND: "G\xE9pkateg\xF3ria nem tal\xE1lhat\xF3",
    HOURLY_RATE_INVALID_DATE: "\xC9rv\xE9nytelen d\xE1tum",
    HOURLY_RATE_PERIOD_ORDER: "A z\xE1r\xF3 d\xE1tum nem lehet kor\xE1bbi a kezd\u0151n\xE9l",
    HOURLY_RATE_NOT_FOUND: "\xD3rad\xEDj konfigur\xE1ci\xF3 nem tal\xE1lhat\xF3",
    LEAVE_OVERLAP: "M\xE1r van szabads\xE1g-k\xE9relmed erre az id\u0151szakra",
    LEAVE_INSUFFICIENT_BALANCE: "Nincs elegend\u0151 szabads\xE1g egyenleged a k\xE9relemhez",
    LEAVE_REQUEST_NOT_FOUND: "A szabads\xE1g-k\xE9relem nem tal\xE1lhat\xF3",
    LEAVE_NOT_PENDING: "A k\xE9relem m\xE1r nem f\xFCgg\u0151ben van",
    EMPLOYEE_PROFILE_NOT_FOUND: "A dolgoz\xF3i profil nem tal\xE1lhat\xF3",
    WARRANTY_ELIGIBLE_LIST_FAILED: "A jogosult munkalapok lek\xE9r\xE9se sikertelen",
    WARRANTY_BATCH_FAILED: "A k\xF6tegelt garanci\xE1lis sz\xE1ml\xE1z\xE1s sikertelen",
    WARRANTY_BATCH_INPUT_REQUIRED: "Hi\xE1nyz\xF3 adatok a k\xF6tegelt sz\xE1ml\xE1z\xE1shoz",
    WARRANTY_BATCH_INVALID_DATE: "\xC9rv\xE9nytelen d\xE1tum a sz\xE1ml\xE1z\xE1si id\u0151szakban",
    WARRANTY_BATCH_PERIOD_ORDER: "A kezd\u0151 d\xE1tum nem lehet k\xE9s\u0151bbi a z\xE1r\xF3 d\xE1tumn\xE1l",
    WARRANTY_ALREADY_INVOICED: "Ez a garanci\xE1lis t\xE9tel m\xE1r ki lett sz\xE1ml\xE1zva",
    WORKSHEET_ID_REQUIRED: "Munkalap-azonos\xEDt\xF3 sz\xFCks\xE9ges",
    PARTNER_DUPLICATE_TAX: "Ezzel az ad\xF3sz\xE1mmal m\xE1r l\xE9tezik partner \u2014 keresd ki a list\xE1b\xF3l.",
    PARTNER_DUPLICATE_CODE: "Partnerk\xF3d-\xFCtk\xF6z\xE9s. Pr\xF3b\xE1ld \xFAjra \u2014 a rendszer \xFAj k\xF3dot gener\xE1l.",
    CALCULATE_FAILED: "A b\xE9rsz\xE1mfejt\xE9si kalkul\xE1ci\xF3 nem fejez\u0151d\xF6tt be. K\xE9rj\xFCk, jelezze az \xFCzemeltet\xE9snek.",
    BOLT_APPROVE_FAILED: "A bolti j\xF3v\xE1hagy\xE1s nem fejez\u0151d\xF6tt be. K\xE9rj\xFCk, jelezze az \xFCzemeltet\xE9snek.",
    CENTRAL_REVIEW_FAILED: "A k\xF6zponti review nem fejez\u0151d\xF6tt be. K\xE9rj\xFCk, jelezze az \xFCzemeltet\xE9snek.",
    FINALIZE_FAILED: "A b\xE9rsz\xE1mfejt\xE9s v\xE9gleges\xEDt\xE9se nem fejez\u0151d\xF6tt be. K\xE9rj\xFCk, jelezze az \xFCzemeltet\xE9snek."
  },
  login: {
    title: "Bejelentkez\xE9s",
    email: "E-mail c\xEDm",
    password: "Jelsz\xF3",
    rememberMe: "Eml\xE9kezz r\xE1m",
    submit: "Bejelentkez\xE9s",
    error: "Bejelentkez\xE9si hiba",
    forgotPassword: "Elfelejtett jelsz\xF3?",
    systemName: "rPI ERP Rendszer",
    testCredentials: "Teszt adatok",
    placeholder: {
      email: "pelda@email.hu"
    },
    errorInvalidCredentials: "Hib\xE1s e-mail-c\xEDm vagy jelsz\xF3.",
    errorSystemTemporary: "\xC1tmeneti rendszerhiba. K\xE9rj\xFCk, pr\xF3b\xE1ld \xFAjra p\xE1r perc m\xFAlva.",
    errorTooManyAttempts: "T\xFAl sok sikertelen pr\xF3b\xE1lkoz\xE1s. K\xE9rj\xFCk, v\xE1rj n\xE9h\xE1ny percet.",
    errorNetwork: "Nem siker\xFClt csatlakozni a szerverhez. Ellen\u0151rizd az internetkapcsolatot."
  },
  rental: {
    loyalty: {
      title: "H\u0171s\xE9gpont bev\xE1lt\xE1s",
      balance: "Egyenleg: {points} pont",
      applied: "{points} pont bev\xE1ltva",
      capReached: "A maxim\xE1lis bev\xE1lthat\xF3 pont a sz\xE1mla 50%-a \u2014 a t\xF6bbi megmarad."
    },
    clone: {
      cta: "Ugyanaz mint m\xFAltkor ({code})",
      label: "Ugyanaz mint m\xFAltkor?",
      lastRental: "Legut\xF3bbi b\xE9rl\xE9s: {code}",
      helper: "Kit\xF6lti a g\xE9peket \xE9s tartoz\xE9kokat, ut\xE1na m\xF3dos\xEDthatsz",
      button: "Ism\xE9tl\xE9s \u2192",
      banner: {
        label: "Mint m\xFAltkor",
        summary: "{equipment} g\xE9p \xB7 {package} csomag",
        helper: "Automatikusan kit\xF6lti a g\xE9peket, csomagokat \xE9s tartoz\xE9kokat. Ut\xE1na b\xE1rmit m\xF3dos\xEDthatsz.",
        apply: "Ism\xE9tl\xE9s",
        dismiss: "\xDCres b\xE9rl\xE9s"
      }
    },
    inlineSign: {
      cta: "Szerz\u0151d\xE9s al\xE1\xEDr\xE1sa most",
      startFailed: "A szerz\u0151d\xE9s el\u0151k\xE9sz\xEDt\xE9se sikertelen."
    },
    pickup: {
      conflictTitle: "A g\xE9p k\xF6zben lefoglalva",
      conflictDesc: "Egy m\xE1sik pult id\u0151k\xF6zben kiadta ezt a g\xE9pet. Friss\xEDtett\xFCk az el\xE9rhet\u0151s\xE9get \u2014 v\xE1lassz m\xE1sik p\xE9ld\xE1nyt vagy pr\xF3b\xE1ld \xFAjra."
    },
    itemDiscount: {
      title: "Per-g\xE9p engedm\xE9ny",
      helper: "T\xE9telenk\xE9nt megadhat\xF3 k\xE9zi engedm\xE9ny. A jogosults\xE1gi plafon (role-cap) felett a rendszer automatikusan visszav\xE1gja.",
      inputAria: "Engedm\xE9ny % \u2014 {name}",
      applied: "Alkalmazva: {pct}%",
      cappedByRole: "role-cap-re v\xE1gva: {pct}%",
      totalDiscount: "\xD6sszes engedm\xE9ny",
      finalAmount: "V\xE9g\xF6sszeg",
      apply: "Engedm\xE9ny alkalmaz\xE1sa",
      noneEntered: "Adj meg legal\xE1bb egy engedm\xE9ny %-ot.",
      applyFailed: "Az engedm\xE9ny alkalmaz\xE1sa sikertelen."
    },
    handover: {
      title: "\xC1llapot-fot\xF3k",
      uploadHandover: "Kiad\xE1skori fot\xF3 felt\xF6lt\xE9se",
      uploadReturn: "Visszav\xE9telkori fot\xF3 felt\xF6lt\xE9se",
      empty: "M\xE9g nincs felt\xF6lt\xF6tt fot\xF3",
      uploading: "Felt\xF6lt\xE9s folyamatban\u2026",
      errorType: "Nem t\xE1mogatott f\xE1jlt\xEDpus. Enged\xE9lyezett: JPEG, PNG, WebP.",
      errorSize: "A f\xE1jl t\xFAl nagy (max {max} MB).",
      compareTitle: "\xC1llapot \xF6sszevet\xE9s (kiad\xE1s \u2194 visszav\xE9tel)",
      compareHint: "A kiad\xE1skori \xE9s visszav\xE9teli fot\xF3k \xF6sszevet\xE9se \u2014 a kiad\xE1skor m\xE1r megl\xE9v\u0151 s\xE9r\xFCl\xE9s nem terheli a b\xE9rl\u0151t a kauci\xF3-elsz\xE1mol\xE1sn\xE1l.",
      handoverColumn: "Kiad\xE1skori \xE1llapot",
      returnColumn: "Visszav\xE9teli \xE1llapot"
    },
    title: "B\xE9rl\xE9s",
    subtitle: "B\xE9rl\xE9s kezel\xE9s \xE9s nyomon k\xF6vet\xE9s",
    fleetCalendar: {
      title: "G\xE9ppark napt\xE1r",
      available: "El\xE9rhet\u0151",
      rented: "B\xE9rbe adva",
      reserved: "Foglalva",
      overdue: "Lej\xE1rt",
      equipment: "Eszk\xF6z",
      noEquipment: "Nincs megjelen\xEDthet\u0151 eszk\xF6z"
    },
    newRental: "\xDAj b\xE9rl\xE9s",
    equipment: "Eszk\xF6z",
    startDate: "Kezd\u0151 d\xE1tum",
    endDate: "Befejez\u0151 d\xE1tum",
    deposit: "Kauci\xF3",
    dailyRate: "Napi d\xEDj",
    returnDate: "Visszahozatal d\xE1tuma",
    returnRental: "B\xE9rl\xE9s visszav\xE9tel",
    status: {
      active: "Akt\xEDv",
      expired: "Lej\xE1rt",
      returned: "Visszav\xE9ve",
      cancelled: "Lemondva"
    },
    contract: "Szerz\u0151d\xE9s",
    period: "Id\u0151szak",
    rentalFee: "B\xE9rleti d\xEDj",
    depositPaid: "Kauci\xF3 befizetve",
    returnDeposit: "Visszaj\xE1r\xF3 kauci\xF3",
    selectReturnRental: "V\xE1lassza ki a visszaveend\u0151 b\xE9rl\xE9st",
    equipmentConditionCheck: "G\xE9p \xE1llapot ellen\u0151rz\xE9se",
    paymentSettlement: "Fizet\xE9si elsz\xE1mol\xE1s",
    returnConfirmation: "Visszav\xE9tel meger\u0151s\xEDt\xE9se",
    activeRentalsCount: "Akt\xEDv b\xE9rl\xE9sek ({count})",
    searchPlaceholder: "Keres\xE9s szerz\u0151d\xE9ssz\xE1m, partner vagy g\xE9p alapj\xE1n...",
    allStatuses: "Minden st\xE1tusz",
    selectEquipment: "Visszaveend\u0151 g\xE9pek kiv\xE1laszt\xE1sa",
    rentalData: "B\xE9rl\xE9si adatok",
    financialSettlement: "P\xE9nz\xFCgyi elsz\xE1mol\xE1s",
    damageBreakdown: "K\xE1rt\xE9r\xEDt\xE9sek g\xE9penk\xE9nti bont\xE1sban",
    deductions: "Levon\xE1sok",
    lateFee: "K\xE9sedelmi d\xEDj ({days} nap)",
    totalDamage: "K\xE1rt\xE9r\xEDt\xE9s \xF6sszesen",
    totalDeductions: "Levon\xE1sok \xF6sszesen:",
    returnableDeposit: "Visszaj\xE1r\xF3 kauci\xF3:",
    summary: "\xD6sszes\xEDt\xE9s",
    returnedEquipment: "Visszavett g\xE9pek:",
    rentalContinues: "B\xE9rl\xE9s folytat\xF3dik:",
    returnable: "Visszaj\xE1r\xF3:",
    partialReturnConfirm: "R\xE9szleges visszav\xE9tel meger\u0151s\xEDt\xE9se",
    returnConfirm: "Visszav\xE9tel meger\u0151s\xEDt\xE9se",
    returnedItems: "Visszavett g\xE9pek",
    continuingItems: "B\xE9rl\xE9s folytat\xF3dik",
    returnableDeposit2: "Visszaj\xE1r\xF3 kauci\xF3",
    cashPayment: "K\xE9szp\xE9nz",
    cardPayment: "K\xE1rtya",
    transferPayment: "\xC1tutal\xE1s",
    cashPaymentLabel: "K\xE9szp\xE9nzben",
    cardPaymentLabel: "K\xE1rty\xE1ra",
    transferPaymentLabel: "\xC1tutal\xE1ssal",
    deductionsLabel: "Levon\xE1sok:",
    searchRentalPlaceholder: "Keres\xE9s b\xE9rl\xE9ssz\xE1m, partner vagy g\xE9p alapj\xE1n...",
    overdueSubtitle: "Lej\xE1rt \xE9s vissza nem hozott g\xE9pek",
    searchPartnerPlaceholder: "Keres\xE9s partner neve, g\xE9p neve alapj\xE1n...",
    loadingActive: "Akt\xEDv b\xE9rl\xE9sek bet\xF6lt\xE9se...",
    returnNotFound: "A b\xE9rl\xE9s nem tal\xE1lhat\xF3 vagy m\xE1r visszavett\xE9k.",
    allRentals: "\xD6sszes b\xE9rl\xE9s",
    partnerNameCol: "Partner neve",
    callPartner: "Partner h\xEDv\xE1sa",
    smsReminder: {
      triggerLabel: "SMS-eml\xE9keztet\u0151",
      title: "SMS-eml\xE9keztet\u0151 k\xFCld\xE9se",
      recipientLabel: "C\xEDmzett",
      messageLabel: "\xDCzenet",
      defaultMessage: "Tisztelt {customerName}! A(z) {equipmentName} b\xE9relt eszk\xF6z visszahoz\xE1si hat\xE1rideje {days} napja lej\xE1rt. K\xE9rj\xFCk, miel\u0151bb hozza vissza, vagy vegye fel vel\xFCnk a kapcsolatot. K\xF6sz\xF6nettel: Kisg\xE9pcentrum",
      send: "K\xFCld\xE9s",
      sending: "K\xFCld\xE9s...",
      close: "Bez\xE1r\xE1s",
      status: {
        sent: "Elk\xFCldve a szolg\xE1ltat\xF3nak",
        blocked: "Nem k\xFCldve \u2014 az SMS-k\xFCld\xE9s jelenleg ki van kapcsolva (gate z\xE1rva)",
        dryRun: "Teszt-m\xF3d: nem k\xFCldve (DRY-RUN), az \xFCzenet napl\xF3zva",
        failed: "Sikertelen k\xFCld\xE9s"
      }
    },
    equipmentNameCol: "G\xE9p megnevez\xE9se",
    expiryDate: "Lej\xE1rat d\xE1tuma",
    daysOverdue: "K\xE9s\xE9s napja",
    rentalCodeCol: "B\xE9rl\xE9si k\xF3d",
    amountCol: "\xD6sszeg",
    lateFeeLabel: "k\xE9sedelmi d\xEDj",
    estimatedLateFeeCol: "V\xE1rhat\xF3 d\xEDj",
    estimatedLateFeeHint: "A mostani visszahoz\xE1sn\xE1l v\xE1rhat\xF3 k\xE9sedelmi d\xEDj (el\u0151n\xE9zet \u2014 a v\xE9gleges \xF6sszeg a visszav\xE9telkor sz\xE1mol\xF3dik)",
    currentDebt: "Kintlev\u0151s\xE9g",
    debtExceedsDeposit: "Kauci\xF3 fedezet t\xFAll\xE9pve!",
    daysLateLabel: "{days} nap k\xE9s\xE9s",
    daysLabel: "{days} nap",
    expired: "Lej\xE1rt:",
    noOverdue: "Nincs kintl\xE9v\u0151s\xE9g",
    allReturned: "Minden g\xE9p id\u0151ben vissza\xE9rkezett!",
    backToRentals: "Vissza a b\xE9rl\xE9sekhez",
    rentalReturn: "B\xE9rl\xE9s visszav\xE9tel",
    unknownEquipment: "Ismeretlen g\xE9p",
    equipmentCount: "{count} g\xE9p",
    multiItemInfo: "T\xF6bb g\xE9pes b\xE9rl\xE9s \u2014 jel\xF6lje ki, mely g\xE9peket veszi vissza. A nem kijel\xF6lt g\xE9pek b\xE9rl\xE9se folytat\xF3dik.",
    earlyReturnLabel: "Korai visszav\xE9tel",
    earlyReturnDays: "Korai visszav\xE9tel \u2014 {actual}/{original} nap",
    originalDiscount: "Eredeti kedvezm\xE9ny:",
    actualDiscount: "T\xE9nyeges kedvezm\xE9ny:",
    discountChanged: "A kedvezm\xE9ny s\xE1v m\xF3dosult \u2014 az \xE1r \xFAjrasz\xE1m\xEDt\xE1sra ker\xFCl.",
    discountUnchanged: "A kedvezm\xE9ny s\xE1v nem v\xE1ltozott \u2014 az eredeti \xE1r \xE9rv\xE9nyes.",
    selectEquipmentReturn: "Visszaveend\u0151 g\xE9pek kiv\xE1laszt\xE1sa",
    selectEquipmentSingle: "Visszaveend\u0151 g\xE9p",
    issuedCondition: "Kiad\xE1skori \xE1llapot:",
    returnConditionLabel: "Visszav\xE9teli \xE1llapot",
    damageDescription: "S\xE9r\xFCl\xE9s le\xEDr\xE1sa",
    damagePlaceholder: "S\xE9r\xFCl\xE9s le\xEDr\xE1sa (ha van)...",
    damageChargeLabel: "K\xE1rt\xE9r\xEDt\xE9s (Ft)",
    damageDescriptionAria: "S\xE9r\xFCl\xE9s le\xEDr\xE1sa: {name}",
    contractLabel: "Szerz\u0151d\xE9s:",
    partnerLabel: "Partner:",
    periodLabel: "Id\u0151szak:",
    rentalFeeLabel: "B\xE9rleti d\xEDj:",
    depositPaidLabel: "Kauci\xF3 befizetve:",
    partialReturnInfo: "R\xE9szleges visszav\xE9tel: {returning} g\xE9p visszav\xE9tele, {continuing} g\xE9p b\xE9rl\xE9se folytat\xF3dik",
    damageBreakdownLabel: "K\xE1rt\xE9r\xEDt\xE9sek g\xE9penk\xE9nti bont\xE1sban",
    noDeductions: "Nincs levon\xE1s",
    depositPaidSummary: "Kauci\xF3 befizetve:",
    totalDeductionsSummary: "Levon\xE1sok \xF6sszesen:",
    depositRefundMethod: "Kauci\xF3 visszafizet\xE9s m\xF3dja",
    optionalNotePlaceholder: "Opcion\xE1lis megjegyz\xE9s...",
    returnNoteAria: "Visszav\xE9teli megjegyz\xE9s",
    returnedEquipmentLabel: "Visszavett g\xE9pek:",
    rentalContinuesLabel: "B\xE9rl\xE9s folytat\xF3dik:",
    returnableLabel: "Visszaj\xE1r\xF3:",
    partialReturnConfirmTitle: "R\xE9szleges visszav\xE9tel meger\u0151s\xEDt\xE9se",
    returnConfirmTitle: "Visszav\xE9tel meger\u0151s\xEDt\xE9se",
    contractSummaryLabel: "Szerz\u0151d\xE9s:",
    partnerSummaryLabel: "Partner:",
    finalizeReturn: "Visszav\xE9tel v\xE9gleges\xEDt\xE9se",
    returnTypePartial: "R\xE9szleges visszav\xE9tel",
    returnTypeFull: "Teljes visszav\xE9tel",
    returnSuccess: "{type} sikeres!\n\nSzerz\u0151d\xE9s: {contract}\nVisszavett g\xE9pek: {equipment}\nKauci\xF3 visszaj\xE1r: {deposit}",
    lateFeeWithDays: "K\xE9sedelmi d\xEDj ({days} nap)",
    lateFeeConfirmLabel: "K\xE9sedelmi d\xEDj:",
    lateFeeBreakdown: "{days} megkezdett nap \xD7 {rate}/nap",
    lateFeeBreakdownCapped: "maximum el\xE9rve ({max})",
    lateFeeModelLegacy: "150%-os napi modell",
    lateFeeWaived: "k\xE9sedelmi d\xEDj elengedve",
    damageConfirmLabel: "K\xE1rt\xE9r\xEDt\xE9s:",
    errorPrefix: "Hiba: {message}",
    daysDelayLabel: "{days} nap k\xE9s\xE9s",
    depositLabel: "Kauci\xF3:",
    lateFeeAmount: "K\xE9sedelmi d\xEDj:",
    quantityLabel: "Mennyis\xE9g: {count} db",
    tierLabels: {
      hourly: "\xD3r\xE1nk\xE9nt",
      daily: "Naponta",
      weekly: "Hetente",
      monthly: "Havonta"
    },
    startTime: "Kezd\xE9s id\u0151pontja",
    endTime: "Befejez\xE9s id\u0151pontja",
    hourlyBilling: "\xD3r\xE1nk\xE9nti sz\xE1ml\xE1z\xE1s",
    hourlyRate: "\xD3rad\xEDj",
    returnTime: "Visszahozatal id\u0151pontja",
    rentalNotes: "Megjegyz\xE9s a b\xE9rl\xE9shez",
    rentalNotesPlaceholder: "Opcion\xE1lis megjegyz\xE9s a b\xE9rl\xE9shez...",
    quantityPcs: "Mennyis\xE9g: {count} db",
    daysAgo: "{days} napja lej\xE1rt",
    daysLeft: "{days} nap van h\xE1tra",
    daysUntilExpiry: "M\xE9g {days} nap a lej\xE1ratig",
    expiresToday: "Ma j\xE1r le!",
    extension: "Hosszabb\xEDt\xE1s",
    extensionDialog: {
      additionalDays: "Plusz napok",
      currentExpiry: "Jelenlegi lej\xE1rat",
      dateError: "Az \xFAj d\xE1tumnak a jelenlegi lej\xE1rat ut\xE1nra kell esnie",
      day: "nap",
      days: "nap",
      discountTierChange: "Kedvezm\xE9ny s\xE1v v\xE1ltoz\xE1s",
      newExpiryDate: "\xDAj lej\xE1rati d\xE1tum",
      priceDisclaimer: "A v\xE9gleges \xE1r a b\xE9rl\xE9si d\xEDj kalkul\xE1ci\xF3 alapj\xE1n ker\xFCl meg\xE1llap\xEDt\xE1sra",
      reasonLabel: "Hosszabb\xEDt\xE1s indoka (opcion\xE1lis)",
      reasonPlaceholder: "Mi\xE9rt sz\xFCks\xE9ges a hosszabb\xEDt\xE1s...",
      surcharge: "Fel\xE1r",
      surchargeWithVat: "Fel\xE1r \xC1F\xC1-val",
      title: "B\xE9rl\xE9s hosszabb\xEDt\xE1sa"
    },
    extensionError: "Hiba a hosszabb\xEDt\xE1s sor\xE1n",
    financialSummary: "P\xE9nz\xFCgyi \xF6sszes\xEDt\xE9s",
    history: "El\u0151zm\xE9nyek",
    notFound: "B\xE9rl\xE9s nem tal\xE1lhat\xF3",
    notFoundDescription: "A keresett b\xE9rl\xE9s nem l\xE9tezik vagy t\xF6r\xF6lve lett",
    overdueAlert: "{days} napja lej\xE1rt \u2014 k\xE9sedelmi d\xEDj sz\xE1m\xEDt\xF3dik!",
    partnerDetails: "Partner adatok",
    printContract: "Szerz\u0151d\xE9s nyomtat\xE1s",
    quickInfo: "Gyors inf\xF3",
    remaining: "H\xE1tral\xE9v\u0151 id\u0151",
    rentedEquipment: "B\xE9relt g\xE9p",
    sendEmail: "K\xFCld\xE9s emailben",
    timeline: {
      contractCreated: "Szerz\u0151d\xE9s l\xE9trehozva",
      depositPaid: "Kauci\xF3 befizetve",
      rentalStarted: "B\xE9rl\xE9s elind\xEDtva"
    },
    totalRentalFee: "B\xE9rleti d\xEDj \xF6sszesen",
    stepWizard: {
      navLabel: "B\xE9rl\xE9s l\xE9p\xE9sei",
      step1: "Partner",
      step2: "G\xE9pek",
      step3: "Id\u0151szak",
      step4: "Szerz\u0151d\xE9s",
      stepAria: "{n}. l\xE9p\xE9s",
      stepDoneAria: "k\xE9sz"
    },
    finalizeChecklist: {
      title: "V\xE9gleges\xEDt\xE9s el\u0151tt",
      allReady: "Minden k\xE9sz a kiad\xE1shoz",
      incomplete: "M\xE9g {count} pont hi\xE1nyzik",
      itemPartner: "Partner kiv\xE1lasztva",
      itemEquipment: "G\xE9p a kos\xE1rban",
      itemSchedule: "B\xE9rl\xE9si id\u0151szak megadva",
      itemPayment: "Fizet\xE9si m\xF3d kiv\xE1lasztva",
      doneAria: "k\xE9sz",
      missingAria: "hi\xE1nyzik",
      fix: "Jav\xEDt\xE1s \u2192"
    },
    wizard: {
      draftRef: "V\xE1zlat",
      ctx: {
        renter: "B\xC9RL\u0150",
        machines: "G\xC9PEK",
        accCount: "{count} tartoz\xE9k",
        payCard: "Bankk\xE1rtya",
        payCash: "K\xE9szp\xE9nz",
        payTransfer: "\xC1tutal\xE1s"
      },
      depositPaidLabel: "Kauci\xF3 befizetve",
      depositPaidYes: "Az \xFCgyf\xE9l most fizeti",
      depositPaidNo: "K\xE9s\u0151bb fizeti vagy nem sz\xFCks\xE9ges",
      title: "B\xE9rl\xE9s ind\xEDt\xE1sa",
      subtitle: "\xDAj b\xE9rl\xE9s l\xE9trehoz\xE1sa",
      stepPartnerDesc: "B\xE9rl\u0151 kiv\xE1laszt\xE1sa",
      stepCostBearerTitle: "K\xF6lts\xE9gvisel\u0151",
      stepCostBearerDesc: "Ki fizet?",
      stepEquipmentTitle: "B\xE9rg\xE9p",
      stepEquipmentDesc: "G\xE9p kiv\xE1laszt\xE1sa",
      stepDetailsDesc: "Id\u0151szak \xE9s \xE1r",
      stepSummaryTitle: "\xD6sszegz\xE9s",
      stepSummaryDesc: "V\xE9gleges\xEDt\xE9s",
      missingData: "Hi\xE1nyz\xF3 adatok",
      missingDataDesc: "K\xE9rj\xFCk t\xF6ltse ki az \xF6sszes k\xF6telez\u0151 mez\u0151t",
      rentalCreated: "B\xE9rl\xE9s sikeresen l\xE9trehozva!",
      contractNumber: "Szerz\u0151d\xE9s sz\xE1m: {number}",
      rentalCreateFailed: "B\xE9rl\xE9s l\xE9trehoz\xE1sa sikertelen",
      unknownError: "Ismeretlen hiba t\xF6rt\xE9nt",
      cancelConfirm: "Biztosan megszak\xEDtja a b\xE9rl\xE9s ind\xEDt\xE1s\xE1t?",
      myposTransaction: "MyPOS tranzakci\xF3...",
      creatingRental: "B\xE9rl\xE9s l\xE9trehoz\xE1sa...",
      finalizeRental: "B\xE9rl\xE9s v\xE9gleges\xEDt\xE9se",
      selectPartner: "B\xE9rl\u0151 (f\u0151partner) kiv\xE1laszt\xE1sa",
      selectPartnerDesc: "Keresse meg vagy v\xE1lassza ki a b\xE9rl\u0151 partnert",
      searchPartnerPlaceholder: "Keres\xE9s n\xE9v, email, telefon, ad\xF3sz\xE1m, v\xE1ros vagy igazolv\xE1ny alapj\xE1n...",
      partnersLoading: "Partnerek bet\xF6lt\xE9se...",
      partnersLoadError: "Hiba a partnerek bet\xF6lt\xE9sekor: {message}",
      noPartnerResults: "Nincs tal\xE1lat a keres\xE9sre",
      createNewPartner: "+ \xDAj partner l\xE9trehoz\xE1sa",
      selectedPartner: "Kiv\xE1lasztott partner: {name}",
      trustedStatus: "T\xF6rzsvev\u0151",
      warningStatus: "Figyelmeztet\u0151",
      blockedStatus: "Tiltott",
      inactiveStatus: "Inakt\xEDv",
      phoneLabel: "Tel:",
      emailLabel: "Email:",
      taxNumberLabel: "Ad\xF3sz:",
      idCardLabel: "Ig.sz:",
      costBearerLabel: "K\xF6lts\xE9gvisel\u0151:",
      balanceLabel: "Egyenleg:",
      loyaltyPointsUnit: "pont",
      totalRentalsLabel: "B\xE9rl\xE9sek sz\xE1ma:",
      lastRentalLabel: "Utols\xF3 b\xE9rl\xE9s:",
      costBearerTitle: "K\xF6lts\xE9gvisel\u0151",
      costBearerDesc: "Ki fizeti a b\xE9rleti d\xEDjat?",
      partnerPaysSelf: "Partner fizet saj\xE1t maga",
      partnerPaysDesc: "{name} fizeti a b\xE9rleti d\xEDjat",
      costBearerPays: "K\xF6lts\xE9gvisel\u0151 fizet:",
      costBearerPaysDesc: "M\xE1sik partner vagy c\xE9g fizeti a b\xE9rleti d\xEDjat",
      selectCostBearer: "V\xE1lassza ki a k\xF6lts\xE9gvisel\u0151t:",
      knownCostBearers: "Ismert k\xF6lts\xE9gvisel\u0151k",
      searchPartner: "Partner keres\xE9se...",
      noCostBearerPartner: "Nincs el\xE9rhet\u0151 k\xF6lts\xE9gvisel\u0151 partner",
      defaultCostBearer: "Alap\xE9rtelmezett k\xF6lts\xE9gvisel\u0151:",
      partnerPaysSelfSummary: "A partner saj\xE1t maga fizet: {name}",
      selectEquipmentTitle: "B\xE9rg\xE9pek kiv\xE1laszt\xE1sa",
      selectEquipmentDesc: "V\xE1lassza ki a b\xE9rbeadand\xF3 g\xE9peket",
      searchEquipmentPlaceholder: "Keres\xE9s n\xE9v, cikksz\xE1m, sorozatsz\xE1m, m\xE1rka...",
      allFilter: "Mind ({count})",
      cart: "Kos\xE1r ({items} t\xE9tel, {total} db)",
      dailyTotal: "Napi \xF6sszeg: {amount}",
      clearCart: "Kos\xE1r \xFCr\xEDt\xE9se",
      perDay: "/nap",
      removeItem: "Elt\xE1vol\xEDt\xE1s",
      decrease: "Cs\xF6kkent\xE9s",
      increase: "N\xF6vel\xE9s",
      totalDeposit: "\xD6sszes\xEDtett kauci\xF3:",
      equipmentLoading: "B\xE9rg\xE9pek bet\xF6lt\xE9se...",
      equipmentLoadError: "Hiba a b\xE9rg\xE9pek bet\xF6lt\xE9sekor: {error}",
      noEquipmentResults: "Nincs el\xE9rhet\u0151 g\xE9p a sz\u0171r\xE9si felt\xE9teleknek megfelel\u0151en",
      itemCode: "Cikksz\xE1m:",
      brand: "M\xE1rka:",
      condition: "\xC1llapot:",
      categoryLabel: "Kateg\xF3ria:",
      dailyPrice: "Napi",
      weeklyPrice: "Heti",
      monthlyPrice: "Havi",
      inCart: "Kos\xE1rban: {count} db",
      addOne: "+1 db",
      accessoriesLoading: "Tartoz\xE9kok bet\xF6lt\xE9se...",
      accessoriesLabel: "Tartoz\xE9kok:",
      requiredAccessory: "(k\xF6telez\u0151)",
      accessoryValue: "Tartoz\xE9k \xE9rt\xE9k:",
      detailsTitle: "B\xE9rl\xE9s r\xE9szletei",
      detailsDesc: "Adja meg a b\xE9rl\xE9si id\u0151szakot \xE9s ellen\u0151rizze az \xE1rakat",
      selectedItems: "Kiv\xE1lasztott t\xE9telek",
      rentalPeriod: "B\xE9rl\xE9si id\u0151szak",
      datePicker: {
        chip: {
          tomorrow: "Holnap",
          twoDays: "2 nap",
          weekend: "H\xE9tv\xE9ge",
          oneWeek: "1 h\xE9t",
          custom: "Egyedi"
        }
      },
      scannerActive: "Szkenner akt\xEDv",
      scannerActiveHint: "USB / Bluetooth vonalk\xF3d-olvas\xF3 keyboard wedge m\xF3dban",
      accessoryDrawer: {
        title: "Tartoz\xE9kok \u2014 {name}",
        description: "Tartoz\xE9k kiv\xE1laszt\xE1sa a g\xE9phez. Kereshet\u0151, sz\u0171rhet\u0151 lista.",
        searchPlaceholder: "Keres\xE9s n\xE9vben, cikksz\xE1mban...",
        requiredOnly: "Csak k\xF6telez\u0151",
        close: "Vissza",
        addAccessory: "Hozz\xE1ad",
        noAccessories: "Nincs tal\xE1lat",
        isRequired: "K\xF6telez\u0151 tartoz\xE9k",
        valueLabel: "\xC9rt\xE9k: {value}",
        loadingAccessories: "Tartoz\xE9kok bet\xF6lt\xE9se...",
        moreAccessoriesBtn: "T\xF6bb tartoz\xE9k",
        prevPage: "El\u0151z\u0151 oldal",
        nextPage: "K\xF6vetkez\u0151 oldal"
      },
      collapseAll: "Mind \xF6sszecsuk",
      collapseAllHint: "Minden panel becsuk\xE1sa \u2014 \xE1ttekint\xE9s",
      expandInvalid: "Csak hib\xE1s nyit",
      expandInvalidHint: "Csak a hi\xE1nyos paneleket nyitja ki \u2014 f\xF3kusz a jav\xEDtand\xF3ra",
      scanSuccess: "{name} a kos\xE1rba",
      scanError: "Beolvas\xE1si hiba",
      scanUnavailable: "Nem el\xE9rhet\u0151",
      scanMatchedField: {
        qrCode: "QR k\xF3d alapj\xE1n",
        factoryBarcode: "Vonalk\xF3d alapj\xE1n",
        equipmentCode: "G\xE9pk\xF3d alapj\xE1n",
        serialNumber: "Sz\xE9riasz\xE1m alapj\xE1n"
      },
      returnDateLabel: "Visszahozatal d\xE1tuma",
      startTimeLabel: "Kezd\u0151 id\u0151pont",
      returnTimeLabel: "Visszahozatal id\u0151pontja",
      hourlyBilling: "\xD3rad\xEDjas sz\xE1m\xEDt\xE1s",
      hourlyBillingDesc: "\xD3ra alap\xFA d\xEDjaz\xE1s az adott napi b\xE9rl\xE9shez",
      durationHours: "{hours} \xF3ra",
      durationDays: "{days} nap",
      priceCalc: "\xC1rkalkul\xE1ci\xF3",
      duration: "Id\u0151tartam",
      pricingType: "D\xEDjaz\xE1s t\xEDpusa",
      netRentalFee: "Nett\xF3 b\xE9rleti d\xEDj",
      discount: "Kedvezm\xE9ny",
      discountPercent: "Kedvezm\xE9ny ({percent}%)",
      vat27: "\xC1FA (27%)",
      rentalFeeTotal: "B\xE9rleti d\xEDj \xF6sszesen",
      payNow: "Fizetend\u0151 most",
      payNowBreakdown: "(B\xE9rleti d\xEDj: {fee} + Kauci\xF3: {deposit})",
      selectDatesForCalc: "V\xE1lassza ki a d\xE1tumokat az \xE1rkalkul\xE1ci\xF3hoz",
      breakdownTitle: "D\xEDjsz\xE1m\xEDt\xE1s r\xE9szletei",
      breakdownDate: "D\xE1tum",
      breakdownDay: "Nap",
      breakdownType: "T\xEDpus",
      breakdownValue: "\xC9rt\xE9k",
      breakdownWorkday: "Munkanap",
      breakdownSunday: "Vas\xE1rnap",
      breakdownHoliday: "\xDCnnepnap",
      breakdownFullDay: "1 nap",
      breakdownHalfDay: "\xBD nap",
      breakdownCalendarDays: "Napt\xE1ri napok",
      breakdownBillableDays: "Sz\xE1ml\xE1zhat\xF3 napok",
      breakdownWeeklyDiscount: "Heti kedvezm\xE9ny (-{days} nap)",
      breakdownPayableDays: "Fizetend\u0151 napok",
      breakdownDailyRate: "Napi d\xEDj",
      breakdownMonthlyNote: "{days} nap \u2192 {billable} fizetend\u0151 nap (havi kedvezm\xE9ny)",
      perHour: "/\xF3ra",
      rentalNotesAriaLabel: "Megjegyz\xE9s a b\xE9rl\xE9shez",
      summaryTitle: "\xD6sszegz\xE9s",
      summaryDesc: "Ellen\u0151rizze a b\xE9rl\xE9s adatait \xE9s hagyja j\xF3v\xE1",
      partnerData: "Partner adatai",
      equipmentCount: "B\xE9rg\xE9pek ({count} db)",
      returnLabel: "Visszahozatal",
      durationLabel: "Id\u0151tartam",
      paymentSummary: "Fizet\xE9si \xF6sszes\xEDt\u0151",
      grossRentalFee: "B\xE9rleti d\xEDj brutt\xF3",
      totalToPay: "FIZETEND\u0150 \xD6SSZESEN",
      selectPaymentMethod: "Fizet\xE9si m\xF3d v\xE1laszt\xE1sa:",
      bankCard: "Bankk\xE1rtya (MyPOS)",
      companyOnly: "(csak c\xE9gek r\xE9sz\xE9re)",
      selectPaymentRequired: "V\xE1lasszon fizet\xE9si m\xF3dot a folytat\xE1shoz",
      disclaimer: "A b\xE9rl\xE9s v\xE9gleges\xEDt\xE9s\xE9vel a partner elfogadja a b\xE9rleti szerz\u0151d\xE9s felt\xE9teleit. A kauci\xF3 a g\xE9p s\xE9rtetlen visszahozatala ut\xE1n visszaj\xE1r.",
      tierHourly: "\xD3rad\xEDjas",
      tierDaily: "Napi d\xEDjaz\xE1s",
      tierWeekly: "Heti d\xEDjaz\xE1s",
      tierMonthly: "Havi d\xEDjaz\xE1s",
      contractCreated: "Szerz\u0151d\xE9s sz\xE1m: {contractNumber}. {transactionInfo}",
      suggestedAccessories: "Javasolt tartoz\xE9kok",
      noSuggestedPackages: "Nincs javasolt tartoz\xE9k csomag",
      selectAccessoryPackage: "Kiv\xE1laszt\xE1s",
      removeAccessoryPackage: "Elt\xE1vol\xEDt\xE1s",
      included: "Ingyenes",
      consignment: "Bizom\xE1ny",
      accessoryPackageSelected: "Tartoz\xE9k csomag kiv\xE1lasztva",
      packages: {
        stepTitle: "Csomagok",
        stepDesc: "Csomagok hozz\xE1rendel\xE9se b\xE9rg\xE9penk\xE9nt",
        intro: "B\xE9rg\xE9penk\xE9nt t\xF6bb csomag is hozz\xE1adhat\xF3 (pl. biztons\xE1gi + karbantart\xE1si).",
        emptyCart: "El\u0151sz\xF6r adjon hozz\xE1 b\xE9rg\xE9pet a kos\xE1rhoz.",
        qtyLabel: "{qty} db",
        addPackage: "Csomag hozz\xE1ad\xE1sa",
        noneAvailable: "Ehhez a b\xE9rg\xE9phez nincs el\xE9rhet\u0151 csomag.",
        duplicateTitle: "Csomag m\xE1r hozz\xE1adva",
        duplicateDesc: "A(z) {name} m\xE1r szerepel \u2014 t\xF6bb k\xE9szlet ugyanabb\xF3l enged\xE9lyezett.",
        removeAria: "{name} csomag elt\xE1vol\xEDt\xE1sa"
      },
      v2: {
        addPackageButton: "Csomag hozz\xE1ad\xE1sa",
        cartCount: "{count} db",
        cartCountFiltered: "{shown} / {total} db",
        cartFilteredEmpty: "A sz\u0171r\u0151 egyetlen kos\xE1relemnek sem felel meg. Vegy\xE9l le sz\u0171r\u0151t a megjelen\xEDt\xE9shez.",
        cartTitle: "B\xE9rg\xE9p kos\xE1r",
        categoryHeader: "Kateg\xF3ria",
        clearFilters: "T\xF6rl\xE9s",
        closePickerAriaLabel: "Bez\xE1r\xE1s",
        combinedStepTitle: "B\xE9rg\xE9p + csomag",
        conditionHeader: "\xC1llapot",
        headerSubtitle: "Multi-machine b\xE9rl\xE9s 3-oszlopos elrendez\xE9sben",
        search: {
          label: "B\xE9rg\xE9p keres\xE9se",
          placeholder: "N\xE9v, gy\xE1ri sz\xE1m vagy kateg\xF3ria keres\xE9se\u2026",
          hint: "Kezdj el \xEDrni a kos\xE1rhoz hozz\xE1ad\xE1shoz.",
          loading: "Keres\xE9s\u2026",
          noResults: 'Nincs tal\xE1lat erre: "{query}"',
          addAction: "Kos\xE1rba",
          addedToCart: "Hozz\xE1adva: {name}",
          alreadyInCart: "{name} m\xE1r a kos\xE1rban",
          alreadyAdded: "\u2713 Hozz\xE1adva",
          clearAriaLabel: "Keres\xE9s t\xF6rl\xE9se",
          noFilterMatch: "Nincs tal\xE1lat a kiv\xE1lasztott sz\u0171r\u0151kkel."
        },
        deferredFilters: "Hamarosan:",
        duplicateDesc: 'A(z) "{name}" csomag m\xE1r hozz\xE1 van rendelve ehhez a g\xE9phez. Hozz\xE1adva \xFAjra.',
        duplicateTitle: "M\xE1r hozz\xE1adva",
        emptyCart: "Adj hozz\xE1 b\xE9rg\xE9peket a kos\xE1rhoz.",
        equipmentCount: "B\xE9rg\xE9p",
        filtersTitle: "Sz\u0171r\u0151k",
        headerTitle: "B\xE9rl\xE9s var\xE1zsl\xF3 \u2014 g\xE9pek \xE9s csomagok",
        packageCount: "Csomag",
        packageRemoveAriaLabel: "{name} csomag elt\xE1vol\xEDt\xE1sa",
        packagesEmpty: "Nincs csomag hozz\xE1rendelve",
        packagesLoading: "Csomagok bet\xF6lt\xE9se\u2026",
        packagesNoneAvailable: "Nincs el\xE9rhet\u0151 csomag",
        pricingDeposit: "Kauci\xF3",
        pricingDiscount: "Kedvezm\xE9ny",
        pricingEmpty: "Adj meg b\xE9rg\xE9pet \xE9s id\u0151szakot az \xE1raz\xE1shoz.",
        pricingError: "Az \xE1raz\xE1s nem t\xF6lthet\u0151 be.",
        pricingGrandTotal: "Brutt\xF3",
        pricingHeader: "\xC1raz\xE1s",
        pricingLoading: "\xC1raz\xE1s sz\xE1m\xEDt\xE1sa\u2026",
        pricingSubtotal: "Nett\xF3",
        pricingVat: "\xC1FA",
        removeAriaLabel: "{name} elt\xE1vol\xEDt\xE1sa",
        removeButton: "Elt\xE1vol\xEDt\xE1s",
        summaryDeferred: "Hamarosan: napi/heti bont\xE1s, akci\xF3 kupon, fizet\xE9si m\xF3d el\u0151n\xE9zet.",
        summaryTitle: "\xD6sszegz\xE9s",
        legend: {
          title: "Jelmagyar\xE1zat",
          free: "Ingyenes",
          rentable: "B\xE9relhet\u0151",
          consignment: "Bizom\xE1nyos"
        },
        itemQty: "{qty} db",
        itemQtyInc: "N\xF6vel\xE9s",
        itemQtyDec: "Cs\xF6kkent\xE9s",
        breakdownHeader: "Napi bont\xE1s",
        breakdownWorkdays: "Munkanap",
        breakdownSundays: "Vas\xE1rnap",
        breakdownHolidays: "\xDCnnepnap",
        breakdownBillable: "Sz\xE1ml\xE1zott nap",
        breakdownWeeklyDiscount: "Heti kedvezm\xE9ny (nap)",
        periodLabel: "B\xE9rl\xE9si id\u0151szak",
        editPeriod: "M\xF3dos\xEDt",
        perMachineHeader: "G\xE9penk\xE9nti bont\xE1s",
        unnamedItem: "Tartoz\xE9k",
        detail: {
          railTitle: "B\xE9relt g\xE9pek",
          railCount: "{n} g\xE9p",
          railEmpty: "M\xE9g nincsenek g\xE9pek a kos\xE1rban.",
          addMachineButton: "+ G\xE9p hozz\xE1ad\xE1sa",
          activeEmpty: "Adj hozz\xE1 b\xE9rg\xE9pet a kos\xE1rhoz a r\xE9szletek megtekint\xE9s\xE9hez.",
          detailHeader: "G\xE9p r\xE9szletei",
          detailSku: "K\xF3d",
          detailDailyRate: "Napid\xEDj",
          detailPackageSection: "Csomag",
          accessoryPlaceholder: "\u2014 Tartoz\xE9kok (slice-2) \u2014",
          legendTitle: "Jelmagyar\xE1zat",
          legendFreeHint: "csomagban benne van",
          legendRentableHint: "napid\xEDjas, csak a felhaszn\xE1lt napok\xE9rt",
          legendConsignHint: "csak a felhaszn\xE1ltat fizeted",
          lineTotal: "V\xE9g\xF6sszeg",
          freeInPkg: "ingyen a csomagban",
          rentableUnit: "Ft/nap",
          consignUnit: "Ft/db (bizom\xE1nyos)",
          calcPeriodTitle: "Id\u0151szak",
          calcDays: "{n} nap",
          calcPerMachineTitle: "G\xE9penk\xE9nti bont\xE1s",
          calcMachineRent: "{rate} Ft/nap \xD7 {days} nap",
          calcEstTotal: "Becs\xFClt \xF6sszeg",
          calcNote: "{m} g\xE9p \xB7 {d} nap",
          calcNoPricing: "\xC1ll\xEDts be id\u0151szakot az \xE1raz\xE1shoz.",
          accCatalogTitle: "Tartoz\xE9kok",
          accCatalogLoading: "Tartoz\xE9kok bet\xF6lt\xE9se\u2026",
          accCatalogEmpty: "Nincsenek tartoz\xE9kok ehhez a g\xE9phez.",
          accCatalogError: "Hiba a tartoz\xE9kok bet\xF6lt\xE9sekor.",
          accTabAll: "Mind",
          accStockN: "{n} db rakt\xE1ron",
          accFree: "ingyenes",
          addMachineDialogTitle: "G\xE9p hozz\xE1ad\xE1sa",
          addMachineSearchPlaceholder: "G\xE9pn\xE9v, k\xF3d keres\xE9se\u2026",
          addMachineHint: "Kezdj el g\xE9pnevet vagy k\xF3dot \xEDrni.",
          addMachineAddAction: "Kos\xE1rba"
        }
      },
      summary: {
        rental: "B\xE9rleti d\xEDj",
        deposit: "Kauci\xF3",
        total: "Fizetend\u0151",
        consignment: "Bizom\xE1nyos"
      },
      reservationTimer: {
        label: "Foglal\xE1s v\xE9gleges\xEDt\xE9se:",
        expired: "A foglal\xE1si id\u0151 lej\xE1rt \u2014 a v\xE9gleges\xEDt\xE9s tov\xE1bbra is lehets\xE9ges.",
        hint: "Vizu\xE1lis eml\xE9keztet\u0151 (nem k\xE9szlet-foglal\xE1s)"
      },
      selectedBadge: "Kiv\xE1lasztva",
      calendar: {
        prevMonth: "El\u0151z\u0151 h\xF3nap",
        nextMonth: "K\xF6vetkez\u0151 h\xF3nap"
      }
    },
    checkout: {
      grant: {
        toggle: {
          label: "A b\xE9rl\u0151 meghatalmaz valakit \xE1tv\xE9telre",
          adrHint: "(grantor = b\xE9rl\u0151 \u2014 ADR-124)",
          desc: "PERMANENT meghatalmaz\xE1s visszavon\xE1sig \xE9rv\xE9nyes. ONE_TIME pap\xEDrfelt\xF6lt\xE9st ig\xE9nyel."
        },
        section: {
          title: "Meghatalmazott"
        },
        loading: "Meghatalmaz\xE1sok bet\xF6lt\xE9se...",
        materializeFailed: "A meghatalmaz\xE1s l\xE9trehoz\xE1sa sikertelen \u2014 a b\xE9rl\xE9s r\xF6gz\xEDtve, de a meghatalmaz\xE1st manu\xE1lisan kell felvenni a b\xE9rl\xE9s oldal\xE1n.",
        permanentDropdown: {
          intro: "Akt\xEDv meghatalmaz\xE1sok \u2014 v\xE1lassz a b\xE9rl\u0151 ({name}) r\xE9sz\xE9r\u0151l:",
          validFrom: "\xE9rv\xE9nyes {date} \xF3ta"
        },
        empty: {
          title: "Nincs akt\xEDv permanens meghatalmaz\xE1s",
          desc: "{name} r\xE9sz\xE9r\u0151l jelenleg nincs PERMANENT grant.",
          tip: 'Tipp: permanens meghatalmaz\xE1st a Partner oldalon a \u201EMeghatalmaz\xE1s" tab alatt vehetsz fel.'
        },
        oneTime: {
          cta: "\xDAj egyszeri meghatalmaz\xE1s",
          pendingHint: "A meghatalmaz\xE1s a b\xE9rl\xE9s v\xE9gleges\xEDt\xE9sekor j\xF6n l\xE9tre."
        },
        oneTimeDialog: {
          title: "\xDAj egyszeri meghatalmaz\xE1s",
          grantor: "B\xE9rl\u0151 (grantor): {name}",
          nameLabel: "\xC1tvev\u0151 neve",
          namePlaceholder: "pl. Kov\xE1cs J\xE1nos",
          idCardLabel: "Szem\xE9lyi igazolv\xE1ny sz\xE1m",
          idCardPlaceholder: "pl. 123456AB",
          phoneLabel: "Telefonsz\xE1m",
          phonePlaceholder: "+36 ...",
          gracePeriodWarning: "Pap\xEDr-meghatalmaz\xE1s felt\xF6lt\xE9se Sprint 18+ scope-ban. Most 24 \xF3r\xE1s t\xFCrelmi id\u0151vel l\xE9trej\xF6n \u2014 fel kell t\xF6lteni az okm\xE1nyt 24 \xF3r\xE1n bel\xFCl, k\xFCl\xF6nben a rendszer automatikusan visszavonja.",
          submit: "Meghatalmaz\xE1s l\xE9trehoz\xE1sa",
          submitting: "Ment\xE9s...",
          errors: {
            nameRequired: "\xC1tvev\u0151 neve k\xF6telez\u0151",
            noRental: "Nincs b\xE9rl\xE9s-kontextus \u2014 adj hozz\xE1 legal\xE1bb egy b\xE9rg\xE9pet el\u0151bb.",
            documentRequired: "Pap\xEDr-meghatalmaz\xE1s k\xF6telez\u0151",
            validationFailed: "Hib\xE1s \xE1tvev\u0151 adatok",
            network: "H\xE1l\xF3zati hiba, pr\xF3b\xE1ld \xFAjra"
          }
        }
      },
      subheader: {
        connectionLabel: "Kapcsolat",
        renter: {
          label: "b\xE9rel"
        },
        payer: {
          label: "fizet"
        },
        grantee: {
          label: "\xE1tvesz"
        }
      }
    },
    category: {
      handTools: "K\xE9zi szersz\xE1mok",
      electricMachines: "Elektromos g\xE9pek",
      outdoorMachines: "K\xFClt\xE9ri g\xE9pek",
      other: "Egy\xE9b",
      construction: "\xC9p\xEDt\u0151ipari",
      cleaning: "Takar\xEDt\xF3g\xE9p",
      machinery: "Munkag\xE9p",
      handTool: "K\xE9ziszersz\xE1m",
      measurement: "M\xE9r\u0151eszk\xF6z",
      safety: "Munkav\xE9delmi"
    },
    equipmentStatus: {
      available: "Szabad",
      rented: "Kiadva",
      inService: "Szervizben",
      reserved: "Foglalt"
    },
    condition: {
      excellent: "Kiv\xE1l\xF3",
      good: "J\xF3",
      fair: "Megfelel\u0151",
      poor: "Gyenge",
      damaged: "S\xE9r\xFClt",
      damagedUsable: "S\xE9r\xFClt \u2014 kiadhat\xF3",
      damagedService: "S\xE9r\xFClt \u2192 Szerv\xEDz",
      incomplete: "Hi\xE1nyos",
      new: "\xDAj",
      used: "Haszn\xE1lt"
    },
    sendToService: "Szerv\xEDzbe k\xFCld\xE9s",
    serviceWorksheetCreated: "Munkalap l\xE9trehozva: {code}",
    serviceWorksheetError: "Munkalap l\xE9trehoz\xE1sa sikertelen",
    damagedServiceInfo: "Ez a g\xE9p nem adhat\xF3 ki tov\xE1bb \u2014 azonnal szervizbe kell k\xFCldeni.",
    damagedServiceDefaultFault: "B\xE9rl\xE9s ut\xE1ni s\xE9r\xFCl\xE9s \u2014 szerviz sz\xFCks\xE9ges",
    crossSell: {
      addProduct: "Term\xE9k hozz\xE1ad\xE1sa",
      additionalItems: "Hozz\xE1adott term\xE9kek",
      rentalFee: "B\xE9rleti d\xEDj",
      productTotal: "Term\xE9k \xF6sszesen",
      productVat: "Term\xE9k \xC1FA (27%)",
      searchPlaceholder: "Keres\xE9s n\xE9v vagy cikksz\xE1m alapj\xE1n...",
      noResults: "Nincs tal\xE1lat",
      stock: "K\xE9szlet",
      depositNote: "csak b\xE9rleti d\xEDjra",
      net: "nett\xF3",
      gross: "brutt\xF3",
      subtotal: "Term\xE9kek \xF6sszesen",
      remove: "Elt\xE1vol\xEDt\xE1s",
      quantity: "Mennyis\xE9g",
      emptyCart: "M\xE9g nem adott hozz\xE1 term\xE9ket",
      unitPrice: "Egys\xE9g\xE1r",
      lineTotal: "\xD6sszesen",
      searching: "Keres\xE9s...",
      add: "Hozz\xE1ad\xE1s",
      pcs: "db"
    },
    confirmPickup: "\xC1tv\xE9tel + Kauci\xF3 r\xF6gz\xEDt\xE9s",
    packageSelect: {
      modeLabel: "B\xE9rl\xE9s m\xF3dja",
      individual: "Egyedi g\xE9pek",
      package: "Csomag",
      individualDesc: "G\xE9pek egyenk\xE9nti kiv\xE1laszt\xE1sa",
      packageDesc: "El\u0151re \xF6ssze\xE1ll\xEDtott csomag kiv\xE1laszt\xE1sa",
      searchPackage: "Csomag keres\xE9se...",
      loadingPackages: "Csomagok bet\xF6lt\xE9se...",
      noPackages: "Nincs el\xE9rhet\u0151 b\xE9rl\xE9si csomag",
      packageContents: "Csomag tartalma",
      included: "TARTOZ\xC9K",
      rental: "B\xC9RBE",
      consignment: "BIZOM\xC1NY",
      optional: "Opcion\xE1lis",
      quantity: "Mennyis\xE9g",
      unitPrice: "Egys\xE9g\xE1r",
      consignmentValue: "Bizom\xE1ny \xE9rt\xE9k",
      onDeliveryNote: "sz\xE1ll\xEDt\xF3lev\xE9len",
      rentalPrice: "B\xE9rleti d\xEDj",
      totalWithConsignment: "\xD6sszesen (b\xE9rleti d\xEDj + bizom\xE1ny)",
      savings: "Megtakar\xEDt\xE1s az egyedi b\xE9rl\xE9shez k\xE9pest",
      savingsPercent: "{percent}% megtakar\xEDt\xE1s",
      selectPackage: "Csomag kiv\xE1laszt\xE1sa",
      selectedPackage: "Kiv\xE1lasztott csomag: {name}",
      changePackage: "Csomag v\xE1lt\xE1sa",
      packageItems: "{count} t\xE9tel"
    },
    consignment: {
      title: "Bizom\xE1ny",
      deliveryNote: "Sz\xE1ll\xEDt\xF3lev\xE9l",
      quantityOut: "Elvitt mennyis\xE9g",
      quantityReturned: "Visszahozott",
      quantityCharged: "Felhaszn\xE1lt",
      settlement: "Bizom\xE1ny elsz\xE1mol\xE1s",
      settleAll: "\xD6sszes elsz\xE1mol\xE1sa",
      activeConsignments: "Akt\xEDv bizom\xE1nyok",
      totalValue: "Kint l\xE9v\u0151 \xE9rt\xE9k",
      noConsignments: "Nincs bizom\xE1ny t\xE9tel",
      returnedItems: "Visszahozott t\xE9telek",
      chargedItems: "Felsz\xE1m\xEDtott t\xE9telek",
      settlementSummary: "Elsz\xE1mol\xE1s \xF6sszes\xEDt\u0151",
      rentalFeeTotal: "B\xE9rleti d\xEDj \xF6sszesen",
      consignmentCharges: "Bizom\xE1ny felsz\xE1m\xEDt\xE1s",
      grandTotal: "V\xE9g\xF6sszeg",
      depositRefund: "Kauci\xF3 visszaj\xE1r\xF3",
      warningOverReturn: "A visszahozott mennyis\xE9g nem lehet t\xF6bb, mint az elvitt!",
      itemName: "Term\xE9k",
      dispatched: "Kiadva",
      returned: "Visszahozva",
      charged: "Felsz\xE1m\xEDtva",
      amount: "\xD6sszeg",
      freeAccessories: "Ingyenes tartoz\xE9kok",
      freeAccessoriesDesc: "Visszahozand\xF3 tartoz\xE9kok (csomag r\xE9sze)",
      accessoryReturned: "Visszahozva",
      accessoryMissing: "Hi\xE1nyzik",
      consignmentTotal: "Bizom\xE1ny \xE9rt\xE9k \xF6sszesen",
      consignmentNote: "A bizom\xE1ny \xE9rt\xE9ke nem ker\xFCl kisz\xE1ml\xE1z\xE1sra most \u2014 visszahoz\xE1skor elsz\xE1mol\xE1s t\xF6rt\xE9nik.",
      createFailed: "Bizom\xE1ny l\xE9trehoz\xE1s sikertelen",
      status: {
        active: "Akt\xEDv",
        settled: "Elsz\xE1molva",
        partiallySettled: "R\xE9szben elsz\xE1molva"
      }
    },
    stepNav: {
      navLabel: "L\xE9p\xE9s-navig\xE1ci\xF3",
      prev: "Vissza",
      next: "Tov\xE1bb",
      incompleteHint: "A l\xE9p\xE9s m\xE9g hi\xE1nyos \u2013 tov\xE1bb l\xE9phetsz",
      stepCounter: "L\xE9p\xE9s {current}/{total}"
    },
    contractCard: {
      title: "B\xE9rleti szerz\u0151d\xE9s",
      lessor: "B\xE9rbead\xF3",
      renter: "B\xE9rl\u0151",
      pdfPreview: "PDF el\u0151n\xE9zet / nyomtat\xE1s",
      pdfAfterFinalize: "A szerz\u0151d\xE9s PDF a v\xE9gleges\xEDt\xE9s ut\xE1n \xE9rhet\u0151 el"
    },
    returnTable: {
      contract: "Szerz\u0151d\xE9s / Kezd\xE9s",
      renter: "B\xE9rl\u0151",
      equipment: "B\xE9relt eszk\xF6z\xF6k",
      expectedReturn: "V\xE1rhat\xF3 visszav\xE9t",
      value: "\xC9rt\xE9k",
      status: "St\xE1tusz"
    },
    dueChips: {
      label: "Esed\xE9kess\xE9g:",
      all: "Mind",
      overdue: "Lej\xE1rt",
      dueToday: "Ma esed\xE9kes",
      dueSoon: "Hamarosan"
    },
    csvHeader: {
      contractNumber: "Szerz\u0151d\xE9ssz\xE1m",
      partner: "Partner",
      equipment: "G\xE9pek",
      endDate: "Hat\xE1rid\u0151",
      status: "St\xE1tusz"
    },
    exportCsv: "Export CSV",
    foundLabel: "tal\xE1lat",
    return: {
      signCta: "\xC1tv\xE9teli jegyz\u0151k\xF6nyv al\xE1\xEDr\xE1sa",
      error: {
        generic: "Hiba a visszav\xE9tel feldolgoz\xE1sakor"
      },
      consignment: {
        settleFailedFallback: "Bizom\xE1ny elsz\xE1mol\xE1s sikertelen",
        settleFailedDetail: "A b\xE9rl\xE9s visszav\xE9tele megt\xF6rt\xE9nt, de a bizom\xE1ny elsz\xE1mol\xE1s NEM. K\xE9rj\xFCk pr\xF3b\xE1lja \xFAjra vagy forduljon az adminisztr\xE1torhoz."
      },
      protocolTitle: "\xC1tv\xE9teli jegyz\u0151k\xF6nyv + al\xE1\xEDr\xE1s",
      generateDoc: "Jegyz\u0151k\xF6nyv gener\xE1l\xE1sa",
      signedOk: "Az \xFCgyf\xE9l al\xE1\xEDrta a jegyz\u0151k\xF6nyvet"
    },
    partnerIdLabel: "Partner azonos\xEDt\xF3",
    resolvedPackage: {
      none: "Nincs csomag",
      noneDesc: "Ehhez a g\xE9phez jelenleg nincs akt\xEDv b\xE9rleti csomag rendelve."
    },
    payment: {
      title: "Fizet\xE9s r\xF6gz\xEDt\xE9se",
      amount: "\xD6sszeg (HUF)",
      cash: "K\xE9szp\xE9nz",
      card: "Bankk\xE1rtya",
      transfer: "\xC1tutal\xE1s",
      reference: "Referencia (opcion\xE1lis)",
      notes: "Megjegyz\xE9s (opcion\xE1lis)",
      submit: "Fizet\xE9s r\xF6gz\xEDt\xE9se",
      success: "Fizet\xE9s sikeresen r\xF6gz\xEDtve",
      overpaymentError: "A befizetett \xF6sszeg meghaladja a fenn\xE1ll\xF3 egyenleget",
      recordFailed: "A fizet\xE9s r\xF6gz\xEDt\xE9se nem siker\xFClt",
      transferNotEligibleTitle: "\xC1tutal\xE1s nem enged\xE9lyezett",
      transferNotEligibleHint: "\xC1tutal\xE1sos fizet\xE9s csak a sz\xE1ml\xE1zott c\xE9g list\xE1zott szem\xE9ly\xE9nek (akt\xEDv k\xE9pvisel\u0151 vagy \xE9rv\xE9nyes meghatalmaz\xE1s).",
      transferBannedTitle: "\xC1tutal\xE1s letiltva",
      transferBannedHint: "A sz\xE1ml\xE1zott partner \xE1tutal\xE1sos fizet\xE9st\u0151l eltiltva (H\xE1rom Csap\xE1s). Csak vezet\u0151i felold\xE1s oldhatja fel.",
      transferPersonBlockedTitle: "Letiltott szem\xE9ly \u2014 \xE1tutal\xE1s nem enged\xE9lyezett",
      transferPersonBlockedHint: "A sz\xE1ml\xE1zott c\xE9g letiltotta ezt a szem\xE9lyt a felel\u0151ss\xE9g-v\xE1llalt list\xE1r\xF3l, ez\xE9rt \xE1tutal\xE1sos fizet\xE9s nem ind\xEDthat\xF3. Vegye fel a szem\xE9lyt a list\xE1ra, vagy v\xE1lasszon k\xE9szp\xE9nzt.",
      transferCashHint: "V\xE1lasszon K\xE9szp\xE9nz vagy Bankk\xE1rtya fizet\xE9si m\xF3dot.",
      outstandingBalance: "Fenn\xE1ll\xF3 egyenleg",
      paidAmount: "Befizetve",
      fullyPaid: "Kifizetve",
      recordButton: "Fizet\xE9s r\xF6gz\xEDt\xE9se",
      loyaltyDiscount: "H\u0171s\xE9gpont-kedvezm\xE9ny"
    },
    depositBreakdown: "Kauci\xF3 g\xE9penk\xE9nt",
    depositSettledAt: "Elsz\xE1molva: {date}",
    depositUnnamed: "N\xE9vtelen t\xE9tel",
    depositAction: {
      refund: "Visszat\xE9r\xEDt\xE9s",
      retain: "Visszatart\xE1s",
      refundTitle: "Kauci\xF3 teljes visszat\xE9r\xEDt\xE9se",
      retainTitle: "Kauci\xF3 visszatart\xE1sa",
      reason: "Indok",
      reasonPlaceholder: "Indok (opcion\xE1lis)",
      retainReasonPlaceholder: "Indok (k\xF6telez\u0151)",
      confirm: "Meger\u0151s\xEDt\xE9s",
      submit: "K\xFCld\xE9s",
      cancel: "M\xE9gse",
      refundSuccess: "Kauci\xF3 sikeresen visszat\xE9r\xEDtve.",
      retainSuccess: "Kauci\xF3 sikeresen visszatartva.",
      partialRefund: "K\xE1r-levon\xE1s",
      partialRefundTitle: "Parci\xE1lis visszat\xE9r\xEDt\xE9s (k\xE1r-levon\xE1s)",
      retainedAmount: "Visszatartott (k\xE1r) \xF6sszeg",
      retainedAmountPlaceholder: "pl. 20000",
      damageDescription: "K\xE1r le\xEDr\xE1sa",
      damageDescriptionPlaceholder: "A k\xE1r r\xF6vid le\xEDr\xE1sa (a sz\xE1ml\xE1n megjelenik)",
      vatRate: "\xC1FA-kulcs",
      returnPreview: "Visszaj\xE1r\xF3 (becs\xFClt)",
      partialRefundSuccess: "K\xE1r-levon\xE1s sikeresen r\xF6gz\xEDtve.",
      viewDamageInvoice: "K\xE1r-sz\xE1mla megtekint\xE9se",
      transfer: "\xC1tvezet\xE9s munkalapra",
      transferTitle: "Kauci\xF3 \xE1tvezet\xE9se szerviz-munkalapra",
      worksheet: "C\xE9l munkalap",
      worksheetPlaceholder: "V\xE1lassz munkalapot\u2026",
      transferAmount: "\xC1tvezetend\u0151 \xF6sszeg (opcion\xE1lis)",
      transferAmountPlaceholder: "\xDCresen hagyva a teljes kauci\xF3",
      transferSuccess: "Kauci\xF3 sikeresen \xE1tvezetve a munkalapra.",
      noWorksheets: "Nincs \xE1tvezethet\u0151 munkalap ehhez a partnerhez.",
      worksheetLoading: "Munkalapok bet\xF6lt\xE9se\u2026",
      cardPartialBlocked: "K\xE1rty\xE1s kauci\xF3 \u2014 MyPOS-\xFAt",
      cardPartialTooltip: "K\xE1rty\xE1s (el\u0151enged\xE9lyezett) kauci\xF3b\xF3l k\xE1r-levon\xE1s nem ind\xEDthat\xF3 itt \u2014 a visszat\xE9r\xEDt\xE9s a MyPOS-\xFAton t\xF6rt\xE9nik."
    },
    depositActionError: {
      notFound: "A kauci\xF3 nem tal\xE1lhat\xF3.",
      invalidStatus: "A kauci\xF3 jelenlegi \xE1llapota nem teszi lehet\u0151v\xE9 ezt a m\u0171veletet.",
      cardNotSupported: "Bankk\xE1rty\xE1s (MyPOS) kauci\xF3ra ez a m\u0171velet nem t\xE1mogatott.",
      serviceUnavailable: "A szolg\xE1ltat\xE1s \xE1tmenetileg nem el\xE9rhet\u0151. K\xE9rj\xFCk, pr\xF3b\xE1lja \xFAjra k\xE9s\u0151bb.",
      failed: "A kauci\xF3-m\u0171velet nem siker\xFClt."
    },
    depositStatus: {
      PENDING: "F\xFCgg\u0151ben",
      RECEIVED: "Be\xE9rkezett",
      HELD: "Tartva",
      RELEASED: "Visszaadva",
      RETAINED: "Visszatartva",
      PARTIAL: "R\xE9szben visszaadva"
    },
    settlement: {
      previewTitle: "Elsz\xE1mol\xE1s-el\u0151n\xE9zet",
      linesTitle: "V\xE9gsz\xE1mla-t\xE9telek (el\u0151k\xE9p)",
      vatPending: "\xC1FA egyeztet\xE9s alatt",
      cashTitle: "K\xE9szp\xE9nzes elsz\xE1mol\xE1s",
      deductionsTotal: "Levon\xE1sok \xF6sszesen",
      depositApplied: "Kauci\xF3-besz\xE1m\xEDt\xE1s",
      refundToCustomer: "Visszaj\xE1r\xF3 az \xFCgyf\xE9lnek",
      payableByCustomer: "\xDCgyf\xE9l \xE1ltal fizetend\u0151",
      cardTitle: "K\xE1rty\xE1s kauci\xF3 (k\xFCl\xF6n elsz\xE1mol\xE1s)",
      cardNotNetted: "A k\xE1rty\xE1s kauci\xF3 nem ker\xFCl besz\xE1m\xEDt\xE1sra \u2014 a visszat\xE9r\xEDt\xE9s a MyPOS-\xFAton t\xF6rt\xE9nik.",
      invoiceTotal: "V\xE9gsz\xE1mla \xF6sszege",
      myposCapture: "MyPOS terhel\xE9s",
      myposRefund: "MyPOS visszat\xE9r\xEDt\xE9s",
      forceImmediate: "Azonnali elsz\xE1mol\xE1s sz\xFCks\xE9ges",
      paymentMethod: {
        CASH: "K\xE9szp\xE9nz",
        CARD: "Bankk\xE1rtya",
        BANK_TRANSFER: "\xC1tutal\xE1s",
        PRE_AUTH: "El\u0151enged\xE9lyez\xE9s (MyPOS)"
      },
      extrasTitle: "K\xE1r / tartoz\xE9k / tiszt\xEDt\xE1s (el\u0151n\xE9zethez)",
      missingAccessoryLabel: "Elveszett tartoz\xE9k (beszerz\xE9si \xE1r, Ft)",
      cleaningOverrideLabel: "Tiszt\xEDt\xE1si d\xEDj fel\xFCl\xEDr\xE1s (Ft)",
      cleaningDefaultHint: "\xFCresen: alapd\xEDj",
      missingAccessoryPlaceholder: "0 Ft",
      sectionCharges: "Terhel\xE9sek",
      sectionSettlement: "Elsz\xE1mol\xE1s",
      sectionPayout: "Kifizet\xE9s",
      settleModeTitle: "Elsz\xE1mol\xE1s m\xF3dja",
      settleNow: "Elsz\xE1mol\xE1s most (alap\xE9rtelmezett)",
      settleAtClose: "Elsz\xE1mol\xE1s a b\xE9rl\xE9s z\xE1r\xE1sakor",
      settleAtCloseHint: "A kauci\xF3-rendez\xE9s a b\xE9rl\xE9s z\xE1r\xE1s\xE1ig v\xE1r; az utols\xF3 g\xE9p visszav\xE9telekor minden elsz\xE1molatlan t\xE9tel automatikusan rendez\u0151dik.",
      forceImmediateTooltip: "Az el\u0151enged\xE9lyezett k\xE1rty\xE1s kauci\xF3 lej\xE1rata miatt azonnali elsz\xE1mol\xE1s sz\xFCks\xE9ges."
    }
  },
  invoice: {
    title: "Sz\xE1ml\xE1k",
    subtitle: "Sz\xE1ml\xE1k \xE9s d\xEDjbek\xE9r\u0151k kezel\xE9se",
    newInvoice: "\xDAj sz\xE1mla",
    editInvoice: "Sz\xE1mla szerkeszt\xE9se",
    invoiceType: "Sz\xE1mla t\xEDpusa",
    allInvoices: "\xD6sszes sz\xE1mla",
    paidRevenue: "Befizetett bev\xE9tel",
    issuedPending: "Ki\xE1ll\xEDtva / F\xFCgg\u0151ben",
    overdueDebt: "Lej\xE1rt tartoz\xE1s",
    searchPlaceholder: "Keres\xE9s (sz\xE1mlasz\xE1m, partner, ad\xF3sz\xE1m)...",
    allStatuses: "Minden st\xE1tusz",
    allTypes: "Minden t\xEDpus",
    dates: "D\xE1tumok",
    items: "T\xE9telek",
    itemName: "T\xE9tel megnevez\xE9se...",
    noItems: 'Nincs t\xE9tel. Kattintson a "T\xE9tel hozz\xE1ad\xE1sa" gombra.',
    netTotal: "Nett\xF3 \xF6sszesen:",
    grossTotal: "Brutt\xF3 \xF6sszesen:",
    invoiceNotes: "Megjegyz\xE9s",
    notesPlaceholder: "Pl.: Fizet\xE9si felt\xE9telek, sz\xE1ll\xEDt\xE1si inform\xE1ci\xF3k...",
    createInvoice: "Sz\xE1mla l\xE9trehoz\xE1sa",
    saveChanges: "V\xE1ltoztat\xE1sok ment\xE9se",
    addressPlaceholder: "1011 Budapest, F\u0151 utca 1.",
    invoiceCreated: "Sz\xE1mla {action}!\nSz\xE1m: {number}\n\xD6sszeg: {amount}",
    loading: "Sz\xE1mla bet\xF6lt\xE9se...",
    notFound: "Sz\xE1mla nem tal\xE1lhat\xF3",
    buyerData: "Vev\u0151 adatok",
    nameLabel: "N\xE9v",
    addressLabel: "C\xEDm",
    taxNumber: "Ad\xF3sz\xE1m",
    description: "Megnevez\xE9s",
    quantity: "Mennyis\xE9g",
    quantityShort: "Menny.",
    unitPrice: "Egys\xE9g\xE1r",
    unitPriceNet: "Egys\xE9g\xE1r (nett\xF3)",
    vat: "\xC1FA",
    total: "\xD6sszesen",
    productIdLabel: "Cikk: {id}",
    noItemsEmpty: "Nincsenek t\xE9telek",
    netTotalLabel: "Nett\xF3 \xF6sszesen:",
    vatTotalLabel: "\xC1FA \xF6sszesen:",
    payable: "Fizetend\u0151:",
    invoiceData: "Sz\xE1mla adatok",
    statusLabel: "St\xE1tusz:",
    typeLabel: "T\xEDpus:",
    issueDateLabel: "Ki\xE1ll\xEDt\xE1s:",
    dueDateLabel: "Fizet\xE9si hat\xE1rid\u0151:",
    paidAt: "Fizetve:",
    paymentMethod: "Fizet\xE9si m\xF3d",
    paymentMethodType: {
      cash: "K\xE9szp\xE9nz",
      card: "Bankk\xE1rtya",
      transfer: "\xC1tutal\xE1s",
      cod: "Ut\xE1nv\xE9t"
    },
    correctionInvoice: "Helyesb\xEDt\u0151 sz\xE1mla",
    originalInvoice: "Eredeti sz\xE1mla:",
    modificationIndex: "M\xF3dos\xEDt\xE1s sorsz\xE1m:",
    modificationReason: "Indokl\xE1s:",
    navOnline: "NAV Online",
    navTransactionId: "Tranzakci\xF3 ID:",
    resendToNav: "\xDAjrak\xFCld\xE9s NAV-nak",
    fullyPaid: "Teljes \xF6sszeg kifizetve",
    balanceDue: "H\xE1tral\xE9k",
    paidSoFar: "Eddig fizetve: {amount}",
    invoiceTotal: "Sz\xE1mla v\xE9g\xF6sszeg",
    pdfDownload: "PDF let\xF6lt\xE9s",
    sendEmail: "K\xFCld\xE9s emailben",
    printInvoice: "Nyomtat\xE1s",
    stornoInvoice: "Sztorn\xF3 sz\xE1mla",
    storno: {
      title: "Sz\xE1mla sztorn\xF3z\xE1sa",
      subtitle: "Sztorn\xF3zand\xF3 sz\xE1mla",
      reasonLabel: "A sztorn\xF3 oka",
      isProductReturnLabel: "A term\xE9ket visszahozt\xE1k",
      inspectionLabel: "Az \xE1ru ellen\u0151rz\xE9se megt\xF6rt\xE9nt",
      submit: "Sztorn\xF3z\xE1s",
      success: "A sz\xE1mla sikeresen sztorn\xF3zva",
      error: "A sztorn\xF3z\xE1s nem siker\xFClt"
    },
    markPaid: "Fizetve jel\xF6l\xE9s",
    paid: "Fizetve",
    overdueWarning: "Lej\xE1rt sz\xE1mla! {days} napja esed\xE9kes.",
    overdueBalance: "H\xE1tral\xE9k: {amount}",
    paymentReminder: "Fizet\xE9si felsz\xF3l\xEDt\xE1s",
    pdfAlert: "PDF gener\xE1l\xE1s: {number}\n\nA sz\xE1mla PDF-je let\xF6lt\xE9sre ker\xFCl...",
    emailAlert: "Email k\xFCld\xE9s: {number}\n\nA sz\xE1mla elk\xFCld\xE9sre ker\xFCl a partner email c\xEDm\xE9re...",
    navResendAlert: "NAV \xFAjrak\xFCld\xE9s: {number}\n\nA sz\xE1mla \xFAjra elk\xFCld\xE9sre ker\xFCl a NAV Online rendszerbe...",
    markPaidAlert: "Fizetve jel\xF6l\xE9s: {number}\n\nA sz\xE1mla kifizettnek jel\xF6lve.",
    errorOccurred: "Hiba t\xF6rt\xE9nt: {message}",
    unknownError: "Ismeretlen hiba",
    editInvoiceSubtitle: "Sz\xE1mla adatainak m\xF3dos\xEDt\xE1sa",
    newInvoiceSubtitle: "\xDAj sz\xE1mla l\xE9trehoz\xE1sa",
    partnerData: "Partner adatai",
    partnerNameRequired: "Partner neve *",
    partnerNamePlaceholder: "Partner neve...",
    unit: "Egys\xE9g",
    vatPercent: "\xC1FA %",
    totalGross: "\xD6sszesen (brutt\xF3)",
    addItem: "+ T\xE9tel hozz\xE1ad\xE1sa",
    itemDescriptionPlaceholder: "T\xE9tel megnevez\xE9se...",
    grossAmount: "Brutt\xF3 \xF6sszesen",
    deleteItem: "T\xF6rl\xE9s",
    noItemsClickAdd: "Nincs t\xE9tel. Kattintson a {button} gombra.",
    vatLabel: "\xC1FA:",
    savingInProgress: "Ment\xE9s...",
    saveChangesButton: "V\xE1ltoztat\xE1sok ment\xE9se",
    createInvoiceButton: "Sz\xE1mla l\xE9trehoz\xE1sa",
    createdAction: "l\xE9trehozva",
    updatedAction: "friss\xEDtve",
    partnerNameValidation: "K\xE9rj\xFCk adja meg a partner nev\xE9t!",
    itemsValidation: "Legal\xE1bb egy t\xE9telt adjon meg!",
    template: {
      standard: "Standard",
      detailed: "R\xE9szletes",
      proforma: "D\xEDjbek\xE9r\u0151",
      select: "Sablon kiv\xE1laszt\xE1sa",
      download: "PDF let\xF6lt\xE9s ({template})"
    },
    advance: {
      title: "El\u0151legsz\xE1mla",
      createDirect: "K\xF6zvetlen el\u0151legsz\xE1mla l\xE9trehoz\xE1sa",
      createFromProforma: "El\u0151legsz\xE1mla proforma alapj\xE1n",
      createFinal: "V\xE9gsz\xE1mla el\u0151leg levon\xE1ssal",
      cancelAdvance: "El\u0151legsz\xE1mla sztorn\xF3",
      deductionLine: "El\u0151leg levon\xE1s",
      advanceAmount: "El\u0151leg \xF6sszege",
      remainingAmount: "Fennmarad\xF3 \xF6sszeg",
      refundMethod: "Visszat\xE9r\xEDt\xE9s m\xF3dja",
      cancelReason: "Lemond\xE1s indoka",
      cancelReasonPlaceholder: "Pl.: Rendel\xE9s lemondva, \xFCgyf\xE9l k\xE9r\xE9sre...",
      proformaMustBePaid: "A d\xEDjbek\xE9r\u0151nek fizetettnek kell lennie",
      advanceMustBePaid: "Az el\u0151legsz\xE1ml\xE1nak fizetettnek kell lennie",
      deductionExceedsTotal: "Az el\u0151leg levon\xE1s meghaladja a v\xE9gsz\xE1mla \xF6sszeg\xE9t",
      created: "El\u0151legsz\xE1mla l\xE9trehozva: {number}",
      finalCreated: "V\xE9gsz\xE1mla l\xE9trehozva: {number}",
      cancelled: "El\u0151legsz\xE1mla sztorn\xF3zva",
      cancelledWithStorno: "El\u0151legsz\xE1mla sztorn\xF3zva, sztorn\xF3: {number}",
      manualTitle: "El\u0151leg levon\xE1s",
      percentLabel: "El\u0151leg %",
      amountLabel: "El\u0151leg \xF6sszeg (Ft)",
      percentPlaceholder: "pl. 30",
      amountPlaceholder: "0 Ft",
      manualHint: "Adja meg az el\u0151leg sz\xE1zal\xE9k\xE1t vagy fix \xF6sszeg\xE9t. A v\xE9gsz\xE1ml\xE1n levon\xE1sra ker\xFCl."
    },
    correction: {
      title: "Helyesb\xEDt\u0151 l\xE9trehoz\xE1sa",
      creating: "L\xE9trehoz\xE1s...",
      originalInvoice: "Eredeti sz\xE1mla:",
      originalAmount: "Eredeti \xF6sszeg:",
      issuedAt: "Ki\xE1ll\xEDtva:",
      reason: "Helyesb\xEDt\xE9s indokl\xE1sa *",
      reasonPlaceholder: "Pl.: Mennyis\xE9gi hiba jav\xEDt\xE1sa, egys\xE9g\xE1r m\xF3dos\xEDt\xE1s...",
      reasonMinLength: "Minimum 5 karakter sz\xFCks\xE9ges",
      itemChanges: "T\xE9telek m\xF3dos\xEDt\xE1sa",
      netDifference: "Nett\xF3 k\xFCl\xF6nb\xF6zet:",
      vatDifference: "\xC1FA k\xFCl\xF6nb\xF6zet:",
      grossDifference: "Brutt\xF3 k\xFCl\xF6nb\xF6zet:",
      createCorrection: "Helyesb\xEDt\u0151 sz\xE1mla l\xE9trehoz\xE1sa",
      correctionTitle: "Helyesb\xEDt\u0151 sz\xE1mla",
      originalLabel: "Eredeti: {number}",
      partner: "Partner:",
      originalQty: "Eredeti menny.",
      newQty: "\xDAj mennyis\xE9g",
      originalPrice: "Eredeti \xE1r",
      newPrice: "\xDAj egys\xE9g\xE1r",
      difference: "K\xFCl\xF6nb\xF6zet",
      correctionCreated: "Helyesb\xEDt\u0151 sz\xE1mla l\xE9trehozva: {number}",
      errorPrefix: "Hiba: {message}",
      reasonValidation: "Az indokl\xE1s legal\xE1bb 5 karakter legyen!",
      correctedItem: "Jav\xEDtott t\xE9tel",
      differenceItem: "K\xFCl\xF6nb\xF6zeti t\xE9tel",
      modificationReference: "M\xF3dos\xEDt\xE1si hivatkoz\xE1s",
      originalItem: "Eredeti t\xE9tel",
      performanceDateNote: "Teljes\xEDt\xE9si d\xE1tum megjegyz\xE9s",
      previewTitle: "Helyesb\xEDt\u0151 sz\xE1mla el\u0151n\xE9zet",
      vatSelfAudit: "\xC1FA \xF6nellen\u0151rz\xE9s",
      vatSelfAuditDescription: "\xC1FA \xF6nellen\u0151rz\xE9si nyilatkozat sz\xFCks\xE9ges"
    },
    deliveryNote: {
      title: "Sz\xE1ll\xEDt\xF3levelek",
      newDeliveryNote: "\xDAj sz\xE1ll\xEDt\xF3lev\xE9l",
      types: {
        standard: "Standard (SZ-)",
        contract: "Szerz\u0151d\xE9ses (SZ-)",
        rentalAccessory: "B\xE9rg\xE9p tartoz\xE9k (SZB-)",
        supplierCredit: "Sz\xE1ll\xEDt\xF3 hitel (SZH-)"
      },
      typeLabels: {
        standard: "Standard",
        contract: "Szerz\u0151d\xE9ses",
        rentalAccessory: "B\xE9rg\xE9p tartoz\xE9k",
        supplierCredit: "Sz\xE1ll\xEDt\xF3 hitel"
      },
      statusLabels: {
        open: "Nyitott",
        invoiced: "Sz\xE1ml\xE1zva",
        settled: "Rendezve",
        closed: "Lez\xE1rva"
      },
      partnerName: "Partner neve",
      partnerNameRequired: "Partner n\xE9v *",
      partnerId: "Partner azonos\xEDt\xF3",
      partnerIdOptional: "Partner ID (opcion\xE1lis)",
      partnerIdPlaceholder: "Partner azonos\xEDt\xF3",
      partnerNamePlaceholder: "Partner neve",
      itemId: "Cikk ID",
      itemIdPlaceholder: "Cikk ID",
      productName: "Term\xE9k neve",
      productNamePlaceholder: "Term\xE9k neve",
      notes: "Megjegyz\xE9s...",
      notesOptional: "Megjegyz\xE9s (opcion\xE1lis)",
      notesPlaceholder: "Megjegyz\xE9s...",
      typeFilterLabel: "T\xEDpus",
      items: "T\xE9telek",
      addItem: "+ T\xE9tel hozz\xE1ad\xE1sa",
      description: "Megnevez\xE9s",
      quantity: "Mennyis\xE9g",
      unitPrice: "Egys\xE9g\xE1r",
      unitPriceHuf: "Egys\xE9g\xE1r (HUF)",
      amount: "\xD6sszeg",
      totalWithAmount: "\xD6sszesen: {amount}",
      totalLabel: "\xD6sszesen:",
      deleteItem: "T\xF6rl\xE9s",
      cancel: "M\xE9gse",
      saving: "Ment\xE9s...",
      createButton: "Sz\xE1ll\xEDt\xF3lev\xE9l l\xE9trehoz\xE1sa",
      errorPrefix: "Hiba: {message}",
      unknownError: "Ismeretlen hiba",
      loading: "Bet\xF6lt\xE9s...",
      notFound: "Sz\xE1ll\xEDt\xF3lev\xE9l nem tal\xE1lhat\xF3",
      backToList: "Vissza a list\xE1hoz",
      statusLabel: "St\xE1tusz",
      amountLabel: "\xD6sszeg",
      createdAt: "L\xE9trehozva",
      invoiceId: "Sz\xE1mla ID",
      contractPartner: "Szerz\u0151d\xE9ses partner",
      manualSettlement: "Manu\xE1lis rendez\xE9s",
      settled: "Rendezve",
      notesLabel: "Megjegyz\xE9s",
      itemsCount: "T\xE9telek ({count})",
      product: "Term\xE9k",
      invoicing: "Sz\xE1ml\xE1z\xE1s",
      processing: "Feldolgoz\xE1s...",
      financiallySettled: "P\xE9nz\xFCgyileg rendezve",
      assignToInvoice: "Sz\xE1ml\xE1hoz rendelve",
      invoiceIdLabel: "Sz\xE1mla ID",
      invoiceIdPlaceholder: "Sz\xE1mla azonos\xEDt\xF3",
      noDeliveryNotes: "Nincs sz\xE1ll\xEDt\xF3lev\xE9l",
      number: "Sz\xE1m",
      date: "D\xE1tum",
      allTypes: "\xD6sszes t\xEDpus",
      allStatuses: "\xD6sszes st\xE1tusz",
      batchConfirmGenerate: "Sz\xE1mla gener\xE1l\xE1sa",
      batchConfirmMessage: "Biztosan k\xF6tegelt sz\xE1ml\xE1t k\xE9sz\xEDt a kijel\xF6lt sz\xE1ll\xEDt\xF3levelekb\u0151l?",
      batchConfirmTitle: "K\xF6tegelt sz\xE1ml\xE1z\xE1s",
      batchGenerating: "Gener\xE1l\xE1s\u2026",
      batchPartnerMismatch: "A kijel\xF6lt sz\xE1ll\xEDt\xF3levelek elt\xE9r\u0151 partnerekhez tartoznak",
      generateBatchInvoice: "K\xF6tegelt sz\xE1mla",
      selectForBatch: "Kijel\xF6l\xE9s k\xF6tegel\xE9shez",
      selectedNotes: "{count} sz\xE1ll\xEDt\xF3lev\xE9l kijel\xF6lve"
    },
    status: {
      draft: "Piszkozat",
      pending: "J\xF3v\xE1hagy\xE1sra v\xE1r",
      approved: "J\xF3v\xE1hagyva",
      sent: "Ki\xE1ll\xEDtva",
      paid: "Kifizetve",
      partiallyPaid: "R\xE9szben fizetve",
      overdue: "Lej\xE1rt",
      cancelled: "T\xF6r\xF6lve",
      voided: "Sztorn\xF3zva"
    },
    type: {
      standard: "Sz\xE1mla",
      advance: "El\u0151legsz\xE1mla",
      final: "V\xE9gsz\xE1mla",
      proforma: "D\xEDjbek\xE9r\u0151",
      creditNote: "Sztorn\xF3",
      correction: "Helyesb\xEDt\u0151",
      storno: "Sztorn\xF3",
      minuszos: "M\xEDnuszos"
    },
    eInvoice: {
      hash: "Hash",
      noEmail: "Nincs email c\xEDm",
      notSent: "Nem k\xFCld\xF6tt",
      send: "E-sz\xE1mla k\xFCld\xE9se",
      sent: "Elk\xFCldve",
      sentAt: "Elk\xFCldve: {date}",
      title: "E-sz\xE1mla",
      partnerNotFound: "A vev\u0151 nem tal\xE1lhat\xF3 \u2014 v\xE1lassz \xE9rv\xE9nyes partnert a NAV-sz\xE1ml\xE1hoz",
      partnerIncomplete: "Hi\xE1nyos vev\u0151-adat (n\xE9v, ir\xE1ny\xEDt\xF3sz\xE1m, v\xE1ros, c\xEDm; c\xE9gn\xE9l ad\xF3sz\xE1m) \u2014 eg\xE9sz\xEDtsd ki a NAV-sz\xE1ml\xE1hoz",
      fixPartner: "Vev\u0151-adat szerkeszt\xE9se"
    },
    export: {
      monthLabel: "Export h\xF3napja",
      xlsxButton: "Export\xE1l\xE1s (XLSX)",
      csvButton: "CSV",
      error: "Az export nem siker\xFClt"
    },
    voided: "Sztorn\xF3zva",
    saveError: "Ment\xE9si hiba"
  },
  sales: {
    title: "\xC9rt\xE9kes\xEDt\xE9s",
    subtitle: "Mai \xE9s kor\xE1bbi elad\xE1sok",
    totalSales: "\xD6sszes elad\xE1s",
    totalRevenue: "\xD6sszes bev\xE9tel",
    avgBasket: "\xC1tlag kos\xE1r",
    searchPlaceholder: "Keres\xE9s (bizonylat, vev\u0151)...",
    allStatuses: "Minden st\xE1tusz",
    cashCustomer: "K\xE9szp\xE9nzes v\xE1s\xE1rl\xF3",
    statusLabels: {
      inProgress: "Folyamatban",
      awaitingPayment: "Fizet\xE9sre v\xE1r",
      completed: "Befejezett",
      reversed: "Sztorn\xF3zott"
    },
    paymentStatusLabels: {
      pending: "\u23F3 F\xFCgg\u0151ben",
      partial: "\u{1F504} R\xE9szleges",
      paid: "\u2705 Fizetett",
      refunded: "\u21A9\uFE0F Visszat\xE9r\xEDtve"
    },
    newSale: "\xDAj \xE9rt\xE9kes\xEDt\xE9s",
    noSales: "Nincsenek \xE9rt\xE9kes\xEDt\xE9sek a sz\u0171r\xE9si felt\xE9teleknek megfelel\u0151en.",
    pendingPayment: "Fizet\xE9sre v\xE1r",
    errorOccurred: "Hiba t\xF6rt\xE9nt: {message}",
    detail: {
      pendingPayment: "Fizet\xE9sre v\xE1r",
      voided: "\xC9rv\xE9nytelen\xEDtett",
      receipt: "Nyugta",
      invoice: "Sz\xE1mla",
      processing: "Feldolgoz\xE1s...",
      void: "\xC9rv\xE9nytelen\xEDt\xE9s",
      voidConfirm: "Biztosan \xE9rv\xE9nytelen\xEDti ezt a tranzakci\xF3t?",
      voidReason: "Felhaszn\xE1l\xF3i k\xE9r\xE9sre",
      voidError: "Hiba t\xF6rt\xE9nt az \xE9rv\xE9nytelen\xEDt\xE9s sor\xE1n",
      printReceipt: "Nyugta nyomtat\xE1sa...",
      printInvoice: "Sz\xE1mla nyomtat\xE1sa...",
      loadError: "Hiba t\xF6rt\xE9nt a bet\xF6lt\xE9s sor\xE1n.",
      transactionNotFound: "Tranzakci\xF3 nem tal\xE1lhat\xF3.",
      items: "T\xE9telek ({count})",
      noItems: "Nincsenek t\xE9telek",
      discount: "kedvezm\xE9ny",
      customerData: "Vev\u0151 adatai",
      partnerId: "Partner azonos\xEDt\xF3",
      voidData: "\xC9rv\xE9nytelen\xEDt\xE9s adatai",
      timestamp: "Id\u0151pont",
      reason: "Indok",
      summary: "\xD6sszes\xEDt\xE9s",
      subtotal: "R\xE9sz\xF6sszeg",
      discountAmount: "Kedvezm\xE9ny",
      paymentStatus: "Fizet\xE9si st\xE1tusz",
      paidAmount: "Fizetve: {amount}",
      change: "Visszaj\xE1r\xF3",
      transactionData: "Tranzakci\xF3 adatok",
      transactionNumber: "Tranzakci\xF3 sz\xE1m",
      sessionId: "Munkamenet azonos\xEDt\xF3"
    },
    pos: {
      title: "P\xE9nzt\xE1r (POS)",
      loadingSession: "Kassza session bet\xF6lt\xE9se...",
      noDefaultWarehouse: "Nincs alap\xE9rtelmezett rakt\xE1r ehhez a fi\xF3khoz. \xC1ll\xEDtson be egyet a kassza megnyit\xE1s\xE1hoz.",
      warehouseLoadError: "Nem siker\xFClt bet\xF6lteni a rakt\xE1rat. Pr\xF3b\xE1lja \xFAjra.",
      retry: "\xDAjra",
      openRegister: "Kassza nyit\xE1s",
      suspend: "Felf\xFCggeszt\xE9s",
      closeRegister: "Kassza z\xE1r\xE1s",
      resume: "Folytat\xE1s",
      addCustomer: "+ Vev\u0151",
      sessionWarning: "A kassza {status} van. Nyissa meg a kassz\xE1t a tranzakci\xF3k ind\xEDt\xE1s\xE1hoz.",
      sessionSuspended: "felf\xFCggesztve",
      sessionClosed: "z\xE1rva",
      searchPlaceholder: "Keres\xE9s n\xE9v, cikksz\xE1m vagy vonalk\xF3d alapj\xE1n...",
      allCategories: "Mind",
      openRegisterForProducts: "Nyissa meg a kassz\xE1t a term\xE9kek megjelen\xEDt\xE9s\xE9hez",
      cart: "Kos\xE1r ({count} t\xE9tel)",
      cartEmpty: "A kos\xE1r \xFCres",
      subtotal: "R\xE9sz\xF6sszeg:",
      discount: "Kedvezm\xE9ny:",
      total: "\xD6sszesen:",
      clearCart: "Kos\xE1r t\xF6rl\xE9se",
      pay: "Fizet\xE9s",
      payment: "Fizet\xE9s",
      discountFt: "Kedvezm\xE9ny (Ft)",
      receivedAmount: "Kapott \xF6sszeg (Ft)",
      toPay: "Fizetend\u0151:",
      change: "Visszaj\xE1r\xF3:",
      completePayment: "Fizet\xE9s befejez\xE9se",
      selectCustomer: "Vev\u0151 kiv\xE1laszt\xE1sa",
      noCustomer: "Nincs vev\u0151 (k\xE9szp\xE9nzes v\xE1s\xE1rl\xE1s)",
      saleSuccess: "Elad\xE1s sikeres!\n\xD6sszeg: {total}\nVissza: {change}",
      noActiveSession: "Nincs akt\xEDv kassza session",
      outOfStock: "A term\xE9k nincs k\xE9szleten",
      procurement: {
        bannerTitle: "{name} \u2014 nincs k\xE9szleten",
        bannerHint: "K\xF6zponti beszerz\xE9si kos\xE1rba teheted, hogy a k\xF6vetkez\u0151 rendel\xE9sn\xE9l a szerel\u0151 tudja, hogy ez a cikk kell.",
        addButton: "Beszerz\xE9si kos\xE1rba",
        addSuccess: "Hozz\xE1adva a k\xF6zponti beszerz\xE9si kos\xE1rhoz",
        addError: "Nem siker\xFClt a kos\xE1rhoz adni"
      },
      unknownBarcode: "Ismeretlen vonalk\xF3d: {barcode}",
      barcodeError: "Hiba a vonalk\xF3d beolvas\xE1sakor",
      paymentError: "Hiba a fizet\xE9s feldolgoz\xE1sakor",
      voidError: "Hiba a tranzakci\xF3 t\xF6rl\xE9sekor",
      voidReason: "Felhaszn\xE1l\xF3 \xE1ltal t\xF6r\xF6lve",
      productCategories: {
        powerTool: "Elektromos szersz\xE1m",
        handTool: "K\xE9ziszersz\xE1m",
        accessory: "Tartoz\xE9k",
        workwear: "Munkaruha"
      },
      loyalty: {
        balance: "Pontegyenleg",
        points: "pont",
        redeem: "Pontbev\xE1lt\xE1s",
        maxRedemption: "max {percent}% a v\xE9g\xF6sszegb\u0151l",
        discount: "H\u0171s\xE9gpont kedvezm\xE9ny",
        remaining: "Marad\xE9k fizetend\u0151",
        redeemFailed: "Pontbev\xE1lt\xE1s sikertelen",
        insufficientPoints: "Nincs el\xE9g h\u0171s\xE9gpont a bev\xE1lt\xE1shoz",
        concurrentRetry: "A pontbev\xE1lt\xE1s \xFCtk\xF6z\xF6tt egy m\xE1sik tranzakci\xF3val \u2014 pr\xF3b\xE1ld \xFAjra"
      },
      packages: {
        title: "Csomagok",
        badge: "Csomag",
        setBadge: "Szett",
        savingsLabel: "Megtakar\xEDt\xE1s a k\xFCl\xF6n-v\xE9telhez",
        tieredNotSellable: "Ez a csomag b\xE9rl\xE9s-hossz-f\xFCgg\u0151 \xE1r\xFA, POS-on nem eladhat\xF3",
        componentPriceMissing: "A csomag egyik t\xE9tel\xE9nek nincs \xE1ra \u2014 \xE1ll\xEDtsd be az admin fel\xFCleten",
        discountMissing: "A kedvezm\xE9nyes csomagnak nincs be\xE1ll\xEDtott kedvezm\xE9nye",
        fixedPriceMissing: "A fix-\xE1ras csomagnak nincs be\xE1ll\xEDtott \xE1ra",
        addFailed: "A csomag nem adhat\xF3 a kos\xE1rhoz"
      },
      barcodePlaceholder: "Vonalk\xF3d beolvas\xE1sa\u2026",
      creditPayment: "Hitelre",
      voucherPayment: "Utalv\xE1ny",
      saleSuccessTitle: "Elad\xE1s sikeres",
      saleSuccessTotal: "Fizetett \xF6sszeg",
      saleSuccessChange: "Visszaj\xE1r\xF3",
      saleTransactionLabel: "Tranzakci\xF3",
      navProcessing: "NAV-ki\xE1ll\xEDt\xE1s folyamatban\u2026",
      newSale: "\xDAj elad\xE1s"
    },
    session: {
      close: {
        title: "Kassza z\xE1r\xE1s",
        sessionLabel: "Munkamenet:",
        openingBalance: "Nyit\xF3 egyenleg:",
        expectedBalance: "V\xE1rt egyenleg:",
        closingBalance: "Z\xE1r\xF3 egyenleg (Ft)",
        variance: "Elt\xE9r\xE9s:",
        surplus: "T\xF6bblet a kassz\xE1ban",
        shortage: "Hi\xE1ny a kassz\xE1ban",
        varianceReason: "Elt\xE9r\xE9s indokl\xE1sa (k\xF6telez\u0151)",
        variancePlaceholder: "Adja meg az elt\xE9r\xE9s ok\xE1t...",
        closeError: "Hiba t\xF6rt\xE9nt a kassza z\xE1r\xE1sakor",
        cancel: "M\xE9gse",
        closing: "Z\xE1r\xE1s...",
        closeButton: "Kassza z\xE1r\xE1sa"
      },
      suspend: {
        title: "Kassza felf\xFCggeszt\xE9se",
        resumeTitle: "Kassza folytat\xE1sa",
        statusLabel: "St\xE1tusz:",
        statusSuspended: "FELF\xDCGGESZTVE",
        statusActive: "AKT\xCDV",
        reasonLabel: "Felf\xFCggeszt\xE9s oka (opcion\xE1lis)",
        reasonPlaceholder: "Pl. eb\xE9dsz\xFCnet, m\u0171szakv\xE1lt\xE1s...",
        quickReasons: {
          lunch: "Eb\xE9dsz\xFCnet",
          break: "Sz\xFCnet",
          shiftChange: "M\u0171szakv\xE1lt\xE1s",
          technical: "Technikai probl\xE9ma"
        },
        resumeInfo: "A kassza jelenleg felf\xFCggesztve van.",
        resumeHint: 'Kattintson a "Folytat\xE1s" gombra a kassza \xFAjraaktiv\xE1l\xE1s\xE1hoz.',
        resuming: "Folytat\xE1s...",
        resumeButton: "Kassza folytat\xE1sa",
        suspending: "Felf\xFCggeszt\xE9s...",
        suspendButton: "Felf\xFCggeszt\xE9s"
      },
      open: {
        title: "Kassza nyit\xE1s",
        openingBalance: "Nyit\xF3 egyenleg (Ft)",
        openError: "Hiba t\xF6rt\xE9nt a kassza nyit\xE1sakor",
        cancel: "M\xE9gse",
        opening: "Nyit\xE1s...",
        openButton: "Kassza nyit\xE1sa"
      },
      status: {
        open: "AKT\xCDV",
        suspended: "FELF\xDCGGESZTVE",
        closed: "Z\xC1RVA",
        noSession: "NINCS AKT\xCDV KASSZA"
      }
    },
    zReport: {
      title: "Z-Jelent\xE9s",
      sessionInfo: "KASSZA INFORM\xC1CI\xD3",
      opened: "Nyit\xE1s:",
      closed: "Z\xE1r\xE1s:",
      cashBalance: "K\xC9SZP\xC9NZ EGYENLEG",
      openingBalance: "Nyit\xF3 egyenleg:",
      expectedBalance: "V\xE1rt egyenleg:",
      closingBalance: "Z\xE1r\xF3 egyenleg:",
      variance: "Elt\xE9r\xE9s:",
      note: "Megjegyz\xE9s:",
      transactions: "TRANZAKCI\xD3K",
      totalTransactions: "\xD6sszes tranzakci\xF3:",
      completed: "Befejezett:",
      voided: "Sztorn\xF3zott:",
      paymentMethods: "FIZET\xC9SI M\xD3DOK",
      cash: "K\xE9szp\xE9nz:",
      card: "Bankk\xE1rtya:",
      transfer: "\xC1tutal\xE1s:",
      voucher: "Utalv\xE1ny:",
      credit: "Hitel:",
      revenue: "FORGALOM",
      grossSales: "Brutt\xF3 elad\xE1s:",
      discounts: "Kedvezm\xE9nyek:",
      netSales: "Nett\xF3 elad\xE1s:",
      taxAmount: "\xC1FA \xF6sszeg:",
      changeGiven: "Visszaadott k\xE9szp\xE9nz:",
      print: "Nyomtat\xE1s",
      downloadPdf: "PDF let\xF6lt\xE9s",
      downloadPdfSoon: "PDF let\xF6lt\xE9s funkci\xF3 hamarosan el\xE9rhet\u0151",
      close: "Bez\xE1r\xE1s",
      refunds: "Visszat\xE9r\xEDt\xE9s"
    }
  },
  inventory: {
    title: "K\xE9szlet",
    stockList: "K\xE9szletlista",
    movements: "Mozg\xE1sok",
    goodsReceipt: "Bev\xE9telez\xE9s",
    scrapping: "Selejtez\xE9s",
    management: "K\xE9szlet kezel\xE9s",
    warehouseAndMovements: "Rakt\xE1rk\xE9szlet \xE9s mozg\xE1sok",
    allItems: "\xD6sszes t\xE9tel",
    stockValue: "K\xE9szlet\xE9rt\xE9k",
    available: "El\xE9rhet\u0151",
    lowStock: "Alacsony k\xE9szlet",
    lowStockCount: "{count} t\xE9tel",
    searchPlaceholder: "Keres\xE9s (term\xE9k, cikksz\xE1m, hivatkoz\xE1s)...",
    allWarehouses: "Minden rakt\xE1r",
    loadingStock: "K\xE9szlet bet\xF6lt\xE9se...",
    reserved: "Foglalt",
    purchasePrice: "Beszerz\xE9si \xE1r",
    warehouse: "Rakt\xE1r",
    noResults: "Nincs tal\xE1lat",
    newReceipt: "+ Bev\xE9telez\xE9s",
    receiptFailed: "Bev\xE9telez\xE9s sikertelen. K\xE9rj\xFCk pr\xF3b\xE1lja \xFAjra.",
    availableCount: "El\xE9rhet\u0151 ({count})",
    reservedCount: "Foglalt ({count})",
    lowStockCountBadge: "Alacsony k\xE9szlet ({count})",
    typeLabels: {
      product: "Term\xE9k",
      rentalEquipment: "B\xE9rleti eszk\xF6z",
      part: "Alkatr\xE9sz",
      consumable: "Fogy\xF3eszk\xF6z"
    },
    statusLabels: {
      available: "El\xE9rhet\u0151",
      reserved: "Foglalt",
      inService: "Szervizben",
      inTransit: "Sz\xE1ll\xEDt\xE1s alatt",
      rented: "Kiadva",
      sold: "Eladva",
      damaged: "S\xE9r\xFClt",
      lost: "Elveszett",
      scrapped: "Selejtezve"
    },
    scrapItems: "Selejt t\xE9telek",
    scrapProtocols: "Jegyz\u0151k\xF6nyvek",
    newScrap: "\xDAj selejt r\xF6gz\xEDt\xE9s",
    scrapMark: "Selejtre jel\xF6l\xE9s",
    scrapRecord: "Selejt r\xF6gz\xEDt\xE9s",
    scrapRecording: "R\xF6gz\xEDt\xE9s...",
    scrapRecords: "Selejt rekordok ({count} db)",
    noScrapRecords: "Nincs selejt rekord.",
    scrapReasonLabels: {
      damaged: "S\xE9r\xFClt",
      expired: "Lej\xE1rt",
      defective: "Hib\xE1s",
      other: "Egy\xE9b"
    },
    scrapProtocolStatuses: {
      draft: "Piszkozat",
      approved: "J\xF3v\xE1hagyott",
      finalized: "V\xE9gleges\xEDtett"
    },
    scrapProtocolsTitle: "Selejtez\xE9si jegyz\u0151k\xF6nyvek",
    newProtocol: "\xDAj jegyz\u0151k\xF6nyv",
    year: "\xC9v",
    inventoryItemId: "K\xE9szlet t\xE9tel ID",
    productId: "Term\xE9k ID",
    warehouseId: "Rakt\xE1r ID",
    itemNotFound: "T\xE9tel nem tal\xE1lhat\xF3",
    stockCount: {
      title: "Lelt\xE1rak",
      newButton: "\xDAj lelt\xE1r",
      newButtonHint: "Lelt\xE1r ind\xEDt\xE1sa \u2014 hamarosan el\xE9rhet\u0151",
      empty: "M\xE9g nincs lelt\xE1r",
      columns: {
        countNumber: "Lelt\xE1rsz\xE1m",
        name: "N\xE9v",
        status: "St\xE1tusz",
        createdAt: "L\xE9trehozva",
        warehouse: "Rakt\xE1r"
      },
      statusLabels: {
        draft: "Tervez\xE9s alatt",
        inProgress: "Folyamatban",
        suspended: "Felf\xFCggesztve",
        pendingReview: "Ellen\u0151rz\xE9sre v\xE1r",
        pendingAdjustment: "Korrekci\xF3ra v\xE1r",
        completed: "Befejezve",
        cancelled: "Visszavonva"
      }
    },
    movementsTitle: "K\xE9szletmozg\xE1sok",
    movementsSubtitle: "Bev\xE9telez\xE9sek, kiad\xE1sok, korrekci\xF3k",
    movementsSearch: "Keres\xE9s (term\xE9k, cikksz\xE1m, hivatkoz\xE1s)...",
    category: {
      powerTool: "Elektromos g\xE9p",
      handTool: "K\xE9zi szersz\xE1m",
      accessory: "Tartoz\xE9k",
      consumable: "Fogy\xF3eszk\xF6z",
      workwear: "Munkaruha",
      sparePart: "Alkatr\xE9sz"
    },
    stockStatus: {
      inStock: "K\xE9szleten",
      lowStock: "Alacsony k\xE9szlet",
      outOfStock: "Nincs k\xE9szleten",
      discontinued: "Kifut\xF3"
    },
    movement: {
      in: "Bev\xE9telez\xE9s",
      out: "Kiad\xE1s",
      adjustment: "Korrekci\xF3",
      transfer: "Rakt\xE1rk\xF6zi",
      return: "Visszav\xE9t"
    },
    addProduct: "Term\xE9k hozz\xE1ad\xE1sa",
    addProductsViaSearch: "Term\xE9k keres\xE9se \xE9s hozz\xE1ad\xE1sa",
    allGroups: "\xD6sszes csoport",
    approve: "J\xF3v\xE1hagy\xE1s",
    backToList: "Vissza a list\xE1hoz",
    basicData: "Alapadatok",
    batchNumber: "T\xE9telsz\xE1m",
    correction: "Korrekci\xF3",
    create: "L\xE9trehoz\xE1s",
    createdAt: "L\xE9trehozva",
    creating: "L\xE9trehoz\xE1s...",
    documentData: "Dokumentum adatok",
    finalize: "V\xE9gleges\xEDt\xE9s",
    issueStock: "Kiad\xE1s",
    items: "T\xE9telek",
    itemsToReceive: "Bev\xE9telezend\u0151 t\xE9telek",
    location: "Lok\xE1ci\xF3",
    maximum: "Maximum",
    minimum: "Minimum",
    month: "H\xF3nap",
    noProtocols: "Nincs jegyz\u0151k\xF6nyv",
    optionalReceiptNote: "Opcion\xE1lis bev\xE9teli megjegyz\xE9s",
    pcs: "db",
    pricing: "\xC1raz\xE1s",
    procurementAndRestock: "Beszerz\xE9s \xE9s ut\xE1np\xF3tl\xE1s",
    productTypes: "Term\xE9kt\xEDpusok",
    profitability: "J\xF6vedelmez\u0151s\xE9g",
    protocolsList: "Jegyz\u0151k\xF6nyvek list\xE1ja",
    purchaseCategories: {
      ARU: "\xC1ru",
      BERENDEZES: "Berendez\xE9s",
      BERUHAZAS: "Beruh\xE1z\xE1s",
      EGYEB: "Egy\xE9b",
      REZSI: "Rezsi"
    },
    purchaseCategoryLabel: "Beszerz\xE9si kateg\xF3ria",
    purchaseCategoryPlaceholder: "V\xE1lasszon kateg\xF3ri\xE1t...",
    purchaseValue: "Beszerz\xE9si \xE9rt\xE9k",
    quickActions: "Gyors m\u0171veletek",
    receive: {
      package: "Csomag",
      packageQuantity: "Csomagsz\xE1m",
      totalUnits: "\xD6sszes egys\xE9g",
      unitPrice: "Egys\xE9g\xE1r",
      unitsPerPackage: "Egys\xE9g/csomag"
    },
    receiveStock: "Bev\xE9telez\xE9s",
    recording: "R\xF6gz\xEDt\xE9s...",
    referenceOrderNumber: "Hivatkoz\xE1si rendel\xE9ssz\xE1m",
    saveReceipt: "Bev\xE9tel ment\xE9se",
    saving: "Ment\xE9s...",
    searchByNameSkuBarcode: "Keres\xE9s n\xE9v, SKU, vonalk\xF3d...",
    serialNumber: "Sorozatsz\xE1m",
    sku: "SKU",
    stock: "K\xE9szlet",
    stockLevels: "K\xE9szletszintek",
    summary: "\xD6sszes\xEDt\xE9s",
    targetWarehouse: "C\xE9l rakt\xE1r",
    total: "\xD6sszesen",
    totalPieces: "\xD6sszesen (db)",
    transferTitle: "Rakt\xE1rk\xF6zi \xE1tcsoportos\xEDt\xE1s",
    transferSubtitle: "H\xE1zon bel\xFCli k\xE9szlet-mozgat\xE1s (sz\xE1mla n\xE9lk\xFCl)",
    transferSource: "Forr\xE1s rakt\xE1r",
    transferTarget: "C\xE9l rakt\xE1r",
    transferSelectSource: "V\xE1lassz forr\xE1s rakt\xE1rt",
    transferSelectTarget: "V\xE1lassz c\xE9l rakt\xE1rt",
    transferReason: "Indok (opcion\xE1lis)",
    transferSameWarehouseError: "A forr\xE1s \xE9s a c\xE9l rakt\xE1r nem lehet azonos",
    transferAvailableItems: "El\xE9rhet\u0151 t\xE9telek",
    transferNoItems: "Nincs el\xE9rhet\u0151 t\xE9tel a forr\xE1s rakt\xE1rban",
    transferAdd: "Hozz\xE1ad",
    transferAddedItems: "\xC1tcsoportos\xEDtand\xF3 t\xE9telek",
    transferQuantity: "Mennyis\xE9g",
    transferAvailable: "El\xE9rhet\u0151: {qty}",
    transferRemove: "Elt\xE1vol\xEDt",
    transferSubmit: "\xC1tcsoportos\xEDt\xE1s ind\xEDt\xE1sa",
    transferSuccess: "\xC1tcsoportos\xEDt\xE1s elind\xEDtva (#{id})",
    transfer: {
      confirmNote: "\xC1tvezet\xE9s megjegyz\xE9s",
      confirmOwnAsset: "Saj\xE1t eszk\xF6zk\xE9nt r\xF6gz\xEDt\xE9s meger\u0151s\xEDt\xE9se",
      confirmRental: "B\xE9rg\xE9pk\xE9nt r\xF6gz\xEDt\xE9s meger\u0151s\xEDt\xE9se",
      ecsStarted: "\xC9CS sz\xE1m\xEDt\xE1s elind\xEDtva",
      error: "\xC1tvezet\xE9si hiba",
      rentalCardCreated: "B\xE9rg\xE9p karton l\xE9trehozva",
      success: "\xC1tvezet\xE9s sikeres",
      title: "K\xE9szlet \xE1tvezet\xE9s",
      toOwnAsset: "Saj\xE1t eszk\xF6zz\xE9 min\u0151s\xEDt\xE9s",
      toRental: "B\xE9rg\xE9pp\xE9 min\u0151s\xEDt\xE9s"
    },
    updatedAt: "Friss\xEDtve",
    views: "N\xE9zetek",
    barcode: {
      scan: "Vonalk\xF3d beolvas\xE1s",
      scanPlaceholder: "Olvassa be a vonalk\xF3dot vagy \xEDrja be a cikksz\xE1mot...",
      notFound: "Nem tal\xE1lhat\xF3 term\xE9k ezzel a vonalk\xF3ddal",
      found: "Term\xE9k megtal\xE1lva",
      lookupError: "Vonalk\xF3d keres\xE9si hiba"
    },
    withdrawal: {
      title: "K\xE9szlet kiv\xE9telez\xE9s",
      scanToAdd: "Vonalk\xF3d beolvas\xE1ssal adhat hozz\xE1 t\xE9telt"
    },
    splitAvailability: {
      title: "Rendel\xE9s-k\xE9szlet feloszt\xE1s",
      split: "K\xE9szlet feloszt\xE1s",
      available: "El\xE9rhet\u0151",
      backordered: "H\xE1trarendelt",
      partial: "R\xE9szben el\xE9rhet\u0151",
      fullyAvailable: "Teljesen el\xE9rhet\u0151",
      fullyBackordered: "Teljesen h\xE1trarendelt",
      summary: "\xD6sszes\xEDt\xE9s: {available} el\xE9rhet\u0151, {backordered} h\xE1trarendelt, {partial} r\xE9szleges"
    },
    centralRequest: {
      title: "Ig\xE9ny k\xF6zponti rakt\xE1rba",
      submit: "Ig\xE9ny bek\xFCld\xE9se",
      submitting: "Bek\xFCld\xE9s...",
      pending: "F\xFCgg\u0151 ig\xE9nyek",
      note: "Megjegyz\xE9s",
      notePlaceholder: "Opcion\xE1lis megjegyz\xE9s az ig\xE9nyhez...",
      success: "Ig\xE9ny sikeresen bek\xFCldve ({count} t\xE9tel)",
      noPending: "Nincs f\xFCgg\u0151 ig\xE9ny",
      requestedAt: "Bek\xFCldve",
      selectLowStock: "Alacsony k\xE9szlet\u0171 t\xE9telek kiv\xE1laszt\xE1sa"
    },
    phantom: {
      title: "Fantom t\xE9telek",
      count: "{count} fantom t\xE9tel",
      badge: "Fantom ({count})",
      resolve: "Rendez\xE9s",
      scrap: "Selejtez\xE9s",
      recount: "\xDAjrasz\xE1ml\xE1l\xE1s",
      actualQuantity: "Val\xF3s mennyis\xE9g",
      reason: "Ok",
      reasonPlaceholder: "Rendez\xE9s oka...",
      resolved: "Fantom t\xE9tel rendezve",
      noPhantom: "Nincs fantom t\xE9tel"
    },
    deadStock: {
      title: "Holt k\xE9szlet",
      subtitle: "T\xE9telek mozg\xE1s-alap\xFA besorol\xE1sa",
      activeLabel: "Akt\xEDv",
      warningLabel: "Figyelmeztet\xE9s",
      deadLabel: "Holt",
      activeCount: "Akt\xEDv t\xE9telek",
      warningCount: "Figyelmeztet\xE9s",
      deadCount: "Holt t\xE9telek",
      totalDeadValue: "Holt k\xE9szlet \xE9rt\xE9ke",
      productName: "Term\xE9k",
      sku: "Cikksz\xE1m",
      quantity: "Mennyis\xE9g",
      lastMovement: "Utols\xF3 mozg\xE1s",
      daysSinceMovement: "Napok \xF3ta \xE1ll",
      classification: "Besorol\xE1s",
      value: "\xC9rt\xE9k",
      warehouse: "Rakt\xE1r",
      noMovement: "Nincs mozg\xE1s",
      noData: "Nincs adat a holt k\xE9szlet elemz\xE9shez"
    },
    analytics: {
      title: "K\xE9szlet analitika",
      subtitle: "ITR \xE9s ABC elemz\xE9s"
    },
    turnover: {
      title: "K\xE9szletforg\xE1si mutat\xF3 (ITR)",
      ratio: "Forg\xE1si r\xE1ta",
      cogs: "EL\xC1B\xC9 (becs\xFClt)",
      avgInventoryValue: "\xC1tlagos k\xE9szlet\xE9rt\xE9k",
      year: "\xC9v",
      previousYear: "El\u0151z\u0151 \xE9v",
      trend: "Trend",
      trendUp: "N\xF6vekv\u0151",
      trendDown: "Cs\xF6kken\u0151",
      trendStable: "Stabil",
      noData: "Nincs adat a forg\xE1si elemz\xE9shez"
    },
    abc: {
      title: "ABC elemz\xE9s",
      subtitle: "Pareto-besorol\xE1s \xE1rbev\xE9tel alapj\xE1n",
      product: "Term\xE9k",
      sku: "Cikksz\xE1m",
      revenue: "\xC1rbev\xE9tel",
      cumulativePercent: "Kumulat\xEDv %",
      class: "Oszt\xE1ly",
      aItems: "A t\xE9telek",
      bItems: "B t\xE9telek",
      cItems: "C t\xE9telek",
      totalRevenue: "\xD6sszes \xE1rbev\xE9tel",
      noData: "Nincs adat az ABC elemz\xE9shez"
    },
    seasonality: {
      title: "Szezonalit\xE1s",
      selectProduct: "Term\xE9k kiv\xE1laszt\xE1sa",
      chooseProduct: "V\xE1lasszon term\xE9ket...",
      topSeasonal: "Top 10 legszezon\xE1lisabb term\xE9k",
      productName: "Term\xE9k",
      index: "Szezonalit\xE1si index",
      peakMonths: "Cs\xFAcs h\xF3napok",
      lowMonths: "Alacsony h\xF3napok",
      peak: "Cs\xFAcs",
      normal: "Norm\xE1l",
      low: "Alacsony",
      noData: "Nincs adat a szezonalit\xE1s elemz\xE9shez"
    },
    transferSuggestion: {
      title: "Transfer javaslatok",
      totalSuggestions: "\xD6sszes javaslat",
      product: "Term\xE9k",
      from: "Forr\xE1s rakt\xE1r",
      to: "C\xE9l rakt\xE1r",
      currentFrom: "Aktu\xE1lis (forr\xE1s)",
      currentTo: "Aktu\xE1lis (c\xE9l)",
      suggestedQty: "Javasolt mennyis\xE9g",
      reason: "Indokl\xE1s",
      noSuggestions: "Jelenleg nincs transfer javaslat"
    },
    supplierCatalog: {
      title: "Besz\xE1ll\xEDt\xF3i katal\xF3gus",
      supplier: "Besz\xE1ll\xEDt\xF3",
      search: "Keres\xE9s",
      searchPlaceholder: "Keres\xE9s term\xE9k, cikksz\xE1m...",
      results: "Tal\xE1latok",
      productName: "Term\xE9k",
      category: "Kateg\xF3ria",
      price: "Nett\xF3 \xE1r",
      availability: "El\xE9rhet\u0151s\xE9g",
      leadTime: "Sz\xE1ll\xEDt\xE1si id\u0151",
      days: "nap",
      inStock: "K\xE9szleten",
      outOfStock: "Nincs k\xE9szleten",
      noResults: "Nincs tal\xE1lat",
      hint: "V\xE1lasszon besz\xE1ll\xEDt\xF3t \xE9s keressen term\xE9keket a katal\xF3gusban"
    },
    allProductGroups: "Minden term\xE9kcsoport",
    productGroups: {
      ALKATRESZ: "Alkatr\xE9sz",
      GEP: "G\xE9p",
      TARTOZEK: "Tartoz\xE9k",
      SZERSZAM: "Szersz\xE1m",
      MUNKARUHA: "Munkaruha / V\xE9d\u0151felszerel\xE9s",
      VEGYSZER: "Vegyszer / Ken\u0151anyag",
      EGYEB: "Egy\xE9b fogy\xF3eszk\xF6z",
      BERGEP: "B\xE9rg\xE9p",
      DIJAK: "D\xEDjak / Szolg\xE1ltat\xE1si d\xEDj",
      SZERZODESES: "Szerz\u0151d\xE9ses",
      BERENDEZES: "Berendez\xE9s"
    },
    reservedForWorksheet: "Munkalaphoz foglalva",
    summaryTitle: "K\xE9szlet \xF6sszes\xEDt\u0151",
    summarySubtitle: "Term\xE9kenk\xE9nti aggreg\xE1tum: mennyi van, foglalt vs. szabad",
    occupiedOfTotal: "{occupied}/{total} foglalt",
    stockLevel: {
      OK: "Rendben",
      LOW: "Alacsony",
      CRITICAL: "Kritikus",
      OUT_OF_STOCK: "Nincs k\xE9szleten"
    },
    movementUnitCost: "Egys\xE9gk\xF6lts\xE9g",
    movementValue: "Mozg\xE1s \xE9rt\xE9ke",
    breakdown: {
      expand: "Rakt\xE1rbont\xE1s megjelen\xEDt\xE9se",
      collapse: "Rakt\xE1rbont\xE1s elrejt\xE9se",
      title: "Rakt\xE1ronk\xE9nti bont\xE1s"
    }
  },
  loyalty: {
    title: "VIP Lojalit\xE1si Program",
    partnerId: "Partner azonos\xEDt\xF3",
    pointBalance: "Pontegyenleg",
    points: "{count} pont",
    trustedStatus: "Megb\xEDzhat\xF3 st\xE1tusz",
    consecutiveClean: "{count} egym\xE1s ut\xE1ni tiszta b\xE9rl\xE9s",
    deposit: "Kauci\xF3",
    creditPoints: "Pont j\xF3v\xE1\xEDr\xE1s",
    amountFt: "\xD6sszeg (Ft)",
    rentalNumber: "B\xE9rl\xE9s sz\xE1m",
    creditNote: "Megjegyz\xE9s",
    creditButton: "Pont j\xF3v\xE1\xEDr\xE1s",
    crediting: "J\xF3v\xE1\xEDr\xE1s...",
    calculationNote: "Pontsz\xE1m\xEDt\xE1s: floor(\xF6sszeg / 10.000). B\xE9rl\xE9s eset\xE9n: csak a 11. b\xE9rlest\u0151l.",
    redeemableRewards: "Bev\xE1lthat\xF3 jutalmak",
    redeem: "Bev\xE1lt\xE1s",
    pointHistory: "Pont t\xF6rt\xE9nelem ({count} db)",
    noPointRecords: "Nincs pont rekord.",
    expiresAt: "Lej\xE1r: {date}",
    sourceLabels: {
      rental: "B\xE9rl\xE9s",
      purchase: "V\xE1s\xE1rl\xE1s",
      bonus: "B\xF3nusz",
      redemption: "Bev\xE1lt\xE1s",
      expiry: "Lej\xE1rat"
    },
    depositRequired: "Kauci\xF3 sz\xFCks\xE9ges",
    depositFree: "Kauci\xF3mentes",
    creditAmount: "\xD6sszeg (Ft)",
    rewardLabel: "Jutalom",
    trusted: "Megb\xEDzhat\xF3",
    notTrusted: "Nem megb\xEDzhat\xF3",
    consecutiveCleanRentals: "{count} egym\xE1s ut\xE1ni tiszta b\xE9rl\xE9s",
    depositTitle: "Kauci\xF3",
    searchButton: "Keres\xE9s",
    loading: "Bet\xF6lt\xE9s...",
    amountPlaceholder: "\xD6sszeg (Ft)",
    rentalCountPlaceholder: "B\xE9rl\xE9s sz\xE1m",
    notePlaceholder: "Megjegyz\xE9s",
    calculationInfo: "Pontsz\xE1m\xEDt\xE1s: floor(\xF6sszeg / 10.000). B\xE9rl\xE9s eset\xE9n: csak a 11. b\xE9rl\xE9s\xE9t\u0151l.",
    redeemButton: "Bev\xE1lt\xE1s",
    expiresLabel: "Lej\xE1r",
    sourceLabelsObj: {
      RENTAL: "B\xE9rl\xE9s",
      PURCHASE: "V\xE1s\xE1rl\xE1s",
      BONUS: "B\xF3nusz",
      REDEMPTION: "Bev\xE1lt\xE1s",
      EXPIRY: "Lej\xE1rat",
      SALES: "\xC9rt\xE9kes\xEDt\xE9s",
      SERVICE: "Szerviz"
    }
  },
  finance: {
    title: "P\xE9nz\xFCgyek",
    journalTitle: "F\u0151k\xF6nyvi napl\xF3",
    journalSubtitle: "K\xF6nyvel\xE9si t\xE9telek (kett\u0151s k\xF6nyvvitel)",
    journalSourceFilter: "Forr\xE1s-sz\u0171r\u0151",
    journalSourceAll: "Mind",
    journalSourceInvoice: "Sz\xE1mla",
    journalSourceSale: "\xC9rt\xE9kes\xEDt\xE9s",
    journalSourceRentalDeposit: "Kauci\xF3",
    journalSourceRentalDepositRefund: "Kauci\xF3-visszat\xE9r\xEDt\xE9s",
    journalSourceRentalDepositForfeit: "Kauci\xF3-megtart\xE1s",
    journalColEntryNumber: "T\xE9telsz\xE1m",
    journalColDate: "D\xE1tum",
    journalColDescription: "Le\xEDr\xE1s",
    journalColSource: "Forr\xE1s",
    journalColDebit: "Tartozik",
    journalColCredit: "K\xF6vetel",
    journalColAccount: "F\u0151k\xF6nyvi sz\xE1mla",
    journalUnbalanced: "Nincs egyens\xFAlyban",
    journalEmpty: "Nincs k\xF6nyvel\xE9si t\xE9tel a kiv\xE1lasztott id\u0151szakban",
    journalEntryCount: "{count} t\xE9tel",
    cashRegister: "Kassza",
    cash: {
      noTransactions: "Nincs tranzakci\xF3 ezen a napon / ezzel a sz\u0171r\u0151vel."
    },
    dailyClose: "Napi z\xE1r\xE1s",
    szhFolder: "SZH Mappa",
    vouchers: "Bizonylatok",
    fixedAssets: "T\xE1rgyi eszk\xF6z\xF6k",
    szh: {
      label: "SZH",
      activity: "Tev\xE9kenys\xE9g",
      amountFt: "\xD6sszeg (Ft)",
      anonymous: "N\xE9vtelen",
      cancel: "Sztorn\xF3",
      confirm: "J\xF3v\xE1hagy\xE1s",
      confirmBody: "Biztosan v\xE9grehajtja az SZH tranzakci\xF3t?",
      confirmTitle: "SZH tranzakci\xF3 meger\u0151s\xEDt\xE9se",
      creditIssuance: "Hitel kiad\xE1s",
      expectedRevenue: "V\xE1rhat\xF3 bev\xE9tel",
      expectedSettlement: "V\xE1rhat\xF3 elsz\xE1mol\xE1s",
      generateReport: "Riport gener\xE1l\xE1sa",
      generating: "Gener\xE1l\xE1s...",
      internalNote: "Bels\u0151 megjegyz\xE9s",
      internalNoteRequired: "Bels\u0151 megjegyz\xE9s k\xF6telez\u0151",
      issue: "Kiad\xE1s",
      items: "T\xE9telek",
      loadError: "Nem siker\xFClt bet\xF6lteni, pr\xF3b\xE1ld \xFAjra.",
      lossReserve: "Vesztes\xE9g tartal\xE9k",
      noItems: "Nincs t\xE9tel",
      partnerName: "Partner neve",
      repayment: "Visszafizet\xE9s",
      reversal: "Sztorn\xF3"
    },
    receivables: "Kintl\xE9v\u0151s\xE9gek",
    deposit: "Kauci\xF3",
    noRegisterOpen: "Ma meg nincs nyitott kassza.",
    openRegister: "Kassza megnyit\xE1sa",
    opening: "Nyit\xE1s...",
    szhFolderButton: "SZH Mappa",
    blindCloseButton: "Vakz\xE1r\xE1s",
    totalBalance: "\xD6sszes egyenleg",
    recordTransaction: "Tranzakci\xF3 r\xF6gz\xEDt\xE9s",
    income: "Bev\xE9tel",
    expense: "Kiad\xE1s",
    expenseSummaryTitle: "Kiad\xE1s \xF6sszes\xEDt\u0151",
    expenseCategory: {
      label: "Kiad\xE1s kateg\xF3ria",
      none: "Kateg\xF3ria n\xE9lk\xFCl",
      salary: "B\xE9r / Fizet\xE9s",
      supplierPayment: "Besz\xE1ll\xEDt\xF3 fizet\xE9s",
      office: "Iroda",
      transport: "Sz\xE1ll\xEDt\xE1s / K\xF6zleked\xE9s",
      marketing: "Marketing",
      other: "Egy\xE9b"
    },
    amountPlaceholder: "\xD6sszeg (Ft)",
    notePlaceholder: "Megjegyz\xE9s",
    record: "R\xF6gz\xEDt\xE9s",
    recordError: {
      conflictTitle: "A kassza k\xF6zben megv\xE1ltozott",
      conflictBody: "Valaki m\xE1s r\xF6gz\xEDtett tranzakci\xF3t ezen a kassz\xE1n. Friss\xEDtsd a list\xE1t, \xE9s n\xE9zd meg, mi t\xF6rt\xE9nt \u2014 a be\xEDrt adatok megmaradtak.",
      refresh: "Friss\xEDt\xE9s",
      amountInvalid: "Ezt az \xF6sszeget \xEDgy nem lehet r\xF6gz\xEDteni. Ellen\u0151rizd, \xE9s \xEDrd be \xFAjra.",
      noteInvalid: "A megjegyz\xE9st ellen\u0151rizd, \xE9s \xEDrd be \xFAjra.",
      validation: "A megadott adatok valamelyik\xE9t \xEDgy nem lehet r\xF6gz\xEDteni. Ellen\u0151rizd, \xE9s pr\xF3b\xE1ld \xFAjra.",
      failed: "A tranzakci\xF3t most nem siker\xFClt r\xF6gz\xEDteni. A be\xEDrt adatok megmaradtak \u2014 pr\xF3b\xE1ld \xFAjra."
    },
    transactions: "Tranzakci\xF3k",
    loadingData: "Bet\xF6lt\xE9s...",
    inLabel: "Be:",
    outLabel: "Ki:",
    blindClose: "Vakz\xE1r\xE1s",
    physicalCount: "Fizikai \xF6sszeg be\xEDr\xE1s",
    physicalCountDesc: "Sz\xE1molja meg az egyes zsebek tartalm\xE1t, majd \xEDrja be a fizikai \xF6sszegeket.",
    physicalAmountPlaceholder: "Fizikai \xF6sszeg (Ft)",
    startBlindClose: "Vakz\xE1r\xE1s ind\xEDt\xE1s",
    compare: "\xD6sszehasonl\xEDt\xE1s",
    result: "Eredm\xE9ny",
    match: "Egyez\xE9s",
    discrepancy: "Elt\xE9r\xE9s!",
    tolerance: "Tolerancia: \xB12.000 Ft",
    recountRequired: "\xDAjrasz\xE1ml\xE1l\xE1s sz\xFCks\xE9ges!",
    recountRequiredDesc: "Az elt\xE9r\xE9s meghaladja a toleranci\xE1t. K\xE9rlek sz\xE1mold \xFAjra a zsebeket.",
    recount: "\xDAjrasz\xE1ml\xE1l\xE1s",
    finalizeClose: "Z\xE1r\xE1s v\xE9gleges\xEDt\xE9se",
    discrepancyReport: "Elt\xE9r\xE9si jegyz\u0151k\xF6nyv",
    blindCloseComplete: "Vakz\xE1r\xE1s befejezve",
    registerClosedSuccess: "A napi kassza sikeresen lez\xE1rva.",
    backToRegister: "Vissza a kassz\xE1hoz",
    noRegisterToClose: "Nincs nyitott kassza.",
    fixedAssetsTitle: "T\xE1rgyi eszk\xF6z\xF6k",
    runDepreciation: "Havi \xC9CS futtat\xE1s",
    runningDepreciation: "\xC9CS futtat\xE1sa...",
    newAsset: "\xDAj eszk\xF6z",
    newAssetForm: "\xDAj t\xE1rgyi eszk\xF6z r\xF6gz\xEDt\xE9s",
    assetName: "Megnevez\xE9s",
    purchasePricePlaceholder: "Beszerz\xE9s \xE1r (min 200.000 Ft)",
    commissionDate: "\xDCzembe helyez\xE9s",
    inventoryNumber: "Lelt\xE1ri sz\xE1m",
    serialNumber: "Sorozatsz\xE1m",
    recordAsset: "Eszk\xF6z r\xF6gz\xEDt\xE9s",
    recording: "R\xF6gz\xEDt\xE9s...",
    depreciationComplete: "\xC9CS futtat\xE1s k\xE9sz: {processed} feldolgozva, {deprecated} null\xE1ra le\xEDrt",
    assetsCount: "Eszk\xF6z\xF6k ({count} db)",
    noAssets: "Nincs eszk\xF6z.",
    purchaseLabel: "Beszerz\xE9s:",
    allCategories: "Minden kateg\xF3ria",
    allStatuses: "Minden st\xE1tusz",
    categoryLabels: {
      machinery: "G\xE9p",
      itEquipment: "IT eszk\xF6z",
      vehicle: "J\xE1rm\u0171"
    },
    assetStatusLabels: {
      active: "Akt\xEDv",
      fullyDepreciated: "0-ra le\xEDrt",
      scrapped: "Selejtezett",
      sold: "\xC9rt\xE9kes\xEDtett"
    },
    errorOccurred: "Hiba: {message}",
    vatSummaryTitle: "\xC1FA \xD6sszes\xEDt\u0151",
    vatSummarySubtitle: "Felsz\xE1m\xEDtott \xE9s levonhat\xF3 \xC1FA \xE1ttekint\xE9s",
    csvExport: "CSV Export",
    period: "Id\u0151szak",
    periodSelector: "Id\u0151szak v\xE1laszt\xF3",
    periodMonth: "H\xF3nap",
    periodQuarter: "Negyed\xE9v",
    periodYear: "\xC9v",
    staticData: "statikus adat",
    outputVat: "Felsz\xE1m\xEDtott \xC1FA",
    inputVat: "Levonhat\xF3 \xC1FA",
    vatPayable: "Fizetend\u0151 \xC1FA",
    vatReclaimable: "Visszaig\xE9nyelhet\u0151",
    salesNet: "\xC9rt\xE9kes\xEDt\xE9s nett\xF3",
    vatBreakdownByRate: "\xC1FA kulcsonk\xE9nti bont\xE1s",
    rateColumn: "Kulcs",
    outputColumn: "Felsz\xE1m\xEDtott",
    inputColumn: "Levonhat\xF3",
    balanceColumn: "Egyenleg",
    payableColumn: "Fizetend\u0151",
    total: "\xD6sszesen",
    monthlyTrend: "Havi alakul\xE1s",
    monthColumn: "H\xF3nap",
    currentLabel: "aktu\xE1lis",
    vatDeadlineTitle: "\xC1FA bevall\xE1s hat\xE1rid\u0151",
    vatDeadlineDescription: "A havi \xC1FA bevall\xE1s \xE9s befizet\xE9s hat\xE1rideje minden h\xF3nap 20-a. Negyed\xE9ves bevall\xE1sn\xE1l a negyed\xE9vet k\xF6vet\u0151 h\xF3nap 20-a.",
    vatPayableLabel: "Fizetend\u0151 \xC1FA:",
    dueDateLabel: "Esed\xE9kess\xE9g:",
    vatExempt: "Mentes",
    receivablesAgingTitle: "Kintl\xE9v\u0151s\xE9gek - \xD6reged\xE9si Riport",
    generatedAt: "Gener\xE1lva: {date}",
    refresh: "Friss\xEDt\xE9s",
    exportCsv: "CSV export\xE1l\xE1s",
    totalReceivables: "\xD6sszes kintl\xE9v\u0151s\xE9g",
    overdueReceivables: "Lej\xE1rt kintl\xE9v\u0151s\xE9g",
    overdueRatio: "Lej\xE1rt ar\xE1ny",
    agingBuckets: "\xD6reged\xE9si S\xE1vok (30/60/90+ nap)",
    partnerCount: "{count} partner, {invoices} sz\xE1mla",
    suspended: "Felf\xFCggesztve",
    invoicesOldest: "{count} sz\xE1mla \u2022 Legr\xE9gebbi: {date}",
    sendReminderTitle: "{level} k\xFCld\xE9se",
    sendReminderDefault: "Eml\xE9keztet\u0151 k\xFCld\xE9se",
    suspendPartnerTitle: "Partner felf\xFCggeszt\xE9se",
    unsuspendPartnerTitle: "Felf\xFCggeszt\xE9s felold\xE1sa",
    morePartners: "+ tov\xE1bbi {count} partner",
    noReceivablesInBucket: "Nincs kintl\xE9v\u0151s\xE9g ebben a s\xE1vban.",
    loadingError: "Hiba az adatok bet\xF6lt\xE9sekor.",
    partnerSuspended: "Partner felf\xFCggesztve ({id})",
    partnerUnsuspended: "Partner felf\xFCggeszt\xE9s feloldva ({id})",
    actionError: "Hiba t\xF6rt\xE9nt a m\u0171velet sor\xE1n",
    reminderSent: "Eml\xE9keztet\u0151 k\xFCldve{level}: {name}",
    confirmSuspend: "Biztosan felf\xFCggeszti a partnert: {name}?",
    confirmUnsuspend: "Biztosan feloldja a partner felf\xFCggeszt\xE9s\xE9t?",
    csvHeaderAgingBucket: "\xD6reged\xE9si s\xE1v",
    csvHeaderPartnerName: "Partner n\xE9v",
    csvHeaderPartnerId: "Partner azonos\xEDt\xF3",
    csvHeaderAmountHuf: "\xD6sszeg (HUF)",
    csvHeaderInvoiceCount: "Sz\xE1ml\xE1k sz\xE1ma",
    csvHeaderOldestInvoice: "Legr\xE9gebbi sz\xE1mla",
    fixedAssetTitle: "T\xE1rgyi eszk\xF6z",
    loading: "Bet\xF6lt\xE9s...",
    assetNotFound: "Eszk\xF6z nem tal\xE1lhat\xF3",
    back: "Vissza",
    basicData: "Alapadatok",
    category: "Kateg\xF3ria",
    status: "St\xE1tusz",
    inventoryNumberLabel: "Lelt\xE1ri sz\xE1m",
    serialNumberLabel: "Sorozatsz\xE1m",
    commissionDateLabel: "\xDCzembe helyez\xE9s",
    depreciationRateLabel: "Le\xEDr\xE1si kulcs",
    valueData: "\xC9rt\xE9kadat",
    purchasePrice: "Beszerz\xE9si \xE1r",
    currentValue: "Aktu\xE1lis \xE9rt\xE9k",
    depreciationPercent: "\xC9rt\xE9kcs\xF6kken\xE9s",
    noteLabel: "Megjegyz\xE9s: ",
    tamDeclarationsTitle: "TAM nyilatkozatok",
    newTamDeclaration: "\xDAj TAM nyilatkozat",
    tamDescription: "TAM cikk (0% \xC1FA) sz\xE1ml\xE1hoz k\xF6telez\u0151 nyilatkozat r\xF6gz\xEDt\xE9s.",
    invoiceIdPlaceholder: "Sz\xE1mla azonos\xEDt\xF3",
    methodApp: "Alkalmaz\xE1s",
    methodEmail: "Email",
    methodPaper: "Pap\xEDr",
    recordingDeclaration: "R\xF6gz\xEDt\xE9s...",
    recordDeclaration: "Nyilatkozat r\xF6gz\xEDt\xE9s",
    retry: "\xDAjrapr\xF3ba",
    errorPrefix: "Hiba: {message}",
    unknownError: "Ismeretlen hiba",
    noTamDeclarations: "M\xE9g nincs TAM nyilatkozat.",
    recordedDeclarations: "R\xF6gz\xEDtett nyilatkozatok ({count})",
    invoiceLabel: "Sz\xE1mla: {id}",
    methodLabel: "M\xF3d: {method}",
    expenseVouchersTitle: "Kiad\xE1si Bizonylatok",
    expenseVoucherManagement: "Kiad\xE1si bizonylat kezel\xE9s",
    expenseVoucherDescription: "A kiad\xE1si bizonylat \xE9s elsz\xE1mol\xE1sra kiad\xE1s funkci\xF3k a k\xF6vetkez\u0151 sprintben ker\xFClnek implement\xE1l\xE1sra (Story 62-8, 62-9 \u2014 ExpenseVoucher + AccountableExpense Prisma modellek sz\xFCks\xE9gesek).",
    issueExpenseVoucher: "Kiad\xE1si bizonylat ki\xE1ll\xEDt\xE1s",
    issueExpenseVoucherDesc: "Koll\xE9ga neve, \xF6sszeg, c\xE9l \u2192 nyomtathat\xF3",
    accountableExpense: "Elsz\xE1mol\xE1sra kiad\xE1s",
    accountableExpenseDesc: "\xD6sszeg, koll\xE9ga, c\xE9l, 3 munkanap deadline",
    comingSoon: "Hamarosan",
    ev: {
      issueNew: "\xDAj bizonylat",
      issueTitle: "Kiad\xE1si bizonylat ki\xE1ll\xEDt\xE1s",
      recipientName: "\xC1tvev\u0151 neve",
      recipientNamePlaceholder: "pl. Kiss P\xE9ter",
      amount: "\xD6sszeg",
      purpose: "C\xE9lmegjel\xF6l\xE9s",
      purposePlaceholder: "pl. Irodaszer beszerz\xE9s",
      issue: "Ki\xE1ll\xEDt\xE1s",
      settleTitle: "Elsz\xE1mol\xE1s",
      settledAmount: "Elsz\xE1molt \xF6sszeg",
      returnedAmount: "Visszaj\xE1r\xF3",
      receiptAttached: "Blokk csatolva",
      settle: "Elsz\xE1mol\xE1s",
      cancel: "Sztorn\xF3",
      filterStatus: "Sz\u0171r\xE9s st\xE1tusz alapj\xE1n",
      voucherNumber: "Bizonylat sz\xE1m",
      recipient: "\xC1tvev\u0151",
      deadline: "Hat\xE1rid\u0151",
      noVouchers: "Nincs bizonylat.",
      statusIssued: "Ki\xE1ll\xEDtva",
      statusOverdue: "Lej\xE1rt",
      statusSettled: "Elsz\xE1molva",
      statusCancelled: "Sztorn\xF3zva",
      receiptOk: "Blokk OK"
    },
    csvHeaderVatRate: "\xC1FA kulcs",
    csvHeaderSalesNet: "\xC9rt\xE9kes\xEDt\xE9s nett\xF3 (Ft)",
    csvHeaderOutputVat: "Felsz\xE1m\xEDtott \xC1FA (Ft)",
    csvHeaderPurchasesNet: "Beszerz\xE9s nett\xF3 (Ft)",
    csvHeaderInputVat: "Levonhat\xF3 \xC1FA (Ft)",
    csvHeaderDifference: "K\xFCl\xF6nb\xF6zet (Ft)",
    autoAccepted: "Automatikusan elfogadva",
    dailyCloseButton: "Napi z\xE1r\xE1s ind\xEDt\xE1sa",
    dailyCloseComplete: "Napi z\xE1r\xE1s befejezve",
    expectedBalance: "V\xE1rt egyenleg",
    overToleranceWarning: "Toleranci\xE1n k\xEDv\xFCli elt\xE9r\xE9s!",
    startDailyClose: "Napi z\xE1r\xE1s megkezd\xE9se",
    szhLabel: "SZH bizonylat",
    toleranceInfo: "Tolerancia: \xB12.000 Ft",
    monthlyClose: {
      title: "Havi z\xE1r\xE1s",
      subtitle: "Sz\xE1mviteli peri\xF3dus lez\xE1r\xE1sa l\xE9p\xE9sr\u0151l l\xE9p\xE9sre",
      selectPeriod: "Peri\xF3dus kiv\xE1laszt\xE1s",
      selectPeriodDesc: "V\xE1lassza ki a lez\xE1rand\xF3 \xE9vet \xE9s h\xF3napot",
      selected: "Kiv\xE1lasztva",
      periodHistory: "Peri\xF3dus t\xF6rt\xE9net",
      noHistory: "Nincs el\xE9rhet\u0151 peri\xF3dus t\xF6rt\xE9net.",
      periodColumn: "Peri\xF3dus",
      statusColumn: "St\xE1tusz",
      closedAtColumn: "Lez\xE1rva",
      closedByColumn: "Lez\xE1rta",
      statusOpen: "Nyitott",
      statusClosed: "Lez\xE1rt",
      summaryTitle: "\xD6sszes\xEDt\u0151 \u2014 {period}",
      revenue: "Bev\xE9tel",
      expenses: "Kiad\xE1s",
      vatTotal: "\xC1FA \xF6sszesen",
      invoiceCount: "Sz\xE1ml\xE1k sz\xE1ma",
      transactionCount: "Tranzakci\xF3k sz\xE1ma",
      closedInfo: "Lez\xE1rva: {date}, felhaszn\xE1l\xF3: {user}",
      noteLabel: "Megjegyz\xE9s",
      reopenButton: "\xDAjranyit\xE1s",
      openItemsTitle: "Nyitott t\xE9telek",
      openItemsDesc: "A peri\xF3dusban l\xE9v\u0151 lez\xE1ratlan t\xE9telek \xE1ttekint\xE9se",
      openDeliveryNotes: "Nyitott sz\xE1ll\xEDt\xF3levelek",
      unpaidInvoices: "Kifizetetlen sz\xE1ml\xE1k",
      pendingSzh: "F\xFCgg\u0151 SZH bizonylatok",
      openItemsWarning: "Figyelem: A peri\xF3dusban nyitott t\xE9telek vannak. A z\xE1r\xE1s el\u0151tt \xE9rdemes ezeket rendezni.",
      vatBreakdownTitle: "\xC1FA \xF6sszes\xEDt\u0151",
      vatBreakdownDesc: "\xC1FA bont\xE1s ad\xF3kulcsonk\xE9nt a peri\xF3dusra",
      vatRateColumn: "Ad\xF3kulcs",
      netColumn: "Nett\xF3",
      vatColumn: "\xC1FA",
      grossColumn: "Brutt\xF3",
      invoiceCountShort: "Sz\xE1ml\xE1k",
      noVatData: "Nincs \xC1FA adat a peri\xF3dusra.",
      csvVatRate: "Ad\xF3kulcs",
      csvNet: "Nett\xF3 (Ft)",
      csvVat: "\xC1FA (Ft)",
      csvGross: "Brutt\xF3 (Ft)",
      csvInvoiceCount: "Sz\xE1ml\xE1k sz\xE1ma",
      confirmTitle: "Havi z\xE1r\xE1s meger\u0151s\xEDt\xE9se",
      confirmCheckbox: "Meger\u0151s\xEDtem a(z) {period} peri\xF3dus havi z\xE1r\xE1s\xE1t. A z\xE1r\xE1s ut\xE1n a peri\xF3dus \xEDr\xE1sv\xE9dett lesz.",
      closeNoteLabel: "Megjegyz\xE9s (opcion\xE1lis)",
      closeNotePlaceholder: "Megjegyz\xE9s a z\xE1r\xE1shoz...",
      noPermission: "Nincs jogosults\xE1ga a peri\xF3dus lez\xE1r\xE1s\xE1hoz. Csak ADMIN \xE9s felettes szint\u0171 felhaszn\xE1l\xF3k z\xE1rhatj\xE1k le.",
      closeButton: "Peri\xF3dus lez\xE1r\xE1sa",
      closeSuccess: "Havi z\xE1r\xE1s sikeres!",
      closeSuccessDesc: "A(z) {period} peri\xF3dus sikeresen lez\xE1rva. A peri\xF3dus mostant\xF3l \xEDr\xE1sv\xE9dett.",
      periodAlreadyClosed: "A peri\xF3dus m\xE1r le van z\xE1rva",
      reopenTitle: "Peri\xF3dus \xFAjranyit\xE1s",
      reopenDesc: "A(z) {period} peri\xF3dus \xFAjranyit\xE1sa. Ez a m\u0171velet csak SUPER_ADMIN jogosults\xE1ggal v\xE9gezhet\u0151 el.",
      reopenReasonPlaceholder: "Indokl\xE1s az \xFAjranyit\xE1shoz...",
      reopenConfirm: "\xDAjranyit\xE1s meger\u0151s\xEDt\xE9se",
      loadError: "Hiba az adatok bet\xF6lt\xE9sekor.",
      vatFiled: "\xC1FA bevallva",
      vatNotFiled: "\xC1FA nem bevallva",
      vatFiledAt: "\xC1FA bevallva: {date}",
      vatFiledBy: "R\xF6gz\xEDtette: {user}",
      markVatFiled: "\xC1FA bevall\xE1s r\xF6gz\xEDt\xE9se",
      vatFilingNote: "Megjegyz\xE9s (opcion\xE1lis)",
      vatFilingNotePlaceholder: "\xC1FA bevall\xE1s megjegyz\xE9s...",
      vatFiledSuccess: "\xC1FA bevall\xE1s sikeresen r\xF6gz\xEDtve.",
      months: {
        januar: "Janu\xE1r",
        februar: "Febru\xE1r",
        marcius: "M\xE1rcius",
        aprilis: "\xC1prilis",
        majus: "M\xE1jus",
        junius: "J\xFAnius",
        julius: "J\xFAlius",
        augusztus: "Augusztus",
        szeptember: "Szeptember",
        oktober: "Okt\xF3ber",
        november: "November",
        december: "December"
      },
      steps: {
        periodSelect: "Peri\xF3dus kiv\xE1laszt\xE1s",
        summaryOverview: "\xD6sszes\xEDt\u0151 \xE1ttekint\xE9s",
        openItems: "Nyitott t\xE9telek",
        vatSummary: "\xC1FA \xF6sszes\xEDt\u0151",
        confirmation: "Meger\u0151s\xEDt\xE9s"
      }
    }
  },
  task: {
    title: "Feladatok",
    loading: "Feladatok bet\xF6lt\xE9se...",
    searchPlaceholder: "Keres\xE9s...",
    allTypes: "Minden t\xEDpus",
    allPriorities: "Minden priorit\xE1s",
    titlePlaceholder: "Feladat c\xEDme...",
    descriptionPlaceholder: "Feladat le\xEDr\xE1sa...",
    statusLabels: {
      open: "Nyitott",
      inProgress: "Folyamatban",
      completed: "K\xE9sz",
      interrupted: "Megszak\xEDtva"
    },
    priorityLabels: {
      low: "Alacsony",
      medium: "K\xF6zepes",
      high: "Magas"
    },
    kanbanTitle: "Kanban t\xE1bla \xE9s feladatkezel\xE9s",
    newTask: "\xDAj feladat",
    taskCount: "feladat",
    highPriority: "magas priorit\xE1s",
    noTasks: "Nincs feladat",
    assignee: "felel\u0151s",
    daysOverdue: "{count} napja lej\xE1rt",
    today: "Ma",
    tomorrow: "Holnap",
    deadline: "Hat\xE1rid\u0151",
    taskDescription: "Le\xEDr\xE1s",
    daysOverdueLabel: "napja lej\xE1rt",
    quantityLabel: "Mennyis\xE9g",
    unitDefault: "db",
    statusChange: "St\xE1tusz m\xF3dos\xEDt\xE1sa",
    closeButton: "Bez\xE1r\xE1s",
    titleLabel: "C\xEDm",
    descriptionLabel: "Le\xEDr\xE1s",
    priorityLabel: "Priorit\xE1s",
    priorityMedium: "K\xF6zepes",
    quantityFieldLabel: "Mennyis\xE9g",
    unitLabel: "Egys\xE9g",
    createButton: "L\xE9trehoz\xE1s",
    assignTo: "Felel\u0151s hozz\xE1rendel\xE9se",
    assignedUsers: "Felel\u0151s\xF6k",
    searchUsers: "Dolgoz\xF3 keres\xE9se...",
    removeAssignee: "Elt\xE1vol\xEDt\xE1s",
    status: {
      open: "Nyitott",
      inProgress: "Folyamatban",
      completed: "K\xE9sz",
      cancelled: "Megszak\xEDtva"
    },
    type: {
      shopping: "Bev\xE1s\xE1rl\xE1s",
      todo: "Teend\u0151",
      note: "Jegyzet",
      message: "\xDCzenet"
    },
    priority: {
      low: "Alacsony",
      medium: "K\xF6zepes",
      high: "Magas"
    }
  },
  admin: {
    title: "Admin K\xF6zpont",
    quickActions: "Gyors m\u0171veletek",
    dailyOpen: "Napi megnyit\xE1s",
    dailyOpenDesc: "Bolt nyit\xE1si folyamat ind\xEDt\xE1sa",
    dailyClose: "Napi z\xE1r\xE1s",
    dailyCloseDesc: "Bolt z\xE1r\xE1si folyamat ind\xEDt\xE1sa",
    sendReminders: "Eml\xE9keztet\u0151 k\xFCld\xE9s",
    sendRemindersDesc: "Lej\xE1rt b\xE9rl\xE9sek eml\xE9keztet\u0151i",
    knowledgeBase: "Tud\xE1sb\xE1zis",
    knowledgeBaseDesc: "Seg\xEDts\xE9g \xE9s \xFAtmutat\xF3k",
    subtitle: "Napi \xF6sszefoglal\xF3, gyors m\u0171veletek \xE9s \xFCzemeltet\xE9s",
    expiredRentals: "Lej\xE1rt b\xE9rl\xE9sek",
    oldestDays: "Legr\xE9gebbi: {days} nap",
    noExpiredRentals: "Nincs lej\xE1rt b\xE9rl\xE9s",
    receivables: "Kintl\xE9v\u0151s\xE9gek",
    overdue30Partners: "30+ napos: {count} partner",
    noReceivables: "Nincs kintl\xE9v\u0151s\xE9g",
    serviceWorksheets: "Szerviz munkalapok",
    worksheetStats: "V\xE1r\xF3: {waiting} | Folyamatban: {inProgress} | K\xE9sz: {completed}",
    todayBookings: "Mai foglal\xE1sok",
    todayPlanned: "Mai napra tervezett",
    tasks: "Feladatok",
    expiredTasks: "Lej\xE1rt: {count} feladat",
    noExpiredTasks: "Nincs lej\xE1rt feladat",
    dailyOpenWizard: "Napi megnyit\xE1s",
    dailyCloseWizard: "Napi z\xE1r\xE1s",
    stepCashBalance: "Kassza nyit\xF3 egyenleg",
    stepExpiredRentals: "Lej\xE1rt b\xE9rl\xE9sek",
    stepTodayBookings: "Mai foglal\xE1sok",
    stepServiceWaiting: "Szerviz v\xE1rakoz\xF3k",
    stepReceivables: "Kintl\xE9v\u0151s\xE9gek",
    stepTasks: "Feladatok",
    stepSummary: "\xD6sszes\xEDt\u0151",
    stepCashBalanceClose: "Kassza egyenleg",
    stepOpenRentals: "Nyitott b\xE9rl\xE9sek",
    stepServiceStatuses: "Szerviz st\xE1tuszok",
    stepDailyTurnover: "Napi forgalom",
    stepTaskClose: "Feladatok lez\xE1r\xE1s",
    enterOpeningBalance: "Adja meg a kassza nyit\xF3 egyenleg\xE9t (p\xE9nzt\xE1rg\xE9p + sz\xE9f).",
    openingBalanceHuf: "Nyit\xF3 egyenleg (HUF)",
    storeOpened: "Bolt megnyitva",
    openingTime: "Nyit\xE1s ideje",
    expectedBalanceHuf: "V\xE1rt egyenleg (HUF)",
    actualBalanceHuf: "T\xE9nyleges egyenleg (HUF)",
    difference: "Elt\xE9r\xE9s",
    storeClosed: "Bolt lez\xE1rva",
    closingTime: "Z\xE1r\xE1s ideje",
    openStore: "Bolt megnyit\xE1sa",
    closeStore: "Bolt lez\xE1r\xE1sa",
    cashBalanceDesc: "Adja meg a kassza v\xE1rt \xE9s t\xE9nyleges egyenleg\xE9t.",
    cashMismatch: "A kassza egyenleg nem egyezik a v\xE1rt \xE9rt\xE9kkel!",
    openRentalsReview: "Nyitott b\xE9rl\xE9sek \xE1ttekint\xE9se",
    expiredRentalsLabel: "Lej\xE1rt b\xE9rl\xE9sek",
    pcs: "db",
    oldestRental: "Legr\xE9gebbi b\xE9rl\xE9s",
    expiredDaysAgo: "{days} napja lej\xE1rt",
    serviceCloseStatus: "Szerviz munkalapok z\xE1r\xF3 st\xE1tusza",
    waitingLabel: "V\xE1rakoz\xF3",
    inProgressLabel: "Folyamatban",
    todayCompleted: "Ma befejezett",
    dailyTurnoverSummary: "Napi forgalom \xF6sszes\xEDt\xE9se",
    todayBookingsLabel: "Mai foglal\xE1sok",
    receivablesLabel: "Kintl\xE9v\u0151s\xE9gek",
    taskReviewClose: "Feladatok \xE1ttekint\xE9se \xE9s lez\xE1r\xE1sa",
    assignedTasks: "Kiosztott feladatok",
    expiredTasksLabel: "Lej\xE1rt feladatok",
    noteOptional: "Megjegyz\xE9s (opcion\xE1lis)",
    notePlaceholder: "Megjegyz\xE9s a mai napr\xF3l...",
    verifyAndCloseStore: "Ellen\u0151rizze az adatokat \xE9s z\xE1rja le a boltot.",
    cashBalance: "Kassza egyenleg",
    expectedActual: "V\xE1rt: {expected} | T\xE9nyleges: {actual}",
    deviation: "Elt\xE9r\xE9s: {amount}",
    openRentalsLabel: "Nyitott b\xE9rl\xE9sek",
    serviceWorksheetsOpen: "Szerviz munkalapok (nyitott)",
    tasksExpiredAssigned: "Feladatok (lej\xE1rt / kiosztott)",
    noteLabel: "Megjegyz\xE9s:",
    back: "Vissza",
    permissionMatrix: {
      adminAlwaysActive: "Admin (mindig akt\xEDv)",
      loading: "Bet\xF6lt\xE9s...",
      noWidgets: "Nincsenek widgetek a rendszerben."
    },
    kb: {
      tagPlaceholder: "\xDAj c\xEDmke (Enter a hozz\xE1ad\xE1shoz)"
    },
    warehouseLoading: "A rakt\xE1r bet\xF6lt\xE9se folyamatban \u2014 k\xE9rj\xFCk, v\xE1rjon.",
    warehouseMissing: "Ehhez a c\xE9ghez nincs be\xE1ll\xEDtva alap\xE9rtelmezett rakt\xE1r, ez\xE9rt a kassza nem nyithat\xF3/z\xE1rhat\xF3. Sz\xF3lj az adminnak.",
    warehouseFetchFailed: "A rakt\xE1r lek\xE9r\xE9se nem siker\xFClt (h\xE1l\xF3zati hiba). Pr\xF3b\xE1ld \xFAjra.",
    warehouseUnresolved: "A rakt\xE1r nem azonos\xEDthat\xF3, ez\xE9rt a kassza-m\u0171velet nem futtathat\xF3."
  },
  settings: {
    title: "Be\xE1ll\xEDt\xE1sok",
    fullName: "Teljes n\xE9v",
    emailAddress: "Email c\xEDm",
    phoneNumber: "Telefonsz\xE1m",
    currentPassword: "Jelenlegi jelsz\xF3",
    newPassword: "\xDAj jelsz\xF3",
    confirmNewPassword: "\xDAj jelsz\xF3 meger\u0151s\xEDt\xE9s",
    profileTab: "Profil",
    appearanceTab: "Megjelen\xE9s",
    notificationsTab: "\xC9rtes\xEDt\xE9sek",
    systemTab: "Rendszer",
    personalData: "Szem\xE9lyes adatok",
    uploadImage: "K\xE9p felt\xF6lt\xE9se",
    role: "Szerepk\xF6r",
    changePassword: "Jelsz\xF3 m\xF3dos\xEDt\xE1s",
    theme: "T\xE9ma",
    themeSystem: "Rendszer",
    themeLight: "Vil\xE1gos",
    themeDark: "S\xF6t\xE9t",
    language: "Nyelv",
    langHu: "Magyar",
    langEn: "English",
    langDe: "Deutsch",
    fontSize: "Bet\u0171m\xE9ret",
    fontSmall: "Kicsi",
    fontMedium: "K\xF6zepes",
    fontLarge: "Nagy",
    compactMode: "Kompakt m\xF3d",
    compactModeDesc: "Kisebb marg\xF3k \xE9s t\xE9rk\xF6z\xF6k",
    notifEmail: "Email \xE9rtes\xEDt\xE9sek",
    notifEmailDesc: "\xC9rtes\xEDt\xE9sek email-ben",
    notifPush: "Push \xE9rtes\xEDt\xE9sek",
    notifPushDesc: "B\xF6ng\xE9sz\u0151 \xE9rtes\xEDt\xE9sek",
    notifSound: "Hangjelz\xE9s",
    notifSoundDesc: "\xC9rtes\xEDt\xE9si hang",
    notifRentalExpiry: "B\xE9rl\xE9s lej\xE1rat",
    notifRentalExpiryDesc: "Figyelmeztet\xE9s b\xE9rl\xE9s lej\xE1ratakor",
    notifServiceReady: "Szerviz k\xE9sz",
    notifServiceReadyDesc: "\xC9rtes\xEDt\xE9s, ha a szerviz munka elk\xE9sz\xFClt",
    notifNewBooking: "\xDAj foglal\xE1s",
    notifNewBookingDesc: "Online foglal\xE1s \xE9rtes\xEDt\xE9s",
    notifPaymentReceived: "Befizet\xE9s",
    notifPaymentReceivedDesc: "\xC9rtes\xEDt\xE9s befizet\xE9skor",
    notifLowStock: "Alacsony k\xE9szlet",
    notifLowStockDesc: "K\xE9szlet figyelmeztet\xE9s",
    notifTaskAssigned: "Feladat hozz\xE1rendel\xE9s",
    notifTaskAssignedDesc: "\xC9rtes\xEDt\xE9s \xFAj feladat hozz\xE1rendel\xE9sekor",
    notificationPrefs: {
      title: "\xC9rtes\xEDt\xE9si be\xE1ll\xEDt\xE1sok",
      subtitle: "\xC1ll\xEDtsd be, mely csatorn\xE1kon (email / SMS / in-app) \xE9rkezzenek az egyes \xE9rtes\xEDt\xE9sek, \xE9s pihen\u0151 id\u0151szakot is meghat\xE1rozhatsz.",
      loading: "Be\xE1ll\xEDt\xE1sok bet\xF6lt\xE9se\u2026",
      loadError: "Nem siker\xFClt bet\xF6lteni a be\xE1ll\xEDt\xE1sokat. K\xE9rj\xFCk, pr\xF3b\xE1ld meg \xFAjra.",
      channelsTitle: "\xC9rtes\xEDt\xE9si csatorn\xE1k t\xEDpusonk\xE9nt",
      channels: {
        email: "Email",
        sms: "SMS",
        "in-app": "Alkalmaz\xE1son bel\xFCl"
      },
      domains: {
        vehicle: "J\xE1rm\u0171",
        rental: "B\xE9rl\xE9s",
        service: "Szerviz",
        sales: "\xC9rt\xE9kes\xEDt\xE9s",
        finance: "P\xE9nz\xFCgy",
        workflow: "Folyamatok",
        documents: "Dokumentumok",
        partner: "Partner"
      },
      priorityCritical: "Kritikus",
      quietHoursTitle: "Pihen\u0151 id\u0151szak",
      quietHoursHint: "A pihen\u0151 id\u0151szakban csak a kritikus \xE9rtes\xEDt\xE9sek jelennek meg \u2014 a t\xF6bbi a k\xF6vetkez\u0151 napra halaszt\xF3dik.",
      quietHoursStart: "Kezd\xE9s",
      quietHoursEnd: "Befejez\xE9s",
      timezone: "Id\u0151z\xF3na",
      timezonePlaceholder: "V\xE1lassz id\u0151z\xF3n\xE1t\u2026",
      saveAll: "\xD6sszes ment\xE9se",
      saving: "Ment\xE9s\u2026",
      unsavedChanges: "{count} nem mentett m\xF3dos\xEDt\xE1s",
      allSaved: "Minden v\xE1ltoz\xE1s mentve",
      adminResetTitle: "Admin: be\xE1ll\xEDt\xE1s vissza\xE1ll\xEDt\xE1sa",
      adminResetHint: "Franchise admin \u2014 egy felhaszn\xE1l\xF3 \xE9rtes\xEDt\xE9si be\xE1ll\xEDt\xE1sait alap\xE9rtelmezettre \xE1ll\xEDtja. A felhaszn\xE1l\xF3 ezt k\xF6vet\u0151en \xFAjra kapja az \xF6sszes alap-\xE9rtes\xEDt\xE9st.",
      adminResetPlaceholder: "Felhaszn\xE1l\xF3 UUID",
      adminResetAction: "Vissza\xE1ll\xEDt\xE1s",
      adminResetting: "Vissza\xE1ll\xEDt\xE1s\u2026",
      adminResetSuccess: "{count} sor vissza\xE1ll\xEDtva az alap\xE9rtelmezetekre.",
      adminResetError: "A vissza\xE1ll\xEDt\xE1s nem siker\xFClt. Ellen\u0151rizd a felhaszn\xE1l\xF3 UUID-t \xE9s a jogosults\xE1got."
    },
    systemSettings: "Rendszer be\xE1ll\xEDt\xE1sok",
    autoLogout: "Automatikus kijelentkez\xE9s",
    autoLogoutDesc: "Inaktivit\xE1s ut\xE1ni kijelentkez\xE9s",
    minutes: "perc",
    dataExport: "Adat export\xE1l\xE1s",
    dataExportDesc: "Szem\xE9lyes adatok let\xF6lt\xE9se GDPR alapj\xE1n",
    exportButton: "Adatok export\xE1l\xE1sa",
    dangerZone: "Vesz\xE9lyes z\xF3na",
    deleteAccount: "Fi\xF3k t\xF6rl\xE9se",
    deleteAccountDesc: "A fi\xF3k \xE9s minden kapcsol\xF3d\xF3 adat v\xE9gleges t\xF6rl\xE9se",
    deleteButton: "Fi\xF3k v\xE9gleges t\xF6rl\xE9se",
    subtitleText: "Rendszer \xE9s felhaszn\xE1l\xF3i be\xE1ll\xEDt\xE1sok",
    roleLabel: "Szerepk\xF6r",
    changePasswordButton: "Jelsz\xF3 m\xF3dos\xEDt\xE1sa",
    themeLabel: "T\xE9ma",
    emailNotifications: "Email \xE9rtes\xEDt\xE9sek",
    pushNotifications: "Push \xE9rtes\xEDt\xE9sek",
    summaryEmails: "\xD6sszefoglal\xF3 emailek",
    rentalExpiryDesc: "\xC9rtes\xEDt\xE9s 1 nappal a b\xE9rl\xE9s lej\xE1rata el\u0151tt",
    dailySummaryDesc: "Minden nap reggel 8:00-kor",
    weeklySummaryDesc: "Minden h\xE9tf\u0151n reggel 8:00-kor",
    languageLabel: "Nyelv",
    dateFormatLabel: "D\xE1tum form\xE1tum",
    currencyLabel: "P\xE9nznem",
    timezoneLabel: "Id\u0151z\xF3na",
    securityTitle: "Biztons\xE1g",
    rentalDefaultsTitle: "B\xE9rl\xE9s alapbe\xE1ll\xEDt\xE1sok",
    defaultRentalDays: "Alap\xE9rtelmezett b\xE9rl\xE9si id\u0151 (nap)",
    defaultDeposit: "Alap\xE9rtelmezett kauci\xF3 (%)",
    exportDesc: "Minden adat let\xF6lt\xE9se CSV form\xE1tumban",
    clearCache: "Gyors\xEDt\xF3t\xE1r t\xF6rl\xE9se",
    clearCacheDesc: "Helyi gyors\xEDt\xF3t\xE1r \xE9s be\xE1ll\xEDt\xE1sok t\xF6rl\xE9se",
    clearButton: "T\xF6rl\xE9s",
    profileSaved: "Profil mentve!",
    notificationsSaved: "\xC9rtes\xEDt\xE9si be\xE1ll\xEDt\xE1sok mentve!",
    systemSaved: "Rendszer be\xE1ll\xEDt\xE1sok mentve!",
    currencyHUF: "HUF - Magyar forint",
    currencyEUR: "EUR - Eur\xF3",
    autoLogout15: "15 perc",
    autoLogout30: "30 perc",
    autoLogout60: "1 \xF3ra",
    autoLogout120: "2 \xF3ra",
    autoLogoutNever: "Soha",
    ocr: {
      zebraLabel: "Zebra ZD220 c\xEDmke (43x26mm)"
    },
    avatarHelp: "JPG vagy PNG, max 2MB",
    sms: {
      sendTab: "SMS k\xFCld\xE9s",
      historyTab: "T\xF6rt\xE9nelem",
      templatesTab: "Sablonok"
    }
  },
  dashboard: {
    title: "Dashboard",
    monthlyRevenue: "Havi bev\xE9tel",
    activeRentals: "Akt\xEDv b\xE9rl\xE9sek",
    openWorksheets: "Nyitott munkalapok",
    dailyTransactions: "Napi tranzakci\xF3k",
    revenueChart: "Bev\xE9tel diagram",
    topPartners: "Top partnerek",
    equipmentProfit: "G\xE9p profitabilit\xE1s",
    rentalStats: "B\xE9rl\xE9si statisztik\xE1k",
    serviceProfit: "Szerviz profitabilit\xE1s",
    seasonality: "Szezonalit\xE1s",
    stockAlerts: "K\xE9szlet riaszt\xE1sok",
    technicianWorkload: "Szerel\u0151 terhel\xE9s",
    partnerActivity: "Partner aktivit\xE1s",
    warrantyRatio: "Garancia ar\xE1ny",
    revenueForecast: "Bev\xE9tel el\u0151rejelz\xE9s",
    vatSummary: "\xC1FA \xF6sszes\xEDt\u0151",
    recurringIssues: "Visszat\xE9r\u0151 hib\xE1k",
    popularEquipment: "N\xE9pszer\u0171 g\xE9pek",
    section: {
      alreadyAtBottom: "M\xE1r a legals\xF3 poz\xEDci\xF3ban",
      alreadyAtTop: "M\xE1r a legfels\u0151 poz\xEDci\xF3ban",
      collapse: "\xD6sszecsuk",
      collapseSection: "Szekci\xF3 \xF6sszecsuk\xE1sa",
      comingSoon: "Hamarosan...",
      expand: "Kinyit",
      expandSection: "Szekci\xF3 kinyit\xE1sa",
      moveDown: "Lejjebb mozgat\xE1s",
      moveSectionDown: "Szekci\xF3 lejjebb mozgat\xE1sa",
      moveSectionUp: "Szekci\xF3 feljebb mozgat\xE1sa",
      moveUp: "Feljebb mozgat\xE1s",
      settings: "Be\xE1ll\xEDt\xE1sok",
      summary: "\xD6sszefoglal\xF3",
      finance: "P\xE9nz\xFCgy",
      inventory: "K\xE9szlet",
      service: "Szerviz",
      partner: "Partner",
      analytics: "B\xE9rl\xE9s",
      rental: "B\xE9rl\xE9s",
      kassza: "Kassza"
    },
    collapse: "\xD6sszecsuk\xE1s",
    expand: "Nagy\xEDt\xE1s",
    showMore: "T\xF6bb mutat\xE1sa",
    showLess: "Kevesebb mutat\xE1sa",
    welcome: "\xDCdv\xF6z\xF6lj\xFCk, {name}!",
    todaySummary: "Itt van a mai nap \xF6sszefoglal\xF3ja.",
    defaultUser: "Felhaszn\xE1l\xF3",
    executiveSummaryAriaLabel: "Executive Summary - F\u0151 mutat\xF3k",
    executiveSummaryTitle: "Vezet\u0151i \xF6sszefoglal\xF3",
    expandWidget: "Widget nagy\xEDt\xE1sa",
    minimize: "Kis m\xE9ret",
    minimizeWidget: "Vissza\xE1ll\xEDt\xE1s kis m\xE9retre",
    pinIndicatorAriaLabel: "R\xF6gz\xEDtett szekci\xF3",
    pinIndicatorTitle: "Mindig l\xE1that\xF3 - nem \xF6sszecsukhat\xF3",
    collapseAll: "\xD6sszes \xF6sszecsuk\xE1sa",
    contactAdminForPermissions: "K\xE9rd a rendszergazd\xE1t a jogosults\xE1gok be\xE1ll\xEDt\xE1s\xE1hoz.",
    executive: {
      activeWorksheets: "Akt\xEDv Munkalapok",
      businessHealth: "\xDCzleti Eg\xE9szs\xE9g",
      dailyRevenue: "Napi Bev\xE9tel",
      healthGood: "J\xF3",
      inventory: "K\xE9szlet",
      openedToday: "ma nyitott",
      receivables: "Kintl\xE9v\u0151s\xE9g",
      utilization: "kihaszn\xE1lts\xE1g",
      revenueTarget: "c\xE9l: {amount}",
      receivablesTarget: "c\xE9l: {amount}"
    },
    expandAll: "\xD6sszes kinyit\xE1sa",
    hideExecutiveSummary: "Executive Summary elrejt\xE9se",
    loading: "Bet\xF6lt\xE9s...",
    noSections: "Nincs megjelen\xEDthet\u0151 szekci\xF3.",
    noWidgetsInSection: "Nincs megjelen\xEDthet\u0151 widget ebben a szekci\xF3ban.",
    notAuthenticated: "Nem vagy bejelentkezve",
    sectionCount: "{count} szekci\xF3",
    showExecutiveSummary: "Executive Summary megjelen\xEDt\xE9se",
    resetLayout: "Alap\xE9rtelmezett elrendez\xE9s vissza\xE1ll\xEDt\xE1sa",
    dragToReorder: "H\xFAzd ide az \xE1trendez\xE9shez",
    widgets: {
      reset: "Widget be\xE1ll\xEDt\xE1sok vissza\xE1ll\xEDt\xE1sa",
      sync_error: "Widget be\xE1ll\xEDt\xE1sok ment\xE9se sikertelen \u2014 pr\xF3b\xE1ld \xFAjra",
      sync_success: "Widget be\xE1ll\xEDt\xE1sok mentve",
      migration_done: "Kor\xE1bbi elrendez\xE9s bet\xF6ltve",
      migration_error: "Kor\xE1bbi elrendez\xE9s \xE1tvitele sikertelen",
      loading: "Be\xE1ll\xEDt\xE1sok bet\xF6lt\xE9se...",
      saved: "Mentve"
    },
    kassza: {
      threePocketTitle: "3-Pocket Kassza",
      total: "\xD6sszesen",
      mainRegister: "F\u0151p\xE9nzt\xE1r",
      szhPocket: "SZH Zseb",
      bankAccount: "Bank (K&H)",
      dailyNet: "napi nett\xF3",
      toleranceTitle: "Kassza Tolerancia",
      toleranceOk: "Toleranci\xE1n bel\xFCl",
      toleranceWarning: "Figyelmeztet\xE9s",
      toleranceCritical: "Toleranci\xE1n k\xEDv\xFCl!",
      lastTransactions: "Utols\xF3 tranzakci\xF3k",
      income: "Bev\xE9tel",
      expense: "Kiad\xE1s",
      transfer: "\xC1thelyz.",
      minutesAgo: "perce",
      hoursAgo: "\xF3r\xE1ja",
      dailyStatusTitle: "Napi St\xE1tusz",
      statusOpen: "Nyitva",
      statusClosed: "Z\xE1rva",
      openedAt: "Megnyitva",
      szhReportTitle: "SZH \xD6sszes\xEDt\u0151",
      szhTotal: "SZH \xD6sszes",
      statusNotOpened: "Nem nyitott",
      noData: "Nincs adat"
    },
    franchiseRevenue: {
      title: "Franchise bev\xE9tel megoszl\xE1s",
      total: "\xD6ssz."
    },
    kpi: {
      grossRevenue: "Brutt\xF3 Bev\xE9tel",
      grossRevenueAria: "Brutt\xF3 Bev\xE9tel KPI widget",
      netRevenue: "Nett\xF3 Bev\xE9tel",
      netRevenueAria: "Nett\xF3 Bev\xE9tel KPI widget",
      receivables: "Kintl\xE9v\u0151s\xE9g",
      receivablesAria: "Kintl\xE9v\u0151s\xE9g KPI widget",
      high: "Magas",
      payments: "Befizet\xE9sek",
      paymentsAria: "Befizet\xE9sek KPI widget"
    },
    detailedView: "R\xE9szletes n\xE9zet"
  },
  network: {
    online: "Online",
    offline: "Offline",
    offlineMode: "Offline m\xF3d",
    syncing: "Szinkroniz\xE1l\xE1s...",
    lastSync: "Utols\xF3 szinkroniz\xE1l\xE1s",
    pendingSync: "v\xE1r szinkroniz\xE1l\xE1sra",
    syncComplete: "Szinkroniz\xE1l\xE1s k\xE9sz",
    syncFailed: "Szinkroniz\xE1l\xE1s sikertelen",
    minuteAgo: "perce",
    minutesAgo: "perce",
    hourAgo: "\xF3r\xE1ja",
    hoursAgo: "\xF3r\xE1ja"
  },
  table: {
    partner: "Partner",
    period: "Id\u0151szak",
    amount: "\xD6sszeg",
    status: "St\xE1tusz",
    actions: "M\u0171veletek",
    date: "D\xE1tum",
    type: "T\xEDpus",
    description: "Le\xEDr\xE1s",
    quantity: "Menny.",
    unitPrice: "Egys\xE9g\xE1r",
    vat: "\xC1FA",
    netAmount: "Nett\xF3",
    grossAmount: "Brutt\xF3",
    addItem: "T\xE9tel hozz\xE1ad\xE1sa"
  },
  payment: {
    cash: "K\xE9szp\xE9nz",
    card: "K\xE1rtya",
    transfer: "\xC1tutal\xE1s",
    method: "Fizet\xE9si m\xF3d"
  },
  page: {
    allStatuses: "Minden st\xE1tusz",
    allTypes: "Minden t\xEDpus",
    allCategories: "Minden kateg\xF3ria",
    noResults: "Nincs tal\xE1lat a keres\xE9si felt\xE9telekre.",
    noFilterResults: "Nincs tal\xE1lat a sz\u0171r\xE9si felt\xE9teleknek megfelel\u0151en.",
    errorPrefix: "Hiba: {message}",
    displayed: "{count} megjelen\xEDtve",
    partnersDisplayed: "{count} partner megjelen\xEDtve",
    ordersCount: "{count} rendel\xE9s",
    itemsCount: "{count} t\xE9tel",
    daysLate: "{count} nap k\xE9s\xE9s",
    machinesCount: "{count} g\xE9p"
  },
  partner: {
    scan: {
      button: "\u{1F4F7} Igazolv\xE1ny szkennel\xE9s",
      buttonAriaLabel: "Okm\xE1ny szkennel\xE9s kamer\xE1val",
      processing: "Feldolgoz\xE1s...",
      success: "Szkennel\xE9s sikeres \u2014 ellen\u0151rizd az adatokat",
      failure: "Nem siker\xFClt beolvasni, pr\xF3b\xE1ld \xFAjra",
      lowConfidence: "Alacsony megb\xEDzhat\xF3s\xE1g \u2014 k\xE9rlek ellen\u0151rizd k\xE9zzel az adatokat"
    },
    expired: {
      banner: "\u26A0\uFE0F Lej\xE1rt okm\xE1ny \u2014 {days} napja",
      bannerNoDate: "\u26A0\uFE0F Az okm\xE1ny lej\xE1rt",
      overrideCheckbox: "Folytat\xE1s lej\xE1rt okm\xE1nnyal",
      overrideReasonLabel: "Fel\xFCl\xEDr\xE1s indokl\xE1sa (k\xF6telez\u0151)",
      overrideReasonPlaceholder: "pl. \xDCgyf\xE9l aznap kapta meg a meg\xFAj\xEDtott okm\xE1nyt",
      overrideReasonRequired: "Indokl\xE1s k\xF6telez\u0151, ha lej\xE1rt okm\xE1nnyal folytatod"
    },
    title: "Partnerek",
    subtitle: "Vev\u0151k, besz\xE1ll\xEDt\xF3k \xE9s alv\xE1llalkoz\xF3k kezel\xE9se",
    name: "N\xE9v",
    email: "E-mail",
    phone: "Telefon",
    address: "C\xEDm",
    taxNumber: "Ad\xF3sz\xE1m",
    newPartner: "\xDAj partner",
    partnerList: "Partnerlista",
    totalPartners: "\xD6sszes partner",
    company: "C\xE9g",
    individual: "Mag\xE1nszem\xE9ly",
    withBalance: "Tartoz\xE1ssal",
    totalBalance: "\xD6ssz. tartoz\xE1s",
    contact: "Kapcsolat",
    revenue: "Forgalom",
    balance: "Tartoz\xE1s",
    categories: "Kateg\xF3ri\xE1k",
    duplicatesTitle: "Partner duplik\xE1ci\xF3 & elhagyott g\xE9pek",
    searchPlaceholder: "Keres\xE9s n\xE9v, k\xF3d, email, telefon, ad\xF3sz\xE1m...",
    matchFieldLabels: {
      phone: "Telefon",
      documentNumber: "Okm\xE1nysz\xE1m",
      email: "Email",
      name: "N\xE9v",
      taxNumber: "Ad\xF3sz\xE1m",
      DOCUMENT_NUMBER: "Igazolv\xE1nysz\xE1m",
      EMAIL: "Email c\xEDm",
      NAME: "N\xE9v",
      TAX_NUMBER: "Ad\xF3sz\xE1m"
    },
    actionLabels: {
      scrapped: "Selejtezve",
      sold: "\xC9rt\xE9kes\xEDtve",
      retained: "Meg\u0151rizve",
      DESTROY: "Megsemmis\xEDt\xE9s",
      KEEP: "Megtart\xE1s",
      SELL: "\xC9rt\xE9kes\xEDt\xE9s"
    },
    scrappingReason: "Selejtez\xE9si indokl\xE1s:",
    registerData: "Partner adatok r\xF6gz\xEDt\xE9se",
    typeAndCategory: "T\xEDpus \xE9s kateg\xF3ria",
    partnerType: "Partner t\xEDpusa",
    categoriesRequired: "Kateg\xF3ri\xE1k * (legal\xE1bb egy)",
    basicData: "Alapadatok",
    companyName: "C\xE9gn\xE9v",
    companyNameOptional: "C\xE9g (opcion\xE1lis)",
    validation: {
      taxFormat: "Az ad\xF3sz\xE1m form\xE1tuma \xE9rv\xE9nytelen (8-1-2 sz\xE1mjegy).",
      taxChecksum: "Az ad\xF3sz\xE1m ellen\u0151rz\u0151 sz\xE1ma hib\xE1s.",
      phoneFormat: "A telefonsz\xE1m form\xE1tuma \xE9rv\xE9nytelen.",
      postalFormat: "Az ir\xE1ny\xEDt\xF3sz\xE1m form\xE1tuma \xE9rv\xE9nytelen (4 sz\xE1mjegy)."
    },
    fullName: "Teljes n\xE9v",
    shortName: "R\xF6vid n\xE9v",
    registrationNumber: "C\xE9gjegyz\xE9ksz\xE1m",
    contactInfo: "El\xE9rhet\u0151s\xE9gek",
    website: "Weboldal",
    billingAddress: "Sz\xE1ml\xE1z\xE1si c\xEDm",
    postalCode: "Ir\xE1ny\xEDt\xF3sz\xE1m",
    city: "V\xE1ros",
    streetAddress: "Utca, h\xE1zsz\xE1m",
    floorDoor: "Emelet/ajt\xF3",
    notificationEmail: "\xC9rtes\xEDt\xE9si email",
    billingEmail: "Sz\xE1ml\xE1z\xE1si email",
    billingEmailSameAsNotification: "Megegyezik az \xE9rtes\xEDt\xE9si email-lel",
    temporaryAddress: "Tart\xF3zkod\xE1si hely",
    tempAddressValidUntil: "\xC9rv\xE9nyess\xE9g v\xE9ge",
    temporaryAddressSection: "Tart\xF3zkod\xE1si hely (ha elt\xE9r a lakc\xEDmt\u0151l)",
    temporaryAddressExpired: "(lej\xE1rt)",
    lastDocumentScanDate: "Utols\xF3 okm\xE1ny beolvas\xE1s",
    documentExpiredWarning: "Okm\xE1ny friss\xEDt\xE9s sz\xFCks\xE9ges",
    documentExpiredRentalWarning: "A partner okm\xE1nya t\xF6bb mint 180 napja lett beolvasva. K\xE9rj\xFCk, k\xE9rje el a friss okm\xE1nyt!",
    cashB2bTaxNumberRequired: "C\xE9ges k\xE9szp\xE9nzes tranzakci\xF3hoz ad\xF3sz\xE1m megad\xE1sa k\xF6telez\u0151!",
    paymentBypassEnabled: "\xC1tutal\xE1sos fizet\xE9s enged\xE9lyez\xE9se j\xF3v\xE1hagy\xE1s n\xE9lk\xFCl",
    paymentBypassDescription: "Bekapcsolva: a partner \xE1tutal\xE1ssal fizethet k\xFCl\xF6n vezet\u0151i enged\xE9ly k\xE9r\xE9se n\xE9lk\xFCl.",
    paymentBypassReadonlyHint: "Csak a vezet\u0151i j\xF3v\xE1hagy\xE1si folyamaton kereszt\xFCl m\xF3dos\xEDthat\xF3.",
    fieldReadonlyHint: "L\xE9trehoz\xE1skor megadott \u2014 itt nem szerkeszthet\u0151.",
    categoriesReadonlyHint: "A kateg\xF3ri\xE1k a partner t\xEDpus\xE1b\xF3l sz\xE1rmaznak \u2014 itt nem szerkeszthet\u0151.",
    idVerified: "Okm\xE1ny ellen\u0151rizve",
    idVerifiedOn: "\u2705 Ellen\u0151rizve: {date}",
    costBearerTree: "K\xF6lts\xE9gvisel\u0151 hierarchia",
    costBearerCompany: "K\xF6lts\xE9gvisel\u0151 c\xE9g",
    costBearerEmployees: "Alkalmazottak",
    compareTitle: "Partner \xF6sszehasonl\xEDt\xE1s",
    partnerA: "Partner A (forr\xE1s)",
    partnerB: "Partner B (egyez\xE9s)",
    compareDescription: "V\xE1laszd ki, melyik partnerbe szeretn\xE9d \xF6sszevonni a m\xE1sikat. Az \xF6sszevon\xE1s \xE1thelyezi a b\xE9rl\xE9seket, munkalapokat \xE9s sz\xE1ml\xE1kat.",
    mergeIntoA: "\xD6sszevon\xE1s A-ba \u2192",
    mergeIntoB: "\u2190 \xD6sszevon\xE1s B-be",
    openInNewTab: "Megnyit\xE1s \xFAj f\xFCl\xF6n \u2192",
    tabRentals: "B\xE9rl\xE9sek",
    tabService: "Szerviz",
    tabInvoices: "Sz\xE1ml\xE1k",
    tabLoyalty: "H\u0171s\xE9gpont",
    transactionTabPlaceholder: "A tranzakci\xF3k bet\xF6lt\xE9se folyamatban...",
    loyaltyPoints: "H\u0171s\xE9gpontok",
    depositExemption: "Kauci\xF3 mentess\xE9g",
    depositRequired: "K\xF6telez\u0151",
    depositExempt: "Mentes\xEDtett",
    depositAutomatic: "Automatikus (TRUSTED)",
    depositRequiredDesc: "Kauci\xF3 fizet\xE9se k\xF6telez\u0151 minden b\xE9rl\xE9shez",
    depositExemptDesc: "Boltvezet\u0151 \xE1ltal mentes\xEDtve \u2014 0 Ft kauci\xF3",
    depositAutomaticDesc: "10 probl\xE9mamentes b\xE9rl\xE9s ut\xE1n automatikus mentes\xEDt\xE9s",
    depositExemptionUpdated: "Kauci\xF3-mentess\xE9g friss\xEDtve",
    depositExemptionError: "A kauci\xF3-mentess\xE9g ment\xE9se nem siker\xFClt",
    depositExemptionListRequired: "A kauci\xF3-mentess\xE9ghez el\u0151bb legal\xE1bb egy list\xE1zott megb\xEDzott sz\xFCks\xE9ges (akt\xEDv k\xE9pvisel\u0151 vagy meghatalmaz\xE1s).",
    depositExemptionRbacHint: "Csak boltvezet\u0151 m\xF3dos\xEDthatja",
    phones: "Telefonsz\xE1mok",
    phoneNumbers: "Telefonsz\xE1mok",
    addPhone: "Telefonsz\xE1m hozz\xE1ad\xE1sa",
    phoneLabel: "T\xEDpus",
    phoneLabelPlaceholder: "pl. Szerv\xEDz, Alkatr\xE9sz...",
    phoneNumber: "Telefonsz\xE1m",
    phoneLabelPrivate: "Priv\xE1t",
    phoneLabelCompany: "C\xE9ges",
    phoneLabelFax: "Fax",
    phoneLabelOther: "Egy\xE9b",
    phonePrimary: "Els\u0151dleges",
    phoneMaxReached: "Legfeljebb 5 telefonsz\xE1m r\xF6gz\xEDthet\u0151",
    loyaltyTier: "Szint",
    personalData: "Szem\xE9lyes adatok",
    birthDate: "Sz\xFClet\xE9si d\xE1tum",
    birthPlace: "Sz\xFClet\xE9si hely",
    mothersName: "Anyja neve",
    idCardNumber: "Szem\xE9lyi ig. sz\xE1m",
    financialSettings: "P\xE9nz\xFCgyi be\xE1ll\xEDt\xE1sok",
    paymentTermDays: "Fizet\xE9si hat\xE1rid\u0151 (nap)",
    creditLimitFt: "Hitelkeret (Ft)",
    discountPercent: "Kedvezm\xE9ny %",
    rentalDepositPercent: "B\xE9rl\xE9si kauci\xF3 %",
    createPartner: "Partner l\xE9trehoz\xE1sa",
    notesPlaceholder: "Opcion\xE1lis megjegyz\xE9s a partnerr\u0151l...",
    nameRequired: "A n\xE9v megad\xE1sa k\xF6telez\u0151!",
    categoryRequired: "Legal\xE1bb egy kateg\xF3ri\xE1t v\xE1lasszon ki!",
    partnerCreated: "Partner l\xE9trehozva!",
    partnerNotFound: "Partner nem tal\xE1lhat\xF3",
    backToList: "Vissza a list\xE1hoz",
    companyLabel: "C\xE9g",
    individualLabel: "Mag\xE1nszem\xE9ly",
    tabOverview: "\xC1ttekint\xE9s",
    tabAddresses: "C\xEDmek",
    tabContacts: "Kapcsolattart\xF3k",
    tabRepresentatives: "Meghatalmazottak",
    tabFinancial: "P\xE9nz\xFCgyek",
    tabHistory: "El\u0151zm\xE9nyek",
    statistics: "Statisztik\xE1k",
    totalRevenue: "\xD6sszes forgalom:",
    ordersCount: "Rendel\xE9sek:",
    rentalsCount: "B\xE9rl\xE9sek:",
    serviceOrdersCount: "Szerviz megrendel\xE9sek:",
    lastOrder: "Utols\xF3 rendel\xE9s:",
    lastRental: "Utols\xF3 b\xE9rl\xE9s:",
    debt: "Tartoz\xE1s:",
    rentalSettings: "B\xE9rl\xE9si be\xE1ll\xEDt\xE1sok",
    depositPercent: "Kauci\xF3 %:",
    rentalStatus: "B\xE9rl\xE9s st\xE1tusz:",
    blocked: "Tiltva",
    allowed: "Enged\xE9lyezve",
    newAddress: "\xDAj c\xEDm",
    noAddresses: "Nincs r\xF6gz\xEDtett c\xEDm.",
    newContact: "\xDAj kapcsolattart\xF3",
    noContacts: "Nincs r\xF6gz\xEDtett kapcsolattart\xF3.",
    primary: "Els\u0151dleges",
    defaultAddress: "Alap\xE9rtelmezett",
    addressBilling: "Sz\xE1ml\xE1z\xE1si",
    addressShipping: "Sz\xE1ll\xEDt\xE1si",
    addressOther: "Egy\xE9b",
    suspend: "Felf\xFCggeszt\xE9s",
    unsuspend: "Felf\xFCggeszt\xE9s felold\xE1sa",
    suspended: "Partner felf\xFCggesztve",
    unsuspended: "Felf\xFCggeszt\xE9s feloldva",
    suspendConfirm: "Biztosan felf\xFCggeszti a partnert: {name}?",
    unsuspendConfirm: "Biztosan feloldja a partner felf\xFCggeszt\xE9s\xE9t?",
    suspendError: "Hiba a felf\xFCggeszt\xE9s sor\xE1n",
    unsuspendError: "Hiba a felf\xFCggeszt\xE9s felold\xE1sa sor\xE1n",
    suspendedBanner: "Partner felf\xFCggesztve",
    suspendedBannerDesc: "Ez a partner felf\xFCggeszt\xE9sre ker\xFClt fizet\xE9si probl\xE9m\xE1k miatt. B\xE9rl\xE9s ind\xEDt\xE1sa \xE9s \xFAj megrendel\xE9s felv\xE9tele nem lehets\xE9ges.",
    rentalBlockedNote: "B\xE9rl\xE9s tiltva \u2014 a felf\xFCggeszt\xE9s felold\xE1sa sz\xFCks\xE9ges.",
    blockedRentalTooltip: "Partner felf\xFCggesztve \u2014 b\xE9rl\xE9s nem ind\xEDthat\xF3",
    newRental: "\xDAj b\xE9rl\xE9s",
    newSale: "\xDAj \xE9rt\xE9kes\xEDt\xE9s",
    newWorksheet: "\xDAj munkalap",
    publicNote: "Publikus megjegyz\xE9s",
    internalNote: "Bels\u0151 megjegyz\xE9s",
    outstandingDebt: "Nyitott tartoz\xE1s: {amount}",
    contactSupport: "K\xE9rj\xFCk, egyeztessen az \xFCgyf\xE9lszolg\xE1lattal.",
    noOutstandingDebt: "Nincs nyitott tartoz\xE1s.",
    paymentTerm: "Fizet\xE9si hat\xE1rid\u0151",
    creditLimit: "Hitelkeret",
    baseDiscount: "Alapkedvezm\xE9ny",
    priceList: "\xC1rlista",
    debtsTitle: "Tartoz\xE1sok",
    partnerUpdated: "Partner adatok friss\xEDtve",
    partnerCreatedBy: "Partner l\xE9trehozva ({user})",
    nDays: "{count} nap",
    defaultPriceList: "Alap",
    noneValue: "Nincs",
    categoryLabels: {
      retail: "Kisker. vev\u0151",
      wholesale: "Nagyker. vev\u0151",
      renter: "B\xE9rl\u0151",
      service: "Szerviz",
      supplier: "Besz\xE1ll\xEDt\xF3",
      subcontractor: "Alv\xE1llalkoz\xF3"
    },
    typeLabels: {
      individual: "Mag\xE1nszem\xE9ly",
      company: "C\xE9g"
    },
    idCard: "Szem\xE9lyi igazolv\xE1ny",
    drivingLicense: "Jogos\xEDtv\xE1ny",
    passport: "\xDAtlev\xE9l",
    duplicateSuspects: "Duplik\xE1ci\xF3 gyan\xFAk",
    abandonedEquipment: "60 napos elhagyott g\xE9pek",
    editTitle: "Partner szerkeszt\xE9se",
    saveChanges: "V\xE1ltoztat\xE1sok ment\xE9se",
    errorPrefix: "Hiba: {error}",
    saveFailed: "Hiba t\xF6rt\xE9nt a ment\xE9s sor\xE1n",
    confidence: "bizonyoss\xE1g",
    detected: "\xC9szlelve",
    mergeButton: "\xD6sszevon\xE1s",
    dismissButton: "Elvetni",
    noDuplicates: "Nincs feloldatlan duplik\xE1ci\xF3.",
    worksheetLabel: "Munkalap",
    noAbandonedEquipment: "Nincs d\xF6nt\xE9sre v\xE1r\xF3 elhagyott g\xE9p.",
    scrapButton: "Selejt",
    sellButton: "\xC9rt\xE9kes\xEDt",
    keepButton: "Meg\u0151rz\xE9s",
    namePlaceholderCompany: "P\xE9lda Kft.",
    namePlaceholderIndividual: "Kov\xE1cs J\xE1nos",
    shortNamePlaceholder: "P\xE9lda",
    streetPlaceholder: "V\xE1ci \xFAt 35.",
    category: {
      retail: "Kisker. vev\u0151",
      wholesale: "Nagyker. vev\u0151",
      rental: "B\xE9rl\u0151",
      service: "Szerviz",
      supplier: "Besz\xE1ll\xEDt\xF3",
      contractor: "Alv\xE1llalkoz\xF3"
    },
    status: {
      active: "Akt\xEDv",
      inactive: "Inakt\xEDv",
      blocked: "Tiltott",
      trusted: "T\xF6rzsvev\u0151",
      warning: "Figyelmeztetve"
    },
    type: {
      individual: "Mag\xE1nszem\xE9ly",
      company: "C\xE9g"
    },
    createSuccess: "Partner sikeresen l\xE9trehozva!\nK\xF3d: {code}\nN\xE9v: {name}",
    placeholder: {
      address: "V\xE1ci \xFAt 35.",
      city: "Budapest",
      companyName: "P\xE9lda Kft.",
      email: "info@example.hu",
      lastName: "P\xE9lda",
      personName: "Kov\xE1cs J\xE1nos",
      website: "https://example.hu",
      birthPlace: "pl. Budapest",
      mothersName: "pl. Kiss M\xE1ria",
      temporaryAddress: "pl. 1052 Budapest, Pet\u0151fi t\xE9r 3.",
      idCardNumber: "pl. 123456AB"
    },
    contractPrices: {
      title: "Szerz\u0151d\xE9ses \xE1rak"
    },
    discount: {
      categorized: "Kategoriz\xE1lt kedvezm\xE9ny",
      max: "Maximum kedvezm\xE9ny",
      noStacking: "Kedvezm\xE9nyek nem halmozhat\xF3k",
      rental: "B\xE9rl\xE9s kedvezm\xE9ny",
      sales: "\xC9rt\xE9kes\xEDt\xE9s kedvezm\xE9ny",
      service: "Szerviz kedvezm\xE9ny"
    },
    displayedCount: "Megjelen\xEDtett: {count}",
    quickCreate: {
      title: "\xDAj partner gyors l\xE9trehoz\xE1s",
      typeLabel: "T\xEDpus",
      individual: "Mag\xE1nszem\xE9ly",
      company: "C\xE9g",
      nameLabel: "N\xE9v *",
      namePlaceholder: "Partner neve",
      taxNumberLabel: "Ad\xF3sz\xE1m",
      taxNumberPlaceholder: "12345678-1-42",
      emailLabel: "Email",
      emailPlaceholder: "email@pelda.hu",
      phoneLabel: "Telefon",
      phonePlaceholder: "+36 30 123 4567",
      cityLabel: "V\xE1ros",
      cityPlaceholder: "Budapest",
      submit: "L\xE9trehoz\xE1s",
      cancel: "M\xE9gse",
      success: "Partner sikeresen l\xE9trehozva: {name}",
      error: "Hiba a partner l\xE9trehoz\xE1sakor: {message}",
      taxNumberHint: "Ad\xF3sz\xE1m n\xE9lk\xFCl a sz\xE1ml\xE1z\xE1s korl\xE1tozott lehet",
      duplicateWarning: "Hasonl\xF3 partner m\xE1r l\xE9tezik:",
      notFound: "Nem tal\xE1lod? \xDAj partner l\xE9trehoz\xE1sa",
      searchPlaceholder: "Keres\xE9s n\xE9v, email, telefon, ad\xF3sz\xE1m, v\xE1ros..."
    },
    sanctions: {
      title: "Szankci\xF3k",
      transferBan: "Utal\xE1s tiltva",
      transferBanThreeMonth: "3 h\xF3napos eltilt\xE1s",
      transferBanSixMonth: "6 h\xF3napos eltilt\xE1s",
      transferBanPermanent: "V\xE9gleges eltilt\xE1s",
      transferBanNone: "Nincs eltilt\xE1s",
      banUntil: "Eltilt\xE1s v\xE9ge: {date}",
      strikeCount: "K\xE9sedelmi esetek: {count}",
      walkInOnly: "Csak Walk-in",
      walkInOnlyUntil: "Walk-in korl\xE1toz\xE1s v\xE9ge: {date}",
      bookingWarning: "Foglal\xE1si figyelmeztet\xE9s",
      cancelledCount: "T\xF6r\xF6lt foglal\xE1sok: {count}",
      noShowCount: "Meg nem jelent: {count}",
      override: "Fel\xFClb\xEDr\xE1l\xE1s",
      overrideTitle: "Szankci\xF3 fel\xFClb\xEDr\xE1l\xE1sa",
      overrideReason: "Indokl\xE1s *",
      overrideReasonPlaceholder: "Mi\xE9rt b\xEDr\xE1lja fel\xFCl a szankci\xF3t?",
      overrideConfirm: "Fel\xFClb\xEDr\xE1l\xE1s v\xE9grehajt\xE1sa",
      overrideSuccess: "Szankci\xF3 sikeresen fel\xFClb\xEDr\xE1lva",
      overrideBy: "Fel\xFClb\xEDr\xE1lta: {user}",
      overrideAt: "Fel\xFClb\xEDr\xE1l\xE1s d\xE1tuma: {date}",
      discountsRevoked: "Kedvezm\xE9nyek megvonva",
      amnestyExpires: "Amnesztia lej\xE1rat: {date}"
    },
    segment: {
      title: "\xDCgyf\xE9l szegmens",
      vip: "VIP",
      active: "Akt\xEDv",
      atRisk: "Vesz\xE9lyeztetett",
      inactive: "Inakt\xEDv",
      calculatedAt: "Utols\xF3 sz\xE1m\xEDt\xE1s: {date}",
      changedAt: "Szegmens v\xE1ltoz\xE1s: {date}",
      distribution: "Szegmens eloszl\xE1s",
      partnerCount: "{count} partner"
    },
    suggestions: {
      title: "Javaslatok",
      crossSell: "{category} \u2014 {count} db k\xE9szleten",
      noSuggestions: "Nincs javaslat",
      calculating: "Szegment\xE1l\xE1s folyamatban..."
    },
    kpi: {
      lifetimeValue: "\xD6ssz. forgalom",
      outstandingBalance: "Nyitott tartoz\xE1s",
      totalRentals: "\xD6sszes b\xE9rl\xE9s"
    },
    timeline: {
      title: "\xDCgyf\xE9l id\u0151szalag",
      quickAddNote: "Jegyzet",
      loadMore: "T\xF6bb bet\xF6lt\xE9se",
      loadError: "Hiba a bet\xF6lt\xE9skor",
      empty: "M\xE9g nincs esem\xE9ny \u2014 hozd l\xE9tre az els\u0151 jegyzetet a \u201EJegyzet\u201D gombbal.",
      expand: "R\xE9szletek",
      collapse: "Bez\xE1r\xE1s",
      filterLabel: "T\xEDpus sz\u0171r\u0151",
      types: {
        TASK: "Feladat",
        INVOICE: "Sz\xE1mla",
        QUOTE: "\xC1raj\xE1nlat",
        DELIVERY_NOTE: "Sz\xE1ll\xEDt\xF3lev\xE9l",
        RENTAL: "B\xE9rl\xE9s",
        WORKSHEET: "Munkalap",
        LOYALTY: "T\xF6rzsvend\xE9g",
        TASK_NOTE: "Jegyzet",
        TASK_CALL: "H\xEDv\xE1s"
      },
      quickAddDialog: {
        title: "Gyors jegyzet",
        description: "Jegyzet vagy h\xEDv\xE1s r\xF6gz\xEDt\xE9se az \xFCgyf\xE9l id\u0151szalagj\xE1ra.",
        typeLabel: "T\xEDpus",
        titleLabel: "C\xEDm",
        titlePlaceholder: "R\xF6vid \xF6sszefoglal\xF3",
        descriptionLabel: "R\xE9szletek",
        descriptionPlaceholder: "Opcion\xE1lis r\xE9szletes le\xEDr\xE1s",
        submit: "Ment\xE9s"
      },
      metaLabels: {
        dueDate: "Hat\xE1rid\u0151",
        completedAt: "Elv\xE9gezve",
        priority: "Priorit\xE1s",
        issueDate: "Ki\xE1ll\xEDtva",
        paidAmount: "Befizetve",
        balanceDue: "H\xE1tral\xE9k",
        currency: "P\xE9nznem",
        paymentMethod: "Fizet\xE9si m\xF3d",
        paidAt: "Kiegyenl\xEDtve",
        navStatus: "NAV st\xE1tusz",
        validUntil: "\xC9rv\xE9nyes",
        sentAt: "Kik\xFCldve",
        acceptedAt: "Elfogadva",
        rejectedAt: "Elutas\xEDtva",
        invoiceId: "Sz\xE1mla ID",
        settledManually: "Manu\xE1lisan rendezve",
        startDate: "B\xE9rl\xE9s kezdete",
        expectedEnd: "Visszav\xE1r\xE1s",
        actualEnd: "T\xE9nyleges v\xE9g",
        returnedAt: "Visszahozva",
        depositRequired: "Kauci\xF3 (k\xE9rt)",
        depositPaid: "Kauci\xF3 (fizetett)",
        depositReturned: "Kauci\xF3 (visszaadott)",
        itemCount: "T\xE9telek sz\xE1ma",
        equipment: "G\xE9p",
        serialNumber: "Gy\xE1ri sz\xE1m",
        receivedAt: "Bev\xE9telezve",
        deliveredAt: "\xC1tadva",
        isWarranty: "Garanci\xE1lis",
        transactionCount: "Tranzakci\xF3k",
        totalSpend: "\xD6ssz. forgalom"
      }
    },
    tabAuthorizationGrants: "Meghatalmaz\xE1s",
    roleToggle: {
      customerLabel: "VEV\u0150",
      supplierLabel: "BESZ\xC1LL\xCDT\xD3",
      addCustomer: "+ VEV\u0150 szerepet hozz\xE1ad",
      addSupplier: "+ BESZ\xC1LL\xCDT\xD3 szerepet hozz\xE1ad",
      removeAria: "Szerep elt\xE1vol\xEDt\xE1sa",
      confirmAddTitle: "Szerep hozz\xE1ad\xE1sa",
      confirmRemoveTitle: "Szerep elt\xE1vol\xEDt\xE1sa",
      confirmAddText: "Hozz\xE1adod a {role} szerepet ehhez a partnerhez?",
      confirmRemoveText: "Elt\xE1vol\xEDtod a {role} szerepet err\u0151l a partnerr\u0151l?",
      notYetWired: "Szerep-v\xE1lt\xE1s m\xE9g nincs bek\xF6tve \u2014 hamarosan (STORY-1212 folytat\xE1s)."
    },
    receiverData: "\xC1tvev\u0151 adatai (mag\xE1nszem\xE9ly)",
    intent: {
      title: "Mit int\xE9z az \xFCgyf\xE9l?",
      hint: "A v\xE1laszt\xE1s alapj\xE1n jel\xF6lj\xFCk, mely adatok kellenek. Elhagyhat\xF3, \xE9s a ment\xE9st nem blokkolja.",
      purchase: "V\xE1s\xE1rol",
      rental: "B\xE9rel",
      service: "Szervizeltet"
    },
    requiredMissing: {
      title: "Ehhez az \xFCgyt\xEDpushoz hi\xE1nyz\xF3 adatok",
      hint: "A ment\xE9st nem blokkolja \u2014 k\xE9s\u0151bb p\xF3tolhat\xF3."
    },
    field: {
      name: "N\xE9v",
      phone: "Telefonsz\xE1m",
      email: "E-mail c\xEDm",
      address: "Lakc\xEDm / sz\xE9khely",
      idCard: "Szem\xE9lyi igazolv\xE1ny",
      addressCard: "Lakc\xEDmk\xE1rtya",
      birthData: "Sz\xFClet\xE9si adatok",
      mothersName: "Anyja neve",
      taxNumber: "Ad\xF3sz\xE1m",
      representative: "K\xE9pvisel\u0151 / \xE1tvev\u0151"
    },
    receiverHint: "A g\xE9p-kiad\xE1shoz az \xE1tvev\u0151 mag\xE1nszem\xE9ly adatai k\xF6telez\u0151k \u2014 ne ugord \xE1t.",
    companyDataSecondary: "C\xE9ges adatok (k\xF6lts\xE9gvisel\u0151)",
    mothersNameRequired: "Az anyja neve megad\xE1sa k\xF6telez\u0151 (\xE1tvev\u0151)!",
    idCardRequired: "A szem\xE9lyi igazolv\xE1ny sz\xE1m megad\xE1sa k\xF6telez\u0151 (\xE1tvev\u0151)!",
    idCardExpiry: "Okm\xE1ny lej\xE1rata",
    idCardCurrentMasked: "Jelenlegi (mentett): {masked} \u2014 hagyd \xFCresen ha nem v\xE1ltozik",
    duplicate: {
      warning: "Hasonl\xF3 \xFCgyf\xE9l m\xE1r l\xE9tezhet \u2014 ellen\u0151rizd a list\xE1t."
    },
    saveAndNew: "Ment\xE9s \xE9s \xFAj",
    saveAndNewSuccess: "Partner mentve \u2014 az \u0171rlap \xFCres az \xFAj r\xF6gz\xEDt\xE9shez.",
    saveHint: "Tipp: Ctrl+Enter a gyors ment\xE9shez",
    searchFilter: {
      typeAll: "Mind",
      typeIndividual: "Mag\xE1nszem\xE9ly",
      typeCompany: "C\xE9g",
      availableOnly: "Csak el\xE9rhet\u0151",
      ariaLabel: "Partner sz\u0171r\u0151k",
      recentTitle: "Legut\xF3bbi partnerek"
    },
    representative: {
      title: "Meghatalmazottak",
      add: "Hozz\xE1ad\xE1s",
      name: "N\xE9v",
      phone: "Telefon",
      email: "E-mail",
      idNumber: "Igazolv\xE1nysz\xE1m",
      validFrom: "\xC9rv\xE9nyes ett\u0151l",
      validUntil: "\xC9rv\xE9nyes eddig",
      unlimited: "korl\xE1tlan",
      permissions: "Jogosults\xE1gok",
      canRent: "B\xE9relhet",
      canReturn: "Visszavihet",
      canSign: "Al\xE1\xEDrhat",
      canPayCash: "K\xE9szp\xE9nzzel fizethet",
      active: "Akt\xEDv",
      inactive: "Inakt\xEDv",
      expired: "Lej\xE1rt",
      expiringSoon: "Hamarosan lej\xE1r",
      activate: "Aktiv\xE1l\xE1s",
      deactivate: "Deaktiv\xE1l\xE1s",
      confirmDelete: "Biztosan t\xF6rli ezt a meghatalmazottat?",
      noRepresentatives: "Nincs meghatalmazott",
      notes: "Megjegyz\xE9s"
    },
    selectSettlement: "T\xF6bb telep\xFCl\xE9s tartozik ehhez az ir\xE1ny\xEDt\xF3sz\xE1mhoz \u2014 v\xE1lasszon:"
  },
  pos: {
    customerPanel: {
      title: "\xDCgyf\xE9l inf\xF3",
      noCustomer: "V\xE1lasszon partnert a kedvezm\xE9nyek megjelen\xEDt\xE9s\xE9hez",
      discounts: "Kedvezm\xE9nyek",
      discountRental: "B\xE9rl\xE9s: {percent}%",
      discountSales: "V\xE1s\xE1rl\xE1s: {percent}%",
      discountService: "Szerviz: {percent}%",
      balance: "Tartoz\xE1s",
      balanceAmount: "{amount} Ft",
      creditLimit: "Hitelkeret: {amount} Ft",
      depositExempt: "Kauci\xF3mentess\xE9g",
      recentTransactions: "Utols\xF3 tranzakci\xF3k",
      noTransactions: "Nincs el\u0151zm\xE9ny",
      viewDetails: "Partner r\xE9szletek"
    },
    suggestions: {
      winBack: "{days} napja nem b\xE9rel \u2014 10% kedvezm\xE9ny aj\xE1nlat",
      winBackApply: "Alkalmaz",
      inactiveNote: "R\xE9gi \xFCgyf\xE9l \u2014 6+ h\xF3napja inakt\xEDv",
      crossSellTitle: "Aj\xE1nlott term\xE9kek",
      crossSellItem: "{name} \u2014 {count} db k\xE9szleten",
      addToCart: "Kos\xE1rba"
    }
  },
  service: {
    warrantyClaim: "Garanci\xE1lis ig\xE9ny",
    warrantyClaimNumber: "Ig\xE9ny sz\xE1ma",
    warrantyManufacturer: "Gy\xE1rt\xF3",
    warrantyManufacturerPlaceholder: "Gy\xE1rt\xF3 neve",
    warrantyClaimValue: "Ig\xE9ny \xE9rt\xE9ke",
    warrantySettledAmount: "Elsz\xE1molt \xF6sszeg",
    warrantySubmittedAt: "Bek\xFCldve",
    warrantyNoClaimYet: "M\xE9g nincs garanci\xE1lis ig\xE9ny",
    warrantyNotes: "Megjegyz\xE9sek",
    warrantyNotesPlaceholder: "Megjegyz\xE9s az ig\xE9nyhez",
    warrantySubmitClaim: "Ig\xE9ny bek\xFCld\xE9se",
    warrantyCreateClaim: "Garanci\xE1lis ig\xE9ny l\xE9trehoz\xE1sa",
    photos: "F\xE9nyk\xE9pek",
    uploadPhoto: "F\xE9nyk\xE9p felt\xF6lt\xE9se",
    photoFile: "F\xE1jl",
    photoFileRequired: "A f\xE1jl megad\xE1sa k\xF6telez\u0151",
    photoCaption: "Felirat",
    photoCaptionPlaceholder: "F\xE9nyk\xE9p felirata",
    photoTypeLabel: "T\xEDpus",
    photoTypeGeneral: "\xC1ltal\xE1nos",
    photoTypeBefore: "Jav\xEDt\xE1s el\u0151tt",
    photoTypeAfter: "Jav\xEDt\xE1s ut\xE1n",
    photoTypeDamage: "S\xE9r\xFCl\xE9s",
    noPhotos: "Nincs felt\xF6lt\xF6tt f\xE9nyk\xE9p",
    itemTypeOther: "Egy\xE9b",
    title: "Szerviz",
    subtitle: "Szerviz munkalap kezel\xE9s",
    worksheet: "Munkalap",
    worksheetLoading: "Munkalap bet\xF6lt\xE9se...",
    worksheetNotFound: "Munkalap nem tal\xE1lhat\xF3",
    technician: "Szerel\u0151",
    parts: "Alkatr\xE9szek",
    laborCost: "Munkad\xEDj",
    diagnosis: "Diagn\xF3zis",
    warranty: "Garancia",
    startWork: "Munka ind\xEDt\xE1sa",
    billing: "Sz\xE1ml\xE1z\xE1s",
    quote: "\xC1raj\xE1nlat",
    close: "Lez\xE1r\xE1s",
    reception: "Felv\xE9tel",
    worksheetIntake: "Munkalap felv\xE9tel",
    newServiceWorksheet: "\xDAj szerviz munkalap",
    worksheetIntakeAndPrint: "Munkalap felv\xE9tel \xE9s nyomtat\xE1s",
    creating: "L\xE9trehoz\xE1s...",
    cancelIntakeConfirm: "Biztosan megszak\xEDtja a munkalap felv\xE9tel\xE9t?",
    selectPartner: "\xDCgyf\xE9l kiv\xE1laszt\xE1sa",
    identifyDevice: "G\xE9p azonos\xEDt\xE1sa",
    identifyDeviceDesc: "V\xE1lassza ki a szervizelend\u0151 g\xE9pet a rendszerb\u0151l, vagy adja meg k\xE9zzel.",
    reportFault: "Hibabejelent\xE9s",
    device: "G\xE9p",
    fault: "Hiba",
    diagnosticsNeeded: "Diagnosztika sz\xFCks\xE9ges",
    diagnosticsNeededDesc: "A munkalap felv\xE9ve, az \xFCgyf\xE9l k\xE9zhez kapta a bizonylatot. A diagnosztika k\xFCl\xF6n l\xE9p\xE9sben t\xF6rt\xE9nik.",
    startDiagnostics: "Diagnosztika ind\xEDt\xE1sa",
    diagnosticsAndItems: "Diagnosztika \xE9s t\xE9telek",
    queuePositionLabel: "{position}. helyen",
    itemNotFound: "T\xE9tel nem tal\xE1lhat\xF3",
    inspection: "\xC1tvizsg\xE1l\xE1s",
    inspectionDesc: "Jelezze a g\xE9p \xE1tvett \xE1llapot\xE1t \xE9s r\xF6gz\xEDtse a digit\xE1lis al\xE1\xEDr\xE1s hely\xE9t.",
    deviceReceivedState: "G\xE9p \xE1tvett \xE1llapota *",
    assembledState: "\xD6sszeszerelt \xE1llapotban",
    disassembledState: "Sz\xE9tszerelt \xE1llapotban",
    assembledDesc: "A g\xE9p eredeti, \xF6sszeszerelt \xE1llapotban \xE9rkezik. Nincs fel\xE1r.",
    disassembledDesc: "A g\xE9p sz\xE9tszerelt \xE1llapotban \xE9rkezik. \xD6sszeszerel\xE9si fel\xE1r ker\xFCl felsz\xE1m\xEDt\xE1sra.",
    disassembledSurcharge: "Sz\xE9tszerelt \xE1llapot miatti fel\xE1r",
    noSurcharge: "Nincs fel\xE1r \xF6sszeszerelt \xE1llapotra",
    free: "Ingyenes",
    deadline: "Hat\xE1rid\u0151",
    limit: "Limit",
    searchPlaceholder: "Keres\xE9s munkalapsz\xE1m, partner, g\xE9p vagy hiba alapj\xE1n...",
    equipmentProduct: "G\xE9p / Term\xE9k",
    designation: "Megnevez\xE9s",
    serialNumber: "Gy\xE1ri sz\xE1m",
    faultDescription: "Hiba le\xEDr\xE1s",
    diagnosisAndWork: "Diagn\xF3zis \xE9s elv\xE9gzett munka",
    completedWork: "Elv\xE9gzett munka",
    internalNote: "Bels\u0151 megjegyz\xE9s",
    internalOnly: "Csak bels\u0151 haszn\xE1latra",
    internalNoteHelper: "Ez a megjegyz\xE9s nem jelenik meg az \xFCgyf\xE9lnek.",
    worksheetData: "Munkalap adatok",
    costLimit: "K\xF6lts\xE9ghat\xE1r",
    responsibleId: "Felel\u0151s ID",
    expectedCompletion: "V\xE1rhat\xF3 elk\xE9sz\xFCl\xE9s",
    queuePosition: "Sorban",
    storageFee: "T\xE1rol\xE1si d\xEDj",
    storageStart: "T\xE1rol\xE1s kezdete",
    storageDailyFee: "Napi d\xEDj",
    storageTotalFee: "\xD6sszes d\xEDj",
    timestamps: "Id\u0151pontok",
    received: "Felv\xE9ve",
    created: "L\xE9trehozva",
    modified: "M\xF3dos\xEDtva",
    completed: "Befejezve",
    creatorId: "L\xE9trehoz\xF3 ID",
    relatedRental: "Kapcsol\xF3d\xF3 b\xE9rl\xE9s",
    viewRental: "B\xE9rl\xE9s megtekint\xE9se",
    statusLabels: {
      received: "Felv\xE9ve",
      inProgress: "Folyamatban",
      waiting: "V\xE1rakoz\xF3",
      completed: "K\xE9sz",
      billable: "Sz\xE1ml\xE1zand\xF3",
      closed: "Lez\xE1rt",
      cancelled: "T\xF6r\xF6lve"
    },
    typeLabels: {
      paid: "Fizet\u0151s jav\xEDt\xE1s",
      warranty: "Garanci\xE1lis",
      rentalService: "B\xE9rl\xE9si szerviz",
      maintenance: "Karbantart\xE1s"
    },
    priorityLabels: {
      urgent: "S\xFCrg\u0151s (+20%)",
      normal: "Norm\xE1l",
      warranty: "Garanci\xE1lis"
    },
    categoryLabels: {
      powerTool: "Elektromos szersz\xE1m",
      gardenEquipment: "Kerti g\xE9p",
      construction: "\xC9p\xEDt\u0151ipari",
      cleaningMachine: "Takar\xEDt\xF3g\xE9p",
      other: "Egy\xE9b"
    },
    searchInSystem: "Keres\xE9s a rendszerben",
    manualEntry: "K\xE9zi bevitel",
    searchProductPlaceholder: "Keres\xE9s n\xE9v, gy\xE1rt\xF3, modell vagy gy\xE1ri sz\xE1m alapj\xE1n...",
    productsLoading: "Term\xE9kek bet\xF6lt\xE9se...",
    productsLoadError: "Hiba a term\xE9kek bet\xF6lt\xE9sekor: {message}",
    serialNumberShort: "Gy.sz.: {serial}",
    manualDeviceEntry: "G\xE9p k\xE9zi bevitele",
    manualDeviceDataEntry: "G\xE9p adatok k\xE9zi bevitele",
    deviceNameRequired: "G\xE9p megnevez\xE9se *",
    deviceNamePlaceholder: "pl. Makita HR2470 F\xFAr\xF3kalap\xE1cs",
    serialNumberPlaceholder: "pl. MK-2024-001234",
    selectedDevice: "Kiv\xE1lasztott g\xE9p: {name}",
    selectPartnerHeading: "Partner kiv\xE1laszt\xE1sa",
    selectPartnerDesc: "V\xE1lassza ki az \xFCgyfelet, akinek a g\xE9p\xE9t szervizelni szeretn\xE9.",
    searchPartnerPlaceholder: "Keres\xE9s n\xE9v, email, telefon, ad\xF3sz\xE1m, v\xE1ros vagy igazolv\xE1ny alapj\xE1n...",
    partnersLoading: "Partnerek bet\xF6lt\xE9se...",
    partnersLoadError: "Hiba a partnerek bet\xF6lt\xE9sekor: {message}",
    trustedPartner: "T\xF6rzsvev\u0151",
    warningStatus: "Figyelmeztet\u0151",
    blockedStatus: "Tiltott",
    taxNumberLabel: "Ad\xF3sz\xE1m: {taxNumber}",
    costBearer: "K\xF6lts\xE9gvisel\u0151: {name}",
    selectedPartner: "Kiv\xE1lasztott partner: {name}",
    reportFaultDesc: "Adja meg a hiba le\xEDr\xE1s\xE1t \xE9s v\xE1lassza ki a munkalap t\xEDpus\xE1t.",
    deviceUnderWarranty: "A g\xE9p garanci\xE1lis id\u0151szakban van!",
    warrantyExpiry: "Garancia lej\xE1rat: {date}",
    worksheetType: "Munkalap t\xEDpusa",
    recommended: "(Aj\xE1nlott)",
    faultDescriptionRequired: "Hiba le\xEDr\xE1sa *",
    faultDescriptionPlaceholder: "\xCDrja le r\xE9szletesen a hib\xE1t, t\xFCneteket, mikor jelentkezett...",
    faultDescriptionHint: "Min\xE9l r\xE9szletesebb a le\xEDr\xE1s, ann\xE1l gyorsabb a diagnosztika.",
    costLimitOptional: "K\xF6lts\xE9ghat\xE1r (opcion\xE1lis)",
    costLimitHint: "Ha a jav\xEDt\xE1s k\xF6lts\xE9ge meghaladja ezt az \xF6sszeget, el\u0151zetes egyeztet\xE9s sz\xFCks\xE9ges.",
    summaryType: "T\xEDpus: {type}",
    summaryPriority: "Priorit\xE1s: {priority}",
    summaryCostLimit: "K\xF6lts\xE9ghat\xE1r: {limit} Ft",
    inspectionFeeLabel: "\xC1tvizsg\xE1l\xE1si / \xF6sszeszerel\xE9si d\xEDj",
    attentionWarning: "Figyelem!",
    disassembledWarning: "Sz\xE9tszerelt \xE1llapotban \xE1tvett g\xE9p eset\xE9n az \xF6sszeszerel\xE9si d\xEDj felsz\xE1m\xEDt\xE1sra ker\xFCl, f\xFCggetlen\xFCl att\xF3l, hogy a jav\xEDt\xE1s megt\xF6rt\xE9nik-e vagy sem.",
    digitalSignature: "Digit\xE1lis al\xE1\xEDr\xE1s",
    digitalSignatureArea: "Digit\xE1lis al\xE1\xEDr\xE1s helye",
    signatureTouchHint: "\xC9rintse meg a k\xE9perny\u0151t az al\xE1\xEDr\xE1s r\xF6gz\xEDt\xE9s\xE9hez",
    signatureConfirmation: "Az \xFCgyf\xE9l al\xE1\xEDr\xE1s\xE1val igazolja a g\xE9p \xE1tad\xE1s\xE1t \xE9s az \xE1llapot felv\xE9tel\xE9t.",
    summaryTitle: "\xD6sszefoglal\xE1s",
    summaryState: "\xC1llapot: {state}",
    summaryFee: "D\xEDj: {fee}",
    summarySignature: "Al\xE1\xEDr\xE1s: {status}",
    signatureRecorded: "R\xF6gz\xEDtve",
    signatureNotRecorded: "M\xE9g nem r\xF6gz\xEDtett",
    historyLabels: {
      created: "L\xE9trehozva",
      statusChange: "St\xE1tusz v\xE1ltoz\xE1s",
      itemAdded: "T\xE9tel hozz\xE1adva",
      itemRemoved: "T\xE9tel t\xF6r\xF6lve",
      assigned: "Hozz\xE1rendelve",
      comment: "Megjegyz\xE9s",
      invoiced: "Sz\xE1ml\xE1zva",
      completed: "Befejezve"
    },
    editWorksheet: "Munkalap szerkeszt\xE9se",
    saveError: "Hiba t\xF6rt\xE9nt a ment\xE9s sor\xE1n",
    errorPrefix: "Hiba: {message}",
    worksheetNotEditable: "Ez a munkalap {status} st\xE1tuszban van, ez\xE9rt nem szerkeszthet\u0151.",
    deviceData: "G\xE9p adatai",
    deviceNamePlaceholderShort: "pl. Makita DLX2220",
    serialNumberPlaceholderShort: "pl. SN123456789",
    worksheetSettings: "Munkalap be\xE1ll\xEDt\xE1sok",
    priorityField: "Priorit\xE1s",
    costLimitFt: "K\xF6lts\xE9ghat\xE1r (Ft)",
    costLimitPlaceholder: "pl. 50000",
    faultDescriptionCustomerPlaceholder: "Mit tapasztal az \xFCgyf\xE9l?",
    diagnosisCausePlaceholder: "Mi a hiba oka?",
    workPerformedPlaceholder: "Milyen munk\xE1kat v\xE9gezt\xFCnk el?",
    internalNotePlaceholder: "Bels\u0151 feljegyz\xE9sek (az \xFCgyf\xE9l nem l\xE1tja)...",
    statusChangeTitle: "St\xE1tusz v\xE1ltoztat\xE1s",
    continueWork: "Folytat\xE1s",
    toBilling: "Sz\xE1ml\xE1z\xE1sra",
    saveChanges: "V\xE1ltoztat\xE1sok ment\xE9se",
    diagnosticsStepDesc: "R\xF6gz\xEDtse a diagnosztik\xE1t, majd adja hozz\xE1 az alkatr\xE9szeket \xE9s munkad\xEDjakat.",
    diagnosisLabel: "Diagnosztika / Meg\xE1llap\xEDt\xE1s *",
    diagnosisPlaceholder: "A g\xE9p \xE1llapota, tal\xE1lt hib\xE1k, sz\xFCks\xE9ges jav\xEDt\xE1sok...",
    workPerformedDetailPlaceholder: "R\xE9szletes le\xEDr\xE1s az elv\xE9gzett munk\xE1r\xF3l...",
    laborNorms: "Munkad\xEDj norm\xE1k",
    customItem: "Egy\xE9b t\xE9tel",
    searchPartPlaceholder: "Keres\xE9s alkatr\xE9sz n\xE9v vagy cikksz\xE1m alapj\xE1n...",
    stockCount: "K\xE9szlet: {count} db",
    searchNormPlaceholder: "Keres\xE9s norma k\xF3d vagy le\xEDr\xE1s alapj\xE1n...",
    normsLoading: "Norm\xE1k bet\xF6lt\xE9se...",
    normsLoadError: "Hiba a norm\xE1k bet\xF6lt\xE9sekor: {message}",
    minuteUnit: "perc",
    addCustomItem: "Egy\xE9b t\xE9tel hozz\xE1ad\xE1sa",
    customItemPlaceholder: "pl. Kisz\xE1ll\xE1si d\xEDj",
    unitPriceFt: "Egys\xE9g\xE1r (Ft)",
    addedItems: "Hozz\xE1adott t\xE9telek ({count})",
    partLabel: "Alkatr\xE9sz",
    otherLabel: "Egy\xE9b",
    externalCostLabel: "Alv\xE1llalkoz\xF3i d\xEDj",
    addExternalCost: "Alv\xE1llalkoz\xF3i d\xEDj hozz\xE1ad\xE1sa",
    externalCostDescription: "Le\xEDr\xE1s",
    externalCostDescriptionPlaceholder: "pl. Motortekercsel\xE9s, Galvaniz\xE1l\xE1s...",
    externalCostAmount: "\xD6sszeg (nett\xF3 Ft)",
    externalCostAmountPlaceholder: "pl. 25000",
    externalCostBadge: "Alv\xE1llalkoz\xF3i",
    externalCostAdded: "Alv\xE1llalkoz\xF3i d\xEDj hozz\xE1adva",
    externalCostDescriptionRequired: "Alv\xE1llalkoz\xF3i d\xEDj le\xEDr\xE1sa k\xF6telez\u0151 (min. 2 karakter)",
    externalCostAmountPositive: "Alv\xE1llalkoz\xF3i d\xEDj \xF6sszege pozit\xEDv kell legyen",
    itemTypeExternalCost: "Alv\xE1llalkoz\xF3i d\xEDj",
    vatLabel: "\xC1FA (27%):",
    summaryHeading: "\xD6sszegz\xE9s",
    summaryStepDesc: "Ellen\u0151rizze az adatokat \xE9s v\xE9gleges\xEDtse a munkalapot.",
    nameLabel: "N\xE9v:",
    emailLabel: "Email:",
    phoneLabel: "Telefon:",
    designationSummaryLabel: "Megnevez\xE9s:",
    serialNumberSummaryLabel: "Gy\xE1ri sz\xE1m:",
    categoryLabel: "Kateg\xF3ria:",
    warrantyLabel: "Garancia:",
    warrantyExpiredNone: "Lej\xE1rt/Nincs",
    faultReport: "Hibabejelent\xE9s",
    typeLabel: "T\xEDpus:",
    priorityLabel: "Priorit\xE1s:",
    costLimitSummaryLabel: "K\xF6lts\xE9ghat\xE1r:",
    faultDescriptionSummaryLabel: "Hiba le\xEDr\xE1sa:",
    findingLabel: "Meg\xE1llap\xEDt\xE1s:",
    completedWorkSummaryLabel: "Elv\xE9gzett munka:",
    itemsWithCount: "T\xE9telek ({count} t\xE9tel)",
    netLabel: "Nett\xF3:",
    noItemsAdded: "Nincs hozz\xE1adott t\xE9tel.",
    completionSection: "Befejez\xE9s",
    internalOnlyPlaceholder: "Csak a szerviz munkat\xE1rsak sz\xE1m\xE1ra l\xE1that\xF3...",
    costLimitWarning: "A munkalap \xF6sszege ({total} Ft) meghaladja a megadott k\xF6lts\xE9ghat\xE1rt ({limit} Ft). Egyeztet\xE9s sz\xFCks\xE9ges az \xFCgyf\xE9llel!",
    worksheetReadyToCreate: "A munkalap k\xE9szen \xE1ll a l\xE9trehoz\xE1sra",
    accessories: "Tartoz\xE9kok",
    accessoriesDesc: "Jelezze, milyen tartoz\xE9kokkal egy\xFCtt vette \xE1t a g\xE9pet.",
    receivedAccessories: "\xC1tvett tartoz\xE9kok",
    addCustomAccessory: "Egy\xE9b tartoz\xE9k hozz\xE1ad\xE1sa",
    customAccessoryPlaceholder: "pl. Porelsz\xEDv\xF3 adapter, L\xE9zerszintez\u0151...",
    customLabel: "Egyedi",
    accessoryNote: "Megjegyz\xE9s a tartoz\xE9kokhoz",
    accessoryNotePlaceholder: "Egy\xE9b megjegyz\xE9s a tartoz\xE9kok \xE1llapot\xE1r\xF3l, hi\xE1nyoss\xE1gair\xF3l...",
    selectedAccessoriesCount: "Kiv\xE1lasztott tartoz\xE9kok ({count} db)",
    noAccessoriesSelected: "Nincs kiv\xE1lasztott tartoz\xE9k.",
    noAccessoriesHint: "Ha a g\xE9p tartoz\xE9kok n\xE9lk\xFCl \xE9rkezett, hagyja \xFCresen \xE9s l\xE9pjen tov\xE1bb.",
    fieldService: "Kisz\xE1ll\xE1si szerviz",
    fieldServiceDesc: "Jelezze, ha helysz\xEDni jav\xEDt\xE1sr\xF3l van sz\xF3.",
    fieldServiceAddress: "Helysz\xEDn c\xEDme *",
    fieldServiceAddressPlaceholder: "pl. 1052 Budapest, De\xE1k Ferenc utca 15.",
    fieldServiceAddressHint: "Adja meg a pontos c\xEDmet, ahol a jav\xEDt\xE1st v\xE9gezni kell.",
    deviceMobility: "G\xE9p mobiliz\xE1lhat\xF3s\xE1ga",
    mobilityLabels: {
      mobile: "Mobiliz\xE1lhat\xF3",
      immobile: "Nem mobiliz\xE1lhat\xF3",
      partiallyMobile: "R\xE9szben mobiliz\xE1lhat\xF3"
    },
    mobilityDescriptions: {
      mobile: "A g\xE9p szabadon mozgathat\xF3, nincs r\xF6gz\xEDtve.",
      immobile: "A g\xE9p r\xF6gz\xEDtve van, helysz\xEDnen kell jav\xEDtani.",
      partiallyMobile: "A g\xE9p korl\xE1tozottan mozgathat\xF3, seg\xEDts\xE9g sz\xFCks\xE9ges."
    },
    assistanceNeeded: "Seg\xEDts\xE9g sz\xFCks\xE9ges",
    assistanceNeededDesc: "A szerviz technikusnak seg\xEDts\xE9g kell a g\xE9p mozgat\xE1s\xE1hoz vagy megk\xF6zel\xEDt\xE9s\xE9hez.",
    assistanceNeededSuffix: " \u2014 Seg\xEDts\xE9g sz\xFCks\xE9ges",
    fieldObstacles: "Helysz\xEDni akad\xE1lyok, megjegyz\xE9sek",
    fieldObstaclesPlaceholder: "pl. Emeletsz\xE1m, bej\xE1rat oldala, parkol\xE1si lehet\u0151s\xE9g, speci\xE1lis k\xF6r\xFClm\xE9nyek...",
    fieldServiceDetails: "Kisz\xE1ll\xE1s r\xE9szletei",
    damageClaim: {
      title: "K\xE1rt\xE9r\xEDt\xE9si ig\xE9nyek",
      titleSingle: "K\xE1rt\xE9r\xEDt\xE9si ig\xE9ny",
      statusLabels: {
        pending: "F\xFCgg\u0151ben",
        approved: "J\xF3v\xE1hagyva",
        rejected: "Elutas\xEDtva",
        settled: "Rendezve"
      },
      typeLabels: {
        warranty: "Garanci\xE1lis (ML-GAR)",
        damage: "K\xE1rt\xE9r\xEDt\xE9s (ML-BH)"
      },
      noClaims: "Nincs k\xE1rt\xE9r\xEDt\xE9si ig\xE9ny.",
      repairCost: "Jav\xEDt\xE1s: {amount}",
      lostRevenue: "Kiesett bev\xE9tel: {amount}",
      totalClaim: "\xD6sszes: {amount}",
      rejectedPrefix: "Elutas\xEDtva: {note}",
      approve: "J\xF3v\xE1hagy\xE1s",
      reject: "Elutas\xEDt\xE1s",
      rejectionPrompt: "Elutas\xEDt\xE1si indokl\xE1s:",
      notFound: "K\xE1rt\xE9r\xEDt\xE9si ig\xE9ny nem tal\xE1lhat\xF3",
      basicData: "Alapadatok",
      statusLabel: "St\xE1tusz",
      typeLabel: "T\xEDpus",
      rentalId: "B\xE9rl\xE9s ID",
      createdAt: "L\xE9trehozva",
      financialData: "P\xE9nz\xFCgyi adatok",
      repairCostLabel: "Jav\xEDt\xE1si k\xF6lts\xE9g",
      lostRevenueLabel: "Kiesett bev\xE9tel",
      totalClaimLabel: "\xD6sszes ig\xE9ny",
      rejectionReason: "Elutas\xEDt\xE1si indokl\xE1s",
      approval: "J\xF3v\xE1hagy\xE1s",
      approvedBy: "J\xF3v\xE1hagyta: {name}",
      processing: "Feldolgoz\xE1s..."
    },
    noItems: "Nincs t\xE9tel",
    worksheetItems: "Munkalap t\xE9telek",
    disassembly: {
      title: "Sz\xE9tszerel\xE9s",
      button: "Sz\xE9tszerel\xE9s",
      modalTitle: "Sz\xE9tszerel\xE9si protokoll",
      modalDescription: "A g\xE9p sz\xE9tszerel\xE9se ut\xE1n az alkatr\xE9szek k\xE9szletbe ker\xFClnek.",
      addPart: "Alkatr\xE9sz hozz\xE1ad\xE1sa",
      productSearch: "Term\xE9k keres\xE9s...",
      quantity: "Mennyis\xE9g",
      condition: "\xC1llapot",
      conditionNew: "\xDAj",
      conditionUsed: "Haszn\xE1lt",
      conditionDamaged: "S\xE9r\xFClt",
      execute: "V\xE9grehajt\xE1s",
      executing: "V\xE9grehajt\xE1s...",
      success: "Sz\xE9tszerel\xE9s sikeresen v\xE9grehajtva",
      error: "Sz\xE9tszerel\xE9s sikertelen",
      protocols: "Sz\xE9tszerel\xE9si protokollok",
      noProtocols: "Nincs sz\xE9tszerel\xE9si protokoll",
      performedBy: "V\xE9grehajt\xF3",
      performedAt: "V\xE9grehajt\xE1s ideje",
      partsCount: "{count} alkatr\xE9sz"
    },
    express: {
      surcharge: "Express fel\xE1r",
      lineItem: "Express fel\xE1r (k\xFCl\xF6n sz\xE1mla sor)",
      addSurcharge: "Express fel\xE1r hozz\xE1ad\xE1sa",
      amount: "Fel\xE1r \xF6sszege (nett\xF3 Ft)",
      success: "Express fel\xE1r hozz\xE1adva",
      error: "Express fel\xE1r hozz\xE1ad\xE1sa sikertelen"
    },
    external: {
      title: "K\xFCls\u0151 szerviz",
      forwardButton: "Tov\xE1bb\xEDt\xE1s k\xFCls\u0151 szervizbe",
      forwardModalTitle: "Tov\xE1bb\xEDt\xE1s k\xFCls\u0151 szerviz partnerhez",
      forwardModalDescription: "A munkalap tov\xE1bb\xEDt\xE1sra ker\xFCl egy k\xFCls\u0151 szerviz partnernek.",
      partnerSelect: "K\xFCls\u0151 szerviz partner",
      reason: "Tov\xE1bb\xEDt\xE1s oka",
      reasonPlaceholder: "pl. Speci\xE1lis jav\xEDt\xE1s, nincs megfelel\u0151 alkatr\xE9sz...",
      estimatedReturn: "V\xE1rhat\xF3 visszav\xE9tel",
      forward: "Tov\xE1bb\xEDt\xE1s",
      forwarding: "Tov\xE1bb\xEDt\xE1s...",
      forwardSuccess: "Munkalap sikeresen tov\xE1bb\xEDtva",
      banner: "K\xFCls\u0151 szervizben",
      bannerInfo: "Partner: {partner} | V\xE1rhat\xF3 visszav\xE9tel: {date}",
      returnButton: "Visszav\xE9tel",
      returnModalTitle: "Visszav\xE9tel k\xFCls\u0151 szervizb\u0151l",
      actualCost: "T\xE9nyleges k\xF6lts\xE9g (nett\xF3 Ft)",
      returnNotes: "Megjegyz\xE9s",
      returnNotesPlaceholder: "pl. Jav\xEDt\xE1s elv\xE9gezve, alkatr\xE9sz cser\xE9lve...",
      returnSuccess: "Visszav\xE9tel sikeresen r\xF6gz\xEDtve",
      error: "Hiba a m\u0171velet sor\xE1n",
      partnerSearchPlaceholder: "Keres\xE9s n\xE9v, telefonsz\xE1m vagy ad\xF3sz\xE1m alapj\xE1n"
    },
    publicRequest: {
      title: "Szerviz ig\xE9nyl\xE9s",
      subtitle: "Online szerviz el\u0151regisztr\xE1ci\xF3",
      customerName: "N\xE9v",
      customerNamePlaceholder: "pl. Kov\xE1cs J\xE1nos",
      phone: "Telefonsz\xE1m",
      phonePlaceholder: "pl. +36 30 123 4567",
      email: "Email (opcion\xE1lis)",
      emailPlaceholder: "pl. kovacs@example.com",
      equipmentDescription: "G\xE9p megnevez\xE9se",
      equipmentDescriptionPlaceholder: "pl. Makita HR2470 f\xFAr\xF3kalap\xE1cs",
      problemDescription: "Hiba le\xEDr\xE1sa",
      problemDescriptionPlaceholder: "R\xE9szletesen \xEDrja le a hib\xE1t...",
      preferredDate: "K\xEDv\xE1nt id\u0151pont (opcion\xE1lis)",
      submit: "Ig\xE9nyl\xE9s bek\xFCld\xE9se",
      submitting: "Bek\xFCld\xE9s...",
      success: "Szerviz ig\xE9nyl\xE9s sikeresen bek\xFCldve! Hamarosan felvessz\xFCk \xD6nnel a kapcsolatot.",
      error: "Hiba t\xF6rt\xE9nt a bek\xFCld\xE9s sor\xE1n"
    },
    pendingRequest: {
      title: "Szerviz ig\xE9nyl\xE9sek",
      noRequests: "Nincs f\xFCgg\u0151 ig\xE9nyl\xE9s",
      accept: "Elfogad\xE1s",
      reject: "Elutas\xEDt\xE1s",
      accepted: "Elfogadva",
      rejected: "Elutas\xEDtva",
      pending: "F\xFCgg\u0151ben",
      customerName: "\xDCgyf\xE9l neve",
      phone: "Telefon",
      equipment: "G\xE9p",
      problem: "Hiba",
      date: "D\xE1tum",
      status: "St\xE1tusz"
    },
    abandoned: {
      tabTitle: "Elhagyott g\xE9pek",
      noItems: "Nincs elhagyott g\xE9p",
      noItemsDesc: "Jelenleg minden b\xE9relt g\xE9p a hat\xE1rid\u0151n bel\xFCl van.",
      totalCount: "{count} elhagyott g\xE9p",
      partner: "Partner",
      rental: "B\xE9rl\xE9s",
      daysOverdue: "nap lej\xE1rat \xF3ta",
      perDay: "nap",
      storageFee: "Becs\xFClt t\xE1rol\xE1si d\xEDj"
    },
    compensation: {
      tabTitle: "Kompenz\xE1ci\xF3",
      title: "Kompenz\xE1ci\xF3s fizet\xE9s r\xF6gz\xEDt\xE9se",
      description: "Ha az \xFCgyf\xE9l nem tudja visszahozni a s\xE9r\xFClt vagy elveszett g\xE9pet, r\xF6gz\xEDtse a kompenz\xE1ci\xF3s fizet\xE9st.",
      rentalId: "B\xE9rl\xE9s azonos\xEDt\xF3",
      rentalIdPlaceholder: "pl. R-20260401-001",
      amount: "\xD6sszeg (Ft)",
      reason: "Indokl\xE1s",
      reasonPlaceholder: "pl. \xDCgyf\xE9l nem tudja visszahozni a g\xE9pet, elveszett a munkahelyen...",
      action: "M\u0171velet",
      writtenOff: "Le\xEDr\xE1s (WRITTEN_OFF)",
      transferredToInventory: "K\xE9szletre v\xE9tel (TRANSFERRED_TO_INVENTORY)",
      submit: "Kompenz\xE1ci\xF3 r\xF6gz\xEDt\xE9se",
      validationError: "K\xE9rj\xFCk, t\xF6ltse ki az \xF6sszes mez\u0151t helyesen."
    },
    afterlife: {
      tabTitle: "Ut\xF3\xE9let d\xF6nt\xE9sek",
      pageTitle: "G\xE9p \xE9letciklus kezel\xE9s",
      pageSubtitle: "Elhagyott g\xE9pek, kompenz\xE1ci\xF3, ut\xF3\xE9let d\xF6nt\xE9sek, csoportos felv\xE9tel",
      noItems: "Nincs elem",
      scrapTitle: "Selejtez\xE9s",
      repairTitle: "Fel\xFAj\xEDt\xE1s",
      decisionTitle: "D\xF6nt\xE9s sz\xFCks\xE9ges",
      repairs: "Jav\xEDt\xE1sok",
      age: "Kor",
      months: "h\xF3nap",
      condition: "\xC1llapot"
    },
    surrender: {
      tabTitle: "\xD6nk\xE9ntes lemond\xE1s",
      title: "\xD6nk\xE9ntes lemond\xE1s r\xF6gz\xEDt\xE9se",
      description: "Ha az \xFCgyf\xE9l \xF6nk\xE9nt lemond a b\xE9relt g\xE9pr\u0151l (nem tudja fizetni, nincs sz\xFCks\xE9ge r\xE1), r\xF6gz\xEDtse a nyilatkozatot.",
      rentalId: "B\xE9rl\xE9s azonos\xEDt\xF3",
      rentalIdPlaceholder: "pl. R-20260401-001",
      statement: "Nyilatkozat",
      statementPlaceholder: "Az \xFCgyf\xE9l nyilatkozata az \xF6nk\xE9ntes lemond\xE1sr\xF3l, indokl\xE1s...",
      submit: "Lemond\xE1s r\xF6gz\xEDt\xE9se",
      validationError: "K\xE9rj\xFCk, t\xF6ltse ki az \xF6sszes mez\u0151t (nyilatkozat min. 5 karakter)."
    },
    issueInvoice: "Sz\xE1mla ki\xE1ll\xEDt\xE1sa",
    invoiceSuccess: "Sz\xE1mla sikeresen ki\xE1ll\xEDtva"
  },
  quotation: {
    draft: "Piszkozat",
    sent: "Elk\xFCldve",
    accepted: "Elfogadva",
    pendingValue: "V\xE1rakoz\xF3 \xE9rt\xE9k",
    worksheet: "Munkalap",
    createdAt: "L\xE9trehozva",
    validUntil: "\xC9rv\xE9nyes",
    amount: "\xD6sszeg",
    expiringSoon: "Hamarosan lej\xE1r!",
    gross: "brutt\xF3",
    itemsCount: "{count} t\xE9tel",
    quotationsDisplayed: "{count} \xE1raj\xE1nlat megjelen\xEDtve",
    newQuotationInfo: "\xDAj \xE1raj\xE1nlat k\xE9sz\xEDt\xE9se",
    newQuotationDesc: '\xC1raj\xE1nlat k\xE9sz\xEDt\xE9s\xE9hez nyisd meg a munkalapot, \xE9s kattints az "\xC1raj\xE1nlat k\xE9sz\xEDt\xE9s" gombra. A munkalap t\xE9telei automatikusan \xE1tker\xFClnek az \xE1raj\xE1nlatba.',
    notFound: "\xC1raj\xE1nlat nem tal\xE1lhat\xF3",
    backToList: "Vissza a list\xE1hoz",
    partnerData: "Partner adatok",
    partnerName: "Partner neve",
    phone: "Telefon",
    relatedWorksheet: "Kapcsol\xF3d\xF3 munkalap",
    itemDescription: "Megnevez\xE9s",
    unitPrice: "Egys\xE9g\xE1r",
    vat: "\xC1FA",
    totalColumn: "\xD6sszesen",
    netTotal: "Nett\xF3 \xF6sszesen:",
    vatTotal: "\xC1FA \xF6sszesen:",
    grossTotal: "Brutt\xF3 \xF6sszesen:",
    netLabel: "nett\xF3:",
    customerNote: "Megjegyz\xE9s az \xFCgyf\xE9lnek",
    internalNote: "Bels\u0151 megjegyz\xE9s (nem l\xE1tja az \xFCgyf\xE9l)",
    statusLabel: "\xC1llapot:",
    createdAtLabel: "L\xE9trehozva:",
    sentAtLabel: "Elk\xFCldve:",
    validUntilLabel: "\xC9rv\xE9nyes:",
    respondedAtLabel: "V\xE1lasz d\xE1tum:",
    createdByLabel: "K\xE9sz\xEDtette:",
    quotationAmount: "\xC1raj\xE1nlat \xF6sszege",
    pdfDownload: "PDF let\xF6lt\xE9s",
    emailSend: "Email k\xFCld\xE9s",
    openWorksheet: "Munkalap megnyit\xE1sa",
    recordAcceptance: "Elfogad\xE1s r\xF6gz\xEDt\xE9se",
    recordRejection: "Elutas\xEDt\xE1s r\xF6gz\xEDt\xE9se",
    generateWorksheet: "Munkalap gener\xE1l\xE1sa",
    acceptTitle: "\xC1raj\xE1nlat elfogad\xE1sa",
    acceptConfirm: "Biztosan r\xF6gz\xEDti az elfogad\xE1st a(z) {number} \xE1raj\xE1nlathoz?",
    acceptAfterInfo: "Elfogad\xE1s ut\xE1n a munkalap gener\xE1l\xE1sa el\xE9rhet\u0151v\xE9 v\xE1lik.",
    processing: "Feldolgoz\xE1s...",
    accept: "Elfogad\xE1s",
    rejectTitle: "\xC1raj\xE1nlat elutas\xEDt\xE1sa",
    rejectConfirm: "Biztosan r\xF6gz\xEDti az elutas\xEDt\xE1st a(z) {number} \xE1raj\xE1nlathoz?",
    rejectionReasonLabel: "Elutas\xEDt\xE1s oka (opcion\xE1lis)",
    rejectionPlaceholder: "Pl. t\xFAl magas \xE1r, m\xE1s aj\xE1nlatot v\xE1lasztott...",
    reject: "Elutas\xEDt\xE1s",
    generateWorksheetTitle: "Munkalap gener\xE1l\xE1sa",
    generateWorksheetConfirm: "Munkalap k\xE9sz\xEDt\xE9se a(z) {number} \xE1raj\xE1nlatb\xF3l?",
    generateWorksheetInfo: "A rendszer automatikusan l\xE9trehozza a munkalapot az \xE1raj\xE1nlat t\xE9teleib\u0151l:",
    partnerLabel: "Partner:",
    itemCountLabel: "T\xE9telek sz\xE1ma:",
    amountLabel: "\xD6sszeg:",
    generating: "Gener\xE1l\xE1s...",
    sendButton: "Elk\xFCld\xE9s",
    sentSuccess: "\xC1raj\xE1nlat elk\xFCldve.",
    sendFailed: "K\xFCld\xE9s sikertelen",
    acceptedSuccess: "\xC1raj\xE1nlat elfogadva.",
    acceptFailed: "Elfogad\xE1s sikertelen",
    rejectedSuccess: "\xC1raj\xE1nlat elutas\xEDtva.",
    rejectFailed: "Elutas\xEDt\xE1s sikertelen",
    worksheetCreated: "Munkalap l\xE9trehozva: {number}",
    conversionFailed: "Konverzi\xF3 sikertelen",
    newQuotation: "\xDAj \xE1raj\xE1nlat",
    editQuotation: "\xC1raj\xE1nlat szerkeszt\xE9se",
    quotationData: "\xC1raj\xE1nlat adatai",
    validityEnd: "\xC9rv\xE9nyess\xE9g v\xE9ge",
    totalGross: "\xD6sszesen (brutt\xF3)",
    addItem: "+ T\xE9tel hozz\xE1ad\xE1sa",
    itemDescriptionPlaceholder: "T\xE9tel megnevez\xE9se...",
    qty: "Menny.",
    unit: "Egys\xE9g",
    netPrice: "Nett\xF3 \xE1r",
    grossTotalItem: "Brutt\xF3 \xF6sszesen",
    noItems: "Nincs t\xE9tel. Kattintson a {button} gombra.",
    customerVisibleNote: "\xDCgyf\xE9l sz\xE1m\xE1ra l\xE1that\xF3 megjegyz\xE9s",
    customerNotePlaceholder: "Pl.: V\xE1rhat\xF3 elk\xE9sz\xFCl\xE9si id\u0151, fizet\xE9si felt\xE9telek...",
    internalNotePlaceholder: "Pl.: Kedvezm\xE9ny oka, \xFCgyf\xE9llel folytatott egyeztet\xE9s...",
    createQuotation: "\xC1raj\xE1nlat l\xE9trehoz\xE1sa",
    saveChanges: "V\xE1ltoztat\xE1sok ment\xE9se",
    saveFailed: "Ment\xE9s sikertelen. K\xE9rj\xFCk pr\xF3b\xE1lja \xFAjra.",
    atLeastOneItem: "Legal\xE1bb egy t\xE9telt adjon meg!",
    productId: "Cikksz\xE1m:",
    emailLabel: "Email",
    worksheetLabel: "Munkalap:",
    sendEmailSubject: "Email k\xFCld\xE9se: {email}\nT\xE1rgy: \xC1raj\xE1nlat - {number}",
    pdfGeneration: "PDF gener\xE1l\xE1s: {number}",
    version: "Verzi\xF3",
    versionHistory: "Verzi\xF3 t\xF6rt\xE9net",
    versionOf: "v{current}/{total}",
    currentVersion: "aktu\xE1lis",
    createNewVersion: "\xDAj verzi\xF3",
    newVersionCreated: "\xDAj verzi\xF3 l\xE9trehozva.",
    newVersionFailed: "\xDAj verzi\xF3 l\xE9trehoz\xE1sa sikertelen",
    quotationNumber: "Aj\xE1nlat sz\xE1m",
    diff: {
      compareVersions: "Verzi\xF3k \xF6sszehasonl\xEDt\xE1sa",
      versionHistory: "Verzi\xF3 t\xF6rt\xE9net",
      versionN: "v{n}",
      changed: "M\xF3dos\xEDtva",
      added: "Hozz\xE1adva",
      removed: "Elt\xE1vol\xEDtva",
      noChanges: "Nincs v\xE1ltoz\xE1s a k\xE9t verzi\xF3 k\xF6z\xF6tt",
      selectVersions: "V\xE1lasszon k\xE9t verzi\xF3t az \xF6sszehasonl\xEDt\xE1shoz",
      basicInfo: "Alap adatok",
      field: "Mez\u0151",
      versions: "Verzi\xF3k"
    },
    status: {
      draft: "Piszkozat",
      sent: "Elk\xFCldve",
      accepted: "Elfogadva",
      rejected: "Elutas\xEDtva",
      expired: "Lej\xE1rt",
      converted: "Konvert\xE1lva"
    }
  },
  vehicle: {
    title: "J\xE1rm\u0171vek",
    rentalVehicles: "B\xE9rg\xE9p j\xE1rm\u0171vek",
    companyVehicles: "C\xE9ges j\xE1rm\u0171vek",
    expiringDocuments: "Lej\xE1r\xF3 dokumentumok",
    technicalInspection: "M\u0171szaki vizsga",
    registrationCert: "Forgalmi enged\xE9ly",
    mtplInsurance: "KGFB biztos\xEDt\xE1s",
    cascoInsurance: "CASCO biztos\xEDt\xE1s",
    highwaySticker: "Aut\xF3p\xE1lya matrica",
    subtitle: "Ut\xE1nfut\xF3k, aggreg\xE1torok, platformok kezel\xE9se",
    newVehicle: "\xDAj j\xE1rm\u0171",
    totalVehicles: "\xD6sszes j\xE1rm\u0171",
    available: "El\xE9rhet\u0151",
    rentedOut: "Kiadva",
    expiringIn30Days: "Lej\xE1r 30 napon bel\xFCl",
    searchPlaceholder: "Keres\xE9s rendsz\xE1m, n\xE9v, m\xE1rka...",
    allTypes: "\xD6sszes t\xEDpus",
    allStatuses: "\xD6sszes st\xE1tusz",
    vehicleColumn: "J\xE1rm\u0171",
    technicalExpiry: "M\u0171szaki lej\xE1rat",
    registrationExpiry: "Forgalmi lej\xE1rat",
    insuranceExpiry: "Biztos\xEDt\xE1s lej\xE1rat",
    operations: "M\u0171veletek",
    loadingVehicles: "J\xE1rm\u0171vek bet\xF6lt\xE9se...",
    noResults: "Nincs tal\xE1lat a keres\xE9si felt\xE9teleknek megfelel\u0151en.",
    deleteConfirm: "Biztosan t\xF6r\xF6lni szeretn\xE9 a j\xE1rm\u0171vet: {name}?",
    deleteFailed: "Nem siker\xFClt t\xF6r\xF6lni a j\xE1rm\u0171vet.",
    typeLabels: {
      trailer: "Ut\xE1nfut\xF3",
      aggregator: "Aggreg\xE1tor",
      platform: "Platform",
      other: "Egy\xE9b"
    },
    statusLabels: {
      active: "El\xE9rhet\u0151",
      rented: "Kiadva",
      maintenance: "Karbantart\xE1s",
      inactive: "Inakt\xEDv",
      available: "El\xE9rhet\u0151"
    },
    companyTypeLabels: {
      car: "Szem\xE9lyaut\xF3",
      van: "Furgon",
      truck: "Teherg\xE9pkocsi"
    },
    companyStatusLabels: {
      active: "El\xE9rhet\u0151",
      in_use: "Haszn\xE1latban",
      maintenance: "Szervizben",
      inactive: "Inakt\xEDv"
    },
    fuelLabels: {
      petrol: "Benzin",
      diesel: "D\xEDzel",
      electric: "Elektromos",
      hybrid: "Hibrid"
    },
    companySubtitle: "Szem\xE9lyaut\xF3k, furgonok k\xF6zponti kezel\xE9se",
    inUse: "Haszn\xE1latban",
    vehicleNotFound: "J\xE1rm\u0171 nem tal\xE1lhat\xF3.",
    basicInfo: "Alapadatok",
    licensePlate: "Rendsz\xE1m",
    brandModel: "M\xE1rka / Modell",
    yearOfManufacture: "\xC9vj\xE1rat",
    fuelType: "\xDCzemanyag",
    odometer: "Kilom\xE9ter\xF3ra",
    assignedTo: "Hozz\xE1rendelve",
    expiryAndInsurance: "Lej\xE1ratok & Biztos\xEDt\xE1sok",
    insurance: "Biztos\xEDt\xE1s",
    recordData: "Rekord adatok",
    lastModified: "Utolj\xE1ra m\xF3dos\xEDtva",
    editCompanyVehicle: "C\xE9ges j\xE1rm\u0171 szerkeszt\xE9se",
    newCompanyVehicle: "\xDAj c\xE9ges j\xE1rm\u0171",
    editVehicleData: "J\xE1rm\u0171 adatainak m\xF3dos\xEDt\xE1sa",
    registerNewCompanyVehicle: "\xDAj c\xE9ges j\xE1rm\u0171 r\xF6gz\xEDt\xE9se",
    licensePlateRequired: "Rendsz\xE1m megad\xE1sa k\xF6telez\u0151",
    nameRequired: "Megnevez\xE9s megad\xE1sa k\xF6telez\u0151",
    brandRequired: "M\xE1rka megad\xE1sa k\xF6telez\u0151",
    kgfbExpiryRequired: "KGFB lej\xE1rat megad\xE1sa k\xF6telez\u0151",
    technicalExpiryRequired: "M\u0171szaki lej\xE1rat megad\xE1sa k\xF6telez\u0151",
    registrationExpiryRequired: "Forgalmi lej\xE1rat megad\xE1sa k\xF6telez\u0151",
    insuranceExpiryRequired: "Biztos\xEDt\xE1s lej\xE1rat megad\xE1sa k\xF6telez\u0151",
    invalidLicensePlate: "\xC9rv\xE9nytelen rendsz\xE1m form\xE1tum (pl. ABC-123)",
    expiryDatesAndInsurance: "Lej\xE1rati d\xE1tumok \xE9s biztos\xEDt\xE1sok",
    designation: "Megnevez\xE9s",
    brandLabel: "M\xE1rka",
    modelLabel: "Modell",
    statusLabel: "St\xE1tusz",
    odometerReading: "Kilom\xE9ter\xF3ra \xE1ll\xE1s",
    assignedStore: "Hozz\xE1rendelt \xFCzlet",
    noAssignment: "-- Nincs hozz\xE1rendel\xE9s --",
    additionalInfo: "Tov\xE1bbi inform\xE1ci\xF3k...",
    savingInProgress: "Ment\xE9s...",
    rentalHistory: "B\xE9rl\xE9si el\u0151zm\xE9nyek",
    loadingHistory: "El\u0151zm\xE9nyek bet\xF6lt\xE9se...",
    noRentalHistory: "Nincs b\xE9rl\xE9si el\u0151zm\xE9ny.",
    backToList: "Vissza a list\xE1hoz",
    expiryDates: "Lej\xE1rati d\xE1tumok",
    editVehicle: "J\xE1rm\u0171 szerkeszt\xE9se",
    addNewVehicle: "\xDAj j\xE1rm\u0171 hozz\xE1ad\xE1sa",
    registerNewRentalVehicle: "\xDAj b\xE9rg\xE9p j\xE1rm\u0171 r\xF6gz\xEDt\xE9se",
    expiringDocsSubtitle: "B\xE9rg\xE9p \xE9s c\xE9ges j\xE1rm\u0171vek lej\xE1r\xF3 dokumentumai",
    within30Days: "30 napon bel\xFCl",
    within60Days: "60 napon bel\xFCl",
    allMonitored: "\xD6sszes figyelt",
    allFilter: "\xD6sszes",
    allCategories: "\xD6sszes kateg\xF3ria",
    allDocuments: "\xD6sszes dokumentum",
    noExpiringDocs: "Nincs lej\xE1r\xF3 dokumentum a kiv\xE1lasztott sz\u0171r\u0151kkel.",
    companyLabel: "C\xE9ges",
    rentalLabel: "B\xE9rg\xE9p",
    expiredDaysAgo: "{days} napja lej\xE1rt",
    expiresInDays: "{days} nap m\xFAlva",
    typeLabel: "T\xEDpus",
    additionalVehicleInfo: "Tov\xE1bbi inform\xE1ci\xF3k a j\xE1rm\u0171r\u0151l...",
    placeholder: {
      brand: "pl. Skoda",
      companyName: "pl. Szolg\xE1lati aut\xF3 1",
      model: "pl. Octavia",
      rentalName: "pl. Ut\xE1nfut\xF3 1"
    }
  },
  user: {
    title: "Felhaszn\xE1l\xF3k",
    subtitle: "Felhaszn\xE1l\xF3k \xE9s jogosults\xE1gok kezel\xE9se",
    loadingUsers: "Felhaszn\xE1l\xF3k bet\xF6lt\xE9se...",
    loadingUser: "Felhaszn\xE1l\xF3 bet\xF6lt\xE9se...",
    errorOccurred: "Hiba t\xF6rt\xE9nt",
    backToDashboard: "Vissza a kezd\u0151lapra",
    roles: "Szerepk\xF6r\xF6k",
    newUser: "+ \xDAj felhaszn\xE1l\xF3",
    totalUsers: "\xD6sszes felhaszn\xE1l\xF3",
    searchPlaceholder: "Keres\xE9s n\xE9v, email...",
    allRoles: "Minden szerepk\xF6r",
    allStores: "Minden \xFCzlet",
    userColumn: "Felhaszn\xE1l\xF3",
    roleColumn: "Szerepk\xF6r",
    createdAtColumn: "L\xE9trehozva",
    usersDisplayed: "{count} felhaszn\xE1l\xF3 megjelen\xEDtve",
    notFound: "Felhaszn\xE1l\xF3 nem tal\xE1lhat\xF3",
    suspend: "Felf\xFCggeszt\xE9s",
    activate: "Aktiv\xE1l\xE1s",
    tabOverview: "\xC1ttekint\xE9s",
    tabActivity: "Tev\xE9kenys\xE9g",
    basicData: "Alapadatok",
    email: "Email",
    role: "Szerepk\xF6r",
    tenantId: "B\xE9rl\u0151i azonos\xEDt\xF3",
    locationId: "Telephely ID",
    systemInfo: "Rendszer inform\xE1ci\xF3",
    identifier: "Azonos\xEDt\xF3:",
    createdLabel: "L\xE9trehozva:",
    modifiedLabel: "M\xF3dos\xEDtva:",
    activityLog: "Tev\xE9kenys\xE9g napl\xF3",
    profileUpdated: "Profil friss\xEDtve",
    userCreated: "Felhaszn\xE1l\xF3 l\xE9trehozva",
    editUser: "Felhaszn\xE1l\xF3 szerkeszt\xE9se",
    newUserTitle: "\xDAj felhaszn\xE1l\xF3",
    savingLabel: "Ment\xE9s...",
    createLabel: "L\xE9trehoz\xE1s",
    nameRequired: "N\xE9v *",
    emailRequired: "Email c\xEDm *",
    passwordChange: "Jelsz\xF3 m\xF3dos\xEDt\xE1s",
    newPassword: "\xDAj jelsz\xF3",
    passwordRequired: "Jelsz\xF3 *",
    minChars: "Legal\xE1bb 8 karakter",
    passwordLeaveEmpty: "Hagyja \xFCresen, ha nem k\xEDv\xE1nja m\xF3dos\xEDtani",
    confirmPassword: "Jelsz\xF3 meger\u0151s\xEDt\xE9se",
    confirmPasswordRequired: "Jelsz\xF3 meger\u0151s\xEDt\xE9se *",
    passwordAgain: "Jelsz\xF3 \xFAjra",
    roleAndLocation: "Szerepk\xF6r \xE9s telephely",
    roleRequired: "Szerepk\xF6r *",
    locationOptional: "\xDCzlet / Telephely (opcion\xE1lis)",
    notSpecified: "Nincs megadva",
    saveChanges: "V\xE1ltoztat\xE1sok ment\xE9se",
    createUser: "Felhaszn\xE1l\xF3 l\xE9trehoz\xE1sa",
    saveError: "Hiba t\xF6rt\xE9nt a ment\xE9s sor\xE1n.",
    namePlaceholder: "Kov\xE1cs J\xE1nos",
    emailPlaceholder: "felhasznalo@example.hu",
    validation: {
      emailRequired: "Email c\xEDm k\xF6telez\u0151",
      emailInvalid: "\xC9rv\xE9nytelen email c\xEDm",
      nameRequired: "N\xE9v k\xF6telez\u0151",
      roleRequired: "Szerepk\xF6r kiv\xE1laszt\xE1sa k\xF6telez\u0151",
      passwordRequired: "Jelsz\xF3 k\xF6telez\u0151",
      passwordMinLength: "Legal\xE1bb 8 karakter",
      passwordMismatch: "Jelszavak nem egyeznek",
      taxFormat: "Az ad\xF3sz\xE1m form\xE1tuma \xE9rv\xE9nytelen (8 vagy 11 sz\xE1mjegy)",
      taxChecksum: "Az ad\xF3sz\xE1m ellen\u0151rz\u0151 sz\xE1mjegye hib\xE1s",
      phoneFormat: "\xC9rv\xE9nytelen telefonsz\xE1m form\xE1tum",
      postalFormat: "Az ir\xE1ny\xEDt\xF3sz\xE1m 4 sz\xE1mjegy"
    },
    roleLabels: {
      OPERATOR: "Oper\xE1tor",
      TECHNIKUS: "Szervizes",
      BOLTVEZETO: "\xDCzletvezet\u0151",
      ACCOUNTANT: "K\xF6nyvel\u0151",
      PARTNER_OWNER: "Partner tulajdonos",
      CENTRAL_ADMIN: "K\xF6zponti admin",
      DEVOPS_ADMIN: "DevOps admin",
      SUPER_ADMIN: "Rendszergazda"
    },
    roleDescriptions: {
      OPERATOR: "Kassza kezel\xE9s, \xE9rt\xE9kes\xEDt\xE9s, b\xE9rl\xE9s",
      TECHNIKUS: "Munkalap kezel\xE9s, szerviz m\u0171veletek",
      BOLTVEZETO: "\xDCzlet m\u0171k\xF6dtet\xE9se, riportok, felhaszn\xE1l\xF3k kezel\xE9se",
      ACCOUNTANT: "P\xE9nz\xFCgyi m\u0171veletek, sz\xE1ml\xE1z\xE1s, elsz\xE1mol\xE1s",
      PARTNER_OWNER: "Partner szint\u0171 hozz\xE1f\xE9r\xE9s, szerz\u0151d\xE9sek",
      CENTRAL_ADMIN: "K\xF6zponti adminisztr\xE1ci\xF3, \xF6sszes \xFCzlet",
      DEVOPS_ADMIN: "Rendszer \xFCzemeltet\xE9s, infrastrukt\xFAra",
      SUPER_ADMIN: "Teljes hozz\xE1f\xE9r\xE9s minden funkci\xF3hoz"
    },
    statusLabels: {
      ACTIVE: "Akt\xEDv",
      INACTIVE: "Inakt\xEDv",
      LOCKED: "Z\xE1rolva",
      PENDING_VERIFICATION: "J\xF3v\xE1hagy\xE1sra v\xE1r"
    },
    rolesAndPermissions: "Szerepk\xF6r\xF6k \xE9s jogosults\xE1gok",
    rbacDescription: "RBAC kezel\xE9s (8 szint\u0171 szerepk\xF6r-hierarchia)",
    rbacInfoBanner: "A szerepk\xF6r\xF6k a backend RBAC rendszerben vannak defini\xE1lva (ADR-032). A jogosults\xE1gok megtekinthet\u0151ek, de m\xF3dos\xEDt\xE1suk a rendszer konfigur\xE1ci\xF3j\xE1ban t\xF6rt\xE9nik.",
    rolesCount: "Szerepk\xF6r\xF6k ({count})",
    level: "Szint {level}",
    code: "K\xF3d:",
    hierarchyLevel: "Hierarchia szint:",
    permissionsLabel: "Jogosults\xE1gok:",
    typeLabel: "T\xEDpus:",
    systemRole: "Rendszer szerepk\xF6r",
    permissionsCount: "Jogosults\xE1gok ({count})",
    selectRolePrompt: "V\xE1lasszon ki egy szerepk\xF6rt a r\xE9szletek megtekint\xE9s\xE9hez."
  },
  dunning: {
    title: "Felsz\xF3l\xEDt\xE1s",
    level: {
      none: "Nincs",
      reminder: "Eml\xE9keztet\u0151",
      warning: "Figyelmeztet\xE9s",
      finalNotice: "V\xE9gs\u0151 felsz\xF3l\xEDt\xE1s"
    },
    currentLevel: "Aktu\xE1lis szint",
    escalate: "Szint emel\xE9se",
    escalateSuccess: "Felsz\xF3l\xEDt\xE1si szint sikeresen emelve",
    history: "Felsz\xF3l\xEDt\xE1si el\u0151zm\xE9nyek",
    sentAt: "K\xFCldve",
    nextEscalation: "K\xF6vetkez\u0151 szint",
    overdueDays: "K\xE9sedelmi napok",
    days: "nap",
    amount: "H\xE1tral\xE9k",
    escalationCount: "Felsz\xF3l\xEDt\xE1sok sz\xE1ma",
    noHistory: "Nincs felsz\xF3l\xEDt\xE1si el\u0151zm\xE9ny"
  },
  invoicePage: {
    invoiceNumber: "Sz\xE1mlasz\xE1m",
    issueDate: "Ki\xE1ll\xEDt\xE1s",
    dueDate: "Fizet\xE9si hat\xE1rid\u0151",
    amount: "\xD6sszeg",
    arrears: "H\xE1tral\xE9k: {amount}",
    loadingInvoices: "Sz\xE1ml\xE1k bet\xF6lt\xE9se...",
    errorOccurred: "Hiba t\xF6rt\xE9nt: {message}",
    noResults: "Nincs tal\xE1lat a megadott sz\u0171r\u0151kkel",
    invoiceCount: "{count} sz\xE1mla"
  },
  contract: {
    title: "Szerz\u0151d\xE9sek",
    subtitle: "B\xE9rl\xE9si \xE9s szolg\xE1ltat\xE1si szerz\u0151d\xE9sek",
    contract: "Szerz\u0151d\xE9s",
    goToRentals: "B\xE9rl\xE9sek",
    activeDeposit: "Akt\xEDv kauci\xF3",
    activeValue: "Akt\xEDv \xE9rt\xE9k",
    searchPlaceholder: "Keres\xE9s sz\xE1m, partner, b\xE9rl\xE9s...",
    deposit: "Kauci\xF3",
    depositPaid: "Befizetve",
    depositMissing: "Nincs",
    depositNotPaid: "Nincs befizetve",
    depositAmount: "Kauci\xF3 \xF6sszege",
    contractsDisplayed: "{count} szerz\u0151d\xE9s megjelen\xEDtve",
    autoGenerationTitle: "Szerz\u0151d\xE9s automatikus gener\xE1l\xE1s",
    autoGenerationDesc: "A szerz\u0151d\xE9sek automatikusan gener\xE1l\xF3dnak a b\xE9rl\xE9s ind\xEDt\xE1sakor. PDF let\xF6lt\xE9s \xE9s nyomtat\xE1s a r\xE9szletek oldalon \xE9rhet\u0151 el.",
    notFound: "Szerz\u0151d\xE9s nem tal\xE1lhat\xF3",
    rental: "B\xE9rl\xE9s",
    pdfDownload: "PDF let\xF6lt\xE9s",
    pdfGeneration: "PDF gener\xE1l\xE1s",
    pdfDownloading: "A szerz\u0151d\xE9s PDF-je let\xF6lt\xE9sre ker\xFCl...",
    sign: "Al\xE1\xEDr\xE1s",
    partnerData: "Partner adatok",
    partnerName: "Partner neve",
    idNumber: "Szem\xE9lyi ig. sz\xE1m",
    contractPeriod: "Szerz\u0151d\xE9s id\u0151tartama",
    startDate: "Kezdete",
    expectedEndDate: "V\xE1rhat\xF3 v\xE9ge",
    expectedEnd: "V\xE1rhat\xF3 v\xE9g",
    actualEndDate: "T\xE9nyleges v\xE9ge",
    activeContractMessage: "Akt\xEDv szerz\u0151d\xE9s - visszav\xE9tel folyamatban",
    dailyRate: "Napi d\xEDj",
    productId: "Cikk",
    termsAndNotes: "Felt\xE9telek \xE9s megjegyz\xE9sek",
    contractTerms: "Szerz\u0151d\xE9si felt\xE9telek",
    signedAt: "Al\xE1\xEDrva",
    signatures: "Al\xE1\xEDr\xE1sok",
    partnerSignature: "Partner al\xE1\xEDr\xE1sa",
    staffSignature: "Munkat\xE1rs al\xE1\xEDr\xE1sa",
    contractAmount: "Szerz\u0151d\xE9s \xF6sszege",
    openRental: "B\xE9rl\xE9s megnyit\xE1sa",
    recordSignature: "Al\xE1\xEDr\xE1s r\xF6gz\xEDt\xE9se",
    editContract: "Szerz\u0151d\xE9s szerkeszt\xE9se",
    contractData: "Szerz\u0151d\xE9s adatai",
    duration: "Id\u0151tartam",
    financialData: "P\xE9nz\xFCgyi adatok",
    termsPlaceholder: "A szerz\u0151d\xE9s \xE1ltal\xE1nos felt\xE9telei...",
    notesPlaceholder: "Egy\xE9b megjegyz\xE9sek...",
    saveChanges: "V\xE1ltoztat\xE1sok ment\xE9se",
    datesRequired: "A kezd\u0151 \xE9s z\xE1r\xF3 d\xE1tum megad\xE1sa k\xF6telez\u0151!",
    saveFailed: "Ment\xE9s sikertelen. K\xE9rj\xFCk pr\xF3b\xE1lja \xFAjra.",
    status: {
      draft: "Piszkozat",
      active: "Akt\xEDv",
      completed: "Lez\xE1rt",
      cancelled: "Visszavont"
    },
    type: {
      rental: "B\xE9rleti",
      service: "Szerviz",
      sales: "Elad\xE1si"
    }
  },
  product: {
    title: "Cikkek",
    subtitle: "Term\xE9kek, alkatr\xE9szek \xE9s b\xE9rg\xE9pek kezel\xE9se",
    newProduct: "\xDAj cikk",
    newProductTitle: "\xDAj cikk",
    newProductSubtitle: "Term\xE9k adatok r\xF6gz\xEDt\xE9se",
    editProduct: "Cikk szerkeszt\xE9se",
    productNotFound: "Cikk nem tal\xE1lhat\xF3",
    backToList: "Vissza a list\xE1hoz",
    identifiers: "Azonos\xEDt\xF3k",
    sku: "Cikksz\xE1m (bels\u0151)",
    skuRequired: "Cikksz\xE1m (bels\u0151) *",
    skuOptional: "Cikksz\xE1m (bels\u0151) \u2014 automatikusan gener\xE1lt, \xFCresen hagyhat\xF3",
    skuAutoPlaceholder: "KGC-2026-####",
    internalCodeSource: {
      label: "Cikksz\xE1m forr\xE1s",
      AUTO_GENERATED: "Automatikus gener\xE1l\xE1s (KGC-{\xE9v}-####)",
      SUPPLIER_FGS: "FGS besz\xE1ll\xEDt\xF3i cikksz\xE1m",
      SUPPLIER_MAV: "MAV besz\xE1ll\xEDt\xF3i cikksz\xE1m"
    },
    barcode: "Vonalk\xF3d (EAN)",
    manufacturerCode: "Gy\xE1rt\xF3i cikksz\xE1m",
    manufacturerCodeShort: "Gy\xE1rt\xF3i k\xF3d",
    locationCode: "Helyk\xF3d (K-P-D)",
    productDetails: "Term\xE9k adatok",
    productName: "Megnevez\xE9s *",
    productNamePlaceholder: "Makita DHP481RTJ akkus \xFCtvef\xFAr\xF3-csavaroz\xF3",
    shortName: "R\xF6vid n\xE9v",
    brand: "M\xE1rka",
    typeModel: "T\xEDpus/Modell",
    supplier: "Besz\xE1ll\xEDt\xF3",
    supplierName: "Besz\xE1ll\xEDt\xF3 neve",
    supplierCode: "Besz\xE1ll\xEDt\xF3 k\xF3d",
    selectPlaceholder: "-- V\xE1lasszon --",
    description: "Le\xEDr\xE1s",
    descriptionPlaceholder: "R\xE9szletes term\xE9kle\xEDr\xE1s...",
    pricing: "\xC1raz\xE1s",
    purchasePriceNet: "Beszerz\xE9si \xE1r (nett\xF3)",
    sellingPriceNet: "Elad\xE1si \xE1r (nett\xF3)",
    sellingPriceGross: "Elad\xE1si \xE1r (brutt\xF3)",
    vatRate: "\xC1FA kulcs",
    calculatedMargin: "Sz\xE1m\xEDtott \xE1rr\xE9s: <strong>{percent}%</strong>",
    stockSettings: "K\xE9szlet be\xE1ll\xEDt\xE1sok",
    minStockLevel: "Minimum k\xE9szletszint",
    reorderQuantity: "Rendel\xE9si mennyis\xE9g",
    rentalSettings: "B\xE9rl\xE9si be\xE1ll\xEDt\xE1sok",
    dailyRateFt: "Napi d\xEDj (Ft)",
    weeklyRateFt: "Heti d\xEDj (Ft)",
    monthlyRateFt: "Havi d\xEDj (Ft)",
    depositAmountFt: "Kauci\xF3 \xF6sszeg (Ft)",
    creating: "L\xE9trehoz\xE1s...",
    createProduct: "Cikk l\xE9trehoz\xE1sa",
    savingChanges: "Ment\xE9s...",
    saveChanges: "M\xF3dos\xEDt\xE1sok ment\xE9se",
    nameRequired: "A n\xE9v megad\xE1sa k\xF6telez\u0151!",
    skuRequiredAlert: "A cikksz\xE1m megad\xE1sa k\xF6telez\u0151!",
    errorPrefix: "Hiba: {message}",
    sale: "Elad\xE1s",
    tabs: {
      overview: "\xC1ttekint\xE9s",
      stock: "K\xE9szlet",
      pricing: "\xC1raz\xE1s",
      rental: "B\xE9rl\xE9s",
      components: "\xD6sszetev\u0151k",
      history: "El\u0151zm\xE9nyek"
    },
    explodedView: {
      title: "\xD6sszetev\u0151k (BOM)",
      addComponent: "Hozz\xE1ad\xE1s",
      noComponents: "Nincsenek \xF6sszetev\u0151k r\xF6gz\xEDtve ehhez a term\xE9khez.",
      componentName: "\xD6sszetev\u0151 neve",
      quantityPerUnit: "Mennyis\xE9g/db",
      unitCost: "Egys\xE9g\xE1r",
      totalCost: "\xD6sszesen",
      totalBomCost: "\xD6sszes\xEDtett BOM k\xF6lts\xE9g",
      marginSummary: "\xC1rr\xE9s \xF6sszes\xEDt\u0151",
      searchProduct: "Term\xE9k keres\xE9se"
    },
    basicData: "Alapadatok",
    noSupplier: "Nincs besz\xE1ll\xEDt\xF3 megadva",
    lastOrder: "Utols\xF3 rendel\xE9s",
    lastPurchasePrice: "Utols\xF3 beszerz\xE9si \xE1r",
    quickOverview: "Gyors \xE1ttekint\xE9s",
    inStock: "K\xE9szleten:",
    reserved: "Foglalt:",
    margin: "\xC1rr\xE9s:",
    goodsReceipt: "Bev\xE9telez\xE9s",
    movements: "Mozg\xE1sok",
    startRental: "B\xE9rl\xE9s ind\xEDt\xE1sa",
    stockData: "K\xE9szletadatok",
    totalStock: "Teljes k\xE9szlet:",
    available: "El\xE9rhet\u0151:",
    minimumLevel: "Minimum szint:",
    placement: "Elhelyez\xE9s",
    notSpecified: "Nincs megadva",
    locationCodeFormat: "A helyk\xF3d form\xE1tuma: <strong>K\xE9szlet - Polc - Doboz</strong>",
    locationCodeExample: "P\xE9ld\xE1ul: A-02-03 = A k\xE9szlet, 2. polc, 3. doboz",
    lowStockWarning: "Alacsony k\xE9szletszint!",
    lowStockDescription: "A k\xE9szlet ({current} db) a minimum szint ({min} db) alatt van. Javasolt rendel\xE9si mennyis\xE9g: {reorder} db",
    prices: "\xC1rak",
    marginCalculation: "\xC1rr\xE9s sz\xE1m\xEDt\xE1s",
    marginFt: "\xC1rr\xE9s (Ft):",
    marginPercent: "\xC1rr\xE9s (%):",
    marginFormula: "\xC1rr\xE9s sz\xE1m\xEDt\xE1s: (Elad\xE1si - Beszerz\xE9si) / Beszerz\xE9si \xD7 100",
    rentalRates: "B\xE9rl\xE9si d\xEDjak",
    dailyRate: "Napi d\xEDj:",
    weeklyRate: "Heti d\xEDj:",
    monthlyRate: "Havi d\xEDj (30 nap):",
    depositAmount: "Kauci\xF3 \xF6sszeg:",
    rentalStatus: "B\xE9rl\xE9si st\xE1tusz",
    totalMachines: "\xD6sszes g\xE9p:",
    rentedOut: "Kiadva (b\xE9rben):",
    availableForRental: "El\xE9rhet\u0151 kiad\xE1sra:",
    startNewRental: "\xDAj b\xE9rl\xE9s ind\xEDt\xE1sa",
    history: "El\u0151zm\xE9nyek",
    productUpdated: "Cikk adatok friss\xEDtve",
    lastPurchase: "Utols\xF3 beszerz\xE9s - {price}",
    productCreated: "Cikk l\xE9trehozva ({user})",
    statusAndCategory: "St\xE1tusz \xE9s kateg\xF3ria",
    currentStock: "Aktu\xE1lis k\xE9szlet: <strong>{total} db</strong> (El\xE9rhet\u0151: {available} db, Foglalt: {reserved} db)",
    stats: {
      total: "\xD6sszes cikk",
      active: "Akt\xEDv",
      lowStock: "Alacsony k\xE9szlet",
      outOfStock: "Nincs k\xE9szleten",
      stockValue: "K\xE9szlet\xE9rt\xE9k"
    },
    searchPlaceholder: "Keres\xE9s n\xE9v, cikksz\xE1m, vonalk\xF3d, m\xE1rka...",
    allCategories: "Minden kateg\xF3ria",
    allStatuses: "Minden st\xE1tusz",
    allSuppliers: "Minden besz\xE1ll\xEDt\xF3",
    lowStockOnly: "Csak alacsony k\xE9szlet",
    tableHeaders: {
      product: "Cikk",
      category: "Kateg\xF3ria",
      barcode: "Vonalk\xF3d",
      supplier: "Besz\xE1ll\xEDt\xF3",
      netPrice: "Nett\xF3 \xE1r",
      grossPrice: "Brutt\xF3 \xE1r",
      stock: "K\xE9szlet",
      status: "St\xE1tusz"
    },
    stockBadge: {
      none: "Nincs",
      low: "Alacsony",
      ok: "OK"
    },
    detailsButton: "R\xE9szletek",
    noResults: "Nincs tal\xE1lat a sz\u0171r\xE9si felt\xE9teleknek megfelel\u0151en.",
    displayedCount: "{count} cikk megjelen\xEDtve",
    filter: {
      allBrands: "\xD6sszes m\xE1rka"
    },
    manufacturerPartNumber: "Gy\xE1rt\xF3i cikksz\xE1m",
    manufacturerPartNumberShort: "Gy\xE1rt\xF3i cikksz.",
    import: {
      imported: "Import\xE1lt",
      updated: "Friss\xEDtett",
      skipped: "Kihagyott",
      totalRows: "\xD6sszes sor"
    },
    categoriesLoadError: "A kateg\xF3ri\xE1k bet\xF6lt\xE9se nem siker\xFClt.",
    noCategories: "Nincs felvett kateg\xF3ria."
  },
  report: {
    title: "Riportok",
    subtitle: "\xDCzleti jelent\xE9sek \xE9s statisztik\xE1k",
    overview: "\xC1ttekint\xE9s",
    sales: "\xC9rt\xE9kes\xEDt\xE9s",
    rentals: "B\xE9rl\xE9sek",
    inventory: "K\xE9szlet",
    financial: "P\xE9nz\xFCgyi",
    period: "Id\u0151szak:",
    today: "Ma",
    week: "H\xE9t",
    month: "H\xF3nap",
    quarter: "Negyed\xE9v",
    year: "\xC9v",
    customPeriod: "Egy\xE9ni id\u0151szak",
    totalRevenue: "\xD6sszes bev\xE9tel",
    comparedToPrevMonth: "el\u0151z\u0151 h\xF3naphoz k\xE9pest",
    salesCount: "\xC9rt\xE9kes\xEDt\xE9sek",
    worksheets: "Munkalapok",
    revenueTrend: "Bev\xE9tel trend",
    revenueChart: "Vonaldiagram - Bev\xE9tel",
    categoryDistribution: "Kateg\xF3ri\xE1k megoszl\xE1sa",
    categoryChart: "K\xF6rdiagram - Kateg\xF3ri\xE1k",
    salesByCategory: "\xC9rt\xE9kes\xEDt\xE9s kateg\xF3ri\xE1nk\xE9nt",
    category: "Kateg\xF3ria",
    amount: "\xD6sszeg",
    pieces: "Darab",
    avgPerPiece: "\xC1tlag/db",
    ratio: "Ar\xE1ny",
    total: "\xD6sszesen",
    dailySales: "Napi \xE9rt\xE9kes\xEDt\xE9s",
    dailySalesChart: "Oszlopdiagram - Napi \xE9rt\xE9kes\xEDt\xE9s",
    topRentals: "Top b\xE9rl\xE9sek - g\xE9pkihaszn\xE1lts\xE1g",
    equipment: "G\xE9p",
    rentalsCount: "B\xE9rl\xE9sek",
    revenue: "Bev\xE9tel",
    utilization: "Kihaszn\xE1lts\xE1g",
    avgRentalDuration: "\xC1tlagos b\xE9rl\xE9si id\u0151",
    avgRentalDays: "{days} nap",
    overdueReturns: "K\xE9sedelmes visszav\xE9telek",
    avgDeposit: "\xC1tlagos kauci\xF3",
    inventoryByCategory: "K\xE9szlet\xE1llapot kateg\xF3ri\xE1nk\xE9nt",
    inStock: "K\xE9szleten",
    reserved: "Foglalt",
    available: "El\xE9rhet\u0151",
    lowStock: "Alacsony k\xE9szlet",
    lowStockItems: "{count} term\xE9k",
    grossRevenue: "Brutt\xF3 bev\xE9tel",
    vatPayment: "\xC1FA befizet\xE9s",
    vatRate: "27% \xC1FA kulcs",
    netResult: "Nett\xF3 eredm\xE9ny",
    expiredInvoices: "{count} lej\xE1rt sz\xE1mla",
    revenueBreakdown: "Bev\xE9tel megoszl\xE1sa",
    productSales: "Term\xE9k\xE9rt\xE9kes\xEDt\xE9s",
    rentalFees: "B\xE9rleti d\xEDjak",
    serviceLabor: "Szerviz munkad\xEDj",
    other: "Egy\xE9b",
    smallMachines: "Kisg\xE9pek",
    tools: "Szersz\xE1mok",
    safetyEquipment: "V\xE9d\u0151felszerel\xE9s",
    rentalReport: "B\xE9rl\xE9si Riport",
    periodLabel: "Id\u0151szak: {start} - {end}",
    refresh: "Friss\xEDt\xE9s",
    filters: "Sz\u0171r\u0151k",
    lastWeek: "Elm\xFAlt h\xE9t",
    lastMonth: "Elm\xFAlt h\xF3nap",
    lastQuarter: "Elm\xFAlt negyed\xE9v",
    lastYear: "Elm\xFAlt \xE9v",
    startDate: "Kezd\u0151 d\xE1tum",
    endDate: "Z\xE1r\xF3 d\xE1tum",
    equipmentType: "G\xE9p t\xEDpusa",
    allTypes: "\xD6sszes t\xEDpus",
    clearFilters: "Sz\u0171r\u0151k t\xF6rl\xE9se",
    totalRentals: "\xD6sszes b\xE9rl\xE9s",
    activeRentals: "Akt\xEDv b\xE9rl\xE9sek",
    closedRentals: "Lez\xE1rt b\xE9rl\xE9sek",
    avgRentalTime: "\xC1tl. b\xE9rl\xE9si id\u0151",
    avgRevenuePerRental: "\xC1tl. bev\xE9tel/b\xE9rl\xE9s",
    overdue: "K\xE9sedelmes",
    rentalsByEquipmentType: "B\xE9rl\xE9sek g\xE9p t\xEDpus szerint",
    equipmentTypeCol: "G\xE9p t\xEDpusa",
    count: "Darabsz\xE1m",
    revenueCol: "Bev\xE9tel",
    ratioCol: "Ar\xE1ny",
    noDataForFilters: "Nincs adat a megadott sz\u0171r\xE9si felt\xE9telekhez.",
    errorLoading: "Hiba az adatok bet\xF6lt\xE9sekor.",
    retryButton: "\xDAjrapr\xF3b\xE1l\xE1s",
    comparedToPrevMonthShort: "el\u0151z\u0151 h\xF3naphoz",
    margin: {
      title: "\xC1rr\xE9s",
      byProduct: "Term\xE9kenk\xE9nt",
      byCategory: "Kateg\xF3ri\xE1nk\xE9nt",
      revenue: "Bev\xE9tel",
      cogs: "Beszerz\xE9si ktg.",
      marginAmount: "\xC1rr\xE9s (Ft)",
      marginPercent: "\xC1rr\xE9s (%)",
      exportCsv: "Export\xE1l\xE1s CSV",
      detailTable: "R\xE9szletes \xE1rr\xE9s kimutat\xE1s",
      productName: "Term\xE9k"
    }
  },
  kb: {
    title: "Tud\xE1sb\xE1zis kezel\xE9s",
    subtitle: "Cikkek l\xE9trehoz\xE1sa, szerkeszt\xE9se \xE9s t\xF6rl\xE9se",
    newArticle: "\xDAj cikk",
    loadingArticles: "Cikkek bet\xF6lt\xE9se...",
    noArticles: "Nincs cikk",
    createNewArticle: "\xDAj cikk l\xE9trehoz\xE1sa",
    editArticle: "Cikk szerkeszt\xE9se",
    articleTitle: "C\xEDm *",
    content: "Tartalom (Markdown) *",
    status: "St\xE1tusz",
    tags: "C\xEDmk\xE9k",
    addTag: "Hozz\xE1ad\xE1s",
    searchTitle: "Tud\xE1sb\xE1zis",
    searchPlaceholder: "Keressen a cikkek k\xF6z\xF6tt...",
    searchInKb: "Keres\xE9s a tud\xE1sb\xE1zisban...",
    noResults: "Nincs tal\xE1lat",
    tryOtherSearch: "Pr\xF3b\xE1lkozzon m\xE1s keres\u0151felt\xE9tellel",
    feedbackThanks: "K\xF6sz\xF6nj\xFCk a visszajelz\xE9st!",
    wasHelpful: "Hasznos volt ez a cikk?",
    helpful: "Hasznos volt",
    notHelpful: "Nem seg\xEDtett",
    helpfulCount: "hasznos",
    notHelpfulCount: "nem seg\xEDtett",
    statusDraft: "Piszkozat",
    statusPublished: "Publik\xE1lt",
    statusArchived: "Archiv\xE1lt",
    deleteButton: "T\xF6rl\xE9s",
    titlePlaceholder: "Cikk c\xEDme...",
    contentPlaceholder: "Cikk tartalma Markdown form\xE1tumban...",
    category: {
      berles: "B\xE9rl\xE9s",
      szerviz: "Szerviz",
      penzugy: "P\xE9nz\xFCgy",
      rendszer: "Rendszer",
      altalanos: "\xC1ltal\xE1nos"
    }
  },
  sms: {
    title: "SMS Be\xE1ll\xEDt\xE1sok",
    sendTab: "SMS k\xFCld\xE9s",
    historyTab: "T\xF6rt\xE9nelem",
    templatesTab: "Sablonok",
    phonePlaceholder: "Telefonsz\xE1m (+36...)",
    messagePlaceholder: "\xDCzenet sz\xF6vege (max 480 karakter)",
    charCount: "{count}/480 karakter",
    sending: "K\xFCld\xE9s...",
    send: "K\xFCld\xE9s",
    sentSuccess: "SMS sikeresen elk\xFCldve!",
    historyTitle: "SMS t\xF6rt\xE9nelem ({count} db)",
    noRecords: "Nincs SMS rekord.",
    directionOutbound: "Kimen\u0151",
    directionInbound: "Bej\xF6v\u0151",
    newTemplate: "\xDAj sablon",
    templateName: "Sablon n\xE9v",
    templateBody: "Sablon sz\xF6vege (v\xE1ltoz\xF3k: {gep}, {datum}, {idopont}, {ml_szam})",
    templateVariables: "V\xE1ltoz\xF3k (vessz\u0151kkel elv\xE1lasztva: gep,datum,idopont)",
    templateActive: "Akt\xEDv",
    templateSaving: "Ment\xE9s...",
    templateSave: "Sablon ment\xE9s",
    templatesTitle: "Sablonok ({count} db)",
    noTemplates: "Nincs sablon.",
    activeLabel: "Akt\xEDv",
    inactiveLabel: "Inakt\xEDv",
    typeCustom: "Egyedi",
    typeBookingConfirm: "Foglal\xE1s meger\u0151s\xEDt\xE9s",
    typeRentalExpiry: "B\xE9rl\xE9s lej\xE1r\xE1s",
    typeServiceReady: "Szerviz k\xE9sz",
    typeRentalReminder: "B\xE9rl\xE9s eml\xE9keztet\u0151",
    backToDashboard: "Vissza a f\u0151oldalra",
    dashboardTitle: "SMS K\xF6zpont",
    filterPending: "Feldolgozatlan",
    filterProcessed: "Feldolgozott",
    inboundTitle: "Bej\xF6v\u0151 \xFCzenetek",
    markProcessed: "Feldolgozottnak jel\xF6l\xE9s",
    noInboundMessages: "Nincs bej\xF6v\u0151 \xFCzenet",
    pendingFailed: "Sikertelen k\xFCld\xE9s",
    quickSend: "Gyors k\xFCld\xE9s",
    recentHistory: "Legut\xF3bbi el\u0151zm\xE9nyek",
    recognizedCommand: "Felismert parancs",
    selectTemplate: "Sablon kiv\xE1laszt\xE1sa",
    sentToday: "Ma k\xFCld\xF6tt",
    settingsLink: "SMS be\xE1ll\xEDt\xE1sok",
    statusPending: "F\xFCgg\u0151ben",
    statusProcessed: "Feldolgozva",
    successRate: "Sikeress\xE9gi ar\xE1ny",
    viewAll: "\xD6sszes megtekint\xE9se",
    viewRelated: "Kapcsol\xF3d\xF3 megtekint\xE9se"
  },
  ocr: {
    title: "Okm\xE1nyolvas\xF3 & C\xEDmke nyomtat\xE1s",
    subtitle: "IPEVO V4K dokumentumkamera + Zebra/Brother c\xEDmkenyomtat\xF3",
    scanTab: "Okm\xE1ny beolvas\xE1s",
    labelTab: "C\xEDmke nyomtat\xE1s",
    scanTitle: "Okm\xE1ny beolvas\xE1s (IPEVO V4K)",
    scanInstruction: "Helyezze az okm\xE1nyt a kamera al\xE1 \xE9s kattintson a beolvas\xE1s gombra.",
    scanButton: "Beolvas\xE1s ind\xEDt\xE1sa",
    scanning: "Beolvas\xE1s...",
    scanResults: "Beolvas\xE1si eredm\xE9nyek",
    noResults: "M\xE9g nincs beolvas\xE1si eredm\xE9ny.",
    labelTitle: "C\xEDmke gener\xE1l\xE1s",
    zebraLabel: "Zebra ZD 220 (43\xD726mm)",
    brotherLabel: "Brother QL-700 (50mm)",
    generateZebra: "Zebra c\xEDmke gener\xE1l\xE1s",
    generateBrother: "Brother c\xEDmke gener\xE1l\xE1s",
    generating: "Gener\xE1l\xE1s...",
    sku: "Cikksz\xE1m",
    productName: "Term\xE9kn\xE9v",
    price: "\xC1r (brutt\xF3)",
    pageTitle: "Okm\xE1nyolvas\xF3 & C\xEDmke nyomtat\xE1s",
    scanButtonLabel: "Okm\xE1ny beolvas\xE1s",
    scanSuccess: "Beolvas\xE1s sikeres!",
    nameLabel: "N\xE9v",
    documentNumberLabel: "Okm\xE1nysz\xE1m",
    confidenceLabel: "Megb\xEDzhat\xF3s\xE1g",
    productNamePlaceholder: "Term\xE9k neve",
    barcodePlaceholder: "Vonalk\xF3d",
    pricePlaceholder: "\xC1r (Ft)",
    skuPlaceholder: "SKU (opcion\xE1lis)",
    netPricePlaceholder: "Nett\xF3 \xE1r (Ft)",
    vatRatePlaceholder: "\xC1FA kulcs (%)",
    barcodeOptionalPlaceholder: "Vonalk\xF3d (opcion\xE1lis)",
    categoryPlaceholder: "Kateg\xF3ria (opcion\xE1lis)",
    generatingLabel: "Gener\xE1l\xE1s...",
    priceLabelGenerate: "\xC1rc\xEDmke gener\xE1l\xE1s",
    errorUnknown: "Ismeretlen hiba"
  },
  businessHours: {
    title: "Nyitvatart\xE1s & \xDCnnepnapok",
    subtitle: "Nyitvatart\xE1si id\u0151k, \xFCnnepnapok \xE9s kiv\xE9telek kezel\xE9se",
    weeklyTab: "Heti rend",
    holidaysTab: "\xDCnnepnapok",
    overridesTab: "Kiv\xE9telek",
    weeklySchedule: "Heti nyitvatart\xE1s",
    dayNames: {
      monday: "H\xE9tf\u0151",
      tuesday: "Kedd",
      wednesday: "Szerda",
      thursday: "Cs\xFCt\xF6rt\xF6k",
      friday: "P\xE9ntek",
      saturday: "Szombat",
      sunday: "Vas\xE1rnap"
    },
    dayShort: {
      monday: "H",
      tuesday: "K",
      wednesday: "Sze",
      thursday: "Cs",
      friday: "P",
      saturday: "Szo",
      sunday: "V"
    },
    open: "Nyitva",
    closed: "Z\xE1rva",
    openTime: "Nyit\xE1s",
    closeTime: "Z\xE1r\xE1s",
    holidayManagement: "\xDCnnepnap kezel\xE9s",
    newHoliday: "\xDAj \xFCnnepnap",
    holidayName: "\xDCnnepnap neve",
    holidayDate: "D\xE1tum",
    recurring: "Minden \xE9vben ism\xE9tl\u0151dik",
    noHolidays: "Nincs r\xF6gz\xEDtett \xFCnnepnap.",
    overrideManagement: "Kiv\xE9tel kezel\xE9s",
    newOverride: "\xDAj kiv\xE9tel",
    overrideDate: "D\xE1tum",
    overrideOpenTime: "Nyit\xE1s ideje",
    overrideCloseTime: "Z\xE1r\xE1s ideje",
    overrideClosed: "Z\xE1rva eg\xE9sz nap",
    overrideReason: "Indok",
    noOverrides: "Nincs r\xF6gz\xEDtett kiv\xE9tel.",
    saved: "Mentve!",
    everyYear: "Minden \xE9vben",
    pageTitle: "Nyitvatart\xE1s kezel\xE9se",
    pageSubtitle: "Heti nyitvatart\xE1s, \xFCnnepnapok \xE9s egyedi napok be\xE1ll\xEDt\xE1sa",
    weeklyScheduleTitle: "Heti nyitvatart\xE1s",
    defaultButton: "Alap\xE9rtelmezett",
    saveButton: "Ment\xE9s",
    savingButton: "Ment\xE9s...",
    savingSuccess: "Nyitvatart\xE1s sikeresen mentve!",
    resetSuccess: "Alap\xE9rtelmezettre \xE1ll\xEDtva!",
    loadingWeekly: "Nyitvatart\xE1s bet\xF6lt\xE9se...",
    dayColumn: "Nap",
    openColumn: "Nyitva",
    openingColumn: "Nyit\xE1s",
    closingColumn: "Z\xE1r\xE1s",
    hungHolidays: "Magyar \xFCnnepnapok",
    newHolidayButton: "\xDAj \xFCnnepnap",
    editHolidayTitle: "\xDCnnepnap szerkeszt\xE9se",
    newHolidayTitle: "\xDAj \xFCnnepnap",
    nameLabel: "N\xE9v",
    dateLabel: "D\xE1tum",
    namePlaceholder: "pl. Kar\xE1csony",
    recurringLabel: "\xC9vente ism\xE9tl\u0151d\u0151",
    cancelButton: "M\xE9gse",
    updateButton: "Friss\xEDt\xE9s",
    createButton: "L\xE9trehoz\xE1s",
    holidayUpdated: "\xDCnnepnap friss\xEDtve!",
    holidayCreated: "\xDCnnepnap l\xE9trehozva!",
    holidayDeleted: "\xDCnnepnap t\xF6r\xF6lve!",
    nationalSeeded: "nemzeti \xFCnnepnap bet\xF6ltve!",
    loadingHolidays: "\xDCnnepnapok bet\xF6lt\xE9se...",
    holidaysTitle: "\xDCnnepnapok",
    noHolidaysText: 'Nincsenek \xFCnnepnapok ebben az \xE9vben. Haszn\xE1ld a "Magyar \xFCnnepnapok" gombot a nemzeti \xFCnnepnapok bet\xF6lt\xE9s\xE9hez.',
    nameColumn: "N\xE9v",
    dateColumnHeader: "D\xE1tum",
    typeColumn: "T\xEDpus",
    actionsColumn: "M\u0171veletek",
    nationalBadge: "Nemzeti",
    recurringBadge: "Ism\xE9tl\u0151d\u0151",
    customBadge: "Egyedi",
    editButton: "Szerkeszt\xE9s",
    deleteButton: "T\xF6rl\xE9s",
    overridesTitle: "Egyedi napok (fel\xFCl\xEDr\xE1sok)",
    newOverrideButton: "\xDAj fel\xFCl\xEDr\xE1s",
    editOverrideTitle: "Fel\xFCl\xEDr\xE1s szerkeszt\xE9se",
    newOverrideTitle: "\xDAj fel\xFCl\xEDr\xE1s",
    overrideUpdated: "Fel\xFCl\xEDr\xE1s friss\xEDtve!",
    overrideCreated: "Fel\xFCl\xEDr\xE1s l\xE9trehozva!",
    overrideDeleted: "Fel\xFCl\xEDr\xE1s t\xF6r\xF6lve!",
    loadingOverrides: "Fel\xFCl\xEDr\xE1sok bet\xF6lt\xE9se...",
    noOverridesText: "Nincsenek egyedi nap fel\xFCl\xEDr\xE1sok.",
    statusColumn: "St\xE1tusz",
    timeColumn: "Id\u0151pont",
    reasonColumn: "Ok",
    reasonLabel: "Ok / megjegyz\xE9s",
    reasonPlaceholder: "pl. Rendk\xEDv\xFCli ny\xE1ri szombati nyitva tart\xE1s",
    openBadge: "Nyitva",
    closedBadge: "Z\xE1rva",
    tabWeekly: "Heti nyitvatart\xE1s",
    tabHolidays: "\xDCnnepnapok",
    tabOverrides: "Egyedi napok"
  },
  tenant: {
    title: "B\xE9rl\u0151i Admin",
    subtitle: "C\xE9gadatok \xE9s franchise kezel\xE9s",
    companyTab: "C\xE9g be\xE1ll\xEDt\xE1sok",
    franchiseTab: "Franchise \xE1ttekint\xE9s",
    basicData: "Alapadatok",
    storeName: "Bolt/telephely neve",
    companyName: "Hivatalos c\xE9gn\xE9v",
    taxNumber: "Ad\xF3sz\xE1m",
    registrationNumber: "C\xE9gjegyz\xE9ksz\xE1m",
    bankAccount: "Banksz\xE1mlasz\xE1m",
    contactInfo: "El\xE9rhet\u0151s\xE9gek",
    phoneNumber: "Telefonsz\xE1m",
    emailAddress: "Email c\xEDm",
    website: "Weboldal",
    address: "C\xEDm",
    franchiseStats: "Franchise statisztik\xE1k",
    totalStores: "\xD6sszes bolt",
    activeStores: "Akt\xEDv boltok",
    totalRevenue: "\xD6sszes\xEDtett bev\xE9tel",
    tenantTable: "Tenant lista",
    tenantName: "N\xE9v",
    tenantStatus: "St\xE1tusz",
    tenantPlan: "Csomag",
    tenantCreated: "L\xE9trehozva",
    bankName: "Bank neve",
    addressLabel: "C\xEDm",
    cityLabel: "V\xE1ros",
    postalCodeLabel: "Ir\xE1ny\xEDt\xF3sz\xE1m",
    phoneLabel: "Telefon",
    emailLabel: "Email",
    websiteLabel: "Weboldal",
    businessHoursTitle: "Nyitvatart\xE1s",
    openLabel: "Nyitva",
    closedLabel: "Z\xE1rva",
    brandingTitle: "Megjelen\xE9s",
    uploadLogo: "Felt\xF6lt\xE9s",
    primaryColor: "F\u0151 sz\xEDn",
    accentColor: "Kiemel\u0151 sz\xEDn",
    systemSettingsTitle: "Rendszer be\xE1ll\xEDt\xE1sok",
    currencyLabel: "P\xE9nznem",
    timezoneLabel: "Id\u0151z\xF3na",
    languageLabel: "Nyelv",
    vatRateLabel: "\xC1FA kulcs (%)",
    employees: "Alkalmazottak",
    activeWorksheets: "Akt\xEDv munkalapok",
    searchPlaceholder: "Keres\xE9s telephelyre, v\xE1rosra, tulajdonosra...",
    locationsTitle: "Telephelyek",
    locationColumn: "Telephely",
    ownerColumn: "Tulajdonos",
    monthlyRevenueColumn: "Havi bev\xE9tel",
    rentalsColumn: "B\xE9rl\xE9sek",
    worksheetsColumn: "Munkalapok",
    lastActivityColumn: "Utols\xF3 aktivit\xE1s",
    statusInactive: "Inakt\xEDv",
    statusSuspended: "Felf\xFCggesztett",
    currencyHUF: "HUF - Magyar Forint",
    currencyEUR: "EUR - Eur\xF3",
    employeesSuffix: "f\u0151"
  },
  chat: {
    title: "Chat",
    newConversation: "\xDAj besz\xE9lget\xE9s",
    you: "Te",
    noMessages: "Nincs \xFCzenet",
    participant: "r\xE9sztvev\u0151",
    participants: "r\xE9sztvev\u0151k",
    online: "Online",
    offline: "Offline",
    call: "H\xEDv\xE1s",
    info: "Inform\xE1ci\xF3",
    attachment: "Csatolm\xE1ny",
    messagePlaceholder: "\xCDrj \xFCzenetet...",
    sendButton: "K\xFCld\xE9s",
    selectConversation: "V\xE1lassz egy besz\xE9lget\xE9st",
    onlineColleagues: "Online koll\xE9g\xE1k",
    newChat: "\xDAj besz\xE9lget\xE9s",
    groupName: "Csoport neve (opcion\xE1lis)",
    selectParticipants: "R\xE9sztvev\u0151k kiv\xE1laszt\xE1sa",
    startConversation: "Besz\xE9lget\xE9s ind\xEDt\xE1sa",
    newButton: "+ \xDAj",
    selectOrStartNew: "V\xE1lassz ki egy megl\xE9v\u0151 besz\xE9lget\xE9st a bal oldalon, vagy ind\xEDts \xFAjat.",
    selected: "kiv\xE1lasztva",
    groupChat: "csoportos chat",
    writeMessage: "\xCDrj \xFCzenetet...",
    sendLabel: "K\xFCld\xE9s",
    groupNamePlaceholder: "Csoport neve...",
    minimize: "Minimaliz\xE1l\xE1s",
    openChat: "Chat megnyit\xE1sa"
  },
  modules: {
    title: "Modul be\xE1ll\xEDt\xE1sok",
    activeCount: "Akt\xEDv modul",
    inactiveCount: "Inakt\xEDv modul",
    totalCount: "\xD6sszes modul",
    mandatory: "K\xF6telez\u0151",
    saved: "Mentve!",
    categoryCore: "Alap",
    categorySales: "\xC9rt\xE9kes\xEDt\xE9s",
    categoryService: "Szerviz",
    categoryFinance: "P\xE9nz\xFCgyek",
    categoryIntegration: "Integr\xE1ci\xF3",
    moduleRental: "B\xE9rl\xE9s",
    moduleRentalDesc: "B\xE9rg\xE9p kiad\xE1s, visszav\xE9tel, d\xEDjsz\xE1m\xEDt\xE1s",
    moduleSales: "\xC9rt\xE9kes\xEDt\xE9s",
    moduleSalesDesc: "Term\xE9k \xE9rt\xE9kes\xEDt\xE9s, POS p\xE9nzt\xE1r",
    moduleService: "Szerviz",
    moduleServiceDesc: "Szerviz munkalap, jav\xEDt\xE1s, garancia",
    moduleInventory: "K\xE9szletkezel\xE9s",
    moduleInventoryDesc: "K\xE9szlet, lelt\xE1r, bev\xE9telez\xE9s",
    moduleInvoicing: "Sz\xE1ml\xE1z\xE1s",
    moduleInvoicingDesc: "Sz\xE1mla ki\xE1ll\xEDt\xE1s, NAV Online",
    modulePartners: "Partner kezel\xE9s",
    modulePartnersDesc: "\xDCgyfelek, besz\xE1ll\xEDt\xF3k",
    moduleQuotes: "\xC1raj\xE1nlat",
    moduleQuotesDesc: "Aj\xE1nlatok, konverzi\xF3k",
    moduleCash: "P\xE9nzt\xE1r",
    moduleCashDesc: "Kassza kezel\xE9s, vakz\xE1r\xE1s",
    moduleReporting: "Riportok",
    moduleReportingDesc: "KPI-k, kimutat\xE1sok",
    moduleChat: "Bels\u0151 chat",
    moduleChatDesc: "Koll\xE9g\xE1k k\xF6z\xF6tti kommunik\xE1ci\xF3",
    moduleBooking: "Online foglal\xE1s",
    moduleBookingDesc: "Weboldali g\xE9pfoglal\xE1s",
    moduleCrm: "CRM (Twenty)",
    moduleCrmDesc: "\xDCgyf\xE9lkapcsolat-kezel\xE9s",
    moduleHr: "HR (Horilla)",
    moduleHrDesc: "Emberi er\u0151forr\xE1s menedzsment",
    moduleVehicles: "J\xE1rm\u0171nyilv\xE1ntart\xE1s",
    moduleVehiclesDesc: "C\xE9ges \xE9s b\xE9relhet\u0151 j\xE1rm\u0171vek",
    moduleLoyalty: "VIP Lojalit\xE1s",
    moduleLoyaltyDesc: "H\u0171s\xE9gprogram, pontgy\u0171jt\xE9s",
    moduleSms: "SMS Gateway",
    moduleSmsDesc: "SMS k\xFCld\xE9s, sablonok",
    subtitle: "Rendszer modulok enged\xE9lyez\xE9se \xE9s tilt\xE1sa. A v\xE1ltoztat\xE1sok azonnali hat\xE1llyal \xE9rv\xE9nybe l\xE9pnek.",
    saveButton: "Ment\xE9s",
    activeLabel: "Akt\xEDv",
    inactiveLabel: "Inakt\xEDv",
    categoryLabels: {
      core: "Alapmodulok",
      domain: "\xDCzleti modulok",
      integration: "Integr\xE1ci\xF3k"
    },
    categoryDescriptions: {
      core: "A rendszer m\u0171k\xF6d\xE9s\xE9hez sz\xFCks\xE9ges alapmodulok. Nem kapcsolhat\xF3k ki.",
      domain: "\xDCzleti funkci\xF3k, amelyeket egyenk\xE9nt enged\xE9lyezhet vagy tilthat.",
      integration: "K\xFCls\u0151 rendszerek integr\xE1ci\xF3i."
    },
    moduleNames: {
      auth: "Hiteles\xEDt\xE9s (Auth)",
      tenant: "Multi-b\xE9rl\u0151i",
      audit: "Audit napl\xF3",
      rental: "B\xE9rl\xE9s modul",
      sales: "\xC9rt\xE9kes\xEDt\xE9s modul",
      service: "Szerviz modul",
      inventory: "K\xE9szletkezel\xE9s",
      quotation: "\xC1raj\xE1nlatkezel\xE9s",
      partners: "Partner kezel\xE9s",
      vehicles: "J\xE1rm\u0171nyilv\xE1ntart\xE1s",
      "nav-online": "NAV Online sz\xE1ml\xE1z\xE1s",
      mypos: "MyPOS fizet\xE9s",
      "szamlazz-hu": "Sz\xE1ml\xE1zz.hu",
      "twenty-crm": "Twenty CRM",
      chatwoot: "rPI Porter",
      "online-booking": "Online foglal\xE1s"
    },
    moduleDescriptions: {
      auth: "Felhaszn\xE1l\xF3i hiteles\xEDt\xE9s, JWT, PIN login, RBAC jogosults\xE1gkezel\xE9s.",
      tenant: "Franchise h\xE1l\xF3zat t\xE1mogat\xE1s, bolti szepar\xE1ci\xF3, RLS policy-k.",
      audit: "Tev\xE9kenys\xE9gellen\u0151rz\xE9s, GDPR megfelel\xE9s, retenci\xF3 kezel\xE9s.",
      rental: "B\xE9rg\xE9p kiad\xE1s, kauci\xF3 kezel\xE9s, hossz\xFA t\xE1v\xFA szerz\u0151d\xE9sek, k\xE9sedelmi d\xEDj.",
      sales: "Term\xE9k \xE9rt\xE9kes\xEDt\xE9s, POS termin\xE1l, NAV Online sz\xE1ml\xE1z\xE1s.",
      service: "Munkalap kezel\xE9s, garanci\xE1lis jav\xEDt\xE1s, alkatr\xE9sz katal\xF3gus.",
      inventory: "K\xE9szletnyilv\xE1ntart\xE1s, lelt\xE1r, bev\xE9telez\xE9s, rakt\xE1rk\xF6zi mozg\xE1s.",
      quotation: "\xC1rkalkul\xE1ci\xF3, konverzi\xF3 k\xF6vet\xE9s, PDF gener\xE1l\xE1s.",
      partners: "\xDCgyfelek, besz\xE1ll\xEDt\xF3k, kedvezm\xE9nyek, h\u0171s\xE9gprogram.",
      vehicles: "C\xE9ges \xE9s b\xE9relhet\u0151 j\xE1rm\u0171vek, dokumentumok.",
      "nav-online": "NAV Online Sz\xE1mla API integr\xE1ci\xF3ja (k\xF6telez\u0151en \xE9lesben).",
      mypos: "Fizet\xE9si kapu, kauci\xF3, k\xE1rty\xE1s fizet\xE9si lehet\u0151s\xE9g.",
      "szamlazz-hu": "Sz\xE1ml\xE1z\xF3 rendszer API integr\xE1ci\xF3ja.",
      "twenty-crm": "CRM rendszer integr\xE1ci\xF3ja \xFCgyf\xE9lkezel\xE9s t\xE1mogat\xE1s\xE1ra.",
      chatwoot: "\xDCgyf\xE9lszolg\xE1lati chat \xE9s t\xE1mogat\xE1s.",
      "online-booking": "Online szerviz \xE9s b\xE9rl\xE9s foglal\xE1si rendszer."
    }
  },
  notifications: {
    title: "\xC9rtes\xEDt\xE9si be\xE1ll\xEDt\xE1sok",
    matrix: "\xC9rtes\xEDt\xE9si m\xE1trix",
    role: "Szerepk\xF6r",
    totalCol: "\xD6ssz.",
    legend: "Jelmagyar\xE1zat",
    enabled: "\xC9rtes\xEDt\xE9s enged\xE9lyezve",
    disabled: "\xC9rtes\xEDt\xE9s tiltva",
    roleLabels: {
      admin: "Admin",
      manager: "Vezet\u0151",
      cashier: "P\xE9nzt\xE1ros",
      technician: "Szerel\u0151",
      salesRep: "\xC9rt\xE9kes\xEDt\u0151",
      warehouseWorker: "Rakt\xE1ros",
      accountant: "K\xF6nyvel\u0151",
      viewer: "Olvas\xF3"
    },
    domainLabels: {
      rental: "B\xE9rl\xE9s",
      service: "Szerviz",
      sales: "\xC9rt\xE9kes\xEDt\xE9s",
      inventory: "K\xE9szlet",
      finance: "P\xE9nz\xFCgy",
      partner: "Partner",
      system: "Rendszer",
      invoice: "Sz\xE1mla"
    },
    subtitle: "\xC1ll\xEDtsa be, mely szerepk\xF6r\xF6k milyen domain \xE9rtes\xEDt\xE9seket kapjanak.",
    matrixHint: "Kattintson egy cell\xE1ra az \xE9rtes\xEDt\xE9s be/kikapcsol\xE1s\xE1hoz. A sor/oszlop fejl\xE9cre kattintva az eg\xE9sz sort/oszlopot v\xE1ltoztathatja.",
    tipText: "Tipp: Kattintson a sor- vagy oszlopfejl\xE9cre az eg\xE9sz sor/oszlop egyszeri be/kikapcsol\xE1s\xE1hoz.",
    vehicle: {
      documentExpiring: {
        subject: "J\xE1rm\u0171 dokumentum lej\xE1r: {licensePlate} ({documentLabel})",
        title: "J\xE1rm\u0171 dokumentum hamarosan lej\xE1r",
        body: "A(z) {licensePlate} rendsz\xE1m\xFA j\xE1rm\u0171 {documentLabel} dokumentuma {daysUntilExpiry} nap m\xFAlva lej\xE1r ({expiryDate}). K\xE9rj\xFCk, int\xE9zkedjen a meg\xFAj\xEDt\xE1sr\xF3l id\u0151ben.",
        cta: "J\xE1rm\u0171 megnyit\xE1sa"
      },
      documentExpired: {
        subject: "LEJ\xC1RT j\xE1rm\u0171 dokumentum: {licensePlate} ({documentLabel})",
        title: "J\xE1rm\u0171 dokumentum LEJ\xC1RT",
        body: "A(z) {licensePlate} rendsz\xE1m\xFA j\xE1rm\u0171 {documentLabel} dokumentuma {daysOverdue} napja lej\xE1rt (lej\xE1rat: {expiryDate}). Lej\xE1rt dokumentummal a j\xE1rm\u0171 nem haszn\xE1lhat\xF3 jogszer\u0171en \u2014 azonnali int\xE9zked\xE9s sz\xFCks\xE9ges.",
        cta: "J\xE1rm\u0171 megnyit\xE1sa"
      },
      documentTypes: {
        REGISTRATION: "forgalmi enged\xE9ly",
        TECHNICAL_INSPECTION: "m\u0171szaki vizsga",
        KGFB_INSURANCE: "k\xF6telez\u0151 biztos\xEDt\xE1s (KGFB)",
        CASCO_INSURANCE: "CASCO biztos\xEDt\xE1s",
        HIGHWAY_STICKER: "p\xE1lyamatrica"
      }
    },
    partner: {
      loyaltyReward: {
        subject: "\xDAj h\u0171s\xE9gprogram jutalom \u2014 {partnerName}",
        title: "H\u0171s\xE9gprogram jutalom feloldva",
        body: "Kedves {partnerName}, \xFAj jutalom \xE9rhet\u0151 el a h\u0171s\xE9gprogramban: {rewardName}. L\xE1togass be hozz\xE1nk a bev\xE1lt\xE1shoz.",
        cta: "Jutalom megtekint\xE9se"
      }
    },
    marketing: {
      seasonal: {
        subject: "{campaignName} \u2014 szezon\xE1lis aj\xE1nlat",
        title: "{campaignName}",
        body: "{campaignBody} V\xE1laszolj STOP-pal a leiratkoz\xE1shoz.",
        cta: "Aj\xE1nlat megtekint\xE9se"
      }
    },
    types: {
      vehicle: {
        document: {
          expiring: {
            label: "J\xE1rm\u0171 dokumentum lej\xE1r",
            description: "J\xE1rm\u0171 forgalmi/m\u0171szaki/biztos\xEDt\xE1s dokumentum k\xF6zelg\u0151 lej\xE1rata."
          },
          expired: {
            label: "J\xE1rm\u0171 dokumentum LEJ\xC1RT",
            description: "Lej\xE1rt j\xE1rm\u0171 dokumentum \u2014 jogi felel\u0151ss\xE9g, azonnali int\xE9zked\xE9s sz\xFCks\xE9ges."
          }
        },
        service: {
          due: {
            label: "J\xE1rm\u0171 szerviz esed\xE9kes",
            description: "\xDCtemezett karbantart\xE1s k\xF6zeleg (km vagy d\xE1tum alapj\xE1n)."
          }
        }
      },
      rental: {
        overdue: {
          label: "Lej\xE1rt b\xE9rl\xE9s",
          description: "A b\xE9rl\u0151 nem hozta vissza az eszk\xF6zt a szerz\u0151d\xF6tt v\xE9ghat\xE1rid\u0151re."
        },
        return: {
          reminder: {
            label: "Visszahozatali eml\xE9keztet\u0151",
            description: "B\xE9rl\xE9s v\xE9ge k\xF6zeleg (24-72 \xF3ra) \u2014 eml\xE9keztet\u0151 kik\xFCld\xE9se."
          }
        },
        contract: {
          signed: {
            label: "B\xE9rleti szerz\u0151d\xE9s al\xE1\xEDrva",
            description: "Elektronikus al\xE1\xEDr\xE1s megt\xF6rt\xE9nt a b\xE9rleti szerz\u0151d\xE9sen."
          }
        }
      },
      service: {
        worksheet: {
          ready: {
            label: "Munkalap elk\xE9sz\xFClt",
            description: "A szerviz munkalap k\xE9sz \xE1llapotba ker\xFClt \u2014 \xFCgyf\xE9l \xE9rtes\xEDt\xE9se."
          }
        },
        warranty: {
          expiring: {
            label: "Garancia hamarosan lej\xE1r",
            description: "Akt\xEDv garancia lej\xE1rata k\xF6zeleg."
          }
        }
      },
      sales: {
        invoice: {
          issued: {
            label: "\xDAj sz\xE1mla ki\xE1ll\xEDtva",
            description: "Sz\xE1mla lett ki\xE1ll\xEDtva \xE9s NAV fel\xE9 jelentve."
          }
        },
        deliveryNote: {
          signed: {
            label: "Sz\xE1ll\xEDt\xF3lev\xE9l al\xE1\xEDrva",
            description: "Sz\xE1ll\xEDt\xF3lev\xE9l elektronikus al\xE1\xEDr\xE1ssal lez\xE1rva."
          }
        }
      },
      finance: {
        payment: {
          overdue: {
            label: "Sz\xE1mla lej\xE1rt",
            description: "Vev\u0151nek ki\xE1ll\xEDtott sz\xE1mla lej\xE1rt \u2014 behajt\xE1si folyamat induljon."
          }
        },
        "cash-close": {
          due: {
            label: "Napi p\xE9nzt\xE1rz\xE1r\xE1s esed\xE9kes",
            description: "A napi kassza z\xE1r\xE1s operat\xEDv hat\xE1rid\u0151vel k\xF6telez\u0151."
          }
        }
      },
      workflow: {
        approval: {
          requested: {
            label: "J\xF3v\xE1hagy\xE1s sz\xFCks\xE9ges",
            description: "Egy workflow fut\xE1s j\xF3v\xE1hagy\xE1si pontba \xE9rt."
          }
        },
        execution: {
          failed: {
            label: "Workflow fut\xE1s sikertelen",
            description: "Egy @kgc/workflow fut\xE1s termin\xE1lisan hib\xE1ra futott."
          }
        }
      },
      documents: {
        hash: {
          mismatch: {
            label: "Dokumentum integrit\xE1s hiba",
            description: "Hash integrit\xE1s ellen\u0151rz\xE9s elt\xE9r\xE9st tal\xE1lt \u2014 lehets\xE9ges manipul\xE1ci\xF3."
          }
        },
        retention: {
          expired: {
            label: "Dokumentum retention lej\xE1rt",
            description: "A GDPR retention id\u0151 lej\xE1rt, a dokumentum t\xF6r\xF6lve."
          }
        }
      },
      partner: {
        blocklisted: {
          label: "Partner szankci\xF3s list\xE1n",
          description: "A partner AML / szankci\xF3s list\xE1ra ker\xFClt \u2014 blokkol\xE1s aktiv\xE1lva."
        },
        loyaltyReward: {
          label: "H\u0171s\xE9gprogram jutalom",
          description: "\xDAj h\u0171s\xE9gprogram jutalom el\xE9rhet\u0151 \u2014 hozz\xE1j\xE1rul\xE1s-alap\xFA marketing \xE9rtes\xEDt\xE9s (E-93)."
        }
      },
      marketing: {
        seasonal: {
          label: "Szezon\xE1lis aj\xE1nlat",
          description: "Id\u0151szakos marketing kamp\xE1ny \u2014 explicit hozz\xE1j\xE1rul\xE1s k\xF6telez\u0151 (E-93 ADR-109 J-1)."
        }
      }
    }
  },
  featureFlags: {
    title: "Funkci\xF3 kapcsol\xF3k",
    subtitle: "Funkci\xF3k be- \xE9s kikapcsol\xE1sa",
    saveChanges: "V\xE1ltoz\xE1sok ment\xE9se",
    totalFlags: "\xD6sszes flag",
    enabledFlags: "Bekapcsolva",
    disabledFlags: "Kikapcsolva",
    newBadge: "\xDAJ",
    betaBadge: "BETA",
    updatedAt: "Friss\xEDtve: {date}",
    dependsOn: "F\xFCgg: {flags}",
    allCategories: "Minden kateg\xF3ria",
    enabledOnly: "Csak bekapcsolt",
    disabledOnly: "Csak kikapcsolt",
    searchPlaceholder: "Keres\xE9s...",
    infoText: "A feature flag-ek az alkalmaz\xE1s funkci\xF3inak be- \xE9s kikapcsol\xE1s\xE1t teszik lehet\u0151v\xE9. Egyes funkci\xF3k m\xE1s funkci\xF3kt\xF3l f\xFCgghetnek.",
    saved: "Mentve!",
    allLabel: "Mind",
    noResults: "Nincs tal\xE1lat a megadott sz\u0171r\u0151kkel",
    searchPlaceholderLong: "Keres\xE9s (n\xE9v, le\xEDr\xE1s, kulcs)...",
    usageTitle: "Feature Flags haszn\xE1lata",
    usageDescription: "A feature flags-ek lehet\u0151v\xE9 teszik funkci\xF3k be- \xE9s kikapcsol\xE1s\xE1t az alkalmaz\xE1sban. N\xE9h\xE1ny flag f\xFCgghet m\xE1sik flag-t\u0151l - ezek csak akkor kapcsolhat\xF3k be, ha a f\xFCgg\u0151s\xE9g akt\xEDv. A BETA jel\xF6l\xE9s\u0171 funkci\xF3k m\xE9g tesztel\xE9s alatt \xE1llnak.",
    dependencyDisabled: "F\xFCgg\u0151s\xE9g nincs bekapcsolva",
    totalLabel: "\xD6sszes flag"
  },
  equipmentProfit: {
    profitable: "Nyeres\xE9ges",
    lossmaking: "Vesztes\xE9ges",
    breakeven: "Nullszald\xF3s",
    missingData: "Hi\xE1nyos adat",
    rentalCancelled: "Visszamondott",
    roi: "Megt\xE9r\xFCl\xE9s",
    purchasePrice: "V\xE9tel\xE1r",
    rentalRevenue: "B\xE9rleti bev\xE9tel",
    serviceCost: "Szerviz k\xF6lts\xE9g",
    profit: "Profit",
    rentalHistory: "B\xE9rl\xE9si el\u0151zm\xE9nyek",
    noRentalHistory: "Nincs b\xE9rl\xE9si el\u0151zm\xE9ny.",
    ongoing: "folyamatban",
    loadError: "Hiba a megt\xE9r\xFCl\xE9si adatok bet\xF6lt\xE9sekor."
  },
  ws: {
    connected: "WebSocket: Csatlakozva",
    connecting: "WebSocket: Csatlakoz\xE1s...",
    reconnecting: "WebSocket: \xDAjracsatlakoz\xE1s...",
    disconnected: "WebSocket: Kapcsolat megszakadt",
    clickToReconnect: "Kattints az \xFAjracsatlakoz\xE1shoz"
  },
  serviceHistory: {
    close: "Bez\xE1r\xE1s",
    issue: "Hiba",
    laborCost: "Munkad\xEDj",
    loadError: "Hiba t\xF6rt\xE9nt az adatok bet\xF6lt\xE9sekor",
    loading: "Bet\xF6lt\xE9s...",
    noHistory: "Nincs szerviz el\u0151zm\xE9ny",
    partsCost: "Alkatr\xE9sz",
    resolution: "Megold\xE1s",
    title: "Szerviz el\u0151zm\xE9ny",
    totalCost: "\xD6sszes k\xF6lts\xE9g",
    totalServices: "\xD6sszes szerviz",
    unknownError: "Ismeretlen hiba",
    warranty: "Garanci\xE1lis",
    warrantyBadge: "Garancia",
    serialNumber: "Sorozatsz\xE1m: {serial}",
    statusDraft: "V\xE1zlat",
    statusDiagnosed: "Diagnosztiz\xE1lt",
    statusInProgress: "Folyamatban",
    statusWaitingParts: "Alkatr\xE9szre v\xE1r",
    statusCompleted: "Befejezett",
    statusClosed: "Lez\xE1rt"
  },
  stockDetail: {
    availableInPhase2: "Funkci\xF3 Phase 2-ben \xE9rhet\u0151 el",
    avgMonthlyUsage: "\xC1tlagos felhaszn\xE1l\xE1s/h\xF3",
    close: "Bez\xE1r\xE1s",
    critical: "Kritikus",
    currentStock: "Aktu\xE1lis k\xE9szlet",
    description: "K\xE9szlet r\xE9szletek \xE9s beszerz\xE9si javaslat",
    lastPurchase: "Utols\xF3 beszerz\xE9s",
    minimumThreshold: "Minimum k\xFCsz\xF6b",
    model: "Modell",
    movementHistory30d: "Mozg\xE1si el\u0151zm\xE9nyek (30 nap)",
    purchaseHistory: "Beszerz\xE9si el\u0151zm\xE9nyek",
    purchaseRecommendation: "Beszerz\xE9si javaslat",
    recommendedPurchase: "Javasolt beszerz\xE9s: {quantity} g\xE9p (a minimum {threshold}-ra emel\xE9shez)",
    serialNumber: "Sorozatsz\xE1m",
    status: "St\xE1tusz",
    tabInfo: "Inform\xE1ci\xF3",
    tabMovement: "Mozg\xE1si el\u0151zm\xE9nyek",
    type: "T\xEDpus",
    warning: "Figyelmeztet\xE9s",
    quantity: "Mennyis\xE9g: {count} db",
    unitCount: "{count} db"
  },
  widget: {
    permissions: {
      title: "Dashboard Widget Jogosults\xE1gok",
      description: "\xC1ll\xEDtsd be, melyik szerepk\xF6r melyik dashboard widgetet l\xE1thassa",
      loadError: "Hiba t\xF6rt\xE9nt a bet\xF6lt\xE9s sor\xE1n",
      unknownError: "Ismeretlen hiba",
      retry: "\xDAjrapr\xF3b\xE1l\xE1s",
      matrixTitle: "Widget M\xE1trix",
      matrixDescription: "Az Admin szerepk\xF6r mindig l\xE1tja az \xF6sszes widgetet \xE9s nem m\xF3dos\xEDthat\xF3.",
      resetToDefaults: "Vissza\xE1ll\xEDt\xE1s alap\xE9rtelmezettre",
      cancel: "M\xE9gse",
      pendingChanges: "{count} m\xF3dos\xEDt\xE1s ment\xE9sre v\xE1r",
      saving: "Ment\xE9s...",
      save: "Ment\xE9s",
      saveError: "Hiba t\xF6rt\xE9nt a ment\xE9s sor\xE1n",
      resetError: "Hiba t\xF6rt\xE9nt a vissza\xE1ll\xEDt\xE1s sor\xE1n",
      resetConfirmTitle: "Vissza\xE1ll\xEDt\xE1s meger\u0151s\xEDt\xE9se",
      resetConfirmDescription: "Biztosan vissza\xE1ll\xEDtod az alap\xE9rtelmezett jogosults\xE1gokat? Ez t\xF6rli az \xF6sszes egyedi be\xE1ll\xEDt\xE1st.",
      resetting: "Vissza\xE1ll\xEDt\xE1s...",
      reset: "Vissza\xE1ll\xEDt\xE1s"
    },
    cardExpiry: {
      title: "K\xE1rtya Lej\xE1rat",
      ariaLabel: "K\xE1rtya lej\xE1rat figyel\xE9s",
      loading: "K\xE1rtya lej\xE1rat bet\xF6lt\xE9se...",
      errorTitle: "Hiba t\xF6rt\xE9nt",
      errorMessage: "Nem siker\xFClt bet\xF6lteni a k\xE1rtya lej\xE1rat adatokat.",
      alertCount: "figyelmeztet\xE9s",
      noAlerts: "Nincs lej\xE1r\xF3 k\xE1rtya figyelmeztet\xE9s.",
      urgent: "S\xFCrg\u0151s",
      warning: "Figyelmeztet\xE9s",
      info: "Inform\xE1ci\xF3",
      expiredToday: "Ma lej\xE1rt",
      expiresToday: "Ma lej\xE1r",
      expiredDaysAgo: "{days} napja lej\xE1rt",
      expiresInDays: "{days} nap m\xFAlva lej\xE1r",
      deposit: "Kauci\xF3",
      newCard: "\xDAj k\xE1rtya",
      newCardRequest: "\xDAj k\xE1rtya k\xE9r\xE9s: {partner}",
      newCardStarted: "\xDAj k\xE1rtya k\xE9r\xE9s ind\xEDtva",
      alertListAria: "{count} k\xE1rtya lej\xE1rat figyelmeztet\xE9s"
    },
    equipmentProfit: {
      title: "B\xE9rg\xE9p Megt\xE9r\xFCl\xE9s",
      loadError: "Hiba az adatok bet\xF6lt\xE9sekor.",
      avgRoi: "\xC1tl. ROI",
      totalRevenue: "\xD6sszes bev\xE9tel",
      totalCosts: "\xD6sszes k\xF6lts\xE9g",
      totalProfit: "\xD6sszes profit",
      totalEquipment: "\xD6sszes g\xE9p",
      profitable: "Nyeres\xE9ges",
      losing: "Vesztes\xE9ges",
      topFive: "Top 5 Legj\xF6vedelmez\u0151bb"
    },
    forecast: {
      title: "Bev\xE9tel el\u0151rejelz\xE9s",
      ariaLabel: "Bev\xE9tel el\u0151rejelz\xE9s",
      loading: "Bev\xE9tel el\u0151rejelz\xE9s bet\xF6lt\xE9se...",
      error: "Hiba t\xF6rt\xE9nt",
      errorDescription: "Nem siker\xFClt bet\xF6lteni a bev\xE9tel el\u0151rejelz\xE9st.",
      comparedToPreviousMonth: "el\u0151z\u0151 h\xF3naphoz k\xE9pest",
      sourceBreakdown: "Forr\xE1s szerinti bont\xE1s",
      previousMonthActual: "El\u0151z\u0151 h\xF3nap t\xE9nyleges",
      sourcePercentage: "{source} ({percentage}%)",
      expectedRevenue: "V\xE1rhat\xF3 Bev\xE9tel"
    },
    partnerActivity: {
      title: "Partner aktivit\xE1s",
      expandedTitle: "Partner Aktivit\xE1s",
      refresh: "Friss\xEDt\xE9s",
      transactions: "tranzakci\xF3",
      totalTransactions: "\xD6sszes tranzakci\xF3",
      vsPrevious: "vs el\u0151z\u0151 id\u0151szak",
      rental: "B\xE9rl\xE9s",
      rentals: "B\xE9rl\xE9sek",
      sales: "Elad\xE1s",
      salesPlural: "Elad\xE1sok",
      service: "Szerviz",
      date: "D\xE1tum",
      totalColumn: "\xD6sszesen"
    },
    partnerOverview: {
      title: "Partner \xF6sszes\xEDt\xE9s",
      refresh: "Friss\xEDt\xE9s",
      last30Days: "(30 nap)",
      activePartners: "akt\xEDv partner",
      categoryRetail: "Lakoss\xE1gi",
      categoryB2B: "C\xE9ges",
      categoryVIP: "Kiemelt"
    },
    receivables: {
      title: "Kintl\xE9v\u0151s\xE9g Aging",
      reportTitle: "Kintl\xE9v\u0151s\xE9g Aging Report",
      totalReceivables: "\xD6sszes kintl\xE9v\u0151s\xE9g",
      bucket0_30: "0-30 nap",
      bucket31_60: "31-60 nap",
      bucket61_90: "61-90 nap",
      bucket90plus: "90+ nap",
      invoices: "sz\xE1mla",
      topDebtors: "Top 3 Ad\xF3s",
      moreDebtors: "tov\xE1bbi ad\xF3s",
      noReceivables: "Nincs kintl\xE9v\u0151s\xE9g",
      loadError: "Hiba az adatok bet\xF6lt\xE9sekor.",
      updatedAt: "Friss\xEDtve",
      total: "\xD6sszesen",
      partnersOwe: "partner tartozik",
      agingBreakdown: "Aging koroszt\xE1ly bont\xE1s",
      ofTotal: "az \xF6sszesb\u0151l",
      allDebtors: "\xD6sszes Ad\xF3s",
      partner: "Partner",
      debt: "Tartoz\xE1s",
      invoicesHeader: "Sz\xE1ml\xE1k",
      oldestDueDate: "Legr\xE9gebbi lej\xE1rat",
      overdue: "K\xE9sedelem",
      pcs: "db",
      days: "nap"
    },
    recurringIssues: {
      title: "Visszat\xE9r\u0151 hib\xE1k",
      refresh: "Friss\xEDt\xE9s",
      problematicEquipment: "probl\xE9m\xE1s g\xE9p",
      critical: "kritikus",
      noIssues: "Nincs visszat\xE9r\u0151 hiba",
      viewServiceHistory: "{name} szerviz el\u0151zm\xE9nyeinek megtekint\xE9se",
      lastService: "Utols\xF3 szerviz",
      more: "tov\xE1bb"
    },
    rentalStats: {
      title: "B\xE9rl\xE9si Statisztika",
      ariaLabel: "B\xE9rl\xE9si Statisztika",
      loading: "B\xE9rl\xE9si statisztika bet\xF6lt\xE9se...",
      error: "Hiba t\xF6rt\xE9nt",
      errorDescription: "Nem siker\xFClt bet\xF6lteni a b\xE9rl\xE9si statisztik\xE1t.",
      daysPerRental: "nap / b\xE9rl\xE9s",
      comparedToPreviousPeriod: "el\u0151z\u0151 id\u0151szakhoz k\xE9pest",
      totalRentals: "\xD6sszes b\xE9rl\xE9s",
      active: "Akt\xEDv",
      overdue: "Lej\xE1rt"
    },
    seasonality: {
      title: "Szezon\xE1lis Trend",
      titleShort: "B\xE9rl\xE9si Trend (12 h\xF3nap)",
      ariaLabel: "Szezon\xE1lis Trend",
      loading: "Szezon\xE1lis trend bet\xF6lt\xE9se...",
      error: "Hiba t\xF6rt\xE9nt",
      errorDescription: "Nem siker\xFClt bet\xF6lteni a szezon\xE1lis trendet.",
      noData: "M\xE9g nincs elegend\u0151 adat a trend megjelen\xEDt\xE9s\xE9hez.",
      rentals: "B\xE9rl\xE9sek",
      revenue: "Bev\xE9tel",
      revenueFt: "Bev\xE9tel (Ft)",
      totalRentals: "\xD6sszes b\xE9rl\xE9s:",
      totalRevenue: "\xD6sszes bev\xE9tel:",
      pcs: "db"
    },
    serviceProfit: {
      title: "Szerviz Profitabilit\xE1s",
      loading: "Bet\xF6lt\xE9s...",
      loadError: "Hiba az adatok bet\xF6lt\xE9sekor.",
      avgMargin: "\xC1tl. \xE1rr\xE9s",
      totalRevenue: "\xD6sszes bev\xE9tel",
      partsCost: "Alkatr\xE9sz k\xF6lts\xE9g",
      netProfit: "Nett\xF3 profit",
      worksheets: "Munkalapok",
      laborRevenue: "Munkad\xEDj",
      topFiveTechnicians: "Top 5 Szerel\u0151 (Profit)",
      worksheet: "munkalap",
      margin: "\xE1rr\xE9s",
      noData: "Nincs szerel\u0151 profit adat ebben az id\u0151szakban."
    },
    serviceRevenue: {
      title: "Szerviz bev\xE9tel",
      periodSelect: "Id\u0151szak v\xE1laszt\xE1s",
      refresh: "Friss\xEDt\xE9s",
      periodDay: "Ma",
      periodWeek: "H\xE9t",
      periodMonth: "H\xF3nap",
      laborFee: "Munkad\xEDj",
      parts: "Alkatr\xE9sz"
    },
    stockAlert: {
      title: "K\xE9szlethi\xE1ny Alertek",
      noShortage: "Nincs k\xE9szlethi\xE1ny",
      allProductsAdequate: "Minden term\xE9k megfelel\u0151 k\xE9szletszinten",
      totalAlerts: "\xD6sszes alert",
      critical: "Kritikus",
      warning: "Figyelmeztet\xE9s",
      criticalShortages: "Kritikus K\xE9szlethi\xE1nyok",
      warnings: "Figyelmeztet\xE9sek",
      model: "Modell",
      type: "T\xEDpus",
      current: "Jelenlegi",
      minimum: "Minimum",
      shortage: "Hi\xE1ny",
      lastOrder: "Utols\xF3 rendel\xE9s",
      status: "St\xE1tusz"
    },
    stockHeatmap: {
      title: "K\xE9szlet H\u0151t\xE9rk\xE9p",
      description: "K\xE9szlet eloszl\xE1s g\xE9pt\xEDpus \xE9s lok\xE1ci\xF3 szerint"
    },
    stockMovement: {
      title: "K\xE9szlet Mozg\xE1sok",
      subtitle: "K\xE9szlet mozg\xE1sok - utols\xF3 30 nap",
      refresh: "Friss\xEDt\xE9s",
      incoming: "Bej\xF6v\u0151",
      outgoing: "Kimen\u0151",
      returns: "Visszavett",
      netChange: "Nett\xF3 v\xE1ltoz\xE1s"
    },
    techWorkload: {
      title: "Szerel\u0151 Terhel\xE9s",
      refresh: "Friss\xEDt\xE9s",
      worksheetsOf: "munkalapjai",
      more: "tov\xE1bbi",
      moreTechnicians: "tov\xE1bbi szerel\u0151",
      totalTechnicians: "\xD6sszes szerel\u0151",
      active: "akt\xEDv",
      activeWorksheets: "Akt\xEDv munkalapok",
      noActiveWorksheets: "Nincs akt\xEDv munkalap",
      priority: {
        low: "Alacsony",
        normal: "Norm\xE1l",
        high: "Magas",
        urgent: "S\xFCrg\u0151s"
      }
    },
    topPartners: {
      title: "Top partnerek",
      expandedTitle: "Top Partnerek",
      periodMonth: "H\xF3nap",
      periodQuarter: "Negyed\xE9v",
      periodYear: "\xC9v",
      periodSelect: "Id\u0151szak v\xE1laszt\xE1s",
      refresh: "Friss\xEDt\xE9s",
      giftEligible: "Aj\xE1nd\xE9kra jogosult",
      morePartners: "tov\xE1bbi partner",
      period: "Id\u0151szak",
      partner: "Partner",
      totalRevenue: "\xD6ssz. bev\xE9tel",
      rental: "B\xE9rl\xE9s",
      sales: "Elad\xE1s",
      service: "Szerviz"
    },
    vat: {
      title: "\xC1FA \xD6sszes\xEDt\u0151",
      ariaLabel: "\xC1FA \xF6sszes\xEDt\u0151",
      loading: "\xC1FA \xF6sszes\xEDt\u0151 bet\xF6lt\xE9se...",
      errorTitle: "Hiba t\xF6rt\xE9nt",
      errorMessage: "Nem siker\xFClt bet\xF6lteni az \xC1FA \xF6sszes\xEDt\u0151t.",
      payable: "Fizetend\u0151 \xC1FA",
      claimable: "Visszaig\xE9nyelhet\u0151 \xC1FA",
      outputVat: "Felsz\xE1m\xEDtott",
      inputVat: "Levonhat\xF3",
      rateBreakdown: "Kulcsonk\xE9nti bont\xE1s"
    },
    warranty: {
      title: "Garanci\xE1lis ar\xE1ny",
      refresh: "Friss\xEDt\xE9s",
      warranty: "Garanci\xE1lis",
      paid: "Fizet\u0151s",
      repairs: "jav\xEDt\xE1s",
      paidRevenue: "Fizet\u0151s bev\xE9tel",
      sixMonthTrend: "6 h\xF3 trend",
      trendUp: "n\u0151",
      trendDown: "cs\xF6kken",
      trendStable: "stabil"
    },
    worksheet: {
      title: "Munkalapok",
      refresh: "Friss\xEDt\xE9s",
      activeWorksheets: "akt\xEDv munkalap",
      status: {
        draft: "V\xE1zlat",
        diagnosed: "Diagnosztiz\xE1lt",
        inProgress: "Folyamatban",
        waitingParts: "Alkatr\xE9szre v\xE1r",
        completed: "Befejezett",
        closed: "Lez\xE1rt"
      }
    },
    emptyState: {
      message: "Nincs megjelen\xEDthet\u0151 widget",
      hint: "K\xE9rd a rendszergazd\xE1t",
      defaultMessage: "Nincs megjelen\xEDthet\u0151 adat",
      defaultHint: "Pr\xF3b\xE1ljon meg m\xE1s sz\u0171r\u0151felt\xE9teleket haszn\xE1lni."
    },
    partnerCredit: {
      comingSoon: "Hamarosan...",
      featureInProgress: "Feature enabled - implement\xE1ci\xF3 folyamatban",
      managementLabel: "Partner hitelkeret kezel\xE9s",
      title: "Partner hitelkeret",
      tooltipDescription: "Partner hitelkeret kezel\xE9s - k\xE9s\u0151bbi epic-ben"
    },
    popularEquipment: {
      ariaLabel: "N\xE9pszer\u0171 g\xE9pek",
      error: "Hiba t\xF6rt\xE9nt",
      errorDescription: "Nem siker\xFClt bet\xF6lteni a n\xE9pszer\u0171 g\xE9peket.",
      loading: "N\xE9pszer\u0171 g\xE9pek bet\xF6lt\xE9se...",
      noData: "M\xE9g nincs elegend\u0151 b\xE9rl\xE9si adat.",
      rentalCount: "{count} b\xE9rl\xE9s",
      title: "N\xE9pszer\u0171 G\xE9pek",
      top5Title: "Top 5 N\xE9pszer\u0171 G\xE9p",
      top5Total: "Top 5 \xF6sszesen"
    },
    warrantyPlaceholder: {
      comingSoon: "Hamarosan...",
      epicInfo: "Epic 38-ban implement\xE1lva",
      ratioLabel: "Garanci\xE1lis vs fizet\u0151s ar\xE1ny",
      title: "Garanci\xE1lis ar\xE1ny",
      tooltipDescription: "Garanci\xE1lis vs fizet\u0151s ar\xE1ny - Epic 38-ban"
    },
    error: {
      loadError: "Hiba t\xF6rt\xE9nt az adatok bet\xF6lt\xE9se sor\xE1n",
      errorTitle: "Widget bet\xF6lt\xE9si hiba",
      retry: "\xDAjra"
    },
    alert: {
      details: "R\xE9szletek"
    },
    stock: {
      critical: "Kritikus",
      warning: "Figyelmeztet\xE9s"
    }
  },
  integration: {
    crm: {
      errorDescription: "A Twenty CRM szolg\xE1ltat\xE1s nem el\xE9rhet\u0151, vagy a b\xF6ng\xE9sz\u0151 blokkolja az iframe bet\xF6lt\xE9s\xE9t.",
      loading: "Twenty CRM bet\xF6lt\xE9se...",
      subtitle: "\xDCgyf\xE9lkapcsolat kezel\xE9s"
    },
    hr: {
      errorDescription: "A Horilla HR szolg\xE1ltat\xE1s nem el\xE9rhet\u0151, vagy a b\xF6ng\xE9sz\u0151 blokkolja az iframe bet\xF6lt\xE9s\xE9t.",
      loading: "Horilla HR bet\xF6lt\xE9se...",
      subtitle: "Hum\xE1ner\u0151forr\xE1s menedzsment"
    },
    flow: {
      errorDescription: "Az rPI Flow nem el\xE9rhet\u0151.",
      loading: "rPI Flow bet\xF6lt\xE9se...",
      subtitle: "Workflow ind\xEDt\xE1s \xE9s k\xF6vet\xE9s",
      unavailable: "Az rPI Flow nincs konfigur\xE1lva ezen a szerveren.",
      publishedWorkflows: "El\xE9rhet\u0151 munkafolyamatok",
      noWorkflows: "Nincs regisztr\xE1lt munkafolyamat",
      recentExecutions: "Legut\xF3bbi v\xE9grehajt\xE1sok",
      noExecutions: "Nincs akt\xEDv v\xE9grehajt\xE1s",
      steps: "l\xE9p\xE9s",
      tabs: {
        catalog: "Katal\xF3gus",
        running: "Fut\xF3",
        history: "T\xF6rt\xE9net",
        approvals: "J\xF3v\xE1hagy\xE1s",
        operations: "M\u0171veletek"
      },
      running: {
        noExecutions: "Nincs fut\xF3 munkafolyamat",
        startOne: "Ind\xEDts egyet \u2192",
        step: "l\xE9p\xE9s"
      },
      health: {
        ok: "OK",
        offline: "Offline",
        workflows: "workflow",
        running: "fut\xF3",
        approvals: "j\xF3v\xE1hagy\xE1s",
        schedules: "\xFCtemez\xE9s"
      },
      operations: {
        engineHealth: "Engine \xE1llapot",
        online: "Online",
        offline: "Offline",
        registeredWorkflows: "regisztr\xE1lt workflow",
        dailyStats: "Napi statisztika",
        totalToday: "Ma \xF6sszesen",
        successRate: "Sikeres",
        schedules: "\xDCtemez\xE9sek",
        schedulesInfo: "Az \xFCtemezett workflow-ok itt jelennek meg"
      },
      schedule: {
        title: "\xDCtemez\xE9s",
        save: "Ment\xE9s",
        saved: "\u23F0 \xDCtemez\xE9s mentve",
        error: "\xDCtemez\xE9s ment\xE9se sikertelen",
        daily: "Minden nap",
        weekdays: "H\xE9tk\xF6znap",
        weekly: "Hetente",
        monthly: "Havonta",
        custom: "Egyedi cron",
        dayOfMonth: "H\xF3nap napja",
        monday: "H\xE9tf\u0151",
        tuesday: "Kedd",
        wednesday: "Szerda",
        thursday: "Cs\xFCt\xF6rt\xF6k",
        friday: "P\xE9ntek",
        saturday: "Szombat",
        sunday: "Vas\xE1rnap"
      },
      approval: {
        approve: "J\xF3v\xE1hagy\xE1s",
        reject: "Elutas\xEDt\xE1s",
        approved: "J\xF3v\xE1hagyva",
        rejected: "Elutas\xEDtva",
        error: "Hiba t\xF6rt\xE9nt",
        noPending: "Nincs v\xE1rakoz\xF3 j\xF3v\xE1hagy\xE1s \u2705",
        pastDecisions: "Kor\xE1bbi d\xF6nt\xE9sek",
        requestedBy: "K\xE9rte",
        requiredRole: "Sz\xFCks\xE9ges role",
        reason: "Indok",
        rejectTitle: "Elutas\xEDt\xE1s indoka",
        reasonPlaceholder: "\xCDrd le az elutas\xEDt\xE1s ok\xE1t..."
      },
      history: {
        noExecutions: "Nincs kor\xE1bbi v\xE9grehajt\xE1s",
        noResults: "Nincs tal\xE1lat a sz\u0171r\u0151kkel",
        startOne: "Ind\xEDts egyet \u2192",
        filterStatus: "St\xE1tusz",
        filterWorkflow: "Workflow",
        filterPeriod: "Id\u0151szak",
        periodAll: "Mind",
        periodToday: "Ma",
        periodWeek: "Ezen a h\xE9ten",
        periodMonth: "Ebben a h\xF3napban",
        restart: "\xDAjraind\xEDt\xE1s"
      },
      toast: {
        completed: "\u2705 {name} befejezve",
        failed: "\u274C {name} sikertelen"
      },
      execution: {
        details: "R\xE9szletek",
        hideDetails: "Bez\xE1r\xE1s",
        parameters: "Param\xE9terek",
        cancel: "Le\xE1ll\xEDt\xE1s",
        cancelConfirm: "Biztosan le\xE1ll\xEDtod?",
        cancelled: "{name} le\xE1ll\xEDtva",
        keepRunning: "Futni hagyom"
      },
      status: {
        running: "Fut",
        pending: "V\xE1rakozik",
        completed: "K\xE9sz",
        failed: "Sikertelen",
        cancelled: "Megszak\xEDtva"
      },
      emptyState: {
        running: "Nincs fut\xF3 munkafolyamat",
        history: "Nincs kor\xE1bbi v\xE9grehajt\xE1s",
        approvals: "Nincs v\xE1rakoz\xF3 j\xF3v\xE1hagy\xE1s",
        operations: "M\u0171veletek hamarosan..."
      },
      categories: {
        finance: "P\xE9nz\xFCgy",
        rental: "B\xE9rl\xE9s",
        service: "Szerviz",
        inventory: "K\xE9szlet",
        sales: "\xC9rt\xE9kes\xEDt\xE9s",
        reporting: "Riport",
        compliance: "Megfelel\u0151s\xE9g",
        hr: "HR",
        operations: "M\u0171veletek"
      },
      startWorkflow: "Ind\xEDt\xE1s",
      favorites: "Kedvencek",
      pinWorkflow: "R\xF6gz\xEDt\xE9s",
      unpinWorkflow: "R\xF6gz\xEDt\xE9s elt\xE1vol\xEDt\xE1sa",
      execute: {
        title: "Workflow ind\xEDt\xE1sa",
        submit: "Ind\xEDt\xE1s",
        success: "{name} elind\xEDtva",
        error: "{name} ind\xEDt\xE1sa sikertelen",
        steps: "L\xE9p\xE9sek",
        required: "K\xF6telez\u0151 mez\u0151"
      }
    },
    loadFailed: "Nem siker\xFClt bet\xF6lteni",
    openInNewTab: "Megnyit\xE1s \xFAj ablakban",
    refresh: "Friss\xEDt\xE9s",
    retry: "\xDAjrapr\xF3b\xE1lkoz\xE1s",
    sso: {
      active: "SSO akt\xEDv",
      connecting: "SSO...",
      fallback: "Manu\xE1lis bel\xE9p\xE9s",
      retryButton: "SSO \xFAjra"
    }
  },
  myforge: {
    openInNewTab: "Megnyit\xE1s \xFAj ablakban"
  },
  pwa: {
    close: "Bez\xE1r\xE1s",
    install: {
      button: "Telep\xEDt\xE9s",
      description: "Telep\xEDtse az alkalmaz\xE1st a kezd\u0151k\xE9perny\u0151re a gyorsabb el\xE9r\xE9s\xE9rt!",
      title: "Alkalmaz\xE1s telep\xEDt\xE9se"
    },
    notification: {
      description: "Kapjon \xE9rtes\xEDt\xE9seket a fontos esem\xE9nyekr\u0151l, b\xE9rl\xE9sekr\u0151l \xE9s szerviz \xE1llapotokr\xF3l.",
      dismiss: "Most nem",
      enable: "Enged\xE9lyez\xE9s",
      title: "\xC9rtes\xEDt\xE9sek enged\xE9lyez\xE9se"
    },
    offline: {
      message: "Nincs internetkapcsolat"
    },
    update: {
      button: "Friss\xEDt\xE9s",
      dismiss: "K\xE9s\u0151bb",
      message: "\xDAj verzi\xF3 el\xE9rhet\u0151"
    }
  },
  worksheetPrint: {
    downloadPdf: "PDF Let\xF6lt\xE9s",
    emailPlaceholder: "Email c\xEDm",
    emailSendFailed: "Email k\xFCld\xE9s sikertelen",
    emailSent: "Email elk\xFCldve",
    errorPrefix: "Hiba",
    generating: "PDF gener\xE1l\xE1s...",
    pdfGenerationFailed: "PDF gener\xE1l\xE1s sikertelen",
    pdfTitle: "Munkalap PDF",
    print: "Nyomtat\xE1s",
    sendEmail: "Email k\xFCld\xE9s",
    sending: "K\xFCld\xE9s...",
    title: "Munkalap nyomtat\xE1s",
    unknownError: "Hiba: Ismeretlen hiba"
  },
  permission: {
    module: {
      auth: "Hiteles\xEDt\xE9s",
      users: "Felhaszn\xE1l\xF3k",
      partners: "Partnerek",
      inventory: "K\xE9szlet",
      rental: "B\xE9rl\xE9s",
      sales: "\xC9rt\xE9kes\xEDt\xE9s",
      service: "Szerviz",
      reports: "Riportok",
      settings: "Be\xE1ll\xEDt\xE1sok"
    }
  },
  worksheet: {
    status: {
      felveve: "Felv\xE9ve",
      folyamatban: "Folyamatban",
      varhato: "V\xE1rakoz\xF3",
      felfuggesztve: "Felf\xFCggesztve",
      kesz: "K\xE9sz",
      szamlazando: "Sz\xE1ml\xE1zand\xF3",
      lezart: "Lez\xE1rt",
      torolve: "T\xF6r\xF6lve"
    },
    stepper: {
      ariaLabel: "Munkalap \xE1llapot-folyamata",
      cancelled: "T\xF6r\xF6lve",
      completed: "k\xE9sz",
      current: "jelenlegi"
    },
    type: {
      fizetos: "Fizet\u0151s jav\xEDt\xE1s",
      garancialis: "Garanci\xE1lis",
      berlesi: "B\xE9rl\xE9si szerviz",
      karbantartas: "Karbantart\xE1s",
      szerzodeses: "Szerz\u0151d\xE9ses"
    },
    priority: {
      surgos: "S\xFCrg\u0151s (+20%)",
      felaras: "Fel\xE1ras",
      garancialis: "Garanci\xE1lis",
      franchise: "Franchise",
      normal: "Norm\xE1l",
      surcharge: "Fel\xE1ras"
    },
    category: {
      powerTool: "Elektromos g\xE9p",
      garden: "Kerti g\xE9p",
      construction: "\xC9p\xEDt\u0151ipari",
      cleaning: "Takar\xEDt\xF3g\xE9p",
      other: "Egy\xE9b"
    },
    history: {
      created: "L\xE9trehozva",
      statusChanged: "St\xE1tusz m\xF3dos\xEDtva",
      itemAdded: "T\xE9tel hozz\xE1adva",
      itemRemoved: "T\xE9tel elt\xE1vol\xEDtva",
      assigned: "Hozz\xE1rendelve",
      noteAdded: "Megjegyz\xE9s hozz\xE1adva",
      invoiced: "Sz\xE1ml\xE1zva",
      completed: "Befejezve"
    },
    placeholder: {
      estimatedCost: "pl. 50000"
    },
    repairType: {
      title: "Jav\xEDt\xE1s t\xEDpusa",
      description: "V\xE1lassza ki a jav\xEDt\xE1s t\xEDpus\xE1t",
      fizetos: "Jav\xEDt\xE1sra",
      fizetosDesc: "Fizet\u0151s jav\xEDt\xE1s, bevizsg\xE1l\xE1si d\xEDj felsz\xE1molhat\xF3",
      garancialis: "Garanci\xE1lis",
      garancialisDesc: "Garanci\xE1lis jav\xEDt\xE1s, bevizsg\xE1l\xE1si d\xEDj nem alkalmazand\xF3",
      szerzodeses: "Szerz\u0151d\xE9ses partner",
      szerzodesesDesc: "Szerz\u0151d\xE9ses partner jav\xEDt\xE1sa, bevizsg\xE1l\xE1si d\xEDj nem alkalmazand\xF3",
      szerzodesesBadge: "Szerz\u0151d\xE9ses partner felismerve",
      selected: "Kiv\xE1lasztva: {type}"
    },
    inspectionFee: {
      notApplicable: "Nem alkalmazand\xF3 ({reason})",
      change: "Bevizsg\xE1l\xE1si d\xEDj m\xF3dos\xEDt\xE1sa",
      confirm: "Bevizsg\xE1l\xE1si d\xEDj meger\u0151s\xEDt\xE9se",
      confirmed: "Bevizsg\xE1l\xE1si d\xEDj j\xF3v\xE1hagyva",
      overridden: "Bevizsg\xE1l\xE1si d\xEDj fel\xFCl\xEDrva",
      override: "Bevizsg\xE1l\xE1si d\xEDj fel\xFCl\xEDr\xE1sa",
      suggested: "Javasolt bevizsg\xE1l\xE1si d\xEDj",
      urgent: "S\xFCrg\u0151ss\xE9gi fel\xE1r"
    },
    paymentGate: {
      title: "Bevizsg\xE1l\xE1si d\xEDj fizet\xE9se sz\xFCks\xE9ges",
      description: "A munka megkezd\xE9s\xE9hez a bevizsg\xE1l\xE1si d\xEDj ({amount}) kifizet\xE9se sz\xFCks\xE9ges. A g\xE9p csak fizet\xE9s ut\xE1n ker\xFClhet a technikushoz.",
      markPaid: "D\xEDj fizetve",
      blockInfo: "Fizet\xE9s n\xE9lk\xFCl a munka nem ind\xEDthat\xF3 el"
    },
    pendingPartsBlock: {
      title: "Lez\xE1r\xE1s letiltva \u2014 f\xFCgg\u0151 alkatr\xE9sz",
      description: "{count} f\xFCgg\u0151 alkatr\xE9sz-beszerz\xE9s van. A munkalap nem fejezhet\u0151 be \xE9s nem z\xE1rhat\xF3 le, am\xEDg az alkatr\xE9sz meg nem \xE9rkezik.",
      blockInfo: "F\xFCgg\u0151 alkatr\xE9sz-beszerz\xE9s miatt letiltva",
      toast: "A munkalap nem z\xE1rhat\xF3 le f\xFCgg\u0151 alkatr\xE9sz-beszerz\xE9ssel."
    },
    inspectionFeeCredit: {
      label: "Bevizsg\xE1l\xE1si d\xEDj j\xF3v\xE1\xEDr\xE1s",
      netAfterCredit: "Fizetend\u0151 (j\xF3v\xE1\xEDr\xE1s ut\xE1n)"
    },
    costAllocation: {
      title: "K\xF6lts\xE9g bont\xE1s",
      customerFacing: "\xDCgyf\xE9lnek felsz\xE1m\xEDtott",
      customerTotal: "\xDCgyf\xE9l \xF6sszesen (nett\xF3)",
      internal: "Bels\u0151 k\xF6lts\xE9gek (alv\xE1llalkoz\xF3)",
      internalTotal: "Bels\u0151 \xF6sszesen",
      grandTotal: "V\xE9g\xF6sszeg (brutt\xF3)",
      vatIncluded: "Tartalmaz \xC1FA"
    },
    basket: {
      title: "Munkalap kos\xE1r",
      addPlaceholder: "Munkalap ID vagy sz\xE1m...",
      empty: "A kos\xE1r \xFCres",
      clear: "\xDCr\xEDt\xE9s",
      checkout: "Konszolid\xE1lt sz\xE1mla",
      checkoutSuccess: "Sz\xE1mla gener\xE1lva",
      warrantyError: "Garanci\xE1lis munkalap nem adhat\xF3 a kos\xE1rhoz \u2014 a garanci\xE1lis jav\xEDt\xE1st a gy\xE1rt\xF3/garancia fedezi, k\xFCl\xF6n gy\u0171jt\u0151-sz\xE1ml\xE1z\xE1ssal."
    },
    supplierSettlement: {
      title: "Gy\xE1rt\xF3i Garanci\xE1s Elsz\xE1mol\xE1s",
      subtitle: "Garanci\xE1lis jav\xEDt\xE1sok gy\u0171jt\u0151sz\xE1mla gener\xE1l\xE1sa a gy\xE1rt\xF3 fel\xE9",
      filters: "Sz\u0171r\u0151k",
      supplier: "Gy\xE1rt\xF3 / besz\xE1ll\xEDt\xF3",
      from: "Id\u0151szak kezdete",
      to: "Id\u0151szak v\xE9ge",
      search: "Keres\xE9s",
      filterRequired: "K\xE9rj\xFCk adja meg a sz\xE1ll\xEDt\xF3t \xE9s az id\u0151szakot",
      eligible: "Elsz\xE1molhat\xF3 munkalapok",
      generateInvoice: "Gy\u0171jt\u0151sz\xE1mla gener\xE1l\xE1s",
      generated: "Gy\u0171jt\u0151sz\xE1mla sikeresen gener\xE1lva!",
      invoiceNumber: "Sz\xE1mlasz\xE1m",
      worksheets: "munkalap",
      wsNumber: "Munkalap sz\xE1m",
      brand: "M\xE1rka",
      completed: "Befejezve"
    },
    procurement: {
      title: "Alkatr\xE9sz beszerz\xE9si ig\xE9nyek",
      addRequest: "\xDAj ig\xE9ny",
      empty: "Nincs beszerz\xE9si ig\xE9ny ehhez a munkalaphoz",
      descriptionPlaceholder: "Alkatr\xE9sz megnevez\xE9s vagy le\xEDr\xE1s...",
      markOrdered: "Megrendelve",
      markReceived: "Be\xE9rkezett",
      status: {
        pending: "F\xFCgg\u0151ben",
        ordered: "Megrendelve",
        received: "Be\xE9rkezett",
        cancelled: "T\xF6r\xF6lve"
      }
    },
    hourlyRateConfig: {
      title: "Szerviz \xD3rad\xEDj Konfigur\xE1ci\xF3",
      subtitle: "G\xE9pkateg\xF3ri\xE1nk\xE9nti \xF3rad\xEDj be\xE1ll\xEDt\xE1s",
      tableTitle: "\xD3rad\xEDj per kateg\xF3ria (nett\xF3 HUF)",
      category: "Kateg\xF3ria",
      fallbackRate: "Alap\xE9rtelmezett",
      configuredRate: "Be\xE1ll\xEDtott \xF3rad\xEDj",
      invalidRate: "Az \xF3rad\xEDj nem lehet negat\xEDv",
      priorityInfo: "Priorit\xE1s: szerz\u0151d\xE9ses partner \xF3rad\xEDj > konfigur\xE1lt kateg\xF3ria \xF3rad\xEDj > alap\xE9rtelmezett t\xE1bla > 8.000 Ft"
    },
    markReadyAction: "Munka k\xE9sz",
    isWarranty: "Garanci\xE1lis",
    suspendAction: "Felf\xFCggeszt\xE9s",
    resumeAction: "Folytat\xE1s",
    suspendedTitle: "Munkalap felf\xFCggesztve \u2014 plusz k\xF6lts\xE9g",
    suspendedDescription: "A jav\xEDt\xE1s sor\xE1n \xFAj probl\xE9ma mer\xFClt fel, amely extra k\xF6lts\xE9get jelent. Az \xFCgyf\xE9l d\xF6nt\xE9s\xE9re v\xE1runk.",
    newQuoteVersion: "\xDAj \xE1raj\xE1nlat k\xE9sz\xEDt\xE9se",
    resumeOriginalScope: "Folytat\xE1s eredeti terjedelemben",
    machineCategory: {
      title: "G\xE9pkateg\xF3ria",
      subtitle: "V\xE1lassza ki a g\xE9p t\xEDpus\xE1t",
      electricSmall: "Elektromos kisg\xE9p",
      electricLarge: "Elektromos nagyg\xE9p",
      petrolHandheld: "Benzines k\xE9zi",
      petrolPush: "Benzines tol\xF3s",
      tractor: "Traktor/Ride-on",
      battery: "Akkumul\xE1toros"
    },
    filter: {
      machineCategory: "G\xE9pkateg\xF3ria",
      allCategories: "\xD6sszes kateg\xF3ria"
    },
    directRepairBadge: "Azonnali jav\xEDt\xE1s \u2014 k\xF6lts\xE9gkorl\xE1t alatt",
    costLimitSkip: "Aj\xE1nlat f\xE1zis kihagyva \u2014 becs\xFClt k\xF6lts\xE9g a limit alatt",
    technician: {
      title: "Hozz\xE1rendelt technikusok",
      primary: "F\u0151 szerel\u0151",
      coTech: "Seg\xE9dtechnikus",
      maxReached: "Maximum {max} seg\xE9dtechnikus rendelhet\u0151 hozz\xE1",
      maxCoTechInfo: "Max {max} seg\xE9d",
      noAssigned: "Nincs hozz\xE1rendelt technikus",
      addTechnician: "Technikus hozz\xE1ad\xE1sa",
      nameLabel: "Technikus neve",
      namePlaceholder: "pl. Kov\xE1cs J\xE1nos",
      roleLabel: "Szerepk\xF6r",
      nameRequired: "A technikus nev\xE9t k\xF6telez\u0151 megadni (min. 2 karakter)"
    },
    batch: {
      tabTitle: "Csoportos felv\xE9tel",
      scanTitle: "Vonalk\xF3d beolvas\xE1s",
      scanPlaceholder: "Olvassa be vagy \xEDrja be a vonalk\xF3dot...",
      worksheetType: "Munkalap t\xEDpusa",
      scannedItems: "Beolvasott t\xE9telek",
      createAll: "\xD6sszes l\xE9trehoz\xE1sa",
      results: "Eredm\xE9nyek",
      successCount: "{count} sikeresen l\xE9trehozva",
      failureCount: "{count} sikertelen"
    },
    tabs: {
      overview: "\xC1ttekint\xE9s",
      diagnosis: "Diagn\xF3zis",
      parts: "Alkatr\xE9szek",
      history: "El\u0151zm\xE9ny",
      photos: "Fot\xF3k",
      warranty: "Garancia",
      noWarranty: "Nincs garanci\xE1lis ig\xE9ny enn\xE9l a munkalapn\xE1l."
    },
    closeConfirm: {
      title: "Munkalap lez\xE1r\xE1sa",
      warning: "{count} beszerz\xE9si t\xE9tel m\xE9g folyamatban. Biztosan lez\xE1rod a munkalapot?",
      qty: "{qty} db",
      unnamedItem: "Beszerz\xE9si t\xE9tel",
      confirm: "M\xE9gis lez\xE1rom",
      cancel: "M\xE9gse",
      status: {
        DRAFT: "Piszkozat",
        SUBMITTED: "Bek\xFCldve",
        ORDERED: "Megrendelve"
      }
    },
    historyEvents: {
      created: "Munkalap l\xE9trehozva",
      received: "Felv\xE9tel",
      diagnosed: "Diagn\xF3zis indult",
      started: "Jav\xEDt\xE1s indult",
      completed: "Elk\xE9sz\xFClt",
      notified: "\xDCgyf\xE9l \xE9rtes\xEDtve",
      delivered: "\xC1tadva",
      closed: "Lez\xE1rva",
      empty: "Nincs megjelen\xEDthet\u0151 esem\xE9ny"
    },
    intakeBatch: {
      count: "{count} g\xE9p egy bead\xE1sban",
      current: "ez a munkalap",
      error: "A csoportos bead\xE1s adatai nem \xE9rhet\u0151k el",
      title: "Csoportos bead\xE1s",
      formTitle: "Csoportos munkalap-bead\xE1s",
      formDesc: "Egy partnert\u0151l t\xF6bb g\xE9p egyszerre, k\xF6z\xF6s bead\xE1s-azonos\xEDt\xF3val.",
      partnerSection: "Partner kiv\xE1laszt\xE1sa",
      partnerHint: "V\xE1lassza ki azt a partnert, akihez a bead\xE1s tartozik.",
      selectedPartner: "Kiv\xE1lasztott partner: {name}",
      changePartner: "Partner m\xF3dos\xEDt\xE1sa",
      batchSettings: "Bead\xE1s be\xE1ll\xEDt\xE1sai",
      deviceList: "G\xE9pek",
      itemHeading: "{index}. g\xE9p",
      addItem: "G\xE9p hozz\xE1ad\xE1sa",
      removeItem: "G\xE9p elt\xE1vol\xEDt\xE1sa",
      itemCount: "{count} / 26 g\xE9p",
      submit: "Bead\xE1s l\xE9trehoz\xE1sa ({count} g\xE9p)",
      submitting: "Bead\xE1s folyamatban\u2026",
      successTitle: "Bead\xE1s sikeres",
      successDesc: "{count} munkalap l\xE9trehozva \u2014 bead\xE1s-azonos\xEDt\xF3: {batchId}",
      newBatch: "\xDAj bead\xE1s",
      listBadge: "Csoportos",
      listBadgeHint: "Csoportos bead\xE1s \u2014 kattintson a teljes bead\xE1s megtekint\xE9s\xE9hez",
      filterActive: "Csoportos bead\xE1s sz\u0171r\u0151 akt\xEDv",
      clearFilter: "Sz\u0171r\u0151 t\xF6rl\xE9se",
      errors: {
        empty: "Legal\xE1bb egy g\xE9p sz\xFCks\xE9ges a bead\xE1shoz.",
        tooMany: "Legfeljebb 26 g\xE9p adhat\xF3 meg egy bead\xE1sban.",
        duplicateSerial: "Ism\xE9tl\u0151d\u0151 gy\xE1ri sz\xE1m a bead\xE1sban \u2014 minden g\xE9pnek egyedi gy\xE1ri sz\xE1ma legyen.",
        deviceActive: "A g\xE9p m\xE1r akt\xEDv munkalapon szerepel.",
        partnerRequired: "V\xE1lasszon partnert a bead\xE1s el\u0151tt.",
        generic: "A bead\xE1s l\xE9trehoz\xE1sa sikertelen. K\xE9rj\xFCk, pr\xF3b\xE1lja \xFAjra."
      }
    },
    resolvedPackage: {
      none: "Nincs csomag",
      noneDesc: "Ehhez a term\xE9khez jelenleg nincs akt\xEDv szervizcsomag rendelve."
    },
    viewInvoice: "Sz\xE1mla megtekint\xE9se",
    billError: {
      alreadyInvoiced: "A munkalap m\xE1r ki van sz\xE1ml\xE1zva.",
      notBillable: "A munkalap jelenleg nem sz\xE1ml\xE1zhat\xF3.",
      warrantyNotBillable: "Garanci\xE1lis munkalap nem sz\xE1ml\xE1zhat\xF3 (a gy\xE1rt\xF3 fedezi).",
      failed: "A sz\xE1mla ki\xE1ll\xEDt\xE1sa nem siker\xFClt."
    },
    partner: {
      loading: "Partner bet\xF6lt\xE9se\u2026",
      label: "Partner: {name}",
      unresolved: "Ismeretlen partner ({id})"
    }
  },
  dashboardApp: {
    changelog: {
      categoryFixed: "Jav\xEDt\xE1s",
      categoryImproved: "Fejleszt\xE9s",
      categoryNew: "\xDAj funkci\xF3",
      codeCoverage: "K\xF3d lefedetts\xE9g:",
      collapseDetails: "\xD6sszes r\xE9szlet \xF6sszecsuk\xE1sa",
      collapseVersions: "\xD6sszes verzi\xF3 \xF6sszecsuk\xE1sa",
      details: "R\xE9szletek",
      expandDetails: "\xD6sszes r\xE9szlet kinyit\xE1sa",
      expandVersions: "\xD6sszes verzi\xF3 kinyit\xE1sa",
      failedTests: "sikertelen",
      filter: "Sz\u0171r\xE9s:",
      filterAll: "Minden",
      filterFixed: "Jav\xEDt\xE1sok",
      filterImproved: "Fejleszt\xE9sek",
      filterNew: "\xDAj funkci\xF3k",
      findings: "\xE9szrev\xE9tel",
      fixedIssues: "jav\xEDtva",
      heading: "V\xE1ltoz\xE1sok \xE9s \xDAjdons\xE1gok",
      openIssues: "nyitott",
      passed: "sikeres",
      relatedTests: "Kapcsol\xF3d\xF3 Tesztek",
      reviewFindings: "Code Review \xC9szrev\xE9telek",
      reviewSummary: "Code Review \xD6sszefoglal\xF3",
      severityCritical: "Kritikus",
      severityMajor: "Fontos",
      severityMinor: "Kisebb",
      statusFixed: "\u2713 Jav\xEDtva",
      statusOpen: "\u25CB Nyitott",
      statusRejected: "\u2014 Elutas\xEDtva",
      subscribe: "Feliratkoz\xE1s",
      subscribeDescription: "Iratkozzon fel h\xEDrlevel\xFCnkre \xE9s els\u0151k\xE9nt \xE9rtes\xFClj\xF6n az \xFAj funkci\xF3kr\xF3l \xE9s fejleszt\xE9sekr\u0151l.",
      subscribeTitle: "\xC9rtes\xFClj\xF6n az \xFAjdons\xE1gokr\xF3l!",
      subtitle: "K\xF6vesse nyomon a rendszer fejleszt\xE9seit \xE9s \xFAj funkci\xF3it",
      test: "teszt",
      testSummary: "Teszt \xD6sszefoglal\xF3",
      typeMajor: "F\u0151verzi\xF3",
      typeMinor: "Funkci\xF3 friss\xEDt\xE9s",
      typePatch: "Hibajav\xEDt\xE1s",
      versions: "Verzi\xF3k"
    },
    developer: {
      active: "akt\xEDv",
      completed: "Befejezett",
      completionTrend: "Befejez\xE9si Trend (Kumulat\xEDv)",
      done: "K\xE9sz",
      epicProgress: "Epic Halad\xE1s (%)",
      epicStorySummary: "Epic & Story \xD6sszes\xEDt\xE9s",
      filterAll: "Mind",
      filterDone: "K\xE9sz",
      filterInProgress: "Folyamatban",
      filterLabel: "Sz\u0171r\xE9s:",
      filterPlanned: "Tervezett",
      inProgress: "Folyamatban",
      inProgressEpics: "Folyamatban L\xE9v\u0151 Epics",
      noFilterResults: "Nincs tal\xE1lat a sz\u0171r\u0151nek",
      noInProgressEpics: "Nincs folyamatban l\xE9v\u0151 epic",
      progress: "Halad\xE1s",
      storyStatusDistribution: "Story St\xE1tusz Eloszl\xE1s",
      tabEpics: "Epics",
      tabOverview: "\xC1ttekint\xE9s",
      tabStories: "Stories",
      totalCompleted: "\xD6sszes befejezett",
      totalEpics: "\xD6sszes Epic",
      totalStories: "\xD6sszes Story"
    },
    downloads: {
      archive: "Arch\xEDvum",
      archiveDesc: "Kor\xE1bbi exportok",
      comingSoon: "A let\xF6lt\xE9sek hamarosan el\xE9rhet\u0151ek lesznek.",
      download: "Let\xF6lt\xE9s \u2192",
      fullStatus: "Teljes St\xE1tusz",
      fullStatusDesc: "Minden adat egy f\xE1jlban",
      heading: "Exportok \xE9s Riportok",
      progressExport: "Halad\xE1s Export",
      progressExportDesc: "Epic \xE9s story halad\xE1s adatok",
      reviewSummary: "Review \xD6sszes\xEDt\u0151",
      reviewSummaryDesc: "Code review eredm\xE9nyek",
      sprintReport: "Sprint Riport",
      sprintReportDesc: "Aktu\xE1lis sprint st\xE1tusz export",
      testReport: "Teszt Riport",
      testReportDesc: "Teszt eredm\xE9nyek \xE9s coverage"
    },
    executive: {
      activeWork: "Akt\xEDv Munka",
      allStoriesDone: "Minden story k\xE9sz!",
      done: "K\xE9sz",
      doneEpic: "K\xE9sz Epic",
      fixed: "Jav\xEDtva",
      inProgress: "Folyamatban",
      issues: "hiba",
      more: "tov\xE1bbi",
      overallProgress: "\xD6sszes halad\xE1s",
      projectProgress: "Projekt Halad\xE1s",
      recentlyCompletedEpics: "Utolj\xE1ra Befejezett Epics",
      testSummary: "Teszt \xD6sszefoglal\xF3",
      tests: "Tesztek",
      totalIssues: "\xD6sszes hiba"
    },
    workflow: {
      pendingApprovals: "J\xF3v\xE1hagy\xE1sra v\xE1r",
      runningWorkflows: "Fut\xF3 workflow",
      openFlow: "rPI Flow megnyit\xE1sa",
      refresh: "Friss\xEDt\xE9s"
    },
    knowledge: {
      adrs: "ADR-ek",
      adrsDesc: "Architekt\xFAra d\xF6nt\xE9si rekordok",
      architecture: "Architekt\xFAra",
      architectureDesc: "Rendszer architekt\xFAra dokument\xE1ci\xF3",
      comingSoon: "A tud\xE1sb\xE1zis hamarosan el\xE9rhet\u0151 lesz.",
      epicDefinitions: "Epic Defin\xEDci\xF3k",
      epicDefinitionsDesc: "Epic \xE9s story le\xEDr\xE1sok",
      heading: "Dokument\xE1ci\xF3",
      prd: "PRD",
      prdDesc: "Term\xE9k k\xF6vetelm\xE9ny dokumentum"
    },
    layout: {
      header: {
        refreshButton: "Friss\xEDt\xE9s",
        settingsButton: "Be\xE1ll\xEDt\xE1sok",
        statsDone: "k\xE9sz",
        statsEpics: "Epics",
        statsStories: "Stories",
        views: {
          changelog: {
            subtitle: "Verzi\xF3k, v\xE1ltoz\xE1sok \xE9s funkci\xF3 friss\xEDt\xE9sek",
            title: "\xDAjdons\xE1gok"
          },
          developer: {
            subtitle: "Epic \xE9s story halad\xE1s r\xE9szletesen",
            title: "Fejleszt\u0151i N\xE9zet"
          },
          downloads: {
            subtitle: "Exportok \xE9s riportok",
            title: "Let\xF6lt\xE9sek"
          },
          executive: {
            subtitle: "Projekt st\xE1tusz \xE9s KPI-k egy pillanatk\xE9pben",
            title: "Vezet\u0151i \xC1ttekint\xE9s"
          },
          knowledge: {
            subtitle: "Dokument\xE1ci\xF3 \xE9s ADR-ek",
            title: "Tud\xE1sb\xE1zis"
          },
          qa: {
            subtitle: "Teszt metrik\xE1k \xE9s code review eredm\xE9nyek",
            title: "QA N\xE9zet"
          },
          statistics: {
            subtitle: "R\xE9szletes projekt metrik\xE1k \xE9s analitika",
            title: "Statisztik\xE1k"
          }
        }
      },
      sidebar: {
        collapse: "\xD6sszecsuk\xE1s",
        darkMode: "S\xF6t\xE9t m\xF3d",
        lightMode: "Vil\xE1gos m\xF3d",
        logoSubtitle: "rPI ERP Dashboard",
        logoTitle: "rPI ERP",
        mobileLogoSubtitle: "KGC ERP Dashboard",
        mobileLogoTitle: "MyForgeOS",
        refresh: "Friss\xEDt\xE9s",
        refreshData: "Adatok friss\xEDt\xE9se",
        refreshing: "Friss\xEDt\xE9s...",
        sectionUtilities: "Seg\xE9dletek",
        sectionViews: "N\xE9zetek",
        themeToggle: "T\xE9ma v\xE1lt\xE1s",
        utilities: {
          changelog: {
            description: "Verzi\xF3k \xE9s v\xE1ltoz\xE1sok",
            name: "\xDAjdons\xE1gok"
          },
          downloads: {
            description: "Exportok \xE9s riportok",
            name: "Let\xF6lt\xE9sek"
          },
          knowledge: {
            description: "Dokument\xE1ci\xF3 \xE9s ADR-ek",
            name: "Tud\xE1sb\xE1zis"
          }
        },
        views: {
          developer: {
            description: "Sprint \xE9s story r\xE9szletek",
            name: "Developer"
          },
          executive: {
            description: "Vezet\u0151i \xE1ttekint\xE9s \xE9s KPI-k",
            name: "Executive"
          },
          qa: {
            description: "Teszt \xE9s min\u0151s\xE9gi metrik\xE1k",
            name: "QA"
          },
          statistics: {
            description: "R\xE9szletes analitika \xE9s chartok",
            name: "Statisztik\xE1k"
          }
        }
      }
    },
    qa: {
      allEpics: "Minden Epic",
      allPackages: "Minden package",
      avgCoverage: "\xC1tlag Coverage",
      claudeVsGemini: "Claude vs Gemini \xD6sszehasonl\xEDt\xE1s",
      collapseAll: "\u25B2 \xD6sszecsuk",
      consensus: "Konszenzus",
      coverageByPackage: "Coverage Package Szerint",
      coveragePercent: "Lefedetts\xE9g %",
      critical: "Kritikus",
      deferred: "Elhalasztva",
      expandAll: "\u25BC Kinyit",
      failed: "Sikertelen",
      failingTests: "Sikertelen Tesztek",
      filter: "Sz\u0171r\xE9s:",
      filterAll: "Minden",
      filterCritical: "\u{1F534} Kritikus",
      filterFailed: "\u2717 Sikertelen",
      filterFixed: "\u2713 Jav\xEDtva",
      filterOpen: "\u25CB Nyitott",
      filterPassed: "\u2713 Sikeres",
      fixed: "Jav\xEDtott",
      found: "Tal\xE1lt",
      heading: "QA Dashboard",
      high: "Magas",
      inProgressRound: "Folyamatban",
      issueResolutionFlow: "Issue Resolution Folyamat",
      issues: "hiba",
      low: "Alacsony",
      medium: "K\xF6zepes",
      noFilterResults: "Nincs tal\xE1lat a sz\u0171r\u0151nek",
      open: "Nyitott",
      passRate: "Sikeress\xE9gi Ar\xE1ny %",
      passed: "Sikeres",
      qualityScore: "Min\u0151s\xE9gi Pontsz\xE1m",
      reviewIssues: "Review Hib\xE1k",
      reviewSummary: "Review \xD6sszes\xEDt\xE9s",
      runTime: "Fut\xE1si id\u0151",
      severityDistribution: "Hiba S\xFAlyoss\xE1g Eloszl\xE1s",
      skipped: "Kihagyva",
      statusDeferred: "\u21B7 Elhalasztva",
      statusFixed: "\u2713 Jav\xEDtva",
      statusOpen: "\u25CB Nyitott",
      statusWontfix: "\u2014 Nem jav\xEDtjuk",
      subtitle: "Teszt metrik\xE1k, code review \xE9s min\u0151s\xE9gbiztos\xEDt\xE1s - val\xF3di BMAD adatokb\xF3l",
      tabOverview: "\xC1ttekint\xE9s",
      tabReviews: "Fel\xFClvizsg\xE1latok",
      tabTests: "Tesztek",
      test: "Tesztek",
      testResultsByPackage: "Teszt Eredm\xE9nyek Package Szerint",
      trendTitle: "Sikeress\xE9gi Ar\xE1ny & Coverage Trend",
      verdictApproved: "\u2705 Elfogadva",
      verdictApprovedWithFixes: "\u2705 Elfogadva (jav\xEDt\xE1sokkal)",
      verdictInProgress: "\u{1F504} Folyamatban",
      verdictRejected: "\u274C Elutas\xEDtva"
    },
    statistics: {
      activeStories: "Akt\xEDv Story",
      actual: "T\xE9nyleges",
      average: "\xC1tlag",
      averageFixRate: "\xC1tlagos fix rate",
      avgStoriesPerEpic: "\xC1tlag Story/Epic",
      claudeVsGemini: "Claude vs Gemini \xD6sszehasonl\xEDt\xE1s",
      codeReviewAnalytics: "Code Review Analitika",
      completedStories: "Befejezett Story",
      completionRate: "Befejez\xE9si R\xE1ta",
      consensusRate: "Konszenzus ar\xE1ny",
      done: "K\xE9sz",
      epicCompletionTimeline: "Epic Befejez\xE9si Timeline",
      epicOverview: "Epic \xC1ttekint\xE9s",
      epicStatusDistribution: "Epic St\xE1tusz Eloszl\xE1s",
      fixRate: "Jav\xEDt\xE1si ar\xE1ny",
      fixed: "Jav\xEDtva",
      found: "Tal\xE1lt",
      heading: "Statisztik\xE1k",
      ideal: "Ide\xE1lis",
      inProgress: "Folyamatban",
      openIssues: "Nyitott hib\xE1k",
      passRate: "\xC1tmen\xE9si ar\xE1ny",
      projectHealth: "Projekt Eg\xE9szs\xE9g",
      projectProgress: "Projekt Halad\xE1s",
      remaining: "H\xE1tra",
      remainingStories: "H\xE1tra l\xE9v\u0151",
      severityDistribution: "Hiba S\xFAlyoss\xE1g Eloszl\xE1s",
      sprintProgress: "Sprint Halad\xE1s",
      storyDistributionByEpic: "Story Eloszl\xE1s Epic-enk\xE9nt",
      subtitle: "R\xE9szletes projekt metrik\xE1k \xE9s analitika",
      teamPerformance: "Csapat Teljes\xEDtm\xE9ny",
      testCoverage: "Teszt Coverage",
      testMetrics: "Teszt Metrik\xE1k",
      testTypeDistribution: "Teszt T\xEDpus Eloszl\xE1s",
      totalIssues: "\xD6sszes hiba",
      totalStories: "\xD6sszes Story",
      uniqueFindings: "Egyedi tal\xE1lt"
    },
    drawer: {
      done: "k\xE9sz",
      epicDetails: "Epic R\xE9szletek",
      fixed: "Jav\xEDtva",
      foundIssues: "Tal\xE1lt hib\xE1k",
      issues: "Hib\xE1k",
      noSubtasks: "Nincsenek r\xE9szfeladatok",
      progress: "Halad\xE1s",
      remaining: "h\xE1tra",
      reviewDetails: "Review R\xE9szletek",
      severity: "S\xFAlyoss\xE1g",
      storyDetails: "Story R\xE9szletek",
      tasks: "Feladatok"
    }
  },
  notification: {
    newRental: {
      message: "{partner} - {count} t\xE9tel",
      title: "\xDAj b\xE9rl\xE9s"
    },
    paymentError: {
      message: "Tranzakci\xF3 elutas\xEDtva ({amount})",
      title: "Fizet\xE9si hiba"
    },
    stockShortage: {
      message: "{productName} k\xE9szlet kritikus szinten (< 50%)",
      title: "K\xE9szlethi\xE1ny"
    },
    urgentWorksheet: {
      message: "\xDAj s\xFCrg\u0151s munkalap ({number}) l\xE9trehozva",
      title: "S\xFCrg\u0151s munkalap"
    }
  },
  permissions: {
    auth: {
      login: "Bejelentkez\xE9s",
      loginDesc: "Rendszer bejelentkez\xE9s",
      pin: "PIN bejelentkez\xE9s",
      pinDesc: "Gyors PIN k\xF3dos bejelentkez\xE9s"
    },
    users: {
      read: "Felhaszn\xE1l\xF3k megtekint\xE9se",
      readDesc: "Felhaszn\xE1l\xF3 lista \xE9s profil megtekint\xE9s",
      create: "Felhaszn\xE1l\xF3 l\xE9trehoz\xE1s",
      createDesc: "\xDAj felhaszn\xE1l\xF3 regisztr\xE1ci\xF3",
      update: "Felhaszn\xE1l\xF3 szerkeszt\xE9s",
      updateDesc: "Felhaszn\xE1l\xF3 adatok m\xF3dos\xEDt\xE1sa",
      delete: "Felhaszn\xE1l\xF3 t\xF6rl\xE9s",
      deleteDesc: "Felhaszn\xE1l\xF3 fi\xF3k deaktiv\xE1l\xE1sa",
      roles: "Szerepk\xF6r kezel\xE9s",
      rolesDesc: "Szerepk\xF6r\xF6k \xE9s jogosults\xE1gok be\xE1ll\xEDt\xE1sa"
    },
    partners: {
      read: "Partnerek megtekint\xE9se",
      readDesc: "Partner lista \xE9s adatlap megtekint\xE9s",
      create: "Partner l\xE9trehoz\xE1s",
      createDesc: "\xDAj partner regisztr\xE1ci\xF3",
      update: "Partner szerkeszt\xE9s",
      updateDesc: "Partner adatok m\xF3dos\xEDt\xE1sa",
      delete: "Partner t\xF6rl\xE9s",
      deleteDesc: "Partner deaktiv\xE1l\xE1sa"
    },
    rental: {
      read: "B\xE9rl\xE9sek megtekint\xE9se",
      readDesc: "B\xE9rl\xE9s lista \xE9s r\xE9szletek megtekint\xE9s",
      create: "B\xE9rl\xE9s ind\xEDt\xE1s",
      createDesc: "\xDAj b\xE9rl\xE9s l\xE9trehoz\xE1sa",
      return: "B\xE9rl\xE9s visszav\xE9tel",
      returnDesc: "B\xE9rg\xE9p visszav\xE9tel feldolgoz\xE1sa",
      extend: "B\xE9rl\xE9s hosszabb\xEDt\xE1s",
      extendDesc: "B\xE9rl\xE9si id\u0151szak meghosszabb\xEDt\xE1sa"
    },
    sales: {
      read: "\xC9rt\xE9kes\xEDt\xE9sek megtekint\xE9se",
      readDesc: "\xC9rt\xE9kes\xEDt\xE9s lista \xE9s r\xE9szletek",
      create: "\xC9rt\xE9kes\xEDt\xE9s l\xE9trehoz\xE1s",
      createDesc: "\xDAj \xE9rt\xE9kes\xEDt\xE9s r\xF6gz\xEDt\xE9se",
      discount: "Kedvezm\xE9ny ad\xE1s",
      discountDesc: "Kedvezm\xE9ny alkalmaz\xE1sa \xE9rt\xE9kes\xEDt\xE9sn\xE9l",
      refund: "Visszat\xE9r\xEDt\xE9s",
      refundDesc: "Visszat\xE9r\xEDt\xE9s feldolgoz\xE1sa"
    },
    service: {
      read: "Munkalapok megtekint\xE9se",
      readDesc: "Szerviz munkalap lista \xE9s r\xE9szletek",
      create: "Munkalap l\xE9trehoz\xE1s",
      createDesc: "\xDAj szerviz munkalap nyit\xE1sa",
      update: "Munkalap szerkeszt\xE9s",
      updateDesc: "Munkalap adatok m\xF3dos\xEDt\xE1sa",
      close: "Munkalap lez\xE1r\xE1s",
      closeDesc: "Szerviz munkalap v\xE9gleges\xEDt\xE9se"
    },
    settings: {
      read: "Be\xE1ll\xEDt\xE1sok megtekint\xE9se",
      readDesc: "Rendszer be\xE1ll\xEDt\xE1sok megtekint\xE9se",
      update: "Be\xE1ll\xEDt\xE1sok m\xF3dos\xEDt\xE1sa",
      updateDesc: "Rendszer be\xE1ll\xEDt\xE1sok szerkeszt\xE9se"
    },
    inventory: {
      read: "K\xE9szlet megtekint\xE9se",
      readDesc: "K\xE9szlet lista \xE9s r\xE9szletek",
      adjust: "K\xE9szlet korrekci\xF3",
      adjustDesc: "K\xE9szlet mennyis\xE9g m\xF3dos\xEDt\xE1sa",
      receive: "Bev\xE9telez\xE9s",
      receiveDesc: "\xC1ru bev\xE9telez\xE9s feldolgoz\xE1sa",
      transfer: "Rakt\xE1rk\xF6zi mozg\xE1s",
      transferDesc: "K\xE9szlet mozgat\xE1s rakt\xE1rak k\xF6z\xF6tt"
    },
    reports: {
      rental: "B\xE9rl\xE9s riportok",
      rentalDesc: "B\xE9rl\xE9si statisztik\xE1k \xE9s riportok",
      sales: "\xC9rt\xE9kes\xEDt\xE9s riportok",
      salesDesc: "\xC9rt\xE9kes\xEDt\xE9si statisztik\xE1k \xE9s riportok",
      financial: "P\xE9nz\xFCgyi riportok",
      financialDesc: "P\xE9nz\xFCgyi \xF6sszes\xEDt\u0151k \xE9s z\xE1r\xE1sok",
      inventory: "K\xE9szlet riportok",
      inventoryDesc: "K\xE9szlet statisztik\xE1k \xE9s lelt\xE1r riportok"
    }
  },
  courier: {
    title: "Fut\xE1ros kisz\xE1ll\xEDt\xE1sok",
    titleSingle: "Kisz\xE1ll\xEDt\xE1s r\xE9szletei",
    newDelivery: "\xDAj kisz\xE1ll\xEDt\xE1s",
    noDeliveries: "Nincs kisz\xE1ll\xEDt\xE1s",
    notFound: "Kisz\xE1ll\xEDt\xE1s nem tal\xE1lhat\xF3",
    noCourierYet: "M\xE9g nincs fut\xE1r hozz\xE1rendelve",
    deliveryInfo: "Kisz\xE1ll\xEDt\xE1si inform\xE1ci\xF3",
    courierInfo: "Fut\xE1r adatai",
    paymentSection: "Fizet\xE9s",
    paymentPendingInfo: "Fizet\xE9s f\xFCgg\u0151ben",
    paymentDescription: "Fizet\xE9si le\xEDr\xE1s",
    createPaymentLink: "Fizet\xE9si link l\xE9trehoz\xE1sa",
    handoff: "\xC1tad\xE1s",
    markDelivered: "K\xE9zbes\xEDtve",
    cancel: "M\xE9gse",
    statusLabel: "St\xE1tusz",
    statusProgress: "Folyamatban",
    providerLabel: "Szolg\xE1ltat\xF3",
    trackingLabel: "Nyomk\xF6vet\xE9si sz\xE1m",
    addressLabel: "C\xEDm",
    costLabel: "K\xF6lts\xE9g",
    scheduledLabel: "\xDCtemezve",
    createdAtLabel: "L\xE9trehozva",
    deliveredAtLabel: "K\xE9zbes\xEDtve",
    handoffAtLabel: "\xC1tadva",
    worksheetIdLabel: "Munkalap",
    enterProvider: "Szolg\xE1ltat\xF3 megad\xE1sa",
    enterTracking: "Nyomk\xF6vet\xE9si sz\xE1m megad\xE1sa",
    enterAmount: "\xD6sszeg megad\xE1sa",
    statusLabels: {
      requested: "K\xE9rve",
      paymentPending: "Fizet\xE9sre v\xE1r",
      paid: "Fizetve",
      dispatched: "Elind\xEDtva",
      delivered: "K\xE9zbes\xEDtve",
      cancelled: "Visszavonva"
    },
    cancelDelivery: "Kisz\xE1ll\xEDt\xE1s lemond\xE1sa"
  },
  contractPriceList: {
    title: "Szerz\u0151d\xE9ses \xE1rjegyz\xE9k",
    orderableOnly: "Csak a list\xE1ban szerepl\u0151 cikkek rendelhet\u0151k",
    importButton: "Import (.xlsx)",
    templateDownload: "Sablon",
    export: "Export\xE1l\xE1s",
    importPreview: "Import el\u0151n\xE9zet \u2014 ellen\u0151rizd a v\xE1ltoz\xE1sokat",
    confirmImport: "Import v\xE9grehajt\xE1sa",
    importSuccess: "Sikeres import: {successful}/{total} t\xE9tel",
    importPartial: "R\xE9szleges import: {successful} sikeres, {failed} hib\xE1s",
    importError: "Hiba az import\xE1l\xE1s sor\xE1n",
    annualLimitWarning: "\xC9ves m\xF3dos\xEDt\xE1si limit!",
    annualLimitDescription: "Az utols\xF3 \xE1rjegyz\xE9k import kevesebb mint 12 h\xF3napja volt. Biztosan fel\xFCl akarod b\xEDr\xE1lni?",
    forceImport: "Fel\xFClb\xEDr\xE1l\xE1s \xE9s import",
    previewNew: "{count} \xFAj",
    previewChanged: "{count} m\xF3dosult",
    previewRemoved: "{count} t\xF6r\xF6lt",
    previewUnchanged: "{count} v\xE1ltozatlan",
    customerSku: "Vev\u0151i cikksz\xE1m",
    product: "Megnevez\xE9s",
    contractPrice: "Szerz\u0151d\xE9ses \xE1r",
    validFrom: "\xC9rv\xE9nyes t\xF3l",
    validUntil: "\xC9rv\xE9nyes ig",
    status: "St\xE1tusz",
    oldPrice: "R\xE9gi \xE1r",
    newPrice: "\xDAj \xE1r",
    change: "V\xE1ltoz\xE1s",
    noItems: "Nincs \xE1rjegyz\xE9k felt\xF6ltve",
    dragDrop: "T\xF6lts fel egy .xlsx f\xE1jlt az Import gombbal",
    itemCount: "{count} t\xE9tel az \xE1rjegyz\xE9kben",
    active: "Akt\xEDv",
    expired: "Lej\xE1rt",
    notYetValid: "M\xE9g nem \xE9rv\xE9nyes",
    notOrderable: "Nem rendelhet\u0151",
    diff: {
      NEW: "\xDAj",
      CHANGED: "M\xF3dosult",
      REMOVED: "T\xF6r\xF6lt",
      UNCHANGED: "V\xE1ltozatlan"
    }
  },
  crossSell: {
    title: "Vegyes sz\xE1mla",
    subtitle: "B\xE9rl\xE9s + v\xE1s\xE1rl\xE1s + kauci\xF3 egy sz\xE1ml\xE1n",
    addItem: "T\xE9tel hozz\xE1ad\xE1sa",
    itemType: "T\xE9tel t\xEDpus",
    rentalFee: "B\xE9rleti d\xEDj",
    product: "Term\xE9k",
    serviceFee: "Szerviz munkad\xEDj",
    servicePart: "Szerviz alkatr\xE9sz",
    deposit: "Kauci\xF3",
    handlingFee: "Kezel\xE9si k\xF6lts\xE9g",
    lateFee: "K\xE9sedelmi d\xEDj",
    discount: "Kedvezm\xE9ny",
    depositCard: "K\xE1rty\xE1s kauci\xF3",
    depositCash: "K\xE9szp\xE9nz kauci\xF3",
    revenueTotal: "Bev\xE9tel \xF6sszesen",
    depositTotal: "Kauci\xF3 (nem bev\xE9tel)",
    payableTotal: "Fizetend\u0151 \xF6sszesen",
    handlingFeeDescription: "K\xE1rty\xE1s kauci\xF3 kezel\xE9si k\xF6lts\xE9g (2%)",
    handlingFeeRefund: "Visszafizetend\u0151 kauci\xF3",
    noDeposit: "Nincs kauci\xF3",
    vatBreakdown: "\xC1FA bont\xE1s"
  },
  assetTransfer: {
    title: "K\xE9szlet \xE1tvezet\xE9s",
    toRentalEquipment: "\xC1tvezet\xE9s b\xE9rg\xE9pbe",
    toOwnedAsset: "\xC1tvezet\xE9s saj\xE1t eszk\xF6zbe",
    confirmTitle: "\xC1tvezet\xE9s meger\u0151s\xEDt\xE9se",
    confirmMessage: "Biztosan \xE1tvezeted a term\xE9ket? Az \xE1tvezet\xE9s nem vonhat\xF3 vissza.",
    success: "\xC1tvezet\xE9s sikeres",
    rentalCardCreated: "B\xE9rg\xE9p karton automatikusan l\xE9trehozva",
    depreciationCreated: "\xC9CS rekord automatikusan l\xE9trehozva (200k+ Ft)",
    noDepreciation: "\xC9CS nem sz\xFCks\xE9ges (\xE1r < 200.000 Ft)",
    note: "Megjegyz\xE9s (opcion\xE1lis)",
    errorNotProduct: "Csak \xE1ru t\xEDpus\xFA t\xE9tel vezethet\u0151 \xE1t",
    errorNotAvailable: "Csak el\xE9rhet\u0151 st\xE1tusz\xFA t\xE9tel vezethet\u0151 \xE1t"
  },
  releaseHub: {
    title: "rPI Delta",
    subtitle: "Legfrissebb fejleszt\xE9sek \xE9s jav\xEDt\xE1sok",
    tabs: {
      changelog: "V\xE1ltoz\xE1snapl\xF3",
      testing: "Release Tesztel\xE9s"
    },
    changelog: {
      version: "Verzi\xF3",
      date: "D\xE1tum",
      changes: "v\xE1ltoz\xE1s",
      expandAll: "\xD6sszes kinyit\xE1sa",
      collapseAll: "\xD6sszes bez\xE1r\xE1sa",
      types: {
        feature: "\xDAj funkci\xF3",
        fix: "Hibajav\xEDt\xE1s",
        improvement: "Fejleszt\xE9s",
        breaking: "Fontos v\xE1ltoz\xE1s"
      },
      testStepsBadge: "Tesztel\xE9s",
      noEntries: "M\xE9g nincsenek bejegyz\xE9sek."
    },
    testing: {
      summary: "\xD6sszesen",
      features: "funkci\xF3",
      steps: "l\xE9p\xE9s",
      expected: "Elv\xE1rt eredm\xE9ny",
      status: {
        passed: "Sikeres",
        failed: "Sikertelen",
        not_tested: "Nem tesztelt"
      },
      progress: "{done}/{total} tesztelve",
      exportCsv: "CSV export",
      changelogBadge: "V\xE1ltoz\xE1snapl\xF3",
      testedBy: "Tesztelte",
      comment: "Megjegyz\xE9s (opcion\xE1lis)...",
      save: "Ment\xE9s",
      noTests: "Nincs tesztel\xE9si l\xE9p\xE9s ehhez a verzi\xF3hoz.",
      retest: "\xDAjratesztel\xE9s",
      retestNote: "\xDAjratesztel\xE9s oka (opcion\xE1lis)...",
      retestConfirm: "\xDAjratesztel\xE9s ind\xEDt\xE1sa",
      retestCancel: "M\xE9gse",
      lastTest: "Utols\xF3",
      testers: "tesztel\u0151",
      retestCount: "{count}x tesztelve",
      history: "Tesztel\xE9si el\u0151zm\xE9nyek",
      historyEmpty: "Nincs kor\xE1bbi tesztel\xE9s.",
      historyError: "Nem siker\xFClt bet\xF6lteni az el\u0151zm\xE9nyeket.",
      historyRetry: "\xDAjrapr\xF3b\xE1l\xE1s",
      saveError: "A ment\xE9s nem siker\xFClt. Pr\xF3b\xE1ld \xFAjra.",
      retestError: "\xDAjratesztel\xE9s ind\xEDt\xE1sa nem siker\xFClt.",
      retestReason: "Ok",
      notTestedYet: "M\xE9g nem tesztelt",
      showSteps: "{count} tesztel\xE9si l\xE9p\xE9s megjelen\xEDt\xE9se",
      hideSteps: "{count} tesztel\xE9si l\xE9p\xE9s",
      previousTests: "{count} kor\xE1bbi",
      noPreviousTests: "0 kor\xE1bbi",
      retestNeeded: "\xDAjratesztel\xE9s sz\xFCks\xE9ges",
      passBtn: "Sikeres",
      failBtn: "Sikertelen",
      untested: "Nincs tesztelve",
      testedPct: "{done}/{total} tesztelve ({pct}%)",
      historyTestedAt: "Tesztelve",
      historyActiveFor: "{duration} ideig volt akt\xEDv",
      historyStepStats: "{checked}/{total} l\xE9p\xE9s pip\xE1lva",
      durationMinutes: "{n} percig",
      durationHours: "{n} \xF3r\xE1ig",
      durationDays: "{n} napig"
    },
    filters: {
      search: "Keres\xE9s...",
      showOlder: "Kor\xE1bbi verzi\xF3k ({count})",
      clearFilters: "Sz\u0171r\u0151k t\xF6rl\xE9se",
      results: "{filtered}/{total} bejegyz\xE9s",
      noResults: "Nincs tal\xE1lat a sz\u0171r\u0151kre.",
      categories: "Kateg\xF3ria",
      types: "T\xEDpus",
      statuses: "\xC1llapot"
    }
  },
  quote: {
    advance: {
      amount: "El\u0151leg \xF6sszege",
      confirm: "El\u0151leg meger\u0151s\xEDt\xE9se",
      deducted: "Levonva",
      exceedsTotal: "Az el\u0151leg meghaladja a v\xE9g\xF6sszeget",
      invalidAmount: "\xC9rv\xE9nytelen \xF6sszeg",
      method: "Fizet\xE9si m\xF3d",
      methodCard: "Bankk\xE1rtya",
      methodCash: "K\xE9szp\xE9nz",
      methodTransfer: "\xC1tutal\xE1s",
      paid: "El\u0151leg befizetve",
      paidAt: "Befizet\xE9s id\u0151pontja",
      pay: "El\u0151leg befizet\xE9se",
      payDescription: "El\u0151leg befizet\xE9s r\xF6gz\xEDt\xE9se",
      recordFailed: "El\u0151leg r\xF6gz\xEDt\xE9s sikertelen",
      recorded: "El\u0151leg r\xF6gz\xEDtve",
      refund: "El\u0151leg visszat\xE9r\xEDt\xE9s",
      refundBtn: "Visszat\xE9r\xEDt\xE9s",
      refundConfirm: "Visszat\xE9r\xEDt\xE9s meger\u0151s\xEDt\xE9se",
      refundFailed: "Visszat\xE9r\xEDt\xE9s sikertelen",
      refunded: "Visszat\xE9r\xEDtve",
      refundedLabel: "Visszat\xE9r\xEDtve"
    }
  },
  priLlm: {
    apiKeyPlaceholder: "\xDAj API kulcs megad\xE1sa...",
    userPerMin: "Felhaszn\xE1l\xF3 / perc",
    tenantPerMin: "Tenant / perc",
    userPerDay: "Felhaszn\xE1l\xF3 / nap",
    sonnetPerMin: "Sonnet / perc",
    requests: "K\xE9r\xE9sek",
    inputTokens: "Input tokenek",
    outputTokens: "Output tokenek",
    costUsd: "K\xF6lts\xE9g (USD)",
    title: "pRI Asszisztens Be\xE1ll\xEDt\xE1sok",
    apiConfigTitle: "API Konfigur\xE1ci\xF3",
    apiConfigDesc: "LLM provider \xE9s API kulcs be\xE1ll\xEDt\xE1sok",
    providerLabel: "Provider",
    apiKeyLabel: "API Kulcs",
    currentKeyLabel: "Jelenlegi:",
    enabledLabel: "pRI Enged\xE9lyezve",
    enabledDesc: "LLM v\xE1laszok enged\xE9lyez\xE9se a felhaszn\xE1l\xF3knak",
    testConnection: "Kapcsolat tesztel\xE9se",
    testOk: "OK \u2014 {model} ({latencyMs}ms)",
    testFailed: "Sikertelen",
    rateLimitTitle: "Rate Limiting & Kv\xF3t\xE1k",
    rateLimitDesc: "Felhaszn\xE1l\xF3i \xE9s tenant-szint\u0171 korl\xE1toz\xE1sok",
    monthlyQuotasTitle: "Havi kv\xF3t\xE1k (k\xE9r\xE9s/h\xF3)",
    tierStrategyTitle: "Tier strat\xE9gia",
    defaultTierLabel: "Alap\xE9rtelmezett tier",
    autoDowngradeLabel: "Auto-downgrade",
    autoDowngradeDesc: "Kv\xF3ta el\xE9r\xE9se ut\xE1n olcs\xF3bb tier-re v\xE1lt",
    usageStatsTitle: "Haszn\xE1lati Statisztik\xE1k",
    usageStatsDesc: "Aktu\xE1lis h\xF3nap \xF6sszes\xEDtett adatai",
    noUsageData: "Nincs haszn\xE1lati adat ebben a h\xF3napban.",
    saveButton: "Be\xE1ll\xEDt\xE1sok ment\xE9se",
    saveSuccessTitle: "Mentve",
    saveSuccessDesc: "A pRI be\xE1ll\xEDt\xE1sok sikeresen friss\xEDtve.",
    saveErrorTitle: "Hiba",
    unknownError: "Ismeretlen hiba.",
    networkError: "H\xE1l\xF3zati hiba"
  },
  goodsReceipt: {
    detail: {
      backToList: "Vissza a list\xE1hoz",
      notFound: "Bev\xE9telez\xE9s nem tal\xE1lhat\xF3",
      completeConfirm: "Biztosan befejezi a bev\xE9telez\xE9st? A k\xE9szlet friss\xFCl.",
      completing: "Befejez\xE9s...",
      complete: "Befejez\xE9s",
      unresolvedCount: "{count} feloldatlan elt\xE9r\xE9s",
      supplier: "Besz\xE1ll\xEDt\xF3",
      createdAt: "L\xE9trehozva",
      completedAt: "Befejezve",
      linkedAvizo: "Kapcsolt aviz\xF3",
      notes: "Megjegyz\xE9s",
      items: "T\xE9telek",
      productCode: "Cikksz\xE1m",
      productName: "Term\xE9k",
      expectedQty: "Elv\xE1rt",
      receivedQty: "\xC9rkezett",
      difference: "Elt\xE9r\xE9s",
      ok: "OK",
      discrepancies: "Elt\xE9r\xE9sek",
      expected: "Elv\xE1rt",
      actual: "T\xE9nyleges",
      resolved: "Feloldva",
      resolutionNotePlaceholder: "Felold\xE1s megjegyz\xE9se...",
      resolveButton: "Felold\xE1s"
    },
    statusLabels: {
      draft: "V\xE1zlat",
      inProgress: "Folyamatban",
      discrepancy: "Elt\xE9r\xE9s",
      completed: "Befejezve"
    },
    discrepancyTypes: {
      shortage: "Hi\xE1ny",
      surplus: "T\xF6bblet",
      damaged: "S\xE9r\xFClt",
      wrong_item: "Rossz term\xE9k"
    },
    shipping: {
      title: "Sz\xE1ll\xEDt\xE1si d\xEDj sz\xE9toszt\xE1s",
      costLabel: "Sz\xE1ll\xEDt\xE1si d\xEDj (Ft)",
      costPlaceholder: "pl. 15000",
      distribute: "Sz\xE9toszt\xE1s",
      allocationTitle: "Sz\xE1ll\xEDt\xE1si d\xEDj allok\xE1ci\xF3",
      originalPrice: "Eredeti egys\xE9g\xE1r",
      proportion: "Ar\xE1ny",
      allocation: "Sz\xE1ll\xEDt\xE1si d\xEDj",
      adjustedPrice: "Korrig\xE1lt egys\xE9g\xE1r"
    },
    form: {
      title: "\xDAj bev\xE9telez\xE9s",
      linkAvizo: "Kapcsol\xE1s aviz\xF3hoz",
      noAvizo: "Nincs aviz\xF3",
      itemsLabel: "t\xE9tel",
      avizoHint: "V\xE1lassz egy f\xFCgg\u0151ben l\xE9v\u0151 aviz\xF3t a t\xE9telek automatikus kit\xF6lt\xE9s\xE9hez",
      supplier: "Besz\xE1ll\xEDt\xF3",
      supplierPlaceholder: "Besz\xE1ll\xEDt\xF3 keres\xE9se\u2026",
      notes: "Megjegyz\xE9s",
      notesPlaceholder: "Megjegyz\xE9s a bev\xE9telez\xE9shez\u2026",
      items: "T\xE9telek",
      addItem: "T\xE9tel hozz\xE1ad\xE1sa",
      productCode: "Cikksz\xE1m",
      productCodePlaceholder: "pl. 12345",
      productName: "Megnevez\xE9s",
      productNamePlaceholder: "Term\xE9k neve",
      expectedQty: "V\xE1rt menny.",
      receivedQty: "\xC9rkezett menny.",
      unitPrice: "Egys\xE9g\xE1r",
      purchaseCategory: "Beszerz\xE9si kateg\xF3ria",
      locationCode: "T\xE1rhely k\xF3d",
      locationPlaceholder: "pl. A-01-02",
      packageSplitting: "Csomagbont\xE1s",
      packageQty: "Csomag menny.",
      unitsPerPackage: "Egys\xE9g / csomag",
      totalUnits: "\xD6sszes egys\xE9g",
      categories: {
        aru: "\xC1ru",
        beruhazas: "Beruh\xE1z\xE1s",
        berendezes: "Berendez\xE9s",
        egyeb: "Egy\xE9b",
        rezsi: "Rezsi"
      }
    },
    allStatuses: "Minden st\xE1tusz",
    hasDiscrepancy: "Elt\xE9r\xE9ssel",
    newReceipt: "\xDAj bev\xE9telez\xE9s",
    noAvizos: "Nincs aviz\xF3",
    noReceipts: "Nincs bev\xE9telez\xE9s",
    searchPlaceholder: "Keres\xE9s cikksz\xE1m, besz\xE1ll\xEDt\xF3 szerint\u2026",
    subtitle: "Be\xE9rkez\u0151 \xE1ruk \xE9s aviz\xF3k kezel\xE9se",
    title: "Bev\xE9telez\xE9sek",
    avizo: {
      expectedDate: "V\xE1rhat\xF3 d\xE1tum",
      itemCount: "T\xE9telek sz\xE1ma",
      notes: "Megjegyz\xE9s",
      startReceipt: "Bev\xE9telez\xE9s ind\xEDt\xE1sa",
      supplier: "Besz\xE1ll\xEDt\xF3"
    },
    stats: {
      completedThisMonth: "Befejezett (e h\xF3nap)",
      inProgress: "Folyamatban",
      total: "\xD6sszes",
      withDiscrepancy: "Elt\xE9r\xE9ssel"
    },
    table: {
      discrepancy: "Elt\xE9r\xE9s",
      itemCount: "T\xE9telsz\xE1m",
      receiptNumber: "Bizonylatsz\xE1m",
      receivedDate: "\xC9rkez\xE9s d\xE1tuma",
      supplier: "Besz\xE1ll\xEDt\xF3"
    },
    tabs: {
      avizos: "Aviz\xF3k",
      receipts: "Bev\xE9telez\xE9sek"
    }
  },
  packages: {
    title: "Csomagok",
    subtitle: "Term\xE9k- \xE9s szolg\xE1ltat\xE1scsomagok kezel\xE9se",
    createNew: "\xDAj csomag",
    editPackage: "Csomag szerkeszt\xE9se",
    editor: {
      sharedBanner: "Ez a csomag {count} g\xE9ppel megosztva. V\xE1ltoz\xE1s mindre hat.",
      conflictTitle: "Csomag megosztva",
      conflictSubtext: "V\xE1ltoz\xE1s minden g\xE9pre hat. Hogyan szeretn\xE9d kezelni?",
      conflictApplyAll: "Mindegyikre",
      conflictApplyAllDesc: "A master csomag m\xF3dosul. Minden linkelt g\xE9p az \xFAj verzi\xF3t l\xE1tja.",
      conflictCopyForThis: "Csak erre",
      conflictCopyForThisDesc: "\xDAj variant csomag j\xF6n l\xE9tre a kiv\xE1lasztott g\xE9pre. A t\xF6bbi g\xE9p a v\xE1ltozatlan master-t haszn\xE1lja. Figyelem: a mostani szerkeszt\xE9si m\xF3dos\xEDt\xE1said NEM ker\xFClnek \xE1t a variantra \u2014 ott \xFAjra kell szerkesztened.",
      conflictForking: "Variant l\xE9trehoz\xE1sa...",
      conflictCopyTargetPlaceholder: "V\xE1lassz g\xE9pet...",
      conflictCopyTargetAriaLabel: "C\xE9l-g\xE9p a fork-hoz"
    },
    editorSubtitle: "Csomag \xF6ssze\xE1ll\xEDt\xE1sa \xE9s \xE1raz\xE1s be\xE1ll\xEDt\xE1sa",
    packageCode: "Csomag k\xF3d",
    packageCodePlaceholder: "pl. PKG-001",
    packageName: "Csomag neve",
    packageNamePlaceholder: "pl. B\xE9rleti alapcsomag",
    noPackages: "Nincs csomag",
    searchPlaceholder: "Keres\xE9s n\xE9v vagy k\xF3d alapj\xE1n...",
    displayedCount: "{count} csomag megjelen\xEDtve",
    copy: "M\xE1sol\xE1s",
    basicInfo: "Alapadatok",
    scopeLabel: "Hat\xF3k\xF6r",
    descriptionPlaceholder: "Csomag le\xEDr\xE1sa...",
    packageItems: "Csomag t\xE9telek",
    noItems: "M\xE9g nincsenek t\xE9telek. Keressen term\xE9keket a jobb oldali panelen.",
    moveUp: "Felfel\xE9 mozgat\xE1s",
    moveDown: "Lefel\xE9 mozgat\xE1s",
    productSearch: "Term\xE9k keres\xE9s",
    searchProductPlaceholder: "Keres\xE9s term\xE9k n\xE9v vagy cikksz\xE1m alapj\xE1n...",
    noSearchResults: "Nincs tal\xE1lat",
    alreadyAdded: "Hozz\xE1adva",
    pricing: "\xC1raz\xE1s",
    pricingModelLabel: "\xC1raz\xE1si modell",
    fixedPriceLabel: "Fix \xE1r (Ft)",
    discountPercentLabel: "Kedvezm\xE9ny (%)",
    validFrom: "\xC9rv\xE9nyes ett\u0151l",
    validUntil: "\xC9rv\xE9nyes eddig",
    calculator: "Kalkul\xE1tor",
    itemsTotal: "T\xE9telek \xF6sszesen",
    packagePriceLabel: "Csomag \xE1r",
    savingsLabel: "Megtakar\xEDt\xE1s",
    itemCount: "{count} t\xE9tel",
    expired: "Lej\xE1rt",
    daysLeft: "{count} nap van h\xE1tra",
    type: {
      rental: "B\xE9rl\xE9s",
      sales: "\xC9rt\xE9kes\xEDt\xE9s",
      service: "Szerviz",
      mixed: "Vegyes",
      promotional: "Akci\xF3s",
      franchise: "Franchise"
    },
    status: {
      active: "Akt\xEDv",
      inactive: "Inakt\xEDv",
      draft: "V\xE1zlat"
    },
    pricingModel: {
      fixed: "Fix \xE1ras",
      discounted: "Kedvezm\xE9nyes",
      tiered: "S\xE1vos"
    },
    scopeValue: {
      central: "K\xF6zponti",
      local: "Helyi"
    },
    itemType: {
      product: "Term\xE9k",
      service: "Szerviz",
      rental_equipment: "B\xE9rg\xE9p"
    },
    upsell: {
      banner: "Tudta?",
      cheaperBy: "csomagban {percent}%-kal olcs\xF3bb!",
      contents: "Csomag tartalma",
      individually: "Egy\xE9nileg",
      inPackage: "Csomagban",
      perDay: "/nap",
      choosePackage: "Csomagot v\xE1lasztom",
      keepIndividual: "Maradok az egyedi g\xE9pn\xE9l",
      savings: "megtakar\xEDt\xE1s",
      savingsPercent: "{percent}% megtakar\xEDt\xE1s"
    },
    linkedCategories: "Kapcsol\xF3d\xF3 g\xE9p kateg\xF3ri\xE1k",
    linkedCategoriesDesc: "Milyen t\xEDpus\xFA g\xE9pekn\xE9l javasolja a rendszer ezt a csomagot",
    scope: {
      sectionTitle: "Csomag hat\xF3k\xF6re",
      mode: {
        category: "Kateg\xF3ria alap\xFA",
        equipment: "Konkr\xE9t b\xE9rg\xE9pek"
      },
      switchConfirmTitle: "Biztosan v\xE1ltasz?",
      switchConfirmBody: "A jelenleg kiv\xE1lasztott {count} elem el fog veszni, ha \xE1tv\xE1lt a m\xE1sik m\xF3dra.",
      switchConfirmOk: "Igen, v\xE1ltok",
      switchConfirmCancel: "M\xE9gsem",
      equipment: {
        selectedTitle: "Kiv\xE1lasztott b\xE9rg\xE9pek ({count})",
        selectedEmpty: "M\xE9g nincs b\xE9rg\xE9p kiv\xE1lasztva",
        searchTitle: "B\xE9rg\xE9p keres\xE9s",
        searchPlaceholder: "G\xE9pn\xE9v vagy cikksz\xE1m...",
        searchEmpty: "Nincs tal\xE1lat",
        alreadyAdded: "M\xE1r hozz\xE1adva",
        add: "Hozz\xE1ad\xE1s",
        remove: "Elt\xE1vol\xEDt\xE1s"
      },
      validationError: {
        categoryRequired: "Legal\xE1bb 1 kateg\xF3ri\xE1t ki kell v\xE1lasztani",
        equipmentRequired: "Legal\xE1bb 1 b\xE9rg\xE9pet ki kell v\xE1lasztani"
      }
    },
    productDetail: {
      linkedPackagesTitle: "Ez a b\xE9rg\xE9p a k\xF6vetkez\u0151 csomagokban szerepel:"
    },
    item: {
      category: "Besorol\xE1s",
      categoryOption: {
        free: "Ingyenes",
        rentable: "B\xE9relhet\u0151",
        consignment: "Bizom\xE1nyos"
      },
      defaultQuantity: "Alap menny.",
      isQuantityEditable: "Menny. szerk.",
      visibleOnWebshop: "Webshopban l\xE1tszik"
    }
  },
  manufacturing: {
    title: "Gy\xE1rt\xE1s",
    bom: {
      title: "Anyagjegyz\xE9k (BOM)",
      subtitle: "Anyagjegyz\xE9kek kezel\xE9se \xE9s szerkeszt\xE9se",
      bomCode: "BOM k\xF3d",
      createNew: "\xDAj BOM",
      editBom: "BOM szerkeszt\xE9se",
      editorSubtitle: "Anyagjegyz\xE9k \xF6ssze\xE1ll\xEDt\xE1sa \xE9s komponensek kezel\xE9se",
      basicInfo: "Alapadatok",
      outputProduct: "Kimeneti term\xE9k",
      outputQuantity: "Kimeneti mennyis\xE9g",
      searchOutputProduct: "Kimeneti term\xE9k keres\xE9se...",
      descriptionPlaceholder: "BOM le\xEDr\xE1sa...",
      validFrom: "\xC9rv\xE9nyes ett\u0151l",
      validUntil: "\xC9rv\xE9nyes eddig",
      components: "Komponensek",
      noLines: "M\xE9g nincsenek komponensek. Keress \xE9s adj hozz\xE1 a jobb panelr\u0151l.",
      addComponent: "Komponens hozz\xE1ad\xE1sa",
      searchComponentPlaceholder: "Term\xE9k keres\xE9se (n\xE9v, SKU)...",
      noSearchResults: "Nincs tal\xE1lat",
      alreadyAdded: "M\xE1r hozz\xE1adva",
      lineCount: "{count} komponens",
      displayedCount: "{count} BOM megjelen\xEDtve",
      noBoms: "Nincsenek anyagjegyz\xE9kek",
      searchPlaceholder: "Keres\xE9s k\xF3d vagy le\xEDr\xE1s alapj\xE1n...",
      optional: "Opcion\xE1lis",
      required: "K\xF6telez\u0151",
      toggleOptional: "Opcion\xE1lis/k\xF6telez\u0151 v\xE1lt\xE1s",
      moveUp: "Felfel\xE9 mozgat\xE1s",
      moveDown: "Lefel\xE9 mozgat\xE1s"
    },
    productionOrder: {
      title: "Gy\xE1rt\xE1si rendel\xE9sek",
      subtitle: "Gy\xE1rt\xE1si rendel\xE9sek kezel\xE9se \xE9s nyomon k\xF6vet\xE9se",
      orderNumber: "Rendel\xE9ssz\xE1m",
      createNew: "\xDAj gy\xE1rt\xE1si rendel\xE9s",
      product: "Term\xE9k",
      planned: "Tervezett",
      actual: "T\xE9nyleges",
      plannedQty: "Tervezett mennyis\xE9g",
      actualQty: "T\xE9nyleges mennyis\xE9g",
      plannedStart: "Tervezett kezd\xE9s",
      plannedEnd: "Tervezett befejez\xE9s",
      progress: "Halad\xE1s",
      phases: "F\xE1zisok",
      phasesCompleted: "f\xE1zis k\xE9sz",
      plan: "Tervez\xE9s",
      startProduction: "Gy\xE1rt\xE1s ind\xEDt\xE1sa",
      complete: "Befejez\xE9s",
      startPhase: "F\xE1zis ind\xEDt\xE1sa",
      completePhase: "F\xE1zis befejez\xE9se",
      recordScrap: "Selejt r\xF6gz\xEDt\xE9se",
      confirmScrap: "Selejt meger\u0151s\xEDt\xE9se",
      scrapReason: "Selejt ok",
      scrapReasonPlaceholder: "Mi okozta a selejtez\xE9st?",
      scrap: "Selejt",
      started: "Elkezdve",
      completed: "Befejezve",
      duration: "Id\u0151tartam",
      noOrders: "Nincsenek gy\xE1rt\xE1si rendel\xE9sek",
      searchPlaceholder: "Keres\xE9s rendel\xE9ssz\xE1m alapj\xE1n...",
      displayedCount: "{count} rendel\xE9s megjelen\xEDtve",
      notFound: "Gy\xE1rt\xE1si rendel\xE9s nem tal\xE1lhat\xF3"
    },
    phase: {
      preparation: "El\u0151k\xE9sz\xEDt\xE9s",
      manufacturing: "Gy\xE1rt\xE1s",
      qc: "Min\u0151s\xE9gellen\u0151rz\xE9s",
      receipt: "Bev\xE9telez\xE9s"
    },
    phaseStatus: {
      pending: "V\xE1rakozik",
      in_progress: "Folyamatban",
      completed: "K\xE9sz",
      skipped: "Kihagyva"
    },
    lotBatch: {
      title: "T\xE9tel/Sarzs",
      lotNumber: "T\xE9telsz\xE1m",
      qualityStatus: "Min\u0151s\xE9gi st\xE1tusz",
      producedAt: "Gy\xE1rt\xE1s d\xE1tuma",
      noLots: "Nincsenek r\xF6gz\xEDtett t\xE9telek"
    },
    status: {
      active: "Akt\xEDv",
      inactive: "Inakt\xEDv",
      draft: "V\xE1zlat",
      planned: "Tervezett",
      in_progress: "Folyamatban",
      completed: "Befejezett",
      cancelled: "T\xF6r\xF6lve"
    },
    bomType: {
      assembly: "\xD6sszeszerel\xE9s",
      kit: "Kit/Csomag",
      refurbishment: "Fel\xFAj\xEDt\xE1s",
      custom: "Egyedi"
    },
    qualityStatus: {
      pending: "F\xFCgg\u0151ben",
      passed: "Megfelelt",
      failed: "Nem felelt meg",
      partial: "R\xE9szben megfelelt"
    },
    refurbishment: {
      title: "Fel\xFAj\xEDt\xE1s",
      start: "Fel\xFAj\xEDt\xE1s ind\xEDt\xE1sa",
      complete: "Fel\xFAj\xEDt\xE1s befejez\xE9se",
      approve: "J\xF3v\xE1hagy\xE1s",
      reject: "Elutas\xEDt\xE1s",
      history: "Fel\xFAj\xEDt\xE1si el\u0151zm\xE9nyek",
      sourceWorksheet: "Forr\xE1s munkalap",
      sourceEquipment: "Forr\xE1s b\xE9rg\xE9p",
      outputProduct: "Kimeneti term\xE9k",
      outputSku: "Kimeneti cikksz\xE1m",
      qualityCheck: "Min\u0151s\xE9gellen\u0151rz\xE9s",
      approved: "J\xF3v\xE1hagyva \u2014 \xFAj term\xE9k l\xE9trehozva",
      rejected: "Elutas\xEDtva \u2014 selejt r\xF6gz\xEDtve",
      noHistory: "Nincsenek fel\xFAj\xEDt\xE1si el\u0151zm\xE9nyek"
    }
  },
  consignment: {
    dashboard: {
      title: "Bizom\xE1ny \xD6sszes\xEDt\u0151",
      outstandingValue: "Kint l\xE9v\u0151 \xE9rt\xE9k",
      partnerCount: "Partnerek sz\xE1ma",
      oldest: "Legr\xE9gebbi",
      daysAgo: "{days} napja",
      overdueWarning: "30 napon t\xFAli",
      overduePartners: "{count} partner",
      overdueRentals: "{count} b\xE9rl\xE9s",
      noActive: "Nincs akt\xEDv bizom\xE1ny"
    }
  },
  helpdesk: {
    screenLabel: "K\xE9perny\u0151 / Men\xFCpont",
    screenPlaceholder: "Pl.: B\xE9rl\xE9s > Akt\xEDv b\xE9rl\xE9sek > Visszav\xE9tel",
    bugDescLabel: "Hiba le\xEDr\xE1sa",
    featureDescLabel: "Ig\xE9ny le\xEDr\xE1sa",
    questionDescLabel: "K\xE9rd\xE9sed",
    guidedActionFieldLabel: "Mit csin\xE1ltam:",
    guidedActionPrefix: "Mit csin\xE1ltam: ",
    actionPlaceholder: "Pl.: R\xE1kattintottam a Ment\xE9s gombra",
    guidedResultFieldLabel: "Mi t\xF6rt\xE9nt:",
    guidedResultPrefix: "Mi t\xF6rt\xE9nt: ",
    resultPlaceholder: "Pl.: Hiba\xFCzenet jelent meg",
    guidedExpectedFieldLabel: "Mi lett volna j\xF3:",
    guidedExpectedPrefix: "Mi lett volna j\xF3: ",
    expectedPlaceholder: "Pl.: Az adatnak ment\u0151dnie kellett volna",
    freeTextModeBtn: "Szabad sz\xF6veg m\xF3d \u2192",
    bugPlaceholder: "Mit csin\xE1lt\xE1l? Mi t\xF6rt\xE9nt? Mi lett volna a j\xF3?",
    featurePlaceholder: "Mit szeretn\xE9l? Hogyan kellene m\u0171k\xF6dnie?",
    questionPlaceholder: "\xCDrd le a k\xE9rd\xE9sed...",
    guidedModeBtn: "\u2190 Guided m\xF3d (seg\xEDt a le\xEDr\xE1sban)",
    duplicateWarningTitle: "\u26A0 Hasonl\xF3 bejelent\xE9s m\xE1r l\xE9tezik:",
    reasonLabel: "Mi\xE9rt fontos?",
    reasonPlaceholder: "Pl.: Havi z\xE1r\xE1shoz kell, most k\xE9zzel sz\xE1molunk",
    screenshotLabel: "K\xE9perny\u0151k\xE9p(ek)",
    tabNewReport: "\xDAj bejelent\xE9s",
    tabMyReports: "Bejelent\xE9seim",
    reporterLabel: "Ki jelenti be?",
    moduleLabel: "Modul",
    selectPlaceholder: "\u2014 V\xE1lassz \u2014",
    severityLabel: "S\xFAlyoss\xE1g",
    priorityLabel: "Priorit\xE1s",
    clearDescriptionBtn: "\u2715 T\xF6rl\xE9s",
    clearDescriptionTitle: "Le\xEDr\xE1s t\xF6rl\xE9se",
    screenshotMax: "\u2014 max {max} db",
    screenshotPasteHint: "ide a screenshot",
    screenshotClickHint: "vagy kattints / h\xFAzd ide a k\xE9pet",
    screenshotCount: "{count} / {max} k\xE9p",
    autoCaptureTitle: "\u26A0 Automatikusan gy\u0171jt\xF6tt adatok",
    attachConsoleErrors: "{count} console hiba csatol\xE1sa",
    attachFailedApis: "{count} sikertelen API h\xEDv\xE1s csatol\xE1sa",
    submitting: "K\xFCld\xE9s...",
    submit: "Bek\xFCld\xE9s",
    resetFormTitle: "\u0170rlap \xFCr\xEDt\xE9se",
    openSpreadsheet: "Helpdesk t\xE1bl\xE1zat megnyit\xE1sa Google Sheets-ben \u2192",
    loading: "Bet\xF6lt\xE9s...",
    noTickets: "M\xE9g nincs bejelent\xE9sed.",
    selectReporterFirst: 'El\u0151sz\xF6r v\xE1laszd ki a neved az "\xDAj bejelent\xE9s" f\xFCl\xF6n!',
    successTitle: "K\xF6sz\xF6nj\xFCk!",
    successMessage: "A bejelent\xE9s elmentve.",
    openInSpreadsheet: "Megnyit\xE1s a t\xE1bl\xE1zatban \u2192",
    fabTooltip: "Helpdesk (Ctrl+Shift+H)",
    alertMissingFields: "K\xE9rj\xFCk t\xF6ltsd ki a k\xF6telez\u0151 mez\u0151ket! (Bejelent\u0151, Modul, Le\xEDr\xE1s)",
    alertMissingSeverity: "K\xE9rj\xFCk v\xE1laszd ki a s\xFAlyoss\xE1got!",
    alertSubmitError: "Hiba t\xF6rt\xE9nt: {error}",
    unknownError: "Ismeretlen hiba",
    type: {
      bug: "Hiba",
      feature: "Ig\xE9ny",
      question: "K\xE9rd\xE9s"
    }
  },
  pri: {
    inputPlaceholder: "K\xE9rdezz b\xE1rmit...",
    sendLabel: "K\xFCld\xE9s",
    welcome: {
      greeting: "Szia! \xC9n vagyok pRI, a digit\xE1lis koll\xE9g\xE1d.",
      subtitle: "Miben seg\xEDthetek?",
      howToFallback: "Hogyan csin\xE1ljam?",
      whatIsFallback: "Mi ez az oldal?",
      expiringRentalsLabel: "Lej\xE1r\xF3 b\xE9rl\xE9sek",
      expiringRentalsMessage: "Mutasd a lej\xE1r\xF3 b\xE9rl\xE9seket!",
      openWorksheetsLabel: "Nyitott munkalapok",
      openWorksheetsMessage: "Mutasd a nyitott munkalapokat!"
    }
  },
  priceInput: {
    netLabel: "Nett\xF3",
    grossLabel: "Brutt\xF3",
    vatRate: "\xC1FA"
  },
  email: {
    templates: "Email Sablonok",
    templateList: "Sablon lista",
    editTemplate: "Sablon szerkeszt\xE9se",
    selectTemplate: "V\xE1lasszon sablont a list\xE1b\xF3l",
    subject: "T\xE1rgy",
    greeting: "\xDCdv\xF6zl\xE9s",
    body: "T\xF6rzs",
    cta: "CTA gomb",
    ctaUrl: "CTA URL",
    insertVariable: "V\xE1ltoz\xF3 beilleszt\xE9se",
    save: "Ment\xE9s",
    saving: "Ment\xE9s...",
    default: "Alap\xE9rtelmezett",
    customized: "Testreszabott",
    active: "Akt\xEDv",
    inactive: "Inakt\xEDv",
    locked: "Z\xE1rolva",
    editable: "Szerkeszthet\u0151",
    missingVariables: "Hi\xE1nyz\xF3 k\xF6telez\u0151 v\xE1ltoz\xF3k",
    saveSuccess: "Sablon mentve",
    version: "Verzi\xF3",
    lastUpdated: "Utolj\xE1ra m\xF3dos\xEDtva",
    source: "Forr\xE1s",
    preview: "El\u0151n\xE9zet",
    desktopPreview: "Asztali n\xE9zet",
    mobilePreview: "Mobil n\xE9zet",
    sendTestEmail: "Teszt email k\xFCld\xE9se",
    testEmailSent: "Teszt email elk\xFCldve",
    testEmailAddress: "C\xE9l email c\xEDm",
    resetToDefault: "Vissza\xE1ll\xEDt\xE1s alap\xE9rtelmezettre",
    resetConfirm: "Biztosan vissza\xE1ll\xEDtja az alap\xE9rtelmezett sablont?",
    resetSuccess: "Sablon vissza\xE1ll\xEDtva",
    smtpSettings: "SMTP be\xE1ll\xEDt\xE1sok",
    smtpHost: "SMTP szerver",
    smtpPort: "Port",
    smtpUser: "Felhaszn\xE1l\xF3",
    smtpPass: "Jelsz\xF3",
    senderEmail: "K\xFCld\u0151 email",
    senderName: "K\xFCld\u0151 neve",
    dailyLimit: "Napi limit",
    testConnection: "Kapcsolat tesztel\xE9se",
    connectionOk: "Kapcsolat OK",
    connectionFailed: "Kapcsolat sikertelen",
    emailLogs: "K\xFCld\xE9si napl\xF3",
    recipientEmail: "C\xEDmzett",
    status: "St\xE1tusz",
    sentAt: "K\xFCld\xE9s id\u0151pontja",
    resend: "\xDAjrak\xFCld\xE9s",
    resendConfirm: "Biztosan \xFAjrak\xFCldi ezt az emailt?",
    resendSuccess: "Email \xFAjrak\xFCldve",
    filterByStatus: "Sz\u0171r\xE9s st\xE1tuszra",
    filterByTemplate: "Sz\u0171r\xE9s sablonra",
    todayStats: "Mai statisztika",
    bulkSend: {
      title: "T\xF6meges email k\xFCld\xE9s",
      settings: "K\xFCld\xE9si be\xE1ll\xEDt\xE1sok",
      template: "Email sablon",
      templatePlaceholder: "V\xE1lassz sablont...",
      language: "Nyelv",
      partnerPlaceholder: "Partner kiv\xE1laszt\xE1s \u2014 hamarosan el\xE9rhet\u0151. Jelenleg az \xF6sszes akt\xEDv partnernek k\xFCld.",
      variables: "V\xE1ltoz\xF3k",
      addVariable: "V\xE1ltoz\xF3 hozz\xE1ad\xE1sa",
      variableKey: "V\xE1ltoz\xF3 neve",
      variableValue: "\xC9rt\xE9ke",
      send: "K\xFCld\xE9s ind\xEDt\xE1sa",
      sending: "K\xFCld\xE9s folyamatban...",
      results: "Eredm\xE9nyek",
      queued: "V\xE1rakozik",
      skipped: "Kihagyva",
      failed: "Sikertelen",
      success: "T\xF6meges k\xFCld\xE9s elind\xEDtva!",
      errorNoTemplate: "K\xE9rlek v\xE1lassz sablont!",
      errorSend: "Hiba t\xF6rt\xE9nt a k\xFCld\xE9s sor\xE1n.",
      filters: {
        title: "Partner sz\u0171r\u0151",
        search: "Keres\xE9s n\xE9v / email / partnerk\xF3d alapj\xE1n",
        segmentLabel: "Szegmens",
        segment: {
          vip: "VIP",
          active: "Norm\xE1l",
          atRisk: "Kock\xE1zatos",
          inactive: "Inakt\xEDv"
        },
        hasActiveRentalLabel: "Akt\xEDv b\xE9rl\xE9s",
        hasActiveRental: {
          any: "Nem sz\u0171r",
          yes: "Van",
          no: "Nincs",
          expiring7d: "Lej\xE1r\xF3 7 napon bel\xFCl"
        },
        lastPurchaseDaysLabel: "Utols\xF3 v\xE1s\xE1rl\xE1s",
        lastPurchase: {
          any: "Nem sz\u0171r",
          "30": "30 napon bel\xFCl",
          "60": "60 napon bel\xFCl",
          "90plus": "90+ napja"
        },
        hasOutstandingLabel: "Tartoz\xE1s",
        hasOutstanding: {
          any: "Nem sz\u0171r",
          yes: "Van",
          no: "Nincs"
        },
        hasEmailOnly: "Csak email-lel rendelkez\u0151k",
        marketingConsentOnly: "Csak marketing consent-tel",
        resetFilters: "Sz\u0171r\u0151 t\xF6rl\xE9se",
        filteredCount: "Sz\u0171rt partnerek ({count})",
        selectedCount: "{count} / {max} partner kiv\xE1lasztva",
        selectAll: "\xD6sszes kijel\xF6l\xE9se",
        clearSelection: "Kijel\xF6l\xE9s t\xF6rl\xE9se",
        maxLimitWarning: "T\xF6bb mint {max} partner egyezik \u2014 finom\xEDtsd a sz\u0171r\xE9st",
        maxSelectionReached: "Max 500 partner / k\xFCld\xE9s (NFR1)",
        unsubscribedTooltip: "Leiratkozott partner \u2014 nem k\xFCldhet\u0151",
        loadMore: "Tov\xE1bb",
        loading: "Bet\xF6lt\xE9s...",
        emptyState: "Nincs a sz\u0171r\xE9snek megfelel\u0151 partner",
        sendWithCount: "K\xFCld\xE9s ({count} partner)",
        columns: {
          name: "N\xE9v",
          email: "Email",
          segment: "Szegmens",
          flags: "Jelz\u0151k"
        },
        flagMarketingConsent: "Marketing hozz\xE1j\xE1rul\xE1s",
        flagUnsubscribed: "Leiratkozott",
        flagOutstanding: "Tartoz\xE1s"
      },
      errorNoRecipients: "Nincs kijel\xF6lt partner",
      confirmModal: {
        title: "Meger\u0151s\xEDt\xE9s: {count} partner",
        description: "Nagy kamp\xE1ny \u2014 \xEDrd be a pontos recipient sz\xE1mot a v\xE9letlen k\xFCld\xE9s elker\xFCl\xE9s\xE9re.",
        hint: "Add meg: {count}",
        inputLabel: "Recipient sz\xE1m",
        inputPlaceholder: "Sz\xE1mjegyek",
        mismatchTooltip: "\xCDrd be a pontos sz\xE1mot",
        confirmButton: "K\xFCld\xE9s meger\u0151s\xEDt\xE9se",
        cancelButton: "M\xE9gse"
      },
      legalBasis: {
        TRANSACTIONAL: "Tranzakci\xF3s",
        MARKETING_CONSENT: "Marketing hozz\xE1j\xE1rul\xE1s",
        LEGITIMATE_INTEREST: "Jogos \xE9rdek",
        unknown: "Ismeretlen sablon",
        marketingWarning: "Ez marketing sablon \u2014 csak azok a partnerek kapj\xE1k meg, akik explicit opt-in-oltak (marketingConsent=true)."
      },
      skipReason: {
        no_email: "Nincs email",
        not_found: "Nem tal\xE1lhat\xF3",
        unsubscribed: "Leiratkozott",
        no_consent: "Nincs hozz\xE1j\xE1rul\xE1s"
      },
      skipBreakdown: "Kihagy\xE1s oka",
      sendDynamic: "{template} k\xFCld\xE9se {count} partnernek",
      preview: {
        openButton: "El\u0151n\xE9zet",
        title: "Sablon el\u0151n\xE9zet",
        subtitle: "{slug} ({language})",
        noTemplate: "V\xE1lassz sablont az el\u0151n\xE9zethez.",
        loading: "El\u0151n\xE9zet bet\xF6lt\xE9se\u2026",
        error: "Hiba",
        subjectLabel: "T\xE1rgy",
        iframeTitle: "Email sablon el\u0151n\xE9zet",
        sampleDataLabel: "Minta v\xE1ltoz\xF3k",
        closeButton: "Bez\xE1r\xE1s"
      },
      undo: {
        toastTitle: "K\xFCld\xE9s {seconds} m\xE1sodperc m\xFAlva\u2026",
        toastBody: "{count} partner",
        undoButton: "M\xE9gse",
        undoneToast: "K\xFCld\xE9s megszak\xEDtva",
        sendingNow: "K\xFCld\xE9s indul\u2026"
      },
      draft: {
        restoreTitle: "Elmentett piszkozat tal\xE1lhat\xF3",
        restoreSubtitle: "Mentve: {savedAt}",
        restoreButton: "Vissza\xE1ll\xEDt\xE1s",
        dismissButton: "Elvet\xE9s"
      },
      stats: {
        totalBatches: "Kamp\xE1nyok",
        activeCampaigns: "Akt\xEDv",
        completedToday: "Ma befejezett",
        successRate: "K\xE9zbes\xEDt\xE9si ar\xE1ny",
        windowHint: "Utols\xF3 {days} nap",
        activeHint: "Fut\xF3 / \xFCtemezett",
        completedHint: "Ma lez\xE1rult",
        successHint: "{recipients} c\xEDmzettb\u0151l"
      },
      allFailed: "Minden k\xFCld\xE9s sikertelen",
      asyncInfo: "A k\xFCld\xE9s a h\xE1tt\xE9rben t\xF6rt\xE9nik, az \xE1llapot friss\xFCl",
      description: "E-mail k\xFCld\xE9se a kiv\xE1lasztott partnereknek",
      error: "Hiba a k\xFCld\xE9s sor\xE1n",
      moreRecipients: "tov\xE1bbi",
      noEmailWarning: "N\xE9h\xE1ny kiv\xE1lasztott partnernek nincs e-mail c\xEDme",
      partialSuccess: "{queued} e-mail elk\xFCldve, {skipped} kihagyva",
      partnersSelected: "partner kijel\xF6lve",
      recipients: "C\xEDmzettek",
      selectLanguage: "Nyelv kiv\xE1laszt\xE1sa",
      selectTemplate: "Sablon kiv\xE1laszt\xE1sa",
      sendButton: "K\xFCld\xE9s",
      sendEmail: "E-mail k\xFCld\xE9se",
      successAll: "{count} e-mail a k\xFCld\xE9si sorba ker\xFClt"
    },
    template: {
      invoiceSent: "Sz\xE1mla k\xFCld\xE9s",
      invoiceOverdue: "Lej\xE1rt sz\xE1mla eml\xE9keztet\u0151",
      rentalConfirmation: "B\xE9rl\xE9s visszaigazol\xE1s",
      rentalOverdue: "Lej\xE1rt b\xE9rl\xE9s \xE9rtes\xEDt\xE9s",
      rentalDepositWarning: "Kauci\xF3 figyelmeztet\xE9s",
      worksheetCreated: "Munkalap l\xE9trehozva",
      worksheetReady: "Munkalap k\xE9sz",
      quoteSent: "\xC1raj\xE1nlat k\xFCld\xE9s",
      welcomePartner: "\xDCdv\xF6zl\u0151 email",
      paymentReceived: "Fizet\xE9s meg\xE9rkezett"
    },
    selectPartners: "V\xE1lassza ki a partnereket",
    bulkResult: "K\xFCld\xE9si eredm\xE9ny",
    queued: "Sorba \xE1ll\xEDtva",
    skipped: "Kihagyva",
    failedCount: "Sikertelen",
    scheduled: {
      title: "\xDCtemezett k\xFCld\xE9sek",
      sectionAriaLabel: "\xDCtemezett bulk-email batch-ek list\xE1ja",
      loading: "Bet\xF6lt\xE9s...",
      empty: "Jelenleg nincs \xFCtemezett k\xFCld\xE9s.",
      error: "Hiba a lista bet\xF6lt\xE9sekor: {message}",
      skippedSuffix: "{count} kihagyva",
      cancelButton: "Megszak\xEDt\xE1s",
      cancelling: "Megszak\xEDt\xE1s...",
      col: {
        template: "Sablon",
        scheduledAt: "Id\u0151pont",
        recipients: "C\xEDmzettek",
        status: "St\xE1tusz",
        legalBasis: "GDPR jogalap",
        actions: "M\u0171veletek"
      },
      cancelModal: {
        title: "\xDCtemezett k\xFCld\xE9s megszak\xEDt\xE1sa",
        description: "Biztosan megszak\xEDtja a(z) {templateSlug} sablon\xFA k\xFCld\xE9st {count} c\xEDmzettnek? A m\u0171velet nem visszavonhat\xF3, de \xFAjraind\xEDthat\xF3 manu\xE1lisan.",
        confirmButton: "Megszak\xEDtom",
        dismissButton: "M\xE9gse"
      },
      cancelToast: {
        success: "\xDCtemezett k\xFCld\xE9s megszak\xEDtva.",
        alreadyCancelled: "Ez a k\xFCld\xE9s m\xE1r kor\xE1bban megszak\xEDtva.",
        notCancellable: "A k\xFCld\xE9s m\xE1r {status} \xE1llapotban van \u2014 nem szak\xEDthat\xF3 meg.",
        race: "A k\xFCld\xE9s \xE9pp megkezd\u0151d\xF6tt \u2014 m\xE1r nem szak\xEDthat\xF3 meg.",
        notFound: "A megszak\xEDtand\xF3 k\xFCld\xE9s nem tal\xE1lhat\xF3.",
        error: "Hiba a megszak\xEDt\xE1s sor\xE1n."
      }
    }
  },
  documents: {
    panel: {
      title: "Dokumentumok",
      uploadButton: "Felt\xF6lt\xE9s",
      downloadButton: "Let\xF6lt\xE9s",
      deleteButton: "T\xF6rl\xE9s",
      deleteConfirm: "Biztosan t\xF6rl\xF6d ezt a dokumentumot?",
      deleteConfirmButton: "T\xF6rl\xE9s meger\u0151s\xEDt\xE9se",
      deleteCancel: "M\xE9gse",
      uploadSuccess: "Dokumentum sikeresen felt\xF6ltve.",
      deleteSuccess: "Dokumentum t\xF6r\xF6lve.",
      loading: "Dokumentumok bet\xF6lt\xE9se\u2026",
      empty: "Nincs csatolt dokumentum.",
      retry: "\xDAjra"
    },
    errors: {
      loadFailed: "Nem siker\xFClt bet\xF6lteni a dokumentumokat.",
      uploadFailed: "Felt\xF6lt\xE9s sikertelen: {message}",
      downloadFailed: "Let\xF6lt\xE9s sikertelen: {message}",
      deleteFailed: "T\xF6rl\xE9s sikertelen: {message}"
    },
    audit: {
      backToAdmin: "Vissza az adminhoz",
      title: "Dokumentum Audit Napl\xF3",
      subtitle: "Minden dokumentum m\u0171velet v\xE1ltoztat\xE1si napl\xF3ja GDPR Art. 30 szerint.",
      filters: "Sz\u0171r\u0151k",
      filterAction: "M\u0171velet",
      filterDocumentId: "Dokumentum ID",
      invalidUuid: "\xC9rv\xE9nytelen UUID form\xE1tum",
      allActions: "\xD6sszes m\u0171velet",
      pageSize: "Sor / oldal",
      clearFilters: "Sz\u0171r\u0151k t\xF6rl\xE9se",
      refresh: "Friss\xEDt\xE9s",
      exportCsv: "CSV export",
      exportSuccess: "CSV export k\xE9sz.",
      loading: "Audit napl\xF3 bet\xF6lt\xE9se\u2026",
      loadError: "Nem siker\xFClt bet\xF6lteni az audit napl\xF3t.",
      retry: "\xDAjra",
      empty: "Nincs tal\xE1lat a megadott sz\u0171r\u0151kkel.",
      previousPage: "El\u0151z\u0151",
      nextPage: "K\xF6vetkez\u0151",
      pageInfo: "Oldal {page}/{totalPages} \xB7 \xF6sszesen {total} sor",
      col: {
        performedAt: "Id\u0151pont",
        action: "M\u0171velet",
        documentId: "Dokumentum",
        performedBy: "Felhaszn\xE1l\xF3",
        ipAddress: "IP c\xEDm",
        metadata: "Metaadat"
      },
      action: {
        UPLOADED: "Felt\xF6ltve",
        DOWNLOADED: "Let\xF6ltve",
        VIEWED: "Megtekintve",
        SHARED_VIA_LINK: "Link megosztva",
        UPDATED: "M\xF3dos\xEDtva",
        DELETED: "T\xF6r\xF6lve",
        RESTORED: "Vissza\xE1ll\xEDtva",
        HASH_VERIFIED: "Hash ellen\u0151rz\xF6tt",
        HASH_MISMATCH: "Hash elt\xE9r\xE9s",
        ORPHAN_DETECTED: "\xC1rva tal\xE1lat"
      }
    }
  },
  esign: {
    error: {
      sessionNotFound: "Az al\xE1\xEDr\xE1si munkamenet nem tal\xE1lhat\xF3.",
      sessionExpired: "Az al\xE1\xEDr\xE1si munkamenet lej\xE1rt.",
      alreadySigned: "Az al\xE1\xEDr\xE1si munkamenet m\xE1r al\xE1 van \xEDrva.",
      invalidProvider: "\xC9rv\xE9nytelen al\xE1\xEDr\xE1si szolg\xE1ltat\xF3.",
      consentNotGiven: "A hozz\xE1j\xE1rul\xE1s nem lett megadva.",
      hashMismatch: "Az al\xE1\xEDr\xE1s hash ellen\u0151rz\xE9s sikertelen \u2014 a tartalom m\xF3dosulhatott.",
      tenantMismatch: "Az al\xE1\xEDr\xE1si munkamenet nem tal\xE1lhat\xF3.",
      internalError: "Bels\u0151 hiba az al\xE1\xEDr\xE1s feldolgoz\xE1sakor.",
      missingConsentBasic: "Az alapvet\u0151 hozz\xE1j\xE1rul\xE1s hi\xE1nyzik.",
      missingConsentDataProcessing: "Az adatkezel\xE9si hozz\xE1j\xE1rul\xE1s hi\xE1nyzik."
    },
    warning: {
      aesRequired: "500 000 Ft feletti kauci\xF3 eset\xE9n min\u0151s\xEDtett (AES) al\xE1\xEDr\xE1s aj\xE1nlott \u2014 a Sprint 2 alatt az egyszer\u0171 (SES) al\xE1\xEDr\xE1s tov\xE1bbra is elfogadott.",
      sessionExpiresSoon: "A munkamenet hamarosan lej\xE1r."
    },
    verify: {
      passed: "Al\xE1\xEDr\xE1s sikeresen ellen\u0151rizve.",
      hashChainBroken: "Az al\xE1\xEDr\xE1si l\xE1nc integrit\xE1sa s\xE9r\xFClt.",
      evidenceHashMismatch: "A bizony\xEDt\xE9k hash nem egyezik a r\xF6gz\xEDtett \xE9rt\xE9kkel.",
      sessionTerminal: "A munkamenet lez\xE1rt \xE1llapotban van (lej\xE1rt vagy visszavont)."
    },
    action: {
      createSession: "Al\xE1\xEDr\xE1s ind\xEDt\xE1sa",
      sign: "Al\xE1\xEDr\xE1s",
      verify: "Ellen\u0151rz\xE9s",
      viewAudit: "Audit napl\xF3 megtekint\xE9se"
    },
    consent: {
      basicLabel: "Elolvastam \xE9s elfogadom a szerz\u0151d\xE9s felt\xE9teleit.",
      dataProcessingLabel: "Hozz\xE1j\xE1rulok a szem\xE9lyes adataim kezel\xE9s\xE9hez az al\xE1\xEDr\xE1s c\xE9lj\xE1b\xF3l."
    },
    dialog: {
      title: "Szerz\u0151d\xE9s al\xE1\xEDr\xE1sa",
      success: "A szerz\u0151d\xE9s sikeresen al\xE1\xEDrva.",
      sessionLoading: "Al\xE1\xEDr\xE1si munkamenet el\u0151k\xE9sz\xEDt\xE9se\u2026",
      padHint: "\xCDrja al\xE1 az ujj\xE1val vagy tollal a mez\u0151ben",
      payloadTooLarge: "Az al\xE1\xEDr\xE1s t\xFAl nagy (max 512 KiB). K\xE9rj\xFCk, t\xF6r\xF6lje \xE9s \xEDrja al\xE1 \xFAjra.",
      consentRequired: "Mindk\xE9t hozz\xE1j\xE1rul\xE1s megad\xE1sa k\xF6telez\u0151."
    }
  },
  hr: {
    employee: {
      title: "Dolgoz\xF3k",
      create: "\xDAj dolgoz\xF3",
      name: "N\xE9v",
      email: "Email",
      tajNumber: "TAJ sz\xE1m",
      taxId: "Ad\xF3azonos\xEDt\xF3",
      bankAccount: "Banksz\xE1mla",
      grossSalary: "Brutt\xF3 b\xE9r",
      employmentType: "Foglalkoztat\xE1s t\xEDpusa",
      salaryType: "B\xE9r t\xEDpusa",
      weeklyHours: "Heti \xF3rasz\xE1m",
      contractStart: "Szerz\u0151d\xE9s kezdete",
      contractEnd: "Szerz\u0151d\xE9s v\xE9ge",
      childrenCount: "Gyerekek sz\xE1ma",
      disabledChildrenCount: "Fogyat\xE9kos gyerekek",
      familyTaxCredit: "Csal\xE1di ad\xF3kedvezm\xE9ny",
      familyCreditChildCount: "Kedvezm\xE9nyezett gyerekek sz\xE1ma",
      isFirstMarriage: "Els\u0151 h\xE1zass\xE1g",
      userId: "Felhaszn\xE1l\xF3 azonos\xEDt\xF3",
      basicInfo: "Alapadatok",
      taxAndBankInfo: "Ad\xF3 \xE9s bankadatok",
      familyData: "Csal\xE1di adatok",
      noEmployees: "Nincs megjelen\xEDthet\u0151 dolgoz\xF3",
      created: "Dolgoz\xF3 l\xE9trehozva",
      updated: "Dolgoz\xF3 adatai friss\xEDtve",
      saveError: "Ment\xE9s sikertelen",
      employmentTypes: {
        fulltime: "Teljes munkaid\u0151",
        parttime: "R\xE9szmunkaid\u0151",
        seasonal: "Szezon\xE1lis"
      },
      salaryTypes: {
        monthly: "Havi",
        hourly: "\xD3rab\xE9r"
      },
      panelBasic: "Alapadatok",
      panelEmployment: "Munkaviszony",
      panelPayroll: "B\xE9rsz\xE1mfejt\xE9s",
      panelFamily: "Csal\xE1di adatok",
      panelInvalid: "Hi\xE1nyz\xF3 vagy \xE9rv\xE9nytelen mez\u0151",
      validationError: "T\xF6lts ki minden k\xF6telez\u0151 mez\u0151t",
      completionLabel: "{percent}% kit\xF6ltve",
      missingLabel: "Hi\xE1nyzik",
      miniCardAttendance: "Jelenl\xE9t {year}-{month}",
      miniCardLeaveBalance: "Szabads\xE1g {year}",
      miniCardRecentRecords: "Utols\xF3 jelenl\xE9tek",
      noAttendanceData: "Nincs jelenl\xE9t adat ebben a h\xF3napban",
      noLeaveBalance: "Szabads\xE1g egyenleg nincs inicializ\xE1lva",
      noRecentRecords: "Nincs friss jelenl\xE9t",
      missingDays: "Hi\xE1ny",
      viewFullAttendance: "Teljes n\xE9zet",
      viewLeaveHistory: "Szabads\xE1g el\u0151zm\xE9nyek"
    },
    attendance: {
      title: "Jelenl\xE9t",
      clockIn: "Bejelentkez\xE9s",
      clockOut: "Kijelentkez\xE9s",
      currentlyClockedIn: "Be vagy jelentkezve",
      currentlyClockedOut: "Ki vagy jelentkezve",
      monthlyView: "Havi n\xE9zet",
      workedDays: "Dolgozott napok",
      overtimeHours: "T\xFAl\xF3ra",
      clockedInSuccess: "Sikeresen bejelentkezt\xE9l",
      clockedOutSuccess: "Sikeresen kijelentkezt\xE9l",
      clockInError: "Bejelentkez\xE9s sikertelen",
      clockOutError: "Kijelentkez\xE9s sikertelen",
      overtimeActive: "T\xFAl\xF3ra folyamatban",
      forgottenClockOut: "Elfelejtett kijelentkez\xE9s",
      forgottenClockOutBanner: "\xDAgy t\u0171nik tegnap elfelejtett\xE9l kijelentkezni.",
      forgottenClockOutHint: "K\xE9rlek jelentkezz ki vagy sz\xF3lj a vezet\u0151dnek korrekci\xF3hoz.",
      startedAt: "Be",
      endedAt: "Ki",
      todayWorkedLabel: "Ma",
      weeklyProgress: "Heti \xF3ra",
      filterEmployee: "Dolgoz\xF3 szerint",
      allEmployees: "\xD6sszes dolgoz\xF3",
      hideWeekend: "H\xE9tv\xE9ge elrejt\xE9se",
      hideHoliday: "\xDCnnep elrejt\xE9se",
      exportCsv: "CSV export",
      summaryLabel: "\xD6sszesen",
      summaryWorkedDays: "{count} munkanap",
      summaryOvertime: "{duration} t\xFAl\xF3ra",
      summaryHolidays: "{count} \xFCnnep",
      summaryMissing: "{count} hi\xE1ny",
      noRecord: "Nincs jelenl\xE9t rekord",
      breakMinutesLabel: "Sz\xFCnet",
      overtimeLabel: "T\xFAl\xF3ra",
      holidayLabel: "\xDCnnepnap",
      weekendLabel: "H\xE9tv\xE9ge",
      sourceLabel: "Forr\xE1s",
      noteLabel: "Megjegyz\xE9s"
    },
    leave: {
      title: "Szabads\xE1g",
      request: "\xDAj k\xE9relem",
      myRequests: "Saj\xE1t k\xE9relmek",
      type: "T\xEDpus",
      startDate: "Kezd\u0151 d\xE1tum",
      endDate: "Befejez\u0151 d\xE1tum",
      reason: "Indokl\xE1s",
      reasonPlaceholder: "Opcion\xE1lis megjegyz\xE9s...",
      balance: "Egyenleg",
      remaining: "Marad\xE9k",
      used: "Felhaszn\xE1lt",
      entitled: "Jogosult",
      calendar: "Napt\xE1r",
      approve: "J\xF3v\xE1hagy\xE1s",
      reject: "Elutas\xEDt\xE1s",
      pending: "F\xFCgg\u0151ben",
      approved: "J\xF3v\xE1hagyva",
      rejected: "Elutas\xEDtva",
      cancelled: "Visszavonva",
      noRequests: "Nincs szabads\xE1g k\xE9relem",
      workingDays: "munkanap",
      requestSubmitted: "Szabads\xE1g k\xE9relem elk\xFCldve",
      requestError: "K\xE9relem k\xFCld\xE9se sikertelen",
      missingFields: "K\xE9rj\xFCk t\xF6ltse ki a k\xF6telez\u0151 mez\u0151ket",
      invalidDateRange: "A befejez\u0151 d\xE1tum nem lehet kor\xE1bbi a kezd\u0151 d\xE1tumn\xE1l",
      selectType: "V\xE1lasszon t\xEDpust",
      types: {
        annual: "\xC9ves szabads\xE1g",
        sickSelf: "Betegszabads\xE1g (saj\xE1t)",
        sickChild: "Betegszabads\xE1g (gyermek)",
        unpaid: "Fizet\xE9s n\xE9lk\xFCli",
        maternity: "Sz\xFCl\xE9si szabads\xE1g",
        paternity: "Apas\xE1gi szabads\xE1g",
        bereavement: "Gy\xE1szszabads\xE1g",
        bloodDonation: "V\xE9rad\xF3i szabads\xE1g"
      },
      datePreset: "Gyors d\xE1tum",
      workingDaysPreview: "{count} munkanap (h\xE9tv\xE9g\xE9k kihagyva)",
      quotaLabel: "maradt {remaining} / {entitled} nap",
      overlapError: "M\xE1r van szabads\xE1g-k\xE9relmed erre az id\u0151szakra",
      insufficientBalance: "Nincs elegend\u0151 szabads\xE1g egyenleged a k\xE9relemhez",
      chip: {
        tomorrow: "Holnap",
        nextMonday: "J\xF6v\u0151 h\xE9t h\xE9tf\u0151",
        oneWeek: "J\xF6v\u0151 h\xE9t H-P",
        custom: "Egyedi"
      },
      filterByType: "T\xEDpus szerint",
      filterByEmployee: "Dolgoz\xF3 szerint",
      allTypes: "\xD6sszes t\xEDpus",
      allEmployees: "\xD6sszes dolgoz\xF3",
      onlyPending: "Csak f\xFCgg\u0151",
      conflictWarning: "K\xE9t j\xF3v\xE1hagyott szabads\xE1g \xFCtk\xF6zik",
      approveError: "J\xF3v\xE1hagy\xE1s sikertelen",
      rejectError: "Elutas\xEDt\xE1s sikertelen"
    },
    shift: {
      title: "M\u0171szakok",
      name: "N\xE9v",
      startTime: "Kezd\xE9s",
      endTime: "Befejez\xE9s",
      breakMinutes: "Sz\xFCnet (perc)",
      isNightShift: "\xC9jszakai m\u0171szak"
    }
  },
  payroll: {
    config: {
      title: "B\xE9rsz\xE1mfejt\xE9s konfigur\xE1ci\xF3",
      taxRates: "Ad\xF3kulcsok",
      shifts: "M\u0171szakok",
      rate: "Kulcs",
      description: "Le\xEDr\xE1s",
      validFrom: "\xC9rv\xE9nyes-t\xF3l",
      validTo: "\xC9rv\xE9nyes-ig",
      save: "Ment\xE9s",
      delete: "T\xF6rl\xE9s",
      addNew: "\xDAj hozz\xE1ad\xE1sa",
      year: "\xC9v",
      deleteConfirm: "Biztosan t\xF6rli az ad\xF3kulcsot?",
      loadError: "Hiba a bet\xF6lt\xE9s sor\xE1n.",
      noRatesForYear: "Nincs ad\xF3kulcs erre az \xE9vre. Futtasson seed-et a /api/v1/payroll/seed endpointon.",
      taxType: "Ad\xF3nem",
      month: "H\xF3nap",
      subtitle: "Ad\xF3kulcsok \xE9s m\u0171szakmint\xE1k kezel\xE9se",
      saveError: "Az ad\xF3kulcs ment\xE9se nem siker\xFClt.",
      deleteError: "Az ad\xF3kulcs t\xF6rl\xE9se nem siker\xFClt."
    },
    runs: {
      title: "B\xE9rsz\xE1mfejt\xE9si futtat\xE1sok",
      detail: "Futtat\xE1s r\xE9szletei",
      newRun: "\xDAj futtat\xE1s",
      period: "Id\u0151szak",
      status: "St\xE1tusz",
      employeeCount: "Dolgoz\xF3k sz\xE1ma",
      totalGross: "Brutt\xF3 \xF6sszeg",
      totalNet: "Nett\xF3 \xF6sszeg",
      totalEmployerCost: "Munk\xE1ltat\xF3i k\xF6lt."
    },
    status: {
      DRAFT: "Tervezet",
      CALCULATED: "Kalkul\xE1lt",
      BOLT_APPROVED: "Bolt j\xF3v\xE1hagyott",
      CENTRAL_REVIEWED: "K\xF6zpontilag \xE1tvizsg\xE1lt",
      FINALIZED: "V\xE9gleges\xEDtett"
    },
    steps: {
      draft: "Tervezet",
      calculated: "Kalkul\xE1lt",
      boltApproved: "Bolt j\xF3v\xE1hagyva",
      centralReviewed: "K\xF6zponti review",
      finalized: "V\xE9gleges\xEDtett"
    },
    actions: {
      calculate: "Kalkul\xE1l\xE1s",
      boltApprove: "Bolt j\xF3v\xE1hagy\xE1s",
      centralReview: "K\xF6zponti review",
      finalize: "V\xE9gleges\xEDt\xE9s",
      exportCsv: "Let\xF6lt\xE9s CSV",
      exportExcel: "Let\xF6lt\xE9s Excel",
      calculateError: "A kalkul\xE1ci\xF3 nem siker\xFClt.",
      approveError: "A j\xF3v\xE1hagy\xE1s nem siker\xFClt."
    },
    payslip: {
      myTitle: "B\xE9rjegyz\xE9keim",
      period: "Id\u0151szak",
      gross: "Brutt\xF3",
      net: "Nett\xF3",
      downloadPdf: "PDF let\xF6lt\xE9s",
      empty: "Nincs b\xE9rjegyz\xE9ked a kiv\xE1lasztott \xE9vre.",
      taxId: "Ad\xF3azonos\xEDt\xF3",
      tajNumber: "TAJ sz\xE1m",
      bankAccount: "Banksz\xE1mlasz\xE1m",
      employmentType: "Foglalkoztat\xE1s t\xEDpusa",
      weeklyHours: "Heti \xF3rasz\xE1m",
      grossSalary: "Brutt\xF3 alapb\xE9r"
    },
    employmentTypes: {
      FULL_TIME: "Teljes munkaid\u0151s",
      PART_TIME: "R\xE9szmunkaid\u0151s",
      SEASONAL: "Id\xE9nyjelleg\u0171"
    },
    items: {
      tableTitle: "B\xE9rsz\xE1mfejt\xE9si t\xE9telek",
      employee: "Dolgoz\xF3",
      workingDays: "Munkanapok",
      workedDays: "Ledolgozott",
      leaveDays: "Szabads\xE1g",
      sickDays: "Betegnap",
      overtimeHours: "T\xFAl\xF3ra (\xF3ra)",
      baseSalary: "Alapb\xE9r",
      totalGross: "Brutt\xF3",
      totalNet: "Nett\xF3",
      empty: "Nincs t\xE9tel a futtat\xE1shoz."
    },
    dashboard: {
      title: "B\xE9rsz\xE1mfejt\xE9s \xE1ttekint\xE9s",
      latestGross: "Legut\xF3bbi brutt\xF3",
      latestNet: "Legut\xF3bbi nett\xF3",
      employerCost: "Munk\xE1ltat\xF3i teher",
      employees: "Dolgoz\xF3k",
      trend: "12 havi trend",
      noData: "Nincs adat a trendhez"
    },
    shift: {
      editHint: "M\u0171szakmint\xE1k szerkeszt\xE9se a HR adminisztr\xE1ci\xF3s fel\xFCleten \xE9rhet\u0151 el.",
      loadError: "Hiba a m\u0171szakmint\xE1k bet\xF6lt\xE9se sor\xE1n.",
      empty: "Nincs m\u0171szakminta.",
      nameHeader: "N\xE9v",
      startHeader: "Kezd\xE9s",
      endHeader: "Befejez\xE9s",
      breakHeader: "Sz\xFCnet (perc)",
      night: "\xC9jszakai"
    }
  },
  camera: {
    title: "Okm\xE1ny kamera r\xF6gz\xEDt\xE9s",
    description: "USB webkamera (Logitech C920) \u2014 csak desktop Chrome / Firefox",
    stepFront: "El\u0151lap r\xF6gz\xEDt\xE9se",
    stepBack: "H\xE1tlap r\xF6gz\xEDt\xE9se (MRZ)",
    stepCounter: "{current}/{total}",
    permissionPrompt: "A b\xF6ng\xE9sz\u0151 enged\xE9ly\xE9t k\xE9rj\xFCk a kamera haszn\xE1lat\xE1hoz.",
    permissionRequest: "Enged\xE9ly k\xE9r\xE9se",
    permissionDenied: "Kamera enged\xE9ly megtagadva. K\xE9rj\xFCk enged\xE9lyezze a b\xF6ng\xE9sz\u0151 be\xE1ll\xEDt\xE1saiban, majd pr\xF3b\xE1lja \xFAjra.",
    deviceNotFound: "Kamera nem tal\xE1lhat\xF3. Csatlakoztassa a Logitech C920 USB webkamer\xE1t.",
    deviceGeneric: "Nem siker\xFClt el\xE9rni a kamer\xE1t. Ellen\u0151rizze hogy m\xE1s alkalmaz\xE1s nem haszn\xE1lja.",
    captureFront: "El\u0151lap r\xF6gz\xEDt\xE9se",
    captureBack: "H\xE1tlap r\xF6gz\xEDt\xE9se",
    retake: "\xDAjra",
    next: "K\xF6vetkez\u0151",
    useCaptures: "K\xE9pek haszn\xE1lata",
    cancel: "M\xE9gse",
    thumbnailFront: "El\u0151lap el\u0151n\xE9zet",
    thumbnailBack: "H\xE1tlap el\u0151n\xE9zet",
    instructionFront: "Helyezze az okm\xE1ny el\u0151lapj\xE1t (f\xE9nyk\xE9p) a kamera el\xE9 \xE9s r\xF6gz\xEDtsen.",
    instructionBack: "Ford\xEDtsa meg az okm\xE1nyt \u2014 a h\xE1toldali g\xE9pi olvas\xE1s\xFA z\xF3na (MRZ) legyen l\xE1that\xF3.",
    zeroRetentionHint: "Nulla meg\u0151rz\xE9s \u2014 a k\xE9pek csak a feldolgoz\xE1sig \xE9lnek, majd azonnal megsemmis\xFClnek.",
    focusManual: "Manu\xE1lis f\xF3kusz t\xE1mogatva",
    focusAuto: "Automatikus f\xF3kusz",
    starting: "Kamera ind\xEDt\xE1sa..."
  },
  porter: {
    inbox: {
      title: "Be\xE9rkezett \xFCzenetek",
      searchPlaceholder: "Keres\xE9s a besz\xE9lget\xE9sekben...",
      filters: "Sz\u0171r\u0151k",
      statusLabel: "\xC1llapot",
      channelLabel: "Csatorna",
      assigneeLabel: "Hozz\xE1rendel\xE9s",
      loading: "Friss\xEDt\xE9s...",
      noSubject: "(nincs t\xE1rgy)",
      threadCount: "Be\xE9rkezett ({count})",
      pollingHint: "Automatikus friss\xEDt\xE9s 5 m\xE1sodpercenk\xE9nt",
      filter: {
        status: {
          all: "Minden \xE1llapot",
          OPEN: "Nyitott",
          PENDING: "F\xFCgg\u0151",
          RESOLVED: "Megoldva",
          SNOOZED: "Snooze"
        },
        channel: {
          all: "Minden csatorna",
          EMAIL: "Email",
          WEBCHAT: "Webchat",
          CONTACT_FORM: "\u0170rlap"
        },
        assignee: {
          all: "\xD6sszes",
          me: "Eny\xE9m",
          unassigned: "Kiosztatlan"
        }
      },
      empty: {
        title: "M\xE9g nincs egyetlen \xFCzenet sem",
        description: "Csatold a Gmail fi\xF3kodat \xE9s a webchat widgetet \u2014 az els\u0151 \xFCzenet 2 percen bel\xFCl meg\xE9rkezik.",
        ctaSetup: "Csatorna be\xE1ll\xEDt\xE1sa",
        ctaDemo: "Demo bej\xE1r\xE1s"
      },
      filteredEmpty: {
        title: "Nincs tal\xE1lat ezekre a sz\u0171r\u0151kre",
        description: "Pr\xF3b\xE1ld a sz\u0171r\u0151k laz\xEDt\xE1s\xE1t."
      },
      error: {
        title: "Nem siker\xFClt bet\xF6lteni az \xFCzeneteket",
        description: "H\xE1l\xF3zati hiba vagy szerver nem el\xE9rhet\u0151. Pr\xF3b\xE1ld \xFAjra.",
        retry: "\xDAjra pr\xF3b\xE1lom"
      },
      previewHint: {
        title: "V\xE1lassz egy besz\xE9lget\xE9st",
        description: "Kattints egy elemre a bal oldalon a besz\xE9lget\xE9s megtekint\xE9s\xE9hez \xE9s a v\xE1laszhoz."
      },
      relativeTime: {
        now: "most",
        minutes: "{count} perce",
        hours: "{count} \xF3r\xE1ja",
        days: "{count} napja"
      },
      sla: {
        OK: "Rendben",
        DUE_SOON: "Hamarosan lej\xE1r",
        BREACHED: "Lej\xE1rt",
        ESCALATED: "Eszkal\xE1lva"
      },
      unread: "Olvasatlan"
    },
    thread: {
      subject: "T\xE1rgy",
      back: "Vissza",
      inboxLink: "Be\xE1rkezett",
      loading: "Bet\xF6lt\xE9s...",
      channel: {
        EMAIL: "Email",
        WEBCHAT: "Webchat",
        CONTACT_FORM: "\u0170rlap"
      },
      status: {
        label: "\xC1llapot",
        OPEN: "Nyitott",
        PENDING: "F\xFCgg\u0151",
        RESOLVED: "Megoldva",
        SNOOZED: "Snooze"
      },
      assignee: {
        label: "Hozz\xE1rendelve",
        unassigned: "Nincs hozz\xE1rendelve"
      },
      partner: {
        label: "\xDCgyf\xE9l",
        unknown: "Ismeretlen kontakt",
        createCta: "+ Partner l\xE9trehoz\xE1sa",
        timeline: "\xD6sszes besz\xE9lget\xE9s"
      },
      message: {
        pending: "k\xFCld\xE9s folyamatban...",
        failed: "k\xFCld\xE9s sikertelen",
        retry: "\xDAjra",
        expand: "Teljes megjelen\xEDt\xE9s",
        collapse: "\xD6sszecsuk\xE1s",
        attachmentUnavailable: "Mell\xE9klet lej\xE1rt, friss\xEDt\xE9s..."
      },
      composer: {
        placeholder: "\xCDrj v\xE1laszt...",
        send: "K\xFCld\xE9s",
        sending: "K\xFCld\xE9s..."
      },
      error: {
        loadFail: "Nem siker\xFClt bet\xF6lteni a besz\xE9lget\xE9st",
        retry: "\xDAjra pr\xF3b\xE1lom"
      }
    },
    settings: {
      channels: {
        title: "Csatorn\xE1k",
        subtitle: "Itt \xE1ll\xEDthatod be hogyan fogad az rPI Porter \xFCzeneteket az \xFCgyfelekt\u0151l.",
        copy: "M\xE1sol\xE1s",
        copySuccess: "M\xE1solva!",
        notConfigured: {
          title: "M\xE9g nincs csatorna bek\xF6tve",
          description: "A Chatwoot account konfigur\xE1ci\xF3ja sz\xFCks\xE9ges els\u0151 l\xE9p\xE9sk\xE9nt. L\xE9pj kapcsolatba az adminnal."
        },
        list: {
          title: "Akt\xEDv csatorn\xE1k",
          EMAIL: {
            name: "Email",
            description: "Gmail IMAP/SMTP bek\xF6t\xE9s"
          },
          WEBCHAT: {
            name: "Webchat widget",
            description: "Be\xE1gyazhat\xF3 snippet a weboldalra"
          },
          CONTACT_FORM: {
            name: "Kapcsolatfelv\xE9teli \u0171rlap",
            description: "Publikus \u0171rlap, hCaptcha v\xE9delem"
          },
          configured: "Bek\xF6tve",
          notConfigured: "Nincs bek\xF6tve",
          setupCta: "Bek\xF6t\xE9s"
        },
        webchat: {
          title: "Webchat embed snippet",
          description: "M\xE1sold be a weboldalad <body> v\xE9g\xE9hez. A widget automatikusan megjelenik."
        },
        form: {
          title: "Publikus \u0171rlap URL",
          description: "Ezt az URL-t megoszthatod a weboldalon vagy kamp\xE1nyokban."
        },
        error: {
          loadFail: "Nem siker\xFClt bet\xF6lteni a csatorna konfigur\xE1ci\xF3t",
          retry: "\xDAjra pr\xF3b\xE1lom"
        }
      },
      webchat: {
        form: {
          replyTimeOptions: {
            in_a_few_minutes: "N\xE9h\xE1ny percen bel\xFCl",
            in_a_few_hours: "N\xE9h\xE1ny \xF3r\xE1n bel\xFCl",
            in_a_day: "1 napon bel\xFCl"
          }
        }
      },
      autoReply: {
        title: "Automatikus v\xE1lasz szab\xE1lyok",
        subtitle: "Automatikus \xFCzenetek k\xFCld\xE9se meghat\xE1rozott felt\xE9telek teljes\xFCl\xE9sekor.",
        addRule: "\xDAj szab\xE1ly",
        editRule: "Szab\xE1ly szerkeszt\xE9se",
        deleteRule: "T\xF6rl\xE9s",
        confirmDelete: "Biztosan t\xF6rli ezt a szab\xE1lyt?",
        noRules: "Nincsenek automatikus v\xE1lasz szab\xE1lyok.",
        active: "Akt\xEDv",
        inactive: "Inakt\xEDv",
        trigger: {
          label: "Kiv\xE1lt\xF3 esem\xE9ny",
          NEW_CONVERSATION: "\xDAj besz\xE9lget\xE9s",
          OFF_HOURS: "Munkaid\u0151n k\xEDv\xFCl",
          KEYWORD: "Kulcssz\xF3",
          NO_RESPONSE_TIMER: "Nincs v\xE1lasz id\u0151z\xEDt\u0151",
          CHANNEL_SPECIFIC: "Csatorna-specifikus"
        },
        form: {
          name: "Szab\xE1ly neve",
          namePlaceholder: "pl. Munka\xF3r\xE1n k\xEDv\xFCli \xFCzenet",
          templateId: "Sablon azonos\xEDt\xF3",
          templateIdPlaceholder: "E-93 email sablon azonos\xEDt\xF3ja",
          conditionJson: "Felt\xE9tel (JSON)",
          save: "Ment\xE9s",
          cancel: "M\xE9gse"
        },
        save: "Ment\xE9s",
        cancel: "M\xE9gse"
      }
    },
    timeline: {
      title: "\xD6sszes besz\xE9lget\xE9s",
      subtitle: "A partnerhez kapcsol\xF3d\xF3 \xF6sszes \xFCgyf\xE9lszolg\xE1lati sz\xE1l kronol\xF3gikus sorrendben.",
      empty: "Nincsenek kor\xE1bbi besz\xE9lget\xE9sek ezzel a partnerrel.",
      lastMessage: "Utols\xF3 \xFCzenet",
      noMessages: "Nincs \xFCzenet",
      openThread: "Megnyit\xE1s",
      loading: "Bet\xF6lt\xE9s...",
      error: "Nem siker\xFClt bet\xF6lteni a besz\xE9lget\xE9seket."
    }
  },
  authGrant: {
    type: {
      permanent: "\xC1lland\xF3",
      oneTime: "Egyszeri"
    },
    badge: {
      permanentActive: "Akt\xEDv",
      oneTimeUntilRental: "B\xE9rl\xE9sig"
    },
    card: {
      revoke: "Visszavon\xE1s",
      validFrom: "Kezdet",
      validUntil: "Lej\xE1rat",
      valueLimit: "\xC9rt\xE9khat\xE1r",
      rental: "B\xE9rl\xE9s",
      revokedReason: "Visszavonva"
    },
    tab: {
      title: "Meghatalmaz\xE1sok",
      subtitle: "\xC1lland\xF3 \xE9s egyszeri partner-meghatalmaz\xE1sok",
      createButton: "\xDAj meghatalmaz\xE1s",
      givenTitle: "Adott meghatalmaz\xE1sok",
      givenEmpty: "Ez a partner m\xE9g nem adott meghatalmaz\xE1st.",
      receivedTitle: "Kapott meghatalmaz\xE1sok",
      receivedEmpty: "Ez a partner m\xE9g nem kapott meghatalmaz\xE1st.",
      archivedToggle: "{count} archiv\xE1lt meghatalmaz\xE1s"
    },
    chooser: {
      title: "\xDAj meghatalmaz\xE1s t\xEDpusa",
      subtitle: "V\xE1laszd ki, milyen t\xEDpus\xFA meghatalmaz\xE1st szeretn\xE9l l\xE9trehozni.",
      permanentLabel: "\xC1lland\xF3 meghatalmaz\xE1s",
      permanentDesc: "Partner-partner k\xF6z\xF6tti tart\xF3s felhatalmaz\xE1s (pl. c\xE9gk\xE9pvisel\u0151).",
      oneTimeLabel: "Egyszeri meghatalmaz\xE1s",
      oneTimeDesc: "Adott b\xE9rl\xE9shez k\xF6t\xF6tt, okm\xE1ny-felt\xF6lt\xE9ssel (pl. sof\u0151r, fut\xE1r)."
    },
    dialog: {
      permanent: {
        title: "\xC1lland\xF3 meghatalmaz\xE1s",
        granteeLabel: "Kedvezm\xE9nyezett partner UUID",
        granteeHint: "Partner UUID (a j\xF6v\u0151beni autocomplete komponens fogja kiv\xE1ltani)",
        validFromLabel: "Kezdet",
        validUntilLabel: "Lej\xE1rat (opcion\xE1lis)",
        valueLimitLabel: "\xC9rt\xE9khat\xE1r (HUF, opcion\xE1lis)",
        submit: "Meghatalmaz\xE1s l\xE9trehoz\xE1sa",
        validationGranteeRequired: "Kedvezm\xE9nyezett partner k\xF6telez\u0151",
        validationGranteeUuid: "Kedvezm\xE9nyezett partner UUID form\xE1tumban kell legyen",
        validationValidFromRequired: "\xC9rv\xE9nyess\xE9g kezdete k\xF6telez\u0151",
        validationValidUntilAfter: "A lej\xE1rat a kezdetn\xE9l k\xE9s\u0151bbi d\xE1tum kell legyen",
        validationValueLimit: "Az \xE9rt\xE9khat\xE1r pozit\xEDv eg\xE9sz sz\xE1m kell legyen (\xFCresen hagyva: korl\xE1tlan)",
        validationValidFromPast: "\xC9rv\xE9nyess\xE9g kezdete nem lehet m\xFAltb\xE9li d\xE1tum"
      }
    }
  },
  equipment: {
    types: {
      categories: {
        SMALL_ENGINE: "Kisg\xE9p-motor",
        LAWN_EQUIPMENT: "Kerti eszk\xF6z",
        POWER_TOOL: "Elektromos szersz\xE1m",
        OTHER: "Egy\xE9b"
      },
      list: {
        title: "Cikkt\xEDpus katal\xF3gus",
        subtitle: "Equipment Type szerkeszt\u0151 \u2014 gy\xE1ri t\xEDpus + cikksz\xE1m + k\xE9pek + kateg\xF3ria",
        newCta: "\xDAj t\xEDpus",
        searchPlaceholder: "Keres\xE9s n\xE9v / SKU / gy\xE1ri SKU alapj\xE1n\u2026",
        allCategories: "\xD6sszes kateg\xF3ria",
        activeOnly: "Csak akt\xEDv",
        loading: "T\xEDpusok bet\xF6lt\xE9se\u2026",
        empty: {
          title: "M\xE9g nincs t\xEDpus",
          desc: "Hozd l\xE9tre az els\u0151 cikkt\xEDpust a webshop arc + b\xE9rl\xE9s/szerviz/\xE9rt\xE9kes\xEDt\xE9s foundation-h\xF6z."
        },
        col: {
          name: "N\xE9v",
          sku: "SKU",
          category: "Kateg\xF3ria",
          brand: "Gy\xE1rt\xF3 / modell",
          status: "St\xE1tusz",
          actions: "M\u0171veletek"
        },
        active: "Akt\xEDv",
        inactive: "Inakt\xEDv",
        actionEdit: "Szerkeszt"
      },
      editor: {
        title: {
          new: "\xDAj cikkt\xEDpus",
          edit: "Cikkt\xEDpus szerkeszt\xE9se"
        },
        subtitle: "T\xF6ltsd ki a t\xEDpus alapadatait. A specifik\xE1ci\xF3k + egys\xE9gek + dokumentumok Phase 2-ben (Sprint 18+).",
        loading: "T\xEDpus bet\xF6lt\xE9se\u2026",
        backToList: "Vissza a list\xE1hoz",
        submitting: "Ment\xE9s\u2026",
        save: "Ment\xE9s",
        create: "L\xE9trehoz\xE1s",
        field: {
          name: "Megnevez\xE9s",
          namePlaceholder: "pl. Honda GX160 benzinmotor",
          sku: "SKU (cikksz\xE1m)",
          skuPlaceholder: "pl. KGC-HONDA-GX160",
          manufacturerSku: "Gy\xE1ri cikksz\xE1m",
          alternativeSkus: "Alternat\xEDv cikksz\xE1mok",
          alternativeSkusPlaceholder: "vessz\u0151vel elv\xE1lasztva",
          alternativeSkusHint: "T\xF6meges import + N6 kereszt-metszet kezel\xE9shez. P\xE9lda: HONDA-180-OLD, MS180-16",
          category: "Kateg\xF3ria",
          brand: "Gy\xE1rt\xF3",
          model: "Modell",
          description: "Le\xEDr\xE1s",
          heroImageUrl: "Hero k\xE9p URL",
          galleryImages: "Gal\xE9ria URL-ek",
          galleryImagesPlaceholder: "https://...\nhttps://...",
          galleryImagesHint: "Soronk\xE9nt egy URL. Phase 2-ben (ADR-123 Am.2) EquipmentTypeImage child t\xE1bla v\xE1ltja fel.",
          isActive: "Akt\xEDv",
          isActiveHint: "Inakt\xEDv t\xEDpus nem jelenik meg a b\xE9rl\xE9s/szerviz/\xE9rt\xE9kes\xEDt\xE9s UI-on.",
          alternativeSkusCreate: '\u201E{value}" hozz\xE1ad\xE1sa',
          alternativeSkusDuplicate: "Ez a cikksz\xE1m m\xE1r szerepel",
          alternativeSkusTooLong: "A cikksz\xE1m legfeljebb 100 karakter lehet"
        },
        images: {
          title: "K\xE9pek (D5 Phase 1)",
          previewError: "A k\xE9p nem t\xF6lthet\u0151 be ezen az URL-en. Ellen\u0151rizze a c\xEDmet."
        },
        toast: {
          created: "Cikkt\xEDpus l\xE9trehozva",
          updated: "Cikkt\xEDpus friss\xEDtve"
        },
        errors: {
          nameRequired: "A n\xE9v k\xF6telez\u0151 mez\u0151",
          skuRequired: "Az SKU k\xF6telez\u0151 mez\u0151",
          duplicateSku: "Ez a SKU m\xE1r l\xE9tezik (gy\xE1ri vagy alternat\xEDv kereszt-metszet)",
          validationFailed: "Hib\xE1s form adatok \u2014 ellen\u0151rizd a mez\u0151ket",
          notFound: "A cikkt\xEDpus nem tal\xE1lhat\xF3",
          network: "H\xE1l\xF3zati hiba, pr\xF3b\xE1ld \xFAjra",
          businessRuleFail: "\xDCzleti szab\xE1ly megs\xE9rtve. Ellen\u0151rizze az adatokat.",
          fkViolation: "Hivatkozott rekord nem tal\xE1lhat\xF3.",
          specsInvalidJson: "A m\u0171szaki specifik\xE1ci\xF3 \xE9rv\xE9nytelen JSON \u2014 jav\xEDtsd a Specs mez\u0151t ment\xE9s el\u0151tt."
        },
        cancelConfirm: "Az el nem mentett v\xE1ltoztat\xE1sok elvesznek. Biztosan megszak\xEDtja?",
        specs: {
          title: "M\u0171szaki specifik\xE1ci\xF3k",
          hint: "Kulcs\u2013\xE9rt\xE9k p\xE1rok a t\xEDpus m\u0171szaki adataihoz (pl. teljes\xEDtm\xE9ny, s\xFAly). A Raw n\xE9zet tetsz\u0151leges JSON-t enged.",
          kvView: "Kulcs\u2013\xE9rt\xE9k",
          rawView: "Raw JSON",
          addRow: "Sor hozz\xE1ad\xE1sa",
          removeRow: "T\xF6rl\xE9s",
          keyPlaceholder: "pl. teljes\xEDtm\xE9ny",
          valuePlaceholder: "pl. 4.0 kW",
          invalidJson: '\xC9rv\xE9nytelen JSON \u2014 objektum sz\xFCks\xE9ges (pl. {"kulcs": "\xE9rt\xE9k"})',
          nonPrimitiveHint: "A specs be\xE1gyazott/t\xEDpusos \xE9rt\xE9keket tartalmaz \u2014 a kulcs\u2013\xE9rt\xE9k n\xE9zet t\xEDpusveszt\u0151 lenne, ez\xE9rt a Raw n\xE9zet akt\xEDv."
        },
        tabsLabel: "T\xEDpus-szerkeszt\u0151 lapok",
        tabs: {
          data: "Alapadatok",
          units: "Egys\xE9gek",
          webshop: "Webshop",
          docs: "Dokumentumok"
        },
        units: {
          loading: "Egys\xE9gek bet\xF6lt\xE9se\u2026",
          error: "Az egys\xE9gek bet\xF6lt\xE9se nem siker\xFClt.",
          empty: "Ehhez a t\xEDpushoz m\xE9g nincs egys\xE9g.",
          countSuffix: "egys\xE9g",
          serialNumber: "Gy\xE1ri sz\xE1m",
          assetTag: "Eszk\xF6zc\xEDmke",
          status: "St\xE1tusz",
          createdAt: "L\xE9trehozva",
          open: "Megnyit\xE1s"
        },
        webshop: {
          loading: "Webshop-adatok bet\xF6lt\xE9se\u2026",
          error: "A webshop-adatok bet\xF6lt\xE9se nem siker\xFClt.",
          localeTitle: "Nyelvi tartalom",
          localeHint: "HU k\xF6telez\u0151 \xB7 EN/DE/UK opcion\xE1lis (\xFCres \u2192 HU-fallback)",
          nameLabel: "N\xE9v",
          namePlaceholderHu: "pl. Honda GX160 benzinmotor",
          huNameRequired: "A magyar n\xE9v k\xF6telez\u0151 webshop-l\xE1that\xF3s\xE1gn\xE1l.",
          descriptionLabel: "Le\xEDr\xE1s",
          slugLabel: "URL slug",
          slugGenerate: "Gener\xE1l\xE1s",
          flagVisibleOnWebshop: "Webshop-l\xE1that\xF3",
          flagVisibleOnWebshopHint: "Bekapcsolva a webshopon b\xE1rki l\xE1tja.",
          flagAvailableForRent: "Foglalhat\xF3 (b\xE9rl\xE9s)",
          flagAvailableForRentHint: "Vev\u0151k tudnak foglalni a webshopb\xF3l.",
          flagAvailableForSale: "V\xE1s\xE1rolhat\xF3",
          flagAvailableForSaleHint: "Vev\u0151k tudnak v\xE1s\xE1rolni a webshopb\xF3l.",
          save: "Webshop-adatok ment\xE9se",
          saving: "Ment\xE9s\u2026",
          saved: "Webshop-adatok elmentve",
          saveFailed: "A ment\xE9s nem siker\xFClt.",
          seoSectionTitle: "Keres\u0151optimaliz\xE1l\xE1s (SEO)",
          seoPlaceholderNote: "El\u0151k\xE9sz\xEDt\xE9s alatt \u2014 a SEO-mez\u0151k ment\xE9se a k\xF6vetkez\u0151 kiad\xE1sban lesz el\xE9rhet\u0151 (a tartalom egyel\u0151re nem ker\xFCl ment\xE9sre).",
          seoTitleLabel: "SEO c\xEDm",
          seoTitlePlaceholder: "pl. Honda GX160 motor b\xE9rl\xE9s \xE9s v\xE1s\xE1rl\xE1s \u2014 Kisg\xE9pcentrum",
          seoDescriptionLabel: "SEO le\xEDr\xE1s",
          seoDescriptionPlaceholder: "pl. Honda GX160 professzion\xE1lis benzinmotor, 4 \xFCtem\u0171, 163 cm\xB3. B\xE9rl\xE9s \xE9s v\xE1s\xE1rl\xE1s a Kisg\xE9pcentrumn\xE1l.",
          seoTooLong: "t\xFAl hossz\xFA"
        },
        docs: {
          loading: "Dokumentumok bet\xF6lt\xE9se\u2026",
          error: "A dokumentumok bet\xF6lt\xE9se nem siker\xFClt.",
          empty: "Ehhez a t\xEDpushoz m\xE9g nincs dokumentum.",
          countSuffix: "dokumentum",
          name: "N\xE9v",
          kind: "T\xEDpus",
          size: "M\xE9ret",
          uploadedAt: "Felt\xF6ltve",
          kinds: {
            MANUAL: "\xDAtmutat\xF3",
            SAFETY: "Biztons\xE1gi",
            WARRANTY: "J\xF3t\xE1ll\xE1s",
            CERTIFICATE: "Tan\xFAs\xEDtv\xE1ny",
            OTHER: "Egy\xE9b"
          }
        }
      }
    }
  },
  procurement: {
    worksheetPanelTitle: "Alkatr\xE9sz ig\xE9nyek",
    addRequest: "\xDAj alkatr\xE9sz ig\xE9ny",
    addRequestTitle: "\xDAj alkatr\xE9sz ig\xE9ny",
    emptyForWorksheet: "Nincs alkatr\xE9sz ig\xE9ny ehhez a munkalaphoz.",
    productSearchLabel: "Term\xE9k",
    productSearchPlaceholder: "Keres\xE9s cikksz\xE1m vagy n\xE9v alapj\xE1n\u2026",
    noProductsFound: "Nincs tal\xE1lat",
    selectedProduct: "Kiv\xE1lasztott term\xE9k",
    productIdShort: "Term\xE9k",
    quantity: "Mennyis\xE9g",
    notes: "Megjegyz\xE9s",
    notesPlaceholder: "Pl. s\xFCrg\u0151s, eredeti gy\xE1ri alkatr\xE9sz\u2026",
    create: "Hozz\xE1ad\xE1s a kos\xE1rhoz",
    errors: {
      productRequired: "V\xE1lassz egy term\xE9ket a list\xE1b\xF3l.",
      quantityInvalid: "A mennyis\xE9gnek pozit\xEDv sz\xE1mnak kell lennie.",
      transitionRejected: "Ez az \xE1llapotv\xE1lt\xE1s nem enged\xE9lyezett ({from} \u2192 {to})."
    },
    status: {
      DRAFT: "Piszkozat",
      SUBMITTED: "Beadva",
      ORDERED: "Rendelve",
      RECEIVED: "Be\xE9rkezett",
      CANCELLED: "T\xF6r\xF6lve"
    },
    actions: {
      submit: "Bead\xE1s",
      markOrdered: "Megrendelve",
      markReceived: "Be\xE9rkezett",
      cancel: "T\xF6rl\xE9s",
      confirmCancel: "Biztosan t\xF6rl\xF6d ezt a beszerz\xE9si ig\xE9nyt?"
    },
    closeGate: {
      title: "Lez\xE1rod a munkalapot?",
      warning: "M\xE9g {count} alkatr\xE9sz ig\xE9ny van folyamatban ehhez a munkalaphoz (nem be\xE9rkezett \xE9s nem t\xF6r\xF6lt). Biztosan lez\xE1rod?",
      proceed: "Igen, lez\xE1rom"
    },
    cart: {
      title: "K\xF6zponti beszerz\xE9si kos\xE1r",
      subtitle: "\xD6sszes beszerz\xE9si ig\xE9ny forr\xE1s szerint csoportos\xEDtva",
      empty: "A beszerz\xE9si kos\xE1r \xFCres.",
      totalCount: "{count} ig\xE9ny",
      productIdShort: "Term\xE9k",
      quantity: "Mennyis\xE9g",
      sourceLabel: {
        WORKSHEET: "Munkalap-alap\xFA",
        SALES: "Elad\xE1si hi\xE1ny (POS)",
        MANUAL: "Manu\xE1lis r\xF6gz\xEDt\xE9s",
        AUTO_MIN: "Automatikus ut\xE1nrendel\xE9s"
      },
      submitButton: "Kos\xE1r bead\xE1sa ({count})",
      confirmSubmit: "{count} ig\xE9nyt beadsz a beszerz\xE9shez. Folytatod?",
      markGroupOrderedButton: "Csoport megrendelve",
      supplierNotesPrompt: "Besz\xE1ll\xEDt\xF3 neve (opcion\xE1lis, a megjegyz\xE9sbe ker\xFCl):"
    },
    listTruncated: "A lista csonk\xEDtott: {shown} elem l\xE1tszik a(z) {total}-b\xF3l. Sz\u0171k\xEDts a sz\u0171r\u0151vel, vagy nyisd meg a teljes beszerz\xE9si list\xE1t."
  },
  package: {
    backToList: "Vissza a csomagokhoz",
    adminTabs: "Csomag n\xE9zetek",
    tabs: {
      items: "T\xE9telek",
      data: "Csomag-adatok"
    },
    item: {
      name: "Megnevez\xE9s",
      settlement: "Elsz\xE1mol\xE1s",
      settlementIncluded: "Be\xE9p\xEDtve",
      settlementRental: "B\xE9rl\xE9s",
      settlementConsignment: "Bizom\xE1nyi",
      unitPrice: "Egys\xE9g\xE1r"
    },
    scope: "Hat\xF3k\xF6r",
    pricingModel: "\xC1raz\xE1si modell",
    fixedPrice: "Fix \xE1r",
    depositAmount: "Kauci\xF3",
    validFrom: "\xC9rv\xE9nyes ett\u0151l",
    validTo: "\xC9rv\xE9nyes eddig",
    category: {
      free: "Ingyenes",
      rentable: "B\xE9relhet\u0151",
      consignment: "Bizom\xE1nyi"
    }
  },
  inquiry: {
    title: "Kapcsolatfelv\xE9tel",
    subtitle: "\xCDrd meg mire van sz\xFCks\xE9ged \u2014 1 munkanapon bel\xFCl v\xE1laszolunk.",
    success: {
      title: "K\xF6sz\xF6nj\xFCk a megkeres\xE9st!",
      body: "1 munkanapon bel\xFCl v\xE1laszolunk a megadott email c\xEDmre."
    },
    field: {
      name: "N\xE9v",
      email: "Email",
      phone: "Telefonsz\xE1m (opcion\xE1lis)",
      message: "\xDCzenet"
    },
    submit: "K\xFCld\xE9s",
    submitting: "K\xFCld\xE9s...",
    validation: {
      nameMin: "Legal\xE1bb 2 karakter",
      email: "\xC9rv\xE9nytelen email",
      messageMin: "Legal\xE1bb 10 karakter",
      messageMax: "Maximum 5000 karakter",
      captcha: "K\xE9rj\xFCk igazold, hogy nem vagy robot"
    },
    error: {
      submit: "Nem siker\xFClt elk\xFCldeni. Pr\xF3b\xE1ld \xFAjra p\xE1r perc m\xFAlva."
    }
  },
  priDrawer: {
    title: "pRI Asszisztens",
    clearHistory: "Besz\xE9lget\xE9s t\xF6rl\xE9se",
    close: "Bez\xE1r\xE1s"
  },
  unifiedFab: {
    items: {
      pri: "pRI Asszisztens",
      chat: "Chat",
      helpdesk: "Helpdesk"
    },
    title: {
      withShortcut: "rPI Asszisztens (Ctrl+Shift+H)",
      default: "rPI Asszisztens"
    }
  }
};

// src/locale/translations/uk.json
var uk_default = {
  equipmentUnit: {
    backToTypes: "Vissza a t\xEDpusokhoz",
    editorTitle: "Egyedi g\xE9p szerkeszt\u0151",
    editorSubtitle: "Egyedi g\xE9p-rekord adatai, st\xE1tusza \xE9s dokumentumai",
    tabsAria: "Egyedi g\xE9p n\xE9zetek",
    tabs: {
      basic: "Alapadatok",
      status: "St\xE1tusz & el\u0151zm\xE9ny",
      images: "K\xE9pek",
      documents: "Dokumentumok"
    },
    seamPending: "Hamarosan \u2014 adatk\xF6t\xE9s a BE-seam-re v\xE1r",
    field: {
      manufacturerSku: "Gy\xE1ri cikksz\xE1m",
      internalSku: "Bels\u0151 cikksz\xE1m",
      altSkus: "Alternat\xEDv SKU-k",
      serialNumber: "Sorozatsz\xE1m",
      purchasedAt: "V\xE1s\xE1rl\xE1s d\xE1tuma",
      hours: "\xDCzem\xF3ra",
      category: "Kateg\xF3ria",
      note: "Megjegyz\xE9s",
      status: "St\xE1tusz",
      statusSince: "St\xE1tusz \xF3ta"
    },
    status: {
      AVAILABLE: "Szabad",
      RESERVED: "Foglalt",
      IN_USE: "Haszn\xE1latban",
      DAMAGED: "S\xE9r\xFClt",
      UNDER_REPAIR: "Jav\xEDt\xE1s alatt",
      SOLD: "Eladva",
      WITHDRAWAL_REQUESTED: "Kivon\xE1sra jel\xF6lve",
      RETIRED: "Kivonva"
    },
    category: {
      SMALL_ENGINE: "Kismotoros g\xE9p",
      LAWN_EQUIPMENT: "Kerti g\xE9p",
      POWER_TOOL: "Elektromos szersz\xE1m",
      OTHER: "Egy\xE9b"
    },
    statusHistory: "St\xE1tusz el\u0151zm\xE9ny",
    altSkusPlaceholder: "SKU + Enter (Excel/CSV beilleszt\xE9s t\xE1mogatott)",
    altSkusCreate: '+ \xDAj: "{value}"',
    altSkusDuplicate: "M\xE1r szerepel",
    saved: "Mentve",
    saveError: "Ment\xE9s sikertelen",
    imagesEmpty: "Nincs felt\xF6lt\xF6tt k\xE9p",
    documentsEmpty: "Nincs dokumentum",
    expiresAt: "Lej\xE1r",
    download: "Let\xF6lt\xE9s",
    transition: {
      button: "St\xE1tusz v\xE1lt\xE1s",
      title: "St\xE1tusz v\xE1lt\xE1s",
      targetLabel: "V\xE1lassz c\xE9lst\xE1tuszt",
      reasonLabel: "Indokl\xE1s",
      required: "k\xF6telez\u0151",
      reasonHint: "Minimum 20 karakter ({count}/20)",
      photoLabel: "F\xE9nyk\xE9pek",
      auditNote: "Minden st\xE1tusz-v\xE1lt\xE1s audit-logolt: ki, mikor \xE9s mi\xE9rt.",
      confirm: "St\xE1tusz meger\u0151s\xEDt\xE9se",
      noTargets: "Ebb\u0151l a st\xE1tuszb\xF3l nincs lehets\xE9ges \xE1tmenet.",
      success: "St\xE1tusz friss\xEDtve",
      error: "A st\xE1tusz-v\xE1lt\xE1s sikertelen"
    }
  },
  bank: {
    title: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0456 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
    subtitle: "\u0420\u0443\u0445 \u043A\u043E\u0448\u0442\u0456\u0432 \u0442\u0430 \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
    newTransaction: "\u041D\u043E\u0432\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u044F",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u0445 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0439...",
    error: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
    noResultsFiltered: "\u041D\u0435\u043C\u0430\u0454 \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u0445 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0439 \u0437\u0430 \u043E\u0431\u0440\u0430\u043D\u0438\u043C \u0444\u0456\u043B\u044C\u0442\u0440\u043E\u043C. \u0417\u043C\u0456\u043D\u0456\u0442\u044C \u0444\u0456\u043B\u044C\u0442\u0440.",
    total: "\u0423\u0441\u044C\u043E\u0433\u043E",
    column: {
      bookingDate: "\u0414\u0430\u0442\u0430 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
      counterparty: "\u041A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442",
      amount: "\u0421\u0443\u043C\u0430",
      matchStatus: "\u0417\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
      source: "\u0414\u0436\u0435\u0440\u0435\u043B\u043E"
    },
    matchStatus: {
      UNMATCHED: "\u041D\u0435 \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      PARTIALLY_MATCHED: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      MATCHED: "\u0417\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      RECONCILED: "\u0423\u0437\u0433\u043E\u0434\u0436\u0435\u043D\u043E"
    },
    direction: {
      IN: "\u041D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      OUT: "\u0412\u0438\u0434\u0430\u0442\u043E\u043A"
    },
    source: {
      MANUAL: "\u0412\u0440\u0443\u0447\u043D\u0443",
      IMPORT: "\u0406\u043C\u043F\u043E\u0440\u0442"
    },
    filter: {
      allStatuses: "\u0423\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
      allDirections: "\u0423\u0441\u0456 \u043D\u0430\u043F\u0440\u044F\u043C\u043A\u0438"
    },
    form: {
      bookingDate: "\u0414\u0430\u0442\u0430 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
      direction: "\u041D\u0430\u043F\u0440\u044F\u043C\u043E\u043A",
      amount: "\u0421\u0443\u043C\u0430",
      counterpartyName: "\u041D\u0430\u0437\u0432\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430",
      counterpartyAccount: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430",
      memo: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      submit: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
      success: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u044E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
      error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438"
    },
    match: {
      action: "\u0417\u0456\u0441\u0442\u0430\u0432\u0438\u0442\u0438",
      title: "\u0417\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u043E\u0457 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
      invoiceLabel: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A",
      invoicePlaceholder: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u0430\u0445\u0443\u043D\u043E\u043A\u2026",
      amountLabel: "\u0417\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u0441\u0443\u043C\u0430",
      submit: "\u0417\u0456\u0441\u0442\u0430\u0432\u0438\u0442\u0438",
      noInvoices: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0445 \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432 \u0434\u043B\u044F \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
      loadError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043A\u0438 \u0434\u043B\u044F \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
      success: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      error: {
        overpay: "\u0417\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u0441\u0443\u043C\u0430 \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0437\u0430\u043B\u0438\u0448\u043E\u043A \u0437\u0430 \u0440\u0430\u0445\u0443\u043D\u043A\u043E\u043C",
        outNotAllowed: "\u0412\u0438\u0445\u0456\u0434\u043D\u0456 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0437\u0456\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0437 \u0440\u0430\u0445\u0443\u043D\u043A\u043E\u043C",
        amountPositive: "\u0417\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u0441\u0443\u043C\u0430 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043D\u043E\u044E",
        alreadyExists: "\u0426\u0435 \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
        invoiceNotFound: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        transactionNotFound: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0443 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        generic: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0437\u0456\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F"
      }
    }
  },
  common: {
    status: "\u0421\u0442\u0430\u0442\u0443\u0441",
    uploading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
    save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
    saving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    delete: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    confirmDelete: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442?",
    search: "\u041F\u043E\u0448\u0443\u043A",
    clearSearch: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u0448\u0443\u043A",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430",
    success: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E",
    yes: "\u0422\u0430\u043A",
    no: "\u041D\u0456",
    close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    back: "\u041D\u0430\u0437\u0430\u0434",
    previous: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F",
    next: "\u0414\u0430\u043B\u0456",
    submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    edit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
    create: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
    details: "\u0414\u0435\u0442\u0430\u043B\u0456",
    new: "\u041D\u043E\u0432\u0438\u0439",
    all: "\u0412\u0441\u0456",
    none: "\u041D\u0435\u043C\u0430\u0454",
    actions: "\u0414\u0456\u0457",
    confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    remove: "\u0412\u0438\u043B\u0443\u0447\u0438\u0442\u0438",
    add: "\u0414\u043E\u0434\u0430\u0442\u0438",
    update: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
    refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
    retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
    print: "\u0414\u0440\u0443\u043A",
    export: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442",
    import: "\u0406\u043C\u043F\u043E\u0440\u0442",
    filter: "\u0424\u0456\u043B\u044C\u0442\u0440",
    sort: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    reset: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438",
    apply: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
    download: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
    upload: "\u0412\u0438\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
    quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
    total: "\u0420\u0430\u0437\u043E\u043C",
    subtotal: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    amount: "\u0421\u0443\u043C\u0430",
    date: "\u0414\u0430\u0442\u0430",
    description: "\u041E\u043F\u0438\u0441",
    notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
    comment: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
    type: "\u0422\u0438\u043F",
    category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
    priority: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
    responsible: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0439",
    noResponsible: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u043E\u0433\u043E",
    id: "ID",
    name: "\u041D\u0430\u0437\u0432\u0430",
    notFound: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445",
    backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
    optional: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E",
    required: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E",
    piece: "\u0448\u0442.",
    day: "\u0434\u0435\u043D\u044C",
    days: "\u0434\u043D\u0456\u0432",
    hour: "\u0433\u043E\u0434\u0438\u043D\u0430",
    hours: "\u0433\u043E\u0434\u0438\u043D",
    createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    updatedAt: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    completedAt: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
    createdBy: "\u0421\u0442\u0432\u043E\u0440\u0438\u0432",
    saved: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    loadingText: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    errorLabel: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430",
    retryButton: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
    months: {
      january: "\u0421\u0456\u0447\u0435\u043D\u044C",
      february: "\u041B\u044E\u0442\u0438\u0439",
      march: "\u0411\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
      april: "\u041A\u0432\u0456\u0442\u0435\u043D\u044C",
      may: "\u0422\u0440\u0430\u0432\u0435\u043D\u044C",
      june: "\u0427\u0435\u0440\u0432\u0435\u043D\u044C",
      july: "\u041B\u0438\u043F\u0435\u043D\u044C",
      august: "\u0421\u0435\u0440\u043F\u0435\u043D\u044C",
      september: "\u0412\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
      october: "\u0416\u043E\u0432\u0442\u0435\u043D\u044C",
      november: "\u041B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
      december: "\u0413\u0440\u0443\u0434\u0435\u043D\u044C"
    },
    monthsShort: {
      jan: "\u0421\u0456\u0447",
      feb: "\u041B\u044E\u0442",
      mar: "\u0411\u0435\u0440",
      apr: "\u041A\u0432\u0456",
      may: "\u0422\u0440\u0430",
      jun: "\u0427\u0435\u0440",
      jul: "\u041B\u0438\u043F",
      aug: "\u0421\u0435\u0440",
      sep: "\u0412\u0435\u0440",
      oct: "\u0416\u043E\u0432",
      nov: "\u041B\u0438\u0441",
      dec: "\u0413\u0440\u0443"
    },
    other: "\u0406\u043D\u0448\u0435",
    unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    activeRentals: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    currency: "Ft",
    summary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    wizardStep: "\u041A\u0440\u043E\u043A {current} / {total}",
    processing: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430...",
    row: "\u0420\u044F\u0434\u043E\u043A",
    clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
    dismiss: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
    active: "Akt\xEDv",
    inactive: "Inakt\xEDv",
    loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F"
  },
  navStatus: {
    label: "\u0421\u0442\u0430\u0442\u0443\u0441 NAV",
    pending: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
    submitted: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
    accepted: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
    rejected: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
    error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430"
  },
  nav: {
    bankImport: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0456 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
    navigation: "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F",
    favorites: "\u041E\u0431\u0440\u0430\u043D\u0435",
    removeFavorite: "\u0412\u0438\u043B\u0443\u0447\u0438\u0442\u0438",
    expandAll: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0435",
    collapseAll: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0435",
    expand: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
    collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
    adminCenter: "\u0410\u0434\u043C\u0456\u043D-\u0446\u0435\u043D\u0442\u0440",
    summary: "\u041E\u0433\u043B\u044F\u0434",
    knowledgeBase: "\u0411\u0430\u0437\u0430 \u0437\u043D\u0430\u043D\u044C",
    rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
    activeRentals: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    newRental: "\u041D\u043E\u0432\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
    returnRental: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    outstandingRentals: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456",
    fleetCalendar: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    worksheet: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    worksheets: "\u0420\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
    newWorksheet: "\u041D\u043E\u0432\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    claims: "\u0420\u0435\u043A\u043B\u0430\u043C\u0430\u0446\u0456\u0457",
    sales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    salesList: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u043E\u0434\u0430\u0436\u0456\u0432",
    pos: "POS (\u041A\u0430\u0441\u0430)",
    inventory: "\u0421\u043A\u043B\u0430\u0434",
    stockList: "\u0421\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    movements: "\u0420\u0443\u0445\u0438",
    goodsReceipt: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0443",
    scrapping: "\u0421\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
    inventoryAnalytics: "\u0410\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    masterData: "\u0414\u043E\u0432\u0456\u0434\u043D\u0438\u043A\u0438",
    products: "\u0422\u043E\u0432\u0430\u0440\u0438",
    quotes: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    contracts: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0438",
    invoices: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
    deliveryNotes: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0456",
    partners: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
    partnerList: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
    newPartner: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440",
    vipProgram: "VIP-\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0430",
    duplicates: "\u0414\u0443\u0431\u043B\u0456\u043A\u0430\u0442\u0438",
    vehicles: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    rentalVehicles: "\u041E\u0440\u0435\u043D\u0434\u043D\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    companyVehicles: "\u0421\u043B\u0443\u0436\u0431\u043E\u0432\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    expiringDocuments: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438, \u0449\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u044E\u0442\u044C\u0441\u044F",
    finance: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
    cashRegister: "\u041A\u0430\u0441\u0430",
    dailyClose: "\u0414\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    monthlyClose: "\u041C\u0456\u0441\u044F\u0447\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    journal: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430 \u043A\u043D\u0438\u0433\u0430",
    szhFolder: "\u041F\u0430\u043F\u043A\u0430 \u0421\u0417\u0413",
    vouchers: "\u0412\u0430\u0443\u0447\u0435\u0440\u0438",
    fixedAssets: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    tamTaxExempt: "\u0422\u0410\u041C \u0417\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u043F\u043E\u0434\u0430\u0442\u043A\u0443",
    receivables: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    overdueRentals: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    chat: "\u0427\u0430\u0442",
    messaging: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    smsDashboard: "SMS \u041F\u0430\u043D\u0435\u043B\u044C",
    inboundSms: "\u0412\u0445\u0456\u0434\u043D\u0456 SMS",
    courierDeliveries: "\u041A\u0443\u0440'\u0454\u0440\u0441\u044C\u043A\u0456 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
    reports: "\u0417\u0432\u0456\u0442\u0438",
    tasks: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    integrations: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457",
    crm: "CRM (Twenty)",
    hr: "HR (Horilla)",
    porter: "rPI Porter",
    porterInbox: "\u0412\u0445\u0456\u0434\u043D\u0456",
    porterChannels: "\u041A\u0430\u043D\u0430\u043B\u0438",
    porterAutoReply: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0430\u0432\u0442\u043E-\u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
    chatwoot: "rPI Porter",
    flow: "rPI Flow",
    admin: "\u0410\u0434\u043C\u0456\u043D",
    users: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456",
    permissions: "\u041F\u0440\u0430\u0432\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0443",
    tenantAdmin: "\u0410\u0434\u043C\u0456\u043D \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
    featureFlags: "\u041F\u0440\u0430\u043F\u043E\u0440\u0446\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0439",
    releaseHub: "rPI Delta",
    settings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    general: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0435",
    openingHours: "\u0413\u043E\u0434\u0438\u043D\u0438 \u0440\u043E\u0431\u043E\u0442\u0438",
    smsSettings: "SMS-\u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    documentScanner: "\u0421\u043A\u0430\u043D\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
    dashboard: "\u041F\u0430\u043D\u0435\u043B\u044C \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F",
    crmNewWindow: "Twenty CRM (\u043D\u043E\u0432\u0435 \u0432\u0456\u043A\u043D\u043E)",
    hrNewWindow: "Horilla HR (\u043D\u043E\u0432\u0435 \u0432\u0456\u043A\u043D\u043E)",
    group: {
      daily: "\u0429\u043E\u0434\u0435\u043D\u043D\u0430 \u0440\u043E\u0431\u043E\u0442\u0430",
      registry: "\u0420\u0435\u0454\u0441\u0442\u0440",
      communication: "\u041A\u043E\u043C\u0443\u043D\u0456\u043A\u0430\u0446\u0456\u044F",
      system: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430",
      hr: "HR"
    },
    manufacturing: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
    bomList: "\u0421\u043F\u0435\u0446\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F (BOM)",
    productionOrders: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
    packages: "\u041F\u0430\u043A\u0435\u0442\u0438",
    more: "\u0411\u0456\u043B\u044C\u0448\u0435",
    administration: "\u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0446\u0456\u044F",
    recentItems: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456",
    moreMenu: "\u0411\u0456\u043B\u044C\u0448\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0456\u0432",
    sidebarMenu: "\u041F\u0430\u043D\u0435\u043B\u044C \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0457",
    emailTemplates: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438 \u043B\u0438\u0441\u0442\u0456\u0432",
    emailSmtp: "Email SMTP",
    emailLogs: "\u0416\u0443\u0440\u043D\u0430\u043B \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044C",
    bulkEmail: "\u041C\u0430\u0441\u043E\u0432\u0430 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0430",
    hrModule: "HR",
    hrAttendance: "\u0412\u0456\u0434\u0432\u0456\u0434\u0443\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    hrLeaveCalendar: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043E\u043A",
    hrLeaveRequest: "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0443",
    hrEmployees: "\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0438"
  },
  header: {
    search: "\u041F\u043E\u0448\u0443\u043A",
    searchShortcut: "\u041F\u043E\u0448\u0443\u043A (Ctrl+K)",
    lightMode: "\u0421\u0432\u0456\u0442\u043B\u0430 \u0442\u0435\u043C\u0430",
    darkMode: "\u0422\u0435\u043C\u043D\u0430 \u0442\u0435\u043C\u0430",
    language: "\u041C\u043E\u0432\u0430",
    user: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
    logout: "\u0412\u0438\u0439\u0442\u0438",
    role: "\u0420\u043E\u043B\u044C",
    pendingSync: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F"
  },
  command: {
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A...",
    noResults: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    navigate: "\u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F",
    open: "\u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
    close: "\u0437\u0430\u043A\u0440\u0438\u0442\u0438",
    addFavorite: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u043E\u0431\u0440\u0430\u043D\u043E\u0433\u043E",
    removeFavorite: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0437 \u043E\u0431\u0440\u0430\u043D\u043E\u0433\u043E"
  },
  status: {
    active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    closed: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438\u0439",
    draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
    expired: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439",
    cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0439",
    pending: "\u041E\u0447\u0456\u043A\u0443\u0454",
    inProgress: "\u0412 \u0440\u043E\u0431\u043E\u0442\u0456",
    completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0439",
    waiting: "\u041E\u0447\u0456\u043A\u0443\u0454",
    billable: "\u0414\u043E \u043E\u043F\u043B\u0430\u0442\u0438",
    deleted: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439",
    partialReturn: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043E",
    returned: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043E",
    free: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
    rentedOut: "\u0412 \u043E\u0440\u0435\u043D\u0434\u0456",
    inService: "\u041D\u0430 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u0456",
    reserved: "\u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E",
    excellent: "\u0412\u0456\u0434\u043C\u0456\u043D\u043D\u0438\u0439",
    good: "\u0414\u043E\u0431\u0440\u0438\u0439",
    adequate: "\u0417\u0430\u0434\u043E\u0432\u0456\u043B\u044C\u043D\u0438\u0439",
    open: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0439",
    interrupted: "\u041F\u0435\u0440\u0435\u0440\u0432\u0430\u043D\u0438\u0439",
    low: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
    medium: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
    high: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
    trusted: "\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0438\u0439",
    notTrusted: "\u041D\u0435 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0438\u0439",
    depositFree: "\u0411\u0435\u0437 \u0437\u0430\u0441\u0442\u0430\u0432\u0438!",
    depositMissing: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u044F",
    storno: "(\u0441\u0442\u043E\u0440\u043D\u043E)"
  },
  toast: {
    saved: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
    deleted: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
    created: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    updated: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    error: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    loginError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0445\u043E\u0434\u0443"
  },
  error: {
    required: "\u0426\u0435 \u043F\u043E\u043B\u0435 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
    invalidEmail: "\u041D\u0435\u0432\u0456\u0440\u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    loadFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
    saveFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
    general: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    notFound: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    minLength: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C {min} \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
    worksheetNotFound: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    rentalNotFound: "\u041E\u0440\u0435\u043D\u0434\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    invoiceNotFound: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    noCashRegisterOpen: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E\u0457 \u043A\u0430\u0441\u0438.",
    atLeastOneItem: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440!",
    enterPartnerName: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0456\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430!",
    minCharsRequired: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C {min} \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
    atLeastOneChange: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u043D\u0430 \u0441\u0443\u0442\u0442\u0454\u0432\u0430 \u0437\u043C\u0456\u043D\u0430!",
    calendar: {
      createHoliday: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0432\u044F\u0442\u043E",
      createOverride: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      deleteHoliday: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0441\u0432\u044F\u0442\u043E",
      deleteOverride: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      loadCalendar: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440",
      loadHolidays: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0432\u044F\u0442\u0430",
      loadHours: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u0447\u0430\u0441",
      loadOverrides: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      resetDefaults: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
      seedNational: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043D\u0430\u0446\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0441\u0432\u044F\u0442\u0430",
      updateHoliday: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0432\u044F\u0442\u043E",
      updateHours: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u0447\u0430\u0441",
      updateOverride: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"
    },
    chat: {
      createConversation: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0447\u0430\u0442",
      loadConversations: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0447\u0430\u0442\u0438",
      loadMessages: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
      loadUsers: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432",
      sendMessage: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F"
    },
    common: {
      operationFailed: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u0430\u0441\u044F",
      unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
    },
    rental: {
      depositPaidEquipmentTaken: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u0441\u043F\u0438\u0441\u0430\u043D\u043E, \u043E\u0440\u0435\u043D\u0434\u0443 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u2014 \u0430\u043B\u0435 \u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0442\u0438\u043C \u0447\u0430\u0441\u043E\u043C \u0432\u0438\u0434\u0430\u043B\u0438 \u0432 \u0456\u043D\u0448\u0443 \u043E\u0440\u0435\u043D\u0434\u0443, \u0442\u043E\u043C\u0443 \u0457\u0457 \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u043A\u0440\u0456\u043F\u0438\u0442\u0438. \u041D\u0415 \u043F\u043E\u0432\u0442\u043E\u0440\u044E\u0439\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443: \u043A\u043E\u0436\u043D\u0430 \u0441\u043F\u0440\u043E\u0431\u0430 \u0441\u0442\u0432\u043E\u0440\u044E\u0454 \u043D\u043E\u0432\u0435 \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u0442\u0430 \u043D\u043E\u0432\u0443 \u043E\u0440\u0435\u043D\u0434\u0443. \u041F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C \u0437\u0430\u0441\u0442\u0430\u0432\u0443 \u043D\u0430 \u0435\u043A\u0440\u0430\u043D\u0456 \u0437\u0430\u0441\u0442\u0430\u0432 \u0456 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0456\u043D\u0448\u0443 \u0442\u0435\u0445\u043D\u0456\u043A\u0443. ({contractNumber})",
      depositPaidNotRecorded: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u0441\u043F\u0438\u0441\u0430\u043D\u043E, \u043E\u0440\u0435\u043D\u0434\u0443 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u2014 \u0430\u043B\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043D\u0435 \u0437\u043C\u043E\u0433\u043B\u0430 \u0437\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0434\u0430\u0447\u0443. \u0422\u0435\u0445\u043D\u0456\u043A\u0430 \u043D\u0435 \u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u0430 \u0437\u0430 \u0436\u043E\u0434\u043D\u043E\u044E \u043E\u0440\u0435\u043D\u0434\u043E\u044E \u0456, \u043C\u043E\u0436\u043B\u0438\u0432\u043E, \u0449\u0435 \u0441\u0442\u043E\u0457\u0442\u044C \u043D\u0430 \u0441\u0442\u0456\u0439\u0446\u0456. \u041D\u0415 \u043F\u043E\u0432\u0442\u043E\u0440\u044E\u0439\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443: \u043A\u043E\u0436\u043D\u0430 \u0441\u043F\u0440\u043E\u0431\u0430 \u0441\u0442\u0432\u043E\u0440\u044E\u0454 \u043D\u043E\u0432\u0435 \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u0442\u0430 \u043D\u043E\u0432\u0443 \u043E\u0440\u0435\u043D\u0434\u0443. \u041F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C \u0437\u0430\u0441\u0442\u0430\u0432\u0443 \u043D\u0430 \u0435\u043A\u0440\u0430\u043D\u0456 \u0437\u0430\u0441\u0442\u0430\u0432 \u0456 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u0442\u0435 \u043F\u0440\u043E \u043F\u043E\u043C\u0438\u043B\u043A\u0443. ({contractNumber})",
      pickupFailed: "\u0412\u0438\u0434\u0430\u0447\u0430 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u0430\u0441\u044F. \u041E\u0440\u0435\u043D\u0434\u0430 \u0437\u0430\u043B\u0438\u0448\u0438\u043B\u0430\u0441\u044F \u0432 \u0441\u0442\u0430\u0442\u0443\u0441\u0456 \u0427\u0415\u0420\u041D\u0415\u0422\u041A\u0410 \u2014 \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u0434\u0435\u0442\u0430\u043B\u0435\u0439. \u041F\u043E\u043C\u0438\u043B\u043A\u0430: {error}",
      depositRefundFailed: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u0435, \u0430\u043B\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F. \u0421\u0443\u043C\u0430: {amount}. \u041F\u043E\u043C\u0438\u043B\u043A\u0430: {error}. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043E\u0444\u043E\u0440\u043C\u0456\u0442\u044C \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0432\u0440\u0443\u0447\u043D\u0443.",
      depositRefundTitle: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438 - \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438"
    },
    tasks: {
      loadAll: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
      loadByStatus: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
      loadOne: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
      loadOverdue: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
      loadStats: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443"
    },
    users: {
      create: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      delete: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      loadAll: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432",
      loadOne: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      update: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430"
    },
    contracts: {
      loadAll: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0438",
      loadOne: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u043E\u0433\u043E\u0432\u0456\u0440"
    },
    quotations: {
      loadAll: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      loadOne: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E"
    },
    NOT_FOUND: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    BAD_REQUEST: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0442",
    UNAUTHORIZED: "\u041D\u0435 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D\u043E",
    FORBIDDEN: "\u0414\u043E\u0441\u0442\u0443\u043F \u0437\u0430\u0431\u043E\u0440\u043E\u043D\u0435\u043D\u043E",
    CONFLICT: "\u041A\u043E\u043D\u0444\u043B\u0456\u043A\u0442 \u2014 \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    INTERNAL_ERROR: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430",
    VALIDATION_FAILED: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0430\u043B\u0456\u0434\u0430\u0446\u0456\u0457",
    AUTH_MISSING: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F",
    AUTH_INVALID_TOKEN: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0442\u043E\u043A\u0435\u043D",
    AUTH_TOKEN_EXPIRED: "\u0422\u0435\u0440\u043C\u0456\u043D \u0434\u0456\u0457 \u0442\u043E\u043A\u0435\u043D\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F",
    AUTH_ACCESS_TOKEN_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0442\u043E\u043A\u0435\u043D \u0434\u043E\u0441\u0442\u0443\u043F\u0443",
    AUTH_INVALID_CREDENTIALS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0456 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0456 \u0434\u0430\u043D\u0456",
    AUTH_SESSION_EXPIRED: "\u0421\u0435\u0441\u0456\u044F \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u043B\u0430\u0441\u044C, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0443\u0432\u0456\u0439\u0434\u0456\u0442\u044C \u0437\u043D\u043E\u0432\u0443",
    AUTH_INVALID_PIN: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 PIN-\u043A\u043E\u0434",
    RENTAL_NOT_FOUND: "\u041E\u0440\u0435\u043D\u0434\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    RENTAL_INVALID_STATUS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u043E\u0440\u0435\u043D\u0434\u0438",
    RENTAL_INVALID_TRANSITION: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u0445\u0456\u0434 \u0441\u0442\u0430\u0442\u0443\u0441\u0443",
    RENTAL_ALREADY_EXISTS: "\u041E\u0440\u0435\u043D\u0434\u0430 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    RENTAL_EQUIPMENT_NOT_AVAILABLE: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435",
    RENTAL_CONTRACT_NOT_FOUND: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u043E\u0440\u0435\u043D\u0434\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    RENTAL_DEPOSIT_NOT_FOUND: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    RENTAL_DEPOSIT_ALREADY_EXISTS: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0434\u043B\u044F \u0446\u0456\u0454\u0457 \u043E\u0440\u0435\u043D\u0434\u0438 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    RENTAL_DEPOSIT_INVALID_AMOUNT: "\u0421\u0443\u043C\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u043F\u043E\u0432\u0438\u043D\u043D\u0430 \u0431\u0443\u0442\u0438 \u043F\u043E\u0437\u0438\u0442\u0438\u0432\u043D\u043E\u044E",
    RENTAL_DEPOSIT_INVALID_STATUS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    RENTAL_DEPOSIT_INSUFFICIENT: "\u041F\u0435\u0440\u0435\u0434 \u0432\u0438\u0434\u0430\u0447\u0435\u044E \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u043F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0441\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0437\u0430\u0441\u0442\u0430\u0432\u0443",
    RENTAL_HISTORY_NOT_FOUND: "\u0406\u0441\u0442\u043E\u0440\u0456\u044E \u043E\u0440\u0435\u043D\u0434\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    WORKSHEET_NOT_FOUND: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    WORKSHEET_INVALID_STATUS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    WORKSHEET_INVALID_TRANSITION: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u0445\u0456\u0434 \u0441\u0442\u0430\u0442\u0443\u0441\u0443 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    WARRANTY_CLAIM_NOT_FOUND: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0443 \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    WARRANTY_INVALID_STATUS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0457",
    SERVICE_NORM_NOT_FOUND: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0443 \u043D\u043E\u0440\u043C\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    SERVICE_NORM_INVALID_CODE: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043A\u043E\u0434 \u043D\u043E\u0440\u043C\u0438",
    DIAGNOSTIC_NOT_FOUND: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    INVOICE_NOT_FOUND: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    INVOICE_INVALID_STATUS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    INVOICE_INVALID_TRANSITION: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u0445\u0456\u0434 \u0441\u0442\u0430\u0442\u0443\u0441\u0443 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    INVOICE_ITEM_NOT_FOUND: "\u041F\u043E\u0437\u0438\u0446\u0456\u044E \u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    POS_SESSION_NOT_FOUND: "\u041A\u0430\u0441\u043E\u0432\u0443 \u0441\u0435\u0441\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    POS_SESSION_ALREADY_OPEN: "\u041A\u0430\u0441\u043E\u0432\u0430 \u0441\u0435\u0441\u0456\u044F \u0432\u0436\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0430",
    QUOTE_NOT_FOUND: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    QUOTE_INVALID_STATUS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    QUOTE_ITEM_NOT_FOUND: "\u041F\u043E\u0437\u0438\u0446\u0456\u044E \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    QUOTE_ONLY_DRAFT_MODIFIABLE: "\u041B\u0438\u0448\u0435 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u043C\u043E\u0436\u043D\u0430 \u0437\u043C\u0456\u043D\u044E\u0432\u0430\u0442\u0438",
    QUOTE_ONLY_DRAFT_DELETABLE: "\u041B\u0438\u0448\u0435 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u0434\u0430\u043B\u044F\u0442\u0438",
    QUOTE_ONLY_DRAFT_SENDABLE: "\u041B\u0438\u0448\u0435 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0438 \u0430\u0431\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043C\u043E\u0436\u043D\u0430 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0442\u0438",
    QUOTE_EMAIL_NOT_CONFIGURED: "\u0421\u043B\u0443\u0436\u0431\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u043E",
    QUOTE_RECIPIENT_REQUIRED: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430 \u043E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
    QUOTE_PARTNER_REQUIRED: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    QUOTE_ITEMS_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u043D\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u044F",
    QUOTE_INVALID_QUANTITY: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043F\u043E\u0432\u0438\u043D\u043D\u0430 \u0431\u0443\u0442\u0438 \u043F\u043E\u0437\u0438\u0442\u0438\u0432\u043D\u043E\u044E",
    QUOTE_INVALID_UNIT_PRICE: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434'\u0454\u043C\u043D\u043E\u044E",
    QUOTE_EXPLODED_VIEW_NOT_FOUND: "\u0421\u0445\u0435\u043C\u0443 \u0432 \u0440\u043E\u0437\u0440\u0456\u0437\u0456 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    QUOTE_MANUFACTURER_REQUIRED: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    QUOTE_MODEL_REQUIRED: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u043C\u043E\u0434\u0435\u043B\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    QUOTE_PARTS_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u043D\u0443 \u0434\u0435\u0442\u0430\u043B\u044C",
    PARTNER_NOT_FOUND: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    PARTNER_ALREADY_EXISTS: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    PARTNER_INVALID_TAX_NUMBER: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    PARTNER_DUPLICATE: "\u0414\u0443\u0431\u043B\u0456\u043A\u0430\u0442 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    PARTNER_CONTRACT_NOT_FOUND: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    PARTNER_REFERENCE_NOT_FOUND: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    WAREHOUSE_NOT_FOUND: "\u0421\u043A\u043B\u0430\u0434 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    WAREHOUSE_LOCATION_NOT_FOUND: "\u041C\u0456\u0441\u0446\u0435 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    STOCK_INSUFFICIENT: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u0456\u0439 \u0437\u0430\u043F\u0430\u0441",
    STOCK_COUNT_NOT_FOUND: "\u0406\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    MOVEMENT_NOT_FOUND: "\u0420\u0443\u0445 \u0437\u0430\u043F\u0430\u0441\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    MOVEMENT_INVALID_TYPE: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0442\u0438\u043F \u0440\u0443\u0445\u0443",
    PHANTOM_WAREHOUSE_NOT_FOUND: "\u0424\u0430\u043D\u0442\u043E\u043C\u043D\u0438\u0439 \u0441\u043A\u043B\u0430\u0434 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    PRODUCT_NOT_FOUND: "\u0422\u043E\u0432\u0430\u0440 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    PRODUCT_SKU_EXISTS: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    PRODUCT_CATEGORY_NOT_FOUND: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044E \u0442\u043E\u0432\u0430\u0440\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    PRODUCT_SUPPLIER_NOT_FOUND: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    VEHICLE_NOT_FOUND: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    VEHICLE_DOCUMENT_EXPIRED: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439",
    CALENDAR_INVALID_DATE: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u0438",
    CALENDAR_HOLIDAY_NOT_FOUND: "\u0421\u0432\u044F\u0442\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    CALENDAR_OVERRIDE_NOT_FOUND: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    PORTAL_INVALID_TOKEN: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0442\u043E\u043A\u0435\u043D \u043F\u043E\u0440\u0442\u0430\u043B\u0443",
    PORTAL_INVALID_OTP: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    PORTAL_BOOKING_NOT_FOUND: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    PORTAL_EQUIPMENT_NOT_FOUND: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    CASH_REGISTER_NOT_FOUND: "\u041A\u0430\u0441\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    CASH_REGISTER_ALREADY_CLOSED: "\u041A\u0430\u0441\u0443 \u0432\u0436\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u043E",
    DAILY_CLOSE_ALREADY_EXISTS: "\u0414\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0432\u0436\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
    DELIVERY_NOTE_NOT_FOUND: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    DELIVERY_NOTE_INVALID_STATUS: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u043E\u0457",
    MENU_ITEM_ID_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u043F\u0443\u043D\u043A\u0442\u0443 \u043C\u0435\u043D\u044E",
    FAVORITES_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0441\u043F\u0438\u0441\u043E\u043A \u043E\u0431\u0440\u0430\u043D\u043E\u0433\u043E",
    EQUIPMENT_NOT_FOUND: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    EQUIPMENT_NOT_AVAILABLE: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435",
    KB_ARTICLE_NOT_FOUND: "\u0421\u0442\u0430\u0442\u0442\u044E \u0431\u0430\u0437\u0438 \u0437\u043D\u0430\u043D\u044C \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    WIDGET_ID_INVALID: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0432\u0456\u0434\u0436\u0435\u0442\u0430",
    TENANT_CONTEXT_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442 \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
    PRI_API_KEY_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043A\u043B\u044E\u0447 API, \u044F\u043A\u0449\u043E \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E",
    HOURLY_RATE_NEGATIVE: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434'\u0454\u043C\u043D\u043E\u044E",
    MACHINE_CATEGORY_NOT_FOUND: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044E \u0442\u0435\u0445\u043D\u0456\u043A\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    HOURLY_RATE_INVALID_DATE: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0430 \u0434\u0430\u0442\u0430",
    HOURLY_RATE_PERIOD_ORDER: "\u0414\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0440\u0430\u043D\u0456\u0448\u0435 \u0434\u0430\u0442\u0438 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
    HOURLY_RATE_NOT_FOUND: "\u041A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E \u043F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u043E\u0457 \u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    LEAVE_OVERLAP: "\u0412\u0438 \u0432\u0436\u0435 \u043C\u0430\u0454\u0442\u0435 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0443 \u043D\u0430 \u0446\u0435\u0439 \u043F\u0435\u0440\u0456\u043E\u0434",
    LEAVE_INSUFFICIENT_BALANCE: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0431\u0430\u043B\u0430\u043D\u0441\u0443 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0438 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0442\u0443",
    LEAVE_REQUEST_NOT_FOUND: "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    LEAVE_NOT_PENDING: "\u0417\u0430\u043F\u0438\u0442 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u043E\u0447\u0456\u043A\u0443\u0454 \u043D\u0430 \u0440\u043E\u0437\u0433\u043B\u044F\u0434",
    EMPLOYEE_PROFILE_NOT_FOUND: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C \u0441\u043F\u0456\u0432\u0440\u043E\u0431\u0456\u0442\u043D\u0438\u043A\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    WARRANTY_ELIGIBLE_LIST_FAILED: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
    WARRANTY_BATCH_FAILED: "\u041F\u0430\u043A\u0435\u0442\u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432 \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F",
    WARRANTY_BATCH_INPUT_REQUIRED: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u0434\u0430\u043D\u0456 \u0434\u043B\u044F \u043F\u0430\u043A\u0435\u0442\u043D\u043E\u0433\u043E \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    WARRANTY_BATCH_INVALID_DATE: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0430 \u0434\u0430\u0442\u0430 \u0432 \u043F\u0435\u0440\u0456\u043E\u0434\u0456 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    WARRANTY_BATCH_PERIOD_ORDER: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0456\u0437\u043D\u0456\u0448\u043E\u044E \u0437\u0430 \u0434\u0430\u0442\u0443 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
    WARRANTY_ALREADY_INVOICED: "\u0426\u044E \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0443 \u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0436\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    WORKSHEET_ID_REQUIRED: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    PARTNER_DUPLICATE_TAX: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0456\u0437 \u0446\u0438\u043C \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u0443\u0436\u0435 \u0456\u0441\u043D\u0443\u0454 \u2014 \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0439\u043E\u0433\u043E \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443.",
    PARTNER_DUPLICATE_CODE: "\u041A\u043E\u043D\u0444\u043B\u0456\u043A\u0442 \u043A\u043E\u0434\u0443 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u2014 \u0431\u0443\u0434\u0435 \u0437\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u043E \u043D\u043E\u0432\u0438\u0439 \u043A\u043E\u0434.",
    CALCULATE_FAILED: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0437\u0430\u0440\u043E\u0431\u0456\u0442\u043D\u043E\u0457 \u043F\u043B\u0430\u0442\u0438 \u043D\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u0442\u0435 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0438.",
    BOLT_APPROVE_FAILED: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u043C \u043D\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u0442\u0435 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0438.",
    CENTRAL_REVIEW_FAILED: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0443 \u0446\u0435\u043D\u0442\u0440\u043E\u043C \u043D\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u0442\u0435 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0438.",
    FINALIZE_FAILED: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u043D\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430\u0440\u043E\u0431\u0456\u0442\u043D\u043E\u0457 \u043F\u043B\u0430\u0442\u0438 \u043D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u0442\u0435 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0438."
  },
  login: {
    title: "\u0412\u0445\u0456\u0434",
    email: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
    password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    rememberMe: "\u0417\u0430\u043F\u0430\u043C'\u044F\u0442\u0430\u0442\u0438 \u043C\u0435\u043D\u0435",
    submit: "\u0423\u0432\u0456\u0439\u0442\u0438",
    error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0445\u043E\u0434\u0443",
    forgotPassword: "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
    systemName: "rPI ERP \u0421\u0438\u0441\u0442\u0435\u043C\u0430",
    testCredentials: "\u0422\u0435\u0441\u0442\u043E\u0432\u0456 \u0434\u0430\u043D\u0456",
    placeholder: {
      email: "\u043F\u0440\u0438\u043A\u043B\u0430\u0434@email.ua"
    },
    errorInvalidCredentials: "\u041D\u0435\u0432\u0456\u0440\u043D\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430 \u0430\u0431\u043E \u043F\u0430\u0440\u043E\u043B\u044C.",
    errorSystemTemporary: "\u0422\u0438\u043C\u0447\u0430\u0441\u043E\u0432\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u0437\u0430 \u043A\u0456\u043B\u044C\u043A\u0430 \u0445\u0432\u0438\u043B\u0438\u043D.",
    errorTooManyAttempts: "\u0417\u0430\u0431\u0430\u0433\u0430\u0442\u043E \u043D\u0435\u0432\u0434\u0430\u043B\u0438\u0445 \u0441\u043F\u0440\u043E\u0431. \u0417\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435 \u043A\u0456\u043B\u044C\u043A\u0430 \u0445\u0432\u0438\u043B\u0438\u043D.",
    errorNetwork: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438\u0441\u044F \u0434\u043E \u0441\u0435\u0440\u0432\u0435\u0440\u0430. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0406\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443."
  },
  rental: {
    loyalty: {
      title: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0442\u0438 \u0431\u0430\u043B\u0438 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456",
      balance: "\u0411\u0430\u043B\u0430\u043D\u0441: {points} \u0431\u0430\u043B\u0456\u0432",
      applied: "{points} \u0431\u0430\u043B\u0456\u0432 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043E",
      capReached: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C \u0434\u043E 50% \u0441\u0443\u043C\u0438 \u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u2014 \u0440\u0435\u0448\u0442\u0430 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F."
    },
    clone: {
      cta: "\u042F\u043A \u043C\u0438\u043D\u0443\u043B\u043E\u0433\u043E \u0440\u0430\u0437\u0443 ({code})",
      label: "\u042F\u043A \u043C\u0438\u043D\u0443\u043B\u043E\u0433\u043E \u0440\u0430\u0437\u0443?",
      lastRental: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0430: {code}",
      helper: "\u0417\u0430\u043F\u043E\u0432\u043D\u044E\u0454 \u043C\u0430\u0448\u0438\u043D\u0438 \u0442\u0430 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438, \u043F\u043E\u0442\u0456\u043C \u043C\u043E\u0436\u043D\u0430 \u0437\u043C\u0456\u043D\u0438\u0442\u0438",
      button: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u2192",
      banner: {
        label: "\u042F\u043A \u043C\u0438\u043D\u0443\u043B\u043E\u0433\u043E \u0440\u0430\u0437\u0443",
        summary: "{equipment} \u043C\u0430\u0448\u0438\u043D \xB7 {package} \u043F\u0430\u043A\u0435\u0442\u0456\u0432",
        helper: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0454 \u043C\u0430\u0448\u0438\u043D\u0438, \u043F\u0430\u043A\u0435\u0442\u0438 \u0442\u0430 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438. \u041F\u043E\u0442\u0456\u043C \u043C\u043E\u0436\u043D\u0430 \u0432\u0441\u0435 \u0437\u043C\u0456\u043D\u0438\u0442\u0438.",
        apply: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
        dismiss: "\u041F\u043E\u0440\u043E\u0436\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0430"
      }
    },
    inlineSign: {
      cta: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438 \u0434\u043E\u0433\u043E\u0432\u0456\u0440 \u0437\u0430\u0440\u0430\u0437",
      startFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0456\u0434\u0433\u043E\u0442\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0433\u043E\u0432\u0456\u0440."
    },
    pickup: {
      conflictTitle: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0432\u0436\u0435 \u0437\u0430\u0439\u043D\u044F\u0442\u0435",
      conflictDesc: "\u0406\u043D\u0448\u0430 \u043A\u0430\u0441\u0430 \u0442\u0438\u043C \u0447\u0430\u0441\u043E\u043C \u0432\u0438\u0434\u0430\u043B\u0430 \u0446\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0456\u0441\u0442\u044C \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u2014 \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0456\u043D\u0448\u0438\u0439 \u0435\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 \u0430\u0431\u043E \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437."
    },
    itemDiscount: {
      title: "\u0417\u043D\u0438\u0436\u043A\u0430 \u043D\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
      helper: "\u0420\u0443\u0447\u043D\u0430 \u0437\u043D\u0438\u0436\u043A\u0430 \u043D\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u044E. \u041F\u043E\u043D\u0430\u0434 \u043B\u0456\u043C\u0456\u0442 \u0440\u043E\u043B\u0456 (role-cap) \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043E\u0431\u043C\u0435\u0436\u0443\u0454.",
      inputAria: "\u0417\u043D\u0438\u0436\u043A\u0430 % \u2014 {name}",
      applied: "\u0417\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0430\u043D\u043E: {pct}%",
      cappedByRole: "\u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043E \u043B\u0456\u043C\u0456\u0442\u043E\u043C \u0440\u043E\u043B\u0456: {pct}%",
      totalDiscount: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0437\u043D\u0438\u0436\u043A\u0430",
      finalAmount: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
      apply: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u0438\u0436\u043A\u0443",
      noneEntered: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u0438\u043D % \u0437\u043D\u0438\u0436\u043A\u0438.",
      applyFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u0438\u0436\u043A\u0443."
    },
    handover: {
      title: "\u0424\u043E\u0442\u043E \u0441\u0442\u0430\u043D\u0443",
      uploadHandover: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0442\u043E \u0432\u0438\u0434\u0430\u0447\u0456",
      uploadReturn: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0442\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      empty: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0438\u0445 \u0444\u043E\u0442\u043E",
      uploading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
      errorType: "\u041D\u0435\u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u043D\u0438\u0439 \u0442\u0438\u043F \u0444\u0430\u0439\u043B\u0443. \u0414\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u043E: JPEG, PNG, WebP.",
      errorSize: "\u0424\u0430\u0439\u043B \u0437\u0430\u0432\u0435\u043B\u0438\u043A\u0438\u0439 (\u043C\u0430\u043A\u0441. {max} \u041C\u0411).",
      compareTitle: "\u041F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043D\u044F \u0441\u0442\u0430\u043D\u0443 (\u0432\u0438\u0434\u0430\u0447\u0430 \u2194 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F)",
      compareHint: "\u041F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043D\u044F \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u0439 \u0432\u0438\u0434\u0430\u0447\u0456 \u0442\u0430 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u2014 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F, \u043D\u0430\u044F\u0432\u043D\u0456 \u043F\u0440\u0438 \u0432\u0438\u0434\u0430\u0447\u0456, \u043D\u0435 \u043E\u0431\u0442\u044F\u0436\u0443\u044E\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F \u043F\u0440\u0438 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u0437\u0430\u0441\u0442\u0430\u0432\u0438.",
      handoverColumn: "\u0421\u0442\u0430\u043D \u043F\u0440\u0438 \u0432\u0438\u0434\u0430\u0447\u0456",
      returnColumn: "\u0421\u0442\u0430\u043D \u043F\u0440\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u0456"
    },
    title: "\u041E\u0440\u0435\u043D\u0434\u0430",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u043E\u044E \u0442\u0430 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F",
    fleetCalendar: {
      title: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
      rented: "\u0412 \u043E\u0440\u0435\u043D\u0434\u0456",
      reserved: "\u0417\u0430\u0431\u0440\u043E\u043D\u044C\u043E\u0432\u0430\u043D\u043E",
      overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
      equipment: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      noEquipment: "\u041D\u0435\u043C\u0430\u0454 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F"
    },
    newRental: "\u041D\u043E\u0432\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
    equipment: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    startDate: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
    endDate: "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
    deposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    dailyRate: "\u0414\u0435\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430",
    returnDate: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnRental: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443",
    status: {
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      expired: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439",
      returned: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u0438\u0439",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0439"
    },
    contract: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440",
    period: "\u041F\u0435\u0440\u0456\u043E\u0434",
    rentalFee: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
    depositPaid: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0441\u043F\u043B\u0430\u0447\u0435\u043D\u0430",
    returnDeposit: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438 \u0437\u0430\u0441\u0442\u0430\u0432\u0443",
    selectReturnRental: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443 \u0434\u043B\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    equipmentConditionCheck: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0441\u0442\u0430\u043D\u0443 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    paymentSettlement: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u0438",
    returnConfirmation: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    activeRentalsCount: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438 ({count})",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443, \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u043C \u0430\u0431\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F\u043C...",
    allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    selectEquipment: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    rentalData: "\u0414\u0430\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    financialSettlement: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    damageBreakdown: "\u041A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F \u0437\u0431\u0438\u0442\u043A\u0456\u0432 \u0437\u0430 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F\u043C",
    deductions: "\u0423\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F",
    lateFee: "\u0428\u0442\u0440\u0430\u0444 \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F ({days} \u0434\u043D\u0456\u0432)",
    totalDamage: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F \u0437\u0431\u0438\u0442\u043A\u0456\u0432",
    totalDeductions: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0456 \u0443\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F:",
    returnableDeposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0434\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F:",
    summary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    returnedEquipment: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F:",
    rentalContinues: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u0454\u0442\u044C\u0441\u044F:",
    returnable: "\u0414\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F:",
    partialReturnConfirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0447\u0430\u0441\u0442\u043A\u043E\u0432\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnConfirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnedItems: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    continuingItems: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u0454\u0442\u044C\u0441\u044F",
    returnableDeposit2: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0434\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    cashPayment: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430",
    cardPayment: "\u041A\u0430\u0440\u0442\u043A\u0430",
    transferPayment: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437",
    cashPaymentLabel: "\u0413\u043E\u0442\u0456\u0432\u043A\u043E\u044E",
    cardPaymentLabel: "\u041D\u0430 \u043A\u0430\u0440\u0442\u043A\u0443",
    transferPaymentLabel: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437\u043E\u043C",
    deductionsLabel: "\u0423\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F:",
    searchRentalPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u043E\u0440\u0435\u043D\u0434\u0438, \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u043C \u0430\u0431\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F\u043C...",
    overdueSubtitle: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0435 \u0442\u0430 \u043D\u0435\u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    searchPartnerPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430, \u043D\u0430\u0437\u0432\u043E\u044E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F...",
    loadingActive: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u043E\u0440\u0435\u043D\u0434...",
    returnNotFound: "\u041E\u0440\u0435\u043D\u0434\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0430\u0431\u043E \u0432\u0436\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E.",
    allRentals: "\u0412\u0441\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    partnerNameCol: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    callPartner: "\u0417\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0443",
    smsReminder: {
      triggerLabel: "SMS-\u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
      title: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 SMS-\u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
      recipientLabel: "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447",
      messageLabel: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
      defaultMessage: "\u0428\u0430\u043D\u043E\u0432\u043D\u0438\u0439(\u0430) {customerName}! \u0422\u0435\u0440\u043C\u0456\u043D \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F {equipmentName} \u043C\u0438\u043D\u0443\u0432 {days} \u0434\u043D. \u0442\u043E\u043C\u0443. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u043E\u0432\u0435\u0440\u043D\u0456\u0442\u044C \u0439\u043E\u0433\u043E \u043D\u0430\u0439\u0431\u043B\u0438\u0436\u0447\u0438\u043C \u0447\u0430\u0441\u043E\u043C \u0430\u0431\u043E \u0437\u0432'\u044F\u0436\u0456\u0442\u044C\u0441\u044F \u0437 \u043D\u0430\u043C\u0438. \u0417 \u043F\u043E\u0432\u0430\u0433\u043E\u044E: Kisg\xE9pcentrum",
      send: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
      sending: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F...",
      close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
      status: {
        sent: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0443",
        blocked: "\u041D\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u2014 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F SMS \u043D\u0430\u0440\u0430\u0437\u0456 \u0432\u0438\u043C\u043A\u043D\u0435\u043D\u043E (\u0448\u043B\u044E\u0437 \u0437\u0430\u043A\u0440\u0438\u0442\u043E)",
        dryRun: "\u0422\u0435\u0441\u0442\u043E\u0432\u0438\u0439 \u0440\u0435\u0436\u0438\u043C: \u043D\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E (DRY-RUN), \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u043E",
        failed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F"
      }
    },
    equipmentNameCol: "\u041D\u0430\u0437\u0432\u0430 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    expiryDate: "\u0414\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
    daysOverdue: "\u0414\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
    rentalCodeCol: "\u041A\u043E\u0434 \u043E\u0440\u0435\u043D\u0434\u0438",
    amountCol: "\u0421\u0443\u043C\u0430",
    lateFeeLabel: "\u043F\u0435\u043D\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
    estimatedLateFeeCol: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
    estimatedLateFeeHint: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430 \u043F\u0435\u043D\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F \u043F\u0440\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u0456 \u0437\u0430\u0440\u0430\u0437 (\u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u2014 \u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u0430 \u0441\u0443\u043C\u0430 \u0440\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F \u043F\u0440\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u0456)",
    currentDebt: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    debtExceedsDeposit: "\u041F\u0435\u0440\u0435\u0432\u0438\u0449\u0435\u043D\u043E \u043F\u043E\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438!",
    daysLateLabel: "{days} \u0434\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
    daysLabel: "{days} \u0434\u043D\u0456\u0432",
    expired: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E:",
    noOverdue: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E\u0433\u043E",
    allReturned: "\u0412\u0441\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043E \u0432\u0447\u0430\u0441\u043D\u043E!",
    backToRentals: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u043E\u0440\u0435\u043D\u0434",
    rentalReturn: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    unknownEquipment: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    equipmentCount: "{count} \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    multiItemInfo: "\u0411\u0430\u0433\u0430\u0442\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439\u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0430 \u2014 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C, \u044F\u043A\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438. \u041D\u0435\u0432\u0438\u0431\u0440\u0430\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u0443\u0432\u0430\u0442\u0438\u0441\u044F.",
    earlyReturnLabel: "\u0414\u043E\u0441\u0442\u0440\u043E\u043A\u043E\u0432\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    earlyReturnDays: "\u0414\u043E\u0441\u0442\u0440\u043E\u043A\u043E\u0432\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u2014 {actual}/{original} \u0434\u043D\u0456\u0432",
    originalDiscount: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0430 \u0437\u043D\u0438\u0436\u043A\u0430:",
    actualDiscount: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0430 \u0437\u043D\u0438\u0436\u043A\u0430:",
    discountChanged: "\u0420\u0456\u0432\u0435\u043D\u044C \u0437\u043D\u0438\u0436\u043A\u0438 \u0437\u043C\u0456\u043D\u0438\u0432\u0441\u044F \u2014 \u0446\u0456\u043D\u0430 \u0431\u0443\u0434\u0435 \u043F\u0435\u0440\u0435\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0430.",
    discountUnchanged: "\u0420\u0456\u0432\u0435\u043D\u044C \u0437\u043D\u0438\u0436\u043A\u0438 \u043D\u0435 \u0437\u043C\u0456\u043D\u0438\u0432\u0441\u044F \u2014 \u0434\u0456\u0454 \u043F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0430 \u0446\u0456\u043D\u0430.",
    selectEquipmentReturn: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    selectEquipmentSingle: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    issuedCondition: "\u0421\u0442\u0430\u043D \u043F\u0440\u0438 \u0432\u0438\u0434\u0430\u0447\u0456:",
    returnConditionLabel: "\u0421\u0442\u0430\u043D \u043F\u0440\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u0456",
    damageDescription: "\u041E\u043F\u0438\u0441 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u044C",
    damagePlaceholder: "\u041E\u043F\u0438\u0441 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u044C (\u044F\u043A\u0449\u043E \u0454)...",
    damageChargeLabel: "\u041A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F \u0437\u0431\u0438\u0442\u043A\u0456\u0432 (Ft)",
    damageDescriptionAria: "\u041E\u043F\u0438\u0441 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u044C: {name}",
    contractLabel: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440:",
    partnerLabel: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440:",
    periodLabel: "\u041F\u0435\u0440\u0456\u043E\u0434:",
    rentalFeeLabel: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430:",
    depositPaidLabel: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0441\u043F\u043B\u0430\u0447\u0435\u043D\u0430:",
    partialReturnInfo: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F: {returning} \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043E, {continuing} \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u0454 \u043E\u0440\u0435\u043D\u0434\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    damageBreakdownLabel: "\u041A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F \u0437\u0431\u0438\u0442\u043A\u0456\u0432 \u043F\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044E",
    noDeductions: "\u041D\u0435\u043C\u0430\u0454 \u0443\u0442\u0440\u0438\u043C\u0430\u043D\u044C",
    depositPaidSummary: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0441\u043F\u043B\u0430\u0447\u0435\u043D\u0430:",
    totalDeductionsSummary: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0456 \u0443\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F:",
    depositRefundMethod: "\u0421\u043F\u043E\u0441\u0456\u0431 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    optionalNotePlaceholder: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430...",
    returnNoteAria: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnedEquipmentLabel: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F:",
    rentalContinuesLabel: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u0454\u0442\u044C\u0441\u044F:",
    returnableLabel: "\u0414\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F:",
    partialReturnConfirmTitle: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0447\u0430\u0441\u0442\u043A\u043E\u0432\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnConfirmTitle: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    contractSummaryLabel: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440:",
    partnerSummaryLabel: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440:",
    finalizeReturn: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnTypePartial: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnTypeFull: "\u041F\u043E\u0432\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    returnSuccess: "{type} \u0443\u0441\u043F\u0456\u0448\u043D\u0435!\n\n\u0414\u043E\u0433\u043E\u0432\u0456\u0440: {contract}\n\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F: {equipment}\n\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438: {deposit}",
    lateFeeWithDays: "\u041F\u0435\u043D\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F ({days} \u0434\u043D\u0456\u0432)",
    lateFeeConfirmLabel: "\u041F\u0435\u043D\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F:",
    lateFeeBreakdown: "{days} \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438\u0445 \u0434\u043D. \xD7 {rate}/\u0434\u0435\u043D\u044C",
    lateFeeBreakdownCapped: "\u0434\u043E\u0441\u044F\u0433\u043D\u0443\u0442\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C\u0443 ({max})",
    lateFeeModelLegacy: "\u043C\u043E\u0434\u0435\u043B\u044C 150% \u0434\u0435\u043D\u043D\u043E\u0457 \u0441\u0442\u0430\u0432\u043A\u0438",
    lateFeeWaived: "\u043F\u0435\u043D\u044E \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
    damageConfirmLabel: "\u041A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F \u0437\u0431\u0438\u0442\u043A\u0456\u0432:",
    errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    daysDelayLabel: "{days} \u0434\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
    depositLabel: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430:",
    lateFeeAmount: "\u041F\u0435\u043D\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F:",
    quantityLabel: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {count} \u0448\u0442.",
    tierLabels: {
      hourly: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u043E",
      daily: "\u041F\u043E\u0434\u043E\u0431\u043E\u0432\u043E",
      weekly: "\u041F\u043E\u0442\u0438\u0436\u043D\u0435\u0432\u043E",
      monthly: "\u041F\u043E\u043C\u0456\u0441\u044F\u0447\u043D\u043E"
    },
    startTime: "\u0427\u0430\u0441 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
    endTime: "\u0427\u0430\u0441 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
    hourlyBilling: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0435 \u043D\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
    hourlyRate: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430",
    returnTime: "\u0427\u0430\u0441 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    rentalNotes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043E\u0440\u0435\u043D\u0434\u0438",
    rentalNotesPlaceholder: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043E\u0440\u0435\u043D\u0434\u0438...",
    quantityPcs: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {count} \u0448\u0442.",
    daysAgo: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E \u043D\u0430 {days} \u0434\u043D\u0456\u0432",
    daysLeft: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C {days} \u0434\u043D\u0456\u0432",
    daysUntilExpiry: "{days} \u0434\u043D\u0456\u0432 \u0434\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
    expiresToday: "\u0417\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456!",
    extension: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F",
    extensionDialog: {
      additionalDays: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u043D\u0456",
      currentExpiry: "\u041F\u043E\u0442\u043E\u0447\u043D\u0430 \u0434\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
      dateError: "\u041D\u043E\u0432\u0430 \u0434\u0430\u0442\u0430 \u043F\u043E\u0432\u0438\u043D\u043D\u0430 \u0431\u0443\u0442\u0438 \u043F\u0456\u0441\u043B\u044F \u043F\u043E\u0442\u043E\u0447\u043D\u043E\u0457 \u0434\u0430\u0442\u0438 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
      day: "\u0434\u0435\u043D\u044C",
      days: "\u0434\u043D\u0456\u0432",
      discountTierChange: "\u0417\u043C\u0456\u043D\u0430 \u0440\u0456\u0432\u043D\u044F \u0437\u043D\u0438\u0436\u043A\u0438",
      newExpiryDate: "\u041D\u043E\u0432\u0430 \u0434\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
      priceDisclaimer: "\u041E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u0430 \u0446\u0456\u043D\u0430 \u0431\u0443\u0434\u0435 \u0440\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0430 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 \u0442\u0430\u0440\u0438\u0444\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0443 \u043E\u0440\u0435\u043D\u0434\u0438",
      reasonLabel: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      reasonPlaceholder: "\u0427\u043E\u043C\u0443 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F...",
      surcharge: "\u0414\u043E\u043F\u043B\u0430\u0442\u0430",
      surchargeWithVat: "\u0414\u043E\u043F\u043B\u0430\u0442\u0430 \u0437 \u041F\u0414\u0412",
      title: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438"
    },
    extensionError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u0456",
    financialSummary: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u043F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F",
    notFound: "\u041E\u0440\u0435\u043D\u0434\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    notFoundDescription: "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0430 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454 \u0430\u0431\u043E \u0431\u0443\u043B\u0430 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0430",
    overdueAlert: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E \u043D\u0430 {days} \u0434\u043D\u0456\u0432 \u2014 \u043D\u0430\u0440\u0430\u0445\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F \u0448\u0442\u0440\u0430\u0444!",
    partnerDetails: "\u0414\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    printContract: "\u0414\u0440\u0443\u043A \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
    quickInfo: "\u041A\u043E\u0440\u043E\u0442\u043A\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
    remaining: "\u0427\u0430\u0441, \u0449\u043E \u0437\u0430\u043B\u0438\u0448\u0438\u0432\u0441\u044F",
    rentedEquipment: "\u041E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    sendEmail: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u044E \u043F\u043E\u0448\u0442\u043E\u044E",
    timeline: {
      contractCreated: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      depositPaid: "\u0417\u0430\u0432\u0434\u0430\u0442\u043E\u043A \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      rentalStarted: "\u041E\u0440\u0435\u043D\u0434\u0443 \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E"
    },
    totalRentalFee: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u0438",
    stepWizard: {
      navLabel: "\u041A\u0440\u043E\u043A\u0438 \u043E\u0440\u0435\u043D\u0434\u0438",
      step1: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
      step2: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      step3: "\u041F\u0435\u0440\u0456\u043E\u0434",
      step4: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440",
      stepAria: "\u041A\u0440\u043E\u043A {n}",
      stepDoneAria: "\u0433\u043E\u0442\u043E\u0432\u043E"
    },
    finalizeChecklist: {
      title: "\u041F\u0435\u0440\u0435\u0434 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F\u043C",
      allReady: "\u0423\u0441\u0435 \u0433\u043E\u0442\u043E\u0432\u043E \u0434\u043E \u0432\u0438\u0434\u0430\u0447\u0456",
      incomplete: "\u0429\u0435 {count} \u043F\u0443\u043D\u043A\u0442(\u0456\u0432) \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456",
      itemPartner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043E\u0431\u0440\u0430\u043D\u043E",
      itemEquipment: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0432 \u043A\u043E\u0448\u0438\u043A\u0443",
      itemSchedule: "\u041F\u0435\u0440\u0456\u043E\u0434 \u043E\u0440\u0435\u043D\u0434\u0438 \u0432\u043A\u0430\u0437\u0430\u043D\u043E",
      itemPayment: "\u0421\u043F\u043E\u0441\u0456\u0431 \u043E\u043F\u043B\u0430\u0442\u0438 \u043E\u0431\u0440\u0430\u043D\u043E",
      doneAria: "\u0433\u043E\u0442\u043E\u0432\u043E",
      missingAria: "\u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0454",
      fix: "\u0412\u0438\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u2192"
    },
    wizard: {
      draftRef: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      ctx: {
        renter: "\u041E\u0420\u0415\u041D\u0414\u0410\u0420",
        machines: "\u0422\u0415\u0425\u041D\u0406\u041A\u0410",
        accCount: "{count} \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432",
        payCard: "\u041A\u0430\u0440\u0442\u043A\u0430",
        payCash: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430",
        payTransfer: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437"
      },
      depositPaidLabel: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u0441\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      depositPaidYes: "\u041A\u043B\u0456\u0454\u043D\u0442 \u0441\u043F\u043B\u0430\u0447\u0443\u0454 \u0437\u0430\u0440\u0430\u0437",
      depositPaidNo: "\u0421\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u043F\u0456\u0437\u043D\u0456\u0448\u0435 \u0430\u0431\u043E \u043D\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E",
      title: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443",
      subtitle: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u0443 \u043E\u0440\u0435\u043D\u0434\u0443",
      stepPartnerDesc: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
      stepCostBearerTitle: "\u041F\u043B\u0430\u0442\u043D\u0438\u043A",
      stepCostBearerDesc: "\u0425\u0442\u043E \u043F\u043B\u0430\u0442\u0438\u0442\u044C?",
      stepEquipmentTitle: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      stepEquipmentDesc: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      stepDetailsDesc: "\u041F\u0435\u0440\u0456\u043E\u0434 \u0456 \u0446\u0456\u043D\u0430",
      stepSummaryTitle: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
      stepSummaryDesc: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438",
      missingData: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u0434\u0430\u043D\u0456",
      missingDataDesc: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0443\u0441\u0456 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u043E\u043B\u044F",
      rentalCreated: "\u041E\u0440\u0435\u043D\u0434\u0443 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E!",
      contractNumber: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443: {number}",
      rentalCreateFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443",
      unknownError: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      cancelConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443?",
      myposTransaction: "MyPOS \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F...",
      creatingRental: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438...",
      finalizeRental: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443",
      selectPartner: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F (\u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430)",
      selectPartnerDesc: "\u0417\u043D\u0430\u0439\u0434\u0456\u0442\u044C \u0430\u0431\u043E \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430-\u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
      searchPartnerPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C'\u044F\u043C, email, \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u043C, \u0406\u041F\u041D, \u043C\u0456\u0441\u0442\u043E\u043C \u0430\u0431\u043E \u043F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F\u043C...",
      partnersLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432...",
      partnersLoadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432: {message}",
      noPartnerResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      createNewPartner: "+ \u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      selectedPartner: "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440: {name}",
      trustedStatus: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0438\u0439 \u043A\u043B\u0456\u0454\u043D\u0442",
      warningStatus: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      blockedStatus: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
      inactiveStatus: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      phoneLabel: "\u0422\u0435\u043B:",
      emailLabel: "Email:",
      taxNumberLabel: "\u0406\u041F\u041D:",
      idCardLabel: "\u041F\u043E\u0441\u0432.:",
      costBearerLabel: "\u041F\u043B\u0430\u0442\u043D\u0438\u043A:",
      balanceLabel: "\u0411\u0430\u043B\u0430\u043D\u0441:",
      loyaltyPointsUnit: "\u0431\u0430\u043B.",
      totalRentalsLabel: "\u0423\u0441\u044C\u043E\u0433\u043E \u043E\u0440\u0435\u043D\u0434:",
      lastRentalLabel: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0430:",
      costBearerTitle: "\u041F\u043B\u0430\u0442\u043D\u0438\u043A",
      costBearerDesc: "\u0425\u0442\u043E \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u043D\u0443 \u043F\u043B\u0430\u0442\u0443?",
      partnerPaysSelf: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441\u0430\u043C",
      partnerPaysDesc: "{name} \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u043D\u0443 \u043F\u043B\u0430\u0442\u0443",
      costBearerPays: "\u041F\u043B\u0430\u0442\u043D\u0438\u043A \u043F\u043B\u0430\u0442\u0438\u0442\u044C:",
      costBearerPaysDesc: "\u0406\u043D\u0448\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440 \u0430\u0431\u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u044F \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u043D\u0443 \u043F\u043B\u0430\u0442\u0443",
      selectCostBearer: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430:",
      knownCostBearers: "\u0412\u0456\u0434\u043E\u043C\u0456 \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0438",
      searchPartner: "\u041F\u043E\u0448\u0443\u043A \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430...",
      noCostBearerPartner: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432-\u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0456\u0432",
      defaultCostBearer: "\u041F\u043B\u0430\u0442\u043D\u0438\u043A \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C:",
      partnerPaysSelfSummary: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441\u0430\u043C: {name}",
      selectEquipmentTitle: "\u0412\u0438\u0431\u0456\u0440 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      selectEquipmentDesc: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
      searchEquipmentPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C, \u0441\u0435\u0440\u0456\u0439\u043D\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C, \u043C\u0430\u0440\u043A\u043E\u044E...",
      allFilter: "\u0423\u0441\u0456 ({count})",
      cart: "\u041A\u043E\u0448\u0438\u043A ({items} \u043F\u043E\u0437\u0438\u0446\u0456\u0439, {total} \u0448\u0442.)",
      dailyTotal: "\u0414\u0435\u043D\u043D\u0430 \u0441\u0443\u043C\u0430: {amount}",
      clearCart: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043A\u043E\u0448\u0438\u043A",
      perDay: "/\u0434\u0435\u043D\u044C",
      removeItem: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
      decrease: "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438",
      increase: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438",
      totalDeposit: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0430:",
      equipmentLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F...",
      equipmentLoadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F: {error}",
      noEquipmentResults: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0437\u0430 \u0437\u0430\u0434\u0430\u043D\u0438\u043C\u0438 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u044F\u043C\u0438",
      itemCode: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B:",
      brand: "\u041C\u0430\u0440\u043A\u0430:",
      condition: "\u0421\u0442\u0430\u043D:",
      categoryLabel: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F:",
      dailyPrice: "\u0414\u0435\u043D\u043D\u0430",
      weeklyPrice: "\u0422\u0438\u0436\u043D\u0435\u0432\u0430",
      monthlyPrice: "\u041C\u0456\u0441\u044F\u0447\u043D\u0430",
      inCart: "\u0423 \u043A\u043E\u0448\u0438\u043A\u0443: {count} \u0448\u0442.",
      addOne: "+1 \u0448\u0442.",
      accessoriesLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432...",
      accessoriesLabel: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438:",
      requiredAccessory: "(\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439)",
      accessoryValue: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432:",
      detailsTitle: "\u0414\u0435\u0442\u0430\u043B\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
      detailsDesc: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C \u043F\u0435\u0440\u0456\u043E\u0434 \u043E\u0440\u0435\u043D\u0434\u0438 \u0442\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0446\u0456\u043D\u0438",
      selectedItems: "\u0412\u0438\u0431\u0440\u0430\u043D\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      rentalPeriod: "\u041F\u0435\u0440\u0456\u043E\u0434 \u043E\u0440\u0435\u043D\u0434\u0438",
      datePicker: {
        chip: {
          tomorrow: "\u0417\u0430\u0432\u0442\u0440\u0430",
          twoDays: "2 \u0434\u043D\u0456",
          weekend: "\u0412\u0438\u0445\u0456\u0434\u043D\u0456",
          oneWeek: "1 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
          custom: "\u0412\u043B\u0430\u0441\u043D\u0438\u0439"
        }
      },
      scannerActive: "\u0421\u043A\u0430\u043D\u0435\u0440 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      scannerActiveHint: "USB / Bluetooth \u0441\u043A\u0430\u043D\u0435\u0440 \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u0456\u0432 \u0443 \u0440\u0435\u0436\u0438\u043C\u0456 \u043A\u043B\u0430\u0432\u0456\u0430\u0442\u0443\u0440\u0438",
      accessoryDrawer: {
        title: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438 \u2014 {name}",
        description: "\u0412\u0438\u0431\u0456\u0440 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0430 \u0434\u043B\u044F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F. \u0421\u043F\u0438\u0441\u043E\u043A \u0437 \u043F\u043E\u0448\u0443\u043A\u043E\u043C \u0456 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438.",
        searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C...",
        requiredOnly: "\u041B\u0438\u0448\u0435 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456",
        close: "\u041D\u0430\u0437\u0430\u0434",
        addAccessory: "\u0414\u043E\u0434\u0430\u0442\u0438",
        noAccessories: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
        isRequired: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440",
        valueLabel: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C: {value}",
        loadingAccessories: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432...",
        moreAccessoriesBtn: "\u0411\u0456\u043B\u044C\u0448\u0435 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432",
        prevPage: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430",
        nextPage: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430"
      },
      collapseAll: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0456",
      collapseAllHint: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u0432\u0441\u0456 \u043F\u0430\u043D\u0435\u043B\u0456 \u2014 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0433\u043B\u044F\u0434",
      expandInvalid: "\u041B\u0438\u0448\u0435 \u043D\u0435\u0432\u0430\u043B\u0456\u0434\u043D\u0456",
      expandInvalidHint: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u043F\u0430\u043D\u0435\u043B\u0456, \u0449\u043E \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u044E\u0442\u044C \u0443\u0432\u0430\u0433\u0438",
      scanSuccess: "{name} \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430",
      scanError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
      scanUnavailable: "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
      scanMatchedField: {
        qrCode: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430 QR-\u043A\u043E\u0434\u043E\u043C",
        factoryBarcode: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430 \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u043E\u043C",
        equipmentCode: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430 \u043A\u043E\u0434\u043E\u043C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        serialNumber: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430 \u0441\u0435\u0440\u0456\u0439\u043D\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C"
      },
      returnDateLabel: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      startTimeLabel: "\u0427\u0430\u0441 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
      returnTimeLabel: "\u0427\u0430\u0441 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      hourlyBilling: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0430",
      hourlyBillingDesc: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0430 \u0434\u043B\u044F \u0434\u0435\u043D\u043D\u043E\u0457 \u043E\u0440\u0435\u043D\u0434\u0438",
      durationHours: "{hours} \u0433\u043E\u0434\u0438\u043D",
      durationDays: "{days} \u0434\u043D\u0456\u0432",
      priceCalc: "\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0446\u0456\u044F \u0446\u0456\u043D\u0438",
      duration: "\u0422\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C",
      pricingType: "\u0422\u0438\u043F \u0442\u0430\u0440\u0438\u0444\u0443",
      netRentalFee: "\u041D\u0435\u0442\u0442\u043E \u043E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
      discount: "\u0417\u043D\u0438\u0436\u043A\u0430",
      discountPercent: "\u0417\u043D\u0438\u0436\u043A\u0430 ({percent}%)",
      vat27: "\u041F\u0414\u0412 (27%)",
      rentalFeeTotal: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430 \u0432\u0441\u044C\u043E\u0433\u043E",
      payNow: "\u0414\u043E \u0441\u043F\u043B\u0430\u0442\u0438 \u0437\u0430\u0440\u0430\u0437",
      payNowBreakdown: "(\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430: {fee} + \u0417\u0430\u0441\u0442\u0430\u0432\u0430: {deposit})",
      selectDatesForCalc: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0438 \u0434\u043B\u044F \u043A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0446\u0456\u0457 \u0446\u0456\u043D\u0438",
      breakdownTitle: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456",
      breakdownDate: "\u0414\u0430\u0442\u0430",
      breakdownDay: "\u0414\u0435\u043D\u044C",
      breakdownType: "\u0422\u0438\u043F",
      breakdownValue: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      breakdownWorkday: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u0434\u0435\u043D\u044C",
      breakdownSunday: "\u041D\u0435\u0434\u0456\u043B\u044F",
      breakdownHoliday: "\u0421\u0432\u044F\u0442\u043E",
      breakdownFullDay: "1 \u0434\u0435\u043D\u044C",
      breakdownHalfDay: "\xBD \u0434\u043D\u044F",
      breakdownCalendarDays: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u0456 \u0434\u043D\u0456",
      breakdownBillableDays: "\u041E\u043F\u043B\u0430\u0447\u0443\u0432\u0430\u043D\u0456 \u0434\u043D\u0456",
      breakdownWeeklyDiscount: "\u0422\u0438\u0436\u043D\u0435\u0432\u0430 \u0437\u043D\u0438\u0436\u043A\u0430 (-{days} \u0434\u0435\u043D\u044C)",
      breakdownPayableDays: "\u0414\u043D\u0456 \u0434\u043E \u043E\u043F\u043B\u0430\u0442\u0438",
      breakdownDailyRate: "\u0414\u0435\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430",
      breakdownMonthlyNote: "{days} \u0434\u043D\u0456\u0432 \u2192 {billable} \u043E\u043F\u043B\u0430\u0447\u0443\u0432\u0430\u043D\u0438\u0445 \u0434\u043D\u0456\u0432 (\u043C\u0456\u0441\u044F\u0447\u043D\u0430 \u0437\u043D\u0438\u0436\u043A\u0430)",
      perHour: "/\u0433\u043E\u0434\u0438\u043D\u0443",
      rentalNotesAriaLabel: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u043E\u0440\u0435\u043D\u0434\u0438",
      summaryTitle: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
      summaryDesc: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0434\u0430\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438 \u0442\u0430 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C",
      partnerData: "\u0414\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      equipmentCount: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F ({count} \u0448\u0442.)",
      returnLabel: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      durationLabel: "\u0422\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C",
      paymentSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u0438",
      grossRentalFee: "\u0411\u0440\u0443\u0442\u0442\u043E \u043E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
      totalToPay: "\u0412\u0421\u042C\u041E\u0413\u041E \u0414\u041E \u0421\u041F\u041B\u0410\u0422\u0418",
      selectPaymentMethod: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u043F\u043E\u0441\u0456\u0431 \u043E\u043F\u043B\u0430\u0442\u0438:",
      bankCard: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0430 \u043A\u0430\u0440\u0442\u043A\u0430 (MyPOS)",
      companyOnly: "(\u0442\u0456\u043B\u044C\u043A\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439)",
      selectPaymentRequired: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u043F\u043E\u0441\u0456\u0431 \u043E\u043F\u043B\u0430\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F",
      disclaimer: "\u0417\u0430\u0432\u0435\u0440\u0448\u0443\u044E\u0447\u0438 \u043E\u0440\u0435\u043D\u0434\u0443, \u043F\u0430\u0440\u0442\u043D\u0435\u0440 \u043F\u0440\u0438\u0439\u043C\u0430\u0454 \u0443\u043C\u043E\u0432\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443 \u043E\u0440\u0435\u043D\u0434\u0438. \u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u043F\u043E\u0432\u0435\u0440\u0442\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u0456\u0441\u043B\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0432 \u043D\u0435\u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043E\u043C\u0443 \u0441\u0442\u0430\u043D\u0456.",
      tierHourly: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430",
      tierDaily: "\u0414\u0435\u043D\u043D\u0438\u0439 \u0442\u0430\u0440\u0438\u0444",
      tierWeekly: "\u0422\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u0442\u0430\u0440\u0438\u0444",
      tierMonthly: "\u041C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u0442\u0430\u0440\u0438\u0444",
      contractCreated: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443: {contractNumber}. {transactionInfo}",
      suggestedAccessories: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0456 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438",
      noSuggestedPackages: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0445 \u043F\u0430\u043A\u0435\u0442\u0456\u0432",
      selectAccessoryPackage: "\u041E\u0431\u0440\u0430\u0442\u0438",
      removeAccessoryPackage: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
      included: "\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      consignment: "\u041A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u044F",
      accessoryPackageSelected: "\u041F\u0430\u043A\u0435\u0442 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432 \u043E\u0431\u0440\u0430\u043D\u043E",
      packages: {
        stepTitle: "\u041F\u0430\u043A\u0435\u0442\u0438",
        stepDesc: "\u041F\u0440\u0438\u043A\u0440\u0456\u043F\u0438\u0442\u0438 \u043F\u0430\u043A\u0435\u0442\u0438 \u0434\u043E \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        intro: "\u0414\u043E \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0438\u043A\u0440\u0456\u043F\u0438\u0442\u0438 \u043A\u0456\u043B\u044C\u043A\u0430 \u043F\u0430\u043A\u0435\u0442\u0456\u0432 (\u043D\u0430\u043F\u0440., \u0431\u0435\u0437\u043F\u0435\u043A\u0430 + \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F).",
        emptyCart: "\u0421\u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0443 \u043A\u043E\u0448\u0438\u043A.",
        qtyLabel: "{qty} \u0448\u0442.",
        addPackage: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0430\u043A\u0435\u0442",
        noneAvailable: "\u0414\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043F\u0430\u043A\u0435\u0442\u0456\u0432.",
        duplicateTitle: "\u041F\u0430\u043A\u0435\u0442 \u0432\u0436\u0435 \u0434\u043E\u0434\u0430\u043D\u043E",
        duplicateDesc: "{name} \u0432\u0436\u0435 \u043F\u0440\u0438\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u043E \u2014 \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u043E \u043A\u0456\u043B\u044C\u043A\u0430 \u043D\u0430\u0431\u043E\u0440\u0456\u0432.",
        removeAria: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0430\u043A\u0435\u0442 {name}"
      },
      v2: {
        addPackageButton: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0430\u043A\u0435\u0442",
        cartCount: "{count} \u0448\u0442.",
        cartCountFiltered: "{shown} / {total} \u0448\u0442.",
        cartFilteredEmpty: "\u0416\u043E\u0434\u0435\u043D \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u043A\u043E\u0448\u0438\u043A\u0430 \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u043C\u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0443. \u0417\u043D\u0456\u043C\u0456\u0442\u044C \u0444\u0456\u043B\u044C\u0442\u0440, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438.",
        cartTitle: "\u041A\u043E\u0448\u0438\u043A \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        categoryHeader: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        clearFilters: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
        closePickerAriaLabel: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
        combinedStepTitle: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F + \u043F\u0430\u043A\u0435\u0442",
        conditionHeader: "\u0421\u0442\u0430\u043D",
        headerSubtitle: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043A\u0456\u043B\u044C\u043A\u043E\u0445 \u043C\u0430\u0448\u0438\u043D, 3-\u043A\u043E\u043B\u043E\u043D\u043A\u043E\u0432\u0438\u0439 \u043C\u0430\u043A\u0435\u0442",
        search: {
          label: "\u041F\u043E\u0448\u0443\u043A \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
          placeholder: "\u0428\u0443\u043A\u0430\u0442\u0438 \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0441\u0435\u0440\u0456\u0439\u043D\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u0430\u0431\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0454\u044E\u2026",
          hint: "\u041F\u043E\u0447\u043D\u0456\u0442\u044C \u0432\u0432\u043E\u0434\u0438\u0442\u0438, \u0449\u043E\u0431 \u0434\u043E\u0434\u0430\u0442\u0438 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430.",
          loading: "\u041F\u043E\u0448\u0443\u043A\u2026",
          noResults: '\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0434\u043B\u044F "{query}"',
          addAction: "\u0414\u043E \u043A\u043E\u0448\u0438\u043A\u0430",
          addedToCart: "\u0414\u043E\u0434\u0430\u043D\u043E: {name}",
          alreadyInCart: "{name} \u0432\u0436\u0435 \u0432 \u043A\u043E\u0448\u0438\u043A\u0443",
          alreadyAdded: "\u2713 \u0414\u043E\u0434\u0430\u043D\u043E",
          clearAriaLabel: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u0448\u0443\u043A",
          noFilterMatch: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0431\u0456\u0433\u0456\u0432 \u0434\u043B\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432."
        },
        deferredFilters: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C:",
        duplicateDesc: '\u041F\u0430\u043A\u0435\u0442 "{name}" \u0443\u0436\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0446\u044C\u043E\u043C\u0443 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044E. \u0414\u043E\u0434\u0430\u043D\u043E \u0437\u043D\u043E\u0432\u0443.',
        duplicateTitle: "\u0423\u0436\u0435 \u0434\u043E\u0434\u0430\u043D\u043E",
        emptyCart: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430.",
        equipmentCount: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        filtersTitle: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
        headerTitle: "\u041C\u0430\u0439\u0441\u0442\u0435\u0440 \u043E\u0440\u0435\u043D\u0434\u0438 \u2014 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0442\u0430 \u043F\u0430\u043A\u0435\u0442\u0438",
        packageCount: "\u041F\u0430\u043A\u0435\u0442",
        packageRemoveAriaLabel: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0430\u043A\u0435\u0442 {name}",
        packagesEmpty: "\u041F\u0430\u043A\u0435\u0442\u0438 \u043D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0456",
        packagesLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u043A\u0435\u0442\u0456\u0432\u2026",
        packagesNoneAvailable: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043F\u0430\u043A\u0435\u0442\u0456\u0432",
        pricingDeposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
        pricingDiscount: "\u0417\u043D\u0438\u0436\u043A\u0430",
        pricingEmpty: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0442\u0430 \u043F\u0435\u0440\u0456\u043E\u0434, \u0449\u043E\u0431 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0446\u0456\u043D\u0438.",
        pricingError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0446\u0456\u043D\u0438.",
        pricingGrandTotal: "\u0412\u0441\u044C\u043E\u0433\u043E",
        pricingHeader: "\u0426\u0456\u043D\u043E\u0443\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        pricingLoading: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0446\u0456\u043D\u2026",
        pricingSubtotal: "\u0411\u0435\u0437 \u041F\u0414\u0412",
        pricingVat: "\u041F\u0414\u0412",
        removeAriaLabel: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 {name}",
        removeButton: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        summaryDeferred: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C: \u0440\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u043F\u043E \u0434\u043D\u044F\u0445/\u0442\u0438\u0436\u043D\u044F\u0445, \u043A\u0443\u043F\u043E\u043D \u0437\u043D\u0438\u0436\u043A\u0438, \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u043F\u043E\u0441\u043E\u0431\u0443 \u043E\u043F\u043B\u0430\u0442\u0438.",
        summaryTitle: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
        legend: {
          title: "\u0423\u043C\u043E\u0432\u043D\u0456 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
          free: "\u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
          rentable: "\u041E\u0440\u0435\u043D\u0434\u0443\u0454\u0442\u044C\u0441\u044F",
          consignment: "\u041A\u043E\u043C\u0456\u0441\u0456\u044F"
        },
        itemQty: "{qty} \u0448\u0442",
        itemQtyInc: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438",
        itemQtyDec: "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438",
        breakdownHeader: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u043F\u043E \u0434\u043D\u044F\u0445",
        breakdownWorkdays: "\u0420\u043E\u0431\u043E\u0447\u0456 \u0434\u043D\u0456",
        breakdownSundays: "\u041D\u0435\u0434\u0456\u043B\u0456",
        breakdownHolidays: "\u0421\u0432\u044F\u0442\u0430",
        breakdownBillable: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u0456 \u0434\u043D\u0456",
        breakdownWeeklyDiscount: "\u0422\u0438\u0436\u043D\u0435\u0432\u0430 \u0437\u043D\u0438\u0436\u043A\u0430 (\u0434\u043D\u0456)",
        periodLabel: "\u041F\u0435\u0440\u0456\u043E\u0434 \u043E\u0440\u0435\u043D\u0434\u0438",
        editPeriod: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438",
        perMachineHeader: "\u041F\u043E \u0442\u0435\u0445\u043D\u0456\u0446\u0456",
        unnamedItem: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440",
        detail: {
          railTitle: "\u041E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0430 \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
          railCount: "{n} \u043E\u0434\u0438\u043D\u0438\u0446\u044F",
          railEmpty: "\u041A\u043E\u0448\u0438\u043A \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u0439.",
          addMachineButton: "+ \u0414\u043E\u0434\u0430\u0442\u0438 \u043C\u0430\u0448\u0438\u043D\u0443",
          activeEmpty: "\u0414\u043E\u0434\u0430\u0439 \u043C\u0430\u0448\u0438\u043D\u0443 \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443 \u0434\u0435\u0442\u0430\u043B\u0435\u0439.",
          detailHeader: "\u0414\u0435\u0442\u0430\u043B\u0456 \u043C\u0430\u0448\u0438\u043D\u0438",
          detailSku: "\u041A\u043E\u0434",
          detailDailyRate: "\u0414\u043E\u0431\u043E\u0432\u0430 \u0441\u0442\u0430\u0432\u043A\u0430",
          detailPackageSection: "\u041F\u0430\u043A\u0435\u0442",
          accessoryPlaceholder: "\u2014 \u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438 (slice-2) \u2014",
          legendTitle: "\u041B\u0435\u0433\u0435\u043D\u0434\u0430",
          legendFreeHint: "\u0432\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u0432 \u043F\u0430\u043A\u0435\u0442",
          legendRentableHint: "\u0434\u0435\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430, \u043B\u0438\u0448\u0435 \u0437\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u0456 \u0434\u043D\u0456",
          legendConsignHint: "\u043F\u043B\u0430\u0442\u0438\u0442\u0435 \u043B\u0438\u0448\u0435 \u0437\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u0435",
          lineTotal: "\u0421\u0443\u043C\u0430 \u0440\u044F\u0434\u043A\u0430",
          freeInPkg: "\u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E \u0432 \u043F\u0430\u043A\u0435\u0442\u0456",
          rentableUnit: "\u0433\u0440\u043D/\u0434\u0435\u043D\u044C",
          consignUnit: "\u0433\u0440\u043D/\u0448\u0442 (\u043A\u043E\u043C\u0456\u0441\u0456\u044F)",
          calcPeriodTitle: "\u041F\u0435\u0440\u0456\u043E\u0434",
          calcDays: "{n} \u0434\u043D.",
          calcPerMachineTitle: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u043F\u043E \u043C\u0430\u0448\u0438\u043D\u0430\u0445",
          calcMachineRent: "{rate} \u0433\u0440\u043D/\u0434\u0435\u043D\u044C \xD7 {days} \u0434\u043D.",
          calcEstTotal: "\u041E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u043D\u0430 \u0441\u0443\u043C\u0430",
          calcNote: "{m} \u043C\u0430\u0448\u0438\u043D\u0438 \xB7 {d} \u0434\u043D.",
          calcNoPricing: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0456\u0442\u044C \u043F\u0435\u0440\u0456\u043E\u0434 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443 \u0446\u0456\u043D\u0438.",
          accCatalogTitle: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438",
          accCatalogLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432\u2026",
          accCatalogEmpty: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432 \u0434\u043B\u044F \u0446\u0456\u0454\u0457 \u043C\u0430\u0448\u0438\u043D\u0438 \u043D\u0435\u043C\u0430\u0454.",
          accCatalogError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432.",
          accTabAll: "\u0412\u0441\u0456",
          accStockN: "{n} \u0448\u0442. \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456",
          accFree: "\u0431\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
          addMachineDialogTitle: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043C\u0430\u0448\u0438\u043D\u0443",
          addMachineSearchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0430\u0431\u043E \u043A\u043E\u0434\u043E\u043C\u2026",
          addMachineHint: "\u041F\u043E\u0447\u043D\u0456\u0442\u044C \u0432\u0432\u043E\u0434\u0438\u0442\u0438 \u0434\u043B\u044F \u043F\u043E\u0448\u0443\u043A\u0443 \u043C\u0430\u0448\u0438\u043D\u0438.",
          addMachineAddAction: "\u0423 \u043A\u043E\u0448\u0438\u043A"
        }
      },
      summary: {
        rental: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
        deposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
        total: "\u0414\u043E \u0441\u043F\u043B\u0430\u0442\u0438",
        consignment: "\u041A\u043E\u043C\u0456\u0441\u0456\u0439\u043D\u0438\u0439"
      },
      reservationTimer: {
        label: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F:",
        expired: "\u0427\u0430\u0441 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u0432\u0438\u0439\u0448\u043E\u0432 \u2014 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0432\u0441\u0435 \u0449\u0435 \u043C\u043E\u0436\u043B\u0438\u0432\u0435.",
        hint: "\u0412\u0456\u0437\u0443\u0430\u043B\u044C\u043D\u0435 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F (\u043D\u0435 \u0440\u0435\u0437\u0435\u0440\u0432 \u0441\u043A\u043B\u0430\u0434\u0443)"
      },
      selectedBadge: "\u0412\u0438\u0431\u0440\u0430\u043D\u043E",
      calendar: {
        prevMonth: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        nextMonth: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C"
      }
    },
    checkout: {
      grant: {
        toggle: {
          label: "\u041E\u0440\u0435\u043D\u0434\u0430\u0440 \u0443\u043F\u043E\u0432\u043D\u043E\u0432\u0430\u0436\u0443\u0454 \u043A\u043E\u0433\u043E\u0441\u044C \u0437\u0430\u0431\u0440\u0430\u0442\u0438",
          adrHint: "(grantor = \u043E\u0440\u0435\u043D\u0434\u0430\u0440 \u2014 ADR-124)",
          desc: "PERMANENT-\u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C \u0434\u0456\u0439\u0441\u043D\u0430 \u0434\u043E \u0432\u0456\u0434\u043A\u043B\u0438\u043A\u0430\u043D\u043D\u044F. ONE_TIME \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u043F\u0435\u0440\u043E\u0432\u043E\u0457 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456."
        },
        section: {
          title: "\u0423\u043F\u043E\u0432\u043D\u043E\u0432\u0430\u0436\u0435\u043D\u0430 \u043E\u0441\u043E\u0431\u0430"
        },
        loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0435\u0439...",
        materializeFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456 \u2014 \u043E\u0440\u0435\u043D\u0434\u0443 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E, \u0430\u043B\u0435 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0432\u0440\u0443\u0447\u043D\u0443 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u043E\u0440\u0435\u043D\u0434\u0438.",
        permanentDropdown: {
          intro: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456 \u2014 \u043E\u0431\u0435\u0440\u0438 \u0432\u0456\u0434 \u0456\u043C\u0435\u043D\u0456 {name}:",
          validFrom: "\u0434\u0456\u0454 \u0437 {date}"
        },
        empty: {
          title: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0457 \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u043E\u0457 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456",
          desc: "\u0423 {name} \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u043C\u0430\u0454 PERMANENT-\u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456.",
          tip: '\u041F\u0456\u0434\u043A\u0430\u0437\u043A\u0430: \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u0456 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456 \u043C\u043E\u0436\u043D\u0430 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0443 \u0432\u043A\u043B\u0430\u0434\u0446\u0456 \u201E\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456".'
        },
        oneTime: {
          cta: "\u041D\u043E\u0432\u0430 \u0440\u0430\u0437\u043E\u0432\u0430 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C",
          pendingHint: "\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C \u0431\u0443\u0434\u0435 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u043F\u0456\u0441\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438."
        },
        oneTimeDialog: {
          title: "\u041D\u043E\u0432\u0430 \u0440\u0430\u0437\u043E\u0432\u0430 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C",
          grantor: "\u041E\u0440\u0435\u043D\u0434\u0430\u0440 (grantor): {name}",
          nameLabel: "\u0406\u043C'\u044F \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430",
          namePlaceholder: "\u043D\u0430\u043F\u0440. \u0406\u0432\u0430\u043D \u0406\u0432\u0430\u043D\u0435\u043D\u043A\u043E",
          idCardLabel: "\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F",
          idCardPlaceholder: "\u043D\u0430\u043F\u0440. AB123456",
          phoneLabel: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
          phonePlaceholder: "+380 ...",
          gracePeriodWarning: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u043F\u0435\u0440\u043E\u0432\u043E\u0457 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u043E\u0441\u0442\u0456 \u2014 Sprint 18+ scope. \u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C \u0441\u0442\u0432\u043E\u0440\u044E\u0454\u0442\u044C\u0441\u044F \u0437 24-\u0433\u043E\u0434\u0438\u043D\u043D\u0438\u043C \u043F\u0456\u043B\u044C\u0433\u043E\u0432\u0438\u043C \u043F\u0435\u0440\u0456\u043E\u0434\u043E\u043C.",
          submit: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C",
          submitting: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
          errors: {
            nameRequired: "\u0406\u043C'\u044F \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
            noRental: "\u041D\u0435\u043C\u0430\u0454 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0443 \u043E\u0440\u0435\u043D\u0434\u0438 \u2014 \u0441\u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0434\u043E\u0434\u0430\u0439 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440.",
            documentRequired: "\u041F\u0430\u043F\u0435\u0440\u043E\u0432\u0430 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
            validationFailed: "\u041D\u0435\u0432\u0456\u0440\u043D\u0456 \u0434\u0430\u043D\u0456 \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430",
            network: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043C\u0435\u0440\u0435\u0436\u0456, \u0441\u043F\u0440\u043E\u0431\u0443\u0439 \u0449\u0435 \u0440\u0430\u0437"
          }
        }
      },
      subheader: {
        connectionLabel: "\u0417\u0432'\u044F\u0437\u043E\u043A",
        renter: {
          label: "\u043E\u0440\u0435\u043D\u0434\u0443\u0454"
        },
        payer: {
          label: "\u043F\u043B\u0430\u0442\u0438\u0442\u044C"
        },
        grantee: {
          label: "\u0437\u0430\u0431\u0438\u0440\u0430\u0454"
        }
      }
    },
    category: {
      handTools: "\u0420\u0443\u0447\u043D\u0456 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438",
      electricMachines: "\u0415\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u043D\u0456 \u043C\u0430\u0448\u0438\u043D\u0438",
      outdoorMachines: "\u0417\u043E\u0432\u043D\u0456\u0448\u043D\u0456 \u043C\u0430\u0448\u0438\u043D\u0438",
      other: "\u0406\u043D\u0448\u0435",
      construction: "\u0411\u0443\u0434\u0456\u0432\u0435\u043B\u044C\u043D\u0438\u0439",
      cleaning: "\u041F\u0440\u0438\u0431\u0438\u0440\u0430\u043B\u044C\u043D\u0438\u0439",
      machinery: "\u041C\u0430\u0448\u0438\u043D\u0438",
      handTool: "\u0420\u0443\u0447\u043D\u0438\u0439 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      measurement: "\u0412\u0438\u043C\u0456\u0440\u044E\u0432\u0430\u043B\u044C\u043D\u0438\u0439",
      safety: "\u041E\u0445\u043E\u0440\u043E\u043D\u0430 \u043F\u0440\u0430\u0446\u0456"
    },
    equipmentStatus: {
      available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
      rented: "\u041E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0439",
      inService: "\u041D\u0430 \u0441\u0435\u0440\u0432\u0456\u0441\u0456",
      reserved: "\u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u0438\u0439"
    },
    condition: {
      excellent: "\u0412\u0456\u0434\u043C\u0456\u043D\u043D\u0438\u0439",
      good: "\u0425\u043E\u0440\u043E\u0448\u0438\u0439",
      fair: "\u0417\u0430\u0434\u043E\u0432\u0456\u043B\u044C\u043D\u0438\u0439",
      poor: "\u041F\u043E\u0433\u0430\u043D\u0438\u0439",
      damaged: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u0438\u0439",
      damagedUsable: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u0438\u0439 \u2014 \u043F\u0440\u0438\u0434\u0430\u0442\u043D\u0438\u0439",
      damagedService: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u0438\u0439 \u2192 \u0421\u0435\u0440\u0432\u0456\u0441",
      incomplete: "\u041D\u0435\u043F\u043E\u0432\u043D\u0438\u0439",
      new: "\u041D\u043E\u0432\u0438\u0439",
      used: "\u0412\u0436\u0438\u0432\u0430\u043D\u0438\u0439"
    },
    sendToService: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u0432 \u0441\u0435\u0440\u0432\u0456\u0441",
    serviceWorksheetCreated: "\u041D\u0430\u0440\u044F\u0434 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E: {code}",
    serviceWorksheetError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u0430\u0440\u044F\u0434",
    damagedServiceInfo: "\u0426\u0435\u0439 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0432\u0438\u0434\u0430\u043D\u0438\u0439 \u2014 \u0439\u043E\u0433\u043E \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u043D\u0435\u0433\u0430\u0439\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u0434\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u0443.",
    damagedServiceDefaultFault: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0456\u0441\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u0438 \u2014 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
    crossSell: {
      addProduct: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0442\u043E\u0432\u0430\u0440",
      additionalItems: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0442\u043E\u0432\u0430\u0440\u0438",
      rentalFee: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
      productTotal: "\u0421\u0443\u043C\u0430 \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
      productVat: "\u041F\u0414\u0412 \u0442\u043E\u0432\u0430\u0440\u0456\u0432 (27%)",
      searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0430\u0431\u043E \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C...",
      noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
      stock: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A",
      depositNote: "\u043B\u0438\u0448\u0435 \u043E\u0440\u0435\u043D\u0434\u0430",
      net: "\u043D\u0435\u0442\u0442\u043E",
      gross: "\u0431\u0440\u0443\u0442\u0442\u043E",
      subtotal: "\u0422\u043E\u0432\u0430\u0440\u0438 \u0440\u0430\u0437\u043E\u043C",
      remove: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
      quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      emptyCart: "\u0422\u043E\u0432\u0430\u0440\u0438 \u0449\u0435 \u043D\u0435 \u0434\u043E\u0434\u0430\u043D\u043E",
      unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
      lineTotal: "\u0420\u0430\u0437\u043E\u043C",
      searching: "\u041F\u043E\u0448\u0443\u043A...",
      add: "\u0414\u043E\u0434\u0430\u0442\u0438",
      pcs: "\u0448\u0442."
    },
    confirmPickup: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F + \u0437\u0430\u0441\u0442\u0430\u0432\u0430",
    packageSelect: {
      modeLabel: "\u0420\u0435\u0436\u0438\u043C \u043E\u0440\u0435\u043D\u0434\u0438",
      individual: "\u041E\u043A\u0440\u0435\u043C\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      package: "\u041F\u0430\u043A\u0435\u0442",
      individualDesc: "\u0412\u0438\u0431\u0456\u0440 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443",
      packageDesc: "\u0412\u0438\u0431\u0456\u0440 \u0433\u043E\u0442\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u043A\u0435\u0442\u0443",
      searchPackage: "\u041F\u043E\u0448\u0443\u043A \u043F\u0430\u043A\u0435\u0442\u0456\u0432...",
      loadingPackages: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u043A\u0435\u0442\u0456\u0432...",
      noPackages: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043F\u0430\u043A\u0435\u0442\u0456\u0432 \u043E\u0440\u0435\u043D\u0434\u0438",
      packageContents: "\u0412\u043C\u0456\u0441\u0442 \u043F\u0430\u043A\u0435\u0442\u0443",
      included: "\u0412\u041A\u041B\u042E\u0427\u0415\u041D\u041E",
      rental: "\u041E\u0420\u0415\u041D\u0414\u0410",
      consignment: "\u041A\u041E\u041D\u0421\u0418\u0413\u041D\u0410\u0426\u0406\u042F",
      optional: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E",
      quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
      consignmentValue: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0457",
      onDeliveryNote: "\u043D\u0430 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0456\u0439",
      rentalPrice: "\u0426\u0456\u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0438",
      totalWithConsignment: "\u0412\u0441\u044C\u043E\u0433\u043E (\u043E\u0440\u0435\u043D\u0434\u0430 + \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u044F)",
      savings: "\u0415\u043A\u043E\u043D\u043E\u043C\u0456\u044F \u043F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043E \u0437 \u043E\u043A\u0440\u0435\u043C\u043E\u044E \u043E\u0440\u0435\u043D\u0434\u043E\u044E",
      savingsPercent: "{percent}% \u0435\u043A\u043E\u043D\u043E\u043C\u0456\u044F",
      selectPackage: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043F\u0430\u043A\u0435\u0442",
      selectedPackage: "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u043F\u0430\u043A\u0435\u0442: {name}",
      changePackage: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u043A\u0435\u0442",
      packageItems: "{count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439"
    },
    consignment: {
      title: "\u041A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u044F",
      deliveryNote: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0430",
      quantityOut: "\u0412\u0438\u0434\u0430\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      quantityReturned: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E",
      quantityCharged: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043E",
      settlement: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0457",
      settleAll: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0435",
      activeConsignments: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0457",
      totalValue: "\u041D\u0435\u043F\u043E\u0433\u0430\u0448\u0435\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
      noConsignments: "\u041D\u0435\u043C\u0430\u0454 \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0439\u043D\u0438\u0445 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      returnedItems: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      chargedItems: "\u041D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      settlementSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      rentalFeeTotal: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430 \u0432\u0441\u044C\u043E\u0433\u043E",
      consignmentCharges: "\u041A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0439\u043D\u0456 \u043D\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
      grandTotal: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0441\u0443\u043C\u0430",
      depositRefund: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
      warningOverReturn: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0434\u0430\u043D\u0443!",
      itemName: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
      dispatched: "\u0412\u0438\u0434\u0430\u043D\u043E",
      returned: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E",
      charged: "\u041D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
      amount: "\u0421\u0443\u043C\u0430",
      freeAccessories: "\u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u0456 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438",
      freeAccessoriesDesc: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438 \u0434\u043B\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F (\u0447\u0430\u0441\u0442\u0438\u043D\u0430 \u043F\u0430\u043A\u0435\u0442\u0443)",
      accessoryReturned: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E",
      accessoryMissing: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439",
      consignmentTotal: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0457",
      consignmentNote: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0457 \u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u044F\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0440\u0430\u0437 \u2014 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0432\u0456\u0434\u0431\u0443\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u0440\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u0456.",
      createFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0457",
      status: {
        active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        settled: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
        partiallySettled: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u0440\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E"
      }
    },
    stepNav: {
      navLabel: "\u041D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F \u043F\u043E \u043A\u0440\u043E\u043A\u0430\u0445",
      prev: "\u041D\u0430\u0437\u0430\u0434",
      next: "\u0414\u0430\u043B\u0456",
      incompleteHint: "\u0426\u0435\u0439 \u043A\u0440\u043E\u043A \u043D\u0435\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0439 \u2013 \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
      stepCounter: "\u041A\u0440\u043E\u043A {current}/{total}"
    },
    contractCard: {
      title: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u043E\u0440\u0435\u043D\u0434\u0438",
      lessor: "\u041E\u0440\u0435\u043D\u0434\u043E\u0434\u0430\u0432\u0435\u0446\u044C",
      renter: "\u041E\u0440\u0435\u043D\u0434\u0430\u0440",
      pdfPreview: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 PDF / \u0434\u0440\u0443\u043A",
      pdfAfterFinalize: "PDF \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443 \u0441\u0442\u0430\u043D\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u043C \u043F\u0456\u0441\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F"
    },
    returnTable: {
      contract: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 / \u041F\u043E\u0447\u0430\u0442\u043E\u043A",
      renter: "\u041E\u0440\u0435\u043D\u0434\u0430\u0440",
      equipment: "\u041E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      expectedReturn: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      value: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
      status: "\u0421\u0442\u0430\u0442\u0443\u0441"
    },
    dueChips: {
      label: "\u0422\u0435\u0440\u043C\u0456\u043D:",
      all: "\u0423\u0441\u0456",
      overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
      dueToday: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
      dueSoon: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C"
    },
    csvHeader: {
      contractNumber: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
      equipment: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      endDate: "\u0422\u0435\u0440\u043C\u0456\u043D",
      status: "\u0421\u0442\u0430\u0442\u0443\u0441"
    },
    exportCsv: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV",
    foundLabel: "\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
    return: {
      signCta: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
      error: {
        generic: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u043E\u0431\u0440\u043E\u0431\u043A\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F"
      },
      consignment: {
        settleFailedFallback: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043A\u043E\u043C\u0456\u0441\u0456\u0457",
        settleFailedDetail: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E, \u0430\u043B\u0435 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043A\u043E\u043C\u0456\u0441\u0456\u0457 \u2014 \u041D\u0406. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u0430\u0431\u043E \u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430."
      },
      protocolTitle: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F + \u043F\u0456\u0434\u043F\u0438\u0441",
      generateDoc: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B",
      signedOk: "\u041A\u043B\u0456\u0454\u043D\u0442 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u0432 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B"
    },
    partnerIdLabel: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    resolvedPackage: {
      none: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0430\u043A\u0435\u0442\u0430",
      noneDesc: "\u0426\u0456\u0439 \u043C\u0430\u0448\u0438\u043D\u0456 \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0433\u043E \u043E\u0440\u0435\u043D\u0434\u043D\u043E\u0433\u043E \u043F\u0430\u043A\u0435\u0442\u0430."
    },
    payment: {
      title: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043E\u043F\u043B\u0430\u0442\u0443",
      amount: "\u0421\u0443\u043C\u0430 (HUF)",
      cash: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430",
      card: "\u041A\u0430\u0440\u0442\u043A\u0430",
      transfer: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437",
      reference: "\u0420\u0435\u0444\u0435\u0440\u0435\u043D\u0441 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      notes: "\u041D\u043E\u0442\u0430\u0442\u043A\u0438 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      submit: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043E\u043F\u043B\u0430\u0442\u0443",
      success: "\u041E\u043F\u043B\u0430\u0442\u0443 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u043E",
      overpaymentError: "\u0421\u0443\u043C\u0430 \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0437\u0430\u043B\u0438\u0448\u043E\u043A \u0431\u043E\u0440\u0433\u0443",
      recordFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043E\u043F\u043B\u0430\u0442\u0443",
      transferNotEligibleTitle: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437 \u043D\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u043E",
      transferNotEligibleHint: "\u041E\u043F\u043B\u0430\u0442\u0430 \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u043C \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u043E\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043B\u0438\u0448\u0435 \u0432\u043A\u0430\u0437\u0430\u043D\u0456\u0439 \u043E\u0441\u043E\u0431\u0456 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457-\u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430 (\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A \u0430\u0431\u043E \u0434\u0456\u0439\u0441\u043D\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F).",
      transferBannedTitle: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437 \u0437\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
      transferBannedHint: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0443-\u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0443 \u0437\u0430\u0431\u043E\u0440\u043E\u043D\u0435\u043D\u043E \u043E\u043F\u043B\u0430\u0442\u0443 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u043E\u043C (\u0422\u0440\u0438 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F). \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043C\u043E\u0436\u0435 \u043B\u0438\u0448\u0435 \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u043A.",
      transferPersonBlockedTitle: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u0430 \u043E\u0441\u043E\u0431\u0430 \u2014 \u043F\u0435\u0440\u0435\u043A\u0430\u0437 \u043D\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u043E",
      transferPersonBlockedHint: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F-\u043F\u043B\u0430\u0442\u043D\u0438\u043A \u0437\u0430\u0431\u043B\u043E\u043A\u0443\u0432\u0430\u043B\u0430 \u0446\u044E \u043E\u0441\u043E\u0431\u0443 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0445 \u043E\u0441\u0456\u0431, \u0442\u043E\u043C\u0443 \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u043E\u043C \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u0430. \u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043E\u0441\u043E\u0431\u0443 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443 \u0430\u0431\u043E \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0433\u043E\u0442\u0456\u0432\u043A\u0443.",
      transferCashHint: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043E\u043F\u043B\u0430\u0442\u0443 \u0433\u043E\u0442\u0456\u0432\u043A\u043E\u044E \u0430\u0431\u043E \u043A\u0430\u0440\u0442\u043A\u043E\u044E.",
      outstandingBalance: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A \u0431\u043E\u0440\u0433\u0443",
      paidAmount: "\u0421\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      fullyPaid: "\u041F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      recordButton: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043E\u043F\u043B\u0430\u0442\u0443",
      loyaltyDiscount: "\u0417\u043D\u0438\u0436\u043A\u0430 \u0437\u0430 \u0431\u0430\u043B\u0438 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456"
    },
    depositBreakdown: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0437\u0430 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    depositSettledAt: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E: {date}",
    depositUnnamed: "\u0411\u0435\u0437\u0456\u043C\u0435\u043D\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442",
    depositAction: {
      refund: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      retain: "\u0423\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F",
      refundTitle: "\u041F\u043E\u0432\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
      retainTitle: "\u0423\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      reasonPlaceholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u043E)",
      retainReasonPlaceholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 (\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
      submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      refundSuccess: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043E.",
      retainSuccess: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0443\u0442\u0440\u0438\u043C\u0430\u043D\u043E.",
      partialRefund: "\u0412\u0456\u0434\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      partialRefundTitle: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F (\u0432\u0456\u0434\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F)",
      retainedAmount: "\u0423\u0442\u0440\u0438\u043C\u0430\u043D\u0430 \u0441\u0443\u043C\u0430 (\u0437\u0430 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F)",
      retainedAmountPlaceholder: "\u043D\u0430\u043F\u0440. 20000",
      damageDescription: "\u041E\u043F\u0438\u0441 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      damageDescriptionPlaceholder: "\u041A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u043E\u043F\u0438\u0441 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F (\u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0432 \u0440\u0430\u0445\u0443\u043D\u043A\u0443)",
      vatRate: "\u0421\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412",
      returnPreview: "\u0414\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F (\u043E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u043D\u043E)",
      partialRefundSuccess: "\u0412\u0456\u0434\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u043E.",
      viewDamageInvoice: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0437\u0430 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      transfer: "\u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0442\u0438 \u043D\u0430 \u043D\u0430\u0440\u044F\u0434",
      transferTitle: "\u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0442\u0438 \u0437\u0430\u0441\u0442\u0430\u0432\u0443 \u043D\u0430 \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0439 \u043D\u0430\u0440\u044F\u0434",
      worksheet: "\u0426\u0456\u043B\u044C\u043E\u0432\u0438\u0439 \u043D\u0430\u0440\u044F\u0434",
      worksheetPlaceholder: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043D\u0430\u0440\u044F\u0434\u2026",
      transferAmount: "\u0421\u0443\u043C\u0430 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u043E)",
      transferAmountPlaceholder: "\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C \u0434\u043B\u044F \u043F\u043E\u0432\u043D\u043E\u0457 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
      transferSuccess: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043D\u043E \u043D\u0430 \u043D\u0430\u0440\u044F\u0434.",
      noWorksheets: "\u041D\u0435\u043C\u0430\u0454 \u043D\u0430\u0440\u044F\u0434\u0443 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043D\u043D\u044F \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430.",
      worksheetLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0430\u0440\u044F\u0434\u0456\u0432\u2026",
      cardPartialBlocked: "\u041A\u0430\u0440\u0442\u043A\u043E\u0432\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0430 \u2014 \u0447\u0435\u0440\u0435\u0437 MyPOS",
      cardPartialTooltip: "\u0423\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F \u0437\u0430 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u0437 \u043A\u0430\u0440\u0442\u043A\u043E\u0432\u043E\u0457 (\u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D\u043E\u0457) \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u0442\u0443\u0442 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u0435 \u2014 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0432\u0456\u0434\u0431\u0443\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0435\u0437 MyPOS."
    },
    depositActionError: {
      notFound: "\u0417\u0430\u0441\u0442\u0430\u0432\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
      invalidStatus: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u043D\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u0454 \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0446\u044E \u0434\u0456\u044E.",
      cardNotSupported: "\u0426\u044F \u0434\u0456\u044F \u043D\u0435 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454\u0442\u044C\u0441\u044F \u0434\u043B\u044F \u0437\u0430\u0441\u0442\u0430\u0432, \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0445 \u043A\u0430\u0440\u0442\u043A\u043E\u044E (MyPOS).",
      serviceUnavailable: "\u0421\u0435\u0440\u0432\u0456\u0441 \u0442\u0438\u043C\u0447\u0430\u0441\u043E\u0432\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
      failed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0434\u0456\u044E \u0456\u0437 \u0437\u0430\u0441\u0442\u0430\u0432\u043E\u044E."
    },
    depositStatus: {
      PENDING: "\u041E\u0447\u0456\u043A\u0443\u0454\u0442\u044C\u0441\u044F",
      RECEIVED: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
      HELD: "\u0423\u0442\u0440\u0438\u043C\u0443\u0454\u0442\u044C\u0441\u044F",
      RELEASED: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E",
      RETAINED: "\u0417\u0430\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
      PARTIAL: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E"
    },
    settlement: {
      previewTitle: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      linesTitle: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u043F\u0456\u0434\u0441\u0443\u043C\u043A\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443 (\u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044C\u043E)",
      vatPending: "\u041F\u0414\u0412 \u043D\u0430 \u0443\u0437\u0433\u043E\u0434\u0436\u0435\u043D\u043D\u0456",
      cashTitle: "\u0413\u043E\u0442\u0456\u0432\u043A\u043E\u0432\u0438\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      deductionsTotal: "\u0412\u0441\u044C\u043E\u0433\u043E \u0443\u0442\u0440\u0438\u043C\u0430\u043D\u044C",
      depositApplied: "\u0417\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E \u0437\u0430\u0441\u0442\u0430\u0432\u0443",
      refundToCustomer: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0443",
      payableByCustomer: "\u0414\u043E \u0441\u043F\u043B\u0430\u0442\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u043E\u043C",
      cardTitle: "\u041A\u0430\u0440\u0442\u043A\u043E\u0432\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0430 (\u043E\u043A\u0440\u0435\u043C\u0438\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A)",
      cardNotNetted: "\u041A\u0430\u0440\u0442\u043A\u043E\u0432\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0430 \u043D\u0456\u043A\u043E\u043B\u0438 \u043D\u0435 \u0437\u0430\u0440\u0430\u0445\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F \u2014 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0447\u0435\u0440\u0435\u0437 MyPOS.",
      invoiceTotal: "\u0421\u0443\u043C\u0430 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      myposCapture: "\u0421\u043F\u0438\u0441\u0430\u043D\u043D\u044F MyPOS",
      myposRefund: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F MyPOS",
      forceImmediate: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043D\u0435\u0433\u0430\u0439\u043D\u0438\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      paymentMethod: {
        CASH: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430",
        CARD: "\u041A\u0430\u0440\u0442\u043A\u0430",
        BANK_TRANSFER: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437",
        PRE_AUTH: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0456\u044F (MyPOS)"
      },
      extrasTitle: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F / \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438 / \u0447\u0438\u0449\u0435\u043D\u043D\u044F (\u0434\u043B\u044F \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443)",
      missingAccessoryLabel: "\u0412\u0442\u0440\u0430\u0447\u0435\u043D\u0438\u0439 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440 (\u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C\u043D\u0430 \u0446\u0456\u043D\u0430, HUF)",
      cleaningOverrideLabel: "\u0417\u0430\u043C\u0456\u043D\u0430 \u043F\u043B\u0430\u0442\u0438 \u0437\u0430 \u0447\u0438\u0449\u0435\u043D\u043D\u044F (HUF)",
      cleaningDefaultHint: "\u043F\u043E\u0440\u043E\u0436\u043D\u044C\u043E: \u0431\u0430\u0437\u043E\u0432\u0430 \u043F\u043B\u0430\u0442\u0430",
      missingAccessoryPlaceholder: "0 Ft",
      sectionCharges: "\u041D\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
      sectionSettlement: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      sectionPayout: "\u0412\u0438\u043F\u043B\u0430\u0442\u0430",
      settleModeTitle: "\u0420\u0435\u0436\u0438\u043C \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      settleNow: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0440\u0430\u0437 (\u0442\u0438\u043F\u043E\u0432\u043E)",
      settleAtClose: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u0438 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
      settleAtCloseHint: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u0447\u0435\u043A\u0430\u0454 \u0434\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043E\u0440\u0435\u043D\u0434\u0438; \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0441\u0442\u0430\u043D\u043D\u044C\u043E\u0433\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0440\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0443\u0454 \u0432\u0441\u0456 \u043D\u0435\u0437\u0430\u043A\u0440\u0438\u0442\u0456 \u0437\u0430\u0441\u0442\u0430\u0432\u0438.",
      forceImmediateTooltip: "\u0427\u0435\u0440\u0435\u0437 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0441\u0442\u0440\u043E\u043A\u0443 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044C\u043E \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D\u043E\u0457 \u043A\u0430\u0440\u0442\u043A\u043E\u0432\u043E\u0457 \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043D\u0435\u0433\u0430\u0439\u043D\u0438\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A."
    }
  },
  service: {
    warrantyClaim: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0430 \u0437\u0430\u044F\u0432\u043A\u0430",
    warrantyClaimNumber: "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438",
    warrantyManufacturer: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A",
    warrantyManufacturerPlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0430",
    warrantyClaimValue: "\u0421\u0443\u043C\u0430 \u0437\u0430\u044F\u0432\u043A\u0438",
    warrantySettledAmount: "\u0412\u0438\u043F\u043B\u0430\u0447\u0435\u043D\u0430 \u0441\u0443\u043C\u0430",
    warrantySubmittedAt: "\u041F\u043E\u0434\u0430\u043D\u043E",
    warrantyNoClaimYet: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u043E\u0457 \u0437\u0430\u044F\u0432\u043A\u0438 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454",
    warrantyNotes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
    warrantyNotesPlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u0437\u0430\u044F\u0432\u043A\u0438",
    warrantySubmitClaim: "\u041F\u043E\u0434\u0430\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443",
    warrantyCreateClaim: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0443 \u0437\u0430\u044F\u0432\u043A\u0443",
    photos: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u0457",
    uploadPhoto: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0442\u043E",
    photoFile: "\u0424\u0430\u0439\u043B",
    photoFileRequired: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0444\u0430\u0439\u043B",
    photoCaption: "\u041F\u0456\u0434\u043F\u0438\u0441",
    photoCaptionPlaceholder: "\u041F\u0456\u0434\u043F\u0438\u0441 \u0434\u043E \u0444\u043E\u0442\u043E",
    photoTypeLabel: "\u0422\u0438\u043F",
    photoTypeGeneral: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0435",
    photoTypeBefore: "\u0414\u043E \u0440\u0435\u043C\u043E\u043D\u0442\u0443",
    photoTypeAfter: "\u041F\u0456\u0441\u043B\u044F \u0440\u0435\u043C\u043E\u043D\u0442\u0443",
    photoTypeDamage: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
    noPhotos: "\u0424\u043E\u0442\u043E \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E",
    title: "\u0421\u0435\u0440\u0432\u0456\u0441",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u043C\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u043C\u0438 \u043B\u0438\u0441\u0442\u0430\u043C\u0438",
    worksheet: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    worksheetLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430...",
    worksheetNotFound: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    technician: "\u0422\u0435\u0445\u043D\u0456\u043A",
    parts: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438",
    laborCost: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0440\u043E\u0431\u043E\u0442\u0438",
    diagnosis: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430",
    warranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
    startWork: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443",
    billing: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    reception: "\u041F\u0440\u0438\u0439\u043E\u043C",
    worksheetIntake: "\u041F\u0440\u0438\u0439\u043E\u043C \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    newServiceWorksheet: "\u041D\u043E\u0432\u0438\u0439 \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    worksheetIntakeAndPrint: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0456 \u0434\u0440\u0443\u043A\u0443\u0432\u0430\u0442\u0438",
    creating: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F...",
    cancelIntakeConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u0438\u0439\u043E\u043C \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430?",
    selectPartner: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
    identifyDevice: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439",
    identifyDeviceDesc: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u0434\u043B\u044F \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u0441\u0438\u0441\u0442\u0435\u043C\u0438 \u0430\u0431\u043E \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0440\u0443\u0447\u043D\u0443.",
    reportFault: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u0438\u0442\u0438 \u043F\u0440\u043E \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u0456\u0441\u0442\u044C",
    device: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439",
    fault: "\u041D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u0456\u0441\u0442\u044C",
    diagnosticsNeeded: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430",
    diagnosticsNeededDesc: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u043E, \u043A\u043B\u0456\u0454\u043D\u0442 \u043E\u0442\u0440\u0438\u043C\u0430\u0432 \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0456\u044E. \u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u0431\u0443\u0434\u0435 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0430 \u043E\u043A\u0440\u0435\u043C\u0438\u043C \u043A\u0440\u043E\u043A\u043E\u043C.",
    startDiagnostics: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0443",
    diagnosticsAndItems: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u0442\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    queuePositionLabel: "\u041F\u043E\u0437\u0438\u0446\u0456\u044F {position}",
    itemNotFound: "\u041F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    inspection: "\u041E\u0433\u043B\u044F\u0434",
    inspectionDesc: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C \u0441\u0442\u0430\u043D \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E \u0442\u0430 \u0437\u0430\u0444\u0456\u043A\u0441\u0443\u0439\u0442\u0435 \u043C\u0456\u0441\u0446\u0435 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0433\u043E \u043F\u0456\u0434\u043F\u0438\u0441\u0443.",
    deviceReceivedState: "\u0421\u0442\u0430\u043D \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E *",
    assembledState: "\u0412 \u0437\u0456\u0431\u0440\u0430\u043D\u043E\u043C\u0443 \u0441\u0442\u0430\u043D\u0456",
    disassembledState: "\u0412 \u0440\u043E\u0437\u0456\u0431\u0440\u0430\u043D\u043E\u043C\u0443 \u0441\u0442\u0430\u043D\u0456",
    assembledDesc: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043F\u0440\u0438\u0431\u0443\u0432\u0430\u0454 \u0432 \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443, \u0437\u0456\u0431\u0440\u0430\u043D\u043E\u043C\u0443 \u0441\u0442\u0430\u043D\u0456. \u0411\u0435\u0437 \u0434\u043E\u043F\u043B\u0430\u0442\u0438.",
    disassembledDesc: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043F\u0440\u0438\u0431\u0443\u0432\u0430\u0454 \u0432 \u0440\u043E\u0437\u0456\u0431\u0440\u0430\u043D\u043E\u043C\u0443 \u0441\u0442\u0430\u043D\u0456. \u0414\u043E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0437\u0431\u0456\u0440\u043A\u0443 \u0431\u0443\u0434\u0435 \u043D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0430.",
    disassembledSurcharge: "\u0414\u043E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0440\u043E\u0437\u0456\u0431\u0440\u0430\u043D\u0438\u0439 \u0441\u0442\u0430\u043D",
    noSurcharge: "\u0411\u0435\u0437 \u0434\u043E\u043F\u043B\u0430\u0442\u0438 \u0437\u0430 \u0437\u0456\u0431\u0440\u0430\u043D\u0438\u0439 \u0441\u0442\u0430\u043D",
    free: "\u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
    quote: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F",
    deadline: "\u0422\u0435\u0440\u043C\u0456\u043D",
    limit: "\u041B\u0456\u043C\u0456\u0442",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430, \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u043C, \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F\u043C \u0430\u0431\u043E \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u0456\u0441\u0442\u044E...",
    equipmentProduct: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F / \u0422\u043E\u0432\u0430\u0440",
    designation: "\u041F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    serialNumber: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    faultDescription: "\u041E\u043F\u0438\u0441 \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u043E\u0441\u0442\u0456",
    diagnosisAndWork: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 \u0442\u0430 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0456 \u0440\u043E\u0431\u043E\u0442\u0438",
    completedWork: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u0456 \u0440\u043E\u0431\u043E\u0442\u0438",
    internalNote: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044F \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    internalOnly: "\u0422\u0456\u043B\u044C\u043A\u0438 \u0434\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044C\u043E\u0433\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F",
    internalNoteHelper: "\u0426\u044F \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u043D\u0435 \u0432\u0438\u0434\u043D\u0430 \u043A\u043B\u0456\u0454\u043D\u0442\u0443.",
    worksheetData: "\u0414\u0430\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    costLimit: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0438\u0442\u0440\u0430\u0442",
    directRepairBadge: "\u041F\u0440\u044F\u043C\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u2014 \u0432 \u043C\u0435\u0436\u0430\u0445 \u043B\u0456\u043C\u0456\u0442\u0443 \u0432\u0438\u0442\u0440\u0430\u0442",
    costLimitSkip: "\u0424\u0430\u0437\u0430 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u0430 \u2014 \u043A\u043E\u0448\u0442\u043E\u0440\u0438\u0441 \u0432 \u043C\u0435\u0436\u0430\u0445 \u043B\u0456\u043C\u0456\u0442\u0443",
    responsibleId: "ID \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u043E\u0433\u043E",
    expectedCompletion: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
    queuePosition: "\u041F\u043E\u0437\u0438\u0446\u0456\u044F \u0432 \u0447\u0435\u0440\u0437\u0456",
    storageFee: "\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F",
    storageStart: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F",
    storageDailyFee: "\u0414\u0435\u043D\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
    storageTotalFee: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
    externalCost: "\u0412\u0438\u0442\u0440\u0430\u0442\u0438 \u043D\u0430 \u0441\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A\u0430",
    addExternalCost: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0438\u0442\u0440\u0430\u0442\u0438 \u043D\u0430 \u0441\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A\u0430",
    externalCostDescription: "\u041E\u043F\u0438\u0441",
    externalCostDescriptionPlaceholder: "\u043D\u0430\u043F\u0440. \u041F\u0435\u0440\u0435\u043C\u043E\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u0432\u0438\u0433\u0443\u043D\u0430, \u0413\u0430\u043B\u044C\u0432\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044F...",
    externalCostAmount: "\u0421\u0443\u043C\u0430 (\u043D\u0435\u0442\u0442\u043E HUF)",
    externalCostAmountPlaceholder: "\u043D\u0430\u043F\u0440. 25000",
    externalCostBadge: "\u0421\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A",
    externalCostAdded: "\u0412\u0438\u0442\u0440\u0430\u0442\u0438 \u043D\u0430 \u0441\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A\u0430 \u0434\u043E\u0434\u0430\u043D\u043E",
    externalCostDescriptionRequired: "\u041E\u043F\u0438\u0441 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    externalCostAmountPositive: "\u0421\u0443\u043C\u0430 \u043F\u043E\u0432\u0438\u043D\u043D\u0430 \u0431\u0443\u0442\u0438 \u043F\u043E\u0437\u0438\u0442\u0438\u0432\u043D\u043E\u044E",
    worksheetItems: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    noItems: "\u041D\u0430 \u0446\u044C\u043E\u043C\u0443 \u0440\u043E\u0431\u043E\u0447\u043E\u043C\u0443 \u043B\u0438\u0441\u0442\u0456 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439.",
    itemTypePart: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0430",
    itemTypeLabor: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0430\u0446\u0456",
    itemTypeOther: "\u0406\u043D\u0448\u0435",
    itemTypeExternalCost: "\u0412\u0438\u0442\u0440\u0430\u0442\u0438 \u043D\u0430 \u0441\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A\u0430",
    timestamps: "\u0427\u0430\u0441\u043E\u0432\u0456 \u043C\u0456\u0442\u043A\u0438",
    received: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
    created: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    modified: "\u0417\u043C\u0456\u043D\u0435\u043D\u043E",
    completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
    creatorId: "ID \u0441\u0442\u0432\u043E\u0440\u044E\u0432\u0430\u0447\u0430",
    relatedRental: "\u041F\u043E\u0432'\u044F\u0437\u0430\u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
    viewRental: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443",
    statusLabels: {
      received: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
      inProgress: "\u0412 \u0440\u043E\u0431\u043E\u0442\u0456",
      waiting: "\u041E\u0447\u0456\u043A\u0443\u0454",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      billable: "\u0414\u043E \u043E\u043F\u043B\u0430\u0442\u0438",
      closed: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
    },
    typeLabels: {
      paid: "\u041F\u043B\u0430\u0442\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442",
      warranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
      rentalService: "\u0421\u0435\u0440\u0432\u0456\u0441 \u043E\u0440\u0435\u043D\u0434\u0438",
      maintenance: "\u0422\u0435\u0445\u043D\u0456\u0447\u043D\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F"
    },
    priorityLabels: {
      urgent: "\u0422\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u043E (+20%)",
      normal: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
      warranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F"
    },
    categoryLabels: {
      powerTool: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      gardenEquipment: "\u0421\u0430\u0434\u043E\u0432\u0430 \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
      construction: "\u0411\u0443\u0434\u0456\u0432\u0435\u043B\u044C\u043D\u0430 \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
      cleaningMachine: "\u041F\u0440\u0438\u0431\u0438\u0440\u0430\u043B\u044C\u043D\u0430 \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
      other: "\u0406\u043D\u0448\u0435"
    },
    searchInSystem: "\u041F\u043E\u0448\u0443\u043A \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0456",
    manualEntry: "\u0420\u0443\u0447\u043D\u0435 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
    searchProductPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u043E\u043C, \u043C\u043E\u0434\u0435\u043B\u043B\u044E \u0430\u0431\u043E \u0441\u0435\u0440\u0456\u0439\u043D\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C...",
    productsLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0456\u0432...",
    productsLoadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0456\u0432: {message}",
    serialNumberShort: "\u0421/\u041D: {serial}",
    manualDeviceEntry: "\u0420\u0443\u0447\u043D\u0435 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E",
    manualDeviceDataEntry: "\u0420\u0443\u0447\u043D\u0435 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E",
    deviceNameRequired: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E *",
    deviceNamePlaceholder: "\u043D\u0430\u043F\u0440. Makita HR2470 \u041F\u0435\u0440\u0444\u043E\u0440\u0430\u0442\u043E\u0440",
    serialNumberPlaceholder: "\u043D\u0430\u043F\u0440. MK-2024-001234",
    selectedDevice: "\u041E\u0431\u0440\u0430\u043D\u0438\u0439 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439: {name}",
    selectPartnerHeading: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    selectPartnerDesc: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0430, \u0447\u0438\u0439 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0442\u0438.",
    searchPartnerPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C\u0435\u043D\u0435\u043C, email, \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u043C, \u0406\u041F\u041D, \u043C\u0456\u0441\u0442\u043E\u043C \u0430\u0431\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C...",
    partnersLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432...",
    partnersLoadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432: {message}",
    trustedPartner: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0438\u0439 \u043A\u043B\u0456\u0454\u043D\u0442",
    warningStatus: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
    blockedStatus: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
    taxNumberLabel: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440: {taxNumber}",
    costBearer: "\u041F\u043B\u0430\u0442\u043D\u0438\u043A: {name}",
    selectedPartner: "\u041E\u0431\u0440\u0430\u043D\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440: {name}",
    reportFaultDesc: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043E\u043F\u0438\u0441 \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u043E\u0441\u0442\u0456 \u0442\u0430 \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430.",
    deviceUnderWarranty: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043D\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0457!",
    warrantyExpiry: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F \u0434\u043E: {date}",
    worksheetType: "\u0422\u0438\u043F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    recommended: "(\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043E)",
    faultDescriptionRequired: "\u041E\u043F\u0438\u0441 \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u043E\u0441\u0442\u0456 *",
    faultDescriptionPlaceholder: "\u041E\u043F\u0438\u0448\u0456\u0442\u044C \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u043E \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u0456\u0441\u0442\u044C, \u0441\u0438\u043C\u043F\u0442\u043E\u043C\u0438, \u043A\u043E\u043B\u0438 \u0437'\u044F\u0432\u0438\u043B\u0430\u0441\u044C...",
    faultDescriptionHint: "\u0427\u0438\u043C \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u0456\u0448\u0438\u0439 \u043E\u043F\u0438\u0441, \u0442\u0438\u043C \u0448\u0432\u0438\u0434\u0448\u0430 \u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430.",
    costLimitOptional: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0438\u0442\u0440\u0430\u0442 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    costLimitHint: "\u042F\u043A\u0449\u043E \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0440\u0435\u043C\u043E\u043D\u0442\u0443 \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0438\u0442\u044C \u0446\u044E \u0441\u0443\u043C\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0456\u044F.",
    summaryType: "\u0422\u0438\u043F: {type}",
    summaryPriority: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442: {priority}",
    summaryCostLimit: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0438\u0442\u0440\u0430\u0442: {limit} Ft",
    inspectionFeeLabel: "\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434 / \u0437\u0431\u0456\u0440\u043A\u0443",
    attentionWarning: "\u0423\u0432\u0430\u0433\u0430!",
    disassembledWarning: "\u0414\u043B\u044F \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457\u0432, \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u0438\u0445 \u0443 \u0440\u043E\u0437\u0456\u0431\u0440\u0430\u043D\u043E\u043C\u0443 \u0441\u0442\u0430\u043D\u0456, \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0437\u0431\u0456\u0440\u043A\u0443 \u0441\u0442\u044F\u0433\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u043E \u0432\u0456\u0434 \u0442\u043E\u0433\u043E, \u0447\u0438 \u0431\u0443\u0434\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E \u0440\u0435\u043C\u043E\u043D\u0442.",
    digitalSignature: "\u0426\u0438\u0444\u0440\u043E\u0432\u0438\u0439 \u043F\u0456\u0434\u043F\u0438\u0441",
    digitalSignatureArea: "\u041C\u0456\u0441\u0446\u0435 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0433\u043E \u043F\u0456\u0434\u043F\u0438\u0441\u0443",
    signatureTouchHint: "\u0422\u043E\u0440\u043A\u043D\u0456\u0442\u044C\u0441\u044F \u0435\u043A\u0440\u0430\u043D\u0443 \u0434\u043B\u044F \u0437\u0430\u043F\u0438\u0441\u0443 \u043F\u0456\u0434\u043F\u0438\u0441\u0443",
    signatureConfirmation: "\u041F\u0456\u0434\u043F\u0438\u0441 \u043A\u043B\u0456\u0454\u043D\u0442\u0430 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E \u0442\u0430 \u043E\u0446\u0456\u043D\u043A\u0443 \u0441\u0442\u0430\u043D\u0443.",
    summaryTitle: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    summaryState: "\u0421\u0442\u0430\u043D: {state}",
    summaryFee: "\u041F\u043B\u0430\u0442\u0430: {fee}",
    summarySignature: "\u041F\u0456\u0434\u043F\u0438\u0441: {status}",
    signatureRecorded: "\u0417\u0430\u043F\u0438\u0441\u0430\u043D\u043E",
    signatureNotRecorded: "\u0429\u0435 \u043D\u0435 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u043E",
    historyLabels: {
      created: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      statusChange: "\u0417\u043C\u0456\u043D\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0443",
      itemAdded: "\u041F\u043E\u0437\u0438\u0446\u0456\u044E \u0434\u043E\u0434\u0430\u043D\u043E",
      itemRemoved: "\u041F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
      assigned: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
      comment: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
      invoiced: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E"
    },
    editWorksheet: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    saveError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u0456",
    errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    worksheetNotEditable: "\u0426\u0435\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043C\u0430\u0454 \u0441\u0442\u0430\u0442\u0443\u0441 {status} \u0456 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434\u0440\u0435\u0434\u0430\u0433\u043E\u0432\u0430\u043D\u0438\u0439.",
    deviceData: "\u0414\u0430\u043D\u0456 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E",
    deviceNamePlaceholderShort: "\u043D\u0430\u043F\u0440. Makita DLX2220",
    serialNumberPlaceholderShort: "\u043D\u0430\u043F\u0440. SN123456789",
    worksheetSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    priorityField: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
    costLimitFt: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0438\u0442\u0440\u0430\u0442 (HUF)",
    costLimitPlaceholder: "\u043D\u0430\u043F\u0440. 50000",
    faultDescriptionCustomerPlaceholder: "\u0429\u043E \u0441\u043F\u043E\u0441\u0442\u0435\u0440\u0456\u0433\u0430\u0454 \u043A\u043B\u0456\u0454\u043D\u0442?",
    diagnosisCausePlaceholder: "\u042F\u043A\u0430 \u043F\u0440\u0438\u0447\u0438\u043D\u0430 \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u043E\u0441\u0442\u0456?",
    workPerformedPlaceholder: "\u042F\u043A\u0456 \u0440\u043E\u0431\u043E\u0442\u0438 \u0431\u0443\u043B\u0438 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0456?",
    internalNotePlaceholder: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456 \u043D\u043E\u0442\u0430\u0442\u043A\u0438 (\u043D\u0435 \u0432\u0438\u0434\u043D\u043E \u043A\u043B\u0456\u0454\u043D\u0442\u0443)...",
    statusChangeTitle: "\u0417\u043C\u0456\u043D\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u0443",
    continueWork: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
    toBilling: "\u0414\u043E \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    diagnosticsStepDesc: "\u0417\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0443, \u043F\u043E\u0442\u0456\u043C \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u0442\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0440\u043E\u0431\u0456\u0442.",
    diagnosisLabel: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430 / \u0412\u0438\u0441\u043D\u043E\u0432\u043E\u043A *",
    diagnosisPlaceholder: "\u0421\u0442\u0430\u043D \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E, \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0456 \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u043E\u0441\u0442\u0456, \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442...",
    workPerformedDetailPlaceholder: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u043F\u0438\u0441 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0438\u0445 \u0440\u043E\u0431\u0456\u0442...",
    laborNorms: "\u041D\u043E\u0440\u043C\u0438 \u043F\u0440\u0430\u0446\u0456",
    customItem: "\u0406\u043D\u0448\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u044F",
    searchPartPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0434\u0435\u0442\u0430\u043B\u0456 \u0430\u0431\u043E \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C...",
    stockCount: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A: {count} \u0448\u0442.",
    searchNormPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043A\u043E\u0434\u043E\u043C \u043D\u043E\u0440\u043C\u0438 \u0430\u0431\u043E \u043E\u043F\u0438\u0441\u043E\u043C...",
    normsLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u043E\u0440\u043C...",
    normsLoadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u043E\u0440\u043C: {message}",
    minuteUnit: "\u0445\u0432",
    addCustomItem: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0456\u043D\u0448\u0443 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    customItemPlaceholder: "\u043D\u0430\u043F\u0440. \u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0432\u0438\u0457\u0437\u0434",
    unitPriceFt: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E (HUF)",
    addedItems: "\u0414\u043E\u0434\u0430\u043D\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457 ({count})",
    partLabel: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0430",
    otherLabel: "\u0406\u043D\u0448\u0435",
    externalCostLabel: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0441\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A\u0430",
    vatLabel: "\u041F\u0414\u0412 (27%):",
    summaryHeading: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    summaryStepDesc: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0434\u0430\u043D\u0456 \u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0456\u0442\u044C \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442.",
    nameLabel: "\u0406\u043C'\u044F:",
    emailLabel: "Email:",
    phoneLabel: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D:",
    designationSummaryLabel: "\u041F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F:",
    serialNumberSummaryLabel: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440:",
    categoryLabel: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F:",
    warrantyLabel: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F:",
    warrantyExpiredNone: "\u0417\u0430\u043A\u0456\u043D\u0447\u0438\u043B\u0430\u0441\u044C/\u041D\u0435\u043C\u0430\u0454",
    faultReport: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u0456\u0441\u0442\u044C",
    typeLabel: "\u0422\u0438\u043F:",
    priorityLabel: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442:",
    costLimitSummaryLabel: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0438\u0442\u0440\u0430\u0442:",
    faultDescriptionSummaryLabel: "\u041E\u043F\u0438\u0441 \u043D\u0435\u0441\u043F\u0440\u0430\u0432\u043D\u043E\u0441\u0442\u0456:",
    findingLabel: "\u0412\u0438\u0441\u043D\u043E\u0432\u043E\u043A:",
    completedWorkSummaryLabel: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u0456 \u0440\u043E\u0431\u043E\u0442\u0438:",
    itemsWithCount: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 ({count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439)",
    netLabel: "\u041D\u0435\u0442\u0442\u043E:",
    noItemsAdded: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u043D\u0435 \u0434\u043E\u0434\u0430\u043D\u0456.",
    completionSection: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
    internalOnlyPlaceholder: "\u0412\u0438\u0434\u043D\u043E \u0442\u0456\u043B\u044C\u043A\u0438 \u0434\u043B\u044F \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u0443...",
    costLimitWarning: "\u0421\u0443\u043C\u0430 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430 ({total} HUF) \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439 \u043B\u0456\u043C\u0456\u0442 \u0432\u0438\u0442\u0440\u0430\u0442 ({limit} HUF). \u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0456\u044F \u0437 \u043A\u043B\u0456\u0454\u043D\u0442\u043E\u043C!",
    worksheetReadyToCreate: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0433\u043E\u0442\u043E\u0432\u0438\u0439 \u0434\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
    accessories: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438",
    accessoriesDesc: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C, \u044F\u043A\u0456 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438 \u0431\u0443\u043B\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u0456 \u0440\u0430\u0437\u043E\u043C \u0437 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0454\u043C.",
    receivedAccessories: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u0456 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438",
    addCustomAccessory: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0456\u043D\u0448\u0438\u0439 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440",
    customAccessoryPlaceholder: "\u043D\u0430\u043F\u0440. \u0410\u0434\u0430\u043F\u0442\u0435\u0440 \u043F\u0438\u043B\u043E\u0441\u043E\u0441\u0430, \u041B\u0430\u0437\u0435\u0440\u043D\u0438\u0439 \u0440\u0456\u0432\u0435\u043D\u044C...",
    customLabel: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0438\u0439",
    accessoryNote: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0434\u043E \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432",
    accessoryNotePlaceholder: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u0449\u043E\u0434\u043E \u0441\u0442\u0430\u043D\u0443 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432, \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0445 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u0456\u0432...",
    selectedAccessoriesCount: "\u041E\u0431\u0440\u0430\u043D\u0456 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438 ({count} \u0448\u0442.)",
    noAccessoriesSelected: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0438 \u043D\u0435 \u043E\u0431\u0440\u0430\u043D\u0456.",
    noAccessoriesHint: "\u042F\u043A\u0449\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043F\u0440\u0438\u0431\u0443\u0432 \u0431\u0435\u0437 \u0430\u043A\u0441\u0435\u0441\u0443\u0430\u0440\u0456\u0432, \u0437\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C \u0456 \u043F\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044C \u0434\u0430\u043B\u0456.",
    fieldService: "\u0412\u0438\u0457\u0437\u043D\u0438\u0439 \u0441\u0435\u0440\u0432\u0456\u0441",
    fieldServiceDesc: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C, \u044F\u043A\u0449\u043E \u0446\u0435 \u0440\u0435\u043C\u043E\u043D\u0442 \u043D\u0430 \u043C\u0456\u0441\u0446\u0456.",
    fieldServiceAddress: "\u0410\u0434\u0440\u0435\u0441\u0430 \u043E\u0431'\u0454\u043A\u0442\u0443 *",
    fieldServiceAddressPlaceholder: "\u043D\u0430\u043F\u0440. 1052 Budapest, De\xE1k Ferenc utca 15.",
    fieldServiceAddressHint: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0442\u043E\u0447\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443, \u0434\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0440\u0435\u043C\u043E\u043D\u0442.",
    deviceMobility: "\u041C\u043E\u0431\u0456\u043B\u044C\u043D\u0456\u0441\u0442\u044C \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E",
    mobilityLabels: {
      mobile: "\u041C\u043E\u0431\u0456\u043B\u044C\u043D\u0438\u0439",
      immobile: "\u041D\u0435\u0440\u0443\u0445\u043E\u043C\u0438\u0439",
      partiallyMobile: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u043C\u043E\u0431\u0456\u043B\u044C\u043D\u0438\u0439"
    },
    mobilityDescriptions: {
      mobile: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043C\u043E\u0436\u043D\u0430 \u0432\u0456\u043B\u044C\u043D\u043E \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0443\u0432\u0430\u0442\u0438, \u043D\u0435 \u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u0438\u0439.",
      immobile: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u0438\u0439, \u0440\u0435\u043C\u043E\u043D\u0442 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u043A\u043E\u043D\u0443\u0432\u0430\u0442\u0438 \u043D\u0430 \u043C\u0456\u0441\u0446\u0456.",
      partiallyMobile: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043C\u0430\u0454 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u0443 \u043C\u043E\u0431\u0456\u043B\u044C\u043D\u0456\u0441\u0442\u044C, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430."
    },
    assistanceNeeded: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
    assistanceNeededDesc: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u043C\u0443 \u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u0430\u0431\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u044E.",
    assistanceNeededSuffix: " \u2014 \u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
    fieldObstacles: "\u041F\u0435\u0440\u0435\u0448\u043A\u043E\u0434\u0438 \u043D\u0430 \u043C\u0456\u0441\u0446\u0456, \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
    fieldObstaclesPlaceholder: "\u043D\u0430\u043F\u0440. \u041F\u043E\u0432\u0435\u0440\u0445, \u0441\u0442\u043E\u0440\u043E\u043D\u0430 \u0432\u0445\u043E\u0434\u0443, \u043F\u0430\u0440\u043A\u0443\u0432\u0430\u043D\u043D\u044F, \u043E\u0441\u043E\u0431\u043B\u0438\u0432\u0456 \u043E\u0431\u0441\u0442\u0430\u0432\u0438\u043D\u0438...",
    fieldServiceDetails: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0432\u0438\u0457\u0437\u043D\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
    damageClaim: {
      title: "\u041F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0457 \u043F\u0440\u043E \u0432\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
      titleSingle: "\u041F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u044F \u043F\u0440\u043E \u0432\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
      statusLabels: {
        pending: "\u041D\u0430 \u0440\u043E\u0437\u0433\u043B\u044F\u0434\u0456",
        approved: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        rejected: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        settled: "\u0412\u0440\u0435\u0433\u0443\u043B\u044C\u043E\u0432\u0430\u043D\u043E"
      },
      typeLabels: {
        warranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0438\u0439 (ML-GAR)",
        damage: "\u0412\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0431\u0438\u0442\u043A\u0456\u0432 (ML-BH)"
      },
      noClaims: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u0439 \u043F\u0440\u043E \u0432\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F.",
      repairCost: "\u0420\u0435\u043C\u043E\u043D\u0442: {amount}",
      lostRevenue: "\u0412\u0442\u0440\u0430\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434: {amount}",
      totalClaim: "\u0412\u0441\u044C\u043E\u0433\u043E: {amount}",
      rejectedPrefix: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E: {note}",
      approve: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
      reject: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
      rejectionPrompt: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F:",
      notFound: "\u041F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u044E \u043F\u0440\u043E \u0432\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      basicData: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
      statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441",
      typeLabel: "\u0422\u0438\u043F",
      rentalId: "ID \u043E\u0440\u0435\u043D\u0434\u0438",
      createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      financialData: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0456 \u0434\u0430\u043D\u0456",
      repairCostLabel: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0440\u0435\u043C\u043E\u043D\u0442\u0443",
      lostRevenueLabel: "\u0412\u0442\u0440\u0430\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      totalClaimLabel: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0456\u044F",
      rejectionReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
      approval: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      approvedBy: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0432: {name}",
      processing: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430..."
    },
    disassembly: {
      title: "\u0420\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F",
      button: "\u0420\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F",
      modalTitle: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0440\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F",
      modalDescription: "\u041F\u0456\u0441\u043B\u044F \u0440\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F \u0434\u0435\u0442\u0430\u043B\u0456 \u0431\u0443\u0434\u0443\u0442\u044C \u0434\u043E\u0434\u0430\u043D\u0456 \u0434\u043E \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u044E.",
      addPart: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u0435\u0442\u0430\u043B\u044C",
      productSearch: "\u041F\u043E\u0448\u0443\u043A \u0442\u043E\u0432\u0430\u0440\u0443...",
      quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      condition: "\u0421\u0442\u0430\u043D",
      conditionNew: "\u041D\u043E\u0432\u0438\u0439",
      conditionUsed: "\u0412\u0436\u0438\u0432\u0430\u043D\u0438\u0439",
      conditionDamaged: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u0438\u0439",
      execute: "\u0412\u0438\u043A\u043E\u043D\u0430\u0442\u0438",
      executing: "\u0412\u0438\u043A\u043E\u043D\u0443\u0454\u0442\u044C\u0441\u044F...",
      success: "\u0420\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E \u0443\u0441\u043F\u0456\u0448\u043D\u043E",
      error: "\u0420\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F",
      protocols: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0438 \u0440\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F",
      noProtocols: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0456\u0432 \u0440\u043E\u0437\u0431\u0438\u0440\u0430\u043D\u043D\u044F",
      performedBy: "\u0412\u0438\u043A\u043E\u043D\u0430\u0432\u0435\u0446\u044C",
      performedAt: "\u0427\u0430\u0441 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F",
      partsCount: "{count} \u0434\u0435\u0442\u0430\u043B\u0435\u0439"
    },
    express: {
      surcharge: "\u0415\u043A\u0441\u043F\u0440\u0435\u0441-\u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0430",
      lineItem: "\u0415\u043A\u0441\u043F\u0440\u0435\u0441-\u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0430 (\u043E\u043A\u0440\u0435\u043C\u0438\u0439 \u0440\u044F\u0434\u043E\u043A \u0440\u0430\u0445\u0443\u043D\u043A\u0443)",
      addSurcharge: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0435\u043A\u0441\u043F\u0440\u0435\u0441-\u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0443",
      amount: "\u0421\u0443\u043C\u0430 \u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0438 (\u043D\u0435\u0442\u0442\u043E HUF)",
      success: "\u0415\u043A\u0441\u043F\u0440\u0435\u0441-\u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0443 \u0434\u043E\u0434\u0430\u043D\u043E",
      error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u0438 \u0435\u043A\u0441\u043F\u0440\u0435\u0441-\u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0443"
    },
    external: {
      title: "\u0417\u043E\u0432\u043D\u0456\u0448\u043D\u0456\u0439 \u0441\u0435\u0440\u0432\u0456\u0441",
      forwardButton: "\u041F\u0435\u0440\u0435\u0441\u043B\u0430\u0442\u0438 \u0434\u043E \u0437\u043E\u0432\u043D\u0456\u0448\u043D\u044C\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
      forwardModalTitle: "\u041F\u0435\u0440\u0435\u0441\u043B\u0430\u0442\u0438 \u0434\u043E \u0437\u043E\u0432\u043D\u0456\u0448\u043D\u044C\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      forwardModalDescription: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0431\u0443\u0434\u0435 \u043F\u0435\u0440\u0435\u0441\u043B\u0430\u043D\u043E \u0437\u043E\u0432\u043D\u0456\u0448\u043D\u044C\u043E\u043C\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u043C\u0443 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0443.",
      partnerSelect: "\u0417\u043E\u0432\u043D\u0456\u0448\u043D\u0456\u0439 \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043F\u0435\u0440\u0435\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
      reasonPlaceholder: "\u043D\u0430\u043F\u0440. \u0421\u043F\u0435\u0446\u0456\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u043D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0438\u0445 \u0434\u0435\u0442\u0430\u043B\u0435\u0439...",
      estimatedReturn: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430 \u0434\u0430\u0442\u0430 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      forward: "\u041F\u0435\u0440\u0435\u0441\u043B\u0430\u0442\u0438",
      forwarding: "\u041F\u0435\u0440\u0435\u0441\u0438\u043B\u0430\u0454\u0442\u044C\u0441\u044F...",
      forwardSuccess: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0441\u043B\u0430\u043D\u043E",
      banner: "\u0423 \u0437\u043E\u0432\u043D\u0456\u0448\u043D\u044C\u043E\u043C\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0456",
      bannerInfo: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440: {partner} | \u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F: {date}",
      returnButton: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      returnModalTitle: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0456\u0437 \u0437\u043E\u0432\u043D\u0456\u0448\u043D\u044C\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
      actualCost: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C (\u043D\u0435\u0442\u0442\u043E HUF)",
      returnNotes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
      returnNotesPlaceholder: "\u043D\u0430\u043F\u0440. \u0420\u0435\u043C\u043E\u043D\u0442 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E, \u0434\u0435\u0442\u0430\u043B\u044C \u0437\u0430\u043C\u0456\u043D\u0435\u043D\u043E...",
      returnSuccess: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u043E",
      error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
      partnerSearchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0430\u0431\u043E \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C"
    },
    publicRequest: {
      title: "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0441\u0435\u0440\u0432\u0456\u0441",
      subtitle: "\u041E\u043D\u043B\u0430\u0439\u043D \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
      customerName: "\u0406\u043C'\u044F",
      customerNamePlaceholder: "\u043D\u0430\u043F\u0440. \u0406\u0432\u0430\u043D \u041F\u0435\u0442\u0440\u0435\u043D\u043A\u043E",
      phone: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
      phonePlaceholder: "\u043D\u0430\u043F\u0440. +36 30 123 4567",
      email: "Email (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      emailPlaceholder: "\u043D\u0430\u043F\u0440. ivan@example.com",
      equipmentDescription: "\u041E\u043F\u0438\u0441 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      equipmentDescriptionPlaceholder: "\u043D\u0430\u043F\u0440. Makita HR2470 \u043F\u0435\u0440\u0444\u043E\u0440\u0430\u0442\u043E\u0440",
      problemDescription: "\u041E\u043F\u0438\u0441 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438",
      problemDescriptionPlaceholder: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u043E \u043E\u043F\u0438\u0448\u0456\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443...",
      preferredDate: "\u0411\u0430\u0436\u0430\u043D\u0430 \u0434\u0430\u0442\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0442",
      submitting: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0442\u044C\u0441\u044F...",
      success: "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0441\u0435\u0440\u0432\u0456\u0441 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E! \u041C\u0438 \u0437\u0432'\u044F\u0436\u0435\u043C\u043E\u0441\u044F \u0437 \u0432\u0430\u043C\u0438 \u043D\u0430\u0439\u0431\u043B\u0438\u0436\u0447\u0438\u043C \u0447\u0430\u0441\u043E\u043C.",
      error: "\u041F\u0456\u0434 \u0447\u0430\u0441 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0441\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
    },
    pendingRequest: {
      title: "\u0417\u0430\u043F\u0438\u0442\u0438 \u043D\u0430 \u0441\u0435\u0440\u0432\u0456\u0441",
      noRequests: "\u041D\u0435\u043C\u0430\u0454 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0445 \u0437\u0430\u043F\u0438\u0442\u0456\u0432",
      accept: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438",
      reject: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
      accepted: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
      rejected: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
      pending: "\u041E\u0447\u0456\u043A\u0443\u0454",
      customerName: "\u0406\u043C'\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
      phone: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      equipment: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      problem: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
      date: "\u0414\u0430\u0442\u0430",
      status: "\u0421\u0442\u0430\u0442\u0443\u0441"
    },
    abandoned: {
      tabTitle: "\u0417\u0430\u043B\u0438\u0448\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      noItems: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043B\u0438\u0448\u0435\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      noItemsDesc: "\u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0441\u0435 \u043E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0431\u0443\u0432\u0430\u0454 \u0432 \u043C\u0435\u0436\u0430\u0445 \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F.",
      totalCount: "\u0417\u0430\u043B\u0438\u0448\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F: {count}",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      daysOverdue: "\u0434\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
      perDay: "\u0434\u0435\u043D\u044C",
      storageFee: "\u041E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F"
    },
    compensation: {
      tabTitle: "\u041A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F",
      title: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u0439\u043D\u043E\u0457 \u0432\u0438\u043F\u043B\u0430\u0442\u0438",
      description: "\u042F\u043A\u0449\u043E \u043A\u043B\u0456\u0454\u043D\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u0435 \u0430\u0431\u043E \u0432\u0442\u0440\u0430\u0447\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u0439\u043D\u0443 \u0432\u0438\u043F\u043B\u0430\u0442\u0443.",
      rentalId: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u043E\u0440\u0435\u043D\u0434\u0438",
      rentalIdPlaceholder: "\u043D\u0430\u043F\u0440. R-20260401-001",
      amount: "\u0421\u0443\u043C\u0430 (Ft)",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      reasonPlaceholder: "\u043D\u0430\u043F\u0440. \u041A\u043B\u0456\u0454\u043D\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u0432\u0442\u0440\u0430\u0447\u0435\u043D\u043E \u043D\u0430 \u0440\u043E\u0431\u043E\u0447\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456...",
      action: "\u0414\u0456\u044F",
      writtenOff: "\u0421\u043F\u0438\u0441\u0430\u043D\u043D\u044F (WRITTEN_OFF)",
      transferredToInventory: "\u041E\u043F\u0440\u0438\u0431\u0443\u0442\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u043D\u0430 \u0441\u043A\u043B\u0430\u0434 (TRANSFERRED_TO_INVENTORY)",
      submit: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044E",
      validationError: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0443\u0441\u0456 \u043F\u043E\u043B\u044F \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E."
    },
    afterlife: {
      tabTitle: "\u0420\u0456\u0448\u0435\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u043E\u0457 \u0434\u043E\u043B\u0456",
      pageTitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0436\u0438\u0442\u0442\u0454\u0432\u0438\u043C \u0446\u0438\u043A\u043B\u043E\u043C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      pageSubtitle: "\u0417\u0430\u043B\u0438\u0448\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F, \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u043E\u0457 \u0434\u043E\u043B\u0456, \u0433\u0440\u0443\u043F\u043E\u0432\u0435 \u043E\u043F\u0440\u0438\u0431\u0443\u0442\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
      noItems: "\u041D\u0435\u043C\u0430\u0454 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
      scrapTitle: "\u0423\u0442\u0438\u043B\u0456\u0437\u0430\u0446\u0456\u044F",
      repairTitle: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      decisionTitle: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u0440\u0456\u0448\u0435\u043D\u043D\u044F",
      repairs: "\u0420\u0435\u043C\u043E\u043D\u0442\u0438",
      age: "\u0412\u0456\u043A",
      months: "\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
      condition: "\u0421\u0442\u0430\u043D"
    },
    surrender: {
      tabTitle: "\u0414\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u0430 \u0432\u0456\u0434\u043C\u043E\u0432\u0430",
      title: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u0434\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u043E\u0457 \u0432\u0456\u0434\u043C\u043E\u0432\u0438",
      description: "\u042F\u043A\u0449\u043E \u043A\u043B\u0456\u0454\u043D\u0442 \u0434\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u043E \u0432\u0456\u0434\u043C\u043E\u0432\u043B\u044F\u0454\u0442\u044C\u0441\u044F \u0432\u0456\u0434 \u043E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F (\u043D\u0435 \u043C\u043E\u0436\u0435 \u0441\u043F\u043B\u0430\u0442\u0438\u0442\u0438, \u043D\u0435 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454), \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0439\u0442\u0435 \u0437\u0430\u044F\u0432\u0443.",
      rentalId: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u043E\u0440\u0435\u043D\u0434\u0438",
      rentalIdPlaceholder: "\u043D\u0430\u043F\u0440. R-20260401-001",
      statement: "\u0417\u0430\u044F\u0432\u0430",
      statementPlaceholder: "\u0417\u0430\u044F\u0432\u0430 \u043A\u043B\u0456\u0454\u043D\u0442\u0430 \u043F\u0440\u043E \u0434\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u0443 \u0432\u0456\u0434\u043C\u043E\u0432\u0443, \u043E\u0431\u0491\u0440\u0443\u043D\u0442\u0443\u0432\u0430\u043D\u043D\u044F...",
      submit: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u0432\u0456\u0434\u043C\u043E\u0432\u0443",
      validationError: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0443\u0441\u0456 \u043F\u043E\u043B\u044F (\u0437\u0430\u044F\u0432\u0430 \u043C\u0456\u043D\u0456\u043C\u0443\u043C 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432)."
    },
    issueInvoice: "\u0412\u0438\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    invoiceSuccess: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E"
  },
  invoice: {
    title: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0430\u043C\u0438 \u0442\u0430 \u043F\u043B\u0430\u0442\u0456\u0436\u043D\u0438\u043C\u0438 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F\u043C\u0438",
    newInvoice: "\u041D\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    editInvoice: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    invoiceType: "\u0422\u0438\u043F \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    allInvoices: "\u0412\u0441\u0456 \u0440\u0430\u0445\u0443\u043D\u043A\u0438",
    paidRevenue: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
    issuedPending: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0456 / \u041E\u0447\u0456\u043A\u0443\u044E\u0442\u044C",
    overdueDebt: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A (\u043D\u043E\u043C\u0435\u0440 \u0440\u0430\u0445\u0443\u043D\u043A\u0443, \u043F\u0430\u0440\u0442\u043D\u0435\u0440, \u0406\u041F\u041D)...",
    allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    allTypes: "\u0412\u0441\u0456 \u0442\u0438\u043F\u0438",
    dates: "\u0414\u0430\u0442\u0438",
    items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457",
    itemName: "\u041D\u0430\u0437\u0432\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u0457...",
    noItems: '\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E".',
    netTotal: "\u041D\u0435\u0442\u0442\u043E \u0440\u0430\u0437\u043E\u043C:",
    grossTotal: "\u0411\u0440\u0443\u0442\u0442\u043E \u0440\u0430\u0437\u043E\u043C:",
    invoiceNotes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
    notesPlaceholder: "\u041D\u0430\u043F\u0440.: \u0423\u043C\u043E\u0432\u0438 \u043E\u043F\u043B\u0430\u0442\u0438, \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F \u043F\u0440\u043E \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443...",
    createInvoice: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    addressPlaceholder: "01001 \u041A\u0438\u0457\u0432, \u0432\u0443\u043B. \u0425\u0440\u0435\u0449\u0430\u0442\u0438\u043A 1.",
    invoiceCreated: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A {action}!\n\u041D\u043E\u043C\u0435\u0440: {number}\n\u0421\u0443\u043C\u0430: {amount}",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0443...",
    notFound: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    buyerData: "\u0414\u0430\u043D\u0456 \u043F\u043E\u043A\u0443\u043F\u0446\u044F",
    nameLabel: "\u0406\u043C'\u044F",
    addressLabel: "\u0410\u0434\u0440\u0435\u0441\u0430",
    taxNumber: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    description: "\u041E\u043F\u0438\u0441",
    quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
    quantityShort: "\u041A-\u0441\u0442\u044C",
    unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
    unitPriceNet: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E (\u043D\u0435\u0442\u0442\u043E)",
    vat: "\u041F\u0414\u0412",
    total: "\u0420\u0430\u0437\u043E\u043C",
    productIdLabel: "\u0422\u043E\u0432\u0430\u0440: {id}",
    noItemsEmpty: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
    netTotalLabel: "\u041D\u0435\u0442\u0442\u043E \u0440\u0430\u0437\u043E\u043C:",
    vatTotalLabel: "\u041F\u0414\u0412 \u0440\u0430\u0437\u043E\u043C:",
    payable: "\u0414\u043E \u0441\u043F\u043B\u0430\u0442\u0438:",
    invoiceData: "\u0414\u0430\u043D\u0456 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441:",
    typeLabel: "\u0422\u0438\u043F:",
    issueDateLabel: "\u0414\u0430\u0442\u0430 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F:",
    dueDateLabel: "\u0422\u0435\u0440\u043C\u0456\u043D \u043E\u043F\u043B\u0430\u0442\u0438:",
    paidAt: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E:",
    paymentMethod: "\u0421\u043F\u043E\u0441\u0456\u0431 \u043E\u043F\u043B\u0430\u0442\u0438",
    paymentMethodType: {
      cash: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430",
      card: "\u041A\u0430\u0440\u0442\u043A\u0430",
      transfer: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0440\u0435\u043A\u0430\u0437",
      cod: "\u041D\u0430\u043A\u043B\u0430\u0434\u0435\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436"
    },
    correctionInvoice: "\u041A\u043E\u0440\u0435\u043A\u0446\u0456\u0439\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    originalInvoice: "\u041E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A:",
    modificationIndex: "\u041D\u043E\u043C\u0435\u0440 \u0437\u043C\u0456\u043D\u0438:",
    modificationReason: "\u041E\u0431\u0491\u0440\u0443\u043D\u0442\u0443\u0432\u0430\u043D\u043D\u044F:",
    navOnline: "NAV Online",
    navTransactionId: "ID \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457:",
    resendToNav: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0434\u043E NAV",
    fullyPaid: "\u041F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
    balanceDue: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    paidSoFar: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E: {amount}",
    invoiceTotal: "\u0421\u0443\u043C\u0430 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    pdfDownload: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 PDF",
    sendEmail: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u044E \u043F\u043E\u0448\u0442\u043E\u044E",
    printInvoice: "\u0414\u0440\u0443\u043A",
    stornoInvoice: "\u0421\u0442\u043E\u0440\u043D\u043E \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    storno: {
      title: "\u0421\u0442\u043E\u0440\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      subtitle: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0434\u043B\u044F \u0441\u0442\u043E\u0440\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
      reasonLabel: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0441\u0442\u043E\u0440\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
      isProductReturnLabel: "\u0422\u043E\u0432\u0430\u0440 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043E",
      inspectionLabel: "\u0422\u043E\u0432\u0430\u0440 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
      submit: "\u0421\u0442\u043E\u0440\u043D\u0443\u0432\u0430\u0442\u0438",
      success: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0441\u0442\u043E\u0440\u043D\u043E\u0432\u0430\u043D\u043E",
      error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u043E\u0440\u043D\u0443\u0432\u0430\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A"
    },
    markPaid: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0439",
    paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
    overdueWarning: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A! {days} \u0434\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F.",
    overdueBalance: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C: {amount}",
    paymentReminder: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u043E \u043E\u043F\u043B\u0430\u0442\u0443",
    pdfAlert: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F PDF: {number}\n\nPDF \u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u0431\u0443\u0434\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E...",
    emailAlert: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F email: {number}\n\n\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u043D\u0430 email \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430...",
    navResendAlert: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0435 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F NAV: {number}\n\n\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0431\u0443\u0434\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0434\u043E NAV Online...",
    markPaidAlert: "\u041F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043E \u044F\u043A \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0439: {number}\n\n\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043E \u044F\u043A \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0439.",
    errorOccurred: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    editInvoiceSubtitle: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    newInvoiceSubtitle: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    partnerData: "\u0414\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    partnerNameRequired: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 *",
    partnerNamePlaceholder: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430...",
    unit: "\u041E\u0434\u0438\u043D\u0438\u0446\u044F",
    vatPercent: "\u041F\u0414\u0412 %",
    totalGross: "\u0420\u0430\u0437\u043E\u043C (\u0431\u0440\u0443\u0442\u0442\u043E)",
    addItem: "+ \u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    itemDescriptionPlaceholder: "\u041E\u043F\u0438\u0441 \u043F\u043E\u0437\u0438\u0446\u0456\u0457...",
    grossAmount: "\u0411\u0440\u0443\u0442\u0442\u043E \u0440\u0430\u0437\u043E\u043C",
    deleteItem: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    noItemsClickAdd: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443 {button}.",
    vatLabel: "\u041F\u0414\u0412:",
    savingInProgress: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    saveChangesButton: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    createInvoiceButton: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    createdAction: "\u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    updatedAction: "\u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    partnerNameValidation: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u0456\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430!",
    itemsValidation: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u043D\u0443 \u043F\u043E\u0437\u0438\u0446\u0456\u044E!",
    template: {
      standard: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0439",
      detailed: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0438\u0439",
      proforma: "\u041F\u0440\u043E\u0444\u043E\u0440\u043C\u0430",
      select: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D",
      download: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 PDF ({template})"
    },
    advance: {
      title: "\u0410\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      createDirect: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0440\u044F\u043C\u0438\u0439 \u0430\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      createFromProforma: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0430\u0432\u0430\u043D\u0441 \u0437 \u043F\u0440\u043E\u0444\u043E\u0440\u043C\u0438",
      createFinal: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0444\u0456\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0437 \u0432\u0438\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F\u043C \u0430\u0432\u0430\u043D\u0441\u0443",
      cancelAdvance: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0430\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      deductionLine: "\u0412\u0438\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u0430\u0432\u0430\u043D\u0441\u0443",
      advanceAmount: "\u0421\u0443\u043C\u0430 \u0430\u0432\u0430\u043D\u0441\u0443",
      remainingAmount: "\u0417\u0430\u043B\u0438\u0448\u043A\u043E\u0432\u0430 \u0441\u0443\u043C\u0430",
      refundMethod: "\u0421\u043F\u043E\u0441\u0456\u0431 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      cancelReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
      cancelReasonPlaceholder: "\u043D\u0430\u043F\u0440.: \u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E, \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043A\u043B\u0456\u0454\u043D\u0442\u0430...",
      proformaMustBePaid: "\u041F\u0440\u043E\u0444\u043E\u0440\u043C\u0430 \u043F\u043E\u0432\u0438\u043D\u043D\u0430 \u0431\u0443\u0442\u0438 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0430",
      advanceMustBePaid: "\u0410\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u0431\u0443\u0442\u0438 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0439",
      deductionExceedsTotal: "\u0412\u0438\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u0430\u0432\u0430\u043D\u0441\u0443 \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0441\u0443\u043C\u0443 \u0444\u0456\u043D\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      created: "\u0410\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E: {number}",
      finalCreated: "\u0424\u0456\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E: {number}",
      cancelled: "\u0410\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
      cancelledWithStorno: "\u0410\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E, \u0441\u0442\u043E\u0440\u043D\u043E: {number}",
      manualTitle: "\u0410\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0432\u0456\u0434\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
      percentLabel: "\u0410\u0432\u0430\u043D\u0441 %",
      amountLabel: "\u0421\u0443\u043C\u0430 \u0430\u0432\u0430\u043D\u0441\u0443 (HUF)",
      percentPlaceholder: "\u043D\u0430\u043F\u0440. 30",
      amountPlaceholder: "0 HUF",
      manualHint: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0456\u0434\u0441\u043E\u0442\u043E\u043A \u0430\u0432\u0430\u043D\u0441\u0443 \u0430\u0431\u043E \u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u0443 \u0441\u0443\u043C\u0443. \u0412\u043E\u043D\u0430 \u0431\u0443\u0434\u0435 \u0432\u0438\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u0430 \u0437 \u043A\u0456\u043D\u0446\u0435\u0432\u043E\u0433\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443."
    },
    correction: {
      title: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043A\u043E\u0440\u0435\u043A\u0446\u0456\u044E",
      creating: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F...",
      originalInvoice: "\u041E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A:",
      originalAmount: "\u041E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0430 \u0441\u0443\u043C\u0430:",
      issuedAt: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E:",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043A\u043E\u0440\u0435\u043A\u0446\u0456\u0457 *",
      reasonPlaceholder: "\u041D\u0430\u043F\u0440.: \u041A\u043E\u0440\u0435\u043A\u0446\u0456\u044F \u043A\u0456\u043B\u044C\u043A\u043E\u0441\u0442\u0456, \u0437\u043C\u0456\u043D\u0430 \u0446\u0456\u043D\u0438...",
      reasonMinLength: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
      itemChanges: "\u0417\u043C\u0456\u043D\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      netDifference: "\u041D\u0435\u0442\u0442\u043E \u0440\u0456\u0437\u043D\u0438\u0446\u044F:",
      vatDifference: "\u041F\u0414\u0412 \u0440\u0456\u0437\u043D\u0438\u0446\u044F:",
      grossDifference: "\u0411\u0440\u0443\u0442\u0442\u043E \u0440\u0456\u0437\u043D\u0438\u0446\u044F:",
      createCorrection: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043A\u043E\u0440\u0435\u043A\u0446\u0456\u0439\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      correctionTitle: "\u041A\u043E\u0440\u0435\u043A\u0446\u0456\u0439\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      originalLabel: "\u041E\u0440\u0438\u0433\u0456\u043D\u0430\u043B: {number}",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440:",
      originalQty: "\u041E\u0440\u0438\u0433. \u043A-\u0441\u0442\u044C",
      newQty: "\u041D\u043E\u0432\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      originalPrice: "\u041E\u0440\u0438\u0433. \u0446\u0456\u043D\u0430",
      newPrice: "\u041D\u043E\u0432\u0430 \u0446\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
      difference: "\u0420\u0456\u0437\u043D\u0438\u0446\u044F",
      correctionCreated: "\u041A\u043E\u0440\u0435\u043A\u0446\u0456\u0439\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E: {number}",
      errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
      reasonValidation: "\u041E\u0431\u0491\u0440\u0443\u043D\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0432\u0438\u043D\u043D\u043E \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432!",
      correctedItem: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u044F",
      differenceItem: "\u0420\u0456\u0437\u043D\u0438\u0446\u0435\u0432\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u044F",
      modificationReference: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0437\u043C\u0456\u043D\u0443",
      originalItem: "\u041E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u044F",
      performanceDateNote: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u0434\u0430\u0442\u0438 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F",
      previewTitle: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      vatSelfAudit: "\u0421\u0430\u043C\u043E\u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u041F\u0414\u0412",
      vatSelfAuditDescription: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u044F \u0441\u0430\u043C\u043E\u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0438 \u041F\u0414\u0412"
    },
    deliveryNote: {
      title: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0456",
      newDeliveryNote: "\u041D\u043E\u0432\u0430 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0430",
      types: {
        standard: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430 (SZ-)",
        contract: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0430 (SZ-)",
        rentalAccessory: "\u041E\u0440\u0435\u043D\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F (SZB-)",
        supplierCredit: "\u041A\u0440\u0435\u0434\u0438\u0442 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 (SZH-)"
      },
      typeLabels: {
        standard: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430",
        contract: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0430",
        rentalAccessory: "\u041E\u0440\u0435\u043D\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        supplierCredit: "\u041A\u0440\u0435\u0434\u0438\u0442 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430"
      },
      statusLabels: {
        open: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0430",
        invoiced: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
        settled: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
        closed: "\u0417\u0430\u043A\u0440\u0438\u0442\u0430"
      },
      partnerName: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      partnerNameRequired: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 *",
      partnerId: "ID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      partnerIdOptional: "ID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      partnerIdPlaceholder: "ID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      partnerNamePlaceholder: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      itemId: "ID \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      itemIdPlaceholder: "ID \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      productName: "\u041D\u0430\u0437\u0432\u0430 \u0442\u043E\u0432\u0430\u0440\u0443",
      productNamePlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0442\u043E\u0432\u0430\u0440\u0443",
      notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438...",
      notesOptional: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      notesPlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438...",
      typeFilterLabel: "\u0422\u0438\u043F",
      items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457",
      addItem: "+ \u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
      description: "\u041E\u043F\u0438\u0441",
      quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
      unitPriceHuf: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E (HUF)",
      amount: "\u0421\u0443\u043C\u0430",
      totalWithAmount: "\u0420\u0430\u0437\u043E\u043C: {amount}",
      totalLabel: "\u0420\u0430\u0437\u043E\u043C:",
      deleteItem: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      saving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
      createButton: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0443",
      errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
      unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
      notFound: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
      statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441",
      amountLabel: "\u0421\u0443\u043C\u0430",
      createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      invoiceId: "ID \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      contractPartner: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440",
      manualSettlement: "\u0420\u0443\u0447\u043D\u0435 \u0432\u0440\u0435\u0433\u0443\u043B\u044E\u0432\u0430\u043D\u043D\u044F",
      settled: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
      notesLabel: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
      itemsCount: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 ({count})",
      product: "\u0422\u043E\u0432\u0430\u0440",
      invoicing: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      processing: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430...",
      financiallySettled: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u043E \u0440\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
      assignToInvoice: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0434\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      invoiceIdLabel: "ID \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      invoiceIdPlaceholder: "ID \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      noDeliveryNotes: "\u041D\u0435\u043C\u0430\u0454 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0438\u0445",
      number: "\u041D\u043E\u043C\u0435\u0440",
      date: "\u0414\u0430\u0442\u0430",
      allTypes: "\u0412\u0441\u0456 \u0442\u0438\u043F\u0438",
      allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
      batchConfirmGenerate: "\u0413\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      batchConfirmMessage: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0430\u043A\u0435\u0442\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0456\u0437 \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0445 \u0432\u0438\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0438\u0445?",
      batchConfirmTitle: "\u041F\u0430\u043A\u0435\u0442\u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
      batchGenerating: "\u0413\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F\u2026",
      batchPartnerMismatch: "\u0412\u0438\u0431\u0440\u0430\u043D\u0456 \u0432\u0438\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0456 \u043D\u0430\u043B\u0435\u0436\u0430\u0442\u044C \u0440\u0456\u0437\u043D\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C",
      generateBatchInvoice: "\u041F\u0430\u043A\u0435\u0442\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      selectForBatch: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0434\u043B\u044F \u043F\u0430\u043A\u0435\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      selectedNotes: "\u0412\u0438\u0431\u0440\u0430\u043D\u043E {count} \u0432\u0438\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0438\u0445"
    },
    status: {
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      pending: "\u041E\u0447\u0456\u043A\u0443\u0454 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      approved: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
      sent: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      partiallyPaid: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
      voided: "\u0410\u043D\u0443\u043B\u044C\u043E\u0432\u0430\u043D\u043E"
    },
    type: {
      standard: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A",
      advance: "\u0410\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      final: "\u041E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      proforma: "\u041F\u0440\u043E\u0444\u043E\u0440\u043C\u0430",
      creditNote: "\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0430 \u043D\u043E\u0442\u0430",
      correction: "\u041A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043D\u043D\u044F",
      storno: "\u0421\u0442\u043E\u0440\u043D\u043E",
      minuszos: "\u041D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A"
    },
    eInvoice: {
      hash: "\u0425\u0435\u0448",
      noEmail: "\u041D\u0435\u043C\u0430\u0454 email",
      notSent: "\u041D\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
      send: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0435-\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      sent: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
      sentAt: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E: {date}",
      title: "\u0415-\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      partnerNotFound: "\u041A\u043B\u0456\u0454\u043D\u0442\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u2014 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0456\u0439\u0441\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0434\u043B\u044F NAV-\u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      partnerIncomplete: "\u041D\u0435\u043F\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456 \u043A\u043B\u0456\u0454\u043D\u0442\u0430 (\u0456\u043C'\u044F, \u043F\u043E\u0448\u0442\u043E\u0432\u0438\u0439 \u0456\u043D\u0434\u0435\u043A\u0441, \u043C\u0456\u0441\u0442\u043E, \u0430\u0434\u0440\u0435\u0441\u0430; \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0439) \u2014 \u0434\u043E\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0434\u043B\u044F NAV-\u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      fixPartner: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u0430\u043D\u0456 \u043A\u043B\u0456\u0454\u043D\u0442\u0430"
    },
    export: {
      monthLabel: "\u041C\u0456\u0441\u044F\u0446\u044C \u0435\u043A\u0441\u043F\u043E\u0440\u0442\u0443",
      xlsxButton: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 (XLSX)",
      csvButton: "CSV",
      error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0435\u043A\u0441\u043F\u043E\u0440\u0442\u0443"
    },
    voided: "\u0410\u043D\u0443\u043B\u044C\u043E\u0432\u0430\u043D\u043E",
    saveError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F"
  },
  sales: {
    title: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    subtitle: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u0456 \u0442\u0430 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0436\u0456",
    totalSales: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0436\u0456",
    totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
    avgBasket: "\u0421\u0435\u0440. \u043A\u043E\u0448\u0438\u043A",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A (\u0447\u0435\u043A, \u043A\u043B\u0456\u0454\u043D\u0442)...",
    allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    cashCustomer: "\u041F\u043E\u043A\u0443\u043F\u0435\u0446\u044C \u0437\u0430 \u0433\u043E\u0442\u0456\u0432\u043A\u0443",
    statusLabels: {
      inProgress: "\u0412 \u0440\u043E\u0431\u043E\u0442\u0456",
      awaitingPayment: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043E\u043F\u043B\u0430\u0442\u0438",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      reversed: "\u0421\u0442\u043E\u0440\u043D\u043E\u0432\u0430\u043D\u043E"
    },
    paymentStatusLabels: {
      pending: "\u041E\u0447\u0456\u043A\u0443\u0454",
      partial: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u0430",
      paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      refunded: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E"
    },
    newSale: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0434\u0430\u0436",
    noSales: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u0434\u0430\u0436\u0456\u0432 \u0437\u0430 \u043E\u0431\u0440\u0430\u043D\u0438\u043C\u0438 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u044F\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0443.",
    pendingPayment: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043E\u043F\u043B\u0430\u0442\u0438",
    errorOccurred: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    detail: {
      pendingPayment: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043E\u043F\u043B\u0430\u0442\u0438",
      voided: "\u0410\u043D\u0443\u043B\u044C\u043E\u0432\u0430\u043D\u043E",
      receipt: "\u041A\u0432\u0438\u0442\u0430\u043D\u0446\u0456\u044F",
      invoice: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A",
      processing: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430...",
      void: "\u0410\u043D\u0443\u043B\u044E\u0432\u0430\u0442\u0438",
      voidConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0430\u043D\u0443\u043B\u044E\u0432\u0430\u0442\u0438 \u0446\u044E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E?",
      voidReason: "\u0410\u043D\u0443\u043B\u044C\u043E\u0432\u0430\u043D\u043E \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      voidError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0430\u043D\u0443\u043B\u044E\u0432\u0430\u043D\u043D\u044F",
      printReceipt: "\u0414\u0440\u0443\u043A \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0456\u0457...",
      printInvoice: "\u0414\u0440\u0443\u043A \u0440\u0430\u0445\u0443\u043D\u043A\u0443...",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F.",
      transactionNotFound: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
      items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 ({count})",
      noItems: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      discount: "\u0437\u043D\u0438\u0436\u043A\u0430",
      customerData: "\u0414\u0430\u043D\u0456 \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
      partnerId: "ID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      voidData: "\u0414\u0430\u043D\u0456 \u0430\u043D\u0443\u043B\u044E\u0432\u0430\u043D\u043D\u044F",
      timestamp: "\u0427\u0430\u0441",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      summary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
      subtotal: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
      discountAmount: "\u0417\u043D\u0438\u0436\u043A\u0430",
      paymentStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043E\u043F\u043B\u0430\u0442\u0438",
      paidAmount: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E: {amount}",
      change: "\u0420\u0435\u0448\u0442\u0430",
      transactionData: "\u0414\u0430\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
      transactionNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
      sessionId: "ID \u0441\u0435\u0441\u0456\u0457"
    },
    pos: {
      title: "\u041A\u0430\u0441\u0430 (POS)",
      loadingSession: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u0435\u0441\u0456\u0457 \u043A\u0430\u0441\u0438...",
      noDefaultWarehouse: "\u041D\u0435\u043C\u0430\u0454 \u0441\u043A\u043B\u0430\u0434\u0443 \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443. \u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0439\u0442\u0435 \u0439\u043E\u0433\u043E, \u0449\u043E\u0431 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043A\u0430\u0441\u0443.",
      warehouseLoadError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u043A\u043B\u0430\u0434. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
      retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
      openRegister: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043A\u0430\u0441\u0443",
      suspend: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438",
      closeRegister: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u043A\u0430\u0441\u0443",
      resume: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
      addCustomer: "+ \u041A\u043B\u0456\u0454\u043D\u0442",
      sessionWarning: "\u041A\u0430\u0441\u0430 {status}. \u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u043A\u0430\u0441\u0443 \u0434\u043B\u044F \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439.",
      sessionSuspended: "\u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u0430",
      sessionClosed: "\u0437\u0430\u043A\u0440\u0438\u0442\u0430",
      searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C \u0430\u0431\u043E \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u043E\u043C...",
      allCategories: "\u0412\u0441\u0456",
      openRegisterForProducts: "\u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u043A\u0430\u0441\u0443 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
      cart: "\u041A\u043E\u0448\u0438\u043A ({count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439)",
      cartEmpty: "\u041A\u043E\u0448\u0438\u043A \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u0439",
      subtotal: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A:",
      discount: "\u0417\u043D\u0438\u0436\u043A\u0430:",
      total: "\u0420\u0430\u0437\u043E\u043C:",
      clearCart: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043A\u043E\u0448\u0438\u043A",
      pay: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0438",
      payment: "\u041E\u043F\u043B\u0430\u0442\u0430",
      discountFt: "\u0417\u043D\u0438\u0436\u043A\u0430 (HUF)",
      receivedAmount: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u0430 \u0441\u0443\u043C\u0430 (HUF)",
      toPay: "\u0414\u043E \u043E\u043F\u043B\u0430\u0442\u0438:",
      change: "\u0420\u0435\u0448\u0442\u0430:",
      completePayment: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043E\u043F\u043B\u0430\u0442\u0443",
      selectCustomer: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
      noCustomer: "\u0411\u0435\u0437 \u043A\u043B\u0456\u0454\u043D\u0442\u0430 (\u0433\u043E\u0442\u0456\u0432\u043A\u043E\u0432\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0430)",
      saleSuccess: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0439!\n\u0421\u0443\u043C\u0430: {total}\n\u0420\u0435\u0448\u0442\u0430: {change}",
      noActiveSession: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0457 \u0441\u0435\u0441\u0456\u0457 \u043A\u0430\u0441\u0438",
      outOfStock: "\u0422\u043E\u0432\u0430\u0440 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456",
      procurement: {
        bannerTitle: "{name} \u2014 \u043D\u0435\u043C\u0430\u0454 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456",
        bannerHint: "\u0414\u043E\u0434\u0430\u0439 \u0434\u043E \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u0448\u0438\u043A\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C, \u0449\u043E\u0431 \u0442\u0435\u0445\u043D\u0456\u043A \u043F\u0456\u0434 \u0447\u0430\u0441 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u043D\u0430\u0432, \u0449\u043E \u0446\u0435\u0439 \u0442\u043E\u0432\u0430\u0440 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D.",
        addButton: "\u0414\u043E \u043A\u043E\u0448\u0438\u043A\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C",
        addSuccess: "\u0414\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043A\u043E\u0448\u0438\u043A\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C",
        addError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430"
      },
      unknownBarcode: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434: {barcode}",
      barcodeError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u0443",
      paymentError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u0431\u0440\u043E\u0431\u043A\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0443",
      voidError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0430\u043D\u0443\u043B\u044E\u0432\u0430\u043D\u043D\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
      voidReason: "\u0410\u043D\u0443\u043B\u044C\u043E\u0432\u0430\u043D\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0435\u043C",
      productCategories: {
        powerTool: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
        handTool: "\u0420\u0443\u0447\u043D\u0438\u0439 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
        accessory: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440",
        workwear: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043E\u0434\u044F\u0433"
      },
      loyalty: {
        balance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0431\u0430\u043B\u0456\u0432",
        points: "\u0431\u0430\u043B\u0456\u0432",
        redeem: "\u041E\u0431\u043C\u0456\u043D\u044F\u0442\u0438 \u0431\u0430\u043B\u0438",
        maxRedemption: "\u043C\u0430\u043A\u0441 {percent}% \u0432\u0456\u0434 \u0441\u0443\u043C\u0438",
        discount: "\u0417\u043D\u0438\u0436\u043A\u0430 \u0437\u0430 \u0431\u0430\u043B\u0438 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456",
        remaining: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A \u0434\u043E \u043E\u043F\u043B\u0430\u0442\u0438",
        redeemFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u043F\u0438\u0441\u0430\u0442\u0438 \u0431\u0430\u043B\u0438",
        insufficientPoints: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0431\u0430\u043B\u0456\u0432 \u0434\u043B\u044F \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
        concurrentRetry: "\u0421\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0431\u0430\u043B\u0456\u0432 \u043A\u043E\u043D\u0444\u043B\u0456\u043A\u0442\u0443\u0432\u0430\u043B\u043E \u0437 \u0456\u043D\u0448\u043E\u044E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0454\u044E \u2014 \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437"
      },
      packages: {
        title: "\u041F\u0430\u043A\u0435\u0442\u0438",
        badge: "\u041F\u0430\u043A\u0435\u0442",
        setBadge: "\u041D\u0430\u0431\u0456\u0440",
        savingsLabel: "\u0415\u043A\u043E\u043D\u043E\u043C\u0456\u044F \u043F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043E \u0437 \u043E\u043A\u0440\u0435\u043C\u043E\u044E \u043A\u0443\u043F\u0456\u0432\u043B\u0435\u044E",
        tieredNotSellable: "\u0426\u0456\u043D\u0430 \u0446\u044C\u043E\u0433\u043E \u043F\u0430\u043A\u0435\u0442\u0430 \u0437\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0456\u0434 \u0442\u0440\u0438\u0432\u0430\u043B\u043E\u0441\u0442\u0456 \u043E\u0440\u0435\u043D\u0434\u0438, \u0439\u043E\u0433\u043E \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0442\u0438 \u043D\u0430 POS",
        componentPriceMissing: "\u041E\u0434\u0438\u043D \u0456\u0437 \u0442\u043E\u0432\u0430\u0440\u0456\u0432 \u043F\u0430\u043A\u0435\u0442\u0430 \u043D\u0435 \u043C\u0430\u0454 \u0446\u0456\u043D\u0438 \u2014 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u0456\u0442\u044C \u0457\u0457 \u0432 \u0430\u0434\u043C\u0456\u043D-\u043F\u0430\u043D\u0435\u043B\u0456",
        discountMissing: "\u0414\u043B\u044F \u043F\u0430\u043A\u0435\u0442\u0430 \u0437\u0456 \u0437\u043D\u0438\u0436\u043A\u043E\u044E \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u043E \u0437\u043D\u0438\u0436\u043A\u0443",
        fixedPriceMissing: "\u0414\u043B\u044F \u043F\u0430\u043A\u0435\u0442\u0430 \u0437 \u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u043E\u044E \u0446\u0456\u043D\u043E\u044E \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u043E \u0446\u0456\u043D\u0443",
        addFailed: "\u041F\u0430\u043A\u0435\u0442 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430"
      },
      barcodePlaceholder: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u0443\u2026",
      creditPayment: "\u0423 \u043A\u0440\u0435\u0434\u0438\u0442",
      voucherPayment: "\u0412\u0430\u0443\u0447\u0435\u0440",
      saleSuccessTitle: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0439",
      saleSuccessTotal: "\u0421\u043F\u043B\u0430\u0447\u0435\u043D\u0430 \u0441\u0443\u043C\u0430",
      saleSuccessChange: "\u0420\u0435\u0448\u0442\u0430",
      saleTransactionLabel: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F",
      navProcessing: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043E NAV \u0442\u0440\u0438\u0432\u0430\u0454\u2026",
      newSale: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0434\u0430\u0436"
    },
    session: {
      close: {
        title: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043A\u0430\u0441\u0438",
        sessionLabel: "\u0421\u0435\u0441\u0456\u044F:",
        openingBalance: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A:",
        expectedBalance: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A:",
        closingBalance: "\u041A\u0456\u043D\u0446\u0435\u0432\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A (HUF)",
        variance: "\u0420\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044C:",
        surplus: "\u041D\u0430\u0434\u043B\u0438\u0448\u043E\u043A \u0443 \u043A\u0430\u0441\u0456",
        shortage: "\u041D\u0435\u0441\u0442\u0430\u0447\u0430 \u0443 \u043A\u0430\u0441\u0456",
        varianceReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0440\u043E\u0437\u0431\u0456\u0436\u043D\u043E\u0441\u0442\u0456 (\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
        variancePlaceholder: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0440\u043E\u0437\u0431\u0456\u0436\u043D\u043E\u0441\u0442\u0456...",
        closeError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043A\u0430\u0441\u0438",
        cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        closing: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F...",
        closeButton: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u043A\u0430\u0441\u0443"
      },
      suspend: {
        title: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438 \u043A\u0430\u0441\u0443",
        resumeTitle: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u043A\u0430\u0441\u0438",
        statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441:",
        statusSuspended: "\u041F\u0420\u0418\u0417\u0423\u041F\u0418\u041D\u0415\u041D\u041E",
        statusActive: "\u0410\u041A\u0422\u0418\u0412\u041D\u0410",
        reasonLabel: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
        reasonPlaceholder: "\u041D\u0430\u043F\u0440. \u043E\u0431\u0456\u0434\u043D\u044F \u043F\u0435\u0440\u0435\u0440\u0432\u0430, \u0437\u043C\u0456\u043D\u0430...",
        quickReasons: {
          lunch: "\u041E\u0431\u0456\u0434\u043D\u044F \u043F\u0435\u0440\u0435\u0440\u0432\u0430",
          break: "\u041F\u0435\u0440\u0435\u0440\u0432\u0430",
          shiftChange: "\u0417\u043C\u0456\u043D\u0430",
          technical: "\u0422\u0435\u0445\u043D\u0456\u0447\u043D\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430"
        },
        resumeInfo: "\u041A\u0430\u0441\u0430 \u043D\u0430\u0440\u0430\u0437\u0456 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u0430.",
        resumeHint: '\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438", \u0449\u043E\u0431 \u0432\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u043A\u0430\u0441\u0438.',
        resuming: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F...",
        resumeButton: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u043A\u0430\u0441\u0438",
        suspending: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F...",
        suspendButton: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438"
      },
      open: {
        title: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043A\u0430\u0441\u0443",
        openingBalance: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A (HUF)",
        openError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u043A\u0430\u0441\u0438",
        cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        opening: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F...",
        openButton: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043A\u0430\u0441\u0443"
      },
      status: {
        open: "\u0410\u041A\u0422\u0418\u0412\u041D\u0410",
        suspended: "\u041F\u0420\u0418\u0417\u0423\u041F\u0418\u041D\u0415\u041D\u041E",
        closed: "\u0417\u0410\u041A\u0420\u0418\u0422\u0410",
        noSession: "\u041D\u0415\u041C\u0410\u0404 \u0410\u041A\u0422\u0418\u0412\u041D\u041E\u0407 \u041A\u0410\u0421\u0418"
      }
    },
    zReport: {
      title: "Z-\u0417\u0432\u0456\u0442",
      sessionInfo: "\u0406\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0406\u042F \u041F\u0420\u041E \u041A\u0410\u0421\u0423",
      opened: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E:",
      closed: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E:",
      cashBalance: "\u0417\u0410\u041B\u0418\u0428\u041E\u041A \u0413\u041E\u0422\u0406\u0412\u041A\u0418",
      openingBalance: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A:",
      expectedBalance: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A:",
      closingBalance: "\u041A\u0456\u043D\u0446\u0435\u0432\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A:",
      variance: "\u0420\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044C:",
      note: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430:",
      transactions: "\u0422\u0420\u0410\u041D\u0417\u0410\u041A\u0426\u0406\u0407",
      totalTransactions: "\u0412\u0441\u044C\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439:",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E:",
      voided: "\u0421\u0442\u043E\u0440\u043D\u043E\u0432\u0430\u043D\u043E:",
      paymentMethods: "\u0421\u041F\u041E\u0421\u041E\u0411\u0418 \u041E\u041F\u041B\u0410\u0422\u0418",
      cash: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430:",
      card: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0430 \u043A\u0430\u0440\u0442\u043A\u0430:",
      transfer: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437:",
      voucher: "\u0412\u0430\u0443\u0447\u0435\u0440:",
      credit: "\u041A\u0440\u0435\u0434\u0438\u0442:",
      revenue: "\u041E\u0411\u041E\u0420\u041E\u0422",
      grossSales: "\u0412\u0430\u043B\u043E\u0432\u0456 \u043F\u0440\u043E\u0434\u0430\u0436\u0456:",
      discounts: "\u0417\u043D\u0438\u0436\u043A\u0438:",
      netSales: "\u0427\u0438\u0441\u0442\u0456 \u043F\u0440\u043E\u0434\u0430\u0436\u0456:",
      taxAmount: "\u0421\u0443\u043C\u0430 \u041F\u0414\u0412:",
      changeGiven: "\u0412\u0438\u0434\u0430\u043D\u0430 \u0440\u0435\u0448\u0442\u0430:",
      print: "\u0414\u0440\u0443\u043A",
      downloadPdf: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 PDF",
      downloadPdfSoon: "\u0424\u0443\u043D\u043A\u0446\u0456\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F PDF \u0441\u043A\u043E\u0440\u043E \u0431\u0443\u0434\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430",
      close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
      refunds: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F"
    }
  },
  inventory: {
    title: "\u0421\u043A\u043B\u0430\u0434",
    stockList: "\u0421\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    movements: "\u0420\u0443\u0445\u0438",
    goodsReceipt: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0443",
    scrapping: "\u0421\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
    management: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0441\u043A\u043B\u0430\u0434\u043E\u043C",
    warehouseAndMovements: "\u0421\u043A\u043B\u0430\u0434\u0441\u044C\u043A\u0456 \u0437\u0430\u043F\u0430\u0441\u0438 \u0442\u0430 \u0440\u0443\u0445\u0438",
    allItems: "\u0412\u0441\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    stockValue: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
    lowStock: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
    lowStockCount: "{count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A (\u043F\u0440\u043E\u0434\u0443\u043A\u0442, \u0430\u0440\u0442\u0438\u043A\u0443\u043B, \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F)...",
    allWarehouses: "\u0412\u0441\u0456 \u0441\u043A\u043B\u0430\u0434\u0438",
    loadingStock: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0456\u0432...",
    reserved: "\u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E",
    purchasePrice: "\u0417\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C\u043D\u0430 \u0446\u0456\u043D\u0430",
    warehouse: "\u0421\u043A\u043B\u0430\u0434",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
    newReceipt: "+ \u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
    receiptFailed: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
    availableCount: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E ({count})",
    reservedCount: "\u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E ({count})",
    lowStockCountBadge: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439 \u0437\u0430\u043F\u0430\u0441 ({count})",
    typeLabels: {
      product: "\u0422\u043E\u0432\u0430\u0440",
      rentalEquipment: "\u041E\u0440\u0435\u043D\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      part: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0430",
      consumable: "\u0412\u0438\u0442\u0440\u0430\u0442\u043D\u0438\u0439 \u043C\u0430\u0442\u0435\u0440\u0456\u0430\u043B"
    },
    statusLabels: {
      available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
      reserved: "\u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E",
      inService: "\u041D\u0430 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u0456",
      inTransit: "\u0412 \u0434\u043E\u0440\u043E\u0437\u0456",
      rented: "\u0412 \u043E\u0440\u0435\u043D\u0434\u0456",
      sold: "\u041F\u0440\u043E\u0434\u0430\u043D\u043E",
      damaged: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043E",
      lost: "\u0412\u0442\u0440\u0430\u0447\u0435\u043D\u043E",
      scrapped: "\u0421\u043F\u0438\u0441\u0430\u043D\u043E"
    },
    scrapItems: "\u0421\u043F\u0438\u0441\u0430\u043D\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    scrapProtocols: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0438",
    newScrap: "\u041D\u043E\u0432\u0435 \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
    scrapMark: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043D\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
    scrapRecord: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
    scrapRecording: "\u0417\u0430\u043F\u0438\u0441...",
    scrapRecords: "\u0417\u0430\u043F\u0438\u0441\u0438 \u0441\u043F\u0438\u0441\u0430\u043D\u044C ({count})",
    noScrapRecords: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 \u0441\u043F\u0438\u0441\u0430\u043D\u044C.",
    scrapReasonLabels: {
      damaged: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043E",
      expired: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
      defective: "\u0414\u0435\u0444\u0435\u043A\u0442\u043D\u0438\u0439",
      other: "\u0406\u043D\u0448\u0435"
    },
    scrapProtocolStatuses: {
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      approved: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
      finalized: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E"
    },
    scrapProtocolsTitle: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0438 \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
    newProtocol: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B",
    year: "\u0420\u0456\u043A",
    inventoryItemId: "ID \u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0441\u043A\u043B\u0430\u0434\u0443",
    productId: "ID \u0442\u043E\u0432\u0430\u0440\u0443",
    warehouseId: "ID \u0441\u043A\u043B\u0430\u0434\u0443",
    itemNotFound: "\u041F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    stockCount: {
      title: "\u0406\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u0457",
      newButton: "\u041D\u043E\u0432\u0430 \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u044F",
      newButtonHint: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u0457 \u2014 \u0441\u043A\u043E\u0440\u043E",
      empty: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u0439",
      columns: {
        countNumber: "\u041D\u043E\u043C\u0435\u0440 \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u0457",
        name: "\u041D\u0430\u0437\u0432\u0430",
        status: "\u0421\u0442\u0430\u0442\u0443\u0441",
        createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        warehouse: "\u0421\u043A\u043B\u0430\u0434"
      },
      statusLabels: {
        draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
        inProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
        suspended: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043E",
        pendingReview: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0438",
        pendingAdjustment: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043D\u043D\u044F",
        completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
      }
    },
    movementsTitle: "\u0420\u0443\u0445\u0438 \u0441\u043A\u043B\u0430\u0434\u0443",
    movementsSubtitle: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F, \u0432\u0438\u0434\u0430\u0447\u0430, \u043A\u043E\u0440\u0435\u043A\u0446\u0456\u0457",
    movementsSearch: "\u041F\u043E\u0448\u0443\u043A (\u0442\u043E\u0432\u0430\u0440, \u0430\u0440\u0442\u0438\u043A\u0443\u043B, \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F)...",
    category: {
      powerTool: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      handTool: "\u0420\u0443\u0447\u043D\u0438\u0439 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      accessory: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440",
      consumable: "\u0412\u0438\u0442\u0440\u0430\u0442\u043D\u0438\u0439 \u043C\u0430\u0442\u0435\u0440\u0456\u0430\u043B",
      workwear: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043E\u0434\u044F\u0433",
      sparePart: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0430"
    },
    stockStatus: {
      inStock: "\u0412 \u043D\u0430\u044F\u0432\u043D\u043E\u0441\u0442\u0456",
      lowStock: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
      outOfStock: "\u041D\u0435\u043C\u0430\u0454 \u0432 \u043D\u0430\u044F\u0432\u043D\u043E\u0441\u0442\u0456",
      discontinued: "\u0417\u043D\u044F\u0442\u043E \u0437 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u0430"
    },
    movement: {
      in: "\u041D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      out: "\u0412\u0438\u0434\u0430\u0447\u0430",
      adjustment: "\u041A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043D\u043D\u044F",
      transfer: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
      return: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F"
    },
    addProduct: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0442\u043E\u0432\u0430\u0440",
    addProductsViaSearch: "\u0417\u043D\u0430\u0439\u0442\u0438 \u0442\u0430 \u0434\u043E\u0434\u0430\u0442\u0438 \u0442\u043E\u0432\u0430\u0440",
    allGroups: "\u0423\u0441\u0456 \u0433\u0440\u0443\u043F\u0438",
    approve: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
    basicData: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
    batchNumber: "\u041D\u043E\u043C\u0435\u0440 \u043F\u0430\u0440\u0442\u0456\u0457",
    correction: "\u041A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043D\u043D\u044F",
    create: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
    createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    creating: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F...",
    documentData: "\u0414\u0430\u043D\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
    finalize: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438",
    issueStock: "\u0412\u0438\u0434\u0430\u0447\u0430",
    items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457",
    itemsToReceive: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u0434\u043B\u044F \u043F\u0440\u0438\u0439\u043E\u043C\u0443",
    location: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
    maximum: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
    minimum: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C",
    month: "\u041C\u0456\u0441\u044F\u0446\u044C",
    noProtocols: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0456\u0432",
    optionalReceiptNote: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    pcs: "\u0448\u0442.",
    pricing: "\u0426\u0456\u043D\u043E\u0443\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
    procurementAndRestock: "\u0417\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044F \u0442\u0430 \u043F\u043E\u043F\u043E\u0432\u043D\u0435\u043D\u043D\u044F",
    productTypes: "\u0422\u0438\u043F\u0438 \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
    profitability: "\u041F\u0440\u0438\u0431\u0443\u0442\u043A\u043E\u0432\u0456\u0441\u0442\u044C",
    protocolsList: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0456\u0432",
    purchaseCategories: {
      ARU: "\u0422\u043E\u0432\u0430\u0440",
      BERENDEZES: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      BERUHAZAS: "\u0406\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0456\u044F",
      EGYEB: "\u0406\u043D\u0448\u0435",
      REZSI: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0456"
    },
    purchaseCategoryLabel: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456",
    purchaseCategoryPlaceholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044E...",
    purchaseValue: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456",
    quickActions: "\u0428\u0432\u0438\u0434\u043A\u0456 \u0434\u0456\u0457",
    receive: {
      package: "\u041F\u0430\u043A\u0443\u043D\u043E\u043A",
      packageQuantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043F\u0430\u043A\u0443\u043D\u043A\u0456\u0432",
      totalUnits: "\u0423\u0441\u044C\u043E\u0433\u043E \u043E\u0434\u0438\u043D\u0438\u0446\u044C",
      unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
      unitsPerPackage: "\u041E\u0434\u0438\u043D\u0438\u0446\u044C \u0443 \u043F\u0430\u043A\u0443\u043D\u043A\u0443"
    },
    receiveStock: "\u041F\u0440\u0438\u0439\u043E\u043C \u0442\u043E\u0432\u0430\u0440\u0443",
    recording: "\u0417\u0430\u043F\u0438\u0441...",
    referenceOrderNumber: "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
    saveReceipt: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043F\u0440\u0438\u0439\u043E\u043C",
    saving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    searchByNameSkuBarcode: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, SKU, \u0448\u0442\u0440\u0438\u0445\u043A\u043E\u0434\u043E\u043C...",
    serialNumber: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    sku: "SKU",
    stock: "\u0417\u0430\u043F\u0430\u0441",
    stockLevels: "\u0420\u0456\u0432\u043D\u0456 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    summary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    targetWarehouse: "\u0426\u0456\u043B\u044C\u043E\u0432\u0438\u0439 \u0441\u043A\u043B\u0430\u0434",
    total: "\u0423\u0441\u044C\u043E\u0433\u043E",
    totalPieces: "\u0423\u0441\u044C\u043E\u0433\u043E (\u0448\u0442.)",
    transferTitle: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u043C\u0456\u0436 \u0441\u043A\u043B\u0430\u0434\u0430\u043C\u0438",
    transferSubtitle: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0454 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0456\u0432 (\u0431\u0435\u0437 \u0440\u0430\u0445\u0443\u043D\u043A\u0443)",
    transferSource: "\u0421\u043A\u043B\u0430\u0434-\u0434\u0436\u0435\u0440\u0435\u043B\u043E",
    transferTarget: "\u0426\u0456\u043B\u044C\u043E\u0432\u0438\u0439 \u0441\u043A\u043B\u0430\u0434",
    transferSelectSource: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u043A\u043B\u0430\u0434-\u0434\u0436\u0435\u0440\u0435\u043B\u043E",
    transferSelectTarget: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0446\u0456\u043B\u044C\u043E\u0432\u0438\u0439 \u0441\u043A\u043B\u0430\u0434",
    transferReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    transferSameWarehouseError: "\u0421\u043A\u043B\u0430\u0434-\u0434\u0436\u0435\u0440\u0435\u043B\u043E \u0442\u0430 \u0446\u0456\u043B\u044C\u043E\u0432\u0438\u0439 \u0441\u043A\u043B\u0430\u0434 \u043D\u0435 \u043C\u043E\u0436\u0443\u0442\u044C \u0437\u0431\u0456\u0433\u0430\u0442\u0438\u0441\u044F",
    transferAvailableItems: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    transferNoItems: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456-\u0434\u0436\u0435\u0440\u0435\u043B\u0456",
    transferAdd: "\u0414\u043E\u0434\u0430\u0442\u0438",
    transferAddedItems: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
    transferQuantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
    transferAvailable: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E: {qty}",
    transferRemove: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    transferSubmit: "\u041F\u043E\u0447\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
    transferSuccess: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E (#{id})",
    transfer: {
      confirmNote: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
      confirmOwnAsset: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E \u044F\u043A \u0432\u043B\u0430\u0441\u043D\u0438\u0439 \u0430\u043A\u0442\u0438\u0432",
      confirmRental: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E \u044F\u043A \u043E\u0440\u0435\u043D\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      ecsStarted: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u0457 \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E",
      error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
      rentalCardCreated: "\u041A\u0430\u0440\u0442\u043A\u0443 \u043E\u0440\u0435\u043D\u0434\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      success: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u0435",
      title: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      toOwnAsset: "\u041F\u0435\u0440\u0435\u043A\u043B\u0430\u0441\u0438\u0444\u0456\u043A\u0443\u0432\u0430\u0442\u0438 \u044F\u043A \u0432\u043B\u0430\u0441\u043D\u0438\u0439 \u0430\u043A\u0442\u0438\u0432",
      toRental: "\u041F\u0435\u0440\u0435\u043A\u043B\u0430\u0441\u0438\u0444\u0456\u043A\u0443\u0432\u0430\u0442\u0438 \u044F\u043A \u043E\u0440\u0435\u043D\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F"
    },
    updatedAt: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    views: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0438",
    barcode: {
      scan: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u0443",
      scanPlaceholder: "\u0421\u043A\u0430\u043D\u0443\u0439\u0442\u0435 \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434 \u0430\u0431\u043E \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434 \u0442\u043E\u0432\u0430\u0440\u0443...",
      notFound: "\u0422\u043E\u0432\u0430\u0440 \u0437 \u0442\u0430\u043A\u0438\u043C \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u043E\u043C \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      found: "\u0422\u043E\u0432\u0430\u0440 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      lookupError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u043E\u0448\u0443\u043A\u0443 \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u0443"
    },
    withdrawal: {
      title: "\u0421\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0437\u0456 \u0441\u043A\u043B\u0430\u0434\u0443",
      scanToAdd: "\u0421\u043A\u0430\u043D\u0443\u0439\u0442\u0435 \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434 \u0434\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0437\u0438\u0446\u0456\u0457"
    },
    splitAvailability: {
      title: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F-\u0437\u0430\u043F\u0430\u0441",
      split: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u043D\u0430\u044F\u0432\u043D\u043E\u0441\u0442\u0456",
      available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
      backordered: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
      partial: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
      fullyAvailable: "\u041F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
      fullyBackordered: "\u041F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
      summary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A: {available} \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E, {backordered} \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E, {partial} \u0447\u0430\u0441\u0442\u043A\u043E\u0432\u043E"
    },
    centralRequest: {
      title: "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0446\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u043A\u043B\u0430\u0434",
      submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0442",
      submitting: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F...",
      pending: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0456 \u0437\u0430\u043F\u0438\u0442\u0438",
      note: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
      notePlaceholder: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u0437\u0430\u043F\u0438\u0442\u0443...",
      success: "\u0417\u0430\u043F\u0438\u0442 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E ({count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439)",
      noPending: "\u041D\u0435\u043C\u0430\u0454 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0445 \u0437\u0430\u043F\u0438\u0442\u0456\u0432",
      requestedAt: "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u043E",
      selectLowStock: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u0437 \u043D\u0438\u0437\u044C\u043A\u0438\u043C \u0437\u0430\u043F\u0430\u0441\u043E\u043C"
    },
    phantom: {
      title: "\u0424\u0430\u043D\u0442\u043E\u043C\u043D\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      count: "{count} \u0444\u0430\u043D\u0442\u043E\u043C\u043D\u0438\u0445 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      badge: "\u0424\u0430\u043D\u0442\u043E\u043C ({count})",
      resolve: "\u0412\u0438\u0440\u0456\u0448\u0438\u0442\u0438",
      scrap: "\u0421\u043F\u0438\u0441\u0430\u0442\u0438",
      recount: "\u041F\u0435\u0440\u0435\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438",
      actualQuantity: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      reasonPlaceholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0438\u0440\u0456\u0448\u0435\u043D\u043D\u044F...",
      resolved: "\u0424\u0430\u043D\u0442\u043E\u043C\u043D\u0443 \u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0438\u0440\u0456\u0448\u0435\u043D\u043E",
      noPhantom: "\u041D\u0435\u043C\u0430\u0454 \u0444\u0430\u043D\u0442\u043E\u043C\u043D\u0438\u0445 \u043F\u043E\u0437\u0438\u0446\u0456\u0439"
    },
    deadStock: {
      title: "\u041C\u0435\u0440\u0442\u0432\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
      subtitle: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457, \u043A\u043B\u0430\u0441\u0438\u0444\u0456\u043A\u043E\u0432\u0430\u043D\u0456 \u0437\u0430 \u0434\u0430\u0432\u043D\u0456\u0441\u0442\u044E \u0440\u0443\u0445\u0443",
      activeLabel: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      warningLabel: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      deadLabel: "\u041C\u0435\u0440\u0442\u0432\u0438\u0439",
      activeCount: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      warningCount: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      deadCount: "\u041C\u0435\u0440\u0442\u0432\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      totalDeadValue: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043C\u0435\u0440\u0442\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0430\u0441\u0443",
      productName: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
      sku: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B",
      quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      lastMovement: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u0440\u0443\u0445",
      daysSinceMovement: "\u0414\u043D\u0456\u0432 \u0431\u0435\u0437 \u0440\u0443\u0445\u0443",
      classification: "\u041A\u043B\u0430\u0441\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F",
      value: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
      warehouse: "\u0421\u043A\u043B\u0430\u0434",
      noMovement: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0443\u0445\u0443",
      noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0430\u043D\u0430\u043B\u0456\u0437\u0443 \u043C\u0435\u0440\u0442\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0430\u0441\u0443"
    },
    analytics: {
      title: "\u0410\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      subtitle: "\u0410\u043D\u0430\u043B\u0456\u0437 ITR \u0442\u0430 ABC"
    },
    turnover: {
      title: "\u041A\u043E\u0435\u0444\u0456\u0446\u0456\u0454\u043D\u0442 \u043E\u0431\u043E\u0440\u043E\u0442\u043D\u043E\u0441\u0442\u0456 \u0437\u0430\u043F\u0430\u0441\u0456\u0432 (ITR)",
      ratio: "\u041A\u043E\u0435\u0444\u0456\u0446\u0456\u0454\u043D\u0442 \u043E\u0431\u043E\u0440\u043E\u0442\u043D\u043E\u0441\u0442\u0456",
      cogs: "\u0421\u043E\u0431\u0456\u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C (\u043E\u0446\u0456\u043D\u043A\u0430)",
      avgInventoryValue: "\u0421\u0435\u0440. \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      year: "\u0420\u0456\u043A",
      previousYear: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0440\u0456\u043A",
      trend: "\u0422\u0440\u0435\u043D\u0434",
      trendUp: "\u0417\u0440\u043E\u0441\u0442\u0430\u0454",
      trendDown: "\u0417\u043D\u0438\u0436\u0443\u0454\u0442\u044C\u0441\u044F",
      trendStable: "\u0421\u0442\u0430\u0431\u0456\u043B\u044C\u043D\u0438\u0439",
      noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0430\u043D\u0430\u043B\u0456\u0437\u0443 \u043E\u0431\u043E\u0440\u043E\u0442\u043D\u043E\u0441\u0442\u0456"
    },
    abc: {
      title: "ABC-\u0430\u043D\u0430\u043B\u0456\u0437",
      subtitle: "\u041A\u043B\u0430\u0441\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F \u041F\u0430\u0440\u0435\u0442\u043E \u0437\u0430 \u0434\u043E\u0445\u043E\u0434\u043E\u043C",
      product: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
      sku: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B",
      revenue: "\u0414\u043E\u0445\u0456\u0434",
      cumulativePercent: "\u041A\u0443\u043C\u0443\u043B\u044F\u0442\u0438\u0432\u043D\u0438\u0439 %",
      class: "\u041A\u043B\u0430\u0441",
      aItems: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 A",
      bItems: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 B",
      cItems: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 C",
      totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F ABC-\u0430\u043D\u0430\u043B\u0456\u0437\u0443"
    },
    seasonality: {
      title: "\u0421\u0435\u0437\u043E\u043D\u043D\u0456\u0441\u0442\u044C",
      selectProduct: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
      chooseProduct: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u043E\u0434\u0443\u043A\u0442...",
      topSeasonal: "\u0422\u043E\u043F-10 \u043D\u0430\u0439\u0441\u0435\u0437\u043E\u043D\u043D\u0456\u0448\u0438\u0445 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432",
      productName: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
      index: "\u0406\u043D\u0434\u0435\u043A\u0441 \u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0441\u0442\u0456",
      peakMonths: "\u041F\u0456\u043A\u043E\u0432\u0456 \u043C\u0456\u0441\u044F\u0446\u0456",
      lowMonths: "\u041D\u0438\u0437\u044C\u043A\u0456 \u043C\u0456\u0441\u044F\u0446\u0456",
      peak: "\u041F\u0456\u043A",
      normal: "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u0438\u0439",
      low: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
      noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0430\u043D\u0430\u043B\u0456\u0437\u0443 \u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0441\u0442\u0456"
    },
    transferSuggestion: {
      title: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
      totalSuggestions: "\u0412\u0441\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      product: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
      from: "\u0421\u043A\u043B\u0430\u0434-\u0434\u0436\u0435\u0440\u0435\u043B\u043E",
      to: "\u0421\u043A\u043B\u0430\u0434-\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447",
      currentFrom: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 (\u0434\u0436\u0435\u0440\u0435\u043B\u043E)",
      currentTo: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 (\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447)",
      suggestedQty: "\u0417\u0430\u043F\u0440\u043E\u043F\u043E\u043D\u043E\u0432\u0430\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      noSuggestions: "\u041D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F"
    },
    supplierCatalog: {
      title: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0456\u0432",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
      search: "\u041F\u043E\u0448\u0443\u043A",
      searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443, \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0443...",
      results: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438",
      productName: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
      category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
      price: "\u0426\u0456\u043D\u0430 \u043D\u0435\u0442\u0442\u043E",
      availability: "\u041D\u0430\u044F\u0432\u043D\u0456\u0441\u0442\u044C",
      leadTime: "\u0422\u0435\u0440\u043C\u0456\u043D \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
      days: "\u0434\u043D\u0456\u0432",
      inStock: "\u0412 \u043D\u0430\u044F\u0432\u043D\u043E\u0441\u0442\u0456",
      outOfStock: "\u041D\u0435\u043C\u0430\u0454 \u0432 \u043D\u0430\u044F\u0432\u043D\u043E\u0441\u0442\u0456",
      noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
      hint: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 \u0442\u0430 \u0448\u0443\u043A\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438 \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0437\u0456"
    },
    allProductGroups: "\u0423\u0441\u0456 \u0442\u043E\u0432\u0430\u0440\u043D\u0456 \u0433\u0440\u0443\u043F\u0438",
    productGroups: {
      ALKATRESZ: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0430",
      GEP: "\u041C\u0430\u0448\u0438\u043D\u0430",
      TARTOZEK: "\u0410\u043A\u0441\u0435\u0441\u0443\u0430\u0440",
      SZERSZAM: "\u0406\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      MUNKARUHA: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043E\u0434\u044F\u0433 / \u0417\u0406\u0417",
      VEGYSZER: "\u0425\u0456\u043C\u0456\u043A\u0430\u0442 / \u041C\u0430\u0441\u0442\u0438\u043B\u043E",
      EGYEB: "\u0406\u043D\u0448\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u043D\u0456 \u043C\u0430\u0442\u0435\u0440\u0456\u0430\u043B\u0438",
      BERGEP: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0430",
      DIJAK: "\u0417\u0431\u043E\u0440\u0438 / \u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043F\u043E\u0441\u043B\u0443\u0433\u0438",
      SZERZODESES: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0438\u0439",
      BERENDEZES: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F"
    },
    reservedForWorksheet: "\u0417\u0430\u0431\u0440\u043E\u043D\u044C\u043E\u0432\u0430\u043D\u043E \u0434\u043B\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u043A\u0430",
    summaryTitle: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    summarySubtitle: "\u0410\u0433\u0440\u0435\u0433\u0430\u0442 \u043F\u043E \u0442\u043E\u0432\u0430\u0440\u0443: \u0441\u043A\u0456\u043B\u044C\u043A\u0438 \u0454, \u0437\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E \u043F\u0440\u043E\u0442\u0438 \u0432\u0456\u043B\u044C\u043D\u043E\u0433\u043E",
    occupiedOfTotal: "{occupied}/{total} \u0437\u0430\u0439\u043D\u044F\u0442\u043E",
    stockLevel: {
      OK: "OK",
      LOW: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
      CRITICAL: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      OUT_OF_STOCK: "\u041D\u0435\u043C\u0430\u0454 \u0432 \u043D\u0430\u044F\u0432\u043D\u043E\u0441\u0442\u0456"
    },
    movementUnitCost: "\u0421\u043E\u0431\u0456\u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u043E\u0434\u0438\u043D\u0438\u0446\u0456",
    movementValue: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0440\u0443\u0445\u0443",
    breakdown: {
      expand: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0440\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0437\u0430 \u0441\u043A\u043B\u0430\u0434\u0430\u043C\u0438",
      collapse: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u0440\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0437\u0430 \u0441\u043A\u043B\u0430\u0434\u0430\u043C\u0438",
      title: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0437\u0430 \u0441\u043A\u043B\u0430\u0434\u0430\u043C\u0438"
    }
  },
  partner: {
    scan: {
      button: "\u{1F4F7} \u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
      buttonAriaLabel: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043A\u0430\u043C\u0435\u0440\u043E\u044E",
      processing: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430...",
      success: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u0435 \u2014 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0434\u0430\u043D\u0456",
      failure: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u0442\u0438, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437",
      lowConfidence: "\u041D\u0438\u0437\u044C\u043A\u0430 \u0434\u043E\u0441\u0442\u043E\u0432\u0456\u0440\u043D\u0456\u0441\u0442\u044C \u2014 \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0434\u0430\u043D\u0456 \u0432\u0440\u0443\u0447\u043D\u0443"
    },
    expired: {
      banner: "\u26A0\uFE0F \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439 \u2014 {days} \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443",
      bannerNoDate: "\u26A0\uFE0F \u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439",
      overrideCheckbox: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0437 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C",
      overrideReasonLabel: "\u041E\u0431\u0491\u0440\u0443\u043D\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0438\u043D\u044F\u0442\u043A\u0443 (\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      overrideReasonPlaceholder: "\u043D\u0430\u043F\u0440. \u041A\u043B\u0456\u0454\u043D\u0442 \u0442\u043E\u0433\u043E \u0436 \u0434\u043D\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u0432 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
      overrideReasonRequired: "\u041E\u0431\u0491\u0440\u0443\u043D\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435, \u044F\u043A\u0449\u043E \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0443\u0454\u0442\u0435 \u0437 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C"
    },
    title: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430\u043C\u0438, \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430\u043C\u0438 \u0442\u0430 \u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A\u0430\u043C\u0438",
    name: "\u041D\u0430\u0437\u0432\u0430",
    email: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
    phone: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
    address: "\u0410\u0434\u0440\u0435\u0441\u0430",
    taxNumber: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    newPartner: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440",
    partnerList: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
    totalPartners: "\u0412\u0441\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
    company: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
    individual: "\u0424\u0456\u0437\u0438\u0447\u043D\u0430 \u043E\u0441\u043E\u0431\u0430",
    withBalance: "\u0417 \u0431\u0430\u043B\u0430\u043D\u0441\u043E\u043C",
    totalBalance: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
    contact: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442",
    revenue: "\u0412\u0438\u0440\u0443\u0447\u043A\u0430",
    balance: "\u0411\u0430\u043B\u0430\u043D\u0441",
    categories: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C\u0435\u043D\u0435\u043C, \u043A\u043E\u0434\u043E\u043C, email, \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u043C, \u0406\u041F\u041D...",
    duplicatesTitle: "\u0414\u0443\u0431\u043B\u0456\u043A\u0430\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u0442\u0430 \u0437\u0430\u043B\u0438\u0448\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    matchFieldLabels: {
      phone: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      documentNumber: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
      email: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
      name: "\u041D\u0430\u0437\u0432\u0430",
      taxNumber: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
      DOCUMENT_NUMBER: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
      EMAIL: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
      NAME: "\u0406\u043C'\u044F",
      TAX_NUMBER: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440"
    },
    actionLabels: {
      scrapped: "\u0421\u043F\u0438\u0441\u0430\u043D\u043E",
      sold: "\u041F\u0440\u043E\u0434\u0430\u043D\u043E",
      retained: "\u0417\u0430\u043B\u0438\u0448\u0435\u043D\u043E",
      DESTROY: "\u0417\u043D\u0438\u0449\u0438\u0442\u0438",
      KEEP: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
      SELL: "\u041F\u0440\u043E\u0434\u0430\u0442\u0438"
    },
    scrappingReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0441\u043F\u0438\u0441\u0430\u043D\u043D\u044F:",
    registerData: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u0434\u0430\u043D\u0438\u0445 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    typeAndCategory: "\u0422\u0438\u043F \u0442\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
    partnerType: "\u0422\u0438\u043F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    categoriesRequired: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 * (\u043C\u0456\u043D\u0456\u043C\u0443\u043C \u043E\u0434\u043D\u0430)",
    basicData: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
    companyName: "\u041D\u0430\u0437\u0432\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457",
    companyNameOptional: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    validation: {
      taxFormat: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 (8-1-2 \u0446\u0438\u0444\u0440\u0438).",
      taxChecksum: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u0430 \u0446\u0438\u0444\u0440\u0430 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0430.",
      phoneFormat: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443.",
      postalFormat: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u043E\u0448\u0442\u043E\u0432\u043E\u0433\u043E \u0456\u043D\u0434\u0435\u043A\u0441\u0443 (4 \u0446\u0438\u0444\u0440\u0438)."
    },
    fullName: "\u041F\u043E\u0432\u043D\u0435 \u0456\u043C'\u044F",
    shortName: "\u0421\u043A\u043E\u0440\u043E\u0447\u0435\u043D\u0430 \u043D\u0430\u0437\u0432\u0430",
    registrationNumber: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    contactInfo: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
    website: "\u0412\u0435\u0431\u0441\u0430\u0439\u0442",
    billingAddress: "\u0410\u0434\u0440\u0435\u0441\u0430 \u0434\u043B\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    postalCode: "\u041F\u043E\u0448\u0442\u043E\u0432\u0438\u0439 \u0456\u043D\u0434\u0435\u043A\u0441",
    city: "\u041C\u0456\u0441\u0442\u043E",
    streetAddress: "\u0412\u0443\u043B\u0438\u0446\u044F, \u043D\u043E\u043C\u0435\u0440 \u0431\u0443\u0434\u0438\u043D\u043A\u0443",
    floorDoor: "\u041F\u043E\u0432\u0435\u0440\u0445/\u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430",
    notificationEmail: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430 \u0434\u043B\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C",
    billingEmail: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430 \u0434\u043B\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    billingEmailSameAsNotification: "\u0417\u0431\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u0437 \u043F\u043E\u0448\u0442\u043E\u044E \u0434\u043B\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C",
    temporaryAddress: "\u0422\u0438\u043C\u0447\u0430\u0441\u043E\u0432\u0430 \u0430\u0434\u0440\u0435\u0441\u0430",
    tempAddressValidUntil: "\u0414\u0456\u0439\u0441\u043D\u0430 \u0434\u043E",
    temporaryAddressSection: "\u0422\u0438\u043C\u0447\u0430\u0441\u043E\u0432\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 (\u044F\u043A\u0449\u043E \u0432\u0456\u0434\u0440\u0456\u0437\u043D\u044F\u0454\u0442\u044C\u0441\u044F \u0432\u0456\u0434 \u043F\u043E\u0441\u0442\u0456\u0439\u043D\u043E\u0457)",
    temporaryAddressExpired: "(\u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0430)",
    lastDocumentScanDate: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
    documentExpiredWarning: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
    documentExpiredRentalWarning: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0431\u0443\u0432 \u0432\u0456\u0434\u0441\u043A\u0430\u043D\u043E\u0432\u0430\u043D\u0438\u0439 \u0431\u0456\u043B\u044C\u0448\u0435 180 \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442!",
    cashB2bTaxNumberRequired: "\u0414\u043B\u044F \u0433\u043E\u0442\u0456\u0432\u043A\u043E\u0432\u0438\u0445 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0439 \u0437 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0438\u043C\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C\u0438 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440!",
    paymentBypassEnabled: "\u0414\u043E\u0437\u0432\u043E\u043B\u0438\u0442\u0438 \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u043F\u0435\u0440\u0435\u043A\u0430\u0437 \u0431\u0435\u0437 \u043F\u043E\u0433\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u043A\u0430",
    paymentBypassDescription: "\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E: \u043F\u0430\u0440\u0442\u043D\u0435\u0440 \u043C\u043E\u0436\u0435 \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u043C \u043F\u0435\u0440\u0435\u043A\u0430\u0437\u043E\u043C \u0431\u0435\u0437 \u043E\u043A\u0440\u0435\u043C\u043E\u0433\u043E \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u043A\u0430.",
    paymentBypassReadonlyHint: "\u041C\u043E\u0436\u043D\u0430 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u043E\u0446\u0435\u0441 \u043F\u043E\u0433\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u043A\u043E\u043C.",
    fieldReadonlyHint: "\u0412\u043A\u0430\u0437\u0430\u043D\u043E \u043F\u0440\u0438 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u0456 \u2014 \u0442\u0443\u0442 \u043D\u0435 \u0440\u0435\u0434\u0430\u0433\u0443\u0454\u0442\u044C\u0441\u044F.",
    categoriesReadonlyHint: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u0432\u0438\u0437\u043D\u0430\u0447\u0430\u044E\u0442\u044C\u0441\u044F \u0442\u0438\u043F\u043E\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u2014 \u0442\u0443\u0442 \u043D\u0435 \u0440\u0435\u0434\u0430\u0433\u0443\u044E\u0442\u044C\u0441\u044F.",
    idVerified: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
    idVerifiedOn: "\u2705 \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E: {date}",
    costBearerTree: "\u0406\u0454\u0440\u0430\u0440\u0445\u0456\u044F \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0456\u0432",
    costBearerCompany: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F-\u043F\u043B\u0430\u0442\u043D\u0438\u043A",
    costBearerEmployees: "\u0421\u043F\u0456\u0432\u0440\u043E\u0431\u0456\u0442\u043D\u0438\u043A\u0438",
    compareTitle: "\u041F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
    partnerA: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0410 (\u0434\u0436\u0435\u0440\u0435\u043B\u043E)",
    partnerB: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0411 (\u0437\u0431\u0456\u0433)",
    compareDescription: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C, \u0443 \u044F\u043A\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043E\u0431'\u0454\u0434\u043D\u0430\u0442\u0438. \u041E\u0431'\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u043D\u043E\u0441\u0438\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u0438, \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438 \u0442\u0430 \u0440\u0430\u0445\u0443\u043D\u043A\u0438.",
    mergeIntoA: "\u041E\u0431'\u0454\u0434\u043D\u0430\u0442\u0438 \u0432 \u0410 \u2192",
    mergeIntoB: "\u2190 \u041E\u0431'\u0454\u0434\u043D\u0430\u0442\u0438 \u0432 \u0411",
    openInNewTab: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456 \u2192",
    tabRentals: "\u041E\u0440\u0435\u043D\u0434\u0438",
    tabService: "\u0421\u0435\u0440\u0432\u0456\u0441",
    tabInvoices: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
    tabLoyalty: "\u041B\u043E\u044F\u043B\u044C\u043D\u0456\u0441\u0442\u044C",
    transactionTabPlaceholder: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439...",
    loyaltyPoints: "\u0411\u0430\u043B\u0438 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456",
    depositExemption: "\u0417\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    depositRequired: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E",
    depositExempt: "\u0417\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043E",
    depositAutomatic: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E (TRUSTED)",
    depositRequiredDesc: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430 \u0434\u043B\u044F \u0432\u0441\u0456\u0445 \u043E\u0440\u0435\u043D\u0434",
    depositExemptDesc: "\u0417\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043E \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043E\u043C \u2014 0 \u0437\u0430\u0441\u0442\u0430\u0432\u0430",
    depositAutomaticDesc: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0437\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u043F\u0456\u0441\u043B\u044F 10 \u0443\u0441\u043F\u0456\u0448\u043D\u0438\u0445 \u043E\u0440\u0435\u043D\u0434",
    depositExemptionUpdated: "\u0417\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    depositExemptionError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0437\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    depositExemptionListRequired: "\u0414\u043B\u044F \u0437\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 \u043E\u0434\u0438\u043D \u0443\u043F\u043E\u0432\u043D\u043E\u0432\u0430\u0436\u0435\u043D\u0438\u0439 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A (\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A \u0430\u0431\u043E \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0456\u0441\u0442\u044C) \u2014 \u0441\u043F\u0435\u0440\u0448\u0443 \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0439\u043E\u0433\u043E.",
    depositExemptionRbacHint: "\u0417\u043C\u0456\u043D\u044E\u0432\u0430\u0442\u0438 \u043C\u043E\u0436\u0435 \u043B\u0438\u0448\u0435 \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u043A \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443",
    loyaltyTier: "\u0420\u0456\u0432\u0435\u043D\u044C",
    phones: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0438",
    phoneNumbers: "\u041D\u043E\u043C\u0435\u0440\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0456\u0432",
    addPhone: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    phoneLabel: "\u0422\u0438\u043F",
    phoneLabelPlaceholder: "\u043D\u0430\u043F\u0440. \u0421\u0435\u0440\u0432\u0456\u0441, \u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438...",
    phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    phoneLabelPrivate: "\u041F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0439",
    phoneLabelCompany: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
    phoneLabelFax: "\u0424\u0430\u043A\u0441",
    phoneLabelOther: "\u0406\u043D\u0448\u0435",
    phonePrimary: "\u041E\u0441\u043D\u043E\u0432\u043D\u0438\u0439",
    phoneMaxReached: "\u0414\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u043E \u043D\u0435 \u0431\u0456\u043B\u044C\u0448\u0435 5 \u043D\u043E\u043C\u0435\u0440\u0456\u0432 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    personalData: "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456",
    birthDate: "\u0414\u0430\u0442\u0430 \u043D\u0430\u0440\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
    birthPlace: "\u041C\u0456\u0441\u0446\u0435 \u043D\u0430\u0440\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
    mothersName: "\u0414\u0456\u0432\u043E\u0447\u0435 \u043F\u0440\u0456\u0437\u0432\u0438\u0449\u0435 \u043C\u0430\u0442\u0435\u0440\u0456",
    idCardNumber: "\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F",
    financialSettings: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    paymentTermDays: "\u0422\u0435\u0440\u043C\u0456\u043D \u043E\u043F\u043B\u0430\u0442\u0438 (\u0434\u043D\u0456\u0432)",
    creditLimitFt: "\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u0439 \u043B\u0456\u043C\u0456\u0442 (HUF)",
    discountPercent: "\u0417\u043D\u0438\u0436\u043A\u0430 %",
    rentalDepositPercent: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0437\u0430 \u043E\u0440\u0435\u043D\u0434\u0443 %",
    createPartner: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    notesPlaceholder: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438 \u043F\u0440\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430...",
    nameRequired: "\u0406\u043C'\u044F \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435!",
    categoryRequired: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u0443 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044E!",
    partnerCreated: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E!",
    partnerNotFound: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
    companyLabel: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
    individualLabel: "\u0424\u0456\u0437\u0438\u0447\u043D\u0430 \u043E\u0441\u043E\u0431\u0430",
    tabOverview: "\u041E\u0433\u043B\u044F\u0434",
    tabAddresses: "\u0410\u0434\u0440\u0435\u0441\u0438",
    tabContacts: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438",
    tabRepresentatives: "\u0423\u043F\u043E\u0432\u043D\u043E\u0432\u0430\u0436\u0435\u043D\u0456",
    tabFinancial: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
    tabHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F",
    statistics: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
    totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0431\u043E\u0440\u043E\u0442:",
    ordersCount: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F:",
    rentalsCount: "\u041E\u0440\u0435\u043D\u0434\u0438:",
    serviceOrdersCount: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F:",
    lastOrder: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F:",
    lastRental: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0430:",
    debt: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C:",
    rentalSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    depositPercent: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 %:",
    rentalStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043E\u0440\u0435\u043D\u0434\u0438:",
    blocked: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
    allowed: "\u0414\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u043E",
    newAddress: "\u041D\u043E\u0432\u0430 \u0430\u0434\u0440\u0435\u0441\u0430",
    noAddresses: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u0430\u0434\u0440\u0435\u0441.",
    newContact: "\u041D\u043E\u0432\u0438\u0439 \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    noContacts: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0456\u0432.",
    primary: "\u041E\u0441\u043D\u043E\u0432\u043D\u0438\u0439",
    defaultAddress: "\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
    addressBilling: "\u0414\u043B\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    addressShipping: "\u0414\u043B\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
    addressOther: "\u0406\u043D\u0448\u0430",
    suspend: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438",
    unsuspend: "\u0417\u043D\u044F\u0442\u0438 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F",
    suspended: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043E",
    unsuspended: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F \u0437\u043D\u044F\u0442\u043E",
    suspendConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430: {name}?",
    unsuspendConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0437\u043D\u044F\u0442\u0438 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430?",
    suspendError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u0456",
    unsuspendError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u043D\u044F\u0442\u0442\u0456 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F",
    suspendedBanner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043E",
    suspendedBannerDesc: "\u0426\u044C\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438 \u0437 \u043E\u043F\u043B\u0430\u0442\u043E\u044E. \u041E\u0440\u0435\u043D\u0434\u0430 \u0442\u0430 \u043F\u0440\u0438\u0439\u043E\u043C \u043D\u043E\u0432\u0438\u0445 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u044C \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u0456.",
    rentalBlockedNote: "\u041E\u0440\u0435\u043D\u0434\u0430 \u0437\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u0430 \u2014 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0437\u043D\u044F\u0442\u0438 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F.",
    blockedRentalTooltip: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u0438\u0439 \u2014 \u043E\u0440\u0435\u043D\u0434\u0430 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u0430",
    newRental: "\u041D\u043E\u0432\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
    newSale: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0434\u0430\u0436",
    newWorksheet: "\u041D\u043E\u0432\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    publicNote: "\u041F\u0443\u0431\u043B\u0456\u0447\u043D\u0430 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    internalNote: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044F \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    outstandingDebt: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C: {amount}",
    contactSupport: "\u0417\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0441\u043B\u0443\u0436\u0431\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438.",
    noOutstandingDebt: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E\u0457 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456.",
    paymentTerm: "\u0422\u0435\u0440\u043C\u0456\u043D \u043E\u043F\u043B\u0430\u0442\u0438",
    creditLimit: "\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u0439 \u043B\u0456\u043C\u0456\u0442",
    baseDiscount: "\u0411\u0430\u0437\u043E\u0432\u0430 \u0437\u043D\u0438\u0436\u043A\u0430",
    priceList: "\u041F\u0440\u0430\u0439\u0441-\u043B\u0438\u0441\u0442",
    debtsTitle: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456",
    partnerUpdated: "\u0414\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    partnerCreatedBy: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E ({user})",
    nDays: "{count} \u0434\u043D\u0456\u0432",
    defaultPriceList: "\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
    noneValue: "\u041D\u0435\u043C\u0430\u0454",
    categoryLabels: {
      retail: "\u0420\u043E\u0437\u0434\u0440\u0456\u0431\u043D\u0438\u0439 \u043F\u043E\u043A\u0443\u043F\u0435\u0446\u044C",
      wholesale: "\u041E\u043F\u0442\u043E\u0432\u0438\u0439 \u043F\u043E\u043A\u0443\u043F\u0435\u0446\u044C",
      renter: "\u041E\u0440\u0435\u043D\u0434\u0430\u0440",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
      subcontractor: "\u0421\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A"
    },
    typeLabels: {
      individual: "\u0424\u0456\u0437\u0438\u0447\u043D\u0430 \u043E\u0441\u043E\u0431\u0430",
      company: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F"
    },
    idCard: "\u041F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F \u043E\u0441\u043E\u0431\u0438",
    drivingLicense: "\u0412\u043E\u0434\u0456\u0439\u0441\u044C\u043A\u0435 \u043F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F",
    passport: "\u041F\u0430\u0441\u043F\u043E\u0440\u0442",
    duplicateSuspects: "\u041F\u0456\u0434\u043E\u0437\u0440\u0438 \u043D\u0430 \u0434\u0443\u0431\u043B\u0456\u043A\u0430\u0442\u0438",
    abandonedEquipment: "60-\u0434\u0435\u043D\u043D\u0435 \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    editTitle: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {error}",
    saveFailed: "\u041F\u0456\u0434 \u0447\u0430\u0441 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    confidence: "\u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456\u0441\u0442\u044C",
    detected: "\u0412\u0438\u044F\u0432\u043B\u0435\u043D\u043E",
    mergeButton: "\u041E\u0431'\u0454\u0434\u043D\u0430\u0442\u0438",
    dismissButton: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
    noDuplicates: "\u041D\u0435\u043C\u0430\u0454 \u043D\u0435\u0432\u0438\u0440\u0456\u0448\u0435\u043D\u0438\u0445 \u0434\u0443\u0431\u043B\u0456\u043A\u0430\u0442\u0456\u0432.",
    worksheetLabel: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    noAbandonedEquipment: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u0449\u043E \u043E\u0447\u0456\u043A\u0443\u0454 \u0440\u0456\u0448\u0435\u043D\u043D\u044F.",
    scrapButton: "\u0421\u043F\u0438\u0441\u0430\u0442\u0438",
    sellButton: "\u041F\u0440\u043E\u0434\u0430\u0442\u0438",
    keepButton: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
    namePlaceholderCompany: "\u041F\u0440\u0438\u043A\u043B\u0430\u0434 \u0422\u041E\u0412",
    namePlaceholderIndividual: "\u0406\u0432\u0430\u043D \u041A\u043E\u0432\u0430\u043B\u0435\u043D\u043A\u043E",
    shortNamePlaceholder: "\u041F\u0440\u0438\u043A\u043B\u0430\u0434",
    streetPlaceholder: "\u0432\u0443\u043B. \u0413\u043E\u043B\u043E\u0432\u043D\u0430 35",
    category: {
      retail: "\u0420\u043E\u0437\u0434\u0440\u0456\u0431\u043D\u0438\u0439 \u043F\u043E\u043A\u0443\u043F\u0435\u0446\u044C",
      wholesale: "\u041E\u043F\u0442\u043E\u0432\u0438\u0439 \u043F\u043E\u043A\u0443\u043F\u0435\u0446\u044C",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430\u0440",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
      contractor: "\u0421\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A"
    },
    status: {
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      blocked: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
      trusted: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0438\u0439 \u043A\u043B\u0456\u0454\u043D\u0442",
      warning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F"
    },
    type: {
      individual: "\u0424\u0456\u0437\u0438\u0447\u043D\u0430 \u043E\u0441\u043E\u0431\u0430",
      company: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F"
    },
    createSuccess: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E!\n\u041A\u043E\u0434: {code}\n\u0406\u043C'\u044F: {name}",
    placeholder: {
      address: "\u0432\u0443\u043B. \u0425\u0440\u0435\u0449\u0430\u0442\u0438\u043A 35",
      city: "\u041A\u0438\u0457\u0432",
      companyName: "\u041F\u0440\u0438\u043A\u043B\u0430\u0434 \u0422\u041E\u0412",
      email: "info@example.ua",
      lastName: "\u041F\u0440\u0438\u043A\u043B\u0430\u0434",
      personName: "\u0406\u0432\u0430\u043D \u041F\u0435\u0442\u0440\u0435\u043D\u043A\u043E",
      website: "https://example.ua",
      birthPlace: "\u043D\u0430\u043F\u0440. \u041A\u0438\u0457\u0432",
      mothersName: "\u043D\u0430\u043F\u0440. \u041C\u0430\u0440\u0456\u044F \u041F\u0435\u0442\u0440\u0435\u043D\u043A\u043E",
      temporaryAddress: "\u043D\u0430\u043F\u0440. 01001 \u041A\u0438\u0457\u0432, \u0432\u0443\u043B. \u0425\u0440\u0435\u0449\u0430\u0442\u0438\u043A 1",
      idCardNumber: "\u043D\u0430\u043F\u0440. 123456\u0410\u0411"
    },
    contractPrices: {
      title: "\u041A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u043D\u0456 \u0446\u0456\u043D\u0438"
    },
    discount: {
      categorized: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0437\u043E\u0432\u0430\u043D\u0430 \u0437\u043D\u0438\u0436\u043A\u0430",
      max: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430 \u0437\u043D\u0438\u0436\u043A\u0430",
      noStacking: "\u0417\u043D\u0438\u0436\u043A\u0438 \u043D\u0435 \u0441\u0443\u043C\u0443\u044E\u0442\u044C\u0441\u044F",
      rental: "\u0417\u043D\u0438\u0436\u043A\u0430 \u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0443",
      sales: "\u0417\u043D\u0438\u0436\u043A\u0430 \u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436",
      service: "\u0417\u043D\u0438\u0436\u043A\u0430 \u043D\u0430 \u0441\u0435\u0440\u0432\u0456\u0441"
    },
    displayedCount: "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E: {count}",
    quickCreate: {
      title: "\u0428\u0432\u0438\u0434\u043A\u0435 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      typeLabel: "\u0422\u0438\u043F",
      individual: "\u0424\u0456\u0437\u0438\u0447\u043D\u0430 \u043E\u0441\u043E\u0431\u0430",
      company: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
      nameLabel: "\u0406\u043C'\u044F *",
      namePlaceholder: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      taxNumberLabel: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
      taxNumberPlaceholder: "12345678-1-42",
      emailLabel: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
      emailPlaceholder: "email@priklad.ua",
      phoneLabel: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      phonePlaceholder: "+36 30 123 4567",
      cityLabel: "\u041C\u0456\u0441\u0442\u043E",
      cityPlaceholder: "\u0411\u0443\u0434\u0430\u043F\u0435\u0448\u0442",
      submit: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      success: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E: {name}",
      error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430: {message}",
      taxNumberHint: "\u0411\u0435\u0437 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u0438\u043C",
      duplicateWarning: "\u0421\u0445\u043E\u0436\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454:",
      notFound: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E? \u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C\u0435\u043D\u0435\u043C, email, \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u043C, \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u043C \u043D\u043E\u043C\u0435\u0440\u043E\u043C, \u043C\u0456\u0441\u0442\u043E\u043C..."
    },
    sanctions: {
      title: "\u0421\u0430\u043D\u043A\u0446\u0456\u0457",
      transferBan: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437 \u0437\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
      transferBanThreeMonth: "3-\u043C\u0456\u0441\u044F\u0447\u043D\u0435 \u0431\u043B\u043E\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
      transferBanSixMonth: "6-\u043C\u0456\u0441\u044F\u0447\u043D\u0435 \u0431\u043B\u043E\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
      transferBanPermanent: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0435 \u0431\u043B\u043E\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
      transferBanNone: "\u041D\u0435\u043C\u0430\u0454 \u0431\u043B\u043E\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
      banUntil: "\u0411\u043B\u043E\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E: {date}",
      strikeCount: "\u0412\u0438\u043F\u0430\u0434\u043A\u0438 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F: {count}",
      walkInOnly: "\u0422\u0456\u043B\u044C\u043A\u0438 Walk-in",
      walkInOnlyUntil: "\u041E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F Walk-in \u0434\u043E: {date}",
      bookingWarning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
      cancelledCount: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u0456 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F: {count}",
      noShowCount: "\u041D\u0435\u044F\u0432\u043A\u0438: {count}",
      override: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438",
      overrideTitle: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0441\u0430\u043D\u043A\u0446\u0456\u0457",
      overrideReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 *",
      overrideReasonPlaceholder: "\u0427\u043E\u043C\u0443 \u0432\u0438 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0430\u0454\u0442\u0435 \u0446\u044E \u0441\u0430\u043D\u043A\u0446\u0456\u044E?",
      overrideConfirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      overrideSuccess: "\u0421\u0430\u043D\u043A\u0446\u0456\u044E \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
      overrideBy: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0438\u0432: {user}",
      overrideAt: "\u0414\u0430\u0442\u0430 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F: {date}",
      discountsRevoked: "\u0417\u043D\u0438\u0436\u043A\u0438 \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u0456",
      amnestyExpires: "\u0410\u043C\u043D\u0456\u0441\u0442\u0456\u044F \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F: {date}"
    },
    segment: {
      title: "\u0421\u0435\u0433\u043C\u0435\u043D\u0442 \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
      vip: "VIP",
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      atRisk: "\u041F\u0456\u0434 \u0437\u0430\u0433\u0440\u043E\u0437\u043E\u044E",
      inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      calculatedAt: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A: {date}",
      changedAt: "\u0417\u043C\u0456\u043D\u0430 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u0443: {date}",
      distribution: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u0456\u0432",
      partnerCount: "{count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432"
    },
    suggestions: {
      title: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      crossSell: "{category} \u2014 {count} \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456",
      noSuggestions: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      calculating: "\u0421\u0435\u0433\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0432\u0438\u043A\u043E\u043D\u0443\u0454\u0442\u044C\u0441\u044F..."
    },
    kpi: {
      lifetimeValue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0431\u043E\u0440\u043E\u0442",
      outstandingBalance: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
      totalRentals: "\u0423\u0441\u044C\u043E\u0433\u043E \u043E\u0440\u0435\u043D\u0434"
    },
    timeline: {
      title: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
      quickAddNote: "\u041D\u043E\u0442\u0430\u0442\u043A\u0430",
      loadMore: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0449\u0435",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
      empty: "\u041F\u043E\u0434\u0456\u0439 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454 \u2014 \u0441\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u043F\u0435\u0440\u0448\u0443 \u043D\u043E\u0442\u0430\u0442\u043A\u0443 \u043A\u043D\u043E\u043F\u043A\u043E\u044E \xAB\u041D\u043E\u0442\u0430\u0442\u043A\u0430\xBB.",
      expand: "\u0414\u0435\u0442\u0430\u043B\u0456",
      collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
      filterLabel: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0442\u0438\u043F\u0456\u0432",
      types: {
        TASK: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        INVOICE: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A",
        QUOTE: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F",
        DELIVERY_NOTE: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0430",
        RENTAL: "\u041E\u0440\u0435\u043D\u0434\u0430",
        WORKSHEET: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
        LOYALTY: "\u041B\u043E\u044F\u043B\u044C\u043D\u0456\u0441\u0442\u044C",
        TASK_NOTE: "\u041D\u043E\u0442\u0430\u0442\u043A\u0430",
        TASK_CALL: "\u0414\u0437\u0432\u0456\u043D\u043E\u043A"
      },
      quickAddDialog: {
        title: "\u0428\u0432\u0438\u0434\u043A\u0430 \u043D\u043E\u0442\u0430\u0442\u043A\u0430",
        description: "\u0417\u0430\u043F\u0438\u0441 \u043D\u043E\u0442\u0430\u0442\u043A\u0438 \u0447\u0438 \u0434\u0437\u0432\u0456\u043D\u043A\u0430 \u043D\u0430 \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u0457 \u043A\u043B\u0456\u0454\u043D\u0442\u0430.",
        typeLabel: "\u0422\u0438\u043F",
        titleLabel: "\u041D\u0430\u0437\u0432\u0430",
        titlePlaceholder: "\u041A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u043E\u043F\u0438\u0441",
        descriptionLabel: "\u0414\u0435\u0442\u0430\u043B\u0456",
        descriptionPlaceholder: "\u041E\u043F\u0446\u0456\u0439\u043D\u0438\u0439 \u0440\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0438\u0439 \u043E\u043F\u0438\u0441",
        submit: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438"
      },
      metaLabels: {
        dueDate: "\u0422\u0435\u0440\u043C\u0456\u043D",
        completedAt: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        priority: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        issueDate: "\u0414\u0430\u0442\u0430 \u0432\u0438\u0434\u0430\u0447\u0456",
        paidAmount: "\u0421\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        balanceDue: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A",
        currency: "\u0412\u0430\u043B\u044E\u0442\u0430",
        paymentMethod: "\u0421\u043F\u043E\u0441\u0456\u0431 \u043E\u043F\u043B\u0430\u0442\u0438",
        paidAt: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        navStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 NAV",
        validUntil: "\u0414\u0456\u0439\u0441\u043D\u043E \u0434\u043E",
        sentAt: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        acceptedAt: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
        rejectedAt: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        invoiceId: "ID \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
        settledManually: "\u0420\u0443\u0447\u043D\u0435 \u0432\u0440\u0435\u0433\u0443\u043B\u044E\u0432\u0430\u043D\u043D\u044F",
        startDate: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A \u043E\u0440\u0435\u043D\u0434\u0438",
        expectedEnd: "\u041E\u0447\u0456\u043A. \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        actualEnd: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0438\u0439 \u043A\u0456\u043D\u0435\u0446\u044C",
        returnedAt: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043E",
        depositRequired: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 (\u043F\u043E\u0442\u0440.)",
        depositPaid: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 (\u0441\u043F\u043B\u0430\u0447.)",
        depositReturned: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 (\u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E)",
        itemCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
        equipment: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        serialNumber: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
        receivedAt: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
        deliveredAt: "\u0412\u0438\u0434\u0430\u043D\u043E",
        isWarranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
        transactionCount: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
        totalSpend: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0431\u043E\u0440\u043E\u0442"
      }
    },
    tabAuthorizationGrants: "\u0414\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
    roleToggle: {
      customerLabel: "\u041A\u041B\u0406\u0404\u041D\u0422",
      supplierLabel: "\u041F\u041E\u0421\u0422\u0410\u0427\u0410\u041B\u042C\u041D\u0418\u041A",
      addCustomer: "+ \u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u043E\u043B\u044C \u041A\u041B\u0406\u0404\u041D\u0422",
      addSupplier: "+ \u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u043E\u043B\u044C \u041F\u041E\u0421\u0422\u0410\u0427\u0410\u041B\u042C\u041D\u0418\u041A",
      removeAria: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0440\u043E\u043B\u044C",
      confirmAddTitle: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u043E\u043B\u044C",
      confirmRemoveTitle: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0440\u043E\u043B\u044C",
      confirmAddText: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u043E\u043B\u044C {role} \u0434\u043E \u0446\u044C\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430?",
      confirmRemoveText: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0440\u043E\u043B\u044C {role} \u0437 \u0446\u044C\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430?",
      notYetWired: "\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u043D\u043D\u044F \u0440\u043E\u043B\u0456 \u0449\u0435 \u043D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u2014 \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C (\u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F STORY-1212)."
    },
    receiverData: "\u0414\u0430\u043D\u0456 \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430 (\u0444\u0456\u0437\u0438\u0447\u043D\u0430 \u043E\u0441\u043E\u0431\u0430)",
    intent: {
      title: "\u0429\u043E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043A\u043B\u0456\u0454\u043D\u0442\u0443?",
      hint: "\u0412\u0438\u0431\u0456\u0440 \u0432\u0438\u0437\u043D\u0430\u0447\u0430\u0454, \u044F\u043A\u0456 \u0434\u0430\u043D\u0456 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0456. \u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E, \u0456 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u043D\u0456\u043A\u043E\u043B\u0438 \u043D\u0435 \u0431\u043B\u043E\u043A\u0443\u0454\u0442\u044C\u0441\u044F.",
      purchase: "\u041A\u0443\u043F\u0456\u0432\u043B\u044F",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441"
    },
    requiredMissing: {
      title: "\u0414\u0430\u043D\u0456, \u044F\u043A\u0438\u0445 \u0431\u0440\u0430\u043A\u0443\u0454 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0442\u0438\u043F\u0443 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
      hint: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u043D\u0435 \u0431\u043B\u043E\u043A\u0443\u0454\u0442\u044C\u0441\u044F \u2014 \u043C\u043E\u0436\u043D\u0430 \u0434\u043E\u043F\u043E\u0432\u043D\u0438\u0442\u0438 \u043F\u0456\u0437\u043D\u0456\u0448\u0435."
    },
    field: {
      name: "\u0406\u043C'\u044F",
      phone: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
      email: "\u0410\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
      address: "\u0410\u0434\u0440\u0435\u0441\u0430 / \u043C\u0456\u0441\u0446\u0435\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      idCard: "\u041F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F \u043E\u0441\u043E\u0431\u0438",
      addressCard: "\u041A\u0430\u0440\u0442\u043A\u0430 \u0430\u0434\u0440\u0435\u0441\u0438",
      birthData: "\u0414\u0430\u043D\u0456 \u043F\u0440\u043E \u043D\u0430\u0440\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      mothersName: "\u0406\u043C'\u044F \u043C\u0430\u0442\u0435\u0440\u0456",
      taxNumber: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
      representative: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A / \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447"
    },
    receiverHint: "\u0414\u0430\u043D\u0456 \u0444\u0456\u0437\u0438\u0447\u043D\u043E\u0457 \u043E\u0441\u043E\u0431\u0438-\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430 \u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u0456 \u0434\u043B\u044F \u0432\u0438\u0434\u0430\u0447\u0456 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u2014 \u043D\u0435 \u043F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0439\u0442\u0435.",
    companyDataSecondary: "\u0414\u0430\u043D\u0456 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457 (\u043F\u043B\u0430\u0442\u043D\u0438\u043A)",
    mothersNameRequired: "\u0414\u0456\u0432\u043E\u0447\u0435 \u043F\u0440\u0456\u0437\u0432\u0438\u0449\u0435 \u043C\u0430\u0442\u0435\u0440\u0456 \u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u0435 (\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447)!",
    idCardRequired: "\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F \u043E\u0441\u043E\u0431\u0438 \u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u0438\u0439 (\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447)!",
    idCardExpiry: "\u0422\u0435\u0440\u043C\u0456\u043D \u0434\u0456\u0457 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
    idCardCurrentMasked: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 (\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u0439): {masked} \u2014 \u0437\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u044F\u043A\u0449\u043E \u0431\u0435\u0437 \u0437\u043C\u0456\u043D",
    duplicate: {
      warning: "\u0421\u0445\u043E\u0436\u0438\u0439 \u043A\u043B\u0456\u0454\u043D\u0442 \u0443\u0436\u0435 \u043C\u043E\u0436\u0435 \u0456\u0441\u043D\u0443\u0432\u0430\u0442\u0438 \u2014 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u043F\u0438\u0441\u043E\u043A."
    },
    saveAndNew: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0456 \u043D\u043E\u0432\u0438\u0439",
    saveAndNewSuccess: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E \u2014 \u0444\u043E\u0440\u043C\u0443 \u043E\u0447\u0438\u0449\u0435\u043D\u043E \u0434\u043B\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
    saveHint: "\u041F\u0456\u0434\u043A\u0430\u0437\u043A\u0430: Ctrl+Enter \u0434\u043B\u044F \u0448\u0432\u0438\u0434\u043A\u043E\u0433\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
    searchFilter: {
      typeAll: "\u0423\u0441\u0456",
      typeIndividual: "\u0424\u0456\u0437\u0438\u0447\u043D\u0430 \u043E\u0441\u043E\u0431\u0430",
      typeCompany: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
      availableOnly: "\u041B\u0438\u0448\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456",
      ariaLabel: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
      recentTitle: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438"
    },
    representative: {
      title: "\u0414\u043E\u0432\u0456\u0440\u0435\u043D\u0456 \u043E\u0441\u043E\u0431\u0438",
      add: "\u0414\u043E\u0434\u0430\u0442\u0438",
      name: "\u0406\u043C'\u044F",
      phone: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      email: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
      idNumber: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
      validFrom: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0437",
      validUntil: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0434\u043E",
      unlimited: "\u043D\u0435\u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043E",
      permissions: "\u041F\u0440\u0430\u0432\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0443",
      canRent: "\u041C\u043E\u0436\u0435 \u043E\u0440\u0435\u043D\u0434\u0443\u0432\u0430\u0442\u0438",
      canReturn: "\u041C\u043E\u0436\u0435 \u043F\u043E\u0432\u0435\u0440\u0442\u0430\u0442\u0438",
      canSign: "\u041C\u043E\u0436\u0435 \u043F\u0456\u0434\u043F\u0438\u0441\u0443\u0432\u0430\u0442\u0438",
      canPayCash: "\u041C\u043E\u0436\u0435 \u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0433\u043E\u0442\u0456\u0432\u043A\u043E\u044E",
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      expired: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
      expiringSoon: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F",
      activate: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
      deactivate: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
      confirmDelete: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u044E \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0443 \u043E\u0441\u043E\u0431\u0443?",
      noRepresentatives: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0432\u0456\u0440\u0435\u043D\u0438\u0445 \u043E\u0441\u0456\u0431",
      notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430"
    },
    selectSettlement: "\u041A\u0456\u043B\u044C\u043A\u0430 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0445 \u043F\u0443\u043D\u043A\u0442\u0456\u0432 \u043C\u0430\u044E\u0442\u044C \u0446\u0435\u0439 \u043F\u043E\u0448\u0442\u043E\u0432\u0438\u0439 \u0456\u043D\u0434\u0435\u043A\u0441 \u2014 \u043E\u0431\u0435\u0440\u0456\u0442\u044C:"
  },
  pos: {
    customerPanel: {
      title: "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F \u043F\u0440\u043E \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
      noCustomer: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443 \u0437\u043D\u0438\u0436\u043E\u043A",
      discounts: "\u0417\u043D\u0438\u0436\u043A\u0438",
      discountRental: "\u041E\u0440\u0435\u043D\u0434\u0430: {percent}%",
      discountSales: "\u041F\u0440\u043E\u0434\u0430\u0436: {percent}%",
      discountService: "\u0421\u0435\u0440\u0432\u0456\u0441: {percent}%",
      balance: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
      balanceAmount: "{amount} Ft",
      creditLimit: "\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u0439 \u043B\u0456\u043C\u0456\u0442: {amount} Ft",
      depositExempt: "\u0417\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
      recentTransactions: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
      noTransactions: "\u041D\u0435\u043C\u0430\u0454 \u0456\u0441\u0442\u043E\u0440\u0456\u0457",
      viewDetails: "\u0414\u0435\u0442\u0430\u043B\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430"
    },
    suggestions: {
      winBack: "\u041D\u0435 \u043E\u0440\u0435\u043D\u0434\u0443\u0432\u0430\u0432 {days} \u0434\u043D\u0456\u0432 \u2014 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F \u0437\u043D\u0438\u0436\u043A\u0438 10%",
      winBackApply: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
      inactiveNote: "\u041A\u043E\u043B\u0438\u0448\u043D\u0456\u0439 \u043A\u043B\u0456\u0454\u043D\u0442 \u2014 \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 6+ \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
      crossSellTitle: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0456 \u0442\u043E\u0432\u0430\u0440\u0438",
      crossSellItem: "{name} \u2014 {count} \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456",
      addToCart: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430"
    }
  },
  loyalty: {
    title: "VIP \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0430 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456",
    partnerId: "ID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    pointBalance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0431\u0430\u043B\u0456\u0432",
    points: "{count} \u0431\u0430\u043B\u0456\u0432",
    trustedStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0434\u043E\u0432\u0456\u0440\u0438",
    consecutiveClean: "{count} \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0438\u0445 \u0447\u0438\u0441\u0442\u0438\u0445 \u043E\u0440\u0435\u043D\u0434",
    deposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    creditPoints: "\u041D\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438 \u0431\u0430\u043B\u0438",
    amountFt: "\u0421\u0443\u043C\u0430 (Ft)",
    rentalNumber: "\u041D\u043E\u043C\u0435\u0440 \u043E\u0440\u0435\u043D\u0434\u0438",
    creditNote: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
    creditButton: "\u041D\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438 \u0431\u0430\u043B\u0438",
    crediting: "\u041D\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F...",
    calculationNote: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A: floor(\u0441\u0443\u043C\u0430 / 10 000). \u0414\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u0438: \u0442\u0456\u043B\u044C\u043A\u0438 \u0437 11-\u0457 \u043E\u0440\u0435\u043D\u0434\u0438.",
    redeemableRewards: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0438",
    redeem: "\u041E\u0431\u043C\u0456\u043D\u044F\u0442\u0438",
    pointHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0431\u0430\u043B\u0456\u0432 ({count} \u0437\u0430\u043F\u0438\u0441\u0456\u0432)",
    noPointRecords: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 \u043F\u0440\u043E \u0431\u0430\u043B\u0438.",
    expiresAt: "\u0414\u0456\u0454 \u0434\u043E: {date}",
    sourceLabels: {
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      purchase: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430",
      bonus: "\u0411\u043E\u043D\u0443\u0441",
      redemption: "\u041E\u0431\u043C\u0456\u043D",
      expiry: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F"
    },
    depositRequired: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0430",
    depositFree: "\u0411\u0435\u0437 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    creditAmount: "\u0421\u0443\u043C\u0430 (HUF)",
    rewardLabel: "\u0412\u0438\u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0430",
    trusted: "\u041D\u0430\u0434\u0456\u0439\u043D\u0438\u0439",
    notTrusted: "\u041D\u0435\u043D\u0430\u0434\u0456\u0439\u043D\u0438\u0439",
    consecutiveCleanRentals: "{count} \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0438\u0445 \u0447\u0438\u0441\u0442\u0438\u0445 \u043E\u0440\u0435\u043D\u0434",
    depositTitle: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    searchButton: "\u041F\u043E\u0448\u0443\u043A",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    amountPlaceholder: "\u0421\u0443\u043C\u0430 (HUF)",
    rentalCountPlaceholder: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043E\u0440\u0435\u043D\u0434",
    notePlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    calculationInfo: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0431\u0430\u043B\u0456\u0432: floor(\u0441\u0443\u043C\u0430 / 10 000). \u0414\u043B\u044F \u043E\u0440\u0435\u043D\u0434: \u043B\u0438\u0448\u0435 \u0437 11-\u0457 \u043E\u0440\u0435\u043D\u0434\u0438.",
    redeemButton: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0442\u0438",
    expiresLabel: "\u0417\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F",
    sourceLabelsObj: {
      RENTAL: "\u041E\u0440\u0435\u043D\u0434\u0430",
      PURCHASE: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430",
      BONUS: "\u0411\u043E\u043D\u0443\u0441",
      REDEMPTION: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F",
      EXPIRY: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
      SALES: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
      SERVICE: "\u0421\u0435\u0440\u0432\u0456\u0441"
    }
  },
  finance: {
    title: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
    journalTitle: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430 \u043A\u043D\u0438\u0433\u0430 (\u0436\u0443\u0440\u043D\u0430\u043B)",
    journalSubtitle: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u044C\u043A\u0456 \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0438 (\u043F\u043E\u0434\u0432\u0456\u0439\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441)",
    journalSourceFilter: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0434\u0436\u0435\u0440\u0435\u043B\u0430",
    journalSourceAll: "\u0423\u0441\u0456",
    journalSourceInvoice: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A",
    journalSourceSale: "\u041F\u0440\u043E\u0434\u0430\u0436",
    journalSourceRentalDeposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    journalSourceRentalDepositRefund: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    journalSourceRentalDepositForfeit: "\u0423\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    journalColEntryNumber: "\u041D\u043E\u043C\u0435\u0440 \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0438",
    journalColDate: "\u0414\u0430\u0442\u0430",
    journalColDescription: "\u041E\u043F\u0438\u0441",
    journalColSource: "\u0414\u0436\u0435\u0440\u0435\u043B\u043E",
    journalColDebit: "\u0414\u0435\u0431\u0435\u0442",
    journalColCredit: "\u041A\u0440\u0435\u0434\u0438\u0442",
    journalColAccount: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A",
    journalUnbalanced: "\u041D\u0435 \u0437\u0431\u0430\u043B\u0430\u043D\u0441\u043E\u0432\u0430\u043D\u043E",
    journalEmpty: "\u041D\u0435\u043C\u0430\u0454 \u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u044C\u043A\u0438\u0445 \u043F\u0440\u043E\u0432\u043E\u0434\u043E\u043A \u0437\u0430 \u043E\u0431\u0440\u0430\u043D\u0438\u0439 \u043F\u0435\u0440\u0456\u043E\u0434",
    journalEntryCount: "{count} \u043F\u0440\u043E\u0432\u043E\u0434\u043E\u043A",
    cashRegister: "\u041A\u0430\u0441\u0430",
    cash: {
      noTransactions: "\u041D\u0435\u043C\u0430\u0454 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439 \u0437\u0430 \u0446\u0435\u0439 \u0434\u0435\u043D\u044C / \u0444\u0456\u043B\u044C\u0442\u0440."
    },
    dailyClose: "\u0414\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    szhFolder: "\u041F\u0430\u043F\u043A\u0430 \u0421\u0417\u0413",
    vouchers: "\u0412\u0430\u0443\u0447\u0435\u0440\u0438",
    fixedAssets: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    szh: {
      label: "\u0421\u0417\u0413",
      activity: "\u0414\u0456\u044F\u043B\u044C\u043D\u0456\u0441\u0442\u044C",
      amountFt: "\u0421\u0443\u043C\u0430 (Ft)",
      anonymous: "\u0410\u043D\u043E\u043D\u0456\u043C\u043D\u0438\u0439",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
      confirmBody: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u0421\u0417\u0413?",
      confirmTitle: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457 \u0421\u0417\u0413",
      creditIssuance: "\u0412\u0438\u0434\u0430\u0447\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0443",
      expectedRevenue: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      expectedSettlement: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      generateReport: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0437\u0432\u0456\u0442",
      generating: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F...",
      internalNote: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044F \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
      internalNoteRequired: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044F \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
      issue: "\u0412\u0438\u0434\u0430\u0447\u0430",
      items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457",
      loadError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
      lossReserve: "\u0420\u0435\u0437\u0435\u0440\u0432 \u0437\u0431\u0438\u0442\u043A\u0456\u0432",
      noItems: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      partnerName: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      repayment: "\u041F\u043E\u0433\u0430\u0448\u0435\u043D\u043D\u044F",
      reversal: "\u0421\u0442\u043E\u0440\u043D\u0443\u0432\u0430\u043D\u043D\u044F"
    },
    receivables: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    deposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    noRegisterOpen: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043A\u0430\u0441\u0430 \u043D\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0430.",
    openRegister: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043A\u0430\u0441\u0443",
    opening: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F...",
    szhFolderButton: "\u041F\u0430\u043F\u043A\u0430 \u0421\u0417\u0413",
    blindCloseButton: "\u0421\u043B\u0456\u043F\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    totalBalance: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
    recordTransaction: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E",
    income: "\u0414\u043E\u0445\u0456\u0434",
    expense: "\u0412\u0438\u0442\u0440\u0430\u0442\u0430",
    expenseSummaryTitle: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0432\u0438\u0442\u0440\u0430\u0442",
    expenseCategory: {
      label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F \u0432\u0438\u0442\u0440\u0430\u0442",
      none: "\u0411\u0435\u0437 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
      salary: "\u0417\u0430\u0440\u043F\u043B\u0430\u0442\u0430",
      supplierPayment: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0443",
      office: "\u041E\u0444\u0456\u0441",
      transport: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 / \u041F\u043E\u0434\u043E\u0440\u043E\u0436\u0456",
      marketing: "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
      other: "\u0406\u043D\u0448\u0435"
    },
    amountPlaceholder: "\u0421\u0443\u043C\u0430 (HUF)",
    notePlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    record: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438",
    recordError: {
      conflictTitle: "\u041A\u0430\u0441\u0430 \u0442\u0438\u043C \u0447\u0430\u0441\u043E\u043C \u0437\u043C\u0456\u043D\u0438\u043B\u0430\u0441\u044F",
      conflictBody: "\u0425\u0442\u043E\u0441\u044C \u0456\u043D\u0448\u0438\u0439 \u0437\u0430\u043F\u0438\u0441\u0430\u0432 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u0432 \u0446\u0456\u0439 \u043A\u0430\u0441\u0456. \u041E\u043D\u043E\u0432\u0438 \u0441\u043F\u0438\u0441\u043E\u043A \u0456 \u043F\u0435\u0440\u0435\u0432\u0456\u0440, \u0449\u043E \u0441\u0442\u0430\u043B\u043E\u0441\u044F \u2014 \u0432\u0432\u0435\u0434\u0435\u043D\u0456 \u0434\u0430\u043D\u0456 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E.",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      amountInvalid: "\u0426\u044E \u0441\u0443\u043C\u0443 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0442\u0430\u043A\u0438\u043C \u0447\u0438\u043D\u043E\u043C. \u041F\u0435\u0440\u0435\u0432\u0456\u0440 \u0456 \u0432\u0432\u0435\u0434\u0438 \u0449\u0435 \u0440\u0430\u0437.",
      noteInvalid: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0443 \u0442\u0430 \u0432\u0432\u0435\u0434\u0438 \u0457\u0457 \u0449\u0435 \u0440\u0430\u0437.",
      validation: "\u041E\u0434\u043D\u0435 \u0437\u0456 \u0437\u043D\u0430\u0447\u0435\u043D\u044C \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0442\u0430\u043A\u0438\u043C \u0447\u0438\u043D\u043E\u043C. \u041F\u0435\u0440\u0435\u0432\u0456\u0440 \u0456 \u0441\u043F\u0440\u043E\u0431\u0443\u0439 \u0449\u0435 \u0440\u0430\u0437.",
      failed: "\u041D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E. \u0412\u0432\u0435\u0434\u0435\u043D\u0456 \u0434\u0430\u043D\u0456 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E \u2014 \u0441\u043F\u0440\u043E\u0431\u0443\u0439 \u0449\u0435 \u0440\u0430\u0437."
    },
    transactions: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
    loadingData: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    inLabel: "\u0412\u0445.:",
    outLabel: "\u0412\u0438\u0445.:",
    blindClose: "\u0421\u043B\u0456\u043F\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    physicalCount: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0444\u0456\u0437\u0438\u0447\u043D\u0443 \u0441\u0443\u043C\u0443",
    physicalCountDesc: "\u041F\u043E\u0440\u0430\u0445\u0443\u0439\u0442\u0435 \u0432\u043C\u0456\u0441\u0442 \u043A\u043E\u0436\u043D\u043E\u0457 \u043A\u0438\u0448\u0435\u043D\u0456, \u043F\u043E\u0442\u0456\u043C \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u0444\u0430\u043A\u0442\u0438\u0447\u043D\u0456 \u0441\u0443\u043C\u0438.",
    physicalAmountPlaceholder: "\u0424\u0456\u0437\u0438\u0447\u043D\u0430 \u0441\u0443\u043C\u0430 (HUF)",
    startBlindClose: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0441\u043B\u0456\u043F\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    compare: "\u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438",
    result: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442",
    match: "\u0417\u0431\u0456\u0433",
    discrepancy: "\u0420\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044C!",
    tolerance: "\u0414\u043E\u043F\u0443\u0441\u043A: \xB12 000 HUF",
    recountRequired: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043F\u0435\u0440\u0435\u0440\u0430\u0445\u0443\u043D\u043E\u043A!",
    recountRequiredDesc: "\u0420\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044C \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0434\u043E\u043F\u0443\u0441\u043A. \u041F\u0435\u0440\u0435\u0440\u0430\u0445\u0443\u0439\u0442\u0435 \u043A\u0438\u0448\u0435\u043D\u0456.",
    recount: "\u041F\u0435\u0440\u0435\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    finalizeClose: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    discrepancyReport: "\u041F\u0440\u043E\u0442\u043E\u043A\u043E\u043B \u0440\u043E\u0437\u0431\u0456\u0436\u043D\u043E\u0441\u0442\u0435\u0439",
    blindCloseComplete: "\u0421\u043B\u0456\u043F\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
    registerClosedSuccess: "\u0414\u0435\u043D\u043D\u0443 \u043A\u0430\u0441\u0443 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u043E.",
    backToRegister: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u043A\u0430\u0441\u0438",
    noRegisterToClose: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E\u0457 \u043A\u0430\u0441\u0438.",
    fixedAssetsTitle: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    runDepreciation: "\u0429\u043E\u043C\u0456\u0441\u044F\u0447\u043D\u0430 \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u044F",
    runningDepreciation: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u0457...",
    newAsset: "\u041D\u043E\u0432\u0438\u0439 \u0430\u043A\u0442\u0438\u0432",
    newAssetForm: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443",
    assetName: "\u041D\u0430\u0437\u0432\u0430",
    purchasePricePlaceholder: "\u0426\u0456\u043D\u0430 \u043F\u0440\u0438\u0434\u0431\u0430\u043D\u043D\u044F (\u043C\u0456\u043D 200 000 HUF)",
    commissionDate: "\u0414\u0430\u0442\u0430 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0432 \u0435\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0456\u044E",
    inventoryNumber: "\u0406\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    serialNumber: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    recordAsset: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u0430\u043A\u0442\u0438\u0432",
    recording: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F...",
    depreciationComplete: "\u0410\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u044E \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {processed} \u043E\u0431\u0440\u043E\u0431\u043B\u0435\u043D\u043E, {deprecated} \u043F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u043E\u0432\u0430\u043D\u043E",
    assetsCount: "\u0410\u043A\u0442\u0438\u0432\u0438 ({count})",
    noAssets: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u0456\u0432.",
    purchaseLabel: "\u041F\u0440\u0438\u0434\u0431\u0430\u043D\u043D\u044F:",
    allCategories: "\u0412\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
    allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    categoryLabels: {
      machinery: "\u041C\u0430\u0448\u0438\u043D\u0430",
      itEquipment: "\u0406\u0422 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      vehicle: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431"
    },
    assetStatusLabels: {
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      fullyDepreciated: "\u041F\u043E\u0432\u043D\u0456\u0441\u0442\u044E \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u043E\u0432\u0430\u043D\u0438\u0439",
      scrapped: "\u0421\u043F\u0438\u0441\u0430\u043D\u0438\u0439",
      sold: "\u041F\u0440\u043E\u0434\u0430\u043D\u0438\u0439"
    },
    errorOccurred: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    vatSummaryTitle: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u041F\u0414\u0412",
    vatSummarySubtitle: "\u041E\u0433\u043B\u044F\u0434 \u043D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E\u0433\u043E \u0442\u0430 \u0432\u0445\u0456\u0434\u043D\u043E\u0433\u043E \u041F\u0414\u0412",
    csvExport: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV",
    period: "\u041F\u0435\u0440\u0456\u043E\u0434",
    periodSelector: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
    periodMonth: "\u041C\u0456\u0441\u044F\u0446\u044C",
    periodQuarter: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B",
    periodYear: "\u0420\u0456\u043A",
    staticData: "\u0441\u0442\u0430\u0442\u0438\u0447\u043D\u0456 \u0434\u0430\u043D\u0456",
    outputVat: "\u041D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0439 \u041F\u0414\u0412",
    inputVat: "\u0412\u0445\u0456\u0434\u043D\u0438\u0439 \u041F\u0414\u0412",
    vatPayable: "\u041F\u0414\u0412 \u0434\u043E \u0441\u043F\u043B\u0430\u0442\u0438",
    vatReclaimable: "\u0414\u043E \u0432\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
    salesNet: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456 \u043D\u0435\u0442\u0442\u043E",
    vatBreakdownByRate: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u041F\u0414\u0412 \u0437\u0430 \u0441\u0442\u0430\u0432\u043A\u043E\u044E",
    rateColumn: "\u0421\u0442\u0430\u0432\u043A\u0430",
    outputColumn: "\u041D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0439",
    inputColumn: "\u0412\u0445\u0456\u0434\u043D\u0438\u0439",
    balanceColumn: "\u0411\u0430\u043B\u0430\u043D\u0441",
    payableColumn: "\u0414\u043E \u0441\u043F\u043B\u0430\u0442\u0438",
    total: "\u0420\u0430\u0437\u043E\u043C",
    monthlyTrend: "\u041C\u0456\u0441\u044F\u0447\u043D\u0430 \u0434\u0438\u043D\u0430\u043C\u0456\u043A\u0430",
    monthColumn: "\u041C\u0456\u0441\u044F\u0446\u044C",
    currentLabel: "\u043F\u043E\u0442\u043E\u0447\u043D\u0438\u0439",
    vatDeadlineTitle: "\u0422\u0435\u0440\u043C\u0456\u043D \u043F\u043E\u0434\u0430\u043D\u043D\u044F \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u0457 \u041F\u0414\u0412",
    vatDeadlineDescription: "\u0422\u0435\u0440\u043C\u0456\u043D \u043F\u043E\u0434\u0430\u043D\u043D\u044F \u043C\u0456\u0441\u044F\u0447\u043D\u043E\u0457 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u0457 \u0442\u0430 \u0441\u043F\u043B\u0430\u0442\u0438 \u041F\u0414\u0412 \u2014 20-\u0442\u0435 \u0447\u0438\u0441\u043B\u043E \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F. \u0414\u043B\u044F \u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u0438\u0445 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u0439 \u2014 20-\u0442\u0435 \u0447\u0438\u0441\u043B\u043E \u043C\u0456\u0441\u044F\u0446\u044F, \u0449\u043E \u043D\u0430\u0441\u0442\u0430\u0454 \u0437\u0430 \u043A\u0432\u0430\u0440\u0442\u0430\u043B\u043E\u043C.",
    vatPayableLabel: "\u041F\u0414\u0412 \u0434\u043E \u0441\u043F\u043B\u0430\u0442\u0438:",
    dueDateLabel: "\u0422\u0435\u0440\u043C\u0456\u043D:",
    vatExempt: "\u0417\u0432\u0456\u043B\u044C\u043D\u0435\u043D\u0438\u0439",
    receivablesAgingTitle: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C - \u0417\u0432\u0456\u0442 \u0441\u0442\u0430\u0440\u0456\u043D\u043D\u044F",
    generatedAt: "\u0417\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u043E: {date}",
    refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
    exportCsv: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV",
    totalReceivables: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0434\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    overdueReceivables: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    overdueRatio: "\u0427\u0430\u0441\u0442\u043A\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E\u0457",
    agingBuckets: "\u0412\u0456\u043A\u043E\u0432\u0456 \u0433\u0440\u0443\u043F\u0438 (30/60/90+ \u0434\u043D\u0456\u0432)",
    partnerCount: "{count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432, {invoices} \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    suspended: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u0438\u0439",
    invoicesOldest: "{count} \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432 \u2022 \u041D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0438\u0439: {date}",
    sendReminderTitle: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 {level}",
    sendReminderDefault: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
    suspendPartnerTitle: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    unsuspendPartnerTitle: "\u0417\u043D\u044F\u0442\u0438 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F",
    morePartners: "+ \u0449\u0435 {count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
    noReceivablesInBucket: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456 \u0432 \u0446\u0456\u0439 \u0433\u0440\u0443\u043F\u0456.",
    loadingError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445.",
    partnerSuspended: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043E ({id})",
    partnerUnsuspended: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0437\u043D\u044F\u0442\u043E ({id})",
    actionError: "\u041F\u0456\u0434 \u0447\u0430\u0441 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u0441\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    reminderSent: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E{level}: {name}",
    confirmSuspend: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430: {name}?",
    confirmUnsuspend: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0437\u043D\u044F\u0442\u0438 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430?",
    csvHeaderAgingBucket: "\u0412\u0456\u043A\u043E\u0432\u0430 \u0433\u0440\u0443\u043F\u0430",
    csvHeaderPartnerName: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    csvHeaderPartnerId: "ID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    csvHeaderAmountHuf: "\u0421\u0443\u043C\u0430 (HUF)",
    csvHeaderInvoiceCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    csvHeaderOldestInvoice: "\u041D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    fixedAssetTitle: "\u041E\u0441\u043D\u043E\u0432\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    assetNotFound: "\u0410\u043A\u0442\u0438\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    back: "\u041D\u0430\u0437\u0430\u0434",
    basicData: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
    category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
    status: "\u0421\u0442\u0430\u0442\u0443\u0441",
    inventoryNumberLabel: "\u0406\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    serialNumberLabel: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    commissionDateLabel: "\u0412\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0432 \u0435\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0456\u044E",
    depreciationRateLabel: "\u041D\u043E\u0440\u043C\u0430 \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u0457",
    valueData: "\u0414\u0430\u043D\u0456 \u043F\u0440\u043E \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
    purchasePrice: "\u0426\u0456\u043D\u0430 \u043F\u0440\u0438\u0434\u0431\u0430\u043D\u043D\u044F",
    currentValue: "\u041F\u043E\u0442\u043E\u0447\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
    depreciationPercent: "\u0410\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u044F",
    noteLabel: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430: ",
    tamDeclarationsTitle: "\u0414\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u0457 TAM",
    newTamDeclaration: "\u041D\u043E\u0432\u0430 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u044F TAM",
    tamDescription: "\u0414\u043B\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u0442\u043E\u0432\u0430\u0440\u0443 TAM (0% \u041F\u0414\u0412) \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430 \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u0457.",
    invoiceIdPlaceholder: "ID \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    methodApp: "\u0414\u043E\u0434\u0430\u0442\u043E\u043A",
    methodEmail: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
    methodPaper: "\u041F\u0430\u043F\u0456\u0440",
    recordingDeclaration: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F...",
    recordDeclaration: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u044E",
    retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
    errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    noTamDeclarations: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u0439 TAM.",
    recordedDeclarations: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0456 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0456\u0457 ({count})",
    invoiceLabel: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A: {id}",
    methodLabel: "\u041C\u0435\u0442\u043E\u0434: {method}",
    expenseVouchersTitle: "\u0412\u0438\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0432\u0430\u0443\u0447\u0435\u0440\u0438",
    expenseVoucherManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0432\u0438\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u043C\u0438 \u0432\u0430\u0443\u0447\u0435\u0440\u0430\u043C\u0438",
    expenseVoucherDescription: "\u0424\u0443\u043D\u043A\u0446\u0456\u0457 \u0432\u0438\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u0432\u0430\u0443\u0447\u0435\u0440\u0456\u0432 \u0442\u0430 \u043F\u0456\u0434\u0437\u0432\u0456\u0442\u043D\u0438\u0445 \u0432\u0438\u0442\u0440\u0430\u0442 \u0431\u0443\u0434\u0443\u0442\u044C \u0440\u0435\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u0456 \u0432 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u043C\u0443 \u0441\u043F\u0440\u0438\u043D\u0442\u0456 (Story 62-8, 62-9 \u2014 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0456 \u043C\u043E\u0434\u0435\u043B\u0456 Prisma ExpenseVoucher + AccountableExpense).",
    issueExpenseVoucher: "\u0412\u0438\u0434\u0430\u0442\u0438 \u0432\u0438\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0432\u0430\u0443\u0447\u0435\u0440",
    issueExpenseVoucherDesc: "\u0406\u043C'\u044F \u043A\u043E\u043B\u0435\u0433\u0438, \u0441\u0443\u043C\u0430, \u043C\u0435\u0442\u0430 \u2192 \u0434\u043B\u044F \u0434\u0440\u0443\u043A\u0443",
    accountableExpense: "\u041F\u0456\u0434\u0437\u0432\u0456\u0442\u043D\u0430 \u0432\u0438\u0442\u0440\u0430\u0442\u0430",
    accountableExpenseDesc: "\u0421\u0443\u043C\u0430, \u043A\u043E\u043B\u0435\u0433\u0430, \u043C\u0435\u0442\u0430, \u0434\u0435\u0434\u043B\u0430\u0439\u043D 3 \u0440\u043E\u0431\u043E\u0447\u0456 \u0434\u043D\u0456",
    comingSoon: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C",
    ev: {
      issueNew: "\u041D\u043E\u0432\u0438\u0439 \u0432\u0430\u0443\u0447\u0435\u0440",
      issueTitle: "\u0412\u0438\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0432\u0430\u0443\u0447\u0435\u0440 \u043D\u0430 \u0432\u0438\u0442\u0440\u0430\u0442\u0438",
      recipientName: "\u0406\u043C'\u044F \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430",
      recipientNamePlaceholder: "\u043D\u0430\u043F\u0440. \u0406\u0432\u0430\u043D\u043E\u0432 \u0406\u0432\u0430\u043D",
      amount: "\u0421\u0443\u043C\u0430",
      purpose: "\u041C\u0435\u0442\u0430",
      purposePlaceholder: "\u043D\u0430\u043F\u0440. \u041E\u0444\u0456\u0441\u043D\u0435 \u043F\u0440\u0438\u043B\u0430\u0434\u0434\u044F",
      issue: "\u0412\u0438\u0441\u0442\u0430\u0432\u0438\u0442\u0438",
      settleTitle: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      settledAmount: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0430 \u0441\u0443\u043C\u0430",
      returnedAmount: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u0430 \u0441\u0443\u043C\u0430",
      receiptAttached: "\u0427\u0435\u043A \u0434\u043E\u0434\u0430\u043D\u043E",
      settle: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      filterStatus: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0437\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u043C",
      voucherNumber: "\u041D\u043E\u043C\u0435\u0440 \u0432\u0430\u0443\u0447\u0435\u0440\u0430",
      recipient: "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447",
      deadline: "\u0422\u0435\u0440\u043C\u0456\u043D",
      noVouchers: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0430\u0443\u0447\u0435\u0440\u0456\u0432.",
      statusIssued: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      statusOverdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
      statusSettled: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
      statusCancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
      receiptOk: "\u0427\u0435\u043A OK"
    },
    csvHeaderVatRate: "\u0421\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412",
    csvHeaderSalesNet: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456 \u043D\u0435\u0442\u0442\u043E (HUF)",
    csvHeaderOutputVat: "\u041D\u0430\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u0439 \u041F\u0414\u0412 (HUF)",
    csvHeaderPurchasesNet: "\u0417\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456 \u043D\u0435\u0442\u0442\u043E (HUF)",
    csvHeaderInputVat: "\u0412\u0445\u0456\u0434\u043D\u0438\u0439 \u041F\u0414\u0412 (HUF)",
    csvHeaderDifference: "\u0420\u0456\u0437\u043D\u0438\u0446\u044F (HUF)",
    autoAccepted: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
    dailyCloseButton: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0434\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    dailyCloseComplete: "\u0414\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
    expectedBalance: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441",
    overToleranceWarning: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0434\u043E\u043F\u0443\u0441\u043A!",
    startDailyClose: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u0434\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    szhLabel: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0421\u0417\u0413",
    toleranceInfo: "\u0414\u043E\u043F\u0443\u0441\u043A: \xB12.000 Ft",
    monthlyClose: {
      title: "\u041C\u0456\u0441\u044F\u0447\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
      subtitle: "\u041F\u043E\u043A\u0440\u043E\u043A\u043E\u0432\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      selectPeriod: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      selectPeriodDesc: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u0456\u043A \u0442\u0430 \u043C\u0456\u0441\u044F\u0446\u044C \u0434\u043B\u044F \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
      selected: "\u041E\u0431\u0440\u0430\u043D\u043E",
      periodHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043F\u0435\u0440\u0456\u043E\u0434\u0456\u0432",
      noHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043F\u0435\u0440\u0456\u043E\u0434\u0456\u0432 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430.",
      periodColumn: "\u041F\u0435\u0440\u0456\u043E\u0434",
      statusColumn: "\u0421\u0442\u0430\u0442\u0443\u0441",
      closedAtColumn: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E",
      closedByColumn: "\u0417\u0430\u043A\u0440\u0438\u0432",
      statusOpen: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0439",
      statusClosed: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438\u0439",
      summaryTitle: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u2014 {period}",
      revenue: "\u0414\u043E\u0445\u0456\u0434",
      expenses: "\u0412\u0438\u0442\u0440\u0430\u0442\u0438",
      vatTotal: "\u041F\u0414\u0412 \u0432\u0441\u044C\u043E\u0433\u043E",
      invoiceCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
      transactionCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439",
      closedInfo: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E: {date}, \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447: {user}",
      noteLabel: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
      reopenButton: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
      openItemsTitle: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      openItemsDesc: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043D\u0435\u0437\u0430\u043A\u0440\u0438\u0442\u0438\u0445 \u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u0437\u0430 \u0446\u0435\u0439 \u043F\u0435\u0440\u0456\u043E\u0434",
      openDeliveryNotes: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0456",
      unpaidInvoices: "\u041D\u0435\u043E\u043F\u043B\u0430\u0447\u0435\u043D\u0456 \u0440\u0430\u0445\u0443\u043D\u043A\u0438",
      pendingSzh: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0421\u0417\u0413",
      openItemsWarning: "\u0423\u0432\u0430\u0433\u0430: \u0412 \u0446\u044C\u043E\u043C\u0443 \u043F\u0435\u0440\u0456\u043E\u0434\u0456 \u0454 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457. \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0454\u0442\u044C\u0441\u044F \u0457\u0445 \u0432\u0438\u0440\u0456\u0448\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0434 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F\u043C.",
      vatBreakdownTitle: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u041F\u0414\u0412",
      vatBreakdownDesc: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u041F\u0414\u0412 \u0437\u0430 \u0441\u0442\u0430\u0432\u043A\u0430\u043C\u0438 \u0434\u043B\u044F \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      vatRateColumn: "\u0421\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412",
      netColumn: "\u041D\u0435\u0442\u0442\u043E",
      vatColumn: "\u041F\u0414\u0412",
      grossColumn: "\u0411\u0440\u0443\u0442\u0442\u043E",
      invoiceCountShort: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
      noVatData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u041F\u0414\u0412 \u0437\u0430 \u0446\u0435\u0439 \u043F\u0435\u0440\u0456\u043E\u0434.",
      csvVatRate: "\u0421\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412",
      csvNet: "\u041D\u0435\u0442\u0442\u043E (HUF)",
      csvVat: "\u041F\u0414\u0412 (HUF)",
      csvGross: "\u0411\u0440\u0443\u0442\u0442\u043E (HUF)",
      csvInvoiceCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
      confirmTitle: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043C\u0456\u0441\u044F\u0447\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
      confirmCheckbox: "\u042F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u044E \u043C\u0456\u0441\u044F\u0447\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430 {period}. \u041F\u0456\u0441\u043B\u044F \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043F\u0435\u0440\u0456\u043E\u0434 \u0441\u0442\u0430\u043D\u0435 \u0442\u0456\u043B\u044C\u043A\u0438 \u0434\u043B\u044F \u0447\u0438\u0442\u0430\u043D\u043D\u044F.",
      closeNoteLabel: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      closeNotePlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F...",
      noPermission: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u043D\u0430 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0446\u044C\u043E\u0433\u043E \u043F\u0435\u0440\u0456\u043E\u0434\u0443. \u0422\u0456\u043B\u044C\u043A\u0438 ADMIN \u0442\u0430 \u0432\u0438\u0449\u0435 \u043C\u043E\u0436\u0443\u0442\u044C \u0437\u0430\u043A\u0440\u0438\u0432\u0430\u0442\u0438 \u043F\u0435\u0440\u0456\u043E\u0434\u0438.",
      closeButton: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u043F\u0435\u0440\u0456\u043E\u0434",
      closeSuccess: "\u041C\u0456\u0441\u044F\u0447\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u0435!",
      closeSuccessDesc: "\u041F\u0435\u0440\u0456\u043E\u0434 {period} \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u043E. \u0422\u0435\u043F\u0435\u0440 \u0432\u0456\u043D \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0442\u0456\u043B\u044C\u043A\u0438 \u0434\u043B\u044F \u0447\u0438\u0442\u0430\u043D\u043D\u044F.",
      periodAlreadyClosed: "\u041F\u0435\u0440\u0456\u043E\u0434 \u0432\u0436\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0438\u0439",
      reopenTitle: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u0435\u0440\u0456\u043E\u0434 \u0437\u043D\u043E\u0432\u0443",
      reopenDesc: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u0435\u0440\u0456\u043E\u0434 {period} \u0437\u043D\u043E\u0432\u0443. \u0426\u044F \u0434\u0456\u044F \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u043F\u0440\u0430\u0432 SUPER_ADMIN.",
      reopenReasonPlaceholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F...",
      reopenConfirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445.",
      vatFiled: "\u041F\u0414\u0412 \u043F\u043E\u0434\u0430\u043D\u043E",
      vatNotFiled: "\u041F\u0414\u0412 \u043D\u0435 \u043F\u043E\u0434\u0430\u043D\u043E",
      vatFiledAt: "\u041F\u0414\u0412 \u043F\u043E\u0434\u0430\u043D\u043E: {date}",
      vatFiledBy: "\u041F\u043E\u0434\u0430\u0432: {user}",
      markVatFiled: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u041F\u0414\u0412 \u044F\u043A \u043F\u043E\u0434\u0430\u043D\u0435",
      vatFilingNote: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      vatFilingNotePlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u043F\u043E\u0434\u0430\u043D\u043D\u044F \u041F\u0414\u0412...",
      vatFiledSuccess: "\u041F\u043E\u0434\u0430\u043D\u043D\u044F \u041F\u0414\u0412 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u043E.",
      months: {
        januar: "\u0421\u0456\u0447\u0435\u043D\u044C",
        februar: "\u041B\u044E\u0442\u0438\u0439",
        marcius: "\u0411\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        aprilis: "\u041A\u0432\u0456\u0442\u0435\u043D\u044C",
        majus: "\u0422\u0440\u0430\u0432\u0435\u043D\u044C",
        junius: "\u0427\u0435\u0440\u0432\u0435\u043D\u044C",
        julius: "\u041B\u0438\u043F\u0435\u043D\u044C",
        augusztus: "\u0421\u0435\u0440\u043F\u0435\u043D\u044C",
        szeptember: "\u0412\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        oktober: "\u0416\u043E\u0432\u0442\u0435\u043D\u044C",
        november: "\u041B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        december: "\u0413\u0440\u0443\u0434\u0435\u043D\u044C"
      },
      steps: {
        periodSelect: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
        summaryOverview: "\u041E\u0433\u043B\u044F\u0434 \u043F\u0456\u0434\u0441\u0443\u043C\u043A\u0456\u0432",
        openItems: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
        vatSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u041F\u0414\u0412",
        confirmation: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F"
      }
    }
  },
  task: {
    title: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C...",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A...",
    allTypes: "\u0412\u0441\u0456 \u0442\u0438\u043F\u0438",
    allPriorities: "\u0412\u0441\u0456 \u043F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442\u0438",
    titlePlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F...",
    descriptionPlaceholder: "\u041E\u043F\u0438\u0441 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F...",
    statusLabels: {
      open: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0439",
      inProgress: "\u0412 \u0440\u043E\u0431\u043E\u0442\u0456",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0439",
      interrupted: "\u041F\u0435\u0440\u0435\u0440\u0432\u0430\u043D\u0438\u0439"
    },
    priorityLabels: {
      low: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
      medium: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
      high: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439"
    },
    kanbanTitle: "Kanban-\u0434\u043E\u0448\u043A\u0430 \u0442\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F\u043C\u0438",
    newTask: "\u041D\u043E\u0432\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    taskCount: "\u0437\u0430\u0432\u0434\u0430\u043D\u044C",
    highPriority: "\u0432\u0438\u0441\u043E\u043A\u0438\u0439 \u043F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
    noTasks: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
    assignee: "\u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0439",
    daysOverdue: "\u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E {count} \u0434\u043D\u0456\u0432",
    today: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    tomorrow: "\u0417\u0430\u0432\u0442\u0440\u0430",
    deadline: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
    taskDescription: "\u041E\u043F\u0438\u0441",
    daysOverdueLabel: "\u0434\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
    quantityLabel: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
    unitDefault: "\u0448\u0442",
    statusChange: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u0441\u0442\u0430\u0442\u0443\u0441",
    closeButton: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    titleLabel: "\u041D\u0430\u0437\u0432\u0430",
    descriptionLabel: "\u041E\u043F\u0438\u0441",
    priorityLabel: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
    priorityMedium: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
    quantityFieldLabel: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
    unitLabel: "\u041E\u0434\u0438\u043D\u0438\u0446\u044F",
    createButton: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
    assignTo: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u043E\u0433\u043E",
    assignedUsers: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0456",
    searchUsers: "\u041F\u043E\u0448\u0443\u043A \u0441\u043F\u0456\u0432\u0440\u043E\u0431\u0456\u0442\u043D\u0438\u043A\u0430...",
    removeAssignee: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    status: {
      open: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      inProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
    },
    type: {
      shopping: "\u041F\u043E\u043A\u0443\u043F\u043A\u0438",
      todo: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
      note: "\u041D\u043E\u0442\u0430\u0442\u043A\u0430",
      message: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F"
    },
    priority: {
      low: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
      medium: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
      high: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439"
    }
  },
  admin: {
    title: "\u0410\u0434\u043C\u0456\u043D-\u0446\u0435\u043D\u0442\u0440",
    quickActions: "\u0428\u0432\u0438\u0434\u043A\u0456 \u0434\u0456\u0457",
    dailyOpen: "\u0420\u0430\u043D\u043A\u043E\u0432\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
    dailyOpenDesc: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0441 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443",
    dailyClose: "\u0414\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    dailyCloseDesc: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0441 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443",
    sendReminders: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
    sendRemindersDesc: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u043E \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    knowledgeBase: "\u0411\u0430\u0437\u0430 \u0437\u043D\u0430\u043D\u044C",
    knowledgeBaseDesc: "\u0414\u043E\u0432\u0456\u0434\u043A\u0430 \u0442\u0430 \u0456\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u0457",
    subtitle: "\u0429\u043E\u0434\u0435\u043D\u043D\u0438\u0439 \u043F\u0456\u0434\u0441\u0443\u043C\u043E\u043A, \u0448\u0432\u0438\u0434\u043A\u0456 \u0434\u0456\u0457 \u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
    expiredRentals: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    oldestDays: "\u041D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0430: {days} \u0434\u043D\u0456\u0432",
    noExpiredRentals: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0445 \u043E\u0440\u0435\u043D\u0434",
    receivables: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    overdue30Partners: "30+ \u0434\u043D\u0456\u0432: {count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
    noReceivables: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456",
    serviceWorksheets: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
    worksheetStats: "\u041E\u0447\u0456\u043A\u0443\u044E\u0442\u044C: {waiting} | \u0412 \u0440\u043E\u0431\u043E\u0442\u0456: {inProgress} | \u0413\u043E\u0442\u043E\u0432\u043E: {completed}",
    todayBookings: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u0456 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
    todayPlanned: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E \u043D\u0430 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    tasks: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    expiredTasks: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E: {count} \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
    noExpiredTasks: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
    dailyOpenWizard: "\u0414\u0435\u043D\u043D\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
    dailyCloseWizard: "\u0414\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    stepCashBalance: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A \u043A\u0430\u0441\u0438 \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043E\u043A",
    stepExpiredRentals: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    stepTodayBookings: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u0456 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
    stepServiceWaiting: "\u0421\u0435\u0440\u0432\u0456\u0441 \u043E\u0447\u0456\u043A\u0443\u0454",
    stepReceivables: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    stepTasks: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    stepSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
    stepCashBalanceClose: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A \u043A\u0430\u0441\u0438",
    stepOpenRentals: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    stepServiceStatuses: "\u0421\u0442\u0430\u0442\u0443\u0441\u0438 \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
    stepDailyTurnover: "\u0414\u0435\u043D\u043D\u0438\u0439 \u043E\u0431\u043E\u0440\u043E\u0442",
    stepTaskClose: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
    enterOpeningBalance: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0437\u0430\u043B\u0438\u0448\u043E\u043A \u043A\u0430\u0441\u0438 \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043E\u043A (\u043A\u0430\u0441\u0430 + \u0441\u0435\u0439\u0444).",
    openingBalanceHuf: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A (HUF)",
    storeOpened: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
    openingTime: "\u0427\u0430\u0441 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
    expectedBalanceHuf: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A (HUF)",
    actualBalanceHuf: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0438\u0439 \u0437\u0430\u043B\u0438\u0448\u043E\u043A (HUF)",
    difference: "\u0420\u0456\u0437\u043D\u0438\u0446\u044F",
    storeClosed: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D \u0437\u0430\u043A\u0440\u0438\u0442\u043E",
    closingTime: "\u0427\u0430\u0441 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    openStore: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043C\u0430\u0433\u0430\u0437\u0438\u043D",
    closeStore: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u043C\u0430\u0433\u0430\u0437\u0438\u043D",
    cashBalanceDesc: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0442\u0430 \u0444\u0430\u043A\u0442\u0438\u0447\u043D\u0438\u0439 \u0431\u0430\u043B\u0430\u043D\u0441 \u043A\u0430\u0441\u0438.",
    cashMismatch: "\u0411\u0430\u043B\u0430\u043D\u0441 \u043A\u0430\u0441\u0438 \u043D\u0435 \u0437\u0431\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u0437 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\u043C!",
    openRentalsReview: "\u041E\u0433\u043B\u044F\u0434 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0445 \u043E\u0440\u0435\u043D\u0434",
    expiredRentalsLabel: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    pcs: "\u0448\u0442",
    oldestRental: "\u041D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
    expiredDaysAgo: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0430 {days} \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443",
    serviceCloseStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0445 \u043B\u0438\u0441\u0442\u0456\u0432",
    waitingLabel: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
    inProgressLabel: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
    todayCompleted: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    dailyTurnoverSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0449\u043E\u0434\u0435\u043D\u043D\u043E\u0433\u043E \u043E\u0431\u043E\u0440\u043E\u0442\u0443",
    todayBookingsLabel: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u043D\u0430 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    receivablesLabel: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    taskReviewClose: "\u041E\u0433\u043B\u044F\u0434 \u0442\u0430 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
    assignedTasks: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    expiredTasksLabel: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    noteOptional: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    notePlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u043F\u0440\u043E \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u0456\u0439 \u0434\u0435\u043D\u044C...",
    verifyAndCloseStore: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0434\u0430\u043D\u0456 \u0442\u0430 \u0437\u0430\u043A\u0440\u0438\u0439\u0442\u0435 \u043C\u0430\u0433\u0430\u0437\u0438\u043D.",
    cashBalance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u043A\u0430\u0441\u0438",
    expectedActual: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439: {expected} | \u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0438\u0439: {actual}",
    deviation: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F: {amount}",
    openRentalsLabel: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    serviceWorksheetsOpen: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0456 \u043B\u0438\u0441\u0442\u0438 (\u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0456)",
    tasksExpiredAssigned: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F (\u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 / \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0456)",
    noteLabel: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430:",
    back: "\u041D\u0430\u0437\u0430\u0434",
    permissionMatrix: {
      adminAlwaysActive: "\u0410\u0434\u043C\u0456\u043D (\u0437\u0430\u0432\u0436\u0434\u0438 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439)",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
      noWidgets: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u0436\u0435\u0442\u0456\u0432 \u0443 \u0441\u0438\u0441\u0442\u0435\u043C\u0456."
    },
    kb: {
      tagPlaceholder: "\u041D\u043E\u0432\u0438\u0439 \u0442\u0435\u0433 (Enter \u0434\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F)"
    },
    warehouseLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u043A\u043B\u0430\u0434\u0443 \u2014 \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435.",
    warehouseMissing: "\u0414\u043B\u044F \u0446\u0456\u0454\u0457 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u043E \u0441\u043A\u043B\u0430\u0434 \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C, \u0442\u043E\u043C\u0443 \u043A\u0430\u0441\u0443 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438/\u0437\u0430\u043A\u0440\u0438\u0442\u0438. \u0417\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430.",
    warehouseFetchFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0441\u043A\u043B\u0430\u0434 (\u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043C\u0435\u0440\u0435\u0436\u0456). \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
    warehouseUnresolved: "\u0421\u043A\u043B\u0430\u0434 \u043D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0432\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438, \u0442\u043E\u043C\u0443 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u044F \u0437 \u043A\u0430\u0441\u043E\u044E \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u0430."
  },
  settings: {
    title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    fullName: "\u041F\u043E\u0432\u043D\u0435 \u0456\u043C'\u044F",
    emailAddress: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
    phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    currentPassword: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    newPassword: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    confirmNewPassword: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u043E\u043B\u044F",
    profileTab: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C",
    appearanceTab: "\u0417\u043E\u0432\u043D\u0456\u0448\u043D\u0456\u0439 \u0432\u0438\u0433\u043B\u044F\u0434",
    notificationsTab: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    systemTab: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430",
    personalData: "\u041E\u0441\u043E\u0431\u0438\u0441\u0442\u0456 \u0434\u0430\u043D\u0456",
    uploadImage: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
    role: "\u0420\u043E\u043B\u044C",
    changePassword: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    theme: "\u0422\u0435\u043C\u0430",
    themeSystem: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430",
    themeLight: "\u0421\u0432\u0456\u0442\u043B\u0430",
    themeDark: "\u0422\u0435\u043C\u043D\u0430",
    language: "\u041C\u043E\u0432\u0430",
    langHu: "Magyar",
    langEn: "English",
    langDe: "Deutsch",
    fontSize: "\u0420\u043E\u0437\u043C\u0456\u0440 \u0448\u0440\u0438\u0444\u0442\u0443",
    fontSmall: "\u041C\u0430\u043B\u0438\u0439",
    fontMedium: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
    fontLarge: "\u0412\u0435\u043B\u0438\u043A\u0438\u0439",
    compactMode: "\u041A\u043E\u043C\u043F\u0430\u043A\u0442\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C",
    compactModeDesc: "\u041C\u0435\u043D\u0448\u0456 \u0432\u0456\u0434\u0441\u0442\u0443\u043F\u0438 \u0442\u0430 \u0456\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0438",
    notifEmail: "Email-\u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    notifEmailDesc: "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043D\u0430 email",
    notifPush: "Push-\u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    notifPushDesc: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430",
    notifSound: "\u0417\u0432\u0443\u043A\u043E\u0432\u0438\u0439 \u0441\u0438\u0433\u043D\u0430\u043B",
    notifSoundDesc: "\u0417\u0432\u0443\u043A \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    notifRentalExpiry: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    notifRentalExpiryDesc: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    notifServiceReady: "\u0421\u0435\u0440\u0432\u0456\u0441 \u0433\u043E\u0442\u043E\u0432\u0438\u0439",
    notifServiceReadyDesc: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u0457 \u0440\u043E\u0431\u043E\u0442\u0438",
    notifNewBooking: "\u041D\u043E\u0432\u0435 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
    notifNewBookingDesc: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u043E\u043D\u043B\u0430\u0439\u043D-\u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
    notifPaymentReceived: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F \u043F\u043B\u0430\u0442\u0435\u0436\u0443",
    notifPaymentReceivedDesc: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043F\u0440\u0438 \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u0456 \u043F\u043B\u0430\u0442\u0435\u0436\u0443",
    notifLowStock: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
    notifLowStockDesc: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0440\u0456\u0432\u0435\u043D\u044C \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    notifTaskAssigned: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    notifTaskAssignedDesc: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u043D\u043E\u0432\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    notificationPrefs: {
      title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C",
      subtitle: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C, \u044F\u043A\u0438\u043C\u0438 \u043A\u0430\u043D\u0430\u043B\u0430\u043C\u0438 (email / SMS / \u0432 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443) \u043D\u0430\u0434\u0445\u043E\u0434\u0438\u0442\u0438\u043C\u0443\u0442\u044C \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F, \u0442\u0430 \u0437\u0430\u0434\u0430\u0439\u0442\u0435 \u0449\u043E\u0434\u0435\u043D\u043D\u0438\u0439 \u0442\u0438\u0445\u0438\u0439 \u043F\u0435\u0440\u0456\u043E\u0434.",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C\u2026",
      loadError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
      channelsTitle: "\u041A\u0430\u043D\u0430\u043B\u0438 \u0437\u0430 \u0442\u0438\u043F\u043E\u043C \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
      channels: {
        email: "Email",
        sms: "SMS",
        "in-app": "\u0423 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443"
      },
      domains: {
        vehicle: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
        rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
        service: "\u0421\u0435\u0440\u0432\u0456\u0441",
        sales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        finance: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        workflow: "\u041F\u0440\u043E\u0446\u0435\u0441\u0438",
        documents: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440"
      },
      priorityCritical: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0435",
      quietHoursTitle: "\u0422\u0438\u0445\u0438\u0439 \u043F\u0435\u0440\u0456\u043E\u0434",
      quietHoursHint: "\u0423 \u0442\u0438\u0445\u0438\u0439 \u043F\u0435\u0440\u0456\u043E\u0434 \u043D\u0430\u0434\u0445\u043E\u0434\u044F\u0442\u044C \u043B\u0438\u0448\u0435 \u043A\u0440\u0438\u0442\u0438\u0447\u043D\u0456 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u2014 \u0456\u043D\u0448\u0456 \u0432\u0456\u0434\u043A\u043B\u0430\u0434\u0430\u044E\u0442\u044C\u0441\u044F \u043D\u0430 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0434\u0435\u043D\u044C.",
      quietHoursStart: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
      quietHoursEnd: "\u041A\u0456\u043D\u0435\u0446\u044C",
      timezone: "\u0427\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441",
      timezonePlaceholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441\u2026",
      saveAll: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0432\u0441\u0435",
      saving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F\u2026",
      unsavedChanges: "{count} \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u0445 \u0437\u043C\u0456\u043D",
      allSaved: "\u0423\u0441\u0456 \u0437\u043C\u0456\u043D\u0438 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
      adminResetTitle: "\u0410\u0434\u043C\u0456\u043D: \u0441\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      adminResetHint: "\u0424\u0440\u0430\u043D\u0448\u0438\u0437\u043D\u0438\u0439 \u0430\u0434\u043C\u0456\u043D \u2014 \u0441\u043A\u0438\u0434\u0430\u0454 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0434\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0445 \u0437\u043D\u0430\u0447\u0435\u043D\u044C \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0443. \u041F\u0456\u0441\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0437\u043D\u043E\u0432\u0443 \u043E\u0442\u0440\u0438\u043C\u0443\u0454 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0456 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F.",
      adminResetPlaceholder: "UUID \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      adminResetAction: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438",
      adminResetting: "\u0421\u043A\u0438\u0434\u0430\u043D\u043D\u044F\u2026",
      adminResetSuccess: "{count} \u0440\u044F\u0434\u043A\u0456\u0432 \u0441\u043A\u0438\u043D\u0443\u0442\u043E \u0434\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0445 \u0437\u043D\u0430\u0447\u0435\u043D\u044C.",
      adminResetError: "\u0421\u043A\u0438\u0434\u0430\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 UUID \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0442\u0430 \u043F\u0440\u0430\u0432\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0443."
    },
    systemSettings: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    autoLogout: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0438\u0439 \u0432\u0438\u0445\u0456\u0434",
    autoLogoutDesc: "\u0412\u0438\u0445\u0456\u0434 \u043F\u0456\u0441\u043B\u044F \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0456",
    minutes: "\u0445\u0432\u0438\u043B\u0438\u043D",
    dataExport: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0434\u0430\u043D\u0438\u0445",
    dataExportDesc: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E GDPR",
    exportButton: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    dangerZone: "\u041D\u0435\u0431\u0435\u0437\u043F\u0435\u0447\u043D\u0430 \u0437\u043E\u043D\u0430",
    deleteAccount: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    deleteAccountDesc: "\u041E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0442\u0430 \u0432\u0441\u0456\u0445 \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445",
    deleteButton: "\u041E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    subtitleText: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0442\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    roleLabel: "\u0420\u043E\u043B\u044C",
    changePasswordButton: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    themeLabel: "\u0422\u0435\u043C\u0430",
    emailNotifications: "Email \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    pushNotifications: "Push \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    summaryEmails: "\u0417\u0432\u0435\u0434\u0435\u043D\u0456 email-\u0438",
    rentalExpiryDesc: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u0437\u0430 1 \u0434\u0435\u043D\u044C \u0434\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    dailySummaryDesc: "\u0429\u043E\u0434\u043D\u044F \u043E 8:00",
    weeklySummaryDesc: "\u0429\u043E\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043A\u0430 \u043E 8:00",
    languageLabel: "\u041C\u043E\u0432\u0430",
    dateFormatLabel: "\u0424\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u0438",
    currencyLabel: "\u0412\u0430\u043B\u044E\u0442\u0430",
    timezoneLabel: "\u0427\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441",
    securityTitle: "\u0411\u0435\u0437\u043F\u0435\u043A\u0430",
    rentalDefaultsTitle: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    defaultRentalDays: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0439 \u0442\u0435\u0440\u043C\u0456\u043D \u043E\u0440\u0435\u043D\u0434\u0438 (\u0434\u043D\u0456)",
    defaultDeposit: "\u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0430 (%)",
    exportDesc: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0432\u0441\u0456 \u0434\u0430\u043D\u0456 \u0443 \u0444\u043E\u0440\u043C\u0430\u0442\u0456 CSV",
    clearCache: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043A\u0435\u0448",
    clearCacheDesc: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u0438\u0439 \u043A\u0435\u0448 \u0442\u0430 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    clearButton: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
    profileSaved: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    notificationsSaved: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    systemSaved: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    currencyHUF: "HUF - \u0423\u0433\u043E\u0440\u0441\u044C\u043A\u0438\u0439 \u0444\u043E\u0440\u0438\u043D\u0442",
    currencyEUR: "EUR - \u0404\u0432\u0440\u043E",
    autoLogout15: "15 \u0445\u0432\u0438\u043B\u0438\u043D",
    autoLogout30: "30 \u0445\u0432\u0438\u043B\u0438\u043D",
    autoLogout60: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
    autoLogout120: "2 \u0433\u043E\u0434\u0438\u043D\u0438",
    autoLogoutNever: "\u041D\u0456\u043A\u043E\u043B\u0438",
    ocr: {
      zebraLabel: "Zebra ZD220 \u0435\u0442\u0438\u043A\u0435\u0442\u043A\u0430 (43x26mm)"
    },
    avatarHelp: "JPG \u0430\u0431\u043E PNG, \u043C\u0430\u043A\u0441 2\u041C\u0411",
    sms: {
      sendTab: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 SMS",
      historyTab: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F",
      templatesTab: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438"
    }
  },
  dashboard: {
    title: "\u041F\u0430\u043D\u0435\u043B\u044C \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F",
    monthlyRevenue: "\u041C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
    activeRentals: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    openWorksheets: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
    dailyTransactions: "\u0414\u0435\u043D\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
    revenueChart: "\u0413\u0440\u0430\u0444\u0456\u043A \u0434\u043E\u0445\u043E\u0434\u0456\u0432",
    topPartners: "\u0422\u043E\u043F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
    equipmentProfit: "\u041F\u0440\u0438\u0431\u0443\u0442\u043E\u043A \u0432\u0456\u0434 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    rentalStats: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043E\u0440\u0435\u043D\u0434\u0438",
    serviceProfit: "\u041F\u0440\u0438\u0431\u0443\u0442\u043E\u043A \u0432\u0456\u0434 \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
    seasonality: "\u0421\u0435\u0437\u043E\u043D\u043D\u0456\u0441\u0442\u044C",
    stockAlerts: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0437\u0430\u043F\u0430\u0441\u0438",
    technicianWorkload: "\u041D\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u0435\u0445\u043D\u0456\u043A\u0456\u0432",
    partnerActivity: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
    warrantyRatio: "\u041A\u043E\u0435\u0444\u0456\u0446\u0456\u0454\u043D\u0442 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439",
    revenueForecast: "\u041F\u0440\u043E\u0433\u043D\u043E\u0437 \u0434\u043E\u0445\u043E\u0434\u0456\u0432",
    vatSummary: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u041F\u0414\u0412",
    recurringIssues: "\u041F\u043E\u0432\u0442\u043E\u0440\u044E\u0432\u0430\u043D\u0456 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438",
    popularEquipment: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    section: {
      alreadyAtBottom: "\u0412\u0436\u0435 \u043D\u0430 \u043D\u0430\u0439\u043D\u0438\u0436\u0447\u0456\u0439 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      alreadyAtTop: "\u0412\u0436\u0435 \u043D\u0430 \u043D\u0430\u0439\u0432\u0438\u0449\u0456\u0439 \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
      collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
      collapseSection: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0441\u0435\u043A\u0446\u0456\u044E",
      comingSoon: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C...",
      expand: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
      expandSection: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0441\u0435\u043A\u0446\u0456\u044E",
      moveDown: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043D\u0438\u0437",
      moveSectionDown: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0441\u0435\u043A\u0446\u0456\u044E \u0432\u043D\u0438\u0437",
      moveSectionUp: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0441\u0435\u043A\u0446\u0456\u044E \u0432\u0433\u043E\u0440\u0443",
      moveUp: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0433\u043E\u0440\u0443",
      settings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      summary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
      finance: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
      inventory: "\u0417\u0430\u043F\u0430\u0441\u0438",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
      analytics: "\u041E\u0440\u0435\u043D\u0434\u0430",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      kassza: "\u041A\u0430\u0441\u0430"
    },
    collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
    expand: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438",
    showMore: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    showLess: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043C\u0435\u043D\u0448\u0435",
    welcome: "\u041B\u0430\u0441\u043A\u0430\u0432\u043E \u043F\u0440\u043E\u0441\u0438\u043C\u043E, {name}!",
    todaySummary: "\u041E\u0441\u044C \u043F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u044C\u043E\u0433\u043E \u0434\u043D\u044F.",
    defaultUser: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
    executiveSummaryAriaLabel: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0433\u043B\u044F\u0434 - \u041A\u043B\u044E\u0447\u043E\u0432\u0456 \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A\u0438",
    executiveSummaryTitle: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u0433\u043B\u044F\u0434",
    expandWidget: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0432\u0456\u0434\u0436\u0435\u0442",
    minimize: "\u041C\u0456\u043D\u0456\u043C\u0456\u0437\u0443\u0432\u0430\u0442\u0438",
    minimizeWidget: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438 \u043C\u0430\u043B\u0438\u0439 \u0440\u043E\u0437\u043C\u0456\u0440",
    pinIndicatorAriaLabel: "\u0417\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u0430 \u0441\u0435\u043A\u0446\u0456\u044F",
    pinIndicatorTitle: "\u0417\u0430\u0432\u0436\u0434\u0438 \u0432\u0438\u0434\u0438\u043C\u0438\u0439 - \u043D\u0435 \u0437\u0433\u043E\u0440\u0442\u0430\u0454\u0442\u044C\u0441\u044F",
    collapseAll: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0435",
    contactAdminForPermissions: "\u0417\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0434\u043B\u044F \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E\u0437\u0432\u043E\u043B\u0456\u0432.",
    executive: {
      activeWorksheets: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
      businessHealth: "\u0417\u0434\u043E\u0440\u043E\u0432'\u044F \u0431\u0456\u0437\u043D\u0435\u0441\u0443",
      dailyRevenue: "\u0429\u043E\u0434\u0435\u043D\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      healthGood: "\u0414\u043E\u0431\u0440\u0435",
      inventory: "\u0417\u0430\u043F\u0430\u0441\u0438",
      openedToday: "\u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
      receivables: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u043A\u0430",
      utilization: "\u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F",
      revenueTarget: "\u0446\u0456\u043B\u044C: {amount}",
      receivablesTarget: "\u0446\u0456\u043B\u044C: {amount}"
    },
    expandAll: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0435",
    hideExecutiveSummary: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 Executive Summary",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    noSections: "\u041D\u0435\u043C\u0430\u0454 \u0441\u0435\u043A\u0446\u0456\u0439 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F.",
    noWidgetsInSection: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u0436\u0435\u0442\u0456\u0432 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0443 \u0446\u0456\u0439 \u0441\u0435\u043A\u0446\u0456\u0457.",
    notAuthenticated: "\u041D\u0435 \u0430\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u043E\u0432\u0430\u043D\u043E",
    sectionCount: "{count} \u0441\u0435\u043A\u0446\u0456\u044F(\u0439)",
    showExecutiveSummary: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 Executive Summary",
    franchiseRevenue: {
      title: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0434\u043E\u0445\u043E\u0434\u0456\u0432 \u0444\u0440\u0430\u043D\u0448\u0438\u0437\u0438",
      total: "\u0412\u0441\u044C\u043E\u0433\u043E"
    },
    dragToReorder: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 \u0434\u043B\u044F \u0432\u043F\u043E\u0440\u044F\u0434\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
    resetLayout: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043C\u0430\u043A\u0435\u0442",
    widgets: {
      reset: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u0436\u0435\u0442\u0456\u0432",
      sync_error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u0436\u0435\u0442\u0456\u0432 \u2014 \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437",
      sync_success: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u0436\u0435\u0442\u0456\u0432 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
      migration_done: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0430\u043A\u0435\u0442 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E",
      migration_error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0442\u0438 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0430\u043A\u0435\u0442",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C...",
      saved: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E"
    },
    kassza: {
      bankAccount: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      dailyNet: "\u0414\u0435\u043D\u043D\u0438\u0439 \u043D\u0435\u0442\u0442\u043E",
      dailyStatusTitle: "\u0414\u0435\u043D\u043D\u0438\u0439 \u0441\u0442\u0430\u0442\u0443\u0441",
      expense: "\u0412\u0438\u0442\u0440\u0430\u0442\u0430",
      hoursAgo: "{hours} \u0433\u043E\u0434 \u0442\u043E\u043C\u0443",
      income: "\u041D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      lastTransactions: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0457",
      mainRegister: "\u0413\u043E\u043B\u043E\u0432\u043D\u0430 \u043A\u0430\u0441\u0430",
      minutesAgo: "{minutes} \u0445\u0432 \u0442\u043E\u043C\u0443",
      openedAt: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E \u043E",
      statusClosed: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E",
      statusOpen: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      szhPocket: "\u041A\u0438\u0448\u0435\u043D\u044F \u0421\u0417\u0413",
      szhReportTitle: "\u0417\u0432\u0456\u0442 \u0421\u0417\u0413",
      szhTotal: "\u0420\u0430\u0437\u043E\u043C \u0421\u0417\u0413",
      threePocketTitle: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0442\u0440\u044C\u043E\u0445 \u043A\u0438\u0448\u0435\u043D\u044C",
      toleranceCritical: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      toleranceOk: "OK",
      toleranceTitle: "\u0414\u043E\u043F\u0443\u0441\u043A",
      toleranceWarning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      total: "\u0420\u0430\u0437\u043E\u043C",
      transfer: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437",
      statusNotOpened: "\u041D\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445"
    },
    kpi: {
      grossRevenue: "\u0412\u0430\u043B\u043E\u0432\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      grossRevenueAria: "\u0412\u0430\u043B\u043E\u0432\u0438\u0439 \u0434\u043E\u0445\u0456\u0434 KPI \u0432\u0456\u0434\u0436\u0435\u0442",
      netRevenue: "\u0427\u0438\u0441\u0442\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      netRevenueAria: "\u0427\u0438\u0441\u0442\u0438\u0439 \u0434\u043E\u0445\u0456\u0434 KPI \u0432\u0456\u0434\u0436\u0435\u0442",
      receivables: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
      receivablesAria: "\u0414\u0435\u0431\u0456\u0442\u043E\u0440\u0441\u044C\u043A\u0430 \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C KPI \u0432\u0456\u0434\u0436\u0435\u0442",
      high: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
      payments: "\u041E\u043F\u043B\u0430\u0442\u0438",
      paymentsAria: "\u041E\u043F\u043B\u0430\u0442\u0438 KPI \u0432\u0456\u0434\u0436\u0435\u0442"
    },
    detailedView: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434"
  },
  network: {
    online: "\u041E\u043D\u043B\u0430\u0439\u043D",
    offline: "\u041E\u0444\u043B\u0430\u0439\u043D",
    offlineMode: "\u041E\u0444\u043B\u0430\u0439\u043D \u0440\u0435\u0436\u0438\u043C",
    syncing: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F...",
    lastSync: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044F",
    pendingSync: "\u041E\u0447\u0456\u043A\u0443\u0454 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u0457",
    syncComplete: "\u0421\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
    syncFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u0457",
    minuteAgo: "\u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
    minutesAgo: "\u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443",
    hourAgo: "\u0433\u043E\u0434\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
    hoursAgo: "\u0433\u043E\u0434\u0438\u043D \u0442\u043E\u043C\u0443"
  },
  table: {
    partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
    period: "\u041F\u0435\u0440\u0456\u043E\u0434",
    amount: "\u0421\u0443\u043C\u0430",
    status: "\u0421\u0442\u0430\u0442\u0443\u0441",
    actions: "\u0414\u0456\u0457",
    date: "\u0414\u0430\u0442\u0430",
    type: "\u0422\u0438\u043F",
    description: "\u041E\u043F\u0438\u0441",
    quantity: "\u041A-\u0441\u0442\u044C",
    unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434.",
    vat: "\u041F\u0414\u0412",
    netAmount: "\u041D\u0435\u0442\u0442\u043E",
    grossAmount: "\u0411\u0440\u0443\u0442\u0442\u043E",
    addItem: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E"
  },
  payment: {
    cash: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430",
    card: "\u041A\u0430\u0440\u0442\u043A\u0430",
    transfer: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437",
    method: "\u0421\u043F\u043E\u0441\u0456\u0431 \u043E\u043F\u043B\u0430\u0442\u0438"
  },
  page: {
    allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    allTypes: "\u0412\u0441\u0456 \u0442\u0438\u043F\u0438",
    allCategories: "\u0412\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u044F\u043C\u0438 \u043F\u043E\u0448\u0443\u043A\u0443.",
    noFilterResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u044F\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0443.",
    errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    displayed: "{count} \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
    partnersDisplayed: "{count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
    ordersCount: "{count} \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u044C",
    itemsCount: "{count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
    daysLate: "{count} \u0434\u043D\u0456\u0432 \u0437\u0430\u0442\u0440\u0438\u043C\u043A\u0438",
    machinesCount: "{count} \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457\u0432",
    abandoned: {
      tabTitle: "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      noItems: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      noItemsDesc: "\u0412\u0441\u0435 \u043E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E \u0432\u0447\u0430\u0441\u043D\u043E.",
      totalCount: "{count} \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      daysOverdue: "\u0434\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
      perDay: "\u0434\u0435\u043D\u044C",
      storageFee: "\u041E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u043D\u0430 \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F"
    },
    compensation: {
      tabTitle: "\u041A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F",
      title: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
      description: "\u042F\u043A\u0449\u043E \u043A\u043B\u0456\u0454\u043D\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u0435 \u0430\u0431\u043E \u0432\u0442\u0440\u0430\u0447\u0435\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u0437\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436.",
      rentalId: "ID \u043E\u0440\u0435\u043D\u0434\u0438",
      rentalIdPlaceholder: "\u043D\u0430\u043F\u0440. R-20260401-001",
      amount: "\u0421\u0443\u043C\u0430 (HUF)",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      reasonPlaceholder: "\u043D\u0430\u043F\u0440. \u041A\u043B\u0456\u0454\u043D\u0442 \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u0432\u0442\u0440\u0430\u0447\u0435\u043D\u043E \u043D\u0430 \u0440\u043E\u0431\u043E\u0447\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456...",
      action: "\u0414\u0456\u044F",
      writtenOff: "\u0421\u043F\u0438\u0441\u0430\u043D\u043D\u044F (WRITTEN_OFF)",
      transferredToInventory: "\u041F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434 (TRANSFERRED_TO_INVENTORY)",
      submit: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044E",
      validationError: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0443\u0441\u0456 \u043F\u043E\u043B\u044F \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E."
    },
    afterlife: {
      tabTitle: "\u0420\u0456\u0448\u0435\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u043E\u0457 \u0434\u043E\u043B\u0456",
      pageTitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0436\u0438\u0442\u0442\u0454\u0432\u0438\u043C \u0446\u0438\u043A\u043B\u043E\u043C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      pageSubtitle: "\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u043A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0456\u044F, \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u0449\u043E\u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u043E\u0457 \u0434\u043E\u043B\u0456, \u0433\u0440\u0443\u043F\u043E\u0432\u0435 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
      noItems: "\u041D\u0435\u043C\u0430\u0454 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432",
      scrapTitle: "\u0423\u0442\u0438\u043B\u0456\u0437\u0430\u0446\u0456\u044F",
      repairTitle: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      decisionTitle: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u0440\u0456\u0448\u0435\u043D\u043D\u044F",
      repairs: "\u0420\u0435\u043C\u043E\u043D\u0442\u0438",
      age: "\u0412\u0456\u043A",
      months: "\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
      condition: "\u0421\u0442\u0430\u043D"
    },
    surrender: {
      tabTitle: "\u0414\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      title: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0434\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      description: "\u042F\u043A\u0449\u043E \u043A\u043B\u0456\u0454\u043D\u0442 \u0434\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u043E \u0432\u0456\u0434\u043C\u043E\u0432\u043B\u044F\u0454\u0442\u044C\u0441\u044F \u0432\u0456\u0434 \u043E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F (\u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u043B\u0430\u0442\u0438\u0442\u0438, \u043D\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E), \u0437\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u0437\u0430\u044F\u0432\u0443.",
      rentalId: "ID \u043E\u0440\u0435\u043D\u0434\u0438",
      rentalIdPlaceholder: "\u043D\u0430\u043F\u0440. R-20260401-001",
      statement: "\u0417\u0430\u044F\u0432\u0430",
      statementPlaceholder: "\u0417\u0430\u044F\u0432\u0430 \u043A\u043B\u0456\u0454\u043D\u0442\u0430 \u043F\u0440\u043E \u0434\u043E\u0431\u0440\u043E\u0432\u0456\u043B\u044C\u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F, \u043F\u0440\u0438\u0447\u0438\u043D\u0430...",
      submit: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      validationError: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0443\u0441\u0456 \u043F\u043E\u043B\u044F (\u0437\u0430\u044F\u0432\u0430 \u043C\u0456\u043D. 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432)."
    }
  },
  quotation: {
    draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
    sent: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
    accepted: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
    pendingValue: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
    worksheet: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    validUntil: "\u0414\u0456\u0439\u0441\u043D\u0430 \u0434\u043E",
    amount: "\u0421\u0443\u043C\u0430",
    expiringSoon: "\u0421\u043A\u043E\u0440\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F!",
    gross: "\u0431\u0440\u0443\u0442\u0442\u043E",
    itemsCount: "{count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
    quotationsDisplayed: "{count} \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
    newQuotationInfo: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    newQuotationDesc: '\u0429\u043E\u0431 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E, \u0432\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0456 \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443 "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E". \u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0443\u0442\u044C\u0441\u044F \u0432 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E.',
    notFound: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
    partnerData: "\u0414\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    partnerName: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    phone: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
    relatedWorksheet: "\u041F\u043E\u0432'\u044F\u0437\u0430\u043D\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    itemDescription: "\u041D\u0430\u0437\u0432\u0430",
    unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E",
    vat: "\u041F\u0414\u0412",
    totalColumn: "\u0420\u0430\u0437\u043E\u043C",
    netTotal: "\u041D\u0435\u0442\u0442\u043E \u0440\u0430\u0437\u043E\u043C:",
    vatTotal: "\u041F\u0414\u0412 \u0440\u0430\u0437\u043E\u043C:",
    grossTotal: "\u0411\u0440\u0443\u0442\u0442\u043E \u0440\u0430\u0437\u043E\u043C:",
    netLabel: "\u043D\u0435\u0442\u0442\u043E:",
    customerNote: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043B\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
    internalNote: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044F \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 (\u043D\u0435 \u0432\u0438\u0434\u043D\u0430 \u043A\u043B\u0456\u0454\u043D\u0442\u0443)",
    statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441:",
    createdAtLabel: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E:",
    sentAtLabel: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E:",
    validUntilLabel: "\u0414\u0456\u0439\u0441\u043D\u0430 \u0434\u043E:",
    respondedAtLabel: "\u0414\u0430\u0442\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456:",
    createdByLabel: "\u0421\u0442\u0432\u043E\u0440\u0438\u0432:",
    quotationAmount: "\u0421\u0443\u043C\u0430 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    pdfDownload: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 PDF",
    emailSend: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 email",
    openWorksheet: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    recordAcceptance: "\u0417\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F",
    recordRejection: "\u0417\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
    generateWorksheet: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    acceptTitle: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    acceptConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0437\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 {number}?",
    acceptAfterInfo: "\u041F\u0456\u0441\u043B\u044F \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F \u0441\u0442\u0430\u043D\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430.",
    processing: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430...",
    accept: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438",
    rejectTitle: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    rejectConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0437\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 {number}?",
    rejectionReasonLabel: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    rejectionPlaceholder: "\u041D\u0430\u043F\u0440. \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0438\u0441\u043E\u043A\u0430 \u0446\u0456\u043D\u0430, \u043E\u0431\u0440\u0430\u043D\u043E \u0456\u043D\u0448\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E...",
    reject: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
    generateWorksheetTitle: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    generateWorksheetConfirm: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0437 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 {number}?",
    generateWorksheetInfo: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u044C \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0437 \u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457:",
    partnerLabel: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440:",
    itemCountLabel: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u0439:",
    amountLabel: "\u0421\u0443\u043C\u0430:",
    generating: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F...",
    sendButton: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    sentSuccess: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E.",
    sendFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    acceptedSuccess: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u043E.",
    acceptFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u0442\u044F",
    rejectedSuccess: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E.",
    rejectFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
    worksheetCreated: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E: {number}",
    conversionFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043A\u043E\u043D\u0432\u0435\u0440\u0442\u0430\u0446\u0456\u0457",
    newQuotation: "\u041D\u043E\u0432\u0430 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F",
    editQuotation: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    quotationData: "\u0414\u0430\u043D\u0456 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    validityEnd: "\u041A\u0456\u043D\u0435\u0446\u044C \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u0434\u0456\u0457",
    totalGross: "\u0420\u0430\u0437\u043E\u043C (\u0431\u0440\u0443\u0442\u0442\u043E)",
    addItem: "+ \u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    itemDescriptionPlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u0457...",
    qty: "\u041A-\u0441\u0442\u044C",
    unit: "\u041E\u0434.",
    netPrice: "\u0426\u0456\u043D\u0430 \u043D\u0435\u0442\u0442\u043E",
    grossTotalItem: "\u0411\u0440\u0443\u0442\u0442\u043E \u0440\u0430\u0437\u043E\u043C",
    noItems: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443 {button}.",
    customerVisibleNote: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430, \u0432\u0438\u0434\u0438\u043C\u0430 \u043A\u043B\u0456\u0454\u043D\u0442\u0443",
    customerNotePlaceholder: "\u041D\u0430\u043F\u0440.: \u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0447\u0430\u0441 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F, \u0443\u043C\u043E\u0432\u0438 \u043E\u043F\u043B\u0430\u0442\u0438...",
    internalNotePlaceholder: "\u041D\u0430\u043F\u0440.: \u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0437\u043D\u0438\u0436\u043A\u0438, \u043E\u0431\u0433\u043E\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437 \u043A\u043B\u0456\u0454\u043D\u0442\u043E\u043C...",
    createQuotation: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    saveFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
    atLeastOneItem: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u0443 \u043F\u043E\u0437\u0438\u0446\u0456\u044E!",
    productId: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B:",
    emailLabel: "Email",
    worksheetLabel: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442:",
    sendEmailSubject: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 email: {email}\n\u0422\u0435\u043C\u0430: \u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F - {number}",
    pdfGeneration: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F PDF: {number}",
    version: "\u0412\u0435\u0440\u0441\u0456\u044F",
    versionHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0435\u0440\u0441\u0456\u0439",
    versionOf: "v{current}/{total}",
    currentVersion: "\u043F\u043E\u0442\u043E\u0447\u043D\u0430",
    createNewVersion: "\u041D\u043E\u0432\u0430 \u0432\u0435\u0440\u0441\u0456\u044F",
    newVersionCreated: "\u041D\u043E\u0432\u0443 \u0432\u0435\u0440\u0441\u0456\u044E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E.",
    newVersionFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u0443 \u0432\u0435\u0440\u0441\u0456\u044E",
    quotationNumber: "\u041D\u043E\u043C\u0435\u0440 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    diff: {
      compareVersions: "\u041F\u043E\u0440\u0456\u0432\u043D\u044F\u0442\u0438 \u0432\u0435\u0440\u0441\u0456\u0457",
      versionHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0435\u0440\u0441\u0456\u0439",
      versionN: "v{n}",
      changed: "\u0417\u043C\u0456\u043D\u0435\u043D\u043E",
      added: "\u0414\u043E\u0434\u0430\u043D\u043E",
      removed: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
      noChanges: "\u041C\u0456\u0436 \u0434\u0432\u043E\u043C\u0430 \u0432\u0435\u0440\u0441\u0456\u044F\u043C\u0438 \u043D\u0435\u043C\u0430\u0454 \u0437\u043C\u0456\u043D",
      selectVersions: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0432\u0456 \u0432\u0435\u0440\u0441\u0456\u0457 \u0434\u043B\u044F \u043F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043D\u044F",
      basicInfo: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
      field: "\u041F\u043E\u043B\u0435",
      versions: "\u0412\u0435\u0440\u0441\u0456\u0457"
    },
    status: {
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      sent: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
      accepted: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
      rejected: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
      expired: "\u0417\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F",
      converted: "\u041A\u043E\u043D\u0432\u0435\u0440\u0442\u043E\u0432\u0430\u043D\u043E"
    }
  },
  vehicle: {
    title: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    rentalVehicles: "\u041E\u0440\u0435\u043D\u0434\u043D\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    companyVehicles: "\u0421\u043B\u0443\u0436\u0431\u043E\u0432\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    expiringDocuments: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438, \u0449\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u044E\u0442\u044C\u0441\u044F",
    technicalInspection: "\u0422\u0435\u0445\u043D\u0456\u0447\u043D\u0438\u0439 \u043E\u0433\u043B\u044F\u0434",
    registrationCert: "\u0421\u0432\u0456\u0434\u043E\u0446\u0442\u0432\u043E \u043F\u0440\u043E \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E",
    mtplInsurance: "\u041E\u0421\u0426\u041F\u0412",
    cascoInsurance: "\u041A\u0410\u0421\u041A\u041E",
    highwaySticker: "\u0414\u043E\u0440\u043E\u0436\u043D\u044F \u043D\u0430\u043A\u043B\u0435\u0439\u043A\u0430",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043F\u0440\u0438\u0447\u0435\u043F\u0430\u043C\u0438, \u0430\u0433\u0440\u0435\u0433\u0430\u0442\u043E\u0440\u0430\u043C\u0438, \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430\u043C\u0438",
    newVehicle: "\u041D\u043E\u0432\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431",
    totalVehicles: "\u0412\u0441\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
    rentedOut: "\u0412 \u043E\u0440\u0435\u043D\u0434\u0456",
    expiringIn30Days: "\u0417\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 30 \u0434\u043D\u0456\u0432",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u043E\u043C\u0435\u0440\u043E\u043C, \u043D\u0430\u0437\u0432\u043E\u044E, \u043C\u0430\u0440\u043A\u043E\u044E...",
    allTypes: "\u0412\u0441\u0456 \u0442\u0438\u043F\u0438",
    allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    vehicleColumn: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431",
    technicalExpiry: "\u0422\u0435\u0440\u043C\u0456\u043D \u0442\u0435\u0445\u043E\u0433\u043B\u044F\u0434\u0443",
    registrationExpiry: "\u0422\u0435\u0440\u043C\u0456\u043D \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0457",
    insuranceExpiry: "\u0422\u0435\u0440\u043C\u0456\u043D \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
    operations: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
    loadingVehicles: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443...",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u044F\u043C\u0438 \u043F\u043E\u0448\u0443\u043A\u0443.",
    deleteConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431: {name}?",
    deleteFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431.",
    typeLabels: {
      trailer: "\u041F\u0440\u0438\u0447\u0456\u043F",
      aggregator: "\u0410\u0433\u0440\u0435\u0433\u0430\u0442\u043E\u0440",
      platform: "\u041F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430",
      other: "\u0406\u043D\u0448\u0435"
    },
    statusLabels: {
      active: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
      rented: "\u0412 \u043E\u0440\u0435\u043D\u0434\u0456",
      maintenance: "\u0422\u0435\u0445\u043D\u0456\u0447\u043D\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
      inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439"
    },
    companyTypeLabels: {
      car: "\u041B\u0435\u0433\u043A\u043E\u0432\u0438\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C",
      van: "\u0424\u0443\u0440\u0433\u043E\u043D",
      truck: "\u0412\u0430\u043D\u0442\u0430\u0436\u0456\u0432\u043A\u0430"
    },
    companyStatusLabels: {
      active: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
      in_use: "\u0423 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u0456",
      maintenance: "\u041D\u0430 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u0456",
      inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439"
    },
    fuelLabels: {
      petrol: "\u0411\u0435\u043D\u0437\u0438\u043D",
      diesel: "\u0414\u0438\u0437\u0435\u043B\u044C",
      electric: "\u0415\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u043D\u0438\u0439",
      hybrid: "\u0413\u0456\u0431\u0440\u0438\u0434"
    },
    companySubtitle: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u0435 \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043B\u0435\u0433\u043A\u043E\u0432\u0438\u043C\u0438 \u0442\u0430 \u0432\u0430\u043D\u0442\u0430\u0436\u043D\u0438\u043C\u0438 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044F\u043C\u0438",
    inUse: "\u0423 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u0456",
    vehicleNotFound: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    basicInfo: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
    licensePlate: "\u041D\u043E\u043C\u0435\u0440\u043D\u0438\u0439 \u0437\u043D\u0430\u043A",
    brandModel: "\u041C\u0430\u0440\u043A\u0430 / \u041C\u043E\u0434\u0435\u043B\u044C",
    yearOfManufacture: "\u0420\u0456\u043A \u0432\u0438\u043F\u0443\u0441\u043A\u0443",
    fuelType: "\u0422\u0438\u043F \u043F\u0430\u043B\u0438\u0432\u0430",
    odometer: "\u041E\u0434\u043E\u043C\u0435\u0442\u0440",
    assignedTo: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
    expiryAndInsurance: "\u0422\u0435\u0440\u043C\u0456\u043D\u0438 \u0434\u0456\u0457 \u0442\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
    insurance: "\u0421\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
    recordData: "\u0414\u0430\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0443",
    lastModified: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
    editCompanyVehicle: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0441\u043B\u0443\u0436\u0431\u043E\u0432\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    newCompanyVehicle: "\u041D\u043E\u0432\u0438\u0439 \u0441\u043B\u0443\u0436\u0431\u043E\u0432\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    editVehicleData: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u0430\u043D\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443",
    registerNewCompanyVehicle: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0441\u043B\u0443\u0436\u0431\u043E\u0432\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    licensePlateRequired: "\u041D\u043E\u043C\u0435\u0440\u043D\u0438\u0439 \u0437\u043D\u0430\u043A \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    nameRequired: "\u041D\u0430\u0437\u0432\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
    brandRequired: "\u041C\u0430\u0440\u043A\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
    kgfbExpiryRequired: "\u0422\u0435\u0440\u043C\u0456\u043D \u041E\u0421\u0426\u041F\u0412 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    technicalExpiryRequired: "\u0422\u0435\u0440\u043C\u0456\u043D \u0442\u0435\u0445\u043E\u0433\u043B\u044F\u0434\u0443 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    registrationExpiryRequired: "\u0422\u0435\u0440\u043C\u0456\u043D \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0457 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    insuranceExpiryRequired: "\u0422\u0435\u0440\u043C\u0456\u043D \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    invalidLicensePlate: "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u043D\u043E\u0433\u043E \u0437\u043D\u0430\u043A\u0430 (\u043D\u0430\u043F\u0440. ABC-123)",
    expiryDatesAndInsurance: "\u0422\u0435\u0440\u043C\u0456\u043D\u0438 \u0434\u0456\u0457 \u0442\u0430 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
    designation: "\u041D\u0430\u0437\u0432\u0430",
    brandLabel: "\u041C\u0430\u0440\u043A\u0430",
    modelLabel: "\u041C\u043E\u0434\u0435\u043B\u044C",
    statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441",
    odometerReading: "\u041F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u043E\u0434\u043E\u043C\u0435\u0442\u0440\u0430",
    assignedStore: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043C\u0430\u0433\u0430\u0437\u0438\u043D",
    noAssignment: "-- \u0411\u0435\u0437 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F --",
    additionalInfo: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F...",
    savingInProgress: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    rentalHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    loadingHistory: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0456\u0441\u0442\u043E\u0440\u0456\u0457...",
    noRentalHistory: "\u041D\u0435\u043C\u0430\u0454 \u0456\u0441\u0442\u043E\u0440\u0456\u0457 \u043E\u0440\u0435\u043D\u0434\u0438.",
    backToList: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
    expiryDates: "\u0422\u0435\u0440\u043C\u0456\u043D\u0438 \u0434\u0456\u0457",
    editVehicle: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    addNewVehicle: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    registerNewRentalVehicle: "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043E\u0440\u0435\u043D\u0434\u043D\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
    expiringDocsSubtitle: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0437 \u0442\u0435\u0440\u043C\u0456\u043D\u043E\u043C \u0434\u0456\u0457 \u0434\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u043D\u0438\u0445 \u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u043E\u0432\u0438\u0445 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0445 \u0437\u0430\u0441\u043E\u0431\u0456\u0432",
    within30Days: "\u041F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 30 \u0434\u043D\u0456\u0432",
    within60Days: "\u041F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 60 \u0434\u043D\u0456\u0432",
    allMonitored: "\u0423\u0441\u0456 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0443\u0432\u0430\u043D\u0456",
    allFilter: "\u0423\u0441\u0456",
    allCategories: "\u0423\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
    allDocuments: "\u0423\u0441\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
    noExpiringDocs: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0437 \u0442\u0435\u0440\u043C\u0456\u043D\u043E\u043C \u0434\u0456\u0457 \u0434\u043B\u044F \u043E\u0431\u0440\u0430\u043D\u0438\u0445 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432.",
    companyLabel: "\u0421\u043B\u0443\u0436\u0431\u043E\u0432\u0438\u0439",
    rentalLabel: "\u041E\u0440\u0435\u043D\u0434\u043D\u0438\u0439",
    expiredDaysAgo: "\u0422\u0435\u0440\u043C\u0456\u043D \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F {days} \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443",
    expiresInDays: "\u0427\u0435\u0440\u0435\u0437 {days} \u0434\u043D\u0456\u0432",
    typeLabel: "\u0422\u0438\u043F",
    additionalVehicleInfo: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F \u043F\u0440\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431...",
    placeholder: {
      brand: "\u043D\u0430\u043F\u0440. Skoda",
      companyName: "\u043D\u0430\u043F\u0440. \u0421\u043B\u0443\u0436\u0431\u043E\u0432\u0438\u0439 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C 1",
      model: "\u043D\u0430\u043F\u0440. Octavia",
      rentalName: "\u043D\u0430\u043F\u0440. \u041F\u0440\u0438\u0447\u0456\u043F 1"
    }
  },
  user: {
    title: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C\u0438 \u0442\u0430 \u0434\u043E\u0437\u0432\u043E\u043B\u0430\u043C\u0438",
    loadingUsers: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432...",
    loadingUser: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430...",
    errorOccurred: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    backToDashboard: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u043F\u0430\u043D\u0435\u043B\u0456",
    roles: "\u0420\u043E\u043B\u0456",
    newUser: "+ \u041D\u043E\u0432\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
    totalUsers: "\u0412\u0441\u044C\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C'\u044F\u043C, email...",
    allRoles: "\u0412\u0441\u0456 \u0440\u043E\u043B\u0456",
    allStores: "\u0412\u0441\u0456 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0438",
    userColumn: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
    roleColumn: "\u0420\u043E\u043B\u044C",
    createdAtColumn: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    usersDisplayed: "{count} \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
    notFound: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    suspend: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438",
    activate: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
    tabOverview: "\u041E\u0433\u043B\u044F\u0434",
    tabActivity: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C",
    basicData: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
    email: "Email",
    role: "\u0420\u043E\u043B\u044C",
    tenantId: "ID \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
    locationId: "ID \u043B\u043E\u043A\u0430\u0446\u0456\u0457",
    systemInfo: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
    identifier: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440:",
    createdLabel: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E:",
    modifiedLabel: "\u0417\u043C\u0456\u043D\u0435\u043D\u043E:",
    activityLog: "\u0416\u0443\u0440\u043D\u0430\u043B \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0456",
    profileUpdated: "\u041F\u0440\u043E\u0444\u0456\u043B\u044C \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    userCreated: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    editUser: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    newUserTitle: "\u041D\u043E\u0432\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
    savingLabel: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    createLabel: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
    nameRequired: "\u0406\u043C'\u044F *",
    emailRequired: "Email \u0430\u0434\u0440\u0435\u0441\u0430 *",
    passwordChange: "\u0417\u043C\u0456\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F",
    newPassword: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    passwordRequired: "\u041F\u0430\u0440\u043E\u043B\u044C *",
    minChars: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C 8 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
    passwordLeaveEmpty: "\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u044F\u043A\u0449\u043E \u043D\u0435 \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u0437\u043C\u0456\u043D\u044E\u0432\u0430\u0442\u0438",
    confirmPassword: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F",
    confirmPasswordRequired: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F *",
    passwordAgain: "\u041F\u0430\u0440\u043E\u043B\u044C \u0449\u0435 \u0440\u0430\u0437",
    roleAndLocation: "\u0420\u043E\u043B\u044C \u0442\u0430 \u043B\u043E\u043A\u0430\u0446\u0456\u044F",
    roleRequired: "\u0420\u043E\u043B\u044C *",
    locationOptional: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D / \u041B\u043E\u043A\u0430\u0446\u0456\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    notSpecified: "\u041D\u0435 \u0432\u043A\u0430\u0437\u0430\u043D\u043E",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    createUser: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    saveError: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F.",
    namePlaceholder: "\u0406\u0432\u0430\u043D \u041F\u0435\u0442\u0440\u0435\u043D\u043A\u043E",
    emailPlaceholder: "user@example.com",
    validation: {
      emailRequired: "Email \u0430\u0434\u0440\u0435\u0441\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
      emailInvalid: "\u041D\u0435\u0432\u0456\u0440\u043D\u0430 email \u0430\u0434\u0440\u0435\u0441\u0430",
      nameRequired: "\u0406\u043C'\u044F \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
      roleRequired: "\u0412\u0438\u0431\u0456\u0440 \u0440\u043E\u043B\u0456 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
      passwordRequired: "\u041F\u0430\u0440\u043E\u043B\u044C \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
      passwordMinLength: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C 8 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
      passwordMismatch: "\u041F\u0430\u0440\u043E\u043B\u0456 \u043D\u0435 \u0437\u0431\u0456\u0433\u0430\u044E\u0442\u044C\u0441\u044F",
      taxFormat: "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 (8 \u0430\u0431\u043E 11 \u0446\u0438\u0444\u0440)",
      taxChecksum: "\u041D\u0435\u0432\u0456\u0440\u043D\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u0430 \u0446\u0438\u0444\u0440\u0430 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430",
      phoneFormat: "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
      postalFormat: "\u041F\u043E\u0448\u0442\u043E\u0432\u0438\u0439 \u0456\u043D\u0434\u0435\u043A\u0441 \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 4 \u0446\u0438\u0444\u0440\u0438"
    },
    roleLabels: {
      OPERATOR: "\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440",
      TECHNIKUS: "\u0422\u0435\u0445\u043D\u0456\u043A",
      BOLTVEZETO: "\u041A\u0435\u0440\u0456\u0432\u043D\u0438\u043A \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443",
      ACCOUNTANT: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440",
      PARTNER_OWNER: "\u0412\u043B\u0430\u0441\u043D\u0438\u043A-\u043F\u0430\u0440\u0442\u043D\u0435\u0440",
      CENTRAL_ADMIN: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0438\u0439 \u0430\u0434\u043C\u0456\u043D",
      DEVOPS_ADMIN: "DevOps \u0430\u0434\u043C\u0456\u043D",
      SUPER_ADMIN: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u0439 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    roleDescriptions: {
      OPERATOR: "\u041A\u0430\u0441\u0430, \u043F\u0440\u043E\u0434\u0430\u0436\u0456, \u043E\u0440\u0435\u043D\u0434\u0430",
      TECHNIKUS: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043D\u0430\u0440\u044F\u0434\u0430\u043C\u0438, \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0456 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457",
      BOLTVEZETO: "\u0420\u043E\u0431\u043E\u0442\u0430 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443, \u0437\u0432\u0456\u0442\u0438, \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C\u0438",
      ACCOUNTANT: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0456 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0457, \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432, \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0438",
      PARTNER_OWNER: "\u0414\u043E\u0441\u0442\u0443\u043F \u043D\u0430 \u0440\u0456\u0432\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430, \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0438",
      CENTRAL_ADMIN: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0435 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0443\u0432\u0430\u043D\u043D\u044F, \u0432\u0441\u0456 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0438",
      DEVOPS_ADMIN: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F, \u0456\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430",
      SUPER_ADMIN: "\u041F\u043E\u0432\u043D\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0432\u0441\u0456\u0445 \u0444\u0443\u043D\u043A\u0446\u0456\u0439"
    },
    statusLabels: {
      ACTIVE: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      INACTIVE: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      LOCKED: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
      PENDING_VERIFICATION: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0438"
    },
    rolesAndPermissions: "\u0420\u043E\u043B\u0456 \u0442\u0430 \u0434\u043E\u0437\u0432\u043E\u043B\u0438",
    rbacDescription: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F RBAC (8-\u0440\u0456\u0432\u043D\u0435\u0432\u0430 \u0456\u0454\u0440\u0430\u0440\u0445\u0456\u044F \u0440\u043E\u043B\u0435\u0439)",
    rbacInfoBanner: "\u0420\u043E\u043B\u0456 \u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0456 \u0432 \u0441\u0435\u0440\u0432\u0435\u0440\u043D\u0456\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u0456 RBAC (ADR-032). \u0414\u043E\u0437\u0432\u043E\u043B\u0438 \u043C\u043E\u0436\u043D\u0430 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0442\u0438, \u0430\u043B\u0435 \u0437\u043C\u0456\u043D\u0438 \u0432\u043D\u043E\u0441\u044F\u0442\u044C\u0441\u044F \u0432 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u0457 \u0441\u0438\u0441\u0442\u0435\u043C\u0438.",
    rolesCount: "\u0420\u043E\u043B\u0456 ({count})",
    level: "\u0420\u0456\u0432\u0435\u043D\u044C {level}",
    code: "\u041A\u043E\u0434:",
    hierarchyLevel: "\u0420\u0456\u0432\u0435\u043D\u044C \u0456\u0454\u0440\u0430\u0440\u0445\u0456\u0457:",
    permissionsLabel: "\u0414\u043E\u0437\u0432\u043E\u043B\u0438:",
    typeLabel: "\u0422\u0438\u043F:",
    systemRole: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430 \u0440\u043E\u043B\u044C",
    permissionsCount: "\u0414\u043E\u0437\u0432\u043E\u043B\u0438 ({count})",
    selectRolePrompt: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u043E\u043B\u044C \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443 \u0434\u0435\u0442\u0430\u043B\u0435\u0439."
  },
  dunning: {
    title: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
    level: {
      none: "\u041D\u0435\u043C\u0430\u0454",
      reminder: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
      warning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      finalNotice: "\u041E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F"
    },
    currentLevel: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0440\u0456\u0432\u0435\u043D\u044C",
    escalate: "\u041F\u0456\u0434\u0432\u0438\u0449\u0438\u0442\u0438 \u0440\u0456\u0432\u0435\u043D\u044C",
    escalateSuccess: "\u0420\u0456\u0432\u0435\u043D\u044C \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0456\u0434\u0432\u0438\u0449\u0435\u043D\u043E",
    history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u044C",
    sentAt: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
    nextEscalation: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u043F\u0456\u0434\u0432\u0438\u0449\u0435\u043D\u043D\u044F",
    overdueDays: "\u0414\u043D\u0456\u0432 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
    days: "\u0434\u043D\u0456\u0432",
    amount: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
    escalationCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u044C",
    noHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u044C \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u044F"
  },
  invoicePage: {
    invoiceNumber: "\u041D\u043E\u043C\u0435\u0440 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    issueDate: "\u0414\u0430\u0442\u0430 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
    dueDate: "\u0422\u0435\u0440\u043C\u0456\u043D \u043E\u043F\u043B\u0430\u0442\u0438",
    amount: "\u0421\u0443\u043C\u0430",
    arrears: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C: {amount}",
    loadingInvoices: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432...",
    errorOccurred: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u043E\u0431\u0440\u0430\u043D\u0438\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438",
    invoiceCount: "{count} \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432"
  },
  contract: {
    title: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0438",
    subtitle: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0438 \u043E\u0440\u0435\u043D\u0434\u0438 \u0442\u0430 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
    contract: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440",
    goToRentals: "\u041E\u0440\u0435\u043D\u0434\u0430",
    activeDeposit: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0430",
    activeValue: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u043E\u043C\u0435\u0440\u043E\u043C, \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u043C, \u043E\u0440\u0435\u043D\u0434\u043E\u044E...",
    deposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    depositPaid: "\u0421\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
    depositMissing: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u044F",
    depositNotPaid: "\u041D\u0435 \u0441\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
    depositAmount: "\u0421\u0443\u043C\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    contractsDisplayed: "{count} \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0456\u0432 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
    autoGenerationTitle: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
    autoGenerationDesc: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0438 \u0441\u0442\u0432\u043E\u0440\u044E\u044E\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043F\u0440\u0438 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043E\u0440\u0435\u043D\u0434\u0438. \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F PDF \u0442\u0430 \u0434\u0440\u0443\u043A \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u0434\u0435\u0442\u0430\u043B\u0435\u0439.",
    notFound: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
    pdfDownload: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 PDF",
    pdfGeneration: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F PDF",
    pdfDownloading: "PDF \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F...",
    sign: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438",
    partnerData: "\u0414\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    partnerName: "\u0406\u043C'\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    idNumber: "\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u0441\u0432\u0456\u0434\u0447\u0435\u043D\u043D\u044F",
    contractPeriod: "\u0422\u0435\u0440\u043C\u0456\u043D \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
    startDate: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
    expectedEndDate: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430 \u0434\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
    expectedEnd: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0435 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
    actualEndDate: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
    activeContractMessage: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u0434\u043E\u0433\u043E\u0432\u0456\u0440 - \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
    dailyRate: "\u0414\u0435\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430",
    productId: "\u0422\u043E\u0432\u0430\u0440",
    termsAndNotes: "\u0423\u043C\u043E\u0432\u0438 \u0442\u0430 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
    contractTerms: "\u0423\u043C\u043E\u0432\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
    signedAt: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043E",
    signatures: "\u041F\u0456\u0434\u043F\u0438\u0441\u0438",
    partnerSignature: "\u041F\u0456\u0434\u043F\u0438\u0441 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
    staffSignature: "\u041F\u0456\u0434\u043F\u0438\u0441 \u0441\u043F\u0456\u0432\u0440\u043E\u0431\u0456\u0442\u043D\u0438\u043A\u0430",
    contractAmount: "\u0421\u0443\u043C\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
    openRental: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443",
    recordSignature: "\u0417\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0456\u0434\u043F\u0438\u0441",
    editContract: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0433\u043E\u0432\u0456\u0440",
    contractData: "\u0414\u0430\u043D\u0456 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
    duration: "\u0422\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C",
    financialData: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0456 \u0434\u0430\u043D\u0456",
    termsPlaceholder: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0456 \u0443\u043C\u043E\u0432\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443...",
    notesPlaceholder: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0438...",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    datesRequired: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456!",
    saveFailed: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
    status: {
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
    },
    type: {
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      sales: "\u041F\u0440\u043E\u0434\u0430\u0436"
    }
  },
  product: {
    title: "\u0422\u043E\u0432\u0430\u0440\u0438",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0430\u043C\u0438, \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0430\u043C\u0438 \u0442\u0430 \u043E\u0440\u0435\u043D\u0434\u043D\u0438\u043C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F\u043C",
    newProduct: "\u041D\u043E\u0432\u0438\u0439 \u0442\u043E\u0432\u0430\u0440",
    newProductTitle: "\u041D\u043E\u0432\u0438\u0439 \u0442\u043E\u0432\u0430\u0440",
    newProductSubtitle: "\u0412\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u0442\u043E\u0432\u0430\u0440\u0443",
    editProduct: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0442\u043E\u0432\u0430\u0440",
    productNotFound: "\u0422\u043E\u0432\u0430\u0440 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
    identifiers: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440\u0438",
    sku: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B (\u0432\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456\u0439)",
    skuRequired: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B (\u0432\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456\u0439) *",
    skuOptional: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B (\u0432\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456\u0439) \u2014 \u0433\u0435\u043D\u0435\u0440\u0443\u0454\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E, \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C",
    skuAutoPlaceholder: "KGC-{year}-####",
    internalCodeSource: {
      label: "\u0414\u0436\u0435\u0440\u0435\u043B\u043E \u0432\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044C\u043E\u0433\u043E \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0430",
      AUTO_GENERATED: "\u0410\u0432\u0442\u043E\u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F (KGC-{year}-####)",
      SUPPLIER_FGS: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 FGS",
      SUPPLIER_MAV: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 MAV"
    },
    barcode: "\u0428\u0442\u0440\u0438\u0445-\u043A\u043E\u0434 (EAN)",
    manufacturerCode: "\u041A\u043E\u0434 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0430",
    manufacturerCodeShort: "\u041A\u043E\u0434 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0430",
    manufacturerPartNumber: "\u0417\u0430\u0432\u043E\u0434\u0441\u044C\u043A\u0438\u0439 \u0430\u0440\u0442\u0438\u043A\u0443\u043B",
    manufacturerPartNumberShort: "\u0417\u0430\u0432\u043E\u0434\u0441\u044C\u043A\u0438\u0439 \u0430\u0440\u0442.",
    locationCode: "\u041A\u043E\u0434 \u043C\u0456\u0441\u0446\u044F (\u0421-\u041F-\u041A)",
    productDetails: "\u0414\u0430\u043D\u0456 \u0442\u043E\u0432\u0430\u0440\u0443",
    productName: "\u041D\u0430\u0437\u0432\u0430 *",
    productNamePlaceholder: "Makita DHP481RTJ \u0430\u043A\u0443\u043C\u0443\u043B\u044F\u0442\u043E\u0440\u043D\u0438\u0439 \u0443\u0434\u0430\u0440\u043D\u0438\u0439 \u0434\u0440\u0438\u043B\u044C",
    shortName: "\u041A\u043E\u0440\u043E\u0442\u043A\u0430 \u043D\u0430\u0437\u0432\u0430",
    brand: "\u0411\u0440\u0435\u043D\u0434",
    typeModel: "\u0422\u0438\u043F/\u041C\u043E\u0434\u0435\u043B\u044C",
    supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
    supplierName: "\u041D\u0430\u0437\u0432\u0430 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430",
    supplierCode: "\u041A\u043E\u0434 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430",
    selectPlaceholder: "-- \u041E\u0431\u0435\u0440\u0456\u0442\u044C --",
    description: "\u041E\u043F\u0438\u0441",
    descriptionPlaceholder: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u043E\u043F\u0438\u0441 \u0442\u043E\u0432\u0430\u0440\u0443...",
    pricing: "\u0426\u0456\u043D\u043E\u0443\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
    purchasePriceNet: "\u0426\u0456\u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456 (\u043D\u0435\u0442\u0442\u043E)",
    sellingPriceNet: "\u0426\u0456\u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 (\u043D\u0435\u0442\u0442\u043E)",
    sellingPriceGross: "\u0426\u0456\u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 (\u0431\u0440\u0443\u0442\u0442\u043E)",
    vatRate: "\u0421\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412",
    calculatedMargin: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0430 \u043C\u0430\u0440\u0436\u0430: <strong>{percent}%</strong>",
    stockSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    minStockLevel: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u0456\u0432\u0435\u043D\u044C \u0437\u0430\u043F\u0430\u0441\u0443",
    reorderQuantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
    rentalSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    dailyRateFt: "\u0414\u0435\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 (HUF)",
    weeklyRateFt: "\u0422\u0438\u0436\u043D\u0435\u0432\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 (HUF)",
    monthlyRateFt: "\u041C\u0456\u0441\u044F\u0447\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 (HUF)",
    depositAmountFt: "\u0421\u0443\u043C\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0438 (HUF)",
    creating: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F...",
    createProduct: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0442\u043E\u0432\u0430\u0440",
    savingChanges: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    nameRequired: "\u041D\u0430\u0437\u0432\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430!",
    skuRequiredAlert: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439!",
    errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: {message}",
    sale: "\u041F\u0440\u043E\u0434\u0430\u0436",
    tabs: {
      overview: "\u041E\u0433\u043B\u044F\u0434",
      stock: "\u0417\u0430\u043F\u0430\u0441\u0438",
      pricing: "\u0426\u0456\u043D\u0438",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      components: "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0438",
      history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F"
    },
    explodedView: {
      title: "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0438 (BOM)",
      addComponent: "\u0414\u043E\u0434\u0430\u0442\u0438",
      noComponents: "\u0414\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443 \u043D\u0435 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u043E \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0456\u0432.",
      componentName: "\u041D\u0430\u0437\u0432\u0430 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430",
      quantityPerUnit: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C/\u0448\u0442",
      unitCost: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u0448\u0442",
      totalCost: "\u0412\u0441\u044C\u043E\u0433\u043E",
      totalBomCost: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C BOM",
      marginSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u043C\u0430\u0440\u0436\u0456",
      searchProduct: "\u041F\u043E\u0448\u0443\u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443"
    },
    basicData: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
    noSupplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A \u043D\u0435 \u0432\u043A\u0430\u0437\u0430\u043D\u0438\u0439",
    lastOrder: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
    lastPurchasePrice: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0446\u0456\u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456",
    quickOverview: "\u0428\u0432\u0438\u0434\u043A\u0438\u0439 \u043E\u0433\u043B\u044F\u0434",
    inStock: "\u041D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456:",
    reserved: "\u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E:",
    margin: "\u041C\u0430\u0440\u0436\u0430:",
    goodsReceipt: "\u041F\u0440\u0438\u0439\u043E\u043C \u0442\u043E\u0432\u0430\u0440\u0443",
    movements: "\u0420\u0443\u0445\u0438",
    startRental: "\u041F\u043E\u0447\u0430\u0442\u0438 \u043E\u0440\u0435\u043D\u0434\u0443",
    stockData: "\u0414\u0430\u043D\u0456 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
    totalStock: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0437\u0430\u043F\u0430\u0441:",
    available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E:",
    minimumLevel: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u0456\u0432\u0435\u043D\u044C:",
    placement: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
    notSpecified: "\u041D\u0435 \u0432\u043A\u0430\u0437\u0430\u043D\u043E",
    locationCodeFormat: "\u0424\u043E\u0440\u043C\u0430\u0442 \u043A\u043E\u0434\u0443 \u043C\u0456\u0441\u0446\u044F: <strong>\u0421\u043A\u043B\u0430\u0434 - \u041F\u043E\u043B\u0438\u0446\u044F - \u041A\u043E\u0440\u043E\u0431\u043A\u0430</strong>",
    locationCodeExample: "\u041F\u0440\u0438\u043A\u043B\u0430\u0434: A-02-03 = \u0421\u043A\u043B\u0430\u0434 A, \u043F\u043E\u043B\u0438\u0446\u044F 2, \u043A\u043E\u0440\u043E\u0431\u043A\u0430 3",
    lowStockWarning: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439 \u0440\u0456\u0432\u0435\u043D\u044C \u0437\u0430\u043F\u0430\u0441\u0443!",
    lowStockDescription: "\u0417\u0430\u043F\u0430\u0441 ({current} \u0448\u0442.) \u043D\u0438\u0436\u0447\u0435 \u043C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0440\u0456\u0432\u043D\u044F ({min} \u0448\u0442.). \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F: {reorder} \u0448\u0442.",
    prices: "\u0426\u0456\u043D\u0438",
    marginCalculation: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043C\u0430\u0440\u0436\u0456",
    marginFt: "\u041C\u0430\u0440\u0436\u0430 (HUF):",
    marginPercent: "\u041C\u0430\u0440\u0436\u0430 (%):",
    marginFormula: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043C\u0430\u0440\u0436\u0456: (\u041F\u0440\u043E\u0434\u0430\u0436 - \u0417\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044F) / \u0417\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044F x 100",
    rentalRates: "\u0422\u0430\u0440\u0438\u0444\u0438 \u043E\u0440\u0435\u043D\u0434\u0438",
    dailyRate: "\u0414\u0435\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430:",
    weeklyRate: "\u0422\u0438\u0436\u043D\u0435\u0432\u0430 \u0441\u0442\u0430\u0432\u043A\u0430:",
    monthlyRate: "\u041C\u0456\u0441\u044F\u0447\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 (30 \u0434\u043D\u0456\u0432):",
    depositAmount: "\u0421\u0443\u043C\u0430 \u0437\u0430\u0441\u0442\u0430\u0432\u0438:",
    rentalStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043E\u0440\u0435\u043D\u0434\u0438",
    totalMachines: "\u0412\u0441\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F:",
    rentedOut: "\u0412 \u043E\u0440\u0435\u043D\u0434\u0456:",
    availableForRental: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u0438:",
    startNewRental: "\u041F\u043E\u0447\u0430\u0442\u0438 \u043D\u043E\u0432\u0443 \u043E\u0440\u0435\u043D\u0434\u0443",
    history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F",
    productUpdated: "\u0414\u0430\u043D\u0456 \u0442\u043E\u0432\u0430\u0440\u0443 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    lastPurchase: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044F - {price}",
    productCreated: "\u0422\u043E\u0432\u0430\u0440 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E ({user})",
    statusAndCategory: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0442\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
    currentStock: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0430\u0441: <strong>{total} \u0448\u0442.</strong> (\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E: {available} \u0448\u0442., \u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E: {reserved} \u0448\u0442.)",
    stats: {
      total: "\u0412\u0441\u044C\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
      lowStock: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
      outOfStock: "\u041D\u0435\u043C\u0430\u0454 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456",
      stockValue: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0437\u0430\u043F\u0430\u0441\u0456\u0432"
    },
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E, \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C, \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u043E\u043C, \u0431\u0440\u0435\u043D\u0434\u043E\u043C...",
    allCategories: "\u0412\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
    allStatuses: "\u0412\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    allSuppliers: "\u0412\u0441\u0456 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438",
    filter: {
      brand: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0437\u0430 \u0431\u0440\u0435\u043D\u0434\u043E\u043C",
      allBrands: "\u0412\u0441\u0456 \u0431\u0440\u0435\u043D\u0434\u0438"
    },
    lowStockOnly: "\u0422\u0456\u043B\u044C\u043A\u0438 \u043D\u0438\u0437\u044C\u043A\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
    tableHeaders: {
      product: "\u0422\u043E\u0432\u0430\u0440",
      category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
      barcode: "\u0428\u0442\u0440\u0438\u0445-\u043A\u043E\u0434",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
      netPrice: "\u0426\u0456\u043D\u0430 \u043D\u0435\u0442\u0442\u043E",
      grossPrice: "\u0426\u0456\u043D\u0430 \u0431\u0440\u0443\u0442\u0442\u043E",
      stock: "\u0417\u0430\u043F\u0430\u0441",
      status: "\u0421\u0442\u0430\u0442\u0443\u0441"
    },
    stockBadge: {
      none: "\u041D\u0435\u043C\u0430\u0454",
      low: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
      ok: "OK"
    },
    detailsButton: "\u0414\u0435\u0442\u0430\u043B\u0456",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u044F\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u0446\u0456\u0457.",
    displayedCount: "{count} \u0442\u043E\u0432\u0430\u0440\u0456\u0432 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
    import: {
      imported: "\u0406\u043C\u043F\u043E\u0440\u0442\u043E\u0432\u0430\u043D\u043E",
      updated: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
      skipped: "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E",
      totalRows: "\u0423\u0441\u044C\u043E\u0433\u043E \u0440\u044F\u0434\u043A\u0456\u0432"
    },
    categoriesLoadError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457.",
    noCategories: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456."
  },
  kb: {
    title: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0431\u0430\u0437\u043E\u044E \u0437\u043D\u0430\u043D\u044C",
    subtitle: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F, \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0442\u0430 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0435\u0439",
    newArticle: "\u041D\u043E\u0432\u0430 \u0441\u0442\u0430\u0442\u0442\u044F",
    loadingArticles: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0435\u0439...",
    noArticles: "\u041D\u0435\u043C\u0430\u0454 \u0441\u0442\u0430\u0442\u0435\u0439",
    createNewArticle: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u0443 \u0441\u0442\u0430\u0442\u0442\u044E",
    editArticle: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0441\u0442\u0430\u0442\u0442\u044E",
    articleTitle: "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A *",
    content: "\u0417\u043C\u0456\u0441\u0442 (Markdown) *",
    status: "\u0421\u0442\u0430\u0442\u0443\u0441",
    tags: "\u0422\u0435\u0433\u0438",
    addTag: "\u0414\u043E\u0434\u0430\u0442\u0438",
    searchTitle: "\u0411\u0430\u0437\u0430 \u0437\u043D\u0430\u043D\u044C",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0441\u0442\u0430\u0442\u0435\u0439...",
    searchInKb: "\u041F\u043E\u0448\u0443\u043A \u0443 \u0431\u0430\u0437\u0456 \u0437\u043D\u0430\u043D\u044C...",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
    tryOtherSearch: "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0456\u043D\u0448\u0456 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u0457 \u043F\u043E\u0448\u0443\u043A\u0443",
    feedbackThanks: "\u0414\u044F\u043A\u0443\u0454\u043C\u043E \u0437\u0430 \u0432\u0456\u0434\u0433\u0443\u043A!",
    wasHelpful: "\u0427\u0438 \u0431\u0443\u043B\u0430 \u0446\u044F \u0441\u0442\u0430\u0442\u0442\u044F \u043A\u043E\u0440\u0438\u0441\u043D\u043E\u044E?",
    helpful: "\u041A\u043E\u0440\u0438\u0441\u043D\u0430",
    notHelpful: "\u041D\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043B\u0430",
    helpfulCount: "\u043A\u043E\u0440\u0438\u0441\u043D\u0430",
    notHelpfulCount: "\u043D\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043B\u0430",
    statusDraft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
    statusPublished: "\u041E\u043F\u0443\u0431\u043B\u0456\u043A\u043E\u0432\u0430\u043D\u043E",
    statusArchived: "\u0410\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u043E",
    deleteButton: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    titlePlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0441\u0442\u0430\u0442\u0442\u0456...",
    contentPlaceholder: "\u0417\u043C\u0456\u0441\u0442 \u0441\u0442\u0430\u0442\u0442\u0456 \u0443 \u0444\u043E\u0440\u043C\u0430\u0442\u0456 Markdown...",
    category: {
      berles: "\u041E\u0440\u0435\u043D\u0434\u0430",
      szerviz: "\u0421\u0435\u0440\u0432\u0456\u0441",
      penzugy: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
      rendszer: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430",
      altalanos: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0435"
    }
  },
  sms: {
    title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F SMS",
    sendTab: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 SMS",
    historyTab: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F",
    templatesTab: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438",
    phonePlaceholder: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 (+36...)",
    messagePlaceholder: "\u0422\u0435\u043A\u0441\u0442 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F (\u043C\u0430\u043A\u0441. 480 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432)",
    charCount: "{count}/480 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
    sending: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0430...",
    send: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
    sentSuccess: "SMS \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E!",
    historyTitle: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F SMS ({count})",
    noRecords: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 SMS.",
    directionOutbound: "\u0412\u0438\u0445\u0456\u0434\u043D\u0456",
    directionInbound: "\u0412\u0445\u0456\u0434\u043D\u0456",
    newTemplate: "\u041D\u043E\u0432\u0438\u0439 \u0448\u0430\u0431\u043B\u043E\u043D",
    templateName: "\u041D\u0430\u0437\u0432\u0430 \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
    templateBody: "\u0422\u0435\u043A\u0441\u0442 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 (\u0437\u043C\u0456\u043D\u043D\u0456: {gep}, {datum}, {idopont}, {ml_szam})",
    templateVariables: "\u0417\u043C\u0456\u043D\u043D\u0456 (\u0447\u0435\u0440\u0435\u0437 \u043A\u043E\u043C\u0443: gep,datum,idopont)",
    templateActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    templateSaving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    templateSave: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D",
    templatesTitle: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438 ({count})",
    noTemplates: "\u041D\u0435\u043C\u0430\u0454 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432.",
    activeLabel: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    inactiveLabel: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    typeCustom: "\u0414\u043E\u0432\u0456\u043B\u044C\u043D\u0438\u0439",
    typeBookingConfirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
    typeRentalExpiry: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    typeServiceReady: "\u0421\u0435\u0440\u0432\u0456\u0441 \u0433\u043E\u0442\u043E\u0432\u0438\u0439",
    typeRentalReminder: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u043E \u043E\u0440\u0435\u043D\u0434\u0443",
    backToDashboard: "\u041D\u0430 \u0433\u043E\u043B\u043E\u0432\u043D\u0443",
    dashboardTitle: "SMS \u0426\u0435\u043D\u0442\u0440",
    filterPending: "\u041E\u0447\u0456\u043A\u0443\u044E\u0442\u044C",
    filterProcessed: "\u041E\u0431\u0440\u043E\u0431\u043B\u0435\u043D\u0456",
    inboundTitle: "\u0412\u0445\u0456\u0434\u043D\u0456 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    markProcessed: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u043E\u0431\u0440\u043E\u0431\u043B\u0435\u043D\u0435",
    noInboundMessages: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0445\u0456\u0434\u043D\u0438\u0445 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u044C",
    pendingFailed: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0435\u0432\u0434\u0430\u043B\u0435",
    quickSend: "\u0428\u0432\u0438\u0434\u043A\u0435 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    recentHistory: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0456\u0441\u0442\u043E\u0440\u0456\u044F",
    recognizedCommand: "\u0420\u043E\u0437\u043F\u0456\u0437\u043D\u0430\u043D\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430",
    selectTemplate: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D",
    sentToday: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    settingsLink: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F SMS",
    statusPending: "\u041E\u0447\u0456\u043A\u0443\u0454",
    statusProcessed: "\u041E\u0431\u0440\u043E\u0431\u043B\u0435\u043D\u043E",
    successRate: "\u0412\u0456\u0434\u0441\u043E\u0442\u043E\u043A \u0443\u0441\u043F\u0456\u0445\u0443",
    viewAll: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0441\u0435",
    viewRelated: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456"
  },
  ocr: {
    title: "\u0421\u043A\u0430\u043D\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0442\u0430 \u0434\u0440\u0443\u043A \u0435\u0442\u0438\u043A\u0435\u0442\u043E\u043A",
    subtitle: "IPEVO V4K \u043A\u0430\u043C\u0435\u0440\u0430 \u0434\u043B\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 + Zebra/Brother \u043F\u0440\u0438\u043D\u0442\u0435\u0440 \u0435\u0442\u0438\u043A\u0435\u0442\u043E\u043A",
    scanTab: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
    labelTab: "\u0414\u0440\u0443\u043A \u0435\u0442\u0438\u043A\u0435\u0442\u043E\u043A",
    scanTitle: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 (IPEVO V4K)",
    scanInstruction: "\u041F\u043E\u043C\u0456\u0441\u0442\u0456\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0456\u0434 \u043A\u0430\u043C\u0435\u0440\u0443 \u0442\u0430 \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F.",
    scanButton: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
    scanning: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F...",
    scanResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
    noResults: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0441\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F.",
    labelTitle: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F \u0435\u0442\u0438\u043A\u0435\u0442\u043E\u043A",
    zebraLabel: "Zebra ZD 220 (43\xD726\u043C\u043C)",
    brotherLabel: "Brother QL-700 (50\u043C\u043C)",
    generateZebra: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0435\u0442\u0438\u043A\u0435\u0442\u043A\u0443 Zebra",
    generateBrother: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0435\u0442\u0438\u043A\u0435\u0442\u043A\u0443 Brother",
    generating: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F...",
    sku: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B",
    productName: "\u041D\u0430\u0437\u0432\u0430 \u0442\u043E\u0432\u0430\u0440\u0443",
    price: "\u0426\u0456\u043D\u0430 (\u0431\u0440\u0443\u0442\u0442\u043E)",
    pageTitle: "\u0417\u0447\u0438\u0442\u0443\u0432\u0430\u0447 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0442\u0430 \u0434\u0440\u0443\u043A \u0435\u0442\u0438\u043A\u0435\u0442\u043E\u043A",
    scanButtonLabel: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
    scanSuccess: "\u0421\u043A\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u0435!",
    nameLabel: "\u0406\u043C'\u044F",
    documentNumberLabel: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
    confidenceLabel: "\u041D\u0430\u0434\u0456\u0439\u043D\u0456\u0441\u0442\u044C",
    productNamePlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
    barcodePlaceholder: "\u0428\u0442\u0440\u0438\u0445-\u043A\u043E\u0434",
    pricePlaceholder: "\u0426\u0456\u043D\u0430 (HUF)",
    skuPlaceholder: "SKU (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    netPricePlaceholder: "\u0426\u0456\u043D\u0430 \u043D\u0435\u0442\u0442\u043E (HUF)",
    vatRatePlaceholder: "\u0421\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412 (%)",
    barcodeOptionalPlaceholder: "\u0428\u0442\u0440\u0438\u0445-\u043A\u043E\u0434 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    categoryPlaceholder: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    generatingLabel: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F...",
    priceLabelGenerate: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0446\u0456\u043D\u043D\u0438\u043A",
    errorUnknown: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
  },
  businessHours: {
    title: "\u0413\u043E\u0434\u0438\u043D\u0438 \u0440\u043E\u0431\u043E\u0442\u0438 \u0442\u0430 \u0441\u0432\u044F\u0442\u0430",
    subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0433\u043E\u0434\u0438\u043D\u0430\u043C\u0438 \u0440\u043E\u0431\u043E\u0442\u0438, \u0441\u0432\u044F\u0442\u0430\u043C\u0438 \u0442\u0430 \u0432\u0438\u043D\u044F\u0442\u043A\u0430\u043C\u0438",
    weeklyTab: "\u0422\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u0440\u043E\u0437\u043A\u043B\u0430\u0434",
    holidaysTab: "\u0421\u0432\u044F\u0442\u0430",
    overridesTab: "\u0412\u0438\u043D\u044F\u0442\u043A\u0438",
    weeklySchedule: "\u0422\u0438\u0436\u043D\u0435\u0432\u0456 \u0433\u043E\u0434\u0438\u043D\u0438 \u0440\u043E\u0431\u043E\u0442\u0438",
    dayNames: {
      monday: "\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
      tuesday: "\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
      wednesday: "\u0421\u0435\u0440\u0435\u0434\u0430",
      thursday: "\u0427\u0435\u0442\u0432\u0435\u0440",
      friday: "\u041F'\u044F\u0442\u043D\u0438\u0446\u044F",
      saturday: "\u0421\u0443\u0431\u043E\u0442\u0430",
      sunday: "\u041D\u0435\u0434\u0456\u043B\u044F"
    },
    dayShort: {
      monday: "\u041F\u043D",
      tuesday: "\u0412\u0442",
      wednesday: "\u0421\u0440",
      thursday: "\u0427\u0442",
      friday: "\u041F\u0442",
      saturday: "\u0421\u0431",
      sunday: "\u041D\u0434"
    },
    open: "\u0412\u0456\u0434\u0447\u0438\u043D\u0435\u043D\u043E",
    closed: "\u0417\u0430\u0447\u0438\u043D\u0435\u043D\u043E",
    openTime: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
    closeTime: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    holidayManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0441\u0432\u044F\u0442\u0430\u043C\u0438",
    newHoliday: "\u041D\u043E\u0432\u0435 \u0441\u0432\u044F\u0442\u043E",
    holidayName: "\u041D\u0430\u0437\u0432\u0430 \u0441\u0432\u044F\u0442\u0430",
    holidayDate: "\u0414\u0430\u0442\u0430",
    recurring: "\u0429\u043E\u0440\u0456\u0447\u043D\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0435\u043D\u043D\u044F",
    noHolidays: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u0441\u0432\u044F\u0442.",
    overrideManagement: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0432\u0438\u043D\u044F\u0442\u043A\u0430\u043C\u0438",
    newOverride: "\u041D\u043E\u0432\u0438\u0439 \u0432\u0438\u043D\u044F\u0442\u043E\u043A",
    overrideDate: "\u0414\u0430\u0442\u0430",
    overrideOpenTime: "\u0427\u0430\u0441 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
    overrideCloseTime: "\u0427\u0430\u0441 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    overrideClosed: "\u0417\u0430\u0447\u0438\u043D\u0435\u043D\u043E \u0446\u0456\u043B\u0438\u0439 \u0434\u0435\u043D\u044C",
    overrideReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
    noOverrides: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u0432\u0438\u043D\u044F\u0442\u043A\u0456\u0432.",
    saved: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    everyYear: "\u0429\u043E\u0440\u043E\u043A\u0443",
    pageTitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0433\u043E\u0434\u0438\u043D\u0430\u043C\u0438 \u0440\u043E\u0431\u043E\u0442\u0438",
    pageSubtitle: "\u0422\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u0440\u043E\u0437\u043A\u043B\u0430\u0434, \u0441\u0432\u044F\u0442\u0430 \u0442\u0430 \u043E\u0441\u043E\u0431\u043B\u0438\u0432\u0456 \u0434\u043D\u0456",
    weeklyScheduleTitle: "\u0422\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u0440\u043E\u0437\u043A\u043B\u0430\u0434",
    defaultButton: "\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
    saveButton: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
    savingButton: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    savingSuccess: "\u0413\u043E\u0434\u0438\u043D\u0438 \u0440\u043E\u0431\u043E\u0442\u0438 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    resetSuccess: "\u0421\u043A\u0438\u043D\u0443\u0442\u043E \u0434\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0445!",
    loadingWeekly: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0433\u043E\u0434\u0438\u043D \u0440\u043E\u0431\u043E\u0442\u0438...",
    dayColumn: "\u0414\u0435\u043D\u044C",
    openColumn: "\u0412\u0456\u0434\u0447\u0438\u043D\u0435\u043D\u043E",
    openingColumn: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
    closingColumn: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    hungHolidays: "\u0423\u0433\u043E\u0440\u0441\u044C\u043A\u0456 \u0441\u0432\u044F\u0442\u0430",
    newHolidayButton: "\u041D\u043E\u0432\u0435 \u0441\u0432\u044F\u0442\u043E",
    editHolidayTitle: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0441\u0432\u044F\u0442\u043E",
    newHolidayTitle: "\u041D\u043E\u0432\u0435 \u0441\u0432\u044F\u0442\u043E",
    nameLabel: "\u041D\u0430\u0437\u0432\u0430",
    dateLabel: "\u0414\u0430\u0442\u0430",
    namePlaceholder: "\u043D\u0430\u043F\u0440. \u0420\u0456\u0437\u0434\u0432\u043E",
    recurringLabel: "\u0429\u043E\u0440\u0456\u0447\u043D\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0435\u043D\u043D\u044F",
    cancelButton: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    updateButton: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
    createButton: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
    holidayUpdated: "\u0421\u0432\u044F\u0442\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E!",
    holidayCreated: "\u0421\u0432\u044F\u0442\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E!",
    holidayDeleted: "\u0421\u0432\u044F\u0442\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E!",
    nationalSeeded: "\u043D\u0430\u0446\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0445 \u0441\u0432\u044F\u0442 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E!",
    loadingHolidays: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u0432\u044F\u0442...",
    holidaysTitle: "\u0421\u0432\u044F\u0442\u0430",
    noHolidaysText: '\u041D\u0435\u043C\u0430\u0454 \u0441\u0432\u044F\u0442 \u0443 \u0446\u044C\u043E\u043C\u0443 \u0440\u043E\u0446\u0456. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443 "\u0423\u0433\u043E\u0440\u0441\u044C\u043A\u0456 \u0441\u0432\u044F\u0442\u0430".',
    nameColumn: "\u041D\u0430\u0437\u0432\u0430",
    dateColumnHeader: "\u0414\u0430\u0442\u0430",
    typeColumn: "\u0422\u0438\u043F",
    actionsColumn: "\u0414\u0456\u0457",
    nationalBadge: "\u041D\u0430\u0446\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u0435",
    recurringBadge: "\u041F\u043E\u0432\u0442\u043E\u0440\u044E\u0432\u0430\u043D\u0435",
    customBadge: "\u041E\u0441\u043E\u0431\u043B\u0438\u0432\u0435",
    editButton: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
    deleteButton: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    overridesTitle: "\u041E\u0441\u043E\u0431\u043B\u0438\u0432\u0456 \u0434\u043D\u0456 (\u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F)",
    newOverrideButton: "\u041D\u043E\u0432\u0435 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    editOverrideTitle: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    newOverrideTitle: "\u041D\u043E\u0432\u0435 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    overrideUpdated: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E!",
    overrideCreated: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E!",
    overrideDeleted: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E!",
    loadingOverrides: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u044C...",
    noOverridesText: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u044C \u043E\u0441\u043E\u0431\u043B\u0438\u0432\u0438\u0445 \u0434\u043D\u0456\u0432.",
    statusColumn: "\u0421\u0442\u0430\u0442\u0443\u0441",
    timeColumn: "\u0427\u0430\u0441",
    reasonColumn: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
    reasonLabel: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 / \u043F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    reasonPlaceholder: "\u043D\u0430\u043F\u0440. \u041E\u0441\u043E\u0431\u043B\u0438\u0432\u0435 \u043B\u0456\u0442\u043D\u0454 \u0441\u0443\u0431\u043E\u0442\u043D\u0454 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F",
    openBadge: "\u0412\u0456\u0434\u0447\u0438\u043D\u0435\u043D\u043E",
    closedBadge: "\u0417\u0430\u0447\u0438\u043D\u0435\u043D\u043E",
    tabWeekly: "\u0422\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u0440\u043E\u0437\u043A\u043B\u0430\u0434",
    tabHolidays: "\u0421\u0432\u044F\u0442\u0430",
    tabOverrides: "\u041E\u0441\u043E\u0431\u043B\u0438\u0432\u0456 \u0434\u043D\u0456"
  },
  tenant: {
    title: "\u0410\u0434\u043C\u0456\u043D \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
    subtitle: "\u0414\u0430\u043D\u0456 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457 \u0442\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0444\u0440\u0430\u043D\u0448\u0438\u0437\u043E\u044E",
    companyTab: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457",
    franchiseTab: "\u041E\u0433\u043B\u044F\u0434 \u0444\u0440\u0430\u043D\u0448\u0438\u0437\u0438",
    basicData: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
    storeName: "\u041D\u0430\u0437\u0432\u0430 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443/\u043B\u043E\u043A\u0430\u0446\u0456\u0457",
    companyName: "\u041E\u0444\u0456\u0446\u0456\u0439\u043D\u0430 \u043D\u0430\u0437\u0432\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457",
    taxNumber: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043A\u043E\u0434",
    registrationNumber: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    bankAccount: "\u041D\u043E\u043C\u0435\u0440 \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u043E\u0433\u043E \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    contactInfo: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
    phoneNumber: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    emailAddress: "\u0410\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    website: "\u0412\u0435\u0431-\u0441\u0430\u0439\u0442",
    address: "\u0410\u0434\u0440\u0435\u0441\u0430",
    franchiseStats: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0444\u0440\u0430\u043D\u0448\u0438\u0437\u0438",
    totalStores: "\u0412\u0441\u044C\u043E\u0433\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432",
    activeStores: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0438",
    totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
    tenantTable: "\u0421\u043F\u0438\u0441\u043E\u043A \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u0456\u0432",
    tenantName: "\u041D\u0430\u0437\u0432\u0430",
    tenantStatus: "\u0421\u0442\u0430\u0442\u0443\u0441",
    tenantPlan: "\u0422\u0430\u0440\u0438\u0444",
    tenantCreated: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    bankName: "\u041D\u0430\u0437\u0432\u0430 \u0431\u0430\u043D\u043A\u0443",
    addressLabel: "\u0410\u0434\u0440\u0435\u0441\u0430",
    cityLabel: "\u041C\u0456\u0441\u0442\u043E",
    postalCodeLabel: "\u041F\u043E\u0448\u0442\u043E\u0432\u0438\u0439 \u0456\u043D\u0434\u0435\u043A\u0441",
    phoneLabel: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
    emailLabel: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
    websiteLabel: "\u0412\u0435\u0431-\u0441\u0430\u0439\u0442",
    businessHoursTitle: "\u0413\u043E\u0434\u0438\u043D\u0438 \u0440\u043E\u0431\u043E\u0442\u0438",
    openLabel: "\u0412\u0456\u0434\u0447\u0438\u043D\u0435\u043D\u043E",
    closedLabel: "\u0417\u0430\u0447\u0438\u043D\u0435\u043D\u043E",
    brandingTitle: "\u0411\u0440\u0435\u043D\u0434\u0438\u043D\u0433",
    uploadLogo: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
    primaryColor: "\u041E\u0441\u043D\u043E\u0432\u043D\u0438\u0439 \u043A\u043E\u043B\u0456\u0440",
    accentColor: "\u0410\u043A\u0446\u0435\u043D\u0442\u043D\u0438\u0439 \u043A\u043E\u043B\u0456\u0440",
    systemSettingsTitle: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    currencyLabel: "\u0412\u0430\u043B\u044E\u0442\u0430",
    timezoneLabel: "\u0427\u0430\u0441\u043E\u0432\u0438\u0439 \u043F\u043E\u044F\u0441",
    languageLabel: "\u041C\u043E\u0432\u0430",
    vatRateLabel: "\u0421\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412 (%)",
    employees: "\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0438",
    activeWorksheets: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043B\u043E\u043A\u0430\u0446\u0456\u0454\u044E, \u043C\u0456\u0441\u0442\u043E\u043C, \u0432\u043B\u0430\u0441\u043D\u0438\u043A\u043E\u043C...",
    locationsTitle: "\u041C\u0456\u0441\u0446\u0435\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
    locationColumn: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
    ownerColumn: "\u0412\u043B\u0430\u0441\u043D\u0438\u043A",
    monthlyRevenueColumn: "\u041C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
    rentalsColumn: "\u041E\u0440\u0435\u043D\u0434\u0438",
    worksheetsColumn: "\u0420\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
    lastActivityColumn: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C",
    statusInactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    statusSuspended: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u0438\u0439",
    currencyHUF: "HUF - \u0423\u0433\u043E\u0440\u0441\u044C\u043A\u0438\u0439 \u0444\u043E\u0440\u0438\u043D\u0442",
    currencyEUR: "EUR - \u0404\u0432\u0440\u043E",
    employeesSuffix: "\u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0456\u0432"
  },
  chat: {
    title: "\u0427\u0430\u0442",
    newConversation: "\u041D\u043E\u0432\u0430 \u0440\u043E\u0437\u043C\u043E\u0432\u0430",
    you: "\u0412\u0438",
    noMessages: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u044C",
    participant: "\u0443\u0447\u0430\u0441\u043D\u0438\u043A",
    participants: "\u0443\u0447\u0430\u0441\u043D\u0438\u043A\u0456\u0432",
    online: "\u041E\u043D\u043B\u0430\u0439\u043D",
    offline: "\u041E\u0444\u043B\u0430\u0439\u043D",
    call: "\u0412\u0438\u043A\u043B\u0438\u043A",
    info: "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
    attachment: "\u0412\u043A\u043B\u0430\u0434\u0435\u043D\u043D\u044F",
    messagePlaceholder: "\u041D\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F...",
    sendButton: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    selectConversation: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u043E\u0437\u043C\u043E\u0432\u0443",
    onlineColleagues: "\u041A\u043E\u043B\u0435\u0433\u0438 \u043E\u043D\u043B\u0430\u0439\u043D",
    newChat: "\u041D\u043E\u0432\u0430 \u0440\u043E\u0437\u043C\u043E\u0432\u0430",
    groupName: "\u041D\u0430\u0437\u0432\u0430 \u0433\u0440\u0443\u043F\u0438 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    selectParticipants: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0443\u0447\u0430\u0441\u043D\u0438\u043A\u0456\u0432",
    startConversation: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0440\u043E\u0437\u043C\u043E\u0432\u0443",
    newButton: "+ \u041D\u043E\u0432\u0438\u0439",
    selectOrStartNew: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0456\u0441\u043D\u0443\u044E\u0447\u0443 \u0440\u043E\u0437\u043C\u043E\u0432\u0443 \u0437\u043B\u0456\u0432\u0430 \u0430\u0431\u043E \u043F\u043E\u0447\u043D\u0456\u0442\u044C \u043D\u043E\u0432\u0443.",
    selected: "\u0432\u0438\u0431\u0440\u0430\u043D\u043E",
    groupChat: "\u0433\u0440\u0443\u043F\u043E\u0432\u0438\u0439 \u0447\u0430\u0442",
    writeMessage: "\u041D\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F...",
    sendLabel: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    groupNamePlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0433\u0440\u0443\u043F\u0438...",
    minimize: "\u041C\u0456\u043D\u0456\u043C\u0456\u0437\u0443\u0432\u0430\u0442\u0438",
    openChat: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0447\u0430\u0442"
  },
  modules: {
    title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043C\u043E\u0434\u0443\u043B\u0456\u0432",
    activeCount: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u043C\u043E\u0434\u0443\u043B\u044C",
    inactiveCount: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u043C\u043E\u0434\u0443\u043B\u044C",
    totalCount: "\u0412\u0441\u044C\u043E\u0433\u043E \u043C\u043E\u0434\u0443\u043B\u0456\u0432",
    mandatory: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
    saved: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    categoryCore: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456",
    categorySales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    categoryService: "\u0421\u0435\u0440\u0432\u0456\u0441",
    categoryFinance: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
    categoryIntegration: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u044F",
    moduleRental: "\u041E\u0440\u0435\u043D\u0434\u0430",
    moduleRentalDesc: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F, \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u0438",
    moduleSales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    moduleSalesDesc: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u043E\u0432\u0430\u0440\u0456\u0432, POS \u043A\u0430\u0441\u0430",
    moduleService: "\u0421\u0435\u0440\u0432\u0456\u0441",
    moduleServiceDesc: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442, \u0440\u0435\u043C\u043E\u043D\u0442, \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
    moduleInventory: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0441\u043A\u043B\u0430\u0434\u043E\u043C",
    moduleInventoryDesc: "\u0417\u0430\u043F\u0430\u0441\u0438, \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u044F, \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0443",
    moduleInvoicing: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    moduleInvoicingDesc: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432, NAV Online",
    modulePartners: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C\u0438",
    modulePartnersDesc: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438, \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438",
    moduleQuotes: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    moduleQuotesDesc: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457, \u043A\u043E\u043D\u0432\u0435\u0440\u0441\u0456\u0457",
    moduleCash: "\u041A\u0430\u0441\u0430",
    moduleCashDesc: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u0430\u0441\u043E\u044E, \u0434\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
    moduleReporting: "\u0417\u0432\u0456\u0442\u043D\u0456\u0441\u0442\u044C",
    moduleReportingDesc: "KPI, \u0437\u0432\u0456\u0442\u0438",
    moduleChat: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456\u0439 \u0447\u0430\u0442",
    moduleChatDesc: "\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u0430 \u043A\u043E\u043C\u0443\u043D\u0456\u043A\u0430\u0446\u0456\u044F",
    moduleBooking: "\u041E\u043D\u043B\u0430\u0439\u043D-\u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F",
    moduleBookingDesc: "\u0411\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0447\u0435\u0440\u0435\u0437 \u0441\u0430\u0439\u0442",
    moduleCrm: "CRM (Twenty)",
    moduleCrmDesc: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0432\u0456\u0434\u043D\u043E\u0441\u0438\u043D\u0430\u043C\u0438 \u0437 \u043A\u043B\u0456\u0454\u043D\u0442\u0430\u043C\u0438",
    moduleHr: "HR (Horilla)",
    moduleHrDesc: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043B\u044E\u0434\u0441\u044C\u043A\u0438\u043C\u0438 \u0440\u0435\u0441\u0443\u0440\u0441\u0430\u043C\u0438",
    moduleVehicles: "\u0420\u0435\u0454\u0441\u0442\u0440 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0443",
    moduleVehiclesDesc: "\u0421\u043B\u0443\u0436\u0431\u043E\u0432\u0456 \u0442\u0430 \u043E\u0440\u0435\u043D\u0434\u043D\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438",
    moduleLoyalty: "VIP \u041B\u043E\u044F\u043B\u044C\u043D\u0456\u0441\u0442\u044C",
    moduleLoyaltyDesc: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u0430 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456, \u0437\u0431\u0456\u0440 \u0431\u0430\u043B\u0456\u0432",
    moduleSms: "SMS Gateway",
    moduleSmsDesc: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0430 SMS, \u0448\u0430\u0431\u043B\u043E\u043D\u0438",
    subtitle: "\u0423\u0432\u0456\u043C\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u0432\u0438\u043C\u043A\u043D\u0456\u0442\u044C \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u043C\u043E\u0434\u0443\u043B\u0456. \u0417\u043C\u0456\u043D\u0438 \u043D\u0430\u0431\u0443\u0432\u0430\u044E\u0442\u044C \u0447\u0438\u043D\u043D\u043E\u0441\u0442\u0456 \u043D\u0435\u0433\u0430\u0439\u043D\u043E.",
    saveButton: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
    activeLabel: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    inactiveLabel: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    categoryLabels: {
      core: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u043C\u043E\u0434\u0443\u043B\u0456",
      domain: "\u0411\u0456\u0437\u043D\u0435\u0441 \u043C\u043E\u0434\u0443\u043B\u0456",
      integration: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457"
    },
    categoryDescriptions: {
      core: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u043C\u043E\u0434\u0443\u043B\u0456 \u0434\u043B\u044F \u0440\u043E\u0431\u043E\u0442\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u0438. \u041D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043C\u043A\u043D\u0443\u0442\u0438.",
      domain: "\u0411\u0456\u0437\u043D\u0435\u0441-\u0444\u0443\u043D\u043A\u0446\u0456\u0457, \u044F\u043A\u0456 \u043C\u043E\u0436\u043D\u0430 \u043E\u043A\u0440\u0435\u043C\u043E \u0432\u043C\u0438\u043A\u0430\u0442\u0438 \u0447\u0438 \u0432\u0438\u043C\u0438\u043A\u0430\u0442\u0438.",
      integration: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457 \u0437 \u0437\u043E\u0432\u043D\u0456\u0448\u043D\u0456\u043C\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u043C\u0438."
    },
    moduleNames: {
      auth: "\u0410\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F (Auth)",
      tenant: "\u041C\u0443\u043B\u044C\u0442\u0438-\u0442\u0435\u043D\u0430\u043D\u0442\u043D\u0456\u0441\u0442\u044C",
      audit: "\u0410\u0443\u0434\u0438\u0442",
      rental: "\u041C\u043E\u0434\u0443\u043B\u044C \u043E\u0440\u0435\u043D\u0434\u0438",
      sales: "\u041C\u043E\u0434\u0443\u043B\u044C \u043F\u0440\u043E\u0434\u0430\u0436\u0456\u0432",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0439 \u043C\u043E\u0434\u0443\u043B\u044C",
      inventory: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0430\u043C\u0438",
      quotation: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F\u043C\u0438",
      partners: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C\u0438",
      vehicles: "\u0420\u0435\u0454\u0441\u0442\u0440 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0445 \u0437\u0430\u0441\u043E\u0431\u0456\u0432",
      "nav-online": "NAV \u041E\u043D\u043B\u0430\u0439\u043D \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
      mypos: "MyPOS \u043E\u043F\u043B\u0430\u0442\u0430",
      "szamlazz-hu": "Sz\xE1ml\xE1zz.hu",
      "twenty-crm": "Twenty CRM",
      chatwoot: "rPI Porter",
      "online-booking": "\u041E\u043D\u043B\u0430\u0439\u043D \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F"
    },
    moduleDescriptions: {
      auth: "\u0410\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432, JWT, PIN \u0432\u0445\u0456\u0434, RBAC \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u0443.",
      tenant: "\u041F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0430 \u0444\u0440\u0430\u043D\u0447\u0430\u0439\u0437\u0438\u043D\u0433\u043E\u0432\u043E\u0457 \u043C\u0435\u0440\u0435\u0436\u0456, \u0440\u043E\u0437\u0434\u0456\u043B\u0435\u043D\u043D\u044F \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432, RLS-\u043F\u043E\u043B\u0456\u0442\u0438\u043A\u0438.",
      audit: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0456, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C GDPR, \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F\u043C.",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F, \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432, \u0434\u043E\u0432\u0433\u043E\u0441\u0442\u0440\u043E\u043A\u043E\u0432\u0456 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0438, \u0448\u0442\u0440\u0430\u0444\u043D\u0456 \u0437\u0431\u043E\u0440\u0438.",
      sales: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u043E\u0432\u0430\u0440\u0456\u0432, POS-\u0442\u0435\u0440\u043C\u0456\u043D\u0430\u043B, NAV \u041E\u043D\u043B\u0430\u0439\u043D \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432.",
      service: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u0438\u043C\u0438 \u043B\u0438\u0441\u0442\u0430\u043C\u0438, \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D.",
      inventory: "\u041E\u0431\u043B\u0456\u043A \u0437\u0430\u043F\u0430\u0441\u0456\u0432, \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u044F, \u043F\u0440\u0438\u0439\u043E\u043C \u0442\u043E\u0432\u0430\u0440\u0443, \u043C\u0456\u0436\u0441\u043A\u043B\u0430\u0434\u0441\u044C\u043A\u0456 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F.",
      quotation: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0446\u0456\u043D, \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u043A\u043E\u043D\u0432\u0435\u0440\u0441\u0456\u0439, \u0433\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F PDF.",
      partners: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438, \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0438, \u0437\u043D\u0438\u0436\u043A\u0438, \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0430 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456.",
      vehicles: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u0439\u043D\u0456 \u0442\u0430 \u043E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0456 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0456 \u0437\u0430\u0441\u043E\u0431\u0438, \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438.",
      "nav-online": "NAV \u041E\u043D\u043B\u0430\u0439\u043D API \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432 (\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E \u0432 \u043F\u0440\u043E\u0434\u0430\u043A\u0448\u0435\u043D\u0456).",
      mypos: "\u041F\u043B\u0430\u0442\u0456\u0436\u043D\u0438\u0439 \u0448\u043B\u044E\u0437, \u0437\u0430\u0441\u0442\u0430\u0432\u0430, \u043E\u043F\u043B\u0430\u0442\u0430 \u043A\u0430\u0440\u0442\u043A\u043E\u044E.",
      "szamlazz-hu": "API \u0456\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0438 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432.",
      "twenty-crm": "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u044F CRM \u0441\u0438\u0441\u0442\u0435\u043C\u0438 \u0434\u043B\u044F \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430\u043C\u0438.",
      chatwoot: "\u0427\u0430\u0442 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432.",
      "online-booking": "\u041E\u043D\u043B\u0430\u0439\u043D \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u043D\u043D\u044F \u0441\u0435\u0440\u0432\u0456\u0441\u0443 \u0442\u0430 \u043E\u0440\u0435\u043D\u0434\u0438."
    }
  },
  notifications: {
    title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C",
    matrix: "\u041C\u0430\u0442\u0440\u0438\u0446\u044F \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C",
    role: "\u0420\u043E\u043B\u044C",
    totalCol: "\u0412\u0441\u044C\u043E\u0433\u043E",
    legend: "\u041B\u0435\u0433\u0435\u043D\u0434\u0430",
    enabled: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E",
    disabled: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u0432\u0438\u043C\u043A\u043D\u0435\u043D\u043E",
    roleLabels: {
      admin: "\u0410\u0434\u043C\u0456\u043D",
      manager: "\u041A\u0435\u0440\u0456\u0432\u043D\u0438\u043A",
      cashier: "\u041A\u0430\u0441\u0438\u0440",
      technician: "\u0422\u0435\u0445\u043D\u0456\u043A",
      salesRep: "\u041C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
      warehouseWorker: "\u0421\u043A\u043B\u0430\u0434\u0441\u044C\u043A\u0438\u0439 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A",
      accountant: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440",
      viewer: "\u0427\u0438\u0442\u0430\u0447"
    },
    domainLabels: {
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      sales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
      inventory: "\u0421\u043A\u043B\u0430\u0434",
      finance: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
      system: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430",
      invoice: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A"
    },
    subtitle: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0439\u0442\u0435, \u044F\u043A\u0456 \u0440\u043E\u043B\u0456 \u043E\u0442\u0440\u0438\u043C\u0443\u044E\u0442\u044C \u044F\u043A\u0456 \u0434\u043E\u043C\u0435\u043D\u043D\u0456 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F.",
    matrixHint: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043D\u0430 \u043A\u043B\u0456\u0442\u0438\u043D\u043A\u0443, \u0449\u043E\u0431 \u0443\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438/\u0432\u0438\u043C\u043A\u043D\u0443\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043D\u0430 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0440\u044F\u0434\u043A\u0430/\u0441\u0442\u043E\u0432\u043F\u0446\u044F, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438 \u0432\u0435\u0441\u044C \u0440\u044F\u0434\u043E\u043A/\u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C.",
    tipText: "\u041F\u043E\u0440\u0430\u0434\u0430: \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043D\u0430 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0440\u044F\u0434\u043A\u0430 \u0447\u0438 \u0441\u0442\u043E\u0432\u043F\u0446\u044F, \u0449\u043E\u0431 \u043E\u0434\u0440\u0430\u0437\u0443 \u043F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438 \u0432\u0435\u0441\u044C \u0440\u044F\u0434\u043E\u043A/\u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C.",
    vehicle: {
      documentExpiring: {
        subject: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F: {licensePlate} ({documentLabel})",
        title: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 \u0441\u043A\u043E\u0440\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F",
        body: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 {documentLabel} \u0434\u043B\u044F \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 {licensePlate} \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0435\u0437 {daysUntilExpiry} \u0434\u043D\u0456\u0432 ({expiryDate}). \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u0432\u043E\u0454\u0447\u0430\u0441\u043D\u043E \u043F\u043E\u043D\u043E\u0432\u0456\u0442\u044C \u0439\u043E\u0433\u043E.",
        cta: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431"
      },
      documentExpired: {
        subject: "\u041F\u0420\u041E\u0422\u0415\u0420\u041C\u0406\u041D\u041E\u0412\u0410\u041D\u0418\u0419 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443: {licensePlate} ({documentLabel})",
        title: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 \u041F\u0420\u041E\u0422\u0415\u0420\u041C\u0406\u041D\u041E\u0412\u0410\u041D\u041E",
        body: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 {documentLabel} \u0434\u043B\u044F \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 {licensePlate} \u043F\u0440\u043E\u0442\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u0430\u043D\u043E {daysOverdue} \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443 (\u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F: {expiryDate}). \u0417 \u043F\u0440\u043E\u0442\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u0430\u043D\u0438\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u043C \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0435\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437\u0430\u043A\u043E\u043D\u043D\u043E \u2014 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0456 \u043D\u0435\u0433\u0430\u0439\u043D\u0456 \u0434\u0456\u0457.",
        cta: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0438\u0439 \u0437\u0430\u0441\u0456\u0431"
      },
      documentTypes: {
        REGISTRATION: "\u0441\u0432\u0456\u0434\u043E\u0446\u0442\u0432\u043E \u043F\u0440\u043E \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E",
        TECHNICAL_INSPECTION: "\u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0438\u0439 \u043E\u0433\u043B\u044F\u0434",
        KGFB_INSURANCE: "\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435 \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F (KGFB)",
        CASCO_INSURANCE: "\u041A\u0410\u0421\u041A\u041E",
        HIGHWAY_STICKER: "\u0430\u0432\u0442\u043E\u043C\u0430\u0433\u0456\u0441\u0442\u0440\u0430\u043B\u044C\u043D\u0430 \u0432\u0456\u043D\u044C\u0454\u0442\u043A\u0430"
      }
    },
    partner: {
      loyaltyReward: {
        subject: "\u041D\u043E\u0432\u0430 \u0432\u0438\u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0430 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0438 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456 \u2014 {partnerName}",
        title: "\u0412\u0438\u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0430 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456 \u0440\u043E\u0437\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u0430",
        body: "\u041F\u0440\u0438\u0432\u0456\u0442 {partnerName}, \u0443 \u0432\u0430\u0441 \u043D\u043E\u0432\u0430 \u0432\u0438\u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0430 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0456 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456: {rewardName}. \u0417\u0430\u0432\u0456\u0442\u0430\u0439\u0442\u0435 \u0434\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443 \u0434\u043B\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043D\u044F.",
        cta: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0438\u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0443"
      }
    },
    marketing: {
      seasonal: {
        subject: "{campaignName} \u2014 \u0441\u043F\u0435\u0446\u0456\u0430\u043B\u044C\u043D\u0430 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F",
        title: "{campaignName}",
        body: "{campaignBody} \u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0439\u0442\u0435 STOP, \u0449\u043E\u0431 \u0432\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438\u0441\u044F.",
        cta: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E"
      }
    },
    types: {
      vehicle: {
        document: {
          expiring: {
            label: "\u0421\u043F\u043B\u0438\u0432\u0430\u0454 \u0441\u0442\u0440\u043E\u043A \u0434\u0456\u0457 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0422\u0417",
            description: "\u041D\u0430\u0431\u043B\u0438\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0441\u0442\u0440\u043E\u043A\u0443 \u0434\u0456\u0457 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 (\u0442\u0435\u0445\u043F\u0430\u0441\u043F\u043E\u0440\u0442/\u0442\u0435\u0445\u043E\u0433\u043B\u044F\u0434/\u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F)."
          },
          expired: {
            label: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0422\u0417 \u041F\u0420\u041E\u0421\u0422\u0420\u041E\u0427\u0415\u041D\u041E",
            description: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u043E\u0431\u0443 \u2014 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0456\u0441\u0442\u044C, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0456 \u043D\u0435\u0433\u0430\u0439\u043D\u0456 \u0434\u0456\u0457."
          }
        },
        service: {
          due: {
            label: "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0435 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F \u0422\u0417",
            description: "\u041D\u0430\u0431\u043B\u0438\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u043B\u0430\u043D\u043E\u0432\u0438\u0439 \u0442\u0435\u0440\u043C\u0456\u043D \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0433\u043E \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F (\u0437\u0430 \u043F\u0440\u043E\u0431\u0456\u0433\u043E\u043C \u0430\u0431\u043E \u0434\u0430\u0442\u043E\u044E)."
          }
        }
      },
      rental: {
        overdue: {
          label: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
          description: "\u041E\u0440\u0435\u043D\u0434\u0430\u0440 \u043D\u0435 \u043F\u043E\u0432\u0435\u0440\u043D\u0443\u0432 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0443 \u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C \u0442\u0435\u0440\u043C\u0456\u043D."
        },
        return: {
          reminder: {
            label: "\u041D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
            description: "\u041D\u0430\u0431\u043B\u0438\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438 (24-72 \u0433\u043E\u0434\u0438\u043D\u0438) \u2014 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430\u0433\u0430\u0434\u0443\u0432\u0430\u043D\u043D\u044F."
          }
        },
        contract: {
          signed: {
            label: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u043E\u0440\u0435\u043D\u0434\u0438 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043E",
            description: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u043E\u0440\u0435\u043D\u0434\u0438 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0438\u043C \u043F\u0456\u0434\u043F\u0438\u0441\u043E\u043C."
          }
        }
      },
      service: {
        worksheet: {
          ready: {
            label: "\u041D\u0430\u0440\u044F\u0434-\u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0433\u043E\u0442\u043E\u0432\u0438\u0439",
            description: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0439 \u043D\u0430\u0440\u044F\u0434-\u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043E \u0443 \u0441\u0442\u0430\u0442\u0443\u0441 \xAB\u0433\u043E\u0442\u043E\u0432\u043E\xBB \u2014 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430."
          }
        },
        warranty: {
          expiring: {
            label: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F",
            description: "\u041D\u0430\u0431\u043B\u0438\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0441\u0442\u0440\u043E\u043A\u0443 \u0434\u0456\u0457 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0457 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0457."
          }
        }
      },
      sales: {
        invoice: {
          issued: {
            label: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u043E\u0432\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
            description: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0456 \u043F\u043E\u0434\u0430\u043D\u043E \u0437\u0432\u0456\u0442 \u0434\u043E NAV (\u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u043E\u0457 \u0441\u043B\u0443\u0436\u0431\u0438 \u0423\u0433\u043E\u0440\u0449\u0438\u043D\u0438)."
          }
        },
        deliveryNote: {
          signed: {
            label: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0443 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043E",
            description: "\u041D\u0430\u043A\u043B\u0430\u0434\u043D\u0443 \u0437\u0430\u043A\u0440\u0438\u0442\u043E \u0437 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0438\u043C \u043F\u0456\u0434\u043F\u0438\u0441\u043E\u043C."
          }
        }
      },
      finance: {
        payment: {
          overdue: {
            label: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
            description: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E \u0440\u0430\u0445\u0443\u043D\u043E\u043A, \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0439 \u043A\u043B\u0456\u0454\u043D\u0442\u0443 \u2014 \u043D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u043E \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0440\u043E\u0446\u0435\u0441 \u0441\u0442\u044F\u0433\u043D\u0435\u043D\u043D\u044F \u0437\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u043E\u0441\u0442\u0456."
          }
        },
        "cash-close": {
          due: {
            label: "\u041D\u0430\u0441\u0442\u0430\u0432 \u0442\u0435\u0440\u043C\u0456\u043D \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043A\u0430\u0441\u0438",
            description: "\u0429\u043E\u0434\u0435\u043D\u043D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u043A\u0430\u0441\u0438 \u0454 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u043C \u0437 \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0439\u043D\u0438\u043C \u0434\u0435\u0434\u043B\u0430\u0439\u043D\u043E\u043C."
          }
        }
      },
      workflow: {
        approval: {
          requested: {
            label: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
            description: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0443 \u0434\u043E\u0441\u044F\u0433\u043B\u043E \u0442\u043E\u0447\u043A\u0438 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F."
          }
        },
        execution: {
          failed: {
            label: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0443 \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F",
            description: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F @kgc/workflow \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u043B\u043E\u0441\u044F \u043A\u0440\u0438\u0442\u0438\u0447\u043D\u043E\u044E \u043F\u043E\u043C\u0438\u043B\u043A\u043E\u044E."
          }
        }
      },
      documents: {
        hash: {
          mismatch: {
            label: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0446\u0456\u043B\u0456\u0441\u043D\u043E\u0441\u0442\u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
            description: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0446\u0456\u043B\u0456\u0441\u043D\u043E\u0441\u0442\u0456 \u0445\u0435\u0448\u0443 \u0432\u0438\u044F\u0432\u0438\u043B\u0430 \u0440\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044C \u2014 \u043C\u043E\u0436\u043B\u0438\u0432\u0435 \u0432\u0442\u0440\u0443\u0447\u0430\u043D\u043D\u044F (\u043C\u0430\u043D\u0456\u043F\u0443\u043B\u044F\u0446\u0456\u044F)."
          }
        },
        retention: {
          expired: {
            label: "\u0421\u0442\u0440\u043E\u043A \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F",
            description: "\u0421\u0442\u0440\u043E\u043A \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F \u0437\u0430 GDPR \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F, \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E."
          }
        }
      },
      partner: {
        blocklisted: {
          label: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0443 \u0441\u0430\u043D\u043A\u0446\u0456\u0439\u043D\u043E\u043C\u0443 \u0441\u043F\u0438\u0441\u043A\u0443",
          description: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u043E \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443 AML / \u0441\u0430\u043D\u043A\u0446\u0456\u0439 \u2014 \u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E \u0431\u043B\u043E\u043A\u0443\u0432\u0430\u043D\u043D\u044F."
        },
        loyaltyReward: {
          label: "\u0412\u0438\u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0430 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0438 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456",
          description: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043D\u043E\u0432\u0430 \u0432\u0438\u043D\u0430\u0433\u043E\u0440\u043E\u0434\u0430 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0438 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0456 \u2014 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u0435 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 \u0437\u0433\u043E\u0434\u0438 (E-93)."
        }
      },
      marketing: {
        seasonal: {
          label: "\u0421\u0435\u0437\u043E\u043D\u043D\u0430 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044F",
          description: "\u041F\u0435\u0440\u0456\u043E\u0434\u0438\u0447\u043D\u0430 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u0430 \u043A\u0430\u043C\u043F\u0430\u043D\u0456\u044F \u2014 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430 \u044F\u0432\u043D\u0430 \u0437\u0433\u043E\u0434\u0430 (E-93 ADR-109 J-1)."
        }
      }
    }
  },
  featureFlags: {
    title: "\u041F\u0440\u0430\u043F\u043E\u0440\u0446\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0439",
    subtitle: "\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043D\u044F \u0442\u0430 \u0432\u0438\u043C\u043A\u043D\u0435\u043D\u043D\u044F \u0444\u0443\u043D\u043A\u0446\u0456\u0439",
    saveChanges: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438",
    totalFlags: "\u0412\u0441\u044C\u043E\u0433\u043E \u043F\u0440\u0430\u043F\u043E\u0440\u0446\u0456\u0432",
    enabledFlags: "\u0423\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E",
    disabledFlags: "\u0412\u0438\u043C\u043A\u043D\u0435\u043D\u043E",
    newBadge: "\u041D\u041E\u0412\u0415",
    betaBadge: "\u0411\u0415\u0422\u0410",
    updatedAt: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043E: {date}",
    dependsOn: "\u0417\u0430\u043B\u0435\u0436\u0438\u0442\u044C: {flags}",
    allCategories: "\u0412\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
    enabledOnly: "\u0422\u0456\u043B\u044C\u043A\u0438 \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u0456",
    disabledOnly: "\u0422\u0456\u043B\u044C\u043A\u0438 \u0432\u0438\u043C\u043A\u043D\u0435\u043D\u0456",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A...",
    infoText: "Feature flags \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442\u044C \u0443\u0432\u0456\u043C\u043A\u043D\u0443\u0432\u0430\u0442\u0438 \u0442\u0430 \u0432\u0438\u043C\u043A\u043D\u0443\u0432\u0430\u0442\u0438 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0434\u043E\u0434\u0430\u0442\u043A\u0443. \u0414\u0435\u044F\u043A\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u043C\u043E\u0436\u0443\u0442\u044C \u0437\u0430\u043B\u0435\u0436\u0430\u0442\u0438 \u0432\u0456\u0434 \u0456\u043D\u0448\u0438\u0445.",
    saved: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E!",
    allLabel: "\u0412\u0441\u0456",
    noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u0432\u043A\u0430\u0437\u0430\u043D\u0438\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438",
    searchPlaceholderLong: "\u041F\u043E\u0448\u0443\u043A (\u043D\u0430\u0437\u0432\u0430, \u043E\u043F\u0438\u0441, \u043A\u043B\u044E\u0447)...",
    usageTitle: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F Feature Flags",
    usageDescription: "Feature flags \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442\u044C \u0432\u043C\u0438\u043A\u0430\u0442\u0438 \u0442\u0430 \u0432\u0438\u043C\u0438\u043A\u0430\u0442\u0438 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0432 \u0434\u043E\u0434\u0430\u0442\u043A\u0443. \u0414\u0435\u044F\u043A\u0456 \u043F\u0440\u0430\u043F\u043E\u0440\u0446\u0456 \u043C\u043E\u0436\u0443\u0442\u044C \u0437\u0430\u043B\u0435\u0436\u0430\u0442\u0438 \u0432\u0456\u0434 \u0456\u043D\u0448\u0438\u0445 - \u0457\u0445 \u043C\u043E\u0436\u043D\u0430 \u0443\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u043B\u0438\u0448\u0435 \u0442\u043E\u0434\u0456, \u043A\u043E\u043B\u0438 \u0437\u0430\u043B\u0435\u0436\u043D\u0456\u0441\u0442\u044C \u0430\u043A\u0442\u0438\u0432\u043D\u0430. \u0424\u0443\u043D\u043A\u0446\u0456\u0457 \u0437 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u043E\u044E BETA \u0449\u0435 \u0442\u0435\u0441\u0442\u0443\u044E\u0442\u044C\u0441\u044F.",
    dependencyDisabled: "\u0417\u0430\u043B\u0435\u0436\u043D\u0456\u0441\u0442\u044C \u043D\u0435 \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u0430",
    totalLabel: "\u0412\u0441\u044C\u043E\u0433\u043E \u043F\u0440\u0430\u043F\u043E\u0440\u0446\u0456\u0432"
  },
  equipmentProfit: {
    profitable: "\u041F\u0440\u0438\u0431\u0443\u0442\u043A\u043E\u0432\u0438\u0439",
    lossmaking: "\u0417\u0431\u0438\u0442\u043A\u043E\u0432\u0438\u0439",
    breakeven: "\u0411\u0435\u0437\u0437\u0431\u0438\u0442\u043A\u043E\u0432\u0438\u0439",
    missingData: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u0434\u0430\u043D\u0456",
    rentalCancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0439",
    roi: "\u041E\u043A\u0443\u043F\u043D\u0456\u0441\u0442\u044C",
    purchasePrice: "\u0426\u0456\u043D\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0438",
    rentalRevenue: "\u0414\u043E\u0445\u0456\u0434 \u0432\u0456\u0434 \u043E\u0440\u0435\u043D\u0434\u0438",
    serviceCost: "\u0412\u0438\u0442\u0440\u0430\u0442\u0438 \u043D\u0430 \u0441\u0435\u0440\u0432\u0456\u0441",
    profit: "\u041F\u0440\u0438\u0431\u0443\u0442\u043E\u043A",
    rentalHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
    noRentalHistory: "\u041D\u0435\u043C\u0430\u0454 \u0456\u0441\u0442\u043E\u0440\u0456\u0457 \u043E\u0440\u0435\u043D\u0434\u0438.",
    ongoing: "\u043F\u043E\u0442\u043E\u0447\u043D\u0430",
    loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u0438\u0431\u0443\u0442\u043A\u043E\u0432\u043E\u0441\u0442\u0456."
  },
  report: {
    title: "\u0417\u0432\u0456\u0442\u0438",
    subtitle: "\u0411\u0456\u0437\u043D\u0435\u0441-\u0437\u0432\u0456\u0442\u0438 \u0442\u0430 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
    overview: "\u041E\u0433\u043B\u044F\u0434",
    sales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    rentals: "\u041E\u0440\u0435\u043D\u0434\u0438",
    inventory: "\u0421\u043A\u043B\u0430\u0434",
    financial: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
    period: "\u041F\u0435\u0440\u0456\u043E\u0434:",
    today: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    week: "\u0422\u0438\u0436\u0434\u0435\u043D\u044C",
    month: "\u041C\u0456\u0441\u044F\u0446\u044C",
    quarter: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B",
    year: "\u0420\u0456\u043A",
    customPeriod: "\u0414\u043E\u0432\u0456\u043B\u044C\u043D\u0438\u0439 \u043F\u0435\u0440\u0456\u043E\u0434",
    totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
    comparedToPrevMonth: "\u043F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043E \u0437 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u043C \u043C\u0456\u0441\u044F\u0446\u0435\u043C",
    salesCount: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
    worksheets: "\u0420\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
    revenueTrend: "\u0422\u0440\u0435\u043D\u0434 \u0434\u043E\u0445\u043E\u0434\u0443",
    revenueChart: "\u041B\u0456\u043D\u0456\u0439\u043D\u0430 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0430 - \u0414\u043E\u0445\u0456\u0434",
    categoryDistribution: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u043C\u0438",
    categoryChart: "\u041A\u0440\u0443\u0433\u043E\u0432\u0430 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0430 - \u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
    salesByCategory: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456 \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u043C\u0438",
    category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
    amount: "\u0421\u0443\u043C\u0430",
    pieces: "\u0428\u0442\u0443\u043A",
    avgPerPiece: "\u0421\u0435\u0440\u0435\u0434./\u0448\u0442.",
    ratio: "\u0427\u0430\u0441\u0442\u043A\u0430",
    total: "\u0420\u0430\u0437\u043E\u043C",
    dailySales: "\u0429\u043E\u0434\u0435\u043D\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0436\u0456",
    dailySalesChart: "\u0421\u0442\u043E\u0432\u043F\u0447\u0430\u0441\u0442\u0430 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0430 - \u0429\u043E\u0434\u0435\u043D\u043D\u0456 \u043F\u0440\u043E\u0434\u0430\u0436\u0456",
    topRentals: "\u0422\u043E\u043F \u043E\u0440\u0435\u043D\u0434\u0438 - \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    equipment: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    rentalsCount: "\u041E\u0440\u0435\u043D\u0434\u0438",
    revenue: "\u0414\u043E\u0445\u0456\u0434",
    utilization: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
    avgRentalDuration: "\u0421\u0435\u0440\u0435\u0434\u043D\u044F \u0442\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C \u043E\u0440\u0435\u043D\u0434\u0438",
    avgRentalDays: "{days} \u0434\u043D\u0456\u0432",
    overdueReturns: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    avgDeposit: "\u0421\u0435\u0440\u0435\u0434\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0432\u0430",
    inventoryByCategory: "\u0421\u0442\u0430\u043D \u0437\u0430\u043F\u0430\u0441\u0456\u0432 \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u043C\u0438",
    inStock: "\u041D\u0430 \u0441\u043A\u043B\u0430\u0434\u0456",
    reserved: "\u0417\u0430\u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432\u0430\u043D\u043E",
    available: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
    lowStock: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
    lowStockItems: "{count} \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
    grossRevenue: "\u0412\u0430\u043B\u043E\u0432\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
    vatPayment: "\u041E\u043F\u043B\u0430\u0442\u0430 \u041F\u0414\u0412",
    vatRate: "27% \u0441\u0442\u0430\u0432\u043A\u0430 \u041F\u0414\u0412",
    netResult: "\u0427\u0438\u0441\u0442\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442",
    expiredInvoices: "{count} \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0445 \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432",
    revenueBreakdown: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0434\u043E\u0445\u043E\u0434\u0443",
    productSales: "\u041F\u0440\u043E\u0434\u0430\u0436 \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
    rentalFees: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
    serviceLabor: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0456 \u0440\u043E\u0431\u043E\u0442\u0438",
    other: "\u0406\u043D\u0448\u0435",
    smallMachines: "\u041C\u0430\u043B\u0456 \u043C\u0430\u0448\u0438\u043D\u0438",
    tools: "\u0406\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438",
    safetyEquipment: "\u0417\u0430\u0445\u0438\u0441\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    rentalReport: "\u0417\u0432\u0456\u0442 \u0437 \u043E\u0440\u0435\u043D\u0434\u0438",
    periodLabel: "\u041F\u0435\u0440\u0456\u043E\u0434: {start} - {end}",
    refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
    filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
    lastWeek: "\u041C\u0438\u043D\u0443\u043B\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
    lastMonth: "\u041C\u0438\u043D\u0443\u043B\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
    lastQuarter: "\u041C\u0438\u043D\u0443\u043B\u0438\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
    lastYear: "\u041C\u0438\u043D\u0443\u043B\u0438\u0439 \u0440\u0456\u043A",
    startDate: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
    endDate: "\u0414\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
    equipmentType: "\u0422\u0438\u043F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    allTypes: "\u0412\u0441\u0456 \u0442\u0438\u043F\u0438",
    clearFilters: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
    totalRentals: "\u0412\u0441\u044C\u043E\u0433\u043E \u043E\u0440\u0435\u043D\u0434",
    activeRentals: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    closedRentals: "\u0417\u0430\u043A\u0440\u0438\u0442\u0456 \u043E\u0440\u0435\u043D\u0434\u0438",
    avgRentalTime: "\u0421\u0435\u0440\u0435\u0434. \u0447\u0430\u0441 \u043E\u0440\u0435\u043D\u0434\u0438",
    avgRevenuePerRental: "\u0421\u0435\u0440\u0435\u0434. \u0434\u043E\u0445\u0456\u0434/\u043E\u0440\u0435\u043D\u0434\u0430",
    overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456",
    rentalsByEquipmentType: "\u041E\u0440\u0435\u043D\u0434\u0438 \u0437\u0430 \u0442\u0438\u043F\u043E\u043C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    equipmentTypeCol: "\u0422\u0438\u043F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    count: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
    revenueCol: "\u0414\u043E\u0445\u0456\u0434",
    ratioCol: "\u0427\u0430\u0441\u0442\u043A\u0430",
    noDataForFilters: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0437\u0430 \u0432\u043A\u0430\u0437\u0430\u043D\u0438\u043C\u0438 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u044F\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u0446\u0456\u0457.",
    errorLoading: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445.",
    retryButton: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
    comparedToPrevMonthShort: "\u043F\u043E\u0440. \u0437 \u043F\u043E\u043F\u0435\u0440. \u043C\u0456\u0441\u044F\u0446\u0435\u043C",
    margin: {
      title: "\u041C\u0430\u0440\u0436\u0430",
      byProduct: "\u0417\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u043C",
      byCategory: "\u0417\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0454\u044E",
      revenue: "\u0414\u043E\u0445\u0456\u0434",
      cogs: "\u0421\u043E\u0431\u0456\u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
      marginAmount: "\u041C\u0430\u0440\u0436\u0430 (HUF)",
      marginPercent: "\u041C\u0430\u0440\u0436\u0430 (%)",
      exportCsv: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV",
      detailTable: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u0437\u0432\u0456\u0442 \u043C\u0430\u0440\u0436\u0456",
      productName: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442"
    }
  },
  ws: {
    connected: "WebSocket: \u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
    connecting: "WebSocket: \u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F...",
    reconnecting: "WebSocket: \u041F\u0435\u0440\u0435\u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F...",
    disconnected: "WebSocket: \u041E\u0444\u043B\u0430\u0439\u043D",
    clickToReconnect: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F"
  },
  serviceHistory: {
    close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    issue: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430",
    laborCost: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0440\u043E\u0431\u043E\u0442\u0438",
    loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    noHistory: "\u041D\u0435\u043C\u0430\u0454 \u0456\u0441\u0442\u043E\u0440\u0456\u0457 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
    partsCost: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438",
    resolution: "\u0420\u0456\u0448\u0435\u043D\u043D\u044F",
    title: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
    totalCost: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
    totalServices: "\u0423\u0441\u044C\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u0456\u0432",
    unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    warranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
    warrantyBadge: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
    serialNumber: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440: {serial}",
    statusDraft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
    statusDiagnosed: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u043E\u0432\u0430\u043D\u043E",
    statusInProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
    statusWaitingParts: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D",
    statusCompleted: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
    statusClosed: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E"
  },
  stockDetail: {
    availableInPhase2: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0443 \u0424\u0430\u0437\u0456 2",
    avgMonthlyUsage: "\u0421\u0435\u0440\u0435\u0434\u043D\u0454 \u043C\u0456\u0441\u044F\u0447\u043D\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F",
    close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    critical: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
    currentStock: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0437\u0430\u043F\u0430\u0441",
    description: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0437\u0430\u043F\u0430\u0441\u0456\u0432 \u0442\u0430 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u0457 \u0449\u043E\u0434\u043E \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456",
    lastPurchase: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
    minimumThreshold: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u043F\u043E\u0440\u0456\u0433",
    model: "\u041C\u043E\u0434\u0435\u043B\u044C",
    movementHistory30d: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0440\u0443\u0445\u0443 (30 \u0434\u043D\u0456\u0432)",
    purchaseHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C",
    purchaseRecommendation: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0456\u044F \u0449\u043E\u0434\u043E \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456",
    recommendedPurchase: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044F: {quantity} \u043E\u0434\u0438\u043D\u0438\u0446\u044C (\u0434\u043E \u043C\u0456\u043D\u0456\u043C\u0443\u043C\u0443 {threshold})",
    serialNumber: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
    status: "\u0421\u0442\u0430\u0442\u0443\u0441",
    tabInfo: "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
    tabMovement: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0440\u0443\u0445\u0443",
    type: "\u0422\u0438\u043F",
    warning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
    quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {count} \u0448\u0442.",
    unitCount: "{count} \u0448\u0442."
  },
  widget: {
    permissions: {
      title: "\u0414\u043E\u0437\u0432\u043E\u043B\u0438 \u0432\u0456\u0434\u0436\u0435\u0442\u0456\u0432 \u0434\u0430\u0448\u0431\u043E\u0440\u0434\u0443",
      description: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0439\u0442\u0435, \u044F\u043A\u0430 \u0440\u043E\u043B\u044C \u043C\u043E\u0436\u0435 \u0431\u0430\u0447\u0438\u0442\u0438 \u044F\u043A\u0438\u0439 \u0432\u0456\u0434\u0436\u0435\u0442 \u0434\u0430\u0448\u0431\u043E\u0440\u0434\u0443",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
      unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
      matrixTitle: "\u041C\u0430\u0442\u0440\u0438\u0446\u044F \u0432\u0456\u0434\u0436\u0435\u0442\u0456\u0432",
      matrixDescription: "\u0420\u043E\u043B\u044C \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430 \u0437\u0430\u0432\u0436\u0434\u0438 \u0431\u0430\u0447\u0438\u0442\u044C \u0443\u0441\u0456 \u0432\u0456\u0434\u0436\u0435\u0442\u0438 \u0456 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0437\u043C\u0456\u043D\u0435\u043D\u0430.",
      resetToDefaults: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0434\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0445",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      pendingChanges: "{count} \u0437\u043C\u0456\u043D\u0430(\u0438) \u043E\u0447\u0456\u043A\u0443\u0454",
      saving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
      save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
      saveError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
      resetError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u043A\u0438\u0434\u0430\u043D\u043D\u044F",
      resetConfirmTitle: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0441\u043A\u0438\u0434\u0430\u043D\u043D\u044F",
      resetConfirmDescription: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0441\u043A\u0438\u043D\u0443\u0442\u0438 \u0434\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0438\u0445 \u0434\u043E\u0437\u0432\u043E\u043B\u0456\u0432? \u0426\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0441\u0456 \u0432\u043B\u0430\u0441\u043D\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F.",
      resetting: "\u0421\u043A\u0438\u0434\u0430\u043D\u043D\u044F...",
      reset: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438"
    },
    cardExpiry: {
      title: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u043A\u0430\u0440\u0442\u043A\u0438",
      ariaLabel: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u043A\u0430\u0440\u0442\u043E\u043A",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0440\u043C\u0456\u043D\u0443...",
      errorTitle: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      errorMessage: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u0430\u043D\u0456 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u043A\u0430\u0440\u0442\u043A\u0438.",
      alertCount: "\u043F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      noAlerts: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u044C \u043F\u0440\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u043A\u0430\u0440\u0442\u043E\u043A.",
      urgent: "\u0422\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u043E",
      warning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      info: "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
      expiredToday: "\u0417\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
      expiresToday: "\u0417\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
      expiredDaysAgo: "\u0417\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F {days} \u0434\u0435\u043D\u044C(\u0434\u043D\u0456\u0432) \u0442\u043E\u043C\u0443",
      expiresInDays: "\u0417\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0435\u0437 {days} \u0434\u0435\u043D\u044C(\u0434\u043D\u0456\u0432)",
      deposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
      newCard: "\u041D\u043E\u0432\u0430 \u043A\u0430\u0440\u0442\u043A\u0430",
      newCardRequest: "\u0417\u0430\u043F\u0438\u0442 \u043D\u043E\u0432\u043E\u0457 \u043A\u0430\u0440\u0442\u043A\u0438: {partner}",
      newCardStarted: "\u0417\u0430\u043F\u0438\u0442 \u043D\u043E\u0432\u043E\u0457 \u043A\u0430\u0440\u0442\u043A\u0438 \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E",
      alertListAria: "{count} \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u043A\u0430\u0440\u0442\u043A\u0438"
    },
    equipmentProfit: {
      title: "\u0420\u0435\u043D\u0442\u0430\u0431\u0435\u043B\u044C\u043D\u0456\u0441\u0442\u044C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445.",
      avgRoi: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439 ROI",
      totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      totalCosts: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438",
      totalProfit: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043F\u0440\u0438\u0431\u0443\u0442\u043E\u043A",
      totalEquipment: "\u0423\u0441\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      profitable: "\u041F\u0440\u0438\u0431\u0443\u0442\u043A\u043E\u0432\u0435",
      losing: "\u0417\u0431\u0438\u0442\u043A\u043E\u0432\u0435",
      topFive: "\u0422\u043E\u043F 5 \u043D\u0430\u0439\u043F\u0440\u0438\u0431\u0443\u0442\u043A\u043E\u0432\u0456\u0448\u0438\u0445"
    },
    forecast: {
      title: "\u041F\u0440\u043E\u0433\u043D\u043E\u0437 \u0434\u043E\u0445\u043E\u0434\u0443",
      ariaLabel: "\u041F\u0440\u043E\u0433\u043D\u043E\u0437 \u0434\u043E\u0445\u043E\u0434\u0443",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0443 \u0434\u043E\u0445\u043E\u0434\u0443...",
      error: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      errorDescription: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0440\u043E\u0433\u043D\u043E\u0437 \u0434\u043E\u0445\u043E\u0434\u0443.",
      comparedToPreviousMonth: "\u043F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043E \u0437 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u043C \u043C\u0456\u0441\u044F\u0446\u0435\u043C",
      sourceBreakdown: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u0437\u0430 \u0434\u0436\u0435\u0440\u0435\u043B\u043E\u043C",
      previousMonthActual: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0456\u0441\u044F\u0446\u044C \u0444\u0430\u043A\u0442\u0438\u0447\u043D\u0438\u0439",
      sourcePercentage: "{source} ({percentage}%)",
      expectedRevenue: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434"
    },
    partnerActivity: {
      title: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
      expandedTitle: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      transactions: "\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044F(\u0439)",
      totalTransactions: "\u0423\u0441\u044C\u043E\u0433\u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439",
      vsPrevious: "\u043F\u0440\u043E\u0442\u0438 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044C\u043E\u0433\u043E \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      rentals: "\u041E\u0440\u0435\u043D\u0434\u0438",
      sales: "\u041F\u0440\u043E\u0434\u0430\u0436",
      salesPlural: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      date: "\u0414\u0430\u0442\u0430",
      totalColumn: "\u0423\u0441\u044C\u043E\u0433\u043E"
    },
    partnerOverview: {
      title: "\u041E\u0433\u043B\u044F\u0434 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      last30Days: "(30 \u0434\u043D\u0456\u0432)",
      activePartners: "\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439(\u0445) \u043F\u0430\u0440\u0442\u043D\u0435\u0440(\u0456\u0432)",
      categoryRetail: "\u0420\u043E\u0437\u0434\u0440\u0456\u0431",
      categoryB2B: "B2B",
      categoryVIP: "VIP"
    },
    receivables: {
      title: "\u0421\u0442\u0430\u0440\u0456\u043D\u043D\u044F \u0434\u0435\u0431\u0456\u0442\u043E\u0440\u043A\u0438",
      reportTitle: "\u0417\u0432\u0456\u0442 \u0441\u0442\u0430\u0440\u0456\u043D\u043D\u044F \u0434\u0435\u0431\u0456\u0442\u043E\u0440\u043A\u0438",
      totalReceivables: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0434\u0435\u0431\u0456\u0442\u043E\u0440\u043A\u0430",
      bucket0_30: "0-30 \u0434\u043D\u0456\u0432",
      bucket31_60: "31-60 \u0434\u043D\u0456\u0432",
      bucket61_90: "61-90 \u0434\u043D\u0456\u0432",
      bucket90plus: "90+ \u0434\u043D\u0456\u0432",
      invoices: "\u0440\u0430\u0445\u0443\u043D\u043E\u043A(\u0456\u0432)",
      topDebtors: "\u0422\u043E\u043F 3 \u0431\u043E\u0440\u0436\u043D\u0438\u043A\u0438",
      moreDebtors: "\u0449\u0435 \u0431\u043E\u0440\u0436\u043D\u0438\u043A(\u0456\u0432)",
      noReceivables: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0435\u0431\u0456\u0442\u043E\u0440\u043A\u0438",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445.",
      updatedAt: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
      total: "\u0423\u0441\u044C\u043E\u0433\u043E",
      partnersOwe: "\u043F\u0430\u0440\u0442\u043D\u0435\u0440(\u0456\u0432) \u0437\u0430\u0431\u043E\u0440\u0433\u0443\u0432\u0430\u043B\u0438",
      agingBreakdown: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u0437\u0430 \u0432\u0456\u043A\u043E\u043C",
      ofTotal: "\u0432\u0456\u0434 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0433\u043E",
      allDebtors: "\u0423\u0441\u0456 \u0431\u043E\u0440\u0436\u043D\u0438\u043A\u0438",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
      debt: "\u0411\u043E\u0440\u0433",
      invoicesHeader: "\u0420\u0430\u0445\u0443\u043D\u043A\u0438",
      oldestDueDate: "\u041D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0438\u0439 \u0442\u0435\u0440\u043C\u0456\u043D",
      overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
      pcs: "\u0448\u0442.",
      days: "\u0434\u0435\u043D\u044C(\u0434\u043D\u0456\u0432)"
    },
    recurringIssues: {
      title: "\u041F\u043E\u0432\u0442\u043E\u0440\u044E\u0432\u0430\u043D\u0456 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      problematicEquipment: "\u043F\u0440\u043E\u0431\u043B\u0435\u043C\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      critical: "\u043A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      noIssues: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0432\u0442\u043E\u0440\u044E\u0432\u0430\u043D\u0438\u0445 \u043F\u0440\u043E\u0431\u043B\u0435\u043C",
      viewServiceHistory: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0456\u0441\u0442\u043E\u0440\u0456\u044E \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F {name}",
      lastService: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
      more: "\u0449\u0435"
    },
    rentalStats: {
      title: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043E\u0440\u0435\u043D\u0434\u0438",
      ariaLabel: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043E\u0440\u0435\u043D\u0434\u0438",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0438 \u043E\u0440\u0435\u043D\u0434\u0438...",
      error: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      errorDescription: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u043E\u0440\u0435\u043D\u0434\u0438.",
      daysPerRental: "\u0434\u043D\u0456\u0432 / \u043E\u0440\u0435\u043D\u0434\u0430",
      comparedToPreviousPeriod: "\u043F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043E \u0437 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u043C \u043F\u0435\u0440\u0456\u043E\u0434\u043E\u043C",
      totalRentals: "\u0423\u0441\u044C\u043E\u0433\u043E \u043E\u0440\u0435\u043D\u0434",
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
      overdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456"
    },
    seasonality: {
      title: "\u0421\u0435\u0437\u043E\u043D\u043D\u0438\u0439 \u0442\u0440\u0435\u043D\u0434",
      titleShort: "\u0422\u0440\u0435\u043D\u0434 \u043E\u0440\u0435\u043D\u0434\u0438 (12 \u043C\u0456\u0441\u044F\u0446\u0456\u0432)",
      ariaLabel: "\u0421\u0435\u0437\u043E\u043D\u043D\u0438\u0439 \u0442\u0440\u0435\u043D\u0434",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u0435\u0437\u043E\u043D\u043D\u043E\u0433\u043E \u0442\u0440\u0435\u043D\u0434\u0443...",
      error: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      errorDescription: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0435\u0437\u043E\u043D\u043D\u0438\u0439 \u0442\u0440\u0435\u043D\u0434.",
      noData: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u0440\u0435\u043D\u0434\u0443.",
      rentals: "\u041E\u0440\u0435\u043D\u0434\u0438",
      revenue: "\u0414\u043E\u0445\u0456\u0434",
      revenueFt: "\u0414\u043E\u0445\u0456\u0434 (HUF)",
      totalRentals: "\u0423\u0441\u044C\u043E\u0433\u043E \u043E\u0440\u0435\u043D\u0434:",
      totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434:",
      pcs: "\u0448\u0442."
    },
    serviceProfit: {
      title: "\u041F\u0440\u0438\u0431\u0443\u0442\u043A\u043E\u0432\u0456\u0441\u0442\u044C \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445.",
      avgMargin: "\u0421\u0435\u0440\u0435\u0434\u043D\u044F \u043C\u0430\u0440\u0436\u0430",
      totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      partsCost: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D",
      netProfit: "\u0427\u0438\u0441\u0442\u0438\u0439 \u043F\u0440\u0438\u0431\u0443\u0442\u043E\u043A",
      worksheets: "\u0420\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
      laborRevenue: "\u0414\u043E\u0445\u0456\u0434 \u0432\u0456\u0434 \u0440\u043E\u0431\u0456\u0442",
      topFiveTechnicians: "\u0422\u043E\u043F 5 \u0442\u0435\u0445\u043D\u0456\u043A\u0456\u0432 (\u043F\u0440\u0438\u0431\u0443\u0442\u043E\u043A)",
      worksheet: "\u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
      margin: "\u043C\u0430\u0440\u0436\u0430",
      noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u043E \u043F\u0440\u0438\u0431\u0443\u0442\u043E\u043A \u0442\u0435\u0445\u043D\u0456\u043A\u0456\u0432 \u0437\u0430 \u0446\u0435\u0439 \u043F\u0435\u0440\u0456\u043E\u0434."
    },
    serviceRevenue: {
      title: "\u0414\u043E\u0445\u0456\u0434 \u0432\u0456\u0434 \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
      periodSelect: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      periodDay: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
      periodWeek: "\u0422\u0438\u0436\u0434\u0435\u043D\u044C",
      periodMonth: "\u041C\u0456\u0441\u044F\u0446\u044C",
      laborFee: "\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0440\u043E\u0431\u043E\u0442\u0443",
      parts: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438"
    },
    stockAlert: {
      title: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0437\u0430\u043F\u0430\u0441\u0438",
      noShortage: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0435\u0444\u0456\u0446\u0438\u0442\u0443 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      allProductsAdequate: "\u0423\u0441\u0456 \u0442\u043E\u0432\u0430\u0440\u0438 \u043D\u0430 \u043D\u0430\u043B\u0435\u0436\u043D\u043E\u043C\u0443 \u0440\u0456\u0432\u043D\u0456 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      totalAlerts: "\u0423\u0441\u044C\u043E\u0433\u043E \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u044C",
      critical: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      warning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      criticalShortages: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439 \u0434\u0435\u0444\u0456\u0446\u0438\u0442",
      warnings: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F",
      model: "\u041C\u043E\u0434\u0435\u043B\u044C",
      type: "\u0422\u0438\u043F",
      current: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439",
      minimum: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C",
      shortage: "\u0414\u0435\u0444\u0456\u0446\u0438\u0442",
      lastOrder: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      status: "\u0421\u0442\u0430\u0442\u0443\u0441"
    },
    stockHeatmap: {
      title: "\u0422\u0435\u043F\u043B\u043E\u0432\u0430 \u043A\u0430\u0440\u0442\u0430 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      description: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0437\u0430\u043F\u0430\u0441\u0456\u0432 \u0437\u0430 \u0442\u0438\u043F\u043E\u043C \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0442\u0430 \u043B\u043E\u043A\u0430\u0446\u0456\u0454\u044E"
    },
    stockMovement: {
      title: "\u0420\u0443\u0445 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      subtitle: "\u0420\u0443\u0445 \u0437\u0430\u043F\u0430\u0441\u0456\u0432 - \u043E\u0441\u0442\u0430\u043D\u043D\u0456 30 \u0434\u043D\u0456\u0432",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      incoming: "\u0412\u0445\u0456\u0434\u043D\u0456",
      outgoing: "\u0412\u0438\u0445\u0456\u0434\u043D\u0456",
      returns: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      netChange: "\u041D\u0435\u0442\u0442\u043E \u0437\u043C\u0456\u043D\u0430"
    },
    techWorkload: {
      title: "\u041D\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u0435\u0445\u043D\u0456\u043A\u0456\u0432",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      worksheetsOf: "\u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
      more: "\u0449\u0435",
      moreTechnicians: "\u0449\u0435 \u0442\u0435\u0445\u043D\u0456\u043A(\u0456\u0432)",
      totalTechnicians: "\u0423\u0441\u044C\u043E\u0433\u043E \u0442\u0435\u0445\u043D\u0456\u043A\u0456\u0432",
      active: "\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      activeWorksheets: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
      noActiveWorksheets: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043B\u0438\u0441\u0442\u0456\u0432",
      priority: {
        low: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
        normal: "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u0438\u0439",
        high: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
        urgent: "\u0422\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u043E"
      }
    },
    topPartners: {
      title: "\u0422\u043E\u043F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
      expandedTitle: "\u0422\u043E\u043F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
      periodMonth: "\u041C\u0456\u0441\u044F\u0446\u044C",
      periodQuarter: "\u041A\u0432\u0430\u0440\u0442\u0430\u043B",
      periodYear: "\u0420\u0456\u043A",
      periodSelect: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      giftEligible: "\u041C\u0430\u0454 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u043F\u043E\u0434\u0430\u0440\u0443\u043D\u043E\u043A",
      morePartners: "\u0449\u0435 \u043F\u0430\u0440\u0442\u043D\u0435\u0440(\u0456\u0432)",
      period: "\u041F\u0435\u0440\u0456\u043E\u0434",
      partner: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440",
      totalRevenue: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      sales: "\u041F\u0440\u043E\u0434\u0430\u0436",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441"
    },
    vat: {
      title: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u041F\u0414\u0412",
      ariaLabel: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u041F\u0414\u0412",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0456\u0434\u0441\u0443\u043C\u043A\u0443 \u041F\u0414\u0412...",
      errorTitle: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      errorMessage: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u041F\u0414\u0412.",
      payable: "\u041F\u0414\u0412 \u0434\u043E \u0441\u043F\u043B\u0430\u0442\u0438",
      claimable: "\u041F\u0414\u0412 \u0434\u043E \u0432\u0456\u0434\u0448\u043A\u043E\u0434\u0443\u0432\u0430\u043D\u043D\u044F",
      outputVat: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439",
      inputVat: "\u0412\u0445\u0456\u0434\u043D\u0438\u0439",
      rateBreakdown: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u0437\u0430 \u0441\u0442\u0430\u0432\u043A\u043E\u044E"
    },
    warranty: {
      title: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0435 \u0441\u043F\u0456\u0432\u0432\u0456\u0434\u043D\u043E\u0448\u0435\u043D\u043D\u044F",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      warranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
      paid: "\u041F\u043B\u0430\u0442\u043D\u0438\u0439",
      repairs: "\u0440\u0435\u043C\u043E\u043D\u0442(\u0456\u0432)",
      paidRevenue: "\u041F\u043B\u0430\u0442\u043D\u0438\u0439 \u0434\u043E\u0445\u0456\u0434",
      sixMonthTrend: "\u0422\u0440\u0435\u043D\u0434 \u0437\u0430 6 \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
      trendUp: "\u0437\u0440\u043E\u0441\u0442\u0430\u0454",
      trendDown: "\u0437\u043C\u0435\u043D\u0448\u0443\u0454\u0442\u044C\u0441\u044F",
      trendStable: "\u0441\u0442\u0430\u0431\u0456\u043B\u044C\u043D\u0438\u0439"
    },
    worksheet: {
      title: "\u0420\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      activeWorksheets: "\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439(\u0445) \u0440\u043E\u0431\u043E\u0447\u0438\u0439(\u0445) \u043B\u0438\u0441\u0442(\u0456\u0432)",
      status: {
        draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
        diagnosed: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u043E\u0432\u0430\u043D\u043E",
        inProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
        waitingParts: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D",
        completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        closed: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E"
      }
    },
    emptyState: {
      message: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u0436\u0435\u0442\u0443 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
      hint: "\u0417\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430",
      defaultMessage: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
      defaultHint: "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0456\u043D\u0448\u0456 \u043A\u0440\u0438\u0442\u0435\u0440\u0456\u0457 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u0446\u0456\u0457."
    },
    partnerCredit: {
      comingSoon: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C...",
      featureInProgress: "\u0424\u0443\u043D\u043A\u0446\u0456\u044F \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u0430 - \u0440\u0435\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      managementLabel: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u043C \u043B\u0456\u043C\u0456\u0442\u043E\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      title: "\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u0439 \u043B\u0456\u043C\u0456\u0442 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      tooltipDescription: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u043C \u043B\u0456\u043C\u0456\u0442\u043E\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 - \u043C\u0430\u0439\u0431\u0443\u0442\u043D\u0456\u0439 epic"
    },
    popularEquipment: {
      ariaLabel: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      error: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
      errorDescription: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F.",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F...",
      noData: "\u0429\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u043E \u043E\u0440\u0435\u043D\u0434\u0443.",
      rentalCount: "{count} \u043E\u0440\u0435\u043D\u0434\u0430(\u0438)",
      title: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      top5Title: "\u0422\u043E\u043F 5 \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      top5Total: "\u0422\u043E\u043F 5 \u0437\u0430\u0433\u0430\u043B\u043E\u043C"
    },
    warrantyPlaceholder: {
      comingSoon: "\u041D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C...",
      epicInfo: "\u0420\u0435\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u043E \u0432 Epic 38",
      ratioLabel: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0435 vs \u043F\u043B\u0430\u0442\u043D\u0435 \u0441\u043F\u0456\u0432\u0432\u0456\u0434\u043D\u043E\u0448\u0435\u043D\u043D\u044F",
      title: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0435 \u0441\u043F\u0456\u0432\u0432\u0456\u0434\u043D\u043E\u0448\u0435\u043D\u043D\u044F",
      tooltipDescription: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0435 vs \u043F\u043B\u0430\u0442\u043D\u0435 \u0441\u043F\u0456\u0432\u0432\u0456\u0434\u043D\u043E\u0448\u0435\u043D\u043D\u044F - \u0432 Epic 38"
    },
    error: {
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456 \u0434\u0430\u043D\u0438\u0445",
      errorTitle: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0432\u0456\u0434\u0436\u0435\u0442\u0430",
      retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438"
    },
    alert: {
      details: "\u0414\u0435\u0442\u0430\u043B\u0456"
    },
    stock: {
      critical: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      warning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F"
    }
  },
  integration: {
    crm: {
      errorDescription: "\u0421\u0435\u0440\u0432\u0456\u0441 Twenty CRM \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0430\u0431\u043E \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0431\u043B\u043E\u043A\u0443\u0454 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F iframe.",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F Twenty CRM...",
      subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0432\u0456\u0434\u043D\u043E\u0441\u0438\u043D\u0430\u043C\u0438 \u0437 \u043A\u043B\u0456\u0454\u043D\u0442\u0430\u043C\u0438"
    },
    hr: {
      errorDescription: "\u0421\u0435\u0440\u0432\u0456\u0441 Horilla HR \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0430\u0431\u043E \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0431\u043B\u043E\u043A\u0443\u0454 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F iframe.",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F Horilla HR...",
      subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043B\u044E\u0434\u0441\u044C\u043A\u0438\u043C\u0438 \u0440\u0435\u0441\u0443\u0440\u0441\u0430\u043C\u0438"
    },
    flow: {
      errorDescription: "rPI Flow \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439.",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F rPI Flow...",
      subtitle: "\u0417\u0430\u043F\u0443\u0441\u043A \u0442\u0430 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043F\u0440\u043E\u0446\u0435\u0441\u0456\u0432",
      unavailable: "rPI Flow \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0438\u0439 \u043D\u0430 \u0446\u044C\u043E\u043C\u0443 \u0441\u0435\u0440\u0432\u0435\u0440\u0456.",
      publishedWorkflows: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043F\u0440\u043E\u0446\u0435\u0441\u0438",
      noWorkflows: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0438\u0445 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043F\u0440\u043E\u0446\u0435\u0441\u0456\u0432",
      recentExecutions: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F",
      noExecutions: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u044C",
      steps: "\u043A\u0440\u043E\u043A\u0456\u0432",
      tabs: {
        catalog: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433",
        running: "\u0417\u0430\u043F\u0443\u0449\u0435\u043D\u0456",
        history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F",
        approvals: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
        operations: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457"
      },
      running: {
        noExecutions: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0438\u0445 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043F\u0440\u043E\u0446\u0435\u0441\u0456\u0432",
        startOne: "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0438 \u2192",
        step: "\u043A\u0440\u043E\u043A"
      },
      health: {
        ok: "OK",
        offline: "\u041E\u0444\u043B\u0430\u0439\u043D",
        workflows: "\u0440\u043E\u0431\u043E\u0447\u0456 \u043F\u0440\u043E\u0446\u0435\u0441\u0438",
        running: "\u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0456",
        approvals: "\u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
        schedules: "\u0440\u043E\u0437\u043A\u043B\u0430\u0434\u0438"
      },
      operations: {
        engineHealth: "\u0421\u0442\u0430\u043D \u0434\u0432\u0438\u0436\u043A\u0430",
        online: "\u041E\u043D\u043B\u0430\u0439\u043D",
        offline: "\u041E\u0444\u043B\u0430\u0439\u043D",
        registeredWorkflows: "\u0437\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u043E\u0432\u0430\u043D\u0456 \u043F\u0440\u043E\u0446\u0435\u0441\u0438",
        dailyStats: "\u0414\u0435\u043D\u043D\u0430 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
        totalToday: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u0432\u0441\u044C\u043E\u0433\u043E",
        successRate: "\u0423\u0441\u043F\u0456\u0448\u043D\u0456\u0441\u0442\u044C",
        schedules: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434\u0438",
        schedulesInfo: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0456 \u043F\u0440\u043E\u0446\u0435\u0441\u0438 \u0437'\u044F\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0442\u0443\u0442"
      },
      schedule: {
        title: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434",
        save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        saved: "\u23F0 \u0420\u043E\u0437\u043A\u043B\u0430\u0434 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0440\u043E\u0437\u043A\u043B\u0430\u0434",
        daily: "\u0429\u043E\u0434\u043D\u044F",
        weekdays: "\u0420\u043E\u0431\u043E\u0447\u0456 \u0434\u043D\u0456",
        weekly: "\u0429\u043E\u0442\u0438\u0436\u043D\u044F",
        monthly: "\u0429\u043E\u043C\u0456\u0441\u044F\u0446\u044F",
        custom: "\u0414\u043E\u0432\u0456\u043B\u044C\u043D\u0438\u0439 cron",
        dayOfMonth: "\u0414\u0435\u043D\u044C \u043C\u0456\u0441\u044F\u0446\u044F",
        monday: "\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        tuesday: "\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        wednesday: "\u0421\u0435\u0440\u0435\u0434\u0430",
        thursday: "\u0427\u0435\u0442\u0432\u0435\u0440",
        friday: "\u041F'\u044F\u0442\u043D\u0438\u0446\u044F",
        saturday: "\u0421\u0443\u0431\u043E\u0442\u0430",
        sunday: "\u041D\u0435\u0434\u0456\u043B\u044F"
      },
      approval: {
        approve: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        reject: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        approved: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        rejected: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        error: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
        noPending: "\u041D\u0435\u043C\u0430\u0454 \u043E\u0447\u0456\u043A\u0443\u044E\u0447\u0438\u0445 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u044C \u2705",
        pastDecisions: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456 \u0440\u0456\u0448\u0435\u043D\u043D\u044F",
        requestedBy: "\u0417\u0430\u043F\u0438\u0442\u0430\u0432",
        requiredRole: "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0430 \u0440\u043E\u043B\u044C",
        reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
        rejectTitle: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
        reasonPlaceholder: "\u041E\u043F\u0438\u0448\u0456\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F..."
      },
      history: {
        noExecutions: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0445 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u044C",
        noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438",
        startOne: "\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0438 \u2192",
        filterStatus: "\u0421\u0442\u0430\u0442\u0443\u0441",
        filterWorkflow: "\u041F\u0440\u043E\u0446\u0435\u0441",
        filterPeriod: "\u041F\u0435\u0440\u0456\u043E\u0434",
        periodAll: "\u0412\u0441\u0456",
        periodToday: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        periodWeek: "\u0426\u044C\u043E\u0433\u043E \u0442\u0438\u0436\u043D\u044F",
        periodMonth: "\u0426\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F",
        restart: "\u041F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u043A"
      },
      toast: {
        completed: "\u2705 {name} \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        failed: "\u274C {name} \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
      },
      execution: {
        details: "\u0414\u0435\u0442\u0430\u043B\u0456",
        hideDetails: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438",
        parameters: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438",
        cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        cancelConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456?",
        cancelled: "{name} \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
        keepRunning: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438"
      },
      status: {
        running: "\u0412\u0438\u043A\u043E\u043D\u0443\u0454\u0442\u044C\u0441\u044F",
        pending: "\u041E\u0447\u0456\u043A\u0443\u0454",
        completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
        failed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430",
        cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
      },
      emptyState: {
        running: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0438\u0445 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043F\u0440\u043E\u0446\u0435\u0441\u0456\u0432",
        history: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0445 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u044C",
        approvals: "\u041D\u0435\u043C\u0430\u0454 \u043E\u0447\u0456\u043A\u0443\u044E\u0447\u0438\u0445 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u044C",
        operations: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457 \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C..."
      },
      categories: {
        finance: "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
        service: "\u0421\u0435\u0440\u0432\u0456\u0441",
        inventory: "\u0406\u043D\u0432\u0435\u043D\u0442\u0430\u0440",
        sales: "\u041F\u0440\u043E\u0434\u0430\u0436",
        reporting: "\u0417\u0432\u0456\u0442\u0438",
        compliance: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C",
        hr: "HR",
        operations: "\u041E\u043F\u0435\u0440\u0430\u0446\u0456\u0457"
      },
      startWorkflow: "\u0417\u0430\u043F\u0443\u0441\u043A",
      favorites: "\u041E\u0431\u0440\u0430\u043D\u0456",
      pinWorkflow: "\u0417\u0430\u043A\u0440\u0456\u043F\u0438\u0442\u0438",
      unpinWorkflow: "\u0412\u0456\u0434\u043A\u0440\u0456\u043F\u0438\u0442\u0438",
      execute: {
        title: "\u0417\u0430\u043F\u0443\u0441\u043A \u043F\u0440\u043E\u0446\u0435\u0441\u0443",
        submit: "\u0417\u0430\u043F\u0443\u0441\u043A",
        success: "{name} \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u043E",
        error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0438 {name}",
        steps: "\u041A\u0440\u043E\u043A\u0438",
        required: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435 \u043F\u043E\u043B\u0435"
      }
    },
    loadFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
    openInNewTab: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u043E\u0432\u043E\u043C\u0443 \u0432\u0456\u043A\u043D\u0456",
    refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
    retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
    sso: {
      active: "SSO \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      connecting: "SSO...",
      fallback: "\u0420\u0443\u0447\u043D\u0438\u0439 \u0432\u0445\u0456\u0434",
      retryButton: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 SSO"
    }
  },
  myforge: {
    openInNewTab: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u043E\u0432\u043E\u043C\u0443 \u0432\u0456\u043A\u043D\u0456"
  },
  pwa: {
    close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    install: {
      button: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438",
      description: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0456\u0442\u044C \u0434\u043E\u0434\u0430\u0442\u043E\u043A \u043D\u0430 \u0433\u043E\u043B\u043E\u0432\u043D\u0438\u0439 \u0435\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0448\u0432\u0438\u0434\u0448\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0443!",
      title: "\u0412\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043E\u043A"
    },
    notification: {
      description: "\u041E\u0442\u0440\u0438\u043C\u0443\u0439\u0442\u0435 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0432\u0430\u0436\u043B\u0438\u0432\u0456 \u043F\u043E\u0434\u0456\u0457, \u043E\u0440\u0435\u043D\u0434\u0438 \u0442\u0430 \u0441\u0442\u0430\u043D \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F.",
      dismiss: "\u041D\u0435 \u0437\u0430\u0440\u0430\u0437",
      enable: "\u0423\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438",
      title: "\u0423\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F"
    },
    offline: {
      message: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F \u0434\u043E \u0406\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0443"
    },
    update: {
      button: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      dismiss: "\u041F\u0456\u0437\u043D\u0456\u0448\u0435",
      message: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043D\u043E\u0432\u0430 \u0432\u0435\u0440\u0441\u0456\u044F"
    }
  },
  worksheetPrint: {
    downloadPdf: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 PDF",
    emailPlaceholder: "Email \u0430\u0434\u0440\u0435\u0441\u0430",
    emailSendFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 email",
    emailSent: "Email \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
    errorPrefix: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430",
    generating: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F PDF...",
    pdfGenerationFailed: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F PDF \u043D\u0435 \u0432\u0434\u0430\u043B\u0430\u0441\u044F",
    pdfTitle: "PDF \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    print: "\u0414\u0440\u0443\u043A",
    sendEmail: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 email",
    sending: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F...",
    title: "\u0414\u0440\u0443\u043A \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
    unknownError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: \u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430"
  },
  permission: {
    module: {
      auth: "\u0410\u0432\u0442\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F",
      users: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456",
      partners: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0438",
      inventory: "\u0417\u0430\u043F\u0430\u0441\u0438",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      sales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      reports: "\u0417\u0432\u0456\u0442\u0438",
      settings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F"
    }
  },
  worksheet: {
    status: {
      felveve: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
      folyamatban: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      varhato: "\u041E\u0447\u0456\u043A\u0443\u0454",
      felfuggesztve: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043E",
      kesz: "\u0413\u043E\u0442\u043E\u0432\u043E",
      szamlazando: "\u0414\u043E \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      lezart: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E",
      torolve: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043E"
    },
    stepper: {
      ariaLabel: "\u041F\u0435\u0440\u0435\u0431\u0456\u0433 \u0441\u0442\u0430\u0442\u0443\u0441\u0443 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0430\u0440\u043A\u0443\u0448\u0430",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
      completed: "\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      current: "\u043F\u043E\u0442\u043E\u0447\u043D\u0438\u0439"
    },
    type: {
      fizetos: "\u041F\u043B\u0430\u0442\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442",
      garancialis: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
      berlesi: "\u0421\u0435\u0440\u0432\u0456\u0441 \u043E\u0440\u0435\u043D\u0434\u0438",
      karbantartas: "\u041E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
      szerzodeses: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0438\u0439"
    },
    priority: {
      surgos: "\u0422\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u043E (+20%)",
      felaras: "\u0417 \u0434\u043E\u043F\u043B\u0430\u0442\u043E\u044E",
      garancialis: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
      franchise: "\u0424\u0440\u0430\u043D\u0448\u0438\u0437\u0430",
      normal: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
      surcharge: "\u0417 \u0434\u043E\u043F\u043B\u0430\u0442\u043E\u044E"
    },
    category: {
      powerTool: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      garden: "\u0421\u0430\u0434\u043E\u0432\u0438\u0439 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      construction: "\u0411\u0443\u0434\u0456\u0432\u0435\u043B\u044C\u043D\u0438\u0439",
      cleaning: "\u041F\u0440\u0438\u0431\u0438\u0440\u0430\u043B\u044C\u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0430",
      other: "\u0406\u043D\u0448\u0435"
    },
    history: {
      created: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      statusChanged: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u043C\u0456\u043D\u0435\u043D\u043E",
      itemAdded: "\u0415\u043B\u0435\u043C\u0435\u043D\u0442 \u0434\u043E\u0434\u0430\u043D\u043E",
      itemRemoved: "\u0415\u043B\u0435\u043C\u0435\u043D\u0442 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
      assigned: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
      noteAdded: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0443 \u0434\u043E\u0434\u0430\u043D\u043E",
      invoiced: "\u0412\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E"
    },
    placeholder: {
      estimatedCost: "\u043D\u0430\u043F\u0440. 50000"
    },
    repairType: {
      title: "\u0422\u0438\u043F \u0440\u0435\u043C\u043E\u043D\u0442\u0443",
      description: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0440\u0435\u043C\u043E\u043D\u0442\u0443",
      fizetos: "\u041F\u043B\u0430\u0442\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442",
      fizetosDesc: "\u041F\u043B\u0430\u0442\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u043C\u043E\u0436\u0435 \u0441\u0442\u044F\u0433\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0443",
      garancialis: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0438\u0439",
      garancialisDesc: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0443 \u043D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F",
      szerzodeses: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440",
      szerzodesesDesc: "\u0420\u0435\u043C\u043E\u043D\u0442 \u0434\u043B\u044F \u0434\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430, \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0434\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0443 \u043D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F",
      szerzodesesBadge: "\u0412\u0438\u044F\u0432\u043B\u0435\u043D\u043E \u0434\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      selected: "\u0412\u0438\u0431\u0440\u0430\u043D\u043E: {type}"
    },
    inspectionFee: {
      notApplicable: "\u041D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F ({reason})",
      change: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434",
      confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434",
      confirmed: "\u041F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
      overridden: "\u041F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
      override: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434",
      suggested: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0430 \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434",
      urgent: "\u0422\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u0438\u0439 \u0437\u0431\u0456\u0440"
    },
    paymentGate: {
      title: "\u041D\u0435\u043E\u0431\u0445\u0456\u0434\u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434",
      description: "\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434 ({amount}) \u043F\u043E\u0432\u0438\u043D\u043D\u0430 \u0431\u0443\u0442\u0438 \u0441\u043F\u043B\u0430\u0447\u0435\u043D\u0430 \u043F\u0435\u0440\u0435\u0434 \u043F\u043E\u0447\u0430\u0442\u043A\u043E\u043C \u0440\u043E\u0431\u043E\u0442\u0438. \u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u0435 \u0442\u0435\u0445\u043D\u0456\u043A\u0443 \u0442\u0456\u043B\u044C\u043A\u0438 \u043F\u0456\u0441\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u0438.",
      markPaid: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u0441\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      blockInfo: "\u0420\u043E\u0431\u043E\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u043F\u043E\u0447\u0430\u0442\u0438\u0441\u044F \u0431\u0435\u0437 \u043E\u043F\u043B\u0430\u0442\u0438"
    },
    pendingPartsBlock: {
      title: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0437\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E \u2014 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0456 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438",
      description: "{count} \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0445 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u044C \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D. \u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0430\u0431\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0438, \u0434\u043E\u043A\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438 \u043D\u0435 \u043D\u0430\u0434\u0456\u0439\u0434\u0443\u0442\u044C.",
      blockInfo: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D",
      toast: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0437\u0430\u043A\u0440\u0438\u0442\u0438 \u0437 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u043C\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F\u043C\u0438 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D."
    },
    inspectionFeeCredit: {
      label: "\u041A\u0440\u0435\u0434\u0438\u0442 \u0437\u0430 \u043E\u0433\u043B\u044F\u0434\u043E\u0432\u0438\u0439 \u0437\u0431\u0456\u0440",
      netAfterCredit: "\u0414\u043E \u0441\u043F\u043B\u0430\u0442\u0438 (\u043F\u0456\u0441\u043B\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u0443)"
    },
    costAllocation: {
      title: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u0432\u0438\u0442\u0440\u0430\u0442",
      customerFacing: "\u0414\u043B\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
      customerTotal: "\u041A\u043B\u0456\u0454\u043D\u0442 \u0432\u0441\u044C\u043E\u0433\u043E (\u043D\u0435\u0442\u0442\u043E)",
      internal: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438 (\u0441\u0443\u0431\u043F\u0456\u0434\u0440\u044F\u0434\u043D\u0438\u043A)",
      internalTotal: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u0456 \u0432\u0441\u044C\u043E\u0433\u043E",
      grandTotal: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u0441\u0443\u043C\u0430 (\u0431\u0440\u0443\u0442\u0442\u043E)",
      vatIncluded: "\u0412\u043A\u043B\u044E\u0447\u0430\u0454 \u041F\u0414\u0412"
    },
    basket: {
      title: "\u041A\u043E\u0448\u0438\u043A \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043B\u0438\u0441\u0442\u0456\u0432",
      addPlaceholder: "ID \u0430\u0431\u043E \u043D\u043E\u043C\u0435\u0440 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430...",
      empty: "\u041A\u043E\u0448\u0438\u043A \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u0439",
      clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
      checkout: "\u0417\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      checkoutSuccess: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0437\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u043E",
      warrantyError: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u043A\u043E\u0448\u0438\u043A\u0430 \u2014 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u043F\u043E\u043A\u0440\u0438\u0432\u0430\u0454 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A/\u0433\u0430\u0440\u0430\u043D\u0442\u0456\u044F \u0447\u0435\u0440\u0435\u0437 \u043E\u043A\u0440\u0435\u043C\u0435 \u043F\u0430\u043A\u0435\u0442\u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432."
    },
    supplierSettlement: {
      title: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439 \u0437 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u043E\u043C",
      subtitle: "\u0413\u0435\u043D\u0435\u0440\u0430\u0446\u0456\u044F \u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0445 \u0440\u0430\u0445\u0443\u043D\u043A\u0456\u0432 \u0437\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u0434\u043B\u044F \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0456\u0432",
      filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
      from: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      to: "\u041A\u0456\u043D\u0435\u0446\u044C \u043F\u0435\u0440\u0456\u043E\u0434\u0443",
      search: "\u041F\u043E\u0448\u0443\u043A",
      filterRequired: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430 \u0442\u0430 \u043F\u0435\u0440\u0456\u043E\u0434",
      eligible: "\u041F\u0440\u0438\u0434\u0430\u0442\u043D\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u043B\u0438\u0441\u0442\u0438",
      generateInvoice: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438 \u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      generated: "\u0417\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0433\u0435\u043D\u0435\u0440\u043E\u0432\u0430\u043D\u043E!",
      invoiceNumber: "\u041D\u043E\u043C\u0435\u0440 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      worksheets: "\u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043B\u0438\u0441\u0442\u0456\u0432",
      wsNumber: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u2116",
      brand: "\u0411\u0440\u0435\u043D\u0434",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E"
    },
    procurement: {
      title: "\u0417\u0430\u043F\u0438\u0442\u0438 \u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044E \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D",
      addRequest: "\u041D\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442",
      empty: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0442\u0456\u0432 \u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044E \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
      descriptionPlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0434\u0435\u0442\u0430\u043B\u0456 \u0430\u0431\u043E \u043E\u043F\u0438\u0441...",
      markOrdered: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
      markReceived: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
      status: {
        pending: "\u041E\u0447\u0456\u043A\u0443\u0454",
        ordered: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
        received: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
        cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
      }
    },
    hourlyRateConfig: {
      title: "\u041A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044F \u043F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u043E\u0457 \u0441\u0442\u0430\u0432\u043A\u0438 \u0441\u0435\u0440\u0432\u0456\u0441\u0443",
      subtitle: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u043E\u0457 \u0441\u0442\u0430\u0432\u043A\u0438 \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0454\u044E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      tableTitle: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 \u0437\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0454\u044E (\u043D\u0435\u0442\u0442\u043E HUF)",
      category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
      fallbackRate: "\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
      configuredRate: "\u041D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430",
      invalidRate: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432\u0456\u0434'\u0454\u043C\u043D\u043E\u044E",
      priorityInfo: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442: \u0441\u0442\u0430\u0432\u043A\u0430 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 > \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 > \u0442\u0430\u0431\u043B\u0438\u0446\u044F \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C > 8 000 HUF"
    },
    markReadyAction: "\u0420\u043E\u0431\u043E\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
    isWarranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
    suspendAction: "\u041F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0438\u0442\u0438",
    resumeAction: "\u0412\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438",
    suspendedTitle: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043F\u0440\u0438\u0437\u0443\u043F\u0438\u043D\u0435\u043D\u043E \u2014 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438",
    suspendedDescription: "\u041F\u0456\u0434 \u0447\u0430\u0441 \u0440\u0435\u043C\u043E\u043D\u0442\u0443 \u0432\u0438\u044F\u0432\u043B\u0435\u043D\u043E \u043D\u043E\u0432\u0443 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443, \u044F\u043A\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u0432\u0438\u0442\u0440\u0430\u0442. \u041E\u0447\u0456\u043A\u0443\u0454\u043C\u043E \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u043A\u043B\u0456\u0454\u043D\u0442\u0430.",
    newQuoteVersion: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u043E\u0432\u0443 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    resumeOriginalScope: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0437 \u043F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u043C \u043E\u0431\u0441\u044F\u0433\u043E\u043C",
    machineCategory: {
      title: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F \u0442\u0435\u0445\u043D\u0456\u043A\u0438",
      subtitle: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0442\u0435\u0445\u043D\u0456\u043A\u0438",
      electricSmall: "\u041C\u0430\u043B\u0438\u0439 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      electricLarge: "\u0412\u0435\u043B\u0438\u043A\u0438\u0439 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
      petrolHandheld: "\u0411\u0435\u043D\u0437\u0438\u043D\u043E\u0432\u0438\u0439 \u0440\u0443\u0447\u043D\u0438\u0439",
      petrolPush: "\u0411\u0435\u043D\u0437\u0438\u043D\u043E\u0432\u0430 \u0433\u0430\u0437\u043E\u043D\u043E\u043A\u043E\u0441\u0430\u0440\u043A\u0430",
      tractor: "\u0422\u0440\u0430\u043A\u0442\u043E\u0440/\u0440\u0430\u0439\u0434\u0435\u0440",
      battery: "\u0410\u043A\u0443\u043C\u0443\u043B\u044F\u0442\u043E\u0440\u043D\u0438\u0439"
    },
    filter: {
      machineCategory: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F \u0442\u0435\u0445\u043D\u0456\u043A\u0438",
      allCategories: "\u0423\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457"
    },
    directRepairBadge: "\u041D\u0435\u0433\u0430\u0439\u043D\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u2014 \u0443 \u043C\u0435\u0436\u0430\u0445 \u043B\u0456\u043C\u0456\u0442\u0443 \u0432\u0438\u0442\u0440\u0430\u0442",
    costLimitSkip: "\u0415\u0442\u0430\u043F \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457 \u043F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E \u2014 \u043E\u0440\u0456\u0454\u043D\u0442\u043E\u0432\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0443 \u043C\u0435\u0436\u0430\u0445 \u043B\u0456\u043C\u0456\u0442\u0443",
    technician: {
      title: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0456 \u0442\u0435\u0445\u043D\u0456\u043A\u0438",
      primary: "\u0413\u043E\u043B\u043E\u0432\u043D\u0438\u0439 \u0442\u0435\u0445\u043D\u0456\u043A",
      coTech: "\u041F\u043E\u043C\u0456\u0447\u043D\u0438\u043A \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
      maxReached: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C {max} \u043F\u043E\u043C\u0456\u0447\u043D\u0438\u043A\u0456\u0432 \u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438",
      maxCoTechInfo: "\u041C\u0430\u043A\u0441 {max} \u043F\u043E\u043C\u0456\u0447\u043D\u0438\u043A\u0456\u0432",
      noAssigned: "\u0422\u0435\u0445\u043D\u0456\u043A \u043D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
      addTechnician: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
      nameLabel: "\u0406\u043C'\u044F \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
      namePlaceholder: "\u043D\u0430\u043F\u0440. \u0406\u0432\u0430\u043D \u041F\u0435\u0442\u0440\u0435\u043D\u043A\u043E",
      roleLabel: "\u0420\u043E\u043B\u044C",
      nameRequired: "\u0406\u043C'\u044F \u0442\u0435\u0445\u043D\u0456\u043A\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435 (\u043C\u0456\u043D. 2 \u0441\u0438\u043C\u0432\u043E\u043B\u0438)"
    },
    batch: {
      tabTitle: "\u0413\u0440\u0443\u043F\u043E\u0432\u0435 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
      scanTitle: "\u0421\u043A\u0430\u043D\u0435\u0440 \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434\u0456\u0432",
      scanPlaceholder: "\u0421\u043A\u0430\u043D\u0443\u0439\u0442\u0435 \u0430\u0431\u043E \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u0448\u0442\u0440\u0438\u0445-\u043A\u043E\u0434...",
      worksheetType: "\u0422\u0438\u043F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
      scannedItems: "\u0412\u0456\u0434\u0441\u043A\u0430\u043D\u043E\u0432\u0430\u043D\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438",
      createAll: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0432\u0441\u0456",
      results: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438",
      successCount: "{count} \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      failureCount: "{count} \u043D\u0435\u0432\u0434\u0430\u043B\u0438\u0445"
    },
    tabs: {
      overview: "\u041E\u0433\u043B\u044F\u0434",
      diagnosis: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0430",
      parts: "\u0417\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0438",
      history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F",
      photos: "\u0424\u043E\u0442\u043E",
      warranty: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
      noWarranty: "\u041D\u0435\u043C\u0430\u0454 \u0433\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u043E\u0457 \u0437\u0430\u044F\u0432\u043A\u0438 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0430\u0440\u043A\u0443\u0448\u0430."
    },
    closeConfirm: {
      title: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u0430\u0440\u043A\u0443\u0448",
      warning: "{count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043D\u043D\u044F \u0449\u0435 \u0432 \u043E\u0431\u0440\u043E\u0431\u0446\u0456. \u0412\u0441\u0435 \u043E\u0434\u043D\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0438 \u0430\u0440\u043A\u0443\u0448?",
      qty: "{qty} \u0448\u0442",
      unnamedItem: "\u041F\u043E\u0437\u0438\u0446\u0456\u044F \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043D\u043D\u044F",
      confirm: "\u0412\u0441\u0435 \u043E\u0434\u043D\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0438",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      status: {
        DRAFT: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
        SUBMITTED: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        ORDERED: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E"
      }
    },
    historyEvents: {
      created: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      received: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
      diagnosed: "\u0414\u0456\u0430\u0433\u043D\u043E\u0441\u0442\u0438\u043A\u0443 \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E",
      started: "\u0420\u0435\u043C\u043E\u043D\u0442 \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      notified: "\u041A\u043B\u0456\u0454\u043D\u0442\u0430 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043E",
      delivered: "\u041F\u0435\u0440\u0435\u0434\u0430\u043D\u043E",
      closed: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E",
      empty: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0434\u0456\u0439 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F"
    },
    intakeBatch: {
      count: "{count} \u043C\u0430\u0448\u0438\u043D \u0432 \u043E\u0434\u043D\u043E\u043C\u0443 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u0456",
      current: "\u0446\u0435\u0439 \u043D\u0430\u0440\u044F\u0434",
      error: "\u0414\u0430\u043D\u0456 \u0433\u0440\u0443\u043F\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456",
      title: "\u0413\u0440\u0443\u043F\u043E\u0432\u0435 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
      formTitle: "\u0413\u0440\u0443\u043F\u043E\u0432\u0435 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u043D\u0430\u0440\u044F\u0434\u0456\u0432",
      formDesc: "\u041A\u0456\u043B\u044C\u043A\u0430 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457\u0432 \u0432\u0456\u0434 \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043E\u0434\u043D\u043E\u0447\u0430\u0441\u043D\u043E, \u043F\u0456\u0434 \u0441\u043F\u0456\u043B\u044C\u043D\u0438\u043C \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440\u043E\u043C \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F.",
      partnerSection: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      partnerHint: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430, \u0434\u043E \u044F\u043A\u043E\u0433\u043E \u043D\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0446\u0435 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F.",
      selectedPartner: "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440: {name}",
      changePartner: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      batchSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
      deviceList: "\u041F\u0440\u0438\u0441\u0442\u0440\u043E\u0457",
      itemHeading: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 {index}",
      addItem: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439",
      removeItem: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439",
      itemCount: "{count} / 26 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457\u0432",
      submit: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F ({count} \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457\u0432)",
      submitting: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F\u2026",
      successTitle: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      successDesc: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E {count} \u043D\u0430\u0440\u044F\u0434\u0456\u0432 \u2014 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F: {batchId}",
      newBatch: "\u041D\u043E\u0432\u0435 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F",
      listBadge: "\u041F\u0430\u0440\u0442\u0456\u044F",
      listBadgeHint: "\u0413\u0440\u0443\u043F\u043E\u0432\u0438\u0439 \u043F\u0440\u0438\u0439\u043E\u043C \u2014 \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0441\u044E \u043F\u0430\u0440\u0442\u0456\u044E",
      filterActive: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0433\u0440\u0443\u043F\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u0438\u0439\u043E\u043C\u0443 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      clearFilter: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440",
      errors: {
        empty: "\u0414\u043B\u044F \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u0438\u043D \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439.",
        tooMany: "\u0412 \u043E\u0434\u043D\u043E\u043C\u0443 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u0456 \u043C\u043E\u0436\u043D\u0430 \u0432\u043A\u0430\u0437\u0430\u0442\u0438 \u0449\u043E\u043D\u0430\u0439\u0431\u0456\u043B\u044C\u0448\u0435 26 \u043F\u0440\u0438\u0441\u0442\u0440\u043E\u0457\u0432.",
        duplicateSerial: "\u041F\u043E\u0432\u0442\u043E\u0440\u044E\u0432\u0430\u043D\u0438\u0439 \u0441\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u0443 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u0456 \u2014 \u043A\u043E\u0436\u0435\u043D \u043F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u043F\u043E\u0432\u0438\u043D\u0435\u043D \u043C\u0430\u0442\u0438 \u0443\u043D\u0456\u043A\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440.",
        deviceActive: "\u041F\u0440\u0438\u0441\u0442\u0440\u0456\u0439 \u0432\u0436\u0435 \u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u043D\u0430\u0440\u044F\u0434.",
        partnerRequired: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u043F\u0435\u0440\u0435\u0434 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C.",
        generic: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437."
      }
    },
    resolvedPackage: {
      none: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0430\u043A\u0435\u0442\u0430",
      noneDesc: "\u0426\u044C\u043E\u043C\u0443 \u0442\u043E\u0432\u0430\u0440\u0443 \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u0433\u043E \u043F\u0430\u043A\u0435\u0442\u0430."
    },
    viewInvoice: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    billError: {
      alreadyInvoiced: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0443\u0436\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0440\u0430\u0445\u0443\u043D\u043E\u043A.",
      notBillable: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435 \u043F\u0456\u0434\u043B\u044F\u0433\u0430\u0454 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044E \u0440\u0430\u0445\u0443\u043D\u043A\u0443.",
      warrantyNotBillable: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u0439\u043D\u0438\u0439 \u043D\u0430\u0440\u044F\u0434 \u043D\u0435 \u043F\u0456\u0434\u043B\u044F\u0433\u0430\u0454 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044E \u0440\u0430\u0445\u0443\u043D\u043A\u0443 (\u043F\u043E\u043A\u0440\u0438\u0432\u0430\u0454 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A).",
      failed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0440\u0430\u0445\u0443\u043D\u043E\u043A."
    },
    partner: {
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u2026",
      label: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440: {name}",
      unresolved: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440 ({id})"
    }
  },
  dashboardApp: {
    changelog: {
      categoryFixed: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
      categoryImproved: "\u041F\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u044F",
      categoryNew: "\u041D\u043E\u0432\u0430 \u0444\u0443\u043D\u043A\u0446\u0456\u044F",
      codeCoverage: "\u041F\u043E\u043A\u0440\u0438\u0442\u0442\u044F \u043A\u043E\u0434\u0443:",
      collapseDetails: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0456 \u0434\u0435\u0442\u0430\u043B\u0456",
      collapseVersions: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0456 \u0432\u0435\u0440\u0441\u0456\u0457",
      details: "\u0414\u0435\u0442\u0430\u043B\u0456",
      expandDetails: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0456 \u0434\u0435\u0442\u0430\u043B\u0456",
      expandVersions: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0456 \u0432\u0435\u0440\u0441\u0456\u0457",
      failedTests: "\u043D\u0435\u0432\u0434\u0430\u043B\u0438\u0445",
      filter: "\u0424\u0456\u043B\u044C\u0442\u0440:",
      filterAll: "\u0412\u0441\u0435",
      filterFixed: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
      filterImproved: "\u041F\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u044F",
      filterNew: "\u041D\u043E\u0432\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0457",
      findings: "\u0437\u043D\u0430\u0445\u0456\u0434\u043E\u043A",
      fixedIssues: "\u0432\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      heading: "\u0417\u043C\u0456\u043D\u0438 \u0442\u0430 \u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      openIssues: "\u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      passed: "\u0443\u0441\u043F\u0456\u0448\u043D\u043E",
      relatedTests: "\u041F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u0422\u0435\u0441\u0442\u0438",
      reviewFindings: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 Code Review",
      reviewSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A Code Review",
      severityCritical: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      severityMajor: "\u0412\u0430\u0436\u043B\u0438\u0432\u0438\u0439",
      severityMinor: "\u041D\u0435\u0437\u043D\u0430\u0447\u043D\u0438\u0439",
      statusFixed: "\u2713 \u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      statusOpen: "\u25CB \u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      statusRejected: "\u2014 \u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
      subscribe: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438\u0441\u044F",
      subscribeDescription: "\u041F\u0456\u0434\u043F\u0438\u0448\u0456\u0442\u044C\u0441\u044F \u043D\u0430 \u043D\u0430\u0448 \u0431\u044E\u043B\u0435\u0442\u0435\u043D\u044C \u0456 \u0434\u0456\u0437\u043D\u0430\u0432\u0430\u0439\u0442\u0435\u0441\u044C \u043F\u0435\u0440\u0448\u0438\u043C\u0438 \u043F\u0440\u043E \u043D\u043E\u0432\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0442\u0430 \u043F\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u044F.",
      subscribeTitle: "\u0411\u0443\u0434\u044C\u0442\u0435 \u0432 \u043A\u0443\u0440\u0441\u0456 \u043D\u043E\u0432\u0438\u043D!",
      subtitle: "\u0421\u043B\u0456\u0434\u043A\u0443\u0439\u0442\u0435 \u0437\u0430 \u0440\u043E\u0437\u0432\u0438\u0442\u043A\u043E\u043C \u0441\u0438\u0441\u0442\u0435\u043C\u0438 \u0442\u0430 \u043D\u043E\u0432\u0438\u043C\u0438 \u0444\u0443\u043D\u043A\u0446\u0456\u044F\u043C\u0438",
      test: "\u0442\u0435\u0441\u0442",
      testSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0422\u0435\u0441\u0442\u0456\u0432",
      typeMajor: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430 \u0432\u0435\u0440\u0441\u0456\u044F",
      typeMinor: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0444\u0443\u043D\u043A\u0446\u0456\u0439",
      typePatch: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F \u043F\u043E\u043C\u0438\u043B\u043E\u043A",
      versions: "\u0412\u0435\u0440\u0441\u0456\u0457"
    },
    developer: {
      active: "\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      completionTrend: "\u0422\u0440\u0435\u043D\u0434 \u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F (\u041A\u0443\u043C\u0443\u043B\u044F\u0442\u0438\u0432\u043D\u0438\u0439)",
      done: "\u0413\u043E\u0442\u043E\u0432\u043E",
      epicProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441 Epic (%)",
      epicStorySummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A Epic \u0442\u0430 Story",
      filterAll: "\u0412\u0441\u0435",
      filterDone: "\u0413\u043E\u0442\u043E\u0432\u043E",
      filterInProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      filterLabel: "\u0424\u0456\u043B\u044C\u0442\u0440:",
      filterPlanned: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E",
      inProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      inProgressEpics: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 Epics",
      noFilterResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0444\u0456\u043B\u044C\u0442\u0440\u0430",
      noInProgressEpics: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 epics",
      progress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441",
      storyStatusDistribution: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0421\u0442\u0430\u0442\u0443\u0441\u0456\u0432 Story",
      tabEpics: "Epics",
      tabOverview: "\u041E\u0433\u043B\u044F\u0434",
      tabStories: "Stories",
      totalCompleted: "\u0412\u0441\u044C\u043E\u0433\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      totalEpics: "\u0412\u0441\u044C\u043E\u0433\u043E Epic",
      totalStories: "\u0412\u0441\u044C\u043E\u0433\u043E Story"
    },
    downloads: {
      archive: "\u0410\u0440\u0445\u0456\u0432",
      archiveDesc: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456 \u0435\u043A\u0441\u043F\u043E\u0440\u0442\u0438",
      comingSoon: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C \u0431\u0443\u0434\u0443\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456.",
      download: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u2192",
      fullStatus: "\u041F\u043E\u0432\u043D\u0438\u0439 \u0421\u0442\u0430\u0442\u0443\u0441",
      fullStatusDesc: "\u0412\u0441\u0456 \u0434\u0430\u043D\u0456 \u0432 \u043E\u0434\u043D\u043E\u043C\u0443 \u0444\u0430\u0439\u043B\u0456",
      heading: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0442\u0430 \u0417\u0432\u0456\u0442\u0438",
      progressExport: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0443",
      progressExportDesc: "\u0414\u0430\u043D\u0456 \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0443 Epic \u0442\u0430 Story",
      reviewSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A Review",
      reviewSummaryDesc: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 code review",
      sprintReport: "\u0417\u0432\u0456\u0442 Sprint",
      sprintReportDesc: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u043F\u043E\u0442\u043E\u0447\u043D\u043E\u0433\u043E \u0441\u0442\u0430\u0442\u0443\u0441\u0443 sprint",
      testReport: "\u0417\u0432\u0456\u0442 \u0422\u0435\u0441\u0442\u0456\u0432",
      testReportDesc: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0442\u0435\u0441\u0442\u0456\u0432 \u0442\u0430 coverage"
    },
    executive: {
      activeWork: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430 \u0420\u043E\u0431\u043E\u0442\u0430",
      allStoriesDone: "\u0423\u0441\u0456 stories \u0433\u043E\u0442\u043E\u0432\u0456!",
      done: "\u0413\u043E\u0442\u043E\u0432\u043E",
      doneEpic: "\u0413\u043E\u0442\u043E\u0432\u0438\u0439 Epic",
      fixed: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      inProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      issues: "\u043F\u043E\u043C\u0438\u043B\u043E\u043A",
      more: "\u0449\u0435",
      overallProgress: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043F\u0440\u043E\u0433\u0440\u0435\u0441",
      projectProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441 \u041F\u0440\u043E\u0435\u043A\u0442\u0443",
      recentlyCompletedEpics: "\u041D\u0435\u0449\u043E\u0434\u0430\u0432\u043D\u043E \u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0456 Epics",
      testSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0422\u0435\u0441\u0442\u0456\u0432",
      tests: "\u0422\u0435\u0441\u0442\u0438",
      totalIssues: "\u0412\u0441\u044C\u043E\u0433\u043E \u043F\u043E\u043C\u0438\u043B\u043E\u043A"
    },
    workflow: {
      pendingApprovals: "\u041E\u0447\u0456\u043A\u0443\u044E\u0442\u044C \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
      runningWorkflows: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043F\u0440\u043E\u0446\u0435\u0441\u0438",
      openFlow: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 rPI Flow",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438"
    },
    knowledge: {
      adrs: "ADR-\u0438",
      adrsDesc: "Architecture Decision Records",
      architecture: "\u0410\u0440\u0445\u0456\u0442\u0435\u043A\u0442\u0443\u0440\u0430",
      architectureDesc: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0430\u0440\u0445\u0456\u0442\u0435\u043A\u0442\u0443\u0440\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u0438",
      comingSoon: "\u0411\u0430\u0437\u0430 \u0437\u043D\u0430\u043D\u044C \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C \u0431\u0443\u0434\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430.",
      epicDefinitions: "\u0412\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F Epic",
      epicDefinitionsDesc: "\u041E\u043F\u0438\u0441\u0438 Epic \u0442\u0430 Story",
      heading: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F",
      prd: "PRD",
      prdDesc: "Product Requirements Document"
    },
    layout: {
      header: {
        refreshButton: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
        settingsButton: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        statsDone: "\u0433\u043E\u0442\u043E\u0432\u043E",
        statsEpics: "Epics",
        statsStories: "Stories",
        views: {
          changelog: {
            subtitle: "\u0412\u0435\u0440\u0441\u0456\u0457, \u0437\u043C\u0456\u043D\u0438 \u0442\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0444\u0443\u043D\u043A\u0446\u0456\u0439",
            title: "\u041D\u043E\u0432\u0438\u043D\u0438"
          },
          developer: {
            subtitle: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441 Epic \u0442\u0430 Story \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u043E",
            title: "\u0412\u0438\u0434 \u0420\u043E\u0437\u0440\u043E\u0431\u043D\u0438\u043A\u0430"
          },
          downloads: {
            subtitle: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0442\u0430 \u0437\u0432\u0456\u0442\u0438",
            title: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F"
          },
          executive: {
            subtitle: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0442\u0430 KPI \u043D\u0430 \u043E\u0434\u043D\u043E\u043C\u0443 \u0435\u043A\u0440\u0430\u043D\u0456",
            title: "\u041E\u0433\u043B\u044F\u0434 \u041A\u0435\u0440\u0456\u0432\u043D\u0438\u043A\u0430"
          },
          knowledge: {
            subtitle: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0442\u0430 ADR-\u0438",
            title: "\u0411\u0430\u0437\u0430 \u0417\u043D\u0430\u043D\u044C"
          },
          qa: {
            subtitle: "\u0422\u0435\u0441\u0442\u043E\u0432\u0456 \u043C\u0435\u0442\u0440\u0438\u043A\u0438 \u0442\u0430 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 code review",
            title: "QA \u0412\u0438\u0434"
          },
          statistics: {
            subtitle: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0456 \u043C\u0435\u0442\u0440\u0438\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0442\u0430 \u0430\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430",
            title: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430"
          }
        }
      },
      sidebar: {
        collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
        darkMode: "\u0422\u0435\u043C\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C",
        lightMode: "\u0421\u0432\u0456\u0442\u043B\u0438\u0439 \u0440\u0435\u0436\u0438\u043C",
        logoSubtitle: "rPI ERP Dashboard",
        logoTitle: "rPI ERP",
        mobileLogoSubtitle: "KGC ERP Dashboard",
        mobileLogoTitle: "MyForgeOS",
        refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
        refreshData: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0430\u043D\u0456",
        refreshing: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F...",
        sectionUtilities: "\u0423\u0442\u0438\u043B\u0456\u0442\u0438",
        sectionViews: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
        themeToggle: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u0442\u0435\u043C\u0443",
        utilities: {
          changelog: {
            description: "\u0412\u0435\u0440\u0441\u0456\u0457 \u0442\u0430 \u0437\u043C\u0456\u043D\u0438",
            name: "\u041D\u043E\u0432\u0438\u043D\u0438"
          },
          downloads: {
            description: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0442\u0430 \u0437\u0432\u0456\u0442\u0438",
            name: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F"
          },
          knowledge: {
            description: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0442\u0430 ADR-\u0438",
            name: "\u0411\u0430\u0437\u0430 \u0417\u043D\u0430\u043D\u044C"
          }
        },
        views: {
          developer: {
            description: "Sprint \u0442\u0430 Story \u0434\u0435\u0442\u0430\u043B\u0456",
            name: "Developer"
          },
          executive: {
            description: "\u041E\u0433\u043B\u044F\u0434 \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u043A\u0430 \u0442\u0430 KPI",
            name: "Executive"
          },
          qa: {
            description: "\u0422\u0435\u0441\u0442\u043E\u0432\u0456 \u0442\u0430 \u044F\u043A\u0456\u0441\u043D\u0456 \u043C\u0435\u0442\u0440\u0438\u043A\u0438",
            name: "QA"
          },
          statistics: {
            description: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0430 \u0430\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430 \u0442\u0430 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0438",
            name: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430"
          }
        }
      }
    },
    qa: {
      allEpics: "\u0412\u0441\u0456 Epics",
      allPackages: "\u0412\u0441\u0456 \u043F\u0430\u043A\u0435\u0442\u0438",
      avgCoverage: "\u0421\u0435\u0440\u0435\u0434\u043D\u0454 Coverage",
      claudeVsGemini: "\u041F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043D\u044F Claude \u0442\u0430 Gemini",
      collapseAll: "\u25B2 \u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
      consensus: "\u041A\u043E\u043D\u0441\u0435\u043D\u0441\u0443\u0441",
      coverageByPackage: "Coverage \u0437\u0430 \u041F\u0430\u043A\u0435\u0442\u0430\u043C\u0438",
      coveragePercent: "Coverage %",
      critical: "\u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      deferred: "\u0412\u0456\u0434\u043A\u043B\u0430\u0434\u0435\u043D\u043E",
      expandAll: "\u25BC \u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
      failed: "\u041D\u0435\u0432\u0434\u0430\u043B\u0438\u0439",
      failingTests: "\u041D\u0435\u0432\u0434\u0430\u043B\u0456 \u0422\u0435\u0441\u0442\u0438",
      filter: "\u0424\u0456\u043B\u044C\u0442\u0440:",
      filterAll: "\u0412\u0441\u0435",
      filterCritical: "\u{1F534} \u041A\u0440\u0438\u0442\u0438\u0447\u043D\u0438\u0439",
      filterFailed: "\u2717 \u041D\u0435\u0432\u0434\u0430\u043B\u0438\u0439",
      filterFixed: "\u2713 \u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      filterOpen: "\u25CB \u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      filterPassed: "\u2713 \u0423\u0441\u043F\u0456\u0448\u043D\u0438\u0439",
      fixed: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      found: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      heading: "QA \u041F\u0430\u043D\u0435\u043B\u044C",
      high: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
      inProgressRound: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      issueResolutionFlow: "\u041F\u0440\u043E\u0446\u0435\u0441 \u0412\u0438\u0440\u0456\u0448\u0435\u043D\u043D\u044F \u041F\u0440\u043E\u0431\u043B\u0435\u043C",
      issues: "\u043F\u043E\u043C\u0438\u043B\u043E\u043A",
      low: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
      medium: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
      noFilterResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0444\u0456\u043B\u044C\u0442\u0440\u0430",
      open: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      passRate: "\u0423\u0441\u043F\u0456\u0448\u043D\u0456\u0441\u0442\u044C %",
      passed: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E",
      qualityScore: "\u041E\u0446\u0456\u043D\u043A\u0430 \u042F\u043A\u043E\u0441\u0442\u0456",
      reviewIssues: "\u041F\u043E\u043C\u0438\u043B\u043A\u0438 Review",
      reviewSummary: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A Review",
      runTime: "\u0427\u0430\u0441 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F",
      severityDistribution: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0421\u0435\u0440\u0439\u043E\u0437\u043D\u043E\u0441\u0442\u0456 \u041F\u043E\u043C\u0438\u043B\u043E\u043A",
      skipped: "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E",
      statusDeferred: "\u21B7 \u0412\u0456\u0434\u043A\u043B\u0430\u0434\u0435\u043D\u043E",
      statusFixed: "\u2713 \u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      statusOpen: "\u25CB \u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
      statusWontfix: "\u2014 \u041D\u0435 \u0431\u0443\u0434\u0435 \u0432\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      subtitle: "\u0422\u0435\u0441\u0442\u043E\u0432\u0456 \u043C\u0435\u0442\u0440\u0438\u043A\u0438, code review \u0442\u0430 \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F \u044F\u043A\u043E\u0441\u0442\u0456 - \u0437 \u0440\u0435\u0430\u043B\u044C\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 BMAD",
      tabOverview: "\u041E\u0433\u043B\u044F\u0434",
      tabReviews: "Reviews",
      tabTests: "\u0422\u0435\u0441\u0442\u0438",
      test: "\u0422\u0435\u0441\u0442\u0438",
      testResultsByPackage: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0422\u0435\u0441\u0442\u0456\u0432 \u0437\u0430 \u041F\u0430\u043A\u0435\u0442\u0430\u043C\u0438",
      trendTitle: "\u0422\u0440\u0435\u043D\u0434 \u0423\u0441\u043F\u0456\u0448\u043D\u043E\u0441\u0442\u0456 & Coverage",
      verdictApproved: "\u2705 \u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
      verdictApprovedWithFixes: "\u2705 \u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E (\u0437 \u0432\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F\u043C\u0438)",
      verdictInProgress: "\u{1F504} \u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      verdictRejected: "\u274C \u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E"
    },
    statistics: {
      activeStories: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 Stories",
      actual: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0438\u0439",
      average: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
      averageFixRate: "\u0421\u0435\u0440\u0435\u0434\u043D\u044F \u0448\u0432\u0438\u0434\u043A\u0456\u0441\u0442\u044C \u0432\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044C",
      avgStoriesPerEpic: "\u0421\u0435\u0440\u0435\u0434\u043D\u044F \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C Stories/Epic",
      claudeVsGemini: "\u041F\u043E\u0440\u0456\u0432\u043D\u044F\u043D\u043D\u044F Claude \u0442\u0430 Gemini",
      codeReviewAnalytics: "\u0410\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430 Code Review",
      completedStories: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0456 Stories",
      completionRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
      consensusRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u041A\u043E\u043D\u0441\u0435\u043D\u0441\u0443\u0441\u0443",
      done: "\u0413\u043E\u0442\u043E\u0432\u043E",
      epicCompletionTimeline: "\u0425\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u044F \u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F Epic",
      epicOverview: "\u041E\u0433\u043B\u044F\u0434 Epic",
      epicStatusDistribution: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0421\u0442\u0430\u0442\u0443\u0441\u0456\u0432 Epic",
      fixRate: "\u0428\u0432\u0438\u0434\u043A\u0456\u0441\u0442\u044C \u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044C",
      fixed: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      found: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      heading: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
      ideal: "\u0406\u0434\u0435\u0430\u043B\u044C\u043D\u0438\u0439",
      inProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      openIssues: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u041F\u043E\u043C\u0438\u043B\u043A\u0438",
      passRate: "\u0420\u0456\u0432\u0435\u043D\u044C \u041F\u0440\u043E\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      projectHealth: "\u0417\u0434\u043E\u0440\u043E\u0432'\u044F \u041F\u0440\u043E\u0435\u043A\u0442\u0443",
      projectProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441 \u041F\u0440\u043E\u0435\u043A\u0442\u0443",
      remaining: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C",
      remainingStories: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C",
      severityDistribution: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0421\u0435\u0440\u0439\u043E\u0437\u043D\u043E\u0441\u0442\u0456 \u041F\u043E\u043C\u0438\u043B\u043E\u043A",
      sprintProgress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441 Sprint",
      storyDistributionByEpic: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B Stories \u0437\u0430 Epic",
      subtitle: "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0456 \u043C\u0435\u0442\u0440\u0438\u043A\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u0442\u0430 \u0430\u043D\u0430\u043B\u0456\u0442\u0438\u043A\u0430",
      teamPerformance: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u041A\u043E\u043C\u0430\u043D\u0434\u0438",
      testCoverage: "\u0422\u0435\u0441\u0442\u043E\u0432\u0435 \u041F\u043E\u043A\u0440\u0438\u0442\u0442\u044F",
      testMetrics: "\u0422\u0435\u0441\u0442\u043E\u0432\u0456 \u041C\u0435\u0442\u0440\u0438\u043A\u0438",
      testTypeDistribution: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0422\u0438\u043F\u0456\u0432 \u0422\u0435\u0441\u0442\u0456\u0432",
      totalIssues: "\u0412\u0441\u044C\u043E\u0433\u043E \u043F\u043E\u043C\u0438\u043B\u043E\u043A",
      totalStories: "\u0412\u0441\u044C\u043E\u0433\u043E Stories",
      uniqueFindings: "\u0423\u043D\u0456\u043A\u0430\u043B\u044C\u043D\u0456 \u0437\u043D\u0430\u0445\u0456\u0434\u043A\u0438"
    },
    drawer: {
      done: "\u0433\u043E\u0442\u043E\u0432\u043E",
      epicDetails: "\u0414\u0435\u0442\u0430\u043B\u0456 Epic",
      fixed: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      foundIssues: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u0456 \u043F\u043E\u043C\u0438\u043B\u043A\u0438",
      issues: "\u041F\u043E\u043C\u0438\u043B\u043A\u0438",
      noSubtasks: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0456\u0434\u0437\u0430\u0434\u0430\u0447",
      progress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441",
      remaining: "\u0437\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C",
      reviewDetails: "\u0414\u0435\u0442\u0430\u043B\u0456 Review",
      severity: "\u0421\u0435\u0440\u0439\u043E\u0437\u043D\u0456\u0441\u0442\u044C",
      storyDetails: "\u0414\u0435\u0442\u0430\u043B\u0456 Story",
      tasks: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F"
    }
  },
  notification: {
    newRental: {
      message: "{partner} - {count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      title: "\u041D\u043E\u0432\u0430 \u043E\u0440\u0435\u043D\u0434\u0430"
    },
    paymentError: {
      message: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u044E \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E ({amount})",
      title: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u043F\u043B\u0430\u0442\u0438"
    },
    stockShortage: {
      message: "{productName} \u0437\u0430\u043F\u0430\u0441 \u043D\u0430 \u043A\u0440\u0438\u0442\u0438\u0447\u043D\u043E\u043C\u0443 \u0440\u0456\u0432\u043D\u0456 (< 50%)",
      title: "\u041D\u0435\u0441\u0442\u0430\u0447\u0430 \u0437\u0430\u043F\u0430\u0441\u0456\u0432"
    },
    urgentWorksheet: {
      message: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u043D\u043E\u0432\u0438\u0439 \u0442\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 ({number})",
      title: "\u0422\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442"
    }
  },
  permissions: {
    auth: {
      login: "\u0412\u0445\u0456\u0434",
      loginDesc: "\u0412\u0445\u0456\u0434 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
      pin: "\u0412\u0445\u0456\u0434 \u0437\u0430 PIN",
      pinDesc: "\u0428\u0432\u0438\u0434\u043A\u0438\u0439 \u0432\u0445\u0456\u0434 \u0437\u0430 PIN-\u043A\u043E\u0434\u043E\u043C"
    },
    users: {
      read: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432",
      readDesc: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u043F\u0438\u0441\u043A\u0443 \u0442\u0430 \u043F\u0440\u043E\u0444\u0456\u043B\u0456\u0432 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432",
      create: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      createDesc: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      update: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      updateDesc: "\u0417\u043C\u0456\u043D\u0430 \u0434\u0430\u043D\u0438\u0445 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      delete: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      deleteDesc: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443",
      roles: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0440\u043E\u043B\u044F\u043C\u0438",
      rolesDesc: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u043E\u043B\u0435\u0439 \u0442\u0430 \u0434\u043E\u0437\u0432\u043E\u043B\u0456\u0432"
    },
    partners: {
      read: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
      readDesc: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u043F\u0438\u0441\u043A\u0443 \u0442\u0430 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
      create: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      createDesc: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      update: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      updateDesc: "\u0417\u043C\u0456\u043D\u0430 \u0434\u0430\u043D\u0438\u0445 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      delete: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      deleteDesc: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430"
    },
    rental: {
      read: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043E\u0440\u0435\u043D\u0434",
      readDesc: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u043F\u0438\u0441\u043A\u0443 \u0442\u0430 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u043E\u0440\u0435\u043D\u0434",
      create: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
      createDesc: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043D\u043E\u0432\u043E\u0457 \u043E\u0440\u0435\u043D\u0434\u0438",
      return: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
      returnDesc: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      extend: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
      extendDesc: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0435\u043D\u043D\u044F \u0442\u0435\u0440\u043C\u0456\u043D\u0443 \u043E\u0440\u0435\u043D\u0434\u0438"
    },
    sales: {
      read: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043F\u0440\u043E\u0434\u0430\u0436\u0456\u0432",
      readDesc: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u043F\u0438\u0441\u043A\u0443 \u0442\u0430 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u043F\u0440\u043E\u0434\u0430\u0436\u0456\u0432",
      create: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
      createDesc: "\u0420\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
      discount: "\u041D\u0430\u0434\u0430\u043D\u043D\u044F \u0437\u043D\u0438\u0436\u043A\u0438",
      discountDesc: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u043D\u0438\u0436\u043A\u0438 \u0434\u043E \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
      refund: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043A\u043E\u0448\u0442\u0456\u0432",
      refundDesc: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043A\u043E\u0448\u0442\u0456\u0432"
    },
    service: {
      read: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043B\u0438\u0441\u0442\u0456\u0432",
      readDesc: "\u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0430 \u0434\u0435\u0442\u0430\u043B\u0456 \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0445 \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u043B\u0438\u0441\u0442\u0456\u0432",
      create: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
      createDesc: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u043D\u043E\u0432\u043E\u0433\u043E \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
      update: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
      updateDesc: "\u0417\u043C\u0456\u043D\u0430 \u0434\u0430\u043D\u0438\u0445 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
      close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
      closeDesc: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430"
    },
    settings: {
      read: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C",
      readDesc: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u0445 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C",
      update: "\u0417\u043C\u0456\u043D\u0430 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C",
      updateDesc: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0438\u0445 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u044C"
    },
    inventory: {
      read: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      readDesc: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0441\u043F\u0438\u0441\u043A\u0443 \u0442\u0430 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      adjust: "\u041A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      adjustDesc: "\u0417\u043C\u0456\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u043E\u0441\u0442\u0456 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      receive: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0443",
      receiveDesc: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430 \u043F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0443",
      transfer: "\u041C\u0456\u0436\u0441\u043A\u043B\u0430\u0434\u0441\u044C\u043A\u0435 \u043F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
      transferDesc: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0430\u0441\u0456\u0432 \u043C\u0456\u0436 \u0441\u043A\u043B\u0430\u0434\u0430\u043C\u0438"
    },
    reports: {
      rental: "\u0417\u0432\u0456\u0442\u0438 \u0437 \u043E\u0440\u0435\u043D\u0434\u0438",
      rentalDesc: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0442\u0430 \u0437\u0432\u0456\u0442\u0438 \u0437 \u043E\u0440\u0435\u043D\u0434\u0438",
      sales: "\u0417\u0432\u0456\u0442\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0456\u0432",
      salesDesc: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0442\u0430 \u0437\u0432\u0456\u0442\u0438 \u0437 \u043F\u0440\u043E\u0434\u0430\u0436\u0456\u0432",
      financial: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0456 \u0437\u0432\u0456\u0442\u0438",
      financialDesc: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0456 \u0437\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0442\u0430 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F",
      inventory: "\u0417\u0432\u0456\u0442\u0438 \u0456\u0437 \u0437\u0430\u043F\u0430\u0441\u0456\u0432",
      inventoryDesc: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430\u043F\u0430\u0441\u0456\u0432 \u0442\u0430 \u0437\u0432\u0456\u0442\u0438 \u0437 \u0456\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u0438\u0437\u0430\u0446\u0456\u0457"
    }
  },
  courier: {
    title: "\u041A\u0443\u0440'\u0454\u0440\u0441\u044C\u043A\u0456 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
    titleSingle: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
    newDelivery: "\u041D\u043E\u0432\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
    noDeliveries: "\u041D\u0435\u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0430\u0432\u043E\u043A",
    notFound: "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    noCourierYet: "\u041A\u0443\u0440'\u0454\u0440\u0430 \u0449\u0435 \u043D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
    deliveryInfo: "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F \u043F\u0440\u043E \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443",
    courierInfo: "\u0414\u0430\u043D\u0456 \u043A\u0443\u0440'\u0454\u0440\u0430",
    paymentSection: "\u041E\u043F\u043B\u0430\u0442\u0430",
    paymentPendingInfo: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043E\u043F\u043B\u0430\u0442\u0438",
    paymentDescription: "\u041E\u043F\u0438\u0441 \u043E\u043F\u043B\u0430\u0442\u0438",
    createPaymentLink: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u0438",
    handoff: "\u041F\u0435\u0440\u0435\u0434\u0430\u0447\u0430",
    markDelivered: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u043C",
    cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441",
    statusProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
    providerLabel: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
    trackingLabel: "\u041D\u043E\u043C\u0435\u0440 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F",
    addressLabel: "\u0410\u0434\u0440\u0435\u0441\u0430",
    costLabel: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
    scheduledLabel: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E",
    createdAtLabel: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
    deliveredAtLabel: "\u0414\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
    handoffAtLabel: "\u041F\u0435\u0440\u0435\u0434\u0430\u043D\u043E",
    worksheetIdLabel: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
    enterProvider: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430",
    enterTracking: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F",
    enterAmount: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0441\u0443\u043C\u0443",
    statusLabels: {
      requested: "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u043E",
      paymentPending: "\u041E\u0447\u0456\u043A\u0443\u0454 \u043E\u043F\u043B\u0430\u0442\u0438",
      paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      dispatched: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E",
      delivered: "\u0414\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
    },
    cancelDelivery: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443"
  },
  contractPriceList: {
    title: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0438\u0439 \u043F\u0440\u0430\u0439\u0441-\u043B\u0438\u0441\u0442",
    orderableOnly: "\u0417\u0430\u043C\u043E\u0432\u0438\u0442\u0438 \u043C\u043E\u0436\u043D\u0430 \u043B\u0438\u0448\u0435 \u0442\u043E\u0432\u0430\u0440\u0438 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
    importButton: "\u0406\u043C\u043F\u043E\u0440\u0442 (.xlsx)",
    templateDownload: "\u0428\u0430\u0431\u043B\u043E\u043D",
    export: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442",
    importPreview: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0456\u043C\u043F\u043E\u0440\u0442\u0443 \u2014 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0437\u043C\u0456\u043D\u0438",
    confirmImport: "\u0412\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0456\u043C\u043F\u043E\u0440\u0442",
    importSuccess: "\u0423\u0441\u043F\u0456\u0448\u043D\u0438\u0439 \u0456\u043C\u043F\u043E\u0440\u0442: {successful}/{total} \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
    importPartial: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u0438\u0439 \u0456\u043C\u043F\u043E\u0440\u0442: {successful} \u0443\u0441\u043F\u0456\u0448\u043D\u043E, {failed} \u0437 \u043F\u043E\u043C\u0438\u043B\u043A\u0430\u043C\u0438",
    importError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0456\u043C\u043F\u043E\u0440\u0442\u0443",
    annualLimitWarning: "\u0420\u0456\u0447\u043D\u0438\u0439 \u043B\u0456\u043C\u0456\u0442 \u0437\u043C\u0456\u043D!",
    annualLimitDescription: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u0456\u043C\u043F\u043E\u0440\u0442 \u043F\u0440\u0430\u0439\u0441-\u043B\u0438\u0441\u0442\u0430 \u0432\u0456\u0434\u0431\u0443\u0432\u0441\u044F \u043C\u0435\u043D\u0448 \u043D\u0456\u0436 12 \u043C\u0456\u0441\u044F\u0446\u0456\u0432 \u0442\u043E\u043C\u0443. \u0412\u0438 \u0441\u043F\u0440\u0430\u0432\u0434\u0456 \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F?",
    forceImport: "\u041F\u0435\u0440\u0435\u0432\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0442\u0430 \u0456\u043C\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438",
    previewNew: "{count} \u043D\u043E\u0432\u0438\u0445",
    previewChanged: "{count} \u0437\u043C\u0456\u043D\u0435\u043D\u043E",
    previewRemoved: "{count} \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
    previewUnchanged: "{count} \u0431\u0435\u0437 \u0437\u043C\u0456\u043D",
    customerSku: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u043A\u043B\u0456\u0454\u043D\u0442\u0430",
    product: "\u041D\u0430\u0439\u043C\u0435\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
    contractPrice: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440\u043D\u0430 \u0446\u0456\u043D\u0430",
    validFrom: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0437",
    validUntil: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0434\u043E",
    status: "\u0421\u0442\u0430\u0442\u0443\u0441",
    oldPrice: "\u0421\u0442\u0430\u0440\u0430 \u0446\u0456\u043D\u0430",
    newPrice: "\u041D\u043E\u0432\u0430 \u0446\u0456\u043D\u0430",
    change: "\u0417\u043C\u0456\u043D\u0430",
    noItems: "\u041F\u0440\u0430\u0439\u0441-\u043B\u0438\u0441\u0442 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E",
    dragDrop: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0444\u0430\u0439\u043B .xlsx \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043A\u043D\u043E\u043F\u043A\u0438 \u0406\u043C\u043F\u043E\u0440\u0442",
    itemCount: "{count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u0443 \u043F\u0440\u0430\u0439\u0441-\u043B\u0438\u0441\u0442\u0456",
    active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    expired: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
    notYetValid: "\u0429\u0435 \u043D\u0435 \u0434\u0456\u0454",
    notOrderable: "\u041D\u0435 \u043F\u0456\u0434\u043B\u044F\u0433\u0430\u0454 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044E",
    diff: {
      NEW: "\u041D\u043E\u0432\u0438\u0439",
      CHANGED: "\u0417\u043C\u0456\u043D\u0435\u043D\u043E",
      REMOVED: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
      UNCHANGED: "\u0411\u0435\u0437 \u0437\u043C\u0456\u043D"
    }
  },
  crossSell: {
    title: "\u0417\u043C\u0456\u0448\u0430\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
    subtitle: "\u041E\u0440\u0435\u043D\u0434\u0430 + \u043A\u0443\u043F\u0456\u0432\u043B\u044F + \u0437\u0430\u0441\u0442\u0430\u0432\u0430 \u043D\u0430 \u043E\u0434\u043D\u043E\u043C\u0443 \u0440\u0430\u0445\u0443\u043D\u043A\u0443",
    addItem: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
    itemType: "\u0422\u0438\u043F \u043F\u043E\u0437\u0438\u0446\u0456\u0457",
    rentalFee: "\u041E\u0440\u0435\u043D\u0434\u043D\u0430 \u043F\u043B\u0430\u0442\u0430",
    product: "\u0422\u043E\u0432\u0430\u0440",
    serviceFee: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0441\u0435\u0440\u0432\u0456\u0441\u043D\u0438\u0445 \u0440\u043E\u0431\u0456\u0442",
    servicePart: "\u0421\u0435\u0440\u0432\u0456\u0441\u043D\u0430 \u0437\u0430\u043F\u0447\u0430\u0441\u0442\u0438\u043D\u0430",
    deposit: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    handlingFee: "\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043E\u0431\u0440\u043E\u0431\u043A\u0443",
    lateFee: "\u041F\u0435\u043D\u044F \u0437\u0430 \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043D\u044F",
    discount: "\u0417\u043D\u0438\u0436\u043A\u0430",
    depositCard: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u043A\u0430\u0440\u0442\u043A\u043E\u044E",
    depositCash: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0433\u043E\u0442\u0456\u0432\u043A\u043E\u044E",
    revenueTotal: "\u0414\u043E\u0445\u0456\u0434 \u0437\u0430\u0433\u0430\u043B\u043E\u043C",
    depositTotal: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 (\u043D\u0435 \u0454 \u0434\u043E\u0445\u043E\u0434\u043E\u043C)",
    payableTotal: "\u0414\u043E \u0441\u043F\u043B\u0430\u0442\u0438 \u0437\u0430\u0433\u0430\u043B\u043E\u043C",
    handlingFeeDescription: "\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043E\u0431\u0440\u043E\u0431\u043A\u0443 \u0437\u0430\u0441\u0442\u0430\u0432\u0438 \u043A\u0430\u0440\u0442\u043A\u043E\u044E (2%)",
    handlingFeeRefund: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430 \u0434\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    noDeposit: "\u0411\u0435\u0437 \u0437\u0430\u0441\u0442\u0430\u0432\u0438",
    vatBreakdown: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u041F\u0414\u0412"
  },
  assetTransfer: {
    title: "\u041F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0430\u043A\u0442\u0438\u0432\u0443",
    toRentalEquipment: "\u041F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0432 \u043E\u0440\u0435\u043D\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    toOwnedAsset: "\u041F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0443 \u0432\u043B\u0430\u0441\u043D\u0438\u0439 \u0430\u043A\u0442\u0438\u0432",
    confirmTitle: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
    confirmMessage: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0446\u0435\u0439 \u0442\u043E\u0432\u0430\u0440? \u0426\u044E \u0434\u0456\u044E \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438.",
    success: "\u041F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u0435",
    rentalCardCreated: "\u041A\u0430\u0440\u0442\u043A\u0443 \u043E\u0440\u0435\u043D\u0434\u043D\u043E\u0433\u043E \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E",
    depreciationCreated: "\u0417\u0430\u043F\u0438\u0441 \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u0457 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E (200 \u0442\u0438\u0441.+ \u0444\u043E\u0440\u0438\u043D\u0442\u0456\u0432)",
    noDepreciation: "\u0410\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0456\u044F \u043D\u0435 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 (\u0446\u0456\u043D\u0430 < 200 000 \u0444\u043E\u0440\u0438\u043D\u0442\u0456\u0432)",
    note: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
    errorNotProduct: "\u041F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u043B\u0438\u0432\u0435 \u043B\u0438\u0448\u0435 \u0434\u043B\u044F \u0442\u043E\u0432\u0430\u0440\u043D\u0438\u0445 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
    errorNotAvailable: "\u041F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u043B\u0438\u0432\u0435 \u043B\u0438\u0448\u0435 \u0434\u043B\u044F \u043F\u043E\u0437\u0438\u0446\u0456\u0439 \u0443 \u0441\u0442\u0430\u0442\u0443\u0441\u0456 \xAB\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E\xBB"
  },
  releaseHub: {
    title: "rPI Delta",
    subtitle: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u0442\u0430 \u043F\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u044F",
    tabs: {
      changelog: "\u0416\u0443\u0440\u043D\u0430\u043B \u0437\u043C\u0456\u043D",
      testing: "\u0422\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u0435\u043B\u0456\u0437\u0443"
    },
    changelog: {
      version: "\u0412\u0435\u0440\u0441\u0456\u044F",
      date: "\u0414\u0430\u0442\u0430",
      changes: "\u0437\u043C\u0456\u043D",
      expandAll: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0456",
      collapseAll: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0432\u0441\u0456",
      types: {
        feature: "\u041D\u043E\u0432\u0430 \u0444\u0443\u043D\u043A\u0446\u0456\u044F",
        fix: "\u0412\u0438\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F",
        improvement: "\u041F\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u044F",
        breaking: "\u0412\u0430\u0436\u043B\u0438\u0432\u0430 \u0437\u043C\u0456\u043D\u0430"
      },
      testStepsBadge: "\u041A\u0440\u043E\u043A\u0438 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      noEntries: "\u0417\u0430\u043F\u0438\u0441\u0456\u0432 \u043F\u043E\u043A\u0438 \u043D\u0435\u043C\u0430\u0454."
    },
    testing: {
      summary: "\u0412\u0441\u044C\u043E\u0433\u043E",
      features: "\u0444\u0443\u043D\u043A\u0446\u0456\u0439",
      steps: "\u043A\u0440\u043E\u043A\u0456\u0432",
      expected: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442",
      status: {
        passed: "\u041F\u0440\u043E\u0439\u0434\u0435\u043D\u043E",
        failed: "\u041D\u0435 \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u043E",
        not_tested: "\u041D\u0435 \u0442\u0435\u0441\u0442\u043E\u0432\u0430\u043D\u043E"
      },
      progress: "{done}/{total} \u043F\u0440\u043E\u0442\u0435\u0441\u0442\u043E\u0432\u0430\u043D\u043E",
      exportCsv: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV",
      changelogBadge: "\u0416\u0443\u0440\u043D\u0430\u043B \u0437\u043C\u0456\u043D",
      testedBy: "\u0422\u0435\u0441\u0442\u0443\u0432\u0430\u0432",
      comment: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)...",
      save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
      noTests: "\u041D\u0435\u043C\u0430\u0454 \u043A\u0440\u043E\u043A\u0456\u0432 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u0446\u0456\u0454\u0457 \u0432\u0435\u0440\u0441\u0456\u0457.",
      retest: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u0435 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      retestNote: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0433\u043E \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)...",
      retestConfirm: "\u041F\u043E\u0447\u0430\u0442\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u0435 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      retestCancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      lastTest: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439",
      testers: "\u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043B\u044C\u043D\u0438\u043A(\u0438)",
      retestCount: "{count}x \u043F\u0440\u043E\u0442\u0435\u0441\u0442\u043E\u0432\u0430\u043D\u043E",
      history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      historyEmpty: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0445 \u0442\u0435\u0441\u0442\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0443\u0441\u043A\u0456\u0432.",
      historyError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0456\u0441\u0442\u043E\u0440\u0456\u044E \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F.",
      historyRetry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
      saveError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
      retestError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u0435 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F.",
      retestReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      notTestedYet: "\u0429\u0435 \u043D\u0435 \u043F\u0440\u043E\u0442\u0435\u0441\u0442\u043E\u0432\u0430\u043D\u043E",
      showSteps: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 {count} \u043A\u0440\u043E\u043A\u0456\u0432 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      hideSteps: "{count} \u043A\u0440\u043E\u043A\u0456\u0432 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      previousTests: "{count} \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0445",
      noPreviousTests: "0 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0445",
      retestNeeded: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u0435 \u0442\u0435\u0441\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
      passBtn: "\u041F\u0440\u043E\u0439\u0434\u0435\u043D\u043E",
      failBtn: "\u041D\u0435 \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u043E",
      untested: "\u041D\u0435 \u043F\u0440\u043E\u0442\u0435\u0441\u0442\u043E\u0432\u0430\u043D\u043E",
      testedPct: "{done}/{total} \u043F\u0440\u043E\u0442\u0435\u0441\u0442\u043E\u0432\u0430\u043D\u043E ({pct}%)",
      historyTestedAt: "\u041F\u0440\u043E\u0442\u0435\u0441\u0442\u043E\u0432\u0430\u043D\u043E",
      historyActiveFor: "\u0410\u043A\u0442\u0438\u0432\u043D\u043E \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C {duration}",
      historyStepStats: "{checked}/{total} \u043A\u0440\u043E\u043A\u0456\u0432 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
      durationMinutes: "{n} \u0445\u0432",
      durationHours: "{n} \u0433\u043E\u0434",
      durationDays: "{n} \u0434\u043D\u0456\u0432"
    },
    filters: {
      search: "\u041F\u043E\u0448\u0443\u043A...",
      showOlder: "\u0421\u0442\u0430\u0440\u0456\u0448\u0456 \u0432\u0435\u0440\u0441\u0456\u0457 ({count})",
      clearFilters: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
      results: "{filtered}/{total} \u0437\u0430\u043F\u0438\u0441\u0456\u0432",
      noResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0434\u043B\u044F \u0446\u0438\u0445 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432.",
      categories: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
      types: "\u0422\u0438\u043F",
      statuses: "\u0421\u0442\u0430\u0442\u0443\u0441"
    }
  },
  quote: {
    advance: {
      amount: "\u0421\u0443\u043C\u0430 \u0430\u0432\u0430\u043D\u0441\u0443",
      confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0430\u0432\u0430\u043D\u0441",
      deducted: "\u0412\u0438\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043E",
      exceedsTotal: "\u0410\u0432\u0430\u043D\u0441 \u043F\u0435\u0440\u0435\u0432\u0438\u0449\u0443\u0454 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u0443 \u0441\u0443\u043C\u0443",
      invalidAmount: "\u041D\u0435\u0432\u0456\u0440\u043D\u0430 \u0441\u0443\u043C\u0430",
      method: "\u0421\u043F\u043E\u0441\u0456\u0431 \u043E\u043F\u043B\u0430\u0442\u0438",
      methodCard: "\u041A\u0430\u0440\u0442\u043A\u0430",
      methodCash: "\u0413\u043E\u0442\u0456\u0432\u043A\u0430",
      methodTransfer: "\u041F\u0435\u0440\u0435\u043A\u0430\u0437",
      paid: "\u0410\u0432\u0430\u043D\u0441 \u043E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      paidAt: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
      pay: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u0438 \u0430\u0432\u0430\u043D\u0441",
      payDescription: "\u0417\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u0430\u0432\u0430\u043D\u0441\u043E\u0432\u0438\u0439 \u043F\u043B\u0430\u0442\u0456\u0436",
      recordFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u0430\u0432\u0430\u043D\u0441",
      recorded: "\u0410\u0432\u0430\u043D\u0441 \u0437\u0430\u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u043E",
      refund: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u0430\u0432\u0430\u043D\u0441\u0443",
      refundBtn: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438",
      refundConfirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
      refundFailed: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u0432\u0434\u0430\u043B\u0435",
      refunded: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E",
      refundedLabel: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u043E"
    }
  },
  priLlm: {
    apiKeyPlaceholder: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u043E\u0432\u0438\u0439 API \u043A\u043B\u044E\u0447...",
    userPerMin: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 / \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
    tenantPerMin: "\u0422\u0435\u043D\u0430\u043D\u0442 / \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
    userPerDay: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 / \u0434\u0435\u043D\u044C",
    sonnetPerMin: "Sonnet / \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
    requests: "\u0417\u0430\u043F\u0438\u0442\u0438",
    inputTokens: "\u0412\u0445\u0456\u0434\u043D\u0456 \u0442\u043E\u043A\u0435\u043D\u0438",
    outputTokens: "\u0412\u0438\u0445\u0456\u0434\u043D\u0456 \u0442\u043E\u043A\u0435\u043D\u0438",
    costUsd: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C (USD)",
    title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0430\u0441\u0438\u0441\u0442\u0435\u043D\u0442\u0430 pRI",
    apiConfigTitle: "\u041A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044F API",
    apiConfigDesc: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F LLM-\u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u0430 \u0442\u0430 \u043A\u043B\u044E\u0447\u0430 API",
    providerLabel: "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440",
    apiKeyLabel: "\u041A\u043B\u044E\u0447 API",
    currentKeyLabel: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439:",
    enabledLabel: "pRI \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E",
    enabledDesc: "\u0414\u043E\u0437\u0432\u043E\u043B\u0438\u0442\u0438 LLM-\u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0434\u043B\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432",
    testConnection: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0437'\u0454\u0434\u043D\u0430\u043D\u043D\u044F",
    testOk: "OK \u2014 {model} ({latencyMs}ms)",
    testFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F",
    rateLimitTitle: "\u041E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F \u0447\u0430\u0441\u0442\u043E\u0442\u0438 \u0442\u0430 \u043A\u0432\u043E\u0442\u0438",
    rateLimitDesc: "\u041E\u0431\u043C\u0435\u0436\u0435\u043D\u043D\u044F \u043D\u0430 \u0440\u0456\u0432\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0442\u0430 \u043E\u0440\u0435\u043D\u0434\u0430\u0440\u044F",
    monthlyQuotasTitle: "\u041C\u0456\u0441\u044F\u0447\u043D\u0456 \u043A\u0432\u043E\u0442\u0438 (\u0437\u0430\u043F\u0438\u0442\u0456\u0432/\u043C\u0456\u0441\u044F\u0446\u044C)",
    tierStrategyTitle: "\u0421\u0442\u0440\u0430\u0442\u0435\u0433\u0456\u044F \u0440\u0456\u0432\u043D\u0456\u0432",
    defaultTierLabel: "\u0420\u0456\u0432\u0435\u043D\u044C \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
    autoDowngradeLabel: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0437\u043D\u0438\u0436\u0435\u043D\u043D\u044F",
    autoDowngradeDesc: "\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u0454\u0442\u044C\u0441\u044F \u043D\u0430 \u0434\u0435\u0448\u0435\u0432\u0448\u0438\u0439 \u0440\u0456\u0432\u0435\u043D\u044C \u043F\u0456\u0441\u043B\u044F \u0434\u043E\u0441\u044F\u0433\u043D\u0435\u043D\u043D\u044F \u043A\u0432\u043E\u0442\u0438",
    usageStatsTitle: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F",
    usageStatsDesc: "\u0417\u0432\u0435\u0434\u0435\u043D\u0456 \u0434\u0430\u043D\u0456 \u0437\u0430 \u043F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
    noUsageData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u0437\u0430 \u0446\u0435\u0439 \u043C\u0456\u0441\u044F\u0446\u044C.",
    saveButton: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
    saveSuccessTitle: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
    saveSuccessDesc: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F pRI \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E.",
    saveErrorTitle: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430",
    unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430.",
    networkError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043C\u0435\u0440\u0435\u0436\u0456"
  },
  goodsReceipt: {
    detail: {
      backToList: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
      notFound: "\u041D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u0442\u043E\u0432\u0430\u0440\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      completeConfirm: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F? \u0417\u0430\u043F\u0430\u0441\u0438 \u0431\u0443\u0434\u0443\u0442\u044C \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456.",
      completing: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F...",
      complete: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438",
      unresolvedCount: "{count} \u043D\u0435\u0432\u0438\u0440\u0456\u0448\u0435\u043D\u0438\u0445 \u0440\u043E\u0437\u0431\u0456\u0436\u043D\u043E\u0441\u0442\u0435\u0439",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
      createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      completedAt: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      linkedAvizo: "\u041F\u043E\u0432'\u044F\u0437\u0430\u043D\u0435 \u0430\u0432\u0456\u0437\u043E",
      notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0438",
      items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457",
      productCode: "\u041A\u043E\u0434 \u0442\u043E\u0432\u0430\u0440\u0443",
      productName: "\u0422\u043E\u0432\u0430\u0440",
      expectedQty: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430",
      receivedQty: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u0430",
      difference: "\u0420\u0456\u0437\u043D\u0438\u0446\u044F",
      ok: "OK",
      discrepancies: "\u0420\u043E\u0437\u0431\u0456\u0436\u043D\u043E\u0441\u0442\u0456",
      expected: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430",
      actual: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0430",
      resolved: "\u0412\u0438\u0440\u0456\u0448\u0435\u043D\u043E",
      resolutionNotePlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u0432\u0438\u0440\u0456\u0448\u0435\u043D\u043D\u044F...",
      resolveButton: "\u0412\u0438\u0440\u0456\u0448\u0438\u0442\u0438"
    },
    statusLabels: {
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      inProgress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      discrepancy: "\u0420\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044C",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E"
    },
    discrepancyTypes: {
      shortage: "\u041D\u0435\u0441\u0442\u0430\u0447\u0430",
      surplus: "\u041D\u0430\u0434\u043B\u0438\u0448\u043E\u043A",
      damaged: "\u041F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043E",
      wrong_item: "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0438\u0439 \u0442\u043E\u0432\u0430\u0440"
    },
    shipping: {
      title: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
      costLabel: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
      costPlaceholder: "\u043D\u0430\u043F\u0440. 15000",
      distribute: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438",
      allocationTitle: "\u0420\u043E\u0437\u043F\u043E\u0434\u0456\u043B \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
      originalPrice: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0430 \u0446\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434.",
      proportion: "\u0427\u0430\u0441\u0442\u043A\u0430",
      allocation: "\u0412\u0430\u0440\u0442\u0456\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
      adjustedPrice: "\u0421\u043A\u043E\u0440\u0438\u0433\u043E\u0432\u0430\u043D\u0430 \u0446\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434."
    },
    form: {
      title: "\u041D\u043E\u0432\u0435 \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      linkAvizo: "\u041F\u0440\u0438\u0432'\u044F\u0437\u0430\u0442\u0438 \u0434\u043E \u0430\u0432\u0456\u0437\u043E",
      noAvizo: "\u041D\u0435\u043C\u0430\u0454 \u0430\u0432\u0456\u0437\u043E",
      itemsLabel: "\u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      avizoHint: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0435 \u0430\u0432\u0456\u0437\u043E \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E\u0433\u043E \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043D\u044F \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A",
      supplierPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u0430\u2026",
      notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
      notesPlaceholder: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430 \u0434\u043E \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F\u2026",
      items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457",
      addItem: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
      productCode: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B",
      productCodePlaceholder: "\u043D\u0430\u043F\u0440. 12345",
      productName: "\u041D\u0430\u0439\u043C\u0435\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
      productNamePlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0442\u043E\u0432\u0430\u0440\u0443",
      expectedQty: "\u041E\u0447\u0456\u043A. \u043A-\u0441\u0442\u044C",
      receivedQty: "\u041E\u0442\u0440\u0438\u043C. \u043A-\u0441\u0442\u044C",
      unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434.",
      purchaseCategory: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u0456",
      locationCode: "\u041A\u043E\u0434 \u043A\u043E\u043C\u0456\u0440\u043A\u0438",
      locationPlaceholder: "\u043D\u0430\u043F\u0440. A-01-02",
      packageSplitting: "\u0420\u043E\u0437\u043F\u0430\u043A\u0443\u0432\u0430\u043D\u043D\u044F",
      packageQty: "\u041A-\u0441\u0442\u044C \u0443\u043F\u0430\u043A\u043E\u0432\u043E\u043A",
      unitsPerPackage: "\u041E\u0434\u0438\u043D\u0438\u0446\u044C / \u0443\u043F\u0430\u043A\u043E\u0432\u043A\u0430",
      totalUnits: "\u0423\u0441\u044C\u043E\u0433\u043E \u043E\u0434\u0438\u043D\u0438\u0446\u044C",
      categories: {
        aru: "\u0422\u043E\u0432\u0430\u0440",
        beruhazas: "\u0406\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0456\u044F",
        berendezes: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        egyeb: "\u0406\u043D\u0448\u0435",
        rezsi: "\u041A\u043E\u043C\u0443\u043D\u0430\u043B\u044C\u043D\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u0438"
      }
    },
    allStatuses: "\u0423\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
    hasDiscrepancy: "\u0417 \u0440\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044E",
    newReceipt: "\u041D\u043E\u0432\u0435 \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
    noAvizos: "\u041D\u0435\u043C\u0430\u0454 \u0430\u0432\u0456\u0437\u043E",
    noReceipts: "\u041D\u0435\u043C\u0430\u0454 \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u044C",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C, \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A\u043E\u043C\u2026",
    subtitle: "\u041A\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0445\u0456\u0434\u043D\u0438\u043C\u0438 \u0442\u043E\u0432\u0430\u0440\u0430\u043C\u0438 \u0442\u0430 \u0430\u0432\u0456\u0437\u043E",
    title: "\u041D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
    avizo: {
      expectedDate: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0430 \u0434\u0430\u0442\u0430",
      itemCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
      startReceipt: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A"
    },
    stats: {
      completedThisMonth: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E (\u0446\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F)",
      inProgress: "\u0423 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      total: "\u0423\u0441\u044C\u043E\u0433\u043E",
      withDiscrepancy: "\u0417 \u0440\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044E"
    },
    table: {
      discrepancy: "\u0420\u043E\u0437\u0431\u0456\u0436\u043D\u0456\u0441\u0442\u044C",
      itemCount: "\u041A-\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
      receiptNumber: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
      receivedDate: "\u0414\u0430\u0442\u0430 \u043D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
      supplier: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A"
    },
    tabs: {
      avizos: "\u0410\u0432\u0456\u0437\u043E",
      receipts: "\u041D\u0430\u0434\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F"
    }
  },
  packages: {
    title: "\u041F\u0430\u043A\u0435\u0442\u0438",
    subtitle: "\u041A\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u0430\u043A\u0435\u0442\u0430\u043C\u0438 \u0442\u043E\u0432\u0430\u0440\u0456\u0432 \u0442\u0430 \u043F\u043E\u0441\u043B\u0443\u0433",
    createNew: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u043A\u0435\u0442",
    editPackage: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0430\u043A\u0435\u0442",
    editor: {
      sharedBanner: "\u0426\u0435\u0439 \u043F\u0430\u043A\u0435\u0442 \u0441\u043F\u0456\u043B\u044C\u043D\u0438\u0439 \u0434\u043B\u044F {count} \u043C\u0430\u0448\u0438\u043D. \u0417\u043C\u0456\u043D\u0438 \u0432\u043F\u043B\u0438\u043D\u0443\u0442\u044C \u043D\u0430 \u0432\u0441\u0456.",
      conflictTitle: "\u041F\u0430\u043A\u0435\u0442 \u0441\u043F\u0456\u043B\u044C\u043D\u0438\u0439",
      conflictSubtext: "\u0417\u043C\u0456\u043D\u0438 \u0432\u043F\u043B\u0438\u043D\u0443\u0442\u044C \u043D\u0430 \u0432\u0441\u0456 \u043C\u0430\u0448\u0438\u043D\u0438. \u042F\u043A \u0431\u0430\u0436\u0430\u0454\u0442\u0435 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?",
      conflictApplyAll: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438 \u0434\u043E \u0432\u0441\u0456\u0445",
      conflictApplyAllDesc: "\u041C\u0430\u0439\u0441\u0442\u0435\u0440-\u043F\u0430\u043A\u0435\u0442 \u043E\u043D\u043E\u0432\u043B\u044E\u0454\u0442\u044C\u0441\u044F. \u0423\u0441\u0456 \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 \u0431\u0430\u0447\u0430\u0442\u044C \u043D\u043E\u0432\u0443 \u0432\u0435\u0440\u0441\u0456\u044E.",
      conflictCopyForThis: "\u041B\u0438\u0448\u0435 \u0434\u043B\u044F \u0446\u0456\u0454\u0457",
      conflictCopyForThisDesc: "\u0414\u043B\u044F \u0432\u0438\u0431\u0440\u0430\u043D\u043E\u0457 \u043C\u0430\u0448\u0438\u043D\u0438 \u0441\u0442\u0432\u043E\u0440\u044E\u0454\u0442\u044C\u0441\u044F \u043D\u043E\u0432\u0438\u0439 \u0432\u0430\u0440\u0456\u0430\u043D\u0442 \u043F\u0430\u043A\u0435\u0442\u0430. \u0406\u043D\u0448\u0456 \u043C\u0430\u0448\u0438\u043D\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C \u043D\u0435\u0437\u043C\u0456\u043D\u0435\u043D\u0438\u0439 \u043C\u0430\u0439\u0441\u0442\u0435\u0440. \u0423\u0432\u0430\u0433\u0430: \u0432\u0430\u0448\u0456 \u043F\u043E\u0442\u043E\u0447\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u041D\u0415 \u043F\u0435\u0440\u0435\u043D\u043E\u0441\u044F\u0442\u044C\u0441\u044F \u0443 \u0432\u0430\u0440\u0456\u0430\u043D\u0442 \u2014 \u0432\u0456\u0434\u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u0439\u043E\u0433\u043E \u0442\u0430\u043C \u0437\u043D\u043E\u0432\u0443.",
      conflictForking: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0430...",
      conflictCopyTargetPlaceholder: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u0430\u0448\u0438\u043D\u0443...",
      conflictCopyTargetAriaLabel: "\u0426\u0456\u043B\u044C\u043E\u0432\u0430 \u043C\u0430\u0448\u0438\u043D\u0430 \u0434\u043B\u044F \u0444\u043E\u0440\u043A\u0430"
    },
    editorSubtitle: "\u0421\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u043F\u0430\u043A\u0435\u0442\u0443 \u0442\u0430 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0446\u0456\u043D",
    packageCode: "\u041A\u043E\u0434 \u043F\u0430\u043A\u0435\u0442\u0443",
    packageCodePlaceholder: "\u043D\u0430\u043F\u0440. PKG-001",
    packageName: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0430\u043A\u0435\u0442\u0443",
    packageNamePlaceholder: "\u043D\u0430\u043F\u0440. \u0411\u0430\u0437\u043E\u0432\u0438\u0439 \u043F\u0430\u043A\u0435\u0442 \u043E\u0440\u0435\u043D\u0434\u0438",
    noPackages: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0430\u043A\u0435\u0442\u0456\u0432",
    searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0430\u0431\u043E \u043A\u043E\u0434\u043E\u043C...",
    displayedCount: "{count} \u043F\u0430\u043A\u0435\u0442\u0456\u0432 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
    copy: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
    basicInfo: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
    scopeLabel: "\u041E\u0431\u043B\u0430\u0441\u0442\u044C \u0434\u0456\u0457",
    descriptionPlaceholder: "\u041E\u043F\u0438\u0441 \u043F\u0430\u043A\u0435\u0442\u0443...",
    packageItems: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u043F\u0430\u043A\u0435\u0442\u0443",
    noItems: "\u041F\u043E\u043A\u0438 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439. \u0417\u043D\u0430\u0439\u0434\u0456\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u0438 \u043D\u0430 \u043F\u0440\u0430\u0432\u0456\u0439 \u043F\u0430\u043D\u0435\u043B\u0456.",
    moveUp: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0433\u043E\u0440\u0443",
    moveDown: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043D\u0438\u0437",
    productSearch: "\u041F\u043E\u0448\u0443\u043A \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
    searchProductPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0430\u0431\u043E \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u043E\u043C...",
    noSearchResults: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
    alreadyAdded: "\u0414\u043E\u0434\u0430\u043D\u043E",
    pricing: "\u0426\u0456\u043D\u043E\u0443\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
    pricingModelLabel: "\u041C\u043E\u0434\u0435\u043B\u044C \u0446\u0456\u043D\u043E\u0443\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
    fixedPriceLabel: "\u0424\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u0430 \u0446\u0456\u043D\u0430",
    discountPercentLabel: "\u0417\u043D\u0438\u0436\u043A\u0430 (%)",
    validFrom: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0437",
    validUntil: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0434\u043E",
    calculator: "\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440",
    itemsTotal: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u0440\u0430\u0437\u043E\u043C",
    packagePriceLabel: "\u0426\u0456\u043D\u0430 \u043F\u0430\u043A\u0435\u0442\u0443",
    savingsLabel: "\u0415\u043A\u043E\u043D\u043E\u043C\u0456\u044F",
    itemCount: "{count} \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
    expired: "\u0417\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F",
    daysLeft: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C {count} \u0434\u043D\u0456\u0432",
    type: {
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      sales: "\u041F\u0440\u043E\u0434\u0430\u0436",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      mixed: "\u0417\u043C\u0456\u0448\u0430\u043D\u0438\u0439",
      promotional: "\u0410\u043A\u0446\u0456\u0439\u043D\u0438\u0439",
      franchise: "\u0424\u0440\u0430\u043D\u0448\u0438\u0437\u0430"
    },
    status: {
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430"
    },
    pricingModel: {
      fixed: "\u0424\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u0430 \u0446\u0456\u043D\u0430",
      discounted: "\u0417\u0456 \u0437\u043D\u0438\u0436\u043A\u043E\u044E",
      tiered: "\u0420\u0456\u0432\u043D\u0435\u0432\u0438\u0439"
    },
    scopeValue: {
      central: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0438\u0439",
      local: "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0438\u0439"
    },
    itemType: {
      product: "\u0422\u043E\u0432\u0430\u0440",
      service: "\u0421\u0435\u0440\u0432\u0456\u0441",
      rental_equipment: "\u041E\u0440\u0435\u043D\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F"
    },
    upsell: {
      banner: "\u0427\u0438 \u0437\u043D\u0430\u043B\u0438 \u0432\u0438?",
      cheaperBy: "\u0443 \u043F\u0430\u043A\u0435\u0442\u0456 \u043D\u0430 {percent}% \u0434\u0435\u0448\u0435\u0432\u0448\u0435!",
      contents: "\u0412\u043C\u0456\u0441\u0442 \u043F\u0430\u043A\u0435\u0442\u0443",
      individually: "\u041E\u043A\u0440\u0435\u043C\u043E",
      inPackage: "\u0423 \u043F\u0430\u043A\u0435\u0442\u0456",
      perDay: "/\u0434\u0435\u043D\u044C",
      choosePackage: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043F\u0430\u043A\u0435\u0442",
      keepIndividual: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0456\u043D\u0434\u0438\u0432\u0456\u0434\u0443\u0430\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0431\u0456\u0440",
      savings: "\u0435\u043A\u043E\u043D\u043E\u043C\u0456\u044F",
      savingsPercent: "{percent}% \u0435\u043A\u043E\u043D\u043E\u043C\u0456\u0457"
    },
    linkedCategories: "\u041F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
    linkedCategoriesDesc: "\u0414\u043B\u044F \u044F\u043A\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043F\u0440\u043E\u043F\u043E\u043D\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u043F\u0430\u043A\u0435\u0442",
    scope: {
      sectionTitle: "\u041E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u0430\u043A\u0435\u0442\u0430",
      mode: {
        category: "\u0417\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0454\u044E",
        equipment: "\u041A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F"
      },
      switchConfirmTitle: "\u041F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438 \u0440\u0435\u0436\u0438\u043C?",
      switchConfirmBody: "\u041F\u043E\u0442\u043E\u0447\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u043D\u0456 {count} \u0435\u043B\u0435\u043C\u0435\u043D\u0442(\u0438) \u0431\u0443\u0434\u0435 \u0432\u0442\u0440\u0430\u0447\u0435\u043D\u043E \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u043D\u043D\u0456.",
      switchConfirmOk: "\u0422\u0430\u043A, \u043F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438",
      switchConfirmCancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      equipment: {
        selectedTitle: "\u0412\u0438\u0431\u0440\u0430\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F ({count})",
        selectedEmpty: "\u041E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0449\u0435 \u043D\u0435 \u0432\u0438\u0431\u0440\u0430\u043D\u0435",
        searchTitle: "\u041F\u043E\u0448\u0443\u043A \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        searchPlaceholder: "\u041D\u0430\u0437\u0432\u0430 \u0430\u0431\u043E \u0430\u0440\u0442\u0438\u043A\u0443\u043B...",
        searchEmpty: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        alreadyAdded: "\u0412\u0436\u0435 \u0434\u043E\u0434\u0430\u043D\u043E",
        add: "\u0414\u043E\u0434\u0430\u0442\u0438",
        remove: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438"
      },
      validationError: {
        categoryRequired: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 1 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        equipmentRequired: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 1 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F"
      }
    },
    productDetail: {
      linkedPackagesTitle: "\u0426\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0454 \u0432 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u043F\u0430\u043A\u0435\u0442\u0430\u0445:"
    },
    item: {
      category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
      categoryOption: {
        free: "\u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
        rentable: "\u041E\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0439",
        consignment: "\u041A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u044F"
      },
      defaultQuantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447.",
      isQuantityEditable: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0440\u0435\u0434\u0430\u0433\u043E\u0432\u0430\u043D\u0430",
      visibleOnWebshop: "\u0412\u0438\u0434\u043D\u043E \u0443 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456"
    }
  },
  manufacturing: {
    title: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
    bom: {
      title: "\u0421\u043F\u0435\u0446\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F (BOM)",
      subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0442\u0430 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043F\u0435\u0446\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439",
      bomCode: "\u041A\u043E\u0434 BOM",
      createNew: "\u041D\u043E\u0432\u0430 BOM",
      editBom: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F BOM",
      editorSubtitle: "\u0421\u043A\u043B\u0430\u0434\u0430\u043D\u043D\u044F \u0441\u043F\u0435\u0446\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 \u0442\u0430 \u0443\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430\u043C\u0438",
      basicInfo: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
      outputProduct: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
      outputQuantity: "\u0412\u0438\u0445\u0456\u0434\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      searchOutputProduct: "\u041F\u043E\u0448\u0443\u043A \u0432\u0438\u0445\u0456\u0434\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443...",
      descriptionPlaceholder: "\u041E\u043F\u0438\u0441 BOM...",
      validFrom: "\u0414\u0456\u0439\u0441\u043D\u0430 \u0437",
      validUntil: "\u0414\u0456\u0439\u0441\u043D\u0430 \u0434\u043E",
      components: "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0438",
      noLines: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0456\u0432. \u0417\u043D\u0430\u0439\u0434\u0456\u0442\u044C \u0456 \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0437 \u043F\u0440\u0430\u0432\u043E\u0457 \u043F\u0430\u043D\u0435\u043B\u0456.",
      addComponent: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442",
      searchComponentPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443 (\u043D\u0430\u0437\u0432\u0430, SKU)...",
      noSearchResults: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      alreadyAdded: "\u0412\u0436\u0435 \u0434\u043E\u0434\u0430\u043D\u043E",
      lineCount: "{count} \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0456\u0432",
      displayedCount: "{count} BOM \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
      noBoms: "\u0421\u043F\u0435\u0446\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043A\u043E\u0434\u043E\u043C \u0430\u0431\u043E \u043E\u043F\u0438\u0441\u043E\u043C...",
      optional: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
      required: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
      toggleOptional: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439/\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
      moveUp: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0433\u043E\u0440\u0443",
      moveDown: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043D\u0438\u0437"
    },
    productionOrder: {
      title: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      subtitle: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u0442\u0430 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0445 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u044C",
      orderNumber: "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      createNew: "\u041D\u043E\u0432\u0435 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0435 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      product: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
      planned: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E",
      actual: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u043E",
      plannedQty: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      actualQty: "\u0424\u0430\u043A\u0442\u0438\u0447\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      plannedStart: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0438\u0439 \u043F\u043E\u0447\u0430\u0442\u043E\u043A",
      plannedEnd: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F",
      progress: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441",
      phases: "\u0424\u0430\u0437\u0438",
      phasesCompleted: "\u0444\u0430\u0437 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      plan: "\u041F\u043B\u0430\u043D\u0443\u0432\u0430\u0442\u0438",
      startProduction: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
      complete: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438",
      startPhase: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0444\u0430\u0437\u0443",
      completePhase: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0444\u0430\u0437\u0443",
      recordScrap: "\u0417\u0430\u0444\u0456\u043A\u0441\u0443\u0432\u0430\u0442\u0438 \u0431\u0440\u0430\u043A",
      confirmScrap: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0431\u0440\u0430\u043A",
      scrapReason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0431\u0440\u0430\u043A\u0443",
      scrapReasonPlaceholder: "\u0429\u043E \u0441\u043F\u0440\u0438\u0447\u0438\u043D\u0438\u043B\u043E \u0431\u0440\u0430\u043A?",
      scrap: "\u0411\u0440\u0430\u043A",
      started: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      duration: "\u0422\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C",
      noOrders: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0445 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u044C \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
      searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u043E\u043C\u0435\u0440\u043E\u043C \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F...",
      displayedCount: "{count} \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u044C \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043E",
      notFound: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0435 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E"
    },
    phase: {
      preparation: "\u041F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430",
      manufacturing: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0446\u0442\u0432\u043E",
      qc: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u044F\u043A\u043E\u0441\u0442\u0456",
      receipt: "\u041F\u0440\u0438\u0439\u043C\u0430\u043D\u043D\u044F"
    },
    phaseStatus: {
      pending: "\u041E\u0447\u0456\u043A\u0443\u0454",
      in_progress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E",
      skipped: "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E"
    },
    lotBatch: {
      title: "\u041F\u0430\u0440\u0442\u0456\u044F/\u0421\u0435\u0440\u0456\u044F",
      lotNumber: "\u041D\u043E\u043C\u0435\u0440 \u043F\u0430\u0440\u0442\u0456\u0457",
      qualityStatus: "\u0421\u0442\u0430\u0442\u0443\u0441 \u044F\u043A\u043E\u0441\u0442\u0456",
      producedAt: "\u0412\u0438\u0440\u043E\u0431\u043B\u0435\u043D\u043E",
      noLots: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u0438\u0445 \u043F\u0430\u0440\u0442\u0456\u0439"
    },
    status: {
      active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      planned: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0438\u0439",
      in_progress: "\u0412 \u043F\u0440\u043E\u0446\u0435\u0441\u0456",
      completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0439",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0439"
    },
    bomType: {
      assembly: "\u0417\u0431\u0456\u0440\u043A\u0430",
      kit: "\u041D\u0430\u0431\u0456\u0440/\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442",
      refurbishment: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      custom: "\u0406\u043D\u0434\u0438\u0432\u0456\u0434\u0443\u0430\u043B\u044C\u043D\u0438\u0439"
    },
    qualityStatus: {
      pending: "\u041E\u0447\u0456\u043A\u0443\u0454",
      passed: "\u041F\u0440\u043E\u0439\u0434\u0435\u043D\u043E",
      failed: "\u041D\u0435 \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u043E",
      partial: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u043E \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u043E"
    },
    refurbishment: {
      title: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      start: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      complete: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      approve: "\u0421\u0445\u0432\u0430\u043B\u0438\u0442\u0438",
      reject: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
      history: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
      sourceWorksheet: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442",
      sourceEquipment: "\u0412\u0438\u0445\u0456\u0434\u043D\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
      outputProduct: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
      outputSku: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439 SKU",
      qualityCheck: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u044F\u043A\u043E\u0441\u0442\u0456",
      approved: "\u0421\u0445\u0432\u0430\u043B\u0435\u043D\u043E \u2014 \u043D\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      rejected: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E \u2014 \u0431\u0440\u0430\u043A \u0437\u0430\u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u043E",
      noHistory: "\u041D\u0435\u043C\u0430\u0454 \u0456\u0441\u0442\u043E\u0440\u0456\u0457 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F"
    }
  },
  consignment: {
    dashboard: {
      title: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0457",
      outstandingValue: "\u041D\u0435\u043F\u043E\u0433\u0430\u0448\u0435\u043D\u0430 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044C",
      partnerCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
      oldest: "\u041D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0438\u0439",
      daysAgo: "{days} \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443",
      overdueWarning: "\u041F\u043E\u043D\u0430\u0434 30 \u0434\u043D\u0456\u0432",
      overduePartners: "{count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440(\u0456\u0432)",
      overdueRentals: "{count} \u043E\u0440\u0435\u043D\u0434\u0430",
      noActive: "\u041D\u0435\u043C\u0430\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u043A\u043E\u043D\u0441\u0438\u0433\u043D\u0430\u0446\u0456\u0439"
    }
  },
  helpdesk: {
    screenLabel: "\u0415\u043A\u0440\u0430\u043D / \u041F\u0443\u043D\u043A\u0442 \u043C\u0435\u043D\u044E",
    screenPlaceholder: "\u041D\u0430\u043F\u0440.: \u041E\u0440\u0435\u043D\u0434\u0430 > \u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043E\u0440\u0435\u043D\u0434\u0438 > \u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
    bugDescLabel: "\u041E\u043F\u0438\u0441 \u043F\u043E\u043C\u0438\u043B\u043A\u0438",
    featureDescLabel: "\u041E\u043F\u0438\u0441 \u0437\u0430\u043F\u0438\u0442\u0443",
    questionDescLabel: "\u0412\u0430\u0448\u0435 \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
    guidedActionFieldLabel: "\u0429\u043E \u044F \u0437\u0440\u043E\u0431\u0438\u0432:",
    guidedActionPrefix: "\u0429\u043E \u044F \u0437\u0440\u043E\u0431\u0438\u0432: ",
    actionPlaceholder: "\u041D\u0430\u043F\u0440.: \u041D\u0430\u0442\u0438\u0441\u043D\u0443\u0432 \u043A\u043D\u043E\u043F\u043A\u0443 \u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
    guidedResultFieldLabel: "\u0429\u043E \u0441\u0442\u0430\u043B\u043E\u0441\u044F:",
    guidedResultPrefix: "\u0429\u043E \u0441\u0442\u0430\u043B\u043E\u0441\u044F: ",
    resultPlaceholder: "\u041D\u0430\u043F\u0440.: \u0417\u02BC\u044F\u0432\u0438\u043B\u043E\u0441\u044F \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u043F\u043E\u043C\u0438\u043B\u043A\u0443",
    guidedExpectedFieldLabel: "\u0429\u043E \u043C\u0430\u043B\u043E \u0441\u0442\u0430\u0442\u0438\u0441\u044F:",
    guidedExpectedPrefix: "\u0429\u043E \u043C\u0430\u043B\u043E \u0441\u0442\u0430\u0442\u0438\u0441\u044F: ",
    expectedPlaceholder: "\u041D\u0430\u043F\u0440.: \u0414\u0430\u043D\u0456 \u043C\u0430\u043B\u0438 \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438\u0441\u044F",
    freeTextModeBtn: "\u0412\u0456\u043B\u044C\u043D\u0438\u0439 \u0442\u0435\u043A\u0441\u0442 \u2192",
    bugPlaceholder: "\u0429\u043E \u0432\u0438 \u0437\u0440\u043E\u0431\u0438\u043B\u0438? \u0429\u043E \u0441\u0442\u0430\u043B\u043E\u0441\u044F? \u0429\u043E \u043C\u0430\u043B\u043E \u0441\u0442\u0430\u0442\u0438\u0441\u044F?",
    featurePlaceholder: "\u0429\u043E \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E? \u042F\u043A \u0446\u0435 \u043C\u0430\u0454 \u043F\u0440\u0430\u0446\u044E\u0432\u0430\u0442\u0438?",
    questionPlaceholder: "\u041E\u043F\u0438\u0448\u0456\u0442\u044C \u0432\u0430\u0448\u0435 \u043F\u0438\u0442\u0430\u043D\u043D\u044F...",
    guidedModeBtn: "\u2190 \u041A\u0435\u0440\u043E\u0432\u0430\u043D\u0438\u0439 \u0440\u0435\u0436\u0438\u043C (\u0434\u043E\u043F\u043E\u043C\u0430\u0433\u0430\u0454 \u0437 \u043E\u043F\u0438\u0441\u043E\u043C)",
    duplicateWarningTitle: "\u26A0 \u041F\u043E\u0434\u0456\u0431\u043D\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454:",
    reasonLabel: "\u0427\u043E\u043C\u0443 \u0446\u0435 \u0432\u0430\u0436\u043B\u0438\u0432\u043E?",
    reasonPlaceholder: "\u041D\u0430\u043F\u0440.: \u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043B\u044F \u043C\u0456\u0441\u044F\u0447\u043D\u043E\u0433\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F, \u0437\u0430\u0440\u0430\u0437 \u0440\u0430\u0445\u0443\u0454\u043C\u043E \u0432\u0440\u0443\u0447\u043D\u0443",
    screenshotLabel: "\u0417\u043D\u0456\u043C\u043E\u043A(\u043A\u0438) \u0435\u043A\u0440\u0430\u043D\u0443",
    tabNewReport: "\u041D\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    tabMyReports: "\u041C\u043E\u0457 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    reporterLabel: "\u0425\u0442\u043E \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u044F\u0454?",
    moduleLabel: "\u041C\u043E\u0434\u0443\u043B\u044C",
    selectPlaceholder: "\u2014 \u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u2014",
    severityLabel: "\u0421\u0435\u0440\u0439\u043E\u0437\u043D\u0456\u0441\u0442\u044C",
    priorityLabel: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
    clearDescriptionBtn: "\u2715 \u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
    clearDescriptionTitle: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043E\u043F\u0438\u0441",
    screenshotMax: "\u2014 \u043C\u0430\u043A\u0441. {max}",
    screenshotPasteHint: "\u0449\u043E\u0431 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0437\u043D\u0456\u043C\u043E\u043A \u0435\u043A\u0440\u0430\u043D\u0430 \u0441\u044E\u0434\u0438",
    screenshotClickHint: "\u0430\u0431\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C / \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u044E\u0434\u0438",
    screenshotCount: "{count} / {max} \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
    autoCaptureTitle: "\u26A0 \u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0437\u0456\u0431\u0440\u0430\u043D\u0456 \u0434\u0430\u043D\u0456",
    attachConsoleErrors: "\u041F\u0440\u0438\u043A\u0440\u0456\u043F\u0438\u0442\u0438 {count} \u043F\u043E\u043C\u0438\u043B\u043E\u043A \u043A\u043E\u043D\u0441\u043E\u043B\u0456",
    attachFailedApis: "\u041F\u0440\u0438\u043A\u0440\u0456\u043F\u0438\u0442\u0438 {count} \u043D\u0435\u0432\u0434\u0430\u043B\u0438\u0445 \u0432\u0438\u043A\u043B\u0438\u043A\u0456\u0432 API",
    submitting: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F...",
    submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    resetFormTitle: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443",
    openSpreadsheet: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044E helpdesk \u0443 Google Sheets \u2192",
    loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    noTickets: "\u0423 \u0432\u0430\u0441 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u044C.",
    selectReporterFirst: `\u0421\u043F\u0435\u0440\u0448\u0443 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u0432\u043E\u0454 \u0456\u043C'\u044F \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u0446\u0456 "\u041D\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F"!`,
    successTitle: "\u0414\u044F\u043A\u0443\u0454\u043C\u043E!",
    successMessage: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E.",
    openInSpreadsheet: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0456 \u2192",
    fabTooltip: "Helpdesk (Ctrl+Shift+H)",
    alertMissingFields: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u043E\u043B\u044F! (\u0417\u0430\u044F\u0432\u043D\u0438\u043A, \u041C\u043E\u0434\u0443\u043B\u044C, \u041E\u043F\u0438\u0441)",
    alertMissingSeverity: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0441\u0435\u0440\u0439\u043E\u0437\u043D\u0456\u0441\u0442\u044C!",
    alertSubmitError: "\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430: {error}",
    unknownError: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
    type: {
      bug: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430",
      feature: "\u0424\u0443\u043D\u043A\u0446\u0456\u044F",
      question: "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F"
    }
  },
  pri: {
    inputPlaceholder: "\u0417\u0430\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u0431\u0443\u0434\u044C-\u0449\u043E...",
    sendLabel: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    welcome: {
      greeting: "\u041F\u0440\u0438\u0432\u0456\u0442! \u042F pRI, \u0432\u0430\u0448 \u0446\u0438\u0444\u0440\u043E\u0432\u0438\u0439 \u043A\u043E\u043B\u0435\u0433\u0430.",
      subtitle: "\u0427\u0438\u043C \u044F \u043C\u043E\u0436\u0443 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438?",
      howToFallback: "\u042F\u043A \u0446\u0435 \u0437\u0440\u043E\u0431\u0438\u0442\u0438?",
      whatIsFallback: "\u0429\u043E \u0446\u0435 \u0437\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430?",
      expiringRentalsLabel: "\u041E\u0440\u0435\u043D\u0434\u0438, \u0449\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u044E\u0442\u044C\u0441\u044F",
      expiringRentalsMessage: "\u041F\u043E\u043A\u0430\u0436\u0438 \u043E\u0440\u0435\u043D\u0434\u0438, \u0449\u043E \u0437\u0430\u043A\u0456\u043D\u0447\u0443\u044E\u0442\u044C\u0441\u044F!",
      openWorksheetsLabel: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u0430\u0440\u043A\u0443\u0448\u0456",
      openWorksheetsMessage: "\u041F\u043E\u043A\u0430\u0436\u0438 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u0440\u043E\u0431\u043E\u0447\u0456 \u0430\u0440\u043A\u0443\u0448\u0456!"
    }
  },
  priceInput: {
    netLabel: "\u041D\u0435\u0442\u0442\u043E",
    grossLabel: "\u0411\u0440\u0443\u0442\u0442\u043E",
    vatRate: "\u041F\u0414\u0412"
  },
  email: {
    templates: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    templateList: "\u0421\u043F\u0438\u0441\u043E\u043A \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432",
    editTemplate: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D",
    selectTemplate: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
    subject: "\u0422\u0435\u043C\u0430",
    greeting: "\u041F\u0440\u0438\u0432\u0456\u0442\u0430\u043D\u043D\u044F",
    body: "\u0422\u0456\u043B\u043E",
    cta: "\u041A\u043D\u043E\u043F\u043A\u0430 CTA",
    ctaUrl: "URL CTA",
    insertVariable: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u0437\u043C\u0456\u043D\u043D\u0443",
    save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
    saving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F...",
    default: "\u0417\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
    customized: "\u041D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u043E",
    active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
    locked: "\u0417\u0430\u0431\u043B\u043E\u043A\u043E\u0432\u0430\u043D\u043E",
    editable: "\u0420\u0435\u0434\u0430\u0433\u043E\u0432\u0430\u043D\u0438\u0439",
    missingVariables: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u0437\u043C\u0456\u043D\u043D\u0456",
    saveSuccess: "\u0428\u0430\u0431\u043B\u043E\u043D \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
    version: "\u0412\u0435\u0440\u0441\u0456\u044F",
    lastUpdated: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
    source: "\u0414\u0436\u0435\u0440\u0435\u043B\u043E",
    preview: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
    desktopPreview: "\u0412\u0438\u0433\u043B\u044F\u0434 \u043D\u0430 \u043A\u043E\u043C\u043F'\u044E\u0442\u0435\u0440\u0456",
    mobilePreview: "\u041C\u043E\u0431\u0456\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434",
    sendTestEmail: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0442\u0435\u0441\u0442\u043E\u0432\u0438\u0439 \u043B\u0438\u0441\u0442",
    testEmailSent: "\u0422\u0435\u0441\u0442\u043E\u0432\u0438\u0439 \u043B\u0438\u0441\u0442 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
    testEmailAddress: "\u0410\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    resetToDefault: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0434\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E",
    resetConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0441\u043A\u0438\u043D\u0443\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D?",
    resetSuccess: "\u0428\u0430\u0431\u043B\u043E\u043D \u0441\u043A\u0438\u043D\u0443\u0442\u043E",
    smtpSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F SMTP",
    smtpHost: "SMTP \u0441\u0435\u0440\u0432\u0435\u0440",
    smtpPort: "\u041F\u043E\u0440\u0442",
    smtpUser: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
    smtpPass: "\u041F\u0430\u0440\u043E\u043B\u044C",
    senderEmail: "Email \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043D\u0438\u043A\u0430",
    senderName: "\u0406\u043C'\u044F \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043D\u0438\u043A\u0430",
    dailyLimit: "\u0414\u0435\u043D\u043D\u0438\u0439 \u043B\u0456\u043C\u0456\u0442",
    testConnection: "\u0422\u0435\u0441\u0442\u0443\u0432\u0430\u0442\u0438 \u0437'\u0454\u0434\u043D\u0430\u043D\u043D\u044F",
    connectionOk: "\u0417'\u0454\u0434\u043D\u0430\u043D\u043D\u044F OK",
    connectionFailed: "\u0417'\u0454\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F",
    emailLogs: "\u0416\u0443\u0440\u043D\u0430\u043B \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044C",
    recipientEmail: "\u041E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447",
    status: "\u0421\u0442\u0430\u0442\u0443\u0441",
    sentAt: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
    resend: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    resendConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E?",
    resendSuccess: "\u041B\u0438\u0441\u0442 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    filterByStatus: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0437\u0430 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u043C",
    filterByTemplate: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0437\u0430 \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u043C",
    todayStats: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    bulkSend: {
      title: "\u041C\u0430\u0441\u043E\u0432\u0430 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0430",
      settings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0438",
      template: "\u0428\u0430\u0431\u043B\u043E\u043D email",
      templatePlaceholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D...",
      language: "\u041C\u043E\u0432\u0430",
      partnerPlaceholder: "\u0412\u0438\u0431\u0456\u0440 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u2014 \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C. \u041D\u0430\u0440\u0430\u0437\u0456 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0442\u044C\u0441\u044F \u0432\u0441\u0456\u043C \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C.",
      variables: "\u0417\u043C\u0456\u043D\u043D\u0456",
      addVariable: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0437\u043C\u0456\u043D\u043D\u0443",
      variableKey: "\u041D\u0430\u0437\u0432\u0430 \u0437\u043C\u0456\u043D\u043D\u043E\u0457",
      variableValue: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      send: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0443",
      sending: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0430...",
      results: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438",
      queued: "\u0423 \u0447\u0435\u0440\u0437\u0456",
      skipped: "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E",
      failed: "\u041D\u0435\u0432\u0434\u0430\u043B\u043E",
      success: "\u041C\u0430\u0441\u043E\u0432\u0443 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0443 \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E!",
      errorNoTemplate: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D!",
      errorSend: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0446\u0456.",
      filters: {
        title: "\u0424\u0456\u043B\u044C\u0442\u0440 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
        search: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C\u2019\u044F\u043C / email / \u043A\u043E\u0434\u043E\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
        segmentLabel: "\u0421\u0435\u0433\u043C\u0435\u043D\u0442",
        segment: {
          vip: "VIP",
          active: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
          atRisk: "\u0420\u0438\u0437\u0438\u043A\u043E\u0432\u0438\u0439",
          inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439"
        },
        hasActiveRentalLabel: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
        hasActiveRental: {
          any: "\u0411\u0435\u0437 \u0444\u0456\u043B\u044C\u0442\u0440\u0430",
          yes: "\u0404",
          no: "\u041D\u0435\u043C\u0430\u0454",
          expiring7d: "\u0417\u0430\u043A\u0456\u043D\u0447\u0443\u0454\u0442\u044C\u0441\u044F \u0437\u0430 7 \u0434\u043D\u0456\u0432"
        },
        lastPurchaseDaysLabel: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u043F\u043E\u043A\u0443\u043F\u043A\u0430",
        lastPurchase: {
          any: "\u0411\u0435\u0437 \u0444\u0456\u043B\u044C\u0442\u0440\u0430",
          "30": "\u0417\u0430 30 \u0434\u043D\u0456\u0432",
          "60": "\u0417\u0430 60 \u0434\u043D\u0456\u0432",
          "90plus": "\u041F\u043E\u043D\u0430\u0434 90 \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443"
        },
        hasOutstandingLabel: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
        hasOutstanding: {
          any: "\u0411\u0435\u0437 \u0444\u0456\u043B\u044C\u0442\u0440\u0430",
          yes: "\u0404",
          no: "\u041D\u0435\u043C\u0430\u0454"
        },
        hasEmailOnly: "\u041B\u0438\u0448\u0435 \u0437 email",
        marketingConsentOnly: "\u041B\u0438\u0448\u0435 \u0437 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u043E\u044E \u0437\u0433\u043E\u0434\u043E\u044E",
        resetFilters: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
        filteredCount: "\u0412\u0456\u0434\u0444\u0456\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438 ({count})",
        selectedCount: "{count} / {max} \u043E\u0431\u0440\u0430\u043D\u043E",
        selectAll: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456\u0445",
        clearSelection: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
        maxLimitWarning: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u043F\u043E\u043D\u0430\u0434 {max} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u2014 \u0437\u0432\u0443\u0437\u044C\u0442\u0435 \u0444\u0456\u043B\u044C\u0442\u0440",
        maxSelectionReached: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C 500 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u0437\u0430 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u044F (NFR1)",
        unsubscribedTooltip: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0432\u0456\u0434\u043F\u0438\u0441\u0430\u0432\u0441\u044F \u2014 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u0435",
        loadMore: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0449\u0435",
        loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
        emptyState: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432, \u0449\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C \u0444\u0456\u043B\u044C\u0442\u0440\u0443",
        sendWithCount: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 ({count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432)",
        columns: {
          name: "\u0406\u043C\u2019\u044F",
          email: "Email",
          segment: "\u0421\u0435\u0433\u043C\u0435\u043D\u0442",
          flags: "\u041E\u0437\u043D\u0430\u043A\u0438"
        },
        flagMarketingConsent: "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u0430 \u0437\u0433\u043E\u0434\u0430",
        flagUnsubscribed: "\u0412\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0439",
        flagOutstanding: "\u0417\u0430\u0431\u043E\u0440\u0433\u043E\u0432\u0430\u043D\u0456\u0441\u0442\u044C"
      },
      errorNoRecipients: "\u041D\u0435 \u043E\u0431\u0440\u0430\u043D\u043E \u0436\u043E\u0434\u043D\u043E\u0433\u043E \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430",
      confirmModal: {
        title: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F: {count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
        description: "\u0412\u0435\u043B\u0438\u043A\u0430 \u043A\u0430\u043C\u043F\u0430\u043D\u0456\u044F \u2014 \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u0442\u043E\u0447\u043D\u0443 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456\u0432, \u0449\u043E\u0431 \u0443\u043D\u0438\u043A\u043D\u0443\u0442\u0438 \u0432\u0438\u043F\u0430\u0434\u043A\u043E\u0432\u043E\u0433\u043E \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F.",
        hint: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C: {count}",
        inputLabel: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456\u0432",
        inputPlaceholder: "\u0426\u0438\u0444\u0440\u0438",
        mismatchTooltip: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0442\u043E\u0447\u043D\u0435 \u0447\u0438\u0441\u043B\u043E",
        confirmButton: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
        cancelButton: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
      },
      legalBasis: {
        TRANSACTIONAL: "\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0456\u0439\u043D\u0438\u0439",
        MARKETING_CONSENT: "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u0430 \u0437\u0433\u043E\u0434\u0430",
        LEGITIMATE_INTEREST: "\u0417\u0430\u043A\u043E\u043D\u043D\u0438\u0439 \u0456\u043D\u0442\u0435\u0440\u0435\u0441",
        unknown: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u0448\u0430\u0431\u043B\u043E\u043D",
        marketingWarning: "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u0438\u0439 \u0448\u0430\u0431\u043B\u043E\u043D \u2014 \u043E\u0442\u0440\u0438\u043C\u0430\u044E\u0442\u044C \u043B\u0438\u0448\u0435 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438 \u0437 \u044F\u0432\u043D\u043E\u044E \u0437\u0433\u043E\u0434\u043E\u044E (marketingConsent=true)."
      },
      skipReason: {
        no_email: "\u0411\u0435\u0437 email",
        not_found: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        unsubscribed: "\u0412\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0439",
        no_consent: "\u0411\u0435\u0437 \u0437\u0433\u043E\u0434\u0438"
      },
      skipBreakdown: "\u0420\u043E\u0437\u0431\u0438\u0432\u043A\u0430 \u0437\u0430 \u043F\u0440\u0438\u0447\u0438\u043D\u0430\u043C\u0438 \u043F\u0440\u043E\u043F\u0443\u0441\u043A\u0443",
      sendDynamic: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 {template} {count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C",
      preview: {
        openButton: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        title: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
        subtitle: "{slug} ({language})",
        noTemplate: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443.",
        loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443\u2026",
        error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430",
        subjectLabel: "\u0422\u0435\u043C\u0430",
        iframeTitle: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 email \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
        sampleDataLabel: "\u0417\u0440\u0430\u0437\u043A\u043E\u0432\u0456 \u0437\u043C\u0456\u043D\u043D\u0456",
        closeButton: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438"
      },
      undo: {
        toastTitle: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0447\u0435\u0440\u0435\u0437 {seconds} \u0441\u0435\u043A\u0443\u043D\u0434\u2026",
        toastBody: "{count} \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
        undoButton: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        undoneToast: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
        sendingNow: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0442\u044C\u0441\u044F\u2026"
      },
      draft: {
        restoreTitle: "\u0417\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u0439 \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0443",
        restoreSubtitle: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E: {savedAt}",
        restoreButton: "\u0412\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438",
        dismissButton: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
      },
      stats: {
        totalBatches: "\u041A\u0430\u043C\u043F\u0430\u043D\u0456\u0457",
        activeCampaigns: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
        completedToday: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0456 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        successRate: "\u0414\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0456\u0441\u0442\u044C",
        windowHint: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 {days} \u0434\u043D\u0456\u0432",
        activeHint: "\u0412\u0438\u043A\u043E\u043D\u0443\u044E\u0442\u044C\u0441\u044F / \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0456",
        completedHint: "\u0417\u0430\u043A\u0440\u0438\u0442\u0456 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        successHint: "\u0437 {recipients} \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456\u0432"
      },
      allFailed: "\u0423\u0441\u0456 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u0438\u0441\u044F",
      asyncInfo: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u0431\u0443\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u0443 \u0444\u043E\u043D\u043E\u0432\u043E\u043C\u0443 \u0440\u0435\u0436\u0438\u043C\u0456, \u0441\u0442\u0430\u0442\u0443\u0441 \u043E\u043D\u043E\u0432\u043B\u044E\u0454\u0442\u044C\u0441\u044F",
      description: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430 \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C",
      error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
      moreRecipients: "\u0449\u0435",
      noEmailWarning: "\u0414\u0435\u044F\u043A\u0456 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0438 \u043D\u0435 \u043C\u0430\u044E\u0442\u044C \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u0430\u0434\u0440\u0435\u0441\u0438",
      partialSuccess: "{queued} \u043B\u0438\u0441\u0442\u0456\u0432 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E, {skipped} \u043F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E",
      partnersSelected: "\u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432 \u0432\u0438\u0431\u0440\u0430\u043D\u043E",
      recipients: "\u041E\u0434\u0435\u0440\u0436\u0443\u0432\u0430\u0447\u0456",
      selectLanguage: "\u0412\u0438\u0431\u0456\u0440 \u043C\u043E\u0432\u0438",
      selectTemplate: "\u0412\u0438\u0431\u0456\u0440 \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
      sendButton: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
      sendEmail: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0438\u0439 \u043B\u0438\u0441\u0442",
      successAll: "{count} \u043B\u0438\u0441\u0442\u0456\u0432 \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0447\u0435\u0440\u0433\u0438 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F"
    },
    template: {
      invoiceSent: "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
      invoiceOverdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      rentalConfirmation: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
      rentalOverdue: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0430 \u043E\u0440\u0435\u043D\u0434\u0430",
      rentalDepositWarning: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u0437\u0430\u0441\u0442\u0430\u0432\u0443",
      worksheetCreated: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      worksheetReady: "\u0420\u043E\u0431\u043E\u0447\u0438\u0439 \u043B\u0438\u0441\u0442 \u0433\u043E\u0442\u043E\u0432\u0438\u0439",
      quoteSent: "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u044E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
      welcomePartner: "\u0412\u0456\u0442\u0430\u043B\u044C\u043D\u0438\u0439 \u043B\u0438\u0441\u0442",
      paymentReceived: "\u041E\u043F\u043B\u0430\u0442\u0443 \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E"
    },
    selectPartners: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0456\u0432",
    bulkResult: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043A\u0438",
    queued: "\u0412 \u0447\u0435\u0440\u0437\u0456",
    skipped: "\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E",
    failedCount: "\u041D\u0435\u0432\u0434\u0430\u043B\u043E",
    scheduled: {
      title: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0456 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0438",
      sectionAriaLabel: "\u0421\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0438\u0445 bulk-email \u043F\u0430\u043A\u0435\u0442\u0456\u0432",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
      empty: "\u0417\u0430\u0440\u0430\u0437 \u043D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0438\u0445 \u0440\u043E\u0437\u0441\u0438\u043B\u043E\u043A.",
      error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u043F\u0438\u0441\u043A\u0443: {message}",
      skippedSuffix: "{count} \u043F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E",
      cancelButton: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      cancelling: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u043D\u043D\u044F...",
      col: {
        template: "\u0428\u0430\u0431\u043B\u043E\u043D",
        scheduledAt: "\u041A\u043E\u043B\u0438",
        recipients: "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456",
        status: "\u0421\u0442\u0430\u0442\u0443\u0441",
        legalBasis: "GDPR \u043F\u0456\u0434\u0441\u0442\u0430\u0432\u0430",
        actions: "\u0414\u0456\u0457"
      },
      cancelModal: {
        title: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0443 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0443",
        description: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0443 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 {templateSlug} \u0434\u043B\u044F {count} \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456\u0432? \u0426\u0435 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438, \u0430\u043B\u0435 \u043C\u043E\u0436\u043D\u0430 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443 \u0432\u0440\u0443\u0447\u043D\u0443.",
        confirmButton: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        dismissButton: "\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438"
      },
      cancelToast: {
        success: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0443 \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0443 \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E.",
        alreadyCancelled: "\u0426\u044E \u0440\u043E\u0437\u0441\u0438\u043B\u043A\u0443 \u0432\u0436\u0435 \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E \u0440\u0430\u043D\u0456\u0448\u0435.",
        notCancellable: "\u0420\u043E\u0437\u0441\u0438\u043B\u043A\u0430 \u0443 \u0441\u0442\u0430\u043D\u0456 {status} \u2014 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438.",
        race: "\u0420\u043E\u0437\u0441\u0438\u043B\u043A\u0430 \u0449\u043E\u0439\u043D\u043E \u043F\u043E\u0447\u0430\u043B\u0430\u0441\u044F \u2014 \u0432\u0436\u0435 \u043F\u0456\u0437\u043D\u043E \u0441\u043A\u0430\u0441\u043E\u0432\u0443\u0432\u0430\u0442\u0438.",
        notFound: "\u0420\u043E\u0437\u0441\u0438\u043B\u043A\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
        error: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043D\u043D\u044F."
      }
    }
  },
  documents: {
    panel: {
      title: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
      uploadButton: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
      downloadButton: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
      deleteButton: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
      deleteConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442?",
      deleteConfirmButton: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F",
      deleteCancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      uploadSuccess: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E.",
      deleteSuccess: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E.",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432\u2026",
      empty: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u0438\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u0438\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432.",
      retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438"
    },
    errors: {
      loadFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438.",
      uploadFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F: {message}",
      downloadFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F: {message}",
      deleteFailed: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F: {message}"
    },
    audit: {
      backToAdmin: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0430\u0434\u043C\u0456\u043D\u0430",
      title: "\u0416\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0443 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
      subtitle: "\u0416\u0443\u0440\u043D\u0430\u043B \u043E\u043F\u0435\u0440\u0430\u0446\u0456\u0439 \u0434\u043B\u044F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E\u0441\u0442\u0456 GDPR \u0441\u0442. 30.",
      filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
      filterAction: "\u0414\u0456\u044F",
      filterDocumentId: "ID \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430",
      invalidUuid: "\u041D\u0435\u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 UUID",
      allActions: "\u0423\u0441\u0456 \u0434\u0456\u0457",
      pageSize: "\u0420\u044F\u0434\u043A\u0456\u0432 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
      clearFilters: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
      refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
      exportCsv: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV",
      exportSuccess: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV \u0433\u043E\u0442\u043E\u0432\u0438\u0439.",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0436\u0443\u0440\u043D\u0430\u043B\u0443 \u0430\u0443\u0434\u0438\u0442\u0443\u2026",
      loadError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0436\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0443.",
      retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
      empty: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0441\u0456\u0432, \u0449\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C.",
      previousPage: "\u041D\u0430\u0437\u0430\u0434",
      nextPage: "\u0414\u0430\u043B\u0456",
      pageInfo: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 {page} \u0437 {totalPages} \xB7 \u0432\u0441\u044C\u043E\u0433\u043E {total} \u0437\u0430\u043F\u0438\u0441\u0456\u0432",
      col: {
        performedAt: "\u0427\u0430\u0441",
        action: "\u0414\u0456\u044F",
        documentId: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        performedBy: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
        ipAddress: "IP-\u0430\u0434\u0440\u0435\u0441\u0430",
        metadata: "\u041C\u0435\u0442\u0430\u0434\u0430\u043D\u0456"
      },
      action: {
        UPLOADED: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E",
        DOWNLOADED: "\u0421\u043A\u0430\u0447\u0430\u043D\u043E",
        VIEWED: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u043E",
        SHARED_VIA_LINK: "\u041F\u043E\u0448\u0438\u0440\u0435\u043D\u043E \u0437\u0430 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C",
        UPDATED: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
        DELETED: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        RESTORED: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
        HASH_VERIFIED: "\u0425\u0435\u0448 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
        HASH_MISMATCH: "\u041D\u0435\u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456\u0441\u0442\u044C \u0445\u0435\u0448\u0430",
        ORPHAN_DETECTED: "\u0412\u0438\u044F\u0432\u043B\u0435\u043D\u043E \u0441\u0438\u0440\u0456\u0442\u0441\u044C\u043A\u0438\u0439"
      }
    }
  },
  esign: {
    error: {
      sessionNotFound: "\u0421\u0435\u0430\u043D\u0441 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
      sessionExpired: "\u0422\u0435\u0440\u043C\u0456\u043D \u0434\u0456\u0457 \u0441\u0435\u0430\u043D\u0441\u0443 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F.",
      alreadySigned: "\u0421\u0435\u0430\u043D\u0441 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u0432\u0436\u0435 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043E.",
      invalidProvider: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A \u043F\u0456\u0434\u043F\u0438\u0441\u0456\u0432.",
      consentNotGiven: "\u0417\u0433\u043E\u0434\u0443 \u043D\u0435 \u043D\u0430\u0434\u0430\u043D\u043E.",
      hashMismatch: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0445\u0435\u0448\u0430 \u043F\u0456\u0434\u043F\u0438\u0441\u0443 \u043D\u0435 \u0432\u0434\u0430\u043B\u0430\u0441\u044F \u2014 \u0432\u043C\u0456\u0441\u0442 \u043C\u0456\u0433 \u0431\u0443\u0442\u0438 \u0437\u043C\u0456\u043D\u0435\u043D\u0438\u0439.",
      tenantMismatch: "\u0421\u0435\u0430\u043D\u0441 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
      internalError: "\u0412\u043D\u0443\u0442\u0440\u0456\u0448\u043D\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0456\u0434 \u0447\u0430\u0441 \u043E\u0431\u0440\u043E\u0431\u043A\u0438 \u043F\u0456\u0434\u043F\u0438\u0441\u0443.",
      missingConsentBasic: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u044F \u0431\u0430\u0437\u043E\u0432\u0430 \u0437\u0433\u043E\u0434\u0430.",
      missingConsentDataProcessing: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u044F \u0437\u0433\u043E\u0434\u0430 \u043D\u0430 \u043E\u0431\u0440\u043E\u0431\u043A\u0443 \u0434\u0430\u043D\u0438\u0445."
    },
    warning: {
      aesRequired: "\u0414\u043B\u044F \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0456\u0432 \u043F\u043E\u043D\u0430\u0434 500 000 HUF \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0454\u0442\u044C\u0441\u044F \u043A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u043E\u0432\u0430\u043D\u0438\u0439 (AES) \u043F\u0456\u0434\u043F\u0438\u0441 \u2014 \u043F\u0440\u043E\u0441\u0442\u0456 (SES) \u043F\u0456\u0434\u043F\u0438\u0441\u0438 \u0437\u0430\u043B\u0438\u0448\u0430\u044E\u0442\u044C\u0441\u044F \u043F\u0440\u0438\u0439\u043D\u044F\u0442\u043D\u0438\u043C\u0438 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C Sprint 2.",
      sessionExpiresSoon: "\u0422\u0435\u0440\u043C\u0456\u043D \u0434\u0456\u0457 \u0441\u0435\u0430\u043D\u0441\u0443 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F \u043D\u0435\u0437\u0430\u0431\u0430\u0440\u043E\u043C \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0442\u044C\u0441\u044F."
    },
    verify: {
      passed: "\u041F\u0456\u0434\u043F\u0438\u0441 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E.",
      hashChainBroken: "\u0426\u0456\u043B\u0456\u0441\u043D\u0456\u0441\u0442\u044C \u043B\u0430\u043D\u0446\u044E\u0433\u0430 \u043F\u0456\u0434\u043F\u0438\u0441\u0456\u0432 \u043F\u043E\u0440\u0443\u0448\u0435\u043D\u0430.",
      evidenceHashMismatch: "\u0425\u0435\u0448 \u0434\u043E\u043A\u0430\u0437\u0456\u0432 \u043D\u0435 \u0437\u0431\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0456 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\u043C.",
      sessionTerminal: "\u0421\u0435\u0430\u043D\u0441 \u0437\u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u0432 \u043A\u0456\u043D\u0446\u0435\u0432\u043E\u043C\u0443 \u0441\u0442\u0430\u043D\u0456 (\u043C\u0438\u043D\u0443\u0432 \u0441\u0442\u0440\u043E\u043A \u0430\u0431\u043E \u0432\u0456\u0434\u043A\u043B\u0438\u043A\u0430\u043D\u043E)."
    },
    action: {
      createSession: "\u041F\u043E\u0447\u0430\u0442\u0438 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F",
      sign: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438",
      verify: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438",
      viewAudit: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0436\u0443\u0440\u043D\u0430\u043B \u0430\u0443\u0434\u0438\u0442\u0443"
    },
    consent: {
      basicLabel: "\u042F \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0432 \u0456 \u043F\u0440\u0438\u0439\u043C\u0430\u044E \u0443\u043C\u043E\u0432\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443.",
      dataProcessingLabel: "\u042F \u043F\u043E\u0433\u043E\u0434\u0436\u0443\u044E\u0441\u044F \u043D\u0430 \u043E\u0431\u0440\u043E\u0431\u043A\u0443 \u043C\u043E\u0457\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0446\u0456\u043B\u0435\u0439 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F."
    },
    dialog: {
      title: "\u041F\u0456\u0434\u043F\u0438\u0441\u0430\u0442\u0438 \u0434\u043E\u0433\u043E\u0432\u0456\u0440",
      success: "\u0414\u043E\u0433\u043E\u0432\u0456\u0440 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043E.",
      sessionLoading: "\u041F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0441\u0435\u0441\u0456\u0457 \u043F\u0456\u0434\u043F\u0438\u0441\u0430\u043D\u043D\u044F\u2026",
      padHint: "\u041F\u0456\u0434\u043F\u0438\u0448\u0456\u0442\u044C \u043F\u0430\u043B\u044C\u0446\u0435\u043C \u0430\u0431\u043E \u0441\u0442\u0438\u043B\u0443\u0441\u043E\u043C \u0443 \u043F\u043E\u043B\u0456",
      payloadTooLarge: "\u041F\u0456\u0434\u043F\u0438\u0441 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0435\u043B\u0438\u043A\u0438\u0439 (\u043C\u0430\u043A\u0441. 512 \u041A\u0456\u0411). \u041E\u0447\u0438\u0441\u0442\u0456\u0442\u044C \u0456 \u043F\u0456\u0434\u043F\u0438\u0448\u0456\u0442\u044C \u0437\u043D\u043E\u0432\u0443.",
      consentRequired: "\u041E\u0431\u0438\u0434\u0432\u0456 \u0437\u0433\u043E\u0434\u0438 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456."
    }
  },
  hr: {
    employee: {
      title: "\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0438",
      create: "\u041D\u043E\u0432\u0438\u0439 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A",
      name: "\u0406\u043C'\u044F",
      email: "Email",
      tajNumber: "\u041D\u043E\u043C\u0435\u0440 \u0441\u043E\u0446\u0456\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u0443\u0432\u0430\u043D\u043D\u044F",
      taxId: "\u0406\u041F\u041D",
      bankAccount: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      grossSalary: "\u0417\u0430\u0440\u043F\u043B\u0430\u0442\u0430 \u0431\u0440\u0443\u0442\u0442\u043E",
      employmentType: "\u0422\u0438\u043F \u0437\u0430\u0439\u043D\u044F\u0442\u043E\u0441\u0442\u0456",
      salaryType: "\u0422\u0438\u043F \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u0438",
      weeklyHours: "\u0413\u043E\u0434\u0438\u043D \u043D\u0430 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
      contractStart: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
      contractEnd: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443",
      childrenCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0434\u0456\u0442\u0435\u0439",
      disabledChildrenCount: "\u0414\u0456\u0442\u0435\u0439 \u0437 \u0456\u043D\u0432\u0430\u043B\u0456\u0434\u043D\u0456\u0441\u0442\u044E",
      familyTaxCredit: "\u0421\u0456\u043C\u0435\u0439\u043D\u0430 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u043F\u0456\u043B\u044C\u0433\u0430",
      familyCreditChildCount: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043F\u0456\u043B\u044C\u0433\u043E\u0432\u0438\u0445 \u0434\u0456\u0442\u0435\u0439",
      isFirstMarriage: "\u041F\u0435\u0440\u0448\u0438\u0439 \u0448\u043B\u044E\u0431",
      userId: "ID \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
      basicInfo: "\u041E\u0441\u043D\u043E\u0432\u043D\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
      taxAndBankInfo: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0442\u0430 \u0431\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
      familyData: "\u0421\u0456\u043C\u0435\u0439\u043D\u0456 \u0434\u0430\u043D\u0456",
      noEmployees: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0456\u0432 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
      created: "\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
      updated: "\u0414\u0430\u043D\u0456 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
      saveError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
      employmentTypes: {
        fulltime: "\u041F\u043E\u0432\u043D\u0430 \u0437\u0430\u0439\u043D\u044F\u0442\u0456\u0441\u0442\u044C",
        parttime: "\u041D\u0435\u043F\u043E\u0432\u043D\u0430 \u0437\u0430\u0439\u043D\u044F\u0442\u0456\u0441\u0442\u044C",
        seasonal: "\u0421\u0435\u0437\u043E\u043D\u043D\u0430"
      },
      salaryTypes: {
        monthly: "\u0429\u043E\u043C\u0456\u0441\u044F\u0447\u043D\u0430",
        hourly: "\u041F\u043E\u0433\u043E\u0434\u0438\u043D\u043D\u0430"
      },
      panelBasic: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
      panelEmployment: "\u0417\u0430\u0439\u043D\u044F\u0442\u0456\u0441\u0442\u044C",
      panelPayroll: "\u0417\u0430\u0440\u043F\u043B\u0430\u0442\u0430",
      panelFamily: "\u0421\u0456\u043C'\u044F",
      panelInvalid: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0454 \u0430\u0431\u043E \u043D\u0435\u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0435 \u043F\u043E\u043B\u0435",
      validationError: "\u0417\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0443\u0441\u0456 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u043E\u043B\u044F",
      completionLabel: "{percent}% \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043E",
      missingLabel: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0454",
      miniCardAttendance: "\u0412\u0456\u0434\u0432\u0456\u0434\u0443\u0432\u0430\u043D\u0456\u0441\u0442\u044C {year}-{month}",
      miniCardLeaveBalance: "\u0412\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430 {year}",
      miniCardRecentRecords: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u0432\u0456\u0434\u0443\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
      noAttendanceData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u043E \u0432\u0456\u0434\u0432\u0456\u0434\u0443\u0432\u0430\u043D\u0456\u0441\u0442\u044C \u0446\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F",
      noLeaveBalance: "\u0411\u0430\u043B\u0430\u043D\u0441 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0438 \u043D\u0435 \u0456\u043D\u0456\u0446\u0456\u0430\u043B\u0456\u0437\u043E\u0432\u0430\u043D\u043E",
      noRecentRecords: "\u041D\u0435\u043C\u0430\u0454 \u043E\u0441\u0442\u0430\u043D\u043D\u044C\u043E\u0457 \u0432\u0456\u0434\u0432\u0456\u0434\u0443\u0432\u0430\u043D\u043E\u0441\u0442\u0456",
      missingDays: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
      viewFullAttendance: "\u041F\u043E\u0432\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
      viewLeaveHistory: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043E\u043A"
    },
    attendance: {
      title: "\u0412\u0456\u0434\u0432\u0456\u0434\u0443\u0432\u0430\u043D\u0456\u0441\u0442\u044C",
      clockIn: "\u0412\u0456\u0434\u043C\u0456\u0442\u0438\u0442\u0438 \u043F\u0440\u0438\u0445\u0456\u0434",
      clockOut: "\u0412\u0456\u0434\u043C\u0456\u0442\u0438\u0442\u0438 \u0432\u0456\u0434\u0445\u0456\u0434",
      currentlyClockedIn: "\u0412\u0438 \u0443\u0432\u0456\u0439\u0448\u043B\u0438",
      currentlyClockedOut: "\u0412\u0438 \u0432\u0438\u0439\u0448\u043B\u0438",
      monthlyView: "\u041C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434",
      workedDays: "\u0412\u0456\u0434\u043F\u0440\u0430\u0446\u044C\u043E\u0432\u0430\u043D\u0456 \u0434\u043D\u0456",
      overtimeHours: "\u041F\u043E\u043D\u0430\u0434\u043D\u043E\u0440\u043C\u043E\u0432\u0456",
      clockedInSuccess: "\u041F\u0440\u0438\u0445\u0456\u0434 \u0432\u0456\u0434\u043C\u0456\u0447\u0435\u043D\u043E",
      clockedOutSuccess: "\u0412\u0456\u0434\u0445\u0456\u0434 \u0432\u0456\u0434\u043C\u0456\u0447\u0435\u043D\u043E",
      clockInError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0456\u0434\u043C\u0456\u0442\u043A\u0438 \u043F\u0440\u0438\u0445\u043E\u0434\u0443",
      clockOutError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0456\u0434\u043C\u0456\u0442\u043A\u0438 \u0432\u0456\u0434\u0445\u043E\u0434\u0443",
      overtimeActive: "\u041F\u043E\u043D\u0430\u0434\u043D\u043E\u0440\u043C\u043E\u0432\u0430 \u0440\u043E\u0431\u043E\u0442\u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u0430",
      forgottenClockOut: "\u0417\u0430\u0431\u0443\u0442\u0438\u0439 \u0432\u0438\u0445\u0456\u0434",
      forgottenClockOutBanner: "\u0421\u0445\u043E\u0436\u0435 \u0432\u0438 \u0437\u0430\u0431\u0443\u043B\u0438 \u0432\u0438\u0439\u0442\u0438 \u0432\u0447\u043E\u0440\u0430.",
      forgottenClockOutHint: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430 \u0432\u0438\u0439\u0434\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u043E\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430 \u043F\u0440\u043E \u043A\u043E\u0440\u0435\u043A\u0446\u0456\u044E.",
      startedAt: "\u0412\u0445\u0456\u0434",
      endedAt: "\u0412\u0438\u0445\u0456\u0434",
      todayWorkedLabel: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
      weeklyProgress: "\u0422\u0438\u0436\u043D\u0435\u0432\u0456 \u0433\u043E\u0434\u0438\u043D\u0438",
      filterEmployee: "\u0417\u0430 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u043E\u043C",
      allEmployees: "\u0423\u0441\u0456 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0438",
      hideWeekend: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u0432\u0438\u0445\u0456\u0434\u043D\u0456",
      hideHoliday: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u0441\u0432\u044F\u0442\u043E",
      exportCsv: "CSV \u0435\u043A\u0441\u043F\u043E\u0440\u0442",
      summaryLabel: "\u0423\u0441\u044C\u043E\u0433\u043E",
      summaryWorkedDays: "{count} \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432",
      summaryOvertime: "{duration} \u043F\u043E\u043D\u0430\u0434\u043D\u043E\u0440\u043C\u043E\u0432\u0438\u0445",
      summaryHolidays: "{count} \u0441\u0432\u044F\u0442",
      summaryMissing: "{count} \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
      noRecord: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0441\u0443",
      breakMinutesLabel: "\u041F\u0435\u0440\u0435\u0440\u0432\u0430",
      overtimeLabel: "\u041F\u043E\u043D\u0430\u0434\u043D\u043E\u0440\u043C\u043E\u0432\u0456",
      holidayLabel: "\u0421\u0432\u044F\u0442\u043E",
      weekendLabel: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439",
      sourceLabel: "\u0414\u0436\u0435\u0440\u0435\u043B\u043E",
      noteLabel: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430"
    },
    leave: {
      title: "\u0412\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430",
      request: "\u041D\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442",
      myRequests: "\u041C\u043E\u0457 \u0437\u0430\u043F\u0438\u0442\u0438",
      type: "\u0422\u0438\u043F",
      startDate: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
      endDate: "\u0414\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
      reason: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
      reasonPlaceholder: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439 \u043A\u043E\u043C\u0435\u043D\u0442\u0430\u0440...",
      balance: "\u0417\u0430\u043B\u0438\u0448\u043E\u043A",
      remaining: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C",
      used: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043E",
      entitled: "\u041D\u0430\u043B\u0435\u0436\u0438\u0442\u044C",
      calendar: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440",
      approve: "\u0421\u0445\u0432\u0430\u043B\u0438\u0442\u0438",
      reject: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
      pending: "\u041D\u0430 \u0440\u043E\u0437\u0433\u043B\u044F\u0434\u0456",
      approved: "\u0421\u0445\u0432\u0430\u043B\u0435\u043D\u043E",
      rejected: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
      cancelled: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
      noRequests: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0442\u0456\u0432 \u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0443",
      workingDays: "\u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432",
      requestSubmitted: "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0443 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
      requestError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0442\u0443",
      missingFields: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0432\u0441\u0456 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u043E\u043B\u044F",
      invalidDateRange: "\u0414\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0440\u0430\u043D\u0456\u0448\u0435 \u0434\u0430\u0442\u0438 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
      selectType: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F",
      types: {
        annual: "\u0429\u043E\u0440\u0456\u0447\u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430",
        sickSelf: "\u041B\u0456\u043A\u0430\u0440\u043D\u044F\u043D\u0438\u0439 (\u0432\u043B\u0430\u0441\u043D\u0438\u0439)",
        sickChild: "\u041B\u0456\u043A\u0430\u0440\u043D\u044F\u043D\u0438\u0439 (\u0434\u0438\u0442\u0438\u043D\u0430)",
        unpaid: "\u0412\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430 \u0431\u0435\u0437 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u0438",
        maternity: "\u0414\u0435\u043A\u0440\u0435\u0442\u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430",
        paternity: "\u0412\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430 \u0434\u043B\u044F \u0431\u0430\u0442\u044C\u043A\u0430",
        bereavement: "\u0412\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430 \u0443 \u0437\u0432'\u044F\u0437\u043A\u0443 \u0437 \u0442\u044F\u0436\u043A\u043E\u044E \u0432\u0442\u0440\u0430\u0442\u043E\u044E",
        bloodDonation: "\u0412\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430 \u0434\u043E\u043D\u043E\u0440\u0430"
      },
      datePreset: "\u0428\u0432\u0438\u0434\u043A\u0430 \u0434\u0430\u0442\u0430",
      workingDaysPreview: "{count} \u0440\u043E\u0431\u043E\u0447\u0438\u0445 \u0434\u043D\u0456\u0432 (\u0432\u0438\u0445\u0456\u0434\u043D\u0456 \u0432\u0438\u043A\u043B\u044E\u0447\u0435\u043D\u043E)",
      quotaLabel: "\u0437\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C {remaining} / {entitled} \u0434\u043D\u0456\u0432",
      overlapError: "\u0412\u0438 \u0432\u0436\u0435 \u043C\u0430\u0454\u0442\u0435 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0443 \u043D\u0430 \u0446\u0435\u0439 \u043F\u0435\u0440\u0456\u043E\u0434",
      insufficientBalance: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043D\u044C\u043E \u0431\u0430\u043B\u0430\u043D\u0441\u0443 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0438 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0442\u0443",
      chip: {
        tomorrow: "\u0417\u0430\u0432\u0442\u0440\u0430",
        nextMonday: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043A\u0430",
        oneWeek: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u041F\u043D-\u041F\u0442",
        custom: "\u0421\u0432\u0456\u0439"
      },
      filterByType: "\u0417\u0430 \u0442\u0438\u043F\u043E\u043C",
      filterByEmployee: "\u0417\u0430 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u043E\u043C",
      allTypes: "\u0423\u0441\u0456 \u0442\u0438\u043F\u0438",
      allEmployees: "\u0423\u0441\u0456 \u043F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0438",
      onlyPending: "\u041B\u0438\u0448\u0435 \u043E\u0447\u0456\u043A\u0443\u044E\u0447\u0456",
      conflictWarning: "\u041A\u043E\u043D\u0444\u043B\u0456\u043A\u0442 \u0434\u0432\u043E\u0445 \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u0438\u0445 \u0432\u0456\u0434\u043F\u0443\u0441\u0442\u043E\u043A",
      approveError: "\u0417\u0431\u0456\u0439 \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043D\u044F",
      rejectError: "\u0417\u0431\u0456\u0439 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F"
    },
    shift: {
      title: "\u0417\u043C\u0456\u043D\u0438",
      name: "\u041D\u0430\u0437\u0432\u0430",
      startTime: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
      endTime: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
      breakMinutes: "\u041F\u0435\u0440\u0435\u0440\u0432\u0430 (\u0445\u0432\u0438\u043B\u0438\u043D)",
      isNightShift: "\u041D\u0456\u0447\u043D\u0430 \u0437\u043C\u0456\u043D\u0430"
    }
  },
  payroll: {
    config: {
      title: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u0438",
      taxRates: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0441\u0442\u0430\u0432\u043A\u0438",
      shifts: "\u0428\u0430\u0431\u043B\u043E\u043D\u0438 \u0437\u043C\u0456\u043D",
      rate: "\u0421\u0442\u0430\u0432\u043A\u0430",
      description: "\u041E\u043F\u0438\u0441",
      validFrom: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0437",
      validTo: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0434\u043E",
      save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
      delete: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
      addNew: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0438\u0439",
      year: "\u0420\u0456\u043A",
      deleteConfirm: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u044E \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u0441\u0442\u0430\u0432\u043A\u0443?",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F.",
      noRatesForYear: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0445 \u0441\u0442\u0430\u0432\u043E\u043A \u043D\u0430 \u0446\u0435\u0439 \u0440\u0456\u043A. \u0417\u0430\u043F\u0443\u0441\u0442\u0456\u0442\u044C seed \u043D\u0430 \u0435\u043D\u0434\u043F\u043E\u0456\u043D\u0442\u0456 /api/v1/payroll/seed.",
      taxType: "\u0422\u0438\u043F \u043F\u043E\u0434\u0430\u0442\u043A\u0443",
      month: "\u041C\u0456\u0441\u044F\u0446\u044C",
      subtitle: "\u041A\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u043C\u0438 \u0441\u0442\u0430\u0432\u043A\u0430\u043C\u0438 \u0442\u0430 \u0437\u043C\u0456\u043D\u0430\u043C\u0438",
      saveError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u0441\u0442\u0430\u0432\u043A\u0443.",
      deleteError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0443 \u0441\u0442\u0430\u0432\u043A\u0443."
    },
    runs: {
      title: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0438 \u0437\u0430\u0440\u043E\u0431\u0456\u0442\u043D\u043E\u0457 \u043F\u043B\u0430\u0442\u0438",
      detail: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      newRun: "\u041D\u043E\u0432\u0438\u0439 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      period: "\u041F\u0435\u0440\u0456\u043E\u0434",
      status: "\u0421\u0442\u0430\u0442\u0443\u0441",
      employeeCount: "\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0438",
      totalGross: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u0431\u0440\u0443\u0442\u0442\u043E",
      totalNet: "\u0417\u0430\u0433\u0430\u043B\u044C\u043D\u0438\u0439 \u043D\u0435\u0442\u0442\u043E",
      totalEmployerCost: "\u0412\u0438\u0442\u0440\u0430\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u043E\u0434\u0430\u0432\u0446\u044F"
    },
    status: {
      DRAFT: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      CALCULATED: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
      BOLT_APPROVED: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u043C",
      CENTRAL_REVIEWED: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E \u0446\u0435\u043D\u0442\u0440\u043E\u043C",
      FINALIZED: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E"
    },
    steps: {
      draft: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      calculated: "\u0420\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043E",
      boltApproved: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u043C",
      centralReviewed: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0446\u0435\u043D\u0442\u0440\u043E\u043C",
      finalized: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E"
    },
    actions: {
      calculate: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u0432\u0430\u0442\u0438",
      boltApprove: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u043C",
      centralReview: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0446\u0435\u043D\u0442\u0440\u043E\u043C",
      finalize: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438",
      exportCsv: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 CSV",
      exportExcel: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 Excel",
      calculateError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u0437\u0430\u0440\u043E\u0431\u0456\u0442\u043D\u043E\u0457 \u043F\u043B\u0430\u0442\u0438.",
      approveError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438."
    },
    payslip: {
      myTitle: "\u041C\u043E\u0457 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u043E\u0432\u0456 \u043B\u0438\u0441\u0442\u043A\u0438",
      period: "\u041F\u0435\u0440\u0456\u043E\u0434",
      gross: "\u0411\u0440\u0443\u0442\u0442\u043E",
      net: "\u041D\u0435\u0442\u0442\u043E",
      downloadPdf: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 PDF",
      empty: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u043E\u0432\u0438\u0445 \u043B\u0438\u0441\u0442\u043A\u0456\u0432 \u0437\u0430 \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0440\u0456\u043A \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
      taxId: "\u041F\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
      tajNumber: "\u041D\u043E\u043C\u0435\u0440 \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0443",
      bankAccount: "\u0411\u0430\u043D\u043A\u0456\u0432\u0441\u044C\u043A\u0438\u0439 \u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      employmentType: "\u0422\u0438\u043F \u0437\u0430\u0439\u043D\u044F\u0442\u043E\u0441\u0442\u0456",
      weeklyHours: "\u0413\u043E\u0434\u0438\u043D \u043D\u0430 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
      grossSalary: "\u0411\u0430\u0437\u043E\u0432\u0438\u0439 \u0431\u0440\u0443\u0442\u0442\u043E-\u043E\u043A\u043B\u0430\u0434"
    },
    employmentTypes: {
      FULL_TIME: "\u041F\u043E\u0432\u043D\u0430 \u0437\u0430\u0439\u043D\u044F\u0442\u0456\u0441\u0442\u044C",
      PART_TIME: "\u0427\u0430\u0441\u0442\u043A\u043E\u0432\u0430 \u0437\u0430\u0439\u043D\u044F\u0442\u0456\u0441\u0442\u044C",
      SEASONAL: "\u0421\u0435\u0437\u043E\u043D\u043D\u0430"
    },
    items: {
      tableTitle: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443",
      employee: "\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A",
      workingDays: "\u0420\u043E\u0431\u043E\u0447\u0456 \u0434\u043D\u0456",
      workedDays: "\u0412\u0456\u0434\u043F\u0440\u0430\u0446\u044C\u043E\u0432\u0430\u043D\u043E",
      leaveDays: "\u0412\u0456\u0434\u043F\u0443\u0441\u0442\u043A\u0430",
      sickDays: "\u041B\u0456\u043A\u0430\u0440\u043D\u044F\u043D\u0456",
      overtimeHours: "\u041F\u043E\u043D\u0430\u0434\u043D\u043E\u0440\u043C\u043E\u0432\u0456 (\u0433\u043E\u0434)",
      baseSalary: "\u0411\u0430\u0437\u043E\u0432\u0438\u0439 \u043E\u043A\u043B\u0430\u0434",
      totalGross: "\u0411\u0440\u0443\u0442\u0442\u043E",
      totalNet: "\u041D\u0435\u0442\u0442\u043E",
      empty: "\u0423 \u0446\u044C\u043E\u043C\u0443 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u0437\u0438\u0446\u0456\u0439."
    },
    dashboard: {
      title: "\u041E\u0433\u043B\u044F\u0434 \u0440\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043A\u0443 \u0437\u0430\u0440\u043E\u0431\u0456\u0442\u043D\u043E\u0457 \u043F\u043B\u0430\u0442\u0438",
      latestGross: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u0431\u0440\u0443\u0442\u0442\u043E",
      latestNet: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u043D\u0435\u0442\u0442\u043E",
      employerCost: "\u0412\u0438\u0442\u0440\u0430\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u043E\u0434\u0430\u0432\u0446\u044F",
      employees: "\u041F\u0440\u0430\u0446\u0456\u0432\u043D\u0438\u043A\u0438",
      trend: "12-\u043C\u0456\u0441\u044F\u0447\u043D\u0438\u0439 \u0442\u0440\u0435\u043D\u0434",
      noData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0442\u0440\u0435\u043D\u0434\u0443"
    },
    shift: {
      editHint: "\u0417\u043C\u0456\u043D\u0438 \u0440\u0435\u0434\u0430\u0433\u0443\u044E\u0442\u044C\u0441\u044F \u0432 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u043C\u0443 \u0456\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0456 HR.",
      loadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D.",
      empty: "\u041D\u0435\u043C\u0430\u0454 \u0437\u043C\u0456\u043D.",
      nameHeader: "\u041D\u0430\u0437\u0432\u0430",
      startHeader: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
      endHeader: "\u041A\u0456\u043D\u0435\u0446\u044C",
      breakHeader: "\u041F\u0435\u0440\u0435\u0440\u0432\u0430 (\u0445\u0432)",
      night: "\u041D\u0456\u0447\u043D\u0430"
    }
  },
  camera: {
    title: "\u0417\u0439\u043E\u043C\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043A\u0430\u043C\u0435\u0440\u043E\u044E",
    description: "USB-\u0432\u0435\u0431\u043A\u0430\u043C\u0435\u0440\u0430 (Logitech C920) \u2014 \u043B\u0438\u0448\u0435 \u0434\u0435\u0441\u043A\u0442\u043E\u043F\u043D\u0456 Chrome / Firefox",
    stepFront: "\u0417\u0439\u043E\u043C\u043A\u0430 \u043B\u0438\u0446\u044C\u043E\u0432\u043E\u0433\u043E \u0431\u043E\u043A\u0443",
    stepBack: "\u0417\u0439\u043E\u043C\u043A\u0430 \u0437\u0432\u043E\u0440\u043E\u0442\u043D\u043E\u0433\u043E \u0431\u043E\u043A\u0443 (MRZ)",
    stepCounter: "{current}/{total}",
    permissionPrompt: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043D\u0430\u0434\u0430\u0439\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0443 \u0434\u043E\u0437\u0432\u0456\u043B \u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F \u043A\u0430\u043C\u0435\u0440\u0438.",
    permissionRequest: "\u0417\u0430\u043F\u0438\u0442 \u0434\u043E\u0437\u0432\u043E\u043B\u0443",
    permissionDenied: "\u0414\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043A\u0430\u043C\u0435\u0440\u0438 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0443\u0432\u0456\u043C\u043A\u043D\u0456\u0442\u044C \u0439\u043E\u0433\u043E \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0442\u0430 \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
    deviceNotFound: "\u041A\u0430\u043C\u0435\u0440\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C USB-\u0432\u0435\u0431\u043A\u0430\u043C\u0435\u0440\u0443 Logitech C920.",
    deviceGeneric: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043A\u0430\u043C\u0435\u0440\u0438. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435, \u0447\u0438 \u043D\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454 \u0457\u0457 \u0456\u043D\u0448\u0438\u0439 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043E\u043A.",
    captureFront: "\u0417\u0439\u043E\u043C\u043A\u0430 \u043B\u0438\u0446\u044C\u043E\u0432\u043E\u0433\u043E \u0431\u043E\u043A\u0443",
    captureBack: "\u0417\u0439\u043E\u043C\u043A\u0430 \u0437\u0432\u043E\u0440\u043E\u0442\u043D\u043E\u0433\u043E \u0431\u043E\u043A\u0443",
    retake: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
    next: "\u0414\u0430\u043B\u0456",
    useCaptures: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0442\u0438 \u0437\u043D\u0456\u043C\u043A\u0438",
    cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    thumbnailFront: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043B\u0438\u0446\u044C\u043E\u0432\u043E\u0433\u043E \u0431\u043E\u043A\u0443",
    thumbnailBack: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0437\u0432\u043E\u0440\u043E\u0442\u043D\u043E\u0433\u043E \u0431\u043E\u043A\u0443",
    instructionFront: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0439\u0442\u0435 \u043B\u0438\u0446\u044C\u043E\u0432\u0438\u0439 \u0431\u0456\u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 (\u0444\u043E\u0442\u043E) \u043F\u0435\u0440\u0435\u0434 \u043A\u0430\u043C\u0435\u0440\u043E\u044E \u0442\u0430 \u0437\u0440\u043E\u0431\u0456\u0442\u044C \u0437\u043D\u0456\u043C\u043E\u043A.",
    instructionBack: "\u041F\u0435\u0440\u0435\u0432\u0435\u0440\u043D\u0456\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u2014 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0432\u0438\u0434\u043D\u043E \u043C\u0430\u0448\u0438\u043D\u043E\u0437\u0447\u0438\u0442\u0443\u0432\u0430\u043D\u0443 \u0437\u043E\u043D\u0443 (MRZ) \u043D\u0430 \u0437\u0432\u043E\u0440\u043E\u0442\u043D\u043E\u043C\u0443 \u0431\u043E\u0446\u0456.",
    zeroRetentionHint: "\u041D\u0443\u043B\u044C\u043E\u0432\u0435 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u043D\u043D\u044F \u2014 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0456\u0441\u043D\u0443\u044E\u0442\u044C \u043B\u0438\u0448\u0435 \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0443 \u043E\u0431\u0440\u043E\u0431\u043A\u0438, \u043F\u0456\u0441\u043B\u044F \u0447\u043E\u0433\u043E \u043E\u0434\u0440\u0430\u0437\u0443 \u0432\u0438\u0434\u0430\u043B\u044F\u044E\u0442\u044C\u0441\u044F.",
    focusManual: "\u041F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454\u0442\u044C\u0441\u044F \u0440\u0443\u0447\u043D\u0435 \u0444\u043E\u043A\u0443\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
    focusAuto: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u0444\u043E\u043A\u0443\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
    starting: "\u0417\u0430\u043F\u0443\u0441\u043A \u043A\u0430\u043C\u0435\u0440\u0438..."
  },
  porter: {
    inbox: {
      title: "\u0412\u0445\u0456\u0434\u043D\u0456 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
      searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0443 \u0440\u043E\u0437\u043C\u043E\u0432\u0430\u0445...",
      filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
      statusLabel: "\u0421\u0442\u0430\u0442\u0443\u0441",
      channelLabel: "\u041A\u0430\u043D\u0430\u043B",
      assigneeLabel: "\u041F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
      loading: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F...",
      noSubject: "(\u0431\u0435\u0437 \u0442\u0435\u043C\u0438)",
      threadCount: "\u0412\u0445\u0456\u0434\u043D\u0456 ({count})",
      pollingHint: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0435 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043A\u043E\u0436\u043D\u0456 5 \u0441\u0435\u043A\u0443\u043D\u0434",
      filter: {
        status: {
          all: "\u0423\u0441\u0456 \u0441\u0442\u0430\u0442\u0443\u0441\u0438",
          OPEN: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0435",
          PENDING: "\u041E\u0447\u0456\u043A\u0443\u0454",
          RESOLVED: "\u0412\u0438\u0440\u0456\u0448\u0435\u043D\u043E",
          SNOOZED: "\u0412\u0456\u0434\u043A\u043B\u0430\u0434\u0435\u043D\u043E"
        },
        channel: {
          all: "\u0423\u0441\u0456 \u043A\u0430\u043D\u0430\u043B\u0438",
          EMAIL: "Email",
          WEBCHAT: "\u0412\u0435\u0431\u0447\u0430\u0442",
          CONTACT_FORM: "\u0424\u043E\u0440\u043C\u0430"
        },
        assignee: {
          all: "\u0423\u0441\u0456",
          me: "\u041C\u043E\u0457",
          unassigned: "\u041D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0456"
        }
      },
      empty: {
        title: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u044C",
        description: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0456\u0442\u044C Gmail-\u0430\u043A\u0430\u0443\u043D\u0442 \u0456 \u0432\u0456\u0434\u0436\u0435\u0442 \u0432\u0435\u0431\u0447\u0430\u0442\u0443 \u2014 \u043F\u0435\u0440\u0448\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u043D\u0430\u0434\u0456\u0439\u0434\u0435 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 2 \u0445\u0432\u0438\u043B\u0438\u043D.",
        ctaSetup: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 \u043A\u0430\u043D\u0430\u043B",
        ctaDemo: "\u0414\u0435\u043C\u043E-\u043E\u0433\u043B\u044F\u0434"
      },
      filteredEmpty: {
        title: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0431\u0456\u0433\u0456\u0432 \u0437\u0430 \u0446\u0438\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438",
        description: "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0441\u043B\u0430\u0431\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438."
      },
      error: {
        title: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        description: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043C\u0435\u0440\u0435\u0436\u0456 \u0430\u0431\u043E \u0441\u0435\u0440\u0432\u0435\u0440 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439. \u041F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443.",
        retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438"
      },
      previewHint: {
        title: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u043E\u0437\u043C\u043E\u0432\u0443",
        description: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043B\u0456\u0432\u043E\u0440\u0443\u0447, \u0449\u043E\u0431 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0440\u043E\u0437\u043C\u043E\u0432\u0443 \u0442\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0441\u0442\u0438."
      },
      relativeTime: {
        now: "\u0449\u043E\u0439\u043D\u043E",
        minutes: "{count} \u0445\u0432 \u0442\u043E\u043C\u0443",
        hours: "{count} \u0433\u043E\u0434 \u0442\u043E\u043C\u0443",
        days: "{count} \u0434\u043D \u0442\u043E\u043C\u0443"
      },
      sla: {
        OK: "\u0413\u0430\u0440\u0430\u0437\u0434",
        DUE_SOON: "\u0421\u043A\u043E\u0440\u043E",
        BREACHED: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u043E",
        ESCALATED: "\u0415\u0441\u043A\u0430\u043B\u044C\u043E\u0432\u0430\u043D\u043E"
      },
      unread: "\u041D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0435"
    },
    thread: {
      subject: "\u0422\u0435\u043C\u0430",
      back: "\u041D\u0430\u0437\u0430\u0434",
      inboxLink: "\u0412\u0445\u0456\u0434\u043D\u0456",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
      channel: {
        EMAIL: "Email",
        WEBCHAT: "\u0412\u0435\u0431\u0447\u0430\u0442",
        CONTACT_FORM: "\u0424\u043E\u0440\u043C\u0430"
      },
      status: {
        label: "\u0421\u0442\u0430\u0442\u0443\u0441",
        OPEN: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
        PENDING: "\u041E\u0447\u0456\u043A\u0443\u0454",
        RESOLVED: "\u0412\u0438\u0440\u0456\u0448\u0435\u043D\u043E",
        SNOOZED: "\u0412\u0456\u0434\u043A\u043B\u0430\u0434\u0435\u043D\u043E"
      },
      assignee: {
        label: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0439",
        unassigned: "\u041D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E"
      },
      partner: {
        label: "\u041A\u043B\u0456\u0454\u043D\u0442",
        unknown: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
        createCta: "+ \u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
        timeline: "\u0423\u0441\u0456 \u0440\u043E\u0437\u043C\u043E\u0432\u0438"
      },
      message: {
        pending: "\u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0442\u044C\u0441\u044F...",
        failed: "\u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
        expand: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
        attachmentUnavailable: "\u0412\u043A\u043B\u0430\u0434\u0435\u043D\u043D\u044F \u0437\u0430\u0441\u0442\u0430\u0440\u0456\u043B\u043E, \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F..."
      },
      composer: {
        placeholder: "\u041D\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C...",
        send: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        sending: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0442\u044C\u0441\u044F..."
      },
      error: {
        loadFail: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0440\u043E\u0437\u043C\u043E\u0432\u0443",
        retry: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443"
      }
    },
    settings: {
      channels: {
        title: "\u041A\u0430\u043D\u0430\u043B\u0438",
        subtitle: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0439\u0442\u0435, \u044F\u043A rPI Porter \u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0442\u0438\u043C\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u0432\u0456\u0434 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432.",
        copy: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
        copySuccess: "\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E!",
        notConfigured: {
          title: "\u041A\u0430\u043D\u0430\u043B\u0438 \u0449\u0435 \u043D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
          description: "\u0421\u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 Chatwoot. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430."
        },
        list: {
          title: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043A\u0430\u043D\u0430\u043B\u0438",
          EMAIL: {
            name: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
            description: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F Gmail IMAP/SMTP"
          },
          WEBCHAT: {
            name: "\u0412\u0456\u0434\u0436\u0435\u0442 \u0432\u0435\u0431-\u0447\u0430\u0442\u0443",
            description: "\u0412\u0441\u0442\u0430\u0432\u043D\u0438\u0439 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442 \u0434\u043B\u044F \u0432\u0430\u0448\u043E\u0433\u043E \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0443"
          },
          CONTACT_FORM: {
            name: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430 \u0444\u043E\u0440\u043C\u0430",
            description: "\u041F\u0443\u0431\u043B\u0456\u0447\u043D\u0430 \u0444\u043E\u0440\u043C\u0430 \u0456\u0437 \u0437\u0430\u0445\u0438\u0441\u0442\u043E\u043C hCaptcha"
          },
          configured: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
          notConfigured: "\u041D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
          setupCta: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0438"
        },
        webchat: {
          title: "\u0424\u0440\u0430\u0433\u043C\u0435\u043D\u0442 \u0432\u0441\u0442\u0430\u0432\u043A\u0438 \u0432\u0435\u0431-\u0447\u0430\u0442\u0443",
          description: "\u0412\u0441\u0442\u0430\u0432\u0442\u0435 \u0432 \u043A\u0456\u043D\u0446\u0456 <body> \u0432\u0430\u0448\u043E\u0433\u043E \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0443. \u0412\u0456\u0434\u0436\u0435\u0442 \u0437'\u044F\u0432\u0438\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E."
        },
        form: {
          title: "URL \u043F\u0443\u0431\u043B\u0456\u0447\u043D\u043E\u0457 \u0444\u043E\u0440\u043C\u0438",
          description: "\u041F\u043E\u0434\u0456\u043B\u0456\u0442\u044C\u0441\u044F \u0446\u0438\u043C URL \u043D\u0430 \u0432\u0430\u0448\u043E\u043C\u0443 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442\u0456 \u0430\u0431\u043E \u0432 \u043A\u0430\u043C\u043F\u0430\u043D\u0456\u044F\u0445."
        },
        error: {
          loadFail: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E \u043A\u0430\u043D\u0430\u043B\u0443",
          retry: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443"
        }
      },
      webchat: {
        form: {
          replyTimeOptions: {
            in_a_few_minutes: "\u041F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u043A\u0456\u043B\u044C\u043A\u043E\u0445 \u0445\u0432\u0438\u043B\u0438\u043D",
            in_a_few_hours: "\u041F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u043A\u0456\u043B\u044C\u043A\u043E\u0445 \u0433\u043E\u0434\u0438\u043D",
            in_a_day: "\u041F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u0434\u043D\u044F"
          }
        }
      },
      autoReply: {
        title: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0430\u0432\u0442\u043E\u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        subtitle: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0439\u0442\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0456 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u043F\u0440\u0438 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u0456 \u043F\u0435\u0432\u043D\u0438\u0445 \u0443\u043C\u043E\u0432.",
        addRule: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u043E",
        editRule: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u043E",
        deleteRule: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        confirmDelete: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u043E?",
        noRules: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u0430\u0432\u0442\u043E\u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0456.",
        active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
        inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
        trigger: {
          label: "\u0422\u0440\u0438\u0433\u0435\u0440",
          NEW_CONVERSATION: "\u041D\u043E\u0432\u0430 \u0440\u043E\u0437\u043C\u043E\u0432\u0430",
          OFF_HOURS: "\u041F\u043E\u0437\u0430\u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u0447\u0430\u0441",
          KEYWORD: "\u041A\u043B\u044E\u0447\u043E\u0432\u0435 \u0441\u043B\u043E\u0432\u043E",
          NO_RESPONSE_TIMER: "\u0422\u0430\u0439\u043C\u0435\u0440 \u0431\u0435\u0437 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
          CHANNEL_SPECIFIC: "\u0421\u043F\u0435\u0446\u0438\u0444\u0456\u0447\u043D\u0438\u0439 \u043A\u0430\u043D\u0430\u043B"
        },
        form: {
          name: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0440\u0430\u0432\u0438\u043B\u0430",
          namePlaceholder: "\u043D\u0430\u043F\u0440. \u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u043F\u043E\u0437\u0430 \u0440\u043E\u0431\u043E\u0447\u0438\u043C \u0447\u0430\u0441\u043E\u043C",
          templateId: "ID \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
          templateIdPlaceholder: "ID email-\u0448\u0430\u0431\u043B\u043E\u043D\u0443 E-93",
          conditionJson: "\u0423\u043C\u043E\u0432\u0430 (JSON)",
          save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
          cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
        },
        save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
      }
    },
    timeline: {
      title: "\u0412\u0441\u0456 \u0440\u043E\u0437\u043C\u043E\u0432\u0438",
      subtitle: "\u0423\u0441\u0456 \u0442\u0435\u043C\u0438 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0432 \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0456\u0447\u043D\u043E\u043C\u0443 \u043F\u043E\u0440\u044F\u0434\u043A\u0443.",
      empty: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0445 \u0440\u043E\u0437\u043C\u043E\u0432 \u0456\u0437 \u0446\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u043C.",
      lastMessage: "\u041E\u0441\u0442\u0430\u043D\u043D\u0454 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
      noMessages: "\u041D\u0435\u043C\u0430\u0454 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u044C",
      openThread: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
      loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
      error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0440\u043E\u0437\u043C\u043E\u0432\u0438."
    }
  },
  authGrant: {
    type: {
      permanent: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0435",
      oneTime: "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0435"
    },
    badge: {
      permanentActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u0435",
      oneTimeUntilRental: "\u0414\u043E \u043E\u0440\u0435\u043D\u0434\u0438"
    },
    card: {
      revoke: "\u0412\u0456\u0434\u043A\u043B\u0438\u043A\u0430\u0442\u0438",
      validFrom: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
      validUntil: "\u041A\u0456\u043D\u0435\u0446\u044C",
      valueLimit: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456",
      rental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      revokedReason: "\u0412\u0456\u0434\u043A\u043B\u0438\u043A\u0430\u043D\u043E"
    },
    tab: {
      title: "\u0414\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
      subtitle: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0456 \u0442\u0430 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0456 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430",
      createButton: "\u041D\u043E\u0432\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
      givenTitle: "\u0412\u0438\u0434\u0430\u043D\u0456 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
      givenEmpty: "\u0426\u0435\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440 \u0449\u0435 \u043D\u0435 \u0432\u0438\u0434\u0430\u0432 \u0436\u043E\u0434\u043D\u043E\u0433\u043E \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F.",
      receivedTitle: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u0456 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
      receivedEmpty: "\u0426\u0435\u0439 \u043F\u0430\u0440\u0442\u043D\u0435\u0440 \u0449\u0435 \u043D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u0432 \u0436\u043E\u0434\u043D\u043E\u0433\u043E \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F.",
      archivedToggle: "{count} \u0430\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u0438\u0445 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u044C"
    },
    chooser: {
      title: "\u0422\u0438\u043F \u043D\u043E\u0432\u043E\u0433\u043E \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
      subtitle: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F.",
      permanentLabel: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
      permanentDesc: "\u0414\u043E\u0432\u0433\u043E\u0441\u0442\u0440\u043E\u043A\u043E\u0432\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F \u043C\u0456\u0436 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C\u0438 (\u043D\u0430\u043F\u0440., \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A).",
      oneTimeLabel: "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
      oneTimeDesc: "\u041F\u0440\u0438\u0432'\u044F\u0437\u0430\u043D\u0435 \u0434\u043E \u043E\u0440\u0435\u043D\u0434\u0438, \u0456\u0437 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 (\u043D\u0430\u043F\u0440., \u0432\u043E\u0434\u0456\u0439)."
    },
    dialog: {
      permanent: {
        title: "\u041F\u043E\u0441\u0442\u0456\u0439\u043D\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
        granteeLabel: "UUID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430-\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0430",
        granteeHint: "UUID \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 (\u0443 \u043C\u0430\u0439\u0431\u0443\u0442\u043D\u044C\u043E\u043C\u0443 \u0437\u0430\u043C\u0456\u043D\u0435\u043D\u043E \u043D\u0430 \u0430\u0432\u0442\u043E\u0434\u043E\u043F\u043E\u0432\u043D\u0435\u043D\u043D\u044F)",
        validFromLabel: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
        validUntilLabel: "\u041A\u0456\u043D\u0435\u0446\u044C (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
        valueLimitLabel: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456 (HUF, \u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
        submit: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
        validationGranteeRequired: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440-\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
        validationGranteeUuid: "\u041F\u0430\u0440\u0442\u043D\u0435\u0440-\u043E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0434\u0456\u0439\u0441\u043D\u0438\u043C UUID",
        validationValidFromRequired: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
        validationValidUntilAfter: "\u0414\u0430\u0442\u0430 \u0437\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043F\u0456\u0441\u043B\u044F \u0434\u0430\u0442\u0438 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
        validationValueLimit: "\u041B\u0456\u043C\u0456\u0442 \u0432\u0430\u0440\u0442\u043E\u0441\u0442\u0456 \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043D\u0438\u043C \u0446\u0456\u043B\u0438\u043C \u0447\u0438\u0441\u043B\u043E\u043C (\u043F\u0443\u0441\u0442\u043E = \u0431\u0435\u0437 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u044C)",
        validationValidFromPast: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0432 \u043C\u0438\u043D\u0443\u043B\u043E\u043C\u0443"
      }
    }
  },
  equipment: {
    types: {
      categories: {
        SMALL_ENGINE: "\u041C\u0430\u043B\u0438\u0439 \u0434\u0432\u0438\u0433\u0443\u043D",
        LAWN_EQUIPMENT: "\u0421\u0430\u0434\u043E\u0432\u0430 \u0442\u0435\u0445\u043D\u0456\u043A\u0430",
        POWER_TOOL: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442",
        OTHER: "\u0406\u043D\u0448\u0435"
      },
      list: {
        title: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u0442\u0438\u043F\u0456\u0432 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F",
        subtitle: "Equipment Type \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u2014 \u0442\u0438\u043F + SKU + \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F + \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        newCta: "\u041D\u043E\u0432\u0438\u0439 \u0442\u0438\u043F",
        searchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E / SKU / \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u043C SKU\u2026",
        allCategories: "\u0423\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        activeOnly: "\u041B\u0438\u0448\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0456",
        loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u0438\u043F\u0456\u0432\u2026",
        empty: {
          title: "\u0422\u0438\u043F\u0456\u0432 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454",
          desc: "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u043F\u0435\u0440\u0448\u0438\u0439 \u0442\u0438\u043F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0434\u043B\u044F \u043E\u043D\u043B\u0430\u0439\u043D-\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443 + \u043E\u0440\u0435\u043D\u0434\u0438/\u0441\u0435\u0440\u0432\u0456\u0441\u0443/\u043F\u0440\u043E\u0434\u0430\u0436\u0443."
        },
        col: {
          name: "\u041D\u0430\u0437\u0432\u0430",
          sku: "SKU",
          category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
          brand: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A / \u043C\u043E\u0434\u0435\u043B\u044C",
          status: "\u0421\u0442\u0430\u0442\u0443\u0441",
          actions: "\u0414\u0456\u0457"
        },
        active: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
        inactive: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
        actionEdit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438"
      },
      editor: {
        title: {
          new: "\u041D\u043E\u0432\u0438\u0439 \u0442\u0438\u043F",
          edit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0442\u0438\u043F"
        },
        subtitle: "\u0417\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u043E\u0441\u043D\u043E\u0432\u043D\u0456 \u043F\u043E\u043B\u044F. \u0421\u043F\u0435\u0446\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0457 + \u043E\u0434\u0438\u043D\u0438\u0446\u0456 + \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0443 \u0444\u0430\u0437\u0456 2 (Sprint 18+).",
        loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0442\u0438\u043F\u0443\u2026",
        backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443",
        submitting: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F\u2026",
        save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        create: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
        field: {
          name: "\u041D\u0430\u0437\u0432\u0430",
          namePlaceholder: "\u043D\u0430\u043F\u0440. Honda GX160 \u0431\u0435\u043D\u0437\u0438\u043D\u043E\u0432\u0438\u0439 \u0434\u0432\u0438\u0433\u0443\u043D",
          sku: "SKU (\u043A\u0430\u0442\u0430\u043B\u043E\u0436\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440)",
          skuPlaceholder: "\u043D\u0430\u043F\u0440. KGC-HONDA-GX160",
          manufacturerSku: "SKU \u0432\u0438\u0440\u043E\u0431\u043D\u0438\u043A\u0430",
          alternativeSkus: "\u0410\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u0456 SKU",
          alternativeSkusPlaceholder: "\u0447\u0435\u0440\u0435\u0437 \u043A\u043E\u043C\u0443",
          alternativeSkusHint: "\u0414\u043B\u044F \u043C\u0430\u0441\u043E\u0432\u043E\u0433\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443 + N6 \u043F\u0435\u0440\u0435\u0445\u0440\u0435\u0441\u043D\u0438\u0445 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u044C. \u041F\u0440\u0438\u043A\u043B\u0430\u0434: HONDA-180-OLD, MS180-16",
          category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
          brand: "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u043A",
          model: "\u041C\u043E\u0434\u0435\u043B\u044C",
          description: "\u041E\u043F\u0438\u0441",
          heroImageUrl: "URL \u0433\u043E\u043B\u043E\u0432\u043D\u043E\u0433\u043E \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
          galleryImages: "URL \u0433\u0430\u043B\u0435\u0440\u0435\u0457",
          galleryImagesPlaceholder: "https://...\nhttps://...",
          galleryImagesHint: "\u041E\u0434\u0438\u043D URL \u0443 \u0440\u044F\u0434\u043A\u0443. \u0424\u0430\u0437\u0430 2 (ADR-123 Am.2) \u0437\u0430\u043C\u0456\u043D\u0438\u0442\u044C \u0434\u043E\u0447\u0456\u0440\u043D\u044C\u043E\u044E \u0442\u0430\u0431\u043B\u0438\u0446\u0435\u044E EquipmentTypeImage.",
          isActive: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
          isActiveHint: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0442\u0438\u043F\u0438 \u043F\u0440\u0438\u0445\u043E\u0432\u0430\u043D\u0456 \u0432\u0456\u0434 \u043E\u0440\u0435\u043D\u0434\u0438 / \u0441\u0435\u0440\u0432\u0456\u0441\u0443 / \u043F\u0440\u043E\u0434\u0430\u0436\u0443.",
          alternativeSkusCreate: "\u0414\u043E\u0434\u0430\u0442\u0438 \xAB{value}\xBB",
          alternativeSkusDuplicate: "\u0426\u0435\u0439 \u0430\u0440\u0442\u0438\u043A\u0443\u043B \u0443\u0436\u0435 \u0434\u043E\u0434\u0430\u043D\u043E",
          alternativeSkusTooLong: "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u043C\u043E\u0436\u0435 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0449\u043E\u043D\u0430\u0439\u0431\u0456\u043B\u044C\u0448\u0435 100 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432"
        },
        images: {
          title: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F (D5 \u0424\u0430\u0437\u0430 1)",
          previewError: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430 \u0432\u043A\u0430\u0437\u0430\u043D\u043E\u044E URL. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0430\u0434\u0440\u0435\u0441\u0443."
        },
        toast: {
          created: "\u0422\u0438\u043F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
          updated: "\u0422\u0438\u043F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E"
        },
        errors: {
          nameRequired: "\u041D\u0430\u0437\u0432\u0430 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0430",
          skuRequired: "SKU \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
          duplicateSku: "\u0426\u0435\u0439 SKU \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
          validationFailed: "\u041D\u0435\u0432\u0456\u0440\u043D\u0456 \u0434\u0430\u043D\u0456 \u0444\u043E\u0440\u043C\u0438",
          notFound: "\u0422\u0438\u043F \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
          network: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043C\u0435\u0440\u0435\u0436\u0456, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437",
          businessRuleFail: "\u041F\u043E\u0440\u0443\u0448\u0435\u043D\u043E \u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u0430\u0432\u0438\u043B\u043E. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0434\u0430\u043D\u0456.",
          fkViolation: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0437\u0430\u043F\u0438\u0441 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454.",
          specsInvalidJson: "\u0422\u0435\u0445\u043D\u0456\u0447\u043D\u0430 \u0441\u043F\u0435\u0446\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F \u043C\u0456\u0441\u0442\u0438\u0442\u044C \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 JSON \u2014 \u0432\u0438\u043F\u0440\u0430\u0432\u0442\u0435 \u043F\u043E\u043B\u0435 Specs \u043F\u0435\u0440\u0435\u0434 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F\u043C."
        },
        cancelConfirm: "\u041D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u0431\u0443\u0434\u0435 \u0432\u0442\u0440\u0430\u0447\u0435\u043D\u043E. \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438?",
        specs: {
          title: "\u0422\u0435\u0445\u043D\u0456\u0447\u043D\u0456 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438",
          hint: "\u041F\u0430\u0440\u0438 \u043A\u043B\u044E\u0447\u2013\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0434\u043B\u044F \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u0442\u0438\u043F\u0443 (\u043D\u0430\u043F\u0440., \u043F\u043E\u0442\u0443\u0436\u043D\u0456\u0441\u0442\u044C, \u0432\u0430\u0433\u0430). \u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 Raw \u043F\u0440\u0438\u0439\u043C\u0430\u0454 \u0434\u043E\u0432\u0456\u043B\u044C\u043D\u0438\u0439 JSON.",
          kvView: "\u041A\u043B\u044E\u0447\u2013\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
          rawView: "Raw JSON",
          addRow: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
          removeRow: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
          keyPlaceholder: "\u043D\u0430\u043F\u0440., \u043F\u043E\u0442\u0443\u0436\u043D\u0456\u0441\u0442\u044C",
          valuePlaceholder: "\u043D\u0430\u043F\u0440., 4.0 \u043A\u0412\u0442",
          invalidJson: '\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 JSON \u2014 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043E\u0431\u02BC\u0454\u043A\u0442 (\u043D\u0430\u043F\u0440., {"\u043A\u043B\u044E\u0447": "\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F"})',
          nonPrimitiveHint: "\u0425\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u043C\u0456\u0441\u0442\u044F\u0442\u044C \u0432\u043A\u043B\u0430\u0434\u0435\u043D\u0456/\u0442\u0438\u043F\u0456\u0437\u043E\u0432\u0430\u043D\u0456 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u2014 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u043A\u043B\u044E\u0447\u2013\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0432\u0442\u0440\u0430\u0442\u0438\u0432 \u0431\u0438 \u0442\u0438\u043F\u0438, \u0442\u043E\u043C\u0443 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 Raw."
        },
        tabsLabel: "\u0412\u043A\u043B\u0430\u0434\u043A\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 \u0442\u0438\u043F\u0443",
        tabs: {
          data: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0434\u0430\u043D\u0456",
          units: "\u041E\u0434\u0438\u043D\u0438\u0446\u0456",
          webshop: "\u0412\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D",
          docs: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438"
        },
        units: {
          loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u0434\u0438\u043D\u0438\u0446\u044C\u2026",
          error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043E\u0434\u0438\u043D\u0438\u0446\u0456.",
          empty: "\u0426\u0435\u0439 \u0442\u0438\u043F \u0449\u0435 \u043D\u0435 \u043C\u0430\u0454 \u043E\u0434\u0438\u043D\u0438\u0446\u044C.",
          countSuffix: "\u043E\u0434\u0438\u043D\u0438\u0446\u044C",
          serialNumber: "\u0421\u0435\u0440\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
          assetTag: "\u0406\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440",
          status: "\u0421\u0442\u0430\u0442\u0443\u0441",
          createdAt: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
          open: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438"
        },
        webshop: {
          loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443\u2026",
          error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u0430\u043D\u0456 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443.",
          localeTitle: "\u041C\u043E\u0432\u043D\u0438\u0439 \u0432\u043C\u0456\u0441\u0442",
          localeHint: "HU \u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u043E \xB7 EN/DE/UK \u043D\u0435\u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u043E (\u043F\u043E\u0440\u043E\u0436\u043D\u0454 \u2192 HU-\u0444\u043E\u043B\u0431\u0435\u043A)",
          nameLabel: "\u041D\u0430\u0437\u0432\u0430",
          namePlaceholderHu: "\u043D\u0430\u043F\u0440., \u0431\u0435\u043D\u0437\u0438\u043D\u043E\u0432\u0438\u0439 \u0434\u0432\u0438\u0433\u0443\u043D Honda GX160",
          huNameRequired: "\u0423\u0433\u043E\u0440\u0441\u044C\u043A\u0430 \u043D\u0430\u0437\u0432\u0430 \u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u0430 \u043F\u0440\u0438 \u0432\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u0456 \u0443 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456.",
          descriptionLabel: "\u041E\u043F\u0438\u0441",
          slugLabel: "URL-\u0441\u043B\u0430\u0433",
          slugGenerate: "\u0417\u0433\u0435\u043D\u0435\u0440\u0443\u0432\u0430\u0442\u0438",
          flagVisibleOnWebshop: "\u0412\u0438\u0434\u0438\u043C\u0438\u0439 \u0443 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456",
          flagVisibleOnWebshopHint: "\u042F\u043A\u0449\u043E \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0439\u043E\u0433\u043E \u0431\u0430\u0447\u0430\u0442\u044C \u0443\u0441\u0456 \u0443 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456.",
          flagAvailableForRent: "\u041C\u043E\u0436\u043D\u0430 \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u0442\u0438 (\u043E\u0440\u0435\u043D\u0434\u0430)",
          flagAvailableForRentHint: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0431\u0440\u043E\u043D\u044E\u0432\u0430\u0442\u0438 \u0437 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443.",
          flagAvailableForSale: "\u041C\u043E\u0436\u043D\u0430 \u043A\u0443\u043F\u0438\u0442\u0438",
          flagAvailableForSaleHint: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u043A\u0443\u043F\u0443\u0432\u0430\u0442\u0438 \u0437 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443.",
          save: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0434\u0430\u043D\u0456 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443",
          saving: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F\u2026",
          saved: "\u0414\u0430\u043D\u0456 \u0432\u0435\u0431\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0443 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
          saveFailed: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438.",
          seoSectionTitle: "\u041F\u043E\u0448\u0443\u043A\u043E\u0432\u0430 \u043E\u043F\u0442\u0438\u043C\u0456\u0437\u0430\u0446\u0456\u044F (SEO)",
          seoPlaceholderNote: "\u0423 \u043F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u0446\u0456 \u2014 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F SEO-\u043F\u043E\u043B\u0456\u0432 \u0431\u0443\u0434\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0432 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u043C\u0443 \u0432\u0438\u043F\u0443\u0441\u043A\u0443 (\u0432\u043C\u0456\u0441\u0442 \u043F\u043E\u043A\u0438 \u043D\u0435 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F).",
          seoTitleLabel: "SEO-\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
          seoTitlePlaceholder: "\u043D\u0430\u043F\u0440. \u041E\u0440\u0435\u043D\u0434\u0430 \u0442\u0430 \u043A\u0443\u043F\u0456\u0432\u043B\u044F \u0434\u0432\u0438\u0433\u0443\u043D\u0430 Honda GX160 \u2014 Kisg\xE9pcentrum",
          seoDescriptionLabel: "SEO-\u043E\u043F\u0438\u0441",
          seoDescriptionPlaceholder: "\u043D\u0430\u043F\u0440. Honda GX160 \u043F\u0440\u043E\u0444\u0435\u0441\u0456\u0439\u043D\u0438\u0439 \u0431\u0435\u043D\u0437\u0438\u043D\u043E\u0432\u0438\u0439 \u0434\u0432\u0438\u0433\u0443\u043D, 4-\u0442\u0430\u043A\u0442\u043D\u0438\u0439, 163 \u0441\u043C\xB3. \u041E\u0440\u0435\u043D\u0434\u0430 \u0442\u0430 \u043A\u0443\u043F\u0456\u0432\u043B\u044F \u0432 Kisg\xE9pcentrum.",
          seoTooLong: "\u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0434\u043E\u0432\u0433\u0438\u0439"
        },
        docs: {
          loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432\u2026",
          error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438.",
          empty: "\u0426\u0435\u0439 \u0442\u0438\u043F \u0449\u0435 \u043D\u0435 \u043C\u0430\u0454 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432.",
          countSuffix: "\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
          name: "\u041D\u0430\u0437\u0432\u0430",
          kind: "\u0422\u0438\u043F",
          size: "\u0420\u043E\u0437\u043C\u0456\u0440",
          uploadedAt: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E",
          kinds: {
            MANUAL: "\u0406\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u044F",
            SAFETY: "\u0411\u0435\u0437\u043F\u0435\u043A\u0430",
            WARRANTY: "\u0413\u0430\u0440\u0430\u043D\u0442\u0456\u044F",
            CERTIFICATE: "\u0421\u0435\u0440\u0442\u0438\u0444\u0456\u043A\u0430\u0442",
            OTHER: "\u0406\u043D\u0448\u0435"
          }
        }
      }
    }
  },
  procurement: {
    worksheetPanelTitle: "\u0417\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C\u043D\u0456 \u0437\u0430\u043F\u0438\u0442\u0438",
    addRequest: "\u041D\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044E",
    addRequestTitle: "\u041D\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044E",
    emptyForWorksheet: "\u0414\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0430\u0440\u043A\u0443\u0448\u0430 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0442\u0456\u0432.",
    productSearchLabel: "\u0422\u043E\u0432\u0430\u0440",
    productSearchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 SKU \u0430\u0431\u043E \u043D\u0430\u0437\u0432\u043E\u044E\u2026",
    noProductsFound: "\u041D\u0435\u043C\u0430\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432",
    selectedProduct: "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0442\u043E\u0432\u0430\u0440",
    productIdShort: "\u0422\u043E\u0432\u0430\u0440",
    quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
    notes: "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430",
    notesPlaceholder: "\u043D\u0430\u043F\u0440. \u0442\u0435\u0440\u043C\u0456\u043D\u043E\u0432\u043E, \u043E\u0440\u0438\u0433\u0456\u043D\u0430\u043B\u044C\u043D\u0430 \u0434\u0435\u0442\u0430\u043B\u044C\u2026",
    create: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432 \u043A\u043E\u0448\u0438\u043A",
    errors: {
      productRequired: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u0432\u0430\u0440 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443.",
      quantityInvalid: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043D\u0438\u043C \u0447\u0438\u0441\u043B\u043E\u043C.",
      transitionRejected: "\u041F\u0435\u0440\u0435\u0445\u0456\u0434 \u0441\u0442\u0430\u043D\u0443 {from} \u2192 {to} \u043D\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0438\u0439."
    },
    status: {
      DRAFT: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
      SUBMITTED: "\u041F\u043E\u0434\u0430\u043D\u043E",
      ORDERED: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
      RECEIVED: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
      CANCELLED: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E"
    },
    actions: {
      submit: "\u041F\u043E\u0434\u0430\u0442\u0438",
      markOrdered: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
      markReceived: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u044F\u043A \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
      cancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
      confirmCancel: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0437\u0430\u043F\u0438\u0442 \u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044E?"
    },
    closeGate: {
      title: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0447\u0438\u0439 \u0430\u0440\u043A\u0443\u0448?",
      warning: "\u0417\u0430\u043B\u0438\u0448\u0438\u043B\u043E\u0441\u044C {count} \u043D\u0435\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0445 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C\u043D\u0438\u0445 \u0437\u0430\u043F\u0438\u0442\u0456\u0432 \u0434\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0430\u0440\u043A\u0443\u0448\u0430 (\u043D\u0435 \u043E\u0442\u0440\u0438\u043C\u0430\u043D\u0456 \u0442\u0430 \u043D\u0435 \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u0456). \u0412\u0441\u0435 \u043E\u0434\u043D\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u0438?",
      proceed: "\u0422\u0430\u043A, \u0437\u0430\u043A\u0440\u0438\u0442\u0438"
    },
    cart: {
      title: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0438\u0439 \u043A\u043E\u0448\u0438\u043A \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C",
      subtitle: "\u0423\u0441\u0456 \u0437\u0430\u043F\u0438\u0442\u0438 \u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044E, \u0437\u0433\u0440\u0443\u043F\u043E\u0432\u0430\u043D\u0456 \u0437\u0430 \u0434\u0436\u0435\u0440\u0435\u043B\u043E\u043C",
      empty: "\u041A\u043E\u0448\u0438\u043A \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u0439.",
      totalCount: "{count} \u0437\u0430\u043F\u0438\u0442\u0456\u0432",
      productIdShort: "\u0422\u043E\u0432\u0430\u0440",
      quantity: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
      sourceLabel: {
        WORKSHEET: "\u0417 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0430\u0440\u043A\u0443\u0448\u0430",
        SALES: "\u041D\u0435\u043C\u0430\u0454 \u0432 \u043D\u0430\u044F\u0432\u043D\u043E\u0441\u0442\u0456 \u043D\u0430 \u043A\u0430\u0441\u0456",
        MANUAL: "\u0420\u0443\u0447\u043D\u0435 \u0432\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
        AUTO_MIN: "\u0410\u0432\u0442\u043E\u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F"
      },
      submitButton: "\u041F\u043E\u0434\u0430\u0442\u0438 \u043A\u043E\u0448\u0438\u043A ({count})",
      confirmSubmit: "\u041F\u043E\u0434\u0430\u0442\u0438 {count} \u0437\u0430\u043F\u0438\u0442\u0456\u0432 \u043D\u0430 \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u043B\u044E. \u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?",
      markGroupOrderedButton: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0433\u0440\u0443\u043F\u0443 \u044F\u043A \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043E",
      supplierNotesPrompt: "\u041F\u043E\u0441\u0442\u0430\u0447\u0430\u043B\u044C\u043D\u0438\u043A (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E, \u0434\u043E\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0434\u043E \u043F\u0440\u0438\u043C\u0456\u0442\u043E\u043A):"
    },
    listTruncated: "\u0421\u043F\u0438\u0441\u043E\u043A \u0441\u043A\u043E\u0440\u043E\u0447\u0435\u043D\u043E: \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u043E {shown} \u0456\u0437 {total}. \u0417\u0432\u0443\u0437\u044C\u0442\u0435 \u0444\u0456\u043B\u044C\u0442\u0440 \u0430\u0431\u043E \u0432\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A \u0437\u0430\u043A\u0443\u043F\u0456\u0432\u0435\u043B\u044C."
  },
  package: {
    backToList: "\u041D\u0430\u0437\u0430\u0434 \u0434\u043E \u043F\u0430\u043A\u0435\u0442\u0456\u0432",
    adminTabs: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0438 \u043F\u0430\u043A\u0435\u0442\u0430",
    tabs: {
      items: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457",
      data: "\u0414\u0430\u043D\u0456 \u043F\u0430\u043A\u0435\u0442\u0430"
    },
    item: {
      name: "\u041D\u0430\u0437\u0432\u0430",
      settlement: "\u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A",
      settlementIncluded: "\u0412\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
      settlementRental: "\u041E\u0440\u0435\u043D\u0434\u0430",
      settlementConsignment: "\u041A\u043E\u043C\u0456\u0441\u0456\u044F",
      unitPrice: "\u0426\u0456\u043D\u0430 \u0437\u0430 \u043E\u0434\u0438\u043D\u0438\u0446\u044E"
    },
    scope: "\u0421\u0444\u0435\u0440\u0430 \u0434\u0456\u0457",
    pricingModel: "\u041C\u043E\u0434\u0435\u043B\u044C \u0446\u0456\u043D\u043E\u0443\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
    fixedPrice: "\u0424\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u0430 \u0446\u0456\u043D\u0430",
    depositAmount: "\u0417\u0430\u0441\u0442\u0430\u0432\u0430",
    validFrom: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0432\u0456\u0434",
    validTo: "\u0414\u0456\u0439\u0441\u043D\u0438\u0439 \u0434\u043E",
    category: {
      free: "\u0411\u0435\u0437\u043A\u043E\u0448\u0442\u043E\u0432\u043D\u043E",
      rentable: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0434\u043B\u044F \u043E\u0440\u0435\u043D\u0434\u0438",
      consignment: "\u041A\u043E\u043C\u0456\u0441\u0456\u044F"
    }
  },
  inquiry: {
    title: "\u0417\u0432'\u044F\u0437\u043E\u043A \u0437 \u043D\u0430\u043C\u0438",
    subtitle: "\u041D\u0430\u043F\u0438\u0448\u0456\u0442\u044C, \u0449\u043E \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u2014 \u043C\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u043C\u043E \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 1 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F.",
    success: {
      title: "\u0414\u044F\u043A\u0443\u0454\u043C\u043E \u0437\u0430 \u0437\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F!",
      body: "\u041C\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u043C\u043E \u043D\u0430 \u0432\u043A\u0430\u0437\u0430\u043D\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 1 \u0440\u043E\u0431\u043E\u0447\u043E\u0433\u043E \u0434\u043D\u044F."
    },
    field: {
      name: "\u0406\u043C'\u044F",
      email: "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
      phone: "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E)",
      message: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F"
    },
    submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    submitting: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F...",
    validation: {
      nameMin: "\u0429\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 2 \u0441\u0438\u043C\u0432\u043E\u043B\u0438",
      email: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
      messageMin: "\u0429\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 10 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
      messageMax: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C 5000 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
      captcha: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u044C\u0442\u0435, \u0449\u043E \u0432\u0438 \u043D\u0435 \u0440\u043E\u0431\u043E\u0442"
    },
    error: {
      submit: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u0437\u0430 \u043A\u0456\u043B\u044C\u043A\u0430 \u0445\u0432\u0438\u043B\u0438\u043D."
    }
  },
  priDrawer: {
    title: "\u0410\u0441\u0438\u0441\u0442\u0435\u043D\u0442 pRI",
    clearHistory: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0440\u043E\u0437\u043C\u043E\u0432\u0443",
    close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438"
  },
  unifiedFab: {
    items: {
      pri: "\u0410\u0441\u0438\u0441\u0442\u0435\u043D\u0442 pRI",
      chat: "\u0427\u0430\u0442",
      helpdesk: "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438"
    },
    title: {
      withShortcut: "\u0410\u0441\u0438\u0441\u0442\u0435\u043D\u0442 rPI (Ctrl+Shift+H)",
      default: "\u0410\u0441\u0438\u0441\u0442\u0435\u043D\u0442 rPI"
    }
  }
};

// src/locale/i18n.service.ts
var translations = {
  hu: hu_default,
  en: en_default,
  de: de_default,
  uk: uk_default
};
var I18nService = class {
  currentLocale = "hu";
  /**
   * Get current locale
   */
  getLocale() {
    return this.currentLocale;
  }
  /**
   * Set current locale (M4 fix: return success/failure)
   * @param locale - Locale to set
   * @returns true if locale was set, false if invalid
   */
  setLocale(locale) {
    if (this.isValidLocale(locale)) {
      this.currentLocale = locale;
      return true;
    }
    return false;
  }
  /**
   * Set locale with validation - throws on invalid
   * @param locale - Locale to set
   * @throws Error if locale is not supported
   */
  setLocaleStrict(locale) {
    if (!this.isValidLocale(locale)) {
      throw new Error(`Invalid locale: ${locale}. Supported: ${SUPPORTED_LOCALES.join(", ")}`);
    }
    this.currentLocale = locale;
  }
  /**
   * Get locale configuration for current locale
   */
  getConfig() {
    return LOCALE_CONFIGS[this.currentLocale];
  }
  /**
   * Get all supported locales
   */
  getSupportedLocales() {
    return SUPPORTED_LOCALES;
  }
  /**
   * Validate if locale is supported
   */
  isValidLocale(locale) {
    return SUPPORTED_LOCALES.includes(locale);
  }
  /**
   * Translate key to current locale with interpolation and fallback
   * ADR-071: Fallback chain: currentLocale → en → key string
   * ADR-071: Interpolation: {param} syntax — t('key', { count: 3 })
   * @param key - Dot-notation key (e.g., 'common.save')
   * @param params - Optional interpolation parameters
   * @returns Translated string or key if not found
   */
  t(key, params) {
    const result = this.resolve(key, this.currentLocale) ?? (this.currentLocale !== "en" ? this.resolve(key, "en") : void 0) ?? (this.currentLocale !== "hu" ? this.resolve(key, "hu") : void 0) ?? key;
    if (params) {
      return result.replace(/\{(\w+)\}/g, (match, paramKey) => {
        const value = params[paramKey];
        return value !== void 0 ? String(value) : match;
      });
    }
    return result;
  }
  /**
   * Resolve a dot-notation key from a specific locale's translations
   * @returns The translated string, or undefined if not found
   */
  resolve(key, locale) {
    const dict = translations[locale];
    const keys = key.split(".");
    let result = dict;
    for (const k of keys) {
      if (result && typeof result === "object" && k in result) {
        result = result[k];
      } else {
        return void 0;
      }
    }
    return typeof result === "string" ? result : void 0;
  }
  /**
   * Format currency based on current locale
   * @param amount - Amount to format
   * @param currencyOverride - Optional currency code override
   */
  formatCurrency(amount, currencyOverride) {
    const config = this.getConfig();
    const currencyCode = currencyOverride || config.currencyCode;
    const formatter = new Intl.NumberFormat(this.getIntlLocale(), {
      style: "currency",
      currency: currencyCode,
      ...config.numberFormat
    });
    return formatter.format(amount);
  }
  /**
   * Format date based on current locale
   * @param date - Date to format (Date object or string)
   */
  formatDate(date) {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    const config = this.getConfig();
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return config.dateFormat.replace("yyyy", String(year)).replace("MM", month).replace("dd", day);
  }
  /**
   * Format number based on current locale
   * @param num - Number to format
   */
  formatNumber(num) {
    const config = this.getConfig();
    const formatter = new Intl.NumberFormat(this.getIntlLocale(), {
      ...config.numberFormat
    });
    return formatter.format(num);
  }
  /**
   * Get Intl locale code
   * Maps our locale codes to standard Intl locale codes
   */
  getIntlLocale() {
    const localeMap = {
      hu: "hu-HU",
      en: "en-GB",
      de: "de-DE",
      uk: "uk-UA"
    };
    return localeMap[this.currentLocale];
  }
};
var i18n = new I18nService();

// src/react/I18nContext.tsx
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
var I18nContext = createContext(null);
var LOCALE_STORAGE_KEY = "kgc-locale";
function getPersistedLocale() {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
      return stored;
    }
  } catch {
  }
  return void 0;
}
function I18nProvider({
  children,
  defaultLocale = "hu",
  honorPersistedLocale = true
}) {
  const [locale, setLocaleState] = useState(
    () => (honorPersistedLocale ? getPersistedLocale() : void 0) ?? defaultLocale
  );
  const service = useMemo(() => {
    const svc = new I18nService();
    svc.setLocale(locale);
    return svc;
  }, [locale]);
  const setLocale = useCallback((newLocale) => {
    setLocaleState(newLocale);
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, newLocale);
    } catch {
    }
  }, []);
  const t = useCallback(
    (key, params) => {
      return service.t(key, params);
    },
    [service]
  );
  const formatCurrency = useCallback(
    (amount, currencyOverride) => {
      return service.formatCurrency(amount, currencyOverride);
    },
    [service]
  );
  const formatDate = useCallback(
    (date) => {
      return service.formatDate(date);
    },
    [service]
  );
  const formatNumber = useCallback(
    (num) => {
      return service.formatNumber(num);
    },
    [service]
  );
  const config = useMemo(() => {
    return LOCALE_CONFIGS[locale];
  }, [locale]);
  const contextValue = useMemo(
    () => ({
      locale,
      setLocale,
      t,
      formatCurrency,
      formatDate,
      formatNumber,
      config
    }),
    [locale, setLocale, t, formatCurrency, formatDate, formatNumber, config]
  );
  return /* @__PURE__ */ jsx(I18nContext.Provider, { value: contextValue, children });
}
function useTranslation() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useTranslation must be used within an I18nProvider");
  }
  return context;
}
function useLocale() {
  const { locale, setLocale } = useTranslation();
  return { locale, setLocale };
}
function useFormatters() {
  const { formatCurrency, formatDate, formatNumber } = useTranslation();
  return { formatCurrency, formatDate, formatNumber };
}

// src/offline/offline-db.interface.ts
var OFFLINE_STORES = {
  PRODUCTS: "products",
  PARTNERS: "partners",
  PENDING_OPERATIONS: "pendingOperations",
  SYNC_METADATA: "syncMetadata"
};
var OFFLINE_DB_CONFIG = {
  name: "kgc-offline",
  version: 1
};

// src/offline/offline-db.service.ts
import { openDB } from "idb";
var DEFAULT_SYNC_METADATA = {
  id: "sync-status",
  lastSyncTimestamp: null,
  pendingChangesCount: 0,
  lastSyncAttempt: null,
  syncInProgress: false
};
function generateId() {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}
var OfflineDbService = class {
  db = null;
  initialized = false;
  currentTenantId = null;
  /**
   * Set current tenant ID for multi-tenant isolation (ADR-001)
   * MUST be called before any data operations
   */
  setTenantId(tenantId) {
    this.currentTenantId = tenantId;
  }
  /**
   * Get current tenant ID
   */
  getTenantId() {
    return this.currentTenantId;
  }
  /**
   * Ensure tenant ID is set (ADR-001 compliance)
   */
  ensureTenantId() {
    if (!this.currentTenantId) {
      throw new Error("TenantId not set. Call setTenantId() before data operations (ADR-001)");
    }
    return this.currentTenantId;
  }
  /**
   * Initialize the database
   */
  async init() {
    if (this.initialized && this.db) {
      return;
    }
    this.db = await openDB(OFFLINE_DB_CONFIG.name, OFFLINE_DB_CONFIG.version, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(OFFLINE_STORES.PRODUCTS)) {
          const productStore = db.createObjectStore(OFFLINE_STORES.PRODUCTS, {
            keyPath: "id"
          });
          productStore.createIndex("by-tenant", "tenantId");
        }
        if (!db.objectStoreNames.contains(OFFLINE_STORES.PARTNERS)) {
          const partnerStore = db.createObjectStore(OFFLINE_STORES.PARTNERS, {
            keyPath: "id"
          });
          partnerStore.createIndex("by-tenant", "tenantId");
        }
        if (!db.objectStoreNames.contains(OFFLINE_STORES.PENDING_OPERATIONS)) {
          const pendingStore = db.createObjectStore(OFFLINE_STORES.PENDING_OPERATIONS, {
            keyPath: "id"
          });
          pendingStore.createIndex("by-status", "status");
        }
        if (!db.objectStoreNames.contains(OFFLINE_STORES.SYNC_METADATA)) {
          db.createObjectStore(OFFLINE_STORES.SYNC_METADATA, {
            keyPath: "id"
          });
        }
      }
    });
    const meta = await this.db.get(OFFLINE_STORES.SYNC_METADATA, "sync-status");
    if (!meta) {
      await this.db.put(OFFLINE_STORES.SYNC_METADATA, DEFAULT_SYNC_METADATA);
    }
    this.initialized = true;
  }
  /**
   * Check if database is initialized
   */
  isInitialized() {
    return this.initialized;
  }
  /**
   * Get database name
   */
  getDatabaseName() {
    return OFFLINE_DB_CONFIG.name;
  }
  /**
   * Close database connection
   */
  async close() {
    if (this.db) {
      this.db.close();
      this.db = null;
      this.initialized = false;
    }
  }
  // ============================================
  // Product Operations
  // ============================================
  async saveProduct(product) {
    this.ensureInitialized();
    await this.db.put(OFFLINE_STORES.PRODUCTS, product);
  }
  async getProduct(id) {
    this.ensureInitialized();
    return this.db.get(OFFLINE_STORES.PRODUCTS, id);
  }
  /**
   * Get all products for CURRENT tenant (ADR-001 enforced)
   * @throws Error if tenantId not set
   */
  async getAllProducts() {
    this.ensureInitialized();
    const tenantId = this.ensureTenantId();
    return this.db.getAllFromIndex(OFFLINE_STORES.PRODUCTS, "by-tenant", tenantId);
  }
  /**
   * Get products by specific tenant (for admin/cross-tenant operations only)
   * @deprecated Use getAllProducts() with setTenantId() for tenant-safe access
   */
  async getProductsByTenant(tenantId) {
    this.ensureInitialized();
    return this.db.getAllFromIndex(OFFLINE_STORES.PRODUCTS, "by-tenant", tenantId);
  }
  async deleteProduct(id) {
    this.ensureInitialized();
    await this.db.delete(OFFLINE_STORES.PRODUCTS, id);
  }
  async bulkSaveProducts(products) {
    this.ensureInitialized();
    const tx = this.db.transaction(OFFLINE_STORES.PRODUCTS, "readwrite");
    await Promise.all([...products.map((p) => tx.store.put(p)), tx.done]);
  }
  async clearProducts() {
    this.ensureInitialized();
    await this.db.clear(OFFLINE_STORES.PRODUCTS);
  }
  // ============================================
  // Partner Operations
  // ============================================
  async savePartner(partner) {
    this.ensureInitialized();
    await this.db.put(OFFLINE_STORES.PARTNERS, partner);
  }
  async getPartner(id) {
    this.ensureInitialized();
    return this.db.get(OFFLINE_STORES.PARTNERS, id);
  }
  /**
   * Get all partners for CURRENT tenant (ADR-001 enforced)
   * @throws Error if tenantId not set
   */
  async getAllPartners() {
    this.ensureInitialized();
    const tenantId = this.ensureTenantId();
    return this.db.getAllFromIndex(OFFLINE_STORES.PARTNERS, "by-tenant", tenantId);
  }
  /**
   * Get partners by specific tenant (for admin/cross-tenant operations only)
   * @deprecated Use getAllPartners() with setTenantId() for tenant-safe access
   */
  async getPartnersByTenant(tenantId) {
    this.ensureInitialized();
    return this.db.getAllFromIndex(OFFLINE_STORES.PARTNERS, "by-tenant", tenantId);
  }
  async deletePartner(id) {
    this.ensureInitialized();
    await this.db.delete(OFFLINE_STORES.PARTNERS, id);
  }
  // ============================================
  // Pending Operations
  // ============================================
  async addPendingOperation(params) {
    this.ensureInitialized();
    const op = {
      id: generateId(),
      entityType: params.entityType,
      entityId: params.entityId,
      operation: params.operation,
      data: params.data,
      createdAt: /* @__PURE__ */ new Date(),
      attempts: 0,
      status: "PENDING"
    };
    await this.db.put(OFFLINE_STORES.PENDING_OPERATIONS, op);
    return op;
  }
  async getPendingOperation(id) {
    this.ensureInitialized();
    return this.db.get(OFFLINE_STORES.PENDING_OPERATIONS, id);
  }
  async getPendingOperations() {
    this.ensureInitialized();
    return this.db.getAll(OFFLINE_STORES.PENDING_OPERATIONS);
  }
  async getPendingOperationsByStatus(status) {
    this.ensureInitialized();
    return this.db.getAllFromIndex(OFFLINE_STORES.PENDING_OPERATIONS, "by-status", status);
  }
  async updateOperationStatus(id, status, errorMessage) {
    this.ensureInitialized();
    const op = await this.getPendingOperation(id);
    if (op) {
      op.status = status;
      if (errorMessage) {
        op.errorMessage = errorMessage;
      }
      await this.db.put(OFFLINE_STORES.PENDING_OPERATIONS, op);
    }
  }
  async incrementOperationAttempt(id) {
    this.ensureInitialized();
    const op = await this.getPendingOperation(id);
    if (op) {
      op.attempts += 1;
      op.lastAttemptAt = /* @__PURE__ */ new Date();
      await this.db.put(OFFLINE_STORES.PENDING_OPERATIONS, op);
    }
  }
  async deleteSyncedOperations() {
    this.ensureInitialized();
    const synced = await this.getPendingOperationsByStatus("SYNCED");
    const tx = this.db.transaction(OFFLINE_STORES.PENDING_OPERATIONS, "readwrite");
    await Promise.all([...synced.map((op) => tx.store.delete(op.id)), tx.done]);
  }
  // ============================================
  // Sync Metadata
  // ============================================
  async getSyncMetadata() {
    this.ensureInitialized();
    const meta = await this.db.get(OFFLINE_STORES.SYNC_METADATA, "sync-status");
    return meta || DEFAULT_SYNC_METADATA;
  }
  async updateLastSync(timestamp) {
    this.ensureInitialized();
    const meta = await this.getSyncMetadata();
    meta.lastSyncTimestamp = timestamp;
    meta.lastSyncAttempt = timestamp;
    await this.db.put(OFFLINE_STORES.SYNC_METADATA, meta);
  }
  async getPendingChangesCount() {
    this.ensureInitialized();
    const pending = await this.getPendingOperationsByStatus("PENDING");
    return pending.length;
  }
  async setSyncInProgress(inProgress) {
    this.ensureInitialized();
    const meta = await this.getSyncMetadata();
    meta.syncInProgress = inProgress;
    await this.db.put(OFFLINE_STORES.SYNC_METADATA, meta);
  }
  // ============================================
  // Clear Operations
  // ============================================
  async clearAll() {
    this.ensureInitialized();
    await Promise.all([
      this.db.clear(OFFLINE_STORES.PRODUCTS),
      this.db.clear(OFFLINE_STORES.PARTNERS),
      this.db.clear(OFFLINE_STORES.PENDING_OPERATIONS)
    ]);
    await this.db.put(OFFLINE_STORES.SYNC_METADATA, DEFAULT_SYNC_METADATA);
  }
  // ============================================
  // Private Helpers
  // ============================================
  ensureInitialized() {
    if (!this.initialized || !this.db) {
      throw new Error("OfflineDbService not initialized. Call init() first.");
    }
  }
};
var offlineDb = new OfflineDbService();

// src/offline/offline-sync.interface.ts
var DEFAULT_SYNC_CONFIG = {
  maxRetries: 3,
  retryDelayMs: 5e3,
  backgroundSyncTag: "sync-pending-operations",
  apiEndpoints: [],
  conflictStrategy: "last-write-wins"
};

// src/offline/offline-sync.service.ts
var OfflineSyncService = class {
  dbService;
  config;
  listeners = /* @__PURE__ */ new Set();
  isSyncing = false;
  constructor(dbService) {
    this.dbService = dbService;
    this.config = { ...DEFAULT_SYNC_CONFIG };
  }
  /**
   * Check if device is online
   */
  isOnline() {
    return typeof navigator !== "undefined" && navigator.onLine;
  }
  /**
   * Queue an operation for sync
   */
  async queueForSync(entityType, entityId, operation, data) {
    await this.dbService.addPendingOperation({
      entityType,
      entityId,
      operation,
      data
    });
  }
  /**
   * Sync pending operations when online
   */
  async syncWhenOnline() {
    const result = {
      success: false,
      syncedCount: 0,
      failedCount: 0,
      conflicts: [],
      timestamp: /* @__PURE__ */ new Date()
    };
    if (!this.isOnline()) {
      this.emitEvent("sync-failed", result);
      return result;
    }
    if (this.isSyncing) {
      return result;
    }
    try {
      this.isSyncing = true;
      await this.dbService.setSyncInProgress(true);
      this.emitEvent("sync-started", result);
      const pending = await this.dbService.getPendingOperationsByStatus("PENDING");
      if (pending.length === 0) {
        result.success = true;
        this.emitEvent("sync-completed", result);
        return result;
      }
      for (const op of pending) {
        const syncResult = await this.syncOperation(op);
        if (syncResult.success) {
          result.syncedCount++;
          await this.dbService.updateOperationStatus(op.id, "SYNCED");
          this.emitEvent("operation-synced", op);
        } else {
          result.failedCount++;
          await this.dbService.updateOperationStatus(op.id, "PENDING", syncResult.error);
          await this.dbService.incrementOperationAttempt(op.id);
          const updated = await this.dbService.getPendingOperation(op.id);
          if (updated && updated.attempts >= this.config.maxRetries) {
            await this.dbService.updateOperationStatus(op.id, "CONFLICT", syncResult.error);
            result.conflicts.push({
              operationId: op.id,
              entityType: op.entityType,
              entityId: op.entityId,
              reason: `Max retries (${this.config.maxRetries}) exceeded: ${syncResult.error ?? "Unknown"}`,
              localValue: op.data
            });
          } else {
            const backoffMs = this.config.retryDelayMs * Math.pow(2, updated?.attempts ?? 0);
            await this.delay(Math.min(backoffMs, 3e4));
          }
          this.emitEvent("operation-failed", op);
        }
      }
      await this.dbService.updateLastSync(/* @__PURE__ */ new Date());
      result.success = result.failedCount === 0;
      this.emitEvent("sync-completed", result);
      return result;
    } finally {
      this.isSyncing = false;
      await this.dbService.setSyncInProgress(false);
    }
  }
  /**
   * Sync a single operation (H2 fix: auth headers)
   */
  async syncOperation(op) {
    try {
      const endpoint = this.getEndpoint(op.entityType);
      const url = this.buildUrl(endpoint, op);
      const method = this.getHttpMethod(op.operation);
      const headers = {
        "Content-Type": "application/json"
      };
      if (this.config.getAuthToken) {
        const token = await Promise.resolve(this.config.getAuthToken());
        if (token) {
          headers["Authorization"] = `Bearer ${token}`;
        }
      }
      const response = await fetch(url, {
        method,
        headers,
        ...op.operation !== "DELETE" && { body: JSON.stringify(op.data) }
      });
      if (!response.ok) {
        return { success: false, error: `HTTP ${response.status}: ${response.statusText}` };
      }
      return { success: true };
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Unknown error";
      return { success: false, error: errorMessage };
    }
  }
  /**
   * Delay helper for retry backoff (M2 fix)
   */
  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  /**
   * Register Background Sync (H3 fix)
   * Call this when going offline to ensure sync happens when back online
   */
  async registerBackgroundSync() {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      return false;
    }
    try {
      const registration = await navigator.serviceWorker.ready;
      if ("sync" in registration) {
        await registration.sync.register(this.config.backgroundSyncTag);
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
  /**
   * Get API endpoint for entity type
   */
  getEndpoint(entityType) {
    const configured = this.config.apiEndpoints.find((e) => e.entityType === entityType);
    if (configured) {
      return configured.baseUrl;
    }
    return `/api/v1/${entityType}s`;
  }
  /**
   * Build URL for operation
   */
  buildUrl(endpoint, op) {
    if (op.operation === "CREATE") {
      return endpoint;
    }
    return `${endpoint}/${op.entityId}`;
  }
  /**
   * Get HTTP method for operation type
   */
  getHttpMethod(operation) {
    switch (operation) {
      case "CREATE":
        return "POST";
      case "UPDATE":
        return "PATCH";
      case "DELETE":
        return "DELETE";
    }
  }
  /**
   * Add sync event listener
   */
  onSyncEvent(listener) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
  /**
   * Emit sync event to all listeners
   */
  emitEvent(type, data) {
    const event = {
      type,
      timestamp: /* @__PURE__ */ new Date(),
      ...data !== void 0 && { data }
    };
    for (const listener of this.listeners) {
      try {
        listener(event);
      } catch {
      }
    }
  }
  /**
   * Get count of pending operations
   */
  async getPendingCount() {
    return this.dbService.getPendingChangesCount();
  }
  /**
   * Get all pending operations
   */
  async getPendingOperations() {
    return this.dbService.getPendingOperationsByStatus("PENDING");
  }
  /**
   * Get current configuration
   */
  getConfig() {
    return { ...this.config };
  }
  /**
   * Update configuration
   */
  configure(config) {
    this.config = {
      ...this.config,
      ...config
    };
  }
};

// src/react/useOfflineStatus.tsx
import {
  createContext as createContext2,
  useCallback as useCallback2,
  useContext as useContext2,
  useEffect,
  useState as useState2
} from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var OfflineStatusContext = createContext2(null);
function OfflineStatusProvider({
  children,
  dbService
}) {
  const [isOnline, setIsOnline] = useState2(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );
  const [isSyncing, setIsSyncing] = useState2(false);
  const [pendingCount, setPendingCount] = useState2(0);
  const [lastSyncTime, setLastSyncTime] = useState2(null);
  const refresh = useCallback2(async () => {
    try {
      const meta = await dbService.getSyncMetadata();
      setIsSyncing(meta.syncInProgress);
      setLastSyncTime(meta.lastSyncTimestamp);
      const count = await dbService.getPendingChangesCount();
      setPendingCount(count);
    } catch {
    }
  }, [dbService]);
  const handleOnline = useCallback2(() => {
    setIsOnline(true);
  }, []);
  const handleOffline = useCallback2(() => {
    setIsOnline(false);
  }, []);
  useEffect(() => {
    void refresh();
    if (typeof window !== "undefined") {
      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);
      return () => {
        window.removeEventListener("online", handleOnline);
        window.removeEventListener("offline", handleOffline);
      };
    }
  }, [refresh, handleOnline, handleOffline]);
  useEffect(() => {
    const interval = setInterval(() => {
      void refresh();
    }, 3e4);
    return () => clearInterval(interval);
  }, [refresh]);
  const value = {
    isOnline,
    isOffline: !isOnline,
    isSyncing,
    pendingCount,
    lastSyncTime,
    refresh
  };
  return /* @__PURE__ */ jsx2(OfflineStatusContext.Provider, { value, children });
}
function useOfflineStatus() {
  const context = useContext2(OfflineStatusContext);
  if (!context) {
    throw new Error("useOfflineStatus must be used within an OfflineStatusProvider");
  }
  return context;
}

// src/react/NetworkStatusIndicator.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
function NetworkStatusIndicator({
  compact = false,
  className = ""
}) {
  const { isOnline, isSyncing, pendingCount, lastSyncTime } = useOfflineStatus();
  const { t } = useTranslation();
  const formatLastSync = () => {
    if (!lastSyncTime) return null;
    const now = /* @__PURE__ */ new Date();
    const diffMs = now.getTime() - lastSyncTime.getTime();
    const diffMinutes = Math.floor(diffMs / 6e4);
    if (diffMinutes < 1) {
      return t("network.syncComplete");
    }
    if (diffMinutes < 60) {
      const timeUnit2 = diffMinutes === 1 ? t("network.minuteAgo") : t("network.minutesAgo");
      return `${t("network.lastSync")}: ${diffMinutes} ${timeUnit2}`;
    }
    const diffHours = Math.floor(diffMinutes / 60);
    const timeUnit = diffHours === 1 ? t("network.hourAgo") : t("network.hoursAgo");
    return `${t("network.lastSync")}: ${diffHours} ${timeUnit}`;
  };
  const getStatusText = () => {
    if (isSyncing) {
      return t("network.syncing");
    }
    return isOnline ? t("network.online") : t("network.offlineMode");
  };
  const containerClasses = ["network-status-indicator", compact ? "compact" : "", className].filter(Boolean).join(" ");
  const indicatorClasses = ["status-dot", isOnline ? "online" : "offline"].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs("div", { className: containerClasses, "data-testid": "network-status", children: [
    /* @__PURE__ */ jsx3("span", { className: indicatorClasses, "data-testid": "status-indicator", children: isSyncing ? "\u{1F504}" : isOnline ? "\u{1F7E2}" : "\u{1F534}" }),
    /* @__PURE__ */ jsx3("span", { className: "status-text", children: getStatusText() }),
    !compact && pendingCount > 0 && /* @__PURE__ */ jsxs("span", { className: "pending-info", "data-testid": "pending-count", children: [
      "(",
      pendingCount,
      " ",
      t("network.pendingSync"),
      ")"
    ] }),
    !compact && isOnline && lastSyncTime && /* @__PURE__ */ jsx3("span", { className: "last-sync-info", "data-testid": "last-sync", children: formatLastSync() }),
    /* @__PURE__ */ jsx3("style", { children: `
        .network-status-indicator {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          border-radius: 8px;
          background: var(--bg-secondary, #f5f5f5);
          font-size: 14px;
        }

        .network-status-indicator.compact {
          padding: 4px 8px;
          font-size: 12px;
          gap: 4px;
        }

        .status-dot {
          font-size: 12px;
        }

        .status-dot.online {
          color: #22c55e;
        }

        .status-dot.offline {
          color: #ef4444;
        }

        .status-text {
          font-weight: 500;
        }

        .pending-info {
          color: #f59e0b;
          font-size: 12px;
        }

        .last-sync-info {
          color: #6b7280;
          font-size: 12px;
          margin-left: auto;
        }
      ` })
  ] });
}
export {
  DEFAULT_SYNC_CONFIG,
  I18nContext,
  I18nProvider,
  I18nService,
  LOCALE_CONFIGS,
  NetworkStatusIndicator,
  OFFLINE_DB_CONFIG,
  OFFLINE_STORES,
  OfflineDbService,
  OfflineStatusProvider,
  OfflineSyncService,
  SUPPORTED_LOCALES,
  i18n,
  offlineDb,
  useFormatters,
  useLocale,
  useOfflineStatus,
  useTranslation
};
//# sourceMappingURL=index.mjs.map